
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2835"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2835"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f2WZf", function(module, exports) {
/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    let shared, worker, mapboxgl;
    if (typeof self !== "undefined") self.__mapboxImport = (u)=>import(/* webpackIgnore: true */ /* @vite-ignore */ u);
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            const sharedChunk = {};
            shared(void 0, sharedChunk);
            mapboxgl = chunk(sharedChunk);
            const workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; self.__mapboxImport = (u) => import(u); (" + shared + ")(undefined, sharedChunk); (" + worker + ")(undefined, sharedChunk); self.onerror = null;";
            if (typeof window !== "undefined" && window && window.URL && window.URL.createObjectURL) mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: "text/javascript"
            }));
        }
    }
    define([
        "require",
        "exports"
    ], function(e1, t1) {
        var i = "3.28.1", n = 1e-6, r = "undefined" != typeof Float32Array ? Float32Array : Array;
        function o(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[3], a = i * o - r * n;
            return a ? (e1[0] = o * (a = 1 / a), e1[1] = -n * a, e1[2] = -r * a, e1[3] = i * a, e1) : null;
        }
        function a() {
            var e1 = new r(9);
            return r != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0), e1[0] = 1, e1[4] = 1, e1[8] = 1, e1;
        }
        function s(e1, t1, i) {
            var n = t1[0], r = t1[1], o = t1[2], a = t1[3], s = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], d = i[0], f = i[1], p = i[2], _ = i[3], m = i[4], g = i[5], y = i[6], x = i[7], v = i[8];
            return e1[0] = d * n + f * a + p * u, e1[1] = d * r + f * s + p * c, e1[2] = d * o + f * l + p * h, e1[3] = _ * n + m * a + g * u, e1[4] = _ * r + m * s + g * c, e1[5] = _ * o + m * l + g * h, e1[6] = y * n + x * a + v * u, e1[7] = y * r + x * s + v * c, e1[8] = y * o + x * l + v * h, e1;
        }
        function l(e1, t1) {
            var i = Math.sin(t1), n = Math.cos(t1);
            return e1[0] = n, e1[1] = i, e1[2] = 0, e1[3] = -i, e1[4] = n, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 1, e1;
        }
        function u() {
            var e1 = new r(16);
            return r != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0), e1[0] = 1, e1[5] = 1, e1[10] = 1, e1[15] = 1, e1;
        }
        function c(e1) {
            var t1 = new r(16);
            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
        }
        function h(e1, t1) {
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
        }
        function d(e1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }
        function f(e1, t1) {
            if (e1 === t1) {
                var i = t1[1], n = t1[2], r = t1[3], o = t1[6], a = t1[7], s = t1[11];
                e1[1] = t1[4], e1[2] = t1[8], e1[3] = t1[12], e1[4] = i, e1[6] = t1[9], e1[7] = t1[13], e1[8] = n, e1[9] = o, e1[11] = t1[14], e1[12] = r, e1[13] = a, e1[14] = s;
            } else e1[0] = t1[0], e1[1] = t1[4], e1[2] = t1[8], e1[3] = t1[12], e1[4] = t1[1], e1[5] = t1[5], e1[6] = t1[9], e1[7] = t1[13], e1[8] = t1[2], e1[9] = t1[6], e1[10] = t1[10], e1[11] = t1[14], e1[12] = t1[3], e1[13] = t1[7], e1[14] = t1[11], e1[15] = t1[15];
            return e1;
        }
        function p(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[3], a = t1[4], s = t1[5], l = t1[6], u = t1[7], c = t1[8], h = t1[9], d = t1[10], f = t1[11], p = t1[12], _ = t1[13], m = t1[14], g = t1[15], y = i * s - n * a, x = i * l - r * a, v = i * u - o * a, b = n * l - r * s, w = n * u - o * s, E = r * u - o * l, A = c * _ - h * p, I = c * m - d * p, T = c * g - f * p, M = h * m - d * _, S = h * g - f * _, z = d * g - f * m, R = y * z - x * S + v * M + b * T - w * I + E * A;
            return R ? (e1[0] = (s * z - l * S + u * M) * (R = 1 / R), e1[1] = (r * S - n * z - o * M) * R, e1[2] = (_ * E - m * w + g * b) * R, e1[3] = (d * w - h * E - f * b) * R, e1[4] = (l * T - a * z - u * I) * R, e1[5] = (i * z - r * T + o * I) * R, e1[6] = (m * v - p * E - g * x) * R, e1[7] = (c * E - d * v + f * x) * R, e1[8] = (a * S - s * T + u * A) * R, e1[9] = (n * T - i * S - o * A) * R, e1[10] = (p * w - _ * v + g * y) * R, e1[11] = (h * v - c * w - f * y) * R, e1[12] = (s * I - a * M - l * A) * R, e1[13] = (i * M - n * I + r * A) * R, e1[14] = (_ * x - p * b - m * y) * R, e1[15] = (c * b - h * x + d * y) * R, e1) : null;
        }
        function _(e1, t1, i) {
            var n = t1[0], r = t1[1], o = t1[2], a = t1[3], s = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], d = t1[9], f = t1[10], p = t1[11], _ = t1[12], m = t1[13], g = t1[14], y = t1[15], x = i[0], v = i[1], b = i[2], w = i[3];
            return e1[0] = x * n + v * s + b * h + w * _, e1[1] = x * r + v * l + b * d + w * m, e1[2] = x * o + v * u + b * f + w * g, e1[3] = x * a + v * c + b * p + w * y, e1[4] = (x = i[4]) * n + (v = i[5]) * s + (b = i[6]) * h + (w = i[7]) * _, e1[5] = x * r + v * l + b * d + w * m, e1[6] = x * o + v * u + b * f + w * g, e1[7] = x * a + v * c + b * p + w * y, e1[8] = (x = i[8]) * n + (v = i[9]) * s + (b = i[10]) * h + (w = i[11]) * _, e1[9] = x * r + v * l + b * d + w * m, e1[10] = x * o + v * u + b * f + w * g, e1[11] = x * a + v * c + b * p + w * y, e1[12] = (x = i[12]) * n + (v = i[13]) * s + (b = i[14]) * h + (w = i[15]) * _, e1[13] = x * r + v * l + b * d + w * m, e1[14] = x * o + v * u + b * f + w * g, e1[15] = x * a + v * c + b * p + w * y, e1;
        }
        function m(e1, t1, i) {
            var n, r, o, a, s, l, u, c, h, d, f, p, _ = i[0], m = i[1], g = i[2];
            return t1 === e1 ? (e1[12] = t1[0] * _ + t1[4] * m + t1[8] * g + t1[12], e1[13] = t1[1] * _ + t1[5] * m + t1[9] * g + t1[13], e1[14] = t1[2] * _ + t1[6] * m + t1[10] * g + t1[14], e1[15] = t1[3] * _ + t1[7] * m + t1[11] * g + t1[15]) : (r = t1[1], o = t1[2], a = t1[3], s = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], d = t1[9], f = t1[10], p = t1[11], e1[0] = n = t1[0], e1[1] = r, e1[2] = o, e1[3] = a, e1[4] = s, e1[5] = l, e1[6] = u, e1[7] = c, e1[8] = h, e1[9] = d, e1[10] = f, e1[11] = p, e1[12] = n * _ + s * m + h * g + t1[12], e1[13] = r * _ + l * m + d * g + t1[13], e1[14] = o * _ + u * m + f * g + t1[14], e1[15] = a * _ + c * m + p * g + t1[15]), e1;
        }
        function g(e1, t1, i) {
            var n = i[0], r = i[1], o = i[2];
            return e1[0] = t1[0] * n, e1[1] = t1[1] * n, e1[2] = t1[2] * n, e1[3] = t1[3] * n, e1[4] = t1[4] * r, e1[5] = t1[5] * r, e1[6] = t1[6] * r, e1[7] = t1[7] * r, e1[8] = t1[8] * o, e1[9] = t1[9] * o, e1[10] = t1[10] * o, e1[11] = t1[11] * o, e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
        }
        function y(e1, t1, i) {
            var n = Math.sin(i), r = Math.cos(i), o = t1[4], a = t1[5], s = t1[6], l = t1[7], u = t1[8], c = t1[9], h = t1[10], d = t1[11];
            return t1 !== e1 && (e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15]), e1[4] = o * r + u * n, e1[5] = a * r + c * n, e1[6] = s * r + h * n, e1[7] = l * r + d * n, e1[8] = u * r - o * n, e1[9] = c * r - a * n, e1[10] = h * r - s * n, e1[11] = d * r - l * n, e1;
        }
        function x(e1, t1, i) {
            var n = Math.sin(i), r = Math.cos(i), o = t1[0], a = t1[1], s = t1[2], l = t1[3], u = t1[8], c = t1[9], h = t1[10], d = t1[11];
            return t1 !== e1 && (e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15]), e1[0] = o * r - u * n, e1[1] = a * r - c * n, e1[2] = s * r - h * n, e1[3] = l * r - d * n, e1[8] = o * n + u * r, e1[9] = a * n + c * r, e1[10] = s * n + h * r, e1[11] = l * n + d * r, e1;
        }
        function v(e1, t1, i) {
            var n = Math.sin(i), r = Math.cos(i), o = t1[0], a = t1[1], s = t1[2], l = t1[3], u = t1[4], c = t1[5], h = t1[6], d = t1[7];
            return t1 !== e1 && (e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15]), e1[0] = o * r + u * n, e1[1] = a * r + c * n, e1[2] = s * r + h * n, e1[3] = l * r + d * n, e1[4] = u * r - o * n, e1[5] = c * r - a * n, e1[6] = h * r - s * n, e1[7] = d * r - l * n, e1;
        }
        function b(e1, t1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = t1[0], e1[13] = t1[1], e1[14] = t1[2], e1[15] = 1, e1;
        }
        function w(e1, t1) {
            return e1[0] = t1[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = t1[1], e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = t1[2], e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }
        function E(e1, t1, i) {
            var r, o, a, s = i[0], l = i[1], u = i[2], c = Math.sqrt(s * s + l * l + u * u);
            return c < n ? null : (s *= c = 1 / c, l *= c, u *= c, r = Math.sin(t1), o = Math.cos(t1), e1[0] = s * s * (a = 1 - o) + o, e1[1] = l * s * a + u * r, e1[2] = u * s * a - l * r, e1[3] = 0, e1[4] = s * l * a - u * r, e1[5] = l * l * a + o, e1[6] = u * l * a + s * r, e1[7] = 0, e1[8] = s * u * a + l * r, e1[9] = l * u * a - s * r, e1[10] = u * u * a + o, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1);
        }
        function A(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[4], a = t1[5], s = t1[6], l = t1[8], u = t1[9], c = t1[10];
            return e1[0] = Math.sqrt(i * i + n * n + r * r), e1[1] = Math.sqrt(o * o + a * a + s * s), e1[2] = Math.sqrt(l * l + u * u + c * c), e1;
        }
        function I(e1, t1) {
            var i = new r(3);
            A(i, t1);
            var n = 1 / i[0], o = 1 / i[1], a = 1 / i[2], s = t1[0] * n, l = t1[1] * o, u = t1[2] * a, c = t1[4] * n, h = t1[5] * o, d = t1[6] * a, f = t1[8] * n, p = t1[9] * o, _ = t1[10] * a, m = s + h + _, g = 0;
            return m > 0 ? (g = 2 * Math.sqrt(m + 1), e1[3] = .25 * g, e1[0] = (d - p) / g, e1[1] = (f - u) / g, e1[2] = (l - c) / g) : s > h && s > _ ? (g = 2 * Math.sqrt(1 + s - h - _), e1[3] = (d - p) / g, e1[0] = .25 * g, e1[1] = (l + c) / g, e1[2] = (f + u) / g) : h > _ ? (g = 2 * Math.sqrt(1 + h - s - _), e1[3] = (f - u) / g, e1[0] = (l + c) / g, e1[1] = .25 * g, e1[2] = (d + p) / g) : (g = 2 * Math.sqrt(1 + _ - s - h), e1[3] = (l - c) / g, e1[0] = (f + u) / g, e1[1] = (d + p) / g, e1[2] = .25 * g), e1;
        }
        function T(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[3], a = i + i, s = n + n, l = r + r, u = i * a, c = n * a, h = n * s, d = r * a, f = r * s, p = r * l, _ = o * a, m = o * s, g = o * l;
            return e1[0] = 1 - h - p, e1[1] = c + g, e1[2] = d - m, e1[3] = 0, e1[4] = c - g, e1[5] = 1 - u - p, e1[6] = f + _, e1[7] = 0, e1[8] = d + m, e1[9] = f - _, e1[10] = 1 - u - h, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }
        var M = function(e1, t1, i, n, r) {
            var o = 1 / Math.tan(t1 / 2);
            if (e1[0] = o / i, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = o, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[15] = 0, null != r && r !== 1 / 0) {
                var a = 1 / (n - r);
                e1[10] = (r + n) * a, e1[14] = 2 * r * n * a;
            } else e1[10] = -1, e1[14] = -2 * n;
            return e1;
        }, S = function(e1, t1, i, n, r, o, a) {
            var s = 1 / (t1 - i), l = 1 / (n - r), u = 1 / (o - a);
            return e1[0] = -2 * s, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = -2 * l, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 2 * u, e1[11] = 0, e1[12] = (t1 + i) * s, e1[13] = (r + n) * l, e1[14] = (a + o) * u, e1[15] = 1, e1;
        }, z = _;
        function R() {
            var e1 = new r(3);
            return r != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1;
        }
        function P(e1) {
            var t1 = new r(3);
            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1;
        }
        function D(e1) {
            var t1 = e1[0], i = e1[1], n = e1[2];
            return Math.sqrt(t1 * t1 + i * i + n * n);
        }
        function C(e1, t1, i) {
            var n = new r(3);
            return n[0] = e1, n[1] = t1, n[2] = i, n;
        }
        function F(e1, t1, i, n) {
            return e1[0] = t1, e1[1] = i, e1[2] = n, e1;
        }
        function O(e1, t1, i) {
            return e1[0] = t1[0] + i[0], e1[1] = t1[1] + i[1], e1[2] = t1[2] + i[2], e1;
        }
        function L(e1, t1, i) {
            return e1[0] = t1[0] - i[0], e1[1] = t1[1] - i[1], e1[2] = t1[2] - i[2], e1;
        }
        function B(e1, t1, i) {
            return e1[0] = t1[0] * i[0], e1[1] = t1[1] * i[1], e1[2] = t1[2] * i[2], e1;
        }
        function N(e1, t1, i) {
            return e1[0] = Math.min(t1[0], i[0]), e1[1] = Math.min(t1[1], i[1]), e1[2] = Math.min(t1[2], i[2]), e1;
        }
        function V(e1, t1, i) {
            return e1[0] = Math.max(t1[0], i[0]), e1[1] = Math.max(t1[1], i[1]), e1[2] = Math.max(t1[2], i[2]), e1;
        }
        function k(e1, t1, i) {
            return e1[0] = t1[0] * i, e1[1] = t1[1] * i, e1[2] = t1[2] * i, e1;
        }
        function U(e1, t1, i, n) {
            return e1[0] = t1[0] + i[0] * n, e1[1] = t1[1] + i[1] * n, e1[2] = t1[2] + i[2] * n, e1;
        }
        function G(e1, t1) {
            var i = t1[0] - e1[0], n = t1[1] - e1[1], r = t1[2] - e1[2];
            return Math.sqrt(i * i + n * n + r * r);
        }
        function j(e1, t1) {
            var i = t1[0] - e1[0], n = t1[1] - e1[1], r = t1[2] - e1[2];
            return i * i + n * n + r * r;
        }
        function H(e1) {
            var t1 = e1[0], i = e1[1], n = e1[2];
            return t1 * t1 + i * i + n * n;
        }
        function $(e1, t1) {
            return e1[0] = -t1[0], e1[1] = -t1[1], e1[2] = -t1[2], e1;
        }
        function Z(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = i * i + n * n + r * r;
            return o > 0 && (o = 1 / Math.sqrt(o)), e1[0] = t1[0] * o, e1[1] = t1[1] * o, e1[2] = t1[2] * o, e1;
        }
        function W(e1, t1) {
            return e1[0] * t1[0] + e1[1] * t1[1] + e1[2] * t1[2];
        }
        function q(e1, t1, i) {
            var n = t1[0], r = t1[1], o = t1[2], a = i[0], s = i[1], l = i[2];
            return e1[0] = r * l - o * s, e1[1] = o * a - n * l, e1[2] = n * s - r * a, e1;
        }
        function X(e1, t1, i, n) {
            var r = t1[0], o = t1[1], a = t1[2];
            return e1[0] = r + n * (i[0] - r), e1[1] = o + n * (i[1] - o), e1[2] = a + n * (i[2] - a), e1;
        }
        function Y(e1, t1, i) {
            var n = t1[0], r = t1[1], o = t1[2], a = i[3] * n + i[7] * r + i[11] * o + i[15];
            return e1[0] = (i[0] * n + i[4] * r + i[8] * o + i[12]) / (a = a || 1), e1[1] = (i[1] * n + i[5] * r + i[9] * o + i[13]) / a, e1[2] = (i[2] * n + i[6] * r + i[10] * o + i[14]) / a, e1;
        }
        function J(e1, t1, i) {
            var n = t1[0], r = t1[1], o = t1[2];
            return e1[0] = n * i[0] + r * i[3] + o * i[6], e1[1] = n * i[1] + r * i[4] + o * i[7], e1[2] = n * i[2] + r * i[5] + o * i[8], e1;
        }
        function K(e1, t1, i) {
            var n = i[0], r = i[1], o = i[2], a = i[3], s = t1[0], l = t1[1], u = t1[2], c = r * u - o * l, h = o * s - n * u, d = n * l - r * s;
            return e1[0] = s + a * (c += c) + r * (d += d) - o * (h += h), e1[1] = l + a * h + o * c - n * d, e1[2] = u + a * d + n * h - r * c, e1;
        }
        function Q(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1;
        }
        function ee(e1, t1) {
            return e1[0] === t1[0] && e1[1] === t1[1] && e1[2] === t1[2];
        }
        var te = L, ie = B, ne = D;
        function re() {
            var e1 = new r(4);
            return r != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 0), e1;
        }
        function oe(e1, t1, i, n) {
            var o = new r(4);
            return o[0] = e1, o[1] = t1, o[2] = i, o[3] = n, o;
        }
        function ae(e1, t1, i) {
            return e1[0] = t1[0] * i, e1[1] = t1[1] * i, e1[2] = t1[2] * i, e1[3] = t1[3] * i, e1;
        }
        function se(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[3], a = i * i + n * n + r * r + o * o;
            return a > 0 && (a = 1 / Math.sqrt(a)), e1[0] = i * a, e1[1] = n * a, e1[2] = r * a, e1[3] = o * a, e1;
        }
        function le(e1, t1, i) {
            var n = t1[0], r = t1[1], o = t1[2], a = t1[3];
            return e1[0] = i[0] * n + i[4] * r + i[8] * o + i[12] * a, e1[1] = i[1] * n + i[5] * r + i[9] * o + i[13] * a, e1[2] = i[2] * n + i[6] * r + i[10] * o + i[14] * a, e1[3] = i[3] * n + i[7] * r + i[11] * o + i[15] * a, e1;
        }
        function ue() {
            var e1 = new r(4);
            return r != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1[3] = 1, e1;
        }
        function ce(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1;
        }
        function he(e1, t1) {
            var i = 2 * Math.acos(t1[3]), r = Math.sin(i / 2);
            return r > n ? (e1[0] = t1[0] / r, e1[1] = t1[1] / r, e1[2] = t1[2] / r) : (e1[0] = 1, e1[1] = 0, e1[2] = 0), i;
        }
        function de(e1, t1, i) {
            i *= .5;
            var n = t1[0], r = t1[1], o = t1[2], a = t1[3], s = Math.sin(i), l = Math.cos(i);
            return e1[0] = n * l + a * s, e1[1] = r * l + o * s, e1[2] = o * l - r * s, e1[3] = a * l - n * s, e1;
        }
        function fe(e1, t1, i) {
            i *= .5;
            var n = t1[0], r = t1[1], o = t1[2], a = t1[3], s = Math.sin(i), l = Math.cos(i);
            return e1[0] = n * l - o * s, e1[1] = r * l + a * s, e1[2] = o * l + n * s, e1[3] = a * l - r * s, e1;
        }
        function pe(e1, t1, i) {
            i *= .5;
            var n = t1[0], r = t1[1], o = t1[2], a = t1[3], s = Math.sin(i), l = Math.cos(i);
            return e1[0] = n * l + r * s, e1[1] = r * l - n * s, e1[2] = o * l + a * s, e1[3] = a * l - o * s, e1;
        }
        R(), re();
        var _e, me, ge, ye = se, xe = (_e = R(), me = C(1, 0, 0), ge = C(0, 1, 0), function(e1, t1, i) {
            var n = W(t1, i);
            return n < -0.999999 ? (q(_e, me, t1), ne(_e) < 1e-6 && q(_e, ge, t1), Z(_e, _e), function(e1, t1, i) {
                i *= .5;
                var n = Math.sin(i);
                e1[0] = n * t1[0], e1[1] = n * t1[1], e1[2] = n * t1[2], e1[3] = Math.cos(i);
            }(e1, _e, Math.PI), e1) : n > .999999 ? (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1) : (q(_e, t1, i), e1[0] = _e[0], e1[1] = _e[1], e1[2] = _e[2], e1[3] = 1 + n, ye(e1, e1));
        });
        function ve() {
            var e1 = new r(2);
            return r != Float32Array && (e1[0] = 0, e1[1] = 0), e1;
        }
        function be(e1, t1) {
            var i = new r(2);
            return i[0] = e1, i[1] = t1, i;
        }
        function we(e1, t1, i) {
            return e1[0] = t1, e1[1] = i, e1;
        }
        function Ee(e1, t1, i) {
            return e1[0] = t1[0] + i[0], e1[1] = t1[1] + i[1], e1;
        }
        function Ae(e1, t1, i) {
            return e1[0] = t1[0] - i[0], e1[1] = t1[1] - i[1], e1;
        }
        function Ie(e1, t1, i) {
            return e1[0] = t1[0] * i, e1[1] = t1[1] * i, e1;
        }
        function Te(e1) {
            var t1 = e1[0], i = e1[1];
            return Math.sqrt(t1 * t1 + i * i);
        }
        function Me(e1, t1) {
            var i = t1[0], n = t1[1], r = i * i + n * n;
            return r > 0 && (r = 1 / Math.sqrt(r)), e1[0] = t1[0] * r, e1[1] = t1[1] * r, e1;
        }
        function Se(e1, t1) {
            return e1[0] * t1[0] + e1[1] * t1[1];
        }
        ue(), ue(), a();
        var ze = Ae;
        function Re(e1, t1, i, n) {
            const r = 3 * e1, o = 3 * (i - e1) - r, a = 1 - r - o, s = 3 * t1, l = 3 * (n - t1) - s, u = 1 - s - l;
            return function(e1, t1 = 1e-6) {
                if (e1 <= 0) return 0;
                if (e1 >= 1) return 1;
                let i = e1;
                for(let n = 0; n < 8; n++){
                    const n = ((a * i + o) * i + r) * i - e1;
                    if (Math.abs(n) < t1) return ((u * i + l) * i + s) * i;
                    const c = (3 * a * i + 2 * o) * i + r;
                    if (Math.abs(c) < 1e-6) break;
                    i -= n / c;
                }
                let n = 0, c = 1;
                i = e1;
                for(let s = 0; s < 20; s++){
                    const s = ((a * i + o) * i + r) * i;
                    if (Math.abs(s - e1) < t1) break;
                    e1 > s ? n = i : c = i, i = .5 * (n + c);
                }
                return ((u * i + l) * i + s) * i;
            };
        }
        function Pe(e1, t1) {
            this.x = e1, this.y = t1;
        }
        function De(e1, t1) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(t1) || e1.length !== t1.length) return !1;
                for(let i = 0; i < e1.length; i++)if (!De(e1[i], t1[i])) return !1;
                return !0;
            }
            if ("object" == typeof e1 && null !== e1 && null !== t1) {
                if ("object" != typeof t1) return !1;
                const i = e1, n = t1;
                if (Object.keys(i).length !== Object.keys(n).length) return !1;
                for(const e1 in i)if (!De(i[e1], n[e1])) return !1;
                return !0;
            }
            return e1 === t1;
        }
        function Ce(e1, t1, i = 0, n = e1.length - 1, r = Oe) {
            for(; n > i;){
                if (n - i > 600) {
                    const o = n - i + 1, a = t1 - i + 1, s = Math.log(o), l = .5 * Math.exp(2 * s / 3), u = .5 * Math.sqrt(s * l * (o - l) / o) * (a - o / 2 < 0 ? -1 : 1);
                    Ce(e1, t1, Math.max(i, Math.floor(t1 - a * l / o + u)), Math.min(n, Math.floor(t1 + (o - a) * l / o + u)), r);
                }
                const o = e1[t1];
                let a = i, s = n;
                for(Fe(e1, i, t1), r(e1[n], o) > 0 && Fe(e1, i, n); a < s;){
                    for(Fe(e1, a, s), a++, s--; r(e1[a], o) < 0;)a++;
                    for(; r(e1[s], o) > 0;)s--;
                }
                0 === r(e1[i], o) ? Fe(e1, i, s) : (s++, Fe(e1, s, n)), s <= t1 && (i = s + 1), t1 <= s && (n = s - 1);
            }
        }
        function Fe(e1, t1, i) {
            const n = e1[t1];
            e1[t1] = e1[i], e1[i] = n;
        }
        function Oe(e1, t1) {
            return e1 < t1 ? -1 : e1 > t1 ? 1 : 0;
        }
        function Le(e1) {
            let t1 = 0;
            for(let i, n, r = 0, o = e1.length, a = o - 1; r < o; a = r++)i = e1[r], n = e1[a], t1 += (n.x - i.x) * (i.y + n.y);
            return t1;
        }
        function Be(e1, t1) {
            return t1.area - e1.area;
        }
        function Ne(e1, t1) {
            const i = e1.length;
            if (i <= 1) return [
                e1
            ];
            const n = [];
            let r, o;
            for(let t1 = 0; t1 < i; t1++){
                const i = Le(e1[t1]);
                0 !== i && (e1[t1].area = Math.abs(i), void 0 === o && (o = i < 0), o === i < 0 ? (r && n.push(r), r = [
                    e1[t1]
                ]) : r.push(e1[t1]));
            }
            if (r && n.push(r), t1 > 1) for(let e1 = 0; e1 < n.length; e1++){
                const i = n[e1];
                i.length <= t1 || (Ce(i, t1, 1, i.length - 1, Be), n[e1] = i.slice(0, t1));
            }
            return n;
        }
        function Ve(e1, t1) {
            e1[0] = Math.min(e1[0], t1[0]), e1[1] = Math.min(e1[1], t1[1]), e1[2] = Math.max(e1[2], t1[0]), e1[3] = Math.max(e1[3], t1[1]);
        }
        function ke(e1, t1) {
            return !(e1[0] <= t1[0] || e1[2] >= t1[2] || e1[1] <= t1[1] || e1[3] >= t1[3]);
        }
        function Ue(e1, t1, i) {
            const n = e1[0] - t1[0], r = e1[1] - t1[1], o = e1[0] - i[0], a = e1[1] - i[1];
            return n * a - o * r === 0 && n * o <= 0 && r * a <= 0;
        }
        function Ge(e1, t1, i) {
            return t1[1] > e1[1] != i[1] > e1[1] && e1[0] < (i[0] - t1[0]) * (e1[1] - t1[1]) / (i[1] - t1[1]) + t1[0];
        }
        function je(e1, t1, i = !1) {
            let n = !1;
            for(let r = 0, o = t1.length; r < o; r++){
                const o = t1[r];
                for(let t1 = 0, r = o.length, a = r - 1; t1 < r; a = t1++){
                    const r = o[a], s = o[t1];
                    if (Ue(e1, r, s)) return i;
                    Ge(e1, r, s) && (n = !n);
                }
            }
            return n;
        }
        function He(e1, t1, i, n) {
            const r = n[0] - i[0], o = n[1] - i[1], a = (e1[0] - i[0]) * o - r * (e1[1] - i[1]), s = (t1[0] - i[0]) * o - r * (t1[1] - i[1]);
            return a > 0 && s < 0 || a < 0 && s > 0;
        }
        function $e(e1, t1, i, n) {
            var r, o;
            return 0 !== (r = [
                n[0] - i[0],
                n[1] - i[1]
            ])[0] * (o = [
                t1[0] - e1[0],
                t1[1] - e1[1]
            ])[1] - r[1] * o[0] && !(!He(e1, t1, i, n) || !He(i, n, e1, t1));
        }
        function Ze(e1) {
            const t1 = new Pe(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY), i = new Pe(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);
            for (const n of e1[0])t1.x > n.x && (t1.x = n.x), t1.y > n.y && (t1.y = n.y), i.x < n.x && (i.x = n.x), i.y < n.y && (i.y = n.y);
            return {
                min: t1,
                max: i
            };
        }
        ve(), Pe.prototype = {
            clone () {
                return new Pe(this.x, this.y);
            },
            add (e1) {
                return this.clone()._add(e1);
            },
            sub (e1) {
                return this.clone()._sub(e1);
            },
            multByPoint (e1) {
                return this.clone()._multByPoint(e1);
            },
            divByPoint (e1) {
                return this.clone()._divByPoint(e1);
            },
            mult (e1) {
                return this.clone()._mult(e1);
            },
            div (e1) {
                return this.clone()._div(e1);
            },
            rotate (e1) {
                return this.clone()._rotate(e1);
            },
            rotateAround (e1, t1) {
                return this.clone()._rotateAround(e1, t1);
            },
            matMult (e1) {
                return this.clone()._matMult(e1);
            },
            unit () {
                return this.clone()._unit();
            },
            perp () {
                return this.clone()._perp();
            },
            round () {
                return this.clone()._round();
            },
            mag () {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals (e1) {
                return this.x === e1.x && this.y === e1.y;
            },
            dist (e1) {
                return Math.sqrt(this.distSqr(e1));
            },
            distSqr (e1) {
                const t1 = e1.x - this.x, i = e1.y - this.y;
                return t1 * t1 + i * i;
            },
            angle () {
                return Math.atan2(this.y, this.x);
            },
            angleTo (e1) {
                return Math.atan2(this.y - e1.y, this.x - e1.x);
            },
            angleWith (e1) {
                return this.angleWithSep(e1.x, e1.y);
            },
            angleWithSep (e1, t1) {
                return Math.atan2(this.x * t1 - this.y * e1, this.x * e1 + this.y * t1);
            },
            _matMult (e1) {
                const t1 = e1[2] * this.x + e1[3] * this.y;
                return this.x = e1[0] * this.x + e1[1] * this.y, this.y = t1, this;
            },
            _add (e1) {
                return this.x += e1.x, this.y += e1.y, this;
            },
            _sub (e1) {
                return this.x -= e1.x, this.y -= e1.y, this;
            },
            _mult (e1) {
                return this.x *= e1, this.y *= e1, this;
            },
            _div (e1) {
                return this.x /= e1, this.y /= e1, this;
            },
            _multByPoint (e1) {
                return this.x *= e1.x, this.y *= e1.y, this;
            },
            _divByPoint (e1) {
                return this.x /= e1.x, this.y /= e1.y, this;
            },
            _unit () {
                return this._div(this.mag()), this;
            },
            _perp () {
                const e1 = this.y;
                return this.y = this.x, this.x = -e1, this;
            },
            _rotate (e1) {
                const t1 = Math.cos(e1), i = Math.sin(e1), n = i * this.x + t1 * this.y;
                return this.x = t1 * this.x - i * this.y, this.y = n, this;
            },
            _rotateAround (e1, t1) {
                const i = Math.cos(e1), n = Math.sin(e1), r = t1.y + n * (this.x - t1.x) + i * (this.y - t1.y);
                return this.x = t1.x + i * (this.x - t1.x) - n * (this.y - t1.y), this.y = r, this;
            },
            _round () {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            },
            constructor: Pe
        }, Pe.convert = function(e1) {
            if (e1 instanceof Pe) return e1;
            if (Array.isArray(e1)) return new Pe(+e1[0], +e1[1]);
            if (void 0 !== e1.x && void 0 !== e1.y) return new Pe(+e1.x, +e1.y);
            throw new Error("Expected [x, y] or {x, y} point format");
        };
        const We = Math.PI / 180, qe = 180 / Math.PI, Xe = /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        function Ye(e1) {
            return e1 * We;
        }
        function Je(e1) {
            return e1 * qe;
        }
        const Ke = [
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ];
        function Qe(e1) {
            if (e1 <= 0) return 0;
            if (e1 >= 1) return 1;
            const t1 = e1 * e1, i = t1 * e1;
            return 4 * (e1 < .5 ? i : 3 * (e1 - t1) + i - .75);
        }
        const et = Re(.25, .1, .25, 1);
        function tt(e1, t1, i) {
            return Math.min(i, Math.max(t1, e1));
        }
        function it(e1, t1, i) {
            return (i = tt((i - e1) / (t1 - e1), 0, 1)) * i * (3 - 2 * i);
        }
        function nt(e1, t1, i) {
            const n = i - t1, r = ((e1 - t1) % n + n) % n + t1;
            return r === t1 ? i : r;
        }
        function rt(e1, t1, i) {
            if (!e1.length) return i(null, []);
            let n = e1.length;
            const r = new Array(e1.length);
            let o = null;
            e1.forEach((e1, a)=>{
                t1(e1, (e1, t1)=>{
                    e1 && (o = e1), r[a] = t1, 0 === --n && i(o, r);
                });
            });
        }
        function ot(e1, t1) {
            const i = {};
            for(let n = 0; n < t1.length; n++){
                const r = t1[n];
                r in e1 && (i[r] = e1[r]);
            }
            return i;
        }
        let at = 1;
        function st() {
            return function e1(t1) {
                return t1 ? (t1 ^ Math.random() * (16 >> t1 / 4)).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, e1);
            }();
        }
        function lt(e1) {
            return e1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log2(e1)));
        }
        function ut(e1) {
            return !!e1 && Xe.test(e1);
        }
        function ct(e1, t1) {
            e1.forEach((e1)=>{
                t1[e1] && (t1[e1] = t1[e1].bind(t1));
            });
        }
        function ht(e1, t1, i) {
            const n = {};
            for(const i in e1)n[i] = t1.call(this, e1[i], i, e1);
            return n;
        }
        function dt(e1, t1, i) {
            const n = {};
            for(const i in e1)t1.call(this, e1[i], i, e1) && (n[i] = e1[i]);
            return n;
        }
        function ft(e1) {
            return Array.isArray(e1) ? e1.map(ft) : "object" == typeof e1 && e1 ? ht(e1, ft) : e1;
        }
        function pt(e1, t1) {
            for(let i = 0; i < e1.length; i++)if (t1.includes(e1[i])) return !0;
            return !1;
        }
        const _t = {};
        function mt(e1) {
            _t[e1] || ("undefined" != typeof console && console.warn(e1), _t[e1] = !0);
        }
        function gt(e1, t1, i) {
            return (i.y - e1.y) * (t1.x - e1.x) > (t1.y - e1.y) * (i.x - e1.x);
        }
        function yt([e1, t1, i]) {
            const n = Ye(t1 + 90), r = Ye(i);
            return {
                x: e1 * Math.cos(n) * Math.sin(r),
                y: e1 * Math.sin(n) * Math.sin(r),
                z: e1 * Math.cos(r),
                azimuthal: t1,
                polar: i
            };
        }
        function xt(e1, t1, i) {
            const n = Math.sqrt(e1 * e1 + t1 * t1 + i * i), r = n > 0 ? Math.acos(i / n) * qe : 0;
            let o = 0 !== e1 || 0 !== t1 ? Math.atan2(-t1, -e1) * qe + 90 : 0;
            return o < 0 && (o += 360), [
                n,
                o,
                r
            ];
        }
        function vt(e1) {
            return ("undefined" != typeof self || void 0 !== e1) && "undefined" != typeof WorkerGlobalScope && (void 0 !== e1 ? e1 : self) instanceof WorkerGlobalScope;
        }
        function bt(e1) {
            const t1 = {};
            if (e1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (e1, i, n, r)=>{
                const o = n || r;
                return t1[i] = !o || o.toLowerCase(), "";
            }), t1["max-age"]) {
                const e1 = parseInt(t1["max-age"], 10);
                isNaN(e1) ? delete t1["max-age"] : t1["max-age"] = e1;
            }
            return t1;
        }
        function wt(e1) {
            return e1 ? {
                cacheControl: e1.get("cache-control"),
                expires: e1.get("expires")
            } : {
                cacheControl: void 0,
                expires: void 0
            };
        }
        function Et(e1) {
            try {
                const t1 = self[e1];
                return t1.setItem("_mapbox_test_", 1), t1.removeItem("_mapbox_test_"), !0;
            } catch (e1) {
                return !1;
            }
        }
        function At(e1, t1) {
            return [
                e1[4 * t1],
                e1[4 * t1 + 1],
                e1[4 * t1 + 2],
                e1[4 * t1 + 3]
            ];
        }
        function It(e1, t1, i) {
            e1[4 * t1 + 0] = i[0], e1[4 * t1 + 1] = i[1], e1[4 * t1 + 2] = i[2], e1[4 * t1 + 3] = i[3];
        }
        function Tt(e1) {
            return [
                Math.pow(e1[0], 1 / 2.2),
                Math.pow(e1[1], 1 / 2.2),
                Math.pow(e1[2], 1 / 2.2)
            ];
        }
        function Mt(e1) {
            return e1 > 0 ? 1 / (1.001 - e1) : 1 + e1;
        }
        function St(e1) {
            return e1 > 0 ? 1 - 1 / (1.001 - e1) : -e1;
        }
        function zt(e1, t1, i) {
            return (e1 - t1.min) * (i.max - i.min) / (t1.max - t1.min) + i.min;
        }
        function Rt(e1) {
            return e1 * e1 * e1 * e1 * e1;
        }
        function Pt(e1) {
            return e1 >>>= 0, e1 = Math.imul(2747636419 ^ e1, 2654435769) >>> 0, e1 = Math.imul(e1 ^ e1 >>> 16, 2654435769) >>> 0, (e1 = Math.imul(e1 ^ e1 >>> 16, 2654435769) >>> 0) / 4294967296;
        }
        let Dt, Ct, Ft, Ot, Lt, Bt;
        function Nt() {
            return Dt ??= self.OffscreenCanvas && !!new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap, Dt;
        }
        const Vt = {
            requestIdleCallback: (e1)=>{
                if ("undefined" != typeof requestIdleCallback) return requestIdleCallback(e1);
                setTimeout(()=>e1({
                        didTimeout: !1,
                        timeRemaining: ()=>50
                    }), 0);
            },
            now: ()=>void 0 !== Ot ? Ot : performance.now(),
            setNow (e1) {
                Ot = e1;
            },
            restoreNow () {
                Ot = void 0;
            },
            frame (e1) {
                const t1 = requestAnimationFrame(e1);
                return {
                    cancel: ()=>cancelAnimationFrame(t1)
                };
            },
            getImageData (e1, t1 = 0) {
                const { width: i, height: n } = e1;
                Lt || (Lt = document.createElement("canvas"));
                const r = Lt.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!r) throw new Error("failed to create canvas 2d context");
                return (i > Lt.width || n > Lt.height) && (Lt.width = i, Lt.height = n), r.clearRect(-t1, -t1, i + 2 * t1, n + 2 * t1), r.drawImage(e1, 0, 0, i, n), r.getImageData(-t1, -t1, i + 2 * t1, n + 2 * t1);
            },
            resolveURL: (e1)=>(Ct || (Ct = document.createElement("a")), Ct.href = e1, Ct.href),
            get devicePixelRatio () {
                return window.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!window.matchMedia && (Ft ??= window.matchMedia("(prefers-reduced-motion: reduce)"), Ft.matches);
            },
            hasCanvasFingerprintNoise () {
                if (void 0 !== Bt) return Bt;
                if (!Nt()) return Bt = !1, !1;
                const e1 = new OffscreenCanvas(85, 1), t1 = e1.getContext("2d", {
                    willReadFrequently: !0
                });
                let i = 0;
                for(let n = 0; n < e1.width; ++n)t1.fillStyle = `rgba(${i++},${i++},${i++}, 255)`, t1.fillRect(n, 0, 1, 1);
                const n = t1.getImageData(0, 0, e1.width, e1.height);
                i = 0;
                for(let e1 = 0; e1 < n.data.length; ++e1)if (e1 % 4 != 3 && i++ !== n.data[e1]) return Bt = !0, !0;
                return Bt = !1, !1;
            }
        };
        let kt;
        const Ut = {
            API_URL: "https://api.mapbox.com",
            API_URL_REGEX: /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i,
            API_TILEJSON_REGEX: /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i,
            API_SPRITE_REGEX: /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i,
            API_FONTS_REGEX: /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i,
            API_STYLE_REGEX: /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i,
            API_CDN_URL_REGEX: /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i,
            get EVENTS_URL () {
                if (!Ut.API_URL) return null;
                try {
                    const e1 = new URL(Ut.API_URL);
                    return "api.mapbox.cn" === e1.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === e1.hostname ? "https://events.mapbox.com/events/v2" : null;
                } catch (e1) {
                    return null;
                }
            },
            SESSION_PATH: "/map-sessions/v1",
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            TILE_URL_VERSION: "v4",
            RASTER_URL_PREFIX: "raster/v1",
            RASTERARRAYS_URL_PREFIX: "rasterarrays/v1",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            DEFAULT_STYLE: "mapbox://styles/mapbox/standard",
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            DRACO_URL: "/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm",
            MESHOPT_URL: "/mapbox-gl-js/meshopt_base_v1.2.wasm",
            MESHOPT_SIMD_URL: "/mapbox-gl-js/meshopt_simd_v1.2.wasm",
            BUILDING_GEN_URL: "/mapbox-gl-js/building-gen/building_gen_v1.2.4.wasm",
            GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
            TILES3D_URL_PREFIX: "3dtiles/v1",
            TILE_PROVIDER_URLS: Object.assign(Object.create(null), {
                pmtiles: "/mapbox-gl-js/plugins/mapbox-gl-pmtiles-provider/v0.0.2/mapbox-gl-pmtiles-provider.js"
            })
        };
        function Gt() {
            return new URL(Ut.DRACO_URL, Ut.API_URL).href;
        }
        function jt() {
            if ("object" != typeof WebAssembly) throw new Error("WebAssembly not supported, cannot instantiate meshoptimizer");
            return new URL(function() {
                if (void 0 === kt) {
                    if ("object" != typeof WebAssembly) return !1;
                    const e1 = new Uint8Array([
                        0,
                        97,
                        115,
                        109,
                        1,
                        0,
                        0,
                        0,
                        1,
                        4,
                        1,
                        96,
                        0,
                        0,
                        3,
                        3,
                        2,
                        0,
                        0,
                        5,
                        3,
                        1,
                        0,
                        1,
                        12,
                        1,
                        0,
                        10,
                        22,
                        2,
                        12,
                        0,
                        65,
                        0,
                        65,
                        0,
                        65,
                        0,
                        252,
                        10,
                        0,
                        0,
                        11,
                        7,
                        0,
                        65,
                        0,
                        253,
                        15,
                        26,
                        11
                    ]);
                    kt = WebAssembly.validate(e1);
                }
                return kt;
            }() ? Ut.MESHOPT_SIMD_URL : Ut.MESHOPT_URL, Ut.API_URL).href;
        }
        function Ht() {
            return new URL(Ut.BUILDING_GEN_URL, Ut.API_URL).href;
        }
        function $t(e1, t1) {
            const i = e1.indexOf("?"), n = i < 0 ? e1 : e1.slice(0, i), r = new URLSearchParams(i < 0 ? "" : e1.slice(i));
            for (const [e1, i] of Object.entries(t1))r.set(e1, i);
            return `${n}?${r}`;
        }
        function Zt(e1, t1 = {
            persistentParams: []
        }) {
            const i = e1.indexOf("?");
            if (i < 0) return e1;
            const n = new URLSearchParams, r = new URLSearchParams(e1.slice(i));
            for (const e1 of t1.persistentParams){
                const t1 = r.get(e1);
                t1 && n.set(e1, t1);
            }
            const o = n.toString();
            return `${e1.slice(0, i)}${o.length > 0 ? `?${o}` : ""}`;
        }
        const Wt = "mapbox-tiles";
        let qt = 500, Xt = 50;
        const Yt = [
            "language",
            "worldview",
            "jobid"
        ];
        let Jt;
        function Kt() {
            try {
                return caches;
            } catch (e1) {}
        }
        function Qt() {
            const e1 = Kt();
            e1 && null == Jt && (Jt = e1.open(Wt));
        }
        let ei = 1 / 0;
        function ti(e1) {
            return Ut.API_URL_REGEX.test(e1);
        }
        function ii(e1) {
            return 0 === e1.indexOf("mapbox:");
        }
        function ni(e1) {
            return Ut.API_CDN_URL_REGEX.test(e1);
        }
        function ri(e1) {
            return Ut.API_SPRITE_REGEX.test(e1);
        }
        function oi(e1) {
            return Ut.API_STYLE_REGEX.test(e1) && !ri(e1);
        }
        const ai = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Iconset: "Iconset",
            Image: "Image",
            Model: "Model"
        };
        Object.freeze(ai);
        class si extends Error {
            constructor(e1, t1, i){
                super(), this.url = i, this.statusText = e1, this.status = t1;
            }
            get message() {
                return 401 === this.status && ti(this.url) ? `${this.statusText}: you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/guides/#access-tokens-and-token-scopes` : this.statusText;
            }
            toString() {
                return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
            }
        }
        function li(e1) {
            return "object" == typeof e1 && null !== e1 && "status" in e1 && 404 === e1.status;
        }
        const ui = vt() ? ()=>self.worker.referrer : ()=>("blob:" === location.protocol ? parent : self).location.href, ci = /^\w+:/, hi = /[\r\n]+/;
        async function di(e1, t1) {
            let i;
            return i = "arrayBuffer" === e1.type ? await t1.arrayBuffer() : "json" === e1.type ? await t1.json() : await t1.text(), {
                data: i,
                headers: t1.headers
            };
        }
        async function fi(e1, t1) {
            var i;
            return t1 && t1.throwIfAborted(), (i = e1.url).startsWith("file:") || ui().startsWith("file:") && !ci.test(i) ? async function(e1, t1) {
                return new Promise((i, n)=>{
                    const r = new XMLHttpRequest, o = ()=>{
                        t1.removeEventListener("abort", o), r.abort(), n(t1.reason);
                    };
                    t1 && t1.addEventListener("abort", o), r.open(e1.method || "GET", e1.url, !0), "arrayBuffer" === e1.type && (r.responseType = "arraybuffer");
                    for(const t1 in e1.headers)r.setRequestHeader(t1, e1.headers[t1]);
                    "json" === e1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === e1.credentials, r.onerror = ()=>{
                        t1 && t1.removeEventListener("abort", o), n(new Error(r.statusText));
                    }, r.onload = ()=>{
                        if (t1 && t1.removeEventListener("abort", o), (r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                            let t1 = r.response;
                            if ("json" === e1.type) try {
                                t1 = JSON.parse(r.response);
                            } catch (e1) {
                                return void n(e1);
                            }
                            const o = new Headers;
                            r.getAllResponseHeaders().trim().split(hi).forEach((e1)=>{
                                const t1 = e1.split(": "), i = t1.shift(), n = t1.join(": ");
                                i && o.set(i, n);
                            }), i({
                                data: t1,
                                headers: o
                            });
                        } else n(new si(r.statusText, r.status, e1.url));
                    }, r.send(e1.body);
                });
            }(e1, t1) : async function(e1, t1) {
                const i = new Request(e1.url, {
                    method: e1.method || "GET",
                    body: e1.body,
                    credentials: e1.credentials,
                    headers: e1.headers,
                    referrer: ui(),
                    referrerPolicy: e1.referrerPolicy,
                    signal: t1
                }), n = (r = i.url).indexOf("sku=") > 0 && ti(r);
                var r;
                if ("json" === e1.type && i.headers.set("Accept", "application/json"), n) {
                    let n = null;
                    try {
                        n = await async function(e1) {
                            if (Qt(), null == Jt) return null;
                            const t1 = await Jt;
                            let i = Zt(e1.url, {
                                persistentParams: Yt
                            });
                            const n = e1.headers.get("Range");
                            n && (i = $t(i, {
                                range: n
                            }));
                            const r = await t1.match(i);
                            if (!r) return null;
                            const o = function(e1) {
                                if (!e1) return !1;
                                const t1 = new Date(e1.headers.get("expires") || 0), i = bt(e1.headers.get("cache-control") || "");
                                return Number(t1) > Date.now() && !i["no-cache"];
                            }(r);
                            return t1.delete(i).catch((e1)=>mt(e1.message)), o && t1.put(i, r.clone()).catch((e1)=>mt(e1.message)), {
                                response: r,
                                fresh: o
                            };
                        }(i);
                    } catch (e1) {
                        "SecurityError" !== e1.message && mt(e1.toString());
                    }
                    if (n && n.fresh) return t1 && t1.throwIfAborted(), di(e1, n.response);
                }
                const o = Date.now();
                let a;
                try {
                    a = await fetch(i);
                } catch (t1) {
                    if ("AbortError" === t1.name) throw t1;
                    throw new Error(`${t1.message} ${e1.url}`, {
                        cause: t1
                    });
                }
                if (t1 && t1.throwIfAborted(), !a.ok) throw new si(a.statusText, a.status, e1.url);
                const s = n ? a.clone() : null, l = await di(e1, a);
                return s && async function(e1, t1, i) {
                    if (Qt(), null == Jt) return;
                    const n = bt(t1.headers.get("cache-control") || "");
                    if (n["no-store"]) return;
                    const r = {
                        status: t1.status,
                        statusText: t1.statusText,
                        headers: new Headers(t1.headers)
                    };
                    n["max-age"] && r.headers.set("Expires", new Date(i + 1e3 * n["max-age"]).toUTCString());
                    const o = r.headers.get("expires");
                    if (!o) return;
                    if (new Date(o).getTime() - i < 42e4) return;
                    let a = Zt(e1.url, {
                        persistentParams: Yt
                    });
                    if (206 === t1.status) {
                        const t1 = e1.headers.get("Range");
                        if (!t1) return;
                        r.status = 200, a = $t(a, {
                            range: t1
                        });
                    }
                    const s = new Response(200 !== (l = t1.status) && 404 !== l && [
                        101,
                        103,
                        204,
                        205,
                        304
                    ].includes(l) ? null : t1.body, r);
                    var l;
                    if (Qt(), null != Jt) try {
                        const e1 = await Jt;
                        await e1.put(a, s);
                    } catch (e1) {
                        mt(e1.message);
                    }
                }(i, s, o), l;
            }(e1, t1);
        }
        async function pi(e1, t1) {
            return fi(Object.assign(e1, {
                type: "json"
            }), t1);
        }
        async function _i(e1, t1) {
            return fi(Object.assign(e1, {
                type: "arrayBuffer"
            }), t1);
        }
        function mi(e1) {
            const t1 = document.createElement("a");
            return t1.href = e1, t1.protocol === location.protocol && t1.host === location.host;
        }
        let gi, yi;
        gi = [], yi = 0;
        const xi = "01", vi = {
            create: "create",
            load: "load",
            fullLoad: "fullLoad"
        }, bi = {
            mark (e1) {
                performance.mark(e1);
            },
            measure (e1, t1, i) {
                performance.measure(e1, t1, i);
            }
        };
        function wi(e1) {
            const t1 = e1.name.split("?")[0];
            return ni(t1) && t1.includes("mapbox-gl.js") ? "javascript" : ni(t1) && t1.includes("mapbox-gl.css") ? "css" : function(e1) {
                return Ut.API_FONTS_REGEX.test(e1);
            }(t1) ? "fontRange" : ri(t1) ? "sprite" : oi(t1) ? "style" : function(e1) {
                return Ut.API_TILEJSON_REGEX.test(e1);
            }(t1) ? "tilejson" : "other";
        }
        const Ei = /(\.(png|jpg)\d*)(?=$)/, Ai = /^.+\/v4\//, Ii = /\.[\w]+$/, Ti = /^(\/v4\/|\/(raster|rasterarrays)\/v1\/)/, Mi = /^access_token=(.*)$/, Si = "NO_ACCESS_TOKEN", zi = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function Ri(e1) {
            const t1 = e1.match(zi);
            if (!t1) throw new Error("Unable to parse URL object");
            return {
                protocol: t1[1],
                authority: t1[2],
                path: t1[3] || "/",
                params: t1[4] ? t1[4].split("&") : []
            };
        }
        function Pi(e1) {
            const t1 = e1.params.length ? `?${e1.params.join("&")}` : "";
            return `${e1.protocol}://${e1.authority}${e1.path}${t1}`;
        }
        const Di = "mapbox.eventData";
        function Ci(e1) {
            if (!e1) return null;
            const t1 = e1.split(".");
            if (!t1 || 3 !== t1.length) return null;
            try {
                return JSON.parse(decodeURIComponent(atob(t1[1]).split("").map((e1)=>"%" + ("00" + e1.charCodeAt(0).toString(16)).slice(-2)).join("")));
            } catch (e1) {
                return null;
            }
        }
        function Fi(e1) {
            return !(!Ut.EVENTS_URL || !e1 && !Ut.ACCESS_TOKEN);
        }
        let Oi;
        const Li = /^[\w.+-]+(\/[\w.+-]+)?$/;
        let Bi = "other";
        class Ni {
            constructor(e1){
                this.type = e1, this.anonId = null, this.anonIdTimestamp = null, this.eventData = {}, this.queue = [], this.pendingRequest = !1;
            }
            getStorageKey(e1) {
                const t1 = Ci(Ut.ACCESS_TOKEN);
                let i = "";
                return i = t1 && t1.u ? btoa(encodeURIComponent(t1.u).replace(/%([0-9A-F]{2})/g, (e1, t1)=>String.fromCharCode(Number("0x" + t1)))) : Ut.ACCESS_TOKEN || "", e1 ? `${Di}.${e1}:${i}` : `${Di}:${i}`;
            }
            fetchEventData() {
                const e1 = Et("localStorage"), t1 = this.getStorageKey(), i = this.getStorageKey("uuid"), n = this.getStorageKey("uuidTimestamp");
                if (e1) try {
                    const e1 = localStorage.getItem(t1);
                    e1 && (this.eventData = JSON.parse(e1));
                    const r = localStorage.getItem(i);
                    r && (this.anonId = r);
                    const o = localStorage.getItem(n);
                    o && (this.anonIdTimestamp = Number(o));
                    const a = Date.now() - 864e5;
                    (!this.anonIdTimestamp || this.anonIdTimestamp < a) && this.refreshUUID();
                } catch (e1) {
                    mt("Unable to read from LocalStorage");
                }
            }
            refreshUUID() {
                this.anonId = st(), this.anonIdTimestamp = Date.now();
            }
            saveEventData() {
                const e1 = Et("localStorage"), t1 = this.getStorageKey(), i = this.getStorageKey("uuid"), n = this.getStorageKey("uuidTimestamp"), r = this.anonId, o = this.anonIdTimestamp;
                if (e1 && r) try {
                    localStorage.setItem(i, r), Object.keys(this.eventData).length >= 1 && localStorage.setItem(t1, JSON.stringify(this.eventData)), o && localStorage.setItem(n, o.toString());
                } catch (e1) {
                    mt("Unable to write to LocalStorage");
                }
            }
            processRequests() {}
            postEvent(e1, t1, i, n) {
                if (!Ut.EVENTS_URL) return;
                const r = Ri(Ut.EVENTS_URL);
                r.params.push(`access_token=${n || Ut.ACCESS_TOKEN || ""}`);
                const o = {
                    event: this.type,
                    created: new Date(e1).toISOString()
                }, a = t1 ? Object.assign(o, t1) : o, s = {
                    url: Pi(r),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        a
                    ])
                };
                this.pendingRequest = !0, (async function(e1) {
                    return fi(Object.assign(e1, {
                        method: "POST"
                    }), void 0);
                })(s).then(()=>{
                    this.pendingRequest = !1, i(null), this.saveEventData(), this.processRequests();
                }).catch((e1)=>{
                    this.pendingRequest = !1, i(e1), this.saveEventData(), this.processRequests();
                });
            }
            queueRequest(e1, t1) {
                this.queue.push({
                    ...e1,
                    customAccessToken: t1
                }), this.processRequests();
            }
        }
        class Vi extends Ni {
            constructor(e1){
                super("metrics"), e1 && (this.data = e1);
            }
            postMetricsEvent(e1) {
                if (!Fi(e1)) return;
                this.anonId || this.fetchEventData(), ut(this.anonId) || this.refreshUUID();
                const t1 = {
                    ...this.data,
                    sessionId: this.anonId
                };
                this.queueRequest({
                    timestamp: Date.now(),
                    payload: t1
                }, e1);
            }
            processRequests() {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: e1, payload: t1, customAccessToken: i } = this.queue.shift();
                this.postEvent(e1, t1, ()=>{}, i);
            }
        }
        const ki = new class extends Ni {
            constructor(e1){
                super("appUserTurnstile"), this._customAccessToken = e1;
            }
            postTurnstileEvent(e1, t1) {
                Fi(t1) && Array.isArray(e1) && e1.some((e1)=>ii(e1) || ti(e1)) && this.queueRequest({
                    timestamp: Date.now()
                }, t1);
            }
            processRequests() {
                if (this.pendingRequest || 0 === this.queue.length) return;
                this.anonId && this.anonIdTimestamp && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                const e1 = Ci(Ut.ACCESS_TOKEN), t1 = e1 ? e1.u : Ut.ACCESS_TOKEN;
                let n = t1 !== this.eventData.tokenU;
                ut(this.anonId) || (this.refreshUUID(), n = !0);
                const { timestamp: r, customAccessToken: o } = this.queue.shift();
                if (this.eventData.lastSuccess) {
                    const e1 = new Date(this.eventData.lastSuccess), t1 = new Date(r), i = (r - this.eventData.lastSuccess) / 864e5;
                    n = n || i >= 1 || i < -1 || e1.getDate() !== t1.getDate();
                } else n = !0;
                if (!n) return void this.processRequests();
                const a = {
                    version: "2.2",
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: i,
                    skuId: xi,
                    "enabled.telemetry": !1,
                    userId: this.anonId,
                    bundleFormat: "umd",
                    bundleDistribution: Bi
                };
                Oi && (a.sdkInfo = Oi), this.postEvent(r, a, (e1)=>{
                    e1 || (this.eventData.lastSuccess = r, this.eventData.tokenU = t1);
                }, o);
            }
        }, Ui = ki.postTurnstileEvent.bind(ki), Gi = new class extends Ni {
            constructor(){
                super("map.load"), this.success = {}, this.skuToken = "";
            }
            postMapLoadEvent(e1, t1, i, n) {
                this.skuToken = t1, this.errorCb = n, Ut.EVENTS_URL && (i || Ut.ACCESS_TOKEN ? this.queueRequest({
                    id: e1,
                    timestamp: Date.now()
                }, i) : this.errorCb(new Error(Si)));
            }
            processRequests() {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: e1, timestamp: t1, customAccessToken: n } = this.queue.shift();
                if (e1 && this.success[e1]) return;
                this.anonId && this.anonIdTimestamp || this.fetchEventData(), ut(this.anonId) || this.refreshUUID();
                const r = {
                    version: "2.2",
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: i,
                    skuId: xi,
                    skuToken: this.skuToken,
                    userId: this.anonId,
                    bundleFormat: "umd",
                    bundleDistribution: Bi
                };
                Oi && (r.sdkInfo = Oi), this.postEvent(t1, r, (t1)=>{
                    t1 ? this.errorCb(t1) : e1 && (this.success[e1] = !0);
                }, n);
            }
            remove() {
                this.errorCb = null;
            }
        }, ji = Gi.postMapLoadEvent.bind(Gi), Hi = new class extends Ni {
            constructor(){
                super("style.load"), this.eventIdPerMapInstanceMap = new Map, this.mapInstanceIdMap = new WeakMap;
            }
            getMapInstanceId(e1) {
                let t1 = this.mapInstanceIdMap.get(e1);
                return t1 || (t1 = st(), this.mapInstanceIdMap.set(e1, t1)), t1;
            }
            getEventId(e1) {
                const t1 = this.eventIdPerMapInstanceMap.get(e1) || 0;
                return this.eventIdPerMapInstanceMap.set(e1, t1 + 1), t1;
            }
            postStyleLoadEvent(e1, t1) {
                const { map: i, style: n, importedStyles: r } = t1;
                if (!Fi(e1)) return;
                const o = this.getMapInstanceId(i), a = {
                    mapInstanceId: o,
                    eventId: this.getEventId(o),
                    style: n
                };
                r.length && (a.importedStyles = r), this.queueRequest({
                    timestamp: Date.now(),
                    payload: a
                }, e1);
            }
            processRequests() {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: e1, payload: t1, customAccessToken: i } = this.queue.shift();
                this.postEvent(e1, t1, ()=>{}, i);
            }
        }, $i = Hi.postStyleLoadEvent.bind(Hi), Zi = new Vi({
            attributes: [
                {
                    name: "maps/js/layer-animations/style-with-appearances"
                }
            ]
        }), Wi = Zi.postMetricsEvent.bind(Zi), qi = new Vi({
            attributes: [
                {
                    name: "maps/js/layer-animations/runtime-appearances"
                }
            ]
        }), Xi = qi.postMetricsEvent.bind(qi), Yi = new class extends Ni {
            constructor(){
                super("gljs.performance");
            }
            postPerformanceEvent(e1, t1) {
                Fi(e1) && this.queueRequest({
                    timestamp: Date.now(),
                    performanceData: t1
                }, e1);
            }
            processRequests() {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: e1, performanceData: t1, customAccessToken: n } = this.queue.shift(), r = function(e1) {
                    const t1 = performance.getEntriesByType("resource"), n = performance.getEntriesByType("mark"), r = function(e1) {
                        const t1 = {};
                        if (e1) {
                            for(const i in e1)if ("other" !== i) for (const n of e1[i]){
                                const e1 = `${i}ResolveRangeMin`, r = `${i}ResolveRangeMax`, o = `${i}RequestCount`, a = `${i}RequestCachedCount`;
                                t1[e1] = Math.min(t1[e1] || 1 / 0, n.startTime), t1[r] = Math.max(t1[r] || -1 / 0, n.responseEnd);
                                const s = (e1)=>{
                                    void 0 === t1[e1] && (t1[e1] = 0), ++t1[e1];
                                };
                                void 0 !== n.transferSize && 0 === n.transferSize && s(a), s(o);
                            }
                        }
                        return t1;
                    }(function(e1, t1) {
                        const i = {};
                        if (e1) for (const n of e1){
                            const e1 = t1(n);
                            void 0 === i[e1] && (i[e1] = []), i[e1].push(n);
                        }
                        return i;
                    }(t1, wi)), o = window.devicePixelRatio, a = navigator.connection || navigator.mozConnection || navigator.webkitConnection, s = a ? a.effectiveType : void 0, l = {
                        counters: [],
                        metadata: [],
                        attributes: []
                    }, u = (e1, t1, i)=>{
                        null != i && e1.push({
                            name: t1,
                            value: i.toString()
                        });
                    };
                    for(const e1 in r)u(l.counters, e1, r[e1]);
                    if (e1.interactionRange[0] !== 1 / 0 && e1.interactionRange[1] !== -1 / 0 && (u(l.counters, "interactionRangeMin", e1.interactionRange[0]), u(l.counters, "interactionRangeMax", e1.interactionRange[1])), n) for (const e1 of Object.values(vi)){
                        const t1 = n.find((t1)=>t1.name === e1);
                        t1 && u(l.counters, e1, t1.startTime);
                    }
                    return u(l.counters, "visibilityHidden", e1.visibilityHidden), u(l.attributes, "style", function(e1) {
                        if (e1) for (const t1 of e1){
                            const e1 = t1.name.split("?")[0];
                            if (oi(e1)) {
                                const t1 = e1.split("/").slice(-2);
                                if (2 === t1.length) return `mapbox://styles/${t1[0]}/${t1[1]}`;
                            }
                        }
                    }(t1)), u(l.attributes, "terrainEnabled", e1.terrainEnabled ? "true" : "false"), u(l.attributes, "fogEnabled", e1.fogEnabled ? "true" : "false"), u(l.attributes, "projection", e1.projection), u(l.attributes, "zoom", e1.zoom), u(l.metadata, "devicePixelRatio", o), u(l.metadata, "connectionEffectiveType", s), u(l.metadata, "navigatorUserAgent", navigator.userAgent), u(l.metadata, "screenWidth", window.screen.width), u(l.metadata, "screenHeight", window.screen.height), u(l.metadata, "windowWidth", window.innerWidth), u(l.metadata, "windowHeight", window.innerHeight), u(l.metadata, "mapWidth", e1.width / o), u(l.metadata, "mapHeight", e1.height / o), u(l.metadata, "webglRenderer", e1.renderer), u(l.metadata, "webglVendor", e1.vendor), u(l.metadata, "sdkVersion", i), u(l.metadata, "sdkIdentifier", "mapbox-gl-js"), l;
                }(t1);
                for (const e1 of r.metadata);
                for (const e1 of r.counters);
                for (const e1 of r.attributes);
                this.postEvent(e1, r, ()=>{}, n);
            }
        }, Ji = Yi.postPerformanceEvent.bind(Yi), Ki = new class extends Ni {
            constructor(){
                super("map.auth"), this.success = {}, this.skuToken = "";
            }
            getSession(e1, t1, i, n) {
                if (!Ut.API_URL || !Ut.SESSION_PATH) return;
                const r = Ri(Ut.API_URL + Ut.SESSION_PATH);
                r.params.push(`sku=${t1 || ""}`), r.params.push(`access_token=${n || Ut.ACCESS_TOKEN || ""}`);
                const o = {
                    url: Pi(r),
                    headers: {
                        "Content-Type": "text/plain"
                    }
                };
                this.pendingRequest = !0, (async function(e1) {
                    return fi(Object.assign(e1, {
                        method: "GET"
                    }), void 0);
                })(o).then(()=>{
                    this.pendingRequest = !1, i(null), this.saveEventData(), this.processRequests();
                }).catch((e1)=>{
                    this.pendingRequest = !1, i(e1), this.saveEventData(), this.processRequests();
                });
            }
            getSessionAPI(e1, t1, i, n) {
                this.skuToken = t1, this.errorCb = n, Ut.EVENTS_URL && Ut.SESSION_PATH && Ut.API_URL && (i || Ut.ACCESS_TOKEN ? this.queueRequest({
                    id: e1,
                    timestamp: Date.now()
                }, i) : this.errorCb(new Error(Si)));
            }
            processRequests() {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: e1, timestamp: t1, customAccessToken: i } = this.queue.shift();
                e1 && this.success[e1] || this.getSession(t1, this.skuToken, (t1)=>{
                    t1 ? this.errorCb(t1) : e1 && (this.success[e1] = !0);
                }, i);
            }
            remove() {
                this.errorCb = null;
            }
        }, Qi = Ki.getSessionAPI.bind(Ki), en = new Set;
        function tn(e1, t1 = 0) {
            const i = 3432918353, n = 461845907, r = e1.length, o = r - (3 & r);
            let a, s = 0 | t1, l = 0;
            for(; l < o;)a = 255 & e1.charCodeAt(l) | (255 & e1.charCodeAt(l + 1)) << 8 | (255 & e1.charCodeAt(l + 2)) << 16 | (255 & e1.charCodeAt(l + 3)) << 24, l += 4, a = Math.imul(a, i), a = a << 15 | a >>> 17, a = Math.imul(a, n), s ^= a, s = s << 13 | s >>> 19, s = Math.imul(s, 5) + 3864292196 | 0;
            a = 0;
            const u = 3 & r;
            return u > 0 && (u >= 3 && (a ^= (255 & e1.charCodeAt(l + 2)) << 16), u >= 2 && (a ^= (255 & e1.charCodeAt(l + 1)) << 8), a ^= 255 & e1.charCodeAt(l), a = Math.imul(a, i), a = a << 15 | a >>> 17, a = Math.imul(a, n), s ^= a), s ^= r, s ^= s >>> 16, s = Math.imul(s, 2246822507), s ^= s >>> 13, s = Math.imul(s, 3266489909), s ^= s >>> 16, s >>> 0;
        }
        class nn {
            constructor(e1, ...t1){
                Object.assign(this, t1[0] || {}), this.type = e1;
            }
        }
        class rn extends nn {
            constructor(e1, t1 = {}){
                super("error", {
                    error: e1,
                    ...t1
                });
            }
        }
        function on(e1, t1, i) {
            i[e1] && i[e1].includes(t1) || (i[e1] = i[e1] || [], i[e1].push(t1));
        }
        function an(e1, t1, i) {
            if (i && i[e1]) {
                const n = i[e1].indexOf(t1);
                -1 !== n && i[e1].splice(n, 1);
            }
        }
        class sn {
            on(e1, t1) {
                return this._listeners = this._listeners || {}, on(e1, t1, this._listeners), this;
            }
            off(e1, t1) {
                return an(e1, t1, this._listeners), an(e1, t1, this._oneTimeListeners), this;
            }
            once(e1, t1) {
                return t1 ? (this._oneTimeListeners = this._oneTimeListeners || {}, on(e1, t1, this._oneTimeListeners), this) : new Promise((t1)=>{
                    this.once(e1, t1);
                });
            }
            fire(e1, t1) {
                const i = "string" == typeof e1 ? new nn(e1, t1) : e1, n = i.type;
                if (this.listens(n)) {
                    i.target = this;
                    const e1 = this._listeners && this._listeners[n] ? this._listeners[n].slice() : [];
                    for (const t1 of e1)t1.call(this, i);
                    const t1 = this._oneTimeListeners && this._oneTimeListeners[n] ? this._oneTimeListeners[n].slice() : [];
                    for (const e1 of t1)an(n, e1, this._oneTimeListeners), e1.call(this, i);
                    const r = this._eventedParent;
                    if (r) {
                        const e1 = "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData;
                        Object.assign(i, e1), r.fire(i);
                    }
                } else i instanceof rn && console.error(i.error);
                return this;
            }
            listens(e1) {
                return !!(this._listeners && this._listeners[e1] && this._listeners[e1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[e1] && this._oneTimeListeners[e1].length > 0 || this._eventedParent && this._eventedParent.listens(e1));
            }
            setEventedParent(e1, t1) {
                return this._eventedParent = e1, this._eventedParentData = t1, this;
            }
        }
        class ln {
            constructor(e1){
                "string" == typeof e1 ? this.name = e1 : (this.name = e1.name, this.iconsetId = e1.iconsetId);
            }
            static from(e1) {
                return new ln(e1);
            }
            static toString(e1) {
                return e1.iconsetId ? `${e1.name}${e1.iconsetId}` : e1.name;
            }
            static parse(e1) {
                const [t1, i] = e1.split("");
                return new ln({
                    name: t1,
                    iconsetId: i
                });
            }
            static isEqual(e1, t1) {
                return e1.name === t1.name && e1.iconsetId === t1.iconsetId;
            }
            toString() {
                return ln.toString(this);
            }
            serialize() {
                return {
                    name: this.name,
                    iconsetId: this.iconsetId
                };
            }
        }
        var un, cn = {}, hn = function() {
            if (un) return cn;
            un = 1;
            var e1 = {
                transparent: [
                    0,
                    0,
                    0,
                    0
                ],
                aliceblue: [
                    240,
                    248,
                    255,
                    1
                ],
                antiquewhite: [
                    250,
                    235,
                    215,
                    1
                ],
                aqua: [
                    0,
                    255,
                    255,
                    1
                ],
                aquamarine: [
                    127,
                    255,
                    212,
                    1
                ],
                azure: [
                    240,
                    255,
                    255,
                    1
                ],
                beige: [
                    245,
                    245,
                    220,
                    1
                ],
                bisque: [
                    255,
                    228,
                    196,
                    1
                ],
                black: [
                    0,
                    0,
                    0,
                    1
                ],
                blanchedalmond: [
                    255,
                    235,
                    205,
                    1
                ],
                blue: [
                    0,
                    0,
                    255,
                    1
                ],
                blueviolet: [
                    138,
                    43,
                    226,
                    1
                ],
                brown: [
                    165,
                    42,
                    42,
                    1
                ],
                burlywood: [
                    222,
                    184,
                    135,
                    1
                ],
                cadetblue: [
                    95,
                    158,
                    160,
                    1
                ],
                chartreuse: [
                    127,
                    255,
                    0,
                    1
                ],
                chocolate: [
                    210,
                    105,
                    30,
                    1
                ],
                coral: [
                    255,
                    127,
                    80,
                    1
                ],
                cornflowerblue: [
                    100,
                    149,
                    237,
                    1
                ],
                cornsilk: [
                    255,
                    248,
                    220,
                    1
                ],
                crimson: [
                    220,
                    20,
                    60,
                    1
                ],
                cyan: [
                    0,
                    255,
                    255,
                    1
                ],
                darkblue: [
                    0,
                    0,
                    139,
                    1
                ],
                darkcyan: [
                    0,
                    139,
                    139,
                    1
                ],
                darkgoldenrod: [
                    184,
                    134,
                    11,
                    1
                ],
                darkgray: [
                    169,
                    169,
                    169,
                    1
                ],
                darkgreen: [
                    0,
                    100,
                    0,
                    1
                ],
                darkgrey: [
                    169,
                    169,
                    169,
                    1
                ],
                darkkhaki: [
                    189,
                    183,
                    107,
                    1
                ],
                darkmagenta: [
                    139,
                    0,
                    139,
                    1
                ],
                darkolivegreen: [
                    85,
                    107,
                    47,
                    1
                ],
                darkorange: [
                    255,
                    140,
                    0,
                    1
                ],
                darkorchid: [
                    153,
                    50,
                    204,
                    1
                ],
                darkred: [
                    139,
                    0,
                    0,
                    1
                ],
                darksalmon: [
                    233,
                    150,
                    122,
                    1
                ],
                darkseagreen: [
                    143,
                    188,
                    143,
                    1
                ],
                darkslateblue: [
                    72,
                    61,
                    139,
                    1
                ],
                darkslategray: [
                    47,
                    79,
                    79,
                    1
                ],
                darkslategrey: [
                    47,
                    79,
                    79,
                    1
                ],
                darkturquoise: [
                    0,
                    206,
                    209,
                    1
                ],
                darkviolet: [
                    148,
                    0,
                    211,
                    1
                ],
                deeppink: [
                    255,
                    20,
                    147,
                    1
                ],
                deepskyblue: [
                    0,
                    191,
                    255,
                    1
                ],
                dimgray: [
                    105,
                    105,
                    105,
                    1
                ],
                dimgrey: [
                    105,
                    105,
                    105,
                    1
                ],
                dodgerblue: [
                    30,
                    144,
                    255,
                    1
                ],
                firebrick: [
                    178,
                    34,
                    34,
                    1
                ],
                floralwhite: [
                    255,
                    250,
                    240,
                    1
                ],
                forestgreen: [
                    34,
                    139,
                    34,
                    1
                ],
                fuchsia: [
                    255,
                    0,
                    255,
                    1
                ],
                gainsboro: [
                    220,
                    220,
                    220,
                    1
                ],
                ghostwhite: [
                    248,
                    248,
                    255,
                    1
                ],
                gold: [
                    255,
                    215,
                    0,
                    1
                ],
                goldenrod: [
                    218,
                    165,
                    32,
                    1
                ],
                gray: [
                    128,
                    128,
                    128,
                    1
                ],
                green: [
                    0,
                    128,
                    0,
                    1
                ],
                greenyellow: [
                    173,
                    255,
                    47,
                    1
                ],
                grey: [
                    128,
                    128,
                    128,
                    1
                ],
                honeydew: [
                    240,
                    255,
                    240,
                    1
                ],
                hotpink: [
                    255,
                    105,
                    180,
                    1
                ],
                indianred: [
                    205,
                    92,
                    92,
                    1
                ],
                indigo: [
                    75,
                    0,
                    130,
                    1
                ],
                ivory: [
                    255,
                    255,
                    240,
                    1
                ],
                khaki: [
                    240,
                    230,
                    140,
                    1
                ],
                lavender: [
                    230,
                    230,
                    250,
                    1
                ],
                lavenderblush: [
                    255,
                    240,
                    245,
                    1
                ],
                lawngreen: [
                    124,
                    252,
                    0,
                    1
                ],
                lemonchiffon: [
                    255,
                    250,
                    205,
                    1
                ],
                lightblue: [
                    173,
                    216,
                    230,
                    1
                ],
                lightcoral: [
                    240,
                    128,
                    128,
                    1
                ],
                lightcyan: [
                    224,
                    255,
                    255,
                    1
                ],
                lightgoldenrodyellow: [
                    250,
                    250,
                    210,
                    1
                ],
                lightgray: [
                    211,
                    211,
                    211,
                    1
                ],
                lightgreen: [
                    144,
                    238,
                    144,
                    1
                ],
                lightgrey: [
                    211,
                    211,
                    211,
                    1
                ],
                lightpink: [
                    255,
                    182,
                    193,
                    1
                ],
                lightsalmon: [
                    255,
                    160,
                    122,
                    1
                ],
                lightseagreen: [
                    32,
                    178,
                    170,
                    1
                ],
                lightskyblue: [
                    135,
                    206,
                    250,
                    1
                ],
                lightslategray: [
                    119,
                    136,
                    153,
                    1
                ],
                lightslategrey: [
                    119,
                    136,
                    153,
                    1
                ],
                lightsteelblue: [
                    176,
                    196,
                    222,
                    1
                ],
                lightyellow: [
                    255,
                    255,
                    224,
                    1
                ],
                lime: [
                    0,
                    255,
                    0,
                    1
                ],
                limegreen: [
                    50,
                    205,
                    50,
                    1
                ],
                linen: [
                    250,
                    240,
                    230,
                    1
                ],
                magenta: [
                    255,
                    0,
                    255,
                    1
                ],
                maroon: [
                    128,
                    0,
                    0,
                    1
                ],
                mediumaquamarine: [
                    102,
                    205,
                    170,
                    1
                ],
                mediumblue: [
                    0,
                    0,
                    205,
                    1
                ],
                mediumorchid: [
                    186,
                    85,
                    211,
                    1
                ],
                mediumpurple: [
                    147,
                    112,
                    219,
                    1
                ],
                mediumseagreen: [
                    60,
                    179,
                    113,
                    1
                ],
                mediumslateblue: [
                    123,
                    104,
                    238,
                    1
                ],
                mediumspringgreen: [
                    0,
                    250,
                    154,
                    1
                ],
                mediumturquoise: [
                    72,
                    209,
                    204,
                    1
                ],
                mediumvioletred: [
                    199,
                    21,
                    133,
                    1
                ],
                midnightblue: [
                    25,
                    25,
                    112,
                    1
                ],
                mintcream: [
                    245,
                    255,
                    250,
                    1
                ],
                mistyrose: [
                    255,
                    228,
                    225,
                    1
                ],
                moccasin: [
                    255,
                    228,
                    181,
                    1
                ],
                navajowhite: [
                    255,
                    222,
                    173,
                    1
                ],
                navy: [
                    0,
                    0,
                    128,
                    1
                ],
                oldlace: [
                    253,
                    245,
                    230,
                    1
                ],
                olive: [
                    128,
                    128,
                    0,
                    1
                ],
                olivedrab: [
                    107,
                    142,
                    35,
                    1
                ],
                orange: [
                    255,
                    165,
                    0,
                    1
                ],
                orangered: [
                    255,
                    69,
                    0,
                    1
                ],
                orchid: [
                    218,
                    112,
                    214,
                    1
                ],
                palegoldenrod: [
                    238,
                    232,
                    170,
                    1
                ],
                palegreen: [
                    152,
                    251,
                    152,
                    1
                ],
                paleturquoise: [
                    175,
                    238,
                    238,
                    1
                ],
                palevioletred: [
                    219,
                    112,
                    147,
                    1
                ],
                papayawhip: [
                    255,
                    239,
                    213,
                    1
                ],
                peachpuff: [
                    255,
                    218,
                    185,
                    1
                ],
                peru: [
                    205,
                    133,
                    63,
                    1
                ],
                pink: [
                    255,
                    192,
                    203,
                    1
                ],
                plum: [
                    221,
                    160,
                    221,
                    1
                ],
                powderblue: [
                    176,
                    224,
                    230,
                    1
                ],
                purple: [
                    128,
                    0,
                    128,
                    1
                ],
                rebeccapurple: [
                    102,
                    51,
                    153,
                    1
                ],
                red: [
                    255,
                    0,
                    0,
                    1
                ],
                rosybrown: [
                    188,
                    143,
                    143,
                    1
                ],
                royalblue: [
                    65,
                    105,
                    225,
                    1
                ],
                saddlebrown: [
                    139,
                    69,
                    19,
                    1
                ],
                salmon: [
                    250,
                    128,
                    114,
                    1
                ],
                sandybrown: [
                    244,
                    164,
                    96,
                    1
                ],
                seagreen: [
                    46,
                    139,
                    87,
                    1
                ],
                seashell: [
                    255,
                    245,
                    238,
                    1
                ],
                sienna: [
                    160,
                    82,
                    45,
                    1
                ],
                silver: [
                    192,
                    192,
                    192,
                    1
                ],
                skyblue: [
                    135,
                    206,
                    235,
                    1
                ],
                slateblue: [
                    106,
                    90,
                    205,
                    1
                ],
                slategray: [
                    112,
                    128,
                    144,
                    1
                ],
                slategrey: [
                    112,
                    128,
                    144,
                    1
                ],
                snow: [
                    255,
                    250,
                    250,
                    1
                ],
                springgreen: [
                    0,
                    255,
                    127,
                    1
                ],
                steelblue: [
                    70,
                    130,
                    180,
                    1
                ],
                tan: [
                    210,
                    180,
                    140,
                    1
                ],
                teal: [
                    0,
                    128,
                    128,
                    1
                ],
                thistle: [
                    216,
                    191,
                    216,
                    1
                ],
                tomato: [
                    255,
                    99,
                    71,
                    1
                ],
                turquoise: [
                    64,
                    224,
                    208,
                    1
                ],
                violet: [
                    238,
                    130,
                    238,
                    1
                ],
                wheat: [
                    245,
                    222,
                    179,
                    1
                ],
                white: [
                    255,
                    255,
                    255,
                    1
                ],
                whitesmoke: [
                    245,
                    245,
                    245,
                    1
                ],
                yellow: [
                    255,
                    255,
                    0,
                    1
                ],
                yellowgreen: [
                    154,
                    205,
                    50,
                    1
                ]
            };
            function t1(e1) {
                return (e1 = Math.round(e1)) < 0 ? 0 : e1 > 255 ? 255 : e1;
            }
            function i(e1) {
                return t1("%" === e1[e1.length - 1] ? parseFloat(e1) / 100 * 255 : parseInt(e1));
            }
            function n(e1) {
                var t1;
                return (t1 = "%" === e1[e1.length - 1] ? parseFloat(e1) / 100 : parseFloat(e1)) < 0 ? 0 : t1 > 1 ? 1 : t1;
            }
            function r(e1, t1, i) {
                return i < 0 ? i += 1 : i > 1 && (i -= 1), 6 * i < 1 ? e1 + (t1 - e1) * i * 6 : 2 * i < 1 ? t1 : 3 * i < 2 ? e1 + (t1 - e1) * (2 / 3 - i) * 6 : e1;
            }
            try {
                cn.parseCSSColor = function(o) {
                    var a, s = o.replace(/ /g, "").toLowerCase();
                    if (s in e1) return e1[s].slice();
                    if ("#" === s[0]) return 4 === s.length ? (a = parseInt(s.substr(1), 16)) >= 0 && a <= 4095 ? [
                        (3840 & a) >> 4 | (3840 & a) >> 8,
                        240 & a | (240 & a) >> 4,
                        15 & a | (15 & a) << 4,
                        1
                    ] : null : 7 === s.length && (a = parseInt(s.substr(1), 16)) >= 0 && a <= 16777215 ? [
                        (16711680 & a) >> 16,
                        (65280 & a) >> 8,
                        255 & a,
                        1
                    ] : null;
                    var l = s.indexOf("("), u = s.indexOf(")");
                    if (-1 !== l && u + 1 === s.length) {
                        var c = s.substr(0, l), h = s.substr(l + 1, u - (l + 1)).split(","), d = 1;
                        switch(c){
                            case "rgba":
                                if (4 !== h.length) return null;
                                d = n(h.pop());
                            case "rgb":
                                return 3 !== h.length ? null : [
                                    i(h[0]),
                                    i(h[1]),
                                    i(h[2]),
                                    d
                                ];
                            case "hsla":
                                if (4 !== h.length) return null;
                                d = n(h.pop());
                            case "hsl":
                                if (3 !== h.length) return null;
                                var f = (parseFloat(h[0]) % 360 + 360) % 360 / 360, p = n(h[1]), _ = n(h[2]), m = _ <= .5 ? _ * (p + 1) : _ + p - _ * p, g = 2 * _ - m;
                                return [
                                    t1(255 * r(g, m, f + 1 / 3)),
                                    t1(255 * r(g, m, f)),
                                    t1(255 * r(g, m, f - 1 / 3)),
                                    d
                                ];
                            default:
                                return null;
                        }
                    }
                    return null;
                };
            } catch (e1) {}
            return cn;
        }();
        function dn(e1, t1, i) {
            return e1 * (1 - i) + t1 * i;
        }
        const fn = new Map;
        class pn {
            constructor(e1, t1, i, n = 1){
                this.r = e1, this.g = t1, this.b = i, this.a = n;
            }
            static parse(e1) {
                if (!e1) return;
                if (e1 instanceof pn) return e1;
                if ("string" != typeof e1) return;
                const t1 = fn.get(e1);
                if (t1) return t1;
                const i = hn.parseCSSColor(e1);
                if (!i) return;
                const n = new pn(i[0] / 255, i[1] / 255, i[2] / 255, i[3]);
                return fn.set(e1, n), n;
            }
            toString() {
                const { r: e1, g: t1, b: i, a: n } = this;
                return `rgba(${Math.round(255 * e1)},${Math.round(255 * t1)},${Math.round(255 * i)},${n})`;
            }
            toNonPremultipliedRenderColor(e1) {
                const { r: t1, g: i, b: n, a: r } = this;
                return new mn(e1, t1, i, n, r);
            }
            toPremultipliedRenderColor(e1) {
                const { r: t1, g: i, b: n, a: r } = this;
                return new gn(e1, t1 * r, i * r, n * r, r);
            }
            clone() {
                return new pn(this.r, this.g, this.b, this.a);
            }
        }
        class _n {
            constructor(e1, t1, i, n, r, o = !1){
                if (this.premultiplied = !1, this.premultiplied = o, e1) {
                    const o = e1.image.height, a = o * o;
                    this.premultiplied ? (t1 = 0 === r ? 0 : t1 / r * (o - 1), i = 0 === r ? 0 : i / r * (o - 1), n = 0 === r ? 0 : n / r * (o - 1)) : (t1 *= o - 1, i *= o - 1, n *= o - 1), t1 = Math.max(0, Math.min(o - 1, t1)), i = Math.max(0, Math.min(o - 1, i)), n = Math.max(0, Math.min(o - 1, n));
                    const s = Math.floor(t1), l = Math.floor(i), u = Math.floor(n), c = Math.ceil(t1), h = Math.ceil(i), d = Math.ceil(n), f = t1 - s, p = i - l, _ = n - u, m = e1.image.data, g = 4 * (s + l * a + u * o), y = 4 * (s + l * a + d * o), x = 4 * (s + h * a + u * o), v = 4 * (s + h * a + d * o), b = 4 * (c + l * a + u * o), w = 4 * (c + l * a + d * o), E = 4 * (c + h * a + u * o), A = 4 * (c + h * a + d * o);
                    this.r = dn(dn(dn(m[g], m[y], _), dn(m[x], m[v], _), p), dn(dn(m[b], m[w], _), dn(m[E], m[A], _), p), f) / 255 * (this.premultiplied ? r : 1), this.g = dn(dn(dn(m[g + 1], m[y + 1], _), dn(m[x + 1], m[v + 1], _), p), dn(dn(m[b + 1], m[w + 1], _), dn(m[E + 1], m[A + 1], _), p), f) / 255 * (this.premultiplied ? r : 1), this.b = dn(dn(dn(m[g + 2], m[y + 2], _), dn(m[x + 2], m[v + 2], _), p), dn(dn(m[b + 2], m[w + 2], _), dn(m[E + 2], m[A + 2], _), p), f) / 255 * (this.premultiplied ? r : 1), this.a = r;
                } else this.r = t1, this.g = i, this.b = n, this.a = r;
            }
            toArray() {
                const { r: e1, g: t1, b: i, a: n } = this;
                return [
                    255 * e1,
                    255 * t1,
                    255 * i,
                    n
                ];
            }
            toHslaArray() {
                let { r: e1, g: t1, b: i, a: n } = this;
                if (this.premultiplied) {
                    if (0 === n) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    const r = 1 / n;
                    e1 *= r, t1 *= r, i *= r;
                }
                const r = Math.min(Math.max(e1, 0), 1), o = Math.min(Math.max(t1, 0), 1), a = Math.min(Math.max(i, 0), 1), s = Math.min(r, o, a), l = Math.max(r, o, a), u = l - s, c = .5 * (s + l);
                if (0 === u) return [
                    0,
                    0,
                    100 * c,
                    n
                ];
                const h = c > .5 ? u / (2 - l - s) : u / (l + s);
                let d;
                switch(l){
                    case r:
                        d = 60 * ((o - a) / u + (o < a ? 6 : 0));
                        break;
                    case o:
                        d = 60 * ((a - r) / u + 2);
                        break;
                    default:
                        d = 60 * ((r - o) / u + 4);
                }
                return [
                    d,
                    100 * h,
                    100 * c,
                    n
                ];
            }
            toArray01() {
                const { r: e1, g: t1, b: i, a: n } = this;
                return [
                    e1,
                    t1,
                    i,
                    n
                ];
            }
            toArray01Scaled(e1) {
                const { r: t1, g: i, b: n } = this;
                return [
                    t1 * e1,
                    i * e1,
                    n * e1
                ];
            }
            toArray01Linear() {
                const { r: e1, g: t1, b: i, a: n } = this;
                return [
                    Math.pow(e1, 2.2),
                    Math.pow(t1, 2.2),
                    Math.pow(i, 2.2),
                    n
                ];
            }
        }
        class mn extends _n {
            constructor(e1, t1, i, n, r){
                super(e1, t1, i, n, r, !1);
            }
        }
        class gn extends _n {
            constructor(e1, t1, i, n, r){
                super(e1, t1, i, n, r, !0);
            }
        }
        function yn(e1, t1, i) {
            return e1.map((e1, n)=>dn(e1, t1[n], i));
        }
        pn.black = new pn(0, 0, 0, 1), pn.white = new pn(1, 1, 1, 1), pn.transparent = new pn(0, 0, 0, 0), pn.red = new pn(1, 0, 0, 1), pn.blue = new pn(0, 0, 1, 1);
        var xn = Object.freeze({
            __proto__: null,
            array: yn,
            color: function(e1, t1, i) {
                return new pn(dn(e1.r, t1.r, i), dn(e1.g, t1.g, i), dn(e1.b, t1.b, i), dn(e1.a, t1.a, i));
            },
            number: dn
        });
        class vn extends Error {
            constructor(e1, t1){
                super(t1), this.message = t1, this.key = e1;
            }
        }
        class bn {
            constructor(e1, t1 = []){
                this.parent = e1, this.bindings = Object.create(null);
                for (const [e1, i] of t1)this.bindings[e1] = i;
            }
            concat(e1) {
                return new bn(this, e1);
            }
            get(e1) {
                if (this.bindings[e1]) return this.bindings[e1];
                if (this.parent) return this.parent.get(e1);
                throw new Error(`${e1} not found in scope.`);
            }
            has(e1) {
                return !!this.bindings[e1] || !!this.parent && this.parent.has(e1);
            }
        }
        const wn = {
            kind: "null"
        }, En = {
            kind: "number"
        }, An = {
            kind: "string"
        }, In = {
            kind: "boolean"
        }, Tn = {
            kind: "color"
        }, Mn = {
            kind: "object"
        }, Sn = {
            kind: "value"
        }, zn = {
            kind: "collator"
        }, Rn = {
            kind: "formatted"
        }, Pn = {
            kind: "resolvedImage"
        };
        function Dn(e1, t1) {
            return {
                kind: "array",
                itemType: e1,
                N: t1
            };
        }
        function Cn(e1) {
            if ("array" === e1.kind) {
                const t1 = Cn(e1.itemType);
                return "number" == typeof e1.N ? `array<${t1}, ${e1.N}>` : "value" === e1.itemType.kind ? "array" : `array<${t1}>`;
            }
            return e1.kind;
        }
        const Fn = [
            wn,
            En,
            An,
            In,
            Tn,
            Rn,
            Mn,
            Dn(Sn),
            Pn
        ];
        function On(e1, t1) {
            if ("error" === t1.kind) return null;
            if ("array" === e1.kind) {
                if ("array" === t1.kind && (0 === t1.N && "value" === t1.itemType.kind || !On(e1.itemType, t1.itemType)) && ("number" != typeof e1.N || e1.N === t1.N)) return null;
            } else {
                if (e1.kind === t1.kind) return null;
                if ("value" === e1.kind) {
                    for (const e1 of Fn)if (!On(e1, t1)) return null;
                }
            }
            return `Expected ${Cn(e1)} but found ${Cn(t1)} instead.`;
        }
        function Ln(e1, t1) {
            return t1.some((t1)=>"null" === t1 ? null === e1 : "array" === t1 ? Array.isArray(e1) : "object" === t1 ? e1 && !Array.isArray(e1) && "object" == typeof e1 : t1 === typeof e1);
        }
        function Bn(e1, t1) {
            return "array" === e1.kind && "array" === t1.kind ? e1.N === t1.N && Bn(e1.itemType, t1.itemType) : e1.kind === t1.kind;
        }
        class Nn {
            constructor(e1, t1, i){
                this.sensitivity = e1 ? t1 ? "variant" : "case" : t1 ? "accent" : "base", this.locale = i, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(e1, t1) {
                return this.collator.compare(e1, t1);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        class Vn {
            constructor(e1, t1, i, n, r){
                this.text = e1.normalize ? e1.normalize() : e1, this.image = t1, this.scale = i, this.fontStack = n, this.textColor = r;
            }
        }
        class kn {
            constructor(e1){
                this.sections = e1;
            }
            static fromString(e1) {
                return new kn([
                    new Vn(e1, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((e1)=>0 !== e1.text.length || !!e1.image && e1.image.hasPrimary());
            }
            static factory(e1) {
                return e1 instanceof kn ? e1 : kn.fromString(e1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((e1)=>e1.text).join("");
            }
            serialize() {
                const e1 = [
                    "format"
                ];
                for (const t1 of this.sections){
                    if (t1.image) {
                        const i = t1.image.getPrimary().id.toString();
                        e1.push([
                            "image",
                            i
                        ]);
                        continue;
                    }
                    e1.push(t1.text);
                    const i = {};
                    t1.fontStack && (i["text-font"] = [
                        "literal",
                        t1.fontStack.split(",")
                    ]), t1.scale && (i["font-scale"] = t1.scale), t1.textColor && (i["text-color"] = [
                        "rgba"
                    ].concat(t1.textColor.toNonPremultipliedRenderColor(null).toArray())), e1.push(i);
                }
                return e1;
            }
        }
        class Un {
            constructor(e1, t1 = {}){
                this.id = ln.from(e1), this.params = t1.params, this.sx = t1.sx || 1, this.sy = t1.sy || 1;
            }
            toString() {
                return JSON.stringify(this);
            }
            static parse(e1) {
                let t1, i, n, r;
                try {
                    ({ id: t1, params: i, sx: n, sy: r } = JSON.parse(e1) || {});
                } catch (e1) {
                    return null;
                }
                return t1 ? new Un(t1, {
                    params: i,
                    sx: n,
                    sy: r
                }) : null;
            }
            scaleSelf(e1, t1 = e1) {
                return this.sx *= e1, this.sy *= t1, this;
            }
        }
        class Gn {
            constructor(e1, t1, i, n, r = !1){
                this.primaryId = ln.from(e1), this.primaryOptions = t1, i && (this.secondaryId = ln.from(i)), this.secondaryOptions = n, this.available = r;
            }
            toString() {
                return this.primaryId && this.secondaryId ? `[${this.primaryId.name},${this.secondaryId.name}]` : this.primaryId.name;
            }
            hasPrimary() {
                return !!this.primaryId;
            }
            getPrimary() {
                return new Un(this.primaryId, this.primaryOptions);
            }
            hasSecondary() {
                return !!this.secondaryId;
            }
            getSecondary() {
                return this.secondaryId ? new Un(this.secondaryId, this.secondaryOptions) : null;
            }
            static from(e1) {
                return "string" != typeof e1 ? e1 : Gn.build({
                    name: e1
                });
            }
            static build(e1, t1, i, n) {
                return !e1 || "object" == typeof e1 && !("name" in e1) ? null : new Gn(e1, i, t1, n);
            }
        }
        function jn(e1, t1, i, n) {
            return "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof i && i >= 0 && i <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                e1,
                t1,
                i,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                e1,
                t1,
                i,
                n
            ] : [
                e1,
                t1,
                i
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function Hn(e1) {
            if (null === e1) return !0;
            if ("string" == typeof e1) return !0;
            if ("boolean" == typeof e1) return !0;
            if ("number" == typeof e1) return !0;
            if (e1 instanceof pn) return !0;
            if (e1 instanceof Nn) return !0;
            if (e1 instanceof kn) return !0;
            if (e1 instanceof Gn) return !0;
            if (Array.isArray(e1)) {
                for (const t1 of e1)if (!Hn(t1)) return !1;
                return !0;
            }
            if ("object" == typeof e1) {
                for(const t1 in e1)if (!Hn(e1[t1])) return !1;
                return !0;
            }
            return !1;
        }
        function $n(e1) {
            if (null === e1) return wn;
            if ("string" == typeof e1) return An;
            if ("boolean" == typeof e1) return In;
            if ("number" == typeof e1) return En;
            if (e1 instanceof pn) return Tn;
            if (e1 instanceof Nn) return zn;
            if (e1 instanceof kn) return Rn;
            if (e1 instanceof Gn) return Pn;
            if (Array.isArray(e1)) {
                const t1 = e1.length;
                let i;
                for (const t1 of e1){
                    const e1 = $n(t1);
                    if (i) {
                        if (i === e1) continue;
                        i = Sn;
                        break;
                    }
                    i = e1;
                }
                return Dn(i || Sn, t1);
            }
            return Mn;
        }
        function Zn(e1) {
            return null === e1 ? "" : "string" == typeof e1 || "number" == typeof e1 || "boolean" == typeof e1 ? String(e1) : e1 instanceof kn || e1 instanceof Gn || e1 instanceof pn ? e1.toString() : JSON.stringify(e1);
        }
        class Wn {
            constructor(e1, t1){
                this.type = e1, this.value = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error(`'literal' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if (!Hn(e1[1])) return t1.error("invalid value");
                const i = e1[1];
                let n = $n(i);
                const r = t1.expectedType;
                return "array" !== n.kind || 0 !== n.N || !r || "array" !== r.kind || "number" == typeof r.N && 0 !== r.N || (n = r), new Wn(n, i);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return "array" === this.type.kind || "object" === this.type.kind ? [
                    "literal",
                    this.value
                ] : this.value instanceof pn ? [
                    "rgba"
                ].concat(this.value.toNonPremultipliedRenderColor(null).toArray()) : this.value instanceof kn ? this.value.serialize() : this.value;
            }
        }
        class qn {
            constructor(e1){
                this.name = "ExpressionEvaluationError", this.message = e1;
            }
            toJSON() {
                return this.message;
            }
        }
        const Xn = {
            string: An,
            number: En,
            boolean: In,
            object: Mn
        };
        class Yn {
            constructor(e1, t1){
                this.type = e1, this.args = t1;
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expected at least one argument.");
                let i, n = 1;
                const r = e1[0];
                if ("array" === r) {
                    let r, o;
                    if (e1.length > 2) {
                        const i = e1[1];
                        if ("string" != typeof i || !(i in Xn) || "object" === i) return t1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        r = Xn[i], n++;
                    } else r = Sn;
                    if (e1.length > 3) {
                        if (null !== e1[2] && ("number" != typeof e1[2] || e1[2] < 0 || e1[2] !== Math.floor(e1[2]))) return t1.error('The length argument to "array" must be a positive integer literal', 2);
                        o = e1[2], n++;
                    }
                    i = Dn(r, o);
                } else i = Xn[r];
                const o = [];
                for(; n < e1.length; n++){
                    const i = t1.parse(e1[n], n, Sn);
                    if (!i) return null;
                    o.push(i);
                }
                return new Yn(i, o);
            }
            evaluate(e1) {
                for(let t1 = 0; t1 < this.args.length; t1++){
                    const i = this.args[t1].evaluate(e1);
                    if (!On(this.type, $n(i))) return i;
                    if (t1 === this.args.length - 1) throw new qn(`The expression ${JSON.stringify(this.args[t1].serialize())} evaluated to ${Cn($n(i))} but was expected to be of type ${Cn(this.type)}.`);
                }
                return null;
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = this.type, t1 = [
                    e1.kind
                ];
                if ("array" === e1.kind) {
                    const i = e1.itemType;
                    if ("string" === i.kind || "number" === i.kind || "boolean" === i.kind) {
                        t1.push(i.kind);
                        const n = e1.N;
                        ("number" == typeof n || this.args.length > 1) && t1.push(n);
                    }
                }
                return t1.concat(this.args.map((e1)=>e1.serialize()));
            }
        }
        class Jn {
            constructor(e1){
                this.type = Rn, this.sections = e1;
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expected at least one argument.");
                const i = e1[1];
                if (!Array.isArray(i) && "object" == typeof i) return t1.error("First argument must be an image or text section.");
                const n = [];
                let r = !1;
                for(let i = 1; i <= e1.length - 1; ++i){
                    const o = e1[i];
                    if (r && "object" == typeof o && !Array.isArray(o)) {
                        r = !1;
                        let e1 = null;
                        if (o["font-scale"] && (e1 = t1.parseObjectValue(o["font-scale"], i, "font-scale", En), !e1)) return null;
                        let a = null;
                        if (o["text-font"] && (a = t1.parseObjectValue(o["text-font"], i, "text-font", Dn(An)), !a)) return null;
                        let s = null;
                        if (o["text-color"] && (s = t1.parseObjectValue(o["text-color"], i, "text-color", Tn), !s)) return null;
                        const l = n.at(-1);
                        l.scale = e1, l.font = a, l.textColor = s;
                    } else {
                        const o = t1.parse(e1[i], i, Sn);
                        if (!o) return null;
                        const a = o.type.kind;
                        if ("string" !== a && "value" !== a && "null" !== a && "resolvedImage" !== a) return t1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        r = !0, n.push({
                            content: o,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new Jn(n);
            }
            evaluate(e1) {
                return new kn(this.sections.map((t1)=>{
                    const i = t1.content.evaluate(e1);
                    return Bn($n(i), Pn) ? new Vn("", i, null, null, null) : new Vn(Zn(i), null, t1.scale ? t1.scale.evaluate(e1) : null, t1.font ? t1.font.evaluate(e1).join(",") : null, t1.textColor ? t1.textColor.evaluate(e1) : null);
                }));
            }
            eachChild(e1) {
                for (const t1 of this.sections)e1(t1.content), t1.scale && e1(t1.scale), t1.font && e1(t1.font), t1.textColor && e1(t1.textColor);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "format"
                ];
                for (const t1 of this.sections){
                    e1.push(t1.content.serialize());
                    const i = {};
                    t1.scale && (i["font-scale"] = t1.scale.serialize()), t1.font && (i["text-font"] = t1.font.serialize()), t1.textColor && (i["text-color"] = t1.textColor.serialize()), e1.push(i);
                }
                return e1;
            }
        }
        class Kn {
            constructor(e1, t1, i, n){
                this._imageWarnHistory = {}, this.type = Pn, this.namePrimary = e1, this.nameSecondary = t1, i && (this.paramsPrimary = i.params, this.iconsetIdPrimary = i.iconset ? i.iconset.id : void 0), n && (this.paramsSecondary = n.params, this.iconsetIdSecondary = n.iconset ? n.iconset.id : void 0);
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expected two or more arguments.");
                let i = 1;
                const n = [];
                function r() {
                    if (i < e1.length) {
                        const r = t1.parse(e1[i], i++, An);
                        return r ? (n.push({
                            image: r,
                            options: {}
                        }), !0) : (t1.error(n.length ? "Secondary image variant is not a string." : "No image name provided."), !1);
                    }
                    return !0;
                }
                function o() {
                    if (i < e1.length) {
                        const o = e1[i];
                        if (null === (r = o) || "object" != typeof r || Array.isArray(r)) return !0;
                        const a = o.params, s = o.iconset, l = t1.concat(i);
                        if (!a && !s) return i++, !0;
                        if (a) {
                            if ("object" != typeof a || a.constructor !== Object) return l.error('Image options "params" should be an object'), !1;
                            const e1 = {}, t1 = l.concat(void 0, "params");
                            for(const i in a){
                                if (!i) return t1.error("Image parameter name should be non-empty"), !1;
                                const n = t1.concat(void 0, i).parse(a[i], void 0, Tn, void 0, {
                                    typeAnnotation: "coerce"
                                });
                                if (!n) return !1;
                                e1[i] = n;
                            }
                            n.at(-1).options.params = e1;
                        }
                        if (s) {
                            if ("object" != typeof s || s.constructor !== Object) return l.error('Image options "iconset" should be an object'), !1;
                            if (!s.id) return l.error('Image options "iconset" should have an "id" property'), !1;
                            n.at(-1).options.iconset = s;
                        }
                        return i++, !0;
                    }
                    var r;
                    return !0;
                }
                for(let e1 = 0; e1 < 2; e1++)if (!r() || !o()) return;
                return new Kn(n[0].image, n[1] ? n[1].image : void 0, n[0].options, n[1] ? n[1].options : void 0);
            }
            evaluateParams(e1, t1) {
                const i = {};
                if (t1) {
                    for(const n in t1)if (t1[n]) try {
                        i[n] = t1[n].evaluate(e1);
                    } catch (e1) {
                        continue;
                    }
                    if (0 !== Object.keys(i).length) return {
                        params: i
                    };
                }
            }
            evaluate(e1) {
                const t1 = {
                    name: this.namePrimary.evaluate(e1),
                    iconsetId: this.iconsetIdPrimary
                }, i = this.nameSecondary ? {
                    name: this.nameSecondary.evaluate(e1),
                    iconsetId: this.iconsetIdSecondary
                } : void 0, n = Gn.build(t1, i, this.paramsPrimary ? this.evaluateParams(e1, this.paramsPrimary) : void 0, this.paramsSecondary ? this.evaluateParams(e1, this.paramsSecondary) : void 0);
                if (n && e1.availableImages) {
                    const t1 = n.getPrimary().id;
                    if (n.available = e1.availableImages.some((e1)=>ln.isEqual(e1, t1)), n.available) {
                        const t1 = n.getSecondary() ? n.getSecondary().id : null;
                        t1 && (n.available = e1.availableImages.some((e1)=>ln.isEqual(e1, t1)));
                    }
                }
                return n;
            }
            eachChild(e1) {
                if (e1(this.namePrimary), this.paramsPrimary) for(const t1 in this.paramsPrimary)this.paramsPrimary[t1] && e1(this.paramsPrimary[t1]);
                if (this.nameSecondary && (e1(this.nameSecondary), this.paramsSecondary)) for(const t1 in this.paramsSecondary)this.paramsSecondary[t1] && e1(this.paramsSecondary[t1]);
            }
            outputDefined() {
                return !1;
            }
            serializeOptions(e1, t1) {
                const i = {};
                if (t1 && (i.iconset = {
                    id: t1
                }), e1) {
                    i.params = {};
                    for(const t1 in e1)e1[t1] && (i.params[t1] = e1[t1].serialize());
                }
                return Object.keys(i).length > 0 ? i : void 0;
            }
            serialize() {
                const e1 = [
                    "image",
                    this.namePrimary.serialize()
                ];
                if (this.paramsPrimary || this.iconsetIdPrimary) {
                    const t1 = this.serializeOptions(this.paramsPrimary, this.iconsetIdPrimary);
                    t1 && e1.push(t1);
                }
                if (this.nameSecondary && (e1.push(this.nameSecondary.serialize()), this.paramsSecondary || this.iconsetIdSecondary)) {
                    const t1 = this.serializeOptions(this.paramsSecondary, this.iconsetIdSecondary);
                    t1 && e1.push(t1);
                }
                return e1;
            }
        }
        function Qn(e1) {
            return tr(e1) ? "string" : ir(e1) ? "number" : nr(e1) ? "boolean" : Array.isArray(e1) ? "array" : null === e1 ? "null" : er(e1) ? "object" : typeof e1;
        }
        function er(e1) {
            return null != e1 && !Array.isArray(e1) && "function" != typeof e1 && !(e1 instanceof String || e1 instanceof Number || e1 instanceof Boolean) && "object" == typeof e1;
        }
        function tr(e1) {
            return "string" == typeof e1 || e1 instanceof String;
        }
        function ir(e1) {
            return "number" == typeof e1 || e1 instanceof Number;
        }
        function nr(e1) {
            return "boolean" == typeof e1 || e1 instanceof Boolean;
        }
        const rr = {
            "to-boolean": In,
            "to-color": Tn,
            "to-number": En,
            "to-string": An
        };
        class or {
            constructor(e1, t1){
                this.type = e1, this.args = t1;
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expected at least one argument.");
                const i = e1[0], n = [];
                let r = wn;
                if ("to-array" === i) {
                    if (!Array.isArray(e1[1])) return null;
                    const i = e1[1].length;
                    if (t1.expectedType) {
                        if ("array" !== t1.expectedType.kind) return t1.error(`Expected ${t1.expectedType.kind} but found array.`);
                        r = Dn(t1.expectedType.itemType, i);
                    } else {
                        if (!(i > 0 && Hn(e1[1][0]))) return null;
                        r = Dn($n(e1[1][0]), i);
                    }
                    for(let o = 0; o < i; o++){
                        const i = e1[1][o];
                        let a;
                        if (Array.isArray(i)) a = t1.parse(i, void 0, r.itemType);
                        else {
                            const e1 = Qn(i);
                            if (e1 !== r.itemType.kind) return t1.error(`Expected ${r.itemType.kind} but found ${e1}.`);
                            a = t1.registry.literal.parse([
                                "literal",
                                void 0 === i ? null : i
                            ], t1);
                        }
                        if (!a) return null;
                        n.push(a);
                    }
                } else {
                    if (("to-boolean" === i || "to-string" === i) && 2 !== e1.length) return t1.error("Expected one argument.");
                    r = rr[i];
                    for(let i = 1; i < e1.length; i++){
                        const r = t1.parse(e1[i], i, Sn);
                        if (!r) return null;
                        n.push(r);
                    }
                }
                return new or(r, n);
            }
            evaluate(e1) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(e1));
                if ("color" === this.type.kind) {
                    let t1, i;
                    for (const n of this.args){
                        if (t1 = n.evaluate(e1), i = null, t1 instanceof pn) return t1;
                        if ("string" == typeof t1) {
                            const i = e1.parseColor(t1);
                            if (i) return i;
                        } else if (Array.isArray(t1) && (i = t1.length < 3 || t1.length > 4 ? `Invalid rbga value ${JSON.stringify(t1)}: expected an array containing either three or four numeric values.` : jn(t1[0], t1[1], t1[2], t1[3]), !i)) return new pn(t1[0] / 255, t1[1] / 255, t1[2] / 255, t1[3]);
                    }
                    throw new qn(i || `Could not parse color from value '${"string" == typeof t1 ? t1 : String(JSON.stringify(t1))}'`);
                }
                if ("number" === this.type.kind) {
                    let t1 = null;
                    for (const i of this.args){
                        if (t1 = i.evaluate(e1), null === t1) return 0;
                        const n = Number(t1);
                        if (!isNaN(n)) return n;
                    }
                    throw new qn(`Could not convert ${JSON.stringify(t1)} to number.`);
                }
                return "formatted" === this.type.kind ? kn.fromString(Zn(this.args[0].evaluate(e1))) : "resolvedImage" === this.type.kind ? Gn.build(Zn(this.args[0].evaluate(e1))) : "array" === this.type.kind ? this.args.map((t1)=>t1.evaluate(e1)) : Zn(this.args[0].evaluate(e1));
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                if ("formatted" === this.type.kind) return new Jn([
                    {
                        content: this.args[0],
                        scale: null,
                        font: null,
                        textColor: null
                    }
                ]).serialize();
                if ("resolvedImage" === this.type.kind) return new Kn(this.args[0]).serialize();
                const e1 = "array" === this.type.kind ? [] : [
                    `to-${this.type.kind}`
                ];
                return this.eachChild((t1)=>{
                    e1.push(t1.serialize());
                }), e1;
            }
        }
        const ar = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class sr {
            constructor(e1, t1, i){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.scope = e1, this.options = t1, this.iconImageUseTheme = i;
            }
            id() {
                return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? ar[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            measureLight(e1) {
                return this.globals.brightness || 0;
            }
            distanceFromCenter() {
                if (this.featureTileCoord && this.featureDistanceData) {
                    const e1 = this.featureDistanceData.center, t1 = this.featureDistanceData.scale, { x: i, y: n } = this.featureTileCoord;
                    return this.featureDistanceData.bearing[0] * (i * t1 - e1[0]) + this.featureDistanceData.bearing[1] * (n * t1 - e1[1]);
                }
                return 0;
            }
            parseColor(e1) {
                return pn.parse(e1);
            }
            getConfig(e1) {
                return this.options ? this.options.get(e1) : null;
            }
        }
        class lr {
            constructor(e1, t1, i, n, r){
                this.name = e1, this.type = t1, this._evaluate = i, this.args = n, this._overloadIndex = r;
            }
            evaluate(e1) {
                if (!this._evaluate) {
                    const e1 = lr.definitions[this.name];
                    this._evaluate = Array.isArray(e1) ? e1[2] : e1.overloads[this._overloadIndex][1];
                }
                return this._evaluate(e1, this.args);
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    this.name
                ].concat(this.args.map((e1)=>e1.serialize()));
            }
            static parse(e1, t1) {
                const i = e1[0], n = lr.definitions[i];
                if (!n) return t1.error(`Unknown expression "${i}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const r = Array.isArray(n) ? n[0] : n.type, o = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, a = [];
                let s = null, l = -1;
                for (const [n, u] of o){
                    if (Array.isArray(n) && n.length !== e1.length - 1) continue;
                    a.push(n), l++, null === s ? s = t1._forkForSignature() : s.errors.length = 0;
                    const o = [];
                    let c = !1;
                    for(let t1 = 1; t1 < e1.length; t1++){
                        const i = e1[t1], r = Array.isArray(n) ? n[t1 - 1] : n.type, a = s.parse(i, 1 + o.length, r);
                        if (!a) {
                            c = !0;
                            break;
                        }
                        o.push(a);
                    }
                    if (!c) {
                        if (Array.isArray(n) && n.length !== o.length) s.error(`Expected ${n.length} arguments, but found ${o.length} instead.`);
                        else {
                            for(let e1 = 0; e1 < o.length; e1++){
                                const t1 = Array.isArray(n) ? n[e1] : n.type;
                                s.checkSubtype(t1, o[e1].type, e1 + 1);
                            }
                            if (0 === s.errors.length) return new lr(i, r, u, o, l);
                        }
                    }
                }
                if (1 === a.length) t1.errors.push(...s.errors);
                else {
                    const i = (a.length ? a : o.map(([e1])=>e1)).map(ur).join(" | "), n = [];
                    for(let i = 1; i < e1.length; i++){
                        const r = t1.parse(e1[i], 1 + n.length);
                        if (!r) return null;
                        n.push(Cn(r.type));
                    }
                    t1.error(`Expected arguments of type ${i}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(e1, t1) {
                lr.definitions = t1;
                for(const i in t1)e1[i] = lr;
            }
        }
        function ur(e1) {
            return Array.isArray(e1) ? `(${e1.map(Cn).join(", ")})` : `(${Cn(e1.type)}...)`;
        }
        class cr {
            constructor(e1, t1, i){
                this.type = zn, this.locale = i, this.caseSensitive = e1, this.diacriticSensitive = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error("Expected one argument."), null;
                const i = e1[1];
                if ("object" != typeof i || Array.isArray(i)) return t1.error("Collator options argument must be an object."), null;
                const n = void 0 === i["case-sensitive"] ? t1.parse(!1, 1, In) : t1.parseObjectValue(i["case-sensitive"], 1, "case-sensitive", In);
                if (!n) return null;
                const r = void 0 === i["diacritic-sensitive"] ? t1.parse(!1, 1, In) : t1.parseObjectValue(i["diacritic-sensitive"], 1, "diacritic-sensitive", In);
                if (!r) return null;
                let o = null;
                return i.locale && (o = t1.parseObjectValue(i.locale, 1, "locale", An), !o) ? null : new cr(n, r, o);
            }
            evaluate(e1) {
                return new Nn(this.caseSensitive.evaluate(e1), this.diacriticSensitive.evaluate(e1), this.locale ? this.locale.evaluate(e1) : null);
            }
            eachChild(e1) {
                e1(this.caseSensitive), e1(this.diacriticSensitive), this.locale && e1(this.locale);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = {};
                return e1["case-sensitive"] = this.caseSensitive.serialize(), e1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (e1.locale = this.locale.serialize()), [
                    "collator",
                    e1
                ];
            }
        }
        function hr(e1) {
            return (180 + e1) / 360;
        }
        function dr(e1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e1 * Math.PI / 360))) / 360;
        }
        function fr(e1) {
            return 360 * e1 - 180;
        }
        function pr(e1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * e1) * Math.PI / 180)) - 90;
        }
        const _r = 8192;
        function mr(e1, t1) {
            const i = hr(e1[0]), n = dr(e1[1]), r = Math.pow(2, t1.z);
            return [
                Math.round(i * r * _r),
                Math.round(n * r * _r)
            ];
        }
        function gr(e1, t1) {
            for(let i = 0; i < t1.length; i++)if (je(e1, t1[i])) return !0;
            return !1;
        }
        function yr(e1, t1, i) {
            for (const n of i)for(let i = 0, r = n.length, o = r - 1; i < r; o = i++)if ($e(e1, t1, n[o], n[i])) return !0;
            return !1;
        }
        function xr(e1, t1) {
            for(let i = 0; i < e1.length; ++i)if (!je(e1[i], t1)) return !1;
            for(let i = 0; i < e1.length - 1; ++i)if (yr(e1[i], e1[i + 1], t1)) return !1;
            return !0;
        }
        function vr(e1, t1) {
            for(let i = 0; i < t1.length; i++)if (xr(e1, t1[i])) return !0;
            return !1;
        }
        function br(e1, t1, i) {
            const n = [];
            for(let r = 0; r < e1.length; r++){
                const o = [];
                for(let n = 0; n < e1[r].length; n++){
                    const a = mr(e1[r][n], i);
                    Ve(t1, a), o.push(a);
                }
                n.push(o);
            }
            return n;
        }
        function wr(e1, t1, i) {
            const n = [];
            for(let r = 0; r < e1.length; r++){
                const o = br(e1[r], t1, i);
                n.push(o);
            }
            return n;
        }
        function Er(e1, t1, i, n) {
            if (e1[0] < i[0] || e1[0] > i[2]) {
                const t1 = .5 * n;
                let r = e1[0] - i[0] > t1 ? -n : i[0] - e1[0] > t1 ? n : 0;
                0 === r && (r = e1[0] - i[2] > t1 ? -n : i[2] - e1[0] > t1 ? n : 0), e1[0] += r;
            }
            Ve(t1, e1);
        }
        function Ar(e1, t1, i, n) {
            const r = Math.pow(2, n.z) * _r, o = [
                n.x * _r,
                n.y * _r
            ], a = [];
            if (!e1) return a;
            for (const n of e1)for (const e1 of n){
                const n = [
                    e1.x + o[0],
                    e1.y + o[1]
                ];
                Er(n, t1, i, r), a.push(n);
            }
            return a;
        }
        function Ir(e1, t1, i, n) {
            const r = Math.pow(2, n.z) * _r, o = [
                n.x * _r,
                n.y * _r
            ], a = [];
            if (!e1) return a;
            for (const i of e1){
                const e1 = [];
                for (const n of i){
                    const i = [
                        n.x + o[0],
                        n.y + o[1]
                    ];
                    Ve(t1, i), e1.push(i);
                }
                a.push(e1);
            }
            if (t1[2] - t1[0] <= r / 2) {
                (s = t1)[0] = s[1] = 1 / 0, s[2] = s[3] = -1 / 0;
                for (const e1 of a)for (const n of e1)Er(n, t1, i, r);
            }
            var s;
            return a;
        }
        class Tr {
            constructor(e1, t1){
                this.type = In, this.geojson = e1, this.geometries = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error(`'within' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if (Hn(e1[1])) {
                    const t1 = e1[1];
                    if ("FeatureCollection" === t1.type) for(let e1 = 0; e1 < t1.features.length; ++e1){
                        const i = t1.features[e1].geometry.type;
                        if ("Polygon" === i || "MultiPolygon" === i) return new Tr(t1, t1.features[e1].geometry);
                    }
                    else if ("Feature" === t1.type) {
                        const e1 = t1.geometry.type;
                        if ("Polygon" === e1 || "MultiPolygon" === e1) return new Tr(t1, t1.geometry);
                    } else if ("Polygon" === t1.type || "MultiPolygon" === t1.type) return new Tr(t1, t1);
                }
                return t1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(e1) {
                if (null != e1.geometry() && null != e1.canonicalID()) {
                    if ("Point" === e1.geometryType()) return function(e1, t1) {
                        const i = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], r = e1.canonicalID();
                        if (!r) return !1;
                        if ("Polygon" === t1.type) {
                            const o = br(t1.coordinates, n, r), a = Ar(e1.geometry(), i, n, r);
                            if (!ke(i, n)) return !1;
                            for (const e1 of a)if (!je(e1, o)) return !1;
                        }
                        if ("MultiPolygon" === t1.type) {
                            const o = wr(t1.coordinates, n, r), a = Ar(e1.geometry(), i, n, r);
                            if (!ke(i, n)) return !1;
                            for (const e1 of a)if (!gr(e1, o)) return !1;
                        }
                        return !0;
                    }(e1, this.geometries);
                    if ("LineString" === e1.geometryType()) return function(e1, t1) {
                        const i = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], r = e1.canonicalID();
                        if (!r) return !1;
                        if ("Polygon" === t1.type) {
                            const o = br(t1.coordinates, n, r), a = Ir(e1.geometry(), i, n, r);
                            if (!ke(i, n)) return !1;
                            for (const e1 of a)if (!xr(e1, o)) return !1;
                        }
                        if ("MultiPolygon" === t1.type) {
                            const o = wr(t1.coordinates, n, r), a = Ir(e1.geometry(), i, n, r);
                            if (!ke(i, n)) return !1;
                            for (const e1 of a)if (!vr(e1, o)) return !1;
                        }
                        return !0;
                    }(e1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "within",
                    this.geojson
                ];
            }
        }
        class Mr {
            constructor(e1 = [], t1 = (e1, t1)=>e1 < t1 ? -1 : e1 > t1 ? 1 : 0){
                if (this.data = e1, this.length = this.data.length, this.compare = t1, this.length > 0) for(let e1 = (this.length >> 1) - 1; e1 >= 0; e1--)this._down(e1);
            }
            push(e1) {
                this.data.push(e1), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const e1 = this.data[0], t1 = this.data.pop();
                return --this.length > 0 && (this.data[0] = t1, this._down(0)), e1;
            }
            peek() {
                return this.data[0];
            }
            _up(e1) {
                const { data: t1, compare: i } = this, n = t1[e1];
                for(; e1 > 0;){
                    const r = e1 - 1 >> 1, o = t1[r];
                    if (i(n, o) >= 0) break;
                    t1[e1] = o, e1 = r;
                }
                t1[e1] = n;
            }
            _down(e1) {
                const { data: t1, compare: i } = this, n = this.length >> 1, r = t1[e1];
                for(; e1 < n;){
                    let n = 1 + (e1 << 1);
                    const o = n + 1;
                    if (o < this.length && i(t1[o], t1[n]) < 0 && (n = o), i(t1[n], r) >= 0) break;
                    t1[e1] = t1[n], e1 = n;
                }
                t1[e1] = r;
            }
        }
        var Sr = 8192;
        const zr = 1 / 298.257223563, Rr = zr * (2 - zr), Pr = Math.PI / 180;
        function Dr(e1) {
            const t1 = 6378.137 * Pr * 1e3, i = Math.cos(e1 * Pr), n = 1 / (1 - Rr * (1 - i * i)), r = Math.sqrt(n);
            return [
                t1 * r * i,
                t1 * r * n * (1 - Rr)
            ];
        }
        function Cr(e1) {
            for(; e1 < -180;)e1 += 360;
            for(; e1 > 180;)e1 -= 360;
            return e1;
        }
        function Fr(e1, t1, i, n) {
            const r = Cr(e1[0] - t1[0]) * i, o = (e1[1] - t1[1]) * n;
            return Math.sqrt(r * r + o * o);
        }
        function Or(e1, t1, i, n, r) {
            let o = t1[0], a = t1[1], s = Cr(i[0] - o) * n, l = (i[1] - a) * r;
            if (0 !== s || 0 !== l) {
                const t1 = (Cr(e1[0] - o) * n * s + (e1[1] - a) * r * l) / (s * s + l * l);
                t1 > 1 ? (o = i[0], a = i[1]) : t1 > 0 && (o += s / n * t1, a += l / r * t1);
            }
            return s = Cr(e1[0] - o) * n, l = (e1[1] - a) * r, Math.sqrt(s * s + l * l);
        }
        function Lr(e1, t1) {
            return t1.dist - e1.dist;
        }
        function Br(e1) {
            const t1 = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (t1.length !== e1.length) return !1;
            for(let i = 0; i < t1.length; i++)if (t1[i] !== e1[i]) return !1;
            return !0;
        }
        function Nr(e1) {
            return e1[1] - e1[0] + 1;
        }
        function Vr(e1, t1) {
            const i = e1[1] >= e1[0] && e1[1] < t1;
            return i || console.warn("Distance Expression: Index is out of range"), i;
        }
        function kr(e1, t1) {
            if (e1[0] > e1[1]) return [
                null,
                null
            ];
            const i = Nr(e1);
            if (t1) {
                if (2 === i) return [
                    e1,
                    null
                ];
                const t1 = Math.floor(i / 2);
                return [
                    [
                        e1[0],
                        e1[0] + t1
                    ],
                    [
                        e1[0] + t1,
                        e1[1]
                    ]
                ];
            }
            {
                if (1 === i) return [
                    e1,
                    null
                ];
                const t1 = Math.floor(i / 2) - 1;
                return [
                    [
                        e1[0],
                        e1[0] + t1
                    ],
                    [
                        e1[0] + t1 + 1,
                        e1[1]
                    ]
                ];
            }
        }
        function Ur(e1, t1) {
            const i = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (!Vr(t1, e1.length)) return i;
            for(let n = t1[0]; n <= t1[1]; ++n)Ve(i, e1[n]);
            return i;
        }
        function Gr(e1) {
            const t1 = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let i = 0; i < e1.length; ++i)for(let n = 0; n < e1[i].length; ++n)Ve(t1, e1[i][n]);
            return t1;
        }
        function jr(e1, t1, i, n) {
            if (Br(e1) || Br(t1)) return NaN;
            let r = 0, o = 0;
            return e1[2] < t1[0] && (r = t1[0] - e1[2]), e1[0] > t1[2] && (r = e1[0] - t1[2]), e1[1] > t1[3] && (o = e1[1] - t1[3]), e1[3] < t1[1] && (o = t1[1] - e1[3]), Fr([
                0,
                0
            ], [
                r,
                o
            ], i, n);
        }
        function Hr(e1, t1, i = 8192) {
            const n = Math.pow(2, t1.z), r = (e1.y / i + t1.y) / n;
            return [
                fr((e1.x / i + t1.x) / n),
                pr(r)
            ];
        }
        function $r(e1, t1) {
            const i = [];
            for(let n = 0; n < e1.length; ++n)i.push(Hr(e1[n], t1));
            return i;
        }
        function Zr(e1, t1, i, n) {
            const r = function(e1, t1, i, n) {
                let r = 1 / 0, o = e1[0][0], a = e1[0][1];
                for(let s = 0; s < e1.length - 1; s++){
                    let l = e1[s][0], u = e1[s][1], c = Cr(e1[s + 1][0] - l) * i, h = (e1[s + 1][1] - u) * n, d = 0;
                    0 === c && 0 === h || (d = (Cr(t1[0] - l) * i * c + (t1[1] - u) * n * h) / (c * c + h * h), d > 1 ? (l = e1[s + 1][0], u = e1[s + 1][1]) : d > 0 && (l += c / i * d, u += h / n * d)), c = Cr(t1[0] - l) * i, h = (t1[1] - u) * n;
                    const f = c * c + h * h;
                    f < r && (r = f, o = l, a = u);
                }
                return [
                    o,
                    a
                ];
            }(t1, e1, i, n);
            return Fr(e1, r, i, n);
        }
        function Wr(e1, t1, i, n, r, o) {
            const a = i.slice(n[0], n[1] + 1);
            let s = 1 / 0;
            for(let i = t1[0]; i <= t1[1]; ++i)if (0 === (s = Math.min(s, Zr(e1[i], a, r, o)))) return 0;
            return s;
        }
        function qr(e1, t1, i, n, r, o) {
            const a = Math.min(Or(e1, i, n, r, o), Or(t1, i, n, r, o)), s = Math.min(Or(i, e1, t1, r, o), Or(n, e1, t1, r, o));
            return Math.min(a, s);
        }
        function Xr(e1, t1, i, n, r, o) {
            if (!Vr(t1, e1.length) || !Vr(n, i.length)) return NaN;
            let a = 1 / 0;
            for(let s = t1[0]; s < t1[1]; ++s)for(let t1 = n[0]; t1 < n[1]; ++t1){
                if ($e(e1[s], e1[s + 1], i[t1], i[t1 + 1])) return 0;
                a = Math.min(a, qr(e1[s], e1[s + 1], i[t1], i[t1 + 1], r, o));
            }
            return a;
        }
        function Yr(e1, t1, i, n, r, o) {
            if (!Vr(t1, e1.length) || !Vr(n, i.length)) return NaN;
            let a = 1 / 0;
            for(let s = t1[0]; s <= t1[1]; ++s)for(let t1 = n[0]; t1 <= n[1]; ++t1)if (0 === (a = Math.min(a, Fr(e1[s], i[t1], r, o)))) return a;
            return a;
        }
        function Jr(e1, t1, i, n) {
            if (je(e1, t1, !0)) return 0;
            let r = 1 / 0;
            for (const o of t1){
                const t1 = o.length;
                if (t1 < 2) return console.warn("Distance Expression: Invalid polygon!"), NaN;
                if (o[0] !== o[t1 - 1] && 0 === (r = Math.min(r, Or(e1, o[t1 - 1], o[0], i, n)))) return r;
                if (0 === (r = Math.min(r, Zr(e1, o, i, n)))) return r;
            }
            return r;
        }
        function Kr(e1, t1, i, n, r) {
            if (!Vr(t1, e1.length)) return NaN;
            for(let n = t1[0]; n <= t1[1]; ++n)if (je(e1[n], i, !0)) return 0;
            let o = 1 / 0;
            for(let a = t1[0]; a < t1[1]; ++a)for (const t1 of i)for(let i = 0, s = t1.length, l = s - 1; i < s; l = i++){
                if ($e(e1[a], e1[a + 1], t1[l], t1[i])) return 0;
                o = Math.min(o, qr(e1[a], e1[a + 1], t1[l], t1[i], n, r));
            }
            return o;
        }
        function Qr(e1, t1) {
            for (const i of e1)for(let e1 = 0; e1 <= i.length - 1; ++e1)if (je(i[e1], t1, !0)) return !0;
            return !1;
        }
        function eo(e1, t1, i, n, r = 1 / 0) {
            const o = Gr(e1), a = Gr(t1);
            if (r !== 1 / 0 && jr(o, a, i, n) >= r) return r;
            if (ke(o, a)) {
                if (Qr(e1, t1)) return 0;
            } else if (Qr(t1, e1)) return 0;
            let s = r;
            for (const r of e1)for(let e1 = 0, o = r.length, a = o - 1; e1 < o; a = e1++)for (const o of t1)for(let t1 = 0, l = o.length, u = l - 1; t1 < l; u = t1++){
                if ($e(r[a], r[e1], o[u], o[t1])) return 0;
                s = Math.min(s, qr(r[a], r[e1], o[u], o[t1], i, n));
            }
            return s;
        }
        function to(e1, t1, i, n, r, o, a, s) {
            if (null === a || null === s) return;
            const l = jr(Ur(r, a), Ur(o, s), i, n);
            l < t1 && e1.push({
                dist: l,
                range1: a,
                range2: s
            });
        }
        function io(e1, t1, i, n, r, o = 1 / 0) {
            let a = Math.min(Fr(e1[0], i[0][0], n, r), o);
            if (0 === a) return a;
            const s = new Mr([
                {
                    dist: 0,
                    range1: [
                        0,
                        e1.length - 1
                    ],
                    range2: [
                        0,
                        0
                    ]
                }
            ], Lr), l = t1 ? 50 : 100, u = Gr(i);
            for(; s.length;){
                const o = s.pop();
                if (o.dist >= a) continue;
                const c = o.range1;
                if (Nr(c) <= l) {
                    if (!Vr(c, e1.length)) return NaN;
                    if (t1) {
                        const t1 = Kr(e1, c, i, n, r);
                        if (0 === (a = Math.min(a, t1))) return a;
                    } else for(let t1 = c[0]; t1 <= c[1]; ++t1){
                        const o = Jr(e1[t1], i, n, r);
                        if (0 === (a = Math.min(a, o))) return a;
                    }
                } else {
                    const i = kr(c, t1);
                    if (null !== i[0]) {
                        const t1 = jr(Ur(e1, i[0]), u, n, r);
                        t1 < a && s.push({
                            dist: t1,
                            range1: i[0],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                    if (null !== i[1]) {
                        const t1 = jr(Ur(e1, i[1]), u, n, r);
                        t1 < a && s.push({
                            dist: t1,
                            range1: i[1],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                }
            }
            return a;
        }
        function no(e1, t1, i, n, r, o, a = 1 / 0) {
            let s = Math.min(a, Fr(e1[0], i[0], r, o));
            if (0 === s) return s;
            const l = new Mr([
                {
                    dist: 0,
                    range1: [
                        0,
                        e1.length - 1
                    ],
                    range2: [
                        0,
                        i.length - 1
                    ]
                }
            ], Lr), u = t1 ? 50 : 100, c = n ? 50 : 100;
            for(; l.length;){
                const a = l.pop();
                if (a.dist >= s) continue;
                const h = a.range1, d = a.range2;
                if (Nr(h) <= u && Nr(d) <= c) {
                    if (!Vr(h, e1.length) || !Vr(d, i.length)) return NaN;
                    if (t1 && n ? s = Math.min(s, Xr(e1, h, i, d, r, o)) : t1 || n ? t1 && !n ? s = Math.min(s, Wr(i, d, e1, h, r, o)) : !t1 && n && (s = Math.min(s, Wr(e1, h, i, d, r, o))) : s = Math.min(s, Yr(e1, h, i, d, r, o)), 0 === s) return s;
                } else {
                    const a = kr(h, t1), u = kr(d, n);
                    to(l, s, r, o, e1, i, a[0], u[0]), to(l, s, r, o, e1, i, a[0], u[1]), to(l, s, r, o, e1, i, a[1], u[0]), to(l, s, r, o, e1, i, a[1], u[1]);
                }
            }
            return s;
        }
        function ro(e1, t1, i, n, r, o = 1 / 0) {
            let a = o;
            const s = Ur(e1, [
                0,
                e1.length - 1
            ]);
            for (const o of i)if (!(a !== 1 / 0 && jr(s, Ur(o, [
                0,
                o.length - 1
            ]), n, r) >= a) && (a = Math.min(a, no(e1, t1, o, !0, n, r, a)), 0 === a)) return a;
            return a;
        }
        function oo(e1, t1, i, n, r, o = 1 / 0) {
            let a = o;
            const s = Ur(e1, [
                0,
                e1.length - 1
            ]);
            for (const o of i){
                if (a !== 1 / 0 && jr(s, Gr(o), n, r) >= a) continue;
                const i = io(e1, t1, o, n, r, a);
                if (isNaN(i)) return i;
                if (0 === (a = Math.min(a, i))) return a;
            }
            return a;
        }
        function ao(e1) {
            return "Point" === e1 || "MultiPoint" === e1 || "LineString" === e1 || "MultiLineString" === e1 || "Polygon" === e1 || "MultiPolygon" === e1;
        }
        class so {
            constructor(e1, t1){
                this.type = En, this.geojson = e1, this.geometries = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error(`'distance' expression requires either one argument, but found ' ${e1.length - 1} instead.`);
                if (Hn(e1[1])) {
                    const t1 = e1[1];
                    if ("FeatureCollection" === t1.type) {
                        for(let e1 = 0; e1 < t1.features.length; ++e1)if (ao(t1.features[e1].geometry.type)) return new so(t1, t1.features[e1].geometry);
                    } else if ("Feature" === t1.type) {
                        if (ao(t1.geometry.type)) return new so(t1, t1.geometry);
                    } else if (ao(t1.type)) return new so(t1, t1);
                }
                return t1.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
            }
            evaluate(e1) {
                const t1 = e1.geometry(), i = e1.canonicalID();
                if (null != t1 && null != i) {
                    if ("Point" === e1.geometryType()) return function(e1, t1, i) {
                        const n = [];
                        for (const i of e1)for (const e1 of i)n.push(Hr(e1, t1));
                        const [r, o] = Dr(n[0][1]);
                        return "Point" === i.type || "MultiPoint" === i.type || "LineString" === i.type ? no(n, !1, "Point" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, "LineString" === i.type, r, o) : "MultiLineString" === i.type ? ro(n, !1, i.coordinates, r, o) : "Polygon" === i.type || "MultiPolygon" === i.type ? oo(n, !1, "Polygon" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, r, o) : null;
                    }(t1, i, this.geometries);
                    if ("LineString" === e1.geometryType()) return function(e1, t1, i) {
                        const n = [];
                        for (const i of e1){
                            const e1 = [];
                            for (const n of i)e1.push(Hr(n, t1));
                            n.push(e1);
                        }
                        const [r, o] = Dr(n[0][0][1]);
                        if ("Point" === i.type || "MultiPoint" === i.type || "LineString" === i.type) return ro("Point" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, "LineString" === i.type, n, r, o);
                        if ("MultiLineString" === i.type) {
                            let e1 = 1 / 0;
                            for(let t1 = 0; t1 < i.coordinates.length; t1++){
                                const a = ro(i.coordinates[t1], !0, n, r, o, e1);
                                if (isNaN(a)) return a;
                                if (0 === (e1 = Math.min(e1, a))) return e1;
                            }
                            return e1;
                        }
                        if ("Polygon" === i.type || "MultiPolygon" === i.type) {
                            let e1 = 1 / 0;
                            for(let t1 = 0; t1 < n.length; t1++){
                                const a = oo(n[t1], !0, "Polygon" === i.type ? [
                                    i.coordinates
                                ] : i.coordinates, r, o, e1);
                                if (isNaN(a)) return a;
                                if (0 === (e1 = Math.min(e1, a))) return e1;
                            }
                            return e1;
                        }
                        return null;
                    }(t1, i, this.geometries);
                    if ("Polygon" === e1.geometryType()) return function(e1, t1, i) {
                        const n = [];
                        for (const i of Ne(e1, 0)){
                            const e1 = [];
                            for(let n = 0; n < i.length; ++n)e1.push($r(i[n], t1));
                            n.push(e1);
                        }
                        const [r, o] = Dr(n[0][0][0][1]);
                        if ("Point" === i.type || "MultiPoint" === i.type || "LineString" === i.type) return oo("Point" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, "LineString" === i.type, n, r, o);
                        if ("MultiLineString" === i.type) {
                            let e1 = 1 / 0;
                            for(let t1 = 0; t1 < i.coordinates.length; t1++){
                                const a = oo(i.coordinates[t1], !0, n, r, o, e1);
                                if (isNaN(a)) return a;
                                if (0 === (e1 = Math.min(e1, a))) return e1;
                            }
                            return e1;
                        }
                        return "Polygon" === i.type || "MultiPolygon" === i.type ? function(e1, t1, i, n) {
                            let r = 1 / 0;
                            for (const o of e1)for (const e1 of t1){
                                const t1 = eo(o, e1, i, n, r);
                                if (isNaN(t1)) return t1;
                                if (0 === (r = Math.min(r, t1))) return r;
                            }
                            return r;
                        }("Polygon" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, n, r, o) : null;
                    }(t1, i, this.geometries);
                    console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
                } else console.warn("Distance Expression: requires valid feature and canonical information.");
                return null;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "distance",
                    this.geojson
                ];
            }
        }
        function lo(e1) {
            if (e1 instanceof lr) {
                if ("get" === e1.name && 1 === e1.args.length) return !1;
                if ("feature-state" === e1.name) return !1;
                if ("has" === e1.name && 1 === e1.args.length) return !1;
                if ("properties" === e1.name || "geometry-type" === e1.name || "id" === e1.name) return !1;
                if (e1.name.startsWith("filter-")) return !1;
            }
            if (e1 instanceof Tr) return !1;
            if (e1 instanceof so) return !1;
            if (e1 instanceof mo) return e1.featureConstant;
            let t1 = !0;
            return e1.eachChild((e1)=>{
                t1 && !lo(e1) && (t1 = !1);
            }), t1;
        }
        function uo(e1) {
            if (e1 instanceof lr && "feature-state" === e1.name) return !1;
            let t1 = !0;
            return e1.eachChild((e1)=>{
                t1 && !uo(e1) && (t1 = !1);
            }), t1;
        }
        function co(e1, t1) {
            if (e1 instanceof lr && t1.has(e1.name)) return !1;
            let i = !0;
            return e1.eachChild((e1)=>{
                i && !co(e1, t1) && (i = !1);
            }), i;
        }
        function ho(e1, t1) {
            return co(e1, new Set(t1));
        }
        function fo(e1, t1, i) {
            return [
                e1,
                t1,
                i
            ].filter(Boolean).join("");
        }
        function po(e1, t1) {
            switch(e1){
                case "string":
                    return Zn(t1);
                case "number":
                    return +t1;
                case "boolean":
                    return !!t1;
                case "color":
                    return pn.parse(t1);
                case "formatted":
                    return kn.fromString(Zn(t1));
                case "resolvedImage":
                    return Gn.build(Zn(t1));
            }
            return t1;
        }
        function _o(e1, t1, i, n) {
            return void 0 !== n && (e1 = n * Math.round(e1 / n)), void 0 !== t1 && e1 < t1 && (e1 = t1), void 0 !== i && e1 > i && (e1 = i), e1;
        }
        class mo {
            constructor(e1, t1, i, n = !1){
                this.type = e1, this.key = t1, this.scope = i, this.featureConstant = n;
            }
            static parse(e1, t1) {
                let i = t1.expectedType;
                if (i ??= Sn, e1.length < 2 || e1.length > 3) return t1.error("Invalid number of arguments for 'config' expression.");
                const n = t1.parse(e1[1], 1);
                if (!(n instanceof Wn)) return t1.error("Key name of 'config' expression must be a string literal.");
                let r, o = !0;
                const a = Zn(n.value);
                if (e1.length >= 3) {
                    const i = t1.parse(e1[2], 2);
                    if (!(i instanceof Wn)) return t1.error("Scope of 'config' expression must be a string literal.");
                    r = Zn(i.value);
                }
                if (t1.options) {
                    const e1 = fo(a, r, t1._scope), i = t1.options.get(e1);
                    i && (o = lo(i.value || i.default));
                }
                return new mo(i, a, r, o);
            }
            evaluate(e1) {
                const t1 = fo(this.key, this.scope, e1.scope), i = e1.getConfig(t1);
                if (!i) return null;
                const { type: n, value: r, values: o, minValue: a, maxValue: s, stepValue: l } = i, u = i.default.evaluate(e1);
                let c = u;
                if (r) {
                    const t1 = e1.scope;
                    e1.scope = (t1 || "").split("").slice(1).join(""), c = r.evaluate(e1), e1.scope = t1;
                }
                return n && (c = po(n, c)), void 0 === c || void 0 === a && void 0 === s && void 0 === l || ("number" == typeof c ? c = _o(c, a, s, l) : Array.isArray(c) && (c = c.map((e1)=>"number" == typeof e1 ? _o(e1, a, s, l) : e1))), void 0 !== r && void 0 !== c && o && !o.includes(c) && (c = u, n && (c = po(n, c))), (n && n !== this.type || void 0 !== c && !Bn($n(c), this.type)) && (c = po(this.type.kind, c)), c;
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "config",
                    this.key
                ];
                return this.scope && e1.concat(this.scope), e1;
            }
        }
        class go {
            constructor(e1, t1){
                this.type = t1.type, this.name = e1, this.boundExpression = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length || "string" != typeof e1[1]) return t1.error("'var' expression requires exactly one string literal argument.");
                const i = e1[1];
                return t1.scope.has(i) ? new go(i, t1.scope.get(i)) : t1.error(`Unknown variable "${i}". Make sure "${i}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(e1) {
                return this.boundExpression.evaluate(e1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "var",
                    this.name
                ];
            }
        }
        class yo {
            constructor(e1, t1 = [], i, n = new bn, r = [], o, a, s){
                this.registry = e1, this.path = t1, this.scope = n, this.errors = r, this.expectedType = i, this._scope = o, this.options = a, this.iconImageUseTheme = s;
            }
            get key() {
                let e1 = "";
                for(let t1 = 0; t1 < this.path.length; t1++){
                    const i = this.path[t1];
                    e1 += "string" == typeof i ? `['${i}']` : `[${i}]`;
                }
                return e1;
            }
            parse(e1, t1, i, n, r = {}) {
                if (t1 || i) {
                    const o = this.expectedType, a = this.scope;
                    n && (this.scope = this.scope.concat(n)), this.expectedType = i || null;
                    const s = "number" == typeof t1;
                    s && this.path.push(t1);
                    const l = this._parse(e1, r);
                    return s && this.path.pop(), this.expectedType = o, this.scope = a, l;
                }
                return this._parse(e1, r);
            }
            parseObjectValue(e1, t1, i, n, r, o = {}) {
                const a = this.expectedType, s = this.scope;
                r && (this.scope = this.scope.concat(r)), this.expectedType = n || null, this.path.push(t1), this.path.push(i);
                const l = this._parse(e1, o);
                return this.path.pop(), this.path.pop(), this.expectedType = a, this.scope = s, l;
            }
            _parse(e1, t1) {
                if (null !== e1 && "string" != typeof e1 && "boolean" != typeof e1 && "number" != typeof e1 || (e1 = [
                    "literal",
                    e1
                ]), Array.isArray(e1)) {
                    if (0 === e1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const i = "string" == typeof e1[0] && Object.hasOwn(this.registry, e1[0]) ? this.registry[e1[0]] : void 0;
                    if (i) {
                        let n = i.parse(e1, this);
                        if (!n) return null;
                        if (this.expectedType) {
                            const e1 = this.expectedType, i = n.type;
                            if ("string" !== e1.kind && "number" !== e1.kind && "boolean" !== e1.kind && "object" !== e1.kind && "array" !== e1.kind || "value" !== i.kind) {
                                if ("color" !== e1.kind && "formatted" !== e1.kind && "resolvedImage" !== e1.kind || "value" !== i.kind && "string" !== i.kind) {
                                    if (this.checkSubtype(e1, i)) return null;
                                } else n = vo(n, e1, t1.typeAnnotation || "coerce");
                            } else n = vo(n, e1, t1.typeAnnotation || "assert");
                        }
                        if (!(n instanceof Wn) && "resolvedImage" !== n.type.kind && bo(n)) {
                            const e1 = new sr(this._scope, this.options, this.iconImageUseTheme);
                            try {
                                n = new Wn(n.type, n.evaluate(e1));
                            } catch (e1) {
                                return this.error(e1.message), null;
                            }
                        }
                        return n;
                    }
                    return or.parse([
                        "to-array",
                        e1
                    ], this);
                }
                return this.error(void 0 === e1 ? "'undefined' value invalid. Use null instead." : "object" == typeof e1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof e1} instead.`);
            }
            concat(e1, t1, i, n) {
                const r = n ? this.scope.concat(n) : this.scope, o = this.path.slice();
                return "number" == typeof e1 && o.push(e1), "string" == typeof t1 && o.push(t1), new yo(this.registry, o, i || null, r, this.errors, this._scope, this.options, this.iconImageUseTheme);
            }
            _forkForSignature() {
                return new yo(this.registry, this.path.slice(), null, this.scope, [], this._scope, this.options, this.iconImageUseTheme);
            }
            error(e1, ...t1) {
                const i = `${this.key}${t1.map((e1)=>`[${e1}]`).join("")}`;
                this.errors.push(new vn(i, e1));
            }
            checkSubtype(e1, t1, i) {
                const n = On(e1, t1);
                return n && this.error(n, ..."number" == typeof i ? [
                    i
                ] : []), n;
            }
        }
        const xo = new Set([
            "zoom",
            "heatmap-density",
            "worldview",
            "line-progress",
            "raster-value",
            "sky-radial-progress",
            "accumulated",
            "is-supported-script",
            "pitch",
            "distance-from-center",
            "measure-light",
            "raster-particle-speed",
            "is-active-floor"
        ]);
        function vo(e1, t1, i) {
            return "assert" === i ? new Yn(t1, [
                e1
            ]) : "coerce" === i ? new or(t1, [
                e1
            ]) : e1;
        }
        function bo(e1) {
            if (e1 instanceof go) return bo(e1.boundExpression);
            if (e1 instanceof lr && "error" === e1.name) return !1;
            if (e1 instanceof cr) return !1;
            if (e1 instanceof Tr) return !1;
            if (e1 instanceof so) return !1;
            if (e1 instanceof mo) return !1;
            const t1 = e1 instanceof or || e1 instanceof Yn;
            let i = !0;
            return e1.eachChild((e1)=>{
                i = t1 ? i && bo(e1) : i && e1 instanceof Wn;
            }), !!i && lo(e1) && co(e1, xo);
        }
        function wo(e1, t1) {
            const i = e1.length - 1;
            let n, r, o = 0, a = i, s = 0;
            for(; o <= a;)if (s = Math.floor((o + a) / 2), n = e1[s], r = e1[s + 1], n <= t1) {
                if (s === i || t1 < r) return s;
                o = s + 1;
            } else {
                if (!(n > t1)) throw new qn("Input is not a number.");
                a = s - 1;
            }
            return 0;
        }
        class Eo {
            constructor(e1, t1, i){
                this.type = e1, this.input = t1, this.labels = [], this.outputs = [];
                for (const [e1, t1] of i)this.labels.push(e1), this.outputs.push(t1);
            }
            static parse(e1, t1) {
                if (e1.length - 1 < 4) return t1.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if ((e1.length - 1) % 2 != 0) return t1.error("Expected an even number of arguments.");
                const i = t1.parse(e1[1], 1, En);
                if (!i) return null;
                const n = [];
                let r = null;
                t1.expectedType && "value" !== t1.expectedType.kind && (r = t1.expectedType);
                for(let i = 1; i < e1.length; i += 2){
                    const o = 1 === i ? -1 / 0 : e1[i], a = e1[i + 1], s = i, l = i + 1;
                    if ("number" != typeof o) return t1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', s);
                    if (n.length && n.at(-1)[0] >= o) return t1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', s);
                    const u = t1.parse(a, l, r);
                    if (!u) return null;
                    r = r || u.type, n.push([
                        o,
                        u
                    ]);
                }
                return new Eo(r, i, n);
            }
            evaluate(e1) {
                const t1 = this.labels, i = this.outputs;
                if (1 === t1.length) return i[0].evaluate(e1);
                const n = this.input.evaluate(e1);
                if (n <= t1[0]) return i[0].evaluate(e1);
                const r = t1.length;
                return n >= t1[r - 1] ? i[r - 1].evaluate(e1) : i[wo(t1, n)].evaluate(e1);
            }
            eachChild(e1) {
                e1(this.input);
                for (const t1 of this.outputs)e1(t1);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = [
                    "step",
                    this.input.serialize()
                ];
                for(let t1 = 0; t1 < this.labels.length; t1++)t1 > 0 && e1.push(this.labels[t1]), e1.push(this.outputs[t1].serialize());
                return e1;
            }
        }
        const Ao = .95047, Io = 1.08883, To = 4 / 29, Mo = 6 / 29, So = 3 * Mo * Mo, zo = Mo * Mo * Mo, Ro = Math.PI / 180, Po = 180 / Math.PI;
        function Do(e1) {
            return e1 > zo ? Math.pow(e1, 1 / 3) : e1 / So + To;
        }
        function Co(e1) {
            return e1 > Mo ? e1 * e1 * e1 : So * (e1 - To);
        }
        function Fo(e1) {
            return 255 * (e1 <= .0031308 ? 12.92 * e1 : 1.055 * Math.pow(e1, 1 / 2.4) - .055);
        }
        function Oo(e1) {
            return (e1 /= 255) <= .04045 ? e1 / 12.92 : Math.pow((e1 + .055) / 1.055, 2.4);
        }
        function Lo(e1) {
            const t1 = Oo(e1.r), i = Oo(e1.g), n = Oo(e1.b), r = Do((.4124564 * t1 + .3575761 * i + .1804375 * n) / Ao), o = Do((.2126729 * t1 + .7151522 * i + .072175 * n) / 1);
            return {
                l: 116 * o - 16,
                a: 500 * (r - o),
                b: 200 * (o - Do((.0193339 * t1 + .119192 * i + .9503041 * n) / Io)),
                alpha: e1.a
            };
        }
        function Bo(e1) {
            let t1 = (e1.l + 16) / 116, i = isNaN(e1.a) ? t1 : t1 + e1.a / 500, n = isNaN(e1.b) ? t1 : t1 - e1.b / 200;
            return t1 = 1 * Co(t1), i = Ao * Co(i), n = Io * Co(n), new pn(Fo(3.2404542 * i - 1.5371385 * t1 - .4985314 * n), Fo(-0.969266 * i + 1.8760108 * t1 + .041556 * n), Fo(.0556434 * i - .2040259 * t1 + 1.0572252 * n), e1.alpha);
        }
        function No(e1, t1, i) {
            const n = t1 - e1;
            return e1 + i * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
        }
        const Vo = {
            forward: Lo,
            reverse: Bo,
            interpolate: function(e1, t1, i) {
                return {
                    l: dn(e1.l, t1.l, i),
                    a: dn(e1.a, t1.a, i),
                    b: dn(e1.b, t1.b, i),
                    alpha: dn(e1.alpha, t1.alpha, i)
                };
            }
        }, ko = {
            forward: function(e1) {
                const { l: t1, a: i, b: n } = Lo(e1), r = Math.atan2(n, i) * Po;
                return {
                    h: r < 0 ? r + 360 : r,
                    c: Math.sqrt(i * i + n * n),
                    l: t1,
                    alpha: e1.a
                };
            },
            reverse: function(e1) {
                const t1 = e1.h * Ro, i = e1.c;
                return Bo({
                    l: e1.l,
                    a: Math.cos(t1) * i,
                    b: Math.sin(t1) * i,
                    alpha: e1.alpha
                });
            },
            interpolate: function(e1, t1, i) {
                return {
                    h: No(e1.h, t1.h, i),
                    c: dn(e1.c, t1.c, i),
                    l: dn(e1.l, t1.l, i),
                    alpha: dn(e1.alpha, t1.alpha, i)
                };
            }
        };
        var Uo = Object.freeze({
            __proto__: null,
            hcl: ko,
            lab: Vo
        });
        class Go {
            constructor(e1, t1, i, n, r){
                this.type = e1, this.operator = t1, this.interpolation = i, this.input = n, this.labels = [], this.outputs = [];
                for (const [e1, t1] of r)this.labels.push(e1), this.outputs.push(t1);
            }
            static interpolationFactor(e1, t1, i, n) {
                let r = 0;
                if ("exponential" === e1.name) r = jo(t1, e1.base, i, n);
                else if ("linear" === e1.name) r = jo(t1, 1, i, n);
                else if ("cubic-bezier" === e1.name) {
                    const o = e1.controlPoints;
                    r = Re(o[0], o[1], o[2], o[3])(jo(t1, 1, i, n));
                }
                return r;
            }
            static parse(e1, t1) {
                let [i, n, r, ...o] = e1;
                if (!Array.isArray(n) || 0 === n.length) return t1.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const e1 = n[1];
                    if ("number" != typeof e1) return t1.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: e1
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return t1.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const e1 = n.slice(1);
                        if (4 !== e1.length || e1.some((e1)=>"number" != typeof e1 || e1 < 0 || e1 > 1)) return t1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: e1
                        };
                    }
                }
                if (e1.length - 1 < 4) return t1.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if (e1.length - 1 > 3 && (e1.length - 1) % 2 != 0) return t1.error("Expected an even number of arguments.");
                if (r = t1.parse(r, 2, En), !r) return null;
                const a = [];
                let s = null;
                "interpolate-hcl" === i || "interpolate-lab" === i ? s = Tn : t1.expectedType && "value" !== t1.expectedType.kind && (s = t1.expectedType);
                for(let e1 = 0; e1 < o.length; e1 += 2){
                    const i = o[e1], n = o[e1 + 1], r = e1 + 3, l = e1 + 4;
                    if ("number" != typeof i) return t1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', r);
                    if (a.length && a.at(-1)[0] >= i) return t1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', r);
                    const u = t1.parse(n, l, s);
                    if (!u) return null;
                    s = s || u.type, a.push([
                        i,
                        u
                    ]);
                }
                return "number" === s.kind || "color" === s.kind || "array" === s.kind && "number" === s.itemType.kind && "number" == typeof s.N ? new Go(s, i, n, r, a) : t1.error(`Type ${Cn(s)} is not interpolatable.`);
            }
            evaluate(e1) {
                const t1 = this.labels, i = this.outputs;
                if (1 === t1.length) return i[0].evaluate(e1);
                const n = this.input.evaluate(e1);
                if (n <= t1[0]) return i[0].evaluate(e1);
                const r = t1.length;
                if (n >= t1[r - 1]) return i[r - 1].evaluate(e1);
                const o = wo(t1, n), a = Go.interpolationFactor(this.interpolation, n, t1[o], t1[o + 1]), s = i[o].evaluate(e1), l = i[o + 1].evaluate(e1);
                return "interpolate" === this.operator ? xn[this.type.kind.toLowerCase()](s, l, a) : "interpolate-hcl" === this.operator ? ko.reverse(ko.interpolate(ko.forward(s), ko.forward(l), a)) : Vo.reverse(Vo.interpolate(Vo.forward(s), Vo.forward(l), a));
            }
            eachChild(e1) {
                e1(this.input);
                for (const t1 of this.outputs)e1(t1);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined());
            }
            serialize() {
                let e1;
                e1 = "linear" === this.interpolation.name ? [
                    "linear"
                ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                    "linear"
                ] : [
                    "exponential",
                    this.interpolation.base
                ] : [
                    "cubic-bezier",
                    ...this.interpolation.controlPoints
                ];
                const t1 = [
                    this.operator,
                    e1,
                    this.input.serialize()
                ];
                for(let e1 = 0; e1 < this.labels.length; e1++)t1.push(this.labels[e1], this.outputs[e1].serialize());
                return t1;
            }
        }
        function jo(e1, t1, i, n) {
            const r = n - i, o = e1 - i;
            return 0 === r ? 0 : 1 === t1 ? o / r : (Math.pow(t1, o) - 1) / (Math.pow(t1, r) - 1);
        }
        class Ho {
            constructor(e1, t1){
                this.type = e1, this.args = t1;
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expectected at least one argument."), null;
                let i = null;
                const n = t1.expectedType;
                n && "value" !== n.kind && (i = n);
                const r = [];
                for (const n of e1.slice(1)){
                    const e1 = t1.parse(n, 1 + r.length, i, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!e1) return null;
                    i = i || e1.type, r.push(e1);
                }
                const o = n && r.some((e1)=>On(n, e1.type));
                return new Ho(o ? Sn : i, r);
            }
            evaluate(e1) {
                let t1, i = null, n = 0;
                for (const r of this.args){
                    if (n++, i = r.evaluate(e1), i && i instanceof Gn && !i.available && (t1 || (t1 = i), i = null, n === this.args.length)) return t1;
                    if (null !== i) break;
                }
                return i;
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = [
                    "coalesce"
                ];
                return this.eachChild((t1)=>{
                    e1.push(t1.serialize());
                }), e1;
            }
        }
        const $o = /[^a-zA-Z0-9_]/;
        class Zo {
            constructor(e1, t1){
                this.type = t1.type, this.bindings = [].concat(e1), this.result = t1;
            }
            evaluate(e1) {
                return this.result.evaluate(e1);
            }
            eachChild(e1) {
                for (const t1 of this.bindings)e1(t1[1]);
                e1(this.result);
            }
            static parse(e1, t1) {
                if (e1.length < 4) return t1.error(`Expected at least 3 arguments, but found ${e1.length - 1} instead.`);
                const i = [];
                for(let n = 1; n < e1.length - 1; n += 2){
                    const r = e1[n];
                    if ("string" != typeof r) return t1.error(`Expected string, but found ${typeof r} instead.`, n);
                    if ($o.test(r)) return t1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const o = t1.parse(e1[n + 1], n + 1);
                    if (!o) return null;
                    i.push([
                        r,
                        o
                    ]);
                }
                const n = t1.parse(e1.at(-1), e1.length - 1, t1.expectedType, i);
                return n ? new Zo(i, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
            serialize() {
                const e1 = [
                    "let"
                ];
                for (const [t1, i] of this.bindings)e1.push(t1, i.serialize());
                return e1.push(this.result.serialize()), e1;
            }
        }
        class Wo {
            constructor(e1, t1, i){
                this.type = e1, this.index = t1, this.input = i;
            }
            static parse(e1, t1) {
                if (3 !== e1.length) return t1.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const i = t1.parse(e1[1], 1, En), n = t1.parse(e1[2], 2, Dn(t1.expectedType || Sn));
                return i && n ? new Wo(n.type.itemType, i, n) : null;
            }
            evaluate(e1) {
                const t1 = this.index.evaluate(e1), i = this.input.evaluate(e1);
                if (t1 < 0) throw new qn("Array index out of bounds: negative index");
                if (t1 >= i.length) throw new qn("Array index out of bounds: index exceeds array size");
                if (t1 !== Math.floor(t1)) throw new qn("Array index must be an integer. Use at-interpolated for fractional indices");
                return i[t1];
            }
            eachChild(e1) {
                e1(this.index), e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        class qo {
            constructor(e1, t1, i){
                this.type = e1, this.index = t1, this.input = i;
            }
            static parse(e1, t1) {
                if (3 !== e1.length) return t1.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const i = t1.parse(e1[1], 1, En), n = t1.parse(e1[2], 2, Dn(t1.expectedType || Sn));
                return i && n ? new qo(n.type.itemType, i, n) : null;
            }
            evaluate(e1) {
                const t1 = this.index.evaluate(e1), i = this.input.evaluate(e1);
                if (t1 < 0) throw new qn(`Array index out of bounds: ${t1} < 0.`);
                if (t1 > i.length - 1) throw new qn(`Array index out of bounds: ${t1} > ${i.length - 1}.`);
                if (t1 === Math.floor(t1)) return i[t1];
                const n = Math.floor(t1), r = Math.ceil(t1), o = i[n], a = i[r];
                if ("number" != typeof o || "number" != typeof a) throw new qn(`Cannot interpolate between non-number values at index ${t1}.`);
                return dn(o, a, t1 - n);
            }
            eachChild(e1) {
                e1(this.index), e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at-interpolated",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        class Xo {
            constructor(e1, t1, i, n, r, o){
                this.inputType = e1, this.type = t1, this.input = i, this.cases = n, this.outputs = r, this.otherwise = o;
            }
            static parse(e1, t1) {
                if (e1.length < 5) return t1.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if (e1.length % 2 != 1) return t1.error("Expected an even number of arguments.");
                let i, n;
                t1.expectedType && "value" !== t1.expectedType.kind && (n = t1.expectedType);
                const r = {}, o = [];
                for(let a = 2; a < e1.length - 1; a += 2){
                    let s = e1[a];
                    const l = e1[a + 1];
                    if (Array.isArray(s) || (s = [
                        s
                    ]), 0 === s.length) return t1.error("Expected at least one branch label.", a);
                    for (const e1 of s){
                        if ("number" != typeof e1 && "string" != typeof e1) return t1.error("Branch labels must be numbers or strings.", a);
                        if ("number" == typeof e1 && Math.abs(e1) > Number.MAX_SAFE_INTEGER) return t1.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`, a);
                        if ("number" == typeof e1 && Math.floor(e1) !== e1) return t1.error("Numeric branch labels must be integer values.", a);
                        if (i) {
                            if (t1.checkSubtype(i, $n(e1), a)) return null;
                        } else i = $n(e1);
                        if (void 0 !== r[String(e1)]) return t1.error("Branch labels must be unique.", a);
                        r[String(e1)] = o.length;
                    }
                    const u = t1.parse(l, a, n);
                    if (!u) return null;
                    n = n || u.type, o.push(u);
                }
                const a = t1.parse(e1[1], 1, Sn);
                if (!a) return null;
                const s = t1.parse(e1.at(-1), e1.length - 1, n);
                return s ? "value" !== a.type.kind && t1.checkSubtype(i, a.type, 1) ? null : new Xo(i, n, a, r, o, s) : null;
            }
            evaluate(e1) {
                const t1 = this.input.evaluate(e1);
                return (Bn($n(t1), this.inputType) && this.outputs[this.cases[t1]] || this.otherwise).evaluate(e1);
            }
            eachChild(e1) {
                e1(this.input), this.outputs.forEach(e1), e1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const e1 = [
                    "match",
                    this.input.serialize()
                ], t1 = Object.keys(this.cases).sort(), i = [], n = {};
                for (const e1 of t1){
                    const t1 = n[this.cases[e1]];
                    void 0 === t1 ? (n[this.cases[e1]] = i.length, i.push([
                        this.cases[e1],
                        [
                            e1
                        ]
                    ])) : i[t1][1].push(e1);
                }
                const r = (e1)=>"number" === this.inputType.kind ? Number(e1) : e1;
                for (const [t1, n] of i)e1.push(1 === n.length ? r(n[0]) : n.map(r)), e1.push(this.outputs[t1].serialize());
                return e1.push(this.otherwise.serialize()), e1;
            }
        }
        class Yo {
            constructor(e1, t1, i){
                this.type = e1, this.branches = t1, this.otherwise = i;
            }
            static parse(e1, t1) {
                if (e1.length < 4) return t1.error(`Expected at least 3 arguments, but found only ${e1.length - 1}.`), null;
                if (e1.length % 2 != 0) return t1.error("Expected an odd number of arguments."), null;
                let i;
                t1.expectedType && "value" !== t1.expectedType.kind && (i = t1.expectedType);
                const n = [];
                for(let r = 1; r < e1.length - 1; r += 2){
                    const o = t1.parse(e1[r], r, In);
                    if (!o) return null;
                    const a = t1.parse(e1[r + 1], r + 1, i);
                    if (!a) return null;
                    n.push([
                        o,
                        a
                    ]), i = i || a.type;
                }
                const r = t1.parse(e1.at(-1), e1.length - 1, i);
                return r ? new Yo(i, n, r) : null;
            }
            evaluate(e1) {
                for (const [t1, i] of this.branches)if (t1.evaluate(e1)) return i.evaluate(e1);
                return this.otherwise.evaluate(e1);
            }
            eachChild(e1) {
                for (const [t1, i] of this.branches)e1(t1), e1(i);
                e1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([e1, t1])=>t1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const e1 = [
                    "case"
                ];
                return this.eachChild((t1)=>{
                    e1.push(t1.serialize());
                }), e1;
            }
        }
        class Jo {
            constructor(e1, t1, i, n){
                this.type = e1, this.input = t1, this.beginIndex = i, this.endIndex = n;
            }
            static parse(e1, t1) {
                if (e1.length <= 2 || e1.length >= 5) return t1.error(`Expected 3 or 4 arguments, but found ${e1.length - 1} instead.`), null;
                const i = t1.parse(e1[1], 1, Sn), n = t1.parse(e1[2], 2, En);
                if (!i || !n) return null;
                if (r = i.type, ![
                    Dn(Sn),
                    An,
                    Sn
                ].some((e1)=>e1.kind === r.kind)) return t1.error(`Expected first argument to be of type array or string, but found ${Cn(i.type)} instead`), null;
                var r;
                if (4 === e1.length) {
                    const r = t1.parse(e1[3], 3, En);
                    return r ? new Jo(i.type, i, n, r) : null;
                }
                return new Jo(i.type, i, n);
            }
            evaluate(e1) {
                const t1 = this.input.evaluate(e1), i = this.beginIndex.evaluate(e1);
                if (!Ln(t1, [
                    "string",
                    "array"
                ])) throw new qn(`Expected first argument to be of type array or string, but found ${Cn($n(t1))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(e1);
                    return t1.slice(i, n);
                }
                return t1.slice(i);
            }
            eachChild(e1) {
                e1(this.input), e1(this.beginIndex), this.endIndex && e1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.endIndex && void 0 !== this.endIndex) {
                    const e1 = this.endIndex.serialize();
                    return [
                        "slice",
                        this.input.serialize(),
                        this.beginIndex.serialize(),
                        e1
                    ];
                }
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize()
                ];
            }
        }
        function Ko(e1, t1) {
            return "==" === e1 || "!=" === e1 ? "boolean" === t1.kind || "string" === t1.kind || "number" === t1.kind || "null" === t1.kind || "value" === t1.kind : "string" === t1.kind || "number" === t1.kind || "value" === t1.kind;
        }
        function Qo(e1, t1, i, n) {
            return 0 === n.compare(t1, i);
        }
        function ea(e1, t1, i) {
            const n = "==" !== e1 && "!=" !== e1;
            return class r {
                constructor(e1, t1, i){
                    this.type = In, this.lhs = e1, this.rhs = t1, this.collator = i, this.hasUntypedArgument = "value" === e1.type.kind || "value" === t1.type.kind;
                }
                static parse(e1, t1) {
                    if (3 !== e1.length && 4 !== e1.length) return t1.error("Expected two or three arguments.");
                    const i = e1[0];
                    let o = t1.parse(e1[1], 1, Sn);
                    if (!o) return null;
                    if (!Ko(i, o.type)) return t1.error(`"${i}" comparisons are not supported for type '${Cn(o.type)}'.`, 1);
                    let a = t1.parse(e1[2], 2, Sn);
                    if (!a) return null;
                    if (!Ko(i, a.type)) return t1.error(`"${i}" comparisons are not supported for type '${Cn(a.type)}'.`, 2);
                    if (o.type.kind !== a.type.kind && "value" !== o.type.kind && "value" !== a.type.kind) return t1.error(`Cannot compare types '${Cn(o.type)}' and '${Cn(a.type)}'.`);
                    n && ("value" === o.type.kind && "value" !== a.type.kind ? o = new Yn(a.type, [
                        o
                    ]) : "value" !== o.type.kind && "value" === a.type.kind && (a = new Yn(o.type, [
                        a
                    ])));
                    let s = null;
                    if (4 === e1.length) {
                        if ("string" !== o.type.kind && "string" !== a.type.kind && "value" !== o.type.kind && "value" !== a.type.kind) return t1.error("Cannot use collator to compare non-string types.");
                        if (s = t1.parse(e1[3], 3, zn), !s) return null;
                    }
                    return new r(o, a, s);
                }
                evaluate(r) {
                    const o = this.lhs.evaluate(r), a = this.rhs.evaluate(r);
                    if (n && this.hasUntypedArgument) {
                        const t1 = $n(o), i = $n(a);
                        if (t1.kind !== i.kind || "string" !== t1.kind && "number" !== t1.kind) throw new qn(`Expected arguments for "${e1}" to be (string, string) or (number, number), but found (${t1.kind}, ${i.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const e1 = $n(o), i = $n(a);
                        if ("string" !== e1.kind || "string" !== i.kind) return t1(r, o, a);
                    }
                    return this.collator ? i(r, o, a, this.collator.evaluate(r)) : t1(r, o, a);
                }
                eachChild(e1) {
                    e1(this.lhs), e1(this.rhs), this.collator && e1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
                serialize() {
                    const t1 = [
                        e1
                    ];
                    return this.eachChild((e1)=>{
                        t1.push(e1.serialize());
                    }), t1;
                }
            };
        }
        const ta = ea("==", function(e1, t1, i) {
            return t1 === i;
        }, Qo), ia = ea("!=", function(e1, t1, i) {
            return t1 !== i;
        }, function(e1, t1, i, n) {
            return !Qo(0, t1, i, n);
        }), na = ea("<", function(e1, t1, i) {
            return t1 < i;
        }, function(e1, t1, i, n) {
            return n.compare(t1, i) < 0;
        }), ra = ea(">", function(e1, t1, i) {
            return t1 > i;
        }, function(e1, t1, i, n) {
            return n.compare(t1, i) > 0;
        }), oa = ea("<=", function(e1, t1, i) {
            return t1 <= i;
        }, function(e1, t1, i, n) {
            return n.compare(t1, i) <= 0;
        }), aa = ea(">=", function(e1, t1, i) {
            return t1 >= i;
        }, function(e1, t1, i, n) {
            return n.compare(t1, i) >= 0;
        });
        class sa {
            constructor(e1, t1, i, n, r, o){
                this.type = An, this.number = e1, this.locale = t1, this.currency = i, this.unit = n, this.minFractionDigits = r, this.maxFractionDigits = o;
            }
            static parse(e1, t1) {
                if (3 !== e1.length) return t1.error("Expected two arguments.");
                const i = t1.parse(e1[1], 1, En);
                if (!i) return null;
                const n = e1[2];
                if ("object" != typeof n || Array.isArray(n)) return t1.error("NumberFormat options argument must be an object.");
                let r = null;
                if (n.locale && (r = t1.parseObjectValue(n.locale, 2, "locale", An), !r)) return null;
                let o = null;
                if (n.currency && (o = t1.parseObjectValue(n.currency, 2, "currency", An), !o)) return null;
                let a = null;
                if (n.unit && (a = t1.parseObjectValue(n.unit, 2, "unit", An), !a)) return null;
                let s = null;
                if (void 0 !== n["min-fraction-digits"] && (s = t1.parseObjectValue(n["min-fraction-digits"], 2, "min-fraction-digits", En), !s)) return null;
                let l = null;
                return void 0 === n["max-fraction-digits"] || (l = t1.parseObjectValue(n["max-fraction-digits"], 2, "max-fraction-digits", En), l) ? new sa(i, r, o, a, s, l) : null;
            }
            evaluate(e1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(e1) : [], {
                    style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                    currency: this.currency ? this.currency.evaluate(e1) : void 0,
                    unit: this.unit ? this.unit.evaluate(e1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(e1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(e1) : void 0
                }).format(this.number.evaluate(e1));
            }
            eachChild(e1) {
                e1(this.number), this.locale && e1(this.locale), this.currency && e1(this.currency), this.unit && e1(this.unit), this.minFractionDigits && e1(this.minFractionDigits), this.maxFractionDigits && e1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = {};
                return this.locale && (e1.locale = this.locale.serialize()), this.currency && (e1.currency = this.currency.serialize()), this.unit && (e1.unit = this.unit.serialize()), this.minFractionDigits && (e1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (e1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                    "number-format",
                    this.number.serialize(),
                    e1
                ];
            }
        }
        class la {
            constructor(e1){
                this.type = En, this.input = e1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error(`Expected 1 argument, but found ${e1.length - 1} instead.`), null;
                const i = t1.parse(e1[1], 1);
                return i ? "array" !== i.type.kind && "string" !== i.type.kind && "value" !== i.type.kind ? (t1.error(`Expected argument of type string or array, but found ${Cn(i.type)} instead.`), null) : new la(i) : null;
            }
            evaluate(e1) {
                const t1 = this.input.evaluate(e1);
                if ("string" == typeof t1) return t1.length;
                if (Array.isArray(t1)) return t1.length;
                throw new qn(`Expected value to be of type string or array, but found ${Cn($n(t1))} instead.`);
            }
            eachChild(e1) {
                e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "length"
                ];
                return this.eachChild((t1)=>{
                    e1.push(t1.serialize());
                }), e1;
            }
        }
        function ua(e1) {
            return function() {
                e1 = 1831565813 + (e1 |= 0) | 0;
                let t1 = Math.imul(e1 ^ e1 >>> 15, 1 | e1);
                return t1 = t1 + Math.imul(t1 ^ t1 >>> 7, 61 | t1) ^ t1, ((t1 ^ t1 >>> 14) >>> 0) / 4294967296;
            };
        }
        const ca = {
            "==": ta,
            "!=": ia,
            ">": ra,
            "<": na,
            ">=": aa,
            "<=": oa,
            array: Yn,
            at: Wo,
            "at-interpolated": qo,
            boolean: Yn,
            case: Yo,
            coalesce: Ho,
            collator: cr,
            format: Jn,
            image: Kn,
            interpolate: Go,
            "interpolate-hcl": Go,
            "interpolate-lab": Go,
            length: la,
            let: Zo,
            literal: Wn,
            match: Xo,
            number: Yn,
            "number-format": sa,
            object: Yn,
            slice: Jo,
            step: Eo,
            string: Yn,
            "to-boolean": or,
            "to-color": or,
            "to-number": or,
            "to-string": or,
            var: go,
            within: Tr,
            distance: so,
            config: mo
        };
        function ha(e1, [t1, i, n, r]) {
            t1 = t1.evaluate(e1), i = i.evaluate(e1), n = n.evaluate(e1);
            const o = r ? r.evaluate(e1) : 1, a = jn(t1, i, n, o);
            if (a) throw new qn(a);
            return new pn(t1 / 255, i / 255, n / 255, o);
        }
        function da(e1, [t1, i, n, r]) {
            t1 = t1.evaluate(e1), i = i.evaluate(e1), n = n.evaluate(e1);
            const o = r ? r.evaluate(e1) : 1, a = function(e1, t1, i, n) {
                return "number" == typeof e1 && e1 >= 0 && e1 <= 360 ? "number" == typeof t1 && t1 >= 0 && t1 <= 100 && "number" == typeof i && i >= 0 && i <= 100 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid hsla value [${[
                    e1,
                    t1,
                    i,
                    n
                ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${("number" == typeof n ? [
                    e1,
                    t1,
                    i,
                    n
                ] : [
                    e1,
                    t1,
                    i
                ]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${("number" == typeof n ? [
                    e1,
                    t1,
                    i,
                    n
                ] : [
                    e1,
                    t1,
                    i
                ]).join(", ")}]: 'h' must be between 0 and 360.`;
            }(t1, i, n, o);
            if (a) throw new qn(a);
            const s = `hsla(${t1}, ${i}%, ${n}%, ${o})`, l = pn.parse(s);
            if (!l) throw new qn(`Failed to parse HSLA color: ${s}`);
            return l;
        }
        function fa(e1, t1) {
            return e1 in t1;
        }
        function pa(e1, t1) {
            const i = t1[e1];
            return void 0 === i ? null : i;
        }
        function _a(e1) {
            return {
                type: e1
            };
        }
        function ma(e1, t1) {
            if (!Ln(e1, [
                "boolean",
                "string",
                "number",
                "null"
            ])) throw new qn(`Expected first argument to be of type boolean, string, number or null, but found ${Cn($n(e1))} instead.`);
            if (!Ln(t1, [
                "string",
                "array"
            ])) throw new qn(`Expected second argument to be of type array or string, but found ${Cn($n(t1))} instead.`);
        }
        function ga(e1) {
            if (e1 instanceof mo) return new Set([
                e1.key
            ]);
            let t1 = new Set;
            return e1.eachChild((e1)=>{
                t1 = new Set([
                    ...t1,
                    ...ga(e1)
                ]);
            }), t1;
        }
        function ya(e1) {
            if (e1 instanceof lr && "is-active-floor" === e1.name) return !0;
            let t1 = !1;
            return e1.eachChild((e1)=>{
                !t1 && ya(e1) && (t1 = !0);
            }), t1;
        }
        function xa(e1) {
            return {
                result: "success",
                value: e1
            };
        }
        function va(e1) {
            return {
                result: "error",
                value: e1
            };
        }
        function ba(e1, t1) {
            return !!e1 && !!e1.parameters && e1.parameters.includes(t1);
        }
        function wa(e1) {
            return "data-driven" === e1["property-type"];
        }
        function Ea(e1) {
            return ba(e1.expression, "measure-light");
        }
        function Aa(e1) {
            return ba(e1.expression, "zoom");
        }
        function Ia(e1) {
            return !!e1.expression && e1.expression.interpolated;
        }
        function Ta(e1) {
            return "object" == typeof e1 && null !== e1 && !Array.isArray(e1);
        }
        function Ma(e1) {
            return e1;
        }
        function Sa(e1, t1) {
            const i = "color" === t1.type, n = e1.stops && "object" == typeof e1.stops[0][0], r = n || !(n || void 0 !== e1.property), o = e1.type || (Ia(t1) ? "exponential" : "interval");
            if (i && ((e1 = {
                ...e1
            }).stops && (e1.stops = e1.stops.map((e1)=>[
                    e1[0],
                    pn.parse(e1[1])
                ])), e1.default = pn.parse(e1.default ? e1.default : t1.default)), e1.colorSpace && "rgb" !== e1.colorSpace && !Uo[e1.colorSpace]) throw new Error(`Unknown color space: ${e1.colorSpace}`);
            let a, s, l;
            if ("exponential" === o) a = Da;
            else if ("interval" === o) a = Pa;
            else if ("categorical" === o) {
                a = Ra, s = Object.create(null);
                for (const t1 of e1.stops)s[t1[0]] = t1[1];
                l = typeof e1.stops[0][0];
            } else {
                if ("identity" !== o) throw new Error(`Unknown function type "${o}"`);
                a = Ca;
            }
            if (n) {
                const i = {}, n = [];
                for(let t1 = 0; t1 < e1.stops.length; t1++){
                    const r = e1.stops[t1], o = r[0].zoom;
                    void 0 === i[o] && (i[o] = {
                        zoom: o,
                        type: e1.type,
                        property: e1.property,
                        default: e1.default,
                        stops: []
                    }, n.push(o)), i[o].stops.push([
                        r[0].value,
                        r[1]
                    ]);
                }
                const r = [];
                for (const e1 of n)r.push([
                    i[e1].zoom,
                    Sa(i[e1], t1)
                ]);
                const o = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: o,
                    interpolationFactor: Go.interpolationFactor.bind(void 0, o),
                    zoomStops: r.map((e1)=>e1[0]),
                    evaluate: ({ zoom: i }, n)=>Da({
                            stops: r,
                            base: e1.base
                        }, t1, i).evaluate(i, n)
                };
            }
            if (r) {
                const i = "exponential" === o ? {
                    name: "exponential",
                    base: void 0 !== e1.base ? e1.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: i,
                    interpolationFactor: Go.interpolationFactor.bind(void 0, i),
                    zoomStops: e1.stops.map((e1)=>e1[0]),
                    evaluate: ({ zoom: i })=>a(e1, t1, i, s, l)
                };
            }
            return {
                kind: "source",
                evaluate (i, n) {
                    const r = n && n.properties ? n.properties[e1.property] : void 0;
                    return void 0 === r ? za(e1.default, t1.default) : a(e1, t1, r, s, l);
                }
            };
        }
        function za(e1, t1, i) {
            return void 0 !== e1 ? e1 : void 0 !== t1 ? t1 : void 0 !== i ? i : void 0;
        }
        function Ra(e1, t1, i, n, r) {
            return za(typeof i === r ? n[i] : void 0, e1.default, t1.default);
        }
        function Pa(e1, t1, i) {
            if (!ir(i)) return za(e1.default, t1.default);
            const n = e1.stops.length;
            if (1 === n) return e1.stops[0][1];
            if (i <= e1.stops[0][0]) return e1.stops[0][1];
            if (i >= e1.stops[n - 1][0]) return e1.stops[n - 1][1];
            const r = wo(e1.stops.map((e1)=>e1[0]), i);
            return e1.stops[r][1];
        }
        function Da(e1, t1, i) {
            const n = void 0 !== e1.base ? e1.base : 1;
            if (!ir(i)) return za(e1.default, t1.default);
            const r = e1.stops.length;
            if (1 === r) return e1.stops[0][1];
            if (i <= e1.stops[0][0]) return e1.stops[0][1];
            if (i >= e1.stops[r - 1][0]) return e1.stops[r - 1][1];
            const o = wo(e1.stops.map((e1)=>e1[0]), i), a = function(e1, t1, i, n) {
                const r = n - i, o = e1 - i;
                return 0 === r ? 0 : 1 === t1 ? o / r : (Math.pow(t1, o) - 1) / (Math.pow(t1, r) - 1);
            }(i, n, e1.stops[o][0], e1.stops[o + 1][0]), s = e1.stops[o][1], l = e1.stops[o + 1][1];
            let u = xn[t1.type] || Ma;
            if (e1.colorSpace && "rgb" !== e1.colorSpace) {
                const t1 = Uo[e1.colorSpace];
                u = (e1, i)=>t1.reverse(t1.interpolate(t1.forward(e1), t1.forward(i), a));
            }
            return "function" == typeof s.evaluate ? {
                evaluate (...e1) {
                    const t1 = s.evaluate.apply(void 0, e1), i = l.evaluate.apply(void 0, e1);
                    if (void 0 !== t1 && void 0 !== i) return u(t1, i, a);
                }
            } : u(s, l, a);
        }
        function Ca(e1, t1, i) {
            return "color" === t1.type ? i = pn.parse(i) : "formatted" === t1.type ? i = kn.fromString(i.toString()) : "resolvedImage" === t1.type ? i = Gn.build(i.toString()) : Qn(i) === t1.type || "enum" === t1.type && t1.values[i] || (i = void 0), za(i, e1.default, t1.default);
        }
        lr.register(ca, {
            error: [
                {
                    kind: "error"
                },
                [
                    An
                ],
                (e1, [t1])=>{
                    throw new qn(t1.evaluate(e1));
                }
            ],
            typeof: [
                An,
                [
                    Sn
                ],
                (e1, [t1])=>Cn($n(t1.evaluate(e1)))
            ],
            "to-rgba": [
                Dn(En, 4),
                [
                    Tn
                ],
                (e1, [t1])=>t1.evaluate(e1).toNonPremultipliedRenderColor(null).toArray()
            ],
            "to-hsla": [
                Dn(En, 4),
                [
                    Tn
                ],
                (e1, [t1])=>t1.evaluate(e1).toNonPremultipliedRenderColor(null).toHslaArray()
            ],
            rgb: [
                Tn,
                [
                    En,
                    En,
                    En
                ],
                ha
            ],
            rgba: [
                Tn,
                [
                    En,
                    En,
                    En,
                    En
                ],
                ha
            ],
            hsl: [
                Tn,
                [
                    En,
                    En,
                    En
                ],
                da
            ],
            hsla: [
                Tn,
                [
                    En,
                    En,
                    En,
                    En
                ],
                da
            ],
            has: {
                type: In,
                overloads: [
                    [
                        [
                            An
                        ],
                        (e1, [t1])=>fa(t1.evaluate(e1), e1.properties())
                    ],
                    [
                        [
                            An,
                            Mn
                        ],
                        (e1, [t1, i])=>fa(t1.evaluate(e1), i.evaluate(e1))
                    ]
                ]
            },
            get: {
                type: Sn,
                overloads: [
                    [
                        [
                            An
                        ],
                        (e1, [t1])=>pa(t1.evaluate(e1), e1.properties())
                    ],
                    [
                        [
                            An,
                            Mn
                        ],
                        (e1, [t1, i])=>pa(t1.evaluate(e1), i.evaluate(e1))
                    ]
                ]
            },
            "feature-state": [
                Sn,
                [
                    An
                ],
                (e1, [t1])=>pa(t1.evaluate(e1), e1.featureState || {})
            ],
            properties: [
                Mn,
                [],
                (e1)=>e1.properties()
            ],
            "geometry-type": [
                An,
                [],
                (e1)=>e1.geometryType()
            ],
            worldview: [
                An,
                [],
                (e1)=>e1.globals.worldview || ""
            ],
            "is-active-floor": [
                In,
                _a(An),
                (e1, t1)=>{
                    if (!(e1.globals && e1.globals.activeFloors && e1.globals.activeFloors.size > 0)) return !1;
                    if (0 === t1.length) return !0;
                    const i = e1.globals.activeFloors;
                    return t1.some((t1)=>{
                        const n = t1.evaluate(e1);
                        return i.has(n);
                    });
                }
            ],
            id: [
                Sn,
                [],
                (e1)=>e1.id()
            ],
            zoom: [
                En,
                [],
                (e1)=>e1.globals.zoom
            ],
            pitch: [
                En,
                [],
                (e1)=>e1.globals.pitch || 0
            ],
            "distance-from-center": [
                En,
                [],
                (e1)=>e1.distanceFromCenter()
            ],
            "measure-light": [
                En,
                [
                    An
                ],
                (e1, [t1])=>e1.measureLight(t1.evaluate(e1))
            ],
            "heatmap-density": [
                En,
                [],
                (e1)=>e1.globals.heatmapDensity || 0
            ],
            "line-progress": [
                En,
                [],
                (e1)=>e1.globals.lineProgress || 0
            ],
            "raster-value": [
                En,
                [],
                (e1)=>e1.globals.rasterValue || 0
            ],
            "raster-particle-speed": [
                En,
                [],
                (e1)=>e1.globals.rasterParticleSpeed || 0
            ],
            "sky-radial-progress": [
                En,
                [],
                (e1)=>e1.globals.skyRadialProgress || 0
            ],
            accumulated: [
                Sn,
                [],
                (e1)=>void 0 === e1.globals.accumulated ? null : e1.globals.accumulated
            ],
            "+": [
                En,
                _a(En),
                (e1, t1)=>{
                    let i = 0;
                    for (const n of t1)i += n.evaluate(e1);
                    return i;
                }
            ],
            "*": [
                En,
                _a(En),
                (e1, t1)=>{
                    let i = 1;
                    for (const n of t1)i *= n.evaluate(e1);
                    return i;
                }
            ],
            "-": {
                type: En,
                overloads: [
                    [
                        [
                            En,
                            En
                        ],
                        (e1, [t1, i])=>t1.evaluate(e1) - i.evaluate(e1)
                    ],
                    [
                        [
                            En
                        ],
                        (e1, [t1])=>-t1.evaluate(e1)
                    ]
                ]
            },
            "/": [
                En,
                [
                    En,
                    En
                ],
                (e1, [t1, i])=>t1.evaluate(e1) / i.evaluate(e1)
            ],
            "%": [
                En,
                [
                    En,
                    En
                ],
                (e1, [t1, i])=>t1.evaluate(e1) % i.evaluate(e1)
            ],
            ln2: [
                En,
                [],
                ()=>Math.LN2
            ],
            pi: [
                En,
                [],
                ()=>Math.PI
            ],
            e: [
                En,
                [],
                ()=>Math.E
            ],
            "^": [
                En,
                [
                    En,
                    En
                ],
                (e1, [t1, i])=>Math.pow(t1.evaluate(e1), i.evaluate(e1))
            ],
            sqrt: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.sqrt(t1.evaluate(e1))
            ],
            log10: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.log(t1.evaluate(e1)) / Math.LN10
            ],
            ln: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.log(t1.evaluate(e1))
            ],
            log2: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.log2(t1.evaluate(e1))
            ],
            sin: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.sin(t1.evaluate(e1))
            ],
            cos: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.cos(t1.evaluate(e1))
            ],
            tan: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.tan(t1.evaluate(e1))
            ],
            asin: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.asin(t1.evaluate(e1))
            ],
            acos: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.acos(t1.evaluate(e1))
            ],
            atan: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.atan(t1.evaluate(e1))
            ],
            min: [
                En,
                _a(En),
                (e1, t1)=>Math.min(...t1.map((t1)=>t1.evaluate(e1)))
            ],
            max: [
                En,
                _a(En),
                (e1, t1)=>Math.max(...t1.map((t1)=>t1.evaluate(e1)))
            ],
            abs: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.abs(t1.evaluate(e1))
            ],
            round: [
                En,
                [
                    En
                ],
                (e1, [t1])=>{
                    const i = t1.evaluate(e1);
                    return i < 0 ? -Math.round(-i) : Math.round(i);
                }
            ],
            floor: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.floor(t1.evaluate(e1))
            ],
            ceil: [
                En,
                [
                    En
                ],
                (e1, [t1])=>Math.ceil(t1.evaluate(e1))
            ],
            "filter-==": [
                In,
                [
                    An,
                    Sn
                ],
                (e1, [t1, i])=>e1.properties()[t1.value] === i.value
            ],
            "filter-id-==": [
                In,
                [
                    Sn
                ],
                (e1, [t1])=>e1.id() === t1.value
            ],
            "filter-type-==": [
                In,
                [
                    An
                ],
                (e1, [t1])=>e1.geometryType() === t1.value
            ],
            "filter-<": [
                In,
                [
                    An,
                    Sn
                ],
                (e1, [t1, i])=>{
                    const n = e1.properties()[t1.value], r = i.value;
                    return typeof n == typeof r && n < r;
                }
            ],
            "filter-id-<": [
                In,
                [
                    Sn
                ],
                (e1, [t1])=>{
                    const i = e1.id(), n = t1.value;
                    return typeof i == typeof n && i < n;
                }
            ],
            "filter->": [
                In,
                [
                    An,
                    Sn
                ],
                (e1, [t1, i])=>{
                    const n = e1.properties()[t1.value], r = i.value;
                    return typeof n == typeof r && n > r;
                }
            ],
            "filter-id->": [
                In,
                [
                    Sn
                ],
                (e1, [t1])=>{
                    const i = e1.id(), n = t1.value;
                    return typeof i == typeof n && i > n;
                }
            ],
            "filter-<=": [
                In,
                [
                    An,
                    Sn
                ],
                (e1, [t1, i])=>{
                    const n = e1.properties()[t1.value], r = i.value;
                    return typeof n == typeof r && n <= r;
                }
            ],
            "filter-id-<=": [
                In,
                [
                    Sn
                ],
                (e1, [t1])=>{
                    const i = e1.id(), n = t1.value;
                    return typeof i == typeof n && i <= n;
                }
            ],
            "filter->=": [
                In,
                [
                    An,
                    Sn
                ],
                (e1, [t1, i])=>{
                    const n = e1.properties()[t1.value], r = i.value;
                    return typeof n == typeof r && n >= r;
                }
            ],
            "filter-id->=": [
                In,
                [
                    Sn
                ],
                (e1, [t1])=>{
                    const i = e1.id(), n = t1.value;
                    return typeof i == typeof n && i >= n;
                }
            ],
            "filter-has": [
                In,
                [
                    Sn
                ],
                (e1, [t1])=>t1.value in e1.properties()
            ],
            "filter-has-id": [
                In,
                [],
                (e1)=>null !== e1.id() && void 0 !== e1.id()
            ],
            "filter-type-in": [
                In,
                [
                    Dn(An)
                ],
                (e1, [t1])=>t1.value.includes(e1.geometryType())
            ],
            "filter-id-in": [
                In,
                [
                    Dn(Sn)
                ],
                (e1, [t1])=>t1.value.includes(e1.id())
            ],
            "filter-in-small": [
                In,
                [
                    An,
                    Dn(Sn)
                ],
                (e1, [t1, i])=>i.value.includes(e1.properties()[t1.value])
            ],
            "filter-in-large": [
                In,
                [
                    An,
                    Dn(Sn)
                ],
                (e1, [t1, i])=>(function(e1, t1, i, n) {
                        for(; i <= n;){
                            const r = i + n >> 1;
                            if (t1[r] === e1) return !0;
                            t1[r] > e1 ? n = r - 1 : i = r + 1;
                        }
                        return !1;
                    })(e1.properties()[t1.value], i.value, 0, i.value.length - 1)
            ],
            all: {
                type: In,
                overloads: [
                    [
                        [
                            In,
                            In
                        ],
                        (e1, [t1, i])=>t1.evaluate(e1) && i.evaluate(e1)
                    ],
                    [
                        _a(In),
                        (e1, t1)=>{
                            for (const i of t1)if (!i.evaluate(e1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: In,
                overloads: [
                    [
                        [
                            In,
                            In
                        ],
                        (e1, [t1, i])=>t1.evaluate(e1) || i.evaluate(e1)
                    ],
                    [
                        _a(In),
                        (e1, t1)=>{
                            for (const i of t1)if (i.evaluate(e1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                In,
                [
                    In
                ],
                (e1, [t1])=>!t1.evaluate(e1)
            ],
            "is-supported-script": [
                In,
                [
                    An
                ],
                (e1, [t1])=>{
                    const i = e1.globals && e1.globals.isSupportedScript;
                    return !i || i(t1.evaluate(e1));
                }
            ],
            upcase: [
                An,
                [
                    An
                ],
                (e1, [t1])=>t1.evaluate(e1).toUpperCase()
            ],
            downcase: [
                An,
                [
                    An
                ],
                (e1, [t1])=>t1.evaluate(e1).toLowerCase()
            ],
            concat: [
                An,
                _a(Sn),
                (e1, t1)=>t1.map((t1)=>Zn(t1.evaluate(e1))).join("")
            ],
            split: [
                Dn(An),
                [
                    An,
                    An
                ],
                (e1, [t1, i])=>t1.evaluate(e1).split(i.evaluate(e1))
            ],
            in: [
                In,
                [
                    Sn,
                    Sn
                ],
                (e1, [t1, i])=>{
                    const n = t1.evaluate(e1), r = i.evaluate(e1);
                    return null != r && (ma(n, r), r.includes(n));
                }
            ],
            "index-of": {
                type: En,
                overloads: [
                    [
                        [
                            Sn,
                            Sn
                        ],
                        (e1, [t1, i])=>{
                            const n = t1.evaluate(e1), r = i.evaluate(e1);
                            return ma(n, r), r.indexOf(n);
                        }
                    ],
                    [
                        [
                            Sn,
                            Sn,
                            En
                        ],
                        (e1, [t1, i, n])=>{
                            const r = t1.evaluate(e1), o = i.evaluate(e1), a = n.evaluate(e1);
                            return ma(r, o), o.indexOf(r, a);
                        }
                    ]
                ]
            },
            "resolved-locale": [
                An,
                [
                    zn
                ],
                (e1, [t1])=>t1.evaluate(e1).resolvedLocale()
            ],
            random: [
                En,
                [
                    En,
                    En,
                    Sn
                ],
                (e1, t1)=>{
                    const [i, n, r] = t1.map((t1)=>t1.evaluate(e1));
                    if (i > n) return i;
                    if (i === n) return i;
                    let o;
                    if ("string" == typeof r) o = function(e1) {
                        let t1 = 0;
                        if (0 === e1.length) return t1;
                        for(let i = 0; i < e1.length; i++)t1 = (t1 << 5) - t1 + e1.charCodeAt(i), t1 &= t1;
                        return t1;
                    }(r);
                    else {
                        if ("number" != typeof r) throw new qn(`Invalid seed input: ${r}`);
                        o = r;
                    }
                    return i + ua(o)() * (n - i);
                }
            ]
        });
        class Fa {
            constructor(e1, t1, i, n, r){
                this.expression = e1, this._warningHistory = {}, this._scope = i, this._options = n, this._iconImageUseTheme = r, this._evaluator = new sr(i, n, r), this._defaultValue = t1 ? function(e1) {
                    return "color" === e1.type && (Ta(e1.default) || Array.isArray(e1.default)) ? new pn(0, 0, 0, 0) : "color" === e1.type ? pn.parse(e1.default) || null : void 0 === e1.default ? null : e1.default;
                }(t1) : null, this._enumValues = t1 && "enum" === t1.type ? t1.values : null, this.configDependencies = ga(e1), this.isIndoorDependent = ya(e1);
            }
            evaluateWithoutErrorHandling(e1, t1, i, n, r, o, a, s) {
                return this._evaluator.globals = e1, this._evaluator.feature = t1, this._evaluator.featureState = i, this._evaluator.canonical = n || null, this._evaluator.availableImages = r || null, this._evaluator.formattedSection = o, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = s || null, this.expression.evaluate(this._evaluator);
            }
            evaluate(e1, t1, i, n, r, o, a, s, l) {
                this._evaluator || (this._evaluator = new sr(this._scope, this._options, this._iconImageUseTheme)), this._evaluator.globals = e1, this._evaluator.feature = t1 || null, this._evaluator.featureState = i || null, this._evaluator.canonical = n || null, this._evaluator.availableImages = r || null, this._evaluator.formattedSection = o || null, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = s || null, this._evaluator.iconImageUseTheme = l || null;
                try {
                    const e1 = this.expression.evaluate(this._evaluator);
                    if (null == e1 || "number" == typeof e1 && e1 != e1) return this._defaultValue;
                    if (this._enumValues && !(e1 in this._enumValues)) throw new qn(`Expected value to be one of ${Object.keys(this._enumValues).map((e1)=>JSON.stringify(e1)).join(", ")}, but found ${JSON.stringify(e1)} instead.`);
                    return e1;
                } catch (e1) {
                    const t1 = e1;
                    return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(`Failed to evaluate expression "${JSON.stringify(this.expression.serialize())}". ${t1.message}`)), this._defaultValue;
                }
            }
        }
        function Oa(e1) {
            return Array.isArray(e1) && e1.length > 0 && "string" == typeof e1[0] && Object.hasOwn(ca, e1[0]);
        }
        function La(e1, t1, i, n, r) {
            const o = new yo(ca, [], t1 ? function(e1) {
                const t1 = {
                    color: Tn,
                    string: An,
                    number: En,
                    enum: An,
                    boolean: In,
                    formatted: Rn,
                    resolvedImage: Pn
                };
                return "array" === e1.type ? Dn(t1[e1.value] || Sn, e1.length) : t1[e1.type];
            }(t1) : void 0, void 0, void 0, i, n, r), a = o.parse(e1, void 0, void 0, void 0, t1 && "string" === t1.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return a ? xa(new Fa(a, t1, i, n, r)) : va(o.errors);
        }
        class Ba {
            constructor(e1, t1, i, n){
                this.kind = e1, this._styleExpression = t1, this.isLightConstant = i, this.isLineProgressConstant = n, this.isStateDependent = "constant" !== e1 && !uo(t1.expression), this.configDependencies = ga(t1.expression), this.isIndoorDependent = ya(t1.expression);
            }
            evaluateWithoutErrorHandling(e1, t1, i, n, r, o) {
                return this._styleExpression.evaluateWithoutErrorHandling(e1, t1, i, n, r, o);
            }
            evaluate(e1, t1, i, n, r, o, a) {
                return this._styleExpression.evaluate(e1, t1, i, n, r, o, void 0, void 0, a);
            }
        }
        class Na {
            constructor(e1, t1, i, n, r, o){
                this.kind = e1, this.zoomStops = i, this._styleExpression = t1, this.isStateDependent = "camera" !== e1 && !uo(t1.expression), this.isIndoorDependent = ya(t1.expression), this.isLightConstant = r, this.isLineProgressConstant = o, this.configDependencies = ga(t1.expression), this.interpolationType = n;
            }
            evaluateWithoutErrorHandling(e1, t1, i, n, r, o) {
                return this._styleExpression.evaluateWithoutErrorHandling(e1, t1, i, n, r, o);
            }
            evaluate(e1, t1, i, n, r, o) {
                return this._styleExpression.evaluate(e1, t1, i, n, r, o);
            }
            interpolationFactor(e1, t1, i) {
                return this.interpolationType ? Go.interpolationFactor(this.interpolationType, e1, t1, i) : 0;
            }
        }
        function Va(e1, t1, i, n, r) {
            if ("error" === (e1 = La(e1, t1, i, n, r)).result) return e1;
            const o = e1.value.expression, a = lo(o);
            if (!a && !wa(t1)) return va([
                new vn("", "data expressions not supported")
            ]);
            const s = ho(o, [
                "zoom",
                "pitch",
                "distance-from-center"
            ]);
            if (!s && !Aa(t1)) return va([
                new vn("", "zoom expressions not supported")
            ]);
            const l = ho(o, [
                "measure-light"
            ]);
            if (!l && !Ea(t1)) return va([
                new vn("", "measure-light expression not supported")
            ]);
            const u = ho(o, [
                "line-progress"
            ]);
            if (!u && !function(e1) {
                return ba(e1.expression, "line-progress");
            }(t1)) return va([
                new vn("", "line-progress expression not supported")
            ]);
            const c = t1.expression && t1.expression.relaxZoomRestriction, h = Ua(o);
            return h || s || c ? h instanceof vn ? va([
                h
            ]) : h instanceof Go && !Ia(t1) ? va([
                new vn("", '"interpolate" expressions cannot be used with this property')
            ]) : xa(h ? new Na(a && u ? "camera" : "composite", e1.value, h.labels, h instanceof Go ? h.interpolation : void 0, l, u) : new Ba(a && u ? "constant" : "source", e1.value, l, u)) : va([
                new vn("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')
            ]);
        }
        class ka {
            constructor(e1, t1){
                this._parameters = e1, this._specification = t1, Object.assign(this, Sa(this._parameters, this._specification));
            }
            static deserialize(e1) {
                return new ka(e1._parameters, e1._specification);
            }
            static serialize(e1) {
                return {
                    _parameters: e1._parameters,
                    _specification: e1._specification
                };
            }
        }
        function Ua(e1) {
            let t1 = null;
            if (e1 instanceof Zo) t1 = Ua(e1.result);
            else if (e1 instanceof Ho) {
                for (const i of e1.args)if (t1 = Ua(i), t1) break;
            } else (e1 instanceof Eo || e1 instanceof Go) && e1.input instanceof lr && "zoom" === e1.input.name && (t1 = e1);
            return t1 instanceof vn || e1.eachChild((e1)=>{
                const i = Ua(e1);
                i instanceof vn ? t1 = i : t1 && i && t1 !== i && (t1 = new vn("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), t1;
        }
        class Ga {
            constructor(e1, t1, i){
                if (this.boxSeen = new Uint32Array(0), this.circleSeen = new Uint32Array(0), this.generation = 0, e1 instanceof ArrayBuffer) {
                    const t1 = new Int32Array(e1);
                    this.width = t1[0], this.height = t1[1], this.xCellCount = t1[2], this.yCellCount = t1[3], this.boxUid = t1[4], this.circleUid = t1[5];
                    const i = this.xCellCount * this.yCellCount, n = [];
                    for(let e1 = 0; e1 < i; e1++){
                        const i = t1[6 + e1], r = t1[6 + e1 + 1];
                        n.push(i === r ? null : t1.subarray(i, r));
                    }
                    const r = t1[6 + i], o = [];
                    for(let e1 = 0; e1 < i; e1++){
                        const i = t1[r + e1], n = t1[r + e1 + 1];
                        o.push(i === n ? null : t1.subarray(i, n));
                    }
                    let a = t1[r + i];
                    this.boxCells = n, this.circleCells = o, this.boxKeys = t1.subarray(a, a + this.boxUid), a += this.boxUid, this.circleKeys = t1.subarray(a, a + this.circleUid), a += this.circleUid, this.bboxes = t1.subarray(a, a + 4 * this.boxUid), a += 4 * this.boxUid, this.circles = t1.subarray(a, a + 3 * this.circleUid);
                } else {
                    this.width = e1, this.height = t1, this.xCellCount = Math.ceil(e1 / i), this.yCellCount = Math.ceil(t1 / i);
                    const n = this.xCellCount * this.yCellCount, r = [], o = [];
                    for(let e1 = 0; e1 < n; e1++)r.push([]), o.push([]);
                    this.boxCells = r, this.circleCells = o, this.boxKeys = [], this.circleKeys = [], this.bboxes = [], this.circles = [], this.boxUid = 0, this.circleUid = 0;
                }
                this.xScale = this.xCellCount / this.width, this.yScale = this.yCellCount / this.height;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            clear() {
                for (const e1 of this.boxCells)e1 && (e1.length = 0);
                for (const e1 of this.circleCells)e1 && (e1.length = 0);
                this.circleKeys.length = 0, this.boxKeys.length = 0, this.bboxes.length = 0, this.circles.length = 0, this.boxUid = 0, this.circleUid = 0;
            }
            insert(e1, t1, i, n, r) {
                const o = this.boxUid++, a = this._xCell(t1), s = this._yCell(i), l = this._xCell(n), u = this._yCell(r);
                for(let e1 = a; e1 <= l; e1++)for(let t1 = s; t1 <= u; t1++)this.boxCells[this.xCellCount * t1 + e1].push(o);
                this.boxKeys.push(e1), this.bboxes.push(t1, i, n, r);
            }
            insertCircle(e1, t1, i, n) {
                const r = this.circleUid++, o = this._xCell(t1 - n), a = this._yCell(i - n), s = this._xCell(t1 + n), l = this._yCell(i + n);
                for(let e1 = o; e1 <= s; e1++)for(let t1 = a; t1 <= l; t1++)this.circleCells[this.xCellCount * t1 + e1].push(r);
                this.circleKeys.push(e1), this.circles.push(t1, i, n);
            }
            query(e1, t1, i, n, r) {
                const o = [];
                if (i < 0 || e1 > this.width || n < 0 || t1 > this.height) return o;
                const a = this._nextGen(), { boxCells: s, circleCells: l, boxKeys: u, circleKeys: c, bboxes: h, circles: d, boxSeen: f, circleSeen: p, xCellCount: _ } = this, m = this._xCell(e1), g = this._yCell(t1), y = this._xCell(i), x = this._yCell(n);
                for(let v = m; v <= y; v++)for(let m = g; m <= x; m++){
                    const g = _ * m + v, y = s[g];
                    if (y) for(let s = 0; s < y.length; s++){
                        const l = y[s];
                        if (f[l] === a) continue;
                        f[l] = a;
                        const c = 4 * l, d = h[c], p = h[c + 1], _ = h[c + 2], m = h[c + 3];
                        e1 <= _ && t1 <= m && i >= d && n >= p && (!r || r(u[l])) && o.push({
                            key: u[l],
                            x1: d,
                            y1: p,
                            x2: _,
                            y2: m
                        });
                    }
                    const x = l[g];
                    if (x) for(let s = 0; s < x.length; s++){
                        const l = x[s];
                        if (p[l] === a) continue;
                        p[l] = a;
                        const u = 3 * l, h = d[u], f = d[u + 1], _ = d[u + 2];
                        !this._circleAndRectCollide(h, f, _, e1, t1, i, n) || r && !r(c[l]) || o.push({
                            key: c[l],
                            x1: h - _,
                            y1: f - _,
                            x2: h + _,
                            y2: f + _
                        });
                    }
                }
                return o;
            }
            queryKeys(e1, t1, i, n, r) {
                const o = [];
                if (i < 0 || e1 > this.width || n < 0 || t1 > this.height) return o;
                const a = this._nextGen(), { boxCells: s, boxKeys: l, bboxes: u, boxSeen: c, xCellCount: h, xScale: d, yScale: f } = this, p = this._xCell(e1), _ = this._yCell(t1), m = this._xCell(i), g = this._yCell(n);
                for(let y = p; y <= m; y++)for(let p = _; p <= g; p++){
                    if (r && !r(y / d, p / f, (y + 1) / d, (p + 1) / f)) continue;
                    const _ = s[h * p + y];
                    if (_) for(let s = 0; s < _.length; s++){
                        const h = _[s];
                        if (c[h] === a) continue;
                        c[h] = a;
                        const d = 4 * h, f = u[d], p = u[d + 1], m = u[d + 2], g = u[d + 3];
                        (r ? r(f, p, m, g) : e1 <= m && t1 <= g && i >= f && n >= p) && o.push(l[h]);
                    }
                }
                return o;
            }
            hitTest(e1, t1, i, n, r) {
                if (i < 0 || e1 > this.width || n < 0 || t1 > this.height) return !1;
                const o = this._nextGen(), { boxCells: a, circleCells: s, boxKeys: l, circleKeys: u, bboxes: c, circles: h, boxSeen: d, circleSeen: f, xCellCount: p } = this, _ = this._xCell(e1), m = this._yCell(t1), g = this._xCell(i), y = this._yCell(n);
                for(let x = _; x <= g; x++)for(let _ = m; _ <= y; _++){
                    const m = p * _ + x, g = a[m];
                    if (g) for(let a = 0; a < g.length; a++){
                        const s = g[a];
                        if (d[s] === o) continue;
                        d[s] = o;
                        const u = 4 * s;
                        if (e1 <= c[u + 2] && t1 <= c[u + 3] && i >= c[u] && n >= c[u + 1] && (!r || r(l[s]))) return !0;
                    }
                    const y = s[m];
                    if (y) for(let a = 0; a < y.length; a++){
                        const s = y[a];
                        if (f[s] === o) continue;
                        f[s] = o;
                        const l = 3 * s;
                        if (this._circleAndRectCollide(h[l], h[l + 1], h[l + 2], e1, t1, i, n) && (!r || r(u[s]))) return !0;
                    }
                }
                return !1;
            }
            hitTestCircle(e1, t1, i, n) {
                const r = e1 - i, o = t1 - i, a = e1 + i, s = t1 + i;
                if (a < 0 || r > this.width || s < 0 || o > this.height) return !1;
                const l = this._nextGen(), { boxCells: u, circleCells: c, boxKeys: h, circleKeys: d, bboxes: f, circles: p, boxSeen: _, circleSeen: m, xCellCount: g } = this, y = this._xCell(r), x = this._yCell(o), v = this._xCell(a), b = this._yCell(s);
                for(let r = y; r <= v; r++)for(let o = x; o <= b; o++){
                    const a = g * o + r, s = u[a];
                    if (s) for(let r = 0; r < s.length; r++){
                        const o = s[r];
                        if (_[o] === l) continue;
                        _[o] = l;
                        const a = 4 * o;
                        if (this._circleAndRectCollide(e1, t1, i, f[a], f[a + 1], f[a + 2], f[a + 3]) && (!n || n(h[o]))) return !0;
                    }
                    const y = c[a];
                    if (y) for(let r = 0; r < y.length; r++){
                        const o = y[r];
                        if (m[o] === l) continue;
                        m[o] = l;
                        const a = 3 * o;
                        if (this._circlesCollide(p[a], p[a + 1], p[a + 2], e1, t1, i) && (!n || n(d[o]))) return !0;
                    }
                }
                return !1;
            }
            static serialize(e1, t1) {
                const i = e1.toArrayBuffer();
                return t1 && t1.add(i), {
                    buffer: i
                };
            }
            static deserialize(e1) {
                return new Ga(e1.buffer);
            }
            toArrayBuffer() {
                const e1 = this.xCellCount * this.yCellCount;
                let t1 = 0, i = 0;
                for(let n = 0; n < e1; n++)t1 += this.boxCells[n].length, i += this.circleCells[n].length;
                const n = new Int32Array(6 + (e1 + 1) + t1 + (e1 + 1) + i + this.boxUid + this.circleUid + 4 * this.boxUid + 3 * this.circleUid);
                n[0] = this.width, n[1] = this.height, n[2] = this.xCellCount, n[3] = this.yCellCount, n[4] = this.boxUid, n[5] = this.circleUid;
                let r = 6 + (e1 + 1);
                for(let t1 = 0; t1 < e1; t1++){
                    n[6 + t1] = r;
                    const e1 = this.boxCells[t1];
                    n.set(e1, r), r += e1.length;
                }
                n[6 + e1] = r;
                const o = r;
                r += e1 + 1;
                for(let t1 = 0; t1 < e1; t1++){
                    n[o + t1] = r;
                    const e1 = this.circleCells[t1];
                    n.set(e1, r), r += e1.length;
                }
                return n[o + e1] = r, n.set(this.boxKeys, r), r += this.boxUid, n.set(this.circleKeys, r), r += this.circleUid, n.set(this.bboxes, r), r += 4 * this.boxUid, n.set(this.circles, r), n.buffer;
            }
            _xCell(e1) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
            }
            _yCell(e1) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
            }
            _nextGen() {
                return this.boxSeen.length < this.boxUid && (this.boxSeen = new Uint32Array(this.boxUid)), this.circleSeen.length < this.circleUid && (this.circleSeen = new Uint32Array(this.circleUid)), this.generation = this.generation + 1 >>> 0, 0 === this.generation && (this.boxSeen.fill(0), this.circleSeen.fill(0), this.generation = 1), this.generation;
            }
            _circlesCollide(e1, t1, i, n, r, o) {
                const a = n - e1, s = r - t1, l = i + o;
                return l * l > a * a + s * s;
            }
            _circleAndRectCollide(e1, t1, i, n, r, o, a) {
                const s = (o - n) / 2, l = Math.abs(e1 - (n + s));
                if (l > s + i) return !1;
                const u = (a - r) / 2, c = Math.abs(t1 - (r + u));
                if (c > u + i) return !1;
                if (l <= s || c <= u) return !0;
                const h = l - s, d = c - u;
                return h * h + d * d <= i * i;
            }
        }
        const ja = {};
        function Ha(e1, t1, i = {}) {
            Object.defineProperty(e1, "_classRegistryKey", {
                value: t1,
                writable: !1
            }), ja[t1] = {
                klass: e1,
                omit: i.omit || []
            };
        }
        Ha(Object, "Object"), Ha(Ga, "Grid"), delete Pe.prototype.constructor, Ha(pn, "Color"), Ha(kn, "Formatted"), Ha(Vn, "FormattedSection"), Ha(Gn, "ResolvedImage"), Ha(ka, "StylePropertyFunction"), Ha(Fa, "StyleExpression", {
            omit: [
                "_evaluator"
            ]
        }), Ha(ln, "ImageId"), Ha(Un, "ImageVariant"), Ha(Na, "ZoomDependentExpression"), Ha(Ba, "ZoomConstantExpression"), Ha(lr, "CompoundExpression", {
            omit: [
                "_evaluate"
            ]
        });
        for(const e1 in ca)ja[ca[e1]._classRegistryKey] || Ha(ca[e1], `Expression${e1}`);
        function $a(e1) {
            return e1 && (e1 instanceof ArrayBuffer || e1.constructor && "ArrayBuffer" === e1.constructor.name);
        }
        const Za = {
            Error: Error,
            TypeError: TypeError,
            RangeError: RangeError,
            SyntaxError: SyntaxError,
            ReferenceError: ReferenceError,
            URIError: URIError,
            EvalError: EvalError
        }, Wa = new Set([
            "message",
            "stack",
            "cause",
            "errors",
            "name",
            "class"
        ]);
        function qa(e1, t1) {
            if (null === e1) return null;
            const i = typeof e1;
            if ("object" !== i) return "bigint" === i ? {
                $name: "BigInt",
                value: e1.toString()
            } : e1;
            if (Array.isArray(e1)) {
                const i = e1.length, n = [];
                n.length = i;
                for(let r = 0; r < i; r++)n[r] = qa(e1[r], t1);
                return n;
            }
            if (ArrayBuffer.isView(e1)) return t1 && t1.add(e1.buffer), e1;
            if ($a(e1) || e1 instanceof ImageBitmap) return t1 && t1.add(e1), e1;
            if (e1 instanceof ImageData) return t1 && t1.add(e1.data.buffer), e1;
            if (e1 instanceof Map) {
                const i = {
                    $name: "Map",
                    entries: []
                };
                for (const [n, r] of e1.entries())i.entries.push(qa(n), qa(r, t1));
                return i;
            }
            if (e1 instanceof Headers) return {
                $name: "Headers",
                entries: [
                    ...e1
                ]
            };
            if (e1 instanceof Set) {
                const t1 = {
                    $name: "Set"
                };
                let i = 0;
                for (const n of e1.values())t1[++i] = qa(n);
                return t1;
            }
            if (e1 instanceof Date || e1 instanceof RegExp || e1 instanceof Boolean || e1 instanceof Number || e1 instanceof String) return e1;
            if (e1 instanceof Error) {
                const i = e1, n = i.constructor && i.constructor.name || "Error", r = {
                    $name: "$Error",
                    class: i instanceof si ? "AJAXError" : i instanceof DOMException ? "DOMException" : i instanceof AggregateError ? "AggregateError" : Za[n] ? n : "Error",
                    name: i.name,
                    message: i.message
                };
                i.stack && (r.stack = i.stack), "cause" in i && i.cause !== i && (r.cause = qa(i.cause, t1)), i instanceof AggregateError && (r.errors = i.errors.filter((e1)=>e1 !== i).map((e1)=>qa(e1, t1)));
                const o = i;
                for(const e1 in o)Object.hasOwn(o, e1) && (Wa.has(e1) || (r[e1] = qa(o[e1], t1)));
                return r;
            }
            const n = e1.constructor || Object, r = n._classRegistryKey;
            if (!r) throw new Error(`Can't serialize object of unregistered class "${n.name}".`);
            const o = n.serialize ? n.serialize(e1, t1) : {};
            if (!n.serialize) {
                const i = ja[r].omit, n = e1;
                for(const e1 in n)Object.hasOwn(n, e1) && (i.includes(e1) || (o[e1] = qa(n[e1], t1)));
            }
            if (o.$name) throw new Error("$name property is reserved for worker serialization logic.");
            return "Object" !== r && (o.$name = r), o;
        }
        function Xa(e1) {
            if (null === e1 || "object" != typeof e1) return e1;
            if (Array.isArray(e1)) {
                for(let t1 = 0; t1 < e1.length; t1++)e1[t1] = Xa(e1[t1]);
                return e1;
            }
            if (ArrayBuffer.isView(e1) || $a(e1) || e1 instanceof ImageBitmap || e1 instanceof ImageData || e1 instanceof Date || e1 instanceof RegExp || e1 instanceof Boolean || e1 instanceof Number || e1 instanceof String) return e1;
            const t1 = e1.$name || "Object";
            if ("Map" === t1) {
                const t1 = e1.entries || [], i = new Map;
                for(let e1 = 0; e1 < t1.length; e1 += 2)i.set(Xa(t1[e1]), Xa(t1[e1 + 1]));
                return i;
            }
            if ("Headers" === t1) return new Headers(e1.entries);
            if ("Set" === t1) {
                const t1 = new Set;
                for(const i in e1)"$name" !== i && t1.add(Xa(e1[i]));
                return t1;
            }
            if ("BigInt" === t1) return BigInt(e1.value);
            if ("$Error" === t1) {
                const t1 = e1.class || "Error", i = e1.name || t1, n = e1.message || "";
                let r;
                r = "DOMException" === t1 ? new DOMException(n, i) : "AggregateError" === t1 ? new AggregateError((e1.errors || []).map(Xa), n) : "AJAXError" === t1 ? new si(e1.statusText, e1.status, e1.url) : new (Za[t1] || Error)(n), "DOMException" !== t1 && (r.name = i), e1.stack && (r.stack = e1.stack), "cause" in e1 && (r.cause = Xa(e1.cause));
                const o = r;
                for(const t1 in e1)Object.hasOwn(e1, t1) && ("$name" === t1 || Wa.has(t1) || (o[t1] = Xa(e1[t1])));
                return r;
            }
            const { klass: i } = ja[t1];
            if (!i) throw new Error(`Can't deserialize unregistered class "${t1}".`);
            if (i.deserialize) return i.deserialize(e1);
            const n = Object.create(i.prototype);
            for(const t1 in e1)"$name" !== t1 && (n[t1] = Xa(e1[t1]));
            return n;
        }
        const Ya = (e1)=>e1 >= 1536 && e1 <= 1791, Ja = (e1)=>e1 >= 1872 && e1 <= 1919, Ka = (e1)=>e1 >= 2208 && e1 <= 2303, Qa = (e1)=>e1 >= 11904 && e1 <= 12031, es = (e1)=>e1 >= 12032 && e1 <= 12255, ts = (e1)=>e1 >= 12272 && e1 <= 12287, is = (e1)=>e1 >= 12288 && e1 <= 12351, ns = (e1)=>e1 >= 12352 && e1 <= 12447, rs = (e1)=>e1 >= 12448 && e1 <= 12543, os = (e1)=>e1 >= 12544 && e1 <= 12591, as = (e1)=>e1 >= 12704 && e1 <= 12735, ss = (e1)=>e1 >= 12736 && e1 <= 12783, ls = (e1)=>e1 >= 12784 && e1 <= 12799, us = (e1)=>e1 >= 12800 && e1 <= 13055, cs = (e1)=>e1 >= 13056 && e1 <= 13311, hs = (e1)=>e1 >= 13312 && e1 <= 19903, ds = (e1)=>e1 >= 19968 && e1 <= 40959, fs = (e1)=>e1 >= 40960 && e1 <= 42127, ps = (e1)=>e1 >= 42128 && e1 <= 42191, _s = (e1)=>e1 >= 44032 && e1 <= 55215, ms = (e1)=>e1 >= 63744 && e1 <= 64255, gs = (e1)=>e1 >= 64336 && e1 <= 65023, ys = (e1)=>e1 >= 65040 && e1 <= 65055, xs = (e1)=>e1 >= 65072 && e1 <= 65103, vs = (e1)=>e1 >= 65104 && e1 <= 65135, bs = (e1)=>e1 >= 65136 && e1 <= 65279, ws = (e1)=>e1 >= 65280 && e1 <= 65519;
        function Es(e1) {
            for (const t1 of e1)if (Is(t1.charCodeAt(0))) return !0;
            return !1;
        }
        function As(e1) {
            return !(Ya(e1) || Ja(e1) || Ka(e1) || gs(e1) || bs(e1));
        }
        function Is(e1) {
            return !(746 !== e1 && 747 !== e1 && (e1 < 4352 || !(as(e1) || os(e1) || xs(e1) && !(e1 >= 65097 && e1 <= 65103) || ms(e1) || cs(e1) || Qa(e1) || ss(e1) || !(!is(e1) || e1 >= 12296 && e1 <= 12305 || e1 >= 12308 && e1 <= 12319 || 12336 === e1) || hs(e1) || ds(e1) || us(e1) || ((e1)=>e1 >= 12592 && e1 <= 12687)(e1) || ((e1)=>e1 >= 43360 && e1 <= 43391)(e1) || ((e1)=>e1 >= 55216 && e1 <= 55295)(e1) || ((e1)=>e1 >= 4352 && e1 <= 4607)(e1) || _s(e1) || ns(e1) || ts(e1) || ((e1)=>e1 >= 12688 && e1 <= 12703)(e1) || es(e1) || ls(e1) || rs(e1) && 12540 !== e1 || !(!ws(e1) || 65288 === e1 || 65289 === e1 || 65293 === e1 || e1 >= 65306 && e1 <= 65310 || 65339 === e1 || 65341 === e1 || 65343 === e1 || e1 >= 65371 && e1 <= 65503 || 65507 === e1 || e1 >= 65512 && e1 <= 65519) || !(!vs(e1) || e1 >= 65112 && e1 <= 65118 || e1 >= 65123 && e1 <= 65126) || ((e1)=>e1 >= 5120 && e1 <= 5759)(e1) || ((e1)=>e1 >= 6320 && e1 <= 6399)(e1) || ys(e1) || ((e1)=>e1 >= 19904 && e1 <= 19967)(e1) || fs(e1) || ps(e1))));
        }
        function Ts(e1) {
            return !(Is(e1) || function(e1) {
                return !!(((e1)=>e1 >= 128 && e1 <= 255)(e1) && (167 === e1 || 169 === e1 || 174 === e1 || 177 === e1 || 188 === e1 || 189 === e1 || 190 === e1 || 215 === e1 || 247 === e1) || ((e1)=>e1 >= 8192 && e1 <= 8303)(e1) && (8214 === e1 || 8224 === e1 || 8225 === e1 || 8240 === e1 || 8241 === e1 || 8251 === e1 || 8252 === e1 || 8258 === e1 || 8263 === e1 || 8264 === e1 || 8265 === e1 || 8273 === e1) || ((e1)=>e1 >= 8448 && e1 <= 8527)(e1) || ((e1)=>e1 >= 8528 && e1 <= 8591)(e1) || ((e1)=>e1 >= 8960 && e1 <= 9215)(e1) && (e1 >= 8960 && e1 <= 8967 || e1 >= 8972 && e1 <= 8991 || e1 >= 8996 && e1 <= 9e3 || 9003 === e1 || e1 >= 9085 && e1 <= 9114 || e1 >= 9150 && e1 <= 9165 || 9167 === e1 || e1 >= 9169 && e1 <= 9179 || e1 >= 9186 && e1 <= 9215) || ((e1)=>e1 >= 9216 && e1 <= 9279)(e1) && 9251 !== e1 || ((e1)=>e1 >= 9280 && e1 <= 9311)(e1) || ((e1)=>e1 >= 9312 && e1 <= 9471)(e1) || ((e1)=>e1 >= 9632 && e1 <= 9727)(e1) || ((e1)=>e1 >= 9728 && e1 <= 9983)(e1) && !(e1 >= 9754 && e1 <= 9759) || ((e1)=>e1 >= 11008 && e1 <= 11263)(e1) && (e1 >= 11026 && e1 <= 11055 || e1 >= 11088 && e1 <= 11097 || e1 >= 11192 && e1 <= 11243) || is(e1) || rs(e1) || ((e1)=>e1 >= 57344 && e1 <= 63743)(e1) || xs(e1) || vs(e1) || ws(e1) || 8734 === e1 || 8756 === e1 || 8757 === e1 || e1 >= 9984 && e1 <= 10087 || e1 >= 10102 && e1 <= 10131 || 65532 === e1 || 65533 === e1);
            }(e1));
        }
        function Ms(e1) {
            return e1 >= 1424 && e1 <= 2303 || gs(e1) || bs(e1);
        }
        function Ss(e1, t1) {
            return !(!t1 && Ms(e1) || e1 >= 2304 && e1 <= 3583 || e1 >= 3840 && e1 <= 4255 || ((e1)=>e1 >= 6016 && e1 <= 6143)(e1));
        }
        function zs(e1) {
            for (const t1 of e1)if (Ms(t1.charCodeAt(0))) return !0;
            return !1;
        }
        const Rs = {
            unavailable: "unavailable",
            deferred: "deferred",
            loading: "loading",
            parsing: "parsing",
            parsed: "parsed",
            loaded: "loaded",
            error: "error"
        };
        let Ps = null, Ds = Rs.unavailable, Cs = null;
        const Fs = function(e1) {
            e1 && (Ds = Rs.error), Ps && Ps(e1);
        };
        function Os() {
            Ls.fire(new nn("pluginStateChange", {
                pluginStatus: Ds,
                pluginURL: Cs
            }));
        }
        const Ls = new sn, Bs = function() {
            return Ds;
        }, Ns = function() {
            if (Ds !== Rs.deferred || !Cs) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            Ds = Rs.loading, Os(), Cs && _i({
                url: Cs
            }).then(()=>{
                Ds = Rs.loaded, Os();
            }).catch((e1)=>{
                Fs(e1);
            });
        }, Vs = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>Ds === Rs.loaded || null != Vs.applyArabicShaping,
            isLoading: ()=>Ds === Rs.loading,
            setState (e1) {
                Ds = e1.pluginStatus, Cs = e1.pluginURL;
            },
            isParsing: ()=>Ds === Rs.parsing,
            isParsed: ()=>Ds === Rs.parsed,
            getPluginURL: ()=>Cs
        };
        class ks {
            constructor(e1, t1){
                this.zoom = e1, t1 ? (this.now = t1.now, this.fadeDuration = t1.fadeDuration, this.transition = t1.transition, this.pitch = t1.pitch, this.brightness = t1.brightness, this.worldview = t1.worldview, this.activeFloors = t1.activeFloors) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
            }
            isSupportedScript(e1) {
                return function(e1, t1) {
                    for (const i of e1)if (!Ss(i.charCodeAt(0), t1)) return !1;
                    return !0;
                }(e1, Vs.isLoaded());
            }
        }
        class Us {
            constructor(e1, t1, i, n, r){
                this.property = e1, this.value = t1, this.expression = function(e1, t1, i, n, r) {
                    if (Ta(e1)) return new ka(e1, t1);
                    if (Oa(e1) || Array.isArray(e1) && e1.length > 0) {
                        const o = Va(e1, t1, i, n, r);
                        if ("error" === o.result) throw new Error(o.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                        return o.value;
                    }
                    {
                        let i = e1;
                        return "string" == typeof e1 && "color" === t1.type && (i = pn.parse(e1)), {
                            kind: "constant",
                            configDependencies: new Set,
                            isIndoorDependent: !1,
                            evaluate: ()=>i
                        };
                    }
                }(void 0 === t1 ? e1.specification.default : t1, e1.specification, i, n, r);
            }
            isIndoorDependent() {
                return this.expression.isIndoorDependent;
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(e1, t1, i, n) {
                return this.property.possiblyEvaluate(this, e1, t1, i, n);
            }
        }
        class Gs {
            constructor(e1, t1, i, n){
                this.property = e1, this.value = new Us(e1, void 0, t1, i, n);
            }
            transitioned(e1, t1) {
                return new Hs(this.property, this.value, t1, {
                    ...e1.transition,
                    ...this.transition
                }, e1.now);
            }
            untransitioned() {
                return new Hs(this.property, this.value, null, {}, 0);
            }
        }
        class js {
            constructor(e1, t1, i, n){
                this._properties = e1, this._values = Object.create(e1.defaultTransitionablePropertyValues), this._scope = t1, this._options = i, this._iconImageUseTheme = n, this._isIndoorDependent = !1, this.configDependencies = new Set;
            }
            getValue(e1) {
                return ft(this._values[e1].value.value);
            }
            setValue(e1, t1) {
                Object.hasOwn(this._values, e1) || (this._values[e1] = new Gs(this._values[e1].property, this._scope, this._options, this._iconImageUseTheme)), this._values[e1].value = new Us(this._values[e1].property, null === t1 ? void 0 : ft(t1), this._scope, this._options, this._iconImageUseTheme), this._values[e1].value.expression.configDependencies && (this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._values[e1].value.expression.configDependencies
                ]), this._isIndoorDependent = this._isIndoorDependent || this._values[e1].value.isIndoorDependent());
            }
            setTransitionOrValue(e1, t1) {
                t1 && (this._options = t1);
                const i = this._properties.properties;
                if (e1) for(const t1 in e1){
                    const n = e1[t1];
                    if (t1.endsWith("-transition")) {
                        const e1 = t1.slice(0, -11);
                        i[e1] && this.setTransition(e1, n);
                    } else Object.hasOwn(i, t1) && this.setValue(t1, n);
                }
            }
            getTransition(e1) {
                return ft(this._values[e1].transition);
            }
            setTransition(e1, t1) {
                Object.hasOwn(this._values, e1) || (this._values[e1] = new Gs(this._values[e1].property)), this._values[e1].transition = ft(t1) || void 0;
            }
            serialize() {
                const e1 = {};
                for (const t1 of Object.keys(this._values)){
                    const i = this.getValue(t1);
                    void 0 !== i && (e1[t1] = i);
                    const n = this.getTransition(t1);
                    void 0 !== n && (e1[`${t1}-transition`] = n);
                }
                return e1;
            }
            transitioned(e1, t1) {
                const i = new $s(this._properties);
                for (const n of Object.keys(this._values))i._values[n] = this._values[n].transitioned(e1, t1._values[n]);
                return i;
            }
            untransitioned() {
                const e1 = new $s(this._properties);
                for (const t1 of Object.keys(this._values))e1._values[t1] = this._values[t1].untransitioned();
                return e1;
            }
            isIndoorDependent() {
                return this._isIndoorDependent;
            }
        }
        class Hs {
            constructor(e1, t1, i, n, r){
                const o = n.delay || 0, a = n.duration || 0;
                r = r || 0, this.property = e1, this.value = t1, this.begin = r + o, this.end = this.begin + a, e1.specification.transition && (n.delay || n.duration) && (this.prior = i);
            }
            possiblyEvaluate(e1, t1, i) {
                const n = e1.now || 0, r = this.value.possiblyEvaluate(e1, t1, i), o = this.prior;
                if (o) {
                    if (n > this.end) return this.prior = null, r;
                    if (this.value.isDataDriven()) return this.prior = null, r;
                    if (n < this.begin) return o.possiblyEvaluate(e1, t1, i);
                    {
                        const a = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(o.possiblyEvaluate(e1, t1, i), r, Qe(a));
                    }
                }
                return r;
            }
        }
        class $s {
            constructor(e1){
                this._properties = e1, this._values = Object.create(e1.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(e1, t1, i) {
                const n = new qs(this._properties);
                for (const r of Object.keys(this._values))n._values[r] = this._values[r].possiblyEvaluate(e1, t1, i);
                return n;
            }
            hasTransition() {
                for (const e1 of Object.keys(this._values))if (this._values[e1].prior) return !0;
                return !1;
            }
        }
        class Zs {
            constructor(e1, t1, i, n){
                this._properties = e1, this._values = Object.create(e1.defaultPropertyValues), this._scope = t1, this._options = i, this._iconImageUseTheme = n, this._isIndoorDependent = !1, this.configDependencies = new Set;
            }
            getValue(e1) {
                return ft(this._values[e1].value);
            }
            setValue(e1, t1) {
                this._values[e1] = new Us(this._values[e1].property, null === t1 ? void 0 : ft(t1), this._scope, this._options, this._iconImageUseTheme), this._values[e1].expression.configDependencies && (this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._values[e1].expression.configDependencies
                ]), this._isIndoorDependent = this._isIndoorDependent || this._values[e1].isIndoorDependent());
            }
            serialize() {
                const e1 = {};
                for (const t1 of Object.keys(this._values)){
                    const i = this.getValue(t1);
                    void 0 !== i && (e1[t1] = i);
                }
                return e1;
            }
            possiblyEvaluate(e1, t1, i, n) {
                const r = new qs(this._properties);
                for (const o of Object.keys(this._values))r._values[o] = this._values[o].possiblyEvaluate(e1, t1, i, n);
                return r;
            }
            isIndoorDependent() {
                return this._isIndoorDependent;
            }
        }
        class Ws {
            constructor(e1, t1, i, n){
                this.property = e1, this.value = t1, this.parameters = i, this.iconImageUseTheme = n;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(e1) {
                return "constant" === this.value.kind ? this.value.value : e1;
            }
            evaluate(e1, t1, i, n, r) {
                return this.property.evaluate(this.value, this.parameters, e1, t1, i, n, this.iconImageUseTheme, r);
            }
        }
        class qs {
            constructor(e1){
                this._properties = e1, this._values = Object.create(e1.defaultPossiblyEvaluatedValues);
            }
            get(e1) {
                return this._values[e1];
            }
        }
        class Xs {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t1) {
                return e1.expression.evaluate(t1);
            }
            interpolate(e1, t1, i) {
                const n = xn[this.specification.type];
                return n ? n(e1, t1, i) : e1;
            }
        }
        class Ys {
            constructor(e1, t1){
                this.specification = e1, this.overrides = t1;
            }
            possiblyEvaluate(e1, t1, i, n, r) {
                return "constant" === e1.expression.kind || "camera" === e1.expression.kind ? new Ws(this, {
                    kind: "constant",
                    value: e1.expression.evaluate(t1, null, {}, i, n, void 0, r)
                }, t1) : new Ws(this, e1.expression, t1, r);
            }
            interpolate(e1, t1, i) {
                if ("constant" !== e1.value.kind || "constant" !== t1.value.kind) return e1;
                if (void 0 === e1.value.value || void 0 === t1.value.value) return new Ws(this, {
                    kind: "constant",
                    value: void 0
                }, e1.parameters);
                const n = xn[this.specification.type];
                return n ? new Ws(this, {
                    kind: "constant",
                    value: n(e1.value.value, t1.value.value, i)
                }, e1.parameters) : e1;
            }
            evaluate(e1, t1, i, n, r, o, a, s) {
                return "constant" === e1.kind ? e1.value : e1.evaluate(t1, i, n, r, o, s, a);
            }
        }
        class Js {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t1, i, n) {
                return !!e1.expression.evaluate(t1, null, {}, i, n);
            }
            interpolate() {
                return !1;
            }
        }
        class Ks {
            constructor(e1){
                this.properties = e1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                const t1 = new ks(0, {});
                for(const i in e1){
                    const n = e1[i], r = n.specification;
                    r && r.overridable && this.overridableProperties.push(i);
                    const o = this.defaultPropertyValues[i] = new Us(n, void 0), a = this.defaultTransitionablePropertyValues[i] = new Gs(n);
                    this.defaultTransitioningPropertyValues[i] = a.untransitioned(), this.defaultPossiblyEvaluatedValues[i] = o.possiblyEvaluate(t1);
                }
            }
        }
        Ha(Ys, "DataDrivenProperty"), Ha(Xs, "DataConstantProperty"), Ha(Js, "ColorRampProperty");
        var Qs = JSON.parse('{"expression":1,"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"appearance":{"condition":{"type":"boolean","expression":{"interpolated":1,"parameters":["distance-from-center","feature","feature-state","measure-light","pitch","zoom"]},"property-type":"data-driven"},"name":{"type":"string"},"properties":{"type":"*"}},"function":{"type":{"type":"enum","default":"exponential","values":{"identity":1,"exponential":1,"interval":1,"categorical":1}},"default":{"type":"*"},"expression":1,"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"colorSpace":{"type":"enum","default":"rgb","values":{"rgb":1,"lab":1,"hcl":1}}},"$version":8,"$root":{"transition":{"type":"transition"},"version":{"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"snow":{"type":"snow"},"rain":{"type":"rain"},"camera":{"type":"camera"},"color-theme":{"type":"colorTheme"},"indoor":{"type":"indoor"},"imports":{"type":"array","value":"import"},"iconsets":{"type":"iconsets"},"schema":{"type":"schema"},"sources":{"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"projection":{"type":"projection"},"layers":{"type":"array","value":"layer"},"models":{"type":"models"},"featuresets":{"type":"featuresets"}},"featuresets":{"*":{"type":"featureset"}},"featureset":{"metadata":{"type":"*"},"selectors":{"type":"array","value":"selector"}},"selector":{"layer":{"type":"string"},"properties":{"type":"selectorProperty"},"featureNamespace":{"type":"string"},"_uniqueFeatureID":{"type":"boolean"}},"selectorProperty":{"*":{"type":"*"}},"model":{"type":"string"},"import":{"id":{"type":"string"},"url":{"type":"string"},"config":{"type":"config"},"data":{"type":"$root"},"color-theme":{"type":"colorTheme","optional":true}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"default":{"type":"*","expression":1},"values":{"type":"array","value":"*"},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}},"id":{"type":"string"},"properties":{"type":"properties"}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1,"use-theme":1},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"cast-shadows":{"type":"boolean","default":false},"shadow-quality":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"parameters":["zoom"]}},"shadow-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"shadow-draw-before-layer":{"type":"string"}},"properties_light_ambient":{"color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1,"use-theme":1},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1,"use-theme":1},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"iconsets":{"*":{"type":"iconset"}},"iconset":["iconset_sprite","iconset_source"],"iconset_sprite":{"type":{"type":"enum","values":{"sprite":1}},"url":{"type":"string"}},"iconset_source":{"type":{"type":"enum","values":{"source":1}},"source":{"type":"string"}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","default":[-180,-85.051129,180,85.051129],"length":4,"value":"number"},"extra_bounds":{"type":"array","value":{"type":"array","length":4,"value":"number"}},"scheme":{"type":"enum","default":"xyz","values":{"xyz":1,"tms":1}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","default":[-180,-85.051129,180,85.051129],"length":4,"value":"number"},"extra_bounds":{"type":"array","value":{"type":"array","length":4,"value":"number"}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","default":"xyz","values":{"xyz":1,"tms":1}},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","default":[-180,-85.051129,180,85.051129],"length":4,"value":"number"},"extra_bounds":{"type":"array","value":{"type":"array","length":4,"value":"number"}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","default":"mapbox","values":{"terrarium":1,"mapbox":1}},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"type":{"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","default":[-180,-85.051129,180,85.051129],"length":4,"value":"number"},"extra_bounds":{"type":"array","value":{"type":"array","length":4,"value":"number"}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"minimum":0,"maximum":512},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"},"dynamic":{"type":"boolean","default":false}},"source_video":{"type":{"type":"enum","values":{"video":1}},"urls":{"type":"array","value":"string"},"coordinates":{"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"type":"enum","values":{"image":1}},"url":{"type":"string"},"coordinates":{"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"modelNodeOverride":{"orientation":{"type":"array","default":[0,0,0],"length":3,"value":"number"}},"modelLightOverrides":{"light-ambient-color":{"type":"color"},"light-ambient-intensity":{"type":"number"},"light-directional-color":{"type":"color"},"light-directional-intensity":{"type":"number"}},"modelNodeOverrides":{"*":{"type":"modelNodeOverride"}},"modelMaterialOverride":{"model-color":{"type":"color"},"model-color-mix-intensity":{"type":"number"},"model-opacity":{"type":"number"},"model-emissive-strength":{"type":"number"}},"modelMaterialOverrides":{"*":{"type":"modelMaterialOverride"}},"modelSourceModel":{"uri":{"type":"string"},"position":{"type":"array","default":[0,0],"minimum":[-180,-90],"maximum":[180,90],"length":2,"value":"number"},"orientation":{"type":"array","default":[0,0,0],"length":3,"value":"number"},"lightOverrides":{"type":"modelLightOverrides"},"nodeOverrides":{"type":"modelNodeOverrides"},"materialOverrides":{"type":"modelMaterialOverrides"},"nodeOverrideNames":{"type":"array","value":"string"},"materialOverrideNames":{"type":"array","value":"string"},"featureProperties":{"type":"*"}},"modelSourceModels":{"*":{"type":"modelSourceModel"}},"source_model":{"type":{"type":"enum","values":{"model":1,"batched-model":1}},"url":{"type":"string"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"},"models":{"type":"modelSourceModels"}},"layer":{"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"building":{},"raster":{},"raster-particle":{},"hillshade":{},"model":{},"background":{},"sky":{},"slot":{},"clip":{}}},"id":{"type":"string"},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"},"appearances":{"type":"array","value":"appearance"}},"layout":["layout_clip","layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_building","layout_symbol","layout_raster","layout_raster-particle","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_sky":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_model":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1},"model-id":{"type":"string","default":"","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"model-allow-density-reduction":{"type":"boolean","default":true}},"layout_clip":{"clip-layer-types":{"type":"array","default":[],"value":"enum","values":{"model":1,"symbol":1},"expression":1},"clip-layer-scope":{"type":"array","default":[],"value":"string","expression":1},"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1},"fill-elevation-reference":{"type":"enum","default":"none","values":{"none":1,"hd-road-base":1,"hd-road-markup":1},"expression":1},"fill-construct-bridge-guard-rail":{"type":"boolean","default":"true","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"circle-elevation-reference":{"type":"enum","default":"none","values":{"none":1,"hd-road-markup":1},"expression":1},"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_heatmap":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_fill-extrusion":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1},"fill-extrusion-edge-radius":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":1},"source-max-zoom":{"type":"number","minimum":0,"maximum":24}},"layout_building":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1},"building-facade":{"type":"boolean","default":false,"expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-facade-floors":{"type":"number","default":3,"minimum":1,"maximum":200,"expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-facade-unit-width":{"type":"number","default":3.1,"minimum":1,"maximum":20,"expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-facade-window":{"type":"array","default":[0.9,0.9],"minimum":0.1,"maximum":1,"length":2,"value":"number","expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-roof-shape":{"type":"enum","default":"flat","values":{"flat":1,"hipped":1,"gabled":1,"parapet":1,"mansard":1,"skillion":1,"pyramidal":1},"expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-height":{"type":"number","default":0,"minimum":0,"expression":1,"transition":1,"property-type":"data-driven"},"building-base":{"type":"number","default":0,"minimum":0,"expression":1,"transition":1,"property-type":"data-driven"},"building-flood-light-wall-radius":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state"]},"transition":1,"property-type":"data-driven"},"building-flood-light-ground-radius":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","feature-state"]},"transition":1,"property-type":"data-driven"},"building-flip-roof-orientation":{"type":"boolean","default":false,"expression":{"interpolated":1,"parameters":["feature","feature-state"]},"transition":1,"property-type":"data-driven"}},"layout_line":{"line-cap":{"type":"enum","default":"butt","values":{"butt":1,"round":1,"square":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"line-join":{"type":"enum","default":"miter","values":{"bevel":1,"round":1,"miter":1,"none":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":1,"parameters":["zoom"]}},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":1,"parameters":["zoom"]}},"line-sort-key":{"type":"number","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"line-z-offset":{"type":"number","default":0,"expression":{"parameters":["feature","line-progress","zoom"]},"property-type":"data-driven"},"line-elevation-reference":{"type":"enum","default":"none","values":{"none":1,"sea":1,"ground":1,"hd-road-markup":1},"expression":1},"line-cross-slope":{"type":"number","expression":1},"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1},"line-width-unit":{"type":"enum","default":"pixels","values":{"pixels":1,"meters":1},"expression":{"parameters":["zoom"]}},"line-elevation-ground-scale":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","line-progress","zoom"]},"transition":1,"property-type":"data-driven"}},"layout_symbol":{"symbol-placement":{"type":"enum","default":"point","values":{"point":1,"line":1,"line-center":1},"expression":{"parameters":["zoom"]}},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":1,"parameters":["zoom"]}},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"symbol-sort-key":{"type":"number","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","default":"auto","values":{"auto":1,"viewport-y":1,"source":1},"expression":{"parameters":["zoom"]}},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"symbol-elevation-reference":{"type":"enum","default":"ground","values":{"sea":1,"ground":1,"hd-road-markup":1},"expression":{"parameters":["zoom"]}},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-rotation-alignment":{"type":"enum","default":"auto","values":{"map":1,"viewport":1,"auto":1},"expression":{"parameters":["zoom"]}},"icon-size":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven","appearance":1},"icon-size-scale-range":{"type":"array","default":[0.8,2],"minimum":[0.1,0.1],"maximum":[10,10],"length":2,"value":"number","expression":1},"icon-text-fit":{"type":"enum","default":"none","values":{"none":1,"width":1,"height":1,"both":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","default":[0,0,0,0],"length":4,"value":"number","expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","expression":{"parameters":["feature","zoom"]},"use-theme":1,"property-type":"data-driven","appearance":1,"tokens":1},"icon-rotate":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven","appearance":1},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]}},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-offset":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven","appearance":1},"icon-anchor":{"type":"enum","default":"center","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","default":"auto","values":{"map":1,"viewport":1,"auto":1},"expression":{"parameters":["zoom"]}},"text-pitch-alignment":{"type":"enum","default":"auto","values":{"map":1,"viewport":1,"auto":1},"expression":{"parameters":["zoom"]}},"text-rotation-alignment":{"type":"enum","default":"auto","values":{"map":1,"viewport":1,"auto":1},"expression":{"parameters":["zoom"]}},"text-field":{"type":"formatted","default":"","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven","tokens":1},"text-font":{"type":"array","default":["Open Sans Regular","Arial Unicode MS Regular"],"value":"string","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven","appearance":1},"text-size-scale-range":{"type":"array","default":[0.8,2],"minimum":[0.1,0.1],"maximum":[10,10],"length":2,"value":"number","expression":1},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-justify":{"type":"enum","default":"center","values":{"auto":1,"left":1,"center":1,"right":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]}},"text-anchor":{"type":"enum","default":"center","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":1,"parameters":["zoom"]}},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]}},"text-rotate":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven","appearance":1},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]}},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"text-transform":{"type":"enum","default":"none","values":{"none":1,"uppercase":1,"lowercase":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-offset":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven","appearance":1},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_raster":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_raster-particle":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_hillshade":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"expression":{"parameters":["distance-from-center","feature","pitch","zoom"]},"property-type":"data-driven"},"filter_fill":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_hillshade":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_raster":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_raster-particle":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_clip":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_model":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_line":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_circle":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_fill-extrusion":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_building":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_heatmap":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function_stop":{"type":"array","minimum":0,"maximum":24,"length":2,"value":["number","color"]},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"high-color":{"type":"color","default":"#245cdf","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"space-color":{"type":"color","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"horizon-blend":{"type":"number","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"star-intensity":{"type":"number","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1}},"snow":{"density":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.85],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"vignette":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.3],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"vignette-color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"center-thinning":{"type":"number","default":0.4,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"direction":{"type":"array","default":[0,50],"minimum":0,"maximum":360,"length":2,"value":"number","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"flake-size":{"type":"number","default":0.71,"minimum":0,"maximum":5,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1}},"rain":{"density":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.5],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"color":{"type":"color","default":["interpolate",["linear"],["measure-light","brightness"],0,"#03113d",0.3,"#a8adbc"],"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"opacity":{"type":"number","default":["interpolate",["linear"],["measure-light","brightness"],0,0.88,1,0.7],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"vignette":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,1],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"vignette-color":{"type":"color","default":["interpolate",["linear"],["measure-light","brightness"],0,"#001736",0.3,"#464646"],"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"center-thinning":{"type":"number","default":0.57,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"direction":{"type":"array","default":[0,80],"minimum":0,"maximum":360,"length":2,"value":"number","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"droplet-size":{"type":"array","default":[2.6,18.2],"minimum":0,"maximum":50,"length":2,"value":"number","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"distortion-strength":{"type":"number","default":0.7,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1}},"camera":{"camera-projection":{"type":"enum","default":"perspective","values":{"perspective":1,"orthographic":1}}},"colorTheme":{"data":{"type":"string","expression":1}},"indoor_source":{"sourceId":{"type":"string"},"sourceLayers":{"type":"array","value":"string"}},"indoor":{"*":{"type":"indoor_source"}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1,"use-theme":1},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"projection":{"name":{"type":"enum","default":"mercator","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1}},"center":{"type":"array","minimum":[-180,-90],"maximum":[180,90],"length":2,"value":"number"},"parallels":{"type":"array","minimum":[-90,-90],"maximum":[90,90],"length":2,"value":"number"}},"terrain":{"source":{"type":"string"},"exaggeration":{"type":"number","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_building","paint_symbol","paint_raster","paint_raster-particle","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"fill-outline-color":{"type":"color","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"fill-translate":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-translate-anchor":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"fill-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]}},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1},"fill-z-offset":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"transition":1,"property-type":"data-driven"},"fill-bridge-guard-rail-color":{"type":"color","default":"rgba(241, 236, 225, 255)","expression":{"interpolated":1,"parameters":["feature","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"fill-tunnel-structure-color":{"type":"color","default":"rgba(241, 236, 225, 255)","expression":{"interpolated":1,"parameters":["feature","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-translate-anchor":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"fill-extrusion-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]}},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"fill-extrusion-height-alignment":{"type":"enum","default":"flat","values":{"terrain":1,"flat":1}},"fill-extrusion-base-alignment":{"type":"enum","default":"terrain","values":{"terrain":1,"flat":1}},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-ambient-occlusion-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-ambient-occlusion-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-ambient-occlusion-wall-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-ambient-occlusion-ground-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-ambient-occlusion-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-flood-light-color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"fill-extrusion-flood-light-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1},"fill-extrusion-flood-light-wall-radius":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state"]},"transition":1,"property-type":"data-driven"},"fill-extrusion-flood-light-ground-radius":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","feature-state"]},"transition":1,"property-type":"data-driven"},"fill-extrusion-flood-light-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-vertical-scale":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-rounded-roof":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":1},"fill-extrusion-front-cutoff":{"type":"array","default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]}},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"fill-extrusion-line-width":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"fill-extrusion-cast-shadows":{"type":"boolean","default":true}},"paint_building":{"building-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"building-ambient-occlusion-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"parameters":[]},"transition":1},"building-ambient-occlusion-ground-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"building-ambient-occlusion-ground-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"building-ambient-occlusion-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"building-vertical-scale":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"building-cast-shadows":{"type":"boolean","default":true},"building-color":{"type":"color","default":"rgba(193, 154, 127, 1)","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light"]},"use-theme":1,"property-type":"data-driven"},"building-emissive-strength":{"type":"number","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light"]},"property-type":"data-driven"},"building-facade-emissive-chance":{"type":"number","default":0.35,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]}},"building-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":1},"building-front-cutoff":{"type":"array","default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]}},"building-flood-light-color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"building-flood-light-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1},"building-flood-light-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"line-translate":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"line-translate-anchor":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"line-width":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","line-progress","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"line-dasharray":{"type":"array","minimum":0,"value":"number","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"line-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]}},"line-gradient":{"type":"color","expression":{"interpolated":1,"parameters":["line-progress"]},"use-theme":1},"line-trim-offset":{"type":"array","default":[0,0],"minimum":[0,0],"maximum":[1,1],"length":2,"value":"number"},"line-trim-fade-range":{"type":"array","default":[0,0],"minimum":[0,0],"maximum":[1,1],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["measure-light","zoom"]}},"line-trim-color":{"type":"color","default":"transparent","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["line-progress","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"line-border-width":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"line-border-color":{"type":"color","default":"rgba(0, 0, 0, 0)","expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"line-border-gradient":{"type":"color","expression":{"interpolated":1,"parameters":["line-progress"]},"use-theme":1},"line-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"line-blend-mode":{"type":"enum","default":"default","values":{"default":1,"multiply":1,"additive":1},"expression":{"parameters":["zoom"]}},"line-blend-additive-clamp":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]}}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"circle-translate":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"circle-translate-anchor":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"circle-pitch-scale":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"circle-pitch-alignment":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"expression":{"interpolated":1,"parameters":["heatmap-density"]},"use-theme":1},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"icon-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"icon-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven","appearance":1},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven","appearance":1},"icon-halo-width":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"icon-translate":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1,"appearance":1},"icon-translate-anchor":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"icon-image-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]}},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"text-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"text-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven","appearance":1,"overridable":1},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven","appearance":1},"text-halo-width":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"text-halo-blur":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"text-translate":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1,"appearance":1},"text-translate-anchor":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"icon-color-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":1},"icon-color-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":1},"icon-color-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":1},"icon-color-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":1},"symbol-z-offset":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"transition":1,"property-type":"data-driven","appearance":1}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-color":{"type":"color","expression":{"interpolated":1,"parameters":["raster-value"]},"use-theme":1},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-color-range":{"type":"array","length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-hue-rotate":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-resampling":{"type":"enum","default":"linear","values":{"linear":1,"nearest":1},"expression":{"parameters":["zoom"]}},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]}},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1},"raster-array-band":{"type":"string"},"raster-elevation":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-elevation-reference":{"type":"enum","default":"sea","values":{"sea":1,"ground":1},"expression":1}},"paint_raster-particle":{"raster-particle-array-band":{"type":"string"},"raster-particle-count":{"type":"number","default":512,"minimum":1},"raster-particle-color":{"type":"color","expression":{"interpolated":1,"parameters":["raster-particle-speed"]},"use-theme":1},"raster-particle-max-speed":{"type":"number","default":1,"minimum":1},"raster-particle-speed-factor":{"type":"number","default":0.2,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-particle-fade-opacity-factor":{"type":"number","default":0.98,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-particle-reset-rate-factor":{"type":"number","default":0.8,"minimum":0,"maximum":1},"raster-particle-elevation":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":1,"parameters":["zoom"]}},"hillshade-illumination-anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"hillshade-shadow-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"hillshade-accent-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1}},"paint_background":{"background-pitch-alignment":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":[]}},"background-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]}},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1}},"paint_sky":{"sky-type":{"type":"enum","default":"atmosphere","values":{"gradient":1,"atmosphere":1},"expression":{"parameters":["zoom"]}},"sky-atmosphere-sun":{"type":"array","minimum":[0,0],"maximum":[360,180],"length":2,"value":"number","expression":{"parameters":["zoom"]}},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100},"sky-gradient-center":{"type":"array","default":[0,0],"minimum":[0,0],"maximum":[360,180],"length":2,"value":"number","expression":{"parameters":["zoom"]}},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]}},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"expression":{"interpolated":1,"parameters":["sky-radial-progress"]},"use-theme":1},"sky-atmosphere-halo-color":{"type":"color","default":"white","use-theme":1},"sky-atmosphere-color":{"type":"color","default":"white","use-theme":1},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"model-rotation":{"type":"array","default":[0,0,0],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"model-scale":{"type":"array","default":[1,1,1],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"model-translation":{"type":"array","default":[0,0,0],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"model-color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"model-color-mix-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light"]},"transition":1,"property-type":"data-driven"},"model-type":{"type":"enum","default":"common-3d","values":{"common-3d":1,"location-indicator":1}},"model-cast-shadows":{"type":"boolean","default":true},"model-receive-shadows":{"type":"boolean","default":true},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"model-emissive-strength":{"type":"number","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light"]},"transition":1,"property-type":"data-driven"},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state"]},"transition":1,"property-type":"data-driven"},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light"]},"transition":1,"property-type":"data-driven"},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":1},"model-front-cutoff":{"type":"array","default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]}},"model-elevation-reference":{"type":"enum","default":"ground","values":{"sea":1,"ground":1,"hd-road-markup":1},"expression":1},"model-line-cutout-mode":{"type":"enum","default":"enabled","values":{"enabled":1,"disabled":1,"enabled-above-cutout":1},"expression":1}},"promoteId":{"*":{"type":"*"}}}');
        function el(e1) {
            return e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean ? e1.valueOf() : e1;
        }
        function tl(e1) {
            if (Array.isArray(e1)) return e1.map(tl);
            if (e1 instanceof Object && !(e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean)) {
                const t1 = {}, i = e1;
                for(const e1 in i)t1[e1] = tl(i[e1]);
                return t1;
            }
            return el(e1);
        }
        function il(e1) {
            if (!0 === e1 || !1 === e1) return !0;
            if (!Array.isArray(e1) || 0 === e1.length) return !1;
            switch(e1[0]){
                case "has":
                    return e1.length >= 2 && "$id" !== e1[1] && "$type" !== e1[1];
                case "in":
                    return e1.length >= 3 && ("string" != typeof e1[1] || Array.isArray(e1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== e1.length || Array.isArray(e1[1]) || Array.isArray(e1[2]);
                case "any":
                case "all":
                    for (const t1 of e1.slice(1))if (!il(t1) && "boolean" != typeof t1) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        function nl(e1, t1 = "", i = null, n = "fill") {
            if (null == e1) return {
                filter: ()=>!0,
                needGeometry: !1,
                needFeature: !1
            };
            il(e1) || (e1 = cl(e1));
            const r = e1;
            let o = !0;
            try {
                o = function(e1) {
                    if (!al(e1)) return e1;
                    let t1 = tl(e1);
                    return ol(t1), t1 = rl(t1), t1;
                }(r);
            } catch (e1) {
                console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(r, null, 2)}\n        `);
            }
            let a = null, s = null;
            if ("background" !== n && "sky" !== n && "slot" !== n) {
                s = Qs[`filter_${n}`];
                const e1 = La(o, s, t1, i);
                if ("error" === e1.result) throw new Error(e1.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                a = (t1, i, n)=>e1.value.evaluate(t1, i, {}, n);
            }
            let l = null, u = null;
            if (o !== r) {
                const e1 = La(r, s, t1, i);
                if ("error" === e1.result) throw new Error(e1.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                l = (t1, i, n, r, o)=>e1.value.evaluate(t1, i, {}, n, void 0, void 0, r, o), u = !lo(e1.value.expression);
            }
            return {
                filter: a,
                dynamicFilter: l || void 0,
                needGeometry: ul(o),
                needFeature: !!u
            };
        }
        function rl(e1) {
            if (!Array.isArray(e1)) return e1;
            const t1 = function(e1) {
                if (sl.has(e1[0])) {
                    for(let t1 = 1; t1 < e1.length; t1++)if (al(e1[t1])) return !0;
                }
                return e1;
            }(e1);
            return !0 === t1 ? t1 : t1.map((e1)=>rl(e1));
        }
        function ol(e1) {
            let t1 = !1;
            const i = [];
            if ("case" === e1[0]) {
                for(let n = 1; n < e1.length - 1; n += 2)t1 = t1 || al(e1[n]), i.push(e1[n + 1]);
                i.push(e1.at(-1));
            } else if ("match" === e1[0]) {
                t1 = t1 || al(e1[1]);
                for(let t1 = 2; t1 < e1.length - 1; t1 += 2)i.push(e1[t1 + 1]);
                i.push(e1.at(-1));
            } else if ("step" === e1[0]) {
                t1 = t1 || al(e1[1]);
                for(let t1 = 1; t1 < e1.length - 1; t1 += 2)i.push(e1[t1 + 1]);
            }
            t1 && (e1.length = 0, e1.push("any", ...i));
            for(let t1 = 1; t1 < e1.length; t1++)ol(e1[t1]);
        }
        function al(e1) {
            if (!Array.isArray(e1)) return !1;
            if ("pitch" === (t1 = e1[0]) || "distance-from-center" === t1) return !0;
            var t1;
            for(let t1 = 1; t1 < e1.length; t1++)if (al(e1[t1])) return !0;
            return !1;
        }
        const sl = new Set([
            "in",
            "==",
            "!=",
            ">",
            ">=",
            "<",
            "<=",
            "to-boolean"
        ]);
        function ll(e1, t1) {
            return e1 < t1 ? -1 : e1 > t1 ? 1 : 0;
        }
        function ul(e1) {
            if (!Array.isArray(e1)) return !1;
            if ("within" === e1[0] || "distance" === e1[0]) return !0;
            for(let t1 = 1; t1 < e1.length; t1++)if (ul(e1[t1])) return !0;
            return !1;
        }
        function cl(e1) {
            if (!e1) return !0;
            const t1 = e1[0];
            var i;
            return e1.length <= 1 ? "any" !== t1 : "==" === t1 ? hl(e1[1], e1[2], "==") : "!=" === t1 ? pl(hl(e1[1], e1[2], "==")) : "<" === t1 || ">" === t1 || "<=" === t1 || ">=" === t1 ? hl(e1[1], e1[2], t1) : "any" === t1 ? (i = e1.slice(1), [
                "any"
            ].concat(i.map(cl))) : "all" === t1 ? [
                "all"
            ].concat(e1.slice(1).map(cl)) : "none" === t1 ? [
                "all"
            ].concat(e1.slice(1).map(cl).map(pl)) : "in" === t1 ? dl(e1[1], e1.slice(2)) : "!in" === t1 ? pl(dl(e1[1], e1.slice(2))) : "has" === t1 ? fl(e1[1]) : "!has" !== t1 || pl(fl(e1[1]));
        }
        function hl(e1, t1, i) {
            switch(e1){
                case "$type":
                    return [
                        `filter-type-${i}`,
                        t1
                    ];
                case "$id":
                    return [
                        `filter-id-${i}`,
                        t1
                    ];
                default:
                    return [
                        `filter-${i}`,
                        e1,
                        t1
                    ];
            }
        }
        function dl(e1, t1) {
            if (0 === t1.length) return !1;
            switch(e1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            t1
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            t1
                        ]
                    ];
                default:
                    return t1.length > 200 && !t1.some((e1)=>typeof e1 != typeof t1[0]) ? [
                        "filter-in-large",
                        e1,
                        [
                            "literal",
                            t1.sort(ll)
                        ]
                    ] : [
                        "filter-in-small",
                        e1,
                        [
                            "literal",
                            t1
                        ]
                    ];
            }
        }
        function fl(e1) {
            switch(e1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        e1
                    ];
            }
        }
        function pl(e1) {
            return [
                "!",
                e1
            ];
        }
        const _l = "";
        function ml(e1, t1) {
            return t1 ? `${e1}${_l}${t1}` : e1;
        }
        function gl(e1) {
            const t1 = e1.indexOf(_l);
            return t1 >= 0 ? e1.slice(t1 + 1) : "";
        }
        let yl;
        const xl = ()=>yl || (yl = new Ks({
                "icon-size": new Ys(Qs.layout_symbol["icon-size"]),
                "icon-image": new Ys(Qs.layout_symbol["icon-image"]),
                "icon-rotate": new Ys(Qs.layout_symbol["icon-rotate"]),
                "icon-offset": new Ys(Qs.layout_symbol["icon-offset"]),
                "text-size": new Ys(Qs.layout_symbol["text-size"]),
                "text-rotate": new Ys(Qs.layout_symbol["text-rotate"]),
                "text-offset": new Ys(Qs.layout_symbol["text-offset"])
            }));
        let vl;
        const bl = ()=>vl || (vl = new Ks({
                "icon-opacity": new Ys(Qs.paint_symbol["icon-opacity"]),
                "icon-occlusion-opacity": new Ys(Qs.paint_symbol["icon-occlusion-opacity"]),
                "icon-emissive-strength": new Ys(Qs.paint_symbol["icon-emissive-strength"]),
                "text-emissive-strength": new Ys(Qs.paint_symbol["text-emissive-strength"]),
                "icon-color": new Ys(Qs.paint_symbol["icon-color"]),
                "icon-halo-color": new Ys(Qs.paint_symbol["icon-halo-color"]),
                "icon-halo-width": new Ys(Qs.paint_symbol["icon-halo-width"]),
                "icon-halo-blur": new Ys(Qs.paint_symbol["icon-halo-blur"]),
                "icon-translate": new Ys(Qs.paint_symbol["icon-translate"]),
                "text-opacity": new Ys(Qs.paint_symbol["text-opacity"]),
                "text-occlusion-opacity": new Ys(Qs.paint_symbol["text-occlusion-opacity"]),
                "text-color": new Ys(Qs.paint_symbol["text-color"], {
                    runtimeType: Tn,
                    getOverride: (e1)=>e1.textColor,
                    hasOverride: (e1)=>!!e1.textColor
                }),
                "text-halo-color": new Ys(Qs.paint_symbol["text-halo-color"]),
                "text-halo-width": new Ys(Qs.paint_symbol["text-halo-width"]),
                "text-halo-blur": new Ys(Qs.paint_symbol["text-halo-blur"]),
                "text-translate": new Ys(Qs.paint_symbol["text-translate"]),
                "symbol-z-offset": new Ys(Qs.paint_symbol["symbol-z-offset"]),
                "icon-color-use-theme": new Ys({
                    type: "string",
                    default: "default",
                    "property-type": "data-driven"
                }),
                "icon-halo-color-use-theme": new Ys({
                    type: "string",
                    default: "default",
                    "property-type": "data-driven"
                }),
                "text-color-use-theme": new Ys({
                    type: "string",
                    default: "default",
                    "property-type": "data-driven"
                }),
                "text-halo-color-use-theme": new Ys({
                    type: "string",
                    default: "default",
                    "property-type": "data-driven"
                })
            }));
        class wl {
            constructor(e1, t1, i, n, r, o){
                this._conditionSpec = e1, this._propertiesSpec = i;
                const a = La(e1, Qs.appearance.condition);
                if ("success" === a.result && (this.condition = a.value), this.name = t1, i) {
                    this.layoutProperties = new qs(xl()), this.unevaluatedLayout = new Zs(xl(), n, r, o), this.paintProperties = new qs(bl()), this.unevaluatedPaint = new Zs(bl(), n, r, "");
                    for(const e1 in i)e1 in this.unevaluatedLayout._values ? this.unevaluatedLayout.setValue(e1, i[e1]) : e1 in this.unevaluatedPaint._values && this.unevaluatedPaint.setValue(e1, i[e1]);
                }
            }
            isActive(e1) {
                return !(this.condition || !e1.isHidden || "hidden" !== this.name) || this.condition.evaluate(e1.globals, e1.feature, e1.featureState, e1.canonical);
            }
            getCondition() {
                return this.condition;
            }
            getName() {
                return this.name;
            }
            getLayoutProperty(e1) {
                return this.layoutProperties.get(e1);
            }
            getPaintProperty(e1) {
                return this.paintProperties.get(e1);
            }
            getUnevaluatedLayoutProperties() {
                return this.unevaluatedLayout;
            }
            getUnevaluatedLayoutProperty(e1) {
                return this.unevaluatedLayout._values[e1];
            }
            getUnevaluatedPaintProperty(e1) {
                return this.unevaluatedPaint._values[e1];
            }
            recalculate(e1, t1, i) {
                this.unevaluatedLayout && (this.layoutProperties = this.unevaluatedLayout.possiblyEvaluate(e1, void 0, t1, i)), this.unevaluatedPaint && (this.paintProperties = this.unevaluatedPaint.possiblyEvaluate(e1, void 0, t1, ""));
            }
            serialize() {
                const e1 = {};
                e1.condition = this.condition.expression.serialize(), this.name && (e1.name = this.name);
                const t1 = {
                    ...this.unevaluatedLayout ? this.unevaluatedLayout.serialize() : {},
                    ...this.unevaluatedPaint ? this.unevaluatedPaint.serialize() : {}
                };
                return Object.keys(t1).length > 0 && (e1.properties = t1), e1;
            }
            hasIconLayoutProperties() {
                const e1 = this.hasLayoutProperty("icon-image"), t1 = this.hasLayoutProperty("icon-size"), i = this.hasLayoutProperty("icon-offset"), n = this.hasLayoutProperty("icon-rotate");
                return e1 || t1 || i || n;
            }
            hasTextLayoutProperties() {
                const e1 = this.hasLayoutProperty("text-size"), t1 = this.hasLayoutProperty("text-offset"), i = this.hasLayoutProperty("text-rotate");
                return e1 || t1 || i;
            }
            hasIconPaintProperties() {
                return !!this.unevaluatedPaint && Object.keys(this.unevaluatedPaint._values).filter((e1)=>!e1.endsWith("-use-theme")).some((e1)=>(e1.startsWith("icon-") || "symbol-z-offset" === e1) && this.hasPaintProperty(e1));
            }
            hasTextPaintProperties() {
                return !!this.unevaluatedPaint && Object.keys(this.unevaluatedPaint._values).filter((e1)=>!e1.endsWith("-use-theme")).some((e1)=>(e1.startsWith("text-") || "symbol-z-offset" === e1) && this.hasPaintProperty(e1));
            }
            hasLayoutProperty(e1) {
                return this.unevaluatedLayout && void 0 !== this.unevaluatedLayout._values[e1].value;
            }
            hasPaintProperty(e1) {
                return this.unevaluatedPaint && void 0 !== this.unevaluatedPaint._values[e1].value;
            }
        }
        const El = "-transition", Al = new Set([
            "fill",
            "line",
            "background",
            "hillshade",
            "raster"
        ]);
        class Il extends sn {
            constructor(e1, t1, i, n, r, o){
                if (super(), this.id = e1.id, this.fqid = ml(this.id, i), this.type = e1.type, this.scope = i, this.lut = n, this.options = r, this.iconImageUseTheme = o, this.appearances = new Array, this.appearancesVersion = 0, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    needFeature: !1
                }, this._filterCompiled = !1, "custom" !== e1.type && (this.metadata = e1.metadata, this.minzoom = e1.minzoom, this.maxzoom = e1.maxzoom, e1.type && "background" !== e1.type && "sky" !== e1.type && "slot" !== e1.type && (this.source = e1.source, this.sourceLayer = e1["source-layer"], this.filter = e1.filter), e1.slot && (this.slot = e1.slot), e1.appearances && this.setAppearances(e1.appearances), t1.layout && (this._unevaluatedLayout = new Zs(t1.layout, this.scope, r, this.iconImageUseTheme)), t1.paint)) {
                    this._transitionablePaint = new js(t1.paint, this.scope, r);
                    for(const t1 in e1.paint)this.setPaintProperty(t1, e1.paint[t1]);
                    for(const t1 in e1.layout)this.setLayoutProperty(t1, e1.layout[t1]);
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new qs(t1.paint);
                }
            }
            onAdd(e1) {}
            onRemove(e1) {}
            isDraped(e1) {
                return !this.is3D(!0) && Al.has(this.type);
            }
            getLayoutProperty(e1) {
                return "visibility" === e1 ? this.visibility : this._unevaluatedLayout.getValue(e1);
            }
            setLayoutProperty(e1, t1) {
                if ("custom" === this.type && "visibility" === e1) return void (this.visibility = t1);
                const i = this._unevaluatedLayout;
                i._properties.properties[e1] && (i.setValue(e1, t1), "visibility" === e1 && this.possiblyEvaluateVisibility());
            }
            setAppearances(e1) {
                this.appearances = [], e1.forEach((e1)=>{
                    this.appearances.push(new wl(e1.condition, e1.name, e1.properties, this.scope, this.options, this.iconImageUseTheme));
                }), this.appearancesVersion++;
            }
            possiblyEvaluateVisibility() {
                this._unevaluatedLayout._values.visibility && (this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({
                    zoom: 0
                }));
            }
            getPaintProperty(e1) {
                return e1.endsWith(El) ? this._transitionablePaint.getTransition(e1.slice(0, -11)) : this._transitionablePaint.getValue(e1);
            }
            isPaintProperty(e1) {
                return !!this._transitionablePaint._properties.properties[e1];
            }
            setPaintProperty(e1, t1) {
                const i = this._transitionablePaint, n = i._properties.properties;
                if (e1.endsWith(El)) {
                    const r = e1.slice(0, -11);
                    return n[r] && i.setTransition(r, t1 || void 0), !1;
                }
                if (!n[e1]) return !1;
                const r = i._values[e1], o = r.value.isDataDriven(), a = r.value;
                i.setValue(e1, t1), this._handleSpecialPaintPropertyUpdate(e1);
                const s = i._values[e1].value, l = s.isDataDriven(), u = e1.endsWith("pattern") || "line-dasharray" === e1;
                return l || o || u || this._handleOverridablePaintPropertyUpdate(e1, a, s);
            }
            _handleSpecialPaintPropertyUpdate(e1) {}
            getProgramIds() {
                return null;
            }
            getDefaultProgramParams(e1, t1, i) {
                return null;
            }
            _handleOverridablePaintPropertyUpdate(e1, t1, i) {
                return !1;
            }
            isHidden(e1) {
                return !!(this.minzoom && e1 < this.minzoom) || !!(this.maxzoom && e1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(e1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(e1, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(e1, t1) {
                this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(e1, void 0, t1, this.iconImageUseTheme)), this.paint = this._transitioningPaint.possiblyEvaluate(e1, void 0, t1);
            }
            serialize() {
                const e1 = {
                    id: this.id,
                    type: this.type,
                    slot: this.slot,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return 0 !== this.appearances.length && (e1.appearances = this.appearances.map((e1)=>e1.serialize())), dt(e1, (e1, t1)=>!(void 0 === e1 || "layout" === t1 && !Object.keys(e1).length || "paint" === t1 && !Object.keys(e1).length));
            }
            is3D(e1) {
                return !1;
            }
            hasElevation() {
                return !1;
            }
            mayUse(e1) {
                return !1;
            }
            prepare() {
                return Promise.resolve();
            }
            isSky() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            hasShadowPass() {
                return !1;
            }
            canCastShadows() {
                return !1;
            }
            hasLightBeamPass() {
                return !1;
            }
            cutoffRange() {
                return 0;
            }
            tileCoverLift() {
                return 0;
            }
            resize() {}
            _clear() {}
            isStateDependent() {
                for(const e1 in this.paint._values){
                    const t1 = this.paint.get(e1);
                    if (t1 instanceof Ws && wa(t1.property.specification) && ("source" === t1.value.kind || "composite" === t1.value.kind) && t1.value.isStateDependent) return !0;
                }
                for (const e1 of this.appearances)if (!uo(e1.condition.expression)) return !0;
                return !1;
            }
            compileFilter(e1) {
                this._filterCompiled || (this._featureFilter = nl(this.filter, this.scope, e1), this._filterCompiled = !0);
            }
            invalidateCompiledFilter() {
                this._filterCompiled = !1;
            }
            dynamicFilter() {
                return this._featureFilter.dynamicFilter;
            }
            dynamicFilterNeedsFeature() {
                return this._featureFilter.needFeature;
            }
            dynamicFilterNeedsGeometry() {
                return this._featureFilter.needGeometry;
            }
            getLayerRenderingStats() {
                return this._stats;
            }
            resetLayerRenderingStats(e1) {
                this._stats && ("shadow" === e1.renderPass ? this._stats.numRenderedVerticesInShadowPass = 0 : this._stats.numRenderedVerticesInTransparentPass = 0);
            }
            getAppearances() {
                return this.appearances;
            }
            queryRenderedFeatures(e1, t1, i) {
                return {};
            }
            queryRadius(e1) {}
            queryIntersectsFeature(e1, t1, i, n, r, o, a, s, l, u) {}
        }
        function Tl(e1, t1, i) {
            if (!e1._unevaluatedLayout) return !1;
            const n = e1._unevaluatedLayout.getValue(t1);
            return void 0 !== n && ("string" != typeof n || i(n));
        }
        function Ml(e1, t1, i = 2) {
            const n = t1 && t1.length, r = n ? t1[0] * i : e1.length;
            let o = Sl(e1, 0, r, i, !0);
            const a = [];
            if (!o || o.next === o.prev) return a;
            let s, l, u;
            if (n && (o = function(e1, t1, i, n) {
                const r = [];
                for(let i = 0, o = t1.length; i < o; i++){
                    const a = Sl(e1, t1[i] * n, i < o - 1 ? t1[i + 1] * n : e1.length, n, !1);
                    a === a.next && (a.steiner = !0), r.push(Vl(a));
                }
                r.sort(Ol);
                for(let e1 = 0; e1 < r.length; e1++)i = Ll(r[e1], i);
                return i;
            }(e1, t1, o, i)), e1.length > 80 * i) {
                s = e1[0], l = e1[1];
                let t1 = s, n = l;
                for(let o = i; o < r; o += i){
                    const i = e1[o], r = e1[o + 1];
                    i < s && (s = i), r < l && (l = r), i > t1 && (t1 = i), r > n && (n = r);
                }
                u = Math.max(t1 - s, n - l), u = 0 !== u ? 32767 / u : 0;
            }
            return Rl(o, a, i, s, l, u, 0), a;
        }
        function Sl(e1, t1, i, n, r) {
            let o;
            if (r === function(e1, t1, i, n) {
                let r = 0;
                for(let o = t1, a = i - n; o < i; o += n)r += (e1[a] - e1[o]) * (e1[o + 1] + e1[a + 1]), a = o;
                return r;
            }(e1, t1, i, n) > 0) for(let r = t1; r < i; r += n)o = Yl(r / n | 0, e1[r], e1[r + 1], o);
            else for(let r = i - n; r >= t1; r -= n)o = Yl(r / n | 0, e1[r], e1[r + 1], o);
            return o && Hl(o, o.next) && (Jl(o), o = o.next), o;
        }
        function zl(e1, t1) {
            if (!e1) return e1;
            t1 || (t1 = e1);
            let i, n = e1;
            do if (i = !1, n.steiner || !Hl(n, n.next) && 0 !== jl(n.prev, n, n.next)) n = n.next;
            else {
                if (Jl(n), n = t1 = n.prev, n === n.next) break;
                i = !0;
            }
            while (i || n !== t1);
            return t1;
        }
        function Rl(e1, t1, i, n, r, o, a) {
            if (!e1) return;
            !a && o && function(e1, t1, i, n) {
                let r = e1;
                do 0 === r.z && (r.z = Nl(r.x, r.y, t1, i, n)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
                while (r !== e1);
                r.prevZ.nextZ = null, r.prevZ = null, function(e1) {
                    let t1, i = 1;
                    do {
                        let n, r = e1;
                        e1 = null;
                        let o = null;
                        for(t1 = 0; r;){
                            t1++;
                            let a = r, s = 0;
                            for(let e1 = 0; e1 < i && (s++, a = a.nextZ, a); e1++);
                            let l = i;
                            for(; s > 0 || l > 0 && a;)0 !== s && (0 === l || !a || r.z <= a.z) ? (n = r, r = r.nextZ, s--) : (n = a, a = a.nextZ, l--), o ? o.nextZ = n : e1 = n, n.prevZ = o, o = n;
                            r = a;
                        }
                        o.nextZ = null, i *= 2;
                    }while (t1 > 1);
                }(r);
            }(e1, n, r, o);
            let s = e1;
            for(; e1.prev !== e1.next;){
                const l = e1.prev, u = e1.next;
                if (o ? Dl(e1, n, r, o) : Pl(e1)) t1.push(l.i, e1.i, u.i), Jl(e1), e1 = u.next, s = u.next;
                else if ((e1 = u) === s) {
                    a ? 1 === a ? Rl(e1 = Cl(zl(e1), t1), t1, i, n, r, o, 2) : 2 === a && Fl(e1, t1, i, n, r, o) : Rl(zl(e1), t1, i, n, r, o, 1);
                    break;
                }
            }
        }
        function Pl(e1) {
            const t1 = e1.prev, i = e1, n = e1.next;
            if (jl(t1, i, n) >= 0) return !1;
            const r = t1.x, o = i.x, a = n.x, s = t1.y, l = i.y, u = n.y, c = Math.min(r, o, a), h = Math.min(s, l, u), d = Math.max(r, o, a), f = Math.max(s, l, u);
            let p = n.next;
            for(; p !== t1;){
                if (p.x >= c && p.x <= d && p.y >= h && p.y <= f && Ul(r, s, o, l, a, u, p.x, p.y) && jl(p.prev, p, p.next) >= 0) return !1;
                p = p.next;
            }
            return !0;
        }
        function Dl(e1, t1, i, n) {
            const r = e1.prev, o = e1, a = e1.next;
            if (jl(r, o, a) >= 0) return !1;
            const s = r.x, l = o.x, u = a.x, c = r.y, h = o.y, d = a.y, f = Math.min(s, l, u), p = Math.min(c, h, d), _ = Math.max(s, l, u), m = Math.max(c, h, d), g = Nl(f, p, t1, i, n), y = Nl(_, m, t1, i, n);
            let x = e1.prevZ, v = e1.nextZ;
            for(; x && x.z >= g && v && v.z <= y;){
                if (x.x >= f && x.x <= _ && x.y >= p && x.y <= m && x !== r && x !== a && Ul(s, c, l, h, u, d, x.x, x.y) && jl(x.prev, x, x.next) >= 0) return !1;
                if (x = x.prevZ, v.x >= f && v.x <= _ && v.y >= p && v.y <= m && v !== r && v !== a && Ul(s, c, l, h, u, d, v.x, v.y) && jl(v.prev, v, v.next) >= 0) return !1;
                v = v.nextZ;
            }
            for(; x && x.z >= g;){
                if (x.x >= f && x.x <= _ && x.y >= p && x.y <= m && x !== r && x !== a && Ul(s, c, l, h, u, d, x.x, x.y) && jl(x.prev, x, x.next) >= 0) return !1;
                x = x.prevZ;
            }
            for(; v && v.z <= y;){
                if (v.x >= f && v.x <= _ && v.y >= p && v.y <= m && v !== r && v !== a && Ul(s, c, l, h, u, d, v.x, v.y) && jl(v.prev, v, v.next) >= 0) return !1;
                v = v.nextZ;
            }
            return !0;
        }
        function Cl(e1, t1) {
            let i = e1;
            do {
                const n = i.prev, r = i.next.next;
                !Hl(n, r) && $l(n, i, i.next, r) && ql(n, r) && ql(r, n) && (t1.push(n.i, i.i, r.i), Jl(i), Jl(i.next), i = e1 = r), i = i.next;
            }while (i !== e1);
            return zl(i);
        }
        function Fl(e1, t1, i, n, r, o) {
            let a = e1;
            do {
                let e1 = a.next.next;
                for(; e1 !== a.prev;){
                    if (a.i !== e1.i && Gl(a, e1)) {
                        let s = Xl(a, e1);
                        return a = zl(a, a.next), s = zl(s, s.next), Rl(a, t1, i, n, r, o, 0), void Rl(s, t1, i, n, r, o, 0);
                    }
                    e1 = e1.next;
                }
                a = a.next;
            }while (a !== e1);
        }
        function Ol(e1, t1) {
            let i = e1.x - t1.x;
            return 0 === i && (i = e1.y - t1.y, 0 === i) && (i = (e1.next.y - e1.y) / (e1.next.x - e1.x) - (t1.next.y - t1.y) / (t1.next.x - t1.x)), i;
        }
        function Ll(e1, t1) {
            const i = function(e1, t1) {
                let i = t1;
                const n = e1.x, r = e1.y;
                let o, a = -1 / 0;
                if (Hl(e1, i)) return i;
                do {
                    if (Hl(e1, i.next)) return i.next;
                    if (r <= i.y && r >= i.next.y && i.next.y !== i.y) {
                        const e1 = i.x + (r - i.y) * (i.next.x - i.x) / (i.next.y - i.y);
                        if (e1 <= n && e1 > a && (a = e1, o = i.x < i.next.x ? i : i.next, e1 === n)) return o;
                    }
                    i = i.next;
                }while (i !== t1);
                if (!o) return null;
                const s = o, l = o.x, u = o.y;
                let c = 1 / 0;
                i = o;
                do {
                    if (n >= i.x && i.x >= l && n !== i.x && kl(r < u ? n : a, r, l, u, r < u ? a : n, r, i.x, i.y)) {
                        const t1 = Math.abs(r - i.y) / (n - i.x);
                        ql(i, e1) && (t1 < c || t1 === c && (i.x > o.x || i.x === o.x && Bl(o, i))) && (o = i, c = t1);
                    }
                    i = i.next;
                }while (i !== s);
                return o;
            }(e1, t1);
            if (!i) return t1;
            const n = Xl(i, e1);
            return zl(n, n.next), zl(i, i.next);
        }
        function Bl(e1, t1) {
            return jl(e1.prev, e1, t1.prev) < 0 && jl(t1.next, e1, e1.next) < 0;
        }
        function Nl(e1, t1, i, n, r) {
            return (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - i) * r | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) | (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - n) * r | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) << 1;
        }
        function Vl(e1) {
            let t1 = e1, i = e1;
            do (t1.x < i.x || t1.x === i.x && t1.y < i.y) && (i = t1), t1 = t1.next;
            while (t1 !== e1);
            return i;
        }
        function kl(e1, t1, i, n, r, o, a, s) {
            return (r - a) * (t1 - s) >= (e1 - a) * (o - s) && (e1 - a) * (n - s) >= (i - a) * (t1 - s) && (i - a) * (o - s) >= (r - a) * (n - s);
        }
        function Ul(e1, t1, i, n, r, o, a, s) {
            return !(e1 === a && t1 === s) && kl(e1, t1, i, n, r, o, a, s);
        }
        function Gl(e1, t1) {
            return e1.next.i !== t1.i && e1.prev.i !== t1.i && !function(e1, t1) {
                let i = e1;
                do {
                    if (i.i !== e1.i && i.next.i !== e1.i && i.i !== t1.i && i.next.i !== t1.i && $l(i, i.next, e1, t1)) return !0;
                    i = i.next;
                }while (i !== e1);
                return !1;
            }(e1, t1) && (ql(e1, t1) && ql(t1, e1) && function(e1, t1) {
                let i = e1, n = !1;
                const r = (e1.x + t1.x) / 2, o = (e1.y + t1.y) / 2;
                do i.y > o != i.next.y > o && i.next.y !== i.y && r < (i.next.x - i.x) * (o - i.y) / (i.next.y - i.y) + i.x && (n = !n), i = i.next;
                while (i !== e1);
                return n;
            }(e1, t1) && (jl(e1.prev, e1, t1.prev) || jl(e1, t1.prev, t1)) || Hl(e1, t1) && jl(e1.prev, e1, e1.next) > 0 && jl(t1.prev, t1, t1.next) > 0);
        }
        function jl(e1, t1, i) {
            return (t1.y - e1.y) * (i.x - t1.x) - (t1.x - e1.x) * (i.y - t1.y);
        }
        function Hl(e1, t1) {
            return e1.x === t1.x && e1.y === t1.y;
        }
        function $l(e1, t1, i, n) {
            const r = Wl(jl(e1, t1, i)), o = Wl(jl(e1, t1, n)), a = Wl(jl(i, n, e1)), s = Wl(jl(i, n, t1));
            return r !== o && a !== s || !(0 !== r || !Zl(e1, i, t1)) || !(0 !== o || !Zl(e1, n, t1)) || !(0 !== a || !Zl(i, e1, n)) || !(0 !== s || !Zl(i, t1, n));
        }
        function Zl(e1, t1, i) {
            return t1.x <= Math.max(e1.x, i.x) && t1.x >= Math.min(e1.x, i.x) && t1.y <= Math.max(e1.y, i.y) && t1.y >= Math.min(e1.y, i.y);
        }
        function Wl(e1) {
            return e1 > 0 ? 1 : e1 < 0 ? -1 : 0;
        }
        function ql(e1, t1) {
            return jl(e1.prev, e1, e1.next) < 0 ? jl(e1, t1, e1.next) >= 0 && jl(e1, e1.prev, t1) >= 0 : jl(e1, t1, e1.prev) < 0 || jl(e1, e1.next, t1) < 0;
        }
        function Xl(e1, t1) {
            const i = Kl(e1.i, e1.x, e1.y), n = Kl(t1.i, t1.x, t1.y), r = e1.next, o = t1.prev;
            return e1.next = t1, t1.prev = e1, i.next = r, r.prev = i, n.next = i, i.prev = n, o.next = n, n.prev = o, n;
        }
        function Yl(e1, t1, i, n) {
            const r = Kl(e1, t1, i);
            return n ? (r.next = n.next, r.prev = n, n.next.prev = r, n.next = r) : (r.prev = r, r.next = r), r;
        }
        function Jl(e1) {
            e1.next.prev = e1.prev, e1.prev.next = e1.next, e1.prevZ && (e1.prevZ.nextZ = e1.nextZ), e1.nextZ && (e1.nextZ.prevZ = e1.prevZ);
        }
        function Kl(e1, t1, i) {
            return {
                i: e1,
                x: t1,
                y: i,
                prev: null,
                next: null,
                z: 0,
                prevZ: null,
                nextZ: null,
                steiner: !1
            };
        }
        function Ql(e1, t1, i = 1) {
            if (!e1) return null;
            const n = "string" == typeof e1 ? Gn.from(e1).getPrimary() : e1.getPrimary(), r = "string" == typeof e1 ? null : e1.getSecondary();
            for (const e1 of [
                n,
                r
            ]){
                if (!e1) continue;
                const n = e1.id.toString();
                t1.has(n) || t1.set(n, []), e1.scaleSelf(i), t1.get(n).push(e1);
            }
            return {
                primary: n.toString(),
                secondary: r ? r.toString() : null
            };
        }
        function eu(e1, t1, i, n) {
            const r = n.patternDependencies;
            let o = !1;
            for (const n of t1){
                const t1 = n.paint.get(`${e1}-pattern`);
                t1.isConstant() || (o = !0), Ql(t1.constantOr(null), r, i) && (o = !0);
            }
            return o;
        }
        function tu(e1, t1, i, n, r, o) {
            const a = o.patternDependencies;
            for (const s of t1){
                const t1 = s.paint.get(`${e1}-pattern`).value;
                if ("constant" !== t1.kind) {
                    const e1 = Ql(t1.evaluate({
                        zoom: n
                    }, i, {}, void 0, o.availableImages), a, r);
                    if (!e1) continue;
                    const { primary: l, secondary: u } = e1;
                    l && (i.patterns[s.id] = [
                        l,
                        u
                    ].filter(Boolean));
                }
            }
            return i;
        }
        const iu = Sr / Math.PI / 2, nu = 64, ru = [
            nu,
            32,
            16
        ], ou = -iu, au = iu;
        function su(e1, t1, i, n = iu) {
            return i = Ye(i), [
                e1 * Math.sin(i) * n,
                -t1 * n,
                e1 * Math.cos(i) * n
            ];
        }
        function lu(e1, t1, i) {
            return su(Math.cos(Ye(e1)), Math.sin(Ye(e1)), t1, i);
        }
        const uu = 6371008.8, cu = 2 * Math.PI * uu;
        class hu {
            constructor(e1, t1){
                if (isNaN(e1) || isNaN(t1)) throw new Error(`Invalid LngLat object: (${e1}, ${t1})`);
                if (this.lng = +e1, this.lat = +t1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new hu(nt(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(e1) {
                const t1 = Math.PI / 180, i = this.lat * t1, n = e1.lat * t1, r = Math.sin(i) * Math.sin(n) + Math.cos(i) * Math.cos(n) * Math.cos((e1.lng - this.lng) * t1);
                return uu * Math.acos(Math.min(r, 1));
            }
            toBounds(e1 = 0) {
                const t1 = 360 * e1 / 40075017, i = t1 / Math.cos(Math.PI / 180 * this.lat);
                return new du({
                    lng: this.lng - i,
                    lat: this.lat - t1
                }, {
                    lng: this.lng + i,
                    lat: this.lat + t1
                });
            }
            toEcef(e1) {
                return lu(this.lat, this.lng, iu + e1 * iu / uu);
            }
            static convert(e1) {
                if (e1 instanceof hu) return e1;
                if (Array.isArray(e1) && (2 === e1.length || 3 === e1.length)) return new hu(Number(e1[0]), Number(e1[1]));
                if (!Array.isArray(e1) && "object" == typeof e1 && null !== e1) return new hu(Number("lng" in e1 ? e1.lng : e1.lon), Number(e1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        class du {
            constructor(e1, t1){
                e1 && (t1 ? this.setSouthWest(e1).setNorthEast(t1) : Array.isArray(e1) && 4 === e1.length ? this.setSouthWest([
                    e1[0],
                    e1[1]
                ]).setNorthEast([
                    e1[2],
                    e1[3]
                ]) : this.setSouthWest(e1[0]).setNorthEast(e1[1]));
            }
            setNorthEast(e1) {
                return this._ne = e1 instanceof hu ? new hu(e1.lng, e1.lat) : hu.convert(e1), this;
            }
            setSouthWest(e1) {
                return this._sw = e1 instanceof hu ? new hu(e1.lng, e1.lat) : hu.convert(e1), this;
            }
            extend(e1) {
                const t1 = this._sw, i = this._ne;
                let n, r;
                if (e1 instanceof hu) n = e1, r = e1;
                else {
                    if (!(e1 instanceof du)) return Array.isArray(e1) ? 4 === e1.length || e1.every(Array.isArray) ? this.extend(du.convert(e1)) : this.extend(hu.convert(e1)) : "object" == typeof e1 && null !== e1 && Object.hasOwn(e1, "lat") && (Object.hasOwn(e1, "lon") || Object.hasOwn(e1, "lng")) ? this.extend(hu.convert(e1)) : this;
                    if (n = e1._sw, r = e1._ne, !n || !r) return this;
                }
                return t1 || i ? (t1.lng = Math.min(n.lng, t1.lng), t1.lat = Math.min(n.lat, t1.lat), i.lng = Math.max(r.lng, i.lng), i.lat = Math.max(r.lat, i.lat)) : (this._sw = new hu(n.lng, n.lat), this._ne = new hu(r.lng, r.lat)), this;
            }
            getCenter() {
                return new hu((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new hu(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new hu(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(e1) {
                const { lng: t1, lat: i } = hu.convert(e1);
                let n = this._sw.lng <= t1 && t1 <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (n = this._sw.lng >= t1 && t1 >= this._ne.lng), this._sw.lat <= i && i <= this._ne.lat && n;
            }
            static convert(e1) {
                if (e1) return e1 instanceof du ? e1 : new du(e1);
            }
        }
        function fu(e1) {
            return cu * Math.cos(e1 * Math.PI / 180);
        }
        function pu(e1, t1) {
            return e1 / fu(t1);
        }
        function _u(e1, t1) {
            return e1 * fu(pr(t1));
        }
        const mu = 85.051129;
        function gu(e1) {
            return Math.cos(Ye(tt(e1, -85.051129, mu)));
        }
        function yu(e1, t1) {
            const i = tt(t1, 0, 25.5), n = Math.pow(2, i);
            return gu(e1) * cu / (512 * n);
        }
        function xu(e1) {
            return 1 / Math.cos(e1 * Math.PI / 180);
        }
        function vu(e1, t1 = 0) {
            const i = Math.exp(Math.PI * (1 - (e1.y + t1 / Sr) / (1 << e1.z) * 2));
            return 80150034 * i / (i * i + 1) / Sr / (1 << e1.z);
        }
        class bu {
            constructor(e1, t1, i = 0){
                this.x = +e1, this.y = +t1, this.z = +i;
            }
            static fromLngLat(e1, t1 = 0) {
                const i = hu.convert(e1);
                return new bu(hr(i.lng), dr(i.lat), pu(t1, i.lat));
            }
            toLngLat() {
                return new hu(fr(this.x), pr(this.y));
            }
            toAltitude() {
                return _u(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                return 1 / cu * xu(pr(this.y));
            }
        }
        function wu(e1, t1, i, n, r, o, a, s, l) {
            const u = (t1 + n) / 2, c = (i + r) / 2, h = new Pe(u, c);
            s(h), function(e1, t1, i, n, r, o) {
                const a = i - r, s = n - o;
                return Math.abs((n - t1) * a - (i - e1) * s) / Math.hypot(a, s);
            }(h.x, h.y, o.x, o.y, a.x, a.y) >= l ? (wu(e1, t1, i, u, c, o, h, s, l), wu(e1, u, c, n, r, h, a, s, l)) : e1.push(a);
        }
        function Eu(e1, t1, i) {
            let n = e1[0], r = n.x, o = n.y;
            t1(n);
            const a = [
                n
            ];
            for(let s = 1; s < e1.length; s++){
                const l = e1[s], { x: u, y: c } = l;
                t1(l), wu(a, r, o, u, c, n, l, t1, i), r = u, o = c, n = l;
            }
            return a;
        }
        function Au(e1, t1, i, n) {
            if (n(t1, i)) {
                const r = t1.add(i)._mult(.5);
                Au(e1, t1, r, n), Au(e1, r, i, n);
            } else e1.push(i);
        }
        function Iu(e1, t1) {
            let i = e1[0];
            const n = [
                i
            ];
            for(let r = 1; r < e1.length; r++){
                const o = e1[r];
                Au(n, i, o, t1), i = o;
            }
            return n;
        }
        const Tu = Math.pow(2, 14) - 1, Mu = -Tu - 1;
        function Su(e1, t1) {
            const i = Math.round(e1.x * t1), n = Math.round(e1.y * t1);
            return e1.x = tt(i, Mu, Tu), e1.y = tt(n, Mu, Tu), (i < e1.x || i > e1.x + 1 || n < e1.y || n > e1.y + 1) && mt("Geometry exceeds allowed extent, reduce your vector tile buffer size"), e1;
        }
        function zu(e1, t1, i) {
            const n = e1.loadGeometry(), r = e1.extent, o = Sr / r;
            if (t1 && i && i.projection.isReprojectedInTileSpace) {
                const o = 1 << t1.z, { scale: a, x: s, y: l, projection: u } = i, c = (e1)=>{
                    const i = fr((t1.x + e1.x / r) / o), n = pr((t1.y + e1.y / r) / o), c = u.project(i, n);
                    e1.x = (c.x * a - s) * r, e1.y = (c.y * a - l) * r;
                };
                for(let t1 = 0; t1 < n.length; t1++)if (1 !== e1.type) n[t1] = Eu(n[t1], c, 1);
                else {
                    const e1 = [];
                    for (const i of n[t1])i.x < 0 || i.x >= r || i.y < 0 || i.y >= r || (c(i), e1.push(i));
                    n[t1] = e1;
                }
            }
            for (const e1 of n)for (const t1 of e1)Su(t1, o);
            return n;
        }
        function Ru(e1, t1) {
            return {
                type: e1.type,
                id: e1.id,
                properties: e1.properties,
                geometry: t1 ? zu(e1) : []
            };
        }
        const Pu = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class Du {
            constructor(e1, t1){
                this._structArray = e1, this._pos1 = t1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        const Cu = new ArrayBuffer(0);
        class Fu {
            constructor(){
                this._reallocCount = 0, this.capacity = 0, this.length = 0;
            }
            static serialize(e1, t1) {
                return e1._trim(), t1 && e1.arrayBuffer && t1.add(e1.arrayBuffer), {
                    length: e1.length,
                    arrayBuffer: e1.arrayBuffer
                };
            }
            static deserialize(e1) {
                const t1 = Object.create(this.prototype);
                return t1.arrayBuffer = e1.arrayBuffer, t1.length = e1.length, e1.arrayBuffer ? t1.capacity = e1.arrayBuffer.byteLength / t1.bytesPerElement : (t1.capacity = 0, t1.arrayBuffer = Cu), t1._refreshViews(), t1;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(e1) {
                this.reserve(e1), this.length = e1;
            }
            resizeExact(e1) {
                this.reserveExact(e1), this.length = e1;
            }
            reserve(e1) {
                e1 > this.capacity && this._allocate(Math.max(e1, Math.floor(5 * this.capacity), 128));
            }
            reserveExact(e1) {
                (e1 > this.capacity || !this.arrayBuffer) && this._allocate(e1);
            }
            _allocate(e1) {
                this._reallocCount++, this.capacity = e1, this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                const t1 = this.uint8;
                this._refreshViews(), t1 && this.uint8.set(t1);
            }
            reserveForAdditional(e1) {
                this.reserve(this.length + e1);
            }
            _refreshViews() {
                throw new Error("StructArray#_refreshViews() must be implemented by each concrete StructArray layout");
            }
            emplace(...e1) {
                throw new Error("StructArray#emplace() must be implemented by each concrete StructArray layout");
            }
            emplaceBack(...e1) {
                throw new Error("StructArray#emplaceBack() must be implemented by each concrete StructArray layout");
            }
            destroy() {
                this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
            }
        }
        function Ou(e1, t1 = 1) {
            let i = 0, n = 0;
            return {
                members: e1.map((e1)=>{
                    const r = Pu[e1.type].BYTES_PER_ELEMENT, o = i = Lu(i, Math.max(t1, r)), a = e1.components || 1;
                    return n = Math.max(n, r), i += r * a, {
                        name: e1.name,
                        type: e1.type,
                        components: a,
                        offset: o
                    };
                }),
                size: Lu(i, Math.max(n, t1)),
                alignment: t1
            };
        }
        function Lu(e1, t1) {
            return Math.ceil(e1 / t1) * t1;
        }
        class Bu extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t1);
            }
            emplace(e1, t1, i) {
                const n = 2 * e1;
                return this.int16[n + 0] = t1, this.int16[n + 1] = i, e1;
            }
        }
        Bu.prototype.bytesPerElement = 4, Ha(Bu, "StructArrayLayout2i4");
        class Nu extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, i);
            }
            emplace(e1, t1, i, n) {
                const r = 3 * e1;
                return this.int16[r + 0] = t1, this.int16[r + 1] = i, this.int16[r + 2] = n, e1;
            }
        }
        Nu.prototype.bytesPerElement = 6, Ha(Nu, "StructArrayLayout3i6");
        class Vu extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1, i, n);
            }
            emplace(e1, t1, i, n, r) {
                const o = 4 * e1;
                return this.int16[o + 0] = t1, this.int16[o + 1] = i, this.uint16[o + 2] = n, this.uint16[o + 3] = r, e1;
            }
        }
        Vu.prototype.bytesPerElement = 8, Ha(Vu, "StructArrayLayout2i2ui8");
        class ku extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.float32[1 * e1 + 0] = t1, e1;
            }
        }
        ku.prototype.bytesPerElement = 4, Ha(ku, "StructArrayLayout1f4");
        class Uu extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, i);
            }
            emplace(e1, t1, i, n) {
                const r = 4 * e1, o = 2 * e1;
                return this.int16[r + 0] = t1, this.int16[r + 1] = i, this.float32[o + 1] = n, e1;
            }
        }
        Uu.prototype.bytesPerElement = 8, Ha(Uu, "StructArrayLayout2i1f8");
        class Gu extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, i);
            }
            emplace(e1, t1, i, n) {
                const r = 4 * e1;
                return this.int16[r + 0] = t1, this.int16[r + 1] = i, this.int16[r + 2] = n, e1;
            }
        }
        Gu.prototype.bytesPerElement = 8, Ha(Gu, "StructArrayLayout3i8");
        class ju extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1, i, n);
            }
            emplace(e1, t1, i, n, r) {
                const o = 4 * e1;
                return this.int16[o + 0] = t1, this.int16[o + 1] = i, this.int16[o + 2] = n, this.int16[o + 3] = r, e1;
            }
        }
        ju.prototype.bytesPerElement = 8, Ha(ju, "StructArrayLayout4i8");
        class Hu extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t1, i, n, r);
            }
            emplace(e1, t1, i, n, r, o) {
                const a = 5 * e1;
                return this.int16[a + 0] = t1, this.int16[a + 1] = i, this.int16[a + 2] = n, this.int16[a + 3] = r, this.int16[a + 4] = o, e1;
            }
        }
        Hu.prototype.bytesPerElement = 10, Ha(Hu, "StructArrayLayout5i10");
        class $u extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t1, i, n, r, o, a);
            }
            emplace(e1, t1, i, n, r, o, a, s) {
                const l = 6 * e1, u = 12 * e1, c = 3 * e1;
                return this.int16[l + 0] = t1, this.int16[l + 1] = i, this.uint8[u + 4] = n, this.uint8[u + 5] = r, this.uint8[u + 6] = o, this.uint8[u + 7] = a, this.float32[c + 2] = s, e1;
            }
        }
        $u.prototype.bytesPerElement = 12, Ha($u, "StructArrayLayout2i4ub1f12");
        class Zu extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, i);
            }
            emplace(e1, t1, i, n) {
                const r = 3 * e1;
                return this.float32[r + 0] = t1, this.float32[r + 1] = i, this.float32[r + 2] = n, e1;
            }
        }
        Zu.prototype.bytesPerElement = 12, Ha(Zu, "StructArrayLayout3f12");
        class Wu extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t1, i, n, r);
            }
            emplace(e1, t1, i, n, r, o) {
                const a = 6 * e1, s = 3 * e1;
                return this.uint16[a + 0] = t1, this.uint16[a + 1] = i, this.uint16[a + 2] = n, this.uint16[a + 3] = r, this.float32[s + 2] = o, e1;
            }
        }
        Wu.prototype.bytesPerElement = 12, Ha(Wu, "StructArrayLayout4ui1f12");
        class qu extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1, i, n);
            }
            emplace(e1, t1, i, n, r) {
                const o = 4 * e1;
                return this.uint16[o + 0] = t1, this.uint16[o + 1] = i, this.uint16[o + 2] = n, this.uint16[o + 3] = r, e1;
            }
        }
        qu.prototype.bytesPerElement = 8, Ha(qu, "StructArrayLayout4ui8");
        class Xu extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t1, i, n, r, o);
            }
            emplace(e1, t1, i, n, r, o, a) {
                const s = 6 * e1;
                return this.int16[s + 0] = t1, this.int16[s + 1] = i, this.int16[s + 2] = n, this.int16[s + 3] = r, this.int16[s + 4] = o, this.int16[s + 5] = a, e1;
            }
        }
        Xu.prototype.bytesPerElement = 12, Ha(Xu, "StructArrayLayout6i12");
        class Yu extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l, u, c, h) {
                const d = this.length;
                return this.resize(d + 1), this.emplace(d, e1, t1, i, n, r, o, a, s, l, u, c, h);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, u, c, h, d) {
                const f = 12 * e1;
                return this.int16[f + 0] = t1, this.int16[f + 1] = i, this.int16[f + 2] = n, this.int16[f + 3] = r, this.uint16[f + 4] = o, this.uint16[f + 5] = a, this.uint16[f + 6] = s, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = d, e1;
            }
        }
        Yu.prototype.bytesPerElement = 24, Ha(Yu, "StructArrayLayout4i4ui4i24");
        class Ju extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t1, i, n, r, o);
            }
            emplace(e1, t1, i, n, r, o, a) {
                const s = 10 * e1, l = 5 * e1;
                return this.int16[s + 0] = t1, this.int16[s + 1] = i, this.int16[s + 2] = n, this.float32[l + 2] = r, this.float32[l + 3] = o, this.float32[l + 4] = a, e1;
            }
        }
        Ju.prototype.bytesPerElement = 20, Ha(Ju, "StructArrayLayout3i3f20");
        class Ku extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1, i, n);
            }
            emplace(e1, t1, i, n, r) {
                const o = 4 * e1;
                return this.float32[o + 0] = t1, this.float32[o + 1] = i, this.float32[o + 2] = n, this.float32[o + 3] = r, e1;
            }
        }
        Ku.prototype.bytesPerElement = 16, Ha(Ku, "StructArrayLayout4f16");
        class Qu extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.uint32[1 * e1 + 0] = t1, e1;
            }
        }
        Qu.prototype.bytesPerElement = 4, Ha(Qu, "StructArrayLayout1ul4");
        class ec extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t1);
            }
            emplace(e1, t1, i) {
                const n = 2 * e1;
                return this.uint16[n + 0] = t1, this.uint16[n + 1] = i, e1;
            }
        }
        ec.prototype.bytesPerElement = 4, Ha(ec, "StructArrayLayout2ui4");
        class tc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l, u, c, h, d) {
                const f = this.length;
                return this.resize(f + 1), this.emplace(f, e1, t1, i, n, r, o, a, s, l, u, c, h, d);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, u, c, h, d, f) {
                const p = 20 * e1, _ = 10 * e1;
                return this.int16[p + 0] = t1, this.int16[p + 1] = i, this.int16[p + 2] = n, this.int16[p + 3] = r, this.int16[p + 4] = o, this.float32[_ + 3] = a, this.float32[_ + 4] = s, this.float32[_ + 5] = l, this.float32[_ + 6] = u, this.int16[p + 14] = c, this.uint32[_ + 8] = h, this.uint16[p + 18] = d, this.uint16[p + 19] = f, e1;
            }
        }
        tc.prototype.bytesPerElement = 40, Ha(tc, "StructArrayLayout5i4f1i1ul2ui40");
        class ic extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t1, i, n, r, o, a);
            }
            emplace(e1, t1, i, n, r, o, a, s) {
                const l = 8 * e1;
                return this.int16[l + 0] = t1, this.int16[l + 1] = i, this.int16[l + 2] = n, this.int16[l + 4] = r, this.int16[l + 5] = o, this.int16[l + 6] = a, this.int16[l + 7] = s, e1;
            }
        }
        ic.prototype.bytesPerElement = 16, Ha(ic, "StructArrayLayout3i2i2i16");
        class nc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t1, i, n, r);
            }
            emplace(e1, t1, i, n, r, o) {
                const a = 4 * e1, s = 8 * e1;
                return this.float32[a + 0] = t1, this.float32[a + 1] = i, this.float32[a + 2] = n, this.int16[s + 6] = r, this.int16[s + 7] = o, e1;
            }
        }
        nc.prototype.bytesPerElement = 16, Ha(nc, "StructArrayLayout2f1f2i16");
        class rc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t1, i, n, r, o);
            }
            emplace(e1, t1, i, n, r, o, a) {
                const s = 20 * e1, l = 5 * e1;
                return this.uint8[s + 0] = t1, this.uint8[s + 1] = i, this.float32[l + 1] = n, this.float32[l + 2] = r, this.float32[l + 3] = o, this.float32[l + 4] = a, e1;
            }
        }
        rc.prototype.bytesPerElement = 20, Ha(rc, "StructArrayLayout2ub4f20");
        class oc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, i);
            }
            emplace(e1, t1, i, n) {
                const r = 3 * e1;
                return this.uint16[r + 0] = t1, this.uint16[r + 1] = i, this.uint16[r + 2] = n, e1;
            }
        }
        oc.prototype.bytesPerElement = 6, Ha(oc, "StructArrayLayout3ui6");
        class ac extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, m, g, y, x, v) {
                const b = this.length;
                return this.resize(b + 1), this.emplace(b, e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, m, g, y, x, v);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, m, g, y, x, v, b) {
                const w = 30 * e1, E = 15 * e1, A = 60 * e1;
                return this.int16[w + 0] = t1, this.int16[w + 1] = i, this.int16[w + 2] = n, this.float32[E + 2] = r, this.float32[E + 3] = o, this.uint16[w + 8] = a, this.uint16[w + 9] = s, this.uint32[E + 5] = l, this.uint32[E + 6] = u, this.uint32[E + 7] = c, this.uint16[w + 16] = h, this.uint16[w + 17] = d, this.uint16[w + 18] = f, this.float32[E + 10] = p, this.float32[E + 11] = _, this.uint8[A + 48] = m, this.uint8[A + 49] = g, this.uint8[A + 50] = y, this.uint32[E + 13] = x, this.int16[w + 28] = v, this.uint8[A + 58] = b, e1;
            }
        }
        ac.prototype.bytesPerElement = 60, Ha(ac, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
        class sc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, m, g, y, x, v, b, w, E, A, I, T, M, S, z, R, P, D) {
                const C = this.length;
                return this.resize(C + 1), this.emplace(C, e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, m, g, y, x, v, b, w, E, A, I, T, M, S, z, R, P, D);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, m, g, y, x, v, b, w, E, A, I, T, M, S, z, R, P, D, C) {
                const F = 20 * e1, O = 40 * e1, L = 80 * e1;
                return this.float32[F + 0] = t1, this.float32[F + 1] = i, this.int16[O + 4] = n, this.int16[O + 5] = r, this.int16[O + 6] = o, this.int16[O + 7] = a, this.int16[O + 8] = s, this.int16[O + 9] = l, this.int16[O + 10] = u, this.int16[O + 11] = c, this.int16[O + 12] = h, this.uint16[O + 13] = d, this.uint16[O + 14] = f, this.uint16[O + 15] = p, this.uint16[O + 16] = _, this.uint16[O + 17] = m, this.uint16[O + 18] = g, this.uint16[O + 19] = y, this.uint16[O + 20] = x, this.uint16[O + 21] = v, this.uint16[O + 22] = b, this.uint16[O + 23] = w, this.uint16[O + 24] = E, this.uint16[O + 25] = A, this.uint16[O + 26] = I, this.uint16[O + 27] = T, this.uint32[F + 14] = M, this.float32[F + 15] = S, this.float32[F + 16] = z, this.float32[F + 17] = R, this.float32[F + 18] = P, this.uint8[L + 76] = D, this.uint16[O + 39] = C, e1;
            }
        }
        sc.prototype.bytesPerElement = 80, Ha(sc, "StructArrayLayout2f9i15ui1ul4f1ub1ui80");
        class lc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t1, i, n, r, o);
            }
            emplace(e1, t1, i, n, r, o, a) {
                const s = 6 * e1;
                return this.float32[s + 0] = t1, this.float32[s + 1] = i, this.float32[s + 2] = n, this.float32[s + 3] = r, this.float32[s + 4] = o, this.float32[s + 5] = a, e1;
            }
        }
        lc.prototype.bytesPerElement = 24, Ha(lc, "StructArrayLayout6f24");
        class uc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t1, i, n, r);
            }
            emplace(e1, t1, i, n, r, o) {
                const a = 5 * e1;
                return this.float32[a + 0] = t1, this.float32[a + 1] = i, this.float32[a + 2] = n, this.float32[a + 3] = r, this.float32[a + 4] = o, e1;
            }
        }
        uc.prototype.bytesPerElement = 20, Ha(uc, "StructArrayLayout5f20");
        class cc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t1, i, n, r, o, a);
            }
            emplace(e1, t1, i, n, r, o, a, s) {
                const l = 7 * e1;
                return this.float32[l + 0] = t1, this.float32[l + 1] = i, this.float32[l + 2] = n, this.float32[l + 3] = r, this.float32[l + 4] = o, this.float32[l + 5] = a, this.float32[l + 6] = s, e1;
            }
        }
        cc.prototype.bytesPerElement = 28, Ha(cc, "StructArrayLayout7f28");
        class hc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l, u, c) {
                const h = this.length;
                return this.resize(h + 1), this.emplace(h, e1, t1, i, n, r, o, a, s, l, u, c);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, u, c, h) {
                const d = 11 * e1;
                return this.float32[d + 0] = t1, this.float32[d + 1] = i, this.float32[d + 2] = n, this.float32[d + 3] = r, this.float32[d + 4] = o, this.float32[d + 5] = a, this.float32[d + 6] = s, this.float32[d + 7] = l, this.float32[d + 8] = u, this.float32[d + 9] = c, this.float32[d + 10] = h, e1;
            }
        }
        hc.prototype.bytesPerElement = 44, Ha(hc, "StructArrayLayout11f44");
        class dc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, e1, t1, i, n, r, o, a, s, l);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, u) {
                const c = 9 * e1;
                return this.float32[c + 0] = t1, this.float32[c + 1] = i, this.float32[c + 2] = n, this.float32[c + 3] = r, this.float32[c + 4] = o, this.float32[c + 5] = a, this.float32[c + 6] = s, this.float32[c + 7] = l, this.float32[c + 8] = u, e1;
            }
        }
        dc.prototype.bytesPerElement = 36, Ha(dc, "StructArrayLayout9f36");
        class fc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t1);
            }
            emplace(e1, t1, i) {
                const n = 2 * e1;
                return this.float32[n + 0] = t1, this.float32[n + 1] = i, e1;
            }
        }
        fc.prototype.bytesPerElement = 8, Ha(fc, "StructArrayLayout2f8");
        class pc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1, i, n);
            }
            emplace(e1, t1, i, n, r) {
                const o = 6 * e1;
                return this.uint32[3 * e1 + 0] = t1, this.uint16[o + 2] = i, this.uint16[o + 3] = n, this.uint16[o + 4] = r, e1;
            }
        }
        pc.prototype.bytesPerElement = 12, Ha(pc, "StructArrayLayout1ul3ui12");
        class _c extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.uint16[1 * e1 + 0] = t1, e1;
            }
        }
        _c.prototype.bytesPerElement = 2, Ha(_c, "StructArrayLayout1ui2");
        class mc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _) {
                const m = this.length;
                return this.resize(m + 1), this.emplace(m, e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, m) {
                const g = 16 * e1;
                return this.float32[g + 0] = t1, this.float32[g + 1] = i, this.float32[g + 2] = n, this.float32[g + 3] = r, this.float32[g + 4] = o, this.float32[g + 5] = a, this.float32[g + 6] = s, this.float32[g + 7] = l, this.float32[g + 8] = u, this.float32[g + 9] = c, this.float32[g + 10] = h, this.float32[g + 11] = d, this.float32[g + 12] = f, this.float32[g + 13] = p, this.float32[g + 14] = _, this.float32[g + 15] = m, e1;
            }
        }
        mc.prototype.bytesPerElement = 64, Ha(mc, "StructArrayLayout16f64");
        class gc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t1, i, n, r, o, a);
            }
            emplace(e1, t1, i, n, r, o, a, s) {
                const l = 10 * e1, u = 5 * e1;
                return this.uint16[l + 0] = t1, this.uint16[l + 1] = i, this.uint16[l + 2] = n, this.uint16[l + 3] = r, this.float32[u + 2] = o, this.float32[u + 3] = a, this.float32[u + 4] = s, e1;
            }
        }
        gc.prototype.bytesPerElement = 20, Ha(gc, "StructArrayLayout4ui3f20");
        class yc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.int16[1 * e1 + 0] = t1, e1;
            }
        }
        yc.prototype.bytesPerElement = 2, Ha(yc, "StructArrayLayout1i2");
        class xc extends Fu {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.uint8[1 * e1 + 0] = t1, e1;
            }
        }
        xc.prototype.bytesPerElement = 1, Ha(xc, "StructArrayLayout1ub1");
        class vc extends Du {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get tileAnchorY() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get x1() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get y1() {
                return this._structArray.float32[this._pos4 + 4];
            }
            get x2() {
                return this._structArray.float32[this._pos4 + 5];
            }
            get y2() {
                return this._structArray.float32[this._pos4 + 6];
            }
            get padding() {
                return this._structArray.int16[this._pos2 + 14];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 8];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
        }
        vc.prototype.size = 40;
        class bc extends tc {
            get(e1) {
                return new vc(this, e1);
            }
        }
        Ha(bc, "CollisionBoxArray");
        class wc extends Du {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 5];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 6];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 7];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 10];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 11];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 48];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 49];
            }
            set placedOrientation(e1) {
                this._structArray.uint8[this._pos1 + 49] = e1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 50];
            }
            set hidden(e1) {
                this._structArray.uint8[this._pos1 + 50] = e1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 13];
            }
            set crossTileID(e1) {
                this._structArray.uint32[this._pos4 + 13] = e1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 28];
            }
            get flipState() {
                return this._structArray.uint8[this._pos1 + 58];
            }
            set flipState(e1) {
                this._structArray.uint8[this._pos1 + 58] = e1;
            }
        }
        wc.prototype.size = 60;
        class Ec extends ac {
            get(e1) {
                return new wc(this, e1);
            }
        }
        Ha(Ec, "PlacedSymbolArray");
        class Ac extends Du {
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 0];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 8];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 9];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 10];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 11];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 12];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 23];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 24];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 25];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 26];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 27];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 14];
            }
            set crossTileID(e1) {
                this._structArray.uint32[this._pos4 + 14] = e1;
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 15];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 16];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 17];
            }
            get zOffset() {
                return this._structArray.float32[this._pos4 + 18];
            }
            set zOffset(e1) {
                this._structArray.float32[this._pos4 + 18] = e1;
            }
            get hasIconTextFit() {
                return this._structArray.uint8[this._pos1 + 76];
            }
            get elevationFeatureIndex() {
                return this._structArray.uint16[this._pos2 + 39];
            }
        }
        Ac.prototype.size = 80;
        class Ic extends sc {
            get(e1) {
                return new Ac(this, e1);
            }
        }
        Ha(Ic, "SymbolInstanceArray");
        class Tc extends ku {
            getoffsetX(e1) {
                return this.float32[1 * e1 + 0];
            }
        }
        Ha(Tc, "GlyphOffsetArray");
        class Mc extends Bu {
            getx(e1) {
                return this.int16[2 * e1 + 0];
            }
            gety(e1) {
                return this.int16[2 * e1 + 1];
            }
        }
        Ha(Mc, "SymbolLineVertexArray");
        class Sc extends Du {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get layoutVertexArrayOffset() {
                return this._structArray.uint16[this._pos2 + 4];
            }
        }
        Sc.prototype.size = 12;
        class zc extends pc {
            get(e1) {
                return new Sc(this, e1);
            }
        }
        Ha(zc, "FeatureIndexArray");
        class Rc extends ec {
            geta_centroid_pos0(e1) {
                return this.uint16[2 * e1 + 0];
            }
            geta_centroid_pos1(e1) {
                return this.uint16[2 * e1 + 1];
            }
        }
        Ha(Rc, "FillExtrusionCentroidArray");
        class Pc extends Du {
            get a_join_normal_inside0() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get a_join_normal_inside1() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get a_join_normal_inside2() {
                return this._structArray.int16[this._pos2 + 2];
            }
        }
        Pc.prototype.size = 6;
        class Dc extends Nu {
            get(e1) {
                return new Pc(this, e1);
            }
        }
        Ha(Dc, "FillExtrusionWallArray");
        const Cc = Ou([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), Fc = Ou([
            {
                name: "a_road_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), Oc = Ou([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_height",
                components: 1,
                type: "Float32"
            }
        ], 4), Lc = Ou([
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ], 4);
        class Bc {
            constructor(e1 = []){
                this.segments = e1;
            }
            _prepareSegment(e1, t1, i, n, r) {
                let o = this.segments.at(-1);
                return e1 > Bc.MAX_VERTEX_ARRAY_LENGTH && mt(`Max vertices per segment is ${Bc.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${e1}`), (!o || o.vertexLength + e1 > Bc.MAX_VERTEX_ARRAY_LENGTH || o.sortKey !== n || void 0 !== r && o && void 0 !== o.batchIndex && o.batchIndex !== r) && (o = {
                    vertexOffset: t1,
                    primitiveOffset: i,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (o.sortKey = n), void 0 !== r && (o.batchIndex = r), this.segments.push(o)), o;
            }
            prepareSegment(e1, t1, i, n, r) {
                return this._prepareSegment(e1, t1.length, i.length, n, r);
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const e1 of this.segments)for(const t1 in e1.vaos)e1.vaos[t1].destroy();
            }
            static simpleSegment(e1, t1, i, n) {
                return new Bc([
                    {
                        vertexOffset: e1,
                        primitiveOffset: t1,
                        vertexLength: i,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function Nc(e1, t1) {
            return 256 * (e1 = tt(Math.floor(e1), 0, 255)) + tt(Math.floor(t1), 0, 255);
        }
        Bc.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Ha(Bc, "SegmentVector");
        const Vc = Ou([
            {
                name: "a_pattern",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio",
                components: 1,
                type: "Float32"
            }
        ]), kc = Ou([
            {
                name: "a_pattern_b",
                components: 4,
                type: "Uint16"
            }
        ]), Uc = Ou([
            {
                name: "a_dash",
                components: 4,
                type: "Uint16"
            }
        ]);
        class Gc {
            constructor(){
                this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = !1;
            }
            add(e1, t1, i, n) {
                this.ids.push(jc(e1)), this.positions.push(t1, i, n);
            }
            eachPosition(e1, t1) {
                const i = jc(e1);
                let n = 0, r = this.ids.length - 1;
                for(; n < r;){
                    const e1 = n + r >> 1;
                    this.ids[e1] >= i ? r = e1 : n = e1 + 1;
                }
                for(; this.ids[n] === i;)t1(this.positions[3 * n], this.positions[3 * n + 1], this.positions[3 * n + 2]), n++;
            }
            static serialize(e1, t1) {
                const i = new Float64Array(e1.ids), n = new Uint32Array(e1.positions);
                return Hc(i, n, 0, i.length - 1), t1 && (t1.add(i.buffer), t1.add(n.buffer)), {
                    ids: i,
                    positions: n
                };
            }
            static deserialize(e1) {
                const t1 = new Gc;
                let i;
                t1.ids = e1.ids, t1.positions = e1.positions;
                for (const e1 of t1.ids)e1 !== i && t1.uniqueIds.push(e1), i = e1;
                return t1.indexed = !0, t1;
            }
        }
        function jc(e1) {
            const t1 = +e1;
            return Number.isSafeInteger(t1) ? t1 : tn(String(e1));
        }
        function Hc(e1, t1, i, n) {
            for(; i < n;){
                const r = e1[i + n >> 1];
                let o = i - 1, a = n + 1;
                for(;;){
                    do o++;
                    while (e1[o] < r);
                    do a--;
                    while (e1[a] > r);
                    if (o >= a) break;
                    $c(e1, o, a), $c(t1, 3 * o, 3 * a), $c(t1, 3 * o + 1, 3 * a + 1), $c(t1, 3 * o + 2, 3 * a + 2);
                }
                a - i < n - a ? (Hc(e1, t1, i, a), i = a + 1) : (Hc(e1, t1, a + 1, n), n = a);
            }
        }
        function $c(e1, t1, i) {
            const n = e1[t1];
            e1[t1] = e1[i], e1[i] = n;
        }
        Ha(Gc, "FeaturePositionMap");
        class Zc {
            constructor(e1){
                this.gl = e1.gl, this.initialized = !1;
            }
            fetchUniformLocation(e1, t1) {
                return this.location || this.initialized || (this.location = this.gl.getUniformLocation(e1, t1), this.initialized = !0), !!this.location;
            }
            set(e1, t1, i) {
                throw new Error("Uniform#set() must be implemented by each concrete Uniform");
            }
        }
        class Wc extends Zc {
            constructor(e1){
                super(e1), this.current = 0;
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && this.current !== i && (this.current = i, this.gl.uniform1i(this.location, i));
            }
        }
        class qc extends Zc {
            constructor(e1){
                super(e1), this.current = 0;
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && this.current !== i && (this.current = i, this.gl.uniform1f(this.location, i));
            }
        }
        class Xc extends Zc {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0
                ];
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && (i[0] === this.current[0] && i[1] === this.current[1] || (this.current = i, this.gl.uniform2f(this.location, i[0], i[1])));
            }
        }
        class Yc extends Zc {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && (i[0] === this.current[0] && i[1] === this.current[1] && i[2] === this.current[2] || (this.current = i, this.gl.uniform3f(this.location, i[0], i[1], i[2])));
            }
        }
        class Jc extends Zc {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && (i[0] === this.current[0] && i[1] === this.current[1] && i[2] === this.current[2] && i[3] === this.current[3] || (this.current = i, this.gl.uniform4ui(this.location, i[0], i[1], i[2], i[3])));
            }
        }
        class Kc extends Zc {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && (i[0] === this.current[0] && i[1] === this.current[1] && i[2] === this.current[2] && i[3] === this.current[3] || (this.current = i, this.gl.uniform4f(this.location, i[0], i[1], i[2], i[3])));
            }
        }
        class Qc extends Zc {
            constructor(e1){
                super(e1), this.current = pn.transparent.toPremultipliedRenderColor(null);
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && (i.r === this.current.r && i.g === this.current.g && i.b === this.current.b && i.a === this.current.a || (this.current = i, this.gl.uniform4f(this.location, i.r, i.g, i.b, i.a)));
            }
        }
        class eh extends Zc {
            constructor(e1){
                super(e1), this.current = new Float32Array(16);
            }
            set(e1, t1, i) {
                if (!this.fetchUniformLocation(e1, t1)) return;
                const n = this.current;
                if (i[12] !== n[12] || i[0] !== n[0]) return n.set(i), void this.gl.uniformMatrix4fv(this.location, !1, n);
                for(let e1 = 1; e1 < 16; e1++)if (i[e1] !== n[e1]) {
                    n.set(i), this.gl.uniformMatrix4fv(this.location, !1, n);
                    break;
                }
            }
        }
        class th extends Zc {
            constructor(e1){
                super(e1), this.current = new Float32Array(4);
            }
            set(e1, t1, i) {
                if (!this.fetchUniformLocation(e1, t1)) return;
                const n = this.current;
                for(let e1 = 0; e1 < 4; e1++)if (i[e1] !== n[e1]) {
                    n.set(i), this.gl.uniformMatrix2fv(this.location, !1, n);
                    break;
                }
            }
        }
        function ih(e1) {
            return [
                Nc(255 * e1.r, 255 * e1.g),
                Nc(255 * e1.b, 255 * e1.a)
            ];
        }
        function nh(e1, t1, i, n, r, o, a, s) {
            return !!e1 && ("composite" === e1.kind || "source" === e1.kind ? "none" === e1.evaluate(new ks(0, {
                brightness: o,
                worldview: s
            }), t1, i, r, n, a) : "none" === e1.value);
        }
        class rh {
            constructor(e1, t1, i, n){
                this.value = e1, this.uniformNames = t1.map((e1)=>`u_${e1}`), this.type = i, this.context = n;
            }
            setUniform(e1, t1, i, n, r) {
                const o = n.constantOr(this.value);
                t1.set(e1, r, o instanceof pn ? o.toPremultipliedRenderColor(this.lutExpression && "constant" === this.lutExpression.kind && "none" === this.lutExpression.value ? null : this.context.lut) : o);
            }
            getBinding(e1, t1) {
                return "color" === this.type ? new Qc(e1) : new qc(e1);
            }
        }
        class oh {
            constructor(e1, t1){
                this.uniformNames = t1.map((e1)=>`u_${e1}`), this.pattern = null, this.patternTransition = null, this.pixelRatio = 1;
            }
            setConstantPatternPositions(e1, t1) {
                this.pixelRatio = e1.pixelRatio || 1, this.pattern = e1.tl.concat(e1.br), this.patternTransition = t1 ? t1.tl.concat(t1.br) : this.pattern;
            }
            setUniform(e1, t1, i, n, r) {
                let o = null;
                "u_pattern" !== r && "u_dash" !== r || (o = this.pattern), "u_pattern_b" === r && (o = this.patternTransition), "u_pixel_ratio" === r && (o = this.pixelRatio), o && t1.set(e1, r, o);
            }
            getBinding(e1, t1) {
                return "u_pattern" === t1 || "u_pattern_b" === t1 || "u_dash" === t1 ? new Jc(e1) : new qc(e1);
            }
        }
        class ah {
            constructor(e1, t1, i, n){
                this.expression = e1, this.type = i, this.maxValue = 0, this.paintVertexAttributes = t1.map((e1)=>({
                        name: `a_${e1}`,
                        type: "Float32",
                        components: "color" === i ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(e1, t1, i, n, r, o, a, s) {
                const l = this.paintVertexArray.length, u = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate(new ks(0, {
                    brightness: o,
                    worldview: s
                }), t1, {}, r, n, a) : "constant" === this.expression.kind && this.expression.value, c = nh(this.lutExpression, t1, {}, n, r, o, a, s);
                this.paintVertexArray.resize(e1), this._setPaintValue(l, e1, u, c ? null : this.context.lut);
            }
            updatePaintArray(e1, t1, i, n, r, o, a, s) {
                const l = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate({
                    zoom: 0,
                    brightness: a,
                    worldview: s
                }, i, n, void 0, r) : "constant" === this.expression.kind && this.expression.value, u = nh(this.lutExpression, i, n, r, void 0, a, void 0, s);
                this._setPaintValue(e1, t1, l, u ? null : this.context.lut);
            }
            _setPaintValue(e1, t1, i, n) {
                if ("color" === this.type) {
                    const r = ih(i.toPremultipliedRenderColor(n));
                    for(let i = e1; i < t1; i++)this.paintVertexArray.emplace(i, r[0], r[1]);
                } else {
                    for(let n = e1; n < t1; n++)this.paintVertexArray.emplace(n, i);
                    this.maxValue = Math.max(this.maxValue, Math.abs(i));
                }
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.lutExpression && "constant" !== this.lutExpression.kind && (this.lutExpression.isStateDependent || !this.lutExpression.isLightConstant) || "constant" !== this.expression.kind && (this.expression.isStateDependent || !this.expression.isLightConstant)));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class sh {
            constructor(e1, t1, i, n, r, o){
                this.expression = e1, this.uniformNames = t1.map((e1)=>`u_${e1}_t`), this.type = i, this.useIntegerZoom = n, this.context = r, this.maxValue = 0, this.paintVertexAttributes = t1.map((e1)=>({
                        name: `a_${e1}`,
                        type: "Float32",
                        components: "color" === i ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new o;
            }
            populatePaintArray(e1, t1, i, n, r, o, a, s) {
                const l = this.expression.evaluate(new ks(this.context.zoom, {
                    brightness: o,
                    worldview: s
                }), t1, {}, r, n, a), u = this.expression.evaluate(new ks(this.context.zoom + 1, {
                    brightness: o,
                    worldview: s
                }), t1, {}, r, n, a), c = nh(this.lutExpression, t1, {}, n, r, o, a, s), h = this.paintVertexArray.length;
                this.paintVertexArray.resize(e1), this._setPaintValue(h, e1, l, u, c ? null : this.context.lut);
            }
            updatePaintArray(e1, t1, i, n, r, o, a, s) {
                const l = this.expression.evaluate({
                    zoom: this.context.zoom,
                    brightness: a,
                    worldview: s
                }, i, n, void 0, r), u = this.expression.evaluate({
                    zoom: this.context.zoom + 1,
                    brightness: a,
                    worldview: s
                }, i, n, void 0, r), c = nh(this.lutExpression, i, n, r, void 0, a, void 0, s);
                this._setPaintValue(e1, t1, l, u, c ? null : this.context.lut);
            }
            _setPaintValue(e1, t1, i, n, r) {
                if ("color" === this.type) {
                    const o = ih(i.toPremultipliedRenderColor(r)), a = ih(n.toPremultipliedRenderColor(r));
                    for(let i = e1; i < t1; i++)this.paintVertexArray.emplace(i, o[0], o[1], a[0], a[1]);
                } else {
                    for(let r = e1; r < t1; r++)this.paintVertexArray.emplace(r, i, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(i), Math.abs(n));
                }
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(e1, t1, i, n, r) {
                const o = this.useIntegerZoom ? Math.floor(i.zoom) : i.zoom, a = tt(this.expression.interpolationFactor(o, this.context.zoom, this.context.zoom + 1), 0, 1);
                t1.set(e1, r, a);
            }
            getBinding(e1, t1) {
                return new qc(e1);
            }
        }
        class lh {
            constructor(e1, t1, i, n, r){
                this.expression = e1, this.layerId = r, this.paintVertexAttributes = ("array" === i ? Uc : Vc).members;
                for(let e1 = 0; e1 < t1.length; ++e1);
                this.paintVertexArray = new n, this.paintTransitionVertexArray = new qu;
            }
            populatePaintArray(e1, t1, i, n) {
                const r = this.paintVertexArray.length;
                this.paintVertexArray.resize(e1), this._setPaintValues(r, e1, t1.patterns && t1.patterns[this.layerId], i);
            }
            updatePaintArray(e1, t1, i, n, r, o, a) {
                this._setPaintValues(e1, t1, i.patterns && i.patterns[this.layerId], o);
            }
            _setPaintValues(e1, t1, i, n) {
                if (!n || !i) return;
                const r = n[i[0]], o = n[i[1]];
                if (r) {
                    if (r) {
                        const { tl: i, br: n, pixelRatio: o } = r;
                        for(let r = e1; r < t1; r++)this.paintVertexArray.emplace(r, i[0], i[1], n[0], n[1], o);
                    }
                    if (o) {
                        this.paintTransitionVertexArray.resize(this.paintVertexArray.length);
                        const { tl: i, br: n } = o;
                        for(let r = e1; r < t1; r++)this.paintTransitionVertexArray.emplace(r, i[0], i[1], n[0], n[1]);
                    }
                }
            }
            upload(e1) {
                const t1 = this.expression.isStateDependent || !this.expression.isLightConstant;
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, t1)), this.paintTransitionVertexArray && this.paintTransitionVertexArray.length && (this.paintTransitionVertexBuffer = e1.createVertexBuffer(this.paintTransitionVertexArray, kc.members, t1));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy(), this.paintTransitionVertexBuffer && this.paintTransitionVertexBuffer.destroy();
            }
        }
        class uh {
            constructor(e1, t1, i = ()=>!0){
                this.binders = {}, this._buffers = [], this.context = t1;
                const n = [], r = e1;
                for(const o in e1.paint._values){
                    const a = r.paint.get(o);
                    if (o.endsWith("-use-theme")) continue;
                    if (!i(o)) continue;
                    if (!(a instanceof Ws && wa(a.property.specification))) continue;
                    const s = dh(o, e1.type), l = a.value, u = a.property.specification.type, c = !!a.property.useIntegerZoom, h = "line-dasharray" === o || o.endsWith("pattern"), d = r.paint.get(`${o}-use-theme`), f = "line-dasharray" === o && "constant" !== r.layout.get("line-cap").value.kind || d && "constant" !== d.value.kind;
                    if ("constant" !== l.kind || f) {
                        if ("source" === l.kind || f || h) {
                            const t1 = _h(o, u, "source");
                            this.binders[o] = h ? new lh(l, s, u, t1, e1.id) : new ah(l, s, u, t1), n.push(`/a_${o}`);
                        } else {
                            const e1 = _h(o, u, "composite");
                            this.binders[o] = new sh(l, s, u, c, t1, e1), n.push(`/z_${o}`);
                        }
                    } else this.binders[o] = h ? new oh(l.value, s) : new rh(l.value, s, u, t1), n.push(`/u_${o}`);
                    d && (this.binders[o].lutExpression = d.value);
                }
                this.cacheKey = n.sort().join("");
            }
            updateExpressions(e1) {
                const t1 = e1;
                for(const e1 in this.binders){
                    const i = this.binders[e1];
                    if (i instanceof ah || i instanceof sh || i instanceof lh) {
                        const n = t1.paint.get(e1);
                        i.expression = n.value;
                    }
                }
            }
            getMaxValue(e1) {
                const t1 = this.binders[e1];
                return t1 instanceof ah || t1 instanceof sh ? t1.maxValue : 0;
            }
            populatePaintArrays(e1, t1, i, n, r, o, a, s) {
                for(const l in this.binders){
                    const u = this.binders[l];
                    u.context = this.context, (u instanceof ah || u instanceof sh || u instanceof lh) && u.populatePaintArray(e1, t1, i, n, r, o, a, s);
                }
            }
            setConstantPatternPositions(e1, t1) {
                for(const i in this.binders){
                    const n = this.binders[i];
                    n instanceof oh && n.setConstantPatternPositions(e1, t1);
                }
            }
            getPatternTransitionVertexBuffer(e1) {
                const t1 = this.binders[e1];
                return t1 instanceof lh ? t1.paintTransitionVertexBuffer : null;
            }
            updatePaintArrays(e1, t1, i, n, r, o, a, s, l, u) {
                let c = !1;
                const h = Object.keys(e1), d = 0 !== h.length && !s, f = d ? h : t1.uniqueIds;
                this.context.lut = r.lut;
                for(const s in this.binders){
                    const h = this.binders[s];
                    if (h.context = this.context, (h instanceof ah || h instanceof sh || h instanceof lh) && h.expression && h.expression.kind && "constant" !== h.expression.kind && (!0 === h.expression.isStateDependent || !1 === h.expression.isLightConstant)) {
                        const p = r.paint.get(s);
                        h.expression = p.value;
                        for (const i of f){
                            const r = e1[i.toString()];
                            t1.eachPosition(i, (e1, t1, i)=>{
                                const s = n.feature(e1);
                                h.updatePaintArray(t1, i, s, r, o, a, l, u);
                            });
                        }
                        if (!d) for (const t1 of i.uniqueIds){
                            const r = e1[t1.toString()];
                            i.eachPosition(t1, (e1, t1, i)=>{
                                const s = n.feature(e1);
                                h.updatePaintArray(t1, i, s, r, o, a, l, u);
                            });
                        }
                        c = !0;
                    }
                }
                return c;
            }
            defines() {
                const e1 = [];
                for(const t1 in this.binders){
                    const i = this.binders[t1];
                    (i instanceof rh || i instanceof oh) && e1.push(...i.uniformNames.map((e1)=>`#define HAS_UNIFORM_${e1}`));
                }
                return e1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(e1) {
                const t1 = [];
                for(const i in this.binders){
                    const n = this.binders[i];
                    if (n instanceof rh || n instanceof oh || n instanceof sh) for (const r of n.uniformNames)t1.push({
                        name: r,
                        property: i,
                        binding: n.getBinding(e1, r)
                    });
                }
                return t1;
            }
            setUniforms(e1, t1, i, n, r) {
                for (const { name: t1, property: o, binding: a } of i)this.binders[o].setUniform(e1, a, r, n.get(o), t1);
            }
            updatePaintBuffers() {
                this._buffers = [];
                for(const e1 in this.binders){
                    const t1 = this.binders[e1];
                    (t1 instanceof ah || t1 instanceof sh || t1 instanceof lh) && t1.paintVertexBuffer && this._buffers.push(t1.paintVertexBuffer), t1 instanceof lh && t1.paintTransitionVertexBuffer && this._buffers.push(t1.paintTransitionVertexBuffer);
                }
            }
            upload(e1) {
                for(const t1 in this.binders){
                    const i = this.binders[t1];
                    (i instanceof ah || i instanceof sh || i instanceof lh) && i.upload(e1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const e1 in this.binders){
                    const t1 = this.binders[e1];
                    (t1 instanceof ah || t1 instanceof sh || t1 instanceof lh) && t1.destroy();
                }
            }
        }
        class ch {
            constructor(e1, t1, i = ()=>!0){
                this.programConfigurations = {};
                for (const n of e1)this.programConfigurations[n.id] = new uh(n, t1, i);
                this.needsUpload = !1, this._featureMap = new Gc, this._featureMapWithoutIds = new Gc, this._bufferOffset = 0, this._idlessCounter = 0;
            }
            populatePaintArrays(e1, t1, i, n, r, o, a, s, l) {
                for(const i in this.programConfigurations)this.programConfigurations[i].populatePaintArrays(e1, t1, n, r, o, a, s, l);
                void 0 !== t1.id ? this._featureMap.add(t1.id, i, this._bufferOffset, e1) : (this._featureMapWithoutIds.add(this._idlessCounter, i, this._bufferOffset, e1), this._idlessCounter += 1), this._bufferOffset = e1, this.needsUpload = !0;
            }
            updatePaintArrays(e1, t1, i, n, r, o, a, s) {
                for (const l of i)this.needsUpload = this.programConfigurations[l.id].updatePaintArrays(e1, this._featureMap, this._featureMapWithoutIds, t1, l, n, r, o, a || 0, s) || this.needsUpload;
            }
            get(e1) {
                return this.programConfigurations[e1];
            }
            upload(e1) {
                if (this.needsUpload) {
                    for(const t1 in this.programConfigurations)this.programConfigurations[t1].upload(e1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const e1 in this.programConfigurations)this.programConfigurations[e1].destroy();
            }
            updateExpressions(e1) {
                const t1 = new Set;
                for (const i of e1){
                    const e1 = this.programConfigurations[i.id];
                    e1 && (e1.updateExpressions(i), t1.add(i.id));
                }
                for(const e1 in this.programConfigurations)t1.has(e1) || delete this.programConfigurations[e1];
            }
        }
        const hh = {
            "text-opacity": [
                "opacity"
            ],
            "icon-opacity": [
                "opacity"
            ],
            "text-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "icon-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "text-color": [
                "fill_color"
            ],
            "icon-color": [
                "fill_color"
            ],
            "text-emissive-strength": [
                "emissive_strength"
            ],
            "icon-emissive-strength": [
                "emissive_strength"
            ],
            "text-halo-color": [
                "halo_color"
            ],
            "icon-halo-color": [
                "halo_color"
            ],
            "text-halo-blur": [
                "halo_blur"
            ],
            "icon-halo-blur": [
                "halo_blur"
            ],
            "text-halo-width": [
                "halo_width"
            ],
            "icon-halo-width": [
                "halo_width"
            ],
            "symbol-z-offset": [
                "z_offset"
            ],
            "line-gap-width": [
                "gapwidth"
            ],
            "line-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "fill-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "fill-extrusion-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "line-dasharray": [
                "dash"
            ],
            "fill-bridge-guard-rail-color": [
                "structure_color"
            ],
            "fill-tunnel-structure-color": [
                "structure_color"
            ]
        };
        function dh(e1, t1) {
            return hh[e1] || [
                e1.replace(`${t1}-`, "").replace(/-/g, "_")
            ];
        }
        const fh = {
            "line-pattern": {
                source: Wu,
                composite: Wu
            },
            "fill-pattern": {
                source: Wu,
                composite: Wu
            },
            "fill-extrusion-pattern": {
                source: Wu,
                composite: Wu
            },
            "line-dasharray": {
                source: qu,
                composite: qu
            }
        }, ph = {
            color: {
                source: fc,
                composite: Ku
            },
            number: {
                source: ku,
                composite: fc
            }
        };
        function _h(e1, t1, i) {
            const n = fh[e1];
            return n && n[i] || ph[t1][i];
        }
        Ha(rh, "ConstantBinder"), Ha(oh, "PatternConstantBinder"), Ha(ah, "SourceExpressionBinder", {
            omit: [
                "expression"
            ]
        }), Ha(lh, "PatternCompositeBinder", {
            omit: [
                "expression"
            ]
        }), Ha(sh, "CompositeExpressionBinder", {
            omit: [
                "expression"
            ]
        }), Ha(uh, "ProgramConfiguration", {
            omit: [
                "_buffers"
            ]
        }), Ha(ch, "ProgramConfigurationSet");
        class mh {
            constructor(e1, t1, i){
                this.layoutVertexArray = new Bu, this.indexArray = new oc, this.lineIndexArray = new ec, this.triangleSegments = new Bc, this.lineSegments = new Bc, this.programConfigurations = new ch(e1, {
                    zoom: t1,
                    lut: i
                }), this.uploaded = !1;
            }
            update(e1, t1, i, n, r, o, a, s) {
                this.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, s);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            needsUpload() {
                return this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, Cc.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.lineIndexBuffer = e1.createIndexBuffer(this.lineIndexArray)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.lineIndexBuffer.destroy(), this.programConfigurations.destroy(), this.triangleSegments.destroy(), this.lineSegments.destroy());
            }
            populatePaintArrays(e1, t1, i, n, r, o, a) {
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, t1, i, n, r, o, void 0, a);
            }
        }
        Ha(mh, "FillBufferData");
        class gh {
            constructor(e1){
                this.zoom = e1.zoom, this.pixelRatio = e1.pixelRatio, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.patternFeatures = [], this.lut = e1.lut, this.bufferData = new mh(e1.layers, e1.zoom, e1.lut), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.projection = e1.projection, this.sourceLayerIndex = e1.sourceLayerIndex, this.sourceLayerName = e1.sourceLayerName || "", this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                this.hasPattern = eu("fill", this.layers, this.pixelRatio, t1);
                const r = this.layers[0].layout.get("fill-sort-key"), o = [];
                for (const { feature: a, id: s, index: l, sourceLayerIndex: u } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = Ru(a, e1);
                    if (!this.layers[0]._featureFilter.filter(new ks(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), c, i)) continue;
                    const h = r ? r.evaluate(c, {}, i, t1.availableImages) : void 0, d = {
                        id: s,
                        properties: a.properties,
                        type: a.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: e1 ? c.geometry : zu(a, i, n),
                        patterns: {},
                        sortKey: h
                    };
                    o.push(d);
                }
                r && o.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                for (const n of o){
                    const { geometry: r, index: o, sourceLayerIndex: a } = n;
                    if (this.hasPattern) {
                        const e1 = tu("fill", this.layers, n, this.zoom, this.pixelRatio, t1);
                        this.patternFeatures.push(e1);
                    } else this.addFeature(n, r, o, i, {}, t1.availableImages, t1.brightness, t1.elevationFeatures);
                    t1.featureIndex.insert(e1[o].feature, r, o, a, this.index);
                }
                !this.hasPattern && this.hdExt && this.hdExt.buildFrcSegments(this);
            }
            update(e1, t1, i, n, r, o, a) {
                this.bufferData.update(e1, t1, i, n, r, o, a, this.worldview), this.hdExt && this.hdExt.update(e1, t1, i, n, r, o, a, this.worldview);
            }
            updateExpressions(e1) {
                this.bufferData.programConfigurations.updateExpressions(e1), this.hdExt && this.hdExt.updateExpressions(e1);
            }
            addFeatures(e1, t1, i, n, r, o) {
                for (const r of this.patternFeatures)this.addFeature(r, r.geometry, r.index, t1, i, n, o, e1.elevationFeatures);
                this.hdExt && this.hdExt.buildFrcSegments(this);
            }
            isEmpty() {
                return this.bufferData.isEmpty() && (!this.hdExt || this.hdExt.isEmpty());
            }
            uploadPending() {
                return !this.uploaded || this.bufferData.needsUpload() || null != this.hdExt && this.hdExt.needsUpload();
            }
            upload(e1) {
                this.bufferData.upload(e1), this.hdExt && this.hdExt.upload(e1);
            }
            destroy() {
                this.bufferData.destroy(), this.hdExt && this.hdExt.destroy();
            }
            addFeature(e1, t1, i, n, r, o = [], a, s) {
                const l = this.hdExt ? this.hdExt.trackFeatureFrc(e1.properties) : null, u = this.bufferData.indexArray.length, c = Ne(t1, 500);
                null != this.hdExt && this.hdExt.handleFeature(e1, c, i, n, s, this) || this.addGeometry(c, this.bufferData), this.bufferData.populatePaintArrays(e1, i, r, o, n, a, this.worldview), this.hdExt && this.hdExt.populatePaintArrays(e1, i, r, o, n, a, this.worldview), this.hdExt && this.hdExt.recordFeatureRange(this, u, this.bufferData.indexArray.length, l);
            }
            addGeometry(e1, t1, i, n) {
                let r = Number.POSITIVE_INFINITY, o = Number.NEGATIVE_INFINITY, a = null;
                i && (a = i.elevationSampler.constantElevation(i.elevation, i.bias), null != a && (r = a, o = a));
                const s = i ? t1 : null, l = (e1, t1, n)=>{
                    if (null != i) {
                        if (t1.push(e1), null != a) s.elevatedLayoutVertexArray.emplaceBack(a), n.push(a);
                        else {
                            const t1 = i.elevationSampler.pointElevation(e1, i.elevation, i.bias);
                            s.elevatedLayoutVertexArray.emplaceBack(t1), n.push(t1), r = Math.min(r, t1), o = Math.max(o, t1);
                        }
                    }
                };
                for (const r of e1){
                    let e1 = 0;
                    for (const t1 of r)e1 += t1.length;
                    const o = t1.triangleSegments.prepareSegment(e1, t1.layoutVertexArray, t1.indexArray), a = o.vertexLength, s = [], u = [], c = [], h = [], d = [], f = t1.layoutVertexArray.length;
                    for (const e1 of r){
                        if (0 === e1.length) continue;
                        e1 !== r[0] && u.push(s.length / 2);
                        const n = t1.lineSegments.prepareSegment(e1.length, t1.layoutVertexArray, t1.lineIndexArray), o = n.vertexLength;
                        i && d.push(t1.layoutVertexArray.length - f), l(e1[0], c, h), t1.layoutVertexArray.emplaceBack(e1[0].x, e1[0].y), t1.lineIndexArray.emplaceBack(o + e1.length - 1, o), s.push(e1[0].x), s.push(e1[0].y);
                        for(let i = 1; i < e1.length; i++)l(e1[i], c, h), t1.layoutVertexArray.emplaceBack(e1[i].x, e1[i].y), t1.lineIndexArray.emplaceBack(o + i - 1, o + i), s.push(e1[i].x), s.push(e1[i].y);
                        n.vertexLength += e1.length, n.primitiveLength += e1.length;
                    }
                    const p = Ml(s, u);
                    for(let e1 = 0; e1 < p.length; e1 += 3)t1.indexArray.emplaceBack(a + p[e1], a + p[e1 + 1], a + p[e1 + 2]);
                    if (p.length > 0 && i && n) {
                        const e1 = i.elevation.isTunnel(), t1 = i.elevation.safeArea, r = n.addVertices(c, h);
                        n.addTriangles(p, r, e1);
                        const o = d.length;
                        if (o > 0) {
                            for(let a = 0; a < o - 1; a++)n.addRenderableRing(i.index, d[a] + r, d[a + 1] - d[a], e1, t1, i.featureInfo);
                            n.addRenderableRing(i.index, d[o - 1] + r, c.length - d[o - 1], e1, t1, i.featureInfo);
                        }
                    }
                    o.vertexLength += e1, o.primitiveLength += p.length / 3;
                }
                return [
                    r,
                    o
                ];
            }
        }
        Ha(gh, "FillBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        const yh = Ou([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            },
            {
                name: "a_linesofar",
                components: 1,
                type: "Float32"
            }
        ], 4), xh = Ou([
            {
                name: "a_z_offset_width",
                components: 4,
                type: "Float32"
            }
        ], 4), vh = Ou([
            {
                name: "a_elevation_id_col",
                components: 3,
                type: "Float32"
            }
        ], 4), bh = Ou([
            {
                name: "a_elevation_ground_scale",
                components: 1,
                type: "Float32"
            }
        ], 4), { members: wh } = yh, Eh = Ou([
            {
                name: "a_packed",
                components: 3,
                type: "Float32"
            }
        ]), { members: Ah } = Eh, Ih = Ou([
            {
                name: "a_pattern_data",
                components: 3,
                type: "Float32"
            }
        ]), { members: Th } = Ih;
        class Mh {
            constructor(e1, t1, i, n, r){
                for(this.properties = Object.create(null), this.extent = i, this.type = 0, this.id = void 0, this._pbf = e1, this._geometry = -1, this._keys = n, this._values = r; e1.pos < t1;){
                    const t1 = e1.readVarint();
                    if (8 === t1) this.id = e1.readVarint();
                    else if (18 === t1) {
                        const t1 = e1.readVarint() + e1.pos;
                        for(; e1.pos < t1;){
                            const t1 = n[e1.readVarint()], i = r[e1.readVarint()];
                            this.properties[t1] = i;
                        }
                    } else 24 === t1 ? this.type = e1.readVarint() : 34 === t1 ? (this._geometry = e1.pos, e1.skip(t1)) : e1.skip(t1);
                }
            }
            loadGeometry() {
                if (this._geometry < 0) throw new Error("feature has no geometry");
                const e1 = this._pbf;
                e1.pos = this._geometry;
                const t1 = e1.readVarint() + e1.pos, i = [];
                let n, r = 1, o = 0, a = 0, s = 0;
                for(; e1.pos < t1;){
                    if (o <= 0) {
                        const t1 = e1.readVarint();
                        if (r = 7 & t1, o = t1 >> 3, 0 === o) continue;
                    }
                    if (o--, 1 === r) a += e1.readSVarint(), s += e1.readSVarint(), n && i.push(n), n = [
                        new Pe(a, s)
                    ];
                    else if (2 === r) a += e1.readSVarint(), s += e1.readSVarint(), n && n.push(new Pe(a, s));
                    else {
                        if (7 !== r) throw new Error(`unknown command ${r}`);
                        n && n.push(n[0].clone());
                    }
                }
                return n && i.push(n), i;
            }
            bbox() {
                if (this._geometry < 0) throw new Error("feature has no geometry");
                const e1 = this._pbf;
                e1.pos = this._geometry;
                const t1 = e1.readVarint() + e1.pos;
                let i = 1, n = 0, r = 0, o = 0, a = 1 / 0, s = -1 / 0, l = 1 / 0, u = -1 / 0;
                for(; e1.pos < t1;){
                    if (n <= 0) {
                        const t1 = e1.readVarint();
                        if (i = 7 & t1, n = t1 >> 3, 0 === n) continue;
                    }
                    if (n--, 1 === i || 2 === i) r += e1.readSVarint(), o += e1.readSVarint(), r < a && (a = r), r > s && (s = r), o < l && (l = o), o > u && (u = o);
                    else if (7 !== i) throw new Error(`unknown command ${i}`);
                }
                return [
                    a,
                    l,
                    s,
                    u
                ];
            }
            toGeoJSON(e1, t1, i) {
                const n = this.extent * Math.pow(2, i), r = this.extent * e1, o = this.extent * t1, a = this.loadGeometry();
                function s(e1) {
                    return [
                        360 * (e1.x + r) / n - 180,
                        360 / Math.PI * Math.atan(Math.exp((1 - 2 * (e1.y + o) / n) * Math.PI)) - 90
                    ];
                }
                function l(e1) {
                    return e1.map(s);
                }
                let u;
                if (1 === this.type) {
                    const e1 = [];
                    for (const t1 of a)e1.push(t1[0]);
                    const t1 = l(e1);
                    u = 1 === e1.length ? {
                        type: "Point",
                        coordinates: t1[0]
                    } : {
                        type: "MultiPoint",
                        coordinates: t1
                    };
                } else if (2 === this.type) {
                    const e1 = a.map(l);
                    u = 1 === e1.length ? {
                        type: "LineString",
                        coordinates: e1[0]
                    } : {
                        type: "MultiLineString",
                        coordinates: e1
                    };
                } else {
                    if (3 !== this.type) throw new Error("unknown feature type");
                    {
                        const e1 = function(e1) {
                            const t1 = e1.length;
                            if (t1 <= 1) return [
                                e1
                            ];
                            const i = [];
                            let n, r;
                            for(let o = 0; o < t1; o++){
                                const t1 = Sh(e1[o]);
                                0 !== t1 && (void 0 === r && (r = t1 < 0), r === t1 < 0 ? (n && i.push(n), n = [
                                    e1[o]
                                ]) : n && n.push(e1[o]));
                            }
                            return n && i.push(n), i;
                        }(a), t1 = [];
                        for (const i of e1)t1.push(i.map(l));
                        u = 1 === t1.length ? {
                            type: "Polygon",
                            coordinates: t1[0]
                        } : {
                            type: "MultiPolygon",
                            coordinates: t1
                        };
                    }
                }
                const c = {
                    type: "Feature",
                    geometry: u,
                    properties: this.properties
                };
                return null != this.id && (c.id = this.id), c;
            }
        }
        function Sh(e1) {
            let t1 = 0;
            for(let i, n, r = 0, o = e1.length, a = o - 1; r < o; a = r++)i = e1[r], n = e1[a], t1 += (n.x - i.x) * (i.y + n.y);
            return t1;
        }
        Mh.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class zh {
            constructor(e1, t1){
                for(this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = e1, this._keys = [], this._values = [], this._features = [], void 0 === t1 && (t1 = e1.length); e1.pos < t1;){
                    const t1 = e1.readVarint();
                    10 === t1 ? this.name = e1.readString() : 18 === t1 ? (this._features.push(e1.pos), e1.skip(t1)) : 26 === t1 ? this._keys.push(e1.readString()) : 34 === t1 ? this._values.push(Rh(e1)) : 40 === t1 ? this.extent = e1.readVarint() : 120 === t1 ? this.version = e1.readVarint() : e1.skip(t1);
                }
                this.length = this._features.length;
            }
            feature(e1) {
                if (e1 < 0 || e1 >= this._features.length) throw new Error("feature index out of bounds");
                this._pbf.pos = this._features[e1];
                const t1 = this._pbf.readVarint() + this._pbf.pos;
                return new Mh(this._pbf, t1, this.extent, this._keys, this._values);
            }
        }
        function Rh(e1) {
            let t1 = null;
            const i = e1.readVarint() + e1.pos;
            for(; e1.pos < i;){
                const i = e1.readVarint();
                t1 = 10 === i ? e1.readString() : 21 === i ? e1.readFloat() : 25 === i ? e1.readDouble() : 32 === i ? e1.readVarint(!0) : 40 === i ? e1.readVarint() : 48 === i ? e1.readSVarint() : 56 === i ? e1.readBoolean() : (e1.skip(i), null);
            }
            if (null == t1) throw new Error("unknown feature value");
            return t1;
        }
        class Ph {
            constructor(e1, t1 = e1.length){
                const i = Object.create(null);
                for(; e1.pos < t1;){
                    const t1 = e1.readVarint();
                    if (26 === t1) {
                        const t1 = new zh(e1, e1.readVarint() + e1.pos);
                        t1.length && (i[t1.name] = t1);
                    } else e1.skip(t1);
                }
                this.layers = i;
            }
        }
        function Dh(e1, t1) {
            for(let i = 0; i < e1.length; i++)if (jh(t1, e1[i])) return !0;
            for(let i = 0; i < t1.length; i++)if (jh(e1, t1[i])) return !0;
            return !!Lh(e1, t1);
        }
        function Ch(e1, t1, i) {
            return !!jh(e1, t1) || !!kh(t1, e1, i);
        }
        function Fh(e1, t1) {
            if (1 === e1.length) return Gh(t1, e1[0]);
            for(let i = 0; i < t1.length; i++){
                const n = t1[i];
                for(let t1 = 0; t1 < n.length; t1++)if (jh(e1, n[t1])) return !0;
            }
            for(let i = 0; i < e1.length; i++)if (Gh(t1, e1[i])) return !0;
            for(let i = 0; i < t1.length; i++)if (Lh(e1, t1[i])) return !0;
            return !1;
        }
        function Oh(e1, t1, i) {
            if (e1.length > 1) {
                if (Lh(e1, t1)) return !0;
                for(let n = 0; n < t1.length; n++)if (kh(t1[n], e1, i)) return !0;
            }
            for(let n = 0; n < e1.length; n++)if (kh(e1[n], t1, i)) return !0;
            return !1;
        }
        function Lh(e1, t1) {
            if (0 === e1.length || 0 === t1.length) return !1;
            for(let i = 0; i < e1.length - 1; i++){
                const n = e1[i], r = e1[i + 1];
                for(let e1 = 0; e1 < t1.length - 1; e1++)if (Bh(n, r, t1[e1], t1[e1 + 1])) return !0;
            }
            return !1;
        }
        function Bh(e1, t1, i, n) {
            return gt(e1, i, n) !== gt(t1, i, n) && gt(e1, t1, i) !== gt(e1, t1, n);
        }
        function Nh(e1, t1, i) {
            return (e1.x - i.x) * (t1.y - i.y) - (e1.y - i.y) * (t1.x - i.x);
        }
        function Vh(e1, t1, i, n) {
            const r = Nh(e1, t1, n), o = Nh(e1, t1, i);
            if (Math.sign(r) === Math.sign(o)) return;
            const a = Nh(i, n, e1), s = a + o - r;
            return Math.sign(a) !== Math.sign(s) ? [
                a / (a - s),
                o / (o - r)
            ] : void 0;
        }
        function kh(e1, t1, i) {
            const n = i * i;
            if (1 === t1.length) return e1.distSqr(t1[0]) < n;
            for(let i = 1; i < t1.length; i++)if (Uh(e1, t1[i - 1], t1[i]) < n) return !0;
            return !1;
        }
        function Uh(e1, t1, i) {
            const n = t1.distSqr(i);
            if (0 === n) return e1.distSqr(t1);
            const r = ((e1.x - t1.x) * (i.x - t1.x) + (e1.y - t1.y) * (i.y - t1.y)) / n;
            return e1.distSqr(r < 0 ? t1 : r > 1 ? i : i.sub(t1)._mult(r)._add(t1));
        }
        function Gh(e1, t1) {
            let i, n, r, o = !1;
            for(let a = 0; a < e1.length; a++){
                i = e1[a];
                for(let e1 = 0, a = i.length - 1; e1 < i.length; a = e1++)n = i[e1], r = i[a], n.y > t1.y != r.y > t1.y && t1.x < (r.x - n.x) * (t1.y - n.y) / (r.y - n.y) + n.x && (o = !o);
            }
            return o;
        }
        function jh(e1, t1) {
            let i = !1;
            for(let n = 0, r = e1.length - 1; n < e1.length; r = n++){
                const o = e1[n], a = e1[r];
                o.y > t1.y != a.y > t1.y && t1.x < (a.x - o.x) * (t1.y - o.y) / (a.y - o.y) + o.x && (i = !i);
            }
            return i;
        }
        function Hh(e1, t1, i, n, r) {
            for (const o of e1)if (t1 <= o.x && i <= o.y && n >= o.x && r >= o.y) return !0;
            const o = [
                new Pe(t1, i),
                new Pe(t1, r),
                new Pe(n, r),
                new Pe(n, i)
            ];
            if (e1.length > 2) {
                for (const t1 of o)if (jh(e1, t1)) return !0;
            }
            for(let t1 = 0; t1 < e1.length - 1; t1++)if ($h(e1[t1], e1[t1 + 1], o)) return !0;
            return !1;
        }
        function $h(e1, t1, i) {
            const n = i[0], r = i[2];
            if (e1.x < n.x && t1.x < n.x || e1.x > r.x && t1.x > r.x || e1.y < n.y && t1.y < n.y || e1.y > r.y && t1.y > r.y) return !1;
            const o = gt(e1, t1, i[0]);
            return o !== gt(e1, t1, i[1]) || o !== gt(e1, t1, i[2]) || o !== gt(e1, t1, i[3]);
        }
        function Zh(e1, t1, i, n, r, o) {
            let a = t1.y - e1.y, s = e1.x - t1.x;
            if (o = o || 0) {
                const e1 = a * a + s * s;
                if (0 === e1) return !0;
                const t1 = Math.sqrt(e1);
                a /= t1, s /= t1;
            }
            return !((i.x - e1.x) * a + (i.y - e1.y) * s - o < 0 || (n.x - e1.x) * a + (n.y - e1.y) * s - o < 0 || (r.x - e1.x) * a + (r.y - e1.y) * s - o < 0);
        }
        function Wh(e1, t1, i, n, r, o, a) {
            return !(Zh(e1, t1, n, r, o, a) || Zh(t1, i, n, r, o, a) || Zh(i, e1, n, r, o, a) || Zh(n, r, e1, t1, i, a) || Zh(r, o, e1, t1, i, a) || Zh(o, n, e1, t1, i, a));
        }
        class qh extends Pe {
            constructor(e1, t1, i){
                super(e1, t1), this.z = i;
            }
        }
        class Xh extends qh {
            constructor(e1, t1, i, n){
                super(e1, t1, i), this.w = n;
            }
        }
        function Yh(e1, t1, i, n) {
            const r = "x" === i ? "y" : "x", o = (n - e1[i]) / (t1[i] - e1[i]);
            e1[r] = Math.round(e1[r] + (t1[r] - e1[r]) * o), e1[i] = n, Object.hasOwn(e1, "z") && (e1.z = dn(e1.z, t1.z, o)), Object.hasOwn(e1, "w") && (e1.w = dn(e1.w, t1.w, o));
        }
        function Jh(e1, t1, i, n) {
            const r = i, o = n;
            for (const i of [
                "x",
                "y"
            ]){
                let n = e1, a = t1;
                n[i] >= a[i] && (n = t1, a = e1), n[i] < r && a[i] > r && Yh(n, a, i, r), n[i] < o && a[i] > o && Yh(a, n, i, o);
            }
        }
        function Kh(e1, t1, i, n, r, o) {
            const a = [];
            for(let s = 0; s < e1.length; s++){
                const l = e1[s];
                let u;
                const c = a.length;
                let h = 0;
                for(let e1 = 0; e1 < l.length - 1; e1++){
                    let c = l[e1], d = l[e1 + 1], f = 0;
                    const p = h;
                    let _, m;
                    o && (f = Math.hypot(d.x - c.x, d.y - c.y), h += f, _ = c, m = d), c.x < t1 && d.x < t1 || (c.x < t1 ? c = new Pe(t1, c.y + (t1 - c.x) / (d.x - c.x) * (d.y - c.y))._round() : d.x < t1 && (d = new Pe(t1, c.y + (t1 - c.x) / (d.x - c.x) * (d.y - c.y))._round()), c.y < i && d.y < i || (c.y < i ? c = new Pe(c.x + (i - c.y) / (d.y - c.y) * (d.x - c.x), i)._round() : d.y < i && (d = new Pe(c.x + (i - c.y) / (d.y - c.y) * (d.x - c.x), i)._round()), c.x >= n && d.x >= n || (c.x >= n ? c = new Pe(n, c.y + (n - c.x) / (d.x - c.x) * (d.y - c.y))._round() : d.x >= n && (d = new Pe(n, c.y + (n - c.x) / (d.x - c.x) * (d.y - c.y))._round()), c.y >= r && d.y >= r || (c.y >= r ? c = new Pe(c.x + (r - c.y) / (d.y - c.y) * (d.x - c.x), r)._round() : d.y >= r && (d = new Pe(c.x + (r - c.y) / (d.y - c.y) * (d.x - c.x), r)._round()), u && c.equals(u.at(-1)) || (u = [
                        c
                    ], a.push(u), o && o.push({
                        progress: {
                            min: p + ed(_, m, c) * f,
                            max: 1
                        },
                        parentIndex: s,
                        prevPoint: _,
                        nextPoint: m
                    })), u.push(d), o && (o.at(-1).progress.max = p + ed(_, m, d) * f, o.at(-1).nextPoint = m)))));
                }
                if (o && h > 0) for(let e1 = c; e1 < a.length; e1++)o[e1].progress.min /= h, o[e1].progress.max /= h;
            }
            return a;
        }
        function Qh(e1, t1, i, n, r) {
            if (e1.length < 2) return void n.push(e1);
            const o = [];
            for(; t1.valid();){
                const [i, n] = t1.get();
                for(let t1 = 0; t1 < e1.length - 1; t1++){
                    const r = e1[t1], a = e1[t1 + 1], s = Vh(r, a, i, n);
                    if (s) {
                        const [e1] = s, i = new Pe(dn(r.x, a.x, e1), dn(r.y, a.y, e1));
                        o.push({
                            t: t1 + e1,
                            distance: 0,
                            point: i
                        });
                    }
                }
                t1.next();
            }
            if (0 === o.length) return void n.push(e1);
            o.sort((e1, t1)=>e1.t - t1.t);
            let a = 0, s = 0, l = [];
            for(n.push(l); a !== e1.length;){
                if (s === o.length) {
                    for(; a !== e1.length;)0 !== l.length && l.at(-1).equals(e1[a]) || l.push(e1[a]), a++;
                    break;
                }
                o[s].t <= a ? (0 !== l.length && l.at(-1).equals(o[s].point) || l.push(o[s].point), o[s].t, s++) : (0 !== l.length && l.at(-1).equals(e1[a]) || l.push(e1[a]), a++);
            }
        }
        function ed(e1, t1, i) {
            return e1.x !== t1.x ? (i.x - e1.x) / (t1.x - e1.x) : e1.y !== t1.y ? (i.y - e1.y) / (t1.y - e1.y) : 0;
        }
        function td(e1, { width: t1, height: i }, n, r) {
            if (r) {
                if (r instanceof Uint8ClampedArray) r = new Uint8Array(r.buffer);
                else if (r.length !== t1 * i * n) throw new RangeError("mismatched image size");
            } else r = new Uint8Array(t1 * i * n);
            return e1.width = t1, e1.height = i, e1.data = r, e1;
        }
        function id(e1, t1, i) {
            const { width: n, height: r } = t1;
            n === e1.width && r === e1.height || (nd(e1, t1, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(e1.width, n),
                height: Math.min(e1.height, r)
            }, i, null), e1.width = n, e1.height = r, e1.data = t1.data);
        }
        function nd(e1, t1, i, n, r, o, a, s) {
            if (0 === r.width || 0 === r.height) return t1;
            if (r.width > e1.width || r.height > e1.height || i.x > e1.width - r.width || i.y > e1.height - r.height) throw new RangeError("out of range source coordinates for image copy");
            if (r.width > t1.width || r.height > t1.height || n.x > t1.width - r.width || n.y > t1.height - r.height) throw new RangeError("out of range destination coordinates for image copy");
            const l = e1.data, u = t1.data, c = 4 === o && s;
            for(let s = 0; s < r.height; s++){
                const h = ((i.y + s) * e1.width + i.x) * o, d = ((n.y + s) * t1.width + n.x) * o;
                if (c) for(let e1 = 0; e1 < r.width; e1++){
                    const t1 = h + e1 * o + 3, i = d + e1 * o;
                    u[i + 0] = 255, u[i + 1] = 255, u[i + 2] = 255, u[i + 3] = l[t1];
                }
                else if (a) for(let e1 = 0; e1 < r.width; e1++){
                    const t1 = h + e1 * o, i = d + e1 * o, n = new pn(l[t1 + 0] / 255, l[t1 + 1] / 255, l[t1 + 2] / 255, l[t1 + 3]).toNonPremultipliedRenderColor(a).toArray();
                    u[i + 0] = n[0], u[i + 1] = n[1], u[i + 2] = n[2], u[i + 3] = n[3];
                }
                else for(let e1 = 0; e1 < r.width * o; e1++)u[d + e1] = l[h + e1];
            }
            return t1;
        }
        class rd {
            constructor(e1, t1){
                td(this, e1, 1, t1);
            }
            resize(e1) {
                id(this, new rd(e1), 1);
            }
            clone() {
                return new rd({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e1, t1, i, n, r) {
                nd(e1, t1, i, n, r, 1, null);
            }
        }
        class od {
            constructor(e1, t1){
                td(this, e1, 4, t1);
            }
            resize(e1) {
                id(this, new od(e1), 4);
            }
            replace(e1, t1) {
                t1 ? this.data.set(e1) : this.data = e1 instanceof Uint8ClampedArray ? new Uint8Array(e1.buffer) : e1;
            }
            clone() {
                return new od({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e1, t1, i, n, r, o, a) {
                nd(e1, t1, i, n, r, 4, o, a);
            }
        }
        class ad {
            constructor(e1, t1){
                this.width = e1.width, this.height = e1.height, this.data = t1 instanceof Uint8Array ? new Float32Array(t1.buffer) : t1;
            }
        }
        Ha(rd, "AlphaImage"), Ha(od, "RGBAImage");
        class sd {
            constructor(e1, t1){
                this.width = e1, this.height = t1, this.nextRow = 0, this.image = new rd({
                    width: e1,
                    height: t1
                }), this.positions = {}, this.uploaded = !1;
            }
            getDash(e1, t1) {
                const i = this.getKey(e1, t1);
                return this.positions[i];
            }
            trim() {
                const e1 = this.width, t1 = this.height = lt(this.nextRow);
                this.image.resize({
                    width: e1,
                    height: t1
                });
            }
            getKey(e1, t1) {
                return e1.join(",") + t1;
            }
            getDashRanges(e1, t1, i) {
                const n = [];
                let r = e1.length % 2 == 1 ? -e1.at(-1) * i : 0, o = e1[0] * i, a = !0;
                n.push({
                    left: r,
                    right: o,
                    isDash: a,
                    zeroLength: 0 === e1[0]
                });
                let s = e1[0];
                for(let t1 = 1; t1 < e1.length; t1++){
                    a = !a;
                    const l = e1[t1];
                    r = s * i, s += l, o = s * i, n.push({
                        left: r,
                        right: o,
                        isDash: a,
                        zeroLength: 0 === l
                    });
                }
                return n;
            }
            addRoundDash(e1, t1, i) {
                const n = t1 / 2;
                for(let t1 = -i; t1 <= i; t1++){
                    const r = this.width * (this.nextRow + i + t1);
                    let o = 0, a = e1[o];
                    for(let s = 0; s < this.width; s++){
                        s / a.right > 1 && (a = e1[++o]);
                        const l = Math.abs(s - a.left), u = Math.abs(s - a.right), c = Math.min(l, u);
                        let h;
                        const d = t1 / i * (n + 1);
                        if (a.isDash) {
                            const e1 = n - Math.abs(d);
                            h = Math.sqrt(c * c + e1 * e1);
                        } else h = n - Math.sqrt(c * c + d * d);
                        this.image.data[r + s] = Math.max(0, Math.min(255, h + 128));
                    }
                }
            }
            addRegularDash(e1, t1) {
                for(let t1 = e1.length - 1; t1 >= 0; --t1){
                    const i = e1[t1], n = e1[t1 + 1];
                    i.zeroLength ? e1.splice(t1, 1) : n && n.isDash === i.isDash && (n.left = i.left, e1.splice(t1, 1));
                }
                const i = e1[0], n = e1.at(-1);
                i.isDash === n.isDash && (i.left = n.left - this.width, n.right = i.right + this.width);
                const r = this.width * this.nextRow;
                let o = 0, a = e1[o];
                for(let i = 0; i < this.width; i++){
                    i / a.right > 1 && (a = e1[++o]);
                    const n = Math.abs(i - a.left), s = Math.abs(i - a.right), l = Math.min(n, s);
                    this.image.data[r + i] = Math.max(0, Math.min(255, (a.isDash ? l : -l) + t1 + 128));
                }
            }
            addDash(e1, t1) {
                const i = this.getKey(e1, t1);
                if (this.positions[i]) return this.positions[i];
                const n = "round" === t1, r = n ? 7 : 0, o = 2 * r + 1;
                if (this.nextRow + o > this.height) return mt("LineAtlas out of space"), null;
                0 === e1.length && e1.push(1);
                let a = 0;
                for(let t1 = 0; t1 < e1.length; t1++)e1[t1] < 0 && (mt("Negative value is found in line dasharray, replacing values with 0"), e1[t1] = 0), a += e1[t1];
                if (0 !== a) {
                    const i = this.width / a, o = this.getDashRanges(e1, this.width, i);
                    n ? this.addRoundDash(o, i, r) : this.addRegularDash(o, "square" === t1 ? .5 * i : 0);
                }
                const s = this.nextRow + r;
                this.nextRow += o;
                const l = Math.floor(a), u = {
                    tl: [
                        s,
                        r
                    ],
                    br: [
                        l,
                        Math.round(65535 * (a - l))
                    ]
                };
                return this.positions[i] = u, u;
            }
        }
        Ha(sd, "LineAtlas");
        const ld = "3d_elevation_id", ud = "level", cd = Mh.types, hd = Math.cos(Math.PI / 180 * 37.5), dd = Math.cos(Math.PI / 180 * 5);
        class fd {
            constructor(e1){
                this.evaluationGlobals = {
                    zoom: 0,
                    lineProgress: void 0
                }, this.elevationType = "none", this.isSeaLevelReference = !1, this.showElevationIdDebug = !1, this.terrainEnabled = !1, this.zoom = e1.zoom, this.evaluationGlobals.zoom = this.zoom, this.overscaling = e1.overscaling, this.pixelRatio = e1.pixelRatio, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.projection = e1.projection, this.hasPattern = !1, this.hasCrossSlope = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.borderGradients = {}, this.layers.forEach((e1)=>{
                    this.gradients[e1.id] = {}, this.borderGradients[e1.id] = {};
                }), this.layoutVertexArray = new $u, this.layoutVertexArray2 = new Zu, this.patternVertexArray = new Zu, this.indexArray = new oc, this.programConfigurations = new ch(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }), this.segments = new Bc, this.sourceLayerName = e1.sourceLayerName || "", this.maxLineLength = 0, this.zOffsetVertexArray = new Ku, this.elevationIdColVertexArray = new Zu, this.elevationGroundScaleVertexArray = new ku, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.tessellationStep = e1.tessellationStep ? e1.tessellationStep : 128, this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                this.showElevationIdDebug = t1.showElevationIdDebug, this.terrainEnabled = t1.terrainEnabled, this.hasPattern = eu("line", this.layers, this.pixelRatio, t1);
                const r = this.layers[0].layout.get("line-sort-key");
                this.tileToMeter = vu(i);
                const o = this.layers[0].layout.get("line-elevation-reference");
                if ("hd-road-markup" === o) this.elevationType = "road";
                else {
                    const e1 = this.layers[0].layout.get("line-z-offset"), t1 = e1.isConstant() && !e1.constantOr(0);
                    this.elevationType = "sea" !== o && "ground" !== o && t1 ? "none" : "offset", "offset" === this.elevationType && "none" === o && mt(`line-elevation-reference: ground is used for the layer ${this.layerIds[0]} because non-zero line-z-offset value was found.`), this.isSeaLevelReference = "sea" === o;
                }
                const a = this.layers[0].layout.get("line-cross-slope");
                this.hasCrossSlope = "offset" === this.elevationType && void 0 !== a;
                const s = [];
                for (const { feature: o, id: a, index: l, sourceLayerIndex: u } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = Ru(o, e1);
                    if (!this.layers[0]._featureFilter.filter(new ks(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), c, i)) continue;
                    const h = r ? r.evaluate(c, {}, i) : void 0, d = {
                        id: a,
                        properties: o.properties,
                        type: o.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: e1 ? c.geometry : zu(o, i, n),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(d);
                }
                r && s.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                const { lineAtlas: l, featureIndex: u } = t1, c = this.addConstantDashes(l);
                for (const n of s){
                    const { geometry: r, index: o, sourceLayerIndex: a } = n;
                    if (c && this.addFeatureDashes(n, l), this.hasPattern) {
                        const e1 = tu("line", this.layers, n, this.zoom, this.pixelRatio, t1);
                        this.patternFeatures.push(e1);
                    } else this.addFeature(n, r, o, i, l.positions, t1.availableImages, t1.brightness, t1.elevationFeatures, t1.elevationParams, t1.crossSourceElevationEnabled);
                    u.insert(e1[o].feature, r, o, a, this.index);
                }
                !this.hasPattern && this.hdExt && this.hdExt.buildFrcSegments(this), this.hdExt && this.hdExt.endPopulate();
            }
            addConstantDashes(e1) {
                let t1 = !1;
                for (const i of this.layers){
                    const n = i.paint.get("line-dasharray").value, r = i.layout.get("line-cap").value;
                    if ("constant" !== n.kind || "constant" !== r.kind) t1 = !0;
                    else {
                        const t1 = r.value, i = n.value;
                        if (!i) continue;
                        e1.addDash(i, t1);
                    }
                }
                return t1;
            }
            addFeatureDashes(e1, t1) {
                const i = this.zoom;
                for (const n of this.layers){
                    const r = n.paint.get("line-dasharray").value, o = n.layout.get("line-cap").value;
                    if ("constant" === r.kind && "constant" === o.kind) continue;
                    let a, s;
                    if ("constant" === r.kind) {
                        if (a = r.value, !a) continue;
                    } else a = r.evaluate({
                        zoom: i
                    }, e1);
                    s = "constant" === o.kind ? o.value : o.evaluate({
                        zoom: i
                    }, e1), t1.addDash(a, s), e1.patterns[n.id] = [
                        t1.getKey(a, s)
                    ];
                }
            }
            update(e1, t1, i, n, r, o, a, s, l) {
                this.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, l);
            }
            updateExpressions(e1) {
                this.programConfigurations.updateExpressions(e1);
            }
            addFeatures(e1, t1, i, n, r, o) {
                for (const r of this.patternFeatures)this.addFeature(r, r.geometry, r.index, t1, i, n, o, e1.elevationFeatures, e1.elevationParams, e1.crossSourceElevationEnabled);
                this.hdExt && (this.hdExt.buildFrcSegments(this), this.hdExt.endPopulate());
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = e1.createVertexBuffer(this.layoutVertexArray2, Ah)), 0 !== this.patternVertexArray.length && (this.patternVertexBuffer = e1.createVertexBuffer(this.patternVertexArray, Th)), !this.zOffsetVertexBuffer && this.zOffsetVertexArray.length > 0 && (this.zOffsetVertexBuffer = e1.createVertexBuffer(this.zOffsetVertexArray, xh.members, !0)), !this.elevationIdColVertexBuffer && this.elevationIdColVertexArray.length > 0 && (this.elevationIdColVertexBuffer = e1.createVertexBuffer(this.elevationIdColVertexArray, vh.members, !0)), !this.elevationGroundScaleVertexBuffer && this.elevationGroundScaleVertexArray.length > 0 && (this.elevationGroundScaleVertexBuffer = e1.createVertexBuffer(this.elevationGroundScaleVertexArray, bh.members, !0)), this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, wh), this.indexBuffer = e1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.elevationIdColVertexBuffer && this.elevationIdColVertexBuffer.destroy(), this.elevationGroundScaleVertexBuffer && this.elevationGroundScaleVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(e1, t1) {
                let i, n;
                if (t1 && t1 > 0 ? (i = `mapbox_clip_start_${t1}`, n = `mapbox_clip_end_${t1}`) : (i = "mapbox_clip_start", n = "mapbox_clip_end"), e1.properties && Object.hasOwn(e1.properties, i) && Object.hasOwn(e1.properties, n)) return {
                    start: +e1.properties[i],
                    end: +e1.properties[n]
                };
            }
            addFeature(e1, t1, i, n, r, o, a, s, l, u) {
                const c = this.layers[0].layout, h = this.hdExt ? this.hdExt.trackFeatureFrc(e1.properties) : null, d = this.indexArray.length, f = c.get("line-join").evaluate(e1, {}), p = c.get("line-cap").evaluate(e1, {}), _ = c.get("line-miter-limit"), m = c.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(e1), this.lineFeature = e1;
                const g = !(!e1.properties || !Object.hasOwn(e1.properties, "mapbox_line_metrics")) && e1.properties.mapbox_line_metrics;
                this.zOffsetValue = c.get("line-z-offset").value;
                const y = this.layers[0].paint, x = y.get("line-width").value;
                "constant" !== x.kind && !1 === x.isLineProgressConstant && (this.variableWidthValue = x);
                const v = y.get("line-emissive-strength").value;
                if ("constant" !== v.kind && !1 === v.isLineProgressConstant && (this.variableEmissiveStrengthValue = v), this.isSeaLevelReference) {
                    const e1 = c.get("line-elevation-ground-scale").value;
                    "constant" === e1.kind && 0 === e1.value || (this.elevationGroundScaleValue = e1);
                }
                if (null == this.hdExt || !this.hdExt.handleFeature(e1, t1, n, s, l, !!u, f, p, _, m, this)) for(let i = 0; i < t1.length; i++)this.addLine(t1[i], e1, n, f, p, _, m, void 0, g && i > 0 ? i : null);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, r, o, n, a, void 0, this.worldview), this.hdExt && this.hdExt.recordFeatureRange(this, d, this.indexArray.length, h);
            }
            fillNonElevatedRoadSegment(e1) {
                for(let t1 = Math.max(e1, this.zOffsetVertexArray.length); t1 < this.layoutVertexArray.length; t1++)this.zOffsetVertexArray.emplaceBack(0, 0, 0, 0), this.showElevationIdDebug && this.elevationIdColVertexArray.emplaceBack(0, 0, 0);
            }
            addLine(e1, t1, i, n, r, o, a, s, l) {
                this.distance = 0, this.prevDistance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.totalFeatureLength = 0, this.lineSoFar = 0, this.currentVertex = void 0, this.lineClips = l ? this.lineFeatureClips(t1, l) : this.lineClips;
                const u = "none" === n;
                this.patternJoinNone = this.hasPattern && u, this.currentLineJoinType = n, this.segmentStart = 0, this.segmentStartf32 = 0, this.segmentPoints = [];
                const c = s && s.progress.min > 0, h = s && s.progress.max < 1;
                if (this.lineClips) {
                    let i = {
                        min: this.lineClips.start,
                        max: this.lineClips.end
                    }, n = 1;
                    if (s) {
                        const e1 = this.lineClips.end - this.lineClips.start;
                        i = function(e1, t1, i) {
                            return {
                                min: zt(e1.min, t1, i),
                                max: zt(e1.max, t1, i)
                            };
                        }(s.progress, {
                            min: 0,
                            max: 1
                        }, i), e1 > 0 && (n = (i.max - i.min) / e1);
                    }
                    const r = +t1.properties.mapbox_clip_feature_len, o = +t1.properties.mapbox_clip_seg_len;
                    if (Number.isNaN(r) || Number.isNaN(o)) {
                        for(let t1 = 0; t1 < e1.length - 1; t1++)this.totalDistance += e1[t1].dist(e1[t1 + 1]);
                        const t1 = this.totalDistance / (i.max - i.min);
                        this.totalFeatureLength = Number.isFinite(t1) ? t1 : 0, this.lineClips.start = i.min, this.lineClips.end = i.max, this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                    } else this.totalFeatureLength = r, this.distance = o * n, this.lineClips.start = i.min, this.lineClips.end = i.max, this.maxLineLength = Math.max(this.maxLineLength, this.distance);
                    this.lineClipsArray.push(this.lineClips), this.updateScaledDistance();
                }
                const d = "Polygon" === cd[t1.type];
                let f = e1.length;
                for(; f >= 2 && e1[f - 1].equals(e1[f - 2]);)f--;
                let p = 0;
                for(; p < f - 1 && e1[p].equals(e1[p + 1]);)p++;
                if (f < (d ? 3 : 2)) return;
                "bevel" === n && (o = 1.05);
                const _ = this.segments.prepareSegment(10 * f, this.layoutVertexArray, this.indexArray);
                let m, g, y, x, v, b, w, E;
                s && s.prevDir && (b = s.prevDir.perp()), s && s.nextDir && (w = s.nextDir.perp()), this.e1 = this.e2 = -1, d && (m = e1[f - 2], v = e1[p].sub(m)._unit()._perp());
                for(let t1 = p; t1 < f; t1++){
                    if (y = t1 === f - 1 ? d ? e1[p + 1] : void 0 : e1[t1 + 1], y && e1[t1].equals(y)) continue;
                    v && (x = v), m && (g = m), m = e1[t1], E = this.evaluateLineProgressFeatures(g ? g.dist(m) : 0), v = y ? y.sub(m)._unit()._perp() : x, x = x || v;
                    const i = g && y;
                    let s = i ? n : d || u ? "butt" : r;
                    const l = x.x * v.x + x.y * v.y;
                    if (u) {
                        const e1 = function(e1) {
                            if (e1.patternJoinNone) {
                                const t1 = e1.segmentPoints.length / 2, i = e1.lineSoFar - e1.segmentStart;
                                for(let n = 0; n < t1; ++n){
                                    const t1 = e1.segmentPoints[2 * n + 1], r = Math.round(e1.segmentPoints[2 * n]) + .5 + .25 * t1;
                                    e1.patternVertexArray.emplaceBack(r, i, e1.segmentStart), e1.patternVertexArray.emplaceBack(r, i, e1.segmentStart);
                                }
                                e1.segmentPoints.length = 0;
                            }
                            e1.e1 = e1.e2 = -1;
                        };
                        if (i && l < dd) {
                            this.updateDistance(g, m), this.addCurrentVertex(m, x, 1, 1, _, E), e1(this), this.addCurrentVertex(m, v, -1, -1, _, E);
                            continue;
                        }
                        if (g) {
                            if (!y) {
                                this.updateDistance(g, m), this.addCurrentVertex(m, x, 1, 1, _, E), e1(this);
                                continue;
                            }
                            s = "miter";
                        }
                    }
                    let A = x.add(v);
                    0 === A.x && 0 === A.y || A._unit();
                    const I = A.x * v.x + A.y * v.y, T = 0 !== I ? 1 / I : 1 / 0, M = 2 * Math.sqrt(2 - 2 * I), S = I < hd && g && y, z = x.x * v.y - x.y * v.x > 0, R = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0;
                    if (i && "round" === s) {
                        if (T < a) s = "miter";
                        else if (T <= 2) {
                            const e1 = pd(m, -10, 8202);
                            s = "offset" === this.elevationType && (e1 || this.hasCrossSlope) ? "miter" : "fakeround";
                        }
                    }
                    if ("miter" === s && T > o && (s = "bevel"), "bevel" === s && (T > 2 && (s = "flipbevel"), T < o && (s = "miter")), g && !("miter" === s && S) && this.updateDistance(g, m), "miter" === s) {
                        if (S) {
                            const e1 = m.dist(g);
                            if (e1 > 2 * R) {
                                const t1 = m.sub(m.sub(g)._mult(R / e1)._round());
                                this.updateDistance(g, t1), this.addCurrentVertex(t1, x, 0, 0, _, E), g = t1;
                            }
                            this.updateDistance(g, m), A._mult(T), this.addCurrentVertex(m, A, 0, 0, _, E);
                            const t1 = m.dist(y);
                            if (t1 > 2 * R) {
                                const e1 = m.add(y.sub(m)._mult(R / t1)._round());
                                this.updateDistance(m, e1), this.addCurrentVertex(e1, v, 0, 0, _, E), m = e1;
                            }
                        } else A._mult(T), this.addCurrentVertex(m, A, 0, 0, _, E);
                    } else if ("flipbevel" === s) {
                        if (T > 100) A = v.mult(-1);
                        else {
                            const e1 = T * x.add(v).mag() / x.sub(v).mag();
                            A._perp()._mult(e1 * (z ? -1 : 1));
                        }
                        this.addCurrentVertex(m, A, 0, 0, _, E), this.addCurrentVertex(m, A.mult(-1), 0, 0, _, E);
                    } else if ("bevel" === s || "fakeround" === s) {
                        const e1 = m.dist(g);
                        let t1 = 1;
                        if ("offset" === this.elevationType && "bevel" === s && "round" !== this.currentLineJoinType && !this.patternJoinNone && null != E && g && y) {
                            const i = 4 * R;
                            e1 < i && (t1 = Math.max(0, e1 / i));
                        }
                        null != E && g && this.addCurrentVertex(m, w || x, -t1, -t1, _, E);
                        const i = e1 <= 2 * R && "bevel" !== s, n = A.mult(z ? 1 : -1);
                        n._mult(T);
                        const r = v.mult(z ? -1 : 1), o = x.mult(z ? -1 : 1), a = this.evaluateLineProgressFeatures(this.distance);
                        if (null == E && (this.addHalfVertex(m, n.x, n.y, !1, !z, 0, _, a), i || this.addHalfVertex(m, n.x + 2 * o.x, n.y + 2 * o.y, !1, z, 0, _, a)), "fakeround" === s) {
                            const e1 = Math.round(180 * M / Math.PI / 20);
                            this.addHalfVertex(m, o.x, o.y, !1, z, 0, _, a);
                            for(let t1 = 0; t1 < e1; t1++){
                                let i = t1 / e1;
                                if (.5 !== i) {
                                    const e1 = i - .5;
                                    i += i * e1 * (i - 1) * ((1.0904 + l * (l * (3.55645 - 1.43519 * l) - 3.2452)) * e1 * e1 + (.848013 + l * (.215638 * l - 1.06021)));
                                }
                                const n = r.sub(o)._mult(i)._add(o)._unit();
                                this.addHalfVertex(m, n.x, n.y, !1, z, 0, _, a);
                            }
                            this.addHalfVertex(m, r.x, r.y, !1, z, 0, _, a);
                        }
                        i || null != E || this.addHalfVertex(m, n.x + 2 * r.x, n.y + 2 * r.y, !1, z, 0, _, a), null != E && y && this.addCurrentVertex(m, b || v, t1, t1, _, E);
                    } else if ("butt" === s) this.addCurrentVertex(m, A, 0, 0, _, E);
                    else if ("square" === s) {
                        if (!g) {
                            const e1 = c ? 0 : -1;
                            this.addCurrentVertex(m, A, e1, e1, _, E);
                        }
                        if (this.addCurrentVertex(m, A, 0, 0, _, E), g) {
                            const e1 = h ? 0 : 1;
                            this.addCurrentVertex(m, A, e1, e1, _, E);
                        }
                    } else if ("round" === s) {
                        if (g) {
                            const e1 = !i && w ? w : x;
                            this.addCurrentVertex(m, e1, 0, 0, _, E), !i && h || this.addCurrentVertex(m, e1, 1, 1, _, E, !0);
                        }
                        if (y) {
                            const e1 = !i && b ? b : v;
                            !i && c || this.addCurrentVertex(m, e1, -1, -1, _, E, !0), this.addCurrentVertex(m, e1, 0, 0, _, E);
                        }
                    }
                }
            }
            addVerticesTo(e1, t1, i, n, r, o, a, s, l, u) {
                const c = (t1.w - e1.w) / this.tessellationStep | 0;
                let h = 0;
                const d = this.scaledDistance;
                if (c > 1) {
                    this.lineSoFar = e1.w;
                    const i = (t1.x - e1.x) / c, n = (t1.y - e1.y) / c, r = (t1.z - e1.z) / c, o = (t1.w - e1.w) / c, a = t1.x - e1.x, s = t1.y - e1.y, d = Math.sqrt(a * a + s * s);
                    if (0 === d) return;
                    const f = -s / d, p = a / d, _ = f, m = p, g = -f, y = -p;
                    for(let t1 = 1; t1 < c; ++t1){
                        e1.x += i, e1.y += n, e1.z += r, this.lineSoFar += o, h += o;
                        const t1 = this.evaluateLineProgressFeatures(this.prevDistance + h);
                        this.scaledDistance = (this.prevDistance + h) / this.totalDistance, this.addHalfVertex(e1, _, m, u, !1, 0, l, t1), this.addHalfVertex(e1, g, y, u, !0, 0, l, t1);
                    }
                }
                this.lineSoFar = t1.w, this.scaledDistance = d;
                const f = this.evaluateLineProgressFeatures(this.distance);
                this.addHalfVertex(t1, i, n, u, !1, a, l, f), this.addHalfVertex(t1, r, o, u, !0, -s, l, f);
            }
            evaluateLineProgressFeatures(e1) {
                if (!this.variableWidthValue && !this.variableEmissiveStrengthValue && "offset" !== this.elevationType) return null;
                this.evaluationGlobals.lineProgress = 0, this.lineClips ? this.evaluationGlobals.lineProgress = Math.min(1, (this.totalFeatureLength * this.lineClips.start + e1) / this.totalFeatureLength) : mt(`line-progress evaluation for ${this.layerIds[0]} requires enabling 'lineMetrics' for the source.`);
                let t1 = 0;
                this.variableWidthValue && "constant" !== this.variableWidthValue.kind && (t1 = this.variableWidthValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0, t1 *= .5);
                let i = 0;
                this.variableEmissiveStrengthValue && "constant" !== this.variableEmissiveStrengthValue.kind && (i = this.variableEmissiveStrengthValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0);
                const n = this.evaluateElevationGroundScale();
                return "offset" !== this.elevationType ? {
                    zOffset: 0,
                    variableWidth: t1,
                    elevationGroundScale: n,
                    variableEmissiveStrength: i
                } : "constant" === this.zOffsetValue.kind ? {
                    zOffset: this.zOffsetValue.value,
                    variableWidth: t1,
                    elevationGroundScale: n,
                    variableEmissiveStrength: i
                } : {
                    zOffset: this.zOffsetValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0,
                    variableWidth: t1,
                    elevationGroundScale: n,
                    variableEmissiveStrength: i
                };
            }
            evaluateElevationGroundScale() {
                return this.elevationGroundScaleValue ? "constant" === this.elevationGroundScaleValue.kind ? this.elevationGroundScaleValue.value : this.elevationGroundScaleValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0 : 0;
            }
            addCurrentVertex(e1, t1, i, n, r, o, a = !1) {
                const s = t1.x + t1.y * i, l = t1.y - t1.x * i, u = t1.y * n - t1.x, c = -t1.y - t1.x * n;
                if (null != o) {
                    const t1 = "offset" === this.elevationType, h = "offset" === this.elevationType ? 2 : 10, d = -h, f = Sr + h, p = o.zOffset, _ = new Xh(e1.x, e1.y, p, this.lineSoFar), m = !!t1 && pd(e1, d, f), g = this.lineSoFar, y = this.distance;
                    if (this.currentVertex) {
                        if (m) {
                            const t1 = this.currentVertexIsOutside, o = this.currentVertex, h = new Xh(e1.x, e1.y, p, this.lineSoFar);
                            if (Jh(o, h, d, f), !pd(h, d, f)) {
                                if (t1) {
                                    this.e1 = this.e2 = -1, this.distance -= o.dist(_), this.lineSoFar = o.w;
                                    const e1 = this.evaluateLineProgressFeatures(o.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                                    this.addHalfVertex(o, s, l, a, !1, i, r, e1), this.addHalfVertex(o, u, c, a, !0, -n, r, e1), this.prevDistance = this.distance;
                                }
                                this.distance = this.prevDistance + o.dist(h), this.scaledDistance = this.distance / this.totalDistance, this.addVerticesTo(o, h, s, l, u, c, i, n, r, a), this.distance = y, this.scaledDistance = this.distance / this.totalDistance;
                            }
                        } else {
                            const e1 = this.currentVertex;
                            if (this.currentVertexIsOutside) {
                                Jh(e1, _, d, f), this.e1 = this.e2 = -1, this.distance -= e1.dist(_), this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = e1.w;
                                const t1 = this.evaluateLineProgressFeatures(e1.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                                this.addHalfVertex(e1, s, l, a, !1, i, r, t1), this.addHalfVertex(e1, u, c, a, !0, -n, r, t1), this.prevDistance = this.distance, this.distance = y, this.scaledDistance = this.distance / this.totalDistance;
                            }
                            this.addVerticesTo(e1, _, s, l, u, c, i, n, r, a);
                        }
                    } else m || (this.addHalfVertex(e1, s, l, a, !1, i, r, o), this.addHalfVertex(e1, u, c, a, !0, -n, r, o));
                    this.currentVertex = _, this.currentVertexIsOutside = m, this.lineSoFar = g;
                } else this.addHalfVertex(e1, s, l, a, !1, i, r, o), this.addHalfVertex(e1, u, c, a, !0, -n, r, o);
            }
            addHalfVertex({ x: e1, y: t1 }, i, n, r, o, a, s, l) {
                if (this.patternJoinNone && (0 === this.segmentPoints.length && (this.segmentStart = this.lineSoFar, this.segmentStartf32 = Math.fround(this.lineSoFar)), o || this.segmentPoints.push(this.lineSoFar - this.segmentStart, a)), this.layoutVertexArray.emplaceBack((e1 << 1) + (r ? 1 : 0), (t1 << 1) + (o ? 1 : 0), Math.round(63 * i) + 128, Math.round(63 * n) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1), 0, this.lineSoFar - this.segmentStartf32), this.lineClips) {
                    const e1 = dn(this.lineClips.start, this.lineClips.end, this.scaledDistance);
                    this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, e1);
                }
                const u = s.vertexLength++;
                if (this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), s.primitiveLength++), o ? this.e2 = u : this.e1 = u, null != l && (this.zOffsetVertexArray.emplaceBack(l.zOffset, l.variableWidth, l.variableWidth, l.variableEmissiveStrength), this.showElevationIdDebug && this.elevationIdColVertexArray.emplaceBack(0, 0, 0)), this.elevationGroundScaleValue) {
                    const e1 = l ? l.elevationGroundScale : this.evaluateElevationGroundScale();
                    this.elevationGroundScaleVertexArray.emplaceBack(e1);
                }
            }
            updateScaledDistance() {
                this.lineClips ? (this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = this.totalFeatureLength * this.lineClips.start + this.distance) : this.lineSoFar = this.distance;
            }
            updateDistance(e1, t1) {
                this.prevDistance = this.distance, this.distance += e1.dist(t1), this.updateScaledDistance();
            }
        }
        function pd(e1, t1, i) {
            return e1.x < t1 || e1.x > i || e1.y < t1 || e1.y > i;
        }
        Ha(fd, "LineBucket", {
            omit: [
                "layers",
                "patternFeatures",
                "currentVertex",
                "currentVertexIsOutside"
            ]
        });
        const _d = Ou([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), md = Ou([
            {
                name: "a_circle_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), gd = Ou([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]);
        class yd {
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.projection = e1.projection, this.layoutVertexArray = new Bu, this.indexArray = new oc, this.segments = new Bc, this.programConfigurations = new ch(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                const r = this.layers[0], o = [];
                let a = null;
                "circle" === r.type && (a = r.layout.get("circle-sort-key"));
                for (const { feature: r, id: s, index: l, sourceLayerIndex: u } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = Ru(r, e1);
                    if (!this.layers[0]._featureFilter.filter(new ks(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), c, i)) continue;
                    const h = a ? a.evaluate(c, {}, i) : void 0, d = {
                        id: s,
                        properties: r.properties,
                        type: r.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: e1 ? c.geometry : zu(r, i, n),
                        patterns: {},
                        sortKey: h
                    };
                    o.push(d);
                }
                a && o.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                let s = null;
                "globe" === n.projection.name && (this.globeExtVertexArray = new Xu, s = n.projection);
                for (const n of o){
                    const { geometry: r, index: o, sourceLayerIndex: a } = n, l = e1[o].feature;
                    this.addFeature(n, r, o, t1.availableImages, i, s, t1.brightness, t1.elevationFeatures), t1.featureIndex.insert(l, r, o, a, this.index);
                }
                this.hdExt && this.hdExt.finalize();
            }
            update(e1, t1, i, n, r, o, a) {
                this.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, this.worldview);
            }
            updateExpressions(e1) {
                this.programConfigurations.updateExpressions(e1);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, _d.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = e1.createVertexBuffer(this.globeExtVertexArray, gd.members)), this.hdExt && this.hdExt.upload(e1)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.hdExt && this.hdExt.destroy());
            }
            addFeature(e1, t1, i, n, r, o, a, s) {
                this.hdExt && this.hdExt.beginFeature(e1, s, r);
                for (const i of t1)for (const t1 of i){
                    const i = t1.x, n = t1.y;
                    if (i < 0 || i >= Sr || n < 0 || n >= Sr) continue;
                    if (o) {
                        const e1 = o.projectTilePoint(i, n, r), t1 = o.upVector(r, i, n);
                        this.addGlobeExtVertex(e1, t1), this.addGlobeExtVertex(e1, t1), this.addGlobeExtVertex(e1, t1), this.addGlobeExtVertex(e1, t1);
                    }
                    const a = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, e1.sortKey), s = a.vertexLength;
                    this.addCircleVertex(i, n, -1, -1), this.addCircleVertex(i, n, 1, -1), this.addCircleVertex(i, n, 1, 1), this.addCircleVertex(i, n, -1, 1), this.hdExt && this.hdExt.writeVertexQuad(i, n), this.indexArray.emplaceBack(s, s + 1, s + 2), this.indexArray.emplaceBack(s, s + 2, s + 3), a.vertexLength += 4, a.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, {}, n, r, a, void 0, this.worldview);
            }
            addCircleVertex(e1, t1, i, n) {
                this.layoutVertexArray.emplaceBack(2 * e1 + (i + 1) / 2, 2 * t1 + (n + 1) / 2);
            }
            addGlobeExtVertex(e1, t1) {
                const i = 16384;
                this.globeExtVertexArray.emplaceBack(e1.x, e1.y, e1.z, t1[0] * i, t1[1] * i, t1[2] * i);
            }
        }
        Ha(yd, "CircleBucket", {
            omit: [
                "layers"
            ]
        });
        const xd = Ou([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_tex_size",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), vd = Ou([
            {
                name: "a_globe_anchor",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_globe_normal",
                components: 3,
                type: "Float32"
            }
        ], 4), bd = Ou([
            {
                name: "a_projected_pos",
                components: 4,
                type: "Float32"
            }
        ], 4);
        Ou([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const wd = Ou([
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), Ed = Ou([
            {
                name: "a_feature_index",
                components: 1,
                type: "Float32"
            }
        ], 4), Ad = Ou([
            {
                name: "a_x_axis",
                components: 3,
                type: "Float32"
            },
            {
                name: "a_y_axis",
                components: 3,
                type: "Float32"
            }
        ]), Id = Ou([
            {
                name: "a_texb",
                components: 2,
                type: "Uint16"
            }
        ]), Td = Ou([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_elevation_from_sea",
                components: 2,
                type: "Float32"
            }
        ]), Md = Ou([
            {
                name: "a_size_scale",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_padding",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ]);
        Ou([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "tileAnchorX"
            },
            {
                type: "Int16",
                name: "tileAnchorY"
            },
            {
                type: "Float32",
                name: "x1"
            },
            {
                type: "Float32",
                name: "y1"
            },
            {
                type: "Float32",
                name: "x2"
            },
            {
                type: "Float32",
                name: "y2"
            },
            {
                type: "Int16",
                name: "padding"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const Sd = Ou([
            {
                name: "a_pos",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), zd = Ou([
            {
                name: "a_pos_2f",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        Ou([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), Ou([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            },
            {
                type: "Uint8",
                name: "flipState"
            }
        ]), Ou([
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Float32",
                name: "zOffset"
            },
            {
                type: "Uint8",
                name: "hasIconTextFit"
            },
            {
                type: "Uint16",
                name: "elevationFeatureIndex"
            }
        ]), Ou([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), Ou([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            }
        ]);
        const Rd = new Float32Array(1), Pd = new Uint32Array(Rd.buffer);
        function Dd(e1) {
            return Rd[0] = e1, Pd[0];
        }
        const Cd = class e1 {
            static getBlockIndices(t1) {
                let i = e1._blockIndicesTemplate;
                if (!i) {
                    i = e1._blockIndicesTemplate = new Uint32Array(t1);
                    for(let e1 = 0; e1 < t1; e1++)i[e1] = e1;
                }
                return i;
            }
            constructor(e1, t1, i, n){
                this.batchIndex = t1, this.headerBuffer = null, this.propertiesBuffer = null, this.blockIndicesBuffer = null, this.context = e1 || null, this.propsDwords = i, this.totalBytes = 4 * this.propsDwords, this.headerData = n, this.propertiesData = new Float32Array(this.propsDwords), this._headerDirty = !0, this._propsDirtyMin = -1, this._propsDirtyMax = -1, this._blockIndicesDirty = !0, e1 && this._initBuffers(e1);
            }
            _initBuffers(t1) {
                const i = t1.gl;
                if (this.totalBytes > t1.maxUniformBlockSize) throw new Error(`UBO size ${this.totalBytes} exceeds device limit ${t1.maxUniformBlockSize}`);
                if (this.headerBuffer = i.createBuffer(), !this.headerBuffer) throw new Error("Failed to create header UBO buffer");
                if (i.bindBuffer(i.UNIFORM_BUFFER, this.headerBuffer), i.bufferData(i.UNIFORM_BUFFER, e1.HEADER_BYTES, i.DYNAMIC_DRAW), this.propertiesBuffer = i.createBuffer(), !this.propertiesBuffer) throw new Error("Failed to create properties UBO buffer");
                if (i.bindBuffer(i.UNIFORM_BUFFER, this.propertiesBuffer), i.bufferData(i.UNIFORM_BUFFER, this.totalBytes, i.DYNAMIC_DRAW), this.blockIndicesBuffer = i.createBuffer(), !this.blockIndicesBuffer) throw new Error("Failed to create block-indices UBO buffer");
                i.bindBuffer(i.UNIFORM_BUFFER, this.blockIndicesBuffer), i.bufferData(i.UNIFORM_BUFFER, this.totalBytes, i.DYNAMIC_DRAW), i.bindBuffer(i.UNIFORM_BUFFER, null);
            }
            markHeaderDirty() {
                this._headerDirty = !0;
            }
            writeDataDrivenBlock(e1, t1) {
                const i = this.headerData, n = 4 * i[2];
                if (0 === n) return;
                const r = t1 * n;
                if (r + n > this.propertiesData.length) throw new Error(`UBO write out of bounds: feature index ${t1} exceeds propertiesData capacity`);
                const o = i[0];
                for(let t1 = 0; t1 < 9; t1++)o & 1 << t1 && this._copyFromFlat(r + 4 * i[3 + t1], t1, e1);
                (-1 === this._propsDirtyMin || r < this._propsDirtyMin) && (this._propsDirtyMin = r);
                const a = r + n;
                a > this._propsDirtyMax && (this._propsDirtyMax = a);
            }
            rightSizeForTransfer() {
                const e1 = -1 === this._propsDirtyMax ? 0 : this._propsDirtyMax;
                e1 < this.propertiesData.length && (this.propertiesData = this.propertiesData.slice(0, e1));
            }
            _copyFromFlat(t1, i, n) {
                let r = 4;
                (i < 2 || 8 === i) && (r = this.headerData[1] >>> i & 1 ? 8 : 4);
                const o = e1.EVAL_FLAT_OFFSETS[i];
                this.propertiesData.set(n.subarray(o, o + r), t1);
            }
            upload(t1) {
                this.context || (this.context = t1);
                const i = t1.gl;
                this.headerBuffer && this.propertiesBuffer && this.blockIndicesBuffer || this._initBuffers(t1);
                let n = !1;
                if (this._headerDirty && (i.bindBuffer(i.UNIFORM_BUFFER, this.headerBuffer), i.bufferSubData(i.UNIFORM_BUFFER, 0, this.headerData), this._headerDirty = !1, n = !0), -1 !== this._propsDirtyMin) {
                    const e1 = this._propsDirtyMin, t1 = this._propsDirtyMax;
                    i.bindBuffer(i.UNIFORM_BUFFER, this.propertiesBuffer), i.bufferSubData(i.UNIFORM_BUFFER, 4 * e1, this.propertiesData, e1, t1 - e1), this._propsDirtyMin = -1, this._propsDirtyMax = -1, n = !0;
                }
                this._blockIndicesDirty && (i.bindBuffer(i.UNIFORM_BUFFER, this.blockIndicesBuffer), i.bufferSubData(i.UNIFORM_BUFFER, 0, e1.getBlockIndices(this.propsDwords)), this._blockIndicesDirty = !1, n = !0), n && i.bindBuffer(i.UNIFORM_BUFFER, null);
            }
            bind(e1, t1) {
                const i = e1.gl, n = (e1, n, r)=>{
                    if (!n) return;
                    const o = i.getUniformBlockIndex(t1, e1);
                    o !== i.INVALID_INDEX && (i.uniformBlockBinding(t1, o, r), i.bindBufferBase(i.UNIFORM_BUFFER, r, n));
                }, r = 3 * this.batchIndex;
                n("SymbolPaintPropertiesHeaderUniform", this.headerBuffer, r), n("SymbolPaintPropertiesUniform", this.propertiesBuffer, r + 1), n("SymbolPaintPropertiesIndexUniform", this.blockIndicesBuffer, r + 2);
            }
            destroy() {
                if (this.context) {
                    const e1 = this.context.gl;
                    this.headerBuffer && (e1.deleteBuffer(this.headerBuffer), this.headerBuffer = null), this.propertiesBuffer && (e1.deleteBuffer(this.propertiesBuffer), this.propertiesBuffer = null), this.blockIndicesBuffer && (e1.deleteBuffer(this.blockIndicesBuffer), this.blockIndicesBuffer = null);
                }
            }
        };
        Cd.HEADER_DWORDS = 16, Cd.HEADER_BYTES = 64, Cd.EVAL_FLAT_OFFSETS = [
            0,
            8,
            16,
            20,
            24,
            28,
            32,
            36,
            40
        ], Cd.EVAL_FLAT_TOTAL = 48, Cd._blockIndicesTemplate = null;
        let Fd = Cd;
        function Od(e1, t1, i, n, r, o, a, s) {
            return !!e1 && ("constant" === e1.kind ? "none" === e1.value : "none" === e1.evaluate({
                zoom: 0,
                brightness: o,
                worldview: s
            }, t1, i, r, n, a));
        }
        function Ld(e1) {
            if (!(e1 instanceof Ws)) return !1;
            const t1 = e1.value;
            return ("source" === t1.kind || "composite" === t1.kind) && t1.isStateDependent;
        }
        Ha(Fd, "SymbolPropertiesUBO", {
            omit: [
                "headerBuffer",
                "propertiesBuffer",
                "blockIndicesBuffer"
            ]
        });
        const Bd = [
            "icon",
            "text"
        ].map((e1)=>[
                `${e1}-color`,
                `${e1}-halo-color`,
                `${e1}-opacity`,
                `${e1}-halo-width`,
                `${e1}-halo-blur`,
                `${e1}-emissive-strength`,
                `${e1}-occlusion-opacity`,
                "symbol-z-offset",
                `${e1}-translate`
            ]), Nd = new Float32Array(Fd.EVAL_FLAT_TOTAL), Vd = [
            0,
            0
        ], kd = new WeakMap;
        class Ud {
            constructor(e1, t1, i, n, r = "", o, a){
                this.layer = e1, this.zoom = t1, this.lut = i, this.isText = n, this.worldview = r, this.maxUniformBufferBindings = o || 24, this.uboSizeDwords = a || 4096, this.allFeatureVtIndices = [], this.allFeatureIds = [], this.allFormattedSections = [], this.featureVertexRangesFromId = null, this.featureVertexRangesFromVtIndex = null, this.ubos = [], this.featureCount = 0, this.cachedConstantUniforms = null, this.cachedConstantRenderZoom = null, this.cachedConstantBrightness = void 0, this.cachedConstantPaint = null, this.activeAppearanceByVtIndex = null, this.zoomDependency = new Uint8Array(9), this.sharedZoomRanges = new Float32Array(18), this._zoomRangeScratch = new Float32Array(2), this._floorZoom = Math.floor(this.zoom), this.header = new Uint32Array(Fd.HEADER_DWORDS), this.updateHeader(), this.isAllConstant = 0 === this.header[0];
                const s = 4 * this.header[2];
                this.maxFeaturesPerBatch = 0 === s ? Number.MAX_SAFE_INTEGER : Math.floor(this.uboSizeDwords / s);
            }
            updateHeader() {
                const e1 = this.layer.paint;
                let t1 = 0, i = 0, n = 0, r = 0, o = !0;
                const a = this._floorZoom, s = Bd[+this.isText];
                for(let l = 0; l < 9; l++){
                    const u = s[l], c = l < 2, h = e1.get(u), d = !(!h || "function" != typeof h.isConstant || h.isConstant()), f = this._appearancesHavePaintProperties(u);
                    if (!d && !f) {
                        const e1 = this._layerUnevaluated(u);
                        e1 && e1.expression && "camera" === e1.expression.kind && (n |= 1 << l);
                        continue;
                    }
                    t1 |= 1 << l;
                    const p = this._collectZoomSignatures(u, a), _ = p.hasZoom, m = p.differs, g = 8 === l;
                    this.zoomDependency[l] = m ? 2 : _ ? 1 : 0;
                    const y = m || g && _;
                    y && (i |= 1 << l);
                    const x = h && h.value;
                    x && !1 === x.isLightConstant && (o = !1), this.header[3 + l] = r, r += y ? 2 : 1, _ && !m && p.representative && (this._computeZoomRange(p.representative, a, this.sharedZoomRanges, 2 * l), c && (this.header[12 + 2 * l] = Dd(this.sharedZoomRanges[2 * l]), this.header[12 + 2 * l + 1] = Dd(this.sharedZoomRanges[2 * l + 1])));
                }
                this.header[0] = t1, this.header[1] = i, this.header[2] = r, this.isLightConstant = o, this.cameraMask = n;
            }
            _recomputeSharedRanges() {
                const e1 = this._floorZoom, t1 = Bd[+this.isText];
                let i = 0, n = !1;
                for(let r = 0; r < 9; r++){
                    const o = t1[r], a = this.zoomDependency[r];
                    if (this.header[0] & 1 << r) {
                        if (0 !== a && 2 !== a) {
                            const t1 = this._collectZoomSignatures(o, e1);
                            t1.representative && (this._computeZoomRange(t1.representative, e1, this.sharedZoomRanges, 2 * r), r < 2 && (this.header[12 + 2 * r] = Dd(this.sharedZoomRanges[2 * r]), this.header[12 + 2 * r + 1] = Dd(this.sharedZoomRanges[2 * r + 1]), n = !0));
                        }
                    } else {
                        const e1 = this._layerUnevaluated(o);
                        e1 && e1.expression && "camera" === e1.expression.kind && (i |= 1 << r);
                    }
                }
                if (this.cameraMask = i, n) for (const e1 of this.ubos)e1.markHeaderDirty();
            }
            _collectZoomSignatures(e1, t1) {
                let i = !1, n = !1, r = null, o = 0, a = 0;
                const s = (e1)=>{
                    if (!e1) return;
                    this._computeZoomRange(e1, t1, this._zoomRangeScratch, 0);
                    const s = this._zoomRangeScratch[0], l = this._zoomRangeScratch[1];
                    i ? s === o && l === a || (n = !0) : (i = !0, o = s, a = l, r = e1);
                };
                s(this._zoomExprOf(this._layerUnevaluated(e1)));
                for (const t1 of this.layer.getAppearances() || [])t1.hasPaintProperty(e1) && s(this._zoomExprOf(t1.getUnevaluatedPaintProperty(e1)));
                return {
                    hasZoom: i,
                    differs: n,
                    representative: r
                };
            }
            evaluateAllProperties(e1, t1, i, n, r, o, a) {
                const s = {
                    brightness: r,
                    worldview: this.worldview
                }, l = {
                    feature: e1,
                    featureState: t1,
                    canonical: i,
                    availableImages: n,
                    params: new ks(this.zoom, s),
                    paramsNext: new ks(this.zoom + 1, s),
                    formattedSection: o,
                    activeAppearance: a
                }, u = Bd[+this.isText];
                for(let e1 = 0; e1 < 9; e1++){
                    const t1 = u[e1], i = e1 < 2, n = 8 === e1, r = this.zoomDependency[e1], o = 0 !== r, a = 2 === r, s = Fd.EVAL_FLAT_OFFSETS[e1], c = s + (i || n ? 4 : 2);
                    i ? this._evaluateColorValue(t1, e1, o, a, c, l, s) : n ? this._evaluateTranslateValue(t1, e1, o, a, c, l, s) : this._evaluateFloatValue(t1, e1, o, a, c, l, s);
                }
                return Nd;
            }
            _resolveProp(e1, t1, i = !1, n) {
                const r = this.layer.paint, o = r.get(e1), a = e1, s = !(!t1 || !t1.hasPaintProperty(a)), l = s ? n && o && o.property.overrides && o.property.overrides.hasOverride(n) ? o : t1.paintProperties.get(a) : r.get(e1);
                if (i || !l || "function" != typeof l.isConstant || !l.isConstant()) return l;
                const u = s ? t1.getUnevaluatedPaintProperty(a) : this._layerUnevaluated(e1);
                return this._unbakeCamera(l, u);
            }
            _unbakeCamera(e1, t1) {
                const i = t1 && t1.expression;
                if (!i || "camera" !== i.kind) return e1;
                let n = kd.get(t1);
                return n || (n = new Ws(e1.property, i, e1.parameters, e1.iconImageUseTheme), kd.set(t1, n)), n;
            }
            _layerUnevaluated(e1) {
                const t1 = this.layer._transitionablePaint._values[e1];
                return t1 && t1.value;
            }
            _zoomExprOf(e1) {
                const t1 = e1 && e1.expression;
                return !t1 || "composite" !== t1.kind && "camera" !== t1.kind ? null : t1;
            }
            _evalAt(e1, t1, i) {
                return e1.property.evaluate(e1.value, t1, i.feature, i.featureState, i.canonical, i.availableImages, e1.iconImageUseTheme, i.formattedSection);
            }
            _evaluateColorValue(e1, t1, i, n, r, o, a) {
                const s = this._resolveProp(e1, o.activeAppearance, !1, o.formattedSection);
                if (this._writePropertyZoomRange(t1, i, n, s, r), !s) return Nd[a] = 0, Nd[a + 1] = 0, Nd[a + 2] = 0, void (Nd[a + 3] = 1);
                const l = this._resolveProp(`${e1}-use-theme`, o.activeAppearance, !0), u = Od(l && "string" != typeof l ? l.value : void 0, o.feature, o.featureState, o.availableImages, o.canonical, o.params.brightness, o.formattedSection, this.worldview) ? null : this.lut, c = (s.isConstant() ? s.constantOr(pn.transparent) : this._evalAt(s, o.params, o) || pn.transparent).toNonPremultipliedRenderColor(u);
                if (Nd[a] = Nc(255 * c.r, 255 * c.g), Nd[a + 1] = Nc(255 * c.b, 255 * c.a), i) {
                    const e1 = (this._evalAt(s, o.paramsNext, o) || pn.transparent).toNonPremultipliedRenderColor(u);
                    Nd[a + 2] = Nc(255 * e1.r, 255 * e1.g), Nd[a + 3] = Nc(255 * e1.b, 255 * e1.a);
                } else Nd[a + 2] = Nd[a], Nd[a + 3] = Nd[a + 1];
            }
            _computeZoomRange(e1, t1, i, n) {
                let r = 0, o = 1;
                const a = !e1 || "composite" !== e1.kind && "camera" !== e1.kind ? null : e1.zoomStops;
                if (a && a.length > 0) {
                    if (null == e1.interpolationType) {
                        r = o = 1;
                        for (const e1 of a)if (e1 > t1 && e1 < t1 + 1) {
                            r = o = e1 - t1;
                            break;
                        }
                    } else a[0] > t1 && a[0] < t1 + 1 && (r = a[0] - t1);
                }
                i[n] = r, i[n + 1] = o;
            }
            _writeZoomRange(e1, t1) {
                this._computeZoomRange(e1 && e1.value, this._floorZoom, Nd, t1);
            }
            _writePropertyZoomRange(e1, t1, i, n, r) {
                i ? this._writeZoomRange(n, r) : t1 ? (Nd[r] = this.sharedZoomRanges[2 * e1], Nd[r + 1] = this.sharedZoomRanges[2 * e1 + 1]) : (Nd[r] = 0, Nd[r + 1] = 0);
            }
            _evaluateFloatValue(e1, t1, i, n, r, o, a) {
                const s = e1.endsWith("opacity") ? 1 : 0, l = this._resolveProp(e1, o.activeAppearance);
                this._writePropertyZoomRange(t1, i, n, l, r);
                const u = (l ? l.isConstant() ? l.constantOr(s) : this._evalAt(l, o.params, o) : s) ?? s;
                if (Nd[a] = u, i) {
                    const e1 = this._evalAt(l, o.paramsNext, o);
                    Nd[a + 1] = e1 ?? s;
                } else Nd[a + 1] = u;
            }
            _evaluateTranslateValue(e1, t1, i, n, r, o, a) {
                const s = this._resolveProp(e1, o.activeAppearance);
                this._writePropertyZoomRange(t1, i, n, s, r);
                const l = !!s && "function" == typeof s.isConstant && !s.isConstant(), u = s ? "function" != typeof s.isConstant ? s : l ? this._evalAt(s, o.params, o) : s.constantOr(Vd) : void 0;
                if (Nd[a] = u ? u[0] : 0, Nd[a + 1] = u ? u[1] : 0, i) {
                    const e1 = l ? this._evalAt(s, o.paramsNext, o) : u;
                    Nd[a + 2] = e1 ? e1[0] : 0, Nd[a + 3] = e1 ? e1[1] : 0;
                } else Nd[a + 2] = Nd[a], Nd[a + 3] = Nd[a + 1];
            }
            _appearancesHavePaintProperties(e1) {
                return this.layer.getAppearances().some((t1)=>t1.hasPaintProperty(e1));
            }
            hasStateDependentPaint(e1) {
                const t1 = e1.paint, i = Bd[+this.isText];
                for (const e1 of i)if (Ld(t1.get(e1))) return !0;
                for (const t1 of e1.getAppearances() || [])for (const e1 of i){
                    const i = e1;
                    if (t1.hasPaintProperty(i) && Ld(t1.paintProperties.get(i))) return !0;
                }
                return !1;
            }
            hasPerFeatureTranslate() {
                return !!(256 & this.header[0]);
            }
            getCurrentBatchIndex() {
                return 0 === this.maxFeaturesPerBatch ? 0 : Math.floor(this.featureCount / this.maxFeaturesPerBatch);
            }
            _writeFeatureBlock(e1, t1) {
                const i = this.isAllConstant ? 0 : e1;
                let n = Math.floor(i / this.maxFeaturesPerBatch), r = i % this.maxFeaturesPerBatch;
                this._batchExceedsDeviceLimit(n) && (n = 0, r = 0);
                const o = this.ubos[n];
                return !!o && (o.writeDataDrivenBlock(t1, r), !0);
            }
            _batchExceedsDeviceLimit(e1) {
                return 3 * e1 + 2 >= this.maxUniformBufferBindings;
            }
            _reevaluateAt(e1, t1, i, n, r, o) {
                if (!t1) return;
                const a = this.allFeatureVtIndices[e1], s = t1.feature(a);
                if (!s) return;
                const l = this.allFeatureIds[e1], u = null != l && r[l] || {}, c = {
                    type: s.type,
                    id: l,
                    properties: s.properties || {},
                    geometry: []
                }, h = this.activeAppearanceByVtIndex ? this.activeAppearanceByVtIndex.get(a) : void 0, d = this.evaluateAllProperties(c, u, i, n, o, (this.allFormattedSections ? this.allFormattedSections[e1] : void 0) || void 0, h);
                this._writeFeatureBlock(e1, d);
            }
            _ensureRangeMaps() {
                if (!this.featureVertexRangesFromId) {
                    this.featureVertexRangesFromId = new Map, this.featureVertexRangesFromVtIndex = new Map;
                    for(let e1 = 0; e1 < this.allFeatureVtIndices.length; e1++){
                        const t1 = this.allFeatureIds[e1];
                        if (null != t1) {
                            let i = this.featureVertexRangesFromId.get(t1);
                            i || this.featureVertexRangesFromId.set(t1, i = []), i.push(e1);
                        }
                        const i = this.allFeatureVtIndices[e1];
                        let n = this.featureVertexRangesFromVtIndex.get(i);
                        n || this.featureVertexRangesFromVtIndex.set(i, n = []), n.push(e1);
                    }
                }
            }
            populateUBO(e1, t1, i, n, r, o) {
                const a = e1.id, s = this.header, l = this.evaluateAllProperties(e1, {}, i, n, r, o);
                let u, c;
                this.isAllConstant ? (u = 0, c = 0 === this.featureCount, c && (this.featureCount = 1)) : (u = this.featureCount++, c = !0);
                let h = Math.floor(u / this.maxFeaturesPerBatch), d = u % this.maxFeaturesPerBatch;
                return c && (this._batchExceedsDeviceLimit(h) ? (mt(`Too many symbol features: batch ${h} requires binding points up to ${3 * h + 2}, device limit ${this.maxUniformBufferBindings}. Some features will render incorrectly.`), h = 0, d = 0) : (this.ubos[h] || (this.ubos[h] = new Fd(null, h, this.uboSizeDwords, s)), this.ubos[h].writeDataDrivenBlock(l, d))), this.allFeatureVtIndices.push(t1), this.allFeatureIds.push(a), this.allFormattedSections.push(o || null), d;
            }
            updateFeatures(e1, t1, i, n, r, o, a) {
                this.layer = t1, this.cachedConstantUniforms = null, this._ensureRangeMaps();
                for (const t1 of e1){
                    const e1 = this.featureVertexRangesFromId.get(t1);
                    if (e1) for (const t1 of e1)this._reevaluateAt(t1, i, n, r, o, a);
                }
            }
            updateDynamicExpressions(e1, t1, i, n, r, o) {
                if (this.layer = e1, this.cachedConstantUniforms = null, this._recomputeSharedRanges(), 0 !== this.header[0]) for(let e1 = 0; e1 < this.allFeatureVtIndices.length; e1++)this._reevaluateAt(e1, t1, i, n, r, o);
            }
            updateFeaturePaintForAppearance(e1, t1, i, n, r, o, a) {
                if (!this.layer) return !1;
                if (this.activeAppearanceByVtIndex || (this.activeAppearanceByVtIndex = new Map), this.activeAppearanceByVtIndex.set(e1, a || null), 0 === this.header[0]) return !1;
                this._ensureRangeMaps();
                const s = this.featureVertexRangesFromVtIndex.get(e1);
                if (!s) return !1;
                let l = !1;
                for (const e1 of s){
                    const s = this.evaluateAllProperties(t1, i, n, r, o, (this.allFormattedSections ? this.allFormattedSections[e1] : void 0) || void 0, a);
                    l = this._writeFeatureBlock(e1, s) || l;
                }
                return l;
            }
            getConstantUniformValues(e1, t1) {
                const i = !!this.cameraMask;
                if (this.cachedConstantUniforms && this.cachedConstantPaint === this.layer.paint && this.cachedConstantBrightness === t1 && (!i || this.cachedConstantRenderZoom === e1)) return this.cachedConstantUniforms;
                const n = this.layer.paint, r = i ? new ks(e1, {
                    brightness: t1,
                    worldview: this.worldview
                }) : null, o = {
                    type: 1,
                    id: void 0,
                    properties: {},
                    geometry: []
                }, a = Bd[+this.isText], s = (e1)=>{
                    const i = a[e1], s = n.get(i);
                    if (!s) return [
                        0,
                        0,
                        0,
                        1
                    ];
                    const l = n.get(`${i}-use-theme`), u = Od(l && "string" != typeof l ? l.value : void 0, o, {}, [], void 0, t1, void 0, this.worldview) ? null : this.lut;
                    return (this.cameraMask & 1 << e1 && r ? s.property.evaluate(s.value, r, o, {}, void 0, []) || pn.transparent : s.constantOr(pn.transparent)).toNonPremultipliedRenderColor(u).toArray01();
                }, l = (e1, t1)=>{
                    const i = n.get(a[e1]);
                    return i ? this.cameraMask & 1 << e1 && r ? i.property.evaluate(i.value, r, o, {}, void 0, []) ?? t1 : i.constantOr(t1) : t1;
                }, u = {
                    fill_np_color: s(0),
                    halo_np_color: s(1),
                    opacity: l(2, 1),
                    halo_width: l(3, 0),
                    halo_blur: l(4, 0),
                    emissive_strength: l(5, 0),
                    occlusion_opacity: l(6, 1),
                    z_offset: l(7, 0)
                };
                return this.cachedConstantUniforms = u, this.cachedConstantRenderZoom = e1, this.cachedConstantBrightness = t1, this.cachedConstantPaint = this.layer.paint, u;
            }
            finalize() {
                for (const e1 of this.ubos)e1.rightSizeForTransfer();
            }
            upload(e1) {
                for (const t1 of this.ubos)t1.upload(e1);
            }
            bind(e1, t1, i = 0) {
                this.ubos[i] && this.ubos[i].bind(e1, t1);
            }
            destroy() {
                for (const e1 of this.ubos)e1.destroy();
                this.ubos = [], this.featureVertexRangesFromId = null, this.featureVertexRangesFromVtIndex = null, this.allFeatureVtIndices = [], this.allFeatureIds = [], this.featureCount = 0, this.maxFeaturesPerBatch = 0;
            }
        }
        Ha(Ud, "SymbolPropertyBinderUBO", {
            omit: [
                "layer",
                "cachedConstantUniforms",
                "cachedConstantRenderZoom",
                "cachedConstantBrightness",
                "cachedConstantPaint",
                "activeAppearanceByVtIndex",
                "featureVertexRangesFromId",
                "featureVertexRangesFromVtIndex"
            ]
        });
        const Gd = 24;
        function jd(e1, t1, i) {
            return e1.sections.forEach((e1)=>{
                e1.text = function(e1, t1, i) {
                    const n = t1.layout.get("text-transform").evaluate(i, {});
                    return "uppercase" === n ? e1 = e1.toLocaleUpperCase() : "lowercase" === n && (e1 = e1.toLocaleLowerCase()), Vs.applyArabicShaping && (e1 = Vs.applyArabicShaping(e1)), e1;
                }(e1.text, t1, i);
            }), e1;
        }
        const Hd = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        };
        function $d(e1) {
            let t1 = .5, i = .5;
            switch(e1){
                case "right":
                case "top-right":
                case "bottom-right":
                    t1 = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    t1 = 0;
            }
            switch(e1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    i = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    i = 0;
            }
            return {
                horizontalAlign: t1,
                verticalAlign: i
            };
        }
        function Zd(e1, t1, i, n) {
            const { horizontalAlign: r, verticalAlign: o } = $d(n), a = i[0] - e1.displaySize[0] * r, s = i[1] - e1.displaySize[1] * o;
            return {
                imagePrimary: e1,
                imageSecondary: t1,
                top: s,
                bottom: s + e1.displaySize[1],
                left: a,
                right: a + e1.displaySize[0]
            };
        }
        function Wd(e1, t1, i, n, r, o) {
            const a = e1.imagePrimary;
            let s;
            if (a.content) {
                const e1 = a.content, t1 = a.pixelRatio || 1;
                s = [
                    e1[0] / t1,
                    e1[1] / t1,
                    a.displaySize[0] - e1[2] / t1,
                    a.displaySize[1] - e1[3] / t1
                ];
            }
            const l = t1.left * o, u = t1.right * o;
            let c, h, d, f;
            "width" === i || "both" === i ? (f = r[0] + l - n[3], h = r[0] + u + n[1]) : (f = r[0] + (l + u - a.displaySize[0]) / 2, h = f + a.displaySize[0]);
            const p = t1.top * o, _ = t1.bottom * o;
            return "height" === i || "both" === i ? (c = r[1] + p - n[0], d = r[1] + _ + n[2]) : (c = r[1] + (p + _ - a.displaySize[1]) / 2, d = c + a.displaySize[1]), {
                imagePrimary: a,
                imageSecondary: void 0,
                top: c,
                right: h,
                bottom: d,
                left: f,
                collisionPadding: s
            };
        }
        const qd = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        };
        function Xd(e1) {
            return "\uFE36" === e1 || "\uFE48" === e1 || "\uFE38" === e1 || "\uFE44" === e1 || "\uFE42" === e1 || "\uFE3E" === e1 || "\uFE3C" === e1 || "\uFE3A" === e1 || "\uFE18" === e1 || "\uFE40" === e1 || "\uFE10" === e1 || "\uFE13" === e1 || "\uFE14" === e1 || "\uFF40" === e1 || "\uFFE3" === e1 || "\uFE11" === e1 || "\uFE12" === e1;
        }
        function Yd(e1) {
            return "\uFE35" === e1 || "\uFE47" === e1 || "\uFE37" === e1 || "\uFE43" === e1 || "\uFE41" === e1 || "\uFE3D" === e1 || "\uFE3B" === e1 || "\uFE39" === e1 || "\uFE17" === e1 || "\uFE3F" === e1;
        }
        const Jd = 128;
        function Kd(e1, t1, i, n) {
            const { expression: r } = t1;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new ks(e1 + 1, {
                    worldview: i
                }), void 0, void 0, void 0, n)
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: t1, interpolationType: o } = r;
                let a = 0;
                for(; a < t1.length && t1[a] <= e1;)a++;
                a = Math.max(0, a - 1);
                let s = a;
                for(; s < t1.length && t1[s] < e1 + 1;)s++;
                s = Math.min(t1.length - 1, s);
                const l = t1[a], u = t1[s];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: l,
                    maxZoom: u,
                    interpolationType: o
                } : {
                    kind: "camera",
                    minZoom: l,
                    maxZoom: u,
                    minSize: r.evaluate(new ks(l, {
                        worldview: i
                    }), void 0, void 0, void 0, n),
                    maxSize: r.evaluate(new ks(u, {
                        worldview: i
                    }), void 0, void 0, void 0, n),
                    interpolationType: o
                };
            }
        }
        function Qd(e1, { uSize: t1, uSizeT: i }, { lowerSize: n, upperSize: r }) {
            return "source" === e1.kind ? n / Jd : "composite" === e1.kind ? dn(n / Jd, r / Jd, i) : t1;
        }
        function ef(e1, t1, i = 1) {
            let n = 0, r = 0;
            if ("constant" === e1.kind) r = e1.layoutSize * i;
            else if ("source" !== e1.kind) {
                const { interpolationType: o, minZoom: a, maxZoom: s } = e1, l = o ? tt(Go.interpolationFactor(o, t1, a, s), 0, 1) : 0;
                "camera" === e1.kind ? r = dn(e1.minSize, e1.maxSize, l) * i : n = l * i;
            }
            return {
                uSizeT: n,
                uSize: r
            };
        }
        const tf = Number.POSITIVE_INFINITY, nf = Math.sqrt(2), rf = 32640;
        function of(e1, t1, i, n, r, o, a) {
            const s = e1.hasLayoutProperty(r) ? t1.getAppearanceValueAndResolveTokens(e1, r, i, n, []) : null;
            return (Array.isArray(o) ? Array.isArray(s) : typeof s == typeof o) ? a ? a(s) : s : o;
        }
        function af(e1, t1, i, n, r, o, a, s) {
            return {
                appearanceIconOffset: of(e1, t1, i, n, "icon-offset", r),
                appearanceIconRotate: of(e1, t1, i, n, "icon-rotate", o),
                appearanceIconSize: of(e1, t1, i, n, "icon-size", a, (e1)=>e1 * s)
            };
        }
        function sf(e1, t1, i, n, r, o, a) {
            const s = of(e1, t1, i, n, "text-offset", r, ([e1, t1])=>[
                    e1 * Gd,
                    t1 * Gd
                ]);
            return {
                appearanceTextOffset: s,
                appearanceTextRotate: of(e1, t1, i, n, "text-rotate", o),
                appearanceTextSize: of(e1, t1, i, n, "text-size", a)
            };
        }
        function lf(e1, t1, i, n, r, o, a, s, l, u) {
            if (!e1) return;
            const c = function(e1, t1, i, n, r, o, a) {
                if ("camera" === e1.kind) return e1.maxSize;
                if ("composite" === e1.kind) {
                    const n = t1.possiblyEvaluate(new ks(e1.maxZoom, {
                        worldview: o
                    }), i, a).evaluate(r, {}, i, a), s = t1.possiblyEvaluate(new ks(e1.minZoom, {
                        worldview: o
                    }), i, a).evaluate(r, {}, i, a);
                    return Math.max(n, s);
                }
                return t1.possiblyEvaluate(new ks(n, {
                    worldview: o
                }), i, a).evaluate(r, {}, i, a);
            }(t1, i, n, r, o, l, u);
            return e1.scaleSelf(c * s * a);
        }
        function uf(e1, t1, i, n, r, o, a, s, l, u) {
            return {
                iconPrimary: lf(e1.getPrimary(), t1, i, n, r, o, a, s, l, u),
                iconSecondary: lf(e1.getSecondary(), t1, i, n, r, o, a, s, l, u)
            };
        }
        function cf(e1, t1) {
            return e1 * t1 / 24;
        }
        function hf(e1, t1, i, n, r, o) {
            let a = null;
            return "source" === t1.kind ? (a = [
                Jd * i * n
            ], a[0] > rf && mt(`${e1}: Value for "text-size" or "icon-size" is >= 255. Reduce your "text-size" or "icon-size".`)) : "composite" === t1.kind && (a = [
                Jd * r * n,
                Jd * o * n
            ], (a[0] > rf || a[1] > rf) && mt(`${e1}: Value for "text-size" or "icon-size" is >= 255. Reduce your "text-size" or "icon-size".`)), a;
        }
        const df = Ou([
            {
                type: "Float32",
                name: "a_globe_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]), { members: ff } = df, pf = Ou([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            }
        ]);
        var _f = Ou([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class mf {
            constructor(e1, t1){
                this.pos = e1, this.dir = t1;
            }
            intersectsPlane(e1, t1, i) {
                const n = Se(t1, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const r = ((e1[0] - this.pos[0]) * t1[0] + (e1[1] - this.pos[1]) * t1[1]) / n;
                return i[0] = this.pos[0] + this.dir[0] * r, i[1] = this.pos[1] + this.dir[1] * r, !0;
            }
        }
        class gf {
            constructor(e1, t1){
                this.pos = e1, this.dir = t1;
            }
            intersectsPlane(e1, t1, i) {
                const n = W(t1, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const r = ((e1[0] - this.pos[0]) * t1[0] + (e1[1] - this.pos[1]) * t1[1] + (e1[2] - this.pos[2]) * t1[2]) / n;
                return i[0] = this.pos[0] + this.dir[0] * r, i[1] = this.pos[1] + this.dir[1] * r, i[2] = this.pos[2] + this.dir[2] * r, !0;
            }
            closestPointOnSphere(e1, t1, i) {
                if (function(e1, t1) {
                    var i = e1[0], r = e1[1], o = e1[2], a = t1[0], s = t1[1], l = t1[2];
                    return Math.abs(i - a) <= n * Math.max(1, Math.abs(i), Math.abs(a)) && Math.abs(r - s) <= n * Math.max(1, Math.abs(r), Math.abs(s)) && Math.abs(o - l) <= n * Math.max(1, Math.abs(o), Math.abs(l));
                }(this.pos, e1) || 0 === t1) return i[0] = i[1] = i[2] = 0, !1;
                const [r, o, a] = this.dir, s = this.pos[0] - e1[0], l = this.pos[1] - e1[1], u = this.pos[2] - e1[2], c = r * r + o * o + a * a, h = 2 * (s * r + l * o + u * a), d = h * h - 4 * c * (s * s + l * l + u * u - t1 * t1);
                if (d < 0) {
                    const e1 = Math.max(-h / 2, 0), n = s + r * e1, c = l + o * e1, d = u + a * e1, f = Math.hypot(n, c, d);
                    return i[0] = n * t1 / f, i[1] = c * t1 / f, i[2] = d * t1 / f, !1;
                }
                {
                    const e1 = (-h - Math.sqrt(d)) / (2 * c);
                    if (e1 < 0) {
                        const e1 = Math.hypot(s, l, u);
                        return i[0] = s * t1 / e1, i[1] = l * t1 / e1, i[2] = u * t1 / e1, !1;
                    }
                    return i[0] = s + r * e1, i[1] = l + o * e1, i[2] = u + a * e1, !0;
                }
            }
        }
        class yf {
            constructor(e1, t1, i, n, r){
                this.TL = e1, this.TR = t1, this.BR = i, this.BL = n, this.horizon = r;
            }
            static fromInvProjectionMatrix(e1, t1, i) {
                const n = [
                    -1,
                    1,
                    1
                ], r = [
                    1,
                    1,
                    1
                ], o = [
                    1,
                    -1,
                    1
                ], a = [
                    -1,
                    -1,
                    1
                ], s = Y(n, n, e1), l = Y(r, r, e1), u = Y(o, o, e1), c = Y(a, a, e1);
                return new yf(s, l, u, c, t1 / i);
            }
        }
        function xf(e1, t1, i, n) {
            const r = t1[0], o = t1[1], a = t1[2], s = i[0], l = i[1], u = i[2];
            let c = 1 / 0, h = -1 / 0;
            for(let t1 = 0; t1 < e1.length; t1++){
                const i = e1[t1], n = (i[0] - r) * s + (i[1] - o) * l + (i[2] - a) * u;
                n < c && (c = n), n > h && (h = n);
            }
            return n[0] = c, n[1] = h, n;
        }
        function vf(e1, t1) {
            let i = !0;
            for(let n = 0; n < e1.planes.length; n++){
                const r = e1.planes[n];
                let o = 0;
                for(let e1 = 0; e1 < t1.length; e1++)o += +(W(r, t1[e1]) + r[3] >= 0);
                if (0 === o) return 0;
                o !== t1.length && (i = !1);
            }
            return i ? 2 : 1;
        }
        const bf = [
            0,
            0
        ];
        function wf(e1, t1) {
            for (const i of e1.projections){
                const n = xf(t1, e1.points[0], i.axis, bf);
                if (i.projection[1] < n[0] || i.projection[0] > n[1]) return 0;
            }
            return 1;
        }
        function Ef(e1, t1) {
            const i = t1[0], n = t1[1], r = t1[2], o = t1[3];
            for(let t1 = 0; t1 < e1.length; t1++){
                const a = e1[t1];
                if (i * a[0] + n * a[1] + r * a[2] + o >= 0) return !0;
            }
            return !1;
        }
        class Af {
            constructor(e1, t1){
                this.points = e1 || new Array(8).fill([
                    0,
                    0,
                    0
                ]), this.planes = t1 || new Array(6).fill([
                    0,
                    0,
                    0,
                    0
                ]), this.bounds = If.fromPoints(this.points), this.projections = [], this.frustumEdges = [
                    te([], this.points[2], this.points[3]),
                    te([], this.points[0], this.points[3]),
                    te([], this.points[4], this.points[0]),
                    te([], this.points[5], this.points[1]),
                    te([], this.points[6], this.points[2]),
                    te([], this.points[7], this.points[3])
                ];
                for (const e1 of this.frustumEdges){
                    const t1 = [
                        0,
                        -e1[2],
                        e1[1]
                    ], i = [
                        e1[2],
                        0,
                        -e1[0]
                    ];
                    this.projections.push({
                        axis: t1,
                        projection: xf(this.points, this.points[0], t1, [
                            0,
                            0
                        ])
                    }), this.projections.push({
                        axis: i,
                        projection: xf(this.points, this.points[0], i, [
                            0,
                            0
                        ])
                    });
                }
            }
            static fromInvProjectionMatrix(e1, t1, i, n) {
                const r = Math.pow(2, i), o = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((i)=>{
                    const o = le([], i, e1), a = 1 / o[3] / t1 * r;
                    var s, l, u;
                    return (s = o)[0] = (l = o)[0] * (u = [
                        a,
                        a,
                        n ? 1 / o[3] : a,
                        a
                    ])[0], s[1] = l[1] * u[1], s[2] = l[2] * u[2], s[3] = l[3] * u[3], s;
                }), a = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((e1)=>{
                    const t1 = Z([], q([], te([], o[e1[0]], o[e1[1]]), te([], o[e1[2]], o[e1[1]]))), i = -W(t1, o[e1[1]]);
                    return t1.concat(i);
                }), s = [];
                for(let e1 = 0; e1 < o.length; e1++)s.push([
                    o[e1][0],
                    o[e1][1],
                    o[e1][2]
                ]);
                return new Af(s, a);
            }
            intersectsPrecise(e1, t1, i) {
                for(let i = 0; i < t1.length; i++)if (!Ef(e1, t1[i])) return 0;
                for(let t1 = 0; t1 < this.planes.length; t1++)if (!Ef(e1, this.planes[t1])) return 0;
                const n = this.points, r = n[0][0], o = n[0][1], a = n[0][2];
                for (const t1 of i)for (const i of this.frustumEdges){
                    const s = t1[1] * i[2] - t1[2] * i[1], l = t1[2] * i[0] - t1[0] * i[2], u = t1[0] * i[1] - t1[1] * i[0];
                    if (0 === s && 0 === l && 0 === u) continue;
                    let c = 1 / 0, h = -1 / 0;
                    for(let e1 = 0; e1 < n.length; e1++){
                        const t1 = n[e1], i = (t1[0] - r) * s + (t1[1] - o) * l + (t1[2] - a) * u;
                        i < c && (c = i), i > h && (h = i);
                    }
                    let d = 1 / 0, f = -1 / 0;
                    for(let t1 = 0; t1 < e1.length; t1++){
                        const i = e1[t1], n = (i[0] - r) * s + (i[1] - o) * l + (i[2] - a) * u;
                        n < d && (d = n), n > f && (f = n);
                    }
                    if (c > f || d > h) return 0;
                }
                return 1;
            }
            containsPoint(e1) {
                for (const t1 of this.planes){
                    const i = t1[3];
                    if (W([
                        t1[0],
                        t1[1],
                        t1[2]
                    ], e1) + i < 0) return !1;
                }
                return !0;
            }
        }
        class If {
            static fromPoints(e1) {
                const t1 = [
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], i = [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ];
                for (const n of e1)N(t1, t1, n), V(i, i, n);
                return new If(t1, i);
            }
            static fromTileIdAndHeight(e1, t1, i) {
                const n = 1 << e1.canonical.z, r = e1.canonical.x, o = e1.canonical.y;
                return new If([
                    r / n,
                    o / n,
                    t1
                ], [
                    (r + 1) / n,
                    (o + 1) / n,
                    i
                ]);
            }
            static applyTransform(e1, t1) {
                const i = e1.getCorners();
                for(let e1 = 0; e1 < i.length; ++e1)Y(i[e1], i[e1], t1);
                return If.fromPoints(i);
            }
            static applyTransformFast(e1, t1) {
                const i = [
                    t1[12],
                    t1[13],
                    t1[14]
                ], n = [
                    ...i
                ];
                for(let r = 0; r < 3; r++)for(let o = 0; o < 3; o++){
                    const a = t1[4 * o + r], s = a * e1.min[o], l = a * e1.max[o];
                    i[r] += Math.min(s, l), n[r] += Math.max(s, l);
                }
                return new If(i, n);
            }
            static projectAabbCorners(e1, t1) {
                const i = e1.getCorners();
                for(let e1 = 0; e1 < i.length; ++e1)Y(i[e1], i[e1], t1);
                return i;
            }
            constructor(e1, t1){
                this.min = e1, this.max = t1, this.center = k([], O([], this.min, this.max), .5);
            }
            quadrant(e1) {
                const t1 = [
                    e1 % 2 == 0,
                    e1 < 2
                ], i = P(this.min), n = P(this.max);
                for(let e1 = 0; e1 < t1.length; e1++)i[e1] = t1[e1] ? this.min[e1] : this.center[e1], n[e1] = t1[e1] ? this.center[e1] : this.max[e1];
                return n[2] = this.max[2], new If(i, n);
            }
            distanceX(e1) {
                return Math.max(Math.min(this.max[0], e1[0]), this.min[0]) - e1[0];
            }
            distanceY(e1) {
                return Math.max(Math.min(this.max[1], e1[1]), this.min[1]) - e1[1];
            }
            distanceZ(e1) {
                return Math.max(Math.min(this.max[2], e1[2]), this.min[2]) - e1[2];
            }
            getCorners() {
                const e1 = this.min, t1 = this.max;
                return [
                    [
                        e1[0],
                        e1[1],
                        e1[2]
                    ],
                    [
                        t1[0],
                        e1[1],
                        e1[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        t1[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        e1[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        e1[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e1[0],
                        t1[1],
                        t1[2]
                    ]
                ];
            }
            intersects(e1) {
                return this.intersectsAabb(e1.bounds) ? vf(e1, this.getCorners()) : 0;
            }
            intersectsFlat(e1) {
                return this.intersectsAabb(e1.bounds) ? vf(e1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsPrecise(e1, t1) {
                return t1 || this.intersects(e1) ? wf(e1, this.getCorners()) : 0;
            }
            intersectsPreciseFlat(e1, t1) {
                return t1 || this.intersectsFlat(e1) ? wf(e1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsAabb(e1) {
                for(let t1 = 0; t1 < 3; ++t1)if (this.min[t1] > e1.max[t1] || e1.min[t1] > this.max[t1]) return !1;
                return !0;
            }
            intersectsAabbXY(e1) {
                return !(this.min[0] > e1.max[0] || e1.min[0] > this.max[0] || this.min[1] > e1.max[1] || e1.min[1] > this.max[1]);
            }
            encapsulate(e1) {
                for(let t1 = 0; t1 < 3; t1++)this.min[t1] = Math.min(this.min[t1], e1.min[t1]), this.max[t1] = Math.max(this.max[t1], e1.max[t1]);
            }
            encapsulatePoint(e1) {
                for(let t1 = 0; t1 < 3; t1++)this.min[t1] = Math.min(this.min[t1], e1[t1]), this.max[t1] = Math.max(this.max[t1], e1[t1]);
            }
            closestPoint(e1) {
                return [
                    Math.max(Math.min(this.max[0], e1[0]), this.min[0]),
                    Math.max(Math.min(this.max[1], e1[1]), this.min[1]),
                    Math.max(Math.min(this.max[2], e1[2]), this.min[2])
                ];
            }
        }
        function Tf(e1) {
            return e1 * iu / uu;
        }
        Ha(If, "Aabb");
        const Mf = [
            new If([
                ou,
                ou,
                ou
            ], [
                au,
                au,
                au
            ]),
            new If([
                ou,
                ou,
                ou
            ], [
                0,
                0,
                au
            ]),
            new If([
                0,
                ou,
                ou
            ], [
                au,
                0,
                au
            ]),
            new If([
                ou,
                0,
                ou
            ], [
                0,
                au,
                au
            ]),
            new If([
                0,
                0,
                ou
            ], [
                au,
                au,
                au
            ])
        ];
        function Sf(e1, t1, i, n = !0) {
            const r = k([], e1._camera.position, e1.worldSize), o = [
                t1,
                i,
                1,
                1
            ];
            le(o, o, e1.pixelMatrixInverse), ae(o, o, 1 / o[3]);
            const a = Z([], te([], o, r)), s = e1.globeMatrix, l = [
                s[12],
                s[13],
                s[14]
            ], u = te([], l, r), c = D(u), h = Z([], u), d = e1.worldSize / (2 * Math.PI), f = W(h, a), p = Math.asin(d / c);
            if (p < Math.acos(f)) {
                if (!n) return null;
                const e1 = [], t1 = [];
                k(e1, a, c / f), Z(t1, te(t1, e1, u)), Z(a, O(a, u, k(a, t1, Math.tan(p) * c)));
            }
            const _ = [];
            new gf(r, a).closestPointOnSphere(l, d, _);
            const m = Z([], At(s, 0)), g = Z([], At(s, 1)), y = Z([], At(s, 2)), x = W(m, _), v = W(g, _), b = W(y, _), w = Je(Math.asin(-v / d));
            let E = Je(Math.atan2(x, b));
            E = e1.center.lng + function(e1, t1) {
                const i = (t1 - e1 + 180) % 360 - 180;
                return i < -180 ? i + 360 : i;
            }(e1.center.lng, E);
            const A = hr(E), I = tt(dr(w), 0, 1);
            return new bu(A, I);
        }
        class zf {
            constructor(e1, t1, i){
                this.a = te([], e1, i), this.b = te([], t1, i), this.center = i;
                const n = Z([], this.a), r = Z([], this.b);
                this.angle = Math.acos(W(n, r));
            }
        }
        function Rf(e1, t1) {
            if (0 === e1.angle) return null;
            let i;
            return i = 0 === e1.a[t1] ? 1 / e1.angle * .5 * Math.PI : 1 / e1.angle * Math.atan(e1.b[t1] / e1.a[t1] / Math.sin(e1.angle) - 1 / Math.tan(e1.angle)), i < 0 || i > 1 ? null : function(e1, t1, i, n) {
                const r = Math.sin(i);
                return e1 * (Math.sin((1 - n) * i) / r) + t1 * (Math.sin(n * i) / r);
            }(e1.a[t1], e1.b[t1], e1.angle, tt(i, 0, 1)) + e1.center[t1];
        }
        function Pf(e1) {
            if (e1.z <= 1) return Mf[e1.z + 2 * e1.y + e1.x];
            const t1 = Lf(Of(e1));
            return If.fromPoints(t1);
        }
        function Df(e1, t1, i) {
            return k(e1, e1, 1 - i), U(e1, e1, t1, i);
        }
        function Cf(e1, t1, i) {
            for (const n of e1)Y(n, n, t1), k(n, n, i);
        }
        function Ff(e1, t1, i, n) {
            const r = t1 / e1.worldSize, o = e1.globeMatrix;
            if (i.z <= 1) {
                const e1 = Pf(i).getCorners();
                return Cf(e1, o, r), If.fromPoints(e1);
            }
            const a = Of(i, n), s = Lf(a, iu + Tf(e1._tileCoverLift));
            Cf(s, o, r);
            const l = Number.MAX_VALUE, u = [
                -l,
                -l,
                -l
            ], c = [
                l,
                l,
                l
            ];
            if (a.contains(e1.center)) {
                for (const e1 of s)N(c, c, e1), V(u, u, e1);
                u[2] = 0;
                const t1 = e1.point, i = [
                    t1.x * r,
                    t1.y * r,
                    0
                ];
                return N(c, c, i), V(u, u, i), new If(c, u);
            }
            if (e1._tileCoverLift > 0) {
                for (const e1 of s)N(c, c, e1), V(u, u, e1);
                return new If(c, u);
            }
            const h = [
                o[12] * r,
                o[13] * r,
                o[14] * r
            ], d = a.getCenter(), f = tt(e1.center.lat, -85.051129, mu), p = tt(d.lat, -85.051129, mu), _ = hr(e1.center.lng), m = dr(f);
            let g = _ - hr(d.lng);
            const y = m - dr(p);
            g > .5 ? g -= 1 : g < -0.5 && (g += 1);
            let x = 0;
            Math.abs(g) > Math.abs(y) ? x = g >= 0 ? 1 : 3 : (x = y >= 0 ? 0 : 2, U(h, h, [
                o[4] * r,
                o[5] * r,
                o[6] * r
            ], -Math.sin(Ye(y >= 0 ? a.getSouth() : a.getNorth())) * iu));
            const v = s[x], b = s[(x + 1) % 4], w = new zf(v, b, h), E = [
                Rf(w, 0) || v[0],
                Rf(w, 1) || v[1],
                Rf(w, 2) || v[2]
            ], A = $f(e1.zoom);
            if (A > 0) {
                const n = function({ x: e1, y: t1, z: i }, n, r, o, a) {
                    const s = 1 / (1 << i);
                    let l = e1 * s, u = l + s, c = t1 * s, h = c + s, d = 0;
                    const f = (l + u) / 2 - o;
                    return f > .5 ? d = -1 : f < -0.5 && (d = 1), l = ((l + d) * n - (o *= n)) * r + o, u = ((u + d) * n - o) * r + o, c = (c * n - (a *= n)) * r + a, h = (h * n - a) * r + a, [
                        [
                            l,
                            h,
                            0
                        ],
                        [
                            u,
                            h,
                            0
                        ],
                        [
                            u,
                            c,
                            0
                        ],
                        [
                            l,
                            c,
                            0
                        ]
                    ];
                }(i, t1, e1._pixelsPerMercatorPixel, _, m);
                for(let e1 = 0; e1 < s.length; e1++)Df(s[e1], n[e1], A);
                const r = O([], n[x], n[(x + 1) % 4]);
                k(r, r, .5), Df(E, r, A);
            }
            for (const e1 of s)N(c, c, e1), V(u, u, e1);
            return c[2] = Math.min(v[2], b[2]), N(c, c, E), V(u, u, E), new If(c, u);
        }
        function Of({ x: e1, y: t1, z: i }, n = !1) {
            const r = 1 / (1 << i), o = new hu(fr(e1 * r), t1 === (1 << i) - 1 && n ? -90 : pr((t1 + 1) * r)), a = new hu(fr((e1 + 1) * r), 0 === t1 && n ? 90 : pr(t1 * r));
            return new du(o, a);
        }
        function Lf(e1, t1 = iu) {
            const i = Ye(e1.getNorth()), n = Ye(e1.getSouth()), r = Math.cos(i), o = Math.cos(n), a = Math.sin(i), s = Math.sin(n), l = e1.getWest(), u = e1.getEast();
            return [
                su(o, s, l, t1),
                su(o, s, u, t1),
                su(r, a, u, t1),
                su(r, a, l, t1)
            ];
        }
        function Bf(e1, t1, i, n) {
            const r = 1 << i.z, o = (e1 / Sr + i.x) / r;
            return lu(pr((t1 / Sr + i.y) / r), fr(o), n);
        }
        function Nf({ min: e1, max: t1 }) {
            return 16383 / Math.max(t1[0] - e1[0], t1[1] - e1[1], t1[2] - e1[2]);
        }
        const Vf = new Float64Array(16);
        function kf(e1) {
            const t1 = Nf(e1), i = w(Vf, [
                t1,
                t1,
                t1
            ]);
            return m(i, i, $([], e1.min));
        }
        function Uf(e1) {
            const t1 = 1 / Nf(e1);
            return b(Vf, e1.min), g(Vf, Vf, [
                t1,
                t1,
                t1
            ]);
        }
        function Gf(e1) {
            const t1 = Sr / (2 * Math.PI);
            return e1 / (2 * Math.PI) / t1;
        }
        function jf(e1, t1) {
            return Sr / (512 * Math.pow(2, e1)) * Nf(Pf(t1));
        }
        function Hf(e1, t1, i, n, r) {
            const o = Gf(i), a = [
                e1,
                t1,
                -i / (2 * Math.PI)
            ], s = d(new Float64Array(16));
            return m(s, s, a), g(s, s, [
                o,
                o,
                o
            ]), y(s, s, Ye(-r)), x(s, s, Ye(-n)), s;
        }
        function $f(e1) {
            return it(5, 6, e1);
        }
        function Zf(e1, t1) {
            const i = lu(t1.lat, t1.lng), n = function(e1) {
                const t1 = lu(e1._center.lat, e1._center.lng);
                let i = q([], C(0, 1, 0), t1);
                const n = E([], -e1.angle, t1);
                i = Y(i, i, n), E(n, -e1._pitch, i);
                const r = Z([], t1);
                return k(r, r, Tf(e1.cameraToCenterDistance / e1.pixelsPerMeter)), Y(r, r, n), O([], t1, r);
            }(e1);
            var r, o, a, s, l, u, c, h, d, f;
            return a = (r = L([], n, i))[0], s = r[1], l = r[2], u = (o = i)[0], c = o[1], h = o[2], f = (d = Math.sqrt((a * a + s * s + l * l) * (u * u + c * c + h * h))) && W(r, o) / d, Math.acos(Math.min(Math.max(f, -1), 1));
        }
        function Wf(e1, t1) {
            return Zf(e1, t1) > Math.PI / 2 * 1.01;
        }
        const qf = Ye(85), Xf = Math.cos(qf), Yf = Math.sin(qf);
        function Jf(e1, t1) {
            const i = e1.fovAboveCenter, n = e1.elevation ? e1.elevation.getMinElevationBelowMSL() * t1 : 0, r = Math.min(n, e1.isOrthographic ? -10 * t1 : 0), o = (e1._camera.position[2] * e1.worldSize - r) / Math.cos(e1._pitch), a = Math.sin(i) * o / Math.sin(Math.max(Math.PI / 2 - e1._pitch - i, .01));
            let s = Math.sin(e1._pitch) * a + o;
            const l = o * (1 / e1._horizonShift);
            if (!e1.elevation || 0 === e1.elevation.exaggeration()) {
                let t1 = Math.max(e1.zoom - 17, 0);
                e1.isOrthographic && (t1 /= 10), s *= 1 + t1;
            }
            return Math.min(1.01 * s, l);
        }
        class Kf {
            constructor(e1, t1, i){
                this.z = e1, this.x = t1, this.y = i, this.key = tp(0, e1, e1, t1, i);
            }
            equals(e1) {
                return this.z === e1.z && this.x === e1.x && this.y === e1.y;
            }
            isChildOf(e1) {
                const t1 = this.z - e1.z;
                return 0 === e1.z || e1.z < this.z && e1.x === this.x >> t1 && e1.y === this.y >> t1;
            }
            url(e1, t1) {
                const i = function(e1, t1, i) {
                    const n = 2 ** i, r = 2 * Math.PI * 6378137, o = r * (e1 / n - .5), a = r * (.5 - (t1 + 1) / n);
                    return `${o},${a},${o + r / n},${a + r / n}`;
                }(this.x, this.y, this.z), n = function(e1, t1, i) {
                    let n, r = "";
                    for(let o = e1; o > 0; o--)n = 1 << o - 1, r += (t1 & n ? 1 : 0) + (i & n ? 2 : 0);
                    return r;
                }(this.z, this.x, this.y);
                return e1[(this.x + this.y) % e1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === t1 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n).replace("{bbox-epsg-3857}", i);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class Qf {
            constructor(e1, t1){
                this.wrap = e1, this.canonical = t1, this.key = tp(e1, t1.z, t1.z, t1.x, t1.y);
            }
        }
        class ep {
            constructor(e1, t1, i, n, r){
                this.overscaledZ = e1, this.wrap = t1, this.canonical = new Kf(i, +n, +r), this.key = 0 === t1 && e1 === i ? this.canonical.key : tp(t1, e1, i, n, r);
            }
            equals(e1) {
                return this.overscaledZ === e1.overscaledZ && this.wrap === e1.wrap && this.canonical.equals(e1.canonical);
            }
            scaledTo(e1) {
                const t1 = this.canonical.z - e1;
                return e1 > this.canonical.z ? new ep(e1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new ep(e1, this.wrap, e1, this.canonical.x >> t1, this.canonical.y >> t1);
            }
            calculateScaledKey(e1, t1 = !0) {
                if (this.overscaledZ === e1 && t1) return this.key;
                if (e1 > this.canonical.z) return tp(this.wrap * +t1, e1, this.canonical.z, this.canonical.x, this.canonical.y);
                {
                    const i = this.canonical.z - e1;
                    return tp(this.wrap * +t1, e1, e1, this.canonical.x >> i, this.canonical.y >> i);
                }
            }
            isChildOf(e1) {
                if (e1.wrap !== this.wrap) return !1;
                const t1 = this.canonical.z - e1.canonical.z;
                return 0 === e1.overscaledZ || e1.overscaledZ < this.overscaledZ && e1.canonical.z < this.canonical.z && e1.canonical.x === this.canonical.x >> t1 && e1.canonical.y === this.canonical.y >> t1;
            }
            children(e1) {
                if (this.overscaledZ >= e1) return [
                    new ep(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const t1 = this.canonical.z + 1, i = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new ep(t1, this.wrap, t1, i, n),
                    new ep(t1, this.wrap, t1, i + 1, n),
                    new ep(t1, this.wrap, t1, i, n + 1),
                    new ep(t1, this.wrap, t1, i + 1, n + 1)
                ];
            }
            isLessThan(e1) {
                return this.wrap < e1.wrap || !(this.wrap > e1.wrap) && (this.overscaledZ < e1.overscaledZ || !(this.overscaledZ > e1.overscaledZ) && (this.canonical.x < e1.canonical.x || !(this.canonical.x > e1.canonical.x) && this.canonical.y < e1.canonical.y));
            }
            wrapped() {
                return new ep(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(e1) {
                return new ep(this.overscaledZ, e1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new Qf(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
        }
        function tp(e1, t1, i, n, r) {
            const o = 1 << Math.min(i, 22);
            let a = o * (r % o) + n % o;
            return e1 && i < 22 && (a += o * o * ((e1 < 0 ? -2 * e1 - 1 : 2 * e1) % (1 << 2 * (22 - i)))), 16 * (32 * a + i) + (t1 - i);
        }
        const ip = [
            (e1)=>{
                let t1 = e1.canonical.x - 1, i = e1.wrap;
                return t1 < 0 && (t1 = (1 << e1.canonical.z) - 1, i--), new ep(e1.overscaledZ, i, e1.canonical.z, t1, e1.canonical.y);
            },
            (e1)=>{
                let t1 = e1.canonical.x + 1, i = e1.wrap;
                return t1 === 1 << e1.canonical.z && (t1 = 0, i++), new ep(e1.overscaledZ, i, e1.canonical.z, t1, e1.canonical.y);
            },
            (e1)=>new ep(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, (0 === e1.canonical.y ? 1 << e1.canonical.z : e1.canonical.y) - 1),
            (e1)=>new ep(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y === (1 << e1.canonical.z) - 1 ? 0 : e1.canonical.y + 1)
        ];
        function np(e1, t1) {
            if (!t1.isReprojectedInTileSpace) return {
                scale: 1 << e1.z,
                x: e1.x,
                y: e1.y,
                x2: e1.x + 1,
                y2: e1.y + 1,
                projection: t1
            };
            const i = Math.pow(2, -e1.z), n = e1.x * i, r = (e1.x + 1) * i, o = e1.y * i, a = (e1.y + 1) * i, s = fr(n), l = fr(r), u = pr(o), c = pr(a), h = t1.project(s, u), d = t1.project(l, u), f = t1.project(l, c), p = t1.project(s, c);
            let _ = Math.min(h.x, d.x, f.x, p.x), m = Math.min(h.y, d.y, f.y, p.y), g = Math.max(h.x, d.x, f.x, p.x), y = Math.max(h.y, d.y, f.y, p.y);
            const x = i / 16;
            function v(e1, i, n, r, o, a) {
                const s = (n + o) / 2, l = (r + a) / 2, u = t1.project(fr(s), pr(l)), c = Math.max(0, _ - u.x, m - u.y, u.x - g, u.y - y);
                _ = Math.min(_, u.x), g = Math.max(g, u.x), m = Math.min(m, u.y), y = Math.max(y, u.y), c > x && (v(e1, u, n, r, s, l), v(u, i, s, l, o, a));
            }
            v(h, d, n, o, r, o), v(d, f, r, o, r, a), v(f, p, r, a, n, a), v(p, h, n, a, n, o), _ -= x, m -= x, g += x, y += x;
            const b = 1 / Math.max(g - _, y - m);
            return {
                scale: b,
                x: _ * b,
                y: m * b,
                x2: g * b,
                y2: y * b,
                projection: t1
            };
        }
        function rp(e1, t1, i, n, r, o, a, s, l) {
            if ("globe" === l.name) return Ff(e1, t1, new Kf(i, n, r), !1);
            const u = np({
                z: i,
                x: n,
                y: r
            }, l);
            return new If([
                (o + u.x / u.scale) * t1,
                t1 * (u.y / u.scale),
                a
            ], [
                (o + u.x2 / u.scale) * t1,
                t1 * (u.y2 / u.scale),
                s
            ]);
        }
        Ha(Kf, "CanonicalTileID"), Ha(ep, "OverscaledTileID", {
            omit: [
                "projMatrix",
                "expandedProjMatrix"
            ]
        });
        const op = d(new Float32Array(16));
        class ap {
            constructor(e1){
                this.spec = e1, this.name = e1.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = [
                    "custom"
                ], this.center = [
                    0,
                    0
                ], this.range = [
                    3.5,
                    7
                ];
            }
            project(e1, t1) {
                return {
                    x: 0,
                    y: 0,
                    z: 0
                };
            }
            unproject(e1, t1) {
                return new hu(0, 0);
            }
            projectTilePoint(e1, t1, i) {
                return {
                    x: e1,
                    y: t1,
                    z: 0
                };
            }
            locationPoint(e1, t1, i, n = !0) {
                return e1._coordinatePoint(e1.locationCoordinate(t1, i), n);
            }
            pixelsPerMeter(e1, t1) {
                return pu(1, e1) * t1;
            }
            pixelSpaceConversion(e1, t1, i) {
                return 1;
            }
            farthestPixelDistance(e1) {
                return Jf(e1, e1.pixelsPerMeter);
            }
            pointCoordinate(e1, t1, i, n) {
                const r = e1.horizonLineFromTop(!1), o = new Pe(t1, Math.max(r, i));
                return e1.rayIntersectionCoordinate(e1.pointRayIntersection(o, n));
            }
            pointCoordinate3D(e1, t1, i) {
                const n = new Pe(t1, i);
                if (e1.elevation) return e1.elevation.pointCoordinate(n);
                {
                    const t1 = this.pointCoordinate(e1, n.x, n.y, 0);
                    return [
                        t1.x,
                        t1.y,
                        t1.z
                    ];
                }
            }
            isPointAboveHorizon(e1, t1) {
                if (e1.elevation && e1.elevation.visibleDemTiles.length) return !this.pointCoordinate3D(e1, t1.x, t1.y);
                const i = e1.horizonLineFromTop();
                return t1.y < i;
            }
            createInversionMatrix(e1, t1) {
                return op;
            }
            createTileMatrix(e1, t1, i) {
                let n, r, o;
                const a = i.canonical, s = d(new Float64Array(16));
                if (this.isReprojectedInTileSpace) {
                    const l = np(a, this);
                    n = 1, r = l.x + i.wrap * l.scale, o = l.y, g(s, s, [
                        n / l.scale,
                        n / l.scale,
                        e1.pixelsPerMeter / t1
                    ]);
                } else n = t1 / e1.zoomScale(a.z), r = (a.x + Math.pow(2, a.z) * i.wrap) * n, o = a.y * n;
                return m(s, s, [
                    r,
                    o,
                    0
                ]), g(s, s, [
                    n / Sr,
                    n / Sr,
                    1
                ]), s;
            }
            upVector(e1, t1, i) {
                return [
                    0,
                    0,
                    1
                ];
            }
            upVectorScale(e1, t1, i) {
                return {
                    metersToTile: 1
                };
            }
        }
        class sp extends ap {
            constructor(e1){
                super(e1), this.range = [
                    4,
                    7
                ], this.center = e1.center || [
                    -96,
                    37.5
                ];
                const [t1, i] = this.parallels = e1.parallels || [
                    29.5,
                    45.5
                ], n = Math.sin(Ye(t1));
                this.n = (n + Math.sin(Ye(i))) / 2, this.c = 1 + n * (2 * this.n - n), this.r0 = Math.sqrt(this.c) / this.n;
            }
            project(e1, t1) {
                const { n: i, c: n, r0: r } = this, o = Ye(e1 - this.center[0]), a = Ye(t1), s = Math.sqrt(n - 2 * i * Math.sin(a)) / i;
                return {
                    x: s * Math.sin(o * i),
                    y: s * Math.cos(o * i) - r,
                    z: 0
                };
            }
            unproject(e1, t1) {
                const { n: i, c: n, r0: r } = this, o = r + t1;
                let a = Math.atan2(e1, Math.abs(o)) * Math.sign(o);
                o * i < 0 && (a -= Math.PI * Math.sign(e1) * Math.sign(o));
                const s = Ye(this.center[0]) * i;
                a = nt(a, -Math.PI - s, Math.PI - s);
                const l = tt(Je(a / i) + this.center[0], -180, 180), u = Math.asin(tt((n - (e1 * e1 + o * o) * i * i) / (2 * i), -1, 1)), c = tt(Je(u), -85.051129, mu);
                return new hu(l, c);
            }
        }
        const lp = 1.340264, up = -0.081106, cp = 893e-6, hp = .003796, dp = Math.sqrt(3) / 2;
        class fp extends ap {
            project(e1, t1) {
                t1 = t1 / 180 * Math.PI, e1 = e1 / 180 * Math.PI;
                const i = Math.asin(dp * Math.sin(t1)), n = i * i, r = n * n * n;
                return {
                    x: .5 * (e1 * Math.cos(i) / (dp * (lp + 3 * up * n + r * (7 * cp + 9 * hp * n))) / Math.PI + .5),
                    y: 1 - .5 * (i * (lp + up * n + r * (cp + hp * n)) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t1) {
                e1 = (2 * e1 - .5) * Math.PI;
                let i = t1 = (2 * (1 - t1) - 1) * Math.PI, n = i * i, r = n * n * n;
                for(let e1, o, a, s = 0; s < 12 && (o = i * (lp + up * n + r * (cp + hp * n)) - t1, a = lp + 3 * up * n + r * (7 * cp + 9 * hp * n), e1 = o / a, i = tt(i - e1, -Math.PI / 3, Math.PI / 3), n = i * i, r = n * n * n, !(Math.abs(e1) < 1e-12)); ++s);
                const o = dp * e1 * (lp + 3 * up * n + r * (7 * cp + 9 * hp * n)) / Math.cos(i), a = Math.asin(Math.sin(i) / dp), s = tt(180 * o / Math.PI, -180, 180), l = tt(180 * a / Math.PI, -85.051129, mu);
                return new hu(s, l);
            }
        }
        class pp extends ap {
            constructor(e1){
                super(e1), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(e1, t1) {
                return {
                    x: .5 + e1 / 360,
                    y: .5 - t1 / 360,
                    z: 0
                };
            }
            unproject(e1, t1) {
                const i = 360 * (e1 - .5), n = tt(360 * (.5 - t1), -85.051129, mu);
                return new hu(i, n);
            }
        }
        const _p = Math.PI / 2;
        function mp(e1) {
            return Math.tan((_p + e1) / 2);
        }
        class gp extends ap {
            constructor(e1){
                super(e1), this.center = e1.center || [
                    0,
                    30
                ];
                const [t1, i] = this.parallels = e1.parallels || [
                    30,
                    30
                ];
                let n = Ye(t1), r = Ye(i);
                this.southernCenter = n + r < 0, this.southernCenter && (n = -n, r = -r);
                const o = Math.cos(n), a = mp(n);
                this.n = n === r ? Math.sin(n) : Math.log(o / Math.cos(r)) / Math.log(mp(r) / a), this.f = o * Math.pow(mp(n), this.n) / this.n;
            }
            project(e1, t1) {
                t1 = Ye(t1), this.southernCenter && (t1 = -t1), e1 = Ye(e1 - this.center[0]);
                const i = 1e-6, { n: n, f: r } = this;
                r > 0 ? t1 < -_p + i && (t1 = -_p + i) : t1 > _p - i && (t1 = _p - i);
                const o = r / Math.pow(mp(t1), n);
                let a = o * Math.sin(n * e1), s = r - o * Math.cos(n * e1);
                return a = .5 * (a / Math.PI + .5), s = .5 * (s / Math.PI + .5), {
                    x: a,
                    y: this.southernCenter ? s : 1 - s,
                    z: 0
                };
            }
            unproject(e1, t1) {
                e1 = (2 * e1 - .5) * Math.PI, this.southernCenter && (t1 = 1 - t1), t1 = (2 * (1 - t1) - .5) * Math.PI;
                const { n: i, f: n } = this, r = n - t1, o = Math.sign(r), a = Math.sign(i) * Math.sqrt(e1 * e1 + r * r);
                let s = Math.atan2(e1, Math.abs(r)) * o;
                r * i < 0 && (s -= Math.PI * Math.sign(e1) * o);
                const l = tt(Je(s / i) + this.center[0], -180, 180), u = tt(Je(2 * Math.atan(Math.pow(n / a, 1 / i)) - _p), -85.051129, mu);
                return new hu(l, this.southernCenter ? -u : u);
            }
        }
        class yp extends ap {
            constructor(e1){
                super(e1), this.wrap = !0, this.supportsWorldCopies = !0, this.supportsTerrain = !0, this.supportsFog = !0, this.supportsFreeCamera = !0, this.isReprojectedInTileSpace = !1, this.unsupportedLayers = [], this.range = null;
            }
            project(e1, t1) {
                return {
                    x: hr(e1),
                    y: dr(t1),
                    z: 0
                };
            }
            unproject(e1, t1) {
                const i = fr(e1), n = pr(t1);
                return new hu(i, n);
            }
        }
        const xp = Ye(mu);
        class vp extends ap {
            project(e1, t1) {
                const i = (t1 = Ye(t1)) * t1, n = i * i;
                return {
                    x: .5 * ((e1 = Ye(e1)) * (.8707 - .131979 * i + n * (n * (.003971 * i - .001529 * n) - .013791)) / Math.PI + .5),
                    y: 1 - .5 * (t1 * (1.007226 + i * (.015085 + n * (.028874 * i - .044475 - .005916 * n))) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t1) {
                e1 = (2 * e1 - .5) * Math.PI;
                let i = t1 = (2 * (1 - t1) - 1) * Math.PI, n = 25, r = 0, o = i * i;
                do {
                    o = i * i;
                    const e1 = o * o;
                    r = (i * (1.007226 + o * (.015085 + e1 * (.028874 * o - .044475 - .005916 * e1))) - t1) / (1.007226 + o * (.045255 + e1 * (.259866 * o - .311325 - .005916 * 11 * e1))), i = tt(i - r, -xp, xp);
                }while (Math.abs(r) > 1e-6 && --n > 0);
                o = i * i;
                const a = tt(Je(e1 / (.8707 + o * (o * (o * o * o * (.003971 - .001529 * o) - .013791) - .131979))), -180, 180), s = Je(i);
                return new hu(a, s);
            }
        }
        const bp = Ye(mu);
        class wp extends ap {
            project(e1, t1) {
                t1 = Ye(t1), e1 = Ye(e1);
                const i = Math.cos(t1), n = 2 / Math.PI, r = Math.acos(i * Math.cos(e1 / 2)), o = Math.sin(r) / r, a = .5 * (e1 * n + 2 * i * Math.sin(e1 / 2) / o) || 0, s = .5 * (t1 + Math.sin(t1) / o) || 0;
                return {
                    x: .5 * (a / Math.PI + .5),
                    y: 1 - .5 * (s / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t1) {
                let i = e1 = (2 * e1 - .5) * Math.PI, n = t1 = (2 * (1 - t1) - 1) * Math.PI, r = 25;
                const o = 1e-6;
                let a = 0, s = 0;
                do {
                    const r = Math.cos(n), o = Math.sin(n), l = 2 * o * r, u = o * o, c = r * r, h = Math.cos(i / 2), d = Math.sin(i / 2), f = 2 * h * d, p = d * d, _ = 1 - c * h * h, m = _ ? 1 / _ : 0, g = _ ? Math.acos(r * h) * Math.sqrt(1 / _) : 0, y = .5 * (2 * g * r * d + 2 * i / Math.PI) - e1, x = .5 * (g * o + n) - t1, v = .5 * m * (c * p + g * r * h * u) + 1 / Math.PI, b = m * (f * l / 4 - g * o * d), w = .125 * m * (l * d - g * o * c * f), E = .5 * m * (u * h + g * p * r) + .5, A = b * w - E * v;
                    a = (x * b - y * E) / A, s = (y * w - x * v) / A, i = tt(i - a, -Math.PI, Math.PI), n = tt(n - s, -bp, bp);
                }while ((Math.abs(a) > o || Math.abs(s) > o) && --r > 0);
                return new hu(Je(i), Je(n));
            }
        }
        class Ep extends ap {
            constructor(e1){
                super(e1), this.center = e1.center || [
                    0,
                    0
                ], this.parallels = e1.parallels || [
                    0,
                    0
                ], this.cosPhi = Math.max(.01, Math.cos(Ye(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(e1, t1) {
                const { scale: i, cosPhi: n } = this;
                return {
                    x: Ye(e1) * n * i + .5,
                    y: -Math.sin(Ye(t1)) / n * i + .5,
                    z: 0
                };
            }
            unproject(e1, t1) {
                const { scale: i, cosPhi: n } = this, r = -(t1 - .5) / i, o = tt(Je((e1 - .5) / i) / n, -180, 180), a = Math.asin(tt(r * n, -1, 1)), s = tt(Je(a), -85.051129, mu);
                return new hu(o, s);
            }
        }
        class Ap extends yp {
            constructor(e1){
                super(e1), this.requiresDraping = !0, this.supportsWorldCopies = !1, this.supportsFog = !0, this.zAxisUnit = "pixels", this.unsupportedLayers = [
                    "debug"
                ], this.range = [
                    3,
                    5
                ];
            }
            projectTilePoint(e1, t1, i) {
                const n = Bf(e1, t1, i);
                return Y(n, n, kf(Pf(i))), {
                    x: n[0],
                    y: n[1],
                    z: n[2]
                };
            }
            locationPoint(e1, t1, i) {
                const n = lu(t1.lat, t1.lng), r = Z([], n), o = i ? e1._centerAltitude + i : e1.elevation ? e1.elevation.getAtPointOrZero(e1.locationCoordinate(t1), e1._centerAltitude) : e1._centerAltitude;
                U(n, n, r, pu(1, 0) * Sr * o);
                const a = d(new Float64Array(16));
                return _(a, e1.pixelMatrix, e1.globeMatrix), Y(n, n, a), new Pe(n[0], n[1]);
            }
            pixelsPerMeter(e1, t1) {
                return pu(1, 0) * t1;
            }
            pixelSpaceConversion(e1, t1, i) {
                const n = pu(1, e1) * t1, r = dn(pu(1, 45) * t1, n, i);
                return this.pixelsPerMeter(e1, t1) / r;
            }
            createTileMatrix(e1, t1, i) {
                const n = Uf(Pf(i.canonical));
                return _(new Float64Array(16), e1.globeMatrix, n);
            }
            createInversionMatrix(e1, t1) {
                const { center: i } = e1, n = kf(Pf(t1));
                return x(n, n, Ye(i.lng)), y(n, n, Ye(i.lat)), g(n, n, [
                    e1._pixelsPerMercatorPixel,
                    e1._pixelsPerMercatorPixel,
                    1
                ]), Float32Array.from(n);
            }
            pointCoordinate(e1, t1, i, n) {
                return Sf(e1, t1, i, !0) || new bu(0, 0);
            }
            pointCoordinate3D(e1, t1, i) {
                const n = this.pointCoordinate(e1, t1, i, 0);
                return [
                    n.x,
                    n.y,
                    n.z
                ];
            }
            isPointAboveHorizon(e1, t1) {
                return !Sf(e1, t1.x, t1.y, !1);
            }
            farthestPixelDistance(e1) {
                const t1 = function(e1, t1) {
                    const i = e1.cameraToCenterDistance, n = e1._centerAltitude * t1, r = e1._camera, o = e1._camera.forward(), a = O([], k([], o, -i), [
                        0,
                        0,
                        n
                    ]), s = e1.worldSize / (2 * Math.PI), l = [
                        0,
                        0,
                        -s
                    ], u = e1.width / e1.height, c = Math.tan(e1.fovAboveCenter), h = k([], r.up(), c), d = k([], r.right(), c * u), f = Z([], O([], O([], o, h), d)), p = [];
                    let _;
                    if (new gf(a, f).closestPointOnSphere(l, s, p)) {
                        const t1 = O([], p, l), i = te([], t1, a);
                        _ = Math.cos(e1.fovAboveCenter) * D(i);
                    } else {
                        const e1 = te([], a, l), t1 = te([], l, a);
                        Z(t1, t1);
                        const i = D(e1) - s;
                        _ = Math.sqrt(i * (i + 2 * s));
                        const n = Math.acos(_ / (s + i)) - Math.acos(W(o, t1));
                        _ *= Math.cos(n);
                    }
                    return 1.01 * _;
                }(e1, this.pixelsPerMeter(e1.center.lat, e1.worldSize)), i = $f(e1.zoom);
                if (i > 0) {
                    const n = Jf(e1, pu(1, e1.center.lat) * e1.worldSize), r = e1.worldSize / (2 * Math.PI), o = Math.max(e1.width, e1.height) / e1.worldSize * Math.PI;
                    return dn(t1, n + r * (1 - Math.cos(o)), Math.pow(i, 10));
                }
                return t1;
            }
            upVector(e1, t1, i) {
                return Bf(t1, i, e1, 1);
            }
            upVectorScale(e1) {
                return {
                    metersToTile: Tf(Nf(Pf(e1)))
                };
            }
        }
        function Ip(e1) {
            const t1 = e1.parallels, i = !!t1 && Math.abs(t1[0] + t1[1]) < .01;
            switch(e1.name){
                case "mercator":
                    return new yp(e1);
                case "equirectangular":
                    return new pp(e1);
                case "naturalEarth":
                    return new vp(e1);
                case "equalEarth":
                    return new fp(e1);
                case "winkelTripel":
                    return new wp(e1);
                case "albers":
                    return i ? new Ep(e1) : new sp(e1);
                case "lambertConformalConic":
                    return i ? new Ep(e1) : new gp(e1);
                case "globe":
                    return new Ap(e1);
            }
            throw new Error(`Invalid projection name: ${e1.name}`);
        }
        const Tp = Number.MAX_SAFE_INTEGER, Mp = Tp - 1;
        function Sp(e1, t1, i, n) {
            return e1.order < t1 || e1.order === Tp || !(e1.clipMask & i) || function(e1, t1) {
                if (0 === t1.length) return !1;
                let i = e1;
                for(; "" !== i;){
                    if (t1.includes(i)) return !1;
                    i = gl(i);
                }
                return !0;
            }(n, e1.clipScope);
        }
        function zp(e1, t1) {
            return e1.x - t1.x || e1.y - t1.y;
        }
        function Rp(e1, t1) {
            return 0 === zp(e1.min, t1.min) && 0 === zp(e1.max, t1.max);
        }
        function Pp(e1, t1) {
            return !(e1.min.x > t1.max.x || e1.max.x < t1.min.x || e1.min.y > t1.max.y || e1.max.y < t1.min.y);
        }
        function Dp(e1, t1) {
            if (e1.length !== t1.length) return !1;
            for(let i = 0; i < e1.length; i++)if (e1[i].sourceId !== t1[i].sourceId || !Rp(e1[i], t1[i]) || e1[i].order !== t1[i].order || e1[i].clipMask !== t1[i].clipMask || !De(e1[i].clipScope, t1[i].clipScope)) return !1;
            return !0;
        }
        function Cp(e1, t1, i) {
            const n = 1 / Sr, r = 1 / (1 << i.canonical.z), o = (t1.x * n + i.canonical.x) * r + i.wrap, a = (t1.y * n + i.canonical.y) * r;
            return {
                min: new Pe((e1.x * n + i.canonical.x) * r + i.wrap, (e1.y * n + i.canonical.y) * r),
                max: new Pe(o, a)
            };
        }
        function Fp(e1, t1, i) {
            const n = 1 << i.canonical.z, r = ((t1.x - i.wrap) * n - i.canonical.x) * Sr, o = (t1.y * n - i.canonical.y) * Sr;
            return {
                min: new Pe(((e1.x - i.wrap) * n - i.canonical.x) * Sr, (e1.y * n - i.canonical.y) * Sr),
                max: new Pe(r, o)
            };
        }
        function Op(e1, t1, i, n, r, o, a) {
            const s = e1.indices, l = e1.vertices, u = [];
            for(let c = n; c < n + r; c += 3){
                const n = t1[i[c + 0] + o], r = t1[i[c + 1] + o], h = t1[i[c + 2] + o], d = Math.min(n.x, r.x, h.x), f = Math.max(n.x, r.x, h.x), p = Math.min(n.y, r.y, h.y), _ = Math.max(n.y, r.y, h.y);
                u.length = 0, e1.grid.query(new Pe(d, p), new Pe(f, _), u);
                for(let e1 = 0; e1 < u.length; e1++){
                    const t1 = u[e1];
                    if (Wh(l[s[3 * t1 + 0]], l[s[3 * t1 + 1]], l[s[3 * t1 + 2]], n, r, h, a)) return !0;
                }
            }
            return !1;
        }
        function Lp(e1, t1, i, n) {
            if (!e1 || !i) return !1;
            let r = e1.vertices;
            if (!t1.canonical.equals(n.canonical) || t1.wrap !== n.wrap) {
                if (i.vertices.length < e1.vertices.length) return Lp(i, n, e1, t1);
                const o = t1.canonical, a = n.canonical, s = Math.pow(2, a.z - o.z);
                r = e1.vertices.map((e1)=>new Pe((e1.x + o.x * Sr) * s - a.x * Sr, (e1.y + o.y * Sr) * s - a.y * Sr));
            }
            return Op(i, r, e1.indices, 0, e1.indices.length, 0, 0);
        }
        function Bp(e1, t1, i, n) {
            const r = Math.pow(2, n.z - i.z);
            return new Pe((e1 + i.x * Sr) * r - n.x * Sr, (t1 + i.y * Sr) * r - n.y * Sr);
        }
        function Np(e1, t1) {
            const i = [];
            t1.grid.queryPoint(e1, i);
            const n = t1.indices, r = t1.vertices;
            for(let t1 = 0; t1 < i.length; t1++){
                const o = i[t1];
                if (jh([
                    r[n[3 * o + 0]],
                    r[n[3 * o + 1]],
                    r[n[3 * o + 2]]
                ], e1)) return !0;
            }
            return !1;
        }
        const Vp = 4294967296, kp = 1 / Vp, Up = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
        class Gp {
            constructor(e1){
                this.buf = ArrayBuffer.isView(e1) ? e1 : new Uint8Array(e1), this.dataView = new DataView(this.buf.buffer, this.buf.byteOffset, this.buf.byteLength), this.pos = 0, this.type = 0, this._valueStart = -1, this.length = this.buf.length;
            }
            readFields(e1, t1, i = this.length) {
                let n;
                for(; n = this.nextField(i);)e1(n, t1, this);
                return t1;
            }
            readMessage(e1, t1) {
                return this.readFields(e1, t1, this.readVarint() + this.pos);
            }
            readFixed32() {
                const e1 = this.dataView.getUint32(this.pos, !0);
                return this.pos += 4, e1;
            }
            readSFixed32() {
                const e1 = this.dataView.getInt32(this.pos, !0);
                return this.pos += 4, e1;
            }
            readFixed64() {
                const e1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * Vp;
                return this.pos += 8, e1;
            }
            readSFixed64() {
                const e1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * Vp;
                return this.pos += 8, e1;
            }
            readFloat() {
                const e1 = this.dataView.getFloat32(this.pos, !0);
                return this.pos += 4, e1;
            }
            readDouble() {
                const e1 = this.dataView.getFloat64(this.pos, !0);
                return this.pos += 8, e1;
            }
            readVarint(e1) {
                const t1 = this.buf, i = t1[this.pos++];
                if (i < 128) return i;
                let n, r = 127 & i;
                return n = t1[this.pos++], r |= (127 & n) << 7, n < 128 ? r : (n = t1[this.pos++], r |= (127 & n) << 14, n < 128 ? r : (n = t1[this.pos++], r |= (127 & n) << 21, n < 128 ? r : (n = t1[this.pos], r |= (15 & n) << 28, function(e1, t1, i) {
                    const n = i.buf;
                    let r, o;
                    if (o = n[i.pos++], r = (112 & o) >> 4, o < 128) return jp(e1, r, t1);
                    if (o = n[i.pos++], r |= (127 & o) << 3, o < 128) return jp(e1, r, t1);
                    if (o = n[i.pos++], r |= (127 & o) << 10, o < 128) return jp(e1, r, t1);
                    if (o = n[i.pos++], r |= (127 & o) << 17, o < 128) return jp(e1, r, t1);
                    if (o = n[i.pos++], r |= (127 & o) << 24, o < 128) return jp(e1, r, t1);
                    if (o = n[i.pos++], r |= (1 & o) << 31, o < 128) return jp(e1, r, t1);
                    throw new Error("Expected varint not more than 10 bytes");
                }(r, e1, this))));
            }
            readSVarint() {
                const e1 = this.readVarint();
                return e1 % 2 == 1 ? (e1 + 1) / -2 : e1 / 2;
            }
            readBoolean() {
                return Boolean(this.readVarint());
            }
            readString() {
                const e1 = this.readVarint() + this.pos, t1 = this.pos;
                return this.pos = e1, e1 - t1 >= 12 && Up ? Up.decode(this.buf.subarray(t1, e1)) : function(e1, t1, i) {
                    let n = "", r = t1;
                    for(; r < i;){
                        const t1 = e1[r];
                        let o, a, s, l = null, u = t1 > 239 ? 4 : t1 > 223 ? 3 : t1 > 191 ? 2 : 1;
                        if (r + u > i) break;
                        1 === u ? t1 < 128 && (l = t1) : 2 === u ? (o = e1[r + 1], 128 == (192 & o) && (l = (31 & t1) << 6 | 63 & o, l <= 127 && (l = null))) : 3 === u ? (o = e1[r + 1], a = e1[r + 2], 128 == (192 & o) && 128 == (192 & a) && (l = (15 & t1) << 12 | (63 & o) << 6 | 63 & a, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === u && (o = e1[r + 1], a = e1[r + 2], s = e1[r + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (l = (15 & t1) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, u = 1) : l > 65535 && (l -= 65536, n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), n += String.fromCharCode(l), r += u;
                    }
                    return n;
                }(this.buf, t1, e1);
            }
            readBytes() {
                const e1 = this.readVarint() + this.pos, t1 = this.buf.subarray(this.pos, e1);
                return this.pos = e1, t1;
            }
            readPackedVarint(e1 = [], t1) {
                const i = this.readPackedEnd();
                for(; this.pos < i;)e1.push(this.readVarint(t1));
                return e1;
            }
            readPackedSVarint(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readSVarint());
                return e1;
            }
            readPackedBoolean(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readBoolean());
                return e1;
            }
            readPackedFloat(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readFloat());
                return e1;
            }
            readPackedDouble(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readDouble());
                return e1;
            }
            readPackedFixed32(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readFixed32());
                return e1;
            }
            readPackedSFixed32(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readSFixed32());
                return e1;
            }
            readPackedFixed64(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readFixed64());
                return e1;
            }
            readPackedSFixed64(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readSFixed64());
                return e1;
            }
            readPackedEnd() {
                return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
            }
            nextField(e1 = this.length) {
                if (this.pos === this._valueStart && this.skip(this.type), this.pos >= e1) return 0;
                const t1 = this.readVarint();
                return this.type = 7 & t1, this._valueStart = this.pos, t1 >>> 3;
            }
            skip(e1) {
                const t1 = 7 & e1;
                if (0 === t1) for(; this.buf[this.pos++] > 127;);
                else if (2 === t1) this.pos = this.readVarint() + this.pos;
                else if (5 === t1) this.pos += 4;
                else {
                    if (1 !== t1) throw new Error(`Unimplemented type: ${t1}`);
                    this.pos += 8;
                }
            }
        }
        function jp(e1, t1, i) {
            return i ? 4294967296 * t1 + (e1 >>> 0) : 4294967296 * (t1 >>> 0) + (e1 >>> 0);
        }
        function Hp(e1, t1, i) {
            const n = t1 <= 16383 ? 1 : t1 <= 2097151 ? 2 : t1 <= 268435455 ? 3 : Math.floor(Math.log(t1) / (7 * Math.LN2));
            i.realloc(n), i.buf.copyWithin(e1 + n, e1, i.pos);
        }
        function $p(e1, t1) {
            const i = e1.length;
            let n = t1.buf, r = t1.pos, o = t1.length;
            for(let a = 0; a < i; a++){
                let i = e1[a];
                if (i < 0 || r + 10 > o) t1.pos = r, t1.writeVarint(i), n = t1.buf, r = t1.pos, o = t1.length;
                else {
                    for(; i > 127;)n[r++] = i % 128 | 128, i = Math.floor(i / 128);
                    n[r++] = i;
                }
            }
            t1.pos = r;
        }
        function Zp(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeSVarint(e1[i]);
        }
        function Wp(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeFloat(e1[i]);
        }
        function qp(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeDouble(e1[i]);
        }
        function Xp(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeBoolean(e1[i]);
        }
        function Yp(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeFixed32(e1[i]);
        }
        function Jp(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeSFixed32(e1[i]);
        }
        function Kp(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeFixed64(e1[i]);
        }
        function Qp(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeSFixed64(e1[i]);
        }
        function e_(e1, t1, i) {
            let n;
            for(; n = e1.nextField(t1);)3 === n ? i.glyphs.push(t_(e1, e1.readVarint() + e1.pos)) : 4 === n ? i.ascender = e1.readSVarint() : 5 === n && (i.descender = e1.readSVarint());
        }
        function t_(e1, t1) {
            let i, n, r = 0, o = 0, a = 0, s = 0, l = 0, u = 0;
            for(; n = e1.nextField(t1);)1 === n ? r = e1.readVarint() : 2 === n ? i = e1.readBytes() : 3 === n ? o = e1.readVarint() : 4 === n ? a = e1.readVarint() : 5 === n ? s = e1.readSVarint() : 6 === n ? l = e1.readSVarint() : 7 === n && (u = e1.readVarint());
            return {
                id: r,
                bitmap: new rd({
                    width: o + 6,
                    height: a + 6
                }, i),
                metrics: {
                    width: o,
                    height: a,
                    left: s,
                    top: l,
                    advance: u
                }
            };
        }
        function i_(e1) {
            let t1 = 0, i = 0;
            for (const n of e1)t1 += n.w * n.h, i = Math.max(i, n.w);
            e1.sort((e1, t1)=>t1.h - e1.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(t1 / .95)), i),
                    h: 1 / 0
                }
            ];
            let r = 0, o = 0;
            for (const t1 of e1)for(let e1 = n.length - 1; e1 >= 0; e1--){
                const i = n[e1];
                if (!(t1.w > i.w || t1.h > i.h)) {
                    if (t1.x = i.x, t1.y = i.y, o = Math.max(o, t1.y + t1.h), r = Math.max(r, t1.x + t1.w), t1.w === i.w && t1.h === i.h) {
                        const t1 = n.pop();
                        t1 && e1 < n.length && (n[e1] = t1);
                    } else t1.h === i.h ? (i.x += t1.w, i.w -= t1.w) : t1.w === i.w ? (i.y += t1.h, i.h -= t1.h) : (n.push({
                        x: i.x + t1.w,
                        y: i.y,
                        w: i.w - t1.w,
                        h: t1.h
                    }), i.y += t1.h, i.h -= t1.h);
                    break;
                }
            }
            return {
                w: r,
                h: o,
                fill: t1 / (r * o) || 0
            };
        }
        function n_(e1, t1) {
            return e1.id < t1.id ? -1 : e1.id > t1.id ? 1 : e1.version < t1.version ? -1 : e1.version > t1.version ? 1 : e1.sx < t1.sx ? -1 : e1.sx > t1.sx ? 1 : e1.sy < t1.sy ? -1 : e1.sy > t1.sy ? 1 : 0;
        }
        function r_(e1) {
            let t1 = 0;
            for(let i = 0; i < e1.length; i++)t1 = (t1 << 5) - t1 + e1.charCodeAt(i), t1 &= t1;
            return t1;
        }
        function o_(e1, t1) {
            return (e1 << 5) - e1 + t1;
        }
        function a_(e1, t1, i, n) {
            for (const [r] of e1.entries()){
                const e1 = n && n.get(r) || Un.parse(r), o = e1.id.toString(), a = t1.get(o) || 0;
                i.push({
                    id: r,
                    version: a,
                    sx: e1.sx,
                    sy: e1.sy
                });
            }
        }
        class s_ {
            constructor(e1, t1, i, n, r = "", o){
                this.scope = r, this.iconDescriptors = [], this.patternDescriptors = [], this.requiresMipMaps = t1.size > 0, a_(e1, i, this.iconDescriptors, o), a_(t1, i, this.patternDescriptors, o), this.iconDescriptors.sort(n_), this.patternDescriptors.sort(n_);
                let a = 0;
                a = o_(a, r_(r)), a = o_(a, 1);
                const s = n ? n.data : "";
                s && (a = o_(a, r_(s))), a = o_(a, 1);
                for (const e1 of this.iconDescriptors)a = o_(a, r_(e1.id)), a = o_(a, e1.version), a = o_(a, e1.sx), a = o_(a, e1.sy);
                a = o_(a, 1);
                for (const e1 of this.patternDescriptors)a = o_(a, r_(e1.id)), a = o_(a, e1.version), a = o_(a, e1.sx), a = o_(a, e1.sy);
                this.hash = a;
            }
            subsetOf(e1) {
                return this.scope === e1.scope && this.isSubsetArray(this.iconDescriptors, e1.iconDescriptors, n_) && this.isSubsetArray(this.patternDescriptors, e1.patternDescriptors, n_);
            }
            isSubsetArray(e1, t1, i) {
                let n = 0, r = 0;
                if (e1.length > t1.length) return !1;
                for(; n < e1.length && r < t1.length;){
                    const o = i(e1[n], t1[r]);
                    if (0 === o) n++, r++;
                    else {
                        if (o < 0) return !1;
                        r++;
                    }
                }
                return n === e1.length;
            }
        }
        function l_(e1) {
            switch(e1){
                case WebGL2RenderingContext.RGBA8:
                case WebGL2RenderingContext.RGBA16F:
                    return WebGL2RenderingContext.RGBA;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.DEPTH_COMPONENT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.DEPTH_STENCIL;
                case WebGL2RenderingContext.R8:
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.RED;
            }
        }
        function u_(e1) {
            switch(e1){
                case WebGL2RenderingContext.RGBA8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.RGBA16F:
                    return WebGL2RenderingContext.HALF_FLOAT;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.UNSIGNED_SHORT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.UNSIGNED_INT_24_8;
                case WebGL2RenderingContext.R8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.FLOAT;
            }
        }
        Ha(s_, "AtlasContentDescriptor");
        class c_ {
            constructor(e1, t1, i, n){
                this.context = e1, this.format = i, this.useMipmap = n && n.useMipmap, this.texture = e1.gl.createTexture(), this.update(t1, {
                    premultiply: n && n.premultiply
                });
            }
            update(e1, t1) {
                const i = e1 && e1 instanceof HTMLVideoElement && 0 === e1.width ? e1.videoWidth : e1.width, n = e1 && e1 instanceof HTMLVideoElement && 0 === e1.height ? e1.videoHeight : e1.height, { context: r } = this, { gl: o } = r, { x: a, y: s } = t1 && t1.position ? t1.position : {
                    x: 0,
                    y: 0
                }, l = a + i, u = s + n;
                this.size && (this.size[0] !== l || this.size[1] !== u) && (!t1 || void 0 === t1.recreateWhenResize || t1.recreateWhenResize) && (o.bindTexture(o.TEXTURE_2D, null), o.deleteTexture(this.texture), this.texture = o.createTexture(), this.size = null), o.bindTexture(o.TEXTURE_2D, this.texture), r.pixelStoreUnpackFlipY.set(!1), r.pixelStoreUnpack.set(1), r.pixelStoreUnpackPremultiplyAlpha.set(this.format === o.RGBA8 && (!t1 || !1 !== t1.premultiply));
                const c = e1 instanceof HTMLImageElement || e1 instanceof HTMLCanvasElement || e1 instanceof HTMLVideoElement || e1 instanceof ImageData || ImageBitmap && e1 instanceof ImageBitmap;
                if (!this.size && l > 0 && u > 0) {
                    const e1 = this.useMipmap ? Math.floor(Math.log2(Math.max(l, u))) + 1 : 1;
                    o.texStorage2D(o.TEXTURE_2D, e1, this.format, l, u), this.size = [
                        l,
                        u
                    ];
                }
                this.size && (c ? o.texSubImage2D(o.TEXTURE_2D, 0, a, s, l_(this.format), u_(this.format), e1) : "data" in e1 && e1.data && o.texSubImage2D(o.TEXTURE_2D, 0, a, s, i, n, l_(this.format), u_(this.format), e1.data)), this.useMipmap && o.generateMipmap(o.TEXTURE_2D);
            }
            bind(e1, t1, i = !1) {
                const { context: n } = this, { gl: r } = n;
                r.bindTexture(r.TEXTURE_2D, this.texture), e1 !== this.minFilter && (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, e1), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, this.useMipmap && !i ? e1 === r.NEAREST ? r.NEAREST_MIPMAP_NEAREST : r.LINEAR_MIPMAP_LINEAR : e1), this.minFilter = e1), t1 !== this.wrapS && (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, t1), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, t1), this.wrapS = t1);
            }
            bindExtraParam(e1, t1, i, n, r) {
                const { context: o } = this, { gl: a } = o;
                a.bindTexture(a.TEXTURE_2D, this.texture), t1 !== this.magFilter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, t1), this.magFilter = t1), e1 !== this.minFilter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, this.useMipmap ? e1 === a.NEAREST ? a.NEAREST_MIPMAP_NEAREST : a.LINEAR_MIPMAP_LINEAR : e1), this.minFilter = e1), i !== this.wrapS && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, i), this.wrapS = i), n !== this.wrapT && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, n), this.wrapT = n), r !== this.compareMode && (r ? (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_COMPARE_MODE, a.COMPARE_REF_TO_TEXTURE), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_COMPARE_FUNC, r)) : a.texParameteri(a.TEXTURE_2D, a.TEXTURE_COMPARE_MODE, a.NONE), this.compareMode = r);
            }
            destroy() {
                const { gl: e1 } = this.context;
                e1.deleteTexture(this.texture), this.texture = null;
            }
        }
        class h_ {
            constructor(e1, t1, i, n){
                this.context = e1, this.format = n, this.size = i, this.texture = e1.gl.createTexture();
                const [r, o, a] = this.size, { gl: s } = e1;
                s.bindTexture(s.TEXTURE_3D, this.texture), e1.pixelStoreUnpackFlipY.set(!1), e1.pixelStoreUnpack.set(1), e1.pixelStoreUnpackPremultiplyAlpha.set(!1), "data" in t1 && t1.data && s.texImage3D(s.TEXTURE_3D, 0, this.format, r, o, a, 0, l_(this.format), u_(this.format), t1.data);
            }
            bind(e1, t1) {
                const { context: i } = this, { gl: n } = i;
                n.bindTexture(n.TEXTURE_3D, this.texture), e1 !== this.minFilter && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MAG_FILTER, e1), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MIN_FILTER, e1), this.minFilter = e1), t1 !== this.wrapS && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_S, t1), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_T, t1), this.wrapS = t1);
            }
            destroy() {
                const { gl: e1 } = this.context;
                e1.deleteTexture(this.texture), this.texture = null;
            }
        }
        class d_ {
            static getImagePositionScale(e1, t1, i) {
                if (t1 && e1) {
                    const { sx: t1, sy: i } = e1;
                    return {
                        x: t1,
                        y: i
                    };
                }
                return {
                    x: i,
                    y: i
                };
            }
            constructor(e1, t1, i, n){
                this.paddedRect = e1;
                const { pixelRatio: r, version: o, stretchX: a, stretchY: s, content: l, sdf: u, usvg: c } = t1;
                this.pixelRatio = r, this.stretchX = a, this.stretchY = s, this.content = l, this.version = o, this.padding = i, this.sdf = u, this.usvg = c, this.scale = d_.getImagePositionScale(n, c, r);
            }
            get tl() {
                return [
                    this.paddedRect.x + this.padding,
                    this.paddedRect.y + this.padding
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - this.padding,
                    this.paddedRect.y + this.paddedRect.h - this.padding
                ];
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * this.padding) / this.scale.x,
                    (this.paddedRect.h - 2 * this.padding) / this.scale.y
                ];
            }
        }
        function f_(e1, t1, i) {
            const n = Un.parse(e1), r = function(e1, t1, i = [
                1,
                1
            ]) {
                return {
                    x: 0,
                    y: 0,
                    w: (e1.data ? e1.data.width : e1.width * i[0]) + 2 * t1,
                    h: (e1.data ? e1.data.height : e1.height * i[1]) + 2 * t1
                };
            }(t1, i, [
                n.sx,
                n.sy
            ]);
            return {
                bin: r,
                imagePosition: new d_(r, t1, i, n),
                imageVariant: n
            };
        }
        function p_(e1, t1) {
            const i = [];
            for (const [n, r] of e1.entries()){
                const e1 = Un.parse(n);
                e1 && (i.push({
                    key: n,
                    value: r,
                    variant: e1
                }), t1 && t1.set(n, e1));
            }
            i.sort((e1, t1)=>{
                const i = e1.variant.id.toString().localeCompare(t1.variant.id.toString());
                return 0 !== i ? i : e1.variant.sx !== t1.variant.sx ? e1.variant.sx - t1.variant.sx : e1.variant.sy !== t1.variant.sy ? e1.variant.sy - t1.variant.sy : e1.key.localeCompare(t1.key);
            });
            const n = new Map;
            for (const e1 of i)n.set(e1.key, e1.value);
            return n;
        }
        class __ {
            constructor(e1){
                this.sourceAtlasHash = e1;
            }
        }
        class m_ {
            constructor(e1, t1, i, n, r = ""){
                const o = new Map, a = new Map;
                this.haveRenderCallbacks = [];
                const s = [], l = void 0 !== n, u = l ? new Map : void 0, c = l ? p_(e1, u) : e1, h = l ? p_(t1, u) : t1;
                this.addImages(c, o, 1, s), this.addImages(h, a, 2, s);
                const { w: d, h: f } = i_(s), p = new od({
                    width: d || 1,
                    height: f || 1
                });
                for (const [e1, t1] of c.entries()){
                    const i = o.get(e1).paddedRect;
                    od.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: i.x + 1,
                        y: i.y + 1
                    }, t1.data, null, t1.sdf);
                }
                for (const [e1, t1] of h.entries()){
                    const n = a.get(e1), r = n.paddedRect;
                    let o = n.padding;
                    const s = r.x + o, l = r.y + o, u = t1.data.width, c = t1.data.height;
                    o = o > 1 ? o - 1 : o, od.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: l
                    }, t1.data, i), od.copy(t1.data, p, {
                        x: 0,
                        y: c - o
                    }, {
                        x: s,
                        y: l - o
                    }, {
                        width: u,
                        height: o
                    }, i), od.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: l + c
                    }, {
                        width: u,
                        height: o
                    }, i), od.copy(t1.data, p, {
                        x: u - o,
                        y: 0
                    }, {
                        x: s - o,
                        y: l
                    }, {
                        width: o,
                        height: c
                    }, i), od.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + u,
                        y: l
                    }, {
                        width: o,
                        height: c
                    }, i), od.copy(t1.data, p, {
                        x: u - o,
                        y: c - o
                    }, {
                        x: s - o,
                        y: l - o
                    }, {
                        width: o,
                        height: o
                    }, i), od.copy(t1.data, p, {
                        x: 0,
                        y: c - o
                    }, {
                        x: s + u,
                        y: l - o
                    }, {
                        width: o,
                        height: o
                    }, i), od.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + u,
                        y: l + c
                    }, {
                        width: o,
                        height: o
                    }, i), od.copy(t1.data, p, {
                        x: u - o,
                        y: 0
                    }, {
                        x: s - o,
                        y: l + c
                    }, {
                        width: o,
                        height: o
                    }, i);
                }
                this.lut = i, this.image = p, this.iconPositions = o, this.patternPositions = a, l && (this.contentDescriptor = new s_(c, h, n, i, r, u));
            }
            addImages(e1, t1, i, n) {
                for (const [r, o] of e1.entries()){
                    const { bin: e1, imagePosition: a, imageVariant: s } = f_(r, o, i);
                    t1.set(r, a), n.push(e1), o.hasRenderCallback && this.haveRenderCallbacks.push(s.id);
                }
            }
            patchUpdatedImages(e1, t1, i, n) {
                this.haveRenderCallbacks = this.haveRenderCallbacks.filter((t1)=>e1.hasImage(t1, i)), e1.dispatchRenderCallbacks(this.haveRenderCallbacks, i);
                for (const r of e1.getUpdatedImages(i)){
                    for (const n of this.iconPositions.keys()){
                        const o = Un.parse(n);
                        if (ln.isEqual(o.id, r)) {
                            const o = e1.getImage(r, i);
                            this.patchUpdatedImage(this.iconPositions.get(n), o, t1, null);
                        }
                    }
                    for (const o of this.patternPositions.keys()){
                        const a = Un.parse(o);
                        if (ln.isEqual(a.id, r)) {
                            const a = e1.getImage(r, i);
                            this.patchUpdatedImage(this.patternPositions.get(o), a, t1, n || this.lut);
                        }
                    }
                }
            }
            patchUpdatedImage(e1, t1, i, n = null) {
                if (!e1 || !t1) return;
                if (e1.version === t1.version) return;
                e1.version = t1.version;
                const [r, o] = e1.tl, a = e1.sdf;
                if (this.lut || a) {
                    const e1 = {
                        width: t1.data.width,
                        height: t1.data.height
                    }, s = new od(e1);
                    od.copy(t1.data, s, {
                        x: 0,
                        y: 0
                    }, {
                        x: 0,
                        y: 0
                    }, e1, n, a), i.update(s, {
                        position: {
                            x: r,
                            y: o
                        },
                        recreateWhenResize: !1
                    });
                } else i.update(t1.data, {
                    position: {
                        x: r,
                        y: o
                    },
                    recreateWhenResize: !1
                });
            }
        }
        Ha(d_, "ImagePosition"), Ha(m_, "ImageAtlas", {
            omit: [
                "lut"
            ]
        }), Ha(__, "ImageAtlasReference");
        class g_ {
            constructor(e1){
                this.pendingRequests = new Map, this.cachedRanges = new Map, this.fontstackCompositing = e1 && e1.fontstackCompositing || "client";
            }
            loadGlyphRange(e1, t1, i, n, r) {
                if ("server" === this.fontstackCompositing) return void g_.loadGlyphRange(e1, t1, i, n, r);
                const o = e1.split(",").map((e1)=>e1.trim()).filter((e1)=>e1.length > 0);
                0 !== o.length ? 1 !== o.length ? this._loadMultipleFonts(o, t1, i, n, r) : this._loadFont(o[0], t1, i, n, r) : r(new Error("Empty fontstack"));
            }
            _loadMultipleFonts(e1, t1, i, n, r) {
                const o = e1.map(()=>null), a = {
                    completed: 0,
                    firstError: null,
                    callbackCalled: !1
                }, s = (t1, i, n)=>{
                    if (!a.callbackCalled && (i && !a.firstError && (a.firstError = i), n && (o[t1] = n), a.completed++, a.completed === e1.length)) {
                        a.callbackCalled = !0;
                        const e1 = o.filter((e1)=>null !== e1);
                        if (0 === e1.length) return void r(a.firstError || new Error("All fonts failed to load"));
                        const t1 = this._composeGlyphs(e1);
                        r(null, t1);
                    }
                };
                for(let r = 0; r < e1.length; r++)this._loadFont(e1[r], t1, i, n, (e1, t1)=>{
                    s(r, e1, t1);
                });
            }
            _loadFont(e1, t1, i, n, r) {
                const o = `${e1}:${t1}`;
                if (this.cachedRanges.has(o)) {
                    const e1 = this.cachedRanges.get(o);
                    return void Vt.frame(()=>r(null, e1));
                }
                const a = this.pendingRequests.get(o);
                a ? a.push(r) : (this.pendingRequests.set(o, [
                    r
                ]), g_.loadGlyphRange(e1, t1, i, n, (e1, t1)=>{
                    e1 || this.cachedRanges.set(o, t1 || null);
                    const i = this.pendingRequests.get(o);
                    if (this.pendingRequests.delete(o), i) for (const n of i)n(e1, t1);
                }));
            }
            _composeGlyphs(e1) {
                const t1 = {};
                let i, n;
                for (const r of e1)if (void 0 === i && void 0 !== r.ascender && (i = r.ascender), void 0 === n && void 0 !== r.descender && (n = r.descender), r.glyphs) for(const e1 in r.glyphs)void 0 === t1[e1] && (t1[e1] = r.glyphs[e1]);
                return {
                    glyphs: t1,
                    ascender: i,
                    descender: n
                };
            }
        }
        g_.loadGlyphRange = async function(e1, t1, i, n, r) {
            const o = 256 * t1, a = o + 255;
            let s;
            try {
                const t1 = await n.transformRequest(n.normalizeGlyphsURL(i).replace("{fontstack}", e1).replace("{range}", `${o}-${a}`), ai.Glyphs), { data: r } = await _i(t1), l = {}, u = function(e1) {
                    return function(e1) {
                        const t1 = {
                            glyphs: []
                        };
                        let i;
                        for(; i = e1.nextField();)1 === i && e_(e1, e1.readVarint() + e1.pos, t1);
                        return t1;
                    }(new Gp(e1));
                }(r);
                for (const e1 of u.glyphs)l[e1.id] = e1;
                s = {
                    glyphs: l,
                    ascender: u.ascender,
                    descender: u.descender
                };
            } catch (e1) {
                return r(e1);
            }
            r(null, s);
        };
        const y_ = 1e20, x_ = new Float64Array(256);
        for(let e1 = 0; e1 < 256; e1++){
            const t1 = .5 - Math.pow(e1 / 255, 1 / 2.2);
            x_[e1] = t1 * Math.abs(t1);
        }
        function v_(e1, t1, i, n, r, o, a, s, l) {
            for(let u = t1; u < t1 + n; u++)b_(e1, i * o + u, o, r, a, s, l);
            for(let u = i; u < i + r; u++)b_(e1, u * o + t1, 1, n, a, s, l);
        }
        function b_(e1, t1, i, n, r, o, a) {
            o[0] = 0, a[0] = -y_, a[1] = y_, r[0] = e1[t1];
            for(let s = 1, l = 0, u = 0; s < n; s++){
                r[s] = e1[t1 + s * i];
                const n = s * s;
                do {
                    const e1 = o[l];
                    u = (r[s] - r[e1] + n - e1 * e1) / (s - e1) / 2;
                }while (u <= a[l] && --l > -1);
                l++, o[l] = s, a[l] = u, a[l + 1] = y_;
            }
            for(let s = 0, l = 0; s < n; s++){
                for(; a[l + 1] < s;)l++;
                const n = o[l], u = s - n;
                e1[t1 + s * i] = r[n] + u * u;
            }
        }
        x_[255] = -y_;
        const w_ = /bold/i, E_ = /medium/i, A_ = /light/i, I_ = {
            none: 0,
            ideographs: 1,
            all: 2
        };
        class T_ {
            constructor(e1, t1, i, n){
                this.requestManager = e1, this.localGlyphMode = t1, this.localFontFamily = i, this.url = "", this.entries = {}, this.localGlyphs = {
                    200: {},
                    400: {},
                    500: {},
                    900: {}
                }, this.glyphLoader = new g_({
                    fontstackCompositing: n
                });
            }
            setURL(e1) {
                this.url = e1;
            }
            prefetchRange(e1, t1) {
                const i = this.url || Ut.GLYPHS_URL;
                if (!i) return;
                let n = this.entries[e1];
                n || (n = this.entries[e1] = {
                    glyphs: {},
                    requests: {},
                    ranges: {}
                }), n.ranges[t1] || n.requests[t1] || (n.requests[t1] = [], this.glyphLoader.loadGlyphRange(e1, t1, i, this.requestManager, (e1, i)=>{
                    if (i) {
                        n.ascender = i.ascender, n.descender = i.descender;
                        for(const e1 in i.glyphs)this._doesCharSupportLocalGlyph(+e1) || (n.glyphs[+e1] = i.glyphs[+e1]);
                        n.ranges[t1] = !0;
                    }
                    for (const r of n.requests[t1] || [])r(e1, i);
                    delete n.requests[t1];
                }));
            }
            getGlyphs(e1, t1) {
                const i = [], n = this.url || Ut.GLYPHS_URL;
                for(const t1 in e1)for (const n of e1[t1])i.push({
                    stack: t1,
                    id: n
                });
                rt(i, ({ stack: e1, id: t1 }, i)=>{
                    let r = this.entries[e1];
                    r || (r = this.entries[e1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {},
                        ascender: void 0,
                        descender: void 0
                    });
                    let o = r.glyphs[t1];
                    if (void 0 !== o) return void i(null, {
                        stack: e1,
                        id: t1,
                        glyph: o
                    });
                    if (o = this._tinySDF(r, e1, t1), o) return r.glyphs[t1] = o, void i(null, {
                        stack: e1,
                        id: t1,
                        glyph: o
                    });
                    const a = Math.floor(t1 / 256);
                    if (256 * a > 65535) return mt("glyphs > 65535 not supported"), void i(null, {
                        stack: e1,
                        id: t1,
                        glyph: o
                    });
                    if (r.ranges[a]) return void i(null, {
                        stack: e1,
                        id: t1,
                        glyph: o
                    });
                    let s = r.requests[a];
                    s || (s = r.requests[a] = [], this.glyphLoader.loadGlyphRange(e1, a, n, this.requestManager, (e1, t1)=>{
                        if (t1) {
                            r.ascender = t1.ascender, r.descender = t1.descender;
                            for(const e1 in t1.glyphs)this._doesCharSupportLocalGlyph(+e1) || (r.glyphs[+e1] = t1.glyphs[+e1]);
                            r.ranges[a] = !0;
                        }
                        for (const i of s)i(e1, t1);
                        delete r.requests[a];
                    })), s.push((n, r)=>{
                        n ? i(n) : r && i(null, {
                            stack: e1,
                            id: t1,
                            glyph: r.glyphs[t1] || null
                        });
                    });
                }, (e1, i)=>{
                    if (e1) t1(e1);
                    else if (i) {
                        const e1 = {};
                        for (const { stack: t1, id: n, glyph: r } of i)void 0 === e1[t1] && (e1[t1] = {}), void 0 === e1[t1].glyphs && (e1[t1].glyphs = {}), e1[t1].glyphs[n] = r && {
                            id: r.id,
                            bitmap: r.bitmap.clone(),
                            metrics: r.metrics
                        }, e1[t1].ascender = this.entries[t1].ascender, e1[t1].descender = this.entries[t1].descender;
                        t1(null, e1);
                    }
                });
            }
            _doesCharSupportLocalGlyph(e1) {
                var t1;
                return this.localGlyphMode !== I_.none && (this.localGlyphMode === I_.all ? !!this.localFontFamily : !!this.localFontFamily && (ds(e1) || _s(e1) || ns(e1) || rs(e1) || is(e1) || hs(e1) || (t1 = e1) >= 131072 && t1 <= 173791 || ((e1)=>e1 >= 66736 && e1 <= 66815)(e1)));
            }
            _tinySDF(e1, t1, i) {
                const n = this.localFontFamily;
                if (!n || !this._doesCharSupportLocalGlyph(i)) return;
                let r = e1.tinySDF;
                if (!r) {
                    let i = "400";
                    w_.test(t1) ? i = "900" : E_.test(t1) ? i = "500" : A_.test(t1) && (i = "200"), r = e1.tinySDF = new T_.TinySDF({
                        fontFamily: n,
                        fontWeight: i,
                        fontSize: 48,
                        buffer: 6,
                        radius: 16
                    }), r.fontWeight = i;
                }
                const o = r.fontWeight;
                if (this.localGlyphs[o][i]) return this.localGlyphs[o][i];
                const a = String.fromCodePoint(i), { data: s, width: l, height: u, glyphWidth: c, glyphHeight: h, glyphLeft: d, glyphTop: f, glyphAdvance: p } = r.draw(a);
                return this.localGlyphs[o][i] = {
                    id: i,
                    bitmap: new rd({
                        width: l,
                        height: u
                    }, s),
                    metrics: {
                        width: c / 2,
                        height: h / 2,
                        left: d / 2,
                        top: f / 2 - 27,
                        advance: p / 2,
                        localGlyph: !0
                    }
                };
            }
        }
        function M_(e1, t1) {
            return e1 + t1[1] - t1[0];
        }
        function S_(e1, t1, i, n, r = 1) {
            const o = [], a = e1.imagePrimary, s = a.pixelRatio, l = a.paddedRect.w - 2, u = a.paddedRect.h - 2, c = (e1.right - e1.left) * r, h = (e1.bottom - e1.top) * r, d = a.stretchX || [
                [
                    0,
                    l
                ]
            ], f = a.stretchY || [
                [
                    0,
                    u
                ]
            ], p = d.reduce(M_, 0), _ = f.reduce(M_, 0), m = l - p, g = u - _;
            let y = 0, x = p, v = 0, b = _, w = 0, E = m, A = 0, I = g;
            if (a.content && n) {
                const e1 = a.content;
                y = z_(d, 0, e1[0]), v = z_(f, 0, e1[1]), x = z_(d, e1[0], e1[2]), b = z_(f, e1[1], e1[3]), w = e1[0] - y, A = e1[1] - v, E = e1[2] - e1[0] - x, I = e1[3] - e1[1] - b;
            }
            const T = (n, o, l, u)=>{
                const d = D_(n.stretch - y, x, c, e1.left * r), f = C_(n.fixed - w, E, n.stretch, p), m = D_(o.stretch - v, b, h, e1.top * r), g = C_(o.fixed - A, I, o.stretch, _), T = D_(l.stretch - y, x, c, e1.left * r), M = C_(l.fixed - w, E, l.stretch, p), S = D_(u.stretch - v, b, h, e1.top * r), z = C_(u.fixed - A, I, u.stretch, _), R = new Pe(d, m), P = new Pe(T, m), D = new Pe(T, S), C = new Pe(d, S), F = new Pe(f / s, g / s), O = new Pe(M / s, z / s), L = t1 * Math.PI / 180;
                if (L) {
                    const e1 = Math.sin(L), t1 = Math.cos(L), i = [
                        t1,
                        -e1,
                        e1,
                        t1
                    ];
                    R._matMult(i), P._matMult(i), C._matMult(i), D._matMult(i);
                }
                const B = n.stretch + n.fixed, N = l.stretch + l.fixed, V = o.stretch + o.fixed, k = u.stretch + u.fixed, U = e1.imageSecondary;
                return {
                    tl: R,
                    tr: P,
                    bl: C,
                    br: D,
                    texPrimary: {
                        x: a.paddedRect.x + 1 + B,
                        y: a.paddedRect.y + 1 + V,
                        w: N - B,
                        h: k - V
                    },
                    texSecondary: U ? {
                        x: U.paddedRect.x + 1 + B,
                        y: U.paddedRect.y + 1 + V,
                        w: N - B,
                        h: k - V
                    } : void 0,
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: F,
                    pixelOffsetBR: O,
                    minFontScaleX: E / s / c,
                    minFontScaleY: I / s / h,
                    isSDF: i
                };
            };
            if (a.stretchX || a.stretchY) {
                const e1 = R_(d, m, p), t1 = R_(f, g, _);
                for(let i = 0; i < e1.length - 1; i++){
                    const n = e1[i], r = e1[i + 1];
                    for(let e1 = 0; e1 < t1.length - 1; e1++)o.push(T(n, t1[e1], r, t1[e1 + 1]));
                }
            } else o.push(T({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return o;
        }
        function z_(e1, t1, i) {
            let n = 0;
            for (const r of e1)n += Math.max(t1, Math.min(i, r[1])) - Math.max(t1, Math.min(i, r[0]));
            return n;
        }
        function R_(e1, t1, i) {
            const n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ];
            for (const [t1, i] of e1){
                const e1 = n.at(-1);
                n.push({
                    fixed: t1 - e1.stretch,
                    stretch: e1.stretch
                }), n.push({
                    fixed: t1 - e1.stretch,
                    stretch: e1.stretch + (i - t1)
                });
            }
            return n.push({
                fixed: t1 + 1,
                stretch: i
            }), n;
        }
        function P_(e1) {
            return 2 * e1.length + 1;
        }
        function D_(e1, t1, i, n) {
            return e1 / t1 * i + n;
        }
        function C_(e1, t1, i, n) {
            return e1 - t1 * i / n;
        }
        function F_(e1, t1, i, n) {
            const r = t1 + e1.positionedLines[n].lineOffset;
            return 0 === n ? i + r / 2 : i + (r + (t1 + e1.positionedLines[n - 1].lineOffset)) / 2;
        }
        function O_(e1, t1, i, n, r, o, a, s, l, u = 1) {
            const c = [];
            if (0 === t1.positionedLines.length) return c;
            const h = (void 0 !== l ? l : n.layout.get("text-rotate").evaluate(o, {})) * Math.PI / 180, d = function(e1) {
                const t1 = e1[0], i = e1[1], n = t1 * i;
                return n > 0 ? [
                    t1,
                    -i
                ] : n < 0 ? [
                    -t1,
                    i
                ] : 0 === t1 ? [
                    i,
                    t1
                ] : [
                    i,
                    -t1
                ];
            }(i);
            let f = Math.abs(t1.top - t1.bottom);
            for (const e1 of t1.positionedLines)f -= e1.lineOffset;
            const p = t1.positionedLines.length, _ = f / p;
            let m = t1.top - i[1];
            for(let e1 = 0; e1 < p; ++e1){
                const n = t1.positionedLines[e1];
                m = F_(t1, _, m, e1);
                for (const e1 of n.positionedGlyphs){
                    if (!e1.rect) continue;
                    const n = e1.rect || {};
                    let o = 4, l = !0, f = 1, p = 0;
                    if (e1.image) {
                        const t1 = a.get(e1.image.toString());
                        if (!t1) continue;
                        if (t1.sdf) {
                            mt("SDF images are not supported in formatted text and will be ignored.");
                            continue;
                        }
                        l = !1, f = t1.pixelRatio, o = 1 / f, t1.usvg || (f /= u);
                    }
                    const _ = (r || s) && e1.vertical, g = e1.metrics.advance * e1.scale / 2, y = e1.metrics, x = e1.rect;
                    if (null === x) continue;
                    s && t1.verticalizable && (p = e1.image ? g - e1.metrics.width * e1.scale / 2 : 0);
                    const v = r ? [
                        e1.x + g,
                        e1.y
                    ] : [
                        0,
                        0
                    ];
                    let b = [
                        0,
                        0
                    ], w = [
                        0,
                        0
                    ], E = !1;
                    r || (_ ? (w = [
                        e1.x + g + d[0],
                        e1.y + d[1] - p
                    ], E = !0) : b = [
                        e1.x + g + i[0],
                        e1.y + i[1] - p
                    ]);
                    const A = x.w * e1.scale / (f * (e1.localGlyph ? 2 : 1)), I = x.h * e1.scale / (f * (e1.localGlyph ? 2 : 1));
                    let T, M, S, z;
                    if (_) {
                        const t1 = e1.y - m, i = new Pe(-g, g - t1), n = -Math.PI / 2, r = new Pe(...w);
                        T = new Pe(-g + b[0], b[1]), T._rotateAround(n, i)._add(r), T.x += -t1 + g, T.y -= (y.left - o) * e1.scale;
                        const a = e1.image ? y.advance * e1.scale : Gd * e1.scale, s = String.fromCodePoint(e1.glyph);
                        Xd(s) ? T.x += (1 - o) * e1.scale : Yd(s) ? T.x += a - y.height * e1.scale + (-o - 1) * e1.scale : T.x += e1.image || y.width + 2 * o === x.w && y.height + 2 * o === x.h ? (a - I) / 2 : (a - (y.height + 2 * o) * e1.scale) / 2, M = new Pe(T.x, T.y - A), S = new Pe(T.x + I, T.y), z = new Pe(T.x + I, T.y - A);
                    } else {
                        const t1 = (y.left - o) * e1.scale - g + b[0], i = (-y.top - o) * e1.scale + b[1], n = t1 + A, r = i + I;
                        T = new Pe(t1, i), M = new Pe(n, i), S = new Pe(t1, r), z = new Pe(n, r);
                    }
                    if (h) {
                        let e1;
                        e1 = r ? new Pe(0, 0) : E ? new Pe(d[0], d[1]) : new Pe(i[0], i[1]), T._rotateAround(h, e1), M._rotateAround(h, e1), S._rotateAround(h, e1), z._rotateAround(h, e1);
                    }
                    const R = new Pe(0, 0), P = new Pe(0, 0);
                    c.push({
                        tl: T,
                        tr: M,
                        bl: S,
                        br: z,
                        texPrimary: n,
                        texSecondary: void 0,
                        writingMode: t1.writingMode,
                        glyphOffset: v,
                        sectionIndex: e1.sectionIndex,
                        isSDF: l,
                        pixelOffsetTL: R,
                        pixelOffsetBR: P,
                        minFontScaleX: 0,
                        minFontScaleY: 0
                    });
                }
            }
            return c;
        }
        T_.TinySDF = class {
            constructor({ fontSize: e1 = 24, buffer: t1 = 3, radius: i = 8, cutoff: n = .25, fontFamily: r = "sans-serif", fontWeight: o = "normal", fontStyle: a = "normal", lang: s = null } = {}){
                this.buffer = t1, this.radius = i, this.cutoff = n, this.lang = s;
                const l = this.size = e1 + 4 * t1, u = this._createCanvas(l), c = this.ctx = u.getContext("2d", {
                    willReadFrequently: !0
                });
                c.font = `${a} ${o} ${e1}px ${r}`, c.textBaseline = "alphabetic", c.textAlign = "left", c.fillStyle = "black", this.gridOuter = new Float64Array(l * l), this.gridInner = new Float64Array(l * l), this.f = new Float64Array(l), this.z = new Float64Array(l + 1), this.v = new Uint16Array(l);
            }
            _createCanvas(e1) {
                if ("undefined" != typeof OffscreenCanvas) return new OffscreenCanvas(e1, e1);
                const t1 = document.createElement("canvas");
                return t1.width = t1.height = e1, t1;
            }
            draw(e1) {
                const { width: t1, actualBoundingBoxAscent: i, actualBoundingBoxDescent: n, actualBoundingBoxLeft: r, actualBoundingBoxRight: o } = this.ctx.measureText(e1), a = Math.ceil(i), s = Math.floor(-r), l = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(o) - s)), u = Math.max(0, Math.min(this.size - this.buffer, a + Math.ceil(n))), c = l + 2 * this.buffer, h = u + 2 * this.buffer, d = Math.max(c * h, 0), f = new Uint8ClampedArray(d), p = {
                    data: f,
                    width: c,
                    height: h,
                    glyphWidth: l,
                    glyphHeight: u,
                    glyphTop: a,
                    glyphLeft: s,
                    glyphAdvance: t1
                };
                if (0 === l || 0 === u) return p;
                const { ctx: _, buffer: m, gridInner: g, gridOuter: y } = this;
                this.lang && (_.lang = this.lang), _.clearRect(m, m, l, u), _.fillText(e1, m - s, m + a);
                const x = _.getImageData(m, m, l, u);
                y.fill(y_, 0, d), g.fill(0, 0, d);
                let v = 3;
                for(let e1 = 0; e1 < u; e1++){
                    let t1 = (e1 + m) * c + m;
                    for(let e1 = 0; e1 < l; e1++, v += 4, t1++){
                        const e1 = x.data[v];
                        if (0 === e1) continue;
                        const i = x_[e1];
                        y[t1] = Math.max(0, i), g[t1] = Math.max(0, -i);
                    }
                }
                v_(y, 0, 0, c, h, c, this.f, this.v, this.z);
                const b = Math.min(m, 1);
                v_(g, m - b, m - b, l + 2 * b, u + 2 * b, c, this.f, this.v, this.z);
                const w = 255 / this.radius, E = 255 * (1 - this.cutoff);
                for(let e1 = 0; e1 < d; e1++){
                    const t1 = Math.sqrt(y[e1]) - Math.sqrt(g[e1]);
                    f[e1] = Math.round(E - w * t1);
                }
                return p;
            }
        };
        class L_ {
            constructor(e1, t1){
                this.lastParams = null, this.lastAllFeaturesIndex = -2, this.appearancesVersion = t1, this.appearances = e1;
                const i = e1.map((e1)=>(function(e1) {
                        if (!e1.condition) return {
                            featureDependent: !1,
                            stateDependent: !1,
                            zoomDependent: !1,
                            pitchDependent: !1,
                            brightnessDependent: !1,
                            worldviewDependent: !1
                        };
                        const t1 = e1.condition.expression;
                        return {
                            featureDependent: !lo(t1),
                            stateDependent: !uo(t1),
                            zoomDependent: !ho(t1, [
                                "zoom"
                            ]),
                            pitchDependent: !ho(t1, [
                                "pitch"
                            ]),
                            brightnessDependent: !ho(t1, [
                                "brightness",
                                "measure-light"
                            ]),
                            worldviewDependent: !ho(t1, [
                                "worldview"
                            ])
                        };
                    })(e1));
                this.anyFeatureDependent = i.some((e1)=>e1.featureDependent), this.anyStateDependent = i.some((e1)=>e1.stateDependent);
            }
            update(e1, t1) {
                const i = this.lastParams, n = !i || i.zoom !== e1.zoom || i.pitch !== (e1.pitch || 0) || i.brightness !== (e1.brightness || 0) || i.worldview !== e1.worldview;
                this.lastParams = {
                    zoom: e1.zoom,
                    pitch: e1.pitch || 0,
                    brightness: e1.brightness || 0,
                    worldview: e1.worldview
                };
                const r = t1 && this.anyStateDependent;
                if (!n && !r && -2 !== this.lastAllFeaturesIndex) return {
                    kind: "no-changes"
                };
                if (!this.anyFeatureDependent && !r) {
                    const t1 = this.evaluateAllFeatures(e1);
                    return t1 === this.lastAllFeaturesIndex ? {
                        kind: "no-changes"
                    } : (this.lastAllFeaturesIndex = t1, {
                        kind: "all-features",
                        appearanceIndex: t1
                    });
                }
                return {
                    kind: "per-feature"
                };
            }
            evaluateAllFeatures(e1) {
                for(let t1 = 0; t1 < this.appearances.length; t1++){
                    const i = this.appearances[t1];
                    if (i.condition && i.condition.evaluate(e1, void 0, void 0, void 0)) return t1;
                }
                return -1;
            }
        }
        const B_ = Mh.types, N_ = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function V_(e1, t1, i, n, r, o, a, s, l, u, c, h, d) {
            const f = s ? Math.min(rf, Math.round(s[0])) : 0, p = s ? Math.min(rf, Math.round(s[1])) : 0;
            e1.emplaceBack(t1, i, Math.round(32 * n), Math.round(32 * r), o, a, (f << 1) + (l ? 1 : 0), 0 + (p << 1), 16 * u, 16 * c, 256 * h, 256 * d);
        }
        function k_(e1, t1, i) {
            e1.emplaceBack(t1, i);
        }
        function U_(e1, t1, i, n, r, o, a) {
            e1.emplaceBack(t1, i, n, r, o, a);
        }
        function G_(e1, t1, i, n, r) {
            const o = 5 * t1 + 2;
            e1.float32[o + 0] = i, e1.float32[o + 1] = n, e1.float32[o + 2] = r;
        }
        function j_(e1, t1, i, n, r) {
            e1.emplaceBack(t1, i, n, r), e1.emplaceBack(t1, i, n, r), e1.emplaceBack(t1, i, n, r), e1.emplaceBack(t1, i, n, r);
        }
        function H_(e1) {
            for (const t1 of e1.sections)if (zs(t1.text)) return !0;
            return !1;
        }
        const $_ = 12;
        class Z_ {
            constructor(e1){
                this.layoutVertexArray = new Yu, this.indexArray = new oc, this.programConfigurations = e1, this.segments = new Bc, this.dynamicLayoutVertexArray = new Ku, this.opacityVertexArray = new Qu, this.placedSymbolArray = new Ec, this.iconTransitioningVertexArray = new ec, this.globeExtVertexArray = new Ju, this.zOffsetVertexArray = new ku, this.orientationVertexArray = new lc, this.symbolInstanceIndices = [], this.uboBinder = null, this.featureIdArray = new ku, this.featureIdBuffer = null, this.cachedBatchIndices = null, this.cachedBatchSegments = null;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
            }
            getBatchGrouping(e1) {
                const t1 = e1.get().length === this.segments.get().length;
                if (t1 && this.cachedBatchIndices && this.cachedBatchSegments) return {
                    batchIndices: this.cachedBatchIndices,
                    batchSegments: this.cachedBatchSegments
                };
                const i = new Map;
                for (const t1 of e1.get()){
                    const e1 = void 0 !== t1.batchIndex ? t1.batchIndex : 0;
                    i.has(e1) || i.set(e1, []), i.get(e1).push(t1);
                }
                const n = Array.from(i.keys()).sort((e1, t1)=>e1 - t1), r = new Map;
                for (const e1 of n){
                    const t1 = i.get(e1);
                    r.set(e1, new Bc(t1));
                }
                return t1 && (this.cachedBatchIndices = n, this.cachedBatchSegments = r), {
                    batchIndices: n,
                    batchSegments: r
                };
            }
            snapshotSymbolVertexData(e1, t1) {
                const i = e1 * $_;
                return this.layoutVertexArray.uint16.slice(i, i + t1 * $_);
            }
            restoreSymbolVertexData(e1, t1) {
                this.layoutVertexArray.uint16.set(t1, e1 * $_);
            }
            snapshotIconTransitioningVertexData(e1, t1) {
                const i = 2 * e1;
                return this.iconTransitioningVertexArray.uint16.slice(i, i + 2 * t1);
            }
            restoreIconTransitioningVertexData(e1, t1) {
                this.iconTransitioningVertexArray.uint16.set(t1, 2 * e1);
            }
            updateSymbolVertexData(e1, t1, i, n, r, o, a, s, l, u, c, h, d) {
                const f = this.layoutVertexArray.uint16, p = e1 * $_;
                f[p] = t1, f[p + 1] = i, f[p + 2] = n, f[p + 3] = r, f[p + 4] = o, f[p + 5] = a, f[p + 6] = s, f[p + 7] = l, f[p + 8] = u, f[p + 9] = c, f[p + 10] = h, f[p + 11] = d;
            }
            upload(e1, t1, i, n, r, o) {
                this.isEmpty() || (i && (this.cachedBatchIndices = null, this.cachedBatchSegments = null, this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, xd.members, !!o), this.indexBuffer = e1.createIndexBuffer(this.indexArray, t1), this.dynamicLayoutVertexBuffer = e1.createVertexBuffer(this.dynamicLayoutVertexArray, bd.members, !0), this.opacityVertexBuffer = e1.createVertexBuffer(this.opacityVertexArray, N_, !0), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = e1.createVertexBuffer(this.iconTransitioningVertexArray, Id.members, !0)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = e1.createVertexBuffer(this.globeExtVertexArray, vd.members, !0)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || r) && (this.zOffsetVertexBuffer = e1.createVertexBuffer(this.zOffsetVertexArray, wd.members, !0)), !this.orientationVertexBuffer && this.orientationVertexArray && this.orientationVertexArray.length > 0 && (this.orientationVertexBuffer = e1.createVertexBuffer(this.orientationVertexArray, Ad.members, !0)), this.opacityVertexBuffer.itemSize = 1, this.featureIdArray.length > 0 && (this.featureIdBuffer = e1.createVertexBuffer(this.featureIdArray, Ed.members, !1))), (i || n) && (this.programConfigurations.upload(e1), this.uboBinder && this.uboBinder.upload(e1)));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.orientationVertexBuffer && this.orientationVertexBuffer.destroy(), this.featureIdBuffer && this.featureIdBuffer.destroy(), this.uboBinder && this.uboBinder.destroy());
            }
        }
        Ha(Z_, "SymbolBuffers", {
            omit: [
                "cachedBatchIndices",
                "cachedBatchSegments"
            ]
        });
        class W_ {
            constructor(e1, t1, i){
                this.layoutVertexArray = new e1, this.layoutAttributes = t1, this.indexArray = new i, this.segments = new Bc, this.collisionVertexArray = new rc, this.collisionVertexArrayExt = new Ku;
            }
            upload(e1) {
                this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = e1.createVertexBuffer(this.collisionVertexArray, Td.members, !0), this.collisionVertexBufferExt = e1.createVertexBuffer(this.collisionVertexArrayExt, Md.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
            }
        }
        Ha(W_, "CollisionBuffers");
        class q_ {
            constructor(e1){
                this.collisionBoxArray = e1.collisionBoxArray, this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.pixelRatio = e1.pixelRatio, this.sourceLayerIndex = e1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.hasAnyIconTextFit = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = d([]), this.placementViewportMatrix = d([]);
                const t1 = this.layers[0]._unevaluatedLayout._values;
                this.worldview = e1.worldview, this.localizable = e1.localizable, this.maxUniformBufferBindings = e1.maxUniformBufferBindings, this.maxUniformBlockSizeDwords = e1.maxUniformBlockSizeDwords, this.textSizeData = Kd(this.zoom, t1["text-size"], this.worldview, e1.availableImages), this.iconSizeData = Kd(this.zoom, t1["icon-size"], this.worldview, e1.availableImages);
                const i = this.layers[0].layout, n = i.get("symbol-sort-key"), r = i.get("symbol-z-order");
                this.lut = e1.lut, this.canOverlap = i.get("text-allow-overlap") || i.get("icon-allow-overlap") || i.get("text-ignore-placement") || i.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== r && void 0 !== n.constantOr(1), this.sortFeaturesByY = ("viewport-y" === r || "auto" === r && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = i.get("text-writing-mode").map((e1)=>Hd[e1]), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.sourceID = e1.sourceID, this.projection = e1.projection, this.hasAnyZOffset = !1, this.zOffsetSortDirty = !1, this.zOffsetBuffersNeedUpload = !1, this.elevationType = "none", this.activeReplacements = [], this.replacementUpdateTime = 0, this.hasAnySecondaryIcon = !1, this.hasAppearances = null, this.featureAppearances = null, this.featureAppearanceData = new Map;
            }
            hasAnyAppearanceLayoutProperty(e1) {
                const t1 = this.layers[0].getAppearances();
                if (!t1 || 0 === t1.length) return !1;
                const i = Array.isArray(e1) ? e1 : [
                    e1
                ];
                return t1.some((e1)=>i.some((t1)=>e1.hasLayoutProperty(t1)));
            }
            getAppearanceFeatureData(e1) {
                return this.featureAppearanceData.get(e1);
            }
            createArrays() {
                this.text = new Z_(new ch(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (e1)=>e1.startsWith("text") || e1.startsWith("symbol"))), this.icon = new Z_(new ch(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (e1)=>e1.startsWith("icon") || e1.startsWith("symbol"))), this.text.uboBinder = new Ud(this.layers[0], this.zoom, this.lut, !0, "", this.maxUniformBufferBindings, this.maxUniformBlockSizeDwords), this.icon.uboBinder = new Ud(this.layers[0], this.zoom, this.lut, !1, "", this.maxUniformBufferBindings, this.maxUniformBlockSizeDwords), this.glyphOffsetArray = new Tc, this.lineVertexArray = new Mc, this.symbolInstances = new Ic;
            }
            calculateGlyphDependencies(e1, t1, i, n, r) {
                for (const i of e1){
                    const e1 = i.codePointAt(0);
                    if (void 0 === e1) break;
                    if (t1[e1] = !0, n && r && e1 <= 65535) {
                        const e1 = qd[i];
                        e1 && (t1[e1.charCodeAt(0)] = !0);
                    }
                }
            }
            calculateEffectiveAppearanceIconSize(e1, t1, i, n, r, o, a) {
                if (!e1.hasLayoutProperty("icon-size")) return a * o;
                let s = 1;
                const l = e1.getUnevaluatedLayoutProperty("icon-size"), u = Kd(this.zoom, l, this.worldview, r), c = ef(u, t1);
                if ("constant" !== u.kind && "camera" !== u.kind || (s = c.uSize), "composite" === u.kind) {
                    const { minZoom: e1, maxZoom: t1 } = u, o = l.possiblyEvaluate(new ks(e1, {
                        worldview: this.worldview
                    }), n), a = l.possiblyEvaluate(new ks(t1, {
                        worldview: this.worldview
                    }), n), h = o.evaluate(i, {}, n, r);
                    s = h + (a.evaluate(i, {}, n, r) - h) * c.uSizeT;
                }
                return "source" === u.kind && (s = l.possiblyEvaluate(new ks(this.zoom, {
                    worldview: this.worldview
                }), n).evaluate(i, {}, n, r)), s * o;
            }
            updateFootprints(e1, t1) {}
            updateReplacement(e1, t1) {
                if (t1.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = t1.updateTime;
                const i = t1.getReplacementRegionsForTile(e1.toUnwrapped(), !0);
                return !Dp(this.activeReplacements, i) && (this.activeReplacements = i, !0);
            }
            getResolvedImageFromTokens(e1) {
                return "string" == typeof e1 ? Gn.build(e1) : e1;
            }
            populate(e1, t1, i, n) {
                const r = this.layers[0], o = r.layout, a = "globe" === this.projection.name, s = o.get("text-font"), l = o.get("text-field"), u = o.get("icon-image"), [c, h] = o.get("icon-size-scale-range"), d = tt(t1.scaleFactor || 1, c, h), [f, p] = o.get("text-size-scale-range"), _ = tt(t1.scaleFactor || 1, f, p), m = ("constant" !== l.value.kind || l.value.value instanceof kn && !l.value.value.isEmpty() || l.value.value.toString().length > 0) && ("constant" !== s.value.kind || s.value.value.length > 0), g = "constant" !== u.value.kind || !!u.value.value || Object.keys(u.parameters).length > 0, y = this.hasAnyAppearanceLayoutProperty("icon-image"), x = o.get("symbol-sort-key");
                if (this.features = [], this.featureAppearanceData = new Map, !m && !g && !y) return;
                const v = t1.iconDependencies, b = t1.glyphDependencies, w = t1.availableImages, E = new ks(this.zoom, {
                    worldview: this.worldview,
                    activeFloors: t1.activeFloors
                }), A = (e1)=>{
                    const t1 = e1.id.toString();
                    v.has(t1) ? v.get(t1).push(e1) : v.set(t1, [
                        e1
                    ]);
                };
                for (const t1 of e1){
                    const { feature: e1, id: l, index: u, sourceLayerIndex: c } = t1, h = r._featureFilter.needGeometry, f = Ru(e1, h);
                    if (!r._featureFilter.filter(E, f, i)) continue;
                    if (h || (f.geometry = zu(e1, i, n)), a && 1 !== e1.type && i.z <= 5) {
                        const e1 = f.geometry, t1 = .98078528056, n = (e1, n)=>W(Bf(e1.x, e1.y, i, 1), Bf(n.x, n.y, i, 1)) < t1;
                        for(let t1 = 0; t1 < e1.length; t1++)e1[t1] = Iu(e1[t1], n);
                    }
                    let p, I;
                    if (m) {
                        const e1 = r.getValueAndResolveTokens("text-field", f, i, w), t1 = kn.factory(e1);
                        H_(t1) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === Bs() || this.hasRTLText && Vs.isParsed()) && (p = jd(t1, r, f));
                    }
                    if (g) {
                        const e1 = r.getValueAndResolveTokens("icon-image", f, i, w);
                        I = this.getResolvedImageFromTokens(e1);
                    }
                    const T = this.layers[0];
                    let M = !1;
                    if (!I && y) {
                        const e1 = T.getAppearances();
                        for (const t1 of e1)if (t1.getLayoutProperty("icon-image")) {
                            const e1 = T.getAppearanceValueAndResolveTokens(t1, "icon-image", f, i, w);
                            if (e1) {
                                I = this.getResolvedImageFromTokens(e1), M = !0;
                                break;
                            }
                        }
                    }
                    if (!p && !I) continue;
                    const S = this.sortFeaturesByKey ? x.evaluate(f, {}, i) : void 0, z = {
                        id: l,
                        text: p,
                        icon: I,
                        index: u,
                        sourceLayerIndex: c,
                        geometry: f.geometry,
                        properties: e1.properties,
                        type: B_[e1.type],
                        sortKey: S
                    };
                    if (this.features.push(z), this.featureAppearanceData.set(u, {
                        id: l,
                        properties: e1.properties,
                        usesAppearanceIconAsPlaceholder: M
                    }), I) {
                        const e1 = T._unevaluatedLayout._values, { iconPrimary: t1, iconSecondary: n } = uf(I, this.iconSizeData, e1["icon-size"], i, this.zoom, z, this.pixelRatio, d, this.worldview, w);
                        A(t1), n && (this.hasAnySecondaryIcon = !0, A(n));
                    }
                    const R = T.getAppearances();
                    if (0 !== R.length && R.forEach((e1)=>{
                        if (!e1.getLayoutProperty("icon-image")) return;
                        const { iconPrimary: t1, iconSecondary: n } = this.getCombinedIconVariants(e1, T, f, i, w, z, d);
                        t1 && (A(t1), n && (this.hasAnySecondaryIcon = !0, A(n)));
                    }), p) {
                        const e1 = s.evaluate(f, {}, i).join(","), t1 = "map" === o.get("text-rotation-alignment") && "point" !== o.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.includes(Hd.vertical);
                        for (const i of p.sections)if (i.image) {
                            const e1 = i.image.getPrimary().scaleSelf(this.pixelRatio * _), t1 = e1.id.toString(), n = v.get(t1) || [];
                            n.push(e1), v.set(t1, n);
                        } else {
                            const n = Es(p.toString()), r = i.fontStack || e1, o = b[r] = b[r] || {};
                            this.calculateGlyphDependencies(i.text, o, t1, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === o.get("symbol-placement") && (this.features = function(e1) {
                    const t1 = {}, i = {}, n = [];
                    let r = 0;
                    function o(t1) {
                        n.push(e1[t1]), r++;
                    }
                    function a(e1, t1, r) {
                        const o = i[e1];
                        return delete i[e1], i[t1] = o, n[o].geometry[0].pop(), n[o].geometry[0] = n[o].geometry[0].concat(r[0]), o;
                    }
                    function s(e1, i, r) {
                        const o = t1[i];
                        return delete t1[i], t1[e1] = o, n[o].geometry[0].shift(), n[o].geometry[0] = r[0].concat(n[o].geometry[0]), o;
                    }
                    function l(e1, t1, i) {
                        const n = i ? t1[0].at(-1) : t1[0][0];
                        return `${e1}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < e1.length; u++){
                        const c = e1[u], h = c.geometry, d = c.text ? c.text.toString() : null;
                        if (!d || h.length > 1) {
                            o(u);
                            continue;
                        }
                        const f = l(d, h, !1), p = l(d, h, !0);
                        if (f in i && p in t1 && i[f] !== t1[p]) {
                            const e1 = s(f, p, h), r = a(f, p, n[e1].geometry);
                            delete t1[f], delete i[p], i[l(d, n[r].geometry, !0)] = r, n[e1].geometry = null;
                        } else f in i ? a(f, p, h) : p in t1 ? s(f, p, h) : (o(u), t1[f] = r - 1, i[p] = r - 1);
                    }
                    return n.filter((e1)=>e1.geometry);
                }(this.features)), "hd-road-markup" === o.get("symbol-elevation-reference") ? (this.elevationType = "road", this.hdExt && (this.hdExt.configureCrossSource(i, t1.elevationParams, t1.crossSourceElevationEnabled, t1.terrainEnabled), t1.elevationFeatures && t1.elevationFeatures.length > 0 && this.hdExt.addElevationFeatures(t1.elevationFeatures, i))) : o.get("symbol-z-elevate") && (this.elevationType = "offset"), "none" !== this.elevationType && (this.zOffsetBuffersNeedUpload = !0), this.sortFeaturesByKey && this.features.sort((e1, t1)=>e1.sortKey - t1.sortKey);
            }
            getCombinedIconVariants(e1, t1, i, n, r, o, a) {
                let s;
                if (e1.hasLayoutProperty("icon-image")) {
                    const o = t1.getAppearanceValueAndResolveTokens(e1, "icon-image", i, n, r);
                    s = this.getResolvedImageFromTokens(o);
                } else {
                    const e1 = t1.getValueAndResolveTokens("icon-image", i, n, r);
                    s = this.getResolvedImageFromTokens(e1);
                }
                if (s) {
                    const i = e1.hasLayoutProperty("icon-size") ? e1.getUnevaluatedLayoutProperty("icon-size") : t1._unevaluatedLayout._values["icon-size"], l = Kd(this.zoom, i, this.worldview, r), { iconPrimary: u, iconSecondary: c } = uf(s, l, i, n, this.zoom, o, this.pixelRatio, a, this.worldview, r);
                    return {
                        iconPrimary: u,
                        iconSecondary: c
                    };
                }
                return {
                    iconPrimary: void 0,
                    iconSecondary: void 0
                };
            }
            getCombinedIconPrimary(e1, t1, i, n, r, o, a) {
                return this.getCombinedIconVariants(e1, t1, i, n, r, o, a).iconPrimary;
            }
            updateSymbolInstanceIconVertices(e1, t1, i, n, r, o) {
                const { canonical: a, availableImages: s, globalProperties: l, layer: u, iconScaleFactor: c, featureState: h, layoutIconOffset: d, layoutIconSize: f, layoutIconRotate: p } = o;
                if (e1.placedIconSymbolIndex < 0) return {
                    vertexOffsetDelta: 0,
                    hasChanges: !1
                };
                if (t1.activeAppearanceIndex === i) return {
                    vertexOffsetDelta: e1.numIconVertices,
                    hasChanges: !1
                };
                const _ = i >= 0 ? u.appearances[i] : null;
                if (_) {
                    const i = {
                        sortKey: void 0,
                        text: void 0,
                        icon: null,
                        index: e1.featureIndex,
                        sourceLayerIndex: e1.featureIndex,
                        geometry: [],
                        properties: t1.properties,
                        type: "Point",
                        id: t1.id
                    }, { iconPrimary: o, iconSecondary: m } = this.getCombinedIconVariants(_, u, n, a, s, i, c);
                    if (!o) return {
                        vertexOffsetDelta: 0,
                        hasChanges: !1
                    };
                    const g = o.toString(), y = this.iconAtlasPositions && this.iconAtlasPositions.get(g);
                    if (y) {
                        const { appearanceIconOffset: i, appearanceIconRotate: o } = af(_, u, n, a, d, p, f, c), g = u.layout.get("icon-anchor").evaluate(n, h, a);
                        let x = Zd(y, m ? this.iconAtlasPositions && this.iconAtlasPositions.get(m.toString()) : void 0, i, g);
                        const v = y.sdf, b = u.layout.get("icon-text-fit").constantOr("none");
                        "none" !== b && t1.textShaping && t1.iconTextFitPadding && t1.fontScale && (x = Wd(x, t1.textShaping, b, t1.iconTextFitPadding, i, t1.fontScale));
                        const w = this.calculateEffectiveAppearanceIconSize(_, l.zoom, n, a, s, c, f), E = 0, A = 1 + (Math.min(rf, Math.round(w * Jd)) << 1), I = S_(x, o, v, "none" !== b, c), T = this.icon.iconTransitioningVertexArray.length > 0;
                        t1.isUsingAppearanceIconVertexData || (t1.isUsingAppearanceIconVertexData = !0, t1.layoutBasedIconVertexData = this.icon.snapshotSymbolVertexData(r, e1.numIconVertices), T && (t1.layoutBasedIconTransitioningVertexData = this.icon.snapshotIconTransitioningVertexData(r, e1.numIconVertices)));
                        const M = Math.floor(e1.numIconVertices / 4), S = Math.min(I.length, M);
                        let z = r;
                        const R = T ? this.icon.iconTransitioningVertexArray.uint16 : null;
                        for(let i = 0; i < S; ++i){
                            const n = I[i], r = t1.layoutBasedIconVertexData[0] || e1.tileAnchorX, o = t1.layoutBasedIconVertexData[1] || e1.tileAnchorY, a = 16 * n.pixelOffsetTL.x, s = 16 * n.pixelOffsetTL.y, l = 16 * n.pixelOffsetBR.x, u = 16 * n.pixelOffsetBR.y, c = 16 * n.minFontScaleX, h = 16 * n.minFontScaleY;
                            if (this.icon.updateSymbolVertexData(z, r, o, Math.round(32 * n.tl.x), Math.round(32 * n.tl.y), n.texPrimary.x, n.texPrimary.y, E, A, a, s, c, h), this.icon.updateSymbolVertexData(z + 1, r, o, Math.round(32 * n.tr.x), Math.round(32 * n.tr.y), n.texPrimary.x + n.texPrimary.w, n.texPrimary.y, E, A, l, s, c, h), this.icon.updateSymbolVertexData(z + 2, r, o, Math.round(32 * n.bl.x), Math.round(32 * n.bl.y), n.texPrimary.x, n.texPrimary.y + n.texPrimary.h, E, A, a, u, c, h), this.icon.updateSymbolVertexData(z + 3, r, o, Math.round(32 * n.br.x), Math.round(32 * n.br.y), n.texPrimary.x + n.texPrimary.w, n.texPrimary.y + n.texPrimary.h, E, A, l, u, c, h), R) {
                                const e1 = n.texSecondary ? n.texSecondary : n.texPrimary, t1 = 2 * z;
                                R[t1] = e1.x, R[t1 + 1] = e1.y, R[t1 + 2] = e1.x + e1.w, R[t1 + 3] = e1.y, R[t1 + 4] = e1.x, R[t1 + 5] = e1.y + e1.h, R[t1 + 6] = e1.x + e1.w, R[t1 + 7] = e1.y + e1.h;
                            }
                            z += 4;
                        }
                        const P = e1.numIconVertices - 4 * S;
                        for(let e1 = 0; e1 < P; ++e1)this.icon.updateSymbolVertexData(z + e1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                        return {
                            vertexOffsetDelta: e1.numIconVertices,
                            hasChanges: !0
                        };
                    }
                } else {
                    if (t1.usesAppearanceIconAsPlaceholder) return this.icon.updateSymbolVertexData(r, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), this.icon.updateSymbolVertexData(r + 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), this.icon.updateSymbolVertexData(r + 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), this.icon.updateSymbolVertexData(r + 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), {
                        vertexOffsetDelta: e1.numIconVertices,
                        hasChanges: !0
                    };
                    if (t1.isUsingAppearanceIconVertexData) return this.icon.restoreSymbolVertexData(r, t1.layoutBasedIconVertexData), t1.layoutBasedIconTransitioningVertexData && this.icon.restoreIconTransitioningVertexData(r, t1.layoutBasedIconTransitioningVertexData), t1.isUsingAppearanceIconVertexData = !1, {
                        vertexOffsetDelta: t1.layoutBasedIconVertexData.length / $_,
                        hasChanges: !0
                    };
                }
                return {
                    vertexOffsetDelta: e1.numIconVertices,
                    hasChanges: !1
                };
            }
            updateSymbolInstanceTextVertices(e1, t1, i, n, r, o) {
                const { canonical: a, layer: s, textScaleFactor: l, imageMap: u, featureState: c, layoutTextOffset: h, layoutTextSize: d, layoutTextRotate: f, layoutMinZoomSize: p, layoutMaxZoomSize: _, layoutTextSizeMinZoom: m, layoutTextSizeMaxZoom: g, availableImages: y } = o, x = e1.numHorizontalGlyphVertices > 0 || e1.numVerticalGlyphVertices > 0;
                if (!x) return {
                    vertexOffsetDelta: x ? e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices : 0,
                    hasChanges: !1
                };
                if (t1.activeAppearanceIndex === i) return {
                    vertexOffsetDelta: e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices,
                    hasChanges: !1
                };
                const v = i >= 0 ? s.appearances[i] : null;
                if (v && t1.textShaping) {
                    const { appearanceTextOffset: i, appearanceTextRotate: o, appearanceTextSize: x } = sf(v, s, n, a, h, f, d);
                    t1.fontScale = cf(x, t1.textScaleFactor);
                    const b = v.getUnevaluatedLayoutProperty("text-size");
                    let w = this.textSizeData, E = m, A = g;
                    v.hasLayoutProperty("text-size") && (w = Kd(this.zoom, b, this.worldview, y), E = "composite" === this.textSizeData.kind ? this.textSizeData.minZoom : 0, A = "composite" === this.textSizeData.kind ? this.textSizeData.maxZoom : 0);
                    const I = t1.textShaping.bottom - h[1], T = t1.textShaping.left - h[0], M = t1.textShaping.right - h[0];
                    t1.textShaping.top = i[1] + (t1.textShaping.top - h[1]), t1.textShaping.bottom = i[1] + I, t1.textShaping.left = i[0] + T, t1.textShaping.right = i[0] + M;
                    const S = O_(0, t1.textShaping, i, s, !1, n, u, this.allowVerticalPlacement, o), z = x && "composite" === w.kind ? b.possiblyEvaluate(new ks(E, {}), a).evaluate(n, c, a) : p, R = x && "composite" === w.kind ? b.possiblyEvaluate(new ks(A, {}), a).evaluate(n, c, a) : _, P = hf(v.name, w, x, l, z, R), D = Array.isArray(P) ? P[1] : x, C = 0, F = 1 + (Math.min(rf, Math.round(D * Jd)) << 1);
                    t1.isUsingAppearanceTextVertexData || (t1.isUsingAppearanceTextVertexData = !0, t1.layoutBasedTextVertexData = this.text.snapshotSymbolVertexData(r, e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices));
                    for(let t1 = 0; t1 < S.length && t1 < (e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices) / 4; ++t1){
                        const i = S[t1], n = i.glyphOffset[1], o = e1.tileAnchorX, a = e1.tileAnchorY, s = r + 4 * t1;
                        this.text.updateSymbolVertexData(s, o, a, Math.round(32 * i.tl.x), Math.round(32 * (n + i.tl.y)), i.texPrimary.x, i.texPrimary.y, C, F, i.pixelOffsetTL.x, i.pixelOffsetTL.y, i.minFontScaleX, i.minFontScaleY), this.text.updateSymbolVertexData(s + 1, o, a, Math.round(32 * i.tr.x), Math.round(32 * (n + i.tr.y)), i.texPrimary.x + i.texPrimary.w, i.texPrimary.y, C, F, i.pixelOffsetBR.x, i.pixelOffsetTL.y, i.minFontScaleX, i.minFontScaleY), this.text.updateSymbolVertexData(s + 2, o, a, Math.round(32 * i.bl.x), Math.round(32 * (n + i.bl.y)), i.texPrimary.x, i.texPrimary.y + i.texPrimary.h, C, F, i.pixelOffsetTL.x, i.pixelOffsetBR.y, i.minFontScaleX, i.minFontScaleY), this.text.updateSymbolVertexData(s + 3, o, a, Math.round(32 * i.br.x), Math.round(32 * (n + i.br.y)), i.texPrimary.x + i.texPrimary.w, i.texPrimary.y + i.texPrimary.h, C, F, i.pixelOffsetBR.x, i.pixelOffsetBR.y, i.minFontScaleX, i.minFontScaleY);
                    }
                    return {
                        vertexOffsetDelta: e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices,
                        hasChanges: !0
                    };
                }
                return t1.isUsingAppearanceTextVertexData ? (this.text.restoreSymbolVertexData(r, t1.layoutBasedTextVertexData), t1.isUsingAppearanceTextVertexData = !1, {
                    vertexOffsetDelta: t1.layoutBasedTextVertexData.length / $_,
                    hasChanges: !0
                }) : {
                    vertexOffsetDelta: e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices,
                    hasChanges: !1
                };
            }
            updateExpressions(e1) {
                this.text && this.text.programConfigurations.updateExpressions(e1), this.icon && this.icon.programConfigurations.updateExpressions(e1);
            }
            update(e1, t1, i, n, r, o, a, s) {
                if (this.text.uboBinder || this.text.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, this.worldview), this.icon.uboBinder || this.icon.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, this.worldview), s) {
                    if (o) for (const n of [
                        this.text.uboBinder,
                        this.icon.uboBinder
                    ])n && !n.isLightConstant && n.updateDynamicExpressions(r[0], t1, s, i, e1, a);
                    else if (Object.keys(e1).length > 0) {
                        const n = r[0], o = [
                            this.text.uboBinder,
                            this.icon.uboBinder
                        ].filter((e1)=>e1 && e1.hasStateDependentPaint(n));
                        if (o.length > 0) {
                            const r = new Set(Object.keys(e1).map((e1)=>{
                                const t1 = Number(e1);
                                return !isNaN(t1) && Number.isSafeInteger(t1) && String(t1) === e1 ? t1 : e1;
                            }));
                            for (const l of o)l.updateFeatures(r, n, t1, s, i, e1, a);
                        }
                    }
                }
            }
            updateZOffset() {
                const e1 = (e1, t1, n)=>{
                    i += t1, i > e1.length && e1.resize(i);
                    for(let r = -t1; r < 0; r++)e1.emplace(r + i, n);
                }, t1 = (e1, t1, i)=>{
                    n += t1, n > e1.length && e1.resize(n);
                    for(let r = -t1; r < 0; r++)e1.emplace(r + n, i);
                };
                if (!this.zOffsetBuffersNeedUpload) return;
                this.zOffsetBuffersNeedUpload = !1;
                let i = 0, n = 0;
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const n = this.symbolInstances.get(i), { numHorizontalGlyphVertices: r, numVerticalGlyphVertices: o, numIconVertices: a } = n, s = n.zOffset, l = a > 0;
                    if ((r > 0 || o > 0) && (e1(this.text.zOffsetVertexArray, r, s), e1(this.text.zOffsetVertexArray, o, s)), l) {
                        const { placedIconSymbolIndex: e1, verticalPlacedIconSymbolIndex: i } = n;
                        e1 >= 0 && t1(this.icon.zOffsetVertexArray, a, s), i >= 0 && t1(this.icon.zOffsetVertexArray, n.numVerticalIconVertices, s);
                    }
                }
                this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(e1, t1, i, n, r) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(e1), this.iconCollisionBox.upload(e1)), this.text.upload(e1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload, this.hasAppearances), null === this.hasAppearances && (this.hasAppearances = this.layers.some((e1)=>e1.appearances && e1.appearances.length > 0)), this.icon.upload(e1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload, this.hasAppearances), this.uploaded = !0;
            }
            updateAppearances(e1, t1, i, n, r, o = !1) {
                const a = {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
                if (!e1 || !i || !this.featureAppearanceData) return a;
                const s = t1 || {}, l = this.icon.layoutVertexArray && this.icon.layoutVertexArray.length > 0 && this.icon.layoutVertexArray.arrayBuffer, u = this.text.layoutVertexArray && this.text.layoutVertexArray.length > 0 && this.text.layoutVertexArray.arrayBuffer;
                if (!l && !u) return a;
                const c = this.layers[0], h = c.layout;
                this.featureAppearances && this.featureAppearances.appearancesVersion === c.appearancesVersion || (this.featureAppearances = new L_(c.appearances, c.appearancesVersion));
                const d = this.featureAppearances.update(n, o);
                if ("no-changes" === d.kind) return a;
                let f = 1, p = 0, _ = !1, m = !1;
                if (l) {
                    const [e1, t1] = h.get("icon-size-scale-range");
                    f = tt(1, e1, t1);
                }
                let g = 1, y = 0, x = !1;
                if (u) {
                    const [e1, t1] = h.get("text-size-scale-range");
                    g = tt(1, e1, t1);
                }
                const v = new Map;
                if (r && i) for (const e1 of i){
                    const t1 = r.getImage(e1, c.scope);
                    if (t1) {
                        const i = new Un(e1.toString());
                        v.set(i.toString(), t1);
                    }
                }
                const b = [
                    this.text.uboBinder,
                    this.icon.uboBinder
                ];
                for(let t1 = 0; t1 < this.symbolInstances.length; t1++){
                    const r = this.symbolInstances.get(t1), o = this.getAppearanceFeatureData(r.featureIndex);
                    if (!o) continue;
                    const a = o.id, w = void 0 !== a ? s[String(a)] : void 0, E = {
                        type: "Point",
                        id: o.id,
                        properties: o.properties,
                        geometry: []
                    };
                    let A;
                    if ("all-features" === d.kind) A = d.appearanceIndex;
                    else {
                        const t1 = c.appearances ? c.appearances.findIndex((t1)=>t1.isActive({
                                globals: n,
                                feature: E,
                                canonical: e1,
                                featureState: w
                            })) : -1;
                        A = t1 >= 0 ? t1 : -1;
                    }
                    const I = o.activeAppearanceIndex !== A;
                    if (u) {
                        const t1 = h.get("text-size"), n = "composite" === this.textSizeData.kind ? this.textSizeData.minZoom : 0, a = "composite" === this.textSizeData.kind ? this.textSizeData.maxZoom : 0, s = {
                            canonical: e1,
                            layer: c,
                            featureState: w,
                            availableImages: i,
                            textScaleFactor: g,
                            imageMap: v,
                            layoutTextOffset: h.get("text-offset").evaluate(E, w, e1).map((e1)=>e1 * Gd),
                            layoutTextSize: t1.evaluate(E, w, e1),
                            layoutTextRotate: h.get("text-rotate").evaluate(E, w, e1),
                            layoutMinZoomSize: t1.evaluate(E, {
                                zoom: n
                            }, e1),
                            layoutMaxZoomSize: t1.evaluate(E, {
                                zoom: a
                            }, e1),
                            layoutTextSizeMinZoom: n,
                            layoutTextSizeMaxZoom: a
                        }, l = this.updateSymbolInstanceTextVertices(r, o, A, E, y, s);
                        y += l.vertexOffsetDelta, x = x || l.hasChanges;
                    }
                    if (l) {
                        const t1 = {
                            canonical: e1,
                            layer: c,
                            featureState: w,
                            availableImages: i,
                            globalProperties: n,
                            iconScaleFactor: f,
                            layoutIconOffset: h.get("icon-offset").evaluate(E, w, e1),
                            layoutIconSize: h.get("icon-size").evaluate(E, w, e1, i),
                            layoutIconRotate: h.get("icon-rotate").evaluate(E, w, e1)
                        }, a = this.updateSymbolInstanceIconVertices(r, o, A, E, p, t1);
                        p += a.vertexOffsetDelta, _ = _ || a.hasChanges;
                    }
                    if (I) {
                        const t1 = r.featureIndex, o = n ? n.brightness : null, a = w || {}, s = A >= 0 ? c.appearances[A] : null;
                        for (const n of b)n && (n.layer = c, m = n.updateFeaturePaintForAppearance(t1, E, a, e1, i, o, s) || m);
                    }
                    o.activeAppearanceIndex = A;
                }
                return _ && this.icon.layoutVertexBuffer && null !== this.icon.layoutVertexArray.arrayBuffer && this.icon.layoutVertexArray.length === this.icon.layoutVertexBuffer.length && this.icon.layoutVertexBuffer.updateData(this.icon.layoutVertexArray), _ && this.icon.iconTransitioningVertexBuffer && this.icon.iconTransitioningVertexArray.length > 0 && this.icon.iconTransitioningVertexArray.length === this.icon.iconTransitioningVertexBuffer.length && this.icon.iconTransitioningVertexBuffer.updateData(this.icon.iconTransitioningVertexArray), x && this.text.layoutVertexBuffer && null !== this.text.layoutVertexArray.arrayBuffer && this.text.layoutVertexArray.length === this.text.layoutVertexBuffer.length && this.text.layoutVertexBuffer.updateData(this.text.layoutVertexArray), {
                    hasLayoutChanges: _ || x,
                    hasUboChanges: m
                };
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            getProjection() {
                return this.projectionInstance || (this.projectionInstance = Ip(this.projection)), this.projectionInstance;
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(e1, t1) {
                const i = this.lineVertexArray.length;
                if (void 0 !== e1.segment) for (const { x: e1, y: i } of t1)this.lineVertexArray.emplaceBack(e1, i);
                return {
                    lineStartIndex: i,
                    lineLength: this.lineVertexArray.length - i
                };
            }
            addSymbols(e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, m, g) {
                const y = e1.indexArray, x = e1.layoutVertexArray, v = e1.globeExtVertexArray, b = g, w = e1.uboBinder ? e1.uboBinder.getCurrentBatchIndex() : void 0, E = e1.segments.prepareSegment(4 * b, x, y, this.canOverlap ? o.sortKey : void 0, w), A = this.glyphOffsetArray.length, I = E.vertexLength, T = this.allowVerticalPlacement && a === Hd.vertical ? Math.PI / 2 : 0, M = o.text && o.text.sections;
                let S = x.length, z = -1;
                for(let n = 0; n < t1.length; n++){
                    const { tl: r, tr: a, bl: u, br: c, texPrimary: h, texSecondary: m, pixelOffsetTL: g, pixelOffsetBR: b, minFontScaleX: w, minFontScaleY: A, glyphOffset: I, isSDF: R, sectionIndex: P } = t1[n], D = E.vertexLength, C = I[1];
                    if (V_(x, l.x, l.y, r.x, C + r.y, h.x, h.y, i, R, g.x, g.y, w, A), V_(x, l.x, l.y, a.x, C + a.y, h.x + h.w, h.y, i, R, b.x, g.y, w, A), V_(x, l.x, l.y, u.x, C + u.y, h.x, h.y + h.h, i, R, g.x, b.y, w, A), V_(x, l.x, l.y, c.x, C + c.y, h.x + h.w, h.y + h.h, i, R, b.x, b.y, w, A), s) {
                        const { x: t1, y: i, z: n } = s.anchor, [r, o, a] = s.up;
                        U_(v, t1, i, n, r, o, a), U_(v, t1, i, n, r, o, a), U_(v, t1, i, n, r, o, a), U_(v, t1, i, n, r, o, a), j_(e1.dynamicLayoutVertexArray, t1, i, n, T);
                    } else j_(e1.dynamicLayoutVertexArray, l.x, l.y, l.z, T);
                    if (_) {
                        const t1 = m || h;
                        k_(e1.iconTransitioningVertexArray, t1.x, t1.y), k_(e1.iconTransitioningVertexArray, t1.x + t1.w, t1.y), k_(e1.iconTransitioningVertexArray, t1.x, t1.y + t1.h), k_(e1.iconTransitioningVertexArray, t1.x + t1.w, t1.y + t1.h);
                    }
                    if (y.emplaceBack(D, D + 1, D + 2), y.emplaceBack(D + 1, D + 2, D + 3), E.vertexLength += 4, E.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(I[0]), (n === t1.length - 1 || P !== t1[n + 1].sectionIndex) && (e1.uboBinder || e1.programConfigurations.populatePaintArrays(x.length, o, o.index, {}, d, f, p, M && M[P], this.worldview), e1.uboBinder)) {
                        const t1 = e1.uboBinder.populateUBO(o, o.index, f, d, p, M && M[P]);
                        z = t1;
                        const i = x.length - S;
                        for(let n = 0; n < i; n++)e1.featureIdArray.emplaceBack(t1);
                        S = x.length;
                    }
                }
                const R = g - t1.length;
                if (0 !== R && (this._addNullVertices(R, x, i, s, v, e1, _, E, y), e1.uboBinder && z >= 0)) {
                    const t1 = 4 * R;
                    for(let i = 0; i < t1; i++)e1.featureIdArray.emplaceBack(z);
                }
                const P = s ? s.anchor : l;
                e1.placedSymbolArray.emplaceBack(P.x, P.y, P.z, l.x, l.y, A, this.glyphOffsetArray.length - A, I, u, c, l.segment, i ? i[0] : 0, i ? i[1] : 0, n[0], n[1], a, 0, 0, 0, h, 0), e1.symbolInstanceIndices.push(m);
            }
            _addNullVertices(e1, t1, i, n, r, o, a, s, l) {
                for(let u = 0; u < e1; u++){
                    for(let e1 = 0; e1 < 4; e1++)V_(t1, 0, 0, 0, 0, 0, 0, i, !1, 0, 0, 0, 0), n ? (U_(r, 0, 0, 0, 0, 0, 0), j_(o.dynamicLayoutVertexArray, 0, 0, 0, 0)) : j_(o.dynamicLayoutVertexArray, 0, 0, 0, 0), a && k_(o.iconTransitioningVertexArray, 0, 0);
                    const e1 = s.vertexLength;
                    l.emplaceBack(e1, e1 + 1, e1 + 2), l.emplaceBack(e1 + 1, e1 + 2, e1 + 3), s.vertexLength += 4, s.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(0);
                }
            }
            _commitLayoutVertex(e1, t1, i, n, r, o, a) {
                e1.emplaceBack(t1, i, n, r, o, Math.round(a.x), Math.round(a.y));
            }
            _addCollisionDebugVertices(e1, t1, i, n, r, o, a) {
                const s = i.segments.prepareSegment(4, i.layoutVertexArray, i.indexArray), l = s.vertexLength, u = a.tileAnchorX, c = a.tileAnchorY;
                for(let e1 = 0; e1 < 4; e1++)i.collisionVertexArray.emplaceBack(0, 0, 0, 0, 0, 0);
                this._commitDebugCollisionVertexUpdate(i.collisionVertexArrayExt, t1, e1.padding, a.zOffset), this._commitLayoutVertex(i.layoutVertexArray, n, r, o, u, c, new Pe(e1.x1, e1.y1)), this._commitLayoutVertex(i.layoutVertexArray, n, r, o, u, c, new Pe(e1.x2, e1.y1)), this._commitLayoutVertex(i.layoutVertexArray, n, r, o, u, c, new Pe(e1.x2, e1.y2)), this._commitLayoutVertex(i.layoutVertexArray, n, r, o, u, c, new Pe(e1.x1, e1.y2)), s.vertexLength += 4;
                const h = i.indexArray;
                h.emplaceBack(l, l + 1), h.emplaceBack(l + 1, l + 2), h.emplaceBack(l + 2, l + 3), h.emplaceBack(l + 3, l), s.primitiveLength += 4;
            }
            _addTextDebugCollisionBoxes(e1, t1, i, n, r, o) {
                for(let a = n; a < r; a++){
                    const n = i.get(a), r = this.getSymbolInstanceTextSize(e1, o, t1, a);
                    this._addCollisionDebugVertices(n, r, this.textCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, o);
                }
            }
            _addIconDebugCollisionBoxes(e1, t1, i, n, r, o) {
                for(let a = n; a < r; a++){
                    const n = i.get(a), r = this.getSymbolInstanceIconSize(e1, t1, o.placedIconSymbolIndex);
                    this._addCollisionDebugVertices(n, r, this.iconCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, o);
                }
            }
            generateCollisionDebugBuffers(e1, t1, i) {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new W_(ic, Sd.members, ec), this.iconCollisionBox = new W_(ic, Sd.members, ec);
                const n = ef(this.iconSizeData, e1), r = ef(this.textSizeData, e1, i);
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const o = this.symbolInstances.get(i);
                    this._addTextDebugCollisionBoxes(r, e1, t1, o.textBoxStartIndex, o.textBoxEndIndex, o), this._addTextDebugCollisionBoxes(r, e1, t1, o.verticalTextBoxStartIndex, o.verticalTextBoxEndIndex, o), this._addIconDebugCollisionBoxes(n, e1, t1, o.iconBoxStartIndex, o.iconBoxEndIndex, o), this._addIconDebugCollisionBoxes(n, e1, t1, o.verticalIconBoxStartIndex, o.verticalIconBoxEndIndex, o);
                }
            }
            getSymbolInstanceTextSize(e1, t1, i, n) {
                const r = this.text.placedSymbolArray.get(t1.rightJustifiedTextSymbolIndex >= 0 ? t1.rightJustifiedTextSymbolIndex : t1.centerJustifiedTextSymbolIndex >= 0 ? t1.centerJustifiedTextSymbolIndex : t1.leftJustifiedTextSymbolIndex >= 0 ? t1.leftJustifiedTextSymbolIndex : t1.verticalPlacedTextSymbolIndex >= 0 ? t1.verticalPlacedTextSymbolIndex : n), o = Qd(this.textSizeData, e1, r) / Gd;
                return this.tilePixelRatio * o;
            }
            getSymbolInstanceIconSize(e1, t1, i) {
                const n = this.icon.placedSymbolArray.get(i), r = Qd(this.iconSizeData, e1, n);
                return this.tilePixelRatio * r;
            }
            _commitDebugCollisionVertexUpdate(e1, t1, i, n) {
                e1.emplaceBack(t1, -i, -i, n), e1.emplaceBack(t1, i, -i, n), e1.emplaceBack(t1, i, i, n), e1.emplaceBack(t1, -i, i, n);
            }
            _updateTextDebugCollisionBoxes(e1, t1, i, n, r, o, a) {
                for(let a = n; a < r; a++){
                    const n = i.get(a), r = this.getSymbolInstanceTextSize(e1, o, t1, a);
                    this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, r, n.padding, o.zOffset);
                }
            }
            _updateIconDebugCollisionBoxes(e1, t1, i, n, r, o, a) {
                for(let a = n; a < r; a++){
                    const n = i.get(a), r = this.getSymbolInstanceIconSize(e1, t1, o.placedIconSymbolIndex);
                    this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, r, n.padding, o.zOffset);
                }
            }
            updateCollisionDebugBuffers(e1, t1, i, n) {
                if (!this.hasDebugData()) return;
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
                const r = ef(this.iconSizeData, e1, n), o = ef(this.textSizeData, e1, i);
                for(let a = 0; a < this.symbolInstances.length; a++){
                    const s = this.symbolInstances.get(a);
                    this._updateTextDebugCollisionBoxes(o, e1, t1, s.textBoxStartIndex, s.textBoxEndIndex, s, i), this._updateTextDebugCollisionBoxes(o, e1, t1, s.verticalTextBoxStartIndex, s.verticalTextBoxEndIndex, s, i), this._updateIconDebugCollisionBoxes(r, e1, t1, s.iconBoxStartIndex, s.iconBoxEndIndex, s, n), this._updateIconDebugCollisionBoxes(r, e1, t1, s.verticalIconBoxStartIndex, s.verticalIconBoxEndIndex, s, n);
                }
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
            }
            _deserializeCollisionBoxesForSymbol(e1, t1, i, n, r, o, a, s, l) {
                const u = {};
                if (t1 < i) {
                    const { x1: i, y1: n, x2: r, y2: o, padding: a, projectedAnchorX: s, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: d, featureIndex: f } = e1.get(t1);
                    u.textBox = {
                        x1: i,
                        y1: n,
                        x2: r,
                        y2: o,
                        padding: a,
                        projectedAnchorX: s,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: d
                    }, u.textFeatureIndex = f;
                }
                if (n < r) {
                    const { x1: t1, y1: i, x2: r, y2: o, padding: a, projectedAnchorX: s, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: d, featureIndex: f } = e1.get(n);
                    u.verticalTextBox = {
                        x1: t1,
                        y1: i,
                        x2: r,
                        y2: o,
                        padding: a,
                        projectedAnchorX: s,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: d
                    }, u.verticalTextFeatureIndex = f;
                }
                if (o < a) {
                    const { x1: t1, y1: i, x2: n, y2: r, padding: a, projectedAnchorX: s, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: d, featureIndex: f } = e1.get(o);
                    u.iconBox = {
                        x1: t1,
                        y1: i,
                        x2: n,
                        y2: r,
                        padding: a,
                        projectedAnchorX: s,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: d
                    }, u.iconFeatureIndex = f;
                }
                if (s < l) {
                    const { x1: t1, y1: i, x2: n, y2: r, padding: o, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: d, featureIndex: f } = e1.get(s);
                    u.verticalIconBox = {
                        x1: t1,
                        y1: i,
                        x2: n,
                        y2: r,
                        padding: o,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: d
                    }, u.verticalIconFeatureIndex = f;
                }
                return u;
            }
            deserializeCollisionBoxes(e1) {
                this.collisionArrays = [];
                for(let t1 = 0; t1 < this.symbolInstances.length; t1++){
                    const i = this.symbolInstances.get(t1);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(e1, i.textBoxStartIndex, i.textBoxEndIndex, i.verticalTextBoxStartIndex, i.verticalTextBoxEndIndex, i.iconBoxStartIndex, i.iconBoxEndIndex, i.verticalIconBoxStartIndex, i.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            hasIconTextFit() {
                return this.hasAnyIconTextFit;
            }
            addIndicesForPlacedSymbol(e1, t1) {
                const i = e1.placedSymbolArray.get(t1), n = i.vertexStartIndex + 4 * i.numGlyphs;
                for(let t1 = i.vertexStartIndex; t1 < n; t1 += 4)e1.indexArray.emplaceBack(t1, t1 + 1, t1 + 2), e1.indexArray.emplaceBack(t1 + 1, t1 + 2, t1 + 3);
            }
            getSortedSymbolIndexes(e1) {
                if (this.sortedAngle === e1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const t1 = Math.sin(e1), i = Math.cos(e1), n = [], r = [], o = [];
                for(let e1 = 0; e1 < this.symbolInstances.length; ++e1){
                    o.push(e1);
                    const a = this.symbolInstances.get(e1);
                    n.push(0 | Math.round(t1 * a.tileAnchorX + i * a.tileAnchorY)), r.push(a.featureIndex);
                }
                return o.sort((e1, t1)=>n[e1] - n[t1] || r[t1] - r[e1]), o;
            }
            getSortedIndexesByZOffset() {
                if (!this.zOffsetSortDirty) return this.symbolInstanceIndexesSortedZOffset;
                if (!this.symbolInstanceIndexesSortedZOffset) {
                    this.symbolInstanceIndexesSortedZOffset = [];
                    for(let e1 = 0; e1 < this.symbolInstances.length; ++e1)this.symbolInstanceIndexesSortedZOffset.push(e1);
                }
                return this.zOffsetSortDirty = !1, this.symbolInstanceIndexesSortedZOffset.sort((e1, t1)=>this.symbolInstances.get(t1).zOffset - this.symbolInstances.get(e1).zOffset);
            }
            addToSortKeyRanges(e1, t1) {
                const i = this.sortKeyRanges.at(-1);
                i && i.sortKey === t1 ? i.symbolInstanceEnd = e1 + 1 : this.sortKeyRanges.push({
                    sortKey: t1,
                    symbolInstanceStart: e1,
                    symbolInstanceEnd: e1 + 1
                });
            }
            sortFeatures(e1) {
                if (this.sortFeaturesByY && this.sortedAngle !== e1) {
                    if (this.text.segments.get().length > 1 || this.icon.segments.get().length > 1) this.sortFeaturesByY = !1;
                    else {
                        this.symbolInstanceIndexes = this.getSortedSymbolIndexes(e1), this.sortedAngle = e1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                        for (const e1 of this.symbolInstanceIndexes){
                            const t1 = this.symbolInstances.get(e1);
                            this.featureSortOrder.push(t1.featureIndex);
                            const { rightJustifiedTextSymbolIndex: i, centerJustifiedTextSymbolIndex: n, leftJustifiedTextSymbolIndex: r, verticalPlacedTextSymbolIndex: o, placedIconSymbolIndex: a, verticalPlacedIconSymbolIndex: s } = t1;
                            i >= 0 && this.addIndicesForPlacedSymbol(this.text, i), n >= 0 && n !== i && this.addIndicesForPlacedSymbol(this.text, n), r >= 0 && r !== n && r !== i && this.addIndicesForPlacedSymbol(this.text, r), o >= 0 && this.addIndicesForPlacedSymbol(this.text, o), a >= 0 && this.addIndicesForPlacedSymbol(this.icon, a), s >= 0 && this.addIndicesForPlacedSymbol(this.icon, s);
                        }
                        this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                    }
                }
            }
        }
        Ha(q_, "SymbolBucket", {
            omit: [
                "layers",
                "collisionBoxArray",
                "compareText",
                "features"
            ]
        }), q_.addDynamicAttributes = j_;
        class X_ extends mh {
            constructor(e1, t1, i){
                super(e1, t1, i), this.elevatedLayoutVertexArray = new ku;
            }
            upload(e1) {
                const t1 = this.uploaded;
                super.upload(e1), !t1 && this.elevatedLayoutVertexArray.length > 0 && (this.elevatedLayoutVertexBuffer = e1.createVertexBuffer(this.elevatedLayoutVertexArray, Fc.members));
            }
            destroy() {
                this.elevatedLayoutVertexBuffer && this.elevatedLayoutVertexBuffer.destroy(), super.destroy();
            }
        }
        Ha(X_, "ElevatedFillBufferData");
        class Y_ {
            constructor(){
                this.portals = [];
            }
            static isOnBorder(e1, t1) {
                return e1 <= 0 && t1 <= 0 || e1 >= Sr && t1 >= Sr;
            }
            static evaluate(e1) {
                if (0 === e1.length) return new Y_;
                let t1 = [];
                for (const i of e1)t1.push(...i.portals);
                if (0 === t1.length) return new Y_;
                for (const e1 of t1){
                    const t1 = e1.va, i = e1.vb;
                    (Y_.isOnBorder(t1.x, i.x) || Y_.isOnBorder(t1.y, i.y)) && (e1.type = "border");
                }
                const i = t1.filter((e1)=>"unevaluated" !== e1.type), n = t1.filter((e1)=>"unevaluated" === e1.type);
                if (0 === n.length) return new Y_;
                n.sort((e1, t1)=>e1.hash === t1.hash ? e1.isTunnel === t1.isTunnel ? 0 : e1.isTunnel ? -1 : 1 : e1.hash < t1.hash ? 1 : -1), t1 = i.concat(n);
                let r = i.length, o = r, a = r;
                do if (o++, o === t1.length || t1[r].hash !== t1[o].hash) {
                    if (o - r === 2) {
                        a < r && (t1[a] = t1[r], t1[r] = null);
                        const e1 = t1[a], i = t1[o - 1];
                        e1.type = e1.isTunnel !== i.isTunnel ? "tunnel" : "polygon", e1.connection = {
                            a: e1.connection.a,
                            b: i.connection.a
                        }, a++;
                    }
                    r = o;
                }
                while (r !== t1.length);
                return t1.splice(a), t1.sort((e1, t1)=>e1.hash < t1.hash ? 1 : -1), {
                    portals: t1
                };
            }
        }
        Ha(Y_, "ElevationPortalGraph");
        class J_ {
            constructor(e1, t1, i){
                this.outPositions = e1, this.outNormals = t1, this.outIndices = i, this.vertexLookup = new Map;
            }
            addVertex(e1, t1, i) {
                let n = e1[2];
                null != i && (n *= i);
                const r = `${e1[0]},${e1[1]},${e1[2]},${t1[0]},${t1[1]},${t1[2]}`, o = this.vertexLookup.get(r);
                if (null != o) return o;
                const a = this.outPositions.length;
                this.vertexLookup.set(r, a);
                const s = Math.trunc(16384 * t1[0]), l = Math.trunc(16384 * t1[1]), u = Math.trunc(16384 * t1[2]);
                return this.outPositions.emplaceBack(e1[0], e1[1], n), this.outNormals.emplaceBack(s, l, u), a;
            }
            addTriangle(e1, t1, i) {
                this.outIndices.emplaceBack(e1, t1, i);
            }
            addTriangles(e1, t1, i, n = 0) {
                if (0 === e1.length) return;
                const r = R(), o = R();
                for(let a = 0; a < e1.length; a += 3){
                    const s = t1[e1[a + 0]], l = t1[e1[a + 1]], u = t1[e1[a + 2]], c = i[e1[a + 1]] + n, h = i[e1[a + 2]] + n;
                    F(r, s.x, s.y, i[e1[a + 0]] + n);
                    const d = this.addVertex(r, o);
                    F(r, l.x, l.y, c);
                    const f = this.addVertex(r, o);
                    F(r, u.x, u.y, h);
                    const p = this.addVertex(r, o);
                    this.outIndices.emplaceBack(d, f, p);
                }
            }
            addQuad(e1, t1, i, n, r, o) {
                const a = this.addVertex(e1, r, o), s = this.addVertex(t1, r, o), l = this.addVertex(i, r, o), u = this.addVertex(n, r, o);
                this.addTriangle(a, s, l), this.addTriangle(l, u, a);
            }
            getVertexCount() {
                return this.outPositions.length;
            }
            clearVertexLookup() {
                this.vertexLookup.clear();
            }
        }
        class K_ {
            constructor(e1, t1, i, n){
                this.unevaluatedPortals = new Y_, this.bridgeFeatureSections = [], this.tunnelFeatureSections = [], this.vertexHashLookup = new Map, this.unevalVertices = [], this.unevalHeights = [], this.unevalTriangles = [], this.unevalTunnelTriangles = [], this.unevalEdges = [], this.vertexPositions = new Uu, this.vertexNormals = new Gu, this.indexArray = new oc, this.tileToMeters = vu(e1), this.bridgeProgramConfigurations = new ch(t1, {
                    zoom: i,
                    lut: n
                }, (e1)=>"fill-tunnel-structure-color" !== e1), this.tunnelProgramConfigurations = new ch(t1, {
                    zoom: i,
                    lut: n
                }, (e1)=>"fill-bridge-guard-rail-color" !== e1);
            }
            addVertices(e1, t1) {
                const i = this.unevalVertices.length;
                for(let i = 0; i < e1.length; i++)this.unevalVertices.push(e1[i]), this.unevalHeights.push(t1[i]);
                return i;
            }
            addTriangles(e1, t1, i) {
                const n = i ? this.unevalTunnelTriangles : this.unevalTriangles;
                for (const i of e1)n.push(i + t1);
            }
            addRenderableRing(e1, t1, i, n, r, o) {
                const a = [
                    new Pe(r.min.x, r.min.y),
                    new Pe(r.max.x, r.min.y),
                    new Pe(r.max.x, r.max.y),
                    new Pe(r.min.x, r.max.y)
                ];
                for(let s = 0; s < i - 1; s++){
                    const i = t1 + s, l = i + 1, u = this.unevalVertices[i], c = this.unevalVertices[l];
                    if (!(u.x >= r.min.x && u.x <= r.max.x && u.y >= r.min.y && u.y <= r.max.y || c.x >= r.min.x && c.x <= r.max.x && c.y >= r.min.y && c.y <= r.max.y || $h(u, c, a))) continue;
                    if (this.isOnBorder(u.x, c.x) || this.isOnBorder(u.y, c.y)) continue;
                    const h = K_.computeEdgeHash(this.unevalVertices[i], this.unevalVertices[l]);
                    let d, f = this.vertexHashLookup.get(K_.computePosHash(u));
                    null != f ? d = f.next : (f = this.vertexHashLookup.get(K_.computePosHash(c)), d = null != f ? f.prev : h), this.unevalEdges.push({
                        polygonIdx: e1,
                        a: i,
                        b: l,
                        hash: h,
                        portalHash: d,
                        isTunnel: n,
                        type: "unevaluated",
                        featureInfo: o
                    });
                }
            }
            addPortalCandidates(e1, t1, i, n, r) {
                if (0 !== t1.length) {
                    this.vertexHashLookup.clear();
                    for (const r of t1){
                        if (0 === r.length) continue;
                        const t1 = r[0];
                        let o = K_.computeEdgeHash(t1[t1.length - 2], t1.at(-1));
                        for(let r = 0; r < t1.length - 1; r++){
                            const a = t1[r + 0], s = t1[r + 1], l = be(s.x - a.x, s.y - a.y), u = Te(l);
                            if (0 === u) continue;
                            let c = "unevaluated";
                            const h = n.pointElevation(a), d = n.pointElevation(s);
                            Math.abs(h) < .01 && Math.abs(d) < .01 ? c = "entrance" : (this.isOnBorder(a.x, s.x) || this.isOnBorder(a.y, s.y)) && (c = "border");
                            const f = K_.computeEdgeHash(a, s);
                            this.unevaluatedPortals.portals.push({
                                connection: {
                                    a: e1,
                                    b: void 0
                                },
                                va: a,
                                vb: s,
                                vab: l,
                                length: u,
                                hash: f,
                                isTunnel: i,
                                type: c
                            });
                            const p = K_.computePosHash(a);
                            this.vertexHashLookup.set(p, {
                                prev: o,
                                next: f
                            }), o = f;
                        }
                    }
                }
            }
            construct(e1) {
                if (0 === this.unevalVertices.length) return;
                const t1 = ()=>({
                        vertexOffset: 0,
                        primitiveOffset: this.indexArray.length
                    }), i = (e1)=>{
                    e1.primitiveLength = this.indexArray.length - e1.primitiveOffset;
                }, n = new J_(this.vertexPositions, this.vertexNormals, this.indexArray);
                this.prepareEdges(e1.portals, this.unevalEdges);
                const r = t1(), o = t1(), a = t1(), s = (e1, t1)=>{
                    e1.sort((e1, i)=>e1.type === t1 && i.type !== t1 ? -1 : e1.type !== t1 && i.type === t1 ? 1 : 0);
                    const i = e1.findIndex((e1)=>e1.type !== t1);
                    return i >= 0 ? i : e1.length;
                };
                let l = 0;
                this.unevalEdges.length > 0 && (l = s(this.unevalEdges, "none"), this.constructBridgeStructures(n, this.unevalVertices, this.unevalHeights, this.unevalEdges, {
                    min: 0,
                    max: l
                }, this.tileToMeters)), i(a);
                const u = t1(), c = t1();
                if (this.unevalEdges.length > 0) {
                    const e1 = this.unevalEdges.splice(l), t1 = s(e1, "tunnel") + l;
                    this.unevalEdges.push(...e1), this.constructTunnelStructures(n, this.unevalVertices, this.unevalHeights, this.unevalEdges, {
                        min: 0,
                        max: l
                    }, {
                        min: l,
                        max: t1
                    });
                }
                i(u), n.addTriangles(this.unevalTriangles, this.unevalVertices, this.unevalHeights), i(c), n.addTriangles(this.unevalTunnelTriangles, this.unevalVertices, this.unevalHeights), i(o), n.addTriangles(this.unevalTunnelTriangles, this.unevalVertices, this.unevalHeights, 4), i(r), this.maskSegments = Bc.simpleSegment(0, c.primitiveOffset, 0, c.primitiveLength), this.depthSegments = Bc.simpleSegment(0, o.primitiveOffset, 0, o.primitiveLength), this.renderableBridgeSegments = Bc.simpleSegment(0, a.primitiveOffset, 0, a.primitiveLength), this.renderableTunnelSegments = Bc.simpleSegment(0, u.primitiveOffset, 0, u.primitiveLength), this.shadowCasterSegments = Bc.simpleSegment(0, r.primitiveOffset, 0, r.primitiveLength);
            }
            update(e1, t1, i, n, r, o, a, s) {
                this.bridgeProgramConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, s), this.tunnelProgramConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, s);
            }
            upload(e1) {
                this.vertexBuffer || 0 === this.vertexPositions.length || 0 === this.vertexNormals.length || 0 === this.indexArray.length || (this.vertexBuffer = e1.createVertexBuffer(this.vertexPositions, Oc.members), this.vertexBufferNormal = e1.createVertexBuffer(this.vertexNormals, Lc.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.bridgeProgramConfigurations.upload(e1), this.tunnelProgramConfigurations.upload(e1));
            }
            destroy() {
                this.vertexBuffer && (this.vertexBuffer.destroy(), this.vertexBufferNormal.destroy(), this.indexBuffer.destroy()), this.maskSegments && (this.maskSegments.destroy(), this.depthSegments.destroy(), this.renderableBridgeSegments.destroy(), this.renderableTunnelSegments.destroy(), this.shadowCasterSegments.destroy()), this.bridgeProgramConfigurations.destroy(), this.tunnelProgramConfigurations.destroy();
            }
            populatePaintArrays(e1, t1, i, n, r) {
                const o = (o, a)=>{
                    for(let s = 0; s < a.length - 1; s++){
                        const l = a[s].featureIndex, u = a[s + 1].vertexStart, c = e1.feature(l);
                        o.populatePaintArrays(u, c, l, {}, i, t1, n, void 0, r);
                    }
                };
                o(this.bridgeProgramConfigurations, this.bridgeFeatureSections), o(this.tunnelProgramConfigurations, this.tunnelFeatureSections);
            }
            computeVertexConnections(e1, t1, i, n, r) {
                const o = new Map;
                for(let a = n; a < r; a++){
                    const n = i[a], r = n.a, s = n.b, l = K_.computePosHash(e1[r]), u = K_.computePosHash(e1[s]);
                    let c = o.get(l);
                    c || (c = {}, o.set(l, c));
                    let h = o.get(u);
                    h || (h = {}, o.set(u, h)), t1[r] <= 0 && t1[s] <= 0 || (c.to = s, h.from = r);
                }
                return o;
            }
            isTerminalVertex(e1, t1) {
                const i = K_.computePosHash(this.unevalVertices[e1]), n = t1.get(i);
                return !n || !n.from || !n.to;
            }
            constructBridgeStructures(e1, t1, i, n, r, o) {
                e1.clearVertexLookup();
                const a = this.computeVertexConnections(t1, i, n, r.min, r.max), s = 1 / o, l = .5 * s, u = (e1, n)=>F(e1, t1[n].x, t1[n].y, i[n] * s), c = R(), h = R(), d = R(), f = R(), p = R(), _ = (e1, i)=>{
                    const n = a.get(K_.computePosHash(t1[i])), r = n.from, o = n.to;
                    if (!r || !o) return;
                    u(c, r), u(h, i), u(d, o), Q(f), ee(c, h) || (te(p, h, c), Z(f, p)), ee(d, h) || (te(p, d, h), O(f, f, Z(p, p)));
                    const s = ne(f);
                    return s > 0 ? k(e1, f, 1 / s) : void 0;
                };
                let m = Number.POSITIVE_INFINITY;
                this.sortSubarray(n, r.min, r.max, (e1, t1)=>e1.featureInfo.featureIndex - t1.featureInfo.featureIndex);
                const g = R(), y = R(), x = R(), v = R(), b = R(), w = R(), E = R(), A = R(), I = R(), T = [
                    R(),
                    R(),
                    R(),
                    R()
                ], M = [
                    R(),
                    R(),
                    R(),
                    R()
                ], S = [
                    {
                        coord: new Pe(0, 0),
                        height: 0
                    },
                    {
                        coord: new Pe(0, 0),
                        height: 0
                    }
                ], z = (e1, t1)=>e1 > t1;
                for(let u = r.min; u < r.max; u++){
                    const r = n[u];
                    if (!r.featureInfo.guardRailEnabled) continue;
                    if (!this.prepareEdgePoints(S, t1, i, r, z)) continue;
                    const [c, h] = S;
                    if (F(g, c.coord.x, c.coord.y, s * c.height), F(y, h.coord.x, h.coord.y, s * h.height), ee(g, y)) continue;
                    te(x, y, g), Z(x, x);
                    const d = _(A, r.a) || x, f = _(I, r.b) || x;
                    F(v, d[1], -d[0], 0), Z(v, v), F(b, f[1], -f[0], 0), Z(b, b), q(A, v, d), Z(w, A), q(A, b, f), Z(E, A), O(T[0], g, k(A, te(A, v, w), l)), O(T[1], g, k(A, O(A, v, w), l)), O(T[2], g, k(A, w, l)), T[3] = g, O(M[0], y, k(A, te(A, b, E), l)), O(M[1], y, k(A, O(A, b, E), l)), O(M[2], y, k(A, E, l)), M[3] = y, m = this.addFeatureSection(r.featureInfo.featureIndex, m, this.bridgeFeatureSections, e1);
                    const p = e1.addVertex(T[0], v, o), R = e1.addVertex(T[1], v, o), P = e1.addVertex(M[0], b, o), D = e1.addVertex(M[1], b, o);
                    e1.addTriangle(p, R, P), e1.addTriangle(R, D, P);
                    const C = e1.addVertex(T[1], w, o), L = e1.addVertex(T[2], w, o), B = e1.addVertex(M[1], E, o), N = e1.addVertex(M[2], E, o);
                    e1.addTriangle(C, L, B), e1.addTriangle(L, N, B), $(v, v), $(b, b);
                    const V = e1.addVertex(T[2], v, o), U = e1.addVertex(T[3], v, o), G = e1.addVertex(M[2], b, o), j = e1.addVertex(M[3], b, o);
                    e1.addTriangle(V, U, G), e1.addTriangle(U, j, G);
                    const H = this.isTerminalVertex(r.a, a), W = this.isTerminalVertex(r.b, a);
                    c.height < .01 && H && e1.addQuad(T[3], T[2], T[1], T[0], $(d, d), o), h.height < .01 && W && e1.addQuad(M[0], M[1], M[2], M[3], f, o);
                }
                this.bridgeFeatureSections.push({
                    featureIndex: Number.POSITIVE_INFINITY,
                    vertexStart: e1.getVertexCount()
                });
            }
            constructTunnelStructures(e1, t1, i, n, r, o) {
                e1.clearVertexLookup();
                let a = Number.POSITIVE_INFINITY;
                const s = (e1, t1)=>e1.featureInfo.featureIndex - t1.featureInfo.featureIndex;
                this.sortSubarray(n, r.min, r.max, s), this.sortSubarray(n, o.min, o.max, s);
                const l = (e1)=>Z(e1, e1), u = [
                    {
                        coord: new Pe(0, 0),
                        height: 0
                    },
                    {
                        coord: new Pe(0, 0),
                        height: 0
                    }
                ], c = (e1, t1)=>e1 < t1, h = R(), d = R(), f = R(), p = R(), _ = R();
                for(let o = r.min; o < r.max; o++){
                    if (!this.prepareEdgePoints(u, t1, i, n[o], c)) continue;
                    const [r, s] = u, m = l(F(_, -(s.coord.y - r.coord.y), s.coord.x - r.coord.x, 0));
                    a = this.addFeatureSection(n[o].featureInfo.featureIndex, a, this.tunnelFeatureSections, e1), e1.addQuad(F(h, r.coord.x, r.coord.y, r.height), F(d, s.coord.x, s.coord.y, s.height), F(f, s.coord.x, s.coord.y, n[o].isTunnel ? s.height + 4 : 0), F(p, r.coord.x, r.coord.y, n[o].isTunnel ? r.height + 4 : 0), m);
                }
                for(let r = o.min; r < o.max; r++){
                    const o = n[r];
                    o.isTunnel && ([o.a, o.b] = [
                        o.b,
                        o.a
                    ]);
                    const s = t1[o.a], u = t1[o.b], c = l(F(_, -(u.y - s.y), u.x - s.x, 0));
                    a = this.addFeatureSection(o.featureInfo.featureIndex, a, this.tunnelFeatureSections, e1), e1.addQuad(F(h, u.x, u.y, 0), F(d, s.x, s.y, 0), F(f, s.x, s.y, i[o.a] + 4), F(p, u.x, u.y, i[o.b] + 4), c), e1.addQuad(F(h, s.x, s.y, 0), F(d, u.x, u.y, 0), F(f, u.x, u.y, i[o.b] + 4), F(p, s.x, s.y, i[o.a] + 4), c);
                }
                this.tunnelFeatureSections.push({
                    featureIndex: Number.POSITIVE_INFINITY,
                    vertexStart: e1.getVertexCount()
                });
            }
            setElevatedPoint(e1, t1, i, n) {
                e1.coord.x = t1, e1.coord.y = i, e1.height = n;
            }
            prepareEdgePoints(e1, t1, i, n, r) {
                let o = t1[n.a].x, a = t1[n.a].y, s = t1[n.b].x, l = t1[n.b].y, u = i[n.a], c = i[n.b];
                const h = r(u, 0), d = r(c, 0);
                if (h && d) return this.setElevatedPoint(e1[0], o, a, u), this.setElevatedPoint(e1[1], s, l, c), !0;
                if (!h && !d) return !1;
                if (h) {
                    if (!d) {
                        const e1 = c / (c - u);
                        s = dn(s, o, e1), l = dn(l, a, e1), c = dn(c, u, e1);
                    }
                } else {
                    const e1 = u / (u - c);
                    o = dn(o, s, e1), a = dn(a, l, e1), u = dn(u, c, e1);
                }
                return this.setElevatedPoint(e1[0], o, a, u), this.setElevatedPoint(e1[1], s, l, c), !0;
            }
            prepareEdges(e1, t1) {
                if (0 === t1.length) return;
                t1.sort((e1, t1)=>e1.hash === t1.hash ? t1.polygonIdx - e1.polygonIdx : t1.hash > e1.hash ? 1 : -1);
                let i = 0, n = 0, r = 0, o = t1[i].polygonIdx;
                do n++, (n === t1.length || t1[i].hash !== t1[n].hash) && ((1 === n - i || t1[n - 1].polygonIdx !== o) && (r < i && (t1[r] = t1[i], t1[i] = null), t1[r].type = "none", r++), i = n, i !== t1.length && (o = t1[i].polygonIdx));
                while (i !== t1.length);
                if (t1.splice(r), 0 !== t1.length && 0 !== e1.length) {
                    t1.sort((e1, t1)=>e1.portalHash < t1.portalHash ? 1 : -1);
                    let i = 0, n = 0;
                    for(; i !== t1.length && n !== e1.length;){
                        const r = t1[i], o = e1[n];
                        r.portalHash > o.hash ? i++ : o.hash > r.portalHash ? n++ : (r.type = o.type, i++);
                    }
                }
            }
            isOnBorder(e1, t1) {
                return e1 <= 0 && t1 <= 0 || e1 >= Sr && t1 >= Sr;
            }
            addFeatureSection(e1, t1, i, n) {
                return e1 !== t1 && (t1 = e1, i.push({
                    featureIndex: e1,
                    vertexStart: n.getVertexCount()
                }), n.clearVertexLookup()), t1;
            }
            sortSubarray(e1, t1, i, n) {
                const r = e1.slice(t1, i);
                r.sort(n), e1.splice(t1, r.length, ...r);
            }
            static computeEdgeHash(e1, t1) {
                return (e1.y === t1.y && e1.x > t1.x || e1.y > t1.y) && ([e1, t1] = [
                    t1,
                    e1
                ]), BigInt(K_.computePosHash(e1)) << 32n | BigInt(K_.computePosHash(t1));
            }
            static computePosHash(e1) {
                return ((65535 & e1.x) << 16 | 65535 & e1.y) >>> 0;
            }
        }
        class Q_ {
            constructor(){
                this._valid = !1;
            }
            reset(e1) {
                return this.feature = e1, this._valid = !0, this._geometry = e1.loadGeometry(), 0 !== this._geometry.length && 0 !== this._geometry[0].length || (this._valid = !1), this;
            }
            geometry(e1, t1) {
                return this._valid && e1(t1(this._geometry)), this;
            }
            require(e1, t1, i) {
                return this.get(e1, !0, t1, i);
            }
            optional(e1, t1, i) {
                return this.get(e1, !1, t1, i);
            }
            success() {
                return this._valid;
            }
            get(e1, t1, i, n) {
                const r = Object.hasOwn(this.feature.properties, e1) ? +this.feature.properties[e1] : void 0;
                return this._valid && void 0 !== r && !Number.isNaN(r) ? i(n ? n(r) : r) : t1 && (this._valid = !1), this;
            }
        }
        class em {
            constructor(e1, t1){
                this.featureFunc = e1, this.vertexFunc = t1;
            }
            parseFeature(e1, t1, i) {
                return this.featureFunc(e1, t1, i);
            }
            parseVertex(e1, t1, i) {
                return this.vertexFunc(e1, t1, i);
            }
        }
        const tm = new em((e1, t1, i)=>e1.reset(t1).require(ld, (e1)=>{
                i.id = e1;
            }).optional("fixed_height_relative", (e1)=>{
                i.constantHeight = e1;
            }, nm.decodeRelativeHeight).geometry((e1)=>{
                i.bounds = e1;
            }, Ze).success(), (e1, t1, i)=>e1.reset(t1).require(ld, (e1)=>{
                i.id = e1;
            }).require("elevation_idx", (e1)=>{
                i.idx = e1;
            }).require("extent", (e1)=>{
                i.extent = e1;
            }).require("height_relative", (e1)=>{
                i.height = e1;
            }, nm.decodeRelativeHeight).geometry((e1)=>{
                i.position = e1;
            }, nm.getPoint).success()), im = new em((e1, t1, i)=>e1.reset(t1).require(ld, (e1)=>{
                i.id = e1;
            }).optional("fixed_height", (e1)=>{
                i.constantHeight = e1;
            }, nm.decodeMetricHeight).geometry((e1)=>{
                i.bounds = e1;
            }, Ze).success(), (e1, t1, i)=>e1.reset(t1).require(ld, (e1)=>{
                i.id = e1;
            }).require("elevation_idx", (e1)=>{
                i.idx = e1;
            }).require("extent", (e1)=>{
                i.extent = e1;
            }).require("height", (e1)=>{
                i.height = e1;
            }, nm.decodeMetricHeight).geometry((e1)=>{
                i.position = e1;
            }, nm.getPoint).success());
        class nm {
            static getPoint(e1) {
                return be(e1[0][0].x, e1[0][0].y);
            }
            static decodeRelativeHeight(e1) {
                return 1e-4 * e1 * 5;
            }
            static decodeMetricHeight(e1) {
                return 1e-4 * e1;
            }
            static getVersionSchema(e1) {
                return e1 ? "1.0.1" === e1 ? im : void 0 : tm;
            }
            static parse(e1) {
                const t1 = [], i = [], n = e1.length, r = new Q_;
                for(let o = 0; o < n; o++){
                    const n = e1.feature(o), a = n.properties.version, s = nm.getVersionSchema(a);
                    if (void 0 === s) {
                        mt(`Unknown elevation feature version number ${a || "(unknown)"}`);
                        continue;
                    }
                    const l = n.properties.type;
                    if (!l) continue;
                    const u = Mh.types[n.type];
                    if ("Point" === u && "curve_point" === l) {
                        const e1 = {};
                        s.parseVertex(r, n, e1) && t1.push(e1);
                    } else if ("Polygon" === u && "curve_meta" === l) {
                        const e1 = {};
                        s.parseFeature(r, n, e1) && i.push(e1);
                    }
                }
                return {
                    vertices: t1,
                    features: i
                };
            }
        }
        const rm = [
            ve(),
            ve(),
            ve(),
            ve(),
            ve(),
            ve(),
            ve()
        ], om = ve(), am = ve();
        function sm(e1) {
            return [
                e1[0],
                e1[1]
            ];
        }
        function lm(e1) {
            return be(e1[0], e1[1]);
        }
        class um {
            constructor(e1, t1, i = null){
                this.feature = e1, this.metersToTile = t1, this.sampler = i, this.index = 0;
            }
            get() {
                const e1 = this.feature.vertices[this.index], t1 = this.feature.vertexProps[this.index].dir, i = t1[1], n = -t1[0], r = (e1.extent + 1) * this.metersToTile, o = this.sampler ? this.sampler.pointTransform(e1.position) : e1.position;
                return [
                    new Pe(Math.trunc(o[0] + i * r), Math.trunc(o[1] + n * r)),
                    new Pe(Math.trunc(o[0] - i * r), Math.trunc(o[1] - n * r))
                ];
            }
            next() {
                this.index++;
            }
            valid() {
                return this.index < this.feature.vertices.length;
            }
        }
        class cm {
            constructor(e1, t1, i, n, r, o){
                if (this.vertices = new Array, this.vertexProps = new Array, this.edges = new Array, this.edgeProps = new Array, this.id = e1, this.heightRange = {
                    min: i,
                    max: i
                }, this.safeArea = t1, this.constantHeight = i, null == this.constantHeight && (null != this.constantHeight || 0 !== n.length)) {
                    this.vertices = n, this.edges = r;
                    for(let e1 = 0; e1 < this.vertices.length; e1++)this.vertices[e1].index = void 0 !== this.vertices[e1].index ? this.vertices[e1].index : e1;
                    this.edges = this.edges.filter((e1)=>{
                        var t1, i;
                        return e1.a < this.vertices.length && e1.b < this.vertices.length && !((t1 = this.vertices[e1.a].position)[0] === (i = this.vertices[e1.b].position)[0] && t1[1] === i[1]);
                    }), this.heightRange = {
                        min: Number.POSITIVE_INFINITY,
                        max: Number.NEGATIVE_INFINITY
                    };
                    for (const e1 of this.vertices)this.vertexProps.push({
                        dir: be(0, 0)
                    }), this.heightRange.min = Math.min(this.heightRange.min, e1.height), this.heightRange.max = Math.max(this.heightRange.max, e1.height);
                    for (const e1 of this.edges){
                        const t1 = this.vertices[e1.a].position, i = this.vertices[e1.b].position, n = Ae(ve(), i, t1), r = Te(n), o = Ie(ve(), n, 1 / r);
                        this.edgeProps.push({
                            vec: n,
                            dir: o,
                            len: r
                        });
                        const a = this.vertexProps[e1.a].dir, s = this.vertexProps[e1.b].dir;
                        Ee(a, a, o), Ee(s, s, o);
                    }
                    for (const e1 of this.vertexProps)0 === e1.dir[0] && 0 === e1.dir[1] || Me(e1.dir, e1.dir);
                    this.tessellate(o);
                }
            }
            pointElevation(e1) {
                if (null != this.constantHeight) return this.constantHeight;
                const t1 = this.getClosestEdge(e1);
                if (null == t1) return 0;
                const [i, n] = t1;
                return dn(this.vertices[this.edges[i].a].height, this.vertices[this.edges[i].b].height, n);
            }
            computeSlopeNormal(e1, t1) {
                const i = this.getClosestEdge(e1);
                if (!i) return C(0, 0, 1);
                const n = i[0], r = this.edges[n], o = this.edgeProps[n].vec, a = C(o[0], o[1], (this.vertices[r.b].height - this.vertices[r.a].height) * t1), s = C(a[1], -a[0], 0);
                q(s, s, a);
                const l = D(s);
                return l > 0 ? k(s, s, 1 / l) : F(s, 0, 0, 1);
            }
            getSafeArea() {
                return this.safeArea;
            }
            isTunnel() {
                return this.heightRange.max <= -5;
            }
            getClosestEdge(e1) {
                if (0 === this.edges.length) return;
                let t1 = 0, i = Number.POSITIVE_INFINITY, n = 0;
                const [r, o, a, s, l, u, c] = rm;
                we(c, e1.x, e1.y);
                const h = new mf(c, null);
                for(let e1 = 0; e1 < this.edges.length; e1++){
                    const d = this.edges[e1], f = this.edgeProps[e1].dir;
                    h.dir = f;
                    const p = this.vertices[d.a].position, _ = this.vertices[d.b].position, m = h.intersectsPlane(p, this.vertexProps[d.a].dir, r), g = h.intersectsPlane(_, this.vertexProps[d.b].dir, o);
                    if (!m || !g) continue;
                    Ae(a, o, r), Ae(s, c, r);
                    const y = Se(a, a), x = y > 0 ? Se(s, a) / y : 0, v = tt(x, 0, 1), b = Math.abs((x - v) * this.edgeProps[e1].len);
                    Ae(l, c, p), we(u, f[1], -f[0]);
                    const w = b + Math.abs(Se(l, u));
                    w < i && (t1 = e1, i = w, n = v);
                }
                return [
                    t1,
                    n
                ];
            }
            tessellate(e1) {
                const t1 = R(), i = R(), n = R(), r = R();
                for(let o = this.edges.length - 1; o >= 0; --o){
                    const a = this.edges[o].a, s = this.edges[o].b, { position: l, height: u, extent: c } = this.vertices[a], { position: h, height: d, extent: f } = this.vertices[s], p = this.vertexProps[a].dir, _ = this.vertexProps[s].dir;
                    if (F(t1, l[0] / e1, l[1] / e1, u), F(i, h[0] / e1, h[1] / e1, d), F(n, p[1], -p[0], 0), k(n, n, c), F(r, _[1], -_[0], 0), k(r, r, f), this.distSqLines(C(t1[0] + .5 * n[0], t1[1] + .5 * n[1], t1[2] + .5 * n[2]), C(i[0] - .5 * r[0], i[1] - .5 * r[1], i[2] - .5 * r[2]), C(t1[0] - .5 * n[0], t1[1] - .5 * n[1], t1[2] - .5 * n[2]), C(i[0] + .5 * r[0], i[1] + .5 * r[1], i[2] + .5 * r[2])) <= .0025000000000000005) continue;
                    const m = this.vertices.length, g = Ee(ve(), l, h);
                    this.vertices.push({
                        position: Ie(g, g, .5),
                        height: .5 * (u + d),
                        extent: .5 * (c + f),
                        index: .5 * ((void 0 !== this.vertices[a].index ? this.vertices[a].index : a) + (void 0 !== this.vertices[s].index ? this.vertices[s].index : s))
                    });
                    const y = Ee(ve(), p, _);
                    this.vertexProps.push({
                        dir: Me(y, y)
                    }), this.edges.splice(o, 1), this.edgeProps.splice(o, 1), this.edges.push({
                        a: a,
                        b: m
                    }), this.edges.push({
                        a: m,
                        b: s
                    });
                    const x = Ae(ve(), this.vertices[m].position, l), v = Te(x), b = {
                        vec: x,
                        dir: Ie(ve(), x, 1 / v),
                        len: v
                    };
                    this.edgeProps.push(b), this.edgeProps.push(b);
                }
            }
            distSqLines(e1, t1, i, n) {
                const r = L(R(), t1, e1), o = L(R(), n, i), a = L(R(), e1, i), s = W(r, r), l = W(r, o), u = W(r, a), c = W(o, o), h = W(o, a), d = s * c - l * l;
                if (0 === d) return j(X(r, i, n, W(a, o) / W(o, o)), e1);
                const f = (s * h - l * u) / d;
                return j(X(r, e1, t1, (l * h - u * c) / d), X(o, i, n, f));
            }
            static serialize(e1, t1) {
                const i = {
                    id: e1.id,
                    heightRange: {
                        min: e1.heightRange.min,
                        max: e1.heightRange.max
                    },
                    safeArea: (n = e1.safeArea, {
                        min: {
                            x: n.min.x,
                            y: n.min.y
                        },
                        max: {
                            x: n.max.x,
                            y: n.max.y
                        }
                    })
                };
                var n;
                return null != e1.constantHeight ? (i.constantHeight = e1.constantHeight, i) : 0 === e1.vertices.length ? (i.vertices = [], i.vertexProps = [], i.edges = [], i.edgeProps = [], i) : (i.vertices = e1.vertices.map((e1)=>({
                        position: sm(e1.position),
                        height: e1.height,
                        extent: e1.extent,
                        index: e1.index
                    })), i.vertexProps = e1.vertexProps.map((e1)=>({
                        dir: sm(e1.dir)
                    })), i.edges = e1.edges.map((e1)=>({
                        a: e1.a,
                        b: e1.b
                    })), i.edgeProps = e1.edgeProps.map((e1)=>({
                        vec: sm(e1.vec),
                        dir: sm(e1.dir),
                        len: e1.len
                    })), i);
            }
            static deserialize(e1) {
                const t1 = function(e1) {
                    return {
                        min: new Pe(e1.min.x, e1.min.y),
                        max: new Pe(e1.max.x, e1.max.y)
                    };
                }(e1.safeArea);
                if (null != e1.constantHeight) return new cm(e1.id, t1, e1.constantHeight);
                if (!e1.vertices || 0 === e1.vertices.length) {
                    const i = Object.create(cm.prototype);
                    return i.id = e1.id, i.constantHeight = void 0, i.heightRange = {
                        min: e1.heightRange.min,
                        max: e1.heightRange.max
                    }, i.safeArea = t1, i.vertices = [], i.vertexProps = [], i.edges = [], i.edgeProps = [], i;
                }
                const i = Object.create(cm.prototype);
                return i.id = e1.id, i.constantHeight = void 0, i.heightRange = {
                    min: e1.heightRange.min,
                    max: e1.heightRange.max
                }, i.safeArea = t1, i.vertices = e1.vertices.map((e1)=>({
                        position: lm(e1.position),
                        height: e1.height,
                        extent: e1.extent,
                        index: e1.index
                    })), i.vertexProps = (e1.vertexProps || []).map((e1)=>({
                        dir: lm(e1.dir)
                    })), i.edges = (e1.edges || []).map((e1)=>({
                        a: e1.a,
                        b: e1.b
                    })), i.edgeProps = (e1.edgeProps || []).map((e1)=>({
                        vec: lm(e1.vec),
                        dir: lm(e1.dir),
                        len: e1.len
                    })), i;
            }
        }
        class hm {
            constructor(e1, t1){
                this.zScale = 1, this.xOffset = 0, this.yOffset = 0, e1.equals(t1) || (this.zScale = Math.pow(2, t1.z - e1.z), this.xOffset = (e1.x * this.zScale - t1.x) * Sr, this.yOffset = (e1.y * this.zScale - t1.y) * Sr);
            }
            pointTransform(e1) {
                return be(e1[0] * this.zScale + this.xOffset, e1[1] * this.zScale + this.yOffset);
            }
            pointTransformInPlace(e1) {
                e1[0] = e1[0] * this.zScale + this.xOffset, e1[1] = e1[1] * this.zScale + this.yOffset;
            }
            constantElevation(e1, t1) {
                if (null != e1.constantHeight) return this.computeBiasedHeight(e1.constantHeight, t1);
            }
            pointElevation(e1, t1, i) {
                const n = this.constantElevation(t1, i);
                return null != n ? n : (e1.x = e1.x * this.zScale + this.xOffset, e1.y = e1.y * this.zScale + this.yOffset, this.computeBiasedHeight(t1.pointElevation(e1), i));
            }
            computeBiasedHeight(e1, t1) {
                return t1 <= 0 ? e1 : e1 + t1 * it(0, t1, e1 >= 0 ? e1 : Math.abs(.5 * e1));
            }
        }
        function dm(e1) {
            if (0 === e1) return [
                0,
                0,
                0
            ];
            const t1 = ua(e1);
            return [
                t1(),
                t1(),
                t1()
            ];
        }
        function fm(e1, t1) {
            let i = 0, n = e1.length - 1;
            for(; i <= n;){
                const r = i + n >> 1;
                e1[r].feature.id < t1 ? i = r + 1 : n = r - 1;
            }
            return i < e1.length && e1[i].feature.id === t1 ? i : -1;
        }
        function pm(e1, t1, i, n) {
            if (!e1.properties) return;
            const r = +e1.properties[ld];
            if (Number.isNaN(r)) return;
            if (t1) {
                const e1 = t1.find((e1)=>e1.id === r);
                if (e1 && n) return {
                    tileId: n,
                    feature: e1
                };
            }
            if (!i || 0 === i.length) return;
            const o = fm(i, r);
            if (!(o < 0)) {
                if (n) {
                    for(let e1 = o; e1 < i.length && i[e1].feature.id === r; e1++)if (i[e1].tileId.key === n.key) return i[e1];
                }
                return i[o];
            }
        }
        function _m(e1, t1) {
            return e1 > t1 ? 1 : e1 < t1 ? -1 : 0;
        }
        Ha(cm, "ElevationFeature");
        class mm {
            constructor(e1 = _m, t1 = !1){
                this._compare = e1, this._root = null, this._size = 0, this._noDuplicates = !!t1;
            }
            rotateLeft(e1) {
                var t1 = e1.right;
                t1 && (e1.right = t1.left, t1.left && (t1.left.parent = e1), t1.parent = e1.parent), e1.parent ? e1 === e1.parent.left ? e1.parent.left = t1 : e1.parent.right = t1 : this._root = t1, t1 && (t1.left = e1), e1.parent = t1;
            }
            rotateRight(e1) {
                var t1 = e1.left;
                t1 && (e1.left = t1.right, t1.right && (t1.right.parent = e1), t1.parent = e1.parent), e1.parent ? e1 === e1.parent.left ? e1.parent.left = t1 : e1.parent.right = t1 : this._root = t1, t1 && (t1.right = e1), e1.parent = t1;
            }
            _splay(e1) {
                for(; e1.parent;){
                    var t1 = e1.parent;
                    t1.parent ? t1.left === e1 && t1.parent.left === t1 ? (this.rotateRight(t1.parent), this.rotateRight(t1)) : t1.right === e1 && t1.parent.right === t1 ? (this.rotateLeft(t1.parent), this.rotateLeft(t1)) : t1.left === e1 && t1.parent.right === t1 ? (this.rotateRight(t1), this.rotateLeft(t1)) : (this.rotateLeft(t1), this.rotateRight(t1)) : t1.left === e1 ? this.rotateRight(t1) : this.rotateLeft(t1);
                }
            }
            splay(e1) {
                for(var t1, i, n, r, o; e1.parent;)(i = (t1 = e1.parent).parent) && i.parent ? ((n = i.parent).left === i ? n.left = e1 : n.right = e1, e1.parent = n) : (e1.parent = null, this._root = e1), r = e1.left, o = e1.right, e1 === t1.left ? (i && (i.left === t1 ? (t1.right ? (i.left = t1.right, i.left.parent = i) : i.left = null, t1.right = i, i.parent = t1) : (r ? (i.right = r, r.parent = i) : i.right = null, e1.left = i, i.parent = e1)), o ? (t1.left = o, o.parent = t1) : t1.left = null, e1.right = t1, t1.parent = e1) : (i && (i.right === t1 ? (t1.left ? (i.right = t1.left, i.right.parent = i) : i.right = null, t1.left = i, i.parent = t1) : (o ? (i.left = o, o.parent = i) : i.left = null, e1.right = i, i.parent = e1)), r ? (t1.right = r, r.parent = t1) : t1.right = null, e1.left = t1, t1.parent = e1);
            }
            replace(e1, t1) {
                e1.parent ? e1 === e1.parent.left ? e1.parent.left = t1 : e1.parent.right = t1 : this._root = t1, t1 && (t1.parent = e1.parent);
            }
            minNode(e1 = this._root) {
                if (e1) for(; e1.left;)e1 = e1.left;
                return e1;
            }
            maxNode(e1 = this._root) {
                if (e1) for(; e1.right;)e1 = e1.right;
                return e1;
            }
            insert(e1, t1) {
                var i = this._root, n = null, r = this._compare;
                if (this._noDuplicates) for(; i;){
                    if (n = i, 0 === r(i.key, e1)) return;
                    i = r(i.key, e1) < 0 ? i.right : i.left;
                }
                else for(; i;)n = i, i = r(i.key, e1) < 0 ? i.right : i.left;
                return i = {
                    key: e1,
                    data: t1,
                    left: null,
                    right: null,
                    parent: n
                }, n ? r(n.key, i.key) < 0 ? n.right = i : n.left = i : this._root = i, this.splay(i), this._size++, i;
            }
            find(e1) {
                for(var t1 = this._root, i = this._compare; t1;){
                    var n = i(t1.key, e1);
                    if (n < 0) t1 = t1.right;
                    else {
                        if (!(n > 0)) return t1;
                        t1 = t1.left;
                    }
                }
                return null;
            }
            contains(e1) {
                for(var t1 = this._root, i = this._compare; t1;){
                    var n = i(e1, t1.key);
                    if (0 === n) return !0;
                    t1 = n < 0 ? t1.left : t1.right;
                }
                return !1;
            }
            remove(e1) {
                var t1 = this.find(e1);
                if (!t1) return !1;
                if (this.splay(t1), t1.left) {
                    if (t1.right) {
                        var i = this.minNode(t1.right);
                        i.parent !== t1 && (this.replace(i, i.right), i.right = t1.right, i.right.parent = i), this.replace(t1, i), i.left = t1.left, i.left.parent = i;
                    } else this.replace(t1, t1.left);
                } else this.replace(t1, t1.right);
                return this._size--, !0;
            }
            removeNode(e1) {
                if (!e1) return !1;
                if (this.splay(e1), e1.left) {
                    if (e1.right) {
                        var t1 = this.minNode(e1.right);
                        t1.parent !== e1 && (this.replace(t1, t1.right), t1.right = e1.right, t1.right.parent = t1), this.replace(e1, t1), t1.left = e1.left, t1.left.parent = t1;
                    } else this.replace(e1, e1.left);
                } else this.replace(e1, e1.right);
                return this._size--, !0;
            }
            erase(e1) {
                var t1 = this.find(e1);
                if (t1) {
                    this.splay(t1);
                    var i = t1.left, n = t1.right, r = null;
                    i && (i.parent = null, r = this.maxNode(i), this.splay(r), this._root = r), n && (i ? r.right = n : this._root = n, n.parent = r), this._size--;
                }
            }
            pop() {
                var e1 = this._root, t1 = null;
                if (e1) {
                    for(; e1.left;)e1 = e1.left;
                    t1 = {
                        key: e1.key,
                        data: e1.data
                    }, this.remove(e1.key);
                }
                return t1;
            }
            next(e1) {
                var t1 = e1;
                if (t1) {
                    if (t1.right) for(t1 = t1.right; t1 && t1.left;)t1 = t1.left;
                    else for(t1 = e1.parent; t1 && t1.right === e1;)e1 = t1, t1 = t1.parent;
                }
                return t1;
            }
            prev(e1) {
                var t1 = e1;
                if (t1) {
                    if (t1.left) for(t1 = t1.left; t1 && t1.right;)t1 = t1.right;
                    else for(t1 = e1.parent; t1 && t1.left === e1;)e1 = t1, t1 = t1.parent;
                }
                return t1;
            }
            forEach(e1) {
                for(var t1 = this._root, i = [], n = !1, r = 0; !n;)t1 ? (i.push(t1), t1 = t1.left) : i.length > 0 ? (e1(t1 = i.pop(), r++), t1 = t1.right) : n = !0;
                return this;
            }
            range(e1, t1, i, n) {
                const r = [], o = this._compare;
                let a, s = this._root;
                for(; 0 !== r.length || s;)if (s) r.push(s), s = s.left;
                else {
                    if (s = r.pop(), a = o(s.key, t1), a > 0) break;
                    if (o(s.key, e1) >= 0 && i.call(n, s)) return this;
                    s = s.right;
                }
                return this;
            }
            keys() {
                for(var e1 = this._root, t1 = [], i = [], n = !1; !n;)e1 ? (t1.push(e1), e1 = e1.left) : t1.length > 0 ? (e1 = t1.pop(), i.push(e1.key), e1 = e1.right) : n = !0;
                return i;
            }
            values() {
                for(var e1 = this._root, t1 = [], i = [], n = !1; !n;)e1 ? (t1.push(e1), e1 = e1.left) : t1.length > 0 ? (e1 = t1.pop(), i.push(e1.data), e1 = e1.right) : n = !0;
                return i;
            }
            at(e1) {
                for(var t1 = this._root, i = [], n = !1, r = 0; !n;)if (t1) i.push(t1), t1 = t1.left;
                else if (i.length > 0) {
                    if (t1 = i.pop(), r === e1) return t1;
                    r++, t1 = t1.right;
                } else n = !0;
                return null;
            }
            load(e1 = [], t1 = [], i = !1) {
                if (0 !== this._size) throw new Error("bulk-load: tree is not empty");
                const n = e1.length;
                return i && ym(e1, t1, 0, n - 1, this._compare), this._root = gm(null, e1, t1, 0, n), this._size = n, this;
            }
            min() {
                var e1 = this.minNode(this._root);
                return e1 ? e1.key : null;
            }
            max() {
                var e1 = this.maxNode(this._root);
                return e1 ? e1.key : null;
            }
            isEmpty() {
                return null === this._root;
            }
            get size() {
                return this._size;
            }
            static createTree(e1, t1, i, n, r) {
                return new mm(i, r).load(e1, t1, n);
            }
        }
        function gm(e1, t1, i, n, r) {
            const o = r - n;
            if (o > 0) {
                const a = n + Math.floor(o / 2), s = {
                    key: t1[a],
                    data: i[a],
                    parent: e1
                };
                return s.left = gm(s, t1, i, n, a), s.right = gm(s, t1, i, a + 1, r), s;
            }
            return null;
        }
        function ym(e1, t1, i, n, r) {
            if (i >= n) return;
            const o = e1[i + n >> 1];
            let a = i - 1, s = n + 1;
            for(;;){
                do a++;
                while (r(e1[a], o) < 0);
                do s--;
                while (r(e1[s], o) > 0);
                if (a >= s) break;
                let i = e1[a];
                e1[a] = e1[s], e1[s] = i, i = t1[a], t1[a] = t1[s], t1[s] = i;
            }
            ym(e1, t1, i, s, r), ym(e1, t1, s + 1, n, r);
        }
        const xm = 11102230246251565e-32, vm = 134217729, bm = (3 + 8 * xm) * xm;
        function wm(e1, t1, i, n, r) {
            let o, a, s, l, u = t1[0], c = n[0], h = 0, d = 0;
            c > u == c > -u ? (o = u, u = t1[++h]) : (o = c, c = n[++d]);
            let f = 0;
            if (h < e1 && d < i) for(c > u == c > -u ? (a = u + o, s = o - (a - u), u = t1[++h]) : (a = c + o, s = o - (a - c), c = n[++d]), o = a, 0 !== s && (r[f++] = s); h < e1 && d < i;)c > u == c > -u ? (a = o + u, l = a - o, s = o - (a - l) + (u - l), u = t1[++h]) : (a = o + c, l = a - o, s = o - (a - l) + (c - l), c = n[++d]), o = a, 0 !== s && (r[f++] = s);
            for(; h < e1;)a = o + u, l = a - o, s = o - (a - l) + (u - l), u = t1[++h], o = a, 0 !== s && (r[f++] = s);
            for(; d < i;)a = o + c, l = a - o, s = o - (a - l) + (c - l), c = n[++d], o = a, 0 !== s && (r[f++] = s);
            return 0 === o && 0 !== f || (r[f++] = o), f;
        }
        function Em(e1) {
            return new Float64Array(e1);
        }
        const Am = Em(4), Im = Em(8), Tm = Em(12), Mm = Em(16), Sm = Em(4);
        function zm(e1, t1, i) {
            null === t1 ? (e1.inOut = !1, e1.otherInOut = !0) : (e1.isSubject === t1.isSubject ? (e1.inOut = !t1.inOut, e1.otherInOut = t1.otherInOut) : (e1.inOut = !t1.otherInOut, e1.otherInOut = t1.isVertical() ? !t1.inOut : t1.inOut), t1 && (e1.prevInResult = !Rm(t1, i) || t1.isVertical() ? t1.prevInResult : t1)), e1.resultTransition = Rm(e1, i) ? function(e1, t1) {
                let i, n = !e1.inOut, r = !e1.otherInOut;
                switch(t1){
                    case 0:
                        i = n && r;
                        break;
                    case 1:
                        i = n || r;
                        break;
                    case 3:
                        i = n !== r;
                        break;
                    case 2:
                        i = e1.isSubject ? n && !r : r && !n;
                }
                return i ? 1 : -1;
            }(e1, i) : 0;
        }
        function Rm(e1, t1) {
            switch(e1.type){
                case 0:
                    switch(t1){
                        case 0:
                            return !e1.otherInOut;
                        case 1:
                            return e1.otherInOut;
                        case 2:
                            return e1.isSubject && e1.otherInOut || !e1.isSubject && !e1.otherInOut;
                        case 3:
                            return !0;
                    }
                    break;
                case 2:
                    return 0 === t1 || 1 === t1;
                case 3:
                    return 2 === t1;
                case 1:
                    return !1;
            }
            return !1;
        }
        class Pm {
            constructor(e1, t1, i, n, r){
                this.left = t1, this.point = e1, this.otherEvent = i, this.isSubject = n ?? !1, this.type = r || 0, this.inOut = !1, this.otherInOut = !1, this.prevInResult = null, this.resultTransition = 0, this.otherPos = -1, this.outputContourId = -1, this.isExteriorRing = !0;
            }
            isBelow(e1) {
                const t1 = this.point, i = this.otherEvent.point;
                return this.left ? (t1[0] - e1[0]) * (i[1] - e1[1]) - (i[0] - e1[0]) * (t1[1] - e1[1]) > 0 : (i[0] - e1[0]) * (t1[1] - e1[1]) - (t1[0] - e1[0]) * (i[1] - e1[1]) > 0;
            }
            isAbove(e1) {
                return !this.isBelow(e1);
            }
            isVertical() {
                return this.point[0] === this.otherEvent.point[0];
            }
            get inResult() {
                return 0 !== this.resultTransition;
            }
            clone() {
                const e1 = new Pm(this.point, this.left, this.otherEvent, this.isSubject, this.type);
                return e1.contourId = this.contourId, e1.resultTransition = this.resultTransition, e1.prevInResult = this.prevInResult, e1.isExteriorRing = this.isExteriorRing, e1.inOut = this.inOut, e1.otherInOut = this.otherInOut, e1;
            }
        }
        function Dm(e1, t1) {
            return e1[0] === t1[0] && e1[1] === t1[1];
        }
        function Cm(e1, t1, i) {
            const n = function(e1, t1, i, n, r, o) {
                const a = (t1 - o) * (i - r), s = (e1 - r) * (n - o), l = a - s;
                if (0 === a || 0 === s || a > 0 != s > 0) return l;
                const u = Math.abs(a + s);
                return Math.abs(l) >= 33306690738754716e-32 * u ? l : -function(e1, t1, i, n, r, o, a) {
                    let s, l, u, c, h, d, f, p, _, m, g, y, x, v, b, w, E, A;
                    const I = e1 - r, T = i - r, M = t1 - o, S = n - o;
                    v = I * S, d = vm * I, f = d - (d - I), p = I - f, d = vm * S, _ = d - (d - S), m = S - _, b = p * m - (v - f * _ - p * _ - f * m), w = M * T, d = vm * M, f = d - (d - M), p = M - f, d = vm * T, _ = d - (d - T), m = T - _, E = p * m - (w - f * _ - p * _ - f * m), g = b - E, h = b - g, Am[0] = b - (g + h) + (h - E), y = v + g, h = y - v, x = v - (y - h) + (g - h), g = x - w, h = x - g, Am[1] = x - (g + h) + (h - w), A = y + g, h = A - y, Am[2] = y - (A - h) + (g - h), Am[3] = A;
                    let z = function(e1, t1) {
                        let i = t1[0];
                        for(let e1 = 1; e1 < 4; e1++)i += t1[e1];
                        return i;
                    }(0, Am), R = 22204460492503146e-32 * a;
                    if (z >= R || -z >= R) return z;
                    if (h = e1 - I, s = e1 - (I + h) + (h - r), h = i - T, u = i - (T + h) + (h - r), h = t1 - M, l = t1 - (M + h) + (h - o), h = n - S, c = n - (S + h) + (h - o), 0 === s && 0 === l && 0 === u && 0 === c) return z;
                    if (R = 11093356479670487e-47 * a + bm * Math.abs(z), z += I * c + S * s - (M * u + T * l), z >= R || -z >= R) return z;
                    v = s * S, d = vm * s, f = d - (d - s), p = s - f, d = vm * S, _ = d - (d - S), m = S - _, b = p * m - (v - f * _ - p * _ - f * m), w = l * T, d = vm * l, f = d - (d - l), p = l - f, d = vm * T, _ = d - (d - T), m = T - _, E = p * m - (w - f * _ - p * _ - f * m), g = b - E, h = b - g, Sm[0] = b - (g + h) + (h - E), y = v + g, h = y - v, x = v - (y - h) + (g - h), g = x - w, h = x - g, Sm[1] = x - (g + h) + (h - w), A = y + g, h = A - y, Sm[2] = y - (A - h) + (g - h), Sm[3] = A;
                    const P = wm(4, Am, 4, Sm, Im);
                    v = I * c, d = vm * I, f = d - (d - I), p = I - f, d = vm * c, _ = d - (d - c), m = c - _, b = p * m - (v - f * _ - p * _ - f * m), w = M * u, d = vm * M, f = d - (d - M), p = M - f, d = vm * u, _ = d - (d - u), m = u - _, E = p * m - (w - f * _ - p * _ - f * m), g = b - E, h = b - g, Sm[0] = b - (g + h) + (h - E), y = v + g, h = y - v, x = v - (y - h) + (g - h), g = x - w, h = x - g, Sm[1] = x - (g + h) + (h - w), A = y + g, h = A - y, Sm[2] = y - (A - h) + (g - h), Sm[3] = A;
                    const D = wm(P, Im, 4, Sm, Tm);
                    v = s * c, d = vm * s, f = d - (d - s), p = s - f, d = vm * c, _ = d - (d - c), m = c - _, b = p * m - (v - f * _ - p * _ - f * m), w = l * u, d = vm * l, f = d - (d - l), p = l - f, d = vm * u, _ = d - (d - u), m = u - _, E = p * m - (w - f * _ - p * _ - f * m), g = b - E, h = b - g, Sm[0] = b - (g + h) + (h - E), y = v + g, h = y - v, x = v - (y - h) + (g - h), g = x - w, h = x - g, Sm[1] = x - (g + h) + (h - w), A = y + g, h = A - y, Sm[2] = y - (A - h) + (g - h), Sm[3] = A;
                    const C = wm(D, Tm, 4, Sm, Mm);
                    return Mm[C - 1];
                }(e1, t1, i, n, r, o, u);
            }(e1[0], e1[1], t1[0], t1[1], i[0], i[1]);
            return n > 0 ? -1 : n < 0 ? 1 : 0;
        }
        function Fm(e1, t1) {
            const i = e1.point, n = t1.point;
            return i[0] > n[0] ? 1 : i[0] < n[0] ? -1 : i[1] !== n[1] ? i[1] > n[1] ? 1 : -1 : function(e1, t1, i) {
                return e1.left !== t1.left ? e1.left ? 1 : -1 : 0 !== Cm(i, e1.otherEvent.point, t1.otherEvent.point) ? e1.isBelow(t1.otherEvent.point) ? -1 : 1 : !e1.isSubject && t1.isSubject ? 1 : -1;
            }(e1, t1, i);
        }
        function Om(e1, t1, i) {
            const n = new Pm(t1, !1, e1, e1.isSubject), r = new Pm(t1, !0, e1.otherEvent, e1.isSubject);
            return Dm(e1.point, e1.otherEvent.point) && console.warn("what is that, a collapsed segment?", e1), n.contourId = r.contourId = e1.contourId, Fm(r, e1.otherEvent) > 0 && (e1.otherEvent.left = !0, r.left = !1), e1.otherEvent.otherEvent = r, e1.otherEvent = n, i.push(r), i.push(n), i;
        }
        function Lm(e1, t1) {
            return e1[0] * t1[1] - e1[1] * t1[0];
        }
        function Bm(e1, t1) {
            return e1[0] * t1[0] + e1[1] * t1[1];
        }
        function Nm(e1, t1, i) {
            const n = function(e1, t1, i, n) {
                const r = [
                    t1[0] - e1[0],
                    t1[1] - e1[1]
                ], o = [
                    n[0] - i[0],
                    n[1] - i[1]
                ];
                function a(e1, t1, i) {
                    return [
                        e1[0] + t1 * i[0],
                        e1[1] + t1 * i[1]
                    ];
                }
                const s = [
                    i[0] - e1[0],
                    i[1] - e1[1]
                ];
                let l = Lm(r, o), u = l * l;
                const c = Bm(r, r);
                if (u > 0) {
                    const t1 = Lm(s, o) / l;
                    if (t1 < 0 || t1 > 1) return null;
                    const n = Lm(s, r) / l;
                    return n < 0 || n > 1 ? null : 0 === t1 || 1 === t1 ? [
                        a(e1, t1, r)
                    ] : 0 === n || 1 === n ? [
                        a(i, n, o)
                    ] : [
                        a(e1, t1, r)
                    ];
                }
                if (l = Lm(s, r), u = l * l, u > 0) return null;
                const h = Bm(r, s) / c, d = h + Bm(r, o) / c, f = Math.min(h, d), p = Math.max(h, d);
                return f <= 1 && p >= 0 ? 1 === f ? [
                    a(e1, f > 0 ? f : 0, r)
                ] : 0 === p ? [
                    a(e1, p < 1 ? p : 1, r)
                ] : [
                    a(e1, f > 0 ? f : 0, r),
                    a(e1, p < 1 ? p : 1, r)
                ] : null;
            }(e1.point, e1.otherEvent.point, t1.point, t1.otherEvent.point), r = n ? n.length : 0;
            if (0 === r || 1 === r && (Dm(e1.point, t1.point) || Dm(e1.otherEvent.point, t1.otherEvent.point)) || 2 === r && e1.isSubject === t1.isSubject) return 0;
            if (1 === r) return !Dm(e1.point, n[0]) && !Dm(e1.otherEvent.point, n[0]) && Om(e1, n[0], i), !Dm(t1.point, n[0]) && !Dm(t1.otherEvent.point, n[0]) && Om(t1, n[0], i), 1;
            const o = [];
            let a = !1, s = !1;
            return Dm(e1.point, t1.point) ? a = !0 : 1 === Fm(e1, t1) ? o.push(t1, e1) : o.push(e1, t1), Dm(e1.otherEvent.point, t1.otherEvent.point) ? s = !0 : 1 === Fm(e1.otherEvent, t1.otherEvent) ? o.push(t1.otherEvent, e1.otherEvent) : o.push(e1.otherEvent, t1.otherEvent), a && s || a ? (t1.type = 1, e1.type = t1.inOut === e1.inOut ? 2 : 3, a && !s && Om(o[1].otherEvent, o[0].point, i), 2) : s ? (Om(o[0], o[1].point, i), 3) : o[0] !== o[3].otherEvent ? (Om(o[0], o[1].point, i), Om(o[1], o[2].point, i), 3) : (Om(o[0], o[1].point, i), Om(o[3].otherEvent, o[2].point, i), 3);
        }
        function Vm(e1, t1) {
            if (e1 === t1) return 0;
            if (0 !== Cm(e1.point, e1.otherEvent.point, t1.point) || 0 !== Cm(e1.point, e1.otherEvent.point, t1.otherEvent.point)) return Dm(e1.point, t1.point) ? e1.isBelow(t1.otherEvent.point) ? -1 : 1 : e1.point[0] === t1.point[0] ? e1.point[1] < t1.point[1] ? -1 : 1 : 1 === Fm(e1, t1) ? t1.isAbove(e1.point) ? -1 : 1 : e1.isBelow(t1.point) ? -1 : 1;
            if (e1.isSubject !== t1.isSubject) return e1.isSubject ? -1 : 1;
            {
                let i = e1.point, n = t1.point;
                if (i[0] === n[0] && i[1] === n[1]) return i = e1.otherEvent.point, n = t1.otherEvent.point, i[0] === n[0] && i[1] === n[1] ? 0 : (e1.contourId ?? 0) > (t1.contourId ?? 0) ? 1 : -1;
            }
            return 1 === Fm(e1, t1) ? 1 : -1;
        }
        class km {
            constructor(){
                this.points = [], this.holeIds = [], this.holeOf = null, this.depth = null;
            }
            isExterior() {
                return null == this.holeOf;
            }
        }
        function Um(e1, t1, i, n) {
            let r, o = e1 + 1, a = t1[e1].point;
            const s = t1.length;
            for(o < s && (r = t1[o].point); o < s && r[0] === a[0] && r[1] === a[1];){
                if (!i[o]) return o;
                o++, o < s && (r = t1[o].point);
            }
            for(o = e1 - 1; i[o] && o > n;)o--;
            return o;
        }
        function Gm(e1, t1, i) {
            const n = new km;
            if (null != e1.prevInResult) {
                const r = e1.prevInResult, o = r.outputContourId;
                if (r.resultTransition > 0) {
                    const e1 = t1[o];
                    if (null != e1.holeOf) {
                        const r = e1.holeOf;
                        t1[r].holeIds.push(i), n.holeOf = r, n.depth = t1[o].depth;
                    } else t1[o].holeIds.push(i), n.holeOf = o, n.depth = t1[o].depth + 1;
                } else n.holeOf = null, n.depth = t1[o].depth;
            } else n.holeOf = null, n.depth = 0;
            return n;
        }
        const jm = Math.max, Hm = Math.min;
        let $m = 0;
        function Zm(e1, t1, i, n, r, o) {
            let a, s, l, u, c, h;
            for(a = 0, s = e1.length - 1; a < s; a++){
                if (l = e1[a], u = e1[a + 1], c = new Pm(l, !1, void 0, t1), h = new Pm(u, !1, c, t1), c.otherEvent = h, l[0] === u[0] && l[1] === u[1]) continue;
                c.contourId = h.contourId = i, o || (c.isExteriorRing = !1, h.isExteriorRing = !1), Fm(c, h) > 0 ? h.left = !0 : c.left = !0;
                const s = l[0], d = l[1];
                r[0] = Hm(r[0], s), r[1] = Hm(r[1], d), r[2] = jm(r[2], s), r[3] = jm(r[3], d), n.push(c), n.push(h);
            }
        }
        const Wm = [];
        function qm(e1, t1, i) {
            let n = e1, r = t1;
            "number" == typeof e1[0][0][0] && (n = [
                e1
            ]), "number" == typeof t1[0][0][0] && (r = [
                t1
            ]);
            let o = function(e1, t1, i) {
                let n = null;
                return e1.length * t1.length === 0 && (0 === i ? n = Wm : 2 === i ? n = e1 : (1 === i || 3 === i) && (n = 0 === e1.length ? t1 : e1)), n;
            }(n, r, i);
            if (o) return o === Wm ? null : o;
            const a = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ], s = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ], l = function(e1, t1, i, n, r) {
                const o = new Mr(void 0, Fm);
                let a, s, l, u, c, h;
                for(l = 0, u = e1.length; l < u; l++)for(a = e1[l], c = 0, h = a.length; c < h; c++)s = 0 === c, s && $m++, Zm(a[c], !0, $m, o, i, s);
                for(l = 0, u = t1.length; l < u; l++)for(a = t1[l], c = 0, h = a.length; c < h; c++)s = 0 === c, 2 === r && (s = !1), s && $m++, Zm(a[c], !1, $m, o, n, s);
                return o;
            }(n, r, a, s, i);
            if (o = function(e1, t1, i, n, r) {
                let o = null;
                return (i[0] > n[2] || n[0] > i[2] || i[1] > n[3] || n[1] > i[3]) && (0 === r ? o = Wm : 2 === r ? o = e1 : (1 === r || 3 === r) && (o = e1.concat(t1))), o;
            }(n, r, a, s, i), o) return o === Wm ? null : o;
            const u = function(e1, t1, i, n, r, o) {
                const a = new mm(Vm), s = [], l = Math.min(n[2], r[2]);
                let u, c, h;
                for(; 0 !== e1.length;){
                    let t1 = e1.pop();
                    if (s.push(t1), 0 === o && t1.point[0] > l || 2 === o && t1.point[0] > n[2]) break;
                    if (t1.left) {
                        c = u = a.insert(t1), h = a.minNode(), u = u !== h ? a.prev(u) : null, c = a.next(c);
                        const i = u ? u.key : null;
                        let n;
                        if (zm(t1, i, o), c && 2 === Nm(t1, c.key, e1) && (zm(t1, i, o), zm(c.key, t1, o)), u && 2 === Nm(u.key, t1, e1)) {
                            let e1 = u;
                            e1 = e1 !== h ? a.prev(e1) : null, n = e1 ? e1.key : null, zm(i, n, o), zm(t1, i, o);
                        }
                    } else t1 = t1.otherEvent, c = u = a.find(t1), u && c && (u = u !== h ? a.prev(u) : null, c = a.next(c), a.remove(t1), c && u && Nm(u.key, c.key, e1));
                }
                return s;
            }(l, 0, 0, a, s, i), c = function(e1) {
                let t1, i;
                const n = function(e1) {
                    let t1, i, n, r, o;
                    const a = [];
                    for(i = 0, n = e1.length; i < n; i++)t1 = e1[i], (t1.left && t1.inResult || !t1.left && t1.otherEvent.inResult) && a.push(t1);
                    let s = !1;
                    for(; !s;)for(s = !0, i = 0, n = a.length; i < n; i++)i + 1 < n && 1 === Fm(a[i], a[i + 1]) && (r = a[i], a[i] = a[i + 1], a[i + 1] = r, s = !1);
                    for(i = 0, n = a.length; i < n; i++)t1 = a[i], t1.otherPos = i;
                    for(i = 0, n = a.length; i < n; i++)t1 = a[i], t1.left || (o = t1.otherPos, t1.otherPos = t1.otherEvent.otherPos, t1.otherEvent.otherPos = o);
                    return a;
                }(e1), r = {}, o = [];
                for(t1 = 0, i = n.length; t1 < i; t1++){
                    if (r[t1]) continue;
                    const e1 = o.length, i = Gm(n[t1], o, e1), a = (t1)=>{
                        r[t1] = !0, t1 < n.length && n[t1] && (n[t1].outputContourId = e1);
                    };
                    let s = t1, l = t1;
                    for(i.points.push(n[t1].point); a(s), s = n[s].otherPos, a(s), i.points.push(n[s].point), s = Um(s, n, r, l), !(s == l || s >= n.length) && n[s];);
                    o.push(i);
                }
                return o;
            }(u), h = [];
            for(let e1 = 0; e1 < c.length; e1++){
                let t1 = c[e1];
                if (t1.isExterior()) {
                    let e1 = [
                        t1.points
                    ];
                    for(let i = 0; i < t1.holeIds.length; i++)e1.push(c[t1.holeIds[i]].points);
                    h.push(e1);
                }
            }
            return h;
        }
        function Xm(e1, t1) {
            const i = qm(Jm(e1), Jm([
                t1
            ]), 0);
            return null == i ? [] : eg(i);
        }
        function Ym(e1, t1, i = 0) {
            const n = 65536;
            let r = Jm(e1, n);
            const o = [];
            for(; t1.valid(); t1.next()){
                const [e1, r] = t1.get();
                let a = e1.x * n, s = e1.y * n, l = r.x * n, u = r.y * n;
                const c = l - a, h = u - s, d = Math.hypot(c, h);
                if (0 === d) continue;
                a -= c * i, s -= h * i, l += c * i, u += h * i;
                const f = Math.trunc(h / d * 3), p = -Math.trunc(c / d * 3);
                o.push([
                    [
                        [
                            a,
                            s
                        ],
                        [
                            l,
                            u
                        ],
                        [
                            l + f,
                            u + p
                        ],
                        [
                            a + f,
                            s + p
                        ],
                        [
                            a,
                            s
                        ]
                    ]
                ]);
            }
            return o.length > 0 && (r = qm(r, o, 2)), eg(r, 1 / n, .001);
        }
        function Jm(e1, t1 = 1) {
            return [
                e1.map((e1)=>e1.map((e1)=>[
                            e1.x * t1,
                            e1.y * t1
                        ]))
            ];
        }
        function Km(e1, t1) {
            const i = Math.floor(e1) + .5;
            return Math.abs(e1 - i) <= t1 ? Math.round(i) : Math.round(e1);
        }
        class Qm {
            constructor(e1){
                this.xs = [], this.ys = [], this.ixs = [], this.iys = [], this.buckets = new Map, this.tolerance = e1;
            }
            canonicalize(e1, t1) {
                const i = this.tolerance, n = Math.floor(e1 / i), r = Math.floor(t1 / i);
                for(let o = -1; o <= 1; o++){
                    const a = this.buckets.get(n + o);
                    if (a) for(let o = -1; o <= 1; o++){
                        const s = a.get(r + o);
                        if (s) {
                            for (const o of s)if (Math.abs(this.xs[o] - e1) <= i && Math.abs(this.ys[o] - t1) <= i) {
                                const i = this.ixs[o], a = this.iys[o];
                                return this.xs[o] === e1 && this.ys[o] === t1 || this.store(e1, t1, i, a, n, r), [
                                    i,
                                    a
                                ];
                            }
                        }
                    }
                }
                const o = Km(e1, i), a = Km(t1, i);
                return this.store(e1, t1, o, a, n, r), [
                    o,
                    a
                ];
            }
            store(e1, t1, i, n, r, o) {
                const a = this.xs.length;
                this.xs.push(e1), this.ys.push(t1), this.ixs.push(i), this.iys.push(n);
                let s = this.buckets.get(r);
                s || (s = new Map, this.buckets.set(r, s));
                let l = s.get(o);
                l || (l = [], s.set(o, l)), l.push(a);
            }
        }
        function eg(e1, t1 = 1, i) {
            const n = null != i ? new Qm(i) : null;
            return e1.map((e1)=>e1.map((e1, i)=>{
                    const r = e1.map((e1)=>{
                        const i = e1[0] * t1, r = e1[1] * t1;
                        if (n) {
                            const [e1, t1] = n.canonicalize(i, r);
                            return new Pe(e1, t1);
                        }
                        return new Pe(Math.round(i), Math.round(r));
                    });
                    return i > 0 && r.reverse(), r;
                }));
        }
        class tg {
            constructor(){
                this.frcCoverage = new Set, this.featureTriSegments = [], this.frcPerLevel = new Map, this.frcNonRoadSegments = new Bc;
            }
            empty() {
                return 0 === this.frcCoverage.size;
            }
        }
        function ig(e1, t1, i) {
            if (0 === e1.frcCoverage.size || 0 === e1.featureTriSegments.length) return;
            const n = i.get(), r = t1.uint16, o = [];
            e1.featureTriSegments.sort((e1, t1)=>e1.segIdx !== t1.segIdx ? e1.segIdx - t1.segIdx : null === e1.frc && null === t1.frc ? 0 : null === e1.frc ? -1 : null === t1.frc ? 1 : t1.frc - e1.frc);
            const a = new Map;
            let s = 0, l = e1.featureTriSegments[0].frc, u = {
                vertexOffset: n[s].vertexOffset,
                primitiveOffset: 0,
                vertexLength: n[s].vertexLength,
                primitiveLength: 0,
                vaos: {},
                sortKey: void 0
            };
            const c = ()=>{
                u.primitiveLength > 0 && (a.has(l) || a.set(l, []), a.get(l).push({
                    ...u
                }));
            };
            for (const t1 of e1.featureTriSegments){
                t1.segIdx !== s && (c(), s = t1.segIdx, l = t1.frc, u = {
                    vertexOffset: n[s].vertexOffset,
                    primitiveOffset: o.length / 3,
                    vertexLength: n[s].vertexLength,
                    primitiveLength: 0,
                    vaos: {},
                    sortKey: void 0
                }), t1.frc !== l && (c(), l = t1.frc, u = {
                    ...u,
                    primitiveOffset: o.length / 3,
                    primitiveLength: 0
                });
                for(let e1 = t1.start; e1 < t1.end; e1++)o.push(r[e1]);
                u.primitiveLength += (t1.end - t1.start) / 3;
            }
            c();
            for(let e1 = 0; e1 < o.length; e1++)r[e1] = o[e1];
            for (const [t1, i] of a)null !== t1 ? e1.frcPerLevel.set(t1, new Bc(i)) : e1.frcNonRoadSegments = new Bc(i);
            e1.featureTriSegments = [];
        }
        Ha(tg, "FrcSegmentData");
        const ng = {
            motorway: 0,
            motorway_link: 0,
            trunk: 1,
            trunk_link: 1,
            primary: 2,
            primary_link: 2,
            secondary: 3,
            secondary_link: 3,
            tertiary: 4,
            tertiary_link: 4,
            unclassified: 5,
            unclassified_link: 5,
            street: 6,
            street_limited: 6,
            residential: 6,
            service: 7,
            living_street: 7,
            pedestrian: 8,
            track: 8,
            path: 8,
            footway: 8,
            cycleway: 8,
            sidewalk: 8,
            crossing: 8
        };
        function rg(e1) {
            for (const t1 of [
                "class",
                "incident_class"
            ]){
                const i = e1[t1];
                if ("string" != typeof i) continue;
                const n = ng[i];
                if (void 0 !== n) return n;
            }
            return null;
        }
        function og(e1, t1, i) {
            for (const n of e1)if (n.startsWith("(")) {
                const e1 = n.indexOf(")");
                if (-1 === e1) continue;
                if (n.slice(1, e1) === t1 && n.slice(e1 + 1) === i) return !0;
            } else if (n === i) return !0;
            return !1;
        }
        class ag {
            constructor(e1, t1, i){
                this.elevationMode = t1, t1 && (this.elevationBufferData = new X_(e1.layers, e1.zoom, e1.lut)), i && (this.frcData = new tg);
            }
            isEmpty() {
                const e1 = !this.elevationBufferData || this.elevationBufferData.isEmpty(), t1 = !this.frcData || this.frcData.empty();
                return e1 && t1;
            }
            needsUpload() {
                return !!this.elevationBufferData && this.elevationBufferData.needsUpload();
            }
            trackFeatureFrc(e1) {
                if (!this.frcData) return null;
                const t1 = rg(e1 || {});
                return null !== t1 && this.frcData.frcCoverage.add(t1), t1;
            }
            recordFeatureRange(e1, t1, i, n) {
                if (!this.frcData || i <= t1) return;
                const r = e1.bufferData.triangleSegments.get();
                this.frcData.featureTriSegments.push({
                    start: 3 * t1,
                    end: 3 * i,
                    segIdx: r.length > 0 ? r.length - 1 : 0,
                    frc: n
                });
            }
            buildFrcSegments(e1) {
                this.frcData && !this.frcData.empty() && ig(this.frcData, e1.bufferData.indexArray, e1.bufferData.triangleSegments);
            }
            handleFeature(e1, t1, i, n, r, o) {
                const a = new Array;
                if (!this.elevationMode) return !1;
                const s = pm(e1, r, void 0, n);
                if (!s) return !1;
                {
                    const e1 = this.clipPolygonsToTile(t1, 1);
                    e1.length > 0 && a.push({
                        polygons: e1,
                        elevationFeature: s.feature,
                        elevationTileID: s.tileId
                    });
                }
                const l = {
                    guardRailEnabled: o.layers[0].layout.get("fill-construct-bridge-guard-rail").evaluate(e1, {}, n),
                    featureIndex: i
                };
                for (const t1 of a)if (t1.elevationFeature) {
                    if ("hd-road-base" === this.elevationMode) {
                        this.elevatedStructures || (this.elevatedStructures = new K_(t1.elevationTileID, o.layers, o.zoom, o.lut));
                        const i = t1.elevationFeature.isTunnel();
                        let n = 0;
                        Object.hasOwn(e1.properties, ud) && (n = +e1.properties[ud]), this.elevatedStructures.addPortalCandidates(t1.elevationFeature.id, t1.polygons, i, t1.elevationFeature, n);
                    }
                    null == t1.elevationFeature.constantHeight && (t1.polygons = this.prepareElevatedPolygons(t1.polygons, t1.elevationFeature, t1.elevationTileID));
                    const r = new hm(n, t1.elevationTileID);
                    this.addElevatedGeometry(o, t1.polygons, r, t1.elevationFeature, "hd-road-base" === this.elevationMode ? 0 : .05, i, l);
                }
                return !0;
            }
            populatePaintArrays(e1, t1, i, n, r, o, a) {
                this.elevationBufferData && this.elevationBufferData.populatePaintArrays(e1, t1, i, n, r, o, a);
            }
            update(e1, t1, i, n, r, o, a, s) {
                this.elevationBufferData && this.elevationBufferData.update(e1, t1, i, n, r, o, a, s), this.elevatedStructures && this.elevatedStructures.update(e1, t1, i, n, r, o, a, s);
            }
            updateExpressions(e1) {
                this.elevationBufferData && this.elevationBufferData.programConfigurations.updateExpressions(e1), this.elevatedStructures && (this.elevatedStructures.bridgeProgramConfigurations.updateExpressions(e1), this.elevatedStructures.tunnelProgramConfigurations.updateExpressions(e1));
            }
            upload(e1) {
                this.elevationBufferData && this.elevationBufferData.upload(e1), this.elevatedStructures && this.elevatedStructures.upload(e1);
            }
            destroy() {
                this.elevationBufferData && this.elevationBufferData.destroy(), this.elevatedStructures && this.elevatedStructures.destroy();
            }
            getUnevaluatedPortalGraph() {
                return this.elevatedStructures ? this.elevatedStructures.unevaluatedPortals : void 0;
            }
            setEvaluatedPortalGraph(e1, t1, i, n, r, o) {
                this.elevatedStructures && (this.elevatedStructures.construct(e1), this.elevatedStructures.populatePaintArrays(t1, i, n, r, o));
            }
            addElevatedGeometry(e1, t1, i, n, r, o, a) {
                const s = {
                    elevation: n,
                    elevationSampler: i,
                    bias: r,
                    index: o,
                    featureInfo: a
                }, [l, u] = e1.addGeometry(t1, this.elevationBufferData, s, this.elevatedStructures);
                null == this.elevationBufferData.heightRange ? this.elevationBufferData.heightRange = {
                    min: l,
                    max: u
                } : (this.elevationBufferData.heightRange.min = Math.min(this.elevationBufferData.heightRange.min, l), this.elevationBufferData.heightRange.max = Math.max(this.elevationBufferData.heightRange.max, u));
            }
            prepareElevatedPolygons(e1, t1, i) {
                const n = 1 / vu(i), r = [];
                for (const i of e1){
                    const e1 = Ym(i, new um(t1, n), .1);
                    r.push(...e1);
                }
                return r;
            }
            clipPolygonsToTile(e1, t1) {
                const i = -t1, n = -t1, r = Sr + t1, o = Sr + t1;
                let a = 0;
                const s = [], l = [];
                for(; a < e1.length; a++){
                    const t1 = e1[a], u = Ze(t1);
                    (u.min.x >= i && u.max.x <= r && u.min.y >= n && u.max.y <= o ? s : l).push(t1);
                }
                if (s.length === e1.length) return e1;
                const u = [
                    new Pe(i, n),
                    new Pe(r, n),
                    new Pe(r, o),
                    new Pe(i, o),
                    new Pe(i, n)
                ], c = s;
                for (const e1 of l)c.push(...Xm(e1, u));
                return c;
            }
        }
        function sg(e1, t1) {
            return e1.nextPoint.sub(t1.at(-2)).unit();
        }
        function lg(e1, t1) {
            return t1[1].sub(e1.prevPoint).unit();
        }
        Ha(ag, "FillHDExtension"), Ha(K_, "ElevatedStructures");
        class ug {
            constructor(e1, t1){
                this.elevationEnabled = e1, this.hasDeferredElevationFeatures = !1, t1 && (this.frcData = new tg);
            }
            isEmpty() {
                const e1 = !this.elevationEnabled || void 0 === this.heightRange, t1 = !this.frcData || this.frcData.empty();
                return e1 && t1;
            }
            trackFeatureFrc(e1) {
                if (!this.frcData) return null;
                const t1 = rg(e1 || {});
                return null !== t1 && this.frcData.frcCoverage.add(t1), t1;
            }
            recordFeatureRange(e1, t1, i, n) {
                if (!this.frcData || i <= t1) return;
                const r = e1.segments.get();
                this.frcData.featureTriSegments.push({
                    start: 3 * t1,
                    end: 3 * i,
                    segIdx: r.length > 0 ? r.length - 1 : 0,
                    frc: n
                });
            }
            buildFrcSegments(e1) {
                this.frcData && !this.frcData.empty() && ig(this.frcData, e1.indexArray, e1.segments);
            }
            handleFeature(e1, t1, i, n, r, o, a, s, l, u, c) {
                if (!this.elevationEnabled) return !1;
                if (!c.terrainEnabled) {
                    const h = pm(e1, n, r ? r.registry : void 0, i), d = null != e1.properties && Object.hasOwn(e1.properties, ld) && !Number.isNaN(+e1.properties[ld]);
                    if (!h && d && o && (!r || !r.allProvidersReady)) return this.hasDeferredElevationFeatures = !0, !0;
                    if (h) {
                        let n = h.feature, o = h.tileId;
                        if (!h.tileId.equals(i)) {
                            const t1 = this.mergedFeatureCache ? this.mergedFeatureCache.get(n.id) : void 0;
                            if (t1) n = t1, o = i;
                            else {
                                const t1 = function(e1, t1, i) {
                                    if (!e1.properties || !t1 || 0 === t1.length) return [];
                                    const n = +e1.properties[ld];
                                    if (Number.isNaN(n)) return [];
                                    const r = fm(t1, n);
                                    if (r < 0) return [];
                                    const o = [];
                                    for(let e1 = r; e1 < t1.length && t1[e1].feature.id === n; e1++){
                                        const n = t1[e1];
                                        (n.tileId.isChildOf(i) || i.isChildOf(n.tileId) || null != n.feature.constantHeight) && o.push(n);
                                    }
                                    return o;
                                }(e1, r ? r.registry : void 0, i);
                                t1.length > 1 && (n = function(e1, t1) {
                                    const i = t1.slice().sort((e1, t1)=>t1.tileId.z - e1.tileId.z), n = new Pe(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY), r = new Pe(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY), o = [];
                                    for (const t1 of i){
                                        const i = new hm(t1.tileId, e1);
                                        for (const e1 of t1.feature.vertices)o.push({
                                            position: i.pointTransform(e1.position),
                                            height: e1.height,
                                            extent: e1.extent,
                                            index: e1.index
                                        });
                                        const a = t1.feature.safeArea;
                                        om[0] = a.min.x, om[1] = a.min.y, am[0] = a.max.x, am[1] = a.max.y, i.pointTransformInPlace(om), i.pointTransformInPlace(am), n.x = Math.min(n.x, om[0], am[0]), n.y = Math.min(n.y, om[1], am[1]), r.x = Math.max(r.x, om[0], am[0]), r.y = Math.max(r.y, om[1], am[1]);
                                    }
                                    const a = {
                                        min: n,
                                        max: r
                                    };
                                    if (null != i[0].feature.constantHeight) return new cm(i[0].feature.id, a, i[0].feature.constantHeight);
                                    o.sort((e1, t1)=>e1.index - t1.index);
                                    const s = [];
                                    for (const e1 of o)0 !== s.length && s.at(-1).index === e1.index || s.push(e1);
                                    const l = [];
                                    for(let e1 = 1; e1 < s.length; e1++)s[e1].index - s[e1 - 1].index <= 1 && l.push({
                                        a: e1 - 1,
                                        b: e1
                                    });
                                    const u = 1 / vu(e1);
                                    return new cm(i[0].feature.id, a, void 0, s, l, u);
                                }(i, t1), o = i, this.mergedFeatureCache || (this.mergedFeatureCache = new Map), this.mergedFeatureCache.set(n.id, n));
                            }
                        }
                        const d = Kh(t1, -1, -1, 8193, 8193), f = this.prepareElevatedLines(d, n, o, i);
                        for (const t1 of f){
                            const r = c.layoutVertexArray.length;
                            c.addLine(t1, e1, i, a, s, l, u);
                            const h = new hm(i, o), d = c.showElevationIdDebug ? dm(n.id) : null;
                            for(let e1 = r; e1 < c.layoutVertexArray.length; e1++){
                                const t1 = new Pe(c.layoutVertexArray.int16[6 * e1] >> 1, c.layoutVertexArray.int16[6 * e1 + 1] >> 1), i = h.pointElevation(t1, n, .05);
                                this.updateHeightRange(i), e1 < c.zOffsetVertexArray.length ? c.zOffsetVertexArray.float32[4 * e1] = i : c.zOffsetVertexArray.emplaceBack(i, 0, 0, 0), d ? e1 < c.elevationIdColVertexArray.length ? (c.elevationIdColVertexArray.float32[3 * e1] = d[0], c.elevationIdColVertexArray.float32[3 * e1 + 1] = d[1], c.elevationIdColVertexArray.float32[3 * e1 + 2] = d[2]) : c.elevationIdColVertexArray.emplaceBack(d[0], d[1], d[2]) : c.showElevationIdDebug && (e1 < c.elevationIdColVertexArray.length ? (c.elevationIdColVertexArray.float32[3 * e1] = 0, c.elevationIdColVertexArray.float32[3 * e1 + 1] = 0, c.elevationIdColVertexArray.float32[3 * e1 + 2] = 0) : c.elevationIdColVertexArray.emplaceBack(0, 0, 0));
                            }
                        }
                        return !0;
                    }
                    if (d && o && r && r.allProvidersReady && r.hasCoveringTile) return !0;
                }
                const h = !(!e1.properties || !Object.hasOwn(e1.properties, "mapbox_line_metrics")) && e1.properties.mapbox_line_metrics, d = c.layoutVertexArray.length, f = [], p = Kh(t1, -1, -1, 8193, 8193, f);
                for(let t1 = 0; t1 < p.length; t1++){
                    const n = p[t1], r = f[t1], o = {
                        progress: {
                            min: r.progress.min,
                            max: r.progress.max
                        },
                        nextDir: sg(r, n),
                        prevDir: lg(r, n)
                    };
                    c.addLine(n, e1, i, a, s, l, u, o, h && r.parentIndex > 0 ? r.parentIndex : null);
                }
                return c.fillNonElevatedRoadSegment(d), !0;
            }
            prepareElevatedLines(e1, t1, i, n) {
                if (null != t1.constantHeight) return e1;
                const r = [], o = 1 / vu(n), a = i.equals(n) ? null : new hm(i, n);
                for (const i of e1)Qh(i, new um(t1, o, a), 0, r);
                return r;
            }
            updateHeightRange(e1) {
                this.heightRange ? (this.heightRange.min = Math.min(this.heightRange.min, e1), this.heightRange.max = Math.max(this.heightRange.max, e1)) : this.heightRange = {
                    min: e1,
                    max: e1
                };
            }
            endPopulate() {
                this.mergedFeatureCache = void 0;
            }
        }
        Ha(ug, "LineHDExtension");
        class cg {
            constructor(){
                this.elevatedLayoutVertexArray = new ku, this.hasElevation = !1;
            }
            beginFeature(e1, t1, i) {
                const n = pm(e1, t1, void 0, i);
                this.currentFeatureElevation = n ? n.feature : void 0;
            }
            writeVertexQuad(e1, t1) {
                const i = this.currentFeatureElevation ? this.currentFeatureElevation.pointElevation(new Pe(e1, t1)) : 0;
                this.hasElevation = this.hasElevation || 0 !== i;
                for(let e1 = 0; e1 < 4; e1++)this.elevatedLayoutVertexArray.emplaceBack(i);
            }
            finalize() {
                this.hasElevation || (this.elevatedLayoutVertexArray = void 0);
            }
            upload(e1) {
                this.elevatedLayoutVertexArray && !this.elevatedLayoutVertexBuffer && (this.elevatedLayoutVertexBuffer = e1.createVertexBuffer(this.elevatedLayoutVertexArray, md.members));
            }
            destroy() {
                this.elevatedLayoutVertexBuffer && this.elevatedLayoutVertexBuffer.destroy();
            }
        }
        Ha(cg, "CircleHDExtension");
        const hg = (e1, t1, i, n)=>{
            for(let r = 0; r < t1; r++)e1.emplaceBack(i[0], i[1], i[2], n[0], n[1], n[2]);
        };
        class dg {
            constructor(){
                this.elevationFeatures = [], this.elevationFeatureTileIds = [], this.elevationFeatureIdToIndex = new Map, this.elevationStateComplete = !1, this.hasDeferredElevationFeatures = !1, this.elevationParams = null, this.crossSourceElevationEnabled = !1, this.terrainEnabled = !1;
            }
            configureCrossSource(e1, t1, i, n) {
                this.consumerCanonical = e1, this.elevationParams = t1, this.crossSourceElevationEnabled = i, this.terrainEnabled = n;
            }
            addElevationFeatures(e1, t1) {
                for (const i of e1)this.elevationFeatureIdToIndex.set(i.id, this.elevationFeatures.length), this.elevationFeatures.push(i), this.elevationFeatureTileIds.push(t1);
            }
            resolveRoadElevation(e1, t1) {
                const i = this.elevationFeatureIdToIndex.get(t1);
                if (void 0 !== i) return i;
                if (this.terrainEnabled || !this.crossSourceElevationEnabled) return 65535;
                const n = pm(e1, void 0, this.elevationParams ? this.elevationParams.registry : void 0, this.consumerCanonical);
                if (n) {
                    const e1 = this.elevationFeatures.length;
                    return this.elevationFeatureIdToIndex.set(t1, e1), this.elevationFeatures.push(n.feature), this.elevationFeatureTileIds.push(n.tileId), e1;
                }
                return this.elevationParams && this.elevationParams.allProvidersReady ? 65535 : (this.hasDeferredElevationFeatures = !0, "defer");
            }
            getElevationFeatureSampler(e1, t1) {
                if (t1.equals(e1)) return new hm(e1, t1);
                this.elevationFeatureSamplerCache || (this.elevationFeatureSamplerCache = new Map);
                let i = this.elevationFeatureSamplerCache.get(t1.key);
                return i || (i = new hm(e1, t1), this.elevationFeatureSamplerCache.set(t1.key, i)), i;
            }
            isCrossTileRoadElevation(e1, t1) {
                if (65535 === e1 || e1 >= this.elevationFeatures.length) return !1;
                const i = this.elevationFeatureTileIds[e1];
                return null != i && !i.equals(t1);
            }
            getRoadFeatureHeightAtAnchor(e1, t1, i) {
                if (65535 === e1 || e1 >= this.elevationFeatures.length) return null;
                const n = this.elevationFeatures[e1], r = this.elevationFeatureTileIds[e1];
                return r.equals(i) ? n.pointElevation(t1) : this.getElevationFeatureSampler(i, r).pointElevation(new Pe(t1.x, t1.y), n, 0);
            }
            sampleRoadFeatureHeight(e1, t1, i) {
                const n = this.getRoadFeatureHeightAtAnchor(e1, t1, i);
                return null === n ? void 0 : n;
            }
            clearWorkerState() {
                this.consumerCanonical = void 0, this.elevationParams = null, this.crossSourceElevationEnabled = !1, this.terrainEnabled = !1, this.elevationFeatureIdToIndex.clear();
            }
            updateRoadElevation(e1, t1) {
                if (this.elevationStateComplete) return;
                this.elevationStateComplete = !0, e1.hasAnyZOffset = !1;
                let i = !1;
                const n = vu(t1), r = 1 / n;
                let o = !1, a = !1;
                for(let s = 0; s < e1.symbolInstances.length; s++){
                    const l = e1.symbolInstances.get(s), u = C(1, 0, 0), c = C(0, 1, 0), { numHorizontalGlyphVertices: h, numVerticalGlyphVertices: d, numIconVertices: f, numVerticalIconVertices: p } = l, _ = h > 0 || d > 0, m = f > 0, g = l.elevationFeatureIndex, y = g < this.elevationFeatures.length ? this.elevationFeatures[g] : void 0;
                    if (y) {
                        const s = new Pe(l.tileAnchorX, l.tileAnchorY), h = this.sampleRoadFeatureHeight(g, s, t1), d = void 0 !== h ? .075 + h : .075;
                        l.zOffset !== d && (i = !0, l.zOffset = d), 0 !== d && (e1.hasAnyZOffset = !0);
                        const f = y.computeSlopeNormal(s, r), p = xe(ue(), C(0, 0, 1), f);
                        K(u, u, p), K(c, c, p), u[2] *= n, c[2] *= n, 1 === u[0] && 0 === u[1] && 0 === u[2] && 0 === c[0] && 1 === c[1] && 0 === c[2] || (o = o || _, a = a || m);
                    }
                    if (_ && (hg(e1.text.orientationVertexArray, h, u, c), hg(e1.text.orientationVertexArray, d, u, c)), m) {
                        const { placedIconSymbolIndex: t1, verticalPlacedIconSymbolIndex: i } = l;
                        t1 >= 0 && hg(e1.icon.orientationVertexArray, f, u, c), i >= 0 && hg(e1.icon.orientationVertexArray, p, u, c);
                    }
                }
                o || (e1.text.orientationVertexArray = void 0), a || (e1.icon.orientationVertexArray = void 0), i && (e1.zOffsetBuffersNeedUpload = !0, e1.zOffsetSortDirty = !0);
            }
            getRoadFeatureHeightForPlacedSymbol(e1, t1, i, n, r) {
                const o = e1.symbolInstances.get(t1.symbolInstanceIndices[i]);
                return this.getRoadFeatureHeightAtAnchor(o.elevationFeatureIndex, n, r);
            }
            getElevationFeatureForPlacedSymbol(e1, t1, i) {
                const n = e1.symbolInstances.get(t1.symbolInstanceIndices[i]).elevationFeatureIndex;
                if (n < this.elevationFeatures.length) return this.elevationFeatures[n];
            }
            makeRoadSymbolElevationParams(e1, t1, i, n, r, o, a, s, l) {
                const u = this.getElevationFeatureForPlacedSymbol(e1, t1, i), c = void 0 !== u ? u : null, h = e1.symbolInstances.get(t1.symbolInstanceIndices[i]);
                return this.isCrossTileRoadElevation(h.elevationFeatureIndex, n.canonical) ? {
                    getElevation: (r)=>{
                        const o = this.getRoadFeatureHeightForPlacedSymbol(e1, t1, i, r, n.canonical);
                        return function(e1, t1, i, n, r, o) {
                            const a = n.upVector(t1, i.x, i.y);
                            return k(a, a, e1 * n.upVectorScale(t1, r, o).metersToTile), [
                                a[0],
                                a[1],
                                a[2]
                            ];
                        }(null !== o ? o : 0, n.canonical, r, a, s, l);
                    },
                    elevation: o,
                    elevationFeature: null
                } : {
                    getElevation: r,
                    elevation: o,
                    elevationFeature: c
                };
            }
        }
        Ha(dg, "SymbolHDExtension", {
            omit: [
                "consumerCanonical",
                "elevationParams",
                "crossSourceElevationEnabled",
                "terrainEnabled",
                "hasDeferredElevationFeatures",
                "elevationFeatureIdToIndex"
            ]
        });
        let fg = null, pg = null, _g = null, mg = null;
        const gg = 5120, yg = 5121, xg = 5122, vg = 5123, bg = 5125, wg = 5126, Eg = {
            [gg]: Int8Array,
            [yg]: Uint8Array,
            [xg]: Int16Array,
            [vg]: Uint16Array,
            [bg]: Uint32Array,
            [wg]: Float32Array
        }, Ag = {
            [gg]: "DT_INT8",
            [yg]: "DT_UINT8",
            [xg]: "DT_INT16",
            [vg]: "DT_UINT16",
            [bg]: "DT_UINT32",
            [wg]: "DT_FLOAT32"
        }, Ig = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        };
        function Tg(e1, t1, i) {
            const n = i.json.bufferViews.length, r = i.buffers.length;
            t1.bufferView = n, i.json.bufferViews[n] = {
                buffer: r,
                byteLength: e1.byteLength
            }, i.buffers[r] = e1;
        }
        const Mg = "KHR_draco_mesh_compression";
        function Sg(e1, t1) {
            const i = e1.extensions && e1.extensions[Mg];
            if (!i) return;
            const n = new fg.Decoder, r = Og(t1, i.bufferView), o = new fg.Mesh;
            if (!n.DecodeArrayToMesh(r, r.byteLength, o)) throw new Error("Failed to decode Draco mesh");
            const a = t1.json.accessors[e1.indices], s = Eg[a.componentType], l = a.count * s.BYTES_PER_ELEMENT, u = fg._malloc(l);
            s === Uint16Array ? n.GetTrianglesUInt16Array(o, l, u) : n.GetTrianglesUInt32Array(o, l, u), Tg(fg.memory.buffer.slice(u, u + l), a, t1), fg._free(u);
            for (const r of Object.keys(i.attributes)){
                const a = n.GetAttributeByUniqueId(o, i.attributes[r]), s = t1.json.accessors[e1.attributes[r]], l = Ag[s.componentType], u = s.count * Ig[s.type] * Eg[s.componentType].BYTES_PER_ELEMENT, c = fg._malloc(u);
                n.GetAttributeDataArrayForAllPoints(o, a, fg[l], u, c), Tg(fg.memory.buffer.slice(c, c + u), s, t1), fg._free(c);
            }
            n.destroy(), o.destroy(), delete e1.extensions[Mg];
        }
        const zg = "EXT_meshopt_compression";
        function Rg(e1, t1) {
            if (!e1.extensions || !e1.extensions[zg]) return;
            const i = e1.extensions[zg], n = new Uint8Array(t1.buffers[i.buffer], i.byteOffset || 0, i.byteLength || 0), r = new Uint8Array(i.count * i.byteStride);
            _g.decodeGltfBuffer(r, i.count, i.byteStride, n, i.mode, i.filter), e1.buffer = t1.buffers.length, e1.byteOffset = 0, t1.buffers[e1.buffer] = r.buffer, delete e1.extensions[zg];
        }
        const Pg = 1179937895, Dg = new TextDecoder("utf8");
        function Cg(e1, t1) {
            return new URL(e1, t1).href;
        }
        async function Fg(e1, t1, i, n, r) {
            const o = await fetch(Cg(e1.uri, n), {
                signal: r
            }), a = await o.arrayBuffer();
            t1.buffers[i] = a;
        }
        function Og(e1, t1) {
            const i = e1.json.bufferViews[t1];
            return new Uint8Array(e1.buffers[i.buffer], i.byteOffset || 0, i.byteLength);
        }
        async function Lg(e1, t1, i, n, r) {
            if (e1.uri) {
                const o = Cg(e1.uri, n), a = await fetch(o, {
                    signal: r
                }), s = await a.blob(), l = await createImageBitmap(s);
                t1.images[i] = l;
            } else if (void 0 !== e1.bufferView) {
                const n = Og(t1, e1.bufferView), r = new Blob([
                    n
                ], {
                    type: e1.mimeType
                }), o = await createImageBitmap(r);
                t1.images[i] = o;
            }
        }
        async function Bg(e1, t1 = 0, i, n) {
            const r = {
                json: null,
                images: [],
                buffers: []
            };
            if (new Uint32Array(e1, t1, 1)[0] === Pg) {
                const i = new Uint32Array(e1, t1);
                let n = 2;
                const o = (i[n++] >> 2) - 3, a = i[n++] >> 2;
                if (n++, r.json = JSON.parse(Dg.decode(i.subarray(n, n + a))), n += a, n < o) {
                    const o = i[n++];
                    n++;
                    const a = t1 + (n << 2);
                    r.buffers[0] = e1.slice(a, a + o);
                }
            } else r.json = JSON.parse(Dg.decode(new Uint8Array(e1, t1)));
            const { buffers: o, images: a, meshes: s, extensionsUsed: l, bufferViews: u } = r.json;
            if (o) {
                const e1 = [];
                for(let t1 = 0; t1 < o.length; t1++){
                    const a = o[t1];
                    a.uri ? e1.push(Fg(a, r, t1, i, n)) : r.buffers[t1] || (r.buffers[t1] = null);
                }
                await Promise.all(e1);
            }
            n && n.throwIfAborted();
            const c = [], h = l && l.includes(Mg), d = l && l.includes(zg);
            if (h && c.push(function() {
                if (!fg) return null != pg || (pg = (function(e1) {
                    let t1, i = null;
                    function n() {
                        t1 = new Uint8Array(i.buffer);
                    }
                    function r() {
                        throw new Error("Unexpected Draco error.");
                    }
                    return WebAssembly.instantiateStreaming(e1, {
                        a: {
                            a: r,
                            d: function(e1, i, n) {
                                return t1.copyWithin(e1, i, i + n);
                            },
                            c: function(e1) {
                                const r = t1.length, o = Math.max(e1 >>> 0, Math.ceil(1.2 * r)), a = Math.ceil((o - r) / 65536);
                                try {
                                    return i.grow(a), n(), !0;
                                } catch (e1) {
                                    return !1;
                                }
                            },
                            b: r
                        }
                    }).then((e1)=>{
                        const { Rb: r, Qb: o, P: a, T: s, X: l, Ja: u, La: c, Qa: h, Va: d, Wa: f, eb: p, jb: _, f: m, e: g, yb: y, zb: x, Ab: v, Bb: b, Db: w, Gb: E } = e1.instance.exports;
                        i = g;
                        const A = (()=>{
                            let e1 = 0, i = 0, n = 0, a = 0;
                            return (s)=>{
                                n && (r(a), r(e1), i += n, n = e1 = 0), e1 || (i += 128, e1 = o(i));
                                const l = s.length + 7 & -8;
                                let u = e1;
                                l >= i && (n = l, u = a = o(l));
                                for(let e1 = 0; e1 < s.length; e1++)t1[u + e1] = s[e1];
                                return u;
                            };
                        })();
                        return n(), m(), {
                            memory: g,
                            _free: r,
                            _malloc: o,
                            Mesh: class {
                                constructor(){
                                    this.ptr = a();
                                }
                                destroy() {
                                    s(this.ptr);
                                }
                            },
                            Decoder: class {
                                constructor(){
                                    this.ptr = u();
                                }
                                destroy() {
                                    _(this.ptr);
                                }
                                DecodeArrayToMesh(e1, t1, i) {
                                    const n = A(e1), r = c(this.ptr, n, t1, i.ptr);
                                    return !!l(r);
                                }
                                GetAttributeByUniqueId(e1, t1) {
                                    return {
                                        ptr: h(this.ptr, e1.ptr, t1)
                                    };
                                }
                                GetTrianglesUInt16Array(e1, t1, i) {
                                    d(this.ptr, e1.ptr, t1, i);
                                }
                                GetTrianglesUInt32Array(e1, t1, i) {
                                    f(this.ptr, e1.ptr, t1, i);
                                }
                                GetAttributeDataArrayForAllPoints(e1, t1, i, n, r) {
                                    p(this.ptr, e1.ptr, t1.ptr, i, n, r);
                                }
                            },
                            DT_INT8: y(),
                            DT_UINT8: x(),
                            DT_INT16: v(),
                            DT_UINT16: b(),
                            DT_UINT32: w(),
                            DT_FLOAT32: E()
                        };
                    });
                })(fetch(Gt())).then((e1)=>{
                    fg = e1, pg = null;
                })), pg;
            }()), d && c.push(function() {
                var e1;
                if (!_g) return null != mg || (mg = (e1 = fetch(jt()), WebAssembly.instantiateStreaming(e1, {}).then((e1)=>{
                    const { sbrk: t1, memory: i, meshopt_decodeVertexBuffer: n, meshopt_decodeIndexBuffer: r, meshopt_decodeIndexSequence: o, meshopt_decodeFilterOct: a, meshopt_decodeFilterQuat: s, meshopt_decodeFilterExp: l } = e1.instance.exports, u = {
                        ATTRIBUTES: n,
                        TRIANGLES: r,
                        INDICES: o
                    }, c = {
                        OCTAHEDRAL: a,
                        QUATERNION: s,
                        EXPONENTIAL: l
                    };
                    return e1.instance.exports.__wasm_call_ctors(), {
                        decodeGltfBuffer (e1, n, r, o, a, s) {
                            const l = n + 3 & -4, h = t1(l * r), d = t1(o.length), f = new Uint8Array(i.buffer);
                            f.set(o, d);
                            const p = u[a](h, n, r, d, o.length);
                            if (0 === p && c[s] && c[s](h, l, r), e1.set(f.subarray(h, h + n * r)), t1(h - t1(0)), 0 !== p) throw new Error(`Malformed buffer data: ${p}`);
                        }
                    };
                })).then((e1)=>{
                    _g = e1, mg = null;
                })), mg;
            }()), a) for(let e1 = 0; e1 < a.length; e1++)c.push(Lg(a[e1], r, e1, i, n));
            if (c.length && await Promise.all(c), n && n.throwIfAborted(), h && s) for (const { primitives: e1 } of s)for (const t1 of e1)Sg(t1, r);
            if (d && s && u) for (const e1 of u)Rg(e1, r);
            return r;
        }
        async function Ng(e1, t1) {
            const { data: i } = await _i({
                url: e1
            }, t1);
            return Bg(i, 0, e1, t1);
        }
        class Vg {
            constructor(e1, t1, i, n){
                if (this.triangleCount = t1.length / 3, this.min = new Pe(0, 0), this.max = new Pe(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], 0 === this.triangleCount || 0 === e1.length) return;
                const [r, o] = [
                    e1[0].clone(),
                    e1[0].clone()
                ];
                for(let t1 = 1; t1 < e1.length; ++t1){
                    const i = e1[t1];
                    r.x = Math.min(r.x, i.x), r.y = Math.min(r.y, i.y), o.x = Math.max(o.x, i.x), o.y = Math.max(o.y, i.y);
                }
                if (n) {
                    const e1 = Math.ceil(Math.max(o.x - r.x, o.y - r.y) / n);
                    i = Math.max(i, e1);
                }
                if (0 === i) return;
                this.min = r, this.max = o;
                const a = this.max.sub(this.min);
                a.x = Math.max(a.x, 1), a.y = Math.max(a.y, 1);
                const s = Math.max(a.x, a.y) / i;
                this.cellsX = Math.max(1, Math.ceil(a.x / s)), this.cellsY = Math.max(1, Math.ceil(a.y / s)), this.xScale = 1 / s, this.yScale = 1 / s;
                const l = [];
                for(let i = 0; i < this.triangleCount; i++){
                    const n = e1[t1[3 * i + 0]].sub(this.min), r = e1[t1[3 * i + 1]].sub(this.min), o = e1[t1[3 * i + 2]].sub(this.min), a = kg(Math.floor(Math.min(n.x, r.x, o.x)), this.xScale, this.cellsX), u = kg(Math.floor(Math.max(n.x, r.x, o.x)), this.xScale, this.cellsX), c = kg(Math.floor(Math.min(n.y, r.y, o.y)), this.yScale, this.cellsY), h = kg(Math.floor(Math.max(n.y, r.y, o.y)), this.yScale, this.cellsY), d = new Pe(0, 0), f = new Pe(0, 0), p = new Pe(0, 0), _ = new Pe(0, 0);
                    for(let e1 = c; e1 <= h; ++e1){
                        d.y = f.y = e1 * s, p.y = _.y = (e1 + 1) * s;
                        for(let t1 = a; t1 <= u; ++t1)d.x = p.x = t1 * s, f.x = _.x = (t1 + 1) * s, (Wh(n, r, o, d, f, _) || Wh(n, r, o, d, _, p)) && l.push({
                            cellIdx: e1 * this.cellsX + t1,
                            triIdx: i
                        });
                    }
                }
                if (0 === l.length) return;
                l.sort((e1, t1)=>e1.cellIdx - t1.cellIdx || e1.triIdx - t1.triIdx);
                let u = 0;
                for(; u < l.length;){
                    const e1 = l[u].cellIdx, t1 = {
                        start: this.payload.length,
                        len: 0
                    };
                    for(; u < l.length && l[u].cellIdx === e1;)++t1.len, this.payload.push(l[u++].triIdx);
                    this.cells[e1] = t1;
                }
            }
            _lazyInitLookup() {
                this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8))), this.lookup.fill(0);
            }
            queryPoint(e1, t1) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (e1.x > this.max.x || this.min.x > e1.x || e1.y > this.max.y || this.min.y > e1.y) return;
                const i = kg(e1.x - this.min.x, this.xScale, this.cellsX), n = kg(e1.y - this.min.y, this.yScale, this.cellsY), r = this.cells[n * this.cellsX + i];
                if (r) {
                    this._lazyInitLookup();
                    for(let e1 = 0; e1 < r.len; e1++){
                        const i = this.payload[r.start + e1], n = Math.floor(i / 8), o = 1 << i % 8;
                        if (!(this.lookup[n] & o) && (this.lookup[n] |= o, t1.push(i), t1.length === this.triangleCount)) return;
                    }
                }
            }
            query(e1, t1, i) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (e1.x > this.max.x || this.min.x > t1.x) return;
                if (e1.y > this.max.y || this.min.y > t1.y) return;
                this._lazyInitLookup();
                const n = kg(e1.x - this.min.x, this.xScale, this.cellsX), r = kg(t1.x - this.min.x, this.xScale, this.cellsX), o = kg(e1.y - this.min.y, this.yScale, this.cellsY), a = kg(t1.y - this.min.y, this.yScale, this.cellsY);
                for(let e1 = o; e1 <= a; e1++)for(let t1 = n; t1 <= r; t1++){
                    const n = this.cells[e1 * this.cellsX + t1];
                    if (n) for(let e1 = 0; e1 < n.len; e1++){
                        const t1 = this.payload[n.start + e1], r = Math.floor(t1 / 8), o = 1 << t1 % 8;
                        if (!(this.lookup[r] & o) && (this.lookup[r] |= o, i.push(t1), i.length === this.triangleCount)) return;
                    }
                }
            }
        }
        function kg(e1, t1, i) {
            return Math.max(0, Math.min(i - 1, Math.floor(e1 * t1)));
        }
        Ha(Vg, "TriangleGridIndex");
        const Ug = Ou([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), Gg = Ou([
            {
                name: "a_color_3f",
                components: 3,
                type: "Float32"
            }
        ]), jg = Ou([
            {
                name: "a_color_4f",
                components: 4,
                type: "Float32"
            }
        ]), Hg = Ou([
            {
                name: "a_uv_2f",
                components: 2,
                type: "Float32"
            }
        ]), $g = Ou([
            {
                name: "a_normal_3f",
                components: 3,
                type: "Float32"
            }
        ]), Zg = Ou([
            {
                name: "a_normal_matrix0",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix1",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix2",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix3",
                components: 4,
                type: "Float32"
            }
        ]), Wg = Ou([
            {
                name: "a_pbr",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_heightBasedEmissiveStrength",
                components: 3,
                type: "Float32"
            }
        ]);
        function qg(e1, t1) {
            const i = Yg(e1.projection, e1.zoom, e1.width, e1.height), n = function(e1, t1, i, n, r) {
                const o = new hu(i.lng - 180 * Jg, i.lat), a = new hu(i.lng + 180 * Jg, i.lat), s = e1.project(o.lng, o.lat), l = e1.project(a.lng, a.lat), u = -Math.atan2(l.y - s.y, l.x - s.x), c = bu.fromLngLat(i);
                c.y = tt(c.y, -1 + Jg, 1 - Jg);
                const h = c.toLngLat(), f = e1.project(h.lng, h.lat), p = bu.fromLngLat(h);
                p.x += Jg;
                const m = p.toLngLat(), y = e1.project(m.lng, m.lat), x = Qg(y.x - f.x, y.y - f.y, u), b = bu.fromLngLat(h);
                b.y += Jg;
                const w = b.toLngLat(), E = e1.project(w.lng, w.lat), A = Qg(E.x - f.x, E.y - f.y, u), I = Math.abs(x.x) / Math.abs(A.y), T = d([]);
                v(T, T, -u * (1 - (r ? 0 : n)));
                const M = d([]);
                return g(M, M, [
                    1,
                    1 - (1 - I) * n,
                    1
                ]), M[4] = -A.x / A.y * n, v(M, M, u), _(M, T, M), M;
            }(e1.projection, 0, e1.center, i, t1), r = Xg(e1);
            return g(n, n, [
                r,
                r,
                1
            ]), n;
        }
        function Xg(e1) {
            const t1 = e1.projection, i = Yg(e1.projection, e1.zoom, e1.width, e1.height), n = Kg(t1, e1.center), r = Kg(t1, hu.convert(t1.center));
            return Math.pow(2, n * i + (1 - i) * r);
        }
        function Yg(e1, t1, i, n, r = 1 / 0) {
            const o = e1.range;
            if (!o) return 0;
            const a = Math.min(r, Math.max(i, n)), s = Math.log2(a / 1024);
            return it(o[0] + s, o[1] + s, t1);
        }
        const Jg = 1 / 4e4;
        function Kg(e1, t1) {
            const i = tt(t1.lat, -85.051129, mu), n = new hu(t1.lng - 180 * Jg, i), r = new hu(t1.lng + 180 * Jg, i), o = e1.project(n.lng, i), a = e1.project(r.lng, i), s = bu.fromLngLat(n), l = bu.fromLngLat(r), u = a.x - o.x, c = a.y - o.y, h = l.x - s.x, d = l.y - s.y, f = Math.sqrt((h * h + d * d) / (u * u + c * c));
            return Math.log2(f);
        }
        function Qg(e1, t1, i) {
            const n = Math.cos(i), r = Math.sin(i);
            return {
                x: e1 * n - t1 * r,
                y: e1 * r + t1 * n
            };
        }
        const ey = new Float64Array([
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]);
        function ty(e1, t1, i) {
            d(e1), v(e1, e1, Ye(t1[2])), y(e1, e1, Ye(t1[0])), x(e1, e1, Ye(t1[1])), g(e1, e1, i), _(e1, e1, ey);
        }
        function iy(e1, t1, i, n, r, o, a, s) {
            const l = [
                i[0] - t1[0],
                i[1] - t1[1],
                0
            ], u = [
                n[0] - t1[0],
                n[1] - t1[1],
                0
            ];
            if (D(l) < 1e-12 || D(u) < 1e-12) return ce(e1);
            const c = q([], l, u);
            Z(c, c), L(u, n, t1), l[2] = (o - r) * s, u[2] = (a - r) * s;
            const h = l;
            return q(h, l, u), Z(h, h), xe(e1, c, h);
        }
        function ny(e1, t1, i = !1) {
            const n = $f(t1.zoom), r = function(e1, t1, i) {
                const n = t1.worldSize, r = [
                    e1[12],
                    e1[13],
                    e1[14]
                ], o = pr(r[1] / n), a = fr(r[0] / n), s = d([]), l = pu(1, o) * n, u = pu(1, 0) * n * yu(o, t1.zoom), c = 1 / Gf(n);
                let h = u * c;
                if (i) {
                    const e1 = Yg(t1.projection, t1.zoom, t1.width, t1.height, 1024);
                    h = c * t1.projection.pixelSpaceConversion(t1.center.lat, n, e1);
                }
                const f = lu(o, a);
                O(f, f, k([], Z([], f), l * h * r[2]));
                const p = function(e1) {
                    const t1 = [
                        e1[0],
                        e1[1],
                        e1[2]
                    ];
                    let i = [
                        0,
                        1,
                        0
                    ];
                    const n = q([], i, t1);
                    return q(i, t1, n), 0 === H(i) && (i = [
                        0,
                        1,
                        0
                    ], q(n, t1, i)), Z(n, n), Z(i, i), Z(t1, t1), [
                        n[0],
                        n[1],
                        n[2],
                        0,
                        i[0],
                        i[1],
                        i[2],
                        0,
                        t1[0],
                        t1[1],
                        t1[2],
                        0,
                        e1[0],
                        e1[1],
                        e1[2],
                        1
                    ];
                }(f);
                g(s, s, [
                    h,
                    h,
                    h * l
                ]), m(s, s, [
                    -r[0],
                    -r[1],
                    -r[2]
                ]);
                const y = _([], t1.globeMatrix, p);
                return _(y, y, s), _(y, y, e1), y;
            }(e1, t1, i);
            if (n > 0) {
                const i = function(e1, t1) {
                    const i = t1.worldSize, n = pu(1, 0) * i * yu(t1.center.lat, t1.zoom) / Gf(i), r = pu(1, t1.center.lat) * i, o = d([]);
                    x(o, o, Ye(t1.center.lng)), y(o, o, Ye(t1.center.lat)), m(o, o, [
                        0,
                        0,
                        iu
                    ]), g(o, o, [
                        n,
                        n,
                        n * r
                    ]);
                    const a = t1.point;
                    return m(o, o, [
                        -a.x,
                        -a.y,
                        0
                    ]), _(o, o, e1), _(o, t1.globeMatrix, o);
                }(e1, t1);
                return function(e1, t1, i) {
                    const n = (e1, t1, i)=>{
                        const n = D(e1), r = D(t1), o = Df(e1, t1, i);
                        return k(o, o, 1 / D(o) * dn(n, r, i));
                    }, r = n([
                        e1[0],
                        e1[1],
                        e1[2]
                    ], [
                        t1[0],
                        t1[1],
                        t1[2]
                    ], i), o = n([
                        e1[4],
                        e1[5],
                        e1[6]
                    ], [
                        t1[4],
                        t1[5],
                        t1[6]
                    ], i), a = n([
                        e1[8],
                        e1[9],
                        e1[10]
                    ], [
                        t1[8],
                        t1[9],
                        t1[10]
                    ], i), s = Df([
                        e1[12],
                        e1[13],
                        e1[14]
                    ], [
                        t1[12],
                        t1[13],
                        t1[14]
                    ], i);
                    return [
                        r[0],
                        r[1],
                        r[2],
                        0,
                        o[0],
                        o[1],
                        o[2],
                        0,
                        a[0],
                        a[1],
                        a[2],
                        0,
                        s[0],
                        s[1],
                        s[2],
                        1
                    ];
                }(r, i, n);
            }
            return r;
        }
        function ry(e1, t1, i, n) {
            const r = If.projectAabbCorners(n, i);
            let o = Number.MAX_VALUE;
            for(let e1 = 0; e1 < r.length; ++e1){
                const i = r[e1];
                i[0] = (.5 * i[0] + .5) * t1.width, i[1] = (.5 - .5 * i[1]) * t1.height, i[2] < o && (o = i[2]);
            }
            const a = function(e1) {
                const t1 = [];
                let i = 0;
                for(let t1 = 1; t1 < e1.length; t1++)(e1[t1][0] < e1[i][0] || e1[t1][0] === e1[i][0] && e1[t1][1] < e1[i][1]) && (i = t1);
                let n, r = i;
                const o = new Uint8Array(e1.length);
                do {
                    if (o[r]) break;
                    t1.push(new Pe(e1[r][0], e1[r][1])), o[r] = 1, n = (r + 1) % e1.length;
                    for(let t1 = 0; t1 < e1.length; t1++){
                        if (e1[t1][0] === e1[n][0] && e1[t1][1] === e1[n][1] || e1[t1][0] === e1[r][0] && e1[t1][1] === e1[r][1]) continue;
                        const i = [
                            e1[t1][0] - e1[r][0],
                            e1[t1][1] - e1[r][1]
                        ], o = [
                            e1[n][0] - e1[r][0],
                            e1[n][1] - e1[r][1]
                        ], a = i[0] * o[1] - i[1] * o[0];
                        (a > 0 || 0 === a && i[0] * o[0] + i[1] * o[1] >= 0 && i[0] * i[0] + i[1] * i[1] > o[0] * o[0] + o[1] * o[1]) && (n = t1);
                    }
                    r = n;
                }while (r !== i);
                return t1.length > 0 && t1.push(t1[0]), t1;
            }(r);
            if (Dh(e1, a)) return o;
        }
        const oy = 64, ay = [
            1,
            1,
            1
        ];
        function sy(e1, t1, i, n, r, o, a, s, l, u = !1) {
            const c = i.zoom, h = i.project(n), f = yu(n.lat, c), p = 1 / f;
            d(e1), m(e1, e1, [
                h.x + a[0] * p,
                h.y + a[1] * p,
                a[2]
            ]);
            let y = 1, x = 1;
            const v = i.worldSize;
            if (u) {
                if ("mercator" === i.projection.name) {
                    let e1 = 0;
                    i.elevation && (e1 = i.elevation.getAtPointOrZero(new bu(h.x / v, h.y / v), 0));
                    const t1 = le([], [
                        h.x,
                        h.y,
                        e1,
                        1
                    ], i.projMatrix)[3] / i.cameraToCenterDistance;
                    y = t1, x = t1 * yu(i.center.lat, c);
                } else if ("globe" === i.projection.name) {
                    const t1 = ny(e1, i), r = [
                        0,
                        0,
                        0,
                        1
                    ];
                    le(r, r, _([], i.projMatrix, t1));
                    const o = r[3] / i.cameraToCenterDistance, a = $f(c), s = i.projection.pixelsPerMeter(n.lat, v) * yu(n.lat, c), l = i.projection.pixelsPerMeter(i.center.lat, v) * yu(i.center.lat, c);
                    y = o / dn(s, gu(i.center.lat), a), x = o * f / s, y *= l, x *= l;
                }
            } else y = p;
            g(e1, e1, [
                y,
                y,
                x
            ]);
            const b = [
                ...e1
            ], w = t1.orientation, E = [];
            if (ty(E, [
                w[0] + (r ? r[0] : 0),
                w[1] + (r ? r[1] : 0),
                w[2] + (r ? r[2] : 0)
            ], o), _(e1, b, E), s && i.elevation) {
                let r = 0;
                const o = [];
                if (l && i.elevation) {
                    r = function(e1, t1, i, n, r) {
                        const o = t1.elevation;
                        if (!o) return 0;
                        const a = If.projectAabbCorners(i, n), s = pu(1, r.lat) * t1.worldSize, l = function(e1, t1) {
                            const i = [
                                0,
                                0,
                                1
                            ], n = [
                                {
                                    corners: [
                                        0,
                                        1,
                                        3,
                                        2
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        1,
                                        5,
                                        2,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        4,
                                        1,
                                        5
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        2,
                                        6,
                                        3,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        4,
                                        7,
                                        5,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        3,
                                        4,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                }
                            ];
                            for (const r of n){
                                const n = e1[r.corners[0]], o = e1[r.corners[1]], a = e1[r.corners[2]], s = [
                                    o[0] - n[0],
                                    o[1] - n[1],
                                    t1 * (o[2] - n[2])
                                ], l = q(s, s, [
                                    a[0] - n[0],
                                    a[1] - n[1],
                                    t1 * (a[2] - n[2])
                                ]);
                                Z(l, l), r.dotProductWithUp = W(l, i);
                            }
                            return n.sort((e1, t1)=>e1.dotProductWithUp - t1.dotProductWithUp), n[0].corners;
                        }(a, s), u = a[l[0]], c = a[l[1]], h = a[l[2]], d = a[l[3]], f = o.getAtPointOrZero(new bu(u[0] / t1.worldSize, u[1] / t1.worldSize), 0), p = o.getAtPointOrZero(new bu(c[0] / t1.worldSize, c[1] / t1.worldSize), 0), _ = o.getAtPointOrZero(new bu(h[0] / t1.worldSize, h[1] / t1.worldSize), 0), m = o.getAtPointOrZero(new bu(d[0] / t1.worldSize, d[1] / t1.worldSize), 0), g = (f + m) / 2, y = (p + _) / 2;
                        return g > y ? p < _ ? iy(e1, c, d, u, p, m, f, s) : iy(e1, h, u, d, _, f, m, s) : f < m ? iy(e1, u, c, h, f, p, _, s) : iy(e1, d, h, c, m, _, p, s), Math.max(g, y);
                    }(o, i, t1.aabb, e1, n);
                    const a = _([], T([], o), E);
                    _(e1, b, a);
                } else r = i.elevation.getAtPointOrZero(new bu(h.x / v, h.y / v), 0);
                0 !== r && (e1[14] += r);
            }
        }
        class ly {
            constructor(e1, t1, i, n, r){
                this.materialOverrides = new Map, this.nodeOverrides = new Map, this.materialOverrideNames = [], this.nodeOverrideNames = [], this.featureProperties = {}, this.id = e1, this.uri = t1, this.position = null != i ? new hu(i[0], i[1]) : new hu(0, 0), this.orientation = n ?? [
                    0,
                    0,
                    0
                ], this.nodes = r, this.uploaded = !1, this.aabb = new If([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]), this.matrix = [];
            }
            _applyTransformations(e1, t1) {
                _(e1.globalMatrix, t1, e1.localMatrix);
                const i = this.nodeOverrides.get(e1.name);
                if (void 0 !== i) {
                    if (i.orientation) {
                        const t1 = [];
                        r = i.orientation, d(n = t1), x(n, n, Ye(r[1])), v(n, n, Ye(r[2])), y(n, n, Ye(r[0])), _(e1.globalMatrix, e1.globalMatrix, t1);
                    }
                    i.minZoom && (e1.minZoom = i.minZoom), i.maxZoom && (e1.maxZoom = i.maxZoom);
                }
                var n, r;
                if (e1.meshes) for (const t1 of e1.meshes){
                    const i = If.applyTransformFast(t1.aabb, e1.globalMatrix);
                    this.aabb.encapsulate(i);
                }
                if (e1.children) for (const t1 of e1.children)this._applyTransformations(t1, e1.globalMatrix);
            }
            computeBoundsAndApplyParent() {
                const e1 = d([]);
                this.aabb = new If([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]);
                for (const t1 of this.nodes)this._applyTransformations(t1, e1);
            }
            computeModelMatrix(e1, t1, i, n, r, o, a = !1) {
                sy(this.matrix, this, e1.transform, this.position, t1, i, n, r, o, a);
            }
            upload(e1) {
                if (!this.uploaded) {
                    for (const t1 of this.nodes)hy(t1, e1);
                    for (const e1 of this.nodes)fy(e1);
                    this.uploaded = !0;
                }
            }
            destroy() {
                for (const e1 of this.nodes)_y(e1);
            }
        }
        function uy(e1, t1, i = !1) {
            e1.uploaded || (e1.gfxTexture = new c_(t1, e1.image, i ? t1.gl.R8 : t1.gl.RGBA8, {
                useMipmap: e1.sampler.minFilter >= t1.gl.NEAREST_MIPMAP_NEAREST
            }), e1.uploaded = !0, e1.image = null);
        }
        function cy(e1, t1, i) {
            e1.indexBuffer = t1.createIndexBuffer(e1.indexArray, !1, !0), e1.vertexBuffer = t1.createVertexBuffer(e1.vertexArray, Ug.members, !1, !0), e1.normalArray && (e1.normalBuffer = t1.createVertexBuffer(e1.normalArray, $g.members, !1, !0)), e1.texcoordArray && (e1.texcoordBuffer = t1.createVertexBuffer(e1.texcoordArray, Hg.members, !1, !0)), e1.colorArray && (e1.colorBuffer = t1.createVertexBuffer(e1.colorArray, (12 === e1.colorArray.bytesPerElement ? Gg : jg).members, !1, !0)), e1.featureArray && (e1.pbrBuffer = t1.createVertexBuffer(e1.featureArray, Wg.members, !0)), e1.segments = Bc.simpleSegment(0, 0, e1.vertexArray.length, e1.indexArray.length);
            const n = e1.material;
            n.pbrMetallicRoughness.baseColorTexture && uy(n.pbrMetallicRoughness.baseColorTexture, t1), n.pbrMetallicRoughness.metallicRoughnessTexture && uy(n.pbrMetallicRoughness.metallicRoughnessTexture, t1), n.normalTexture && uy(n.normalTexture, t1), n.occlusionTexture && uy(n.occlusionTexture, t1, i), n.emissionTexture && uy(n.emissionTexture, t1);
        }
        function hy(e1, t1, i) {
            if (e1.meshes) for (const n of e1.meshes)cy(n, t1, i);
            if (e1.lodMeshes) for (const n of e1.lodMeshes)cy(n, t1, i);
            if (e1.children) for (const n of e1.children)hy(n, t1, i);
        }
        function dy(e1) {
            e1.indexArray.destroy(), e1.vertexArray.destroy(), e1.colorArray && e1.colorArray.destroy(), e1.normalArray && e1.normalArray.destroy(), e1.texcoordArray && e1.texcoordArray.destroy(), e1.featureArray && e1.featureArray.destroy();
        }
        function fy(e1) {
            if (e1.meshes) for (const t1 of e1.meshes)dy(t1);
            if (e1.lodMeshes) for (const t1 of e1.lodMeshes)dy(t1);
            if (e1.children) for (const t1 of e1.children)fy(t1);
        }
        function py(e1) {
            var t1;
            e1.vertexBuffer && (e1.vertexBuffer.destroy(), e1.indexBuffer.destroy(), e1.normalBuffer && e1.normalBuffer.destroy(), e1.texcoordBuffer && e1.texcoordBuffer.destroy(), e1.colorBuffer && e1.colorBuffer.destroy(), e1.pbrBuffer && e1.pbrBuffer.destroy(), e1.segments.destroy(), e1.material && ((t1 = e1.material).pbrMetallicRoughness.baseColorTexture && t1.pbrMetallicRoughness.baseColorTexture.gfxTexture && t1.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), t1.pbrMetallicRoughness.metallicRoughnessTexture && t1.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && t1.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), t1.normalTexture && t1.normalTexture.gfxTexture && t1.normalTexture.gfxTexture.destroy(), t1.emissionTexture && t1.emissionTexture.gfxTexture && t1.emissionTexture.gfxTexture.destroy(), t1.occlusionTexture && t1.occlusionTexture.gfxTexture && t1.occlusionTexture.gfxTexture.destroy()));
        }
        function _y(e1) {
            if (e1.meshes) for (const t1 of e1.meshes)py(t1);
            if (e1.lodMeshes) for (const t1 of e1.lodMeshes)py(t1);
            if (e1.footprintDebugMesh && (e1.footprintDebugMesh.vertexBuffer.destroy(), e1.footprintDebugMesh.indexBuffer.destroy(), e1.footprintDebugMesh.segments.destroy()), e1.children) for (const t1 of e1.children)_y(t1);
        }
        function my(e1, t1, i, n) {
            return e1[0] <= n[0] && t1[0] >= i[0] && e1[1] <= n[1] && t1[1] >= i[1] && e1[2] <= n[2] && t1[2] >= i[2];
        }
        function gy(e1, t1, i, n, r, o, a, s, l, u, c) {
            const h = .5 * (u[0] + c[0]), d = .5 * (u[1] + c[1]), f = .5 * (u[2] + c[2]), p = .5 * (c[0] - u[0]), _ = .5 * (c[1] - u[1]), m = .5 * (c[2] - u[2]), g = e1 - h, y = t1 - d, x = i - f, v = n - h, b = r - d, w = o - f, E = a - h, A = s - d, I = l - f, T = v - g, M = b - y, S = w - x, z = E - v, R = A - b, P = I - w, D = g - E, C = y - A, F = x - I;
            let O, L, B, N, V, k;
            if (O = x * M - y * S, L = w * M - b * S, B = I * M - A * S, N = Math.min(O, L, B), V = Math.max(O, L, B), k = Math.abs(S) * _ + Math.abs(M) * m, N > k || V < -k) return !1;
            if (O = x * R - y * P, L = w * R - b * P, B = I * R - A * P, N = Math.min(O, L, B), V = Math.max(O, L, B), k = Math.abs(P) * _ + Math.abs(R) * m, N > k || V < -k) return !1;
            if (O = x * C - y * F, L = w * C - b * F, B = I * C - A * F, N = Math.min(O, L, B), V = Math.max(O, L, B), k = Math.abs(F) * _ + Math.abs(C) * m, N > k || V < -k) return !1;
            if (O = g * S - x * T, L = v * S - w * T, B = E * S - I * T, N = Math.min(O, L, B), V = Math.max(O, L, B), k = Math.abs(S) * p + Math.abs(T) * m, N > k || V < -k) return !1;
            if (O = g * P - x * z, L = v * P - w * z, B = E * P - I * z, N = Math.min(O, L, B), V = Math.max(O, L, B), k = Math.abs(P) * p + Math.abs(z) * m, N > k || V < -k) return !1;
            if (O = g * F - x * D, L = v * F - w * D, B = E * F - I * D, N = Math.min(O, L, B), V = Math.max(O, L, B), k = Math.abs(F) * p + Math.abs(D) * m, N > k || V < -k) return !1;
            if (O = y * T - g * M, L = b * T - v * M, B = A * T - E * M, N = Math.min(O, L, B), V = Math.max(O, L, B), k = Math.abs(M) * p + Math.abs(T) * _, N > k || V < -k) return !1;
            if (O = y * z - g * R, L = b * z - v * R, B = A * z - E * R, N = Math.min(O, L, B), V = Math.max(O, L, B), k = Math.abs(R) * p + Math.abs(z) * _, N > k || V < -k) return !1;
            if (O = y * D - g * C, L = b * D - v * C, B = A * D - E * C, N = Math.min(O, L, B), V = Math.max(O, L, B), k = Math.abs(C) * p + Math.abs(D) * _, N > k || V < -k) return !1;
            if (N = Math.min(g, v, E), V = Math.max(g, v, E), N > p || V < -p) return !1;
            if (N = Math.min(y, b, A), V = Math.max(y, b, A), N > _ || V < -_) return !1;
            if (N = Math.min(x, w, I), V = Math.max(x, w, I), N > m || V < -m) return !1;
            const U = M * P - S * R, G = S * z - T * P, j = T * R - M * z, H = -(U * g + G * y + j * x);
            return k = p * Math.abs(U) + _ * Math.abs(G) + m * Math.abs(j), !(Math.abs(H) > k);
        }
        const yy = [];
        class xy {
            serializeFromGltf(e1, t1, i, n) {
                if (e1.length < 7) return;
                let r = 0;
                if (109 !== e1[r++] || 98 !== e1[r++] || 120 !== e1[r++] || 98 !== e1[r++] || 118 !== e1[r++] || 104 !== e1[r++]) return;
                if (43 !== e1[r++]) return;
                const o = new DataView(e1.buffer, e1.byteOffset), a = o.getUint16(r, !0);
                if (r += 2, 0 === a) return;
                this._nodes = [];
                let s = 0;
                for(let e1 = 0; e1 < a; e1++){
                    const e1 = [
                        t1[3 * s],
                        t1[3 * s + 1],
                        t1[3 * s + 2]
                    ], n = [
                        i[3 * s],
                        i[3 * s + 1],
                        i[3 * s + 2]
                    ];
                    s++;
                    const a = o.getUint16(r, !0);
                    r += 2;
                    let l = 0, u = 0;
                    65535 === a && (l = o.getUint16(r, !0), r += 2, u = o.getUint32(r, !0), r += 4), this._nodes.push({
                        aabbMin: e1,
                        aabbMax: n,
                        backChild: a,
                        indexCount: l,
                        indexOffset: u
                    });
                }
                const l = o.getUint32(r, !0);
                this._indices = n.slice(0, l);
            }
            setVertices(e1) {
                this._vertices = e1;
            }
            findHighestPoint(e1, t1) {
                if (!this._nodes || 0 === this._nodes.length) return null;
                if (!my(this._nodes[0].aabbMin, this._nodes[0].aabbMax, e1, t1)) return null;
                const i = yy;
                i.length = 0, i.push(0);
                let n = -1 / 0;
                for(; i.length > 0;){
                    const r = i.pop(), o = this._nodes[r];
                    if (o.aabbMax[2] <= n) continue;
                    if (65535 === o.backChild) {
                        for(let i = 0; i < o.indexCount; i += 3){
                            const r = 3 * this._indices[o.indexOffset + i], a = 3 * this._indices[o.indexOffset + i + 1], s = 3 * this._indices[o.indexOffset + i + 2];
                            gy(this._vertices[r], this._vertices[r + 1], this._vertices[r + 2], this._vertices[a], this._vertices[a + 1], this._vertices[a + 2], this._vertices[s], this._vertices[s + 1], this._vertices[s + 2], e1, t1) && (n = Math.max(n, this._vertices[r + 2], this._vertices[a + 2], this._vertices[s + 2]));
                        }
                        continue;
                    }
                    const a = r + 1, s = o.backChild, l = this._nodes[a], u = this._nodes[s], c = my(l.aabbMin, l.aabbMax, e1, t1), h = my(u.aabbMin, u.aabbMax, e1, t1);
                    c && h ? l.aabbMax[2] < u.aabbMax[2] ? (i.push(a), i.push(s)) : (i.push(s), i.push(a)) : c ? i.push(a) : h && i.push(s);
                }
                return n >= 0 ? n : null;
            }
        }
        function vy(e1, t1) {
            const i = e1.json.bufferViews[t1.bufferView], n = Eg[t1.componentType];
            return new n(e1.buffers[i.buffer], (t1.byteOffset || 0) + (i.byteOffset || 0), t1.count * (i.byteStride && i.byteStride !== Ig[t1.type] * n.BYTES_PER_ELEMENT ? i.byteStride / n.BYTES_PER_ELEMENT : Ig[t1.type]));
        }
        function by(e1, t1, i, n) {
            const r = Eg[t1.componentType], o = function(e1) {
                switch(e1){
                    case Int8Array:
                        return 1 / 127;
                    case Uint8Array:
                        return 1 / 255;
                    case Int16Array:
                        return 1 / 32767;
                    case Uint16Array:
                        return 1 / 65535;
                    default:
                        return 1;
                }
            }(r), a = e1.json.bufferViews[t1.bufferView], s = a.byteStride ? a.byteStride / r.BYTES_PER_ELEMENT : Ig[t1.type], l = i.float32, u = l.length / i.capacity, c = t1.count * s;
            for(let e1 = 0, t1 = 0; e1 < c; e1 += s, t1 += u)for(let i = 0; i < u; i++)l[t1 + i] = n[e1 + i] * o;
        }
        function wy(e1, t1, i) {
            const n = e1.indices, r = e1.attributes, o = {};
            o.indexArray = new oc;
            const a = t1.json.accessors[n], s = vy(t1, a);
            o.indexArray.resizeExact(a.count / 3), o.indexArray.uint16.set(s), o.vertexArray = new Zu;
            const l = t1.json.accessors[r.POSITION], u = vy(t1, l);
            o.vertexArray.resizeExact(l.count), o.vertexArray.float32.set(u), o.aabb = new If(l.min, l.max);
            const [c, h, d] = l.min, [f, p, _] = l.max;
            if (o.centroid = [
                .5 * (c + f),
                .5 * (h + p),
                .5 * (d + _)
            ], void 0 !== r.COLOR_0) {
                const e1 = t1.json.accessors[r.COLOR_0], i = Ig[e1.type], n = vy(t1, e1);
                o.colorArray = 3 === i ? new Zu : new Ku, o.colorArray.resizeExact(e1.count), by(t1, e1, o.colorArray, n);
            }
            if (void 0 !== r.NORMAL) {
                o.normalArray = new Zu;
                const e1 = t1.json.accessors[r.NORMAL];
                o.normalArray.resizeExact(e1.count);
                const i = vy(t1, e1);
                by(t1, e1, o.normalArray, i);
            }
            if (void 0 !== r.TEXCOORD_0 && i.length > 0) {
                o.texcoordArray = new fc;
                const e1 = t1.json.accessors[r.TEXCOORD_0];
                o.texcoordArray.resizeExact(e1.count);
                const i = vy(t1, e1);
                by(t1, e1, o.texcoordArray, i);
            }
            if (void 0 !== r._FEATURE_ID_RGBA4444) {
                const e1 = t1.json.accessors[r._FEATURE_ID_RGBA4444];
                t1.json.extensionsUsed && t1.json.extensionsUsed.includes("EXT_meshopt_compression") && (o.featureData = vy(t1, e1));
            }
            void 0 !== r._FEATURE_RGBA4444 && (o.featureData = new Uint32Array(vy(t1, t1.json.accessors[r._FEATURE_RGBA4444]).buffer));
            const m = e1.material;
            return o.material = function(e1, t1) {
                const { emissiveFactor: i = [
                    0,
                    0,
                    0
                ], alphaMode: n = "OPAQUE", alphaCutoff: r = .5, normalTexture: o, occlusionTexture: a, emissiveTexture: s, doubleSided: l, name: u } = e1, { baseColorFactor: c = [
                    1,
                    1,
                    1,
                    1
                ], metallicFactor: h = 1, roughnessFactor: d = 1, baseColorTexture: f, metallicRoughnessTexture: p } = e1.pbrMetallicRoughness || {}, _ = a ? t1[a.index] : void 0;
                if (a && a.extensions && a.extensions.KHR_texture_transform && _) {
                    const e1 = a.extensions.KHR_texture_transform;
                    _.offsetScale = [
                        e1.offset[0],
                        e1.offset[1],
                        e1.scale[0],
                        e1.scale[1]
                    ];
                }
                return {
                    name: u,
                    pbrMetallicRoughness: {
                        baseColorFactor: new pn(...c),
                        metallicFactor: h,
                        roughnessFactor: d,
                        baseColorTexture: f ? t1[f.index] : void 0,
                        metallicRoughnessTexture: p ? t1[p.index] : void 0
                    },
                    doubleSided: l,
                    emissiveFactor: new pn(...i),
                    alphaMode: n,
                    alphaCutoff: r,
                    normalTexture: o ? t1[o.index] : void 0,
                    occlusionTexture: _,
                    emissionTexture: s ? t1[s.index] : void 0,
                    defined: void 0 === e1.defined
                };
            }(void 0 !== m ? t1.json.materials[m] : {
                defined: !1
            }, i), o;
        }
        function Ey(e1, t1, i) {
            const { matrix: n, rotation: r, translation: o, scale: a, mesh: s, extras: l, children: u, name: h } = e1, d = {};
            if (d.name = h, d.localMatrix = n || function(e1, t1, i, n) {
                var r = t1[0], o = t1[1], a = t1[2], s = t1[3], l = r + r, u = o + o, c = a + a, h = r * l, d = r * u, f = r * c, p = o * u, _ = o * c, m = a * c, g = s * l, y = s * u, x = s * c, v = n[0], b = n[1], w = n[2];
                return e1[0] = (1 - (p + m)) * v, e1[1] = (d + x) * v, e1[2] = (f - y) * v, e1[3] = 0, e1[4] = (d - x) * b, e1[5] = (1 - (h + m)) * b, e1[6] = (_ + g) * b, e1[7] = 0, e1[8] = (f + y) * w, e1[9] = (_ - g) * w, e1[10] = (1 - (h + p)) * w, e1[11] = 0, e1[12] = i[0], e1[13] = i[1], e1[14] = i[2], e1[15] = 1, e1;
            }([], r || [
                0,
                0,
                0,
                1
            ], o || [
                0,
                0,
                0
            ], a || [
                1,
                1,
                1
            ]), d.globalMatrix = c(d.localMatrix), void 0 !== s) {
                d.meshes = i[s];
                const e1 = d.anchor = [
                    0,
                    0
                ];
                for (const t1 of d.meshes){
                    const { min: i, max: n } = t1.aabb;
                    e1[0] += i[0] + n[0], e1[1] += i[1] + n[1];
                }
                e1[0] = Math.floor(e1[0] / d.meshes.length / 2), e1[1] = Math.floor(e1[1] / d.meshes.length / 2);
            }
            if (l && (l.id && (d.id = l.id), l.lights && (d.lights = function(e1) {
                if (!e1.length) return [];
                const t1 = function(e1) {
                    const t1 = atob(e1), i = new Uint8Array(t1.length);
                    for(let e1 = 0; e1 < t1.length; e1++)i[e1] = t1.codePointAt(e1);
                    return i;
                }(e1), i = [], n = t1.length / 24, r = new Uint16Array(t1.buffer), o = new Float32Array(t1.buffer);
                for(let e1 = 0; e1 < n; e1++){
                    const t1 = r[2 * e1 * 6] / 30, n = r[2 * e1 * 6 + 1] / 30, a = r[2 * e1 * 6 + 10] / 100, s = o[6 * e1 + 1], l = o[6 * e1 + 2], u = o[6 * e1 + 3], c = o[6 * e1 + 4], h = u - s, d = c - l, f = Math.hypot(h, d);
                    i.push({
                        pos: [
                            s + .5 * h,
                            l + .5 * d,
                            n
                        ],
                        normal: [
                            d / f,
                            -h / f,
                            0
                        ],
                        width: f,
                        height: t1,
                        depth: a,
                        points: [
                            s,
                            l,
                            u,
                            c
                        ]
                    });
                }
                return i;
            }(l.lights)), l.MAPBOX_geometry_bloom && (d.isGeometryBloom = l.MAPBOX_geometry_bloom), l.MAPBOX_zoom_min && (d.minZoom = l.MAPBOX_zoom_min), l.MAPBOX_zoom_max && (d.maxZoom = l.MAPBOX_zoom_max)), u) {
                const e1 = [];
                for (const n of u)e1.push(Ey(t1.json.nodes[n], t1, i));
                d.children = e1;
            }
            if (e1.extensions && e1.extensions.mbx_bvh && (d.meshBVH = function(e1, t1, i) {
                const n = t1.binaryAccessor, r = t1.positionMinAccessor, o = t1.positionMaxAccessor, a = t1.indexAccessor;
                if (!(Number.isInteger(n) && Number.isInteger(r) && Number.isInteger(o) && Number.isInteger(a))) return null;
                const s = e1.json.accessors;
                if (n >= s.length || r >= s.length || o >= s.length || a >= s.length) return null;
                const l = s[n], u = s[r], c = s[o], h = s[a];
                if (void 0 === l.bufferView || void 0 === u.bufferView || void 0 === c.bufferView || void 0 === h.bufferView) return null;
                const d = e1.json.bufferViews;
                if (l.bufferView >= d.length || u.bufferView >= d.length || c.bufferView >= d.length || h.bufferView >= d.length) return null;
                const f = d[l.bufferView], p = d[u.bufferView], _ = d[c.bufferView], m = d[h.bufferView];
                if (f.buffer >= e1.buffers.length || p.buffer >= e1.buffers.length || _.buffer >= e1.buffers.length || m.buffer >= e1.buffers.length) return null;
                const g = (e1, t1, i)=>e1 >= 0 && e1 <= i && t1 <= i - e1, y = l.byteOffset || 0, x = u.byteOffset || 0, v = c.byteOffset || 0, b = h.byteOffset || 0;
                if (!(g(y, 0, f.byteLength) && g(x, 3 * u.count * 4, p.byteLength) && g(v, 3 * c.count * 4, _.byteLength) && g(b, 4 * h.count, m.byteLength))) return null;
                const w = new Uint8Array(e1.buffers[f.buffer], (f.byteOffset || 0) + y, f.byteLength - y), E = new Float32Array(e1.buffers[p.buffer], (p.byteOffset || 0) + x, 3 * u.count), A = new Float32Array(e1.buffers[_.buffer], (_.byteOffset || 0) + v, 3 * c.count), I = new Uint32Array(e1.buffers[m.buffer], (m.byteOffset || 0) + b, h.count), T = new xy;
                if (T.serializeFromGltf(w, E, A, I), void 0 !== i && e1.json.meshes && e1.json.meshes[i]) {
                    const t1 = e1.json.meshes[i].primitives[0];
                    if (t1 && void 0 !== t1.attributes.POSITION && t1.attributes.POSITION < s.length) {
                        const i = s[t1.attributes.POSITION];
                        if (void 0 !== i.bufferView && i.bufferView < d.length) {
                            const t1 = d[i.bufferView];
                            if (t1.buffer < e1.buffers.length) {
                                const n = i.byteOffset || 0, r = t1.byteStride ? t1.byteStride / 4 : 3;
                                if (g(n, i.count * r * 4, t1.byteLength)) {
                                    const o = (t1.byteOffset || 0) + n;
                                    if (3 === r) T.setVertices(new Float32Array(e1.buffers[t1.buffer], o, 3 * i.count));
                                    else {
                                        const n = new Float32Array(e1.buffers[t1.buffer], o, i.count * r), a = new Float32Array(3 * i.count);
                                        for(let e1 = 0; e1 < i.count; e1++)a[3 * e1] = n[e1 * r], a[3 * e1 + 1] = n[e1 * r + 1], a[3 * e1 + 2] = n[e1 * r + 2];
                                        T.setVertices(a);
                                    }
                                }
                            }
                        }
                    }
                }
                return T;
            }(t1, e1.extensions.mbx_bvh, s)), !d.meshBVH && d.children) {
                for (const e1 of d.children)if (e1.meshBVH) {
                    d.meshBVH = e1.meshBVH;
                    break;
                }
            }
            return d;
        }
        function Ay(e1) {
            if (0 === e1.vertices.length || 0 === e1.indices.length) return null;
            const t1 = new Vg(e1.vertices, e1.indices, 8, 256), [i, n] = [
                t1.min.clone(),
                t1.max.clone()
            ];
            return {
                vertices: e1.vertices,
                indices: e1.indices,
                grid: t1,
                min: i,
                max: n
            };
        }
        function Iy(e1) {
            if (!e1.extras || !e1.extras.ground) return null;
            const t1 = e1.extras.ground;
            if (!t1 || !Array.isArray(t1) || 0 === t1.length) return null;
            const i = t1[0];
            if (!i || !Array.isArray(i) || 0 === i.length) return null;
            const n = [];
            for (const e1 of i){
                if (!Array.isArray(e1) || 2 !== e1.length) continue;
                const t1 = e1[0], i = e1[1];
                "number" == typeof t1 && "number" == typeof i && n.push(new Pe(t1, i));
            }
            if (n.length < 3) return null;
            n.length > 1 && n.at(-1).equals(n[0]) && n.pop();
            let r = 0;
            for(let e1 = 0; e1 < n.length; e1++){
                const t1 = n[e1], i = n[(e1 + 1) % n.length], o = n[(e1 + 2) % n.length];
                r += (t1.x - i.x) * (o.y - i.y) - (o.x - i.x) * (t1.y - i.y);
            }
            r > 0 && n.reverse();
            const o = Ml(n.flatMap((e1)=>[
                    e1.x,
                    e1.y
                ]), []);
            return 0 === o.length ? null : {
                vertices: n,
                indices: o
            };
        }
        function Ty(e1, t1) {
            const i = [], n = [];
            let r = 0;
            const o = [];
            for (const a of e1){
                r = i.length;
                const e1 = a.vertexArray.float32, s = a.indexArray.uint16;
                for(let n = 0; n < a.vertexArray.length; n++)o[0] = e1[3 * n + 0], o[1] = e1[3 * n + 1], o[2] = e1[3 * n + 2], Y(o, o, t1), i.push(new Pe(o[0], o[1]));
                for(let e1 = 0; e1 < 3 * a.indexArray.length; e1++)n.push(s[e1] + r);
            }
            if (n.length % 3 != 0) return null;
            for(let e1 = 0; e1 < n.length; e1 += 3){
                const t1 = i[n[e1 + 0]], r = i[n[e1 + 1]], o = i[n[e1 + 2]];
                (t1.x - r.x) * (o.y - r.y) - (o.x - r.x) * (t1.y - r.y) > 0 && ([n[e1 + 1], n[e1 + 2]] = [
                    n[e1 + 2],
                    n[e1 + 1]
                ]);
            }
            return {
                vertices: i,
                indices: n
            };
        }
        function My(e1, t1) {
            for(let i = 0; i < e1.length; i++)if (e1[i].name === t1) return i;
            return -1;
        }
        function Sy(e1) {
            const t1 = function(e1, t1) {
                const i = [], n = WebGL2RenderingContext;
                if (e1.json.textures) for (const r of e1.json.textures){
                    const o = {
                        magFilter: n.LINEAR,
                        minFilter: n.NEAREST,
                        wrapS: n.REPEAT,
                        wrapT: n.REPEAT
                    };
                    void 0 !== r.sampler && Object.assign(o, e1.json.samplers[r.sampler]), i.push({
                        image: t1[r.source],
                        sampler: o,
                        uploaded: !1
                    });
                }
                return i;
            }(e1, e1.images), i = function(e1, t1) {
                const i = [];
                if (!e1.json.meshes) return i;
                for (const n of e1.json.meshes){
                    const r = [];
                    for (const i of n.primitives)r.push(wy(i, e1, t1));
                    i.push(r);
                }
                return i;
            }(e1, t1), { scenes: n, scene: r, nodes: o } = e1.json;
            let a = n ? My(n, "Default Scene") : -1;
            a < 0 && (a = r || 0);
            const s = n && n[a] ? n[a].nodes || [] : [
                ...o.keys()
            ], l = [];
            for (const t1 of s)l.push(Ey(o[t1], e1, i));
            !function(e1, t1, i) {
                const n = {}, r = new Set;
                for(let o = 0; o < e1.length; o++){
                    const e1 = i[t1[o]];
                    if (!e1.extras) continue;
                    const a = e1.extras["mapbox:footprint:version"], s = e1.extras["mapbox:footprint:id"];
                    (a || s) && r.add(o), "1.0.0" === a && s && (n[s] = o);
                }
                for(let o = 0; o < e1.length; o++){
                    if (r.has(o)) continue;
                    const a = e1[o], s = i[t1[o]];
                    if (!s.extras) continue;
                    let l = null;
                    a.id in n && (l = Ty(e1[n[a.id]].meshes, a.localMatrix)), l || (l = Iy(s)), l && (a.footprint = Ay(l));
                }
                if (r.size > 0) {
                    const t1 = Array.from(r.values()).sort((e1, t1)=>e1 - t1);
                    for(let i = t1.length - 1; i >= 0; i--)e1.splice(t1[i], 1);
                }
            }(l, s, e1.json.nodes);
            const u = n ? My(n, "LOD") : -1;
            if (u >= 0) {
                const t1 = n[u].nodes, r = new Map;
                for (const n of t1){
                    const t1 = Ey(o[n], e1, i);
                    t1.id && r.set(t1.id, t1);
                }
                for (const e1 of l)if (e1.id) {
                    const t1 = r.get(e1.id);
                    t1 && t1.meshes && (e1.lodMeshes = t1.meshes, t1.meshBVH && (e1.meshBVH = t1.meshBVH));
                }
            }
            return l;
        }
        function zy(e1) {
            e1.heightmap = new Float32Array(4096), e1.heightmap.fill(-1);
            const t1 = e1.vertexArray.float32, i = e1.aabb.min[0] - 1, n = e1.aabb.min[1] - 1, r = oy / (e1.aabb.max[0] - i + 2), o = oy / (e1.aabb.max[1] - n + 2);
            for(let a = 0; a < t1.length; a += 3){
                const s = t1[a + 2], l = (t1[a + 0] - i) * r | 0, u = (t1[a + 1] - n) * o | 0;
                s > e1.heightmap[u * oy + l] && (e1.heightmap[u * oy + l] = s);
            }
        }
        function Ry(e1, t1, i, n, r) {
            i.reserve(i.length + 4 * e1.length), n.reserve(n.length + 10 * e1.length), r.reserve(r.length + 10 * e1.length);
            let o = n.length;
            for (const a of e1){
                const e1 = Math.min(10, Math.max(4, 1.3 * a.height)) * t1, s = [
                    -a.normal[1],
                    a.normal[0],
                    0
                ], l = Math.min(.29, .1 * a.width / a.depth), u = a.width - 2 * a.depth * t1 * (l + .01), c = U([], a.pos, s, u / 2), h = U([], a.pos, s, -u / 2), d = [
                    c[0],
                    c[1],
                    c[2] + a.height
                ], f = [
                    h[0],
                    h[1],
                    h[2] + a.height
                ], p = U([], a.normal, s, l);
                k(p, p, e1);
                const _ = U([], a.normal, s, -l);
                k(_, _, e1), O(p, c, p), O(_, h, _), c[2] += .1, h[2] += .1, n.emplaceBack(p[0], p[1], p[2]), n.emplaceBack(_[0], _[1], _[2]), n.emplaceBack(c[0], c[1], c[2]), n.emplaceBack(h[0], h[1], h[2]), n.emplaceBack(d[0], d[1], d[2]), n.emplaceBack(f[0], f[1], f[2]), n.emplaceBack(c[0], c[1], c[2]), n.emplaceBack(h[0], h[1], h[2]), n.emplaceBack(p[0], p[1], p[2]), n.emplaceBack(_[0], _[1], _[2]);
                const m = u / e1 / 2;
                r.emplaceBack(-m - l, -1, m, .8), r.emplaceBack(m + l, -1, m, .8), r.emplaceBack(-m, 0, m, 1.3), r.emplaceBack(m, 0, m, 1.3), r.emplaceBack(m + l, -0.8, m, .7), r.emplaceBack(m + l, -0.8, m, .7), r.emplaceBack(0, 0, m, 1.3), r.emplaceBack(0, 0, m, 1.3), r.emplaceBack(m + l, -1.2, m, .8), r.emplaceBack(m + l, -1.2, m, .8), i.emplaceBack(6 + o, 4 + o, 8 + o), i.emplaceBack(7 + o, 9 + o, 5 + o), i.emplaceBack(0 + o, 1 + o, 2 + o), i.emplaceBack(1 + o, 3 + o, 2 + o), o += 10;
            }
        }
        function Py(e1, t1) {
            const i = {};
            i.indexArray = new oc, i.vertexArray = new Zu, i.colorArray = new Ku, i.indexArray.reserveExact(4 * e1.length), i.vertexArray.reserveExact(10 * e1.length), i.colorArray.reserveExact(10 * e1.length), Ry(e1, t1, i.indexArray, i.vertexArray, i.colorArray);
            const n = {
                defined: !0
            };
            n.emissiveFactor = pn.black;
            const r = {};
            return r.baseColorFactor = pn.white, n.pbrMetallicRoughness = r, i.material = n, i.aabb = new If([
                1 / 0,
                1 / 0,
                1 / 0
            ], [
                -1 / 0,
                -1 / 0,
                -1 / 0
            ]), i;
        }
        Ha(xy, "ModelBVH");
        const Dy = Ou([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), Cy = Ou([
            {
                name: "a_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), Fy = Ou([
            {
                name: "a_centroid_3",
                components: 3,
                type: "Int16"
            }
        ]), Oy = Ou([
            {
                name: "a_part_color_emissive",
                components: 2,
                type: "Uint16"
            }
        ]), Ly = Ou([
            {
                name: "a_faux_facade_color_emissive",
                components: 2,
                type: "Uint16"
            }
        ]), By = Ou([
            {
                name: "a_faux_facade_data",
                components: 4,
                type: "Uint16"
            }
        ]), Ny = Ou([
            {
                name: "a_faux_facade_vertical_range",
                components: 2,
                type: "Uint16"
            }
        ]), Vy = Ou([
            {
                name: "a_bloom_attenuation",
                components: 4,
                type: "Float32"
            }
        ]), ky = Ou([
            {
                name: "a_flood_light_wall_radius_1i16",
                components: 1,
                type: "Int16"
            }
        ]), Uy = Ou([
            {
                name: "a_pos_normal_ed",
                components: 4,
                type: "Int16"
            }
        ]), Gy = Ou([
            {
                name: "a_pos_end",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_angular_offset_factor",
                components: 1,
                type: "Int16"
            }
        ]), jy = Ou([
            {
                name: "a_flood_light_ground_radius",
                components: 1,
                type: "Float32"
            }
        ]), Hy = Ou([
            {
                name: "a_centroid_pos",
                components: 2,
                type: "Uint16"
            }
        ]), $y = Ou([
            {
                name: "a_join_normal_inside",
                components: 3,
                type: "Int16"
            }
        ]), Zy = Ou([
            {
                name: "a_hidden_by_landmark",
                components: 1,
                type: "Uint8"
            }
        ]), Wy = Ou([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), { members: qy } = Uy;
        function Xy(e1, t1, i, n) {
            const r = [], o = 0 === n ? (e1, t1, i, n, r, o)=>{
                e1.push(new Pe(o, i + (o - t1) / (n - t1) * (r - i)));
            } : (e1, t1, i, n, r, o)=>{
                e1.push(new Pe(t1 + (o - i) / (r - i) * (n - t1), o));
            };
            for (const a of e1){
                const e1 = [];
                for (const r of a){
                    if (r.length <= 2) continue;
                    const a = [];
                    for(let e1 = 0; e1 < r.length - 1; e1++){
                        const s = r[e1].x, l = r[e1].y, u = r[e1 + 1].x, c = r[e1 + 1].y, h = 0 === n ? s : l, d = 0 === n ? u : c;
                        h < t1 ? d > t1 && o(a, s, l, u, c, t1) : h > i ? d < i && o(a, s, l, u, c, i) : a.push(r[e1]), d < t1 && h >= t1 && o(a, s, l, u, c, t1), d > i && h <= i && o(a, s, l, u, c, i);
                    }
                    let s = r.at(-1);
                    const l = 0 === n ? s.x : s.y;
                    l >= t1 && l <= i && a.push(s), a.length && (s = a.at(-1), a[0].x === s.x && a[0].y === s.y || a.push(a[0]), e1.push(a));
                }
                e1.length && r.push(e1);
            }
            return r;
        }
        const Yy = {
            None: 0,
            Model: 1,
            Symbol: 2,
            FillExtrusion: 4
        }, Jy = [
            new Pe(0, 0),
            new Pe(Sr, 0),
            new Pe(Sr, Sr),
            new Pe(0, Sr)
        ];
        function Ky(e1, t1) {
            const i = [];
            let n = [];
            if (!t1 || e1.length < 2) return [
                e1
            ];
            if (2 === e1.length) return $h(e1[0], e1[1], Jy) ? [
                e1
            ] : [];
            for(let t1 = 0; t1 < e1.length + 2; t1++){
                const r = 0 === t1 ? e1.at(-1) : e1[(t1 - 1) % e1.length], o = e1[t1 % e1.length], a = e1[(t1 + 1) % e1.length], s = $h(r, o, Jy), l = $h(o, a, Jy), u = s || l;
                u && n.push(o), u && l || n.length > 0 && (n.length > 1 && i.push(n), n = []);
            }
            return n.length > 1 && i.push(n), i;
        }
        const Qy = Mh.types, ex = [
            "fill-extrusion-base",
            "fill-extrusion-height",
            "fill-extrusion-color",
            "fill-extrusion-pattern",
            "fill-extrusion-flood-light-wall-radius",
            "fill-extrusion-line-width",
            "fill-extrusion-emissive-strength"
        ], tx = [
            "fill-extrusion-flood-light-ground-radius"
        ], ix = Math.pow(2, 13), nx = Math.pow(2, 15) - 1, rx = new Pe(0, 1), ox = 2147483648, ax = 1073741824;
        function sx(e1, t1, i, n, r, o, a, s) {
            e1.emplaceBack((t1 << 1) + a, (i << 1) + o, (Math.floor(n * ix) << 1) + r, Math.round(s));
        }
        function lx(e1, t1, i) {
            e1.emplaceBack(t1.x * Sr, t1.y * Sr, i ? 1 : 0);
        }
        function ux(e1, t1, i, n, r, o) {
            e1.emplaceBack(t1.x, t1.y, (i.x << 1) + n, (i.y << 1) + r, o);
        }
        function cx(e1, t1, i) {
            const n = 16384;
            e1.emplaceBack(t1.x, t1.y, t1.z, i[0] * n, i[1] * n, i[2] * n);
        }
        class hx {
            constructor(){
                this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
            }
        }
        class dx {
            constructor(){
                this.data = [];
            }
            get length() {
                return this.data.length;
            }
            push(e1) {
                this.data.push(e1);
            }
            get(e1) {
                return this.data[e1];
            }
            static serialize(e1, t1) {
                const i = e1.data.length, n = new Uint32Array(4 * i), r = [];
                r.length = i;
                for(let t1 = 0; t1 < i; t1++){
                    const i = e1.data[t1], o = 4 * t1;
                    n[o] = i.vertexOffset, n[o + 1] = i.vertexCount, n[o + 2] = i.indexOffset, n[o + 3] = i.indexCount, r[t1] = i.ringIndices;
                }
                return t1 && t1.add(n.buffer), {
                    scalars: n,
                    rings: r
                };
            }
            static deserialize(e1) {
                const { scalars: t1, rings: i } = e1, n = t1.length / 4, r = new dx, o = [];
                o.length = n, r.data = o;
                for(let e1 = 0; e1 < n; e1++){
                    const n = 4 * e1, o = new hx;
                    o.vertexOffset = t1[n], o.vertexCount = t1[n + 1], o.indexOffset = t1[n + 2], o.indexCount = t1[n + 3], o.ringIndices = i[e1], r.data[e1] = o;
                }
                return r;
            }
        }
        class fx {
            constructor(){
                this.centroidXY = new Pe(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new Pe(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new Pe(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0, this.buildingId = 0, this.groupCentroidPos = new Pe(0, 0);
            }
            span() {
                return new Pe(this.max.x - this.min.x, this.max.y - this.min.y);
            }
        }
        class px {
            constructor(){
                this.data = [], this.buffer = null;
            }
            get length() {
                return this.data.length;
            }
            push(e1) {
                this.data.push(e1);
            }
            get(e1) {
                return this.data[e1];
            }
            find(e1) {
                return this.data.find(e1);
            }
            [Symbol.iterator]() {
                return this.data[Symbol.iterator]();
            }
            static serialize(e1, t1) {
                const i = e1.data.length, n = new Float64Array(15 * i);
                for(let t1 = 0; t1 < i; t1++){
                    const i = e1.data[t1], r = 15 * t1;
                    n[r] = i.centroidXY.x, n[r + 1] = i.centroidXY.y, n[r + 2] = i.min.x, n[r + 3] = i.min.y, n[r + 4] = i.max.x, n[r + 5] = i.max.y, n[r + 6] = i.groupCentroidPos.x, n[r + 7] = i.groupCentroidPos.y, n[r + 8] = i.vertexArrayOffset, n[r + 9] = i.vertexCount, n[r + 10] = i.groundVertexArrayOffset, n[r + 11] = i.groundVertexCount, n[r + 12] = i.footprintSegLen, n[r + 13] = i.height, n[r + 14] = i.buildingId;
                }
                return t1 && t1.add(n.buffer), {
                    buffer: n
                };
            }
            static deserialize(e1) {
                const t1 = e1.buffer, i = t1.length / 15, n = new px;
                n.buffer = t1;
                const r = [];
                r.length = i, n.data = r;
                let o = 0;
                for(let e1 = 0; e1 < i; e1++){
                    const i = 15 * e1, r = new fx;
                    r.centroidXY = new Pe(t1[i], t1[i + 1]), r.min = new Pe(t1[i + 2], t1[i + 3]), r.max = new Pe(t1[i + 4], t1[i + 5]), r.groupCentroidPos = new Pe(t1[i + 6], t1[i + 7]), r.vertexArrayOffset = t1[i + 8], r.vertexCount = t1[i + 9], r.groundVertexArrayOffset = t1[i + 10], r.groundVertexCount = t1[i + 11], r.footprintSegLen = t1[i + 12], r.height = t1[i + 13], r.buildingId = t1[i + 14], r.footprintSegIdx = o, o += r.footprintSegLen, n.data[e1] = r;
                }
                return n;
            }
        }
        class _x {
            constructor(){
                this.acc = new Pe(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
            }
            startRing(e1, t1) {
                e1.min.x === Number.MAX_VALUE && (e1.min.x = e1.max.x = t1.x, e1.min.y = e1.max.y = t1.y);
            }
            appendEdge(e1, t1, i) {
                this.accCount++, this.acc._add(t1);
                let n = !!this.borders;
                t1.x < e1.min.x ? (e1.min.x = t1.x, n = !0) : t1.x > e1.max.x && (e1.max.x = t1.x, n = !0), t1.y < e1.min.y ? (e1.min.y = t1.y, n = !0) : t1.y > e1.max.y && (e1.max.y = t1.y, n = !0), ((0 === t1.x || t1.x === Sr) && t1.x === i.x) != ((0 === t1.y || t1.y === Sr) && t1.y === i.y) && this.processBorderOverlap(t1, i), n && this.checkBorderIntersection(t1, i);
            }
            checkBorderIntersection(e1, t1) {
                t1.x < 0 != e1.x < 0 && this.addBorderIntersection(0, dn(t1.y, e1.y, (0 - t1.x) / (e1.x - t1.x))), t1.x > Sr != e1.x > Sr && this.addBorderIntersection(1, dn(t1.y, e1.y, (Sr - t1.x) / (e1.x - t1.x))), t1.y < 0 != e1.y < 0 && this.addBorderIntersection(2, dn(t1.x, e1.x, (0 - t1.y) / (e1.y - t1.y))), t1.y > Sr != e1.y > Sr && this.addBorderIntersection(3, dn(t1.x, e1.x, (Sr - t1.y) / (e1.y - t1.y)));
            }
            addBorderIntersection(e1, t1) {
                this.borders || (this.borders = [
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ]
                ]);
                const i = this.borders[e1];
                t1 < i[0] && (i[0] = t1), t1 > i[1] && (i[1] = t1);
            }
            processBorderOverlap(e1, t1) {
                if (e1.x === t1.x) {
                    if (e1.y === t1.y) return;
                    const i = 0 === e1.x ? 0 : 1;
                    this.addBorderIntersection(i, t1.y), this.addBorderIntersection(i, e1.y);
                } else {
                    const i = 0 === e1.y ? 2 : 3;
                    this.addBorderIntersection(i, t1.x), this.addBorderIntersection(i, e1.x);
                }
            }
            centroid() {
                return 0 === this.accCount ? new Pe(0, 0) : new Pe(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
            }
            intersectsCount() {
                return this.borders ? this.borders.reduce((e1, t1)=>e1 + +(t1[0] !== Number.MAX_VALUE), 0) : 0;
            }
        }
        function mx(e1, t1) {
            const i = e1.add(t1)._unit(), n = tt(e1.x * i.x + e1.y * i.y, -1, 1);
            var r, o, a;
            return a = Math.acos(n), Math.min(4, Math.max(-4, Math.tan(a))) / 4 * nx * ((r = e1).x * (o = t1).y - r.y * o.x < 0 ? -1 : 1);
        }
        const gx = [
            (e1)=>e1.x < 0,
            (e1)=>e1.x > Sr,
            (e1)=>e1.y < 0,
            (e1)=>e1.y > Sr
        ];
        function yx(e1, t1, i, n) {
            const r = [
                4
            ];
            if (0 === n) return r;
            i._mult(n);
            const o = e1.sub(i), a = t1.sub(i), s = [
                e1,
                t1,
                o,
                a
            ];
            for(let e1 = 0; e1 < 4; e1++)for (const t1 of s)if (gx[e1](t1)) {
                r.push(e1);
                break;
            }
            return r;
        }
        class xx {
            constructor(e1){
                this.groundRadiusArray = null, this.groundRadiusBuffer = null, this.vertexArray = new Hu, this.indexArray = new oc, this.programConfigurations = new ch(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }, (e1)=>tx.includes(e1)), this._segments = new Bc, this.hiddenByLandmarkVertexArray = new xc, this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [
                    0,
                    0,
                    0,
                    0,
                    0
                ], this.regionSegments = {}, this.regionSegments[4] = new Bc;
            }
            getDefaultSegment() {
                return this.regionSegments[4];
            }
            hasData() {
                return 0 !== this.vertexArray.length;
            }
            addData(e1, t1, i, n = !1) {
                const r = e1.length;
                if (r > 2) {
                    let o = Math.max(0, this._segments.get().length - 1);
                    const a = this._segments._prepareSegment(4 * r, this.vertexArray.length, 2 * this._segmentToGroundQuads[o].length);
                    let s;
                    o !== this._segments.get().length - 1 && (o++, this._segmentToGroundQuads[o] = [], this._segmentToRegionTriCounts[o] = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ]);
                    {
                        const t1 = e1[0], i = e1[1];
                        s = mx(t1.sub(e1[r - 1])._perp()._unit(), i.sub(t1)._perp()._unit());
                    }
                    for(let l = 0; l < r; l++){
                        const u = l === r - 1 ? 0 : l + 1, c = e1[l], h = e1[u], d = e1[u === r - 1 ? 0 : u + 1], f = h.sub(c)._perp()._unit(), p = mx(f, d.sub(h)._perp()._unit()), _ = s, m = p;
                        if (Mx(c, h, t1) || n && Sx(c, t1) && Sx(h, t1)) {
                            s = p;
                            continue;
                        }
                        const g = a.vertexLength;
                        ux(this.vertexArray, c, h, 1, 1, _), ux(this.vertexArray, c, h, 1, 0, _), ux(this.vertexArray, c, h, 0, 1, m), ux(this.vertexArray, c, h, 0, 0, m), a.vertexLength += 4;
                        const y = yx(c, h, f, i);
                        for (const e1 of y)this._segmentToGroundQuads[o].push({
                            id: g,
                            region: e1
                        }), this._segmentToRegionTriCounts[o][e1] += 2, a.primitiveLength += 2;
                        s = p;
                    }
                }
            }
            prepareBorderSegments() {
                if (!this.hasData()) return;
                const e1 = this._segments.get(), t1 = e1.length;
                for(let e1 = 0; e1 < t1; e1++)this._segmentToGroundQuads[e1].sort((e1, t1)=>e1.region - t1.region);
                for(let i = 0; i < t1; i++){
                    const t1 = this._segmentToGroundQuads[i], n = e1[i], r = this._segmentToRegionTriCounts[i];
                    r.reduce((e1, t1)=>e1 + t1, 0);
                    let o = 0;
                    for(let e1 = 0; e1 <= 4; e1++){
                        const t1 = r[e1];
                        if (0 !== t1) {
                            let i = this.regionSegments[e1];
                            i || (i = this.regionSegments[e1] = new Bc);
                            const r = {
                                vertexOffset: n.vertexOffset,
                                primitiveOffset: n.primitiveOffset + o,
                                vertexLength: n.vertexLength,
                                primitiveLength: t1
                            };
                            i.get().push(r);
                        }
                        o += t1;
                    }
                    for(let e1 = 0; e1 < t1.length; e1++){
                        const i = t1[e1].id;
                        this.indexArray.emplaceBack(i, i + 1, i + 3), this.indexArray.emplaceBack(i, i + 3, i + 2);
                    }
                }
                this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
            }
            addPaintPropertiesData(e1, t1, i, n, r, o, a) {
                this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, e1, t1, i, n, r, o, void 0, a);
            }
            upload(e1) {
                this.hasData() && (this.vertexBuffer = e1.createVertexBuffer(this.vertexArray, Gy.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), null != this.groundRadiusArray && (this.groundRadiusBuffer = e1.createVertexBuffer(this.groundRadiusArray, jy.members)));
            }
            uploadPaintProperties(e1) {
                this.hasData() && this.programConfigurations.upload(e1);
            }
            update(e1, t1, i, n, r, o, a, s) {
                this.hasData() && this.programConfigurations.updatePaintArrays(e1, t1, i, n, r, o, a, s);
            }
            updateHiddenByLandmark(e1) {
                this.updateHiddenByLandmarkRange(e1.groundVertexArrayOffset, e1.groundVertexCount, !!(e1.flags & ox || e1.flags & ax));
            }
            updateHiddenByLandmarkRange(e1, t1, i) {
                if (!this.hasData()) return;
                const n = t1 + e1;
                if (0 !== t1) {
                    for(let t1 = e1; t1 < n; ++t1)this.hiddenByLandmarkVertexArray.emplace(t1, i ? 1 : 0);
                    this._needsHiddenByLandmarkUpdate = !0;
                }
            }
            uploadHiddenByLandmark(e1) {
                this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = e1.createVertexBuffer(this.hiddenByLandmarkVertexArray, Zy.members, !0) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = !1);
            }
            destroy() {
                if (this.vertexBuffer) {
                    this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this.groundRadiusBuffer && this.groundRadiusBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
                    for(let e1 = 0; e1 <= 4; e1++){
                        const t1 = this.regionSegments[e1];
                        t1 && t1.destroy();
                    }
                }
            }
        }
        class vx {
            constructor(e1){
                this.zoom = e1.zoom, this.canonical = e1.canonical, this.overscaling = e1.overscaling, this.layers = e1.layers, this.pixelRatio = e1.pixelRatio, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = e1.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = new px, this.footprintIndices = new oc, this.footprintVertices = new Bu, this.footprintSegments = new dx, this.layoutVertexArray = new ju, this.centroidVertexArray = new Rc, this.wallVertexArray = new Dc, this.indexArray = new oc, this.programConfigurations = new ch(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }, (e1)=>ex.includes(e1)), this.segments = new Bc, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.groundEffect = new xx(e1), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [], this.buildingGroups = new Map, this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                this.features = [], this.hasPattern = eu("fill-extrusion", this.layers, this.pixelRatio, t1), this.featuresOnBorder = [], this.borderFeatureIndices = [
                    [],
                    [],
                    [],
                    []
                ], this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ], this.selfDEMTileTimestamp = Number.MAX_VALUE, this.borderDEMTileTimestamp = [
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE
                ], this.tileToMeter = vu(i), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter, this.wallMode = 0 !== this.layers[0].paint.get("fill-extrusion-line-width").constantOr(1);
                for (const { feature: r, id: o, index: a, sourceLayerIndex: s } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, l = Ru(r, e1);
                    if (!this.layers[0]._featureFilter.filter(new ks(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), l, i)) continue;
                    const u = {
                        id: o,
                        sourceLayerIndex: s,
                        index: a,
                        geometry: e1 ? l.geometry : zu(r, i, n),
                        properties: r.properties,
                        type: r.type,
                        patterns: {}
                    }, c = this.layoutVertexArray.length, h = "Polygon" === Qy[u.type];
                    if (this.hasPattern) this.features.push({
                        featureId: r.id,
                        feature: tu("fill-extrusion", this.layers, u, this.zoom, this.pixelRatio, t1)
                    });
                    else if (this.wallMode) for (const e1 of u.geometry)for (const o of Ky(e1, h))this.addFeature(r.id, u, [
                        o
                    ], a, i, {}, t1.availableImages, n, t1.brightness);
                    else this.addFeature(r.id, u, u.geometry, a, i, {}, t1.availableImages, n, t1.brightness);
                    t1.featureIndex.insert(r, u.geometry, a, s, this.index, c);
                }
                this._finalizeBuildingGroups(), this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
            }
            addFeatures(e1, t1, i, n, r, o) {
                for (const { featureId: e1, feature: a } of this.features){
                    const s = "Polygon" === Qy[a.type], { geometry: l } = a;
                    if (this.wallMode) for (const u of l)for (const l of Ky(u, s))this.addFeature(e1, a, [
                        l
                    ], a.index, t1, i, n, r, o);
                    else this.addFeature(e1, a, l, a.index, t1, i, n, r, o);
                }
                this._finalizeBuildingGroups(), this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
            }
            update(e1, t1, i, n, r, o, a) {
                this.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, this.worldview), this.groundEffect.update(e1, t1, r, i, n, o, a, this.worldview);
            }
            updateExpressions(e1) {
                this.programConfigurations.updateExpressions(e1), this.groundEffect.programConfigurations.updateExpressions(e1);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, qy), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.wallVertexBuffer = e1.createVertexBuffer(this.wallVertexArray, $y.members), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = e1.createVertexBuffer(this.layoutVertexExtArray, Wy.members, !0)), this.groundEffect.upload(e1)), this.groundEffect.uploadPaintProperties(e1), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            uploadCentroid(e1) {
                this.groundEffect.uploadHiddenByLandmark(e1), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = e1.createVertexBuffer(this.centroidVertexArray, Hy.members, !0) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = !1);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(e1, t1, i, n, r, o, a, s, l) {
                const u = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(t1, {}) / this.tileToMeter, c = [
                    new Pe(0, 0),
                    new Pe(Sr, Sr)
                ], h = s.projection, d = "globe" === h.name, f = this.wallMode || "Polygon" === Qy[t1.type], p = new _x;
                p.centroidDataIndex = this.centroidData.length;
                const _ = new fx;
                _.buildingId = e1, t1.properties && Object.hasOwn(t1.properties, "building_id") && (_.buildingId = Number(t1.properties.building_id)), p.buildingId = _.buildingId;
                const m = this.layers[0].paint.get("fill-extrusion-base").evaluate(t1, {}, r) <= 0, g = this.layers[0].paint.get("fill-extrusion-height").evaluate(t1, {}, r);
                let y;
                if (_.height = g, _.vertexArrayOffset = this.layoutVertexArray.length, _.groundVertexArrayOffset = this.groundEffect.vertexArray.length, d && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new Xu), this.wallMode) {
                    if (d) return void mt("Non zero fill-extrusion-line-width is not yet supported on globe.");
                    if (1 !== i.length) return;
                    y = function(e1) {
                        const t1 = e1[0].x === e1.at(-1).x && e1[0].y === e1.at(-1).y, i = function(e1) {
                            let t1 = 0;
                            const i = e1.length;
                            for(let n = 0; n < i; n++)t1 += (e1[(n + 1) % i].x - e1[n].x) * (e1[(n + 1) % i].y + e1[n].y);
                            return t1 >= 0;
                        }(e1);
                        i || (e1 = e1.reverse());
                        const n = {
                            geometry: [],
                            joinNormals: [],
                            indices: []
                        }, r = [], o = [], a = [];
                        let s = e1.length;
                        for(; s >= 2 && e1[s - 1].equals(e1[s - 2]);)s--;
                        if (s < (t1 ? 3 : 2)) return n;
                        let l, u, c, h, d, f = 0;
                        for(; f < s - 1 && e1[f].equals(e1[f + 1]);)f++;
                        t1 && (l = e1[s - 2], d = e1[f].sub(l)._unit()._perp());
                        for(let i = f; i < s; i++){
                            if (c = i === s - 1 ? t1 ? e1[f + 1] : void 0 : e1[i + 1], c && e1[i].equals(c)) continue;
                            d && (h = d), l && (u = l), l = e1[i], d = c ? c.sub(l)._unit()._perp() : h, h = h || d;
                            let n = h.add(d);
                            0 === n.x && 0 === n.y || n._unit();
                            const p = n.x * d.x + n.y * d.y, _ = 0 !== p ? 1 / p : 1 / 0, m = h.x * d.y - h.y * d.x > 0;
                            let g = "miter";
                            const y = 2;
                            "miter" === g && _ > y && (g = "bevel"), "bevel" === g && (_ > 100 && (g = "flipbevel"), _ < y && (g = "miter"));
                            const x = (e1, t1, i, n)=>{
                                const s = new Pe(e1.x, e1.y), l = new Pe(e1.x, e1.y);
                                s.x += t1.x * n, s.y += t1.y * n, l.x -= t1.x * Math.max(i, 1), l.y -= t1.y * Math.max(i, 1), a.push(t1), r.push(s), o.push(l);
                            };
                            if ("miter" === g) n._mult(_), x(l, n, 0, 0);
                            else if ("flipbevel" === g) n = d.mult(-1), x(l, n, 0, 0), x(l, n.mult(-1), 0, 0);
                            else {
                                const e1 = -Math.sqrt(_ * _ - 1), t1 = m ? e1 : 0, i = m ? 0 : e1;
                                u && x(l, h, t1, i), c && x(l, d, t1, i);
                            }
                        }
                        n.geometry = [
                            ...r,
                            ...o.reverse(),
                            r[0]
                        ], n.joinNormals = [
                            ...a,
                            ...a.reverse(),
                            a.at(-1)
                        ];
                        const p = n.geometry.length - 1;
                        for(let e1 = 0; e1 < p / 2; e1++)if (e1 + 1 < p / 2) {
                            let t1 = e1, i = e1 + 1, r = p - 1 - e1, o = p - 2 - e1;
                            t1 = 0 === t1 ? p - 1 : t1 - 1, i = 0 === i ? p - 1 : i - 1, r = 0 === r ? p - 1 : r - 1, o = 0 === o ? p - 1 : o - 1, n.indices.push(r), n.indices.push(i), n.indices.push(t1), n.indices.push(r), n.indices.push(o), n.indices.push(i);
                        }
                        return n;
                    }(i[0]), i = [
                        y.geometry
                    ];
                }
                const x = (e1, t1)=>e1 < (t1.length - 1) / 2 || e1 === t1.length - 1, v = this.wallMode ? [
                    i
                ] : Ne(i, 500);
                for(let e1 = v.length - 1; e1 >= 0; e1--){
                    const t1 = v[e1];
                    (0 === t1.length || zx(t1[0])) && v.splice(e1, 1);
                }
                let b;
                if (d) b = Cx(v, c, r);
                else {
                    b = [];
                    for (const e1 of v)b.push({
                        polygon: e1,
                        bounds: c
                    });
                }
                const w = f ? this.edgeRadius : 0, E = w > 0 && this.zoom < 17, A = (e1, t1)=>{
                    if (0 === e1.length) return !1;
                    const i = e1.at(-1);
                    return t1.x === i.x && t1.y === i.y;
                };
                for (const { polygon: e1, bounds: t1 } of b){
                    let i = 0, n = 0;
                    for (const t1 of e1)f && !t1[0].equals(t1.at(-1)) && t1.push(t1[0]), n += f ? t1.length - 1 : t1.length;
                    const o = this.segments.prepareSegment((f ? 5 : 4) * n, this.layoutVertexArray, this.indexArray);
                    _.footprintSegIdx < 0 && (_.footprintSegIdx = this.footprintSegments.length), _.polygonSegIdx < 0 && (_.polygonSegIdx = this.polygonSegments.length);
                    const a = {
                        triangleArrayOffset: this.indexArray.length,
                        triangleCount: 0,
                        triangleSegIdx: this.segments.segments.length - 1
                    }, s = new hx;
                    if (s.vertexOffset = this.footprintVertices.length, s.indexOffset = 3 * this.footprintIndices.length, s.ringIndices = [], f) {
                        const n = [], a = [];
                        i = o.vertexLength;
                        for(let i = 0; i < e1.length; i++){
                            const l = e1[i];
                            l.length && 0 !== i && a.push(n.length / 2);
                            const c = [];
                            let f, p;
                            f = l[1].sub(l[0])._perp()._unit(), s.ringIndices.push(l.length - 1);
                            for(let e1 = 1; e1 < l.length; e1++){
                                const t1 = l[e1], i = l[e1 === l.length - 1 ? 1 : e1 + 1], a = t1.clone();
                                if (w) {
                                    p = wx(t1, i, f);
                                    const e1 = Ex(f, p), n = Ax(f, p), r = w * Math.min(4, 1 / n);
                                    a.x += r * e1.x, a.y += r * e1.y, a.x = Math.round(a.x), a.y = Math.round(a.y), f = p;
                                }
                                if (!m || 0 !== w && !E || A(c, a) || c.push(a), sx(this.layoutVertexArray, a.x, a.y, 0, 0, 1, 1, 0), this.wallMode) {
                                    const t1 = x(e1, l);
                                    lx(this.wallVertexArray, y.joinNormals[e1], !t1);
                                }
                                o.vertexLength++, this.footprintVertices.emplaceBack(t1.x, t1.y), n.push(t1.x, t1.y), d && cx(this.layoutVertexExtArray, h.projectTilePoint(a.x, a.y, r), h.upVector(r, a.x, a.y));
                            }
                            m && (0 === w || E) && (0 !== c.length && A(c, c[0]) && c.pop(), this.groundEffect.addData(c, t1, u));
                        }
                        const l = this.wallMode ? y.indices : Ml(n, a);
                        for(let e1 = 0; e1 < l.length; e1 += 3)this.footprintIndices.emplaceBack(s.vertexOffset + l[e1 + 0], s.vertexOffset + l[e1 + 1], s.vertexOffset + l[e1 + 2]), this.indexArray.emplaceBack(i + l[e1], i + l[e1 + 2], i + l[e1 + 1]), o.primitiveLength++;
                        s.indexCount += l.length, s.vertexCount += this.footprintVertices.length - s.vertexOffset;
                    }
                    for(let n = 0; n < e1.length; n++){
                        const a = e1[n];
                        p.startRing(_, a[0]);
                        let s = a.length > 4 && Rx(a[a.length - 2], a[0], a[1]), l = w ? Ix(a[a.length - 2], a[0], a[1], w) : 0;
                        const c = [];
                        let g, v, b;
                        v = a[1].sub(a[0])._perp()._unit();
                        let E = !0;
                        for(let e1 = 1, n = 0; e1 < a.length; e1++){
                            let u = a[e1 - 1], f = a[e1];
                            const I = a[e1 === a.length - 1 ? 1 : e1 + 1];
                            if (p.appendEdge(_, f, u), Mx(f, u, t1)) {
                                w && (v = I.sub(f)._perp()._unit(), E = !E);
                                continue;
                            }
                            const T = f.sub(u)._perp(), M = T.x / (Math.abs(T.x) + Math.abs(T.y)), S = T.y > 0 ? 1 : 0, z = u.dist(f);
                            if (n + z > 32768 && (n = 0), w) {
                                b = wx(f, I, v);
                                let e1 = Tx(u, f, I, Ax(v, b), w);
                                isNaN(e1) && (e1 = 0);
                                const t1 = bx(u, f, new Pe(0, 0));
                                u = u.add(t1.mult(l))._round(), f = f.add(t1.mult(-e1))._round(), l = e1, v = b, m && this.zoom >= 17 && (A(c, u) || c.push(u), A(c, f) || c.push(f));
                            }
                            const R = o.vertexLength, P = a.length > 4 && Rx(u, f, I);
                            let D = Px(n, s, E);
                            if (sx(this.layoutVertexArray, u.x, u.y, M, S, 0, 0, D), sx(this.layoutVertexArray, u.x, u.y, M, S, 0, 1, D), this.wallMode) {
                                const t1 = x(e1 - 1, a), i = y.joinNormals[e1 - 1];
                                lx(this.wallVertexArray, i, t1), lx(this.wallVertexArray, i, t1);
                            }
                            if (n += z, D = Px(n, P, !E), s = P, sx(this.layoutVertexArray, f.x, f.y, M, S, 0, 0, D), sx(this.layoutVertexArray, f.x, f.y, M, S, 0, 1, D), this.wallMode) {
                                const t1 = x(e1, a), i = y.joinNormals[e1];
                                lx(this.wallVertexArray, i, t1), lx(this.wallVertexArray, i, t1);
                            }
                            if (o.vertexLength += 4, this.indexArray.emplaceBack(R + 0, R + 1, R + 2), this.indexArray.emplaceBack(R + 1, R + 3, R + 2), o.primitiveLength += 2, w) {
                                const n = i + (1 === e1 ? a.length - 2 : e1 - 2), r = 1 === e1 ? i : n + 1;
                                if (this.indexArray.emplaceBack(R + 1, n, R + 3), this.indexArray.emplaceBack(n, r, R + 3), o.primitiveLength += 2, void 0 === g && (g = R), !Mx(I, a[e1], t1)) {
                                    const t1 = e1 === a.length - 1 ? g : o.vertexLength;
                                    this.indexArray.emplaceBack(R + 2, R + 3, t1), this.indexArray.emplaceBack(R + 3, t1 + 1, t1), this.indexArray.emplaceBack(R + 3, r, t1 + 1), o.primitiveLength += 3;
                                }
                                E = !E;
                            }
                            if (d) {
                                const e1 = this.layoutVertexExtArray, t1 = h.projectTilePoint(u.x, u.y, r), i = h.projectTilePoint(f.x, f.y, r), n = h.upVector(r, u.x, u.y), o = h.upVector(r, f.x, f.y);
                                cx(e1, t1, n), cx(e1, t1, n), cx(e1, i, o), cx(e1, i, o);
                            }
                        }
                        f && (i += a.length - 1), m && w && this.zoom >= 17 && (0 !== c.length && A(c, c[0]) && c.pop(), this.groundEffect.addData(c, t1, u, w > 0));
                    }
                    this.footprintSegments.push(s), a.triangleCount = this.indexArray.length - a.triangleArrayOffset, this.polygonSegments.push(a), ++_.footprintSegLen, ++_.polygonSegLen;
                }
                if (_.vertexCount = this.layoutVertexArray.length - _.vertexArrayOffset, _.groundVertexCount = this.groundEffect.vertexArray.length - _.groundVertexArrayOffset, 0 !== _.vertexCount) {
                    if (_.centroidXY = p.borders ? rx : this.encodeCentroid(p, _), t1.properties && Object.hasOwn(t1.properties, "building_id")) {
                        const e1 = _.buildingId;
                        let t1 = this.buildingGroups.get(e1);
                        t1 || (t1 = {
                            accX: 0,
                            accY: 0,
                            accCount: 0,
                            mergedMin: new Pe(Number.MAX_VALUE, Number.MAX_VALUE),
                            mergedMax: new Pe(-Number.MAX_VALUE, -Number.MAX_VALUE),
                            partIndices: []
                        }, this.buildingGroups.set(e1, t1)), t1.accX += p.acc.x, t1.accY += p.acc.y, t1.accCount += p.accCount, t1.mergedMin.x = Math.min(t1.mergedMin.x, _.min.x), t1.mergedMin.y = Math.min(t1.mergedMin.y, _.min.y), t1.mergedMax.x = Math.max(t1.mergedMax.x, _.max.x), t1.mergedMax.y = Math.max(t1.mergedMax.y, _.max.y), t1.partIndices.push(this.centroidData.length);
                    }
                    if (this.centroidData.push(_), p.borders) {
                        this.featuresOnBorder.push(p);
                        const e1 = this.featuresOnBorder.length - 1;
                        for(let t1 = 0; t1 < p.borders.length; t1++)p.borders[t1][0] !== Number.MAX_VALUE && this.borderFeatureIndices[t1].push(e1);
                    }
                    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, n, o, a, r, l, void 0, this.worldview), this.groundEffect.addPaintPropertiesData(t1, n, o, a, r, l, this.worldview), this.maxHeight = Math.max(this.maxHeight, g);
                }
            }
            _finalizeBuildingGroups() {
                for (const [, e1] of this.buildingGroups){
                    if (0 === e1.partIndices.length) continue;
                    const t1 = new _x;
                    t1.acc = new Pe(e1.accX, e1.accY), t1.accCount = e1.accCount;
                    const i = new fx;
                    i.min = e1.mergedMin, i.max = e1.mergedMax;
                    const n = this.encodeCentroid(t1, i), r = t1.centroid();
                    for (const t1 of e1.partIndices){
                        const i = this.centroidData.get(t1);
                        i.centroidXY.x === rx.x && i.centroidXY.y === rx.y || (i.centroidXY = n), i.min = e1.mergedMin, i.max = e1.mergedMax, i.groupCentroidPos = r;
                    }
                }
                this.buildingGroups.clear();
            }
            sortBorders() {
                for(let e1 = 0; e1 < this.borderFeatureIndices.length; e1++)this.borderFeatureIndices[e1].sort((t1, i)=>this.featuresOnBorder[t1].borders[e1][0] - this.featuresOnBorder[i].borders[e1][0]);
            }
            splitToSubtiles() {
                const e1 = [];
                for(let t1 = 0; t1 < this.centroidData.length; t1++){
                    const i = this.centroidData.get(t1), n = +(i.min.y + i.max.y > Sr), r = 2 * n + (+(i.min.x + i.max.x > Sr) ^ n);
                    for(let n = 0; n < i.polygonSegLen; n++){
                        const o = i.polygonSegIdx + n;
                        e1.push({
                            centroidIdx: t1,
                            subtile: r,
                            polygonSegmentIdx: o,
                            triangleSegmentIdx: this.polygonSegments[o].triangleSegIdx
                        });
                    }
                }
                const t1 = new oc;
                e1.sort((e1, t1)=>e1.triangleSegmentIdx === t1.triangleSegmentIdx ? e1.subtile - t1.subtile : e1.triangleSegmentIdx - t1.triangleSegmentIdx);
                let i = 0, n = 0, r = 0;
                for (const t1 of e1){
                    if (t1.triangleSegmentIdx !== i) break;
                    r++;
                }
                const o = e1.length;
                for(; n !== e1.length;){
                    i = e1[n].triangleSegmentIdx;
                    let a = 0, s = n, l = n;
                    for(let t1 = s; t1 < r && e1[t1].subtile === a; t1++)l++;
                    for(; s !== r;){
                        const n = e1[s];
                        a = n.subtile;
                        const o = this.centroidData.get(n.centroidIdx).min.clone(), u = this.centroidData.get(n.centroidIdx).max.clone(), c = {
                            vertexOffset: this.segments.segments[i].vertexOffset,
                            primitiveOffset: t1.length,
                            vertexLength: this.segments.segments[i].vertexLength,
                            primitiveLength: 0,
                            sortKey: void 0,
                            vaos: {}
                        };
                        for(let i = s; i < l; i++){
                            const n = e1[i], r = this.polygonSegments[n.polygonSegmentIdx], a = this.centroidData.get(n.centroidIdx).min, s = this.centroidData.get(n.centroidIdx).max, l = this.indexArray.uint16;
                            for(let e1 = r.triangleArrayOffset; e1 < r.triangleArrayOffset + r.triangleCount; e1++)t1.emplaceBack(l[3 * e1], l[3 * e1 + 1], l[3 * e1 + 2]);
                            c.primitiveLength += r.triangleCount, o.x = Math.min(o.x, a.x), o.y = Math.min(o.y, a.y), u.x = Math.max(u.x, s.x), u.y = Math.max(u.y, s.y);
                        }
                        c.primitiveLength > 0 && this.triangleSubSegments.push({
                            segment: c,
                            min: o,
                            max: u
                        }), s = l;
                        for(let t1 = s; t1 < r && e1[t1].subtile === e1[s].subtile; t1++)l++;
                    }
                    n = r;
                    for(let t1 = n; t1 < o && e1[t1].triangleSegmentIdx === e1[n].triangleSegmentIdx; t1++)r++;
                }
                t1._trim(), this.indexArray = t1;
            }
            getVisibleSegments(e1, t1, i) {
                const n = new Bc;
                if (this.wallMode) {
                    for (const e1 of this.triangleSubSegments)n.segments.push(e1.segment);
                    return n;
                }
                let r = 0, o = 0;
                const a = 1 << e1.canonical.z;
                if (t1) {
                    const i = t1.getMinMaxForTile(e1);
                    i && (r = i.min, o = i.max);
                }
                o += this.maxHeight;
                const s = e1.toUnwrapped();
                let l;
                const u = [
                    s.canonical.x / a + s.wrap,
                    s.canonical.y / a
                ], c = [
                    (s.canonical.x + 1) / a + s.wrap,
                    (s.canonical.y + 1) / a
                ], h = (e1, t1, i)=>[
                        dn(e1[0], t1[0], i[0]),
                        dn(e1[1], t1[1], i[1])
                    ], d = [], f = [];
                for (const e1 of this.triangleSubSegments){
                    d[0] = e1.min.x / Sr, d[1] = e1.min.y / Sr, f[0] = e1.max.x / Sr, f[1] = e1.max.y / Sr;
                    const t1 = h(u, c, d), a = h(u, c, f);
                    if (0 === new If([
                        t1[0],
                        t1[1],
                        r
                    ], [
                        a[0],
                        a[1],
                        o
                    ]).intersectsPrecise(i)) {
                        l && (n.segments.push(l), l = void 0);
                        continue;
                    }
                    const s = e1.segment;
                    l && l.vertexOffset !== s.vertexOffset && (n.segments.push(l), l = void 0), l ? (l.vertexLength += s.vertexLength, l.primitiveLength += s.primitiveLength) : l = {
                        vertexOffset: s.vertexOffset,
                        primitiveLength: s.primitiveLength,
                        vertexLength: s.vertexLength,
                        primitiveOffset: s.primitiveOffset,
                        sortKey: void 0,
                        vaos: {}
                    };
                }
                return l && n.segments.push(l), n;
            }
            encodeCentroid(e1, t1) {
                const i = e1.centroid(), n = t1.span(), r = Math.min(7, Math.round(n.x * this.tileToMeter / 10)), o = Math.min(6, Math.round(n.y * this.tileToMeter / 10));
                return new Pe(tt(i.x, 1, 8191) << 3 | r, tt(i.y, 1, 8191) << 3 | o);
            }
            encodeBorderCentroid(e1) {
                if (!e1.borders) return new Pe(0, 0);
                const t1 = e1.borders, i = Number.MAX_VALUE;
                if (t1[0][0] !== i || t1[1][0] !== i) {
                    const e1 = t1[0][0] !== i ? 0 : 1;
                    return new Pe(6 | (t1[0][0] !== i ? 0 : 65528), (t1[e1][0] + t1[e1][1]) / 2 << 3 | 6);
                }
                {
                    const e1 = t1[2][0] !== i ? 2 : 3;
                    return new Pe((t1[e1][0] + t1[e1][1]) / 2 << 3 | 6, 6 | (t1[2][0] !== i ? 0 : 65528));
                }
            }
            showCentroid(e1) {
                const t1 = this.centroidData.get(e1.centroidDataIndex);
                if (t1.flags &= ox, 0 !== t1.groupCentroidPos.x || 0 !== t1.groupCentroidPos.y) {
                    const e1 = t1.span(), i = Math.min(7, Math.round(e1.x * this.tileToMeter / 10)), n = Math.min(6, Math.round(e1.y * this.tileToMeter / 10));
                    t1.centroidXY = new Pe(tt(t1.groupCentroidPos.x, 1, 8191) << 3 | i, tt(t1.groupCentroidPos.y, 1, 8191) << 3 | n);
                } else t1.centroidXY = new Pe(0, 0);
                this.writeCentroidToBuffer(t1);
            }
            writeCentroidToBuffer(e1) {
                this.groundEffect.updateHiddenByLandmark(e1);
                const t1 = e1.vertexArrayOffset, i = e1.vertexCount + e1.vertexArrayOffset, n = -1073741824 & e1.flags ? rx : e1.centroidXY, r = this.centroidVertexArray.geta_centroid_pos0(t1);
                if (this.centroidVertexArray.geta_centroid_pos1(t1) !== n.y || r !== n.x) {
                    for(let e1 = t1; e1 < i; ++e1)this.centroidVertexArray.emplace(e1, n.x, n.y);
                    this.needsCentroidUpdate = !0;
                }
            }
            createCentroidsBuffer() {
                this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const e1 of this.centroidData)this.writeCentroidToBuffer(e1);
            }
            updateReplacement(e1, t1, i) {
                if (t1.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t1.updateTime;
                const n = t1.getReplacementRegionsForTile(e1.toUnwrapped());
                if (Dp(this.activeReplacements, n)) return;
                if (this.activeReplacements = n, 0 === this.centroidVertexArray.length) this.createCentroidsBuffer();
                else for (const e1 of this.centroidData)e1.flags &= 1073741823;
                const r = [];
                for (const t1 of this.activeReplacements){
                    if (t1.order < i) continue;
                    const n = Math.max(1, Math.pow(2, t1.footprintTileId.canonical.z - e1.canonical.z));
                    if (t1.footprint.buildingIds) for (const e1 of this.centroidData)e1.flags & ox || e1.flags & ax || t1.min.x > e1.max.x || e1.min.x > t1.max.x || t1.min.y > e1.max.y || e1.min.y > t1.max.y || t1.footprint.buildingIds.has(e1.buildingId) && (e1.flags |= t1.clipMask !== Yy.None ? -1073741824 : ox);
                    else for (const i of this.centroidData)if (!(i.flags & ox || i.flags & ax || t1.min.x > i.max.x || i.min.x > t1.max.x || t1.min.y > i.max.y || i.min.y > t1.max.y)) for(let o = 0; o < i.footprintSegLen; o++){
                        const a = this.footprintSegments.get(i.footprintSegIdx + o);
                        if (r.length = 0, Fx(this.footprintVertices, a.vertexOffset, a.vertexCount, t1.footprintTileId.canonical, e1.canonical, r), Op(t1.footprint, r, this.footprintIndices.uint16, a.indexOffset, a.indexCount, -a.vertexOffset, -n)) {
                            i.flags |= t1.clipMask !== Yy.None ? -1073741824 : ox;
                            break;
                        }
                    }
                }
                for (const e1 of this.centroidData)this.writeCentroidToBuffer(e1);
                this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ];
            }
            footprintContainsPoint(e1, t1, i) {
                let n = !1;
                for(let r = 0; r < i.footprintSegLen; r++){
                    const o = this.footprintSegments.get(i.footprintSegIdx + r);
                    let a = 0;
                    for (const i of o.ringIndices){
                        for(let r = a, s = i + a - 1; r < i + a; s = r++){
                            const i = this.footprintVertices.int16[2 * (r + o.vertexOffset) + 0], a = this.footprintVertices.int16[2 * (r + o.vertexOffset) + 1], l = this.footprintVertices.int16[2 * (s + o.vertexOffset) + 1];
                            a > t1 != l > t1 && e1 < (this.footprintVertices.int16[2 * (s + o.vertexOffset) + 0] - i) * (t1 - a) / (l - a) + i && (n = !n);
                        }
                        a = i;
                    }
                }
                return n;
            }
            getHeightAtTileCoord(e1, t1) {
                let i = Number.NEGATIVE_INFINITY, n = !0;
                const r = 4 * (e1 + Sr) * Sr + (t1 + Sr);
                if (Object.hasOwn(this.partLookup, r)) {
                    const e1 = this.partLookup[r];
                    return e1 ? {
                        height: e1.height,
                        hidden: !!(e1.flags & ox)
                    } : void 0;
                }
                const o = this.centroidData.buffer, a = this.centroidData.length;
                for(let s = 0; s < a; s++){
                    const a = 15 * s;
                    if (e1 > o[a + 4] || o[a + 2] > e1 || t1 > o[a + 5] || o[a + 3] > t1) continue;
                    const l = o[a + 13];
                    if (l <= i) continue;
                    const u = this.centroidData.get(s);
                    this.footprintContainsPoint(e1, t1, u) && (i = l, this.partLookup[r] = u, n = !!(u.flags & ox));
                }
                if (i !== Number.NEGATIVE_INFINITY) return {
                    height: i,
                    hidden: n
                };
                this.partLookup[r] = void 0;
            }
        }
        function bx(e1, t1, i) {
            return e1.equals(t1) ? i : t1.sub(e1)._unit();
        }
        function wx(e1, t1, i) {
            return e1.equals(t1) ? i : t1.sub(e1)._perp()._unit();
        }
        function Ex(e1, t1) {
            const i = e1.add(t1), n = i.mag();
            return 0 === n ? e1 : i.div(n);
        }
        function Ax(e1, t1) {
            const i = Ex(e1, t1);
            return e1.x * i.x + e1.y * i.y;
        }
        function Ix(e1, t1, i, n) {
            let r, o;
            return e1.equals(t1) ? (o = wx(t1, i, new Pe(0, 0)), r = o) : (r = t1.sub(e1)._perp()._unit(), o = wx(t1, i, r)), Tx(e1, t1, i, Ax(r, o), n);
        }
        function Tx(e1, t1, i, n, r) {
            const o = Math.sqrt(1 - n * n);
            return Math.min(e1.dist(t1) / 3, t1.dist(i) / 3, r * o / n);
        }
        function Mx(e1, t1, i) {
            return e1.x < i[0].x && t1.x < i[0].x || e1.x > i[1].x && t1.x > i[1].x || e1.y < i[0].y && t1.y < i[0].y || e1.y > i[1].y && t1.y > i[1].y;
        }
        function Sx(e1, t1) {
            return e1.x < t1[0].x || e1.x > t1[1].x || e1.y < t1[0].y || e1.y > t1[1].y;
        }
        function zx(e1) {
            return e1.every((e1)=>e1.x <= 0) || e1.every((e1)=>e1.x >= Sr) || e1.every((e1)=>e1.y <= 0) || e1.every((e1)=>e1.y >= Sr);
        }
        function Rx(e1, t1, i) {
            if (e1.x < 0 || e1.x >= Sr || t1.x < 0 || t1.x >= Sr || i.x < 0 || i.x >= Sr) return !1;
            const n = i.sub(t1), r = n.perp(), o = e1.sub(t1);
            return (n.x * o.x + n.y * o.y) / Math.sqrt((n.x * n.x + n.y * n.y) * (o.x * o.x + o.y * o.y)) > -0.866 && r.x * o.x + r.y * o.y < 0;
        }
        function Px(e1, t1, i) {
            const n = t1 ? 2 | e1 : -3 & e1;
            return i ? 1 | n : -2 & n;
        }
        function Dx() {
            const e1 = Math.PI / 32, t1 = Math.tan(e1), i = uu;
            return i * Math.sqrt(1 + 2 * t1 * t1) - i;
        }
        function Cx(e1, t1, i) {
            const n = 1 << i.z, r = fr(i.x / n), o = fr((i.x + 1) / n), a = pr(i.y / n), s = pr((i.y + 1) / n);
            return function(e1, t1, i, n, r = 0, o) {
                const a = [];
                if (!e1.length || !i || !n) return a;
                const s = (e1, t1)=>{
                    for (const i of e1)a.push({
                        polygon: i,
                        bounds: t1
                    });
                }, l = Math.ceil(Math.log2(i)), u = Math.ceil(Math.log2(n)), c = l - u, h = [];
                for(let e1 = 0; e1 < Math.abs(c); e1++)h.push(c > 0 ? 0 : 1);
                for(let e1 = 0; e1 < Math.min(l, u); e1++)h.push(0), h.push(1);
                let d = e1;
                if (d = Xy(d, t1[0].y - r, t1[1].y + r, 1), d = Xy(d, t1[0].x - r, t1[1].x + r, 0), !d.length) return a;
                const f = [];
                for(h.length ? f.push({
                    polygons: d,
                    bounds: t1,
                    depth: 0
                }) : s(d, t1); f.length;){
                    const e1 = f.pop(), t1 = e1.depth, i = h[t1], n = e1.bounds[0], a = e1.bounds[1], l = 0 === i ? n.x : n.y, u = 0 === i ? a.x : a.y, c = o ? o(i, l, u) : .5 * (l + u), d = Xy(e1.polygons, l - r, c + r, i), p = Xy(e1.polygons, c - r, u + r, i);
                    if (d.length) {
                        const e1 = [
                            n,
                            new Pe(0 === i ? c : a.x, 1 === i ? c : a.y)
                        ];
                        h.length > t1 + 1 ? f.push({
                            polygons: d,
                            bounds: e1,
                            depth: t1 + 1
                        }) : s(d, e1);
                    }
                    if (p.length) {
                        const e1 = [
                            new Pe(0 === i ? c : n.x, 1 === i ? c : n.y),
                            a
                        ];
                        h.length > t1 + 1 ? f.push({
                            polygons: p,
                            bounds: e1,
                            depth: t1 + 1
                        }) : s(p, e1);
                    }
                }
                return a;
            }(e1, t1, Math.ceil((o - r) / 11.25), Math.ceil((a - s) / 11.25), 1, (e1, t1, r)=>{
                if (0 === e1) return .5 * (t1 + r);
                {
                    const e1 = pr((i.y + t1 / Sr) / n);
                    return (dr(.5 * (pr((i.y + r / Sr) / n) + e1)) * n - i.y) * Sr;
                }
            });
        }
        function Fx(e1, t1, i, n, r, o) {
            const a = Math.pow(2, n.z - r.z);
            for(let s = 0; s < i; s++){
                let i = e1.int16[2 * (s + t1) + 0], l = e1.int16[2 * (s + t1) + 1];
                i = (i + r.x * Sr) * a - n.x * Sr, l = (l + r.y * Sr) * a - n.y * Sr, o.push(new Pe(i, l));
            }
        }
        Ha(vx, "FillExtrusionBucket", {
            omit: [
                "layers",
                "features"
            ]
        }), Ha(fx, "PartData"), Ha(px, "PartDataArray"), Ha(dx, "FootprintSegmentArray"), Ha(_x, "BorderCentroidData"), Ha(xx, "GroundEffect");
        const Ox = 4096;
        class Lx {
            constructor(e1){
                this.module = e1, this.memoryStack = this.module.malloc(Ox), this.memoryStackNextFree = this.memoryStack;
            }
            createIntArray(e1) {
                const t1 = this.memoryStackNextFree;
                return this.memoryStackNextFree += e1.length * Int32Array.BYTES_PER_ELEMENT, this.memoryStackNextFree - this.memoryStack > Ox ? -1 : (new Int32Array(this.module.heap32.buffer, t1, e1.length).set(e1), t1);
            }
            createFloatArray(e1) {
                const t1 = this.memoryStackNextFree;
                return this.memoryStackNextFree += e1.length * Float32Array.BYTES_PER_ELEMENT, this.memoryStackNextFree - this.memoryStack > Ox ? -1 : (new Float32Array(this.module.heapF32.buffer, t1, e1.length).set(e1), t1);
            }
            readStringBuffer(e1) {
                let t1 = "";
                for(; 0 !== this.module.heapU8[e1];)t1 += String.fromCharCode(this.module.heapU8[e1]), ++e1;
                return t1;
            }
            setStyle(e1) {
                const t1 = e1.normalScale;
                this.module.setStyle(t1[0], t1[1], t1[2], e1.tileToMeters);
            }
            setAOOptions(e1, t1) {
                this.module.setAOOptions(e1 ? 1 : 0, t1);
            }
            setMetricOptions(e1, t1) {
                this.module.setMetricOptions(e1 ? 1 : 0, t1);
            }
            setStructuralOptions(e1) {
                this.module.setStructuralOptions(e1 ? 1 : 0);
            }
            setFacadeOptions(e1, t1) {
                this.module.setFacadeOptions(e1, t1 ? 1 : 0);
            }
            setFauxFacadeOptions(e1, t1, i) {
                this.module.setFauxFacadeOptions(e1 ? 1 : 0, t1 ? 1 : 0, i);
            }
            setFacadeClassifierOptions(e1) {
                this.module.setFacadeClassifierOptions(e1);
            }
            generateMesh(e1, t1) {
                this.memoryStackNextFree = this.memoryStack;
                for (const t1 of e1){
                    const e1 = this.createIntArray(t1.ringIndices), i = this.createFloatArray(t1.coordinates);
                    if (-1 === e1 || -1 === i) return `building_gen: Out of stack memory: ${this.memoryStackNextFree - this.memoryStack}/4096`;
                    this.module.addFeature(t1.id, t1.sourceId, t1.minHeight, t1.height, t1.roofType, i, e1, t1.ringIndices.length - 1);
                }
                for (const e1 of t1){
                    let t1;
                    t1 = e1.entrances ? JSON.parse(e1.entrances) : [];
                    const i = this.createFloatArray(t1), n = this.createFloatArray(e1.coordinates);
                    if (-1 === i || -1 === n) return `building_gen: Out of stack memory: ${this.memoryStackNextFree - this.memoryStack}/4096`;
                    this.module.addFacade(e1.sourceId, e1.crossPerc, e1.distanceToRoad, i, t1.length, n, e1.coordinates.length);
                }
                if (!this.module.generateMesh()) {
                    const e1 = this.module.getLastError();
                    return this.readStringBuffer(e1);
                }
                const i = this.module.getMeshCount(), n = new Array(i);
                for(let e1 = 0; e1 < i; e1++){
                    const t1 = this.module.getPositionsPtr(e1), i = this.module.getPositionsLength(e1), r = new Float32Array(this.module.heapF32.buffer, t1, i), o = this.module.getNormalsPtr(e1), a = this.module.getNormalsLength(e1), s = new Float32Array(this.module.heapF32.buffer, o, a), l = this.module.getAOPtr(e1), u = this.module.getAOLength(e1), c = new Float32Array(this.module.heapF32.buffer, l, u), h = this.module.getUVPtr(e1), d = this.module.getUVLength(e1), f = new Float32Array(this.module.heapF32.buffer, h, d), p = this.module.getFauxFacadePtr(e1), _ = this.module.getFauxFacadeLength(e1), m = new Uint8Array(this.module.heapU8.buffer, p, _), g = this.module.getIndicesPtr(e1), y = this.module.getIndicesLength(e1), x = new Int16Array(this.module.heap16.buffer, g, y), v = this.module.getBuildingPart(e1);
                    n[e1] = {
                        positions: r,
                        normals: s,
                        ao: c,
                        uv: f,
                        isFauxFacade: m,
                        indices: x,
                        buildingPart: v
                    };
                }
                const r = this.module.getRingCount(), o = [];
                for(let e1 = 0; e1 < r; e1++){
                    const t1 = this.module.getRingPtr(e1), i = this.module.getRingLength(e1), n = new Float32Array(this.module.heapF32.buffer, t1, i);
                    o.push(n);
                }
                return {
                    meshes: n,
                    outerRingLength: this.module.getOuterRingLength(),
                    modifiedPolygonRings: o
                };
            }
        }
        const Bx = Mh.types, Nx = 32767;
        function Vx(e1, t1) {
            const i = Sr + t1;
            for (const n of e1)for (const e1 of n)if (e1.x < -t1 || e1.x > i || e1.y < -t1 || e1.y > i) return !1;
            return !0;
        }
        function kx(e1) {
            switch(e1){
                case "flat":
                    return 3;
                case "hipped":
                    return 1;
                case "gabled":
                    return 2;
                case "parapet":
                    return 0;
                case "mansard":
                    return 4;
                case "skillion":
                    return 5;
                case "pyramidal":
                    return 6;
                default:
                    throw new Error(`Unknown roof shape: ${e1}`);
            }
        }
        let Ux, Gx, jx = null, Hx = null, $x = null;
        class Zx {
            constructor(){
                this.layoutVertexArray = new Zu, this.layoutAttenuationArray = new Ku, this.layoutColorArray = new ec, this.indexArray = new oc, this.indexArrayForConflation = new oc, this.segmentsBucket = new Bc;
            }
        }
        class Wx {
            constructor(e1){
                this.layoutFacadePaintArray = null, this.layoutFacadeDataArray = null, this.layoutFacadeVerticalRangeArray = null, this.segmentsBucket = new Bc, this.entranceBloom = new Zx;
                const t1 = 66560;
                this.layoutVertexArray = new Zu, this.layoutVertexArray.reserve(t1), this.layoutNormalArray = new Nu, this.layoutNormalArray.reserve(t1), this.layoutCentroidArray = new Nu, this.layoutCentroidArray.reserve(t1), this.layoutColorArray = new ec, this.layoutColorArray.reserve(t1), this.layoutFloodLightDataArray = new yc, this.layoutFloodLightDataArray.reserve(t1), this.layoutAOArray = new xc, this.layoutAOArray.reserve(t1), this.indexArray = new oc, this.indexArray.reserve(66560), this.indexArrayForConflation = new oc, this.segmentsBucket = new Bc, this.entranceBloom = new Zx, e1 && (this.layoutFacadePaintArray = new ec, this.layoutFacadeDataArray = new qu, this.layoutFacadeVerticalRangeArray = new ec);
            }
            reserve(e1, t1, i) {
                this.layoutVertexArray.reserveForAdditional(e1), this.layoutCentroidArray.reserveForAdditional(e1), this.layoutFloodLightDataArray.reserveForAdditional(e1), this.layoutNormalArray.reserveForAdditional(e1), this.layoutAOArray.reserveForAdditional(e1), this.layoutColorArray.reserveForAdditional(e1), this.indexArray.reserveForAdditional(t1), i && (this.layoutFacadePaintArray.reserveForAdditional(e1), this.layoutFacadeDataArray.reserveForAdditional(e1), this.layoutFacadeVerticalRangeArray.reserveForAdditional(e1));
            }
        }
        class qx {
            constructor(e1){
                this.requiresHDRuntime = !0, this.colorBufferUploaded = !1, this.maxHeight = 0, this.replacementUpdateTime = 0, this.activeReplacements = [], this.footprints = [], this.footprintsVertices = new fc, this.footprintsIndices = new _c, this.footprintsMin = new Pe(1 / 0, 1 / 0), this.footprintsMax = new Pe(-1 / 0, -1 / 0), this.featuresOnBorder = [], this.buildingWithoutFacade = new Wx(!1), this.buildingWithFacade = new Wx(!0), this.indexArrayForConflationUploaded = !1, this.featureFootprintLookup = new Map, this.buildingIds = new Set, this.footprintLookup = {}, this.zoom = e1.zoom, this.canonical = e1.canonical, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.worldview = e1.worldview, this.lut = e1.lut, this.programConfigurations = new ch(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.projection = e1.projection, this.groundEffect = new xx(e1), this.groundEffect.groundRadiusArray = new ku, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {
                const i = new Vg([], [], 1), n = {
                    vertices: [],
                    indices: new Uint32Array(0),
                    grid: i,
                    min: this.footprintsMin,
                    max: this.footprintsMax,
                    buildingIds: this.buildingIds
                };
                t1.push({
                    footprint: n,
                    id: e1
                });
            }
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                if (!$x) return;
                const r = vu(i);
                this.tileToMeter = r, this.brightness = t1.brightness, $x.setStyle({
                    normalScale: [
                        1,
                        -1,
                        r
                    ],
                    tileToMeters: r
                }), $x.setAOOptions(!1, .3), $x.setMetricOptions(!1, 16), $x.setStructuralOptions(!0), $x.setFacadeClassifierOptions(3);
                const o = new Map, a = new Map;
                let s = 0;
                for (const { feature: t1 } of e1){
                    if ("LineString" !== Bx[t1.type]) {
                        o.set(t1.id, t1.properties.source_id);
                        continue;
                    }
                    const e1 = this.layers[0]._featureFilter.needGeometry;
                    if (e1 && !this.layers[0]._featureFilter.filter(new ks(this.zoom), t1, i)) continue;
                    const r = Ru(t1, e1);
                    if (!e1 && !this.layers[0]._featureFilter.filter(new ks(this.zoom), r, i)) continue;
                    const l = e1 ? r.geometry : zu(t1, i, n), u = [];
                    for (const e1 of l)for (const t1 of e1)u.push(t1.x), u.push(t1.y);
                    const c = {
                        coordinates: u,
                        crossPerc: t1.properties.cross_perc,
                        distanceToRoad: t1.properties.distance_to_road,
                        entrances: t1.properties.entrances,
                        sourceId: 0
                    }, h = t1.properties.source_id;
                    let d = a.get(h);
                    d || (d = [], a.set(h, d)), d.push(c), ++s;
                }
                this.maxHeight = 0;
                const l = new Array, u = new Set, c = (e1)=>{
                    null != e1 && u.add(e1);
                }, h = (e1, t1)=>{
                    null != e1 && l.push({
                        buildingId: e1,
                        footprintIndex: t1
                    });
                }, d = 64 * (e1.length - s), f = d / 2;
                this.buildingWithFacade.reserve(d, f, !0), this.buildingWithoutFacade.reserve(2 * d, 2 * f, !1), this.footprintsIndices.reserve(16 * (e1.length - s)), this.footprintsVertices.reserve(8 * (e1.length - s));
                for (const { feature: s, id: l, index: d, sourceLayerIndex: f } of e1){
                    if ("LineString" === Bx[s.type]) continue;
                    const e1 = this.layers[0]._featureFilter.needGeometry;
                    if (e1 && !this.layers[0]._featureFilter.filter(new ks(this.zoom), s, i)) continue;
                    let p = null;
                    if (s.properties && Object.hasOwn(s.properties, "building_id") && (p = Number(s.properties.building_id), u.has(p))) continue;
                    const _ = Ru(s, e1);
                    if (!e1 && !this.layers[0]._featureFilter.filter(new ks(this.zoom), _, i)) continue;
                    const m = e1 ? _.geometry : zu(s, i, n), g = Ne(m, 500);
                    let y = !1;
                    for (const e1 of g)if (1 !== e1.length) {
                        y = !0;
                        break;
                    }
                    if (y) {
                        c(p);
                        continue;
                    }
                    if (!Vx(m, 163)) {
                        c(p);
                        continue;
                    }
                    const x = this.layers[0], v = kx(x.layout.get("building-roof-shape").evaluate(s, {}, i)), b = x.layout.get("building-base").evaluate(s, {}, i), w = x.layout.get("building-height").evaluate(s, {}, i), E = x.layout.get("building-flood-light-ground-radius").evaluate(s, {}, i), A = x.paint.get("building-ambient-occlusion-intensity"), I = E / this.tileToMeter;
                    s.properties["building-part"] = "roof";
                    const T = x.paint.get("building-color").evaluate(s, {}, this.canonical).toPremultipliedRenderColor(this.lut), M = x.paint.get("building-emissive-strength").evaluate(s, {}, this.canonical);
                    s.properties["building-part"] = "wall";
                    const S = x.paint.get("building-color").evaluate(s, {}, this.canonical).toPremultipliedRenderColor(this.lut), z = x.paint.get("building-emissive-strength").evaluate(s, {}, this.canonical);
                    s.properties["building-part"] = "window";
                    const R = x.paint.get("building-color").evaluate(s, {}, this.canonical).toPremultipliedRenderColor(this.lut), P = x.paint.get("building-emissive-strength").evaluate(s, {}, this.canonical);
                    s.properties["building-part"] = "door";
                    const D = x.paint.get("building-color").evaluate(s, {}, this.canonical).toPremultipliedRenderColor(this.lut), C = x.paint.get("building-emissive-strength").evaluate(s, {}, this.canonical);
                    let F = x.layout.get("building-flood-light-wall-radius").evaluate(s, {}, i);
                    F = tt(F, 0, 2048);
                    const O = F / 2048 * Nx, L = o.get(l), B = a.get(L) || [], N = 0 !== B.length && x.layout.get("building-facade").evaluate(s, {}, i);
                    $x.setFacadeOptions(4, !0), $x.setFauxFacadeOptions(N, !1, 1);
                    let V = 0, k = 0, U = 0, G = 0, j = 0, H = 0, $ = 0, Z = 0, W = 0, q = 0, X = 0;
                    if (N) {
                        let e1 = Math.round(x.layout.get("building-facade-floors").evaluate(s, {}, i));
                        if (0 === b) {
                            e1 = Math.max(1, e1 - (B.length > 0 ? 1 : 0));
                            let t1 = 4;
                            if (w > 100) {
                                const e1 = [
                                    10,
                                    13,
                                    15
                                ];
                                t1 = e1[s.id ? s.id % e1.length : 0];
                            } else w <= 10 && (t1 = 3);
                            $x.setFacadeOptions(t1, !0), j = (w < 15 ? 1.3 : 1.61803) * t1 / r;
                        } else j = b / r;
                        H = w / r, j = Math.min(j, H), U = x.layout.get("building-facade-unit-width").evaluate(s, {}, i) / r, G = (H - j) / e1, $x.setFauxFacadeOptions(!0, !0, U);
                        const t1 = x.layout.get("building-facade-window").evaluate(s, {}, i);
                        V = t1[0], k = t1[1], $ = Math.floor(65535 * Math.min(1, j / Sr)), Z = Math.floor(65535 * Math.min(1, H / Sr)), W = Math.floor(255 * V) << 8 | Math.floor(255 * k), q = Math.floor(65535 * Math.min(1, U / Sr)), X = Math.floor(65535 * Math.min(1, G / Sr));
                    }
                    const Y = Array(g.length), J = {
                        x: 1 / 0,
                        y: 1 / 0
                    }, K = {
                        x: -1 / 0,
                        y: -1 / 0
                    }, Q = {
                        x: 0,
                        y: 0
                    };
                    let ee = 0;
                    for(let e1 = 0; e1 < g.length; e1++){
                        const t1 = g[e1];
                        if (t1.length > 0) {
                            const i = [], n = Array(t1.length + 1);
                            n[0] = 0;
                            for(let e1 = 0; e1 < t1.length; e1++){
                                const r = t1[e1];
                                for(let e1 = 0; e1 < r.length; e1++){
                                    const t1 = r[r.length - e1 - 1];
                                    J.x = Math.min(J.x, t1.x), J.y = Math.min(J.y, t1.y), K.x = Math.max(K.x, t1.x), K.y = Math.max(K.y, t1.y), Q.x += t1.x, Q.y += t1.y, ee++, i.push(t1.x), i.push(t1.y);
                                }
                                n[e1 + 1] = i.length;
                            }
                            Y[e1] = {
                                id: s.id ? s.id : 0,
                                height: w,
                                minHeight: b,
                                sourceId: 0,
                                roofType: v,
                                coordinates: i,
                                ringIndices: n
                            };
                        }
                    }
                    Q.x /= ee || 1, Q.y /= ee || 1;
                    const te = $x.generateMesh(Y, B);
                    if ("string" == typeof te) {
                        mt(`Unable to generate building ${s.id}: ${te}`), c(p);
                        continue;
                    }
                    if (0 === te.meshes.length || 0 === te.modifiedPolygonRings.length) {
                        c(p);
                        continue;
                    }
                    const ie = N ? this.buildingWithFacade : this.buildingWithoutFacade;
                    let ne = 0;
                    for (const e1 of te.meshes)ne += e1.positions.length / 3;
                    const re = ie.segmentsBucket.prepareSegment(ne, ie.layoutVertexArray, ie.indexArray), oe = [];
                    let ae = null, se = 0, le = -1;
                    const ue = ie.layoutVertexArray.length, ce = ue + ne;
                    ie.layoutVertexArray.resize(ce), ie.layoutCentroidArray.resize(ce), ie.layoutNormalArray.resize(ce), ie.layoutAOArray.resize(ce), ie.layoutColorArray.resize(ce), ie.layoutFloodLightDataArray.resize(ce), N && (ie.layoutFacadePaintArray.resize(ce), ie.layoutFacadeDataArray.resize(ce), ie.layoutFacadeVerticalRangeArray.resize(ce));
                    const he = ie.indexArray.length;
                    let de = 0, fe = ue;
                    for (const e1 of te.meshes){
                        let t1, i;
                        if (1 === e1.buildingPart) t1 = T, i = M;
                        else if (0 === e1.buildingPart) t1 = S, i = z;
                        else if (2 === e1.buildingPart) t1 = R, i = P;
                        else {
                            if (3 !== e1.buildingPart) continue;
                            t1 = D, i = C;
                        }
                        if (i = tt(i, 0, 1), 3 === e1.buildingPart) {
                            const t1 = new Array;
                            for(let i = 0; i < e1.positions.length; i += 12){
                                const n = e1.positions[i + 0], r = e1.positions[i + 1], o = e1.positions[i + 3], a = e1.positions[i + 4], s = e1.positions[i + 2], l = e1.positions[i + 8] - s, u = 1, c = o - n, h = a - r, d = Math.hypot(c, h);
                                t1.push({
                                    pos: [
                                        n + .5 * c,
                                        r + .5 * h,
                                        s
                                    ],
                                    normal: [
                                        h / d,
                                        -c / d,
                                        0
                                    ],
                                    width: d,
                                    height: l,
                                    depth: u,
                                    points: [
                                        n,
                                        r,
                                        o,
                                        a
                                    ]
                                });
                            }
                            const i = ie.entranceBloom.segmentsBucket.prepareSegment(10 * t1.length, ie.entranceBloom.layoutVertexArray, ie.entranceBloom.indexArray), n = ie.entranceBloom.layoutVertexArray.length;
                            se = ie.entranceBloom.indexArray.length, Ry(t1, .5 / this.tileToMeter, ie.entranceBloom.indexArray, ie.entranceBloom.layoutVertexArray, ie.entranceBloom.layoutAttenuationArray);
                            const r = ie.entranceBloom.layoutVertexArray.length - n;
                            le = ie.entranceBloom.indexArray.length - se;
                            for(let e1 = 0; e1 < r; e1++)ie.entranceBloom.layoutColorArray.emplaceBack(255 * D.r << 8 | 255 * D.g, 255 * D.b << 8 | 51 * C);
                            i.vertexLength += r, i.primitiveLength += le, ae = {
                                part: e1.buildingPart,
                                vertexOffset: n,
                                vertexLength: r
                            };
                        }
                        ie.layoutVertexArray.float32.set(e1.positions, 3 * fe);
                        const n = e1.positions.length / 3;
                        for(let r = 0; r < n; ++r){
                            const n = 3 * r;
                            de = Math.max(de, e1.positions[n + 2]);
                            const o = e1.normals[n + 1] * Nx, a = e1.normals[n + 2] * Nx, s = 3 * (fe + r);
                            ie.layoutNormalArray.int16[s] = e1.normals[n] * Nx, ie.layoutNormalArray.int16[s + 1] = o, ie.layoutNormalArray.int16[s + 2] = a;
                            const l = e1.ao[r];
                            ie.layoutAOArray.uint8[fe + r] = 255 * l;
                            const u = 1 + (l - 1) * A, c = 255 * t1.b * u << 8 | 255 * i;
                            ie.layoutColorArray.uint16[2 * (fe + r)] = 255 * t1.r * u << 8 | 255 * t1.g * u, ie.layoutColorArray.uint16[2 * (fe + r) + 1] = c;
                        }
                        const r = Math.min(8191, Math.max(0, Math.floor(Q.x))), o = Math.min(8191, Math.max(0, Math.floor(Q.y))), a = Math.floor(w), s = 20, l = 4 * r + Math.min(3, Math.round((K.x - J.x) * this.tileToMeter / s)), u = 4 * o + Math.min(3, Math.round((K.y - J.y) * this.tileToMeter / s));
                        for(let e1 = 0; e1 < n; ++e1){
                            const t1 = 3 * (fe + e1);
                            ie.layoutCentroidArray.int16[t1] = l, ie.layoutCentroidArray.int16[t1 + 1] = u, ie.layoutCentroidArray.int16[t1 + 2] = a;
                        }
                        if (ie.layoutFloodLightDataArray.int16.fill(0 === e1.buildingPart ? O : 0, fe, fe + n), N) {
                            const t1 = 255 * R.r << 8 | 255 * R.g, i = 255 * R.b << 8 | 255 * P;
                            for(let e1 = 0; e1 < n; ++e1){
                                const n = 2 * (fe + e1);
                                ie.layoutFacadePaintArray.uint16[n] = t1, ie.layoutFacadePaintArray.uint16[n + 1] = i;
                            }
                            for(let t1 = 0; t1 < n; ++t1)if (e1.isFauxFacade[t1]) {
                                const i = Math.min(65535, Math.floor(e1.uv[2 * t1] * te.outerRingLength));
                                ie.layoutFacadeDataArray.emplace(fe + t1, 1 | i, W, q, X), ie.layoutFacadeVerticalRangeArray.emplace(fe + t1, $, Z);
                            } else ie.layoutFacadeDataArray.emplace(fe + t1, 0, 0, 0, 0), ie.layoutFacadeVerticalRangeArray.emplace(fe + t1, 0, 0);
                        }
                        const c = re.vertexLength, h = e1.indices.length / 3, d = ie.indexArray.length;
                        ie.indexArray.resize(d + h);
                        for(let t1 = 0; t1 < h; ++t1){
                            const i = 3 * t1, n = 3 * d + i;
                            ie.indexArray.uint16[n] = c + e1.indices[i], ie.indexArray.uint16[n + 1] = c + e1.indices[i + 1], ie.indexArray.uint16[n + 2] = c + e1.indices[i + 2];
                        }
                        1 !== e1.buildingPart && 0 !== e1.buildingPart && 2 !== e1.buildingPart && 3 !== e1.buildingPart || oe.push({
                            part: e1.buildingPart,
                            vertexOffset: fe,
                            vertexLength: e1.positions.length / 3
                        }), fe += n, re.vertexLength += n, re.primitiveLength += e1.indices.length / 3;
                    }
                    this.maxHeight = Math.max(this.maxHeight, de);
                    const pe = ie.indexArray.length - he, _e = this.footprintsIndices.length, me = this.footprintsVertices.length, ge = [], ye = new Pe(1 / 0, 1 / 0), xe = new Pe(-1 / 0, -1 / 0), ve = this.groundEffect.vertexArray.length;
                    for (const e1 of te.modifiedPolygonRings){
                        const t1 = [], i = new Pe(1 / 0, 1 / 0), n = new Pe(-1 / 0, -1 / 0);
                        for(let r = 0; r < e1.length; r += 2){
                            const o = e1.length - r - 2;
                            i.x = Math.min(i.x, e1[o]), i.y = Math.min(i.y, e1[o + 1]), n.x = Math.max(n.x, e1[o]), n.y = Math.max(n.y, e1[o + 1]);
                            const a = new Pe(e1[o], e1[o + 1]);
                            t1.push(a), ge.push(a.x, a.y), this.footprintsVertices.emplaceBack(a.x, a.y);
                        }
                        ye.x = Math.min(ye.x, i.x), ye.y = Math.min(ye.y, i.y), xe.x = Math.max(xe.x, n.x), xe.y = Math.max(xe.y, n.y), this.groundEffect.addData(t1, [
                            i,
                            n
                        ], I);
                    }
                    const be = this.groundEffect.vertexArray.length - ve;
                    this.groundEffect.groundRadiusArray.reserveForAdditional(be);
                    for(let e1 = 0; e1 < be; e1++)this.groundEffect.groundRadiusArray.emplaceBack(E);
                    (J.x < 0 || K.x > Sr || J.y < 0 || K.y > Sr) && this.featuresOnBorder.push({
                        featureId: s.id,
                        footprintIndex: this.footprints.length
                    });
                    {
                        const e1 = Ml(ge, null, 2);
                        this.footprintsIndices.resize(this.footprintsIndices.length + e1.length), this.footprintsIndices.uint16.set(e1, _e), this.buildingIds.add(p ?? s.id), this.footprintsMin.x = Math.min(this.footprintsMin.x, ye.x), this.footprintsMin.y = Math.min(this.footprintsMin.y, ye.y), this.footprintsMax.x = Math.max(this.footprintsMax.x, xe.x), this.footprintsMax.y = Math.max(this.footprintsMax.y, xe.y);
                        const t1 = {
                            footprintVertexOffset: me,
                            footprintVertexLength: this.footprintsVertices.length - me,
                            footprintIndexOffset: _e,
                            footprintIndexLength: this.footprintsIndices.length - _e,
                            min: ye,
                            max: xe,
                            hiddenFlags: 0,
                            indicesOffset: he,
                            indicesLength: pe,
                            bloomIndicesOffset: se,
                            bloomIndicesLength: le,
                            groundEffectVertexOffset: ve,
                            groundEffectVertexLength: be,
                            hasFauxFacade: N,
                            height: de,
                            promoteId: l,
                            feature: _,
                            parts: oe,
                            buildingBloom: ae
                        }, i = this.footprints.length;
                        void 0 !== s.id && this.featureFootprintLookup.set(s.id, i), h(p, i), this.footprints.push(t1);
                    }
                    this.programConfigurations.populatePaintArrays(ie.layoutVertexArray.length, s, d, {}, t1.availableImages, i, t1.brightness), this.groundEffect.addPaintPropertiesData(s, d, {}, t1.availableImages, i, t1.brightness), t1.featureIndex.insert(s, m, d, f, this.index, ue);
                }
                l.forEach(({ buildingId: e1, footprintIndex: t1 })=>{
                    u.has(e1) && (this.footprints[t1].hiddenFlags |= 4);
                });
                const p = new Set;
                this.buildingIds.forEach((e1, t1, i)=>{
                    u.has(e1) || p.add(e1);
                }), this.buildingIds = p, this.groundEffect.prepareBorderSegments();
            }
            update(e1, t1, i, n, r, o, a) {
                this.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a), this.groundEffect.update(e1, t1, r, i, n, o, a), this.evaluate(this.layers[0], e1), this.colorBufferUploaded = !1;
            }
            updateExpressions(e1) {
                this.programConfigurations.updateExpressions(e1), this.groundEffect.programConfigurations.updateExpressions(e1);
            }
            isEmpty() {
                return 0 === this.buildingWithoutFacade.layoutVertexArray.length && 0 === this.buildingWithFacade.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(e1) {
                const t1 = (t1)=>{
                    t1.layoutVertexBuffer = e1.createVertexBuffer(t1.layoutVertexArray, Dy.members), t1.layoutNormalBuffer = e1.createVertexBuffer(t1.layoutNormalArray, Cy.members), t1.layoutCentroidBuffer = e1.createVertexBuffer(t1.layoutCentroidArray, Fy.members), t1.layoutFloodLightDataBuffer = e1.createVertexBuffer(t1.layoutFloodLightDataArray, ky.members), t1.layoutFacadeDataArray && t1.layoutFacadeDataArray.length && (t1.layoutFacadeDataBuffer = e1.createVertexBuffer(t1.layoutFacadeDataArray, By.members)), t1.layoutFacadeVerticalRangeArray && t1.layoutFacadeVerticalRangeArray.length && (t1.layoutFacadeVerticalRangeBuffer = e1.createVertexBuffer(t1.layoutFacadeVerticalRangeArray, Ny.members)), t1.entranceBloom.layoutVertexArray.length && (t1.entranceBloom.layoutVertexBuffer = e1.createVertexBuffer(t1.entranceBloom.layoutVertexArray, Dy.members), t1.entranceBloom.layoutAttenuationBuffer = e1.createVertexBuffer(t1.entranceBloom.layoutAttenuationArray, Vy.members)), this.uploadUpdatedColorBuffer(e1), this.uploadUpdatedIndexBuffer(e1);
                };
                this.uploaded || (t1(this.buildingWithoutFacade), t1(this.buildingWithFacade), this.groundEffect.upload(e1)), this.groundEffect.uploadPaintProperties(e1), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                const e1 = (e1)=>{
                    e1.layoutVertexBuffer && (e1.layoutVertexBuffer.destroy(), e1.layoutNormalBuffer.destroy(), e1.layoutColorBuffer.destroy(), e1.segmentsBucket.destroy(), e1.indexBuffer && e1.indexBuffer.destroy(), e1.entranceBloom.layoutVertexBuffer && (e1.entranceBloom.layoutVertexBuffer.destroy(), e1.entranceBloom.layoutColorBuffer.destroy(), e1.entranceBloom.layoutAttenuationBuffer.destroy(), e1.entranceBloom.indexBuffer.destroy(), e1.entranceBloom.segmentsBucket.destroy()));
                };
                e1(this.buildingWithoutFacade), e1(this.buildingWithFacade), this.groundEffect.destroy(), this.programConfigurations.destroy();
            }
            updateFootprintHiddenFlags(e1, t1, i = !0) {
                let n = !1;
                const r = i ? t1 : 0, o = 0 | (i ? -1 : ~t1);
                0 === this.groundEffect.hiddenByLandmarkVertexArray.length && this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const t1 of e1){
                    const e1 = this.footprints[t1], i = e1.hiddenFlags & o | r;
                    e1.hiddenFlags !== i && (e1.hiddenFlags = i, n = !0, this.groundEffect.updateHiddenByLandmarkRange(e1.groundEffectVertexOffset, e1.groundEffectVertexLength, 0 !== e1.hiddenFlags));
                }
                return n && (this.indexArrayForConflationUploaded = !1), n;
            }
            uploadUpdatedIndexBuffer(e1) {
                if (this.groundEffect.uploadHiddenByLandmark(e1), this.indexArrayForConflationUploaded) return;
                const t1 = (e1)=>{
                    0 !== e1.indexArray.length && (e1.indexArrayForConflation.resize(e1.indexArray.length), e1.indexArrayForConflation.uint16.set(e1.indexArray.uint16), e1.entranceBloom.indexArrayForConflation.resize(e1.entranceBloom.indexArray.length), e1.entranceBloom.indexArrayForConflation.uint16.set(e1.entranceBloom.indexArray.uint16));
                };
                t1(this.buildingWithoutFacade), t1(this.buildingWithFacade);
                for (const e1 of this.footprints){
                    const t1 = e1.hasFauxFacade ? this.buildingWithFacade : this.buildingWithoutFacade, i = e1.indicesOffset + e1.indicesLength;
                    if (0 !== e1.hiddenFlags) {
                        for(let n = e1.indicesOffset; n < i; n++)t1.indexArrayForConflation.uint16[3 * n + 0] = 0, t1.indexArrayForConflation.uint16[3 * n + 1] = 0, t1.indexArrayForConflation.uint16[3 * n + 2] = 0;
                        const n = e1.bloomIndicesOffset + e1.bloomIndicesLength;
                        for(let i = e1.bloomIndicesOffset; i < n; i++)t1.entranceBloom.indexArrayForConflation.uint16[3 * i + 0] = 0, t1.entranceBloom.indexArrayForConflation.uint16[3 * i + 1] = 0, t1.entranceBloom.indexArrayForConflation.uint16[3 * i + 2] = 0;
                    }
                }
                const i = (t1)=>{
                    0 !== t1.indexArray.length && (t1.indexBuffer ? t1.indexBuffer.updateData(t1.indexArrayForConflation) : t1.indexBuffer = e1.createIndexBuffer(t1.indexArrayForConflation, !0), t1.entranceBloom.indexBuffer ? t1.entranceBloom.indexBuffer.updateData(t1.entranceBloom.indexArrayForConflation) : t1.entranceBloom.indexBuffer = e1.createIndexBuffer(t1.entranceBloom.indexArrayForConflation, !0));
                };
                i(this.buildingWithoutFacade), i(this.buildingWithFacade), this.indexArrayForConflationUploaded = !0;
            }
            uploadUpdatedColorBuffer(e1) {
                const t1 = (t1)=>{
                    t1.layoutColorBuffer ? t1.layoutColorBuffer.updateData(t1.layoutColorArray) : t1.layoutColorBuffer = e1.createVertexBuffer(t1.layoutColorArray, Oy.members, !0), t1.layoutFacadePaintArray && (t1.layoutFacadePaintBuffer ? t1.layoutFacadePaintBuffer.updateData(t1.layoutFacadePaintArray) : t1.layoutFacadePaintBuffer = e1.createVertexBuffer(t1.layoutFacadePaintArray, Ly.members, !0)), t1.entranceBloom.layoutColorBuffer ? t1.entranceBloom.layoutColorBuffer.updateData(t1.entranceBloom.layoutColorArray) : t1.entranceBloom.layoutColorBuffer = e1.createVertexBuffer(t1.entranceBloom.layoutColorArray, Oy.members, !0);
                };
                t1(this.buildingWithoutFacade), t1(this.buildingWithFacade), this.colorBufferUploaded = !0;
            }
            evaluate(e1, t1) {
                const i = e1.paint.get("building-ambient-occlusion-intensity");
                for (const n of this.footprints){
                    if (4 & n.hiddenFlags) continue;
                    const r = t1[n.promoteId], o = n.feature;
                    o.properties["building-part"] = "roof";
                    const a = e1.paint.get("building-color").evaluate(o, r, this.canonical).toPremultipliedRenderColor(this.lut), s = e1.paint.get("building-emissive-strength").evaluate(o, r, this.canonical);
                    o.properties["building-part"] = "wall";
                    const l = e1.paint.get("building-color").evaluate(o, r, this.canonical).toPremultipliedRenderColor(this.lut), u = e1.paint.get("building-emissive-strength").evaluate(o, r, this.canonical);
                    o.properties["building-part"] = "window";
                    const c = e1.paint.get("building-color").evaluate(o, r, this.canonical).toPremultipliedRenderColor(this.lut), h = e1.paint.get("building-emissive-strength").evaluate(o, r, this.canonical);
                    o.properties["building-part"] = "door";
                    const d = e1.paint.get("building-color").evaluate(o, r, this.canonical).toPremultipliedRenderColor(this.lut), f = e1.paint.get("building-emissive-strength").evaluate(o, r, this.canonical), p = n.hasFauxFacade ? this.buildingWithFacade : this.buildingWithoutFacade;
                    for (const e1 of n.parts){
                        let t1, r = a;
                        1 === e1.part ? (r = a, t1 = s) : 0 === e1.part ? (r = l, t1 = u) : 2 === e1.part ? (r = c, t1 = h) : 3 === e1.part && (r = d, t1 = f), t1 = tt(t1, 0, 1);
                        for(let o = 0; o < e1.vertexLength; o++){
                            const a = e1.vertexOffset + o, s = 1 + (p.layoutAOArray.uint8[a] / 255 - 1) * i;
                            p.layoutColorArray.emplace(a, r.r * s * 255 << 8 | r.g * s * 255, r.b * s * 255 << 8 | 255 * t1), n.hasFauxFacade && p.layoutFacadePaintArray.emplace(a, 255 * c.r << 8 | 255 * c.g, 255 * c.b << 8 | 255 * h);
                        }
                    }
                    const _ = n.buildingBloom;
                    if (_) for(let e1 = 0; e1 < _.vertexLength; e1++)p.entranceBloom.layoutColorArray.emplace(_.vertexOffset + e1, 255 * d.r << 8 | 255 * d.g, 255 * d.b << 8 | 51 * f);
                }
            }
            needsEvaluation() {
                return !this.colorBufferUploaded;
            }
            updateReplacement(e1, t1, i) {
                if (t1.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t1.updateTime;
                const n = t1.getReplacementRegionsForTile(e1.toUnwrapped());
                if (Dp(this.activeReplacements, n)) return;
                this.activeReplacements = n;
                for (const e1 of this.footprints)e1.hiddenFlags &= -2;
                const r = [];
                for (const t1 of this.activeReplacements){
                    if (t1.order < i) continue;
                    const n = Math.max(1, Math.pow(2, t1.footprintTileId.canonical.z - e1.canonical.z));
                    for (const i of this.footprints)i.min.x > t1.max.x || i.max.x < t1.min.x || i.min.y > t1.max.y || i.max.y < t1.min.y || (r.length = 0, Yx(this.footprintsVertices, i.footprintVertexOffset, i.footprintVertexLength, t1.footprintTileId.canonical, e1.canonical, r), Op(t1.footprint, r, this.footprintsIndices.uint16, i.footprintIndexOffset, i.footprintIndexLength, 0, -n) && (i.hiddenFlags |= 1));
                }
                0 === this.groundEffect.hiddenByLandmarkVertexArray.length && this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const e1 of this.footprints)this.groundEffect.updateHiddenByLandmarkRange(e1.groundEffectVertexOffset, e1.groundEffectVertexLength, 0 !== e1.hiddenFlags);
                this.indexArrayForConflationUploaded = !1;
            }
            getFootprint(e1) {
                if (void 0 !== e1.id) {
                    const t1 = this.featureFootprintLookup.get(e1.id);
                    return this.footprints[t1];
                }
                return null;
            }
            getHeightAtTileCoord(e1, t1) {
                let i = Number.NEGATIVE_INFINITY, n = !0;
                const r = 4 * (e1 + Sr) * Sr + (t1 + Sr);
                if (Object.hasOwn(this.footprintLookup, r)) {
                    const e1 = this.footprintLookup[r];
                    return e1 ? {
                        height: e1.height,
                        hidden: 0 !== e1.hiddenFlags
                    } : void 0;
                }
                const o = new Pe(e1, t1);
                for (const a of this.footprints)e1 > a.max.x || a.min.x > e1 || t1 > a.max.y || a.min.y > t1 || a.height <= i || Xx(o, this.footprintsVertices.float32.subarray(2 * a.footprintVertexOffset, 2 * (a.footprintVertexOffset + a.footprintVertexLength)), this.footprintsIndices.uint16.subarray(a.footprintIndexOffset, a.footprintIndexOffset + a.footprintIndexLength)) && (i = a.height, this.footprintLookup[r] = a, n = 0 !== a.hiddenFlags);
                if (i !== Number.NEGATIVE_INFINITY) return {
                    height: i,
                    hidden: n
                };
                this.footprintLookup[r] = void 0;
            }
        }
        function Xx(e1, t1, i) {
            for(let n = 0; n < i.length; n += 3){
                const r = i[n], o = i[n + 1], a = i[n + 2], s = t1[2 * r + 0], l = t1[2 * r + 1], u = t1[2 * o + 0], c = t1[2 * o + 1], h = t1[2 * a + 0], d = t1[2 * a + 1], f = (s - h) * (e1.y - d) - (l - d) * (e1.x - h), p = (u - s) * (e1.y - l) - (c - l) * (e1.x - s);
                if (f < 0 != p < 0 && 0 !== f && 0 !== p) continue;
                const _ = (h - u) * (e1.y - c) - (d - c) * (e1.x - u);
                if (0 === _ || _ < 0 == f + p <= 0) return !0;
            }
            return !1;
        }
        function Yx(e1, t1, i, n, r, o) {
            const a = Math.pow(2, n.z - r.z);
            for(let s = 0; s < i; s++){
                let i = e1.float32[2 * (s + t1) + 0], l = e1.float32[2 * (s + t1) + 1];
                i = (i + r.x * Sr) * a - n.x * Sr, l = (l + r.y * Sr) * a - n.y * Sr, o.push(new Pe(i, l));
            }
        }
        Ha(qx, "BuildingBucket", {
            omit: [
                "layers"
            ]
        }), Ha(Wx, "BuildingGeometry"), Ha(Zx, "BuildingBloomGeometry");
        class Jx {
            constructor(e1 = 0, t1 = []){
                this.frcMask = e1, this.rings = t1;
            }
            hasGeometry() {
                return this.rings.length > 0 && this.rings[0].length > 0;
            }
        }
        async function Kx() {}
        function Qx(e1, t1, i) {
            const n = t1.paint.get(e1).value;
            return "constant" === n.kind ? n.value : i.programConfigurations.get(t1.id).getMaxValue(e1);
        }
        function ev(e1) {
            return Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]);
        }
        function tv(e1, t1, i, n, r) {
            if (!t1[0] && !t1[1]) return e1;
            const o = Pe.convert(t1)._mult(r);
            "viewport" === i && o._rotate(-n);
            const a = [];
            for(let t1 = 0; t1 < e1.length; t1++)a.push(e1[t1].sub(o));
            return a;
        }
        function iv(e1, t1, i, n) {
            const r = Pe.convert(e1)._mult(n);
            return "viewport" === t1 && r._rotate(-i), r;
        }
        Ha(Jx, "FrcCoveragePolygon");
        const nv = u(), rv = (e1)=>{
            const t1 = [];
            return "map" === e1.paint.get("circle-pitch-alignment") && t1.push("PITCH_WITH_MAP"), "map" === e1.paint.get("circle-pitch-scale") && t1.push("SCALE_WITH_MAP"), t1;
        };
        function ov(e1, t1, i, n, r, o, a, s, l) {
            if (o && e1.queryGeometry.isAboveHorizon) return !1;
            o && (l *= e1.pixelToTileUnitsFactor);
            const u = e1.tileID.canonical, c = i.projection.upVectorScale(u, i.center.lat, i.worldSize).metersToTile;
            for (const h of t1)for (const t1 of h){
                const h = t1.add(s), d = r && i.elevation ? i.elevation.exaggeration() * r.getElevationAt(h.x, h.y, !0) : 0, f = i.projection.projectTilePoint(h.x, h.y, u);
                if (d > 0) {
                    const e1 = i.projection.upVector(u, h.x, h.y);
                    f.x += e1[0] * c * d, f.y += e1[1] * c * d, f.z += e1[2] * c * d;
                }
                const p = o ? h : av(f.x, f.y, f.z, n), _ = o ? e1.tilespaceRays.map((e1)=>uv(e1, d)) : e1.queryGeometry.screenGeometry, m = le([], [
                    f.x,
                    f.y,
                    f.z,
                    1
                ], n);
                if (!a && o ? l *= m[3] / i.cameraToCenterDistance : a && !o && (l *= i.cameraToCenterDistance / m[3]), o) {
                    const e1 = pr((t1.y / Sr + u.y) / (1 << u.z));
                    l /= i.projection.pixelsPerMeter(e1, 1) / pu(1, e1);
                }
                if (Ch(_, p, l)) return !0;
            }
            return !1;
        }
        function av(e1, t1, i, n) {
            const r = le([], [
                e1,
                t1,
                i,
                1
            ], n);
            return new Pe(r[0] / r[3], r[1] / r[3]);
        }
        const sv = C(0, 0, 0), lv = C(0, 0, 1);
        function uv(e1, t1) {
            const i = R();
            return sv[2] = t1, e1.intersectsPlane(sv, lv, i), new Pe(i[0], i[1]);
        }
        class cv extends yd {
        }
        let hv, dv, fv, pv, _v, mv, gv, yv, xv, vv, bv, wv, Ev, Av;
        function Iv(e1) {
            const t1 = {}, i = e1.resolution || 256, n = e1.clips ? e1.clips.length : 1, r = e1.image || new od({
                width: i,
                height: n
            }), o = e1.lut || null, a = (i, n, a)=>{
                t1[e1.evaluationKey] = a;
                const s = e1.expression.evaluate(t1), l = s ? s.toNonPremultipliedRenderColor(o) : null;
                l && (r.data[i + n + 0] = Math.floor(255 * l.r), r.data[i + n + 1] = Math.floor(255 * l.g), r.data[i + n + 2] = Math.floor(255 * l.b), r.data[i + n + 3] = Math.floor(255 * l.a));
            };
            if (e1.clips) for(let t1 = 0, r = 0; t1 < n; ++t1, r += 4 * i)for(let n = 0, o = 0; n < i; n++, o += 4){
                const s = n / (i - 1), { start: l, end: u } = e1.clips[t1];
                a(r, o, dn(l, u, s));
            }
            else for(let e1 = 0, t1 = 0; e1 < i; e1++, t1 += 4)a(0, t1, e1 / (i - 1));
            return r;
        }
        Ha(cv, "HeatmapBucket", {
            omit: [
                "layers"
            ]
        });
        class Tv {
            constructor(e1){
                this.zoom = e1.zoom, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.footprints = [], this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {
                for (const i of this.footprints)t1.push({
                    footprint: i,
                    id: e1
                });
            }
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                const r = [];
                for (const { feature: o, id: a, index: s, sourceLayerIndex: l } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, u = Ru(o, e1);
                    if (!this.layers[0]._featureFilter.filter(new ks(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), u, i)) continue;
                    const c = {
                        id: a,
                        properties: o.properties,
                        type: o.type,
                        sourceLayerIndex: l,
                        index: s,
                        geometry: e1 ? u.geometry : zu(o, i, n),
                        patterns: {}
                    };
                    r.push(c);
                }
                for (const n of r){
                    const { geometry: r, index: o, sourceLayerIndex: a } = n;
                    this.addFeature(n, r, o, i, {}, t1.availableImages, t1.brightness), t1.featureIndex.insert(e1[o].feature, r, o, a, this.index);
                }
            }
            isEmpty() {
                return 0 === this.footprints.length;
            }
            uploadPending() {
                return !1;
            }
            upload(e1) {}
            update(e1, t1, i, n, r, o, a) {}
            destroy() {}
            addFeature(e1, t1, i, n, r, o = [], a) {
                for (const e1 of Ne(t1, 2)){
                    const t1 = [], i = [], n = [], r = new Pe(1 / 0, 1 / 0), o = new Pe(-1 / 0, -1 / 0);
                    for (const a of e1)if (0 !== a.length) {
                        a !== e1[0] && n.push(i.length / 2);
                        for(let e1 = 0; e1 < a.length; e1++)i.push(a[e1].x), i.push(a[e1].y), t1.push(a[e1]), r.x = Math.min(r.x, a[e1].x), r.y = Math.min(r.y, a[e1].y), o.x = Math.max(o.x, a[e1].x), o.y = Math.max(o.y, a[e1].y);
                    }
                    const a = Ml(i, n), s = new Vg(t1, a, 8, 256);
                    this.footprints.push({
                        vertices: t1,
                        indices: a,
                        grid: s,
                        min: r,
                        max: o
                    });
                }
            }
        }
        function Mv(e1, t1) {
            return e1.x * t1.x + e1.y * t1.y;
        }
        function Sv(e1, t1) {
            if (1 === e1.length) {
                let i = 0;
                const n = t1[i++];
                let r;
                for(; !r || n.equals(r);)if (r = t1[i++], !r) return 1 / 0;
                for(; i < t1.length; i++){
                    const o = t1[i], a = e1[0], s = r.sub(n), l = o.sub(n), u = a.sub(n), c = Mv(s, s), h = Mv(s, l), d = Mv(l, l), f = Mv(u, s), p = Mv(u, l), _ = c * d - h * h, m = (d * f - h * p) / _, g = (c * p - h * f) / _, y = n.z * (1 - m - g) + r.z * m + o.z * g;
                    if (isFinite(y)) return y;
                }
                return 1 / 0;
            }
            {
                let e1 = 1 / 0;
                for (const i of t1)e1 = Math.min(e1, i.z);
                return e1;
            }
        }
        function zv(e1, t1, i) {
            let n = 1 / 0;
            Fh(i, t1) && (n = Sv(i, t1[0]));
            for(let r = 0; r < t1.length; r++){
                const o = t1[r], a = e1[r];
                for(let e1 = 0; e1 < o.length - 1; e1++){
                    const t1 = o[e1], r = [
                        t1,
                        o[e1 + 1],
                        a[e1 + 1],
                        a[e1],
                        t1
                    ];
                    Dh(i, r) && (n = Math.min(n, Sv(i, r)));
                }
            }
            return n !== 1 / 0 && n;
        }
        function Rv(e1, t1, i, n, r, o, a, s, l, u, c) {
            return "globe" === e1.projection.name ? function(e1, t1, i, n, r, o, a, s, l, u, c) {
                const h = [], d = [], f = e1.projection.upVectorScale(c, e1.center.lat, e1.worldSize).metersToTile, p = [
                    0,
                    0,
                    0,
                    1
                ], _ = [
                    0,
                    0,
                    0,
                    1
                ], m = (e1, t1, i, n)=>{
                    e1[0] = t1, e1[1] = i, e1[2] = n, e1[3] = 1;
                }, g = Dx();
                i > 0 && (i += g), n += g;
                for (const g of t1){
                    const t1 = [], y = [];
                    for (const h of g){
                        const d = h.x + r.x, g = h.y + r.y, x = e1.projection.projectTilePoint(d, g, c), v = e1.projection.upVector(c, h.x, h.y);
                        let b = i, w = n;
                        if (a) {
                            const e1 = Pv(d, g, i, n, a, s, l, u);
                            b += e1.base, w += e1.top;
                        }
                        0 !== i ? m(p, x.x + v[0] * f * b, x.y + v[1] * f * b, x.z + v[2] * f * b) : m(p, x.x, x.y, x.z), m(_, x.x + v[0] * f * w, x.y + v[1] * f * w, x.z + v[2] * f * w), Y(p, p, o), Y(_, _, o), t1.push(new qh(p[0], p[1], p[2])), y.push(new qh(_[0], _[1], _[2]));
                    }
                    h.push(t1), d.push(y);
                }
                return [
                    h,
                    d
                ];
            }(e1, t1, i, n, r, o, a, s, l, u, c) : a ? function(e1, t1, i, n, r, o, a, s, l) {
                const u = [], c = [], h = [
                    0,
                    0,
                    0,
                    1
                ];
                for (const d of e1){
                    const e1 = [], f = [];
                    for (const u of d){
                        const c = u.x + n.x, d = u.y + n.y, p = Pv(c, d, t1, i, o, a, s, l);
                        h[0] = c, h[1] = d, h[2] = p.base, h[3] = 1, le(h, h, r), h[3] = Math.max(h[3], 1e-5);
                        const _ = new qh(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                        h[0] = c, h[1] = d, h[2] = p.top, h[3] = 1, le(h, h, r), h[3] = Math.max(h[3], 1e-5);
                        const m = new qh(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                        e1.push(_), f.push(m);
                    }
                    u.push(e1), c.push(f);
                }
                return [
                    u,
                    c
                ];
            }(t1, i, n, r, o, a, s, l, u) : function(e1, t1, i, n, r) {
                const o = [], a = [], s = r[8] * t1, l = r[9] * t1, u = r[10] * t1, c = r[11] * t1, h = r[8] * i, d = r[9] * i, f = r[10] * i, p = r[11] * i;
                for (const t1 of e1){
                    const e1 = [], i = [];
                    for (const o of t1){
                        const t1 = o.x + n.x, a = o.y + n.y, _ = r[0] * t1 + r[4] * a + r[12], m = r[1] * t1 + r[5] * a + r[13], g = r[2] * t1 + r[6] * a + r[14], y = r[3] * t1 + r[7] * a + r[15], x = _ + s, v = m + l, b = g + u, w = Math.max(y + c, 1e-5), E = _ + h, A = m + d, I = g + f, T = Math.max(y + p, 1e-5);
                        e1.push(new qh(x / w, v / w, b / w)), i.push(new qh(E / T, A / T, I / T));
                    }
                    o.push(e1), a.push(i);
                }
                return [
                    o,
                    a
                ];
            }(t1, i, n, r, o);
        }
        function Pv(e1, t1, i, n, r, o, a, s) {
            const l = a * r.getElevationAt(e1, t1, !0, !0), u = 0 !== o[0], c = u ? 0 === o[1] ? a * (o[0] / 7 - 450) : a * function(e1, t1, i) {
                const n = Math.floor(t1[0] / 8), r = Math.floor(t1[1] / 8), o = 10 * (t1[0] - 8 * n), a = 10 * (t1[1] - 8 * r), s = e1.getElevationAt(n, r, !0, !0), l = e1.getMeterToDEM(i), u = Math.floor(.5 * (o * l - 1)), c = Math.floor(.5 * (a * l - 1)), h = e1.tileCoordToPixel(n, r), d = 2 * u + 1, f = 2 * c + 1, p = function(e1, t1, i, n, r) {
                    return [
                        e1.getElevationAtPixel(t1, i, !0),
                        e1.getElevationAtPixel(t1 + r, i, !0),
                        e1.getElevationAtPixel(t1, i + r, !0),
                        e1.getElevationAtPixel(t1 + n, i + r, !0)
                    ];
                }(e1, h.x - u, h.y - c, d, f), _ = Math.abs(p[0] - p[1]), m = Math.abs(p[2] - p[3]), g = Math.abs(p[0] - p[2]) + Math.abs(p[1] - p[3]), y = Math.min(.25, .5 * l * (_ + m) / d), x = Math.min(.25, .5 * l * g / f);
                return s + Math.max(y * o, x * a);
            }(r, o, s) : l;
            return {
                base: l + (0 === i ? -1 : i),
                top: u ? Math.max(c + n, l + i + 2) : l + n
            };
        }
        function Dv(e1, t1, i) {
            return t1 * (Sr / (e1.tileSize * Math.pow(2, i - e1.tileID.overscaledZ)));
        }
        function Cv(e1, t1) {
            return 1 / Dv(e1, 1, t1.tileZoom);
        }
        function Fv(e1, t1, i, n) {
            return e1.translatePosMatrix(n || t1.tileID.projMatrix, t1, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        Ha(Tv, "ClipBucket", {
            omit: [
                "layers"
            ]
        });
        const Ov = (e1)=>{
            const t1 = [];
            Lv(e1) && t1.push("RENDER_LINE_DASH"), e1.paint.get("line-gradient") && t1.push("RENDER_LINE_GRADIENT"), "multiply" === e1.paint.get("line-blend-mode") && t1.push("LINE_BLEND_MULTIPLY"), "additive" === e1.paint.get("line-blend-mode") && t1.push("LINE_BLEND_ADDITIVE");
            const i = e1.paint.get("line-trim-offset");
            0 === i[0] && 0 === i[1] || t1.push("RENDER_LINE_TRIM_OFFSET");
            const n = 0 !== e1.paint.get("line-border-width").constantOr(1);
            n && t1.push("RENDER_LINE_BORDER"), n && e1.paint.get("line-border-gradient") && t1.push("RENDER_LINE_BORDER_GRADIENT");
            const r = "none" === e1.layout.get("line-join").constantOr("miter"), o = !!e1.paint.get("line-pattern").constantOr(1);
            return r && o && t1.push("LINE_JOIN_NONE"), t1;
        };
        function Lv(e1) {
            const t1 = e1.paint.get("line-dasharray").value;
            return "constant" !== t1.kind || t1.value;
        }
        let Bv;
        const Nv = ()=>Bv || (Bv = {
                layout: Ev || (Ev = new Ks({
                    "line-cap": new Ys(Qs.layout_line["line-cap"]),
                    "line-join": new Ys(Qs.layout_line["line-join"]),
                    "line-miter-limit": new Xs(Qs.layout_line["line-miter-limit"]),
                    "line-round-limit": new Xs(Qs.layout_line["line-round-limit"]),
                    "line-sort-key": new Ys(Qs.layout_line["line-sort-key"]),
                    "line-z-offset": new Ys(Qs.layout_line["line-z-offset"]),
                    "line-elevation-reference": new Xs(Qs.layout_line["line-elevation-reference"]),
                    "line-cross-slope": new Xs(Qs.layout_line["line-cross-slope"]),
                    visibility: new Xs(Qs.layout_line.visibility),
                    "line-width-unit": new Xs(Qs.layout_line["line-width-unit"]),
                    "line-elevation-ground-scale": new Ys(Qs.layout_line["line-elevation-ground-scale"])
                })),
                paint: Av || (Av = new Ks({
                    "line-opacity": new Ys(Qs.paint_line["line-opacity"]),
                    "line-color": new Ys(Qs.paint_line["line-color"]),
                    "line-translate": new Xs(Qs.paint_line["line-translate"]),
                    "line-translate-anchor": new Xs(Qs.paint_line["line-translate-anchor"]),
                    "line-width": new Ys(Qs.paint_line["line-width"]),
                    "line-gap-width": new Ys(Qs.paint_line["line-gap-width"]),
                    "line-offset": new Ys(Qs.paint_line["line-offset"]),
                    "line-blur": new Ys(Qs.paint_line["line-blur"]),
                    "line-dasharray": new Ys(Qs.paint_line["line-dasharray"]),
                    "line-pattern": new Ys(Qs.paint_line["line-pattern"]),
                    "line-pattern-cross-fade": new Xs(Qs.paint_line["line-pattern-cross-fade"]),
                    "line-gradient": new Js(Qs.paint_line["line-gradient"]),
                    "line-trim-offset": new Xs(Qs.paint_line["line-trim-offset"]),
                    "line-trim-fade-range": new Xs(Qs.paint_line["line-trim-fade-range"]),
                    "line-trim-color": new Xs(Qs.paint_line["line-trim-color"]),
                    "line-emissive-strength": new Ys(Qs.paint_line["line-emissive-strength"]),
                    "line-border-width": new Ys(Qs.paint_line["line-border-width"]),
                    "line-border-color": new Ys(Qs.paint_line["line-border-color"]),
                    "line-border-gradient": new Js(Qs.paint_line["line-border-gradient"]),
                    "line-occlusion-opacity": new Xs(Qs.paint_line["line-occlusion-opacity"]),
                    "line-blend-mode": new Xs(Qs.paint_line["line-blend-mode"]),
                    "line-blend-additive-clamp": new Xs(Qs.paint_line["line-blend-additive-clamp"]),
                    "line-color-use-theme": new Ys({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-gradient-use-theme": new Ys({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-trim-color-use-theme": new Ys({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-border-color-use-theme": new Ys({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-border-gradient-use-theme": new Ys({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    })
                }))
            }, Bv);
        class Vv extends Ys {
            possiblyEvaluate(e1, t1) {
                return t1 = new ks(Math.floor(t1.zoom), {
                    now: t1.now,
                    fadeDuration: t1.fadeDuration,
                    transition: t1.transition,
                    worldview: t1.worldview
                }), super.possiblyEvaluate(e1, t1);
            }
            evaluate(e1, t1, i, n) {
                return t1 = {
                    ...t1,
                    zoom: Math.floor(t1.zoom)
                }, super.evaluate(e1, t1, i, n);
            }
        }
        let kv, Uv, Gv, jv;
        function Hv(e1, t1) {
            return t1 > 0 ? t1 + 2 * e1 : e1;
        }
        function $v(e1, t1) {
            return t1.replace(/{([^{}]+)}/g, (t1, i)=>i in e1 ? String(e1[i]) : "");
        }
        class Zv {
            constructor(e1){
                this.type = e1.property.overrides ? e1.property.overrides.runtimeType : wn, this.defaultValue = e1;
            }
            evaluate(e1) {
                if (e1.formattedSection) {
                    const t1 = this.defaultValue.property.overrides;
                    if (t1 && t1.hasOverride(e1.formattedSection)) return t1.getOverride(e1.formattedSection);
                }
                return e1.feature && e1.featureState ? this.defaultValue.evaluate(e1.feature, e1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(e1) {
                this.defaultValue.isConstant() || e1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        Ha(Zv, "FormatSectionOverride", {
            omit: [
                "defaultValue"
            ]
        });
        const Wv = ()=>jv || (jv = {
                layout: Uv || (Uv = new Ks({
                    "symbol-placement": new Xs(Qs.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new Xs(Qs.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new Xs(Qs.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new Ys(Qs.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new Xs(Qs.layout_symbol["symbol-z-order"]),
                    "symbol-z-elevate": new Xs(Qs.layout_symbol["symbol-z-elevate"]),
                    "symbol-elevation-reference": new Xs(Qs.layout_symbol["symbol-elevation-reference"]),
                    "icon-allow-overlap": new Xs(Qs.layout_symbol["icon-allow-overlap"]),
                    "icon-ignore-placement": new Xs(Qs.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new Xs(Qs.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new Xs(Qs.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new Ys(Qs.layout_symbol["icon-size"]),
                    "icon-size-scale-range": new Xs(Qs.layout_symbol["icon-size-scale-range"]),
                    "icon-text-fit": new Ys(Qs.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new Ys(Qs.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new Ys(Qs.layout_symbol["icon-image"]),
                    "icon-image-use-theme": new Xs({
                        type: "string",
                        default: "default",
                        "property-type": "data-constant"
                    }),
                    "icon-rotate": new Ys(Qs.layout_symbol["icon-rotate"]),
                    "icon-padding": new Xs(Qs.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new Xs(Qs.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new Ys(Qs.layout_symbol["icon-offset"]),
                    "icon-anchor": new Ys(Qs.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new Xs(Qs.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new Xs(Qs.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new Xs(Qs.layout_symbol["text-rotation-alignment"]),
                    "text-field": new Ys(Qs.layout_symbol["text-field"]),
                    "text-font": new Ys(Qs.layout_symbol["text-font"]),
                    "text-size": new Ys(Qs.layout_symbol["text-size"]),
                    "text-size-scale-range": new Xs(Qs.layout_symbol["text-size-scale-range"]),
                    "text-max-width": new Ys(Qs.layout_symbol["text-max-width"]),
                    "text-line-height": new Ys(Qs.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new Ys(Qs.layout_symbol["text-letter-spacing"]),
                    "text-justify": new Ys(Qs.layout_symbol["text-justify"]),
                    "text-radial-offset": new Ys(Qs.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new Xs(Qs.layout_symbol["text-variable-anchor"]),
                    "text-anchor": new Ys(Qs.layout_symbol["text-anchor"]),
                    "text-max-angle": new Xs(Qs.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new Xs(Qs.layout_symbol["text-writing-mode"]),
                    "text-rotate": new Ys(Qs.layout_symbol["text-rotate"]),
                    "text-padding": new Xs(Qs.layout_symbol["text-padding"]),
                    "text-keep-upright": new Xs(Qs.layout_symbol["text-keep-upright"]),
                    "text-transform": new Ys(Qs.layout_symbol["text-transform"]),
                    "text-offset": new Ys(Qs.layout_symbol["text-offset"]),
                    "text-allow-overlap": new Xs(Qs.layout_symbol["text-allow-overlap"]),
                    "text-ignore-placement": new Xs(Qs.layout_symbol["text-ignore-placement"]),
                    "text-optional": new Xs(Qs.layout_symbol["text-optional"]),
                    visibility: new Xs(Qs.layout_symbol.visibility)
                })),
                paint: Gv || (Gv = new Ks({
                    "icon-opacity": new Ys(Qs.paint_symbol["icon-opacity"]),
                    "icon-occlusion-opacity": new Ys(Qs.paint_symbol["icon-occlusion-opacity"]),
                    "icon-emissive-strength": new Ys(Qs.paint_symbol["icon-emissive-strength"]),
                    "text-emissive-strength": new Ys(Qs.paint_symbol["text-emissive-strength"]),
                    "icon-color": new Ys(Qs.paint_symbol["icon-color"]),
                    "icon-halo-color": new Ys(Qs.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new Ys(Qs.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new Ys(Qs.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new Xs(Qs.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new Xs(Qs.paint_symbol["icon-translate-anchor"]),
                    "icon-image-cross-fade": new Xs(Qs.paint_symbol["icon-image-cross-fade"]),
                    "text-opacity": new Ys(Qs.paint_symbol["text-opacity"]),
                    "text-occlusion-opacity": new Ys(Qs.paint_symbol["text-occlusion-opacity"]),
                    "text-color": new Ys(Qs.paint_symbol["text-color"], {
                        runtimeType: Tn,
                        getOverride: (e1)=>e1.textColor,
                        hasOverride: (e1)=>!!e1.textColor
                    }),
                    "text-halo-color": new Ys(Qs.paint_symbol["text-halo-color"]),
                    "text-halo-width": new Ys(Qs.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new Ys(Qs.paint_symbol["text-halo-blur"]),
                    "text-translate": new Xs(Qs.paint_symbol["text-translate"]),
                    "text-translate-anchor": new Xs(Qs.paint_symbol["text-translate-anchor"]),
                    "icon-color-saturation": new Xs(Qs.paint_symbol["icon-color-saturation"]),
                    "icon-color-contrast": new Xs(Qs.paint_symbol["icon-color-contrast"]),
                    "icon-color-brightness-min": new Xs(Qs.paint_symbol["icon-color-brightness-min"]),
                    "icon-color-brightness-max": new Xs(Qs.paint_symbol["icon-color-brightness-max"]),
                    "symbol-z-offset": new Ys(Qs.paint_symbol["symbol-z-offset"]),
                    "icon-color-use-theme": new Ys({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "icon-halo-color-use-theme": new Ys({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "text-color-use-theme": new Ys({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "text-halo-color-use-theme": new Ys({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    })
                }))
            }, jv);
        class qv extends Il {
            constructor(e1, t1, i, n){
                super(e1, Wv(), t1, i, n, e1.layout ? e1.layout["icon-image-use-theme"] : null), this._colorAdjustmentMatrix = d([]), this.hasOcclusionOpacityProperties = void 0 !== e1.paint && ("icon-occlusion-opacity" in e1.paint || "text-occlusion-opacity" in e1.paint);
            }
            _handleSpecialPaintPropertyUpdate(e1) {
                "icon-occlusion-opacity" !== e1 && "text-occlusion-opacity" !== e1 || (this.hasOcclusionOpacityProperties = !0);
            }
            recalculate(e1, t1) {
                super.recalculate(e1, t1), this.appearances && this.appearances.forEach((i)=>{
                    i.recalculate(e1, t1, this.iconImageUseTheme);
                }), 0 !== this.appearances.length && delete this.layout._values["text-variable-anchor"], "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
                const i = this.layout.get("text-writing-mode");
                if (i) {
                    const e1 = [];
                    for (const t1 of i)e1.includes(t1) || e1.push(t1);
                    this.layout._values["text-writing-mode"] = e1;
                } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? [
                    "horizontal"
                ] : [
                    "horizontal",
                    "vertical"
                ];
                this._setPaintOverrides();
            }
            getColorAdjustmentMatrix(e1, t1, i, n) {
                return this._saturation === e1 && this._contrast === t1 && this._brightnessMin === i && this._brightnessMax === n || (this._colorAdjustmentMatrix = function(e1, t1, i, n) {
                    e1 = St(e1), t1 = Mt(t1);
                    const r = u(), o = e1 / 3, a = 1 - 2 * o, s = [
                        a,
                        o,
                        o,
                        0,
                        o,
                        a,
                        o,
                        0,
                        o,
                        o,
                        a,
                        0,
                        0,
                        0,
                        0,
                        1
                    ], l = .5 - .5 * t1, c = n - i;
                    return _(r, [
                        c,
                        0,
                        0,
                        0,
                        0,
                        c,
                        0,
                        0,
                        0,
                        0,
                        c,
                        0,
                        i,
                        i,
                        i,
                        1
                    ], [
                        t1,
                        0,
                        0,
                        0,
                        0,
                        t1,
                        0,
                        0,
                        0,
                        0,
                        t1,
                        0,
                        l,
                        l,
                        l,
                        1
                    ]), _(r, r, s), r;
                }(e1, t1, i, n), this._saturation = e1, this._contrast = t1, this._brightnessMin = i, this._brightnessMax = n), this._colorAdjustmentMatrix;
            }
            getValueAndResolveTokens(e1, t1, i, n) {
                const r = this.layout.get(e1).evaluate(t1, {}, i, n), o = this._unevaluatedLayout._values[e1];
                return o.isDataDriven() || Oa(o.value) || !r ? r : $v(t1.properties, r);
            }
            getAppearanceValueAndResolveTokens(e1, t1, i, n, r) {
                const o = e1.getLayoutProperty(t1);
                if (!o) return;
                const a = o.evaluate(i, {}, n, r), s = e1.getUnevaluatedLayoutProperties()._values[t1];
                return s.isDataDriven() || Oa(s.value) || !a || "string" != typeof a ? a : $v(i.properties, a);
            }
            createBucket(e1) {
                return new q_(e1);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            _setPaintOverrides() {
                for (const e1 of Wv().paint.overridableProperties){
                    if (!qv.hasPaintOverride(this.layout, e1)) continue;
                    const t1 = this.paint.get(e1), i = new Zv(t1), n = new Fa(i, t1.property.specification, this.scope, this.options, this.layout.get("icon-image-use-theme"));
                    let r = null;
                    r = "constant" === t1.value.kind || "source" === t1.value.kind ? new Ba("source", n) : new Na("composite", n, t1.value.zoomStops, t1.value.interpolationType), this.paint._values[e1] = new Ws(t1.property, r, t1.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(e1, t1, i) {
                return !(!this.layout || t1.isDataDriven() || i.isDataDriven()) && qv.hasPaintOverride(this.layout, e1);
            }
            static hasPaintOverride(e1, t1) {
                const i = e1.get("text-field"), n = Wv().paint.properties[t1];
                let r = !1;
                const o = (e1)=>{
                    for (const t1 of e1)if (n.overrides && n.overrides.hasOverride(t1)) return void (r = !0);
                };
                if ("constant" === i.value.kind && i.value.value instanceof kn) o(i.value.value.sections);
                else if ("source" === i.value.kind) {
                    const e1 = (t1)=>{
                        r || (t1 instanceof Wn && $n(t1.value) === Rn ? o(t1.value.sections) : t1 instanceof Jn ? o(t1.sections) : t1.eachChild(e1));
                    }, t1 = i.value;
                    t1._styleExpression && e1(t1._styleExpression.expression);
                }
                return r;
            }
            getProgramIds() {
                return [
                    "symbol"
                ];
            }
            getDefaultProgramParams(e1, t1, i) {
                return {
                    config: new uh(this, {
                        zoom: t1,
                        lut: i
                    }),
                    overrideFog: !1
                };
            }
            hasElevation() {
                return this.layout && "hd-road-markup" === this.layout.get("symbol-elevation-reference");
            }
            mayUse(e1) {
                return "HD" === e1 && Tl(this, "symbol-elevation-reference", (e1)=>"hd-road-markup" === e1);
            }
            prepare() {
                return this.mayUse("HD") ? Kx() : Promise.resolve();
            }
        }
        let Xv, Yv, Jv, Kv;
        const Qv = 1024, eb = (Math.pow(Qv, 2) - 1) / 268170240;
        class tb extends Il {
            constructor(e1, t1, i, n){
                super(e1, {
                    layout: Jv || (Jv = new Ks({
                        visibility: new Xs(Qs.layout_raster.visibility)
                    })),
                    paint: Kv || (Kv = new Ks({
                        "raster-opacity": new Xs(Qs.paint_raster["raster-opacity"]),
                        "raster-color": new Js(Qs.paint_raster["raster-color"]),
                        "raster-color-mix": new Xs(Qs.paint_raster["raster-color-mix"]),
                        "raster-color-range": new Xs(Qs.paint_raster["raster-color-range"]),
                        "raster-hue-rotate": new Xs(Qs.paint_raster["raster-hue-rotate"]),
                        "raster-brightness-min": new Xs(Qs.paint_raster["raster-brightness-min"]),
                        "raster-brightness-max": new Xs(Qs.paint_raster["raster-brightness-max"]),
                        "raster-saturation": new Xs(Qs.paint_raster["raster-saturation"]),
                        "raster-contrast": new Xs(Qs.paint_raster["raster-contrast"]),
                        "raster-resampling": new Xs(Qs.paint_raster["raster-resampling"]),
                        "raster-fade-duration": new Xs(Qs.paint_raster["raster-fade-duration"]),
                        "raster-emissive-strength": new Xs(Qs.paint_raster["raster-emissive-strength"]),
                        "raster-array-band": new Xs(Qs.paint_raster["raster-array-band"]),
                        "raster-elevation": new Xs(Qs.paint_raster["raster-elevation"]),
                        "raster-elevation-reference": new Xs(Qs.paint_raster["raster-elevation-reference"]),
                        "raster-color-use-theme": new Ys({
                            type: "string",
                            default: "default",
                            "property-type": "data-driven"
                        })
                    }))
                }, t1, i, n), this.updateColorRamp(), this._curRampRange = [
                    NaN,
                    NaN
                ];
            }
            getProgramIds() {
                return [
                    "raster"
                ];
            }
            hasColorMap() {
                return !!this._transitionablePaint._values["raster-color"].value.value;
            }
            tileCoverLift() {
                return this.paint.get("raster-elevation");
            }
            isDraped(e1) {
                const t1 = e1 ? e1._source : null;
                return (!t1 || "image" !== t1.type && "video" !== t1.type && "canvas" !== t1.type || !t1.onNorthPole && !t1.onSouthPole) && 0 === this.paint.get("raster-elevation");
            }
            _handleSpecialPaintPropertyUpdate(e1) {
                "raster-color" !== e1 && "raster-color-range" !== e1 || (this._curRampRange = [
                    NaN,
                    NaN
                ], this.updateColorRamp());
            }
            _clear() {
                this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
            }
            updateColorRamp(e1) {
                if (!this.hasColorMap()) return;
                if (!this._curRampRange) return;
                const t1 = this._transitionablePaint._values["raster-color"].value.expression, [i, n] = e1 || this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({
                    zoom: 0
                }) || [
                    NaN,
                    NaN
                ];
                isNaN(i) && isNaN(n) || i === this._curRampRange[0] && n === this._curRampRange[1] || (this.colorRamp = Iv({
                    expression: t1,
                    evaluationKey: "rasterValue",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: i,
                            end: n
                        }
                    ],
                    resolution: Qv
                }), this.colorRampTexture = null, this._curRampRange = [
                    i,
                    n
                ]);
            }
            is3D(e1) {
                return this.paint.get("raster-elevation") > 0;
            }
        }
        let ib, nb, rb, ob, ab, sb, lb;
        class ub extends Il {
            constructor(e1, t1, i, n){
                super(e1, {
                    layout: ib || (ib = new Ks({
                        visibility: new Xs(Qs["layout_raster-particle"].visibility)
                    })),
                    paint: nb || (nb = new Ks({
                        "raster-particle-array-band": new Xs(Qs["paint_raster-particle"]["raster-particle-array-band"]),
                        "raster-particle-count": new Xs(Qs["paint_raster-particle"]["raster-particle-count"]),
                        "raster-particle-color": new Js(Qs["paint_raster-particle"]["raster-particle-color"]),
                        "raster-particle-max-speed": new Xs(Qs["paint_raster-particle"]["raster-particle-max-speed"]),
                        "raster-particle-speed-factor": new Xs(Qs["paint_raster-particle"]["raster-particle-speed-factor"]),
                        "raster-particle-fade-opacity-factor": new Xs(Qs["paint_raster-particle"]["raster-particle-fade-opacity-factor"]),
                        "raster-particle-reset-rate-factor": new Xs(Qs["paint_raster-particle"]["raster-particle-reset-rate-factor"]),
                        "raster-particle-elevation": new Xs(Qs["paint_raster-particle"]["raster-particle-elevation"]),
                        "raster-particle-color-use-theme": new Ys({
                            type: "string",
                            default: "default",
                            "property-type": "data-driven"
                        })
                    }))
                }, t1, i, n), this._updateColorRamp(), this.lastInvalidatedAt = Vt.now();
            }
            mayUse(e1) {
                return "HD" === e1;
            }
            _clear() {
                this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null), this.tileFramebuffer && (this.tileFramebuffer.destroy(), this.tileFramebuffer = null), this.particleFramebuffer && (this.particleFramebuffer.destroy(), this.particleFramebuffer = null);
            }
            onRemove(e1) {
                this.colorRampTexture && this.colorRampTexture.destroy(), this.tileFramebuffer && this.tileFramebuffer.destroy(), this.particleFramebuffer && this.particleFramebuffer.destroy();
            }
            hasColorMap() {
                return !!this._transitionablePaint._values["raster-particle-color"].value.value;
            }
            getProgramIds() {
                return [
                    "rasterParticle"
                ];
            }
            hasOffscreenPass() {
                return "none" !== this.visibility;
            }
            isDraped(e1) {
                return !1;
            }
            _handleSpecialPaintPropertyUpdate(e1) {
                "raster-particle-color" !== e1 && "raster-particle-max-speed" !== e1 || (this._updateColorRamp(), this._invalidateAnimationState()), "raster-particle-count" === e1 && this._invalidateAnimationState();
            }
            _updateColorRamp() {
                if (!this.hasColorMap()) return;
                const e1 = this._transitionablePaint._values["raster-particle-color"].value.expression, t1 = this._transitionablePaint._values["raster-particle-max-speed"].value.expression.evaluate({
                    zoom: 0
                });
                this.colorRamp = Iv({
                    expression: e1,
                    evaluationKey: "rasterParticleSpeed",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: 0,
                            end: t1
                        }
                    ],
                    resolution: 256
                }), this.colorRampTexture = null;
            }
            _invalidateAnimationState() {
                this.lastInvalidatedAt = Vt.now();
            }
            tileCoverLift() {
                return this.paint.get("raster-particle-elevation");
            }
        }
        class cb extends Il {
            constructor(e1, t1){
                super(e1, {}, t1, null), this.implementation = e1, e1.slot && (this.slot = e1.slot);
            }
            is3D(e1) {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            isDraped(e1) {
                return void 0 !== this.implementation.renderToTile;
            }
            shouldRedrape() {
                return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {}
            onAdd(e1) {
                this.implementation.onAdd && this.implementation.onAdd(e1, e1.painter.context.gl);
            }
            onRemove(e1) {
                this.implementation.onRemove && this.implementation.onRemove(e1, e1.painter.context.gl);
            }
        }
        function hb(e1, t1, i) {
            const n = [
                0,
                0,
                1
            ], r = ce([]);
            return fe(r, r, i ? -Ye(e1) + Math.PI : Ye(e1)), de(r, r, -Ye(t1)), K(n, n, r), Z(n, n);
        }
        class db {
            constructor(e1, t1){
                this.feature = e1, this.instancedDataOffset = t1, this.instancedDataCount = 0, this.rotation = [
                    0,
                    0,
                    0
                ], this.scale = [
                    1,
                    1,
                    1
                ], this.translation = [
                    0,
                    0,
                    0
                ];
            }
        }
        class fb {
            constructor(){
                this.maxScale = 1, this.maxXYTranslationDistance = 0, this.instancedDataArray = new mc, this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
            }
            colorForInstance(e1) {
                const t1 = 16 * e1, i = this.instancedDataArray.float32;
                let n = Math.floor(i[t1 + 2]);
                const r = 1.05 * (i[t1 + 2] - n);
                return n /= 100, [
                    i[t1] % 1 * 1.05,
                    i[t1 + 1] % 1 * 1.05,
                    r,
                    n
                ];
            }
            tileCoordinatesForInstance(e1) {
                const t1 = 16 * e1, i = this.instancedDataArray.float32;
                let n = i[t1 + 0];
                return n = n > Sr ? n - Sr : n, new Pe(Math.trunc(n), Math.trunc(i[t1 + 1]));
            }
            translationForInstance(e1) {
                const t1 = 16 * e1, i = this.instancedDataArray.float32;
                return [
                    i[t1 + 4],
                    i[t1 + 5],
                    i[t1 + 6]
                ];
            }
            rotationScaleForInstance(e1) {
                const t1 = 16 * e1, i = this.instancedDataArray.float32;
                return [
                    i[t1 + 7],
                    i[t1 + 8],
                    i[t1 + 9],
                    i[t1 + 10],
                    i[t1 + 11],
                    i[t1 + 12],
                    i[t1 + 13],
                    i[t1 + 14],
                    i[t1 + 15]
                ];
            }
            transformForInstance(e1) {
                const t1 = 16 * e1, i = this.instancedDataArray.float32;
                return [
                    i[t1 + 7],
                    i[t1 + 8],
                    i[t1 + 9],
                    i[t1 + 4],
                    i[t1 + 10],
                    i[t1 + 11],
                    i[t1 + 12],
                    i[t1 + 5],
                    i[t1 + 13],
                    i[t1 + 14],
                    i[t1 + 15],
                    i[t1 + 6],
                    0,
                    0,
                    0,
                    1
                ];
            }
        }
        class pb {
            constructor(e1){
                this.requiresStandardRuntime = !0, this.zoom = e1.zoom, this.canonical = e1.canonical, this.overscaledZ = this.canonical.z + Math.log2(e1.overscaling), this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.projection = e1.projection, this.index = e1.index, this.worldview = e1.worldview, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.hasPattern = !1, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z + 1 ? 0 : this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = {
                    id: null,
                    timestamp: 0
                }, this.modelUris = [], this.modelsRequested = !1, this.activeReplacements = [], this.replacementUpdateTime = 0, this.styleDefinedModelURLs = e1.styleDefinedModelURLs, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                this.tileToMeter = vu(i);
                const r = this.layers[0]._featureFilter.needGeometry;
                this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
                const o = "hd-road-markup" === this.layers[0].paint.get("model-elevation-reference") ? t1.elevationFeatures : void 0;
                for (const { feature: a, id: s, index: l, sourceLayerIndex: u } of e1){
                    const e1 = s ?? (a.properties && Object.hasOwn(a.properties, "id") ? a.properties.id : void 0), c = Ru(a, r);
                    if (!this.layers[0]._featureFilter.filter(new ks(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), c, i)) continue;
                    const h = {
                        id: e1,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: r ? c.geometry : zu(a, i, n),
                        properties: a.properties,
                        type: a.type,
                        patterns: {}
                    }, d = this.addFeature(h, h.geometry, c, o, i);
                    d && t1.featureIndex.insert(a, h.geometry, l, u, this.index, this.instancesPerModel[d].instancedDataArray.length, 256);
                }
                this.lookup = null;
            }
            evaluateQueryRenderedFeaturePadding() {
                const e1 = this.layers[0].modelManager, t1 = this.layers[0].scope;
                let i = 0;
                for (const n of this.modelUris){
                    const r = e1.getModel(n, t1);
                    if (!r) continue;
                    const o = this.instancesPerModel[n];
                    if (o) {
                        const e1 = .5 * G(r.aabb.max, r.aabb.min) * o.maxScale + o.maxXYTranslationDistance, t1 = Math.min(Sr, Math.max(e1 / this.tileToMeter, 256));
                        i = Math.max(t1, i);
                    }
                }
                return i;
            }
            update(e1, t1, i, n) {
                for(const t1 in this.instancesPerModel){
                    const i = this.instancesPerModel[t1];
                    for(const t1 in e1)Object.hasOwn(i.idToFeaturesIndex, t1) && (this.evaluate(i.features[i.idToFeaturesIndex[t1]], e1[t1], i, !0), this.uploaded = !1);
                }
                this.maxHeight = 0;
            }
            updateZoomBasedPaintProperties() {
                if (!this.hasZoomDependentProperties) return !1;
                let e1 = !1;
                for(const t1 in this.instancesPerModel){
                    const i = this.instancesPerModel[t1];
                    for (const t1 of i.features){
                        const n = this.layers[0], r = t1.feature, o = this.canonical, a = n.paint.get("model-rotation").evaluate(r, {}, o), s = n.paint.get("model-scale").evaluate(r, {}, o), l = n.paint.get("model-translation").evaluate(r, {}, o);
                        ee(t1.rotation, a) && ee(t1.scale, s) && ee(t1.translation, l) || (this.evaluate(t1, t1.featureStates, i, !0), e1 = !0);
                    }
                }
                return e1;
            }
            updateReplacement(e1, t1, i, n) {
                if (t1.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = t1.updateTime;
                const r = t1.getReplacementRegionsForTile(e1.toUnwrapped(), !0);
                if (Dp(this.activeReplacements, r)) return !1;
                this.activeReplacements = r;
                let o = !1;
                for(const t1 in this.instancesPerModel){
                    const r = this.instancesPerModel[t1], a = r.instancedDataArray;
                    for (const t1 of r.features){
                        const r = t1.instancedDataOffset, s = t1.instancedDataCount;
                        for(let t1 = 0; t1 < s; t1++){
                            const s = 16 * (t1 + r);
                            let l = a.float32[s + 0];
                            const u = l > Sr;
                            l = u ? l - Sr : l;
                            const c = Math.floor(l), h = Math.floor(a.float32[s + 1]);
                            let d = !1;
                            for (const t1 of this.activeReplacements)if (!Sp(t1, i, Yy.Model, n) && !(t1.min.x > c || c > t1.max.x || t1.min.y > h || h > t1.max.y) && (d = Np(Bp(c, h, e1.canonical, t1.footprintTileId.canonical), t1.footprint), d)) break;
                            a.float32[s] = d ? l + Sr : l, o = o || d !== u;
                        }
                    }
                }
                return o;
            }
            isEmpty() {
                for(const e1 in this.instancesPerModel)if (0 !== this.instancesPerModel[e1].instancedDataArray.length) return !1;
                return !0;
            }
            uploadPending() {
                return !this.uploaded;
            }
            upload(e1) {
                if (!this.uploaded) for(const t1 in this.instancesPerModel){
                    const i = this.instancesPerModel[t1];
                    i.instancedDataArray.length < 0 || 0 === i.instancedDataArray.length || (i.instancedDataBuffer ? i.instancedDataBuffer.updateData(i.instancedDataArray) : i.instancedDataBuffer = e1.createVertexBuffer(i.instancedDataArray, Zg.members, !0, void 0, this.instanceCount));
                }
                this.uploaded = !0;
            }
            destroy(e1) {
                for(const e1 in this.instancesPerModel){
                    const t1 = this.instancesPerModel[e1];
                    0 !== t1.instancedDataArray.length && t1.instancedDataBuffer && t1.instancedDataBuffer.destroy();
                }
                const t1 = this.layers[0].modelManager;
                if (e1 && t1 && this.modelUris && this.modelsRequested) for (const e1 of this.modelUris)t1.removeModel(e1, "", !0);
            }
            addFeature(e1, t1, i, n, r) {
                const o = this.layers[0], a = o.layout.get("model-id"), s = o.layout.get("model-allow-density-reduction"), l = a.evaluate(i, {}, this.canonical);
                if (!l) return mt(`modelId is not evaluated for layer ${o.id} and it is not going to get rendered.`), l;
                !l.includes("://") && !this.styleDefinedModelURLs[l] || this.modelUris.includes(l) || this.modelUris.push(l), this.instancesPerModel[l] || (this.instancesPerModel[l] = new fb);
                const u = this.instancesPerModel[l], c = u.instancedDataArray, h = new db(i, c.length);
                let d;
                if (n) {
                    const t1 = pm(e1, n, void 0, r);
                    d = t1 ? t1.feature : void 0;
                }
                for (const e1 of t1)for (const t1 of e1){
                    if (t1.x < 0 || t1.x >= Sr || t1.y < 0 || t1.y >= Sr) continue;
                    if (0 !== this.lookupDim && s) {
                        const e1 = (this.lookupDim - 1) / Sr, i = this.lookupDim * (t1.y * e1 | 0) + t1.x * e1 | 0;
                        if (this.lookup) {
                            if (0 !== this.lookup[i]) continue;
                            this.lookup[i] = 1;
                        }
                    }
                    this.instanceCount++;
                    const e1 = c.length;
                    if (c.resize(e1 + 1), n) {
                        u.instancesRoadElevation || (u.instancesRoadElevation = []);
                        const e1 = d ? d.pointElevation(new Pe(t1.x, t1.y)) : 0;
                        u.instancesRoadElevation.push(e1);
                    }
                    u.instancesEvaluatedElevation.push(0), c.float32[16 * e1] = t1.x, c.float32[16 * e1 + 1] = t1.y;
                }
                return h.instancedDataCount = u.instancedDataArray.length - h.instancedDataOffset, h.instancedDataCount > 0 && (e1.id && (u.idToFeaturesIndex[e1.id] = u.features.length), u.features.push(h), this.evaluate(h, {}, u, !1)), l;
            }
            getModelUris() {
                return this.modelUris;
            }
            evaluate(e1, t1, i, n) {
                const r = this.layers[0], o = e1.feature, a = this.canonical, s = e1.rotation = r.paint.get("model-rotation").evaluate(o, t1, a), l = e1.scale = r.paint.get("model-scale").evaluate(o, t1, a), u = e1.translation = r.paint.get("model-translation").evaluate(o, t1, a), { r: c, g: h, b: d } = r.paint.get("model-color").evaluate(o, t1, a), f = r.paint.get("model-color-mix-intensity").evaluate(o, t1, a), p = [];
                this.maxVerticalOffset < u[2] && (this.maxVerticalOffset = u[2]);
                const _ = u[0] * u[0] + u[1] * u[1], m = _ > 0 ? Math.sqrt(_) : 0;
                i.maxScale = Math.max(Math.max(i.maxScale, l[0]), Math.max(l[1], l[2])), i.maxXYTranslationDistance = Math.max(i.maxXYTranslationDistance, m), this.maxScale = Math.max(Math.max(this.maxScale, l[0]), Math.max(l[1], l[2])), ty(p, s, l);
                const g = Math.round(100 * f) + d / 1.05;
                for(let t1 = 0; t1 < e1.instancedDataCount; ++t1){
                    const r = e1.instancedDataOffset + t1, o = 16 * r, s = i.instancedDataArray.float32;
                    let l = 0;
                    n && (l = s[o + 6] - i.instancesEvaluatedElevation[r]);
                    const d = 0 | s[o + 1];
                    s[o] = (0 | s[o]) + c / 1.05, s[o + 1] = d + h / 1.05, s[o + 2] = g, s[o + 3] = 1 / (a.z > 10 ? this.tileToMeter : vu(a, d)), s[o + 4] = u[0], s[o + 5] = u[1], s[o + 6] = u[2] + (i.instancesRoadElevation ? i.instancesRoadElevation[r] : 0) + l, s[o + 7] = p[0], s[o + 8] = p[1], s[o + 9] = p[2], s[o + 10] = p[4], s[o + 11] = p[5], s[o + 12] = p[6], s[o + 13] = p[8], s[o + 14] = p[9], s[o + 15] = p[10], i.instancesEvaluatedElevation[r] = u[2];
                }
            }
        }
        Ha(pb, "ModelBucket", {
            omit: [
                "layers"
            ]
        }), Ha(fb, "PerModelAttributes"), Ha(db, "ModelFeature");
        class _b {
            constructor(e1, t1, i){
                this._demTile = e1, this._dem = this._demTile.dem, this._scale = t1, this._offset = i;
            }
            static create(e1, t1, i) {
                const n = i || e1.findDEMTileFor(t1);
                if (!n || !n.dem) return;
                const r = n.dem, o = n.tileID, a = 1 << t1.canonical.z - o.canonical.z;
                return new _b(n, r.dim / Sr / a, [
                    (t1.canonical.x / a - o.canonical.x) * r.dim,
                    (t1.canonical.y / a - o.canonical.y) * r.dim
                ]);
            }
            tileCoordToPixel(e1, t1) {
                const i = t1 * this._scale + this._offset[1];
                return new Pe(Math.floor(e1 * this._scale + this._offset[0]), Math.floor(i));
            }
            getElevationAt(e1, t1, i, n) {
                const r = e1 * this._scale + this._offset[0], o = t1 * this._scale + this._offset[1], a = Math.floor(r), s = Math.floor(o), l = this._dem;
                return n = !!n, i ? dn(dn(l.get(a, s, n), l.get(a, s + 1, n), o - s), dn(l.get(a + 1, s, n), l.get(a + 1, s + 1, n), o - s), r - a) : l.get(a, s, n);
            }
            getElevationAtPixel(e1, t1, i) {
                return this._dem.get(e1, t1, !!i);
            }
            getMeterToDEM(e1) {
                return (1 << this._demTile.tileID.canonical.z) * pu(1, e1) * this._dem.stride;
            }
        }
        const mb = new Float32Array(262144), gb = new Uint8Array(262144), yb = [
            0,
            0,
            0
        ], xb = [
            0,
            0,
            0
        ];
        function vb(e1) {
            let t1 = 0;
            if (e1.meshes) for (const i of e1.meshes)t1 = Math.max(t1, i.aabb.max[2]);
            if (e1.children) for (const i of e1.children)t1 = Math.max(t1, vb(i));
            return t1;
        }
        function bb(e1, t1, i) {
            if (e1.meshes) for (const n of e1.meshes){
                if (n.aabb.min[0] === 1 / 0) continue;
                const r = If.applyTransform(n.aabb, e1.globalMatrix);
                i.insert(t1, r.min[0], r.min[1], r.max[0], r.max[1]);
            }
            if (e1.children) for (const n of e1.children)bb(n, t1, i);
        }
        const wb = [
            "",
            "wall",
            "door",
            "roof",
            "window",
            "lamp",
            "logo"
        ];
        class Eb {
            constructor(e1){
                this.node = e1, this.evaluatedRMEA = [
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        .4,
                        1,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ]
                ], this.hiddenByReplacement = !1, this.evaluatedTranslation = [
                    0,
                    0,
                    0
                ], this.evaluatedScale = [
                    1,
                    1,
                    1
                ], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.cameraCollisionOpacity = 1, this.targetLod = -1, this.feature = {
                    type: "Point",
                    id: e1.id,
                    geometry: [],
                    properties: {
                        height: vb(e1)
                    }
                }, this.aabb = this._getLocalBounds(), this.state = null;
            }
            _getLocalBounds() {
                if (!this.node.meshes) return new If([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]);
                if (!this.aabb) {
                    let e1 = 0;
                    const t1 = new If([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]);
                    for (const i of this.node.meshes)this.node.lightMeshIndex !== e1 && (i.transformedAabb = If.applyTransformFast(i.aabb, this.node.globalMatrix), t1.encapsulate(i.transformedAabb)), e1++;
                    this.aabb = t1;
                }
                return this.aabb;
            }
        }
        class Ab {
            constructor(e1, t1, i, n, r, o, a, s){
                this.requiresStandardRuntime = !0, this.isTiled3dModelBucket = !0, this.id = i, this.layers = e1, this.layerIds = this.layers.map((e1)=>e1.fqid), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.modelTraits |= 1, this.uploaded = !1, this.hasPattern = !1, n && (this.modelTraits |= 4), r && (this.modelTraits |= 8), this.zoom = -1, this.terrainExaggeration = 1, this.projection = {
                    name: "mercator"
                }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = o, this.worldview = s, this.dirty = !0, this.needsUpload = !1, this.filter = null, this.nodesInfo = [];
                for (const e1 of t1)this.nodesInfo.push(new Eb(e1)), bb(e1, a.featureIndexArray.length, a.grid), a.featureIndexArray.emplaceBack(this.nodesInfo.length - 1, 0, a.bucketLayerIDs.length - 1, 0);
                this.states = {}, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {
                for (const i of this.getNodesInfo()){
                    const n = i.node;
                    n.footprint && t1.push({
                        footprint: n.footprint,
                        id: e1
                    });
                }
            }
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            update(e1) {
                const t1 = 0 !== Object.keys(e1).length;
                if (t1 && !this.stateDependentLayers.length) return;
                const i = t1 ? this.stateDependentLayers : this.layers;
                if (!De(e1, this.states)) for (const t1 of i)this.evaluate(t1, e1);
                this.states = structuredClone(e1);
            }
            populate() {
                console.log("populate 3D model bucket");
            }
            uploadPending() {
                return !this.uploaded || this.needsUpload;
            }
            upload(e1) {
                if (!this.needsUpload) return;
                const t1 = this.getNodesInfo();
                for (const i of t1){
                    const t1 = i.node;
                    this.uploaded ? this.updatePbrBuffer(t1) : hy(t1, e1, !0);
                }
                for (const e1 of t1)fy(e1.node);
                this.uploaded = !0, this.needsUpload = !1;
            }
            updatePbrBuffer(e1) {
                let t1 = !1;
                if (!e1.meshes) return t1;
                for (const i of e1.meshes)i.pbrBuffer && (i.pbrBuffer.updateData(i.featureArray), t1 = !0);
                if (e1.lodMeshes) for (const i of e1.lodMeshes)i.pbrBuffer && (i.pbrBuffer.updateData(i.featureArray), t1 = !0);
                return t1;
            }
            needsReEvaluation(e1, t1, i) {
                const n = e1.transform.projectionOptions, r = e1.style.getBrightness(), o = this.brightness !== r;
                if (!this.uploaded || this.dirty || n.name !== this.projection.name || Ib(i.paint.get("model-color").value, o) || Ib(i.paint.get("model-color-mix-intensity").value, o) || Ib(i.paint.get("model-roughness").value, o) || Ib(i.paint.get("model-emissive-strength").value, o) || Ib(i.paint.get("model-height-based-emissive-strength-multiplier").value, o)) {
                    this.projection = n, this.brightness = r;
                    const e1 = this.getNodesInfo();
                    for (const t1 of e1)t1.state = null;
                    return !0;
                }
                return !1;
            }
            evaluateTransform(e1, t1) {
                if (e1.transform.zoom === this.zoom) return;
                this.zoom = e1.transform.zoom;
                const i = this.getNodesInfo(), n = this.id.canonical;
                for (const e1 of i){
                    const i = e1.feature;
                    e1.evaluatedTranslation = t1.paint.get("model-translation").evaluate(i, {}, n), e1.evaluatedScale = t1.paint.get("model-scale").evaluate(i, {}, n);
                }
            }
            evaluate(e1, t1) {
                const i = this.getNodesInfo();
                for (const n of i){
                    if (!n.node.meshes) continue;
                    const i = n.feature, r = t1 && t1[i.id];
                    if (De(r, n.state)) continue;
                    n.state = structuredClone(r);
                    const o = n.node.meshes && n.node.meshes[0].featureData, a = n.evaluatedColor[2], s = n.evaluatedRMEA[2], l = this.id.canonical;
                    if (n.hasTranslucentParts = !1, o) {
                        for(let t1 = 0; t1 < wb.length; t1++){
                            const o = wb[t1];
                            o.length && (i.properties.part = o);
                            const a = e1.paint.get("model-color").evaluate(i, r, l).toPremultipliedRenderColor(null), s = e1.paint.get("model-color-mix-intensity").evaluate(i, r, l);
                            n.evaluatedColor[t1] = [
                                a.r,
                                a.g,
                                a.b,
                                s
                            ], n.evaluatedRMEA[t1][0] = e1.paint.get("model-roughness").evaluate(i, r, l), n.evaluatedRMEA[t1][2] = e1.paint.get("model-emissive-strength").evaluate(i, r, l), n.evaluatedRMEA[t1][3] = a.a, n.emissionHeightBasedParams[t1] = e1.paint.get("model-height-based-emissive-strength-multiplier").evaluate(i, r, l), !n.hasTranslucentParts && a.a < 1 && (n.hasTranslucentParts = !0);
                        }
                        delete i.properties.part, zb(n, a !== n.evaluatedColor[2] || s !== n.evaluatedRMEA[2], this.modelTraits);
                    } else n.evaluatedRMEA[0][2] = e1.paint.get("model-emissive-strength").evaluate(i, r, l);
                    n.evaluatedTranslation = e1.paint.get("model-translation").evaluate(i, r, l), n.evaluatedScale = e1.paint.get("model-scale").evaluate(i, r, l), this.updatePbrBuffer(n.node) || (this.needsUpload = !0);
                }
                this.dirty = !1;
            }
            elevationUpdate(e1, t1, i, n) {
                const r = e1.findDEMTileFor(i);
                if (r && (r.tileID.canonical !== this.terrainTile || t1 !== this.terrainExaggeration)) {
                    if (r.dem && r.tileID.overscaledZ !== this.elevationReadFromZ) {
                        this.elevationReadFromZ = r.tileID.overscaledZ;
                        const t1 = _b.create(e1, i, r);
                        if (!t1) return;
                        4 & this.modelTraits && this.updateDEM(e1, t1, i, n);
                        for (const e1 of this.getNodesInfo()){
                            const i = e1.node;
                            if (!i.footprint || !i.footprint.vertices || !i.footprint.vertices.length) continue;
                            const n = i.footprint.vertices;
                            let r = t1.getElevationAt(n[0].x, n[0].y, !0, !0);
                            for(let e1 = 1; e1 < n.length; e1++)r = Math.min(r, t1.getElevationAt(n[e1].x, n[e1].y, !0, !0));
                            i.elevation = r;
                        }
                    }
                    this.terrainTile = r.tileID.canonical, this.terrainExaggeration = t1;
                }
            }
            updateDEM(e1, t1, i, n) {
                let r = t1._dem._modifiedForSources[n];
                if (void 0 === r && (t1._dem._modifiedForSources[n] = [], r = t1._dem._modifiedForSources[n]), r.includes(i.canonical)) return;
                const o = t1._dem.dim;
                r.push(i.canonical);
                let a = !1;
                for (const e1 of this.getNodesInfo()){
                    const i = e1.node;
                    if (!i.footprint || !i.footprint.grid) continue;
                    const n = i.footprint.grid, r = t1.tileCoordToPixel(n.min.x, n.min.y), s = t1.tileCoordToPixel(n.max.x, n.max.y), l = Math.min(Math.min(o - s.y, r.x), Math.min(r.y, o - s.x));
                    if (l < 0) continue;
                    const u = tt(l, 2, 5);
                    let c = Math.max(0, r.x - u), h = Math.max(0, r.y - u), d = Math.min(s.x + u, o - 1), f = Math.min(s.y + u, o - 1);
                    for(let e1 = h; e1 <= f; ++e1)for(let t1 = c; t1 <= d; ++t1)gb[e1 * o + t1] = 255;
                    let p = 0, _ = 0;
                    for(let e1 = 0; e1 < n.cellsY; ++e1)for(let i = 0; i < n.cellsX; ++i){
                        if (!n.cells[e1 * n.cellsX + i]) continue;
                        const r = t1.tileCoordToPixel(n.min.x + i / n.xScale, n.min.y + e1 / n.yScale), a = t1.tileCoordToPixel(n.min.x + (i + 1) / n.xScale, n.min.y + (e1 + 1) / n.yScale);
                        for(let e1 = r.y; e1 <= Math.min(a.y + 1, o - 1); ++e1)for(let i = r.x; i <= Math.min(a.x + 1, o - 1); ++i)255 === gb[e1 * o + i] && (gb[e1 * o + i] = 0, p += t1.getElevationAtPixel(i, e1), _++);
                    }
                    const m = p / _;
                    c = Math.max(1, r.x - u), h = Math.max(1, r.y - u), d = Math.min(s.x + u, o - 2), f = Math.min(s.y + u, o - 2), a = !0;
                    for(let e1 = h; e1 <= f; ++e1)for(let i = c; i <= d; ++i)0 === gb[e1 * o + i] && (mb[e1 * o + i] = t1._dem.set(i, e1, m));
                    for(let e1 = 1; e1 < u; ++e1){
                        c = Math.max(1, r.x - e1), h = Math.max(1, r.y - e1), d = Math.min(s.x + e1, o - 2), f = Math.min(s.y + e1, o - 2);
                        for(let i = h; i <= f; ++i)for(let n = c; n <= d; ++n){
                            const r = i * o + n;
                            if (255 === gb[r]) {
                                let a = 0, s = 0, l = -1, c = -1;
                                for(let t1 = -1; t1 <= 1; ++t1)for(let r = -1; r <= 1; ++r){
                                    const u = (i + t1) * o + n + r;
                                    if (gb[u] >= e1) continue;
                                    const h = mb[u], d = Math.abs(h);
                                    d > s && (a = h, s = d, l = r, c = t1);
                                }
                                if (s > .1) {
                                    const o = 1 - (e1 + .5 * Math.abs(l * c)) / u;
                                    let s = t1._dem.get(n, i) + a * o;
                                    const h = t1._dem.get(n + l, i + c), d = t1._dem.get(n - l, i - c, !0);
                                    (s - h) * (s - d) > 0 && (s = (h + d) / 2), mb[r] = t1._dem.set(n, i, s), gb[r] = e1;
                                }
                            }
                        }
                    }
                }
                a && (t1._demTile.needsDEMTextureUpload = !0, t1._dem._timestamp = Vt.now());
            }
            setFilter(e1) {
                this.filter = e1 ? nl(e1) : null;
            }
            getNodesInfo() {
                return this.filter ? this.nodesInfo.filter((e1)=>this.filter.filter(new ks(this.id.overscaledZ, {
                        worldview: this.worldview
                    }), e1.feature, this.id.canonical)) : this.nodesInfo;
            }
            destroy() {
                const e1 = this.getNodesInfo();
                for (const t1 of e1)fy(t1.node), _y(t1.node);
            }
            isEmpty() {
                return !this.nodesInfo.length;
            }
            updateReplacement(e1, t1) {
                if (t1.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t1.updateTime;
                const i = t1.getReplacementRegionsForTile(e1.toUnwrapped());
                for (const e1 of this.getNodesInfo()){
                    const t1 = e1.node.footprint;
                    e1.hiddenByReplacement = !!t1 && !i.some((e1)=>e1.footprint === t1);
                }
            }
            getHeightAtTileCoord(e1, t1) {
                const i = [
                    0,
                    0,
                    0
                ], n = d([]);
                for (const r of this.getNodesInfo()){
                    const o = r.node.meshes[0], a = o.transformedAabb;
                    if (e1 < a.min[0] || t1 < a.min[1] || e1 > a.max[0] || t1 > a.max[1]) continue;
                    if (!0 === r.node.hidden) return {
                        height: 1 / 0,
                        maxHeight: r.feature.properties.height,
                        hidden: !1,
                        verticalScale: r.evaluatedScale[2]
                    };
                    if (p(n, r.node.globalMatrix), i[0] = e1, i[1] = t1, i[2] = 0, Y(i, i, n), r.node.meshBVH) {
                        const e1 = i[0], t1 = i[1];
                        yb[0] = e1 - 1, yb[1] = t1 - 1, yb[2] = -1000, xb[0] = e1 + 1, xb[1] = t1 + 1, xb[2] = 1e3;
                        const n = r.node.meshBVH.findHighestPoint(yb, xb);
                        if (null !== n) return {
                            height: n,
                            maxHeight: r.feature.properties.height,
                            hidden: r.hiddenByReplacement,
                            verticalScale: r.evaluatedScale[2]
                        };
                        continue;
                    }
                    const s = (i[0] - o.aabb.min[0]) / (o.aabb.max[0] - o.aabb.min[0]) * oy | 0, l = Math.min(63, (i[1] - o.aabb.min[1]) / (o.aabb.max[1] - o.aabb.min[1]) * oy | 0) * oy + Math.min(63, s), u = o.heightmap[l];
                    if (u < 0 && r.node.footprint) {
                        const i = [];
                        if (r.node.footprint.grid.query(new Pe(e1, t1), new Pe(e1, t1), i), i.length > 0) return {
                            height: void 0,
                            maxHeight: r.feature.properties.height,
                            hidden: r.hiddenByReplacement,
                            verticalScale: r.evaluatedScale[2]
                        };
                        continue;
                    }
                    if (r.hiddenByReplacement) return;
                    return {
                        height: u,
                        maxHeight: r.feature.properties.height,
                        hidden: !1,
                        verticalScale: r.evaluatedScale[2]
                    };
                }
            }
        }
        function Ib(e1, t1) {
            return e1 instanceof Ba && !e1.isLightConstant && t1;
        }
        function Tb(e1) {
            const t1 = tt(e1, 0, 2);
            return Math.min(Math.round(.5 * t1 * 255), 255);
        }
        const Mb = new Float64Array(10 * wb.length);
        function Sb(e1, t1, i, n, r, o) {
            if (!e1.featureData) return;
            const a = e1.featureArray = new gc;
            a.reserveExact(e1.featureData.length), function(e1, t1, i) {
                const n = i - t1;
                for(let i = 0; i < wb.length; i++){
                    const r = e1.evaluatedRMEA[i], o = e1.evaluatedColor[i], a = e1.emissionHeightBasedParams[i], s = tt(a[0], 0, 1), l = tt(a[1], 0, 1);
                    let u = 65535, c = 0, h = 1, d = 1;
                    if (s !== l && 0 !== n) {
                        const e1 = tt(a[2], 0, 1), i = tt(a[3], 0, 1), r = n * (l - s);
                        c = 1 / r, h = -(t1 + n * s) / r, d = Math.pow(10, tt(a[4], -1, 1)), u = 255 * e1 << 8 | 255 * i;
                    }
                    const f = Mb, p = 10 * i;
                    f[p] = 255 * o[0], f[p + 1] = 255 * o[1], f[p + 2] = 255 * o[2], f[p + 3] = o[3], f[p + 4] = Math.floor(255 * r[3]), f[p + 5] = Tb(r[2]) << 8 | 15 * r[0] << 4 | 15 * r[1], f[p + 6] = u, f[p + 7] = c, f[p + 8] = h, f[p + 9] = d;
                }
            }(t1, e1.aabb.min[2], e1.aabb.max[2]);
            const s = Mb, l = t1.node;
            let u = r && !!l.lights;
            for (const t1 of e1.featureData){
                const e1 = t1 >> i & 65535, r = t1 >> n & 15, c = r < 8 ? r : 0, h = 10 * c;
                let d = (61440 & e1 | (61440 & e1) >> 4) >> 8, f = (3840 & e1 | (3840 & e1) >> 4) >> 4, p = 240 & e1 | (240 & e1) >> 4;
                const _ = (15 & e1 | (15 & e1) << 4) / 255, m = s[h + 3];
                m > 0 && (d = dn(d, s[h], m), f = dn(f, s[h + 1], m), p = dn(p, s[h + 2], m)), o && (d *= _, f *= _, p *= _);
                const g = d << 8 | f, y = p << 8 | s[h + 4], x = s[h + 5], v = s[h + 6], b = s[h + 7], w = s[h + 8], E = s[h + 9];
                if (a.emplaceBack(g, y, x, v, b, w, E), u && 2 === c) {
                    u = !1;
                    const e1 = 10 * l.lights.length, t1 = new gc;
                    t1.reserveExact(e1);
                    for(let i = 0; i < e1; i++)t1.emplaceBack(g, y, x, v, b, w, E);
                    l.meshes[l.lightMeshIndex].featureArray = t1;
                }
            }
        }
        function zb(e1, t1, i) {
            const n = e1.node, r = 8 & i, o = r ? 0 : 16, a = r ? 16 : 0;
            for(let i = 0; i < n.meshes.length; i++)n.lights && n.lightMeshIndex === i || Sb(n.meshes[i], e1, o, a, t1, !1);
            if (n.lodMeshes) for (const t1 of n.lodMeshes)Sb(t1, e1, o, a, !1, !0);
        }
        Ha(Ab, "Tiled3dModelBucket", {
            omit: [
                "layers"
            ]
        }), Ha(Eb, "Tiled3dModelFeature");
        class Rb {
            constructor(e1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let t1 = 0; t1 < e1.length; t1++){
                    const i = e1[t1];
                    this._stringToNumber[i] = t1, this._numberToString[t1] = i;
                }
            }
            encode(e1) {
                return this._stringToNumber[e1];
            }
            decode(e1) {
                return this._numberToString[e1];
            }
        }
        const Pb = [
            "id",
            "tile",
            "layer",
            "source",
            "sourceLayer",
            "state"
        ];
        class Db {
            constructor(e1, t1, i, n, r){
                this.type = "Feature", this._vectorTileFeature = e1, this._z = t1, this._x = i, this._y = n, this.properties = e1 ? e1.properties : {}, this.id = r;
            }
            clone() {
                const e1 = new Db(this._vectorTileFeature, this._z, this._x, this._y, this.id);
                return this.state && (e1.state = {
                    ...this.state
                }), this.layer && (e1.layer = {
                    ...this.layer
                }), this.source && (e1.source = this.source), this.sourceLayer && (e1.sourceLayer = this.sourceLayer), e1;
            }
            get geometry() {
                return void 0 === this._geometry && this._vectorTileFeature && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
            }
            set geometry(e1) {
                this._geometry = e1;
            }
            toJSON() {
                const e1 = {
                    type: "Feature",
                    state: void 0,
                    geometry: this.geometry,
                    properties: this.properties
                };
                for (const t1 of Pb)void 0 !== this[t1] && (e1[t1] = this[t1]);
                return e1;
            }
        }
        const Cb = {
            BaseColor: 5,
            MetallicRoughness: 6,
            Normal: 7,
            Occlusion: 8,
            Emission: 9,
            LUT: 10,
            ShadowMap0: 11
        }, Fb = new Float32Array(d([])), Ob = [
            0,
            0,
            0
        ], Lb = (e1, t1, i, n, r, o, s, u, c, h, d, f, p, _ = [
            0,
            0,
            0
        ], m, g, y, x = 1, v = !1)=>{
            let b = Ob, w = 0, E = Ob;
            if (!v) {
                const e1 = r.style.light, t1 = e1.properties.get("position");
                if (b = [
                    -t1.x,
                    -t1.y,
                    t1.z
                ], "viewport" === e1.properties.get("anchor")) {
                    const e1 = a();
                    l(e1, -r.transform.angle), J(b, b, e1);
                }
                const i = e1.properties.get("color").toNonPremultipliedRenderColor(null);
                w = e1.properties.get("intensity"), E = [
                    i.r,
                    i.g,
                    i.b
                ];
            }
            const A = "MASK" === d.alphaMode, I = p.paint.get("model-ambient-occlusion-intensity"), T = p.paint.get("model-color").constantOr(pn.white).toNonPremultipliedRenderColor(null);
            return T.a = p.paint.get("model-color-mix-intensity").constantOr(0), y && (T.r = y[0], T.g = y[1], T.b = y[2], T.a = y[3]), g && (T.r = g.color.r, T.g = g.color.g, T.b = g.color.b, T.a = g.colorMix, f = g.emissionStrength, o *= g.opacity), {
                u_matrix: e1,
                u_lighting_matrix: t1,
                u_normal_matrix: i,
                u_node_matrix: n || Fb,
                u_lightpos: b,
                u_lightintensity: w,
                u_lightcolor: E,
                u_camera_pos: _,
                u_opacity: o,
                u_baseTextureIsAlpha: 0,
                u_alphaMask: +A,
                u_alphaCutoff: d.alphaCutoff,
                u_baseColorFactor: s.toNonPremultipliedRenderColor(null).toArray01(),
                u_emissiveFactor: u.toNonPremultipliedRenderColor(null).toArray01(),
                u_metallicFactor: c,
                u_roughnessFactor: h,
                u_baseColorTexture: Cb.BaseColor,
                u_metallicRoughnessTexture: Cb.MetallicRoughness,
                u_normalTexture: Cb.Normal,
                u_occlusionTexture: Cb.Occlusion,
                u_emissionTexture: Cb.Emission,
                u_lutTexture: Cb.LUT,
                u_color_mix: T.toArray01(),
                u_aoIntensity: I,
                u_emissive_strength: f,
                u_occlusionTextureTransform: m || [
                    0,
                    0,
                    0,
                    0
                ],
                u_dithered_discard_threshold: x
            };
        }, Bb = (e1, t1 = Fb, i = Fb)=>({
                u_matrix: e1,
                u_instance: t1,
                u_node_matrix: i
            }), Nb = 7680;
        class Vb {
            constructor(e1, t1, i, n, r, o){
                this.test = e1, this.ref = t1, this.mask = i, this.fail = n, this.depthFail = r, this.pass = o;
            }
        }
        Vb.disabled = new Vb({
            func: 519,
            mask: 0
        }, 0, 0, Nb, Nb, Nb);
        const kb = 770, Ub = 771;
        class Gb {
            constructor(e1, t1, i, n){
                this.blendFunction = e1, this.blendColor = t1.toNonPremultipliedRenderColor(null), this.mask = i, this.blendEquation = n;
            }
        }
        Gb.Replace = [
            1,
            0,
            1,
            0
        ], Gb.disabled = new Gb(Gb.Replace, pn.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Gb.unblended = new Gb(Gb.Replace, pn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Gb.alphaBlended = new Gb([
            1,
            Ub,
            1,
            Ub
        ], pn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Gb.alphaBlendedNonPremultiplied = new Gb([
            kb,
            Ub,
            kb,
            Ub
        ], pn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Gb.multiply = new Gb([
            774,
            0,
            774,
            0
        ], pn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Gb.multiplyAccumulateAlpha = new Gb([
            774,
            0,
            1,
            Ub
        ], pn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Gb.additive = new Gb([
            1,
            1,
            1,
            1
        ], pn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Gb.additiveAlphaWeighted = new Gb([
            kb,
            1,
            773,
            1
        ], pn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Gb.additiveAlphaWeightedUnboundedAlpha = new Gb([
            kb,
            1,
            1,
            1
        ], pn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        class jb {
            constructor(e1, t1, i){
                this.func = e1, this.mask = t1, this.range = i;
            }
        }
        jb.ReadOnly = !1, jb.ReadWrite = !0, jb.disabled = new jb(519, jb.ReadOnly, [
            0,
            1
        ]);
        const Hb = 1029, $b = 2305;
        class Zb {
            constructor(e1, t1, i){
                this.enable = e1, this.mode = t1, this.frontFace = i;
            }
        }
        Zb.disabled = new Zb(!1, Hb, $b), Zb.backCCW = new Zb(!0, Hb, $b), Zb.backCW = new Zb(!0, Hb, 2304), Zb.frontCW = new Zb(!0, 1028, 2304), Zb.frontCCW = new Zb(!0, 1028, $b);
        class Wb {
            constructor(e1 = 0, t1 = 0, i = 0, n = 0){
                if (isNaN(e1) || e1 < 0 || isNaN(t1) || t1 < 0 || isNaN(i) || i < 0 || isNaN(n) || n < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e1, this.bottom = t1, this.left = i, this.right = n;
            }
            interpolate(e1, t1, i) {
                return null != t1.top && null != e1.top && (this.top = dn(e1.top, t1.top, i)), null != t1.bottom && null != e1.bottom && (this.bottom = dn(e1.bottom, t1.bottom, i)), null != t1.left && null != e1.left && (this.left = dn(e1.left, t1.left, i)), null != t1.right && null != e1.right && (this.right = dn(e1.right, t1.right, i)), this;
            }
            getCenter(e1, t1) {
                return new Pe(tt((this.left + e1 - this.right) / 2, 0, e1), tt((this.top + t1 - this.bottom) / 2, 0, t1));
            }
            equals(e1) {
                return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
            }
            clone() {
                return new Wb(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        function qb(e1, t1) {
            const i = At(e1, 3);
            T(e1, t1), It(e1, 3, i);
        }
        function Xb(e1, t1) {
            const i = ce([]);
            return pe(i, i, -t1), de(i, i, -e1), i;
        }
        function Yb(e1, t1) {
            const i = [
                e1[0],
                e1[1],
                0
            ], n = [
                t1[0],
                t1[1],
                0
            ];
            if (D(i) >= 1e-15) {
                const e1 = Z([], i);
                k(n, e1, W(n, e1)), t1[0] = n[0], t1[1] = n[1];
            }
            const r = q([], t1, e1);
            if (ne(r) < 1e-15) return null;
            const o = Math.atan2(-r[1], r[0]);
            return Xb(Math.atan2(Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]), -e1[2]), o);
        }
        class Jb {
            constructor(e1, t1){
                this.position = e1, this.orientation = t1;
            }
            get position() {
                return this._position;
            }
            set position(e1) {
                if (e1) {
                    const t1 = e1 instanceof bu ? e1 : new bu(e1[0], e1[1], e1[2]);
                    this._renderWorldCopies && (t1.x = nt(t1.x, 0, 1)), this._position = t1;
                } else this._position = null;
            }
            lookAtPoint(e1, t1, i) {
                if (this.orientation = null, !this.position) return;
                const n = this.position, r = i || (this._elevation ? this._elevation.getAtPointOrZero(bu.fromLngLat(e1)) : 0), o = bu.fromLngLat(e1, r), a = [
                    o.x - n.x,
                    o.y - n.y,
                    o.z - n.z
                ];
                t1 || (t1 = [
                    0,
                    0,
                    1
                ]), t1[2] = Math.abs(t1[2]), this.orientation = Yb(a, t1);
            }
            setPitchBearing(e1, t1) {
                this.orientation = Xb(Ye(e1), Ye(-t1));
            }
        }
        class Kb {
            constructor(e1, t1){
                this._transform = d([]), this.orientation = t1, this.position = e1;
            }
            get mercatorPosition() {
                const e1 = this.position;
                return new bu(e1[0], e1[1], e1[2]);
            }
            get position() {
                const e1 = At(this._transform, 3);
                return [
                    e1[0],
                    e1[1],
                    e1[2]
                ];
            }
            set position(e1) {
                var t1;
                e1 && It(this._transform, 3, [
                    (t1 = e1)[0],
                    t1[1],
                    t1[2],
                    1
                ]);
            }
            get orientation() {
                return this._orientation;
            }
            set orientation(e1) {
                this._orientation = e1 || ce([]), e1 && qb(this._transform, this._orientation);
            }
            getPitchBearing() {
                const e1 = this.forward(), t1 = this.right();
                return {
                    bearing: Math.atan2(-t1[1], t1[0]),
                    pitch: Math.atan2(Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]), -e1[2])
                };
            }
            setPitchBearing(e1, t1) {
                this._orientation = Xb(e1, t1), qb(this._transform, this._orientation);
            }
            forward() {
                const e1 = At(this._transform, 2);
                return [
                    -e1[0],
                    -e1[1],
                    -e1[2]
                ];
            }
            up() {
                const e1 = At(this._transform, 1);
                return [
                    -e1[0],
                    -e1[1],
                    -e1[2]
                ];
            }
            right() {
                const e1 = At(this._transform, 0);
                return [
                    e1[0],
                    e1[1],
                    e1[2]
                ];
            }
            getCameraToWorld(e1, t1) {
                const i = new Float64Array(16);
                return p(i, this.getWorldToCamera(e1, t1)), i;
            }
            getCameraToWorldMercator() {
                return this._transform;
            }
            getWorldToCameraPosition(e1, t1, i) {
                const n = this.position;
                k(n, n, -e1);
                const r = new Float64Array(16);
                return w(r, [
                    i,
                    i,
                    i
                ]), m(r, r, n), r[10] *= t1, r;
            }
            getWorldToCamera(e1, t1) {
                const i = new Float64Array(16), n = new Float64Array(4), r = this.position;
                var o, a;
                return (o = n)[0] = -(a = this._orientation)[0], o[1] = -a[1], o[2] = -a[2], o[3] = a[3], k(r, r, -e1), T(i, n), m(i, i, r), i[1] *= -1, i[5] *= -1, i[9] *= -1, i[13] *= -1, i[8] *= t1, i[9] *= t1, i[10] *= t1, i[11] *= t1, i;
            }
            getCameraToClipPerspective(e1, t1, i, n) {
                const r = new Float64Array(16);
                return M(r, e1, t1, i, n), r;
            }
            getCameraToClipOrthographic(e1, t1, i, n, r, o) {
                const a = new Float64Array(16);
                return S(a, e1, t1, i, n, r, o), a;
            }
            getDistanceToElevation(e1, t1 = !1) {
                const i = 0 === e1 ? 0 : pu(e1, t1 ? pr(this.position[1]) : this.position[1]), n = this.forward();
                return (i - this.position[2]) / n[2];
            }
            clone() {
                return new Kb([
                    ...this.position
                ], [
                    ...this.orientation
                ]);
            }
        }
        const Qb = Math.tan(85 * Math.PI / 180);
        function ew(e1, t1, i, n, r, a, s) {
            const l = u();
            if (i) {
                if ("globe" === a.name) {
                    const e1 = function(e1, t1) {
                        const { x: i, y: n } = e1.point, r = Hf(i, n, e1.worldSize / e1._pixelsPerMercatorPixel, 0, 0);
                        return _(r, r, Uf(Pf(t1)));
                    }(r, t1);
                    _(l, l, e1);
                } else {
                    const e1 = o([], s);
                    l[0] = e1[0], l[1] = e1[1], l[4] = e1[2], l[5] = e1[3], n || v(l, l, r.angle);
                }
            } else _(l, r.labelPlaneMatrix, e1);
            return l;
        }
        function tw(e1, t1, i, n) {
            const r = [
                e1,
                t1,
                i,
                1
            ];
            i ? le(r, r, n) : dw(r, r, n);
            const o = r[3];
            return r[0] /= o, r[1] /= o, r[2] /= o, r;
        }
        function iw(e1, t1) {
            return Math.min(.5 + e1 / t1 * .5, 1.5);
        }
        function nw(e1, t1) {
            const i = e1[0] / e1[3], n = e1[1] / e1[3];
            return i >= -t1[0] && i <= t1[0] && n >= -t1[1] && n <= t1[1];
        }
        function rw(e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, m, g) {
            const { lineStartIndex: y, glyphStartIndex: x, segment: v } = s, b = x + s.numGlyphs, w = y + s.lineLength, E = t1.getoffsetX(x), A = t1.getoffsetX(b - 1), I = cw(e1 * E, i, n, r, o, a, v, y, w, l, u, c, h, d, !0, f, p, _, m, g);
            if (!I) return null;
            const T = cw(e1 * A, i, n, r, o, a, v, y, w, l, u, c, h, d, !0, f, p, _, m, g);
            return T ? {
                first: I,
                last: T
            } : null;
        }
        function ow(e1, t1, i, n) {
            return e1 === Hd.horizontal && Math.abs(n) > Math.abs(i) ? {
                useVertical: !0
            } : e1 === Hd.vertical ? n > 0 ? {
                needsFlipping: !0
            } : null : 0 !== t1 && function(e1, t1) {
                return 0 === e1 || Math.abs(t1 / e1) > Qb;
            }(i, n) ? 1 === t1 ? {
                needsFlipping: !0
            } : null : i < 0 ? {
                needsFlipping: !0
            } : null;
        }
        function aw(e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, m, g, y, x, v) {
            const b = t1 / 24, w = e1.lineOffsetX * b, E = e1.lineOffsetY * b, { lineStartIndex: A, glyphStartIndex: I, numGlyphs: T, segment: M, writingMode: S, flipState: z } = e1, R = A + e1.lineLength, P = (e1)=>{
                if (c) {
                    const [t1, i, n] = e1.up, r = u.length;
                    G_(c, r + 0, t1, i, n), G_(c, r + 1, t1, i, n), G_(c, r + 2, t1, i, n), G_(c, r + 3, t1, i, n);
                }
                const [t1, i, n] = e1.point;
                j_(u, t1, i, n, e1.angle);
            };
            if (T > 1) {
                const t1 = rw(b, s, w, E, i, h, d, e1, l, o, f, _, !1, m, g, y, x, v);
                if (!t1) return {
                    notEnoughRoom: !0
                };
                if (n && !i) {
                    let [i, n, r] = t1.first.point, [o, s, l] = t1.last.point;
                    [i, n] = tw(i, n, r, a), [o, s] = tw(o, s, l, a);
                    const u = ow(S, z, (o - i) * p, s - n);
                    if (e1.flipState = u && u.needsFlipping ? 1 : 2, u) return u;
                }
                P(t1.first);
                for(let e1 = I + 1; e1 < I + T - 1; e1++){
                    const t1 = cw(b * s.getoffsetX(e1), w, E, i, h, d, M, A, R, l, o, f, _, !1, !1, m, g, y, x, v);
                    if (!t1) return u.length -= 4 * (e1 - I), {
                        notEnoughRoom: !0
                    };
                    P(t1);
                }
                P(t1.last);
            } else {
                if (n && !i) {
                    const t1 = tw(d.x, d.y, 0, r), i = A + M + 1, n = new Pe(l.getx(i), l.gety(i)), o = tw(n.x, n.y, 0, r), a = o[3] > 0 ? o : uw(d, n, t1, 1, r, void 0, m, g.canonical), s = ow(S, z, (a[0] - t1[0]) * p, a[1] - t1[1]);
                    if (e1.flipState = s && s.needsFlipping ? 1 : 2, s) return s;
                }
                const t1 = cw(b * s.getoffsetX(I), w, E, i, h, d, M, A, R, l, o, f, _, !1, !1, m, g, y, x, v);
                if (!t1) return {
                    notEnoughRoom: !0
                };
                P(t1);
            }
            return {};
        }
        function sw(e1, t1, i) {
            const n = 1 << t1.z;
            let r = (e1.x / Sr + t1.x) / n - i.mercCenter[0];
            const o = (e1.y / Sr + t1.y) / n - i.mercCenter[1];
            r -= Math.round(r);
            const a = [
                r * Sr,
                o * Sr,
                Sr / (2 * Math.PI),
                1
            ];
            return le(a, a, i.invMatrix), [
                a[0],
                a[1],
                a[2]
            ];
        }
        function lw(e1, t1, i, n, r, o) {
            let { x: a, y: s, z: l } = n.projectTilePoint(e1.x, e1.y, t1);
            if (o) {
                const [i, n, r] = sw(e1, t1, o);
                a += (i - a) * o.t, s += (n - s) * o.t, l += (r - l) * o.t;
            }
            if (!r) return tw(a, s, l, i);
            const [u, c, h] = r.getElevation(e1, r.elevation, r.elevationFeature);
            return tw(a + u, s + c, l + h, i);
        }
        function uw(e1, t1, i, n, r, o, a, s, l) {
            const u = lw(e1.sub(t1)._unit()._add(e1), s, r, a, o, l);
            return te(u, i, u), Z(u, u), U(u, i, u, n);
        }
        function cw(e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, m, g, y, x) {
            const v = n ? e1 - t1 : e1 + t1;
            let b = v > 0 ? 1 : -1, w = 0;
            n && (b *= -1, w = Math.PI), b < 0 && (w += Math.PI);
            let E = s + a + (b > 0 ? 0 : 1) | 0, A = r, I = r, T = 0, M = 0;
            const S = Math.abs(v), z = [], R = [];
            let P = o, D = P, C = Q([]);
            const F = ()=>uw(D, P, I, S - T + 1, c, d, _, m.canonical, x);
            for(; T + M <= S;){
                if (E += b, E < s || E >= l) return null;
                if (I = A, D = P, z.push(I), f && R.push(D), P = new Pe(u.getx(E), u.gety(E)), A = h[E], !A) {
                    const e1 = lw(P, m.canonical, c, _, d, x);
                    A = e1[3] > 0 ? h[E] = e1 : F();
                }
                T += M;
                const e1 = te([], A, I), t1 = G(I, A);
                if (i && t1 > 0 && M > 0 && W(C, e1) / (M * t1) < y) return null;
                M = t1, C = e1;
            }
            p && d && (h[E] && (A = F(), M = G(I, A), C = te([], A, I)), h[E] = A);
            const O = (S - T) / M, L = P.sub(D)._mult(O)._add(D), B = U([], I, C, O);
            let N = [
                0,
                0,
                1
            ], V = C[0], k = C[1];
            if (g && (N = _.upVector(m.canonical, L.x, L.y), 0 !== N[0] || 0 !== N[1] || 1 !== N[2])) {
                const e1 = [
                    N[2],
                    0,
                    -N[0]
                ], t1 = q([], N, e1);
                Z(e1, e1), Z(t1, t1), V = W(C, e1), k = W(C, t1);
            }
            if (i) {
                const e1 = q([], N, C);
                Z(e1, e1), U(B, B, e1, i * b);
            }
            const j = w + Math.atan2(k, V);
            return z.push(B), f && R.push(L), {
                point: B,
                angle: j,
                path: z,
                tilePath: R,
                up: N
            };
        }
        function hw(e1, t1) {
            const i = t1.length, n = i + 4 * e1;
            t1.resize(n), t1.float32.fill(-1 / 0, 4 * i, 4 * n);
        }
        function dw(e1, t1, i) {
            const n = t1[0], r = t1[1];
            return e1[0] = i[0] * n + i[4] * r + i[12], e1[1] = i[1] * n + i[5] * r + i[13], e1[3] = i[3] * n + i[7] * r + i[15], e1;
        }
        const fw = 15;
        class pw {
            constructor(e1, t1, i, n, r, o, a){
                this.tileSize = 512, this._renderWorldCopies = void 0 === r || r, this._minZoom = e1 || 0, this._maxZoom = t1 || 22, this._minPitch = i ?? 0, this._maxPitch = n ?? 60, this.setProjection(o), this.setMaxBounds(a), this.width = 0, this.height = 0, this._center = new hu(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._nearClipOffset = 0, this._unmodified = !0, this._edgeInsets = new Wb, this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new Kb, this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [
                    0,
                    0,
                    0
                ], this._tileCoverLift = 0, this.freezeTileCoverage = !1, this._horizonShift = .1, this._orthographicProjectionAtLowPitch = !1, this._allowWorldUnderZoom = !1, this.mercatorMatrix = new Float64Array(16), this.mercatorFogMatrix = new Float32Array(16), this.invProjMatrix = new Float64Array(16), this._expandedFarZProjMatrixBuf = new Float64Array(16), this.expandedFarZProjMatrix = this._expandedFarZProjMatrixBuf, this.starsProjMatrix = new Float32Array(16), this.skyboxMatrix = new Float32Array(16), this._mat4Scratch = new Float64Array(16), this.alignedProjMatrix = new Float64Array(16), this.labelPlaneMatrix = new Float32Array(16), this.glCoordMatrix = new Float32Array(16), this.pixelMatrix = new Float64Array(16), this.pixelMatrixInverse = new Float64Array(16);
            }
            clone() {
                const e1 = new pw(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection(), this.maxBounds);
                return e1._elevation = this._elevation, e1._centerAltitude = this._centerAltitude, e1._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e1.tileSize = this.tileSize, e1.mercatorFromTransition = this.mercatorFromTransition, e1.width = this.width, e1.height = this.height, e1.cameraElevationReference = this.cameraElevationReference, e1._center = this._center, e1._setZoom(this.zoom), e1._seaLevelZoom = this._seaLevelZoom, e1.angle = this.angle, e1._fov = this._fov, e1._pitch = this._pitch, e1._nearZ = this._nearZ, e1._farZ = this._farZ, e1._nearClipOffset = this._nearClipOffset, e1._averageElevation = this._averageElevation, e1._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e1._unmodified = this._unmodified, e1._edgeInsets = this._edgeInsets.clone(), e1._camera = this._camera.clone(), e1._calcMatrices(), e1.freezeTileCoverage = this.freezeTileCoverage, e1.frustumCorners = this.frustumCorners, e1._allowWorldUnderZoom = this._allowWorldUnderZoom, e1;
            }
            get isOrthographic() {
                return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < fw;
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(e1) {
                this._elevation !== e1 && (this._elevation = e1, this._updateCameraOnTerrain(), this._calcMatrices());
            }
            get nearClipOffset() {
                return this._nearClipOffset;
            }
            set nearClipOffset(e1) {
                this._nearClipOffset = e1, this._calcMatrices();
            }
            get depthOcclusionForSymbolsAndCircles() {
                return "globe" !== this.projection.name && !this.isOrthographic;
            }
            updateElevation(e1, t1 = !1) {
                const i = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
                (null == this._seaLevelZoom || i) && this._updateCameraOnTerrain(), (e1 || i) && this._constrainCamera(t1), this._calcMatrices();
            }
            getProjection() {
                return ot(this.projection, [
                    "name",
                    "center",
                    "parallels"
                ]);
            }
            setProjection(e1) {
                this.projectionOptions = e1 || {
                    name: "mercator"
                };
                const t1 = this.projection ? this.getProjection() : void 0;
                this.projection = Ip(this.projectionOptions);
                const i = !De(t1, this.getProjection());
                return i && this._calcMatrices(), this.mercatorFromTransition = !1, i;
            }
            setOrthographicProjectionAtLowPitch(e1) {
                return this._orthographicProjectionAtLowPitch !== e1 && (this._orthographicProjectionAtLowPitch = e1, this._calcMatrices(), !0);
            }
            setMercatorFromTransition() {
                const e1 = this.projection.name;
                this.mercatorFromTransition = !0, this.projectionOptions = {
                    name: "mercator"
                }, this.projection = Ip({
                    name: "mercator"
                });
                const t1 = e1 !== this.projection.name;
                return t1 && this._calcMatrices(), t1;
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(e1) {
                this._minZoom !== e1 && (this._minZoom = e1, this.zoom = Math.max(this.zoom, e1));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(e1) {
                this._maxZoom !== e1 && (this._maxZoom = e1, this.zoom = Math.min(this.zoom, e1));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(e1) {
                this._minPitch !== e1 && (this._minPitch = e1, this.pitch = Math.max(this.pitch, e1));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(e1) {
                this._maxPitch !== e1 && (this._maxPitch = e1, this.pitch = Math.min(this.pitch, e1));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies && !0 === this.projection.supportsWorldCopies;
            }
            set renderWorldCopies(e1) {
                void 0 === e1 ? e1 = !0 : null === e1 && (e1 = !1), this._renderWorldCopies = e1;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get cameraWorldSizeForFog() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get cameraWorldSize() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation, !0), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get pixelsPerMeter() {
                return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
            }
            get cameraPixelsPerMeter() {
                return pu(1, this.center.lat) * this.cameraWorldSizeForFog;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new Pe(this.width, this.height);
            }
            get bearing() {
                return nt(this.rotation, -180, 180);
            }
            set bearing(e1) {
                this.rotation = e1;
            }
            get rotation() {
                return -this.angle / Math.PI * 180;
            }
            set rotation(e1) {
                const t1 = -e1 * Math.PI / 180;
                if (this.angle === t1) return;
                this._unmodified = !1, this.angle = t1, this._calcMatrices();
                const i = Math.sin(this.angle), n = Math.cos(this.angle);
                this.rotationMatrix = [
                    n,
                    i,
                    -i,
                    n
                ];
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(e1) {
                const t1 = tt(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== t1 && (this._unmodified = !1, this._pitch = t1, this._calcMatrices());
            }
            get aspect() {
                return this.width / this.height;
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            set fov(e1) {
                e1 = Math.max(.01, Math.min(60, e1)), this._fov !== e1 && (this._unmodified = !1, this._fov = Ye(e1), this._calcMatrices());
            }
            get fovX() {
                return this._fov;
            }
            get fovY() {
                const e1 = 1 / Math.tan(.5 * this.fovX);
                return 2 * Math.atan(1 / this.aspect / e1);
            }
            get horizontalFov() {
                return Je(2 * Math.atan(Math.tan(.5 * this._fov) * this.aspect));
            }
            get averageElevation() {
                return this._averageElevation;
            }
            set averageElevation(e1) {
                this._averageElevation = e1, this._calcFogMatrices(), this._distanceTileDataCache = {};
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(e1) {
                const t1 = Math.min(Math.max(e1, this.minZoom), this.maxZoom);
                this._zoom !== t1 && (this._unmodified = !1, this._setZoom(t1), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
            }
            _setZoom(e1) {
                this._zoom = e1, this.scale = this.zoomScale(e1), this.tileZoom = Math.floor(e1), this.zoomFraction = e1 - this.tileZoom;
            }
            get tileCoverLift() {
                return this._tileCoverLift;
            }
            set tileCoverLift(e1) {
                this._tileCoverLift !== e1 && (this._tileCoverLift = e1);
            }
            _updateCameraOnTerrain() {
                const e1 = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, t1 = this.elevation && e1 === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
                if (!this._elevation || e1 === Number.NEGATIVE_INFINITY && (!t1 || !this._centerAltitude)) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
                const i = this._elevation;
                t1 || this._centerAltitude && this._centerAltitudeValidForExaggeration && i.exaggeration() && this._centerAltitudeValidForExaggeration !== i.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i.exaggeration(), this._centerAltitudeValidForExaggeration = i.exaggeration()) : (this._centerAltitude = e1 || 0, this._centerAltitudeValidForExaggeration = i.exaggeration()), this._updateSeaLevelZoom();
            }
            _updateSeaLevelZoom() {
                if (void 0 === this._centerAltitudeValidForExaggeration) return;
                const e1 = Math.max(0, (this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize);
                this._seaLevelZoom = this._zoomFromMercatorZ(e1);
            }
            sampleAverageElevation() {
                if (!this._elevation) return 0;
                const e1 = this._elevation, t1 = [
                    [
                        .5,
                        .2
                    ],
                    [
                        .3,
                        .5
                    ],
                    [
                        .5,
                        .5
                    ],
                    [
                        .7,
                        .5
                    ],
                    [
                        .5,
                        .8
                    ]
                ], i = this.horizonLineFromTop();
                let n = 0, r = 0;
                for(let o = 0; o < t1.length; o++){
                    const a = new Pe(t1[o][0] * this.width, i + t1[o][1] * (this.height - i)), s = e1.pointCoordinate(a);
                    if (!s) continue;
                    const l = 1 / Math.hypot(s[0] - this._camera.position[0], s[1] - this._camera.position[1]);
                    n += s[3] * l, r += l;
                }
                return 0 === r ? NaN : n / r;
            }
            get center() {
                return this._center;
            }
            set center(e1) {
                e1.lat === this._center.lat && e1.lng === this._center.lng || (this._unmodified = !1, this._center = e1, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
            }
            _updateZoomFromElevation() {
                if (null == this._seaLevelZoom || !this._elevation) return;
                const e1 = this._seaLevelZoom, t1 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i = this.pixelsPerMeter / this.worldSize * t1, n = this._mercatorZfromZoom(e1), r = this._mercatorZfromZoom(this._maxZoom), o = Math.max(n - i, r);
                this._setZoom(this._zoomFromMercatorZ(o));
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(e1) {
                this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
            }
            equals(e1) {
                const t1 = this.elevation, i = e1.elevation, n = null != t1 != (null != i) || t1 && i && t1.exaggeration() !== i.exaggeration();
                return this.width === e1.width && this.height === e1.height && this.center.lng === e1.center.lng && this.center.lat === e1.center.lat && this.zoom === e1.zoom && this.bearing === e1.bearing && this.pitch === e1.pitch && this.fov === e1.fov && this.projection.name === e1.projection.name && this._edgeInsets.equals(e1.padding) && !n;
            }
            computeZoomRelativeTo(e1) {
                const t1 = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, e1.toAltitude()));
                let i;
                i = e1.z < this._camera.position[2] ? [
                    t1.x,
                    t1.y,
                    t1.z
                ] : [
                    e1.x,
                    e1.y,
                    e1.z
                ];
                const n = D(te([], this._camera.position, i));
                return tt(this._zoomFromMercatorZ(n), this._minZoom, this._maxZoom);
            }
            setFreeCameraOptions(e1) {
                if (!this.height) return;
                if (!e1.position && !e1.orientation) return;
                this._updateCameraState();
                let t1 = !1;
                if (e1.orientation && !((i = e1.orientation)[0] === (n = this._camera.orientation)[0] && i[1] === n[1] && i[2] === n[2] && i[3] === n[3]) && (t1 = this._setCameraOrientation(e1.orientation)), e1.position) {
                    const i = [
                        e1.position.x,
                        e1.position.y,
                        e1.position.z
                    ];
                    ee(i, this._camera.position) || (this._setCameraPosition(i), t1 = !0);
                }
                var i, n;
                t1 && (this._updateStateFromCamera(), this.recenterOnTerrain());
            }
            getFreeCameraOptions() {
                this._updateCameraState();
                const e1 = this._camera.position, t1 = new Jb;
                return t1.position = new bu(e1[0], e1[1], e1[2]), t1.orientation = this._camera.orientation, t1._elevation = this.elevation, t1._renderWorldCopies = this.renderWorldCopies, t1;
            }
            _setCameraOrientation(e1) {
                if (!function(e1) {
                    var t1 = e1[0], i = e1[1], n = e1[2], r = e1[3];
                    return Math.sqrt(t1 * t1 + i * i + n * n + r * r);
                }(e1)) return !1;
                ye(e1, e1);
                const t1 = K([], [
                    0,
                    0,
                    -1
                ], e1), i = K([], [
                    0,
                    -1,
                    0
                ], e1);
                if (i[2] < 0) return !1;
                const n = Yb(t1, i);
                return !!n && (this._camera.orientation = n, !0);
            }
            _setCameraPosition(e1) {
                const t1 = this.zoomScale(this.minZoom) * this.tileSize, i = this.zoomScale(this.maxZoom) * this.tileSize, n = this.cameraToCenterDistance;
                e1[2] = tt(e1[2], n / i, n / t1), this._camera.position = e1;
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            get fovAboveCenter() {
                return this._fov * (.5 + this.centerOffset.y / this.height);
            }
            isPaddingEqual(e1) {
                return this._edgeInsets.equals(e1);
            }
            interpolatePadding(e1, t1, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e1, t1, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(e1) {
                const t1 = (e1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e1.tileSize));
                return Math.max(0, t1);
            }
            getVisibleUnwrappedCoordinates(e1) {
                const t1 = [
                    new Qf(0, e1)
                ];
                if (this.renderWorldCopies) {
                    const i = this.pointCoordinate(new Pe(0, 0)), n = this.pointCoordinate(new Pe(this.width, 0)), r = this.pointCoordinate(new Pe(this.width, this.height)), o = this.pointCoordinate(new Pe(0, this.height)), a = Math.floor(Math.min(i.x, n.x, r.x, o.x)), s = Math.floor(Math.max(i.x, n.x, r.x, o.x)), l = 1;
                    for(let i = a - l; i <= s + l; i++)0 !== i && t1.push(new Qf(i, e1));
                }
                return t1;
            }
            isLODDisabled(e1) {
                return (!e1 || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
            }
            extendTileCover(e1, t1, i, n) {
                let r = [];
                const o = null != i, a = !o;
                if (a && this.zoom < t1) return r;
                if (o && 0 === i[0] && 0 === i[1]) return r;
                const s = new Set, l = (e1, t1, i, n, o)=>{
                    const a = tp(t1, e1, i, n, o);
                    s.has(a) || (r.push(new ep(e1, t1, i, n, o)), s.add(a));
                };
                for(let r = 0; r < e1.length; r++){
                    const s = e1[r];
                    if (a && s.canonical.z !== t1) continue;
                    if (o && void 0 !== n && n > s.canonical.z) continue;
                    const u = s.canonical, c = s.overscaledZ, h = s.wrap, d = 1 << u.z, f = u.x + 1 < d, p = u.x > 0, _ = u.y + 1 < d, m = u.y > 0, g = s.wrap - (p ? 0 : 1), y = s.wrap + (f ? 0 : 1), x = p ? u.x - 1 : d - 1, v = f ? u.x + 1 : 0;
                    if (o) i[0] < 0 ? (l(c, y, u.z, v, u.y), i[1] < 0 && _ && (l(c, h, u.z, u.x, u.y + 1), l(c, y, u.z, v, u.y + 1)), i[1] > 0 && m && (l(c, h, u.z, u.x, u.y - 1), l(c, y, u.z, v, u.y - 1))) : i[0] > 0 ? (l(c, g, u.z, x, u.y), i[1] < 0 && _ && (l(c, h, u.z, u.x, u.y + 1), l(c, g, u.z, x, u.y + 1)), i[1] > 0 && m && (l(c, h, u.z, u.x, u.y - 1), l(c, g, u.z, x, u.y - 1))) : i[1] < 0 && _ ? l(c, h, u.z, u.x, u.y + 1) : m && l(c, h, u.z, u.x, u.y - 1);
                    else {
                        const e1 = s.visibleQuadrants;
                        1 & e1 && (l(c, g, u.z, x, u.y), m && (l(c, h, u.z, u.x, u.y - 1), l(c, g, u.z, x, u.y - 1))), 2 & e1 && (l(c, y, u.z, v, u.y), m && (l(c, h, u.z, u.x, u.y - 1), l(c, y, u.z, v, u.y - 1))), 4 & e1 && (l(c, g, u.z, x, u.y), _ && (l(c, h, u.z, u.x, u.y + 1), l(c, g, u.z, x, u.y + 1))), 8 & e1 && (l(c, y, u.z, v, u.y), _ && (l(c, h, u.z, u.x, u.y + 1), l(c, y, u.z, v, u.y + 1)));
                    }
                }
                const u = [];
                for (const e1 of r)r.some((t1)=>e1.isChildOf(t1)) || u.push(e1);
                if (r = u.filter((i)=>!e1.some((e1)=>!!(i.overscaledZ < t1 && e1.isChildOf(i)) || i.equals(e1) || i.isChildOf(e1))), a) {
                    const e1 = 1 << t1, i = "globe" === this.projection.name ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), n = [
                        e1 * i.x,
                        e1 * i.y
                    ], o = 4, a = o * o;
                    r = r.filter((e1)=>{
                        const t1 = e1.canonical.x + .5 - n[0], i = e1.canonical.y + .5 - n[1];
                        return t1 * t1 + i * i < a;
                    });
                }
                return r;
            }
            extendTileCoverToNearPlane(e1, t1, i) {
                const n = [], r = new Set;
                for (const t1 of e1)r.add(t1.key);
                const o = (e1, t1, i, o, a)=>{
                    const s = tp(t1, e1, i, o, a);
                    r.has(s) || (n.push(new ep(e1, t1, i, o, a)), r.add(s));
                }, a = e1.reduce((e1, t1)=>Math.max(e1, t1.overscaledZ), i), s = 1 << i, l = [
                    new Pe(0, 0),
                    new Pe(Sr, 0),
                    new Pe(Sr, Sr),
                    new Pe(0, Sr)
                ], u = new Pe(0, 0), c = new Pe(0, 0), h = (e1, t1)=>{
                    const n = Math.floor(e1[0]), r = Math.floor(e1[1]), h = (e1[0] - n) * Sr, d = (e1[1] - r) * Sr, f = Math.floor(t1[0]), p = Math.floor(t1[1]), _ = (t1[0] - f) * Sr, m = (t1[1] - p) * Sr;
                    for(let e1 = -1; e1 <= 1; e1++){
                        const t1 = n + e1;
                        if (!(t1 < 0 || t1 >= s)) {
                            u.x = h - e1 * Sr, c.x = _ - (t1 - f) * Sr;
                            for(let e1 = -1; e1 <= 1; e1++){
                                const n = r + e1;
                                u.y = d - e1 * Sr, c.y = m - (n - p) * Sr, $h(u, c, l) && o(a, 0, i, t1, n);
                            }
                        }
                    }
                }, d = t1.points, f = d[3], p = d[2], _ = this._projectToGround(f, d[7]), m = this._projectToGround(p, d[6]);
                return h(f, _), h(p, m), n;
            }
            _projectToGround(e1, t1) {
                return X(R(), e1, t1, e1[2] / (e1[2] - t1[2]));
            }
            _projectToZ(e1, t1, i) {
                const n = e1[2] - t1[2];
                return Math.abs(n) < 1e-6 ? P(e1) : X(R(), e1, t1, (e1[2] - i) / n);
            }
            extendTileCoverForTunnels(e1, t1, i, n) {
                if (i < 18) return [];
                const r = t1.points, o = r[0], a = r[1], s = r[4], l = r[5];
                if (s[2] >= 0 && l[2] >= 0 || o[2] <= 0 || a[2] <= 0) return [];
                const u = s[2] < 0 ? this._projectToZ(o, s, 0) : s, c = l[2] < 0 ? this._projectToZ(a, l, 0) : l, h = -n, d = s[2] < h ? this._projectToZ(o, s, h) : s, f = l[2] < h ? this._projectToZ(a, l, h) : l, p = this._findExtensionTilesInQuad(e1, i, [
                    f,
                    d,
                    c,
                    u
                ], [
                    .5 * (u[0] + c[0]),
                    .5 * (u[1] + c[1])
                ]);
                return p.length > 3 && (p.length = 3), p;
            }
            _findExtensionTilesInQuad(e1, t1, i, n) {
                const r = [], o = new Set;
                for (const t1 of e1)o.add(t1.key);
                const a = e1.reduce((e1, t1)=>Math.max(e1, t1.overscaledZ), t1), s = 1 << t1, l = [
                    new Pe(i[0][0], i[0][1]),
                    new Pe(i[1][0], i[1][1]),
                    new Pe(i[3][0], i[3][1]),
                    new Pe(i[2][0], i[2][1]),
                    new Pe(i[0][0], i[0][1])
                ], u = i[0][0], c = i[1][0], h = i[2][0], d = i[3][0], f = i[0][1], p = i[1][1], _ = i[2][1], m = i[3][1], g = Math.max(0, Math.floor(Math.min(u, c, h, d))), y = Math.min(s - 1, Math.ceil(Math.max(u, c, h, d)) - 1), x = Math.max(0, Math.floor(Math.min(f, p, _, m))), v = Math.min(s - 1, Math.ceil(Math.max(f, p, _, m)) - 1);
                for(let e1 = x; e1 <= v; e1++)for(let i = g; i <= y; i++){
                    if (!Hh(l, i, e1, i + 1, e1 + 1)) continue;
                    const n = tp(0, a, t1, i, e1);
                    o.has(n) || (r.push(new ep(a, 0, t1, i, e1)), o.add(n));
                }
                const b = n[0], w = n[1];
                return r.sort((e1, t1)=>{
                    const i = e1.canonical.x + .5 - b, n = e1.canonical.y + .5 - w, r = t1.canonical.x + .5 - b, o = t1.canonical.y + .5 - w;
                    return i * i + n * n - (r * r + o * o) || e1.canonical.x - t1.canonical.x || e1.canonical.y - t1.canonical.y;
                }), r;
            }
            coveringTiles(e1) {
                let t1 = this.coveringZoomLevel(e1);
                const i = t1, n = this.elevation && this.elevation.exaggeration(), r = n && !e1.isTerrainDEM, o = "mercator" === this.projection.name;
                if (void 0 !== e1.minzoom && t1 < e1.minzoom) return [];
                void 0 !== e1.maxzoom && t1 > e1.maxzoom && (t1 = e1.maxzoom);
                const a = this.locationCoordinate(this.center), s = this.center.lat, l = 1 << t1, u = [
                    l * a.x,
                    l * a.y,
                    0
                ], c = "globe" === this.projection.name, h = !c, d = Af.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, t1, h), f = c ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), p = l * pu(1, this.center.lat), _ = this._camera.position[2] / pu(1, this.center.lat), m = [
                    l * f.x,
                    l * f.y,
                    _ * (h ? 1 : p)
                ], g = c || n, y = this.cameraToCenterDistance / e1.tileSize * (e1.roundZoom ? 1 : .502), x = this.isLODDisabled(!0) ? t1 : 0;
                let v;
                if (this._elevation && e1.isTerrainDEM) v = 1e4 * this._elevation.exaggeration();
                else if (this._elevation) {
                    const e1 = this._elevation.getMinMaxForVisibleTiles();
                    v = e1 ? e1.max : this._centerAltitude;
                } else v = this._centerAltitude;
                const b = e1.isTerrainDEM ? -v : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, w = this.projection.isReprojectedInTileSpace ? Xg(this) : 1, E = (e1)=>{
                    const t1 = 1 / 4e4, i = new bu(e1.x + t1, e1.y, e1.z), n = new bu(e1.x, e1.y + t1, e1.z), r = e1.toLngLat(), o = i.toLngLat(), a = n.toLngLat(), s = this.locationCoordinate(r), l = this.locationCoordinate(o), u = this.locationCoordinate(a), c = Math.hypot(l.x - s.x, l.y - s.y), h = Math.hypot(u.x - s.x, u.y - s.y);
                    return Math.sqrt(c * h) * w / t1;
                }, A = (e1)=>{
                    const t1 = v, i = b;
                    return {
                        aabb: rp(this, l, 0, 0, 0, e1, i, t1, this.projection),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        minZ: i,
                        maxZ: t1,
                        wrap: e1,
                        fullyVisible: !1
                    };
                }, I = [];
                let T = [];
                const M = t1, S = e1.reparseOverscaled ? i : t1, z = (_ - this._centerAltitude) * p, R = (e1)=>{
                    if (!this._elevation || !e1.tileID || !o) return;
                    const t1 = this._elevation.getMinMaxForTile(e1.tileID), i = e1.aabb;
                    t1 ? (i.min[2] = t1.min, i.max[2] = t1.max, i.center[2] = (i.min[2] + i.max[2]) / 2) : (e1.shouldSplit = D(e1), e1.shouldSplit || (i.min[2] = i.max[2] = i.center[2] = this._centerAltitude));
                }, P = (e1, t1)=>{
                    if (.707 * t1 < e1) return 1;
                    const i = t1 / e1;
                    return i / (1.4144271570014144 + (Math.pow(1.1, i - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
                }, D = (e1)=>{
                    if (e1.zoom < x) return !0;
                    if (e1.zoom === M) return !1;
                    if (null != e1.shouldSplit) return e1.shouldSplit;
                    const t1 = e1.aabb.distanceX(m), n = e1.aabb.distanceY(m);
                    let a = z, l = 1;
                    if (c) {
                        a = e1.aabb.distanceZ(m);
                        const t1 = Math.pow(2, e1.zoom), i = pr((e1.y + 1) / t1), n = pr(e1.y / t1), r = Math.min(Math.max(s, i), n), o = fu(r) / fu(s);
                        if (l = r === s ? 1 / Math.max(1, this._mercatorScaleRatio - .3) : Math.min(1, o / this._mercatorScaleRatio), this.zoom <= 5 && e1.zoom === M - 1 && o >= .9) return !0;
                    } else if (r && (a = e1.aabb.distanceZ(m) * p), this.projection.isReprojectedInTileSpace && i <= 5) {
                        const t1 = Math.pow(2, e1.zoom), i = E(new bu((e1.x + .5) / t1, (e1.y + .5) / t1));
                        l = i > .85 ? 1 : i;
                    }
                    if (!o && !c) {
                        const i = Math.sqrt(t1 * t1 + n * n + a * a);
                        let r = (1 << M - e1.zoom) * y * l;
                        return r *= P(Math.max(a, z), i), i < r;
                    }
                    let h = Number.MAX_VALUE, d = 0;
                    const f = e1.aabb.getCorners(), _ = [
                        0,
                        0,
                        0
                    ];
                    for (const e1 of f){
                        te(_, e1, m), c || (r ? _[2] *= p : _[2] = z);
                        const t1 = W(_, this._camera.forward());
                        t1 < h && (h = t1, d = Math.abs(_[2]));
                    }
                    let g = (1 << M - e1.zoom) * y * l;
                    if (g *= P(Math.max(d, z), h), h < g) return !0;
                    const v = e1.aabb.closestPoint(u);
                    return v[0] === u[0] && v[1] === u[1];
                };
                if (this.renderWorldCopies) for(let e1 = 1; e1 <= 3; e1++)I.push(A(-e1)), I.push(A(e1));
                for(I.push(A(0)); I.length > 0;){
                    const i = I.pop(), n = i.x, a = i.y;
                    let s = i.fullyVisible;
                    const h = ()=>"globe" === this.projection.name && (0 === i.y || i.y === (1 << i.zoom) - 1);
                    if (!s) {
                        let e1 = g ? i.aabb.intersects(d) : i.aabb.intersectsFlat(d);
                        if (0 === e1 && h()) {
                            const t1 = new Kf(i.zoom, n, a);
                            e1 = Ff(this, l, t1, !0).intersects(d);
                        }
                        if (0 === e1) continue;
                        s = 2 === e1;
                    }
                    if (i.zoom === M || !D(i)) {
                        const r = i.zoom === M ? S : i.zoom;
                        if (e1.minzoom && e1.minzoom > r) continue;
                        let o = 0;
                        if (!s) {
                            let t1 = g ? i.aabb.intersectsPrecise(d) : i.aabb.intersectsPreciseFlat(d);
                            if (0 === t1 && h()) {
                                const e1 = new Kf(i.zoom, n, a);
                                t1 = Ff(this, l, e1, !0).intersectsPrecise(d);
                            }
                            if (0 === t1) continue;
                            if (e1.calculateQuadrantVisibility) {
                                if (d.containsPoint(i.aabb.center)) o = 15;
                                else for(let e1 = 0; e1 < 4; e1++)0 !== i.aabb.quadrant(e1).intersects(d) && (o |= 1 << e1);
                            }
                        }
                        const c = u[0] - (.5 + n + (i.wrap << i.zoom)) * (1 << t1 - i.zoom), f = u[1] - .5 - a, p = i.tileID ? i.tileID : new ep(r, i.wrap, i.zoom, n, a);
                        e1.calculateQuadrantVisibility && (p.visibleQuadrants = o), T.push({
                            tileID: p,
                            distanceSq: c * c + f * f
                        });
                        continue;
                    }
                    for(let e1 = 0; e1 < 4; e1++){
                        const t1 = (n << 1) + e1 % 2, u = (a << 1) + (e1 >> 1), h = {
                            aabb: o ? i.aabb.quadrant(e1) : rp(this, l, i.zoom + 1, t1, u, i.wrap, i.minZ, i.maxZ, this.projection),
                            zoom: i.zoom + 1,
                            x: t1,
                            y: u,
                            wrap: i.wrap,
                            fullyVisible: s,
                            tileID: void 0,
                            shouldSplit: void 0,
                            minZ: i.minZ,
                            maxZ: i.maxZ
                        };
                        r && !c && (h.tileID = new ep(i.zoom + 1 === M ? S : i.zoom + 1, i.wrap, i.zoom + 1, t1, u), R(h)), I.push(h);
                    }
                }
                if (this.fogCullDistSq) {
                    const t1 = this.fogCullDistSq, i = this.horizonLineFromTop();
                    T = T.filter((n)=>{
                        const r = [
                            0,
                            0,
                            0,
                            1
                        ], o = [
                            Sr,
                            Sr,
                            0,
                            1
                        ], a = this.calculateFogTileMatrix(n.tileID.toUnwrapped());
                        le(r, r, a), le(o, o, a);
                        const s = (h = r, d = o, (c = [])[0] = Math.min(h[0], d[0]), c[1] = Math.min(h[1], d[1]), c[2] = Math.min(h[2], d[2]), c[3] = Math.min(h[3], d[3]), c), l = function(e1, t1, i) {
                            return e1[0] = Math.max(t1[0], i[0]), e1[1] = Math.max(t1[1], i[1]), e1[2] = Math.max(t1[2], i[2]), e1[3] = Math.max(t1[3], i[3]), e1;
                        }([], r, o), u = function(e1, t1) {
                            let i = 0;
                            for(let n = 0; n < 2; ++n){
                                const r = 0;
                                e1[n] > r && (i += (e1[n] - r) * (e1[n] - r)), t1[n] < r && (i += (r - t1[n]) * (r - t1[n]));
                            }
                            return i;
                        }(s, l);
                        var c, h, d;
                        if (0 === u) return !0;
                        let f = !1;
                        const p = this._elevation;
                        if (p && u > t1 && 0 !== i) {
                            const t1 = this.calculateProjMatrix(n.tileID.toUnwrapped());
                            let r;
                            e1.isTerrainDEM || (r = p.getMinMaxForTile(n.tileID)), r || (r = {
                                min: b,
                                max: v
                            });
                            const o = function(e1) {
                                const t1 = Math.round((e1 + 45 + 360) % 360 / 90) % 4;
                                return Ke[t1];
                            }(this.rotation), a = [
                                o[0] * Sr,
                                o[1] * Sr,
                                r.max
                            ];
                            Y(a, a, t1), f = (1 - a[1]) * this.height * .5 < i;
                        }
                        return u < t1 || f;
                    });
                }
                return T.sort((e1, t1)=>e1.distanceSq - t1.distanceSq).map((e1)=>e1.tileID);
            }
            resize(e1, t1) {
                this.width = e1, this.height = t1, this.pixelsToGLUnits = [
                    2 / e1,
                    -2 / t1
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(e1) {
                return Math.pow(2, e1);
            }
            scaleZoom(e1) {
                return Math.log2(e1);
            }
            project(e1) {
                const t1 = tt(e1.lat, -85.051129, mu), i = this.projection.project(e1.lng, t1);
                return new Pe(i.x * this.worldSize, i.y * this.worldSize);
            }
            unproject(e1) {
                return this.projection.unproject(e1.x / this.worldSize, e1.y / this.worldSize);
            }
            get point() {
                return this.project(this.center);
            }
            get pointMerc() {
                return this.point._div(this.worldSize);
            }
            get pixelsPerMeterRatio() {
                return this.pixelsPerMeter / pu(1, this.center.lat) / this.worldSize;
            }
            setLocationAtPoint(e1, t1) {
                let i, n;
                const r = this.centerPoint;
                if ("globe" === this.projection.name) {
                    const e1 = this.worldSize;
                    i = (t1.x - r.x) / e1, n = (t1.y - r.y) / e1;
                } else {
                    const e1 = this.pointCoordinate(t1), o = this.pointCoordinate(r);
                    i = e1.x - o.x, n = e1.y - o.y;
                }
                const o = this.locationCoordinate(e1);
                this.setLocation(new bu(o.x - i, o.y - n));
            }
            setLocation(e1) {
                this.center = this.coordinateLocation(e1), this.projection.wrap && (this.center = this.center.wrap());
            }
            locationPoint(e1, t1) {
                return this.projection.locationPoint(this, e1, t1);
            }
            locationPoint3D(e1, t1) {
                return this.projection.locationPoint(this, e1, t1, !0);
            }
            pointLocation(e1) {
                return this.coordinateLocation(this.pointCoordinate(e1));
            }
            pointLocation3D(e1, t1) {
                return this.coordinateLocation(this.pointCoordinate3D(e1, t1));
            }
            locationCoordinate(e1, t1) {
                const i = t1 ? pu(t1, e1.lat) : void 0, n = this.projection.project(e1.lng, e1.lat);
                return new bu(n.x, n.y, i);
            }
            coordinateLocation(e1) {
                return this.projection.unproject(e1.x, e1.y);
            }
            pointRayIntersection(e1, t1) {
                const i = t1 ?? this._centerAltitude, n = [
                    e1.x,
                    e1.y,
                    0,
                    1
                ], r = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                le(n, n, this.pixelMatrixInverse), le(r, r, this.pixelMatrixInverse);
                const o = r[3];
                ae(n, n, 1 / n[3]), ae(r, r, 1 / o);
                const a = n[2], s = r[2];
                return {
                    p0: n,
                    p1: r,
                    t: a === s ? 0 : (i - a) / (s - a)
                };
            }
            screenPointToMercatorRay(e1) {
                const t1 = [
                    e1.x,
                    e1.y,
                    0,
                    1
                ], i = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                return le(t1, t1, this.pixelMatrixInverse), le(i, i, this.pixelMatrixInverse), ae(t1, t1, 1 / t1[3]), ae(i, i, 1 / i[3]), t1[2] = pu(t1[2], this._center.lat) * this.worldSize, i[2] = pu(i[2], this._center.lat) * this.worldSize, ae(t1, t1, 1 / this.worldSize), ae(i, i, 1 / this.worldSize), new gf([
                    t1[0],
                    t1[1],
                    t1[2]
                ], Z([], te([], i, t1)));
            }
            rayIntersectionCoordinate(e1) {
                const { p0: t1, p1: i, t: n } = e1, r = pu(t1[2], this._center.lat), o = pu(i[2], this._center.lat);
                return new bu(dn(t1[0], i[0], n) / this.worldSize, dn(t1[1], i[1], n) / this.worldSize, dn(r, o, n));
            }
            pointCoordinate(e1, t1 = this._centerAltitude) {
                return this.projection.pointCoordinate(this, e1.x, e1.y, t1);
            }
            pointCoordinate3D(e1, t1) {
                if (!this.elevation) return this.pointCoordinate(e1, t1);
                let i = this.projection.pointCoordinate3D(this, e1.x, e1.y);
                if (i) return new bu(i[0], i[1], i[2]);
                let n = 0, r = this.horizonLineFromTop();
                if (e1.y > r) return this.pointCoordinate(e1, t1);
                const o = .02 * r, a = e1.clone();
                for(let e1 = 0; e1 < 10 && r - n > o; e1++){
                    a.y = dn(n, r, .66);
                    const e1 = this.projection.pointCoordinate3D(this, a.x, a.y);
                    e1 ? (r = a.y, i = e1) : n = a.y;
                }
                return i ? new bu(i[0], i[1], i[2]) : this.pointCoordinate(e1);
            }
            isPointAboveHorizon(e1) {
                return this.projection.isPointAboveHorizon(this, e1);
            }
            isPointOnSurface(e1) {
                if (e1.y < 0 || e1.y > this.height || e1.x < 0 || e1.x > this.width) return !1;
                if (this.elevation || this.zoom >= 6) return !this.isPointAboveHorizon(e1);
                const t1 = this.pointCoordinate(e1);
                return t1.y >= 0 && t1.y <= 1;
            }
            _coordinatePoint(e1, t1) {
                const i = t1 && this.elevation ? this.elevation.getAtPointOrZero(e1, this._centerAltitude) : this._centerAltitude, n = [
                    e1.x * this.worldSize,
                    e1.y * this.worldSize,
                    i + e1.toAltitude(),
                    1
                ];
                return le(n, n, this.pixelMatrix), n[3] > 0 ? new Pe(n[0] / n[3], n[1] / n[3]) : new Pe(Number.MAX_VALUE, Number.MAX_VALUE);
            }
            _getBoundsNonRectangular() {
                const { top: e1, left: t1 } = this._edgeInsets, i = this.height - this._edgeInsets.bottom, n = this.width - this._edgeInsets.right, r = this.pointLocation3D(new Pe(t1, e1)), o = this.pointLocation3D(new Pe(n, e1)), a = this.pointLocation3D(new Pe(n, i)), s = this.pointLocation3D(new Pe(t1, i));
                let l = Math.min(r.lng, o.lng, a.lng, s.lng), u = Math.max(r.lng, o.lng, a.lng, s.lng), c = Math.min(r.lat, o.lat, a.lat, s.lat), h = Math.max(r.lat, o.lat, a.lat, s.lat);
                const f = Math.pow(2, -this.zoom) / 16 * 270, p = "globe" === this.projection.name ? 1 : 4, m = (e1, t1, i, n, r)=>{
                    const o = (e1 + i) / 2, a = (t1 + n) / 2, s = new Pe(o, a), { lng: d, lat: _ } = this.pointLocation3D(s), g = Math.max(0, l - d, c - _, d - u, _ - h);
                    l = Math.min(l, d), u = Math.max(u, d), c = Math.min(c, _), h = Math.max(h, _), (r < p || g > f) && (m(e1, t1, o, a, r + 1), m(o, a, i, n, r + 1));
                };
                if (m(t1, e1, n, e1, 1), m(n, e1, n, i, 1), m(n, i, t1, i, 1), m(t1, i, t1, e1, 1), "globe" === this.projection.name) {
                    const [e1, t1] = function(e1) {
                        const t1 = d(new Float64Array(16));
                        _(t1, e1.pixelMatrix, e1.globeMatrix);
                        const i = [
                            0,
                            ou,
                            0
                        ], n = [
                            0,
                            au,
                            0
                        ];
                        return Y(i, i, t1), Y(n, n, t1), [
                            i[0] > 0 && i[0] <= e1.width && i[1] > 0 && i[1] <= e1.height && !Wf(e1, new hu(e1.center.lat, 90)),
                            n[0] > 0 && n[0] <= e1.width && n[1] > 0 && n[1] <= e1.height && !Wf(e1, new hu(e1.center.lat, -90))
                        ];
                    }(this);
                    e1 ? (h = 90, u = 180, l = -180) : t1 && (c = -90, u = 180, l = -180);
                }
                return new du(new hu(l, c), new hu(u, h));
            }
            _getBoundsRectangular(e1, t1) {
                const { top: i, left: n } = this._edgeInsets, r = this.height - this._edgeInsets.bottom, o = this.width - this._edgeInsets.right, a = new Pe(n, i), s = new Pe(o, i), l = new Pe(o, r), u = new Pe(n, r);
                let c = this.pointCoordinate(a, e1), h = this.pointCoordinate(s, e1);
                const d = this.pointCoordinate(l, t1), f = this.pointCoordinate(u, t1), p = (e1, t1)=>(t1.y - e1.y) / (t1.x - e1.x);
                return c.y > 1 && h.y >= 0 ? c = new bu((1 - f.y) / p(f, c) + f.x, 1) : c.y < 0 && h.y <= 1 && (c = new bu(-f.y / p(f, c) + f.x, 0)), h.y > 1 && c.y >= 0 ? h = new bu((1 - d.y) / p(d, h) + d.x, 1) : h.y < 0 && c.y <= 1 && (h = new bu(-d.y / p(d, h) + d.x, 0)), (new du).extend(this.coordinateLocation(c)).extend(this.coordinateLocation(h)).extend(this.coordinateLocation(f)).extend(this.coordinateLocation(d));
            }
            _getBoundsRectangularTerrain() {
                const e1 = this.elevation;
                if (!e1.visibleDemTiles.length || e1.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
                const t1 = e1.visibleDemTiles.reduce((e1, t1)=>{
                    if (t1.dem) {
                        const i = t1.dem.tree;
                        e1.min = Math.min(e1.min, i.minimums[0]), e1.max = Math.max(e1.max, i.maximums[0]);
                    }
                    return e1;
                }, {
                    min: Number.MAX_VALUE,
                    max: 0
                });
                return this._getBoundsRectangular(t1.min * e1.exaggeration(), t1.max * e1.exaggeration());
            }
            getBounds() {
                return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
            }
            horizonLineFromTop(e1 = !0) {
                const t1 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, .1)) - this.centerOffset.y, i = this.height / 2 - t1 * (1 - this._horizonShift);
                return e1 ? Math.max(0, i) : i;
            }
            getMaxBounds() {
                return this.maxBounds;
            }
            setMaxBounds(e1) {
                this.maxBounds = e1, this.minLat = -85.051129, this.maxLat = mu, this.minLng = -180, this.maxLng = 180, e1 && (this.minLat = e1.getSouth(), this.maxLat = e1.getNorth(), this.minLng = e1.getWest(), this.maxLng = e1.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = hr(this.minLng) * this.tileSize, this.worldMaxX = hr(this.maxLng) * this.tileSize, this.worldMinY = dr(this.maxLat) * this.tileSize, this.worldMaxY = dr(this.minLat) * this.tileSize, this._constrain();
            }
            calculatePosMatrix(e1, t1) {
                return this.projection.createTileMatrix(this, t1, e1);
            }
            calculateDistanceTileData(e1) {
                const t1 = e1.key, i = this._distanceTileDataCache;
                if (i[t1]) return i[t1];
                const n = e1.canonical, r = 1 / this.height, o = this.cameraWorldSize, a = o / this.zoomScale(n.z), s = (n.x + Math.pow(2, n.z) * e1.wrap) * a, l = n.y * a, u = this.point;
                u.x *= o / this.worldSize, u.y *= o / this.worldSize;
                const c = this.angle, h = Math.sin(-c), d = -Math.cos(-c);
                return i[t1] = {
                    bearing: [
                        h,
                        d
                    ],
                    center: [
                        (u.x - s) * r,
                        (u.y - l) * r
                    ],
                    scale: a / Sr * r
                }, i[t1];
            }
            calculateFogTileMatrix(e1) {
                const t1 = e1.key, i = this._fogTileMatrixCache;
                if (i[t1]) return i[t1];
                const n = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, e1);
                return _(n, this.worldToFogMatrix, n), i[t1] = new Float32Array(n), i[t1];
            }
            calculateProjMatrix(e1, t1 = !1, i = !1) {
                const n = e1.key;
                let r;
                if (r = i ? this._expandedProjMatrixCache : t1 ? this._alignedProjMatrixCache : this._projMatrixCache, r[n]) return r[n];
                const o = this.calculatePosMatrix(e1, this.worldSize);
                let a;
                return a = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : i ? this.expandedFarZProjMatrix : t1 ? this.alignedProjMatrix : this.projMatrix, _(o, a, o), r[n] = new Float32Array(o), r[n];
            }
            calculatePixelsToTileUnitsMatrix(e1) {
                const t1 = e1.tileID.key, i = this._pixelsToTileUnitsCache;
                if (i[t1]) return i[t1];
                const n = function(e1, t1) {
                    const { scale: i } = e1.tileTransform, n = i * Sr / (e1.tileSize * Math.pow(2, t1.zoom - e1.tileID.overscaledZ + e1.tileID.canonical.z)), r = t1.inverseAdjustmentMatrix;
                    return new Float32Array([
                        r[0] * n,
                        r[1] * n,
                        r[2] * n,
                        r[3] * n
                    ]);
                }(e1, this);
                return i[t1] = n, i[t1];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            globeToMercatorMatrix() {
                if ("globe" === this.projection.name) {
                    const e1 = 1 / this.worldSize, t1 = w([], [
                        e1,
                        e1,
                        e1
                    ]);
                    return _(t1, t1, this.globeMatrix), t1;
                }
            }
            recenterOnTerrain() {
                if (!this._elevation || "globe" === this.projection.name) return;
                const e1 = this._elevation;
                this._updateCameraState();
                const t1 = pu(1, this._center.lat) * this.worldSize, i = this._computeCameraPosition(t1), n = this._camera.forward(), r = pu(1, this._center.lat);
                i[2] /= r, n[2] /= r, Z(n, n);
                const o = e1.raycast(i, n, e1.exaggeration());
                if (o) {
                    const e1 = U([], i, n, o), t1 = new bu(e1[0], e1[1], pu(e1[2], pr(e1[1]))), a = (t1.z + D([
                        t1.x - i[0],
                        t1.y - i[1],
                        t1.z - i[2] * r
                    ])) * this._pixelsPerMercatorPixel;
                    this._seaLevelZoom = this._zoomFromMercatorZ(a), this._centerAltitude = t1.toAltitude(), this._center = this.coordinateLocation(t1), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
                }
            }
            _constrainCamera(e1 = !1) {
                if (!this._elevation) return;
                const t1 = this._elevation, i = pu(1, this._center.lat) * this.worldSize, n = this._computeCameraPosition(i), r = t1.getAtPointOrZero(new bu(...n)), o = this.pixelsPerMeter / this.worldSize * r, a = this._minimumHeightOverTerrain(), s = n[2] - o;
                if (s <= a) {
                    if (s < 0 || e1) {
                        const e1 = this.locationCoordinate(this._center, this._centerAltitude), t1 = [
                            n[0],
                            n[1],
                            e1.z - n[2]
                        ], i = D(t1);
                        t1[2] -= (a - s) / this._pixelsPerMercatorPixel;
                        const r = D(t1);
                        if (0 === r) return;
                        k(t1, t1, i / r * this._pixelsPerMercatorPixel), this._camera.position = [
                            n[0],
                            n[1],
                            e1.z * this._pixelsPerMercatorPixel - t1[2]
                        ], this._updateStateFromCamera();
                    } else this._isCameraConstrained = !0;
                }
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                const e1 = "globe" === this.projection.name || this.mercatorFromTransition;
                if (this.projection.isReprojectedInTileSpace || e1) {
                    const t1 = this.center;
                    return t1.lat = tt(t1.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !e1) && (t1.lng = tt(t1.lng, this.minLng, this.maxLng)), this.center = t1, void (this._constraining = !1);
                }
                const t1 = this._unmodified, { x: i, y: n } = this.point;
                let r = 0, o = i, a = n;
                const s = this.width / 2, l = this.height / 2, u = this.worldMinY * this.scale, c = this.worldMaxY * this.scale;
                if (n - l < u && (a = u + l), n + l > c && (a = c - l), c - u < this.height && (r = Math.max(r, this.height / (c - u)), a = (c + u) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
                    const e1 = this.worldMinX * this.scale, t1 = this.worldMaxX * this.scale, n = this.worldSize / 2 - (e1 + t1) / 2;
                    o = (i + n + this.worldSize) % this.worldSize - n, o - s < e1 && (o = e1 + s), o + s > t1 && (o = t1 - s), t1 - e1 < this.width && (r = Math.max(r, this.width / (t1 - e1)), o = (t1 + e1) / 2);
                }
                o === i && a === n || this._allowWorldUnderZoom || (this.center = this.unproject(new Pe(o, a))), r && !this._allowWorldUnderZoom && (this.zoom += this.scaleZoom(r)), this._constrainCamera(), this._unmodified = t1, this._constraining = !1;
            }
            _minZoomForBounds() {
                let e1 = Math.max(0, this.scaleZoom(Math.max(0, this.height) / (this.worldMaxY - this.worldMinY)));
                return this.maxBounds && (e1 = Math.max(e1, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e1;
            }
            _maxCameraBoundsDistance() {
                return this._mercatorZfromZoom(this._minZoomForBounds());
            }
            _calcMatrices() {
                if (!this.height) return;
                const e1 = this.centerOffset, t1 = "globe" === this.projection.name, i = this.pixelsPerMeter;
                "globe" === this.projection.name && (this._mercatorScaleRatio = pu(1, this.center.lat) / pu(1, 45));
                const n = Yg(this.projection, this.zoom, this.width, this.height, 1024);
                this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, n), this.cameraToCenterDistance = .5 / Math.tan(.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
                const r = "meters" === this.projection.zAxisUnit ? i : 1, a = this._camera.getWorldToCamera(this.worldSize, r);
                let s;
                const l = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
                if (l[8] = 2 * -e1.x / this.width, l[9] = 2 * e1.y / this.height, this.isOrthographic) {
                    let t1 = .5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(.5 * this._fov), i = t1 * this.aspect, n = -i, r = -t1;
                    i -= e1.x, n -= e1.x, t1 += e1.y, r += e1.y, s = this._camera.getCameraToClipOrthographic(n, i, r, t1, this._nearZ + this._nearClipOffset, this._farZ), ((e1, t1, i, n)=>{
                        for(let r = 0; r < 16; r++)e1[r] = dn(t1[r], i[r], n);
                    })(s, s, l, Rt(this.pitch >= fw ? 1 : this.pitch / fw));
                } else s = l;
                const u = z([], l, a), c = z([], s, a);
                if (this.projection.isReprojectedInTileSpace) {
                    const e1 = this.locationCoordinate(this.center);
                    d(this._mat4Scratch);
                    const t1 = this._mat4Scratch;
                    m(t1, t1, [
                        e1.x * this.worldSize,
                        e1.y * this.worldSize,
                        0
                    ]), _(t1, t1, qg(this)), m(t1, t1, [
                        -e1.x * this.worldSize,
                        -e1.y * this.worldSize,
                        0
                    ]), _(c, c, t1), _(u, u, t1), this.inverseAdjustmentMatrix = function(e1) {
                        const t1 = qg(e1, !0);
                        return o([], [
                            t1[0],
                            t1[1],
                            t1[4],
                            t1[5]
                        ]);
                    }(this);
                } else this.inverseAdjustmentMatrix = [
                    1,
                    0,
                    0,
                    1
                ];
                if (g(this.mercatorMatrix, c, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize / r,
                    1
                ]), this.projMatrix = c, p(this.invProjMatrix, this.projMatrix), t1) {
                    const t1 = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
                    t1[8] = 2 * -e1.x / this.width, t1[9] = 2 * e1.y / this.height, z(this._expandedFarZProjMatrixBuf, t1, a), this.expandedFarZProjMatrix = this._expandedFarZProjMatrixBuf;
                } else this.expandedFarZProjMatrix = this.projMatrix;
                p(this._mat4Scratch, s), this.frustumCorners = yf.fromInvProjectionMatrix(this._mat4Scratch, this.horizonLineFromTop(), this.height), this.cameraFrustum = Af.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !t1), w(this.skyboxMatrix, [
                    1,
                    -1,
                    1
                ]), y(this.skyboxMatrix, this.skyboxMatrix, this._pitch), v(this.skyboxMatrix, this.skyboxMatrix, this.angle), M(this.starsProjMatrix, this._fov, this.width / this.height, this._nearZ, this._farZ);
                const f = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
                h(this._mat4Scratch, this.starsProjMatrix), this._mat4Scratch[8] = 2 * -e1.x / this.width, this._mat4Scratch[9] = 2 * (e1.y + f) / this.height, _(this.skyboxMatrix, this._mat4Scratch, this.skyboxMatrix);
                const x = this.point, b = x.x, E = x.y, A = this.width % 2 / 2, I = this.height % 2 / 2, T = Math.cos(this.angle), S = Math.sin(this.angle), R = b - Math.round(b) + T * A + S * I, P = E - Math.round(E) + T * I + S * A;
                if (h(this.alignedProjMatrix, c), m(this.alignedProjMatrix, this.alignedProjMatrix, [
                    R > .5 ? R - 1 : R,
                    P > .5 ? P - 1 : P,
                    0
                ]), w(this.labelPlaneMatrix, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), m(this.labelPlaneMatrix, this.labelPlaneMatrix, [
                    1,
                    -1,
                    0
                ]), w(this.glCoordMatrix, [
                    1,
                    -1,
                    1
                ]), m(this.glCoordMatrix, this.glCoordMatrix, [
                    -1,
                    -1,
                    0
                ]), g(this.glCoordMatrix, this.glCoordMatrix, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), _(this.pixelMatrix, this.labelPlaneMatrix, u), this._calcFogMatrices(), this._distanceTileDataCache = {}, !p(this.pixelMatrixInverse, this.pixelMatrix)) throw new Error("failed to invert matrix");
                if ("globe" === this.projection.name || this.mercatorFromTransition) {
                    this.globeMatrix = function(e1) {
                        const { x: t1, y: i } = e1.point, { lng: n, lat: r } = e1._center;
                        return Hf(t1, i, e1.worldSize, n, r);
                    }(this);
                    const e1 = [
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ];
                    this.globeCenterInViewSpace = Y(e1, e1, a), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
                } else this.globeMatrix = this.pixelMatrixInverse;
                this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
            }
            _calcFogMatrices() {
                this._fogTileMatrixCache = {};
                const e1 = this.cameraWorldSizeForFog, t1 = this.cameraPixelsPerMeter, i = this._camera.position, n = 1 / this.height / this._pixelsPerMercatorPixel, r = [
                    e1,
                    e1,
                    t1
                ];
                k(r, r, n), k(i, i, -1), B(i, i, r), b(this.mercatorFogMatrix, i), g(this.mercatorFogMatrix, this.mercatorFogMatrix, r), this.worldToFogMatrix = this._camera.getWorldToCameraPosition(e1, t1, n);
            }
            _computeCameraPosition(e1) {
                const t1 = (e1 = e1 || this.pixelsPerMeter) / this.pixelsPerMeter, i = this._camera.forward(), n = this.point, r = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t1 - e1 / this.worldSize * this._centerAltitude;
                return [
                    n.x / this.worldSize - i[0] * r,
                    n.y / this.worldSize - i[1] * r,
                    e1 / this.worldSize * this._centerAltitude - i[2] * r
                ];
            }
            _updateCameraState() {
                this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
            }
            _translateCameraConstrained(e1) {
                const t1 = this._maxCameraBoundsDistance() * Math.cos(this._pitch), i = this._camera.position[2], n = e1[2];
                let r = 1;
                this.projection.wrap && (this.center = this.center.wrap()), n > 0 && (r = Math.min((t1 - i) / n, 1)), this._camera.position = U([], this._camera.position, e1, r), this._updateStateFromCamera();
            }
            _updateStateFromCamera() {
                const e1 = this._camera.position, t1 = this._camera.forward(), { pitch: i, bearing: n } = this._camera.getPitchBearing(), r = pu(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, o = this._mercatorZfromZoom(this._maxZoom) * Math.cos(Ye(this._maxPitch)), a = Math.max((e1[2] - r) / Math.cos(i), o), s = this._zoomFromMercatorZ(a);
                U(e1, e1, t1, a), this._pitch = tt(i, Ye(this.minPitch), Ye(this.maxPitch)), this.angle = nt(n, -Math.PI, Math.PI), this._setZoom(tt(s, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new bu(e1[0], e1[1], e1[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
            }
            _worldSizeFromZoom(e1) {
                return Math.pow(2, e1) * this.tileSize;
            }
            _mercatorZfromZoom(e1) {
                return this.cameraToCenterDistance / this._worldSizeFromZoom(e1);
            }
            _minimumHeightOverTerrain() {
                const e1 = Math.min(this._seaLevelZoom ?? this._zoom, this._maxZoom) + 4;
                return this._mercatorZfromZoom(e1);
            }
            _zoomFromMercatorZ(e1) {
                return this.scaleZoom(this.cameraToCenterDistance / (Math.max(0, e1) * this.tileSize));
            }
            zoomFromMercatorZAdjusted(e1) {
                let t1 = 0, i = 6, n = 0, r = 1 / 0;
                for(; i - t1 > 1e-6 && i > t1;){
                    const o = t1 + .5 * (i - t1), a = this.tileSize * Math.pow(2, o), s = this.getCameraToCenterDistance(this.projection, o, a), l = this.scaleZoom(s / (Math.max(0, e1) * this.tileSize)), u = Math.abs(o - l);
                    u < r && (r = u, n = o), o < l ? t1 = o : i = o;
                }
                return n;
            }
            _terrainEnabled() {
                return !(!this._elevation || !this.projection.supportsTerrain && (mt("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
            }
            anyCornerOffEdge(e1, t1) {
                const i = Math.min(e1.x, t1.x), n = Math.max(e1.x, t1.x), r = Math.min(e1.y, t1.y), o = Math.max(e1.y, t1.y);
                if (r < this.horizonLineFromTop(!1)) return !0;
                if ("mercator" !== this.projection.name) return !1;
                const a = [
                    new Pe(i, r),
                    new Pe(n, o),
                    new Pe(i, o),
                    new Pe(n, r)
                ], s = this.renderWorldCopies ? -3 : 0, l = this.renderWorldCopies ? 4 : 1;
                for (const e1 of a){
                    const t1 = this.pointRayIntersection(e1);
                    if (t1.t < 0) return !0;
                    const i = this.rayIntersectionCoordinate(t1);
                    if (i.x < s || i.y < 0 || i.x > l || i.y > 1) return !0;
                }
                return !1;
            }
            isHorizonVisible() {
                return this.pitch + Je(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new Pe(0, 0), new Pe(this.width, this.height));
            }
            zoomDeltaToMovement(e1, t1) {
                const i = D(te([], this._camera.position, e1)), n = this._zoomFromMercatorZ(i) + t1;
                return i - this._mercatorZfromZoom(n);
            }
            getCameraPoint() {
                if ("globe" === this.projection.name) {
                    const e1 = function([e1, t1, i], n) {
                        const r = [
                            e1,
                            t1,
                            i,
                            1
                        ];
                        le(r, r, n);
                        const o = r[3] = Math.max(r[3], 1e-6);
                        return r[0] /= o, r[1] /= o, r[2] /= o, r;
                    }([
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ], this.pixelMatrix);
                    return new Pe(e1[0], e1[1]);
                }
                {
                    const e1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                    return this.centerPoint.add(new Pe(0, e1));
                }
            }
            getCameraToCenterDistance(e1, t1 = this.zoom, i = this.worldSize) {
                const n = Yg(e1, t1, this.width, this.height, 1024), r = e1.pixelSpaceConversion(this.center.lat, i, n);
                let o = .5 / Math.tan(.5 * this._fov) * this.height * r;
                return this.isOrthographic && (o = dn(1, o, Rt(this.pitch >= fw ? 1 : this.pitch / fw))), o;
            }
            getWorldToCameraMatrix() {
                const e1 = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
                return "globe" === this.projection.name && _(e1, e1, this.globeMatrix), e1;
            }
            getFrustum(e1) {
                return Af.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, e1, "meters" === this.projection.zAxisUnit);
            }
        }
        const _w = (e1, t1)=>{
            if (t1 <= 0 || e1.terrain) return {
                shouldRenderCutoff: !1,
                uniformValues: {
                    u_cutoff_params: [
                        0,
                        0,
                        0,
                        1
                    ]
                }
            };
            const i = e1.transform, n = i.pitch, r = i.isLODDisabled(!1) ? 60 : 30;
            if (n < r - 15) return {
                shouldRenderCutoff: !1,
                uniformValues: {
                    u_cutoff_params: [
                        0,
                        0,
                        0,
                        1
                    ]
                }
            };
            const o = i._farZ - i._nearZ, a = t1 * i.height * 1.3, s = Math.pow(2, .85 * Math.max(i._zoom - e1.minCutoffZoom, 0)), l = 1.4 * i.cameraToCenterDistance * s, u = it(r - 15, r, n), c = dn(i._farZ + a, l, u), h = Math.min(a, c - i._nearZ);
            return {
                shouldRenderCutoff: u > 0,
                uniformValues: {
                    u_cutoff_params: [
                        i._nearZ,
                        i._farZ,
                        (c - i._nearZ) / o,
                        (c - h - i._nearZ) / o
                    ]
                }
            };
        }, mw = .05;
        function gw(e1, t1, i) {
            const n = it(45, 65, i), [r, o] = e1.range;
            let a = 1 - Math.min(1, Math.exp((t1 - r) / (o - r) * -6));
            return a *= a * a, a = Math.min(1, 1.00747 * a), a * n * e1.alpha;
        }
        function yw(e1, t1, i, n, r) {
            return gw(e1, D(Y([], [
                t1,
                i,
                n
            ], r.mercatorFogMatrix)), r.pitch);
        }
        function xw(e1, t1, i, n) {
            const r = 1 << e1.z;
            t1.lat = pr((n / Sr + e1.y) / r), t1.lng = fr((i / Sr + e1.x) / r);
        }
        const vw = (e1, t1, i = 1)=>({
                u_matrix: e1,
                u_color: t1,
                u_overlay: 0,
                u_overlay_scale: i
            }), bw = new Float64Array(16), ww = new Float64Array(16), Ew = new Float64Array(16), Aw = new Float64Array(16), Iw = new Float64Array(16), Tw = new Float64Array(16), Mw = new Float64Array(16), Sw = [
            0,
            0,
            0
        ], zw = new Float32Array(16), Rw = [
            0,
            0,
            0
        ], Pw = [
            0,
            0,
            0
        ], Dw = [];
        function Cw(e1, t1, i) {
            const n = i.cameraWorldSizeForFog / i.worldSize;
            return g(e1, i.worldToFogMatrix, [
                n,
                n,
                1
            ]), _(e1, e1, t1), e1;
        }
        function Fw(e1, t1, i, n) {
            return m(e1, t1, i), ee(n, ay) || g(e1, e1, n), e1;
        }
        function Ow(e1, t1, i, n, r) {
            const o = i.material, a = n.context, { baseColorTexture: s, metallicRoughnessTexture: l } = o.pbrMetallicRoughness, { normalTexture: u, occlusionTexture: c, emissionTexture: h } = o;
            function d(t1, i, n) {
                if (t1 && (e1.push(i), a.activeTexture.set(a.gl.TEXTURE0 + n), t1.gfxTexture)) {
                    const { minFilter: e1, magFilter: i, wrapS: n, wrapT: r } = t1.sampler;
                    t1.gfxTexture.bindExtraParam(e1, i, n, r);
                }
            }
            d(s, "HAS_TEXTURE_u_baseColorTexture", Cb.BaseColor), d(l, "HAS_TEXTURE_u_metallicRoughnessTexture", Cb.MetallicRoughness), d(u, "HAS_TEXTURE_u_normalTexture", Cb.Normal), d(c, "HAS_TEXTURE_u_occlusionTexture", Cb.Occlusion), d(h, "HAS_TEXTURE_u_emissionTexture", Cb.Emission), r && (r.texture || (r.texture = new h_(n.context, r.image, [
                r.image.height,
                r.image.height,
                r.image.height
            ], a.gl.RGBA8)), a.activeTexture.set(a.gl.TEXTURE0 + Cb.LUT), r.texture && r.texture.bind(a.gl.LINEAR, a.gl.CLAMP_TO_EDGE), e1.push("APPLY_LUT_ON_GPU")), i.texcoordBuffer && (e1.push("HAS_ATTRIBUTE_a_uv_2f"), t1.push(i.texcoordBuffer)), i.colorBuffer && (e1.push(12 === i.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), t1.push(i.colorBuffer)), i.normalBuffer && (e1.push("HAS_ATTRIBUTE_a_normal_3f"), t1.push(i.normalBuffer)), i.pbrBuffer && (e1.push("HAS_ATTRIBUTE_a_pbr"), e1.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), t1.push(i.pbrBuffer)), "OPAQUE" !== o.alphaMode && "MASK" !== o.alphaMode || e1.push("UNPREMULT_TEXTURE_IN_SHADER"), o.defined || e1.push("DIFFUSE_SHADED");
            const f = n.shadowRenderer;
            f && (e1.push("RENDER_SHADOWS"), f.useNormalOffset && e1.push("NORMAL_OFFSET"));
        }
        function Lw(e1, t1, i, n, r, o) {
            const a = e1.modelOpacity, s = t1.context, l = new jb(t1.context.gl.LEQUAL, e1.isLightMesh ? jb.ReadOnly : jb.ReadWrite, t1.depthRangeFor3D), u = t1.transform, c = e1.mesh, h = c.material, d = h.pbrMetallicRoughness, m = t1.style.fog;
            "pixels" === t1.transform.projection.zAxisUnit ? bw.set(e1.nodeModelMatrix) : _(bw, n.zScaleMatrix, e1.nodeModelMatrix), _(bw, n.negCameraPosMatrix, bw), p(ww, bw), f(ww, ww);
            const g = "none" === i.paint.get("model-color-use-theme").constantOr("default"), y = i.paint.get("model-emissive-strength").constantOr(0), x = {
                defines: []
            }, v = [], b = t1.shadowRenderer;
            b && (b.useNormalOffset = !1), Ow(x.defines, v, c, t1, g ? null : i.lut);
            let w = null;
            if (m && (w = Cw(Ew, e1.nodeModelMatrix, t1.transform), "globe" !== u.projection.name)) {
                const e1 = c.aabb.min, t1 = c.aabb.max, [i, n] = m.getOpacityForBounds(w, e1[0], e1[1], t1[0], t1[1]);
                x.overrideFog = i >= mw || n >= mw;
            }
            const E = _w(t1, i.paint.get("model-cutoff-fade-range"));
            E.shouldRenderCutoff && x.defines.push("RENDER_CUTOFF");
            const A = t1.getOrCreateProgram("model", x), I = Lb(e1.worldViewProjection, bw, ww, null, t1, a, d.baseColorFactor, h.emissiveFactor, d.metallicFactor, d.roughnessFactor, h, y, i, void 0, void 0, e1.materialOverride, e1.modelColor, 1, A.fixedDefines.includes("LIGHTING_3D_MODE"));
            t1.uploadCommonUniforms(s, A, null, w, E, e1.lightOverrides), "shadow" !== t1.renderPass && b && b.setupShadowsFromMatrix(e1.nodeModelMatrix, A), A.draw(t1, s.gl.TRIANGLES, l, r, o, c.material.doubleSided ? Zb.disabled : Zb.backCCW, I, i.id, c.vertexBuffer, c.indexBuffer, c.segments, i.paint, t1.transform.zoom, void 0, v);
        }
        function Bw(e1, t1) {
            return e1.style._importedAsBasemap ? "basemap" : t1.scope;
        }
        function Nw(e1, t1, i, n, r, o, a, s, l, u, c) {
            const h = e1.transform, d = !!t1.isGeometryBloom && t1.isGeometryBloom;
            if (void 0 !== t1.minZoom && e1.transform.zoom < t1.minZoom) return;
            if (void 0 !== t1.maxZoom && e1.transform.zoom > t1.maxZoom) return;
            if (d && "shadow" === e1.renderPass) return;
            const f = "globe" === h.projection.name ? ny(i, h) : [
                ...i
            ];
            _(f, f, t1.globalMatrix);
            const p = _([], n, f);
            if (t1.meshes) for (const e1 of t1.meshes){
                const n = s.get(e1.material.name);
                if (n && n.opacity <= 0) continue;
                if ("BLEND" !== e1.material.alphaMode) {
                    a.push({
                        mesh: e1,
                        depth: 0,
                        modelIndex: r,
                        worldViewProjection: p,
                        nodeModelMatrix: f,
                        isLightMesh: d,
                        materialOverride: n,
                        modelOpacity: l,
                        modelColor: u,
                        lightOverrides: c,
                        node: t1,
                        modelMatrix: i
                    });
                    continue;
                }
                const _ = Y([], e1.centroid, p);
                !h.isOrthographic && _[2] <= 0 || o.push({
                    mesh: e1,
                    depth: _[2],
                    modelIndex: r,
                    worldViewProjection: p,
                    nodeModelMatrix: f,
                    isLightMesh: d,
                    materialOverride: n,
                    modelOpacity: l,
                    modelColor: u,
                    lightOverrides: c,
                    node: t1,
                    modelMatrix: i
                });
            }
            if (t1.children) for (const h of t1.children)Nw(e1, h, i, n, r, o, a, s, l, u, c);
        }
        function Vw(e1, t1, i, n, r) {
            const o = i.shadowRenderer;
            if (!o) return;
            const a = o.getShadowPassDepthMode(), s = r || o.calculateShadowPassMatrixFromMatrix(t1), l = Bb(s);
            i.getOrCreateProgram("modelDepth").draw(i, i.context.gl.TRIANGLES, a, Vb.disabled, Gb.disabled, Zb.disabled, l, n.id, e1.vertexBuffer, e1.indexBuffer, e1.segments, n.paint, i.transform.zoom, void 0, void 0);
        }
        function kw(e1, t1, i, n) {
            const r = function(e1, t1) {
                if (t1.footprintDebugMesh) return t1.footprintDebugMesh;
                if (!t1.footprint) return null;
                const i = e1.context, n = t1.footprint.vertices, r = t1.footprint.indices, o = new Bu;
                o.reserve(n.length);
                for (const e1 of n)o.emplaceBack(e1.x, e1.y);
                const a = new oc;
                a.reserve(r.length);
                for(let e1 = 0; e1 < r.length; e1 += 3)a.emplaceBack(r[e1], r[e1 + 1], r[e1 + 2]);
                const s = i.createVertexBuffer(o, _f.members), l = i.createIndexBuffer(a), u = Bc.simpleSegment(0, 0, n.length, r.length), c = t1.id || t1.name || "footprint";
                let h;
                const d = parseInt(c, 10);
                h = isNaN(d) ? function(e1) {
                    let t1 = 0;
                    for(let i = 0; i < e1.length; i++)t1 = (t1 << 5) - t1 + e1.charCodeAt(i) | 0;
                    return t1;
                }(c) : d;
                const f = Pt(h), p = Pt(h + 1), _ = Pt(h + 2);
                return t1.footprintDebugMesh = {
                    vertexBuffer: s,
                    indexBuffer: l,
                    segments: u,
                    color: new pn(f, p, _, .5)
                }, t1.footprintDebugMesh;
            }(e1, i);
            if (!r) return;
            const o = e1.context, a = o.gl, s = e1.getOrCreateProgram("debug"), l = r.color, u = jb.disabled;
            o.activeTexture.set(a.TEXTURE0), e1.emptyTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), s.draw(e1, a.TRIANGLES, u, Vb.disabled, Gb.alphaBlended, Zb.disabled, vw(n, l.toPremultipliedRenderColor(null)), "$debug", r.vertexBuffer, r.indexBuffer, r.segments);
        }
        function Uw(e1, t1, i, n, r, o) {
            for (const a of r){
                const r = {
                    ...n
                };
                r.part = a;
                const s = {
                    type: "Unknown",
                    id: t1,
                    properties: r
                }, l = {
                    orientation: e1.paint.get("model-rotation").evaluate(s, i)
                };
                o.set(a, l);
            }
        }
        function Gw(e1, t1, i, n, r, o) {
            for (const a of r){
                const r = {
                    ...n
                };
                r.part = a;
                const s = {
                    type: "Unknown",
                    id: t1,
                    properties: r
                }, l = {
                    color: e1.paint.get("model-color").evaluate(s, i),
                    colorMix: e1.paint.get("model-color-mix-intensity").evaluate(s, i),
                    opacity: e1.paint.get("model-opacity").evaluate(s, i),
                    emissionStrength: e1.paint.get("model-emissive-strength").evaluate(s, i)
                };
                o.set(a, l);
            }
        }
        function jw(e1, t1, i, n, r) {
            let o = !1;
            for (const i of n)1 !== i.modelOpacity && (Lw(i, e1, t1, r[i.modelIndex], Vb.disabled, Gb.disabled), o = !0);
            for (const i of n)Lw(i, e1, t1, r[i.modelIndex], 1 !== i.modelOpacity ? e1.stencilModeFor3D() : Vb.disabled, e1.colorModeForRenderPass());
            o && e1.resetStencilClippingMasks();
            const a = Gb.additive;
            for (const n of i)Lw(n, e1, t1, r[n.modelIndex], Vb.disabled, n.isLightMesh ? a : e1.colorModeForRenderPass());
        }
        function Hw(e1, t1, i) {
            const n = t1.updateZoomBasedPaintProperties(), r = function(e1, t1, i) {
                let n, r, o, a = e1.terrain ? e1.terrain.exaggeration() : 0;
                if (e1.terrain && a > 0) {
                    const t1 = e1.terrain, r = t1.findDEMTileFor(i);
                    r && r.dem ? n = _b.create(t1, i, r) : a = 0;
                }
                if (0 === a && (t1.terrainElevationMin = 0, t1.terrainElevationMax = 0), a === t1.validForExaggeration && (0 === a || n && n._demTile && n._demTile.tileID === t1.validForDEMTile.id && n._dem._timestamp === t1.validForDEMTile.timestamp)) return !1;
                for(const e1 in t1.instancesPerModel){
                    const i = t1.instancesPerModel[e1];
                    for(let e1 = 0; e1 < i.instancedDataArray.length; ++e1){
                        const s = (n ? a * n.getElevationAt(0 | i.instancedDataArray.float32[16 * e1], 0 | i.instancedDataArray.float32[16 * e1 + 1], !0, !0) : 0) + i.instancesEvaluatedElevation[e1];
                        i.instancedDataArray.float32[16 * e1 + 6] = s, r = r ? Math.min(t1.terrainElevationMin, s) : s, o = o ? Math.max(t1.terrainElevationMax, s) : s;
                    }
                }
                return t1.terrainElevationMin = r || 0, t1.terrainElevationMax = o || 0, t1.validForExaggeration = a, t1.validForDEMTile = n && n._demTile ? {
                    id: n._demTile.tileID,
                    timestamp: n._dem._timestamp
                } : {
                    id: void 0,
                    timestamp: 0
                }, !0;
            }(e1, t1, i);
            (n || r) && (t1.uploaded = !1, t1.upload(e1.context));
        }
        const $w = {
            shadowUniformsInitialized: !1,
            useSingleShadowCascade: !1,
            tileMatrix: new Float64Array(16),
            shadowTileMatrix: new Float32Array(16),
            aabb: new If([
                0,
                0,
                0
            ], [
                Sr,
                Sr,
                0
            ])
        };
        function Zw(e1, t1) {
            const i = 1 << e1.canonical.z, n = t1.getFreeCameraOptions().position, r = t1.elevation, o = e1.canonical.x / i, a = (e1.canonical.x + 1) / i, s = e1.canonical.y / i, l = (e1.canonical.y + 1) / i;
            let u = t1._centerAltitude;
            if (r) {
                const t1 = r.getMinMaxForTile(e1);
                t1 && t1.max > u && (u = t1.max);
            }
            const c = tt(n.x, o, a) - n.x, h = tt(n.y, s, l) - n.y, d = pu(u, t1.center.lat) - n.z;
            return t1._zoomFromMercatorZ(Math.sqrt(c * c + h * h + d * d));
        }
        function Ww(e1, t1, i, n, r, o, a) {
            const s = e1.context, l = "shadow" === e1.renderPass, u = e1.shadowRenderer, c = l && u ? u.getShadowPassDepthMode() : new jb(s.gl.LEQUAL, jb.ReadWrite, e1.depthRangeFor3D), h = e1.isTileAffectedByFog(o), d = "globe" === e1.transform.projection.name;
            if (i.meshes) for (const f of i.meshes){
                const p = d ? [] : [
                    "MODEL_POSITION_ON_GPU"
                ], _ = [];
                let m, g, y;
                const x = !d && n.instancedDataArray.length > 20;
                x && p.push("INSTANCED_ARRAYS");
                const v = _w(e1, t1.paint.get("model-cutoff-fade-range"));
                if (v.shouldRenderCutoff && p.push("RENDER_CUTOFF"), l && u) m = e1.getOrCreateProgram("modelDepth", {
                    defines: p
                }), g = Bb(a.shadowTileMatrix, a.shadowTileMatrix, i.globalMatrix), y = Gb.disabled;
                else {
                    Ow(p, _, f, e1, "none" === t1.paint.get("model-color-use-theme").constantOr("default") ? null : t1.lut), m = e1.getOrCreateProgram("model", {
                        defines: p,
                        overrideFog: h
                    });
                    const n = f.material, l = n.pbrMetallicRoughness, c = t1.paint.get("model-opacity").constantOr(1), d = t1.paint.get("model-emissive-strength").constantOr(0);
                    g = Lb(o.expandedProjMatrix, i.globalMatrix, zw, null, e1, c, l.baseColorFactor, n.emissiveFactor, l.metallicFactor, l.roughnessFactor, n, d, t1, r, void 0, void 0, void 0, 1, m.fixedDefines.includes("LIGHTING_3D_MODE")), u && (a.shadowUniformsInitialized ? m.setShadowUniformValues(s, u.getShadowUniformValues()) : (u.setupShadows(o.toUnwrapped(), m, "model-tile"), a.shadowUniformsInitialized = !0)), y = v.shouldRenderCutoff || c < 1 || "OPAQUE" !== n.alphaMode ? Gb.alphaBlended : Gb.unblended;
                }
                e1.uploadCommonUniforms(s, m, o.toUnwrapped(), null, v);
                const b = f.material.doubleSided ? Zb.disabled : Zb.backCCW;
                if (x) _.push(n.instancedDataBuffer), m.draw(e1, s.gl.TRIANGLES, c, Vb.disabled, y, b, g, t1.id, f.vertexBuffer, f.indexBuffer, f.segments, t1.paint, e1.transform.zoom, void 0, _, n.instancedDataArray.length);
                else {
                    const i = l ? "u_instance" : "u_normal_matrix";
                    for(let r = 0; r < n.instancedDataArray.length; ++r)g[i] = new Float32Array(n.instancedDataArray.arrayBuffer, 64 * r, 16), m.draw(e1, s.gl.TRIANGLES, c, Vb.disabled, y, b, g, t1.id, f.vertexBuffer, f.indexBuffer, f.segments, t1.paint, e1.transform.zoom, void 0, _);
                }
            }
            if (i.children) for (const s of i.children)Ww(e1, t1, s, n, r, o, a);
        }
        function qw(e1, t1, i, n, r) {
            const o = e1.node;
            if (o.lodMeshes && o.lodMeshes.length > 0) {
                if (e1.targetLod < 0) e1.targetLod = t1 > n ? 1 : 0;
                else {
                    const o = r > 0 ? i / 1e3 / r : 1;
                    e1.targetLod = tt(t1 > n ? e1.targetLod + o : e1.targetLod - o, 0, 1);
                }
            } else e1.targetLod = 0;
        }
        function Xw(e1, t1, i, n) {
            if (!i.modelManager) return !0;
            const r = i.modelManager;
            if (!i.shadowRenderer) return !0;
            const o = i.shadowRenderer, a = t1.aabb;
            let s = !0, l = e1.maxHeight;
            if (0 === l) {
                let t1 = 0;
                for(const i in e1.instancesPerModel){
                    const e1 = r.getModel(i, n);
                    e1 ? t1 = Math.max(t1, Math.max(Math.max(e1.aabb.max[0], e1.aabb.max[1]), e1.aabb.max[2])) : s = !1;
                }
                l = e1.maxScale * t1 * 1.41 + e1.maxVerticalOffset, s && (e1.maxHeight = l);
            }
            a.max[2] = l, a.min[2] += e1.terrainElevationMin, a.max[2] += e1.terrainElevationMax, Y(a.min, a.min, t1.tileMatrix), Y(a.max, a.max, t1.tileMatrix);
            const u = a.intersects(o.getCurrentCascadeFrustum());
            return 0 === i.currentShadowCascade && (e1.isInsideFirstShadowMapFrustum = 2 === u), 0 === u;
        }
        function Yw(e1, t1) {
            const i = e1.uniformValues.u_cutoff_params[0], n = e1.uniformValues.u_cutoff_params[1], r = e1.uniformValues.u_cutoff_params[2], o = e1.uniformValues.u_cutoff_params[3];
            return n === i || o === r ? 1 : tt(((t1 - i) / (n - i) - r) / (o - r), 0, 1);
        }
        function Jw(e1, t1, i, n) {
            if (t1.pitch < 20) return 1;
            const r = t1.getWorldToCameraMatrix();
            _(r, r, e1);
            const o = oe(i.min[0], i.min[1], i.min[2], 1);
            let a = le(re(), o, r), s = a, l = a;
            o[1] = i.max[1], a = le(re(), o, r), s = a[1] < s[1] ? a : s, l = a[1] > l[1] ? a : l, o[0] = i.max[0], a = le(re(), o, r), s = a[1] < s[1] ? a : s, l = a[1] > l[1] ? a : l, o[1] = i.min[1], a = le(re(), o, r), s = a[1] < s[1] ? a : s, l = a[1] > l[1] ? a : l;
            const u = tt(n[0], 0, 1), c = 100 * t1.pixelsPerMeter * tt(n[1], 0, 1), h = tt(n[2], 0, 1), d = (m = re(), b = (g = s)[1], w = g[2], E = g[3], m[0] = (v = g[0]) + (x = u) * ((y = l)[0] - v), m[1] = b + x * (y[1] - b), m[2] = w + x * (y[2] - w), m[3] = E + x * (y[3] - E), m), f = Math.tan(.5 * t1.fovX), p = -d[2] * f;
            var m, g, y, x, v, b, w, E;
            if (0 === c) return d[1] < -Math.abs(p) ? h : 1;
            const A = tt(dn(1, h, (-Math.abs(p) - d[1]) / c), h, 1);
            return dn(1, A, tt((t1.pitch - 20) / 20, 0, 1));
        }
        var Kw = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif", Qw = "\n#if defined(VIEWPORT_ORIGIN_TOP_LEFT) || defined(FLIP_Y)\n#define FLIP_VIEWPORT_UV_Y(uv) (uv).y=1.0-(uv).y\n#else\n#define FLIP_VIEWPORT_UV_Y(uv)\n#endif\n#ifdef DUAL_SOURCE_BLENDING\nlayout(location=0,index=0) out vec4 glFragColor;layout(location=0,index=1) out vec4 glFragColorSrc1;\n#elif defined(FLOAT_RENDER_TARGET)\nlayout(location=0) out highp vec4 glFragColor;\n#else\nlayout(location=0) out vec4 glFragColor;\n#endif\n#ifdef USE_MRT1\nlayout(location=1) out vec4 out_Target1;\n#endif\nhighp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {\n#ifdef CLIP_ZERO_TO_ONE\nhighp float depth=ndc_z;\n#else\nhighp float depth=ndc_z*0.5+0.5;\n#endif\nconst highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}const float DITHER_THRESHOLDS[16]=float[16](\n1.0/17.0, 9.0/17.0, 3.0/17.0,11.0/17.0,13.0/17.0, 5.0/17.0,15.0/17.0, 7.0/17.0,4.0/17.0,12.0/17.0, 2.0/17.0,10.0/17.0,16.0/17.0, 8.0/17.0,14.0/17.0, 6.0/17.0\n);int viewport_dither_index(vec2 fragCoordXY) {return (int(fragCoordXY.x) % 4)*4+(int(fragCoordXY.y) % 4);}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif\nvec4 textureLodCustom(sampler2D image,highp vec2 pos,highp vec2 lod_coord) {highp vec2 size=vec2(textureSize(image,0));highp vec2 dx=dFdx(lod_coord.xy*size);highp vec2 dy=dFdy(lod_coord.xy*size);highp float delta_max_sqr=max(dot(dx,dx),dot(dy,dy));highp float lod=0.5*log2(delta_max_sqr);return textureLod(image,pos,lod);}vec4 premultiplyColor(vec3 nonPremultipliedColor,float a) {return vec4(nonPremultipliedColor*a,a);}vec3 unpremultiplyColor(vec4 premultipliedColor) {if (premultipliedColor.a > 0.0) {return premultipliedColor.rgb/premultipliedColor.a;}return premultipliedColor.rgb;}vec3 applyLUT(highp sampler3D lut,vec3 col) {vec3 size=vec3(textureSize(lut,0));vec3 uvw=(col.rbg*float(size-1.0)+0.5)/size;return texture(lut,uvw).rgb;}vec4 applyLUT(highp sampler3D lut,vec4 premultipliedColor) {return premultiplyColor(applyLUT(lut,unpremultiplyColor(premultipliedColor)),premultipliedColor.a);}", eE = "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const vec2 units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (units_to_pixels*pos+offset)/pattern_size;}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {return get_pattern_pos(pixel_coord_upper,pixel_coord_lower,pattern_size,vec2(tile_units_to_pixels),pos);}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(ivec2 posWithComposedSkirt)\n{float skirt=float(float(posWithComposedSkirt.x) >=skirtOffset);vec2 pos=vec2(posWithComposedSkirt)-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}\n#ifndef HAS_SHADER_STORAGE_BLOCK_material_buffer\n#define GET_ATTRIBUTE_float(attrib,matInfo,attrib_id) attrib\n#define GET_ATTRIBUTE_vec4(attrib,matInfo,attrib_id) attrib\n#define GET_ATTRIBUTE_vec2(attrib,matInfo,attrib_id) attrib\n#define DECLARE_MATERIAL_TABLE_INFO\n#endif", tE = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", iE = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;\n#endif\nvec3 elevationVector(vec2 pos) {\n#ifdef PROJECTION_GLOBE_VIEW\nvec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;\n#else\nreturn vec3(0,0,1);\n#endif\n}\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}vec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#endif\nfloat elevation(vec2 apos) {\n#ifdef TERRAIN\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);\n#else\nreturn currentElevation(apos);\n#endif\n#else\nreturn 0.0;\n#endif\n}\n#ifdef DEPTH_OCCLUSION\nuniform highp sampler2D u_depth;uniform highp vec2 u_depth_size_inv;uniform highp vec2 u_depth_range_unpack;uniform highp float u_occluder_half_size;uniform highp float u_occlusion_depth_offset;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}vec4 unpack_depth4(vec4 depth) {return depth*u_depth_range_unpack.x+vec4(u_depth_range_unpack.y);}\n#else\nhighp float unpack_depth_rgba(vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;\n#ifdef CLIP_ZERO_TO_ONE\ncoord.z=-1.0+2.0*coord.z; \n#endif\n#ifdef DEPTH_D24\nfloat depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5).r);\n#else\nfloat depth=unpack_depth_rgba(texture(u_depth,(coord.xy+1.0)*0.5));\n#endif\nreturn coord.z+u_occlusion_depth_offset > depth;}highp vec4 getCornerDepths(vec2 coord) {highp vec3 df=vec3(u_occluder_half_size*u_depth_size_inv,0.0);highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef DEPTH_D24\nhighp vec4 depth=vec4(\ntexture(u_depth,uv-df.xz).r,texture(u_depth,uv+df.xz).r,texture(u_depth,uv-df.zy).r,texture(u_depth,uv+df.zy).r\n);depth=unpack_depth4(depth);\n#else\nhighp vec4 depth=vec4(\nunpack_depth_rgba(texture(u_depth,uv-df.xz)),unpack_depth_rgba(texture(u_depth,uv+df.xz)),unpack_depth_rgba(texture(u_depth,uv-df.zy)),unpack_depth_rgba(texture(u_depth,uv+df.zy))\n);\n#endif\nreturn depth;}highp float occlusionFadeMultiSample(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef CLIP_ZERO_TO_ONE\ncoord.z=-1.0+2.0*coord.z; \n#endif\nint NX=3;int NY=4;highp vec2 df=u_occluder_half_size*u_depth_size_inv;highp vec2 oneStep=2.0*u_occluder_half_size*u_depth_size_inv/vec2(NX-1,NY-1);highp float res=0.0;for (int y=0; y < NY;++y) {for (int x=0; x < NX;++x) {\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)));\n#endif\nres+=1.0-clamp(300.0*(coord.z+u_occlusion_depth_offset-depth),0.0,1.0);}}res=clamp(2.0*res/float(NX*NY)-0.5,0.0,1.0);return res;}highp float occlusionFade(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;\n#ifdef CLIP_ZERO_TO_ONE\ncoord.z=-1.0+2.0*coord.z; \n#endif\nhighp vec4 depth=getCornerDepths(coord.xy);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z+u_occlusion_depth_offset)-depth),0.0,1.0));}\n#else\nbool isOccluded(vec4 frag) { return false; }highp float occlusionFade(vec4 frag) { return 1.0; }highp float occlusionFadeMultiSample(vec4 frag) { return 1.0; }\n#endif", nE = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", rE = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;FLIP_VIEWPORT_UV_Y(uv);highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {return color;}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", oE = "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif", aE = "#ifdef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);ivec4 _raTexLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}vec2 _raTexLinearMix(highp vec2 fxy,highp vec4 colorMix,highp float colorOffset,highp vec4 t00,highp vec4 t10,highp vec4 t01,highp vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image0,c.yz,0),texelFetch(u_image0,c.xz,0),texelFetch(u_image0,c.yw,0),texelFetch(u_image0,c.xw,0)\n);}vec2 raTexture2D_image1_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image1,c.yz,0),texelFetch(u_image1,c.xz,0),texelFetch(u_image1,c.yw,0),texelFetch(u_image1,c.xw,0)\n);}vec2 raTexture2D_image0_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image0,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image1,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif", sE = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {vec3 transformed_normal=vec3(-normal.xy,normal.z);float NDotL=dot(normalize(transformed_normal),u_shadow_direction);float dotScale=min(1.0-NDotL,1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif", lE = "#ifdef RENDER_SHADOWS\nprecision highp sampler2DShadow;uniform sampler2DShadow u_shadowmap_0;uniform sampler2DShadow u_shadowmap_1;uniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;highp vec2 shadow_map_ndc_to_uv(highp vec2 ndc_xy) {\n#ifdef SHADOW_MAP_FLIP_Y\nreturn ndc_xy*vec2(0.5,-0.5)+0.5;\n#else\nreturn ndc_xy*0.5+0.5;\n#endif\n}highp vec3 shadow_map_ndc_to_sample_space(highp vec3 ndc) {\n#ifdef CLIP_ZERO_TO_ONE\nreturn vec3(shadow_map_ndc_to_uv(ndc.xy),ndc.z);\n#else\nreturn vec3(shadow_map_ndc_to_uv(ndc.xy),ndc.z*0.5+0.5);\n#endif\n}float shadow_sample(sampler2DShadow shadowmap,highp vec3 pos,highp float bias) {\n#ifdef CLIP_ZERO_TO_ONE\nhighp vec3 coord=vec3(shadow_map_ndc_to_uv(pos.xy),pos.z-bias);\n#else\nhighp vec3 coord=vec3(shadow_map_ndc_to_uv(pos.xy),pos.z*0.5+0.5-bias);\n#endif\nreturn texture(shadowmap,coord);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {light_view_pos0.xyz/=light_view_pos0.w;\n#ifdef SHADOWS_SINGLE_CASCADE\nvec2 abs_bounds=abs(light_view_pos0.xy);if (abs_bounds.x >=1.0 || abs_bounds.y >=1.0) {return 0.0;}return shadow_sample(u_shadowmap_0,light_view_pos0.xyz,bias);\n#else\nlight_view_pos1.xyz/=light_view_pos1.w;vec4 abs_bounds=abs(vec4(light_view_pos0.xy,light_view_pos1.xy));if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {return shadow_sample(u_shadowmap_0,light_view_pos0.xyz,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}float occlusion1=shadow_sample(u_shadowmap_1,light_view_pos1.xyz,bias);return clamp(mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth)),0.0,1.0);\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_opacity(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,float shadow_opacity) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias)*shadow_opacity;return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}highp vec2 compute_receiver_plane_depth_bias(highp vec3 pos_dx,highp vec3 pos_dy)\n{highp vec2 biasUV=vec2(\npos_dy.y*pos_dx.z-pos_dx.y*pos_dy.z,pos_dx.x*pos_dy.z-pos_dy.x*pos_dx.z);biasUV*=1.0/((pos_dx.x*pos_dy.y)-(pos_dx.y*pos_dy.x));return biasUV;}float shadowed_light_factor_plane_bias(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {highp vec3 light_view_pos0_xyz=shadow_map_ndc_to_sample_space(light_view_pos0.xyz/light_view_pos0.w);highp vec3 light_view_pos0_ddx=dFdx(light_view_pos0_xyz);highp vec3 light_view_pos0_ddy=dFdy(light_view_pos0_xyz);highp vec2 plane_depth_bias=compute_receiver_plane_depth_bias(light_view_pos0_ddx,light_view_pos0_ddy);highp float bias=dot(vec2(u_shadow_texel_size,u_shadow_texel_size),plane_depth_bias)+0.0001;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
        const uE = /^#include\s+"([^"]+)"\s*\r?\n/gm, cE = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g, hE = /\b[A-Za-z_][A-Za-z0-9_]*\b/g, dE = new Set([
            "ifdef",
            "ifndef",
            "elif",
            "if",
            "defined"
        ]), fE = new Set;
        EE(Kw, fE), EE(eE, fE), EE(Qw, fE);
        const pE = {
            "_prelude_fog.vertex.glsl": nE,
            "_prelude_terrain.vertex.glsl": iE,
            "_prelude_shadow.vertex.glsl": sE,
            "_prelude_material_table.vertex.glsl": "#ifdef HAS_SHADER_STORAGE_BLOCK_material_buffer\n#define MATERIAL_TABLE_DEBUG 0\nuniform int u_material_offset;uniform int u_vertex_offset;layout(std140,binding=0)readonly buffer material_buffer{uvec4 material_data[];};struct MaterialInfo{uint dataOffset;\n#if MATERIAL_TABLE_DEBUG\nvec4 colorDebug;\n#endif\n};uint read_buf_no_offset(uint iDword) {return material_data[iDword/4u][iDword % 4u];}uint read_buf(uint iDword) {iDword+=uint(u_material_offset/4);return read_buf_no_offset(iDword);}float read_buf_float(uint iDword){return uintBitsToFloat(read_buf(iDword));}uint read_buf_uint8(uint iDword,uint iUint8){uint dwordOffset=iDword+(iUint8/4u);uint byteOffset=iUint8 & 3u;uint bitOffset=8u*byteOffset;uint mask=0xffu << bitOffset;uint dwordVal=read_buf(dwordOffset);return (dwordVal & mask) >> bitOffset;}uint read_buf_uint16(uint iDword,uint iUint16){uint dwordOffset=iDword+(iUint16 >> 1u);uint bitOffset=(iUint16 & 1u)*16u;uint mask=0xffffu << bitOffset;uint dwordVal=read_buf(dwordOffset);return (dwordVal & mask) >> bitOffset;}uint nrDwordsForVertexIdEntries(uint nrMaterialLookupEntries) {return nrMaterialLookupEntries;}uint nrDwordsForMaterialIdEntries(uint nrMaterialLookupEntries) {return (nrMaterialLookupEntries*2u+3u)/4u;}uint findRangeBinarySearch(uint vertexId,uint numRanges,uint dwordOffset) {uint left=0u;uint right=numRanges-1u;for (uint i=0u; i < 16u; i++) { \nif (left > right) {break;}uint mid=(left+right)/2u;uint start=read_buf(dwordOffset+mid);uint nextStart=(mid+1u < numRanges) ? read_buf(dwordOffset+mid+1u) : 0xffffffffu;if (vertexId >=start && vertexId < nextStart) {return mid;} else if (vertexId < start) {if (mid==0u) {break;}right=mid-1u;} else {left=mid+1u;}}return 0u; \n}uint readVertexId(uint dwordOffset,uint iMaterialLookupEntry) {return read_buf(dwordOffset+iMaterialLookupEntry);}uint findRange(uint vertexId,uint numRanges,uint dwordOffset) {uint iRange;if(numRanges <=64u){uint vertexBegin;for(iRange=0u; iRange < numRanges;++iRange) {vertexBegin=readVertexId(dwordOffset,iRange);if(vertexBegin > vertexId) {break;}}iRange=iRange==0u? 0u : iRange-1u;} else { \niRange=findRangeBinarySearch(vertexId,numRanges,dwordOffset);}return iRange;}MaterialInfo read_material_info(uint vertex_id) {MaterialInfo info;\n#if MATERIAL_TABLE_DEBUG\nconst vec4 red=vec4(1.0,0.0,0.0,1.0);const vec4 orange=vec4(1.0,0.5,0.0,1.0);const vec4 yellow=vec4(1.0,1.0,0.0,1.0);const vec4 green=vec4(0.0,1.0,0.0,1.0);const vec4 indigo=vec4(0.294,0.0,0.510,1.0);const vec4 blue=vec4(0.0,0.0,1.0,1.0);const vec4 purple=vec4(0.5,0.0,0.5,1.0);const vec4 pink=vec4(1.0,0.0,1.0,1.0);info.colorDebug=green;\n#endif\nuint offset=0u;\n#if MATERIAL_TABLE_DEBUG\nbool keepFinding=true;uint magic=read_buf(offset);if(magic !=0xCAFEBABEu) {info.colorDebug=red;keepFinding=false;return info;}\n#endif\noffset++;\n#if MATERIAL_TABLE_DEBUG\nuint nrMaterials=read_buf(offset);uint nrVertices=read_buf(offset+1u);if(keepFinding && vertex_id >=nrVertices) {info.colorDebug=red;keepFinding=false;}\n#endif\noffset+=2u;uint nrMaterialLookupEntries=read_buf(offset++);uint perMaterialEntrySizeDwords=read_buf(offset++);\n#if MATERIAL_TABLE_DEBUG\nif(keepFinding && perMaterialEntrySizeDwords !=1u) {info.colorDebug=red;keepFinding=false;}\n#endif\nuint iMaterialLookup=findRange(vertex_id,nrMaterialLookupEntries,offset);\n#if MATERIAL_TABLE_DEBUG\nif(keepFinding)\n{uint vertexBeginCheck=readVertexId(offset,iMaterialLookup);if(vertexBeginCheck > vertex_id) {info.colorDebug=red;keepFinding=false;}if(iMaterialLookup < nrMaterialLookupEntries-1u) {uint vertexEndCheck=readVertexId(offset,iMaterialLookup+1u);if(vertexEndCheck <=vertex_id) {info.colorDebug=red;keepFinding=false;}}}\n#endif\noffset+=nrDwordsForVertexIdEntries(nrMaterialLookupEntries);uint materialId=iMaterialLookup;\n#if MATERIAL_TABLE_DEBUG\nif(keepFinding) {if(materialId >=nrMaterialLookupEntries) {info.colorDebug=red;}}\n#endif\ninfo.dataOffset=offset+materialId*perMaterialEntrySizeDwords;return info;}uint get_data_location(const MaterialInfo matInfo,uint attribOffsetBytes)\n{uint attribFieldOffsetDwords=attribOffsetBytes/4u;return matInfo.dataOffset+attribFieldOffsetDwords;}vec4 read_material_vec4(const MaterialInfo matInfo,uint attribOffsetBytes){uint loc=get_data_location(matInfo,attribOffsetBytes);return vec4(read_buf_float(loc),read_buf_float(loc+1u),read_buf_float(loc+2u),read_buf_float(loc+3u));}vec2 read_material_vec2(const MaterialInfo matInfo,uint attribOffsetBytes){uint loc=get_data_location(matInfo,attribOffsetBytes);return vec2(read_buf_float(loc),read_buf_float(loc+1u));}float read_material_float(const MaterialInfo matInfo,uint attribOffsetBytes){uint loc=get_data_location(matInfo,attribOffsetBytes);return read_buf_float(loc);}\n#define GET_ATTRIBUTE_float(attrib,matInfo,attrib_offset) read_material_float(matInfo,attrib_offset)\n#define GET_ATTRIBUTE_vec4(attrib,matInfo,attrib_offset) read_material_vec4(matInfo,attrib_offset)\n#define GET_ATTRIBUTE_vec2(attrib,matInfo,attrib_offset) read_material_vec2(matInfo,attrib_offset)\n#define DECLARE_MATERIAL_TABLE_INFO MaterialInfo materialInfo=read_material_info(uint(gl_VertexID));\n#define DECLARE_MATERIAL_TABLE_INFO_DEBUG(dbgColor) MaterialInfo materialInfo=read_material_info(uint(gl_VertexID)); dbgColor=materialInfo.colorDebug;\n#endif",
            "_prelude_fog.fragment.glsl": rE,
            "_prelude_shadow.fragment.glsl": lE,
            "_prelude_lighting.glsl": oE,
            "_prelude_raster_array.glsl": aE,
            "_prelude_indicator_cutout.fragment.glsl": "\n#ifdef INDICATOR_CUTOUT\nuniform vec3 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;\n#endif\nvec4 applyCutout(vec4 color,float height) {\n#ifdef INDICATOR_CUTOUT\nfloat verticalFadeRange=u_indicator_cutout_centers.z*0.25;float holeMinOpacity=mix(1.0,u_indicator_cutout_params.x,smoothstep(u_indicator_cutout_centers.z,u_indicator_cutout_centers.z+verticalFadeRange,height));float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);\n#else\nreturn color;\n#endif\n}float cutoutGroundRoofOpacity(vec4 groundRoof) {\n#ifdef INDICATOR_CUTOUT\nfloat fadeStartX=u_indicator_cutout_params.w;float holeRadius=u_indicator_cutout_params.y;float holeMinOpacity=mix(u_indicator_cutout_params.x,1.0,smoothstep(u_indicator_cutout_params.z,u_indicator_cutout_centers.z,groundRoof.y));float distX=abs(u_indicator_cutout_centers.x-groundRoof.x);float roofOpacity=mix(holeMinOpacity,1.0,smoothstep(fadeStartX,holeRadius,u_indicator_cutout_centers.y-groundRoof.w));float groundOpacity=min(smoothstep(fadeStartX,holeRadius,distX)+holeMinOpacity,1.0);return max(roofOpacity,groundOpacity);\n#else\nreturn 1.0;\n#endif\n}",
            "_prelude_feature_cutout.fragment.glsl": "// feature cutout (gl-native only)\n",
            "_prelude_feature_cutout.vertex.glsl": "// feature cutout (gl-native only)\n"
        }, _E = {}, mE = "precision highp float;", gE = "precision mediump float;", yE = "\n#if defined(GL_EXT_blend_func_extended) && defined(DUAL_SOURCE_BLENDING)\n#extension GL_EXT_blend_func_extended : require\n#endif", xE = {
            preludeTerrain: IE("", iE),
            preludeFog: IE(rE, nE),
            preludeShadow: IE(lE, sE),
            preludeRasterArray: IE(aE, ""),
            preludeLighting: IE(oE, oE),
            preludePrecisionQualifiers: IE(gE, mE),
            prelude: IE(Qw, eE),
            preludeExtensions: IE(yE, "")
        }, vE = [
            yE,
            gE,
            Kw,
            xE.prelude.fragmentSource
        ].join("\n"), bE = [
            mE,
            Kw,
            xE.prelude.vertexSource
        ].join("\n");
        var wE = {
            background: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nuniform vec4 u_color;uniform float u_opacity;uniform mediump float u_emissive_strength;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef FEATURE_CUTOUT\nvec2 uv=fragcoord_to_viewport_uv(gl_FragCoord.xy,u_inv_viewport_size.xy);float factorTex=min(texture(u_cutout_factor_image,uv).r,1.0);float cutoutFactor=(1.0-u_feature_cutout_params.x)*factorTex;out_color=u_color*(1.0-cutoutFactor);\n#else\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin ivec2 a_pos;uniform mat4 u_matrix;uniform mediump float u_emissive_strength;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifndef FEATURE_CUTOUT\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n#endif\n}'),
            backgroundPattern: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in highp vec2 v_pos;void main() {highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=textureLodCustom(u_image,pos,v_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec2 u_pattern_units_to_pixels;in ivec2 a_pos;out highp vec2 v_pos;void main() {vec2 pos=vec2(a_pos);gl_Position=u_matrix*vec4(pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_pattern_units_to_pixels,pos);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            circle: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float blur_positive=blur < 0.0 ? 0.0 : 1.0;lowp float antialiasblur=v_data.z;float extrude_length=length(extrude)+antialiasblur*(1.0-blur_positive);float antialiased_blur=-max(abs(blur),antialiasblur);float antialiase_blur_opacity=smoothstep(0.0,antialiasblur,extrude_length-1.0);float opacity_t=blur_positive==1.0 ? \nsmoothstep(0.0,-antialiased_blur,1.0-extrude_length) : \nsmoothstep(antialiased_blur,0.0,extrude_length-1.0)-antialiase_blur_opacity;float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in ivec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;in ivec4 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\n#ifdef ELEVATED_ROADS\nin float a_circle_z_offset;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1.0,-1.0),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1.0,-1.0),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1.0,1.0),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1.0,1.0),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 pos2=vec2(a_pos);vec2 extrude=vec2(mod(pos2,2.0)*2.0-1.0);vec2 circle_center=floor(pos2*0.5);float height=circle_elevation(circle_center);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nsurface_vectors=globe_mercator_surface_vectors(vec3(a_pos_normal_3)/16384.0,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*height;vec3 globe_pos=vec3(a_pos_3)+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*height;vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);world_center=vec4(circle_center,height,1);\n#endif\n#ifdef ELEVATED_ROADS\nworld_center.z+=a_circle_z_offset+ELEVATION_BIAS;\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'),
            clippingMask: IE("void main() {glFragColor=vec4(1.0);}", "in ivec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: IE('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_intensity;in ivec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;in ivec4 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(vec2(a_pos),2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(vec2(a_pos)*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=vec3(a_pos_normal_3)/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=vec3(a_pos_3)+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            heatmapTexture: IE("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in ivec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=vec2(a_pos)*0.5+0.5;}"),
            collisionBox: IE("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin ivec4 a_pos;in ivec2 a_anchor_pos;in ivec2 a_extrude;in uvec2 a_placed;in vec2 a_shift;in vec2 a_elevation_from_sea;in float a_size_scale;in vec2 a_padding;in float a_auto_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform float u_zoom_transition;\n#endif\nout float v_placed;out float v_notUsed;void main() {vec2 anchor_pos=vec2(a_anchor_pos);float feature_elevation=a_elevation_from_sea.x+a_auto_z_offset;float terrain_elevation=(a_elevation_from_sea.y==1.0 ? 0.0 : elevation(anchor_pos));vec3 proj_pos=vec3(a_pos)+elevationVector(anchor_pos)*(feature_elevation+terrain_elevation);\n#ifdef PROJECTION_GLOBE_VIEW\n#ifndef PROJECTED_POS_ON_VIEWPORT\nvec3 globe_pos=proj_pos;vec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,anchor_pos,u_tile_id,u_merc_center);proj_pos=mix_globe_mercator(globe_pos,mercator_pos,u_zoom_transition);\n#endif\n#endif\nvec4 projectedPoint=u_matrix*vec4(proj_pos,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(vec2(a_extrude)*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=float(a_placed.x);v_notUsed=float(a_placed.y);}'),
            collisionCircle: IE("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in ivec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;int vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2)),mix(-1.0,1.0,float(vertexIdx >=1 && vertexIdx <=2)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=float(a_flags.x);gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: IE("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin ivec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {vec2 pos=vec2(a_pos);float h=elevation(pos);v_uv=pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(vec3(a_pos_3)+elevationVector(pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(pos*u_overlay_scale,h,1);\n#endif\n}'),
            fill: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;uniform lowp float u_opacity_multiplier;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(opacity*u_opacity_multiplier);\n#ifdef INDICATOR_CUTOUT\nif (v_z_offset >=0.0) {out_color=applyCutout(out_color,v_z_offset);}\n#endif\n#ifdef FEATURE_CUTOUT\nfloat z=0.0;\n#ifdef ELEVATED_ROADS\nz=v_road_z_offset;\n#endif\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x,z);\n#endif\nglFragColor=out_color;\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin ivec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform mat4 u_matrix;uniform lowp float u_opacity_multiplier;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=z_offset;\n#endif\n}'),
            fillOutline: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nin highp vec2 v_pos;uniform float u_emissive_strength;uniform lowp float u_opacity_multiplier;\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;vec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef FEATURE_CUTOUT\nfloat z=0.0;\n#ifdef ELEVATED_ROADS\nz=v_road_z_offset;\n#endif\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x,z);\n#endif\nglFragColor=out_color*(alpha*opacity*u_opacity_multiplier);\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin ivec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nuniform mat4 u_matrix;uniform vec2 u_world;uniform lowp float u_opacity_multiplier;out highp vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);\n#ifdef FLIP_Y\nv_pos=(vec2(gl_Position.x,-gl_Position.y)/gl_Position.w+1.0)/2.0*u_world;\n#else\nv_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#endif\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n}'),
            fillOutlinePattern: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nuniform float u_emissive_strength;uniform lowp float u_opacity_multiplier;\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\nin highp vec2 v_pos;in highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef FILL_PATTERN_TRANSITION\nvec2 pattern_b_tl=vec2(pattern_b.xy);vec2 pattern_b_br=vec2(pattern_b.zw);highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\nvec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FEATURE_CUTOUT\nfloat z=0.0;\n#ifdef ELEVATED_ROADS\nz=v_road_z_offset;\n#endif\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x,z);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity*u_opacity_multiplier);\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform lowp float u_opacity_multiplier;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in ivec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;out highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);vec2 pos=vec2(a_pos);gl_Position=mix(u_matrix*vec4(pos,z_offset,1),AWAY,hidden);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);\n#ifdef FLIP_Y\nv_pos_world=(vec2(gl_Position.x,-gl_Position.y)/gl_Position.w+1.0)/2.0*u_world;\n#else\nv_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#endif\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(pos,z_offset);vec3 shd_pos1=vec3(pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            fillPattern: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nin highp vec2 v_pos;uniform float u_emissive_strength;uniform lowp float u_opacity_multiplier;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef FILL_PATTERN_TRANSITION\nvec2 pattern_b_tl=vec2(pattern_b.xy);vec2 pattern_b_br=vec2(pattern_b.zw);highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\nvec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FEATURE_CUTOUT\nfloat z=0.0;\n#ifdef ELEVATED_ROADS\nz=v_road_z_offset;\n#endif\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x,z);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(opacity*u_opacity_multiplier);\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform lowp float u_opacity_multiplier;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in ivec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump uvec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);vec2 pos=vec2(a_pos);gl_Position=mix(u_matrix*vec4(pos,z_offset,1),AWAY,hidden);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(pos,z_offset);vec3 shd_pos1=vec3(pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            lineBlendComposite: IE("uniform highp sampler2D u_image;uniform float u_opacity;uniform int u_blend_mode;uniform highp float u_max_density;in vec2 v_pos;\n#define ADDITIVE 1\nvoid main() {vec4 color=texture(u_image,v_pos);if (u_blend_mode==ADDITIVE) {if (color.a <=0.0) {discard;}highp float density=color.a;vec3 avgColor=color.rgb/max(density,0.001);highp float n=density/max(u_max_density,0.001);highp float t=sqrt(n/(n+1.0));glFragColor=vec4(avgColor*t,t);} else {vec3 multiplyFactor=color.rgb*u_opacity+(1.0-u_opacity);glFragColor=vec4(multiplyFactor,1.0);}\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in ivec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=vec2(a_pos)*0.5+0.5;}"),
            lineBlendReduce: IE("uniform highp sampler2D u_image;uniform vec2 u_texel_size;uniform bool u_first_pass;in vec2 v_pos;void main() {vec2 o=u_texel_size*0.5;vec4 s0=texture(u_image,v_pos+vec2(-o.x,-o.y));vec4 s1=texture(u_image,v_pos+vec2( o.x,-o.y));vec4 s2=texture(u_image,v_pos+vec2(-o.x, o.y));vec4 s3=texture(u_image,v_pos+vec2( o.x, o.y));float r0; float g0;float r1; float g1;float r2; float g2;float r3; float g3;if (u_first_pass) {float a0=s0.a;float a1=s1.a;float a2=s2.a;float a3=s3.a;r0=a0; g0=a0 > 0.0 ? 1.0 : 0.0;r1=a1; g1=a1 > 0.0 ? 1.0 : 0.0;r2=a2; g2=a2 > 0.0 ? 1.0 : 0.0;r3=a3; g3=a3 > 0.0 ? 1.0 : 0.0;} else {r0=s0.r; g0=s0.g;r1=s1.r; g1=s1.g;r2=s2.r; g2=s2.g;r3=s3.r; g3=s3.g;}glFragColor=vec4((r0+r1+r2+r3)*0.25,(g0+g1+g2+g3)*0.25,0.0,0.0);}", "in ivec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=vec2(a_pos)*0.5+0.5;}"),
            fillExtrusion: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nin vec4 v_color;in vec4 v_flat;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\nuniform lowp float u_opacity;\n#ifdef RENDER_FRONT_CUTOFF\nin float v_front_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\nin vec4 v_ground_roof;\n#endif\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nin float v_height;\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float emissive_strength\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor;\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\ncolor.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\n{float ditherOpacity=cutoutGroundRoofOpacity(v_ground_roof);if (ditherOpacity < 1.0) {int index=viewport_dither_index(gl_FragCoord.xy);if (ditherOpacity < DITHER_THRESHOLDS[index]) {discard;}}}\n#else\ncolor=applyCutout(color,h);\n#endif\n#endif\n#ifdef RENDER_FRONT_CUTOFF\nif (v_front_cutoff_opacity < 1.0) {int index=viewport_dither_index(gl_FragCoord.xy);if (v_front_cutoff_opacity < DITHER_THRESHOLDS[index]) {discard;}}\n#endif\n#ifdef FEATURE_CUTOUT\ncolor=apply_feature_cutout(color,gl_FragCoord,get_cutout_factors(gl_FragCoord).x,0.0);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_material_table.vertex.glsl"\nuniform mat4 u_matrix;\n#ifndef LIGHTING_3D_MODE\nuniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;\n#endif\nuniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;uniform float u_width_scale;in ivec4 a_pos_normal_ed;\n#if defined(HAS_CENTROID) || defined(TERRAIN)\nin uvec2 a_centroid_pos;\n#endif\n#ifdef RENDER_WALL_MODE\nin ivec4 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;in ivec4 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nuniform highp float u_vertical_scale;\n#ifdef RENDER_FRONT_CUTOFF\nuniform vec3 u_front_cutoff_params;out float v_front_cutoff_opacity;\n#endif\nout vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\nout vec4 v_ground_roof;\n#endif\n#endif\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp float emissive_strength\nvoid main() {DECLARE_MATERIAL_TABLE_INFO\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp float emissive_strength\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 top_up_ny_start=vec4(a_pos_normal_ed & 1);vec4 pos_nx=vec4(a_pos_normal_ed >> 1);float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny_start.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny_start.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);float attr_height=height;height=max(0.0,top_up_ny_start.y==0.0 && top_up_ny_start.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny_start.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=vec2(a_centroid_pos);\n#endif\nfloat ele=0.0;float h=0.0;float c_ele=0.0;vec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);bool is_elevation_encoded=centroid_pos.y==0.0 || (centroid_pos.y > 0.0 && (int(centroid_pos.y) & 7)==7);c_ele=is_flat_height || is_flat_base ? (is_elevation_encoded ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;\n#else\nh=t > 0.0 ? height : base;\n#endif\npos=vec3(pos_nx.xy,h);\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(vec3(a_pos_normal_3)/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=vec3(a_pos_3)+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat cutoff=1.0;vec3 scaled_pos=pos;\n#if defined(RENDER_CUTOFF) || defined(RENDER_FRONT_CUTOFF)\nvec2 centroid_decoded=pos.xy;bool isBorderCentroid=false;if (centroid_pos.x > 0.0 && centroid_pos.y > 0.0) {int iy=int(centroid_pos.y);int spanYbits=iy & 7;if (spanYbits==7) {isBorderCentroid=true;int borderID=(iy >> 3) & 3;float coordAlongBorder=float(iy >> 5)*4.0;if (borderID==0) centroid_decoded=vec2(0.0,coordAlongBorder);else if (borderID==1) centroid_decoded=vec2(EXTENT,coordAlongBorder);else if (borderID==2) centroid_decoded=vec2(coordAlongBorder,0.0);else centroid_decoded=vec2(coordAlongBorder,EXTENT);} else {centroid_decoded=floor(centroid_pos/8.0);}}\n#endif\n#if defined(RENDER_CUTOFF) || defined(RENDER_FRONT_CUTOFF)\nvec4 ground=u_matrix*vec4(centroid_decoded,ele,1.0);\n#endif\n#ifdef RENDER_CUTOFF\n#ifdef CLIP_ZERO_TO_ONE\ncutoff=cutoff_opacity(u_cutoff_params,ground.z*2.0-ground.w);\n#else\ncutoff=cutoff_opacity(u_cutoff_params,ground.z);\n#endif\nif (centroid_pos.y !=0.0 && centroid_pos.x !=0.0) {vec3 centroid_random=vec3(centroid_pos.xy,centroid_pos.x+centroid_pos.y+1.0);vec3 ground_pos=centroid_random/8.0;vec3 g=floor(ground_pos);vec3 mod_=centroid_random-g*8.0;float seed=min(1.0,0.1*(min(3.5,max(mod_.x+mod_.y,0.2*attr_height))*0.35+mod_.z));if (cutoff < 0.8-seed) {cutoff=0.0;}}float cutoff_scale=cutoff;v_cutoff_opacity=cutoff;scaled_pos.z=mix(c_ele,h,cutoff_scale);\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (cutoff==0.0 && centroid_pos.x !=0.0) || (color.a==0.0));\n#ifdef RENDER_FRONT_CUTOFF\nv_front_cutoff_opacity=1.0;if (centroid_pos.x > 0.0 && centroid_pos.y > 0.0) {hidden=max(hidden,float(ground.w <=0.0));float ndc_y=ground.y/max(ground.w,0.001);float threshold=u_front_cutoff_params.x*2.0-1.0;float range_ndc=u_front_cutoff_params.y*2.0;if (!isBorderCentroid) {hidden=max(hidden,float(ndc_y < threshold-range_ndc));}float t=clamp((ndc_y-(threshold-range_ndc))/max(range_ndc,0.001),0.0,1.0);v_front_cutoff_opacity=mix(u_front_cutoff_params.z,1.0,t);}\n#endif\n#ifdef RENDER_WALL_MODE\nvec3 join_normal_inside=vec3(a_join_normal_inside);vec2 wall_offset=u_width_scale*line_width*(join_normal_inside.xy/EXTENT);scaled_pos.xy+=(1.0-join_normal_inside.z)*wall_offset*0.5;scaled_pos.xy-=join_normal_inside.z*wall_offset*0.5;\n#endif\ngl_Position=mix(u_matrix*vec4(scaled_pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny_start.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny_start.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);float ndotl=calculate_NdotL(normal);v_flat.rgb=sRGBToLinear(color.rgb);v_flat.rgb=v_flat.rgb*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);v_flat=vec4(linearTosRGB(v_flat.rgb),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\nvec4 pos_ground=u_matrix*vec4(pos.xy,ele,1.0);vec4 pos_roof=u_matrix*vec4(pos.xy,ele+height,1.0);v_ground_roof=vec4(pos_ground.xy/pos_ground.w,pos_roof.xy/pos_roof.w);\n#endif\n#endif\n}'),
            fillExtrusionPattern: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\nin highp vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump uvec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\nvec2 pattern_b_tl=vec2(pattern_b.xy);vec2 pattern_b_br=vec2(pattern_b.zw);highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,height);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_material_table.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_width_scale;\n#ifndef LIGHTING_3D_MODE\nuniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;\n#endif\nin ivec4 a_pos_normal_ed;\n#if defined(HAS_CENTROID) || defined(TERRAIN)\nin uvec2 a_centroid_pos;\n#endif\n#ifdef RENDER_WALL_MODE\nin ivec4 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;in ivec4 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nout highp vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump uvec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define highp float pixel_ratio\n#pragma mapbox: define highp float line_width\nvoid main() {DECLARE_MATERIAL_TABLE_INFO\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize highp float pixel_ratio\n#pragma mapbox: initialize highp float line_width\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);vec4 top_up_ny_start=vec4(a_pos_normal_ed & 1);vec4 pos_nx=vec4(a_pos_normal_ed >> 1);float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny_start.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny_start.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=float(a_pos_normal_ed.w);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny_start.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=vec2(a_centroid_pos);\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);bool is_elevation_encoded=centroid_pos.y==0.0 || (centroid_pos.y > 0.0 && int(centroid_pos.y)-(int(centroid_pos.y)/8)*8==7);c_ele=is_flat_height || is_flat_base ? (is_elevation_encoded ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(vec3(a_pos_normal_3)/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=vec3(a_pos_3)+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\n#ifdef RENDER_WALL_MODE\nvec3 join_normal_inside=vec3(a_join_normal_inside);vec2 wall_offset=u_width_scale*line_width*(join_normal_inside.xy/EXTENT);p.xy+=(1.0-join_normal_inside.z)*wall_offset*0.5;p.xy-=join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny_start.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'),
            hillshadePrepare: IE("precision highp float;uniform highp sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in ivec2 a_pos;in uvec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(vec2(a_texture_pos)/8192.0)*scale+epsilon;}"),
            hillshade: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in ivec2 a_pos;in uvec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=vec2(a_texture_pos)/8192.0;\n#ifdef VIEWPORT_ORIGIN_TOP_LEFT\nv_pos.y=1.0-v_pos.y;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n}'),
            line: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nuniform lowp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform float u_alpha_discard_threshold;uniform lowp float u_opacity_multiplier;uniform bool u_clip_to_tile_borders;in vec4 v_width2_dilute;in vec2 v_normal;in float v_gamma_scale;in vec2 v_tile_pos;\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef VARIABLE_LINE_WIDTH\nin float stub_side;\n#endif\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;uniform highp float u_floor_width_scale;in vec2 v_tex;\n#endif\n#ifdef DEBUG_ELEVATION_ID\nin vec3 v_elevation_id_col;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nin highp vec3 v_uv;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\n#ifdef RENDER_LINE_BORDER_GRADIENT\nuniform sampler2D u_border_gradient_image;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nuniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform highp vec2 u_trim_gradient_mix_range;uniform lowp vec4 u_trim_color;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform bool u_emissive_in_shadows;uniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump uvec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float side_z_offset\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\n#pragma mapbox: define lowp float emissive_strength\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump uvec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float side_z_offset\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\n#pragma mapbox: initialize lowp float emissive_strength\nfloat dist=length(v_normal)*v_width2_dilute.x;float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;\n#ifdef RENDER_LINE_BORDER\n#ifndef VARIABLE_LINE_WIDTH\nANTIALIASING*=8.0;\n#endif\n#endif\n#ifdef VARIABLE_LINE_WIDTH\nblur=mix(blur,0.0,stub_side);\n#endif\nfloat diluted_opacity=opacity*v_width2_dilute.z;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2_dilute.y-blur2),v_width2_dilute.x-dist)/blur2,0.0,1.0);float pxStep;float delta;\n#ifdef RENDER_LINE_BORDER\n#ifndef VARIABLE_LINE_WIDTH\npxStep=fwidth(dist);float out_edge=v_width2_dilute.x-dist;float in_edge=dist-(v_width2_dilute.y-2.0*ANTIALIASING);delta=v_width2_dilute.y > 0.0 ? min(in_edge,out_edge) : out_edge;float edge=ANTIALIASING;alpha=delta > 0.0 ? smoothstep(edge-pxStep,u_width_scale*blur+edge+pxStep,delta) : 0.0;\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture(u_dash_image,v_tex).r;float sdfgamma=ANTIALIASING/(float(dash.z)+float(dash.w)/65535.0);float scaled_floorwidth=(floorwidth*u_floor_width_scale);alpha*=linearstep(0.5-sdfgamma/scaled_floorwidth,0.5+sdfgamma/scaled_floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trim_alpha=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);highp float gradient_trim_color_mix_factor=0.0;\n#ifdef RENDER_LINE_GRADIENT\ngradient_trim_color_mix_factor=smoothstep(u_trim_gradient_mix_range.x,u_trim_gradient_mix_range.y,line_progress);\n#endif\nhighp vec4 trim_color=mix(u_trim_color,out_color,gradient_trim_color_mix_factor);out_color=mix(u_trim_gradient_mix_range.x < 1.0 ? color : out_color,trim_color,transition_factor);trim_alpha=1.0-transition_factor;}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef RENDER_LINE_BORDER\n#ifndef VARIABLE_LINE_WIDTH\nfloat edge2=border_width*u_width_scale+ANTIALIASING;float alpha2=smoothstep(edge2-pxStep,edge2+pxStep,delta);if (alpha2 < 1.) {\n#ifdef RENDER_LINE_BORDER_GRADIENT\nvec4 border_gradient_color=texture(u_border_gradient_image,v_uv.xy);out_color=mix(border_gradient_color*trim_alpha,out_color,alpha2);\n#else\nif (border_color.a==0.0) {\n#ifndef RENDER_LINE_GRADIENT\nfloat Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-alpha2));} else {out_color.rgb*=(0.6+0.4*alpha2);}\n#else\nout_color.rgb*=(0.6+0.4*alpha2);\n#endif\n} else {out_color=mix(border_color*trim_alpha,out_color,alpha2);}\n#endif\nout_color*=v_width2_dilute.w;}\n#endif\n#endif\nvec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);light=u_emissive_in_shadows ? mix(light,1.0,emissive_strength) : light;\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*diluted_opacity*u_opacity_multiplier);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_z_offset);\n#endif\n#ifdef FEATURE_CUTOUT\nfloat z=0.0;\n#ifdef ELEVATED_ROADS\nz=v_road_z_offset;\n#endif\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x,z);\n#endif\n#ifdef LINE_BLEND_ADDITIVE\n{float cov=alpha*diluted_opacity;glFragColor=vec4(cov > 0.0 ? out_color.rgb/cov : vec3(0.0),cov);}\n#else\n#ifdef LINE_BLEND_MULTIPLY\nglFragColor=vec4(out_color.rgb+(1.0-out_color.a),1.0);\n#else\nglFragColor=out_color;\n#endif\n#endif\n#ifdef DUAL_SOURCE_BLENDING\nglFragColorSrc1=vec4(vec3(0.0),emissive_strength);\n#else\n#ifdef USE_MRT1\nout_Target1=vec4(emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n#ifdef DEBUG_ELEVATION_ID\nglFragColor=vec4(v_elevation_id_col,1.0);\n#endif\nif (u_clip_to_tile_borders) {if (v_tile_pos.x > 1.0 || v_tile_pos.y > 1.0 || v_tile_pos.x < 0.0 || v_tile_pos.y < 0.0) {discard;}}HANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin ivec2 a_pos_normal;in uvec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS) || defined(VARIABLE_LINE_WIDTH) || defined(VARIABLE_LINE_EMISSIVE_STRENGTH)\nin vec4 a_z_offset_width;\n#endif\n#ifdef DEBUG_ELEVATION_ID\nin vec3 a_elevation_id_col;\n#endif\n#ifdef DEBUG_ELEVATION_ID\nout vec3 v_elevation_id_col;\n#endif\n#ifdef ELEVATION_GROUND_SCALE\nin float a_elevation_ground_scale;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET) || defined(RENDER_LINE_CURVE)\nin highp vec3 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nin float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;uniform float u_width_scale;uniform float u_z_offset;uniform highp float u_road_view_depth_bias;uniform highp vec4 u_road_clip_to_view;\n#ifdef RENDER_LINE_CURVE\nuniform mat3 u_curve_points_x;uniform mat3 u_curve_points_y;uniform mat3 u_curve_points_z;uniform float u_curve_point_count;\n#endif\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec4 v_width2_dilute;out float v_gamma_scale;out vec2 v_tile_pos;\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef VARIABLE_LINE_WIDTH\nout float stub_side;\n#endif\n#ifdef RENDER_LINE_DASH\nuniform highp float u_floor_width_scale;uniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nout highp vec3 v_uv;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT)\nuniform float u_image_height;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump uvec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float side_z_offset\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\n#pragma mapbox: define lowp float emissive_strength\n#ifdef RENDER_LINE_CURVE\nvec3 getCurvePoint(int index) {int row=index/3;int col=index-row*3;float x=u_curve_points_x[row][col];float y=u_curve_points_y[row][col];float z=u_curve_points_z[row][col];return vec3(x,y,z);}vec3 catmullRom(vec3 p0,vec3 p1,vec3 p2,vec3 p3,float t) {float t2=t*t;float t3=t2*t;return 0.5*(\n2.0*p1+(-p0+p2)*t+(2.0*p0-5.0*p1+4.0*p2-p3)*t2+(-p0+3.0*p1-3.0*p2+p3)*t3\n);}vec2 catmullRomTangent(vec2 p0,vec2 p1,vec2 p2,vec2 p3,float t) {float t2=t*t;return 0.5*(\n(-p0+p2)+(2.0*p0-5.0*p1+4.0*p2-p3)*2.0*t+(-p0+3.0*p1-3.0*p2+p3)*3.0*t2\n);}struct CurveResult {vec3 point;vec2 tangent;};CurveResult calculateCurve(float line_progress) {float curve_progress=line_progress*(u_curve_point_count-1.0);float curve_progress_local=fract(curve_progress);float curve_segment=floor(curve_progress);int seg=int(curve_segment);vec3 p1=getCurvePoint(seg);vec3 p2=getCurvePoint(seg+1);float is_first_seg=step(curve_segment,0.5);vec3 p0_extrapolated=p1-(p2-p1);vec3 p0_fetched=getCurvePoint(max(seg-1,0));vec3 p0=mix(p0_fetched,p0_extrapolated,is_first_seg);int last_seg=int(u_curve_point_count)-2;float is_last_seg=step(float(last_seg)-0.5,curve_segment);vec3 p3_extrapolated=p2+(p2-p1);vec3 p3_fetched=getCurvePoint(min(seg+2,int(u_curve_point_count)-1));vec3 p3=mix(p3_fetched,p3_extrapolated,is_last_seg);vec3 point=catmullRom(p0,p1,p2,p3,curve_progress_local);vec2 tangent=catmullRomTangent(p0.xy,p1.xy,p2.xy,p3.xy,curve_progress_local)*(u_curve_point_count-1.0);CurveResult result;result.point=point;result.tangent=tangent;return result;}\n#endif\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump uvec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float side_z_offset\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\n#pragma mapbox: initialize lowp float emissive_strength\n#ifdef VARIABLE_LINE_EMISSIVE_STRENGTH\nemissive_strength=a_z_offset_width.w;\n#endif\nfloat a_z_offset=u_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset+=a_z_offset_width.x;\n#endif\n#ifdef DEBUG_ELEVATION_ID\nv_elevation_id_col=a_elevation_id_col;\n#endif\nhighp float line_progress=0.0;\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET) || defined(RENDER_LINE_CURVE)\nline_progress=a_packed[2];\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;\n#ifdef RENDER_LINE_BORDER\n#ifndef VARIABLE_LINE_WIDTH\nANTIALIASING*=8.0;\n#endif\n#endif\nvec2 a_extrude=vec2(a_data.xy)-128.0;float a_direction=float(a_data.z & 3u)-1.0;vec2 pos_normal=vec2(a_pos_normal);vec2 pos=floor(pos_normal*0.5);mediump vec2 normal=pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;offset=-1.0*offset*u_width_scale;bool left=normal.y==1.0;\n#ifdef RENDER_LINE_CURVE\nCurveResult curve=calculateCurve(line_progress);pos=curve.point.xy*8192.0;a_extrude=length(a_extrude)*normalize(curve.tangent);a_extrude=left ? vec2(-a_extrude.y,a_extrude.x) : vec2(a_extrude.y,-a_extrude.x);a_z_offset+=curve.point.z;\n#endif\ngapwidth=gapwidth/2.0;float halfwidth;float dilute_scale=1.0;float dilute_border_scale=1.0;float symmetric_outset=0.0;\n#ifdef VARIABLE_LINE_WIDTH\nfloat left_width=a_z_offset_width.y;float right_width=a_z_offset_width.z;halfwidth=u_width_scale*(left ? left_width : right_width);if (side_z_offset !=0.0) {float left_f=step(1.0,normal.y);float is_negative=step(side_z_offset,0.0);float apply=mix(1.0-left_f,left_f,is_negative);a_extrude*=apply;a_z_offset+=abs(side_z_offset)*apply;v_normal*=apply;}offset=border_width > 0.0 ? (left_width+right_width)*u_width_scale : offset;halfwidth=border_width > 0.0 ? border_width*u_width_scale*0.5 : halfwidth;bool zero_right_width=border_width==0.0 && right_width==0.0;symmetric_outset=zero_right_width ? u_width_scale*left_width : halfwidth;stub_side=zero_right_width ?-normal.y : 0.0;v_normal=!left && zero_right_width ? vec2(0.0) : v_normal;ANTIALIASING=!left && zero_right_width ? 0.0 : ANTIALIASING;\n#else\nhalfwidth=(u_width_scale*width)/2.0;\n#endif\nfloat inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth > 0.0 ? ANTIALIASING : 0.0);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;v_tile_pos=pos+offset2*u_pixels_to_tile_units;gl_Position=u_matrix*vec4(v_tile_pos,a_z_offset,1.0);\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;float scaled_z_offset=a_z_offset;\n#ifdef ELEVATION_GROUND_SCALE\nscaled_z_offset=a_z_offset*mix(1.0,u_exaggeration,a_elevation_ground_scale);\n#endif\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=pos_normal.y-2.0*floor(pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+scaled_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+scaled_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+scaled_z_offset;\n#endif\n#endif\nv_tile_pos=offset_pos;gl_Position=u_matrix*vec4(v_tile_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\nv_tile_pos=pos+offset2*u_pixels_to_tile_units;gl_Position=u_matrix*vec4(v_tile_pos,0.0,1.0);\n#endif\n#endif\n#ifndef ELEVATED\n#ifndef VARIABLE_LINE_WIDTH\n#ifndef RENDER_TO_TEXTURE\nfloat base_w=gl_Position.w;vec2 screen_width=abs(projected_extrude.xy/base_w*u_units_to_pixels);float max_extrude_component=max(screen_width.x,screen_width.y);if (width >=1.0 && base_w > 0.0 && max_extrude_component > 0.0001) {float min_pixel=1.05;if (max_extrude_component < min_pixel) {vec2 abs_pos=abs(gl_Position.xy);float is_out=max(abs_pos.x,abs_pos.y)/base_w;dilute_scale=mix(max_extrude_component/min_pixel,1.0,smoothstep(2.5,4.5,is_out));projected_extrude/=dilute_scale;}else if (gapwidth > 0.0) {float visible_ratio=(halfwidth+ANTIALIASING)/outset;vec2 visible_screen_width=screen_width*visible_ratio;float max_visible_component=max(visible_screen_width.x,visible_screen_width.y);dilute_scale=min(1.0,max_visible_component/min_pixel);}else\n{\n#ifdef RENDER_LINE_BORDER\nfloat border_ratio=(border_width*u_width_scale+ANTIALIASING)/outset;screen_width*=border_ratio;float max_border_component=max(screen_width.x,screen_width.y);dilute_border_scale=min(1.0,max_border_component/min_pixel);\n#endif\n}}\n#endif\n#endif\nv_tile_pos=(v_tile_pos+extrude)/EXTENT;\n#ifdef ELEVATED_ROADS\ngl_Position=gl_Position+projected_extrude;\n#ifdef VARIABLE_LINE_WIDTH\n#ifndef ELEVATED\nif (u_road_view_depth_bias > 0.0) {highp float z_in=gl_Position.z/gl_Position.w*0.5+0.5;highp float a=u_road_clip_to_view.x;highp float b=u_road_clip_to_view.y;highp float c=u_road_clip_to_view.z;highp float d=u_road_clip_to_view.w;highp float view=(a*z_in+b)/(c*z_in+d);highp float view_new=view+u_road_view_depth_bias;highp float z_new=(view_new*d-b)/(a-view_new*c);z_new=clamp(z_new,0.0,1.0);gl_Position.z=(z_new*2.0-1.0)*gl_Position.w;}\n#endif\n#endif\n#else\ngl_Position=mix(gl_Position+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat epsilon=0.0001;float extrude_length_without_perspective=max(length(dist),epsilon);float extrude_length_with_perspective=max(length(projected_extrude_xy/gl_Position.w*u_units_to_pixels),epsilon);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nhighp float a_uv_x=a_packed[0];float a_split_index=a_packed[1];\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT)\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec3(a_uv_x,a_split_index*texel_height-half_texel_height,line_progress);\n#else\nv_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nvec4 dashf=vec4(dash);float totalLength=dashf.z+dashf.w/65535.0;float scale=totalLength==0.0 ? 0.0 : u_tile_units_to_pixels/totalLength;v_tex=vec2(a_linesofar*scale/(floorwidth*u_floor_width_scale),(-normal.y*dashf.y+dashf.x+0.5)/u_texsize.y);\n#endif\nv_width2_dilute=vec4(outset,inset,dilute_scale,dilute_border_scale);\n#ifdef VARIABLE_LINE_WIDTH\nv_width2_dilute.x=symmetric_outset;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=a_z_offset;\n#endif\n}'),
            linePattern: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\nuniform highp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_alpha_discard_threshold;uniform lowp float u_opacity_multiplier;uniform highp vec2 u_texsize;uniform highp float u_tile_units_to_pixels;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;uniform sampler2D u_image;\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef LINE_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nin vec2 v_normal;in vec2 v_width2;in highp float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef LINE_JOIN_NONE\nin vec2 v_pattern_data;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define mediump uvec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize lowp float emissive_strength\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;highp float pattern_size=display_size.x/u_tile_units_to_pixels;float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);highp float pattern_x=v_linesofar/pattern_size*aspect;highp float x=mod(pattern_x,1.0);highp float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;highp vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));highp vec2 lod_pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(pattern_x,y));vec4 color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\n#ifdef LINE_PATTERN_TRANSITION\nvec2 pattern_b_tl=vec2(pattern_b.xy);vec2 pattern_b_br=vec2(pattern_b.zw);highp vec2 pos_b=mix(pattern_b_tl*texel_size-texel_size,pattern_b_br*texel_size+texel_size,vec2(x,y));vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);color=color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);color=mix(color,color.a*u_trim_color,transition_factor);}\n#endif\n#ifdef LINE_JOIN_NONE\nhighp float pattern_len=pattern_size/aspect;highp float segment_phase=pattern_len-mod(v_linesofar-v_pattern_data.x+pattern_len,pattern_len);highp float visible_start=segment_phase-step(pattern_len*0.5,segment_phase)*pattern_len;highp float visible_end=floor((v_pattern_data.y-segment_phase)/pattern_len)*pattern_len+segment_phase;visible_end+=step(pattern_len*0.5,v_pattern_data.y-visible_end)*pattern_len;if (v_pattern_data.x < visible_start || v_pattern_data.x >=visible_end) {color=vec4(0.0);}\n#endif\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_with_emission_ground(color,emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\ncolor.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\ncolor.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity*u_opacity_multiplier);if (u_alpha_discard_threshold !=0.0) {if (color.a < u_alpha_discard_threshold) {discard;}}\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,v_z_offset);\n#endif\nglFragColor=color;\n#ifdef DUAL_SOURCE_BLENDING\nglFragColorSrc1=vec4(vec3(0.0),emissive_strength);\n#else\n#ifdef USE_MRT1\nout_Target1=vec4(emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define scale 0.015873016\nin ivec2 a_pos_normal;in uvec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\nin vec4 a_z_offset_width;\n#endif\n#ifdef ELEVATION_GROUND_SCALE\nin float a_elevation_ground_scale;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 a_packed;\n#endif\nin highp float a_linesofar;\n#ifdef LINE_JOIN_NONE\nin highp vec3 a_pattern_data;out vec2 v_pattern_data;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform mat4 u_matrix;uniform float u_tile_units_to_pixels;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform float u_device_pixel_ratio;uniform float u_width_scale;uniform float u_floor_width_scale;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec2 v_width2;out highp float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nout highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define mediump float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float floorwidth\n#pragma mapbox: define mediump uvec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize mediump float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float floorwidth\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize lowp float emissive_strength\nfloat a_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset=a_z_offset_width.x;\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(a_data.xy)-128.0;float a_direction=float(a_data.z & 3u)-1.0;vec2 pos_normal=vec2(a_pos_normal);vec2 pos=floor(pos_normal*0.5);vec2 normal=pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=(u_width_scale*width)/2.0;offset=-1.0*offset*u_width_scale;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);vec2 dist=outset*a_extrude*scale;float u=0.5*a_direction;float t=1.0-abs(u);vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset,1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;float scaled_z_offset=a_z_offset;\n#ifdef ELEVATION_GROUND_SCALE\nscaled_z_offset=a_z_offset*mix(1.0,u_exaggeration,a_elevation_ground_scale);\n#endif\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=pos_normal.y-2.0*floor(pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+scaled_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+scaled_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+scaled_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude_xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float a_uv_x=a_packed[0];highp float line_progress=a_packed[2];v_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=(floorwidth*u_floor_width_scale);\n#ifdef LINE_JOIN_NONE\nv_width=(floorwidth*u_floor_width_scale)+ANTIALIASING;mediump float pixels_to_tile_units=1.0/u_tile_units_to_pixels;mediump float pixel_ratio_inverse=1.0/pixel_ratio;mediump float aspect=v_width/(float(pattern.w-pattern.y)*pixel_ratio_inverse);highp float subt_multiple=float(pattern.z-pattern.x)*pixel_ratio_inverse*pixels_to_tile_units*aspect*32.0;highp float subt=floor(a_pattern_data.z/subt_multiple)*subt_multiple;float offset_sign=(fract(a_pattern_data.x)-0.5)*4.0;float line_progress_offset=offset_sign*v_width*0.5*pixels_to_tile_units;v_linesofar=(a_pattern_data.z-subt)+a_linesofar+line_progress_offset;v_pattern_data=vec2(a_pattern_data.x+line_progress_offset,a_pattern_data.y);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=a_z_offset;\n#endif\n}'),
            raster: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;uniform highp float u_zoom_transition;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nin float v_split_fade;\n#endif\nuniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;\n#ifdef GLOBE_POLES\ncolor.a*=1.0-smoothstep(0.0,0.05,u_zoom_transition);\n#endif\nvec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef PROJECTION_GLOBE_VIEW\nglFragColor*=mix(1.0,1.0-smoothstep(0.0,0.05,u_zoom_transition),smoothstep(0.8,0.9,v_split_fade));\n#endif\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;\n#endif\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin ivec2 a_pos;in uvec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nout float v_split_fade;\n#endif\nvoid main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;uv=a_uv;float ele=u_raster_elevation;\n#ifdef ELEVATION_REFERENCE_GROUND\nele+=elevation(uv*EXTENT);\n#endif\nglobe_pos+=normalize(globe_pos)*ele*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos,1.0);\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\nvec4 world_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec2 texture_pos=vec2(a_texture_pos);uv=texture_pos/8192.0;vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);  \nfloat tiles=u_grid_matrix[0][2];if (tiles > 0.0) {float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvY=mercatorY*tiles-idy;float uvX=mercatorX*tiles-idx;uv=vec2(uvX,uvY);}float ele=u_raster_elevation;\n#ifdef ELEVATION_REFERENCE_GROUND\nele+=elevation(uv*EXTENT)-decomposed_pos_and_skirt.z;\n#endif\nvec4 merc_world_pos=vec4(0.0);   \nv_split_fade=0.0;if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,ele,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;float opposite_merc_center=mod(u_merc_center.x+0.5,1.0);float dist_from_poles=(abs(mercatorY-0.5)*2.0);float range=0.1;v_split_fade=abs(opposite_merc_center-mercatorX);v_split_fade=clamp(1.0-v_split_fade,0.0,1.0);v_split_fade=max(smoothstep(1.0-range,1.0,dist_from_poles),max(smoothstep(1.0-range,1.0,v_split_fade),smoothstep(1.0-range,1.0,1.0-v_split_fade)));}vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*ele*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);world_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nfloat ele=0.0;vec2 decodedPos=vec2(a_pos);\n#ifdef ELEVATION_REFERENCE_GROUND\nvec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;decodedPos=decomposedPosAndSkirt.xy;uv=decodedPos/8192.0;ele=elevation(decodedPos)-skirt;\n#else\nuv=vec2(a_texture_pos)/8192.0;\n#endif\nworld_pos=vec4(decodedPos,(u_raster_elevation+ele),1.0);\n#ifdef FOG\nv_fog_pos=fog_position(decodedPos);\n#endif\n#endif\nfloat w=1.0+dot(uv*EXTENT,u_perspective_transform);gl_Position=u_matrix*world_pos*w;\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef ELEVATED\nfloat z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor);gl_Position.z-=(gl_Position.w*zbias);\n#endif\n#ifdef RENDER_CUTOFF\nv_depth=gl_Position.z;\n#endif\n}'),
            symbol: IE('#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;\n#ifdef RENDER_TEXT_AND_SYMBOL\nuniform sampler2D u_texture_icon;\n#endif\nuniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_sdf;uniform lowp float u_scale_factor;uniform lowp float u_opacity_multiplier;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\n#ifdef COLOR_ADJUSTMENT\nuniform mat4 u_color_adj_mat;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#else\n#ifdef RENDER_SHADOWS\nin highp float v_z_offset;\n#endif\n#endif\nin vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\nin float v_draw_halo;in vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nin float is_sdf;in vec2 v_tex_a_icon;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\nin lowp float v_opacity;in lowp vec4 v_fill_np_color;in lowp vec4 v_halo_np_color;in lowp float v_halo_width;in lowp float v_halo_blur;\n#ifdef LIGHTING_3D_MODE\nin lowp float v_emissive_strength;\n#endif\nvoid main() {lowp float opacity=v_opacity;lowp vec4 fill_color=vec4(0.0);lowp vec4 halo_color=vec4(0.0);lowp float halo_width=0.0;lowp float halo_blur=0.0;if (u_is_sdf) {fill_color=vec4(v_fill_np_color.rgb*v_fill_np_color.a,v_fill_np_color.a);halo_color=vec4(v_halo_np_color.rgb*v_halo_np_color.a,v_halo_np_color.a);halo_width=v_halo_width;halo_blur=v_halo_blur;}lowp float emissive_strength=0.0;\n#ifdef LIGHTING_3D_MODE\nemissive_strength=v_emissive_strength;\n#endif\nvec4 out_color;float fade_opacity=v_gamma_scale_size_fade_opacity[2];\n#ifdef RENDER_TEXT_AND_SYMBOL\nif (is_sdf==ICON) {vec2 tex_icon=v_tex_a_icon;lowp float alpha=opacity*fade_opacity*u_opacity_multiplier;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}\n#endif\nvec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\nif (u_is_sdf) {float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_gamma_scale_size_fade_opacity.x;float size=v_gamma_scale_size_fade_opacity.y;float fontScale=u_is_text ? size/24.0 : size;out_color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {out_color=halo_color;gamma=(halo_blur*u_scale_factor*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width*u_scale_factor/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,v_tex_a).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);out_color*=alpha;} else {\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b);\n#else\nout_color=texture(u_texture,v_tex_a);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef COLOR_ADJUSTMENT\nout_color=u_color_adj_mat*out_color;\n#endif\n}out_color*=opacity*fade_opacity*u_opacity_multiplier;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);\n#ifdef TERRAIN\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#else\nout_color.rgb*=mix(v_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_z_offset);\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x,0.0);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#define USING_APPEARANCE 1.0\nin ivec4 a_pos_offset;in uvec4 a_tex_size;in ivec4 a_pixeloffset;in vec4 a_projected_pos;in uint a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_auto_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin uvec2 a_texb;\n#endif\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\n#ifdef ELEVATED_ROADS\nin vec3 a_x_axis;in vec3 a_y_axis;uniform float u_normal_scale;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#else\n#ifdef RENDER_SHADOWS\nout highp float v_z_offset;\n#endif\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_inv_matrix;\n#endif\nuniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_elevation_from_sea;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_up_vector;\n#endif\n#ifdef RENDER_TEXT_AND_SYMBOL\nuniform vec2 u_texsize_icon;\n#endif\nuniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_draw_halo;out vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nout float is_sdf;out vec2 v_tex_a_icon;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#ifndef MAX_UBO_SIZE_VEC4\n#define MAX_UBO_SIZE_VEC4 1024u\n#endif\n#define SPP_HEADER_SIZE_VEC4 4u\nstruct SymbolPaintProperties {vec4 fill_np_color;vec4 halo_np_color;float opacity;float halo_width;float halo_blur;float emissive_strength;float occlusion_opacity;float z_offset;vec2 translate;};uniform lowp vec4 u_spp_fill_np_color;uniform lowp vec4 u_spp_halo_np_color;uniform lowp float u_spp_opacity;uniform lowp float u_spp_halo_width;uniform lowp float u_spp_halo_blur;uniform lowp float u_spp_emissive_strength;uniform lowp float u_spp_occlusion_opacity;uniform highp float u_spp_z_offset;uniform lowp vec2 u_spp_translate_rotation;uniform highp float u_spp_zoom_fraction;in float a_feature_index;layout(std140) uniform SymbolPaintPropertiesHeaderUniform {uvec4 header[SPP_HEADER_SIZE_VEC4];} u_spp_header;layout(std140) uniform SymbolPaintPropertiesUniform {vec4 properties[MAX_UBO_SIZE_VEC4];} u_spp_properties;layout(std140) uniform SymbolPaintPropertiesIndexUniform {uvec4 block_indices[MAX_UBO_SIZE_VEC4];} u_spp_index;out lowp float v_opacity;out lowp vec4 v_fill_np_color;out lowp vec4 v_halo_np_color;out lowp float v_halo_width;out lowp float v_halo_blur;\n#ifdef LIGHTING_3D_MODE\nout lowp float v_emissive_strength;\n#endif\nfloat zoomFactor(float zm,float zM) {if (zm==zM) return u_spp_zoom_fraction-zm >=0.0 ? 1.0 : 0.0;return clamp((u_spp_zoom_fraction-zm)/(zM-zm),0.0,1.0);}vec4 readColor(uint base,bool isDataDriven,uint offsetVec4,uint dzr,vec2 headerZoom,vec4 fallbackValue) {if (!isDataDriven) return fallbackValue;vec4 value=u_spp_properties.properties[base+offsetVec4];vec2 blockZoom=u_spp_properties.properties[base+offsetVec4+dzr].xy;vec2 zr=mix(headerZoom,blockZoom,float(dzr));return unpack_mix_color(value,zoomFactor(zr.x,zr.y));}uint uvec4At(uvec4 v,uint index) {return (index==0u) ? v.x :\n(index==1u) ? v.y :\n(index==2u) ? v.z : v.w;}float readScalar(uint base,bool isDataDriven,uint offsetVec4,float fallbackValue) {if (!isDataDriven) return fallbackValue;vec4 slot=u_spp_properties.properties[base+offsetVec4];return unpack_mix_vec2(slot.xy,zoomFactor(slot.z,slot.w));}vec2 readTranslate(uint base,bool isDataDriven,uint offsetVec4,uint dzr) {if (!isDataDriven) return vec2(0.0);vec4 value=u_spp_properties.properties[base+offsetVec4];vec2 blockZoom=u_spp_properties.properties[base+offsetVec4+dzr].xy;float t=zoomFactor(blockZoom.x,blockZoom.y)*float(dzr);return mix(value.xy,value.zw,t);}SymbolPaintProperties readSymbolPaintProperties() {uint dataDrivenMask=u_spp_header.header[0][0];uint dzrMask       =u_spp_header.header[0][1];uint blockSizeVec4 =u_spp_header.header[0][2];uint fillColorDzr=dzrMask & 1u;uint haloColorDzr=(dzrMask >> 1u) & 1u;vec2 fillColorHeaderZoom=uintBitsToFloat(u_spp_header.header[3].xy);vec2 haloColorHeaderZoom=uintBitsToFloat(u_spp_header.header[3].zw);uint featureIndex=uint(a_feature_index);uvec4 indexSlot=u_spp_index.block_indices[featureIndex/4u];uint base=uvec4At(indexSlot,featureIndex % 4u)*blockSizeVec4;SymbolPaintProperties props;props.fill_np_color    =readColor(base,(dataDrivenMask & (1u << 0u)) !=0u,u_spp_header.header[0][3],fillColorDzr,fillColorHeaderZoom,u_spp_fill_np_color);props.halo_np_color    =readColor(base,(dataDrivenMask & (1u << 1u)) !=0u,u_spp_header.header[1][0],haloColorDzr,haloColorHeaderZoom,u_spp_halo_np_color);props.opacity          =readScalar(base,(dataDrivenMask & (1u << 2u)) !=0u,u_spp_header.header[1][1],u_spp_opacity);props.halo_width       =readScalar(base,(dataDrivenMask & (1u << 3u)) !=0u,u_spp_header.header[1][2],u_spp_halo_width);props.halo_blur        =readScalar(base,(dataDrivenMask & (1u << 4u)) !=0u,u_spp_header.header[1][3],u_spp_halo_blur);props.emissive_strength=readScalar(base,(dataDrivenMask & (1u << 5u)) !=0u,u_spp_header.header[2][0],u_spp_emissive_strength);props.occlusion_opacity=readScalar(base,(dataDrivenMask & (1u << 6u)) !=0u,u_spp_header.header[2][1],u_spp_occlusion_opacity);props.z_offset         =readScalar(base,(dataDrivenMask & (1u << 7u)) !=0u,u_spp_header.header[2][2],u_spp_z_offset);uint translateDzr=(dzrMask >> 8u) & 1u;props.translate        =readTranslate(base,(dataDrivenMask & (1u << 8u)) !=0u,u_spp_header.header[2][3],translateDzr);return props;}vec2 unpack_opacity(uint packedOpacity) {return vec2(float(packedOpacity/2u)/127.0,float(packedOpacity & 1u));}void main() {SymbolPaintProperties paint_properties=readSymbolPaintProperties();lowp float opacity=paint_properties.opacity;v_opacity=opacity;v_fill_np_color=paint_properties.fill_np_color;v_halo_np_color=paint_properties.halo_np_color;v_halo_width=paint_properties.halo_width;v_halo_blur=paint_properties.halo_blur;\n#ifdef LIGHTING_3D_MODE\nv_emissive_strength=paint_properties.emissive_strength;\n#endif\nlowp float occlusion_opacity=paint_properties.occlusion_opacity;highp float z_offset=paint_properties.z_offset;vec2 a_pos=vec2(a_pos_offset.xy);vec2 a_offset=vec2(a_pos_offset.zw);vec2 a_tex=vec2(a_tex_size.xy);vec2 a_size=vec2(a_tex_size.zw);float a_size_min=floor(a_size[0]*0.5);float a_size_max= floor(a_size[1]*0.5);float a_apperance=a_size[1]-2.0*a_size_max;vec2 a_pxoffset=vec2(a_pixeloffset.xy);vec2 a_min_font_scale=vec2(a_pixeloffset.zw)/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (a_apperance==USING_APPEARANCE) {size=a_size_max/128.0;} else if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size_max,u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=u_elevation_from_sea ? z_offset : z_offset+elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_auto_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=vec3(a_globe_anchor)+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(vec3(a_globe_anchor)+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\n#ifdef PROJECTED_POS_ON_VIEWPORT\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xyz+h,1.0);\n#else\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz,mercator_pos,u_zoom_transition)+h;projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#endif\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\n#ifdef Z_OFFSET\nz+=u_pitch_with_map ? a_auto_z_offset+z_offset : 0.0;\n#else\nz+=u_pitch_with_map ? z_offset : 0.0;\n#endif\nfloat occlusion_fade=globe_occlusion_fade;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float out_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));\n#ifdef DEPTH_OCCLUSION\nfloat depth_occlusion=occlusionFadeMultiSample(projected_point);float depth_occlusion_multplier=mix(occlusion_opacity,1.0,depth_occlusion);out_fade_opacity*=depth_occlusion_multplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;\n#endif\n#ifdef Z_TEST_OCCLUSION\nout_fade_opacity*=occlusion_opacity;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);pos=projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y;\n#else\n#ifdef ELEVATED_ROADS\nvec3 xAxis=vec3(a_x_axis.xy,a_x_axis.z*u_normal_scale);vec3 yAxis=vec3(a_y_axis.xy,a_y_axis.z*u_normal_scale);pos=projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y;\n#else\npos=vec3(projected_pos.xy/projected_pos.w+offset,z);\n#endif\n#endif\ngl_Position=mix(u_coord_matrix*vec4(pos,1.0),AWAY,hidden);{vec2 tr=paint_properties.translate;vec2 rotated_tr=vec2(\nu_spp_translate_rotation.x*tr.x-u_spp_translate_rotation.y*tr.y,u_spp_translate_rotation.y*tr.x+u_spp_translate_rotation.x*tr.y\n);gl_Position.xy+=(u_coord_matrix*vec4(rotated_tr,0.0,0.0)).xy;}float gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_gamma_scale_size_fade_opacity=vec3(gamma_scale,size,out_fade_opacity);v_tex_a=a_tex/u_texsize;\n#ifdef RENDER_TEXT_AND_SYMBOL\nis_sdf=a_size[0]-2.0*a_size_min;v_tex_a_icon=a_tex/u_texsize_icon;\n#endif\n#ifdef ICON_TRANSITION\nv_tex_b=vec2(a_texb)/u_texsize;\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shd_pos=u_inv_matrix*vec4(pos,1.0);vec3 shd_pos0=shd_pos.xyz;vec3 shd_pos1=shd_pos.xyz;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=e;\n#else\n#ifdef RENDER_SHADOWS\nv_z_offset=e;\n#endif\n#endif\n}'),
            terrainRaster: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nuniform sampler2D u_image1;uniform float u_emissive_texture_available;\n#endif\nin vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nfloat emissive_strength=u_emissive_texture_available > 0.5 ? texture(u_image1,v_pos0).r : image_color.a;vec3 unlit_base=image_color.rgb*(1.0-emissive_strength);vec3 emissive_base=image_color.rgb*emissive_strength;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nfloat emissive_strength=u_emissive_texture_available > 0.5 ? texture(u_image1,v_pos0).r : image_color.a;color.rgb=mix(color.rgb,image_color.rgb,emissive_strength);color.a=1.0;\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in ivec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;\n#ifdef VIEWPORT_ORIGIN_TOP_LEFT\nv_pos0.y=1.0-v_pos0.y;\n#endif\ngl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);\n#endif\n}'),
            terrainDepth: IE("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in ivec2 a_pos;out float v_depth;void main() {float elevation=elevation(vec2(a_pos));gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'),
            skybox: IE('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', tE),
            skyboxGradient: IE('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', tE),
            skyboxCapture: IE("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;\n#ifndef VIEWPORT_ORIGIN_TOP_LEFT\nv_position.y*=-1.0;\n#endif\nv_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),
            globeRaster: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nuniform sampler2D u_image1;uniform float u_emissive_texture_available;\n#endif\nuniform float u_far_z_cutoff;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nhighp vec2 uv=gl_FragCoord.xy/u_viewport;FLIP_VIEWPORT_UV_Y(uv);highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;highp float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);highp float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nfloat emissive_strength=u_emissive_texture_available > 0.5 ? texture(u_image1,v_pos0).r : raster.a;raster=apply_lighting_with_emission_ground(raster,emissive_strength);color=vec4(clamp(raster.rgb,vec3(0),vec3(1))*antialias,antialias);\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nfloat emissive_strength=u_emissive_texture_available > 0.5 ? texture(u_image1,v_pos0).r : color.a;color=apply_lighting_with_emission_ground(color,emissive_strength);color.a=1.0;\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=1.0-step(u_far_z_cutoff,1.0/gl_FragCoord.w);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;\n#ifndef GLOBE_POLES\nuniform mat4 u_merc_matrix;\n#endif\nuniform float u_zoom_transition;uniform vec2 u_merc_center;\n#ifndef GLOBE_POLES\nuniform mat3 u_grid_matrix;\n#endif\nuniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin ivec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;\n#ifdef VIEWPORT_ORIGIN_TOP_LEFT\nv_pos0.y=1.0-v_pos0.y;\n#endif\nvec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}'),
            globeAtmosphere: IE('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_atmosphere_fog_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\n#ifdef NATIVE\nglFragColor=vec4(1,1,1,1);\n#else\nglFragColor=vec4(0,0,0,1);\n#endif\nreturn;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_atmosphere_fog_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_atmosphere_fog_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;glFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"),
            stars: IE("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}"),
            occlusion: IE("uniform vec4 u_color;void main() {glFragColor=u_color;}", '#include "_prelude_terrain.vertex.glsl"\nin highp vec2 a_offset_xy;uniform highp vec3 u_anchorPos;uniform mat4 u_matrix;uniform vec2 u_screenSizePx;uniform vec2 u_occluderSizePx;void main() {vec3 world_pos=u_anchorPos;\n#ifdef TERRAIN\nfloat e=elevation(world_pos.xy);world_pos.z+=e;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1.0);projected_point.xy+=projected_point.w*a_offset_xy*0.5*u_occluderSizePx/u_screenSizePx;gl_Position=projected_point;}')
        };
        function EE(e1, t1) {
            const i = e1.split("\n");
            for (let e1 of i){
                if (e1 = e1.trimStart(), "#" !== e1[0]) continue;
                if (!e1.includes("if")) continue;
                if (e1.startsWith("#endif")) continue;
                const i = e1.match(hE);
                if (i) for (const e1 of i)dE.has(e1) || t1.add(e1);
            }
        }
        function AE(e1) {
            return new Set([
                "uint",
                "int",
                "uvec2",
                "ivec2",
                "uvec3",
                "ivec3",
                "uvec4",
                "ivec4"
            ]).has(e1);
        }
        function IE(e1, t1) {
            const i = new Set, n = [], r = [];
            e1 = e1.replace(uE, (e1, t1)=>(r.push(t1), "")), t1 = t1.replace(uE, (e1, t1)=>(n.push(t1), ""));
            let o = new Set(fE);
            EE(e1, o), EE(t1, o);
            for (const e1 of [
                ...n,
                ...r
            ])_E[e1] || (_E[e1] = new Set, EE(pE[e1], _E[e1])), o = new Set([
                ...o,
                ..._E[e1]
            ]);
            return {
                fragmentSource: e1 = e1.replace(cE, (e1, t1, n, r, o)=>(i.add(o), "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${o}\n${AE(r) ? "flat " : ""}in ${n} ${r} ${o};\n#else\nuniform ${n} ${r} u_${o};\n#endif\n` : "initialize" === t1 ? `\n#ifdef HAS_UNIFORM_u_${o}\n    ${n} ${r} ${o} = u_${o};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${o}\n    in ${n} ${r} ${o};\n#endif\n` : "initialize-attribute" === t1 ? "" : void 0)),
                vertexSource: t1 = t1.replace(cE, (e1, t1, n, r, o)=>{
                    const a = `MATERIAL_ATTRIBUTE_OFFSET_${o}`, s = "float" === r ? "vec2" : r, l = `GET_ATTRIBUTE_${s}(a_${o}, materialInfo, ${a})`, u = o.includes("color") ? "color" : s;
                    return "define-attribute-vertex-shader-only" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${o}\nin ${n} ${r} a_${o};\n#endif\n` : i.has(o) ? "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${o}\nuniform lowp float u_${o}_t;\n    #if !defined(${a})\n        in ${n} ${s} a_${o};\n    #endif\n${AE(r) ? "flat " : ""}out ${n} ${r} ${o};\n#else\nuniform ${n} ${r} u_${o};\n#endif\n` : "initialize" === t1 ? "vec4" === u || "uvec4" === u ? `\n#ifndef HAS_UNIFORM_u_${o}\n    ${o} = a_${o};\n#else\n    ${n} ${r} ${o} = u_${o};\n#endif\n` : `\n#if !defined(HAS_UNIFORM_u_${o})\n    #ifdef ${a}\n        ${o} = unpack_mix_${u}(${l}, u_${o}_t);\n    #else\n        ${o} = unpack_mix_${u}(a_${o}, u_${o}_t);\n    #endif\n#else\n    ${n} ${r} ${o} = u_${o};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${o}\n    in ${n} ${r} a_${o};\n    out ${n} ${r} ${o};\n#endif\n` : "initialize-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${o}\n    ${o} = a_${o};\n#endif\n` : void 0 : "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${o}\nuniform lowp float u_${o}_t;\n    #if !defined(${a})\n        in ${n} ${s} a_${o};\n    #endif\n#else\nuniform ${n} ${r} u_${o};\n#endif\n` : "define-instanced" === t1 ? "mat4" === u ? `\n#ifdef INSTANCED_ARRAYS\nin vec4 a_${o}0;\nin vec4 a_${o}1;\nin vec4 a_${o}2;\nin vec4 a_${o}3;\n#else\nuniform ${n} ${r} u_${o};\n#endif\n` : `\n#ifdef INSTANCED_ARRAYS\nin ${n} ${s} a_${o};\n#else\nuniform ${n} ${r} u_${o};\n#endif\n` : "initialize-attribute-custom" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${o}\n    ${n} ${r} ${o} = a_${o};\n#endif\n` : "vec4" === u || "uvec4" === u ? `\n#ifndef HAS_UNIFORM_u_${o}\n    #ifdef ${a}\n        ${n} ${r} ${o} = ${l};\n    #else\n        ${n} ${r} ${o} = a_${o};\n    #endif\n#else\n    ${n} ${r} ${o} = u_${o};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${o}\n    #ifdef ${a}\n        ${n} ${r} ${o} = unpack_mix_${u}(${l}, u_${o}_t);\n    #else\n        ${n} ${r} ${o} = unpack_mix_${u}(a_${o}, u_${o}_t);\n    #endif\n#else\n    ${n} ${r} ${o} = u_${o};\n#endif\n`;
                }),
                usedDefines: o,
                vertexIncludes: n,
                fragmentIncludes: r
            };
        }
        var TE = {
            model: IE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nuniform float u_opacity;\n#ifdef DITHERED_DISCARD\nuniform float u_dithered_discard_threshold;\n#endif\n#ifndef LIGHTING_3D_MODE\nuniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;\n#endif\nuniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nuniform vec4 u_occlusionTextureTransform;\n#endif\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_pbr\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef FEATURE_CUTOUT_VERTEX\nin highp float v_cutout_factor;\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nin highp float v_depth;uniform highp sampler2D u_depthTexture;uniform highp vec2 u_inv_depth_size;uniform highp vec2 u_depth_range_unpack;\n#ifdef DEPTH_D24\nhighp float unpack_depth(highp float depth) {return  depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}\n#else\nhighp float unpack_depth_rgba(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded() {highp vec2 coord=gl_FragCoord.xy*u_inv_depth_size;\n#ifdef FLIP_Y\ncoord.y=1.0-coord.y;\n#endif\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depthTexture,coord).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depthTexture,coord));\n#endif\nreturn v_depth > depth+0.0005;}\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\ntexColor=vec4(unpremultiplyColor(texColor),1.0);\n#endif\nif(u_baseTextureIsAlpha) {if (texColor.r < 0.5) {discard;}} else {texColor.rgb=sRGBToLinear(texColor.rgb);albedo*=texColor;}\n#endif\nvec4 color=vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\nreturn color;}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;\n#ifdef FLIP_Y\nT=-T;B=-B;\n#endif\nhighp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_3f\nn=normalize(normal_3f);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));\n#ifdef FLIP_Y\nn=normalize(cross(fdx,fdy));\n#else\nn=normalize(cross(fdx,fdy))*-1.0;\n#endif\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_pbr\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nif (isOccluded()) {discard;}\n#endif\nvec3 lightDir;vec3 lightColor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#else\nlightDir=u_lightpos;lightColor=u_lightcolor;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 baseColor=getBaseColor().rgb;vec3 diffuse=getDiffuseShadedColor(baseColor,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(mix(diffuse,baseColor,u_emissive_strength),1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nvec2 uv=uv_2f.xy*u_occlusionTextureTransform.zw+u_occlusionTextureTransform.xy;\n#else\nvec2 uv=uv_2f;\n#endif\nao=(texture(u_occlusionTexture,uv).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nfloat emissiveFactorLength=max(length(u_emissiveFactor.rgb),0.001);emissive.rgb=sRGBToLinear(applyLUT(u_lutTexture,linearTosRGB(emissive.rgb/emissiveFactorLength).rbg))*emissiveFactorLength;\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_pbr\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);vec3 color_mix=v_color_mix.rgb;\n#ifdef APPLY_LUT_ON_GPU\ncolor_mix=applyLUT(u_lutTexture,color_mix);\n#endif\ncolor=mix(color,color_mix,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef DITHERED_DISCARD\nif (abs(u_dithered_discard_threshold) < 1.0) {float ditherValue=fract(52.9829189*fract(0.06711056*gl_FragCoord.x+0.00583715*gl_FragCoord.y));float compareValue=mix(1.0-ditherValue,ditherValue,step(0.0,u_dithered_discard_threshold));if (abs(u_dithered_discard_threshold) < compareValue) {discard;}}\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nfinalColor=applyCutout(finalColor,v_position_height.w);\n#endif\n#ifdef FEATURE_CUTOUT_VERTEX\napply_feature_cutout_dither(gl_FragCoord,v_cutout_factor);\n#else\n#ifdef FEATURE_CUTOUT\nfinalColor=apply_feature_cutout(finalColor,gl_FragCoord,get_cutout_factors(gl_FragCoord).x,0.0);\n#endif\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_feature_cutout.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp uvec4 pbr\n#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength\nuniform mat4 u_matrix;uniform mat4 u_node_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nout highp float v_depth;\n#endif\n#ifdef FEATURE_CUTOUT_VERTEX\nout highp float v_cutout_factor;\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp uvec4 pbr\n#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\n#ifdef FEATURE_CUTOUT_VERTEX\nv_cutout_factor=1.0;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float hidden=float(pos_a.x > EXTENT);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=mix(u_matrix*pos,AWAY,hidden);pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#ifdef FEATURE_CUTOUT_VERTEX\nhighp vec4 ground_pos=vec4(pos_a.xy,0.0,1.0);highp vec4 cutout_clip_pos=mix(u_matrix*ground_pos,AWAY,hidden);highp vec3 cutout_ndc=cutout_clip_pos.xyz/cutout_clip_pos.w;vec2 uv=cutout_ndc.xy*0.5+0.5;highp float fragDepthNDC=cutout_ndc.z*0.5+0.5;\n#ifdef FLIP_Y\nfragDepthNDC=cutout_ndc.z;\n#endif\nhighp float cutoutFactor=get_cutout_factors_vert(uv).x;highp float cutoutDepthNDC=sample_cutout_depth(u_cutout_depth_image,uv);highp float groundThreshold=0.001;highp float groundLimit=clamp((fragDepthNDC+groundThreshold-cutoutDepthNDC)/groundThreshold+0.5,0.0,1.0);v_cutout_factor=mix(1.0-cutoutFactor,1.0,groundLimit);\n#endif\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_pbr\nvec4 albedo_c=decode_color(vec2(pbr.xy));vec2 e_r_m=unpack_float(float(pbr.z));vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(float(pbr.w))/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nv_depth=gl_Position.z/gl_Position.w;\n#ifdef CLIP_ZERO_TO_ONE\nv_depth=-1.0+2.0*v_depth; \n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);\n#else\nnormal_3f=vec3(normal_matrix*vec4(normal_3f,0));\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shadow_pos=u_node_matrix*vec4(local_pos,1.0);\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normal_3f);shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*shadow_pos;v_pos_light_view_1=u_light_matrix_1*shadow_pos;v_depth_shadows=gl_Position.w;\n#endif\n}'),
            modelDepth: IE("void main() {}", "in vec3 a_pos_3f;uniform mat4 u_matrix;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float hidden=float(pos_a.x > EXTENT);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=mix(u_matrix*pos,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\n}"),
            fillExtrusionDepth: IE("void main() {}", '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_material_table.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_width_scale;uniform float u_vertical_scale;\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nin ivec4 a_pos_normal_ed;\n#if defined(HAS_CENTROID) || defined(TERRAIN)\nin uvec2 a_centroid_pos;\n#endif\n#ifdef RENDER_WALL_MODE\nin ivec4 a_join_normal_inside;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp vec4 color\nvoid main() {DECLARE_MATERIAL_TABLE_INFO\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp vec4 color\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 top_up_ny=vec3(a_pos_normal_ed.xyz & 1);vec3 pos_nx=vec3(a_pos_normal_ed.xyz >> 1);base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=vec2(a_centroid_pos);\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;float ele=elevation(pos_nx.xy);bool is_elevation_encoded=centroid_pos.y==0.0 || (centroid_pos.y > 0.0 && int(centroid_pos.y)-(int(centroid_pos.y)/8)*8==7);float c_ele=is_flat_height || is_flat_base ? (is_elevation_encoded ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);float h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\n#ifdef RENDER_WALL_MODE\nvec3 join_normal_inside=vec3(a_join_normal_inside);vec2 wall_offset=u_width_scale*line_width*(join_normal_inside.xy/EXTENT);pos.xy+=(1.0-join_normal_inside.z)*wall_offset*0.5;pos.xy-=join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);}'),
            fillExtrusionGroundEffect: IE("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\n#ifdef USE_MRT1\nout_Target1=vec4(1.0-texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size)).a,0.0,0.0,0.0);\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;\n#endif\n#endif\nHANDLE_WIREFRAME_DEBUG;\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp ivec4 a_pos_end;in highp int a_angular_offset_factor;in highp uint a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp float u_dynamic_offset;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec4 pos_end=vec4(a_pos_end);vec2 p=pos_end.xy;vec2 q=floor(pos_end.zw*0.5);vec2 start_bottom=pos_end.zw-q*2.0;float fl_ground_radius=abs(flood_light_ground_radius);float direction=flood_light_ground_radius < 0.0 ?-1.0 : 1.0;float flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=float(a_angular_offset_factor)/NORM*TANGENT_CUTOFF;float angular_offset=direction*angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(u_dynamic_offset,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=direction*perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=float(a_hidden_by_landmark);\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'),
            groundShadow: IE('#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor_plane_bias(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\n#ifdef INDICATOR_CUTOUT\nshadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0),0.0).r);\n#endif\n#ifdef FEATURE_CUTOUT\nvec2 uv=gl_FragCoord.xy*u_inv_viewport_size.xy;\n#ifdef FLIP_Y\nuv.y=1.0-uv.y;\n#endif\nhighp float cutoutFactor=get_cutout_factors(gl_FragCoord).y;highp float cutoutDepthNDC=sample_cutout_depth_bilinear(u_cutout_depth_image,uv);highp float fragDepthNDC=gl_FragCoord.z/u_feature_cutout_params.w;highp float groundThreshold=-0.001;highp float groundLimit=clamp((fragDepthNDC+groundThreshold-cutoutDepthNDC)/groundThreshold+0.5,0.0,1.0);cutoutFactor=mix(0.0,cutoutFactor,groundLimit);shadow=mix(shadow,vec3(1.0),cutoutFactor);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in ivec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));v_fog_opacity=fog(v_fog_pos);\n#endif\n}')
        };
        const ME = (e1, t1)=>({
                u_matrix: e1,
                u_ground_shadow_factor: t1
            });
        function SE(e1, t1, i = 0) {
            const n = Math.pow(2, t1.tileID.overscaledZ), r = t1.tileSize * Math.pow(2, e1.transform.tileZoom) / n, o = r * (t1.tileID.canonical.x + t1.tileID.wrap * n), a = r * t1.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: t1.imageAtlasTexture ? t1.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: 1 / Dv(t1, 1, e1.transform.tileZoom),
                u_pixel_coord_upper: [
                    o >> 16,
                    a >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & o,
                    65535 & a
                ],
                u_pattern_transition: i
            };
        }
        const zE = {
            terrain: 0,
            flat: 1
        }, RE = u(), PE = [
            0,
            0,
            0
        ], DE = (e1, t1, i, n, r, o, s, u, c, h, d, f, p, _, m, g, y, x, v = [
            0,
            0,
            1
        ], b = !1)=>{
            let w = PE, E = 0, A = PE;
            if (!b) {
                const e1 = t1.style.light, i = e1.properties.get("position");
                if (w = [
                    i.x,
                    i.y,
                    i.z
                ], "viewport" === e1.properties.get("anchor")) {
                    const e1 = a();
                    l(e1, -t1.transform.angle), J(w, w, e1);
                }
                const n = e1.properties.get("color").toPremultipliedRenderColor(null);
                E = e1.properties.get("intensity"), A = [
                    n.r,
                    n.g,
                    n.b
                ];
            }
            const I = t1.transform, T = {
                u_matrix: e1,
                u_lightpos: w,
                u_lightintensity: E,
                u_lightcolor: A,
                u_vertical_gradient: +i,
                u_opacity: n,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: RE,
                u_merc_center: [
                    0,
                    0
                ],
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_height_lift: 0,
                u_height_type: zE[h],
                u_base_type: zE[d],
                u_ao: r,
                u_edge_radius: o,
                u_width_scale: s,
                u_flood_light_color: m,
                u_vertical_scale: g,
                u_flood_light_intensity: y,
                u_ground_shadow_factor: x,
                u_front_cutoff_params: v
            };
            return "globe" === I.projection.name && (T.u_tile_id = [
                u.canonical.x,
                u.canonical.y,
                1 << u.canonical.z
            ], T.u_zoom_transition = f, T.u_inv_rot_matrix = _, T.u_merc_center = p, T.u_up_dir = I.projection.upVector(new Kf(0, 0, 0), p[0] * Sr, p[1] * Sr), T.u_height_lift = c), T;
        }, CE = new Float32Array(16);
        function FE(e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, g, y, x, v, b) {
            const w = t1.context, E = w.gl, A = t1.transform, I = t1.transform.zoom, T = [], M = e1.translate, S = e1.translateAnchor, z = e1.edgeRadius, R = _w(t1, e1.cutoffFadeRange);
            "clear" === c ? (T.push("CLEAR_SUBPASS"), v && (T.push("CLEAR_FROM_TEXTURE"), w.activeTexture.set(E.TEXTURE0), v.bind(E.LINEAR, E.CLAMP_TO_EDGE))) : "sdf" === c ? T.push("SDF_SUBPASS") : "emissive" === c && (T.push("USE_MRT1"), w.activeTexture.set(E.TEXTURE0), v.bind(E.LINEAR, E.CLAMP_TO_EDGE)), y && T.push("HAS_CENTROID"), R.shouldRenderCutoff && T.push("RENDER_CUTOFF");
            const P = (e1, i, r, c, m)=>{
                let x = T;
                null != i.groundRadiusBuffer && (x = T.concat("HAS_ATTRIBUTE_a_flood_light_ground_radius"));
                const b = i.programConfigurations.get(n.id), E = t1.isTileAffectedByFog(e1), A = t1.getOrCreateProgram("fillExtrusionGroundEffect", {
                    config: b,
                    defines: x,
                    overrideFog: E
                }), M = ((e1, t1, i, n, r, o, a, s, l, u)=>({
                        u_matrix: e1,
                        u_opacity: t1,
                        u_ao_pass: i ? 1 : 0,
                        u_meter_to_tile: n,
                        u_ao: r,
                        u_flood_light_intensity: o,
                        u_flood_light_color: a,
                        u_attenuation: s,
                        u_edge_radius: l,
                        u_fb: 0,
                        u_fb_size: u,
                        u_dynamic_offset: 1
                    }))(c, h, u, m, [
                    d,
                    f * m
                ], p, _, g, I >= 17 ? 0 : z * m, v ? v.size[0] : 0), S = [];
                y && S.push(i.hiddenByLandmarkVertexBuffer), null != i.groundRadiusBuffer && S.push(i.groundRadiusBuffer), t1.uploadCommonUniforms(w, A, e1.toUnwrapped(), null, R), A.draw(t1, w.gl.TRIANGLES, o, a, s, l, M, n.id, i.vertexBuffer, i.indexBuffer, r, n.paint, I, b, S);
            };
            for (const e1 of r){
                const r = i.getTile(e1), o = r.getBucket(n);
                if (!o || o.projection.name !== A.projection.name || !o.groundEffect || o.groundEffect && !o.groundEffect.hasData()) continue;
                const a = o.groundEffect, s = 1 / o.tileToMeter;
                {
                    const i = t1.translatePosMatrix(e1.projMatrix, r, M, S), n = a.getDefaultSegment();
                    P(e1, a, n, i, s);
                }
                if (x) for(let o = 0; o < 4; o++){
                    const a = ip[o](e1), l = i.getTile(a);
                    if (!l) continue;
                    const u = l.getBucket(n);
                    if (!u || u.projection.name !== A.projection.name || !u.groundEffect || u.groundEffect && !u.groundEffect.hasData()) continue;
                    const c = u.groundEffect;
                    let h, d;
                    0 === o ? (h = [
                        -8192,
                        0,
                        0
                    ], d = 1) : 1 === o ? (h = [
                        Sr,
                        0,
                        0
                    ], d = 0) : 2 === o ? (h = [
                        0,
                        -8192,
                        0
                    ], d = 3) : (h = [
                        0,
                        Sr,
                        0
                    ], d = 2);
                    const f = c.regionSegments[d];
                    f && (m(CE, e1.projMatrix, h), P(e1, c, f, t1.translatePosMatrix(CE, r, M, S), s));
                }
            }
        }
        const OE = {
            model: (e1)=>({
                    u_matrix: new eh(e1),
                    u_lighting_matrix: new eh(e1),
                    u_normal_matrix: new eh(e1),
                    u_node_matrix: new eh(e1),
                    u_lightpos: new Yc(e1),
                    u_lightintensity: new qc(e1),
                    u_lightcolor: new Yc(e1),
                    u_camera_pos: new Yc(e1),
                    u_opacity: new qc(e1),
                    u_baseColorFactor: new Kc(e1),
                    u_emissiveFactor: new Kc(e1),
                    u_metallicFactor: new qc(e1),
                    u_roughnessFactor: new qc(e1),
                    u_baseTextureIsAlpha: new Wc(e1),
                    u_alphaMask: new Wc(e1),
                    u_alphaCutoff: new qc(e1),
                    u_baseColorTexture: new Wc(e1),
                    u_metallicRoughnessTexture: new Wc(e1),
                    u_normalTexture: new Wc(e1),
                    u_occlusionTexture: new Wc(e1),
                    u_emissionTexture: new Wc(e1),
                    u_lutTexture: new Wc(e1),
                    u_color_mix: new Kc(e1),
                    u_aoIntensity: new qc(e1),
                    u_emissive_strength: new qc(e1),
                    u_occlusionTextureTransform: new Kc(e1),
                    u_dithered_discard_threshold: new qc(e1)
                }),
            modelDepth: (e1)=>({
                    u_matrix: new eh(e1),
                    u_instance: new eh(e1),
                    u_node_matrix: new eh(e1)
                }),
            groundShadow: (e1)=>({
                    u_matrix: new eh(e1),
                    u_ground_shadow_factor: new Yc(e1)
                }),
            fillExtrusionDepth: (e1)=>({
                    u_matrix: new eh(e1),
                    u_edge_radius: new qc(e1),
                    u_width_scale: new qc(e1),
                    u_vertical_scale: new qc(e1),
                    u_height_type: new Wc(e1),
                    u_base_type: new Wc(e1)
                }),
            fillExtrusionGroundEffect: (e1)=>({
                    u_matrix: new eh(e1),
                    u_opacity: new qc(e1),
                    u_ao_pass: new qc(e1),
                    u_meter_to_tile: new qc(e1),
                    u_ao: new Xc(e1),
                    u_flood_light_intensity: new qc(e1),
                    u_flood_light_color: new Yc(e1),
                    u_attenuation: new qc(e1),
                    u_edge_radius: new qc(e1),
                    u_fb: new Wc(e1),
                    u_fb_size: new qc(e1),
                    u_dynamic_offset: new qc(e1)
                })
        };
        function LE(e1) {
            const t1 = e1.properties.get("direction"), i = xt(t1.x, t1.y, t1.z);
            i[2] = tt(i[2], 0, 75);
            const n = yt([
                i[0],
                i[1],
                i[2]
            ]);
            return C(n.x, n.y, n.z);
        }
        function BE(e1, t1, i) {
            const n = "none" === t1.properties.get("color-use-theme"), r = t1.properties.get("color"), o = t1.properties.get("intensity"), a = t1.properties.get("direction"), s = [
                a.x,
                a.y,
                a.z
            ], l = "none" === i.properties.get("color-use-theme"), u = i.properties.get("color"), c = i.properties.get("intensity"), h = Math.max(W([
                0,
                0,
                1
            ], s), 0), d = [
                0,
                0,
                0
            ];
            k(d, u.toPremultipliedRenderColor(l ? null : e1.getLut(t1.scope)).toArray01Linear().slice(0, 3), c);
            const f = [
                0,
                0,
                0
            ];
            return k(f, r.toPremultipliedRenderColor(n ? null : e1.getLut(i.scope)).toArray01Linear().slice(0, 3), h * o), Tt([
                d[0] > 0 ? d[0] / (d[0] + f[0]) : 0,
                d[1] > 0 ? d[1] / (d[1] + f[1]) : 0,
                d[2] > 0 ? d[2] / (d[2] + f[2]) : 0
            ]);
        }
        const NE = [];
        function VE(e1) {
            return NE[e1] = NE[e1] || new Float64Array(16);
        }
        const kE = [], UE = new Float32Array(16);
        class GE {
            constructor(e1, t1){
                this.aabb = e1, this.lastCascade = t1;
            }
        }
        class jE {
            add(e1, t1) {
                const i = this.receivers[e1.key];
                void 0 !== i ? (i.aabb.min[0] = Math.min(i.aabb.min[0], t1.min[0]), i.aabb.min[1] = Math.min(i.aabb.min[1], t1.min[1]), i.aabb.min[2] = Math.min(i.aabb.min[2], t1.min[2]), i.aabb.max[0] = Math.max(i.aabb.max[0], t1.max[0]), i.aabb.max[1] = Math.max(i.aabb.max[1], t1.max[1]), i.aabb.max[2] = Math.max(i.aabb.max[2], t1.max[2])) : this.receivers[e1.key] = new GE(t1, null);
            }
            clear() {
                this.receivers = {};
            }
            get(e1) {
                return this.receivers[e1.key];
            }
            computeRequiredCascades(e1, t1, i) {
                const n = If.fromPoints(e1.points);
                let r = 0;
                for(const e1 in this.receivers){
                    const o = this.receivers[e1];
                    if (!o) continue;
                    if (!n.intersectsAabb(o.aabb)) continue;
                    o.aabb.min = n.closestPoint(o.aabb.min), o.aabb.max = n.closestPoint(o.aabb.max);
                    const a = o.aabb.getCorners();
                    for(let e1 = 0; e1 < i.length; e1++){
                        let n = !0;
                        for (const r of a){
                            const o = [
                                r[0] * t1,
                                r[1] * t1,
                                r[2]
                            ];
                            if (Y(o, o, i[e1].matrix), o[0] < -1 || o[0] > 1 || o[1] < -1 || o[1] > 1) {
                                n = !1;
                                break;
                            }
                        }
                        if (o.lastCascade = e1, r = Math.max(r, e1), n) break;
                    }
                }
                return r + 1;
            }
        }
        function HE(e1, t1, i) {
            const n = q([], te([], i, t1), te([], e1, t1)), r = D(n);
            return 0 === r ? [
                0,
                0,
                1,
                0
            ] : (k(n, n, 1 / r), [
                n[0],
                n[1],
                n[2],
                -W(n, t1)
            ]);
        }
        function $E(e1, t1, i, n, r, o) {
            const a = e1.zoom, s = e1.scale, l = e1.worldSize, u = 1 / l, c = e1.aspect, h = Math.sqrt(1 + c * c) * Math.tan(.5 * e1.fovX), f = h * h, g = n - i, y = n + i;
            let x, v;
            f > g / y ? (x = n, v = n * h) : (x = .5 * y * (1 + f), v = .5 * Math.sqrt(g * g + 2 * (n * n + i * i) * f + y * y * f * f));
            const b = e1.projection.pixelsPerMeter(e1.center.lat, l), w = [
                0,
                0,
                -x * u
            ];
            Y(w, w, e1._camera.getCameraToWorldMercator());
            let E = v * u;
            const A = function(t1) {
                return t1[0] /= s, t1[1] /= s, t1[2] = pu(t1[2], e1._center.lat), t1;
            }, I = e1._edgeInsets;
            if (!(0 === I.left && 0 === I.top && 0 === I.right && 0 === I.bottom || I.left === I.right && I.top === I.bottom)) {
                const t1 = e1._camera.getWorldToCamera(e1.worldSize, "meters" === e1.projection.zAxisUnit ? b : 1), r = e1._camera.getCameraToClipPerspective(e1._fov, e1.width / e1.height, i, n);
                r[8] = 2 * -e1.centerOffset.x / e1.width, r[9] = 2 * e1.centerOffset.y / e1.height;
                const o = new Float64Array(16);
                z(o, r, t1);
                const s = new Float64Array(16);
                p(s, o);
                const u = Af.fromInvProjectionMatrix(s, l, a, !0);
                for (const e1 of u.points){
                    const t1 = A(e1);
                    E = Math.max(E, ne(L([], w, t1)));
                }
            }
            E *= r / (r - 1);
            const T = Math.acos(t1[2]), M = Math.atan2(-t1[0], -t1[1]), S = new Kb;
            S.position = w, S.setPitchBearing(T, M);
            const R = S.getWorldToCamera(l, b), P = E * l, D = Math.min(e1._mercatorZfromZoom(17) * l * -2, -2 * P), F = S.getCameraToClipOrthographic(-P, P, -P, P, D, (P + o * b) / t1[2]), O = new Float64Array(16);
            _(O, F, R);
            const B = .5 * r, N = [
                0,
                0,
                0
            ];
            Y(N, C(Math.floor(1e6 * w[0]) / 1e6 * l, Math.floor(1e6 * w[1]) / 1e6 * l, 0), O), k(N, N, B);
            const V = [
                Math.floor(N[0]),
                Math.floor(N[1]),
                Math.floor(N[2])
            ], U = [
                0,
                0,
                0
            ];
            te(U, N, V), k(U, U, -1 / B);
            const G = new Float64Array(16);
            return d(G), m(G, G, U), _(O, G, O), [
                O,
                P
            ];
        }
        class ZE extends sn {
            constructor(e1, t1, i, n){
                super(), this.id = e1, this.type = "model", this.models = [], this._options = t1, this._modelsInfo = new Map, this._abortController = null;
            }
            cancelModelRequests() {
                this._abortController && (this._abortController.abort(), this._abortController = null);
            }
            async loadGLTFFromURI(e1, t1) {
                return Ng((await this.map._requestManager.transformRequest(e1, ai.Model, t1)).url, t1);
            }
            async loadModel(e1, t1, i) {
                try {
                    const n = await this.loadGLTFFromURI(t1.uri, i);
                    if (i.aborted) return;
                    const r = this._modelsInfo.get(e1);
                    if (!r) return;
                    const o = Sy(n), a = r.modelSpec, s = new ly(e1, a.uri, a.position, a.orientation, o);
                    ZE.applyModelSpecification(s, a), s.computeBoundsAndApplyParent(), this.models.push(s), r.model = s;
                } catch (n) {
                    if (i.aborted) return;
                    this.fire(new rn(new Error(`Could not load model ${e1} from ${t1.uri}`, {
                        cause: n
                    })));
                }
            }
            async load() {
                this._abortController || (this._abortController = new AbortController);
                const e1 = this._abortController.signal, t1 = [];
                for(const i in this._options.models){
                    const n = this._options.models[i], r = this._modelsInfo.get(i);
                    if (r && r.model) {
                        r.modelSpec = n;
                        const e1 = r.model;
                        e1.position = null != n.position ? new hu(n.position[0], n.position[1]) : new hu(0, 0), e1.orientation = n.orientation ?? [
                            0,
                            0,
                            0
                        ], ZE.applyModelSpecification(e1, n), e1.computeBoundsAndApplyParent(), this.models.push(e1);
                    } else r ? r.modelSpec = n : (this._modelsInfo.set(i, {
                        modelSpec: n,
                        model: null
                    }), t1.push(this.loadModel(i, n, e1)));
                }
                0 !== t1.length ? (await Promise.allSettled(t1), e1.aborted || this.fire(new nn("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                }))) : this.loaded() && this.fire(new nn("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                }));
            }
            static arrayFromColorSpecification(e1) {
                const t1 = e1;
                if (void 0 === t1) return;
                if (Array.isArray(t1)) return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
                const i = pn.parse(t1);
                return i ? [
                    i.r,
                    i.g,
                    i.b
                ] : void 0;
            }
            static applyModelSpecification(e1, t1) {
                if (t1.nodeOverrides && ZE.convertNodeOverrides(e1, t1.nodeOverrides), t1.materialOverrides && ZE.convertMaterialOverrides(e1, t1.materialOverrides), t1.nodeOverrideNames && (e1.nodeOverrideNames = [
                    ...t1.nodeOverrideNames
                ]), t1.materialOverrideNames && (e1.materialOverrideNames = [
                    ...t1.materialOverrideNames
                ]), t1.featureProperties && (e1.featureProperties = t1.featureProperties), t1.lightOverrides) {
                    const i = t1.lightOverrides, n = ZE.arrayFromColorSpecification(i["light-ambient-color"]), r = ZE.arrayFromColorSpecification(i["light-directional-color"]);
                    e1.lightOverrides = {
                        ambientIntensity: i["light-ambient-intensity"],
                        ambientColor: n,
                        directionalIntensity: i["light-directional-intensity"],
                        directionalColor: r
                    };
                } else e1.lightOverrides = void 0;
            }
            static convertNodeOverrides(e1, t1) {
                if (Array.isArray(t1) && t1.every((e1)=>"string" == typeof e1)) {
                    e1.nodeOverrideNames = [];
                    for (const i of t1)e1.nodeOverrideNames.push(i);
                } else Object.entries(t1).forEach(([t1, i])=>{
                    const n = {
                        orientation: [
                            0,
                            0,
                            0
                        ],
                        minZoom: void 0,
                        maxZoom: void 0
                    };
                    if (Object.hasOwn(i, "orientation")) {
                        const e1 = i.orientation;
                        e1 && (n.orientation = e1);
                    }
                    Object.hasOwn(i, "minzoom") && (n.minZoom = i.minzoom), Object.hasOwn(i, "maxzoom") && (n.maxZoom = i.maxzoom), e1.nodeOverrides.set(t1, n);
                });
            }
            static convertMaterialOverrides(e1, t1) {
                if (Array.isArray(t1) && t1.every((e1)=>"string" == typeof e1)) {
                    e1.materialOverrideNames = [];
                    for (const i of t1)e1.materialOverrideNames.push(i);
                } else Object.entries(t1).forEach(([t1, i])=>{
                    const n = ZE.arrayFromColorSpecification(i["model-color"]), r = {
                        color: void 0 !== n ? new pn(n[0], n[1], n[2]) : new pn(1, 1, 1),
                        colorMix: 0,
                        emissionStrength: 0,
                        opacity: 1
                    }, o = i["model-color-mix-intensity"];
                    void 0 !== o && (r.colorMix = o);
                    const a = i["model-emissive-strength"];
                    void 0 !== a && (r.emissionStrength = a);
                    const s = i["model-opacity"];
                    void 0 !== s && (r.opacity = s), e1.materialOverrides.set(t1, r);
                });
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            hasTransition() {
                return !1;
            }
            loaded() {
                if (0 === this._modelsInfo.size) return !0;
                for (const e1 of this._modelsInfo.values())if (null == e1.model) return !1;
                return !0;
            }
            getModels() {
                return this.models;
            }
            loadTile(e1, t1) {}
            serialize() {
                return this._options;
            }
            setProperty(e1, t1) {
                return !1;
            }
            reload() {
                this.cancelModelRequests();
                const e1 = ml(this.id, this.scope);
                this.map.style.clearSource(e1), this.models = [], this._modelsInfo.clear(), this.load();
            }
            onRemove(e1) {
                this.cancelModelRequests();
            }
            setModels(e1) {
                this.models = [];
                const t1 = new Map;
                for(const i in e1){
                    const n = e1[i], r = this._modelsInfo.get(i);
                    r && r.modelSpec.uri === n.uri && t1.set(i, r);
                }
                if (this._modelsInfo.size !== t1.size) {
                    this.cancelModelRequests();
                    for (const [e1, i] of t1)i.model || t1.delete(e1);
                }
                this._modelsInfo = t1, this._options.models = e1, this.load();
            }
        }
        function WE(e1, t1, i) {
            try {
                t1 = function(e1) {
                    if (!e1.variants) return e1;
                    if (!Array.isArray(e1.variants)) throw new Error("variants must be an array");
                    for (const t1 of e1.variants){
                        if (null == t1 || "object" != typeof t1 || t1.constructor !== Object) throw new Error("variant must be an object");
                        if (!Array.isArray(t1.capabilities)) throw new Error("capabilities must be an array");
                        if (1 === t1.capabilities.length && "meshopt" === t1.capabilities[0]) return Object.assign(e1, t1);
                    }
                    return e1;
                }(t1);
            } catch (e1) {
                return new Error("Failed to process TileJSON variants", {
                    cause: e1
                });
            }
            const n = ot({
                ...t1,
                ...e1
            }, [
                "tilejson",
                "tiles",
                "minzoom",
                "maxzoom",
                "attribution",
                "mapbox_logo",
                "bounds",
                "extra_bounds",
                "scheme",
                "tileSize",
                "encoding",
                "vector_layers",
                "raster_layers",
                "worldview_options",
                "worldview_default",
                "worldview"
            ]);
            return e1.url && t1.tiles && e1.tiles && (n.tiles = t1.tiles), n.tiles = i.canonicalizeTileset(n, e1.url), n;
        }
        function qE(e1, t1, i, n, r) {
            const o = function(i, n) {
                if (i) return r(i);
                if (n) {
                    e1.url && n.tiles && e1.tiles && delete e1.tiles;
                    const i = WE(e1, n, t1);
                    if (i instanceof Error) return r(i);
                    r(null, i);
                }
            }, a = function(e1, t1, i) {
                if (!e1) return null;
                if (!t1 && !i) return e1;
                i = i || e1.worldview_default;
                const n = Object.values(e1.language || {});
                if (0 === n.length) return null;
                const r = Object.values(e1.worldview || {});
                if (0 === r.length) return null;
                const o = n.every((e1)=>e1 === t1), a = r.every((e1)=>e1 === i);
                return o && a ? e1 : t1 in (e1.language_options || {}) || i in (e1.worldview_options || {}) ? null : e1.language_options && e1.worldview_options ? e1 : null;
            }(e1.data, i, n);
            if (a) return Vt.frame(()=>o(null, a));
            if (e1.url) {
                const r = new AbortController;
                return (async ()=>{
                    const a = await t1.transformRequest(t1.normalizeSourceURL(e1.url, null, i, n), ai.Source, r.signal), { data: s } = await pi(a, r.signal);
                    o(null, s);
                })().catch((e1)=>{
                    r.signal.aborted || o(e1);
                }), {
                    cancel: ()=>r.abort()
                };
            }
            return Vt.frame(()=>{
                const { data: t1, ...i } = e1;
                o(null, i);
            });
        }
        function XE(e1, t1) {
            const i = Math.pow(2, t1.z), n = Math.floor(hr(e1.getWest()) * i), r = Math.floor(dr(e1.getNorth()) * i), o = Math.ceil(hr(e1.getEast()) * i), a = Math.ceil(dr(e1.getSouth()) * i);
            return t1.x >= n && t1.x < o && t1.y >= r && t1.y < a;
        }
        class YE {
            constructor(e1, t1, i){
                this.bounds = e1 ? du.convert(this.validateBounds(e1)) : null, this.minzoom = t1 || 0, this.maxzoom = i || 24;
            }
            validateBounds(e1) {
                return Array.isArray(e1) && 4 === e1.length ? [
                    Math.max(-180, e1[0]),
                    Math.max(-90, e1[1]),
                    Math.min(180, e1[2]),
                    Math.min(90, e1[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            addExtraBounds(e1) {
                if (e1) {
                    this.extraBounds || (this.extraBounds = []);
                    for (const t1 of e1)this.extraBounds.push(du.convert(this.validateBounds(t1)));
                }
            }
            contains(e1) {
                if (e1.z > this.maxzoom || e1.z < this.minzoom) return !1;
                if (this.bounds && !XE(this.bounds, e1)) return !1;
                if (!this.extraBounds) return !0;
                for (const t1 of this.extraBounds)if (XE(t1, e1)) return !0;
                return !1;
            }
            static fromTileJSON(e1) {
                if (!e1.bounds && !e1.extra_bounds) return null;
                const t1 = new YE(e1.bounds, e1.minzoom, e1.maxzoom);
                return t1.addExtraBounds(e1.extra_bounds), t1;
            }
        }
        const JE = {
            loaded: !0,
            drawModels: function(e1, t1, i, n) {
                if ("opaque" === e1.renderPass) return;
                const r = i.paint.get("model-opacity").constantOr(1), o = i.paint.get("model-elevation-reference"), a = "ground" === o, s = "ground" === o;
                if (0 === r) return;
                const l = i.paint.get("model-cast-shadows");
                if ("shadow" === e1.renderPass) {
                    if (!l) return;
                    if (e1.terrain && r < .65 && i._transitionablePaint._values["model-opacity"].value.expression instanceof Na) return;
                }
                const c = e1.shadowRenderer, h = i.paint.get("model-receive-shadows");
                c && (c.useNormalOffset = !0, h || (c.enabled = !1));
                const d = ()=>{
                    c && (c.useNormalOffset = !0, h || (c.enabled = !0));
                }, m = t1.getSource();
                if ("light-beam" === e1.renderPass && "batched-model" !== m.type) return;
                if ("vector" === m.type || "geojson" === m.type) return function(e1, t1, i, n, r) {
                    const o = e1.transform, a = "globe" === o.projection.name, s = o.getFreeCameraOptions().position;
                    if (!e1.modelManager) return;
                    const l = e1.modelManager;
                    i.modelManager = l;
                    const c = e1.shadowRenderer;
                    if (!Object.hasOwn(i._unevaluatedLayout._values, "model-id")) return;
                    const h = i._unevaluatedLayout._values["model-id"], d = {
                        ...i.layout.get("model-id").parameters
                    }, f = e1.style.order.indexOf(i.fqid), p = i.paint.get("model-opacity").constantOr(1);
                    for (const _ of n){
                        const n = t1.getTile(_).getBucket(i);
                        if (!n || n.projection.name !== o.projection.name) continue;
                        const m = n.getModelUris();
                        if (m && !n.modelsRequested && (l.addModelsFromBucket(m, r), n.modelsRequested = !0), a) d.zoom = _.overscaledZ;
                        else {
                            const e1 = Zw(_, o);
                            d.zoom = e1;
                        }
                        const g = h.possiblyEvaluate(d);
                        if (Hw(e1, n, _), $w.shadowUniformsInitialized = !1, $w.useSingleShadowCascade = !!c && 0 === c.getMaxCascadeForTile(_.toUnwrapped()), "shadow" === e1.renderPass && c) {
                            if (1 === e1.currentShadowCascade && n.isInsideFirstShadowMapFrustum) continue;
                            const t1 = o.calculatePosMatrix(_.toUnwrapped(), o.worldSize);
                            if ($w.tileMatrix.set(t1), $w.shadowTileMatrix.set(c.calculateShadowPassMatrixFromMatrix(t1)), $w.aabb.min = [
                                0,
                                0,
                                0
                            ], $w.aabb.max[0] = $w.aabb.max[1] = Sr, $w.aabb.max[2] = 0, Xw(n, $w, e1, i.scope)) continue;
                        }
                        const y = 1 << _.canonical.z, x = [
                            ((s.x - _.wrap) * y - _.canonical.x) * Sr,
                            (s.y * y - _.canonical.y) * Sr,
                            s.z * y * Sr
                        ];
                        e1.conflationActive && Object.keys(n.instancesPerModel).length > 0 && e1.style.isLayerClipped(i, t1.getSource()) && n.updateReplacement(_, e1.replacementSource, f, i.scope) && (n.uploaded = !1, n.upload(e1.context));
                        let v = 0;
                        const E = new Array, T = new Array, M = new Array;
                        for(let t1 in n.instancesPerModel){
                            const o = n.instancesPerModel[t1];
                            o.features.length > 0 && !a && (t1 = g.evaluate(o.features[0].feature, {}));
                            const c = l.getModel(t1, r);
                            if (c || l.hasURLBeenRequested(t1) || n.modelUris.includes(t1) || (n.modelUris.push(t1), n.modelsRequested = !1), c && c.uploaded) {
                                if (a) {
                                    const t1 = k([], [
                                        s.x,
                                        s.y,
                                        s.z
                                    ], e1.transform.worldSize);
                                    $(t1, t1);
                                    for(let i = 0; i < o.instancedDataArray.length; ++i){
                                        const r = [
                                            0,
                                            0,
                                            0
                                        ], a = [
                                            1,
                                            1,
                                            1
                                        ], s = ue(), l = o.tileCoordinatesForInstance(i), h = o.transformForInstance(i);
                                        A(a, h), I(s, h), he(r, s);
                                        const d = o.translationForInstance(i), f = new hu(0, 0);
                                        xw(n.canonical, f, l.x, l.y);
                                        const _ = u();
                                        sy(_, c, e1.transform, f, r, a, d, !0, !1, !1);
                                        const m = o.colorForInstance(i), g = b([], t1), y = w([], [
                                            1,
                                            1,
                                            1 / yu(f.lat, e1.transform.zoom)
                                        ]);
                                        M.push({
                                            zScaleMatrix: y,
                                            negCameraPosMatrix: g
                                        });
                                        for (const t1 of c.nodes)Nw(e1, t1, _, e1.transform.expandedFarZProjMatrix, v, E, T, c.materialOverrides, p, m);
                                        ++v;
                                    }
                                } else for (const t1 of c.nodes)Ww(e1, i, t1, o, x, _, $w);
                            }
                        }
                        if (a) {
                            if ("shadow" === e1.renderPass) {
                                for (const t1 of T)Vw(t1.mesh, t1.nodeModelMatrix, e1, i);
                                for (const t1 of E)Vw(t1.mesh, t1.nodeModelMatrix, e1, i);
                            } else jw(e1, i, E, T, M);
                        }
                    }
                }(e1, t1, i, n, Bw(e1, i)), void d();
                if (!m.loaded()) return;
                if ("batched-model" === m.type) return function(e1, t1, i, n) {
                    i.resetLayerRenderingStats(e1);
                    const r = e1.context, o = e1.transform, a = e1.style.fog, s = e1.shadowRenderer;
                    if ("mercator" !== o.projection.name) return void mt(`Drawing 3D landmark models for ${o.projection.name} projection is not yet implemented`);
                    const l = e1.transform.getFreeCameraOptions().position, u = k([], [
                        l.x,
                        l.y,
                        l.z
                    ], e1.transform.worldSize), c = b([], $([], u)), h = yu(o.center.lat, o.zoom), d = _([], c, w([], [
                        1,
                        1,
                        1 / h
                    ])), m = i.paint.get("model-opacity").constantOr(1), y = new jb(r.gl.LEQUAL, jb.ReadWrite, e1.depthRangeFor3D), x = new jb(r.gl.LEQUAL, jb.ReadOnly, e1.depthRangeFor3D), v = new If([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]), E = "shadow" === e1.renderPass, A = "light-beam" === e1.renderPass, I = "none" === i.paint.get("model-color-use-theme").constantOr("default"), T = E && s ? s.getCurrentCascadeFrustum() : o.getFrustum(o.scaleZoom(o.worldSize)), M = i.paint.get("model-front-cutoff"), S = M[2] < 1, z = _w(e1, i.paint.get("model-cutoff-fade-range")), P = i.getLayerRenderingStats();
                    (function(e1, t1, i, n) {
                        const r = e1.terrain ? e1.terrain.exaggeration() : 0, o = e1.transform.zoom;
                        for (const a of n){
                            const n = t1.getTile(a).getBucket(i);
                            n && (n.setFilter(i.filter), e1.conflationActive && n.updateReplacement(a, e1.replacementSource), n.evaluateTransform(e1, i), e1.terrain && r > 0 && n.elevationUpdate(e1.terrain, r, a, i.source), n.needsReEvaluation(e1, o, i) && n.evaluate(i));
                        }
                    })(e1, t1, i, n), function() {
                        const l = new Map;
                        let c, b, w;
                        S ? (c = n.length - 1, b = -1, w = -1) : (c = 0, b = n.length, w = 1);
                        const D = R(), C = new Pe(0, 0);
                        for(let R = c; R !== b; R += w){
                            const c = n[R], b = t1.getTile(c).getBucket(i);
                            if (!b || !b.uploaded) continue;
                            let w = !1;
                            s && (w = 0 === s.getMaxCascadeForTile(c.toUnwrapped()));
                            const F = o.calculatePosMatrix(c.toUnwrapped(), o.worldSize), O = !!(4 & b.modelTraits);
                            _(Aw, d, F), _(Iw, o.expandedFarZProjMatrix, F), p(Tw, Aw), f(Tw, Tw);
                            const L = !E && s && s.enabled ? s.computeCascadeTileMatrices(F) : null;
                            !E && S && (p(ww, F), Y(D, u, ww), C.x = D[0], C.y = D[1]);
                            const B = [];
                            b.setFilter(i.filter);
                            for (const t1 of b.getNodesInfo()){
                                if (t1.hiddenByReplacement) continue;
                                if (!t1.node.meshes) continue;
                                const i = t1.node;
                                let n = 0;
                                e1.terrain && i.elevation && (n = i.elevation * e1.terrain.exaggeration());
                                const r = ()=>{
                                    const e1 = t1.aabb, i = v.min, r = v.max;
                                    return i[0] = e1.min[0], i[1] = e1.min[1], i[2] = e1.min[2] + n, r[0] = e1.max[0], r[1] = e1.max[1], r[2] = e1.max[2] + n, Y(i, i, F), Y(r, r, F), v;
                                }, a = r(), s = t1.evaluatedScale;
                                if (s[0] <= 1 && s[1] <= 1 && s[2] <= 1 && 0 === a.intersects(T)) continue;
                                if (!E) {
                                    const i = a.min, n = a.max;
                                    Rw[0] = .5 * (i[0] + n[0]), Rw[1] = .5 * (i[1] + n[1]), Rw[2] = .5 * (i[2] + n[2]);
                                    const r = G(u, Rw) * h, o = e1._debugParams.lodSwitchDistance, l = o >= 0;
                                    if (l && o >= 9999) t1.targetLod = 0;
                                    else {
                                        let a;
                                        if (l) a = o;
                                        else {
                                            const e1 = (n[2] - i[2]) * h * s[2], t1 = Math.max(n[0] - i[0], n[1] - i[1]) * h * Math.max(s[0], s[1]);
                                            let r;
                                            r = e1 >= 30 ? 1 : t1 >= 80 ? .5 : Math.max(e1, t1) >= 20 ? .25 : 0, a = 2e3 + 3e3 * r;
                                        }
                                        qw(t1, r, Math.min(e1.frameTimeDelta, 1e3 / 30), a, e1._debugParams.lodSwitchFadeDuration);
                                    }
                                }
                                if (!E && S) {
                                    const e1 = 1 / 6;
                                    t1.cameraCollisionOpacity = u[0] > a.min[0] && u[0] < a.max[0] && u[1] > a.min[1] && u[1] < a.max[1] && u[2] * h < a.max[2] && i.footprint && Np(C, i.footprint) ? Math.max(t1.cameraCollisionOpacity - e1, 0) : Math.min(1, t1.cameraCollisionOpacity + e1);
                                }
                                const l = 1 / vu(c.canonical), d = i.anchor ? i.anchor[0] : 0, f = i.anchor ? i.anchor[1] : 0, p = [
                                    d * (s[0] - 1) + t1.evaluatedTranslation[0] * l,
                                    f * (s[1] - 1) + t1.evaluatedTranslation[1] * l,
                                    n + t1.evaluatedTranslation[2]
                                ], g = Fw(new Float64Array(16), F, p, s), y = _([], g, i.globalMatrix), x = _([], o.expandedFarZProjMatrix, y), b = x[2] * d + x[6] * f + x[10] * n + x[14];
                                i.hidden = !1;
                                let w = m;
                                E || (S && (w *= t1.cameraCollisionOpacity, w *= Jw(g, o, t1.aabb, M)), w *= Yw(z, b)), 0 !== w ? B.push({
                                    nodeInfo: t1,
                                    depth: b,
                                    opacity: w,
                                    wvpForNode: x,
                                    nodeModelMatrix: y,
                                    tileModelMatrix: g,
                                    tileTranslation: p
                                }) : i.hidden = !0;
                            }
                            E || B.sort((e1, t1)=>!S || 1 === e1.opacity && 1 === t1.opacity ? e1.depth < t1.depth ? -1 : 1 : 1 === e1.opacity ? -1 : 1 === t1.opacity ? 1 : e1.depth > t1.depth ? -1 : 1);
                            for (const t1 of B){
                                const n = t1.nodeInfo, u = n.node;
                                let c = null;
                                if (e1._debugParams.show3DModelFootprints && u.footprint) {
                                    const e1 = u.id || u.name || "footprint";
                                    if (!l.has(e1)) {
                                        const i = Fw(new Float64Array(16), Iw, t1.tileTranslation, t1.nodeInfo.evaluatedScale);
                                        l.set(e1, {
                                            node: u,
                                            mvp: i
                                        });
                                    }
                                }
                                const h = t1.nodeInfo.evaluatedScale;
                                Fw(bw, Aw, t1.tileTranslation, h), Sw[0] = 1 / h[0], Sw[1] = -1 / h[1], Sw[2] = 1 / h[2], g(ww, Tw, Sw), _(bw, bw, u.globalMatrix);
                                const d = O ? 0 : n.evaluatedRMEA[0][2], f = n.targetLod, p = u.lodMeshes && u.lodMeshes.length > 0, m = p && f > 0 && f < 1;
                                if (E && p && 1 === Math.round(f)) continue;
                                const v = !E && a ? Cw(Ew, t1.nodeModelMatrix, e1.transform) : null, b = E && s ? s.calculateShadowPassMatrixFromMatrix(t1.nodeModelMatrix) : null, T = m ? 2 : 1, M = p && 1 === Math.round(f);
                                for(let l = 0; l < T; ++l){
                                    const h = m ? 1 === l : M, p = h ? u.lodMeshes : u.meshes, _ = m ? h ? -f : 1 - f : 1;
                                    for(let l = 0; l < p.length; ++l){
                                        const f = p[l], g = !h && l === u.lightMeshIndex;
                                        let T = t1.wvpForNode;
                                        if (g) {
                                            if (!A && !e1.terrain && e1.shadowRenderer) {
                                                e1.currentLayer < e1.firstLightBeamLayer && (e1.firstLightBeamLayer = e1.currentLayer);
                                                continue;
                                            }
                                            T = Fw(Mw, Iw, t1.tileTranslation, t1.nodeInfo.evaluatedScale);
                                        } else if (A) continue;
                                        const M = {
                                            defines: []
                                        }, S = [], z = !!f.normalBuffer;
                                        if (!E && s && (s.useNormalOffset = z), Ow(M.defines, S, f, e1, I ? null : i.lut), O || M.defines.push("DIFFUSE_SHADED"), w && M.defines.push("SHADOWS_SINGLE_CASCADE"), P && (E ? P.numRenderedVerticesInShadowPass += f.vertexArray.length : P.numRenderedVerticesInTransparentPass += f.vertexArray.length), E) {
                                            Vw(f, t1.nodeModelMatrix, e1, i, b);
                                            continue;
                                        }
                                        if (a && "globe" !== o.projection.name) {
                                            const e1 = f.aabb.min, t1 = f.aabb.max, [i, n] = a.getOpacityForBounds(v, e1[0], e1[1], t1[0], t1[1]);
                                            M.overrideFog = i >= mw || n >= mw;
                                        }
                                        const R = f.material;
                                        let D;
                                        R.occlusionTexture && R.occlusionTexture.offsetScale && (D = R.occlusionTexture.offsetScale, M.defines.push("OCCLUSION_TEXTURE_TRANSFORM")), m && M.defines.push("DITHERED_DISCARD");
                                        const C = e1.getOrCreateProgram("model", M);
                                        if (!E && s && s.enabled) {
                                            if (c !== z) {
                                                for(let e1 = 0; e1 < L.length; e1++)Fw(Dw[e1] = Dw[e1] || new Float64Array(16), L[e1], t1.tileTranslation, t1.nodeInfo.evaluatedScale);
                                                s.setupShadowsFromCascadeMatrices(Dw, C, z), c = z;
                                            } else C.setShadowUniformValues(r, s.getShadowUniformValues());
                                        }
                                        e1.uploadCommonUniforms(r, C, null, v);
                                        const F = R.pbrMetallicRoughness;
                                        F.metallicFactor = .9, F.roughnessFactor = .5;
                                        const B = Lb(T, bw, ww, u.globalMatrix, e1, t1.opacity, F.baseColorFactor, R.emissiveFactor, F.metallicFactor, F.roughnessFactor, R, d, i, Pw, D, void 0, void 0, _, C.fixedDefines.includes("LIGHTING_3D_MODE"));
                                        !g && (n.hasTranslucentParts || t1.opacity < 1) && C.draw(e1, r.gl.TRIANGLES, y, Vb.disabled, Gb.disabled, Zb.backCCW, B, i.id, f.vertexBuffer, f.indexBuffer, f.segments, i.paint, e1.transform.zoom, void 0, S), C.draw(e1, r.gl.TRIANGLES, g ? x : y, Vb.disabled, g || t1.opacity < 1 || n.hasTranslucentParts ? Gb.alphaBlended : Gb.unblended, Zb.backCCW, B, i.id, f.vertexBuffer, f.indexBuffer, f.segments, i.paint, e1.transform.zoom, void 0, S);
                                    }
                                }
                            }
                        }
                        if (e1._debugParams.show3DModelFootprints && l.size > 0) {
                            const t1 = Array.from(l.keys()).sort();
                            for (const i of t1){
                                const { node: t1, mvp: n } = l.get(i);
                                kw(e1, 0, t1, n);
                            }
                        }
                    }();
                }(e1, t1, i, n), void d();
                if ("model" !== m.type) return;
                const y = m.getModels(), x = [], v = e1.transform.getFreeCameraOptions().position, E = k([], [
                    v.x,
                    v.y,
                    v.z
                ], e1.transform.worldSize);
                $(E, E);
                const T = [], M = [];
                let S = 0;
                for (const n of y){
                    const r = t1.getFeatureState("", n.id), o = {
                        type: "Unknown",
                        id: n.id,
                        properties: n.featureProperties
                    }, l = i.paint.get("model-rotation").evaluate(o, r), u = i.paint.get("model-scale").evaluate(o, r), c = i.paint.get("model-translation").evaluate(o, r), h = i.paint.get("model-opacity").evaluate(o, r);
                    Uw(i, n.id, r, n.featureProperties, n.nodeOverrideNames, n.nodeOverrides), Gw(i, n.id, r, n.featureProperties, n.materialOverrideNames, n.materialOverrides), n.nodeOverrides.size > 0 && n.computeBoundsAndApplyParent(), n.computeModelMatrix(e1, l, u, c, s, a, !1);
                    const d = b([], E), f = w([], [
                        1,
                        1,
                        1 / yu(n.position.lat, e1.transform.zoom)
                    ]);
                    x.push({
                        zScaleMatrix: f,
                        negCameraPosMatrix: d
                    });
                    for (const t1 of n.nodes)Nw(e1, t1, n.matrix, e1.transform.expandedFarZProjMatrix, S, T, M, n.materialOverrides, h, void 0, n.lightOverrides);
                    S++;
                }
                if (T.sort((e1, t1)=>t1.depth - e1.depth), "shadow" !== e1.renderPass) {
                    if (e1._debugParams.show3DModelFootprints) {
                        const t1 = e1.transform.projMatrix, i = new Map, n = (e1, n)=>{
                            if (e1.footprint) {
                                const r = e1.id || e1.name || "footprint";
                                if (!i.has(r)) {
                                    const o = _([], t1, n);
                                    i.set(r, {
                                        node: e1,
                                        mvp: o
                                    });
                                }
                            }
                        };
                        for (const e1 of M)n(e1.node, e1.modelMatrix);
                        for (const e1 of T)n(e1.node, e1.modelMatrix);
                        const r = Array.from(i.keys()).sort();
                        for (const t1 of r){
                            const { node: n, mvp: r } = i.get(t1);
                            kw(e1, 0, n, r);
                        }
                    }
                    jw(e1, i, T, M, x), d();
                } else {
                    for (const t1 of M)Vw(t1.mesh, t1.nodeModelMatrix, e1, i);
                    for (const t1 of T)Vw(t1.mesh, t1.nodeModelMatrix, e1, i);
                    d();
                }
            },
            prepare: function(e1, t1, i) {
                const n = t1.getSource();
                if (!n.loaded()) return;
                if ("vector" === n.type || "geojson" === n.type) return void (i.modelManager && i.modelManager.upload(i, Bw(i, e1)));
                if ("batched-model" === n.type) return;
                if ("model" !== n.type) return;
                const r = n.getModels();
                for (const e1 of r)e1.upload(i.context);
            },
            shaders: TE,
            programUniforms: OE,
            ShadowRenderer: class {
                constructor(e1){
                    this.painter = e1, this._enabled = !1, this._drawShadowAfterLayer = -1, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new jE, this._depthMode = new jb(e1.context.gl.LEQUAL, jb.ReadWrite, [
                        0,
                        1
                    ]), this._uniformValues = {
                        u_light_matrix_0: new Float32Array(16),
                        u_light_matrix_1: new Float32Array(16),
                        u_shadow_intensity: 0,
                        u_fade_range: [
                            0,
                            0
                        ],
                        u_shadow_normal_offset: [
                            1,
                            1,
                            1
                        ],
                        u_shadow_texel_size: 1,
                        u_shadow_map_resolution: 1,
                        u_shadow_direction: [
                            0,
                            0,
                            1
                        ],
                        u_shadow_bias: [
                            36e-5,
                            .0012,
                            .012
                        ],
                        u_shadowmap_0: 0,
                        u_shadowmap_1: 0
                    }, this._forceDisable = !1, this._devtoolsFolder = null, this.useNormalOffset = !1, this._shadowParameters = {
                        cascadeCount: 2,
                        normalOffset: 3,
                        shadowMapResolution: 2048
                    };
                }
                destroy() {
                    for (const e1 of this._cascades)e1.texture.destroy(), e1.framebuffer.destroy();
                    this._cascades = [];
                }
                updateShadowParameters(e1, t1) {
                    const i = this.painter;
                    if (this._enabled = !1, this._drawShadowAfterLayer = -1, this._receivers.clear(), !t1 || !t1.properties) return;
                    const n = t1.properties.get("shadow-intensity"), r = t1.properties.get("shadow-draw-before-layer");
                    if (!t1.shadowsEnabled() || n <= 0) return;
                    let o = -1, a = 0;
                    for (const t1 of i.style.order){
                        const n = i.style._mergedLayers[t1];
                        n.hasShadowPass() && !n.isHidden(e1.zoom) && (o = a), !r || r !== t1 && r !== n.slot || (this._drawShadowAfterLayer = a > 0 ? a - 1 : 0), a += 1;
                    }
                    if (this._enabled = o >= 0, !this.enabled) return;
                    this._drawShadowAfterLayer < 0 && (this._drawShadowAfterLayer = o);
                    const s = i.context, l = this._shadowParameters.shadowMapResolution, u = this._shadowParameters.shadowMapResolution;
                    if (0 === this._cascades.length || this._shadowParameters.shadowMapResolution !== this._cascades[0].texture.size[0]) {
                        this._cascades = [];
                        for(let e1 = 0; e1 < this._shadowParameters.cascadeCount; ++e1){
                            const e1 = s.gl, t1 = s.createFramebuffer(l, u, 0, "texture"), i = new c_(s, {
                                width: l,
                                height: u,
                                data: null
                            }, e1.DEPTH_COMPONENT16);
                            t1.depthAttachment.set(i.texture), this._cascades.push({
                                framebuffer: t1,
                                texture: i,
                                matrix: [],
                                far: 0,
                                boundingSphereRadius: 0,
                                frustum: new Af,
                                scale: 0
                            });
                        }
                    }
                    this.shadowDirection = LE(t1);
                    let c = 0;
                    if (e1.elevation) {
                        const t1 = e1.elevation, i = [
                            1e4,
                            -10000
                        ];
                        t1.visibleDemTiles.filter((e1)=>e1.dem).forEach((e1)=>{
                            const t1 = e1.dem.tree;
                            i[0] = Math.min(i[0], t1.minimums[0]), i[1] = Math.max(i[1], t1.maximums[0]);
                        }), 1e4 !== i[0] && (c = (i[1] - i[0]) * t1.exaggeration());
                    }
                    const h = 1.5 * e1.cameraToCenterDistance, d = 3 * h, f = new Float64Array(16);
                    for(let t1 = 0; t1 < this._cascades.length; ++t1){
                        const i = this._cascades[t1];
                        let n = e1.height / 50, r = 1;
                        1 === this._shadowParameters.cascadeCount ? r = d : 0 === t1 ? r = h : (n = h, r = d);
                        const [o, a] = $E(e1, this.shadowDirection, n, r, this._shadowParameters.shadowMapResolution, c);
                        i.scale = e1.scale, i.matrix = o, i.boundingSphereRadius = a, p(f, i.matrix), i.frustum = Af.fromInvProjectionMatrix(f, 1, 0, !0), i.far = r;
                    }
                    const _ = this._cascades.length - 1;
                    this._uniformValues.u_fade_range = [
                        .75 * this._cascades[_].far,
                        this._cascades[_].far
                    ], this._uniformValues.u_shadow_intensity = n, this._uniformValues.u_shadow_direction = [
                        this.shadowDirection[0],
                        this.shadowDirection[1],
                        this.shadowDirection[2]
                    ], this._uniformValues.u_shadow_texel_size = 1 / this._shadowParameters.shadowMapResolution, this._uniformValues.u_shadow_map_resolution = this._shadowParameters.shadowMapResolution, this._uniformValues.u_shadowmap_0 = Cb.ShadowMap0, this._uniformValues.u_shadowmap_1 = Cb.ShadowMap0 + 1, this._groundShadowTiles = i.transform.coveringTiles({
                        tileSize: 512,
                        renderWorldCopies: !0
                    });
                    const m = i.transform.elevation;
                    for (const e1 of this._groundShadowTiles){
                        let t1 = {
                            min: 0,
                            max: 0
                        };
                        if (m) {
                            const i = m.getMinMaxForTile(e1);
                            i && (t1 = i);
                        }
                        this.addShadowReceiver(e1.toUnwrapped(), t1.min, t1.max);
                    }
                }
                get enabled() {
                    return this._enabled && !this._forceDisable;
                }
                set enabled(e1) {
                    this._enabled = e1;
                }
                drawShadowPass(e1, t1) {
                    if (!this.enabled) return;
                    const i = this.painter, n = i.context;
                    this._numCascadesToRender = this._receivers.computeRequiredCascades(i.transform.getFrustum(0), i.transform.worldSize, this._cascades), n.viewport.set([
                        0,
                        0,
                        this._shadowParameters.shadowMapResolution,
                        this._shadowParameters.shadowMapResolution
                    ]);
                    for(let r = 0; r < this._numCascadesToRender; ++r){
                        i.currentShadowCascade = r, n.bindFramebuffer.set(this._cascades[r].framebuffer.framebuffer), n.clear({
                            color: pn.white,
                            depth: 1
                        });
                        for (const n of e1.order){
                            const r = e1._mergedLayers[n];
                            if (!r.hasShadowPass() || r.isHidden(i.transform.zoom)) continue;
                            const o = e1.getLayerSourceCache(r), a = o ? t1[o.id] : void 0;
                            ("model" === r.type || a && a.length) && i.renderLayer(i, o, r, a);
                        }
                    }
                    i.currentShadowCascade = 0;
                }
                drawGroundShadows() {
                    if (!this.enabled) return;
                    const e1 = this.painter, t1 = e1.style, i = e1.context, n = i.gl, r = t1.directionalLight, o = t1.ambientLight;
                    if (!r || !o) return;
                    const a = [], s = _w(e1, e1.longestCutoffRange);
                    s.shouldRenderCutoff && a.push("RENDER_CUTOFF"), a.push("RENDER_SHADOWS"), this.useNormalOffset && a.push("NORMAL_OFFSET");
                    const l = BE(t1, r, o), u = new jb(n.LEQUAL, jb.ReadOnly, e1.depthRangeFor3D), c = new Vb({
                        func: n.EQUAL,
                        mask: 255
                    }, 0, 255, n.KEEP, n.KEEP, n.KEEP);
                    for (const t1 of this._groundShadowTiles){
                        const r = t1.toUnwrapped(), o = e1.isTileAffectedByFog(t1), h = e1.getOrCreateProgram("groundShadow", {
                            defines: a,
                            overrideFog: o
                        });
                        this.setupShadows(r, h), e1.uploadCommonUniforms(i, h, r, null, s);
                        const d = ME(e1.transform.calculateProjMatrix(r), l);
                        h.draw(e1, n.TRIANGLES, u, c, Gb.multiply, Zb.disabled, d, "ground_shadow", e1.tileExtentBuffer, e1.quadTriangleIndexBuffer, e1.tileExtentSegments, null, e1.transform.zoom, null, null);
                    }
                }
                getShadowPassDepthMode() {
                    return this._depthMode;
                }
                getGroundShadowLayerIndex() {
                    return this._drawShadowAfterLayer;
                }
                calculateShadowPassMatrixFromTile(e1) {
                    const t1 = this.painter.transform, i = t1.calculatePosMatrix(e1, t1.worldSize);
                    return _(i, this._cascades[this.painter.currentShadowCascade].matrix, i), Float32Array.from(i);
                }
                calculateShadowPassMatrixFromMatrix(e1) {
                    return _(UE, this._cascades[this.painter.currentShadowCascade].matrix, e1);
                }
                setupShadows(e1, t1, i) {
                    if (!this.enabled) return;
                    const n = this.painter.transform, r = this.painter.context, o = r.gl, a = this._uniformValues, s = n.calculatePosMatrix(e1, n.worldSize);
                    for(let e1 = 0; e1 < this._cascades.length; e1++){
                        const t1 = VE(e1);
                        _(t1, this._cascades[e1].matrix, s), a[0 === e1 ? "u_light_matrix_0" : "u_light_matrix_1"] = t1, r.activeTexture.set(o.TEXTURE0 + Cb.ShadowMap0 + e1), this._cascades[e1].texture.bindExtraParam(o.LINEAR, o.LINEAR, o.CLAMP_TO_EDGE, o.CLAMP_TO_EDGE, o.GREATER);
                    }
                    if (this.useNormalOffset = !!i, this.useNormalOffset) {
                        const t1 = vu(e1.canonical), r = 2 / n.tileSize * Sr / this._shadowParameters.shadowMapResolution, o = r * this._cascades[0].boundingSphereRadius, s = r * this._cascades.at(-1).boundingSphereRadius, l = ("vector-tile" === i ? 1 : 3) * function(e1) {
                            const t1 = tt((e1 - 22) / -22, 0, 1);
                            return .125 * (1 - t1) + 4 * t1;
                        }(n.zoom);
                        a.u_shadow_normal_offset = [
                            t1,
                            o * l,
                            s * l
                        ], a.u_shadow_bias = [
                            1e-4,
                            .0012,
                            .012
                        ];
                    } else a.u_shadow_bias = [
                        36e-5,
                        .0012,
                        .012
                    ];
                    t1.setShadowUniformValues(r, a);
                }
                computeCascadeTileMatrices(e1) {
                    const t1 = this._shadowParameters.cascadeCount;
                    for(let i = 0; i < t1; i++)_(kE[i] = kE[i] || new Float64Array(16), this._cascades[i].matrix, e1);
                    return kE.length = t1, kE;
                }
                setupShadowsFromMatrix(e1, t1, i = !1) {
                    if (!this.enabled) return;
                    const n = this._shadowParameters.cascadeCount;
                    for(let t1 = 0; t1 < n; t1++)_(VE(t1), this._cascades[t1].matrix, e1);
                    NE.length = n, this.setupShadowsFromCascadeMatrices(NE, t1, i);
                }
                setupShadowsFromCascadeMatrices(e1, t1, i = !1) {
                    if (!this.enabled) return;
                    const n = this.painter.context, r = n.gl, o = this._uniformValues;
                    for(let t1 = 0; t1 < this._shadowParameters.cascadeCount; t1++)o[0 === t1 ? "u_light_matrix_0" : "u_light_matrix_1"] = e1[t1], n.activeTexture.set(r.TEXTURE0 + Cb.ShadowMap0 + t1), this._cascades[t1].texture.bindExtraParam(r.LINEAR, r.LINEAR, r.CLAMP_TO_EDGE, r.CLAMP_TO_EDGE, r.GREATER);
                    if (this.useNormalOffset = i, i) {
                        const e1 = this._shadowParameters.normalOffset;
                        o.u_shadow_normal_offset = [
                            1,
                            e1,
                            e1
                        ], o.u_shadow_bias = [
                            6e-5,
                            .0012,
                            .012
                        ];
                    } else o.u_shadow_bias = [
                        36e-5,
                        .0012,
                        .012
                    ];
                    t1.setShadowUniformValues(n, o);
                }
                getShadowUniformValues() {
                    return this._uniformValues;
                }
                getCurrentCascadeFrustum() {
                    return this._cascades[this.painter.currentShadowCascade].frustum;
                }
                computeSimplifiedTileShadowVolume(e1, t1, i, n) {
                    if (n[2] >= 0) return {};
                    const r = (function(e1, t1, i) {
                        const n = i / (1 << e1.canonical.z);
                        return new If([
                            e1.canonical.x * n + e1.wrap * i,
                            e1.canonical.y * n + e1.wrap * i,
                            0
                        ], [
                            (e1.canonical.x + 1) * n + e1.wrap * i,
                            (e1.canonical.y + 1) * n + e1.wrap * i,
                            t1
                        ]);
                    })(e1, t1, i).getCorners(), o = t1 / -n[2];
                    n[0] < 0 ? (O(r[0], r[0], [
                        n[0] * o,
                        0,
                        0
                    ]), O(r[3], r[3], [
                        n[0] * o,
                        0,
                        0
                    ])) : n[0] > 0 && (O(r[1], r[1], [
                        n[0] * o,
                        0,
                        0
                    ]), O(r[2], r[2], [
                        n[0] * o,
                        0,
                        0
                    ])), n[1] < 0 ? (O(r[0], r[0], [
                        0,
                        n[1] * o,
                        0
                    ]), O(r[1], r[1], [
                        0,
                        n[1] * o,
                        0
                    ])) : n[1] > 0 && (O(r[2], r[2], [
                        0,
                        n[1] * o,
                        0
                    ]), O(r[3], r[3], [
                        0,
                        n[1] * o,
                        0
                    ]));
                    const a = {};
                    return a.vertices = r, a.planes = [
                        HE(r[1], r[0], r[4]),
                        HE(r[2], r[1], r[5]),
                        HE(r[3], r[2], r[6]),
                        HE(r[0], r[3], r[7])
                    ], a;
                }
                addShadowReceiver(e1, t1, i) {
                    this._receivers.add(e1, If.fromTileIdAndHeight(e1, t1, i));
                }
                getMaxCascadeForTile(e1) {
                    const t1 = this._receivers.get(e1);
                    return t1 && t1.lastCascade ? t1.lastCascade : 0;
                }
            },
            drawGroundEffect: FE,
            queryModelLayerRendered: function(e1, t1, i, n) {
                const r = i.getSource();
                if (!r || "model" !== r.type) return {};
                const o = r, a = {};
                a[e1.id] = [];
                const s = a[e1.id];
                let l = 0;
                for (const r of o.models){
                    const o = i.getFeatureState(e1.sourceLayer, r.id), a = {
                        type: "Unknown",
                        id: r.id,
                        properties: r.featureProperties
                    }, u = e1.paint.get("model-rotation").evaluate(a, o), c = e1.paint.get("model-scale").evaluate(a, o), h = e1.paint.get("model-translation").evaluate(a, o), d = e1.paint.get("model-elevation-reference");
                    let f = [];
                    sy(f, r, n, r.position, u, c, h, "ground" === d, "ground" === d, !1), "globe" === n.projection.name && (f = ny(f, n));
                    const p = _([], n.projMatrix, f), m = ry(t1.isPointQuery() ? t1.screenBounds : t1.screenGeometry, n, p, r.aabb);
                    if (null != m) {
                        const t1 = new Db(void 0, 0, 0, 0, r.id);
                        t1.layer = e1.layer, t1.properties = structuredClone(r.featureProperties), t1.properties.layer = e1.id, t1.properties.uri = r.uri, t1.properties.orientation = r.orientation, t1.sourceLayer = e1.sourceLayer, t1.geometry = {
                            type: "Point",
                            coordinates: [
                                r.position.lng,
                                r.position.lat
                            ]
                        }, t1.state = o, t1.source = e1.source, s.push({
                            featureIndex: l,
                            feature: t1,
                            intersectionZ: m
                        });
                    }
                    ++l;
                }
                return a;
            },
            queryModelLayerIntersectsFeature: function(e1, t1, i, n, r, o) {
                if (!e1.modelManager) return !1;
                const a = e1.modelManager, s = t1.tile.getBucket(e1);
                if (!(s && s instanceof pb)) return !1;
                for(const n in s.instancesPerModel){
                    const l = s.instancesPerModel[n], u = void 0 !== i.id ? i.id : i.properties && Object.hasOwn(i.properties, "id") ? i.properties.id : void 0;
                    if (Object.hasOwn(l.idToFeaturesIndex, u)) {
                        const i = l.features[l.idToFeaturesIndex[u]], c = a.getModel(n, o || e1.scope);
                        if (!c) return !1;
                        let h = [];
                        const d = new hu(0, 0), f = s.canonical;
                        let p = Number.MAX_VALUE;
                        for(let e1 = 0; e1 < i.instancedDataCount; ++e1){
                            const n = 16 * (i.instancedDataOffset + e1), o = l.instancedDataArray.float32, a = [
                                o[n + 4],
                                o[n + 5],
                                o[n + 6]
                            ];
                            xw(f, d, Math.floor(o[n]), Math.floor(o[n + 1])), sy(h, c, r, d, i.rotation, i.scale, a, !1, !1, !1), "globe" === r.projection.name && (h = ny(h, r));
                            const s = _([], r.projMatrix, h), u = t1.queryGeometry, m = ry(u.isPointQuery() ? u.screenBounds : u.screenGeometry, r, s, c.aabb);
                            null != m && (p = Math.min(m, p));
                        }
                        return p !== Number.MAX_VALUE && p;
                    }
                }
                return !1;
            },
            loadMatchingModelFeature: function(e1, t1, i, n) {
                const r = e1.getNodesInfo()[t1];
                if (!r || r.hiddenByReplacement || !r.node.meshes) return;
                let o = Number.MAX_VALUE;
                const a = r.node, s = i.tile, l = n.calculatePosMatrix(s.tileID.toUnwrapped(), n.worldSize), u = r.evaluatedScale;
                let c = 0;
                n.elevation && a.elevation && (c = a.elevation * n.elevation.exaggeration()), m(l, l, [
                    (a.anchor ? a.anchor[0] : 0) * (u[0] - 1),
                    (a.anchor ? a.anchor[1] : 0) * (u[1] - 1),
                    c
                ]), g(l, l, u);
                const h = i.queryGeometry, d = h.isPointQuery() ? h.screenBounds : h.screenGeometry, f = function(e1) {
                    const t1 = _([], l, e1.globalMatrix);
                    _(t1, n.expandedFarZProjMatrix, t1);
                    for(let i = 0; i < e1.meshes.length; ++i){
                        const r = e1.meshes[i];
                        if (i === e1.lightMeshIndex) continue;
                        const a = ry(d, n, t1, r.aabb);
                        null != a && (o = Math.min(a, o));
                    }
                    if (e1.children) for (const t1 of e1.children)f(t1);
                };
                if (f(a), o === Number.MAX_VALUE) return;
                const p = new hu(0, 0);
                return xw(s.tileID.canonical, p, r.node.anchor[0], r.node.anchor[1]), {
                    intersectionZ: o,
                    position: p,
                    feature: r.feature
                };
            },
            ModelSource: ZE,
            Tiled3dModelSource: class extends sn {
                constructor(e1, t1, i, n){
                    super(), this.type = "batched-model", this.id = e1, this.tileSize = 512, this._options = t1, this.tiles = this._options.tiles, this.maxzoom = t1.maxzoom || 19, this.minzoom = t1.minzoom || 0, this.roundZoom = !0, this.usedInConflation = !0, this.dispatcher = i, this.reparseOverscaled = !1, this.scheme = "xyz", this._loaded = !1, this.setEventedParent(n);
                }
                onAdd(e1) {
                    this.map = e1, this.load();
                }
                reload() {
                    this.cancelTileJSONRequest();
                    const e1 = ml(this.id, this.scope);
                    this.load(()=>this.map.style.clearSource(e1));
                }
                cancelTileJSONRequest() {
                    this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                }
                load(e1) {
                    this._loaded = !1, this.fire(new nn("dataloading", {
                        dataType: "source"
                    }));
                    const t1 = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, i = this.map.getWorldview();
                    this._tileJSONRequest = qE(this._options, this.map._requestManager, t1, i, (n, r)=>{
                        this._tileJSONRequest = null, this._loaded = !0, n ? (t1 && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${t1}`), i && 2 !== i.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${i}`), this.fire(new rn(n))) : r && (Object.assign(this, r), r.bounds && (this.tileBounds = new YE(r.bounds, this.minzoom, this.maxzoom)), Ui(r.tiles, this.map._requestManager._customAccessToken), this.fire(new nn("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new nn("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }))), e1 && e1(n);
                    });
                }
                hasTransition() {
                    return !1;
                }
                hasTile(e1) {
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                loaded() {
                    return this._loaded;
                }
                async loadTile(e1, t1) {
                    const i = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme)), n = !e1.actor || "expired" === e1.state;
                    if (n) e1.actor = this.dispatcher.getActor();
                    else {
                        if ("loading" === e1.state) return void (e1.reloadCallback = t1);
                        if (e1.buckets) {
                            const t1 = Object.values(e1.buckets);
                            for (const e1 of t1)e1.dirty = !0;
                            return void (e1.state = "loaded");
                        }
                    }
                    const r = n ? "loadTile" : "reloadTile", o = new AbortController;
                    e1.request = o;
                    const a = (i, n)=>(delete e1.request, e1.aborted ? t1(null) : i && !li(i) ? t1(i) : (this.map._refreshExpiredTiles && n && e1.setExpiryData(wt(n.headers)), e1.loadModelData(n, this.map.painter), e1.state = "loaded", t1(null), void (e1.reloadCallback && (this.loadTile(e1, e1.reloadCallback), e1.reloadCallback = null))));
                    try {
                        const n = await this.map._requestManager.transformRequest(i, ai.Tile, o.signal);
                        if (o.signal.aborted) return t1(null);
                        const s = {
                            request: n,
                            data: void 0,
                            uid: e1.uid,
                            tileID: e1.tileID,
                            tileZoom: e1.tileZoom,
                            zoom: e1.tileID.overscaledZ,
                            tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                            type: this.type,
                            source: this.id,
                            scope: this.scope,
                            showCollisionBoxes: this.map.showCollisionBoxes,
                            renderSourceType: e1.renderSourceType,
                            brightness: this.map.style && this.map.style.getBrightness() || 0,
                            pixelRatio: Vt.devicePixelRatio,
                            promoteId: this.promoteId
                        };
                        e1.request = e1.actor.sendCancelable(r, s, {}, a);
                    } catch (e1) {
                        if (o.signal.aborted) return t1(null);
                        t1(e1);
                    }
                }
                abortTile(e1) {
                    e1.request && (e1.request.abort(), delete e1.request), e1.actor && e1.actor.notify("abortTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    });
                }
                serialize() {
                    return {
                        ...this._options
                    };
                }
            },
            loadModel: async function(e1, t1, i) {
                const n = await Ng(e1), r = new ly(t1, i, void 0, void 0, Sy(n));
                return r.computeBoundsAndApplyParent(), r;
            }
        };
        class KE {
            constructor(e1, t1){
                this.tileID = e1, this.x = e1.canonical.x, this.y = e1.canonical.y, this.z = e1.canonical.z, this.grid = new Ga(Sr, Sr, 512), this.featureIndexArray = new zc, this.promoteId = t1, this.is3DTile = !1, this.serializedLayersCache = new Map;
            }
            insert(e1, t1, i, n, r, o = 0, a = 0) {
                const s = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(i, n, r, o);
                const l = this.grid;
                for(let e1 = 0; e1 < t1.length; e1++){
                    const i = t1[e1], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let e1 = 0; e1 < i.length; e1++){
                        const t1 = i[e1];
                        n[0] = Math.min(n[0], t1.x), n[1] = Math.min(n[1], t1.y), n[2] = Math.max(n[2], t1.x), n[3] = Math.max(n[3], t1.y);
                    }
                    0 !== a && (n[0] -= a, n[1] -= a, n[2] += a, n[3] += a), n[0] < Sr && n[1] < Sr && n[2] >= 0 && n[3] >= 0 && l.insert(s, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                if (!this.vtLayers) {
                    this.vtLayers = new Ph(new Gp(this.rawTileData)).layers, this.sourceLayerCoder = new Rb(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                        "_geojsonTileLayer"
                    ]), this.vtFeatures = {};
                    for(const e1 in this.vtLayers)this.vtFeatures[e1] = [];
                }
                return this.vtLayers;
            }
            query(e1, t1) {
                const { tilespaceGeometry: i, transform: n, tileTransform: r, pixelPosMatrix: o, availableImages: a, worldview: s } = t1;
                this.loadVTLayers(), this.serializedLayersCache.clear();
                const l = t1.queryRadius ? t1.queryRadius : 0, u = i.bufferedTilespaceBounds, c = this.grid.queryKeys(u.min.x, u.min.y, u.max.x, u.max.y, (e1, t1, n, r)=>Hh(i.bufferedTilespaceGeometry, e1 - l, t1 - l, n + l, r + l));
                c.sort(eA);
                let h = null;
                n.elevation && c.length > 0 && (h = _b.create(n.elevation, this.tileID));
                const d = {};
                let f;
                for(let l = 0; l < c.length; l++){
                    const u = c[l];
                    if (u === f) continue;
                    f = u;
                    const p = this.featureIndexArray.get(u);
                    let _ = null;
                    this.is3DTile ? this.loadMatchingModelFeature(d, p, e1, i, n, s) : this.loadMatchingFeature(d, p, e1, a, s, (e1, a, s, l = 0)=>(_ || (_ = zu(e1, this.tileID.canonical, r)), a.queryIntersectsFeature(i, e1, s, _, this.z, n, o, h, l, t1.scope)));
                }
                return d;
            }
            loadMatchingFeature(e1, t1, i, n, r, o) {
                const { featureIndex: a, bucketIndex: s, sourceLayerIndex: l, layoutVertexArrayOffset: u } = t1, c = this.bucketLayerIDs[s], h = i.layers, d = Object.keys(h);
                if (d.length && !pt(d, c)) return;
                const f = i.sourceCache, p = this.sourceLayerCoder.decode(l), _ = this.vtLayers[p].feature(a), m = this.getId(_, p);
                for(let t1 = 0; t1 < c.length; t1++){
                    const i = c[t1];
                    if (!h[i]) continue;
                    const { styleLayer: s, targets: l } = h[i];
                    let d = {};
                    void 0 !== m && (d = f.getFeatureState(s.sourceLayer, m));
                    const p = !o || o(_, s, d, u);
                    if (!p) continue;
                    const g = new Db(_, this.z, this.x, this.y, m);
                    g.tile = this.tileID.canonical, g.state = d;
                    let y = this.serializedLayersCache.get(i);
                    y || (y = s.serialize(), y.id = i, this.serializedLayersCache.set(i, y)), g.source = y.source, g.sourceLayer = y["source-layer"], g.layer = {
                        ...y
                    }, g.layer.paint = QE(y.paint, s.paint, _, d, n), g.layer.layout = QE(y.layout, s.layout, _, d, n);
                    const x = new ks(this.tileID.overscaledZ, {
                        worldview: r
                    });
                    let v = !1;
                    for (const e1 of l){
                        this.updateFeatureProperties(g, e1);
                        const { filter: t1 } = e1;
                        if (t1) {
                            if (_.properties = g.properties, t1.needGeometry) {
                                const e1 = Ru(_, !0);
                                if (!t1.filter(x, e1, this.tileID.canonical)) continue;
                            } else if (!t1.filter(x, _)) continue;
                        }
                        v = !0, e1.targetId && this.addFeatureVariant(g, e1);
                    }
                    v && this.appendToResult(e1, i, a, g, p);
                }
            }
            loadMatchingModelFeature(e1, t1, i, n, r, o) {
                const { featureIndex: a, bucketIndex: s } = t1, l = this.bucketLayerIDs[s], u = i.layers, c = Object.keys(u);
                if (!c.length || pt(c, l)) for(let t1 = 0; t1 < l.length; t1++){
                    const s = l[t1], { styleLayer: c, targets: h } = u[s];
                    if ("model" !== c.type) continue;
                    const d = n.tile, f = d.getBucket(c);
                    if (!f || !f.isTiled3dModelBucket) continue;
                    if (!JE.loadMatchingModelFeature) continue;
                    const p = JE.loadMatchingModelFeature(f, a, n, r);
                    if (!p) continue;
                    const { z: _, x: m, y: g } = d.tileID.canonical, { feature: y, intersectionZ: x, position: v } = p;
                    let b = {};
                    void 0 !== y.id && (b = i.sourceCache.getFeatureState(c.sourceLayer, y.id));
                    const w = new Db({}, _, m, g, y.id);
                    w.tile = this.tileID.canonical, w.state = b, w.properties = y.properties, w.geometry = {
                        type: "Point",
                        coordinates: [
                            v.lng,
                            v.lat
                        ]
                    };
                    let E = this.serializedLayersCache.get(s);
                    E || (E = c.serialize(), E.id = s, this.serializedLayersCache.set(s, E)), w.source = E.source, w.sourceLayer = E["source-layer"], w.layer = {
                        ...E
                    };
                    const A = new ks(this.tileID.overscaledZ, {
                        worldview: o
                    });
                    let I = !1;
                    for (const e1 of h){
                        this.updateFeatureProperties(w, e1);
                        const { filter: t1 } = e1;
                        if (t1) {
                            if (y.properties = w.properties, t1.needGeometry) {
                                if (!t1.filter(A, y, this.tileID.canonical)) continue;
                            } else if (!t1.filter(A, y)) continue;
                        }
                        I = !0, e1.targetId && this.addFeatureVariant(w, e1);
                    }
                    I && this.appendToResult(e1, s, a, w, x);
                }
            }
            updateFeatureProperties(e1, t1, i) {
                if (t1.properties) {
                    const n = {};
                    for(const r in t1.properties){
                        const o = t1.properties[r].evaluate({
                            zoom: this.z
                        }, e1._vectorTileFeature, e1.state, e1.tile, i);
                        null != o && (n[r] = o);
                    }
                    e1.properties = n;
                }
            }
            addFeatureVariant(e1, t1, i) {
                const n = {
                    target: t1.target,
                    namespace: t1.namespace,
                    uniqueFeatureID: t1.uniqueFeatureID
                };
                t1.properties && (n.properties = e1.properties), e1.variants = e1.variants || {}, e1.variants[t1.targetId] = e1.variants[t1.targetId] || [], e1.variants[t1.targetId].push(n);
            }
            appendToResult(e1, t1, i, n, r) {
                let o = e1[t1];
                void 0 === o && (o = e1[t1] = []), o.push({
                    featureIndex: i,
                    feature: n,
                    intersectionZ: r
                });
            }
            lookupSymbolFeatures(e1, t1, i, n, r, o) {
                const a = {};
                this.loadVTLayers();
                for (const s of e1)this.loadMatchingFeature(a, {
                    bucketIndex: t1,
                    sourceLayerIndex: i,
                    featureIndex: s,
                    layoutVertexArrayOffset: 0
                }, n, r, o);
                return a;
            }
            loadFeature(e1) {
                const { featureIndex: t1, sourceLayerIndex: i } = e1;
                this.loadVTLayers();
                const n = this.sourceLayerCoder.decode(i), r = this.vtFeatures[n];
                if (r[t1]) return r[t1];
                const o = this.vtLayers[n].feature(t1);
                return r[t1] = o, o;
            }
            hasLayer(e1) {
                for (const t1 of this.bucketLayerIDs)for (const i of t1)if (e1 === i) return !0;
                return !1;
            }
            getId(e1, t1) {
                let i = e1.id;
                if (this.promoteId) {
                    const n = Array.isArray(this.promoteId) || "object" != typeof this.promoteId ? this.promoteId : this.promoteId[t1];
                    if (null != n) {
                        if (Array.isArray(n)) {
                            if (!this.promoteIdExpression) {
                                const e1 = La(n);
                                if ("success" !== e1.result) {
                                    const t1 = e1.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", ");
                                    return void mt(`Failed to create expression for promoteId: ${t1}`);
                                }
                                this.promoteIdExpression = e1.value;
                            }
                            i = this.promoteIdExpression.evaluate({
                                zoom: 0
                            }, e1);
                        } else i = e1.properties[n];
                    }
                    "boolean" == typeof i && (i = Number(i));
                }
                return i;
            }
        }
        function QE(e1, t1, i, n, r) {
            return ht(e1, (e1, o)=>{
                const a = t1 instanceof qs ? t1.get(o) : null;
                return a && a.evaluate ? a.evaluate(i, n, void 0, r) : a;
            });
        }
        function eA(e1, t1) {
            return t1 - e1;
        }
        async function tA() {
            return Promise.resolve();
        }
        Ha(KE, "FeatureIndex", {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        const iA = {
            circle: class extends Il {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: Ux || (Ux = new Ks({
                            "circle-sort-key": new Ys(Qs.layout_circle["circle-sort-key"]),
                            "circle-elevation-reference": new Xs(Qs.layout_circle["circle-elevation-reference"]),
                            visibility: new Xs(Qs.layout_circle.visibility)
                        })),
                        paint: Gx || (Gx = new Ks({
                            "circle-radius": new Ys(Qs.paint_circle["circle-radius"]),
                            "circle-color": new Ys(Qs.paint_circle["circle-color"]),
                            "circle-blur": new Ys(Qs.paint_circle["circle-blur"]),
                            "circle-opacity": new Ys(Qs.paint_circle["circle-opacity"]),
                            "circle-translate": new Xs(Qs.paint_circle["circle-translate"]),
                            "circle-translate-anchor": new Xs(Qs.paint_circle["circle-translate-anchor"]),
                            "circle-pitch-scale": new Xs(Qs.paint_circle["circle-pitch-scale"]),
                            "circle-pitch-alignment": new Xs(Qs.paint_circle["circle-pitch-alignment"]),
                            "circle-stroke-width": new Ys(Qs.paint_circle["circle-stroke-width"]),
                            "circle-stroke-color": new Ys(Qs.paint_circle["circle-stroke-color"]),
                            "circle-stroke-opacity": new Ys(Qs.paint_circle["circle-stroke-opacity"]),
                            "circle-emissive-strength": new Xs(Qs.paint_circle["circle-emissive-strength"]),
                            "circle-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "circle-stroke-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n);
                }
                createBucket(e1) {
                    return new yd(e1);
                }
                queryRadius(e1) {
                    const t1 = e1;
                    return Qx("circle-radius", this, t1) + Qx("circle-stroke-width", this, t1) + ev(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(e1, t1, i, n, r, o, a, s) {
                    const l = iv(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), u = this.paint.get("circle-radius").evaluate(t1, i) + this.paint.get("circle-stroke-width").evaluate(t1, i);
                    return ov(e1, n, o, a, s, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l, u);
                }
                getProgramIds() {
                    return [
                        "circle"
                    ];
                }
                getDefaultProgramParams(e1, t1, i) {
                    const n = rv(this);
                    return {
                        config: new uh(this, {
                            zoom: t1,
                            lut: i
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                is3D(e1) {
                    return !e1 && !!this.layout && "none" !== this.layout.get("circle-elevation-reference");
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("circle-elevation-reference");
                }
                mayUse(e1) {
                    return "HD" === e1 && Tl(this, "circle-elevation-reference", (e1)=>"hd-road-markup" === e1);
                }
                prepare() {
                    return this.mayUse("HD") ? Kx() : Promise.resolve();
                }
            },
            heatmap: class extends Il {
                createBucket(e1) {
                    return new cv(e1);
                }
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: hv || (hv = new Ks({
                            visibility: new Xs(Qs.layout_heatmap.visibility)
                        })),
                        paint: dv || (dv = new Ks({
                            "heatmap-radius": new Ys(Qs.paint_heatmap["heatmap-radius"]),
                            "heatmap-weight": new Ys(Qs.paint_heatmap["heatmap-weight"]),
                            "heatmap-intensity": new Xs(Qs.paint_heatmap["heatmap-intensity"]),
                            "heatmap-color": new Js(Qs.paint_heatmap["heatmap-color"]),
                            "heatmap-opacity": new Xs(Qs.paint_heatmap["heatmap-opacity"]),
                            "heatmap-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    "heatmap-color" === e1 && this._updateColorRamp();
                }
                _updateColorRamp() {
                    this.colorRamp = Iv({
                        expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                _clear() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                queryRadius(e1) {
                    return Qx("heatmap-radius", this, e1);
                }
                queryIntersectsFeature(e1, t1, i, n, r, o, a, s) {
                    const l = this.paint.get("heatmap-radius").evaluate(t1, i);
                    return ov(e1, n, o, a, s, !0, !0, new Pe(0, 0), l);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "heatmap",
                        "heatmapTexture"
                    ];
                }
                getDefaultProgramParams(e1, t1, i) {
                    return "heatmap" === e1 ? {
                        config: new uh(this, {
                            zoom: t1,
                            lut: i
                        }),
                        overrideFog: !1
                    } : {};
                }
            },
            hillshade: class extends Il {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: fv || (fv = new Ks({
                            visibility: new Xs(Qs.layout_hillshade.visibility)
                        })),
                        paint: pv || (pv = new Ks({
                            "hillshade-illumination-direction": new Xs(Qs.paint_hillshade["hillshade-illumination-direction"]),
                            "hillshade-illumination-anchor": new Xs(Qs.paint_hillshade["hillshade-illumination-anchor"]),
                            "hillshade-exaggeration": new Xs(Qs.paint_hillshade["hillshade-exaggeration"]),
                            "hillshade-shadow-color": new Xs(Qs.paint_hillshade["hillshade-shadow-color"]),
                            "hillshade-highlight-color": new Xs(Qs.paint_hillshade["hillshade-highlight-color"]),
                            "hillshade-accent-color": new Xs(Qs.paint_hillshade["hillshade-accent-color"]),
                            "hillshade-emissive-strength": new Xs(Qs.paint_hillshade["hillshade-emissive-strength"]),
                            "hillshade-shadow-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "hillshade-highlight-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "hillshade-accent-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n);
                }
                shouldRedrape() {
                    return this.hasOffscreenPass() && "viewport" === this.paint.get("hillshade-illumination-anchor");
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "hillshade",
                        "hillshadePrepare"
                    ];
                }
                getDefaultProgramParams(e1, t1, i) {
                    return {
                        overrideFog: !1
                    };
                }
            },
            fill: class extends Il {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: _v || (_v = new Ks({
                            "fill-sort-key": new Ys(Qs.layout_fill["fill-sort-key"]),
                            visibility: new Xs(Qs.layout_fill.visibility),
                            "fill-elevation-reference": new Xs(Qs.layout_fill["fill-elevation-reference"]),
                            "fill-construct-bridge-guard-rail": new Ys(Qs.layout_fill["fill-construct-bridge-guard-rail"])
                        })),
                        paint: mv || (mv = new Ks({
                            "fill-antialias": new Xs(Qs.paint_fill["fill-antialias"]),
                            "fill-opacity": new Ys(Qs.paint_fill["fill-opacity"]),
                            "fill-color": new Ys(Qs.paint_fill["fill-color"]),
                            "fill-outline-color": new Ys(Qs.paint_fill["fill-outline-color"]),
                            "fill-translate": new Xs(Qs.paint_fill["fill-translate"]),
                            "fill-translate-anchor": new Xs(Qs.paint_fill["fill-translate-anchor"]),
                            "fill-pattern": new Ys(Qs.paint_fill["fill-pattern"]),
                            "fill-pattern-cross-fade": new Xs(Qs.paint_fill["fill-pattern-cross-fade"]),
                            "fill-emissive-strength": new Xs(Qs.paint_fill["fill-emissive-strength"]),
                            "fill-z-offset": new Ys(Qs.paint_fill["fill-z-offset"]),
                            "fill-bridge-guard-rail-color": new Ys(Qs.paint_fill["fill-bridge-guard-rail-color"]),
                            "fill-tunnel-structure-color": new Ys(Qs.paint_fill["fill-tunnel-structure-color"]),
                            "fill-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-outline-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-bridge-guard-rail-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-tunnel-structure-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n);
                }
                getProgramIds() {
                    const e1 = this.paint.get("fill-pattern"), t1 = e1 && e1.constantOr(1), i = [
                        t1 ? "fillPattern" : "fill"
                    ];
                    return this.paint.get("fill-antialias") && i.push(t1 && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), i;
                }
                getDefaultProgramParams(e1, t1, i) {
                    return {
                        config: new uh(this, {
                            zoom: t1,
                            lut: i
                        }),
                        overrideFog: !1
                    };
                }
                recalculate(e1, t1) {
                    super.recalculate(e1, t1);
                    const i = this.paint._values["fill-outline-color"];
                    "constant" === i.value.kind && void 0 === i.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(e1) {
                    return new gh(e1);
                }
                queryRadius() {
                    return ev(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(e1, t1, i, n, r, o) {
                    return !e1.queryGeometry.isAboveHorizon && Fh(tv(e1.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), n);
                }
                isTileClipped() {
                    return 0 === this.paint.get("fill-z-offset").constantOr(1);
                }
                is3D(e1) {
                    if (0 !== this.paint.get("fill-z-offset").constantOr(1)) return !0;
                    const t1 = this.layout && "none" !== this.layout.get("fill-elevation-reference");
                    return null != e1 ? t1 && !e1 : t1;
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("fill-elevation-reference");
                }
                mayUse(e1) {
                    return "HD" === e1 && Tl(this, "fill-elevation-reference", (e1)=>"none" !== e1);
                }
                prepare() {
                    return this.mayUse("HD") ? Kx() : Promise.resolve();
                }
                hasShadowPass() {
                    return this.layout && "none" !== this.layout.get("fill-elevation-reference");
                }
            },
            "fill-extrusion": class extends Il {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: xv || (xv = new Ks({
                            visibility: new Xs(Qs["layout_fill-extrusion"].visibility),
                            "fill-extrusion-edge-radius": new Xs(Qs["layout_fill-extrusion"]["fill-extrusion-edge-radius"]),
                            "source-max-zoom": new Xs(Qs["layout_fill-extrusion"]["source-max-zoom"])
                        })),
                        paint: vv || (vv = new Ks({
                            "fill-extrusion-opacity": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                            "fill-extrusion-color": new Ys(Qs["paint_fill-extrusion"]["fill-extrusion-color"]),
                            "fill-extrusion-translate": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-translate"]),
                            "fill-extrusion-translate-anchor": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                            "fill-extrusion-pattern": new Ys(Qs["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                            "fill-extrusion-pattern-cross-fade": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-pattern-cross-fade"]),
                            "fill-extrusion-height": new Ys(Qs["paint_fill-extrusion"]["fill-extrusion-height"]),
                            "fill-extrusion-base": new Ys(Qs["paint_fill-extrusion"]["fill-extrusion-base"]),
                            "fill-extrusion-height-alignment": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-height-alignment"]),
                            "fill-extrusion-base-alignment": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-base-alignment"]),
                            "fill-extrusion-vertical-gradient": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
                            "fill-extrusion-ambient-occlusion-intensity": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),
                            "fill-extrusion-ambient-occlusion-radius": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]),
                            "fill-extrusion-ambient-occlusion-wall-radius": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-radius": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-attenuation": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]),
                            "fill-extrusion-flood-light-color": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]),
                            "fill-extrusion-flood-light-intensity": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]),
                            "fill-extrusion-flood-light-wall-radius": new Ys(Qs["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]),
                            "fill-extrusion-flood-light-ground-radius": new Ys(Qs["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]),
                            "fill-extrusion-flood-light-ground-attenuation": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]),
                            "fill-extrusion-vertical-scale": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]),
                            "fill-extrusion-rounded-roof": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]),
                            "fill-extrusion-cutoff-fade-range": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]),
                            "fill-extrusion-front-cutoff": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-front-cutoff"]),
                            "fill-extrusion-emissive-strength": new Ys(Qs["paint_fill-extrusion"]["fill-extrusion-emissive-strength"]),
                            "fill-extrusion-line-width": new Ys(Qs["paint_fill-extrusion"]["fill-extrusion-line-width"]),
                            "fill-extrusion-cast-shadows": new Xs(Qs["paint_fill-extrusion"]["fill-extrusion-cast-shadows"]),
                            "fill-extrusion-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-extrusion-flood-light-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(e1) {
                    return new vx(e1);
                }
                queryRadius() {
                    return ev(this.paint.get("fill-extrusion-translate"));
                }
                is3D(e1) {
                    return !0;
                }
                hasShadowPass() {
                    return this.paint.get("fill-extrusion-cast-shadows");
                }
                cutoffRange() {
                    return this.paint.get("fill-extrusion-cutoff-fade-range");
                }
                canCastShadows() {
                    return !0;
                }
                getProgramIds() {
                    return [
                        this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"
                    ];
                }
                queryIntersectsFeature(e1, t1, i, n, r, o, a, s, l) {
                    const u = iv(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), c = this.paint.get("fill-extrusion-height").evaluate(t1, i), h = this.paint.get("fill-extrusion-base").evaluate(t1, i), d = [
                        0,
                        0
                    ], f = s && o.elevation, p = o.elevation ? o.elevation.exaggeration() : 1, _ = e1.tile.getBucket(this);
                    if (_ instanceof vx) {
                        const e1 = _.centroidData.find((e1)=>l >= e1.vertexArrayOffset && l < e1.vertexArrayOffset + e1.vertexCount);
                        if (e1 && e1.flags & ax) return !1;
                        if (f) {
                            const e1 = _.centroidVertexArray, t1 = l + 1;
                            t1 < e1.length && (d[0] = e1.geta_centroid_pos0(t1), d[1] = e1.geta_centroid_pos1(t1));
                        }
                    }
                    if (0 === d[0] && 1 === d[1]) return !1;
                    "globe" === o.projection.name && (n = Cx([
                        n
                    ], [
                        new Pe(0, 0),
                        new Pe(Sr, Sr)
                    ], e1.tileID.canonical).map((e1)=>e1.polygon).flat());
                    const m = f ? s : null, [g, y] = Rv(o, n, h, c, u, a, m, d, p, o.center.lat, e1.tileID.canonical), x = e1.queryGeometry;
                    return zv(g, y, x.isPointQuery() ? x.screenBounds : x.screenGeometry);
                }
            },
            building: class extends Il {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: bv || (bv = new Ks({
                            visibility: new Xs(Qs.layout_building.visibility),
                            "building-facade": new Ys(Qs.layout_building["building-facade"]),
                            "building-facade-floors": new Ys(Qs.layout_building["building-facade-floors"]),
                            "building-facade-unit-width": new Ys(Qs.layout_building["building-facade-unit-width"]),
                            "building-facade-window": new Ys(Qs.layout_building["building-facade-window"]),
                            "building-roof-shape": new Ys(Qs.layout_building["building-roof-shape"]),
                            "building-height": new Ys(Qs.layout_building["building-height"]),
                            "building-base": new Ys(Qs.layout_building["building-base"]),
                            "building-flood-light-wall-radius": new Ys(Qs.layout_building["building-flood-light-wall-radius"]),
                            "building-flood-light-ground-radius": new Ys(Qs.layout_building["building-flood-light-ground-radius"]),
                            "building-flip-roof-orientation": new Ys(Qs.layout_building["building-flip-roof-orientation"])
                        })),
                        paint: wv || (wv = new Ks({
                            "building-opacity": new Xs(Qs.paint_building["building-opacity"]),
                            "building-ambient-occlusion-intensity": new Xs(Qs.paint_building["building-ambient-occlusion-intensity"]),
                            "building-ambient-occlusion-ground-intensity": new Xs(Qs.paint_building["building-ambient-occlusion-ground-intensity"]),
                            "building-ambient-occlusion-ground-radius": new Xs(Qs.paint_building["building-ambient-occlusion-ground-radius"]),
                            "building-ambient-occlusion-ground-attenuation": new Xs(Qs.paint_building["building-ambient-occlusion-ground-attenuation"]),
                            "building-vertical-scale": new Xs(Qs.paint_building["building-vertical-scale"]),
                            "building-cast-shadows": new Xs(Qs.paint_building["building-cast-shadows"]),
                            "building-color": new Ys(Qs.paint_building["building-color"]),
                            "building-emissive-strength": new Ys(Qs.paint_building["building-emissive-strength"]),
                            "building-facade-emissive-chance": new Xs(Qs.paint_building["building-facade-emissive-chance"]),
                            "building-cutoff-fade-range": new Xs(Qs.paint_building["building-cutoff-fade-range"]),
                            "building-front-cutoff": new Xs(Qs.paint_building["building-front-cutoff"]),
                            "building-flood-light-color": new Xs(Qs.paint_building["building-flood-light-color"]),
                            "building-flood-light-intensity": new Xs(Qs.paint_building["building-flood-light-intensity"]),
                            "building-flood-light-ground-attenuation": new Xs(Qs.paint_building["building-flood-light-ground-attenuation"]),
                            "building-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "building-flood-light-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                mayUse(e1) {
                    return "HD" === e1;
                }
                prepare() {
                    return async function() {
                        return function() {
                            if (!vt(self)) return null;
                            if (null != $x || null != Hx) return null;
                            if (null != jx) return jx;
                            const e1 = fetch(Ht());
                            return jx = (function(e1) {
                                let t1, i, n, r, o;
                                function a() {
                                    t1 = new Uint8Array(o.buffer), i = new Int16Array(o.buffer), n = new Int32Array(o.buffer), r = new Float32Array(o.buffer);
                                }
                                function s() {
                                    throw new Error("Unexpected BuildingGen error.");
                                }
                                const l = ()=>{}, u = {
                                    a: {
                                        a: s,
                                        f: function(e1) {
                                            const i = t1.length, n = Math.max(e1 >>> 0, Math.ceil(1.2 * i)), r = Math.ceil((n - i) / 65536);
                                            try {
                                                return o.grow(r), a(), !0;
                                            } catch (e1) {
                                                return !1;
                                            }
                                        },
                                        g: s,
                                        b: l,
                                        c: l,
                                        d: l,
                                        e: l
                                    }
                                };
                                return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(e1, u) : e1.then((e1)=>e1.arrayBuffer()).then((e1)=>WebAssembly.instantiate(e1, u))).then((e1)=>{
                                    const s = e1.instance.exports;
                                    return (0, s.g)(), o = s.f, a(), new Lx({
                                        setStyle: s.h,
                                        setAOOptions: s.i,
                                        setMetricOptions: s.j,
                                        setStructuralOptions: s.k,
                                        setFacadeOptions: s.l,
                                        setFauxFacadeOptions: s.m,
                                        setFacadeClassifierOptions: s.n,
                                        addFeature: s.o,
                                        addFacade: s.p,
                                        generateMesh: s.q,
                                        getLastError: s.r,
                                        getOuterRingLength: s.s,
                                        getMeshCount: s.t,
                                        getPositionsPtr: s.u,
                                        getPositionsLength: s.v,
                                        getNormalsPtr: s.w,
                                        getNormalsLength: s.x,
                                        getAOPtr: s.y,
                                        getAOLength: s.z,
                                        getUVPtr: s.A,
                                        getUVLength: s.B,
                                        getFauxFacadePtr: s.C,
                                        getFauxFacadeLength: s.D,
                                        getIndicesPtr: s.E,
                                        getIndicesLength: s.F,
                                        getBuildingPart: s.G,
                                        getRingCount: s.H,
                                        getRingPtr: s.I,
                                        getRingLength: s.J,
                                        malloc: s.K,
                                        free: s.L,
                                        heapU8: t1,
                                        heap16: i,
                                        heap32: n,
                                        heapF32: r
                                    });
                                });
                            })(e1).then((e1)=>{
                                jx = null, $x = e1;
                            }).catch((e1)=>{
                                mt("Could not load building-gen"), jx = null, Hx = e1;
                            }), jx;
                        }();
                    }();
                }
                createBucket(e1) {
                    return new qx(e1);
                }
                cutoffRange() {
                    return this.paint.get("building-cutoff-fade-range");
                }
                hasShadowPass() {
                    return this.paint.get("building-cast-shadows");
                }
                hasLightBeamPass() {
                    return !0;
                }
                canCastShadows() {
                    return !0;
                }
                is3D(e1) {
                    return !0;
                }
                queryRadius(e1) {
                    return 0;
                }
                queryIntersectsFeature(e1, t1, i, n, r, o, a, s, l, u) {
                    let c = this.layout.get("building-height").evaluate(t1, i);
                    const h = this.layout.get("building-base").evaluate(t1, i), d = e1.tile.getBucket(this).getFootprint(t1);
                    if (d) {
                        if (0 !== d.hiddenFlags) return !1;
                        c = d.height;
                    }
                    const [f, p] = Rv(o, n, h, c, new Pe(0, 0), a, null, [
                        0,
                        0
                    ], 1, o.center.lat, e1.tileID.canonical), _ = e1.queryGeometry;
                    return zv(f, p, _.isPointQuery() ? _.screenBounds : _.screenGeometry);
                }
            },
            line: class extends Il {
                constructor(e1, t1, i, n){
                    const r = Nv();
                    super(e1, r, t1, i, n), r.layout && (this.layout = new qs(r.layout)), this.gradientVersion = 0, this.borderGradientVersion = 0, this.hasElevatedBuckets = !1, this.hasNonElevatedBuckets = !1, this.lineBlendFbos = null, this.lineBlendDensityReadback = null;
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    if ("line-gradient" === e1) {
                        const e1 = this._transitionablePaint._values["line-gradient"].value.expression;
                        this.stepInterpolant = e1._styleExpression && e1._styleExpression.expression instanceof Eo, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    } else if ("line-gradient-use-theme" === e1) this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    else if ("line-border-gradient" === e1) {
                        const e1 = this._transitionablePaint._values["line-border-gradient"].value.expression;
                        this.borderStepInterpolant = e1._styleExpression && e1._styleExpression.expression instanceof Eo, this.borderGradientVersion = (this.borderGradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    } else "line-border-gradient-use-theme" === e1 && (this.borderGradientVersion = (this.borderGradientVersion + 1) % Number.MAX_SAFE_INTEGER);
                }
                gradientExpression() {
                    return this._transitionablePaint._values["line-gradient"].value.expression;
                }
                borderGradientExpression() {
                    return this._transitionablePaint._values["line-border-gradient"].value.expression;
                }
                widthExpression() {
                    return this._transitionablePaint._values["line-width"].value.expression;
                }
                emissiveStrengthExpression() {
                    return this._transitionablePaint._values["line-emissive-strength"].value.expression;
                }
                recalculate(e1, t1) {
                    super.recalculate(e1, t1), this.paint._values["line-floorwidth"] = (()=>{
                        if (kv) return kv;
                        const e1 = Nv();
                        return kv = new Vv(e1.paint.properties["line-width"].specification), kv.useIntegerZoom = !0, kv;
                    })().possiblyEvaluate(this._transitioningPaint._values["line-width"].value, e1);
                }
                createBucket(e1) {
                    return new fd(e1);
                }
                getProgramIds() {
                    const e1 = [
                        this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"
                    ];
                    return "default" !== this.paint.get("line-blend-mode") && e1.push("lineBlendComposite"), e1;
                }
                getDefaultProgramParams(e1, t1, i) {
                    if ("lineBlendComposite" === e1) return {};
                    const n = Ov(this);
                    return {
                        config: new uh(this, {
                            zoom: t1,
                            lut: i
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                queryRadius(e1) {
                    const t1 = e1, i = Hv(Qx("line-width", this, t1), Qx("line-gap-width", this, t1)), n = Qx("line-offset", this, t1);
                    return i / 2 + Math.abs(n) + ev(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(e1, t1, i, n, r, o) {
                    if (e1.queryGeometry.isAboveHorizon) return !1;
                    const a = tv(e1.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), s = e1.pixelToTileUnitsFactor / 2 * Hv(this.paint.get("line-width").evaluate(t1, i), this.paint.get("line-gap-width").evaluate(t1, i)), l = this.paint.get("line-offset").evaluate(t1, i);
                    return l && (n = function(e1, t1) {
                        const i = [], n = new Pe(0, 0);
                        for(let r = 0; r < e1.length; r++){
                            const o = e1[r], a = [];
                            for(let e1 = 0; e1 < o.length; e1++){
                                const i = o[e1], r = o[e1 + 1], s = 0 === e1 ? n : i.sub(o[e1 - 1])._unit()._perp(), l = e1 === o.length - 1 ? n : r.sub(i)._unit()._perp(), u = s._add(l)._unit();
                                u._mult(1 / (u.x * l.x + u.y * l.y)), a.push(u._mult(t1)._add(i));
                            }
                            i.push(a);
                        }
                        return i;
                    }(n, l * e1.pixelToTileUnitsFactor)), function(e1, t1, i) {
                        for(let n = 0; n < t1.length; n++){
                            const r = t1[n];
                            if (e1.length >= 3) {
                                for(let t1 = 0; t1 < r.length; t1++)if (jh(e1, r[t1])) return !0;
                            }
                            if (Oh(e1, r, i)) return !0;
                        }
                        return !1;
                    }(a, n, s);
                }
                isTileClipped() {
                    return this.hasNonElevatedBuckets;
                }
                isDraped(e1) {
                    return !this.hasElevatedBuckets || this.layout && "hd-road-markup" === this.layout.get("line-elevation-reference");
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("line-elevation-reference");
                }
                mayUse(e1) {
                    return "HD" === e1 && Tl(this, "line-elevation-reference", (e1)=>"hd-road-markup" === e1);
                }
                prepare() {
                    return this.mayUse("HD") ? Kx() : Promise.resolve();
                }
                hasOffscreenPass() {
                    return "default" !== this.paint.get("line-blend-mode") && 0 !== this.paint.get("line-opacity").constantOr(1) && 0 !== this.paint.get("line-width").constantOr(1) && "none" !== this.visibility;
                }
                resize() {
                    this._destroyLineBlendFbo();
                }
                onRemove(e1) {
                    this._destroyLineBlendFbo(e1.painter && e1.painter.context && e1.painter.context.gl || void 0);
                }
                _clear() {
                    this._destroyLineBlendFbo();
                }
                _destroyLineBlendFbo(e1) {
                    this.lineBlendFbos && (this.lineBlendFbos.destroy(), this.lineBlendFbos = null), e1 && this.lineBlendDensityReadback && this.lineBlendDensityReadback.destroy(e1), this.lineBlendDensityReadback = null;
                }
            },
            symbol: qv,
            background: class extends Il {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: Xv || (Xv = new Ks({
                            visibility: new Xs(Qs.layout_background.visibility)
                        })),
                        paint: Yv || (Yv = new Ks({
                            "background-pitch-alignment": new Xs(Qs.paint_background["background-pitch-alignment"]),
                            "background-color": new Xs(Qs.paint_background["background-color"]),
                            "background-pattern": new Xs(Qs.paint_background["background-pattern"]),
                            "background-opacity": new Xs(Qs.paint_background["background-opacity"]),
                            "background-emissive-strength": new Xs(Qs.paint_background["background-emissive-strength"]),
                            "background-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n);
                }
                getProgramIds() {
                    return [
                        this.paint.get("background-pattern") ? "backgroundPattern" : "background"
                    ];
                }
                getDefaultProgramParams(e1, t1, i) {
                    return {
                        overrideFog: !1
                    };
                }
                is3D(e1) {
                    return "viewport" === this.paint.get("background-pitch-alignment");
                }
            },
            raster: tb,
            "raster-particle": ub,
            sky: class extends Il {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: rb || (rb = new Ks({
                            visibility: new Xs(Qs.layout_sky.visibility)
                        })),
                        paint: ob || (ob = new Ks({
                            "sky-type": new Xs(Qs.paint_sky["sky-type"]),
                            "sky-atmosphere-sun": new Xs(Qs.paint_sky["sky-atmosphere-sun"]),
                            "sky-atmosphere-sun-intensity": new Xs(Qs.paint_sky["sky-atmosphere-sun-intensity"]),
                            "sky-gradient-center": new Xs(Qs.paint_sky["sky-gradient-center"]),
                            "sky-gradient-radius": new Xs(Qs.paint_sky["sky-gradient-radius"]),
                            "sky-gradient": new Js(Qs.paint_sky["sky-gradient"]),
                            "sky-atmosphere-halo-color": new Xs(Qs.paint_sky["sky-atmosphere-halo-color"]),
                            "sky-atmosphere-color": new Xs(Qs.paint_sky["sky-atmosphere-color"]),
                            "sky-opacity": new Xs(Qs.paint_sky["sky-opacity"]),
                            "sky-gradient-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "sky-atmosphere-halo-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "sky-atmosphere-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n), this._updateColorRamp();
                }
                _clear() {
                    this.skyboxFbo && (this.skyboxFbo.destroy(), this.skyboxFbo = null), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null), this._skyboxInvalidated = !0;
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    "sky-gradient" === e1 ? this._updateColorRamp() : "sky-atmosphere-sun" !== e1 && "sky-atmosphere-halo-color" !== e1 && "sky-atmosphere-color" !== e1 && "sky-atmosphere-sun-intensity" !== e1 || (this._skyboxInvalidated = !0);
                }
                _updateColorRamp() {
                    this.colorRamp = Iv({
                        expression: this._transitionablePaint._values["sky-gradient"].value.expression,
                        evaluationKey: "skyRadialProgress"
                    }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                needsSkyboxCapture(e1) {
                    if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return !0;
                    if (!this.paint.get("sky-atmosphere-sun")) {
                        const t1 = e1.style.light.properties.get("position");
                        return this._lightPosition.azimuthal !== t1.azimuthal || this._lightPosition.polar !== t1.polar;
                    }
                    return !1;
                }
                getCenter(e1, t1) {
                    if ("atmosphere" === this.paint.get("sky-type")) {
                        const i = this.paint.get("sky-atmosphere-sun"), n = !i, r = e1.style.light, o = r.properties.get("position");
                        return n && "viewport" === r.properties.get("anchor") && mt("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n ? hb(o.azimuthal, 90 - o.polar, t1) : hb(i[0], 90 - i[1], t1);
                    }
                    const i = this.paint.get("sky-gradient-center");
                    return hb(i[0], 90 - i[1], t1);
                }
                isSky() {
                    return !0;
                }
                markSkyboxValid(e1) {
                    this._skyboxInvalidated = !1, this._lightPosition = e1.style.light.properties.get("position");
                }
                hasOffscreenPass() {
                    return !0;
                }
                getProgramIds() {
                    const e1 = this.paint.get("sky-type");
                    return "atmosphere" === e1 ? [
                        "skyboxCapture",
                        "skybox"
                    ] : "gradient" === e1 ? [
                        "skyboxGradient"
                    ] : null;
                }
            },
            slot: class extends Il {
                constructor(e1, t1, i, n){
                    super(e1, {
                        paint: ab || (ab = new Ks({}))
                    }, t1, null);
                }
            },
            model: class extends Il {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: sb || (sb = new Ks({
                            visibility: new Xs(Qs.layout_model.visibility),
                            "model-id": new Ys(Qs.layout_model["model-id"]),
                            "model-allow-density-reduction": new Xs(Qs.layout_model["model-allow-density-reduction"])
                        })),
                        paint: lb || (lb = new Ks({
                            "model-opacity": new Ys(Qs.paint_model["model-opacity"]),
                            "model-rotation": new Ys(Qs.paint_model["model-rotation"]),
                            "model-scale": new Ys(Qs.paint_model["model-scale"]),
                            "model-translation": new Ys(Qs.paint_model["model-translation"]),
                            "model-color": new Ys(Qs.paint_model["model-color"]),
                            "model-color-mix-intensity": new Ys(Qs.paint_model["model-color-mix-intensity"]),
                            "model-type": new Xs(Qs.paint_model["model-type"]),
                            "model-cast-shadows": new Xs(Qs.paint_model["model-cast-shadows"]),
                            "model-receive-shadows": new Xs(Qs.paint_model["model-receive-shadows"]),
                            "model-ambient-occlusion-intensity": new Xs(Qs.paint_model["model-ambient-occlusion-intensity"]),
                            "model-emissive-strength": new Ys(Qs.paint_model["model-emissive-strength"]),
                            "model-roughness": new Ys(Qs.paint_model["model-roughness"]),
                            "model-height-based-emissive-strength-multiplier": new Ys(Qs.paint_model["model-height-based-emissive-strength-multiplier"]),
                            "model-cutoff-fade-range": new Xs(Qs.paint_model["model-cutoff-fade-range"]),
                            "model-front-cutoff": new Xs(Qs.paint_model["model-front-cutoff"]),
                            "model-elevation-reference": new Xs(Qs.paint_model["model-elevation-reference"]),
                            "model-line-cutout-mode": new Xs(Qs.paint_model["model-line-cutout-mode"]),
                            "model-color-use-theme": new Ys({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n), this.layer = e1, this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                mayUse(e1) {
                    return "Standard" === e1;
                }
                prepare() {
                    return tA();
                }
                createBucket(e1) {
                    return new pb(e1);
                }
                getProgramIds() {
                    return [
                        "model"
                    ];
                }
                is3D(e1) {
                    return !0;
                }
                hasShadowPass() {
                    return !0;
                }
                canCastShadows() {
                    return !0;
                }
                hasLightBeamPass() {
                    return !0;
                }
                cutoffRange() {
                    return this.paint.get("model-cutoff-fade-range");
                }
                queryRadius(e1) {
                    return e1.isTiled3dModelBucket ? 8191 : 0;
                }
                queryRenderedFeatures(e1, t1, i) {
                    return JE.queryModelLayerRendered ? JE.queryModelLayerRendered(this, e1, t1, i) : {};
                }
                queryIntersectsFeature(e1, t1, i, n, r, o, a, s, l, u) {
                    return !!JE.queryModelLayerIntersectsFeature && JE.queryModelLayerIntersectsFeature(this, e1, t1, i, o, u);
                }
                _handleOverridablePaintPropertyUpdate(e1, t1, i) {
                    return !(!this.layout || t1.isDataDriven() || i.isDataDriven() || "model-color" !== e1 && "model-color-mix-intensity" !== e1 && "model-rotation" !== e1 && "model-scale" !== e1 && "model-translation" !== e1 && "model-emissive-strength" !== e1);
                }
                _isPropertyZoomDependent(e1) {
                    const t1 = this._transitionablePaint._values[e1];
                    return null != t1 && null != t1.value && null != t1.value.expression && t1.value.expression instanceof Na;
                }
                isZoomDependent() {
                    return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
                }
            },
            clip: class extends Il {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: gv || (gv = new Ks({
                            "clip-layer-types": new Xs(Qs.layout_clip["clip-layer-types"]),
                            "clip-layer-scope": new Xs(Qs.layout_clip["clip-layer-scope"]),
                            visibility: new Xs(Qs.layout_clip.visibility)
                        })),
                        paint: yv || (yv = new Ks({}))
                    }, t1, i, n);
                }
                recalculate(e1, t1) {
                    super.recalculate(e1, t1);
                }
                createBucket(e1) {
                    return new Tv(e1);
                }
                is3D(e1) {
                    return !0;
                }
            }
        };
        class nA {
            constructor(e1){
                this.capacity = e1, this.cache = new Map;
            }
            get(e1) {
                if (!this.cache.has(e1)) return;
                const t1 = this.cache.get(e1);
                return this.cache.delete(e1), this.cache.set(e1, t1), t1;
            }
            put(e1, t1) {
                this.cache.has(e1) ? this.cache.delete(e1) : this.cache.size === this.capacity && this.cache.delete(this.cache.keys().next().value), this.cache.set(e1, t1);
            }
            delete(e1) {
                this.cache.delete(e1);
            }
        }
        Ha(nA, "LRUCache");
        class rA {
            constructor(e1){
                this._callback = e1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                this._channel && (this._channel.port1.close(), this._channel.port2.close()), this._callback = ()=>{};
            }
        }
        const oA = {
            Other: 0,
            Symbol: 1,
            FillExtrusion: 2,
            HdRoadCoverage: 3,
            HdRoadElevation: 4
        };
        class aA {
            constructor(){
                this.tasks = new Map, ct([
                    "process"
                ], this), this.invoker = new rA(this.process), this.nextId = 0;
            }
            add(e1, t1) {
                const i = this.nextId++, n = function({ type: e1, renderSourceType: t1, zoom: i }) {
                    i = i || 0;
                    const n = t1 === oA.Symbol;
                    return "message" === e1 ? 0 : "maybePrepare" !== e1 || n ? "parseTile" !== e1 || n ? "parseTile" === e1 && n ? 300 - i : "maybePrepare" === e1 && n ? 400 - i : 500 : 200 - i : 100 - i;
                }(t1);
                if (0 === n) {
                    e1();
                    return null;
                }
                return this.tasks.set(i, {
                    fn: e1,
                    metadata: t1,
                    priority: n,
                    id: i
                }), this.invoker.trigger(), {
                    cancel: ()=>{
                        this.tasks.delete(i);
                    }
                };
            }
            process() {
                {
                    const e1 = this.pick();
                    if (!e1) return;
                    this.tasks.delete(e1.id), this.tasks.size > 0 && this.invoker.trigger(), e1.fn();
                }
            }
            pick() {
                let e1 = null, t1 = 1 / 0;
                for (const i of this.tasks.values())i.priority < t1 && (t1 = i.priority, e1 = i);
                return e1;
            }
            remove() {
                this.tasks.clear(), this.invoker.remove();
            }
        }
        const sA = {
            type: "message"
        }, lA = new Map, uA = new Map;
        class cA {
            constructor(e1){
                this.size = e1, this.minimums = [], this.maximums = [], this.leaves = [];
            }
            getElevation(e1, t1) {
                const i = this.toIdx(e1, t1);
                return {
                    min: this.minimums[i],
                    max: this.maximums[i]
                };
            }
            isLeaf(e1, t1) {
                return this.leaves[this.toIdx(e1, t1)];
            }
            toIdx(e1, t1) {
                return t1 * this.size + e1;
            }
        }
        function hA(e1, t1, i, n) {
            let r = 0, o = Number.MAX_VALUE;
            for(let a = 0; a < 3; a++)if (Math.abs(n[a]) < 1e-15) {
                if (i[a] < e1[a] || i[a] > t1[a]) return null;
            } else {
                const s = 1 / n[a];
                let l = (e1[a] - i[a]) * s, u = (t1[a] - i[a]) * s;
                if (l > u) {
                    const e1 = l;
                    l = u, u = e1;
                }
                if (l > r && (r = l), u < o && (o = u), r > o) return null;
            }
            return r;
        }
        function dA(e1, t1, i, n, r, o, a, s, l, u, c) {
            const h = n - e1, d = r - t1, f = o - i, p = a - e1, _ = s - t1, m = l - i, g = c[1] * m - c[2] * _, y = c[2] * p - c[0] * m, x = c[0] * _ - c[1] * p, v = h * g + d * y + f * x;
            if (Math.abs(v) < 1e-15) return null;
            const b = 1 / v, w = u[0] - e1, E = u[1] - t1, A = u[2] - i, I = (w * g + E * y + A * x) * b;
            if (I < 0 || I > 1) return null;
            const T = E * f - A * d, M = A * h - w * f, S = w * d - E * h, z = (c[0] * T + c[1] * M + c[2] * S) * b;
            return z < 0 || I + z > 1 ? null : (p * T + _ * M + m * S) * b;
        }
        function fA(e1, t1, i, n, r, o, a, s, l) {
            const u = 1 << i, c = o - n, h = a - r, d = (e1 + 1) / u * c + n, f = (t1 + 0) / u * h + r, p = (t1 + 1) / u * h + r;
            s[0] = (e1 + 0) / u * c + n, s[1] = f, l[0] = d, l[1] = p;
        }
        class pA {
            constructor(e1){
                if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = e1, this._siblingOffset = [
                    [
                        0,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        1
                    ]
                ], !this.dem) return;
                const t1 = function(e1) {
                    const t1 = e1.dim, i = Math.ceil(Math.log2(t1 / 8)), n = [];
                    let r = Math.ceil(Math.pow(2, i));
                    const o = (e1, t1, i, n, r)=>{
                        const o = n ? 1 : 0, a = (e1 + 1) * i - o, s = t1 * i, l = (t1 + 1) * i - o;
                        r[0] = e1 * i, r[1] = s, r[2] = a, r[3] = l;
                    };
                    let a = new cA(r);
                    const s = 1 / r, { floatView: l, stride: u } = e1, c = [];
                    for(let i = 0; i < r * r; i++){
                        const n = Math.floor(i / r), h = i % r;
                        o(h, n, s, !1, c);
                        const d = mA(c[0], c[1], e1), f = mA(c[2], c[1], e1), p = mA(c[2], c[3], e1), _ = mA(c[0], c[3], e1), m = Math.min(d, f, p, _), g = Math.max(0, 8 * h - 1), y = Math.min(t1 - 1, 8 * (h + 1)), x = Math.max(0, 8 * n - 1), v = Math.min(t1 - 1, 8 * (n + 1));
                        let b = -1 / 0;
                        for(let e1 = x; e1 <= v; e1++){
                            const t1 = (e1 + 1) * u;
                            for(let e1 = g; e1 <= y; e1++){
                                const i = l[t1 + e1 + 1];
                                i > b && (b = i);
                            }
                        }
                        a.minimums.push(m), a.maximums.push(b), a.leaves.push(1);
                    }
                    for(n.push(a), r /= 2; r >= 1; r /= 2){
                        const e1 = n.at(-1);
                        a = new cA(r);
                        for(let t1 = 0; t1 < r * r; t1++){
                            o(t1 % r, Math.floor(t1 / r), 2, !0, c);
                            const i = e1.getElevation(c[0], c[1]), n = e1.getElevation(c[2], c[1]), s = e1.getElevation(c[2], c[3]), l = e1.getElevation(c[0], c[3]), u = e1.isLeaf(c[0], c[1]), h = e1.isLeaf(c[2], c[1]), d = e1.isLeaf(c[2], c[3]), f = e1.isLeaf(c[0], c[3]), p = Math.min(i.min, n.min, s.min, l.min), _ = Math.max(i.max, n.max, s.max, l.max), m = u && h && d && f;
                            a.maximums.push(_), a.minimums.push(p), a.leaves.push(_ - p <= 5 && m ? 1 : 0);
                        }
                        n.push(a);
                    }
                    return n;
                }(this.dem), i = t1.length - 1, n = t1[i];
                this._addNode(n.minimums[0], n.maximums[0], n.leaves[0]), this._construct(t1, 0, 0, i, 0);
            }
            raycastRoot(e1, t1, i, n, r, o, a = 1) {
                return hA([
                    e1,
                    t1,
                    -100
                ], [
                    i,
                    n,
                    this.maximums[0] * a
                ], r, o);
            }
            raycast(e1, t1, i, n, r, o, a = 1) {
                if (!this.nodeCount) return null;
                const s = this.raycastRoot(e1, t1, i, n, r, o, a);
                if (null == s) return null;
                const l = [], u = [], c = [], h = [], d = [
                    {
                        idx: 0,
                        t: s,
                        nodex: 0,
                        nodey: 0,
                        depth: 0
                    }
                ];
                for(; d.length > 0;){
                    const { idx: s, t: f, nodex: p, nodey: _, depth: m } = d.pop();
                    if (this.leaves[s]) {
                        fA(p, _, m, e1, t1, i, n, c, h);
                        const s = 1 << m, l = p / s, u = (p + 1) / s, d = _ / s, g = (_ + 1) / s, { dim: y, floatView: x, stride: v } = this.dem, b = Math.floor(l * y), w = Math.ceil(u * y), E = Math.floor(d * y), A = w - b, I = Math.ceil(g * y) - E;
                        if (A <= 0 || I <= 0) continue;
                        const T = c[0], M = c[1], S = (h[0] - T) / A, z = (h[1] - M) / I, R = Math.max(0, f), P = r[0] + o[0] * R, D = r[1] + o[1] * R, C = Math.abs(o[0]) > 1e-10, F = Math.abs(o[1]) > 1e-10, O = o[0] >= 0 ? 1 : -1, L = o[1] >= 0 ? 1 : -1;
                        let B = Math.max(0, Math.min(A - 1, Math.floor((P - T) / S))), N = Math.max(0, Math.min(I - 1, Math.floor((D - M) / z)));
                        const V = C ? Math.abs(S / o[0]) : Number.MAX_VALUE, k = F ? Math.abs(z / o[1]) : Number.MAX_VALUE;
                        let G = C ? R + (T + (o[0] >= 0 ? B + 1 : B) * S - P) / o[0] : Number.MAX_VALUE, j = F ? R + (M + (o[1] >= 0 ? N + 1 : N) * z - D) / o[1] : Number.MAX_VALUE;
                        const H = (e1, t1)=>x[(t1 + 1) * v + e1 + 1] * a;
                        let $ = H(b + B, E + N), Z = H(b + B + 1, E + N), W = H(b + B, E + N + 1), q = H(b + B + 1, E + N + 1), X = null;
                        for(let e1 = 0; e1 < A + I; e1++){
                            const e1 = Math.min(G, j);
                            if (o[2] >= 0 || r[2] + o[2] * e1 <= Math.max($, Z, W, q)) {
                                const e1 = T + B * S, t1 = e1 + S, i = M + N * z, n = i + z, a = dA(t1, i, Z, e1, i, $, e1, n, W, r, o), s = dA(e1, n, W, t1, n, q, t1, i, Z, r, o);
                                null != a && a >= 0 && (null === X || a < X) && (X = a), null != s && s >= 0 && (null === X || s < X) && (X = s);
                            }
                            const t1 = G < j;
                            if (t1 ? (B += O, G += V) : (N += L, j += k), B < 0 || B >= A || N < 0 || N >= I) break;
                            if (null !== X && e1 > X) break;
                            t1 ? O > 0 ? ($ = Z, W = q, Z = H(b + B + 1, E + N), q = H(b + B + 1, E + N + 1)) : (Z = $, q = W, $ = H(b + B, E + N), W = H(b + B, E + N + 1)) : L > 0 ? ($ = W, Z = q, W = H(b + B, E + N + 1), q = H(b + B + 1, E + N + 1)) : (W = $, q = Z, $ = H(b + B, E + N), Z = H(b + B + 1, E + N));
                        }
                        if (null !== X) return X || 0;
                        const Y = U([], r, o, f), J = (Y[0] - c[0]) / (h[0] - c[0]), K = (Y[1] - c[1]) / (h[1] - c[1]), Q = mA(l, d, this.dem) * a, ee = mA(u, d, this.dem) * a, te = mA(u, g, this.dem) * a;
                        if (_A(Q, ee, mA(l, g, this.dem) * a, te, J, K) >= Y[2]) return f;
                        continue;
                    }
                    let g = 0;
                    for(let d = 0; d < this._siblingOffset.length; d++){
                        fA((p << 1) + this._siblingOffset[d][0], (_ << 1) + this._siblingOffset[d][1], m + 1, e1, t1, i, n, c, h), c[2] = -100, h[2] = this.maximums[this.childOffsets[s] + d] * a;
                        const f = hA(c, h, r, o);
                        if (null != f) {
                            const e1 = f;
                            l[d] = e1;
                            let t1 = !1;
                            for(let i = 0; i < g && !t1; i++)e1 >= l[u[i]] && (u.splice(i, 0, d), t1 = !0);
                            t1 || (u[g] = d), g++;
                        }
                    }
                    for(let e1 = 0; e1 < g; e1++){
                        const t1 = u[e1];
                        d.push({
                            idx: this.childOffsets[s] + t1,
                            t: l[t1],
                            nodex: (p << 1) + this._siblingOffset[t1][0],
                            nodey: (_ << 1) + this._siblingOffset[t1][1],
                            depth: m + 1
                        });
                    }
                }
                return null;
            }
            _addNode(e1, t1, i) {
                return this.minimums.push(e1), this.maximums.push(t1), this.leaves.push(i), this.childOffsets.push(0), this.nodeCount++;
            }
            _construct(e1, t1, i, n, r) {
                if (1 === e1[n].isLeaf(t1, i)) return;
                this.childOffsets[r] || (this.childOffsets[r] = this.nodeCount);
                const o = n - 1, a = e1[o];
                let s = 0, l = 0;
                for(let e1 = 0; e1 < this._siblingOffset.length; e1++){
                    const n = 2 * t1 + this._siblingOffset[e1][0], r = 2 * i + this._siblingOffset[e1][1], o = a.getElevation(n, r), u = a.isLeaf(n, r), c = this._addNode(o.min, o.max, u);
                    u && (s |= 1 << e1), l || (l = c);
                }
                for(let n = 0; n < this._siblingOffset.length; n++)s & 1 << n || this._construct(e1, 2 * t1 + this._siblingOffset[n][0], 2 * i + this._siblingOffset[n][1], o, l + n);
            }
        }
        function _A(e1, t1, i, n, r, o) {
            return dn(dn(e1, i, o), dn(t1, n, o), r);
        }
        function mA(e1, t1, i) {
            const n = i.dim, r = tt(e1 * n - .5, 0, n - 1), o = tt(t1 * n - .5, 0, n - 1), a = Math.floor(r), s = Math.floor(o), l = Math.min(a + 1, n - 1), u = Math.min(s + 1, n - 1);
            return _A(i.get(a, s), i.get(l, s), i.get(a, u), i.get(l, u), r - a, o - s);
        }
        const gA = {
            mapbox: [
                6553.6,
                25.6,
                .1,
                1e4
            ],
            terrarium: [
                256,
                1,
                1 / 256,
                32768
            ]
        };
        function yA(e1, t1, i) {
            return (256 * e1 * 256 + 256 * t1 + i) / 10 - 1e4;
        }
        function xA(e1, t1, i) {
            return 256 * e1 + t1 + i / 256 - 32768;
        }
        class vA {
            get tree() {
                return this._tree || this._buildQuadTree(), this._tree;
            }
            constructor(e1, t1, i, n = !1){
                if (this.uid = e1, t1.height !== t1.width) throw new RangeError("DEM tiles must be square");
                if (i && "mapbox" !== i && "terrarium" !== i) return void mt(`"${i}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = t1.height;
                const r = this.dim = t1.height - 2, o = new Uint32Array(t1.data.buffer);
                if (this.pixels = new Uint8Array(t1.data.buffer), this.floatView = new Float32Array(t1.data.buffer), this.borderReady = n, this._modifiedForSources = {}, !n) {
                    for(let e1 = 0; e1 < r; e1++)o[this._idx(-1, e1)] = o[this._idx(0, e1)], o[this._idx(r, e1)] = o[this._idx(r - 1, e1)], o[this._idx(e1, -1)] = o[this._idx(e1, 0)], o[this._idx(e1, r)] = o[this._idx(e1, r - 1)];
                    o[this._idx(-1, -1)] = o[this._idx(0, 0)], o[this._idx(r, -1)] = o[this._idx(r - 1, 0)], o[this._idx(-1, r)] = o[this._idx(0, r - 1)], o[this._idx(r, r)] = o[this._idx(r - 1, r - 1)];
                }
                const a = "terrarium" === i ? xA : yA;
                for(let e1 = 0; e1 < o.length; ++e1){
                    const t1 = 4 * e1;
                    this.floatView[e1] = a(this.pixels[t1], this.pixels[t1 + 1], this.pixels[t1 + 2]);
                }
                this._timestamp = Vt.now();
            }
            _buildQuadTree() {
                this._tree = new pA(this);
            }
            get(e1, t1, i = !1) {
                i && (e1 = tt(e1, -1, this.dim), t1 = tt(t1, -1, this.dim));
                const n = this._idx(e1, t1);
                return this.floatView[n];
            }
            set(e1, t1, i) {
                const n = this._idx(e1, t1), r = this.floatView[n];
                return this.floatView[n] = i, i - r;
            }
            static getUnpackVector(e1) {
                return gA[e1];
            }
            _idx(e1, t1) {
                if (e1 < -1 || e1 >= this.dim + 1 || t1 < -1 || t1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (t1 + 1) * this.stride + (e1 + 1);
            }
            static pack(e1, t1) {
                const i = [
                    0,
                    0,
                    0,
                    0
                ], n = vA.getUnpackVector(t1);
                let r = Math.floor((e1 + n[3]) / n[2]);
                return i[2] = r % 256, r = Math.floor(r / 256), i[1] = r % 256, r = Math.floor(r / 256), i[0] = r, i;
            }
            getPixels() {
                return new ad({
                    width: this.stride,
                    height: this.stride
                }, this.pixels);
            }
            backfillBorder(e1, t1, i) {
                if (this.dim !== e1.dim) throw new Error("dem dimension mismatch");
                let n = t1 * this.dim, r = t1 * this.dim + this.dim, o = i * this.dim, a = i * this.dim + this.dim;
                switch(t1){
                    case -1:
                        n = r - 1;
                        break;
                    case 1:
                        r = n + 1;
                }
                switch(i){
                    case -1:
                        o = a - 1;
                        break;
                    case 1:
                        a = o + 1;
                }
                const s = -t1 * this.dim, l = -i * this.dim;
                for(let t1 = o; t1 < a; t1++)for(let i = n; i < r; i++){
                    const n = 4 * this._idx(i, t1), r = 4 * this._idx(i + s, t1 + l);
                    this.pixels[n + 0] = e1.pixels[r + 0], this.pixels[n + 1] = e1.pixels[r + 1], this.pixels[n + 2] = e1.pixels[r + 2], this.pixels[n + 3] = e1.pixels[r + 3];
                }
            }
            onDeserialize() {
                this._tree && (this._tree.dem = this);
            }
        }
        function bA(e1, t1) {
            const i = {};
            let n;
            for(; n = e1.nextField(t1);)1 === n ? (i.delta_filter = wA(e1, e1.readVarint() + e1.pos), i.filter = "delta_filter") : 2 === n ? (e1.readVarint(), i.filter = "zigzag_filter") : 3 === n ? (e1.readVarint(), i.filter = "bitshuffle_filter") : 4 === n && (e1.readVarint(), i.filter = "byteshuffle_filter");
            return i;
        }
        function wA(e1, t1) {
            const i = {
                blockSize: 0
            };
            let n;
            for(; n = e1.nextField(t1);)1 === n && (i.blockSize = e1.readVarint());
            return i;
        }
        function EA(e1, t1) {
            const i = {};
            let n;
            for(; n = e1.nextField(t1);)1 === n ? (e1.readVarint(), i.codec = "gzip_data") : 2 === n ? (e1.readVarint(), i.codec = "jpeg_image") : 3 === n ? (e1.readVarint(), i.codec = "webp_image") : 4 === n && (e1.readVarint(), i.codec = "png_image");
            return i;
        }
        function AA(e1, t1) {
            const i = {
                firstByte: 0,
                lastByte: 0,
                filters: [],
                codec: null,
                offset: 0,
                scale: 0,
                bands: []
            };
            let n, r = 0, o = 0;
            for(; n = e1.nextField(t1);)1 === n ? i.firstByte = e1.readFixed64() : 2 === n ? i.lastByte = e1.readFixed64() : 3 === n ? i.filters.push(bA(e1, e1.readVarint() + e1.pos)) : 4 === n ? i.codec = EA(e1, e1.readVarint() + e1.pos) : 5 === n ? o = e1.readFloat() : 6 === n ? r = e1.readFloat() : 7 === n ? i.bands.push(e1.readString()) : 8 === n ? i.offset = e1.readDouble() : 9 === n && (i.scale = e1.readDouble());
            return 0 === i.offset && (i.offset = o), 0 === i.scale && (i.scale = r), i;
        }
        function IA(e1, t1) {
            const i = {
                version: 0,
                name: "",
                units: "",
                tileSize: 0,
                buffer: 0,
                pixelFormat: 0,
                dataIndex: []
            };
            let n;
            for(; n = e1.nextField(t1);)1 === n ? i.version = e1.readVarint() : 2 === n ? i.name = e1.readString() : 3 === n ? i.units = e1.readString() : 4 === n ? i.tileSize = e1.readVarint() : 5 === n ? i.buffer = e1.readVarint() : 6 === n ? i.pixelFormat = e1.readVarint() : 7 === n && i.dataIndex.push(AA(e1, e1.readVarint() + e1.pos));
            return i;
        }
        function TA(e1, t1, i) {
            let n;
            for(; n = e1.nextField(t1);)if (1 === n) {
                let t1 = 0;
                const n = e1.readVarint() + e1.pos;
                for(; e1.pos < n;)i[t1++] = e1.readVarint();
            }
            return i;
        }
        function MA(e1, t1) {
            if (4 !== t1.length) throw new Error(`Expected data of dimension 4 but got ${t1.length}.`);
            let i = t1[3];
            for(let n = 2; n >= 1; n--){
                const r = 1 === n ? 1 : 0, o = 2 === n ? 1 : 0;
                for(let n = 0; n < t1[0]; n++){
                    const a = t1[1] * n;
                    for(let n = r; n < t1[1]; n++){
                        const r = t1[2] * (n + a);
                        for(let n = o; n < t1[2]; n++){
                            const o = t1[3] * (n + r);
                            for(let n = 0; n < t1[3]; n++){
                                const t1 = o + n;
                                e1[t1] += e1[t1 - i];
                            }
                        }
                    }
                }
                i *= t1[n];
            }
            return e1;
        }
        function SA(e1) {
            for(let t1 = 0, i = e1.length; t1 < i; t1++)e1[t1] = e1[t1] >>> 1 ^ -(1 & e1[t1]);
            return e1;
        }
        function zA(e1, t1) {
            switch(t1){
                case "uint32":
                    return e1;
                case "uint16":
                    for(let t1 = 0; t1 < e1.length; t1 += 2){
                        const i = e1[t1], n = e1[t1 + 1];
                        e1[t1] = (240 & i) >> 4 | (61440 & i) >> 8 | (240 & n) << 4 | 61440 & n, e1[t1 + 1] = 15 & i | (3840 & i) >> 4 | (15 & n) << 8 | (3840 & n) << 4;
                    }
                    return e1;
                case "uint8":
                    for(let t1 = 0; t1 < e1.length; t1 += 4){
                        const i = e1[t1], n = e1[t1 + 1], r = e1[t1 + 2], o = e1[t1 + 3];
                        e1[t1 + 0] = (192 & i) >> 6 | (192 & n) >> 4 | (192 & r) >> 2 | 192 & o, e1[t1 + 1] = (48 & i) >> 4 | (48 & n) >> 2 | 48 & r | (48 & o) << 2, e1[t1 + 2] = (12 & i) >> 2 | 12 & n | (12 & r) << 2 | (12 & o) << 4, e1[t1 + 3] = 3 & i | (3 & n) << 2 | (3 & r) << 4 | (3 & o) << 6;
                    }
                    return e1;
                default:
                    throw new Error(`Invalid pixel format, "${t1}"`);
            }
        }
        Ha(vA, "DEMData"), Ha(pA, "DemMinMaxQuadTree", {
            omit: [
                "dem"
            ]
        });
        var RA = Uint8Array, PA = Uint16Array, DA = Int32Array, CA = new RA([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), FA = new RA([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), OA = new RA([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), LA = function(e1, t1) {
            for(var i = new PA(31), n = 0; n < 31; ++n)i[n] = t1 += 1 << e1[n - 1];
            var r = new DA(i[30]);
            for(n = 1; n < 30; ++n)for(var o = i[n]; o < i[n + 1]; ++o)r[o] = o - i[n] << 5 | n;
            return {
                b: i,
                r: r
            };
        }, BA = LA(CA, 2), NA = BA.b, VA = BA.r;
        NA[28] = 258, VA[258] = 28;
        for(var kA = LA(FA, 0).b, UA = new PA(32768), GA = 0; GA < 32768; ++GA){
            var jA = (43690 & GA) >> 1 | (21845 & GA) << 1;
            UA[GA] = ((65280 & (jA = (61680 & (jA = (52428 & jA) >> 2 | (13107 & jA) << 2)) >> 4 | (3855 & jA) << 4)) >> 8 | (255 & jA) << 8) >> 1;
        }
        var HA = function(e1, t1, i) {
            for(var n = e1.length, r = 0, o = new PA(t1); r < n; ++r)e1[r] && ++o[e1[r] - 1];
            var a, s = new PA(t1);
            for(r = 1; r < t1; ++r)s[r] = s[r - 1] + o[r - 1] << 1;
            a = new PA(1 << t1);
            var l = 15 - t1;
            for(r = 0; r < n; ++r)if (e1[r]) for(var u = r << 4 | e1[r], c = t1 - e1[r], h = s[e1[r] - 1]++ << c, d = h | (1 << c) - 1; h <= d; ++h)a[UA[h] >> l] = u;
            return a;
        }, $A = new RA(288);
        for(GA = 0; GA < 144; ++GA)$A[GA] = 8;
        for(GA = 144; GA < 256; ++GA)$A[GA] = 9;
        for(GA = 256; GA < 280; ++GA)$A[GA] = 7;
        for(GA = 280; GA < 288; ++GA)$A[GA] = 8;
        var ZA = new RA(32);
        for(GA = 0; GA < 32; ++GA)ZA[GA] = 5;
        var WA = HA($A, 9), qA = HA(ZA, 5), XA = function(e1) {
            for(var t1 = e1[0], i = 1; i < e1.length; ++i)e1[i] > t1 && (t1 = e1[i]);
            return t1;
        }, YA = function(e1, t1, i) {
            var n = t1 / 8 | 0;
            return (e1[n] | e1[n + 1] << 8) >> (7 & t1) & i;
        }, JA = function(e1, t1) {
            var i = t1 / 8 | 0;
            return (e1[i] | e1[i + 1] << 8 | e1[i + 2] << 16) >> (7 & t1);
        }, KA = function(e1) {
            return (e1 + 7) / 8 | 0;
        }, QA = [
            "unexpected EOF",
            "invalid block type",
            "invalid length/literal",
            "invalid distance",
            "stream finished",
            "no stream handler",
            ,
            "no callback",
            "invalid UTF-8 data",
            "extra field too long",
            "date not in range 1980-2099",
            "filename too long",
            "stream finishing",
            "invalid zip data"
        ], eI = function(e1, t1, i) {
            var n = new Error(t1 || QA[e1]);
            if (n.code = e1, Error.captureStackTrace && Error.captureStackTrace(n, eI), !i) throw n;
            return n;
        }, tI = new RA(0);
        var iI = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            iI.decode(tI, {
                stream: !0
            });
        } catch (e1) {}
        const nI = {
            gzip_data: "gzip"
        };
        class rI extends Error {
            constructor(e1){
                super(e1), this.name = "MRTError";
            }
        }
        const oI = {
            0: "uint32",
            1: "uint32",
            2: "uint16",
            3: "uint8"
        }, aI = {
            uint32: 1,
            uint16: 2,
            uint8: 4
        }, sI = {
            uint32: Uint32Array,
            uint16: Uint16Array,
            uint8: Uint8Array
        };
        let lI;
        class uI {
            constructor(e1 = 5){
                this.x = NaN, this.y = NaN, this.z = NaN, this.layers = {}, this._cacheSize = e1;
            }
            getLayer(e1) {
                const t1 = this.layers[e1];
                if (!t1) throw new rI(`Layer '${e1}' not found`);
                return t1;
            }
            getHeaderLength(e1) {
                const t1 = new Uint8Array(e1), i = new DataView(e1);
                if (13 !== t1[0]) throw new rI("File is not a valid MRT.");
                return i.getUint32(1, !0);
            }
            parseHeader(e1) {
                const t1 = new Uint8Array(e1), i = this.getHeaderLength(e1);
                if (t1.length < i) throw new rI(`Expected header with length >= ${i} but got buffer of length ${t1.length}`);
                const n = function(e1) {
                    const t1 = {
                        headerLength: 0,
                        x: 0,
                        y: 0,
                        z: 0,
                        layers: []
                    };
                    let i;
                    for(; i = e1.nextField(void 0);)1 === i ? t1.headerLength = e1.readFixed32() : 2 === i ? t1.x = e1.readVarint() : 3 === i ? t1.y = e1.readVarint() : 4 === i ? t1.z = e1.readVarint() : 5 === i && t1.layers.push(IA(e1, e1.readVarint() + e1.pos));
                    return t1;
                }(new lI(t1.subarray(0, i)));
                if (!isNaN(this.x) && (this.x !== n.x || this.y !== n.y || this.z !== n.z)) throw new rI(`Invalid attempt to parse header ${n.z}/${n.x}/${n.y} for tile ${this.z}/${this.x}/${this.y}`);
                this.x = n.x, this.y = n.y, this.z = n.z;
                for (const e1 of n.layers)this.layers[e1.name] = new cI(e1, {
                    cacheSize: this._cacheSize
                });
                return this;
            }
            createDecodingTask(e1) {
                const t1 = [], i = this.getLayer(e1.layerName);
                for (let n of e1.blockIndices){
                    const r = i.dataIndex[n], o = r.firstByte - e1.firstByte, a = r.lastByte - e1.firstByte;
                    if (i._blocksInProgress.has(n)) continue;
                    const s = {
                        layerName: i.name,
                        firstByte: o,
                        lastByte: a,
                        pixelFormat: i.pixelFormat,
                        blockIndex: n,
                        blockShape: [
                            r.bands.length
                        ].concat(i.bandShape),
                        buffer: i.buffer,
                        codec: r.codec.codec,
                        filters: r.filters.map((e1)=>e1.filter)
                    };
                    i._blocksInProgress.add(n), t1.push(s);
                }
                return new hI(t1, ()=>{
                    t1.forEach((e1)=>i._blocksInProgress.delete(e1.blockIndex));
                }, (e1, n)=>{
                    if (t1.forEach((e1)=>i._blocksInProgress.delete(e1.blockIndex)), e1) throw e1;
                    n.forEach((e1)=>{
                        this.getLayer(e1.layerName).processDecodedData(e1);
                    });
                });
            }
        }
        class cI {
            constructor({ version: e1, name: t1, units: i, tileSize: n, pixelFormat: r, buffer: o, dataIndex: a }, s){
                if (this.version = e1, 1 !== this.version) throw new rI(`Cannot parse raster layer encoded with MRT version ${e1}`);
                this.name = t1, this.units = i, this.tileSize = n, this.buffer = o, this.pixelFormat = oI[r], this.dataIndex = a, this.bandShape = [
                    n + 2 * o,
                    n + 2 * o,
                    aI[this.pixelFormat]
                ], this._decodedBlocks = new nA(s ? s.cacheSize : 5), this._blocksInProgress = new Set;
            }
            get dimension() {
                return aI[this.pixelFormat];
            }
            get cacheSize() {
                return this._decodedBlocks.capacity;
            }
            getBandList() {
                return this.dataIndex.map(({ bands: e1 })=>e1).flat();
            }
            processDecodedData(e1) {
                const t1 = e1.blockIndex.toString();
                this._decodedBlocks.get(t1) || this._decodedBlocks.put(t1, e1.data);
            }
            getBlockForBand(e1) {
                let t1 = 0;
                switch(typeof e1){
                    case "string":
                        for (const [i, n] of this.dataIndex.entries()){
                            for (const [r, o] of n.bands.entries())if (o === e1) return {
                                bandIndex: t1 + r,
                                blockIndex: i,
                                blockBandIndex: r
                            };
                            t1 += n.bands.length;
                        }
                        break;
                    case "number":
                        for (const [i, n] of this.dataIndex.entries()){
                            if (e1 >= t1 && e1 < t1 + n.bands.length) return {
                                bandIndex: e1,
                                blockIndex: i,
                                blockBandIndex: e1 - t1
                            };
                            t1 += n.bands.length;
                        }
                        break;
                    default:
                        throw new rI(`Invalid band \`${JSON.stringify(e1)}\`. Expected string or integer.`);
                }
                return {
                    blockIndex: -1,
                    blockBandIndex: -1
                };
            }
            getDataRange(e1) {
                let t1 = 1 / 0, i = -1 / 0;
                const n = [], r = new Set;
                for (const o of e1){
                    const { blockIndex: e1 } = this.getBlockForBand(o);
                    if (e1 < 0) throw new rI(`Invalid band: ${JSON.stringify(o)}`);
                    const a = this.dataIndex[e1];
                    n.includes(e1) || n.push(e1), r.add(e1), t1 = Math.min(t1, a.firstByte), i = Math.max(i, a.lastByte);
                }
                if (r.size > this.cacheSize) throw new rI(`Number of blocks to decode (${r.size}) exceeds cache size (${this.cacheSize}).`);
                return {
                    layerName: this.name,
                    firstByte: t1,
                    lastByte: i,
                    blockIndices: n
                };
            }
            hasBand(e1) {
                const { blockIndex: t1 } = this.getBlockForBand(e1);
                return t1 >= 0;
            }
            hasDataForBand(e1) {
                const { blockIndex: t1 } = this.getBlockForBand(e1);
                return t1 >= 0 && !!this._decodedBlocks.get(t1.toString());
            }
            getBandView(e1) {
                const { blockIndex: t1, blockBandIndex: i } = this.getBlockForBand(e1);
                if (t1 < 0) throw new rI(`Band not found: ${JSON.stringify(e1)}`);
                const n = this._decodedBlocks.get(t1.toString());
                if (!n) throw new rI(`Data for band ${JSON.stringify(e1)} of layer "${this.name}" not decoded.`);
                const r = this.dataIndex[t1], o = this.bandShape.reduce((e1, t1)=>e1 * t1, 1), a = i * o, s = n.subarray(a, a + o);
                return {
                    data: s,
                    bytes: new Uint8Array(s.buffer).subarray(s.byteOffset, s.byteOffset + s.byteLength),
                    tileSize: this.tileSize,
                    buffer: this.buffer,
                    pixelFormat: this.pixelFormat,
                    dimension: this.dimension,
                    offset: r.offset,
                    scale: r.scale
                };
            }
        }
        uI.setPbf = function(e1) {
            lI = e1;
        };
        class hI {
            constructor(e1, t1, i){
                this.tasks = e1, this._onCancel = t1, this._onComplete = i, this._finalized = !1;
            }
            cancel() {
                this._finalized || (this._onCancel(), this._finalized = !0);
            }
            complete(e1, t1) {
                this._finalized || (this._onComplete(e1, t1), this._finalized = !0);
            }
        }
        uI.performDecoding = function(e1, t1) {
            const i = new Uint8Array(e1);
            return Promise.all(t1.tasks.map((e1)=>{
                const { layerName: t1, firstByte: n, lastByte: r, pixelFormat: o, blockShape: a, blockIndex: s, filters: l, codec: u } = e1, c = i.subarray(n, r + 1), h = new Uint32Array(a[0] * a[1] * a[2]);
                let d;
                if ("gzip_data" !== u) throw new rI(`Unhandled codec: ${u}`);
                return d = (function(e1, t1) {
                    if (!globalThis.DecompressionStream && "gzip_data" === t1) return Promise.resolve((a = function(e1) {
                        31 == e1[0] && 139 == e1[1] && 8 == e1[2] || eI(6, "invalid gzip data");
                        var t1 = e1[3], i = 10;
                        4 & t1 && (i += 2 + (e1[10] | e1[11] << 8));
                        for(var n = (t1 >> 3 & 1) + (t1 >> 4 & 1); n > 0; n -= !e1[i++]);
                        return i + (2 & t1);
                    }(i = e1), a + 8 > i.length && eI(6, "invalid gzip data"), function(e1, t1, i, n) {
                        var r = e1.length;
                        if (!r || t1.f && !t1.l) return i || new RA(0);
                        var o = !i, a = o || 2 != t1.i, s = t1.i;
                        o && (i = new RA(3 * r));
                        var l = function(e1) {
                            var t1 = i.length;
                            if (e1 > t1) {
                                var n = new RA(Math.max(2 * t1, e1));
                                n.set(i), i = n;
                            }
                        }, u = t1.f || 0, c = t1.p || 0, h = t1.b || 0, d = t1.l, f = t1.d, p = t1.m, _ = t1.n, m = 8 * r;
                        do {
                            if (!d) {
                                u = YA(e1, c, 1);
                                var g = YA(e1, c + 1, 3);
                                if (c += 3, !g) {
                                    var y = e1[(z = KA(c) + 4) - 4] | e1[z - 3] << 8, x = z + y;
                                    if (x > r) {
                                        s && eI(0);
                                        break;
                                    }
                                    a && l(h + y), i.set(e1.subarray(z, x), h), t1.b = h += y, t1.p = c = 8 * x, t1.f = u;
                                    continue;
                                }
                                if (1 == g) d = WA, f = qA, p = 9, _ = 5;
                                else if (2 == g) {
                                    var v = YA(e1, c, 31) + 257, b = YA(e1, c + 10, 15) + 4, w = v + YA(e1, c + 5, 31) + 1;
                                    c += 14;
                                    for(var E = new RA(w), A = new RA(19), I = 0; I < b; ++I)A[OA[I]] = YA(e1, c + 3 * I, 7);
                                    c += 3 * b;
                                    var T = XA(A), M = (1 << T) - 1, S = HA(A, T);
                                    for(I = 0; I < w;){
                                        var z, R = S[YA(e1, c, M)];
                                        if (c += 15 & R, (z = R >> 4) < 16) E[I++] = z;
                                        else {
                                            var P = 0, D = 0;
                                            for(16 == z ? (D = 3 + YA(e1, c, 3), c += 2, P = E[I - 1]) : 17 == z ? (D = 3 + YA(e1, c, 7), c += 3) : 18 == z && (D = 11 + YA(e1, c, 127), c += 7); D--;)E[I++] = P;
                                        }
                                    }
                                    var C = E.subarray(0, v), F = E.subarray(v);
                                    p = XA(C), _ = XA(F), d = HA(C, p), f = HA(F, _);
                                } else eI(1);
                                if (c > m) {
                                    s && eI(0);
                                    break;
                                }
                            }
                            a && l(h + 131072);
                            for(var O = (1 << p) - 1, L = (1 << _) - 1, B = c;; B = c){
                                var N = (P = d[JA(e1, c) & O]) >> 4;
                                if ((c += 15 & P) > m) {
                                    s && eI(0);
                                    break;
                                }
                                if (P || eI(2), N < 256) i[h++] = N;
                                else {
                                    if (256 == N) {
                                        B = c, d = null;
                                        break;
                                    }
                                    var V = N - 254;
                                    N > 264 && (V = YA(e1, c, (1 << (G = CA[I = N - 257])) - 1) + NA[I], c += G);
                                    var k = f[JA(e1, c) & L], U = k >> 4;
                                    if (k || eI(3), c += 15 & k, F = kA[U], U > 3) {
                                        var G = FA[U];
                                        F += JA(e1, c) & (1 << G) - 1, c += G;
                                    }
                                    if (c > m) {
                                        s && eI(0);
                                        break;
                                    }
                                    a && l(h + 131072);
                                    var j = h + V;
                                    if (h < F) {
                                        var H = 0 - F, $ = Math.min(F, j);
                                        for(H + h < 0 && eI(3); h < $; ++h)i[h] = n[H + h];
                                    }
                                    for(; h < j; ++h)i[h] = i[h - F];
                                }
                            }
                            t1.l = d, t1.p = B, t1.b = h, t1.f = u, d && (u = 1, t1.m = p, t1.d = f, t1.n = _);
                        }while (!u);
                        return h != i.length && o ? function(e1, t1, i) {
                            return (null == i || i > e1.length) && (i = e1.length), new RA(e1.subarray(0, i));
                        }(i, 0, h) : i.subarray(0, h);
                    }(i.subarray(a, -8), {
                        i: 2
                    }, new RA(((r = i)[(o = r.length) - 4] | r[o - 3] << 8 | r[o - 2] << 16 | r[o - 1] << 24) >>> 0), n)));
                    var i, n, r, o, a;
                    const s = nI[t1];
                    if (!s) throw new Error(`Unhandled codec: ${t1}`);
                    const l = new globalThis.DecompressionStream(s);
                    return new Response(new Blob([
                        e1
                    ]).stream().pipeThrough(l)).arrayBuffer().then((e1)=>new Uint8Array(e1));
                })(c, u).then((e1)=>((function(e1, t1) {
                        let i;
                        for(; i = e1.nextField();)if (2 === i) TA(e1, e1.readVarint() + e1.pos, t1);
                        else if (3 === i) throw new Error("Not implemented");
                    })(new lI(e1), h), new sI[o](h.buffer))), d.then((e1)=>{
                    for(let t1 = l.length - 1; t1 >= 0; t1--)switch(l[t1]){
                        case "delta_filter":
                            MA(e1, a);
                            break;
                        case "zigzag_filter":
                            SA(e1);
                            break;
                        case "bitshuffle_filter":
                            zA(e1, o);
                            break;
                        default:
                            throw new rI(`Unhandled filter "${l[t1]}"`);
                    }
                    return {
                        layerName: t1,
                        blockIndex: s,
                        data: e1
                    };
                }).catch((e1)=>{
                    throw e1;
                });
            }));
        }, Ha(hI, "MRTDecodingBatch", {
            omit: [
                "_onCancel",
                "_onComplete"
            ]
        }), Ha(uI, "MapboxRasterTile"), Ha(cI, "MapboxRasterLayer", {
            omit: [
                "_blocksInProgress"
            ]
        });
        const dI = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ], fI = new Uint32Array(96);
        class pI {
            static from(e1) {
                if (!e1 || void 0 === e1.byteLength || e1.buffer) throw new Error("Data must be an instance of ArrayBuffer or SharedArrayBuffer.");
                const [t1, i] = new Uint8Array(e1, 0, 2);
                if (219 !== t1) throw new Error("Data does not appear to be in a KDBush format.");
                const n = i >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const r = dI[15 & i];
                if (!r) throw new Error("Unrecognized array type.");
                const [o] = new Uint16Array(e1, 2, 1), [a] = new Uint32Array(e1, 4, 1);
                return new pI(a, o, r, void 0, e1);
            }
            constructor(e1, t1 = 64, i = Float64Array, n = ArrayBuffer, r){
                if (isNaN(e1) || e1 < 0) throw new Error(`Unexpected numItems value: ${e1}.`);
                this.numItems = +e1, this.nodeSize = Math.min(Math.max(+t1, 2), 65535), this.ArrayType = i, this.IndexArrayType = e1 < 65536 ? Uint16Array : Uint32Array;
                const o = dI.indexOf(this.ArrayType), a = 2 * e1 * this.ArrayType.BYTES_PER_ELEMENT, s = e1 * this.IndexArrayType.BYTES_PER_ELEMENT, l = (8 - s % 8) % 8;
                if (o < 0) throw new Error(`Unexpected typed array class: ${i}.`);
                if (r) this.data = r, this.ids = new this.IndexArrayType(r, 8, e1), this.coords = new i(r, 8 + s + l, 2 * e1), this._pos = 2 * e1, this._finished = !0;
                else {
                    const r = this.data = new n(8 + a + s + l);
                    this.ids = new this.IndexArrayType(r, 8, e1), this.coords = new i(r, 8 + s + l, 2 * e1), this._pos = 0, this._finished = !1, new Uint8Array(r, 0, 2).set([
                        219,
                        16 + o
                    ]), new Uint16Array(r, 2, 1)[0] = t1, new Uint32Array(r, 4, 1)[0] = e1;
                }
            }
            add(e1, t1) {
                const i = this._pos >> 1;
                return this.ids[i] = i, this.coords[this._pos++] = e1, this.coords[this._pos++] = t1, i;
            }
            finish() {
                const e1 = this._pos >> 1;
                if (e1 !== this.numItems) throw new Error(`Added ${e1} items when expected ${this.numItems}.`);
                return _I(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(e1, t1, i, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: r, coords: o, nodeSize: a } = this;
                fI[0] = 0, fI[1] = r.length - 1, fI[2] = 0;
                let s = 3;
                const l = [];
                for(; s > 0;){
                    const u = fI[--s], c = fI[--s], h = fI[--s];
                    if (c - h <= a) {
                        for(let a = h; a <= c; a++){
                            const s = o[2 * a], u = o[2 * a + 1];
                            s >= e1 && s <= i && u >= t1 && u <= n && l.push(r[a]);
                        }
                        continue;
                    }
                    const d = h + c >> 1, f = o[2 * d], p = o[2 * d + 1];
                    f >= e1 && f <= i && p >= t1 && p <= n && l.push(r[d]), (0 === u ? e1 <= f : t1 <= p) && (fI[s++] = h, fI[s++] = d - 1, fI[s++] = 1 - u), (0 === u ? i >= f : n >= p) && (fI[s++] = d + 1, fI[s++] = c, fI[s++] = 1 - u);
                }
                return l;
            }
            within(e1, t1, i) {
                const n = [];
                return this.withinInto(e1, t1, i, n), n;
            }
            withinInto(e1, t1, i, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: r, coords: o, nodeSize: a } = this;
                fI[0] = 0, fI[1] = r.length - 1, fI[2] = 0;
                let s = 3, l = 0;
                const u = i * i;
                for(; s > 0;){
                    const c = fI[--s], h = fI[--s], d = fI[--s];
                    if (h - d <= a) {
                        for(let i = d; i <= h; i++)xI(o[2 * i], o[2 * i + 1], e1, t1) <= u && (n[l++] = r[i]);
                        continue;
                    }
                    const f = d + h >> 1, p = o[2 * f], _ = o[2 * f + 1];
                    xI(p, _, e1, t1) <= u && (n[l++] = r[f]), (0 === c ? e1 - i <= p : t1 - i <= _) && (fI[s++] = d, fI[s++] = f - 1, fI[s++] = 1 - c), (0 === c ? e1 + i >= p : t1 + i >= _) && (fI[s++] = f + 1, fI[s++] = h, fI[s++] = 1 - c);
                }
                return l;
            }
        }
        function _I(e1, t1, i, n, r, o) {
            if (r - n <= i) return;
            const a = n + r >> 1;
            mI(e1, t1, a, n, r, o), _I(e1, t1, i, n, a - 1, 1 - o), _I(e1, t1, i, a + 1, r, 1 - o);
        }
        function mI(e1, t1, i, n, r, o) {
            for(; r > n;){
                if (r - n > 600) {
                    const a = r - n + 1, s = i - n + 1, l = Math.log(a), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (a - u) / a) * (s - a / 2 < 0 ? -1 : 1);
                    mI(e1, t1, i, Math.max(n, Math.floor(i - s * u / a + c)), Math.min(r, Math.floor(i + (a - s) * u / a + c)), o);
                }
                const a = t1[2 * i + o];
                let s = n, l = r;
                for(gI(e1, t1, n, i), t1[2 * r + o] > a && gI(e1, t1, n, r); s < l;){
                    for(gI(e1, t1, s, l), s++, l--; t1[2 * s + o] < a;)s++;
                    for(; t1[2 * l + o] > a;)l--;
                }
                t1[2 * n + o] === a ? gI(e1, t1, n, l) : (l++, gI(e1, t1, l, r)), l <= i && (n = l + 1), i <= l && (r = l - 1);
            }
        }
        function gI(e1, t1, i, n) {
            yI(e1, i, n), yI(t1, 2 * i, 2 * n), yI(t1, 2 * i + 1, 2 * n + 1);
        }
        function yI(e1, t1, i) {
            const n = e1[t1];
            e1[t1] = e1[i], e1[i] = n;
        }
        function xI(e1, t1, i, n) {
            const r = e1 - i, o = t1 - n;
            return r * r + o * o;
        }
        t1.$ = Zb, t1.A = uo, t1.B = ho, t1.C = pn, t1.D = lo, t1.E = sn, t1.F = lr, t1.G = nr, t1.H = tr, t1.I = ln, t1.J = il, t1.K = /^(.*)-transition$/, t1.L = nA, t1.M = Ta, t1.N = Ea, t1.O = De, t1.P = Pe, t1.Q = c, t1.R = ai, t1.S = $f, t1.T = c_, t1.U = /^(.*)-use-theme$/, t1.V = function(e1, t1) {
            const i = $f(t1.zoom);
            if (0 === i) return Pf(e1);
            const n = Of(e1), r = Lf(n), o = hr(n.getWest()) * t1.worldSize, a = hr(n.getEast()) * t1.worldSize, s = dr(n.getNorth()) * t1.worldSize, l = dr(n.getSouth()) * t1.worldSize, u = [
                o,
                s,
                0
            ], c = [
                a,
                s,
                0
            ], h = [
                o,
                l,
                0
            ], d = [
                a,
                l,
                0
            ], f = p([], t1.globeMatrix);
            return Y(u, u, f), Y(c, c, f), Y(h, h, f), Y(d, d, f), r[0] = Df(r[0], h, i), r[1] = Df(r[1], d, i), r[2] = Df(r[2], c, i), r[3] = Df(r[3], u, i), If.fromPoints(r);
        }, t1.W = Uf, t1.X = _, t1.Y = u, t1.Z = jb, t1._ = Vb, t1.a = async function(e1, t1) {
            e1.headers || (e1.headers = {}), e1.headers.accept = "image/webp,*/*";
            const i = await function(e1) {
                return new Promise((t1, i)=>{
                    if (e1 && e1.aborted) return void i(e1.reason);
                    const n = ()=>{
                        const e1 = gi.shift();
                        e1 ? e1() : yi--;
                    };
                    if (yi < Ut.MAX_PARALLEL_IMAGE_REQUESTS) return yi++, void t1(n);
                    const r = ()=>{
                        e1 && e1.removeEventListener("abort", o), t1(n);
                    }, o = ()=>{
                        const t1 = gi.indexOf(r);
                        -1 !== t1 && gi.splice(t1, 1), i(e1.reason);
                    };
                    e1 && e1.addEventListener("abort", o), gi.push(r);
                });
            }(t1);
            try {
                const { data: i, headers: n } = await _i(e1, t1);
                let r;
                try {
                    r = await createImageBitmap(new Blob([
                        new Uint8Array(i)
                    ], {
                        type: "image/png"
                    }));
                } catch (e1) {
                    throw new Error(`Could not load image because of ${e1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`, {
                        cause: e1
                    });
                }
                return t1 && t1.throwIfAborted(), {
                    data: r,
                    headers: n
                };
            } finally{
                i();
            }
        }, t1.a$ = yc, t1.a0 = vw, t1.a1 = Gb, t1.a2 = Sr, t1.a3 = Xc, t1.a4 = qc, t1.a5 = eh, t1.a6 = Yc, t1.a7 = hr, t1.a8 = dr, t1.a9 = z, t1.aA = yu, t1.aB = ip, t1.aC = vx, t1.aD = Dx, t1.aE = _w, t1.aF = BE, t1.aG = Gn, t1.aH = (e1, t1, i, n, r, o, a, s, l, u, c, h, d, f, p, _, m, g, y = !1)=>{
            const x = DE(e1, t1, i, n, r, o, a, s, u, c, h, d, f, p, _, m, 1, [
                0,
                0,
                0
            ], [
                0,
                0,
                1
            ], y), v = {
                u_height_factor: -Math.pow(2, s.overscaledZ) / l.tileSize / 8
            };
            return Object.assign(x, SE(t1, l, g), v);
        }, t1.aI = DE, t1.aJ = ox, t1.aK = 450, t1.aL = 7, t1.aM = (e1, t1, i, n, r, o)=>({
                u_matrix: e1,
                u_edge_radius: t1,
                u_width_scale: i,
                u_vertical_scale: n,
                u_height_type: zE[r],
                u_base_type: zE[o]
            }), t1.aN = g, t1.aO = p, t1.aP = f, t1.aQ = FE, t1.aR = 4, t1.aS = 2, t1.aT = Dh, t1.aU = Fh, t1.aV = ct, t1.aW = class {
            static calculate(e1, t1, i) {
                const n = new Set, r = new Map, o = new Set, a = new Set;
                for (const i of Object.values(e1))for (const [e1, s] of Object.entries(i.floors)){
                    o.add(e1), s.isDefault && a.add(e1), s.conflicts && r.set(e1, s.conflicts);
                    const i = e1 === t1, l = s.connections && t1 && s.connections.has(t1);
                    (i || l) && n.add(e1);
                }
                const s = (e1)=>{
                    const t1 = r.get(e1) || new Set;
                    for (const i of n)if ((r.get(i) || new Set).has(e1) || t1.has(i)) return !0;
                    return !1;
                };
                if (i) for (const e1 of i)o.has(e1) && (s(e1) || n.add(e1));
                for (const e1 of a)n.has(e1) || s(e1) || n.add(e1);
                return n;
            }
        }, t1.aX = Wc, t1.aY = Kc, t1.aZ = class extends Zc {
            constructor(e1){
                super(e1), this.current = new Float32Array(9);
            }
            set(e1, t1, i) {
                if (!this.fetchUniformLocation(e1, t1)) return;
                const n = this.current;
                for(let e1 = 0; e1 < 9; e1++)if (i[e1] !== n[e1]) {
                    n.set(i), this.gl.uniformMatrix3fv(this.location, !1, n);
                    break;
                }
            }
        }, t1.a_ = Ou, t1.aa = nc, t1.ab = zd, t1.ac = Bc, t1.ad = oc, t1.ae = js, t1.af = Ks, t1.ag = Xs, t1.ah = class {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t1) {
                return yt(e1.expression.evaluate(t1));
            }
            interpolate(e1, t1, i) {
                return {
                    x: dn(e1.x, t1.x, i),
                    y: dn(e1.y, t1.y, i),
                    z: dn(e1.z, t1.z, i),
                    azimuthal: dn(e1.azimuthal, t1.azimuthal, i),
                    polar: dn(e1.polar, t1.polar, i)
                };
            }
        }, t1.ai = ks, t1.aj = Na, t1.ak = qs, t1.al = dn, t1.am = it, t1.an = 65, t1.ao = 45, t1.ap = function(e1, t1, i) {
            const n = bu.fromLngLat(t1), r = i.elevation ? i.elevation.getAtPointOrZero(n) : 0;
            return yw(e1, n.x, n.y, r, i);
        }, t1.aq = function(e1, t1, i, n, r, o, a) {
            const s = [
                [
                    i,
                    n,
                    0
                ],
                [
                    r,
                    n,
                    0
                ],
                [
                    r,
                    o,
                    0
                ],
                [
                    i,
                    o,
                    0
                ]
            ];
            let l = Number.MAX_VALUE, u = -Number.MAX_VALUE;
            for (const e1 of s){
                const i = D(Y([], e1, t1));
                l = Math.min(l, i), u = Math.max(u, i);
            }
            return [
                gw(e1, l, a.pitch),
                gw(e1, u, a.pitch)
            ];
        }, t1.ar = yn, t1.as = yw, t1.at = mw, t1.au = Ye, t1.av = function() {
            return at++;
        }, t1.aw = class {
            constructor(e1, t1, i){
                this.target = e1, this.parent = t1, this.mapId = i, this.pendingResponses = new Map, ct([
                    "receive"
                ], this), this.target.addEventListener("message", this.receive, !1), this.scheduler = new aA;
            }
            send(e1, t1, i) {
                const { signal: n, targetMapId: r, metadata: o } = i || {}, a = Math.round(1e18 * Math.random()).toString(36).substring(0, 10), s = new Set;
                return n && n.aborted ? Promise.reject(n.reason) : (this.target.postMessage({
                    id: a,
                    type: e1,
                    targetMapId: r,
                    sourceMapId: this.mapId,
                    data: qa(t1, s)
                }, [
                    ...s
                ]), new Promise((e1, t1)=>{
                    const i = {
                        resolve: e1,
                        reject: t1,
                        metadata: o || sA
                    };
                    if (n) {
                        const e1 = ()=>{
                            this.pendingResponses.delete(a), t1(n.reason);
                        };
                        n.addEventListener("abort", e1, {
                            once: !0
                        }), i.detach = ()=>n.removeEventListener("abort", e1);
                    }
                    this.pendingResponses.set(a, i);
                }));
            }
            notify(e1, t1, i) {
                const { targetMapId: n } = i || {}, r = new Set;
                this.target.postMessage({
                    type: e1,
                    targetMapId: n,
                    sourceMapId: this.mapId,
                    data: qa(t1, r)
                }, [
                    ...r
                ]);
            }
            sendCancelable(e1, t1, i, n) {
                const r = new AbortController;
                return this.send(e1, t1, {
                    ...i,
                    signal: r.signal
                }).then((e1)=>n(null, e1)).catch((e1)=>{
                    "AbortError" !== e1.name && n(e1);
                }), r;
            }
            getWorkerSourceActor(e1) {
                return {
                    scheduler: this.scheduler,
                    send: (t1, i, n)=>this.send(t1, i, {
                            ...n,
                            targetMapId: e1
                        }),
                    notify: (t1, i)=>{
                        this.notify(t1, i, {
                            targetMapId: e1
                        });
                    },
                    sendCancelable: (t1, i, n, r)=>this.sendCancelable(t1, i, {
                            ...n,
                            targetMapId: e1
                        }, r)
                };
            }
            receive(e1) {
                const t1 = e1.data;
                if (!t1) return;
                const i = t1.id;
                if (!t1.targetMapId || this.mapId === t1.targetMapId) {
                    if (vt(self)) {
                        const e1 = this.pendingResponses.get(i);
                        this.scheduler.add(()=>{
                            this.processTask(i, t1);
                        }, e1 && e1.metadata || sA);
                    } else this.processTask(i, t1);
                }
            }
            async processTask(e1, t1) {
                if ("<response>" === t1.type) {
                    const i = this.pendingResponses.get(e1);
                    if (this.pendingResponses.delete(e1), i) {
                        i.detach && i.detach();
                        try {
                            t1.error ? i.reject(Xa(t1.error)) : i.resolve(Xa(t1.data));
                        } catch (e1) {
                            i.reject(e1);
                        }
                    }
                    return;
                }
                const i = new Set, n = Xa(t1.data);
                try {
                    let r;
                    if (this.parent[t1.type]) r = await this.parent[t1.type](t1.sourceMapId, n);
                    else {
                        if (!this.parent.getWorkerSource) throw new Error(`Could not find function ${t1.type}`);
                        {
                            const e1 = t1.type.split("."), { source: i, scope: o } = n, a = this.parent.getWorkerSource(t1.sourceMapId, {
                                type: e1[0],
                                source: i,
                                scope: o
                            });
                            r = await a[e1[1]](n);
                        }
                    }
                    if (!e1) return;
                    this.target.postMessage({
                        id: e1,
                        type: "<response>",
                        sourceMapId: this.mapId,
                        error: null,
                        data: qa(r, i)
                    }, [
                        ...i
                    ]);
                } catch (t1) {
                    this.target.postMessage({
                        id: e1,
                        type: "<response>",
                        sourceMapId: this.mapId,
                        error: qa(t1),
                        data: null
                    }, []);
                }
            }
            remove() {
                for (const e1 of this.pendingResponses.values())e1.detach && e1.detach(), e1.reject(new DOMException("Actor removed", "AbortError"));
                this.pendingResponses.clear(), this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
        }, t1.ax = class {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t1) {
                return function([e1, t1]) {
                    const i = yt([
                        1,
                        e1,
                        t1
                    ]);
                    return {
                        x: i.x,
                        y: i.y,
                        z: i.z
                    };
                }(e1.expression.evaluate(t1));
            }
            interpolate(e1, t1, i) {
                return {
                    x: dn(e1.x, t1.x, i),
                    y: dn(e1.y, t1.y, i),
                    z: dn(e1.z, t1.z, i)
                };
            }
        }, t1.ay = JE, t1.az = Af, t1.b = od, t1.b$ = function(e1, { x: t1, y: i }, n = 0) {
            return new Pe(((t1 - n) * e1.scale - e1.x) * Sr, (i * e1.scale - e1.y) * Sr);
        }, t1.b0 = tt, t1.b1 = 6, t1.b2 = Of, t1.b3 = function(e1) {
            const t1 = 80.051129;
            e1 = tt(e1, -80.051129, t1) / t1 * 90;
            const i = Math.pow(Math.abs(Math.sin(Ye(e1))), 3);
            return Math.round(i * (ru.length - 1));
        }, t1.b4 = kf, t1.b5 = Pf, t1.b6 = function(e1) {
            const t1 = e1.pixelsPerMeter, i = t1 / pu(1, e1.center.lat), n = d(new Float64Array(16));
            return m(n, n, [
                e1.point.x,
                e1.point.y,
                0
            ]), g(n, n, [
                i,
                i,
                t1
            ]), Float32Array.from(n);
        }, t1.b7 = function(e1, t1, i, n) {
            const r = t1.getNorth(), o = t1.getSouth(), a = t1.getWest(), l = t1.getEast(), u = 1 << e1.z, c = l - a, h = r - o, d = c / nu, f = -h / ru[i], p = [
                0,
                d,
                0,
                f,
                0,
                0,
                r,
                a,
                0
            ];
            if (e1.z > 0) {
                const e1 = 180 / n;
                s(p, p, [
                    e1 / c + 1,
                    0,
                    0,
                    0,
                    e1 / h + 1,
                    0,
                    -0.5 * e1 / d,
                    .5 * e1 / f,
                    1
                ]);
            }
            return p[2] = u, p[5] = e1.x, p[8] = e1.y, p;
        }, t1.b8 = Pt, t1.b9 = 256, t1.bA = gh, t1.bB = zu, t1.bC = Bu, t1.bD = _c, t1.bE = _f, t1.bF = Ml, t1.bG = Bf, t1.bH = Y, t1.bI = Df, t1.bJ = Nu, t1.bK = pf, t1.bL = w, t1.bM = m, t1.bN = function() {
            Vs.isLoading() || Vs.isLoaded() || "deferred" !== Bs() || Ns();
        }, t1.bO = li, t1.bP = ep, t1.bQ = function(e1, t1) {
            const i = [];
            for(const n in e1)n in t1 || i.push(n);
            return i;
        }, t1.bR = oA, t1.bS = bu, t1.bT = rt, t1.bU = "hd_road_coverage", t1.bV = function(e1) {
            const t1 = e1.indexOf(_l);
            return t1 >= 0 ? e1.slice(0, t1) : e1;
        }, t1.bW = gl, t1.bX = Kf, t1.bY = Qf, t1.bZ = function(e1, t1, i = 0, n = !0) {
            const r = new Pe(i, i), o = e1.sub(r), a = t1.add(r), s = [
                o,
                new Pe(a.x, o.y),
                a,
                new Pe(o.x, a.y)
            ];
            return n && s.push(o.clone()), s;
        }, t1.b_ = function(e1, t1) {
            const i = [];
            for(let n = 0; n < e1.length; n++){
                const r = nt(n - 1, -1, e1.length - 1), o = nt(n + 1, -1, e1.length - 1), a = e1[n], s = e1[o], l = e1[r].sub(a).unit(), u = s.sub(a).unit(), c = u.angleWithSep(l.x, l.y), h = l.add(u).unit().mult(-1 * t1 / Math.sin(c / 2));
                i.push(a.add(h));
            }
            return i;
        }, t1.ba = pE, t1.bb = IE, t1.bc = fc, t1.bd = ce, t1.be = de, t1.bf = pe, t1.bg = T, t1.bh = C, t1.bi = ua, t1.bj = uu, t1.bk = dc, t1.bl = hc, t1.bm = _u, t1.bn = fw, t1.bo = Rt, t1.bp = np, t1.bq = fr, t1.br = pr, t1.bs = Vu, t1.bt = bc, t1.bu = q_, t1.bv = nl, t1.bw = Ru, t1.bx = Db, t1.by = bt, t1.bz = fd, t1.c = La, t1.c$ = dw, t1.c0 = Hh, t1.c1 = function(e1, t1, i = 0) {
            return C(((t1.x - i) * e1.scale - e1.x) * Sr, (t1.y * e1.scale - e1.y) * Sr, _u(t1.z, t1.y));
        }, t1.c2 = te, t1.c3 = Z, t1.c4 = gf, t1.c5 = Dv, t1.c6 = function(e1) {
            let t1 = 1 / 0, i = 1 / 0, n = -1 / 0, r = -1 / 0;
            for (const o of e1)t1 = Math.min(t1, o.x), i = Math.min(i, o.y), n = Math.max(n, o.x), r = Math.max(r, o.y);
            return {
                min: new Pe(t1, i),
                max: new Pe(n, r)
            };
        }, t1.c7 = le, t1.c8 = iu, t1.c9 = jh, t1.cA = uI, t1.cB = Gp, t1.cC = _i, t1.cD = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ], t1.cE = function(e1, t1, i, n, r, o, a) {
            const s = ew(e1, t1, i, n, r, o, a);
            return "globe" === o.name && i || (s[2] = s[6] = s[10] = s[14] = 0), s;
        }, t1.cF = function(e1, t1, i, n, r, o, a) {
            if (i) {
                if ("globe" === o.name) {
                    const s = ew(e1, t1, i, n, r, o, a);
                    return p(s, s), _(s, e1, s), s;
                }
                {
                    const t1 = c(e1), [i, o, s, l] = a, [u, h, d, f, p, _, m, g] = t1;
                    return t1[0] = i * u + o * p, t1[1] = i * h + o * _, t1[2] = i * d + o * m, t1[3] = i * f + o * g, t1[4] = s * u + l * p, t1[5] = s * h + l * _, t1[6] = s * d + l * m, t1[7] = s * f + l * g, n || v(t1, t1, -r.angle), t1;
                }
            }
            return r.glCoordMatrix;
        }, t1.cG = ef, t1.cH = Sp, t1.cI = Yy, t1.cJ = Bp, t1.cK = Np, t1.cL = Hd, t1.cM = $d, t1.cN = function(e1, [t1, i]) {
            let n = 0, r = 0;
            if (i === tf) {
                t1 < 0 && (t1 = 0);
                const i = t1 / nf;
                switch(e1){
                    case "top-right":
                    case "top-left":
                        r = i - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        r = 7 - i;
                        break;
                    case "bottom":
                        r = 7 - t1;
                        break;
                    case "top":
                        r = t1 - 7;
                }
                switch(e1){
                    case "top-right":
                    case "bottom-right":
                        n = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        n = i;
                        break;
                    case "left":
                        n = t1;
                        break;
                    case "right":
                        n = -t1;
                }
            } else {
                switch(t1 = Math.abs(t1), i = Math.abs(i), e1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        r = i - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        r = 7 - i;
                }
                switch(e1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -t1;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = t1;
                }
            }
            return [
                n,
                r
            ];
        }, t1.cO = function(e1) {
            switch(e1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }, t1.cP = Ga, t1.cQ = be, t1.cR = Ie, t1.cS = Ee, t1.cT = ze, t1.cU = nt, t1.cV = oe, t1.cW = class {
            isDataAvailableAtPoint(e1) {
                const t1 = this._source();
                if (this.isUsingMockSource() || !t1 || e1.y < 0 || e1.y > 1) return !1;
                const i = t1.getSource().maxzoom, n = 1 << i, r = Math.floor(e1.x), o = Math.floor((e1.x - r) * n), a = Math.floor(e1.y * n), s = this.findDEMTileFor(new ep(i, r, i, o, a));
                return !(!s || !s.dem);
            }
            getAtPointOrZero(e1, t1 = 0) {
                return this.getAtPoint(e1, t1) || 0;
            }
            getAtPoint(e1, t1, i = !0) {
                if (this.isUsingMockSource()) return null;
                t1 ??= null;
                const n = this._source();
                if (!n) return t1;
                if (e1.y < 0 || e1.y > 1) return t1;
                const r = n.getSource().maxzoom, o = 1 << r, a = Math.floor(e1.x), s = e1.x - a, l = new ep(r, a, r, Math.floor(s * o), Math.floor(e1.y * o)), u = this.findDEMTileFor(l);
                if (!u || !u.dem) return t1;
                const c = u.dem, h = 1 << u.tileID.canonical.z, d = (s * h - u.tileID.canonical.x) * c.dim, f = (e1.y * h - u.tileID.canonical.y) * c.dim, p = Math.floor(d), _ = Math.floor(f);
                return (i ? this.exaggeration() : 1) * dn(dn(c.get(p, _), c.get(p, _ + 1), f - _), dn(c.get(p + 1, _), c.get(p + 1, _ + 1), f - _), d - p);
            }
            static getAtTileOffset(e1, t1, i, n) {
                const r = 1 << e1.canonical.z;
                return n ? n.pointElevation(t1) : i ? i.getAtPointOrZero(new bu(e1.wrap + (e1.canonical.x + t1.x / Sr) / r, (e1.canonical.y + t1.y / Sr) / r)) : 0;
            }
            static getAtTileOffsetFunc(e1, t1, i, n) {
                return (r, o, a)=>{
                    const s = this.getAtTileOffset(e1, r, o, a), l = n.upVector(e1.canonical, r.x, r.y);
                    return k(l, l, s * n.upVectorScale(e1.canonical, t1, i).metersToTile), l;
                };
            }
            getForTilePoints(e1, t1, i, n) {
                if (this.isUsingMockSource()) return !1;
                const r = _b.create(this, e1, n);
                return !!r && (t1.forEach((e1)=>{
                    e1[2] = this.exaggeration() * r.getElevationAt(e1[0], e1[1], i, !0);
                }), !0);
            }
            getMinMaxForTile(e1) {
                if (this.isUsingMockSource()) return null;
                const t1 = this.findDEMTileFor(e1);
                if (!t1 || !t1.dem) return null;
                const i = t1.dem.tree, n = t1.tileID, r = 1 << e1.canonical.z - n.canonical.z;
                let o = e1.canonical.x / r - n.canonical.x, a = e1.canonical.y / r - n.canonical.y, s = 0;
                for(let t1 = 0; t1 < e1.canonical.z - n.canonical.z && !i.leaves[s]; t1++){
                    o *= 2, a *= 2;
                    const e1 = 2 * Math.floor(a) + Math.floor(o);
                    s = i.childOffsets[s] + e1, o %= 1, a %= 1;
                }
                return {
                    min: this.exaggeration() * i.minimums[s],
                    max: this.exaggeration() * i.maximums[s]
                };
            }
            getMinElevationBelowMSL() {
                throw new Error("Pure virtual method called.");
            }
            raycast(e1, t1, i) {
                throw new Error("Pure virtual method called.");
            }
            pointCoordinate(e1) {
                throw new Error("Pure virtual method called.");
            }
            _source() {
                throw new Error("Pure virtual method called.");
            }
            isUsingMockSource() {
                throw new Error("Pure virtual method called.");
            }
            exaggeration() {
                throw new Error("Pure virtual method called.");
            }
            findDEMTileFor(e1) {
                throw new Error("Pure virtual method called.");
            }
            get visibleDemTiles() {
                throw new Error("Getter must be implemented in subclass.");
            }
            getMinMaxForVisibleTiles() {
                const e1 = this.visibleDemTiles;
                if (0 === e1.length) return null;
                let t1 = !1, i = Number.MAX_VALUE, n = Number.MIN_VALUE;
                for (const r of e1){
                    const e1 = this.getMinMaxForTile(r.tileID);
                    e1 && (i = Math.min(i, e1.min), n = Math.max(n, e1.max), t1 = !0);
                }
                return t1 ? {
                    min: i,
                    max: n
                } : null;
            }
        }, t1.cX = tw, t1.cY = rw, t1.cZ = Kh, t1.c_ = function(e1, t1, i, n, r, o) {
            const a = [
                t1,
                i,
                n
            ];
            return Y(a, a, o.calculateFogTileMatrix(r)), gw(e1, D(a), o.pitch);
        }, t1.ca = Eu, t1.cb = ot, t1.cc = class {
            constructor(e1){
                this.entries = {}, this.scheduler = e1;
            }
            request(e1, t1, i, n) {
                const r = this.entries[e1] = this.entries[e1] || {
                    callbacks: []
                };
                if (r.result) {
                    const [e1, i] = r.result;
                    return this.scheduler ? this.scheduler.add(()=>{
                        n(e1, i);
                    }, t1) : n(e1, i), ()=>{};
                }
                return r.callbacks.push(n), r.cancel || (r.cancel = i((i, n)=>{
                    r.result = [
                        i,
                        n
                    ];
                    for (const e1 of r.callbacks)this.scheduler ? this.scheduler.add(()=>{
                        e1(i, n);
                    }, t1) : e1(i, n);
                    setTimeout(()=>delete this.entries[e1], 3e3);
                })), ()=>{
                    r.result || (r.callbacks = r.callbacks.filter((e1)=>e1 !== n), r.callbacks.length || (r.cancel(), delete this.entries[e1]));
                };
            }
        }, t1.cd = function(e1) {
            if ("provider" in e1 && !e1.provider) return null;
            let t1 = e1.provider;
            if (!t1 && "url" in e1 && e1.url && (t1 = function(e1) {
                try {
                    const t1 = new URL(e1).pathname.split("/").pop() || "", i = t1.lastIndexOf(".");
                    return i >= 0 ? t1.slice(i + 1) : "";
                } catch  {
                    return "";
                }
            }(e1.url)), !t1) return null;
            const i = Ut.TILE_PROVIDER_URLS[t1];
            if (!i) return null;
            let n;
            try {
                n = new URL(i, Ut.API_URL).href;
            } catch (e1) {
                return new Error(`TileProvider "${t1}" has an invalid URL: "${i}"`);
            }
            return {
                name: t1,
                url: n
            };
        }, t1.ce = qE, t1.cf = YE, t1.cg = ii, t1.ch = function(e1, t1, i) {
            const n = JSON.stringify(e1.request);
            return e1.data && (this.deduped.entries[n] = {
                result: [
                    null,
                    e1.data
                ]
            }), this.deduped.request(n, {
                type: "parseTile",
                renderSourceType: e1.renderSourceType,
                zoom: e1.tileZoom
            }, (t1)=>{
                const n = new AbortController;
                return _i(e1.request, n.signal).then(({ data: e1, headers: n })=>{
                    t1(null, {
                        rawData: e1,
                        vectorTile: i ? void 0 : new Ph(new Gp(e1)),
                        headers: n
                    });
                }).catch((e1)=>{
                    n.signal.aborted || (li(e1) ? t1(null, null) : t1(e1));
                }), ()=>{
                    n.abort(), t1(null, null);
                };
            }, t1);
        }, t1.ci = wt, t1.cj = function(e1) {
            ei++, ei > Xt && (e1.getActor().notify("enforceCacheSizeLimit", qt), ei = 0);
        }, t1.ck = Ui, t1.cl = async function(e1, t1, i) {
            const n = e1.url && !e1.tiles ? await t1.transformRequest(e1.url, ai.Source, i) : void 0;
            return {
                request: n,
                options: n ? {
                    ...e1,
                    url: n.url
                } : e1
            };
        }, t1.cm = function(e1, t1, i) {
            return t1 ? WE(e1, t1, i) : e1.tiles && e1.tiles.length > 0 ? {
                tiles: e1.tiles
            } : new Error('TileJSON is missing required "tiles" property');
        }, t1.cn = async function(e1, t1) {
            const i = uA.get(e1);
            if (i) return i;
            const n = lA.get(e1);
            if (void 0 !== n) return n;
            const r = self.__mapboxImport(/* webpackIgnore: true */ /* @vite-ignore */ t1).catch((t1)=>{
                throw new Error(`TileProvider "${e1}" failed to load: ${t1 instanceof Error ? t1.message : String(t1)}`);
            }).then((t1)=>{
                const i = t1.default;
                if ("function" != typeof i) throw new Error(`TileProvider "${e1}" module must default-export a class`);
                if ("function" != typeof i.prototype.loadTile) throw new Error(`TileProvider "${e1}" class must have a loadTile method`);
                return uA.set(e1, i), i;
            }).finally(()=>{
                lA.delete(e1);
            });
            return lA.set(e1, r), r;
        }, t1.co = class {
            constructor(e1, t1){
                this.context = e1, this.texture = t1;
            }
            bind(e1, t1) {
                const { context: i } = this, { gl: n } = i;
                n.bindTexture(n.TEXTURE_2D, this.texture), e1 !== this.minFilter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, e1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, e1), this.minFilter = e1), t1 !== this.wrapS && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, t1), this.wrapS = t1);
            }
        }, t1.cp = mu, t1.cq = function(e1, t1, i, n) {
            for(; t1 < i;){
                const r = t1 + i >> 1;
                e1[r] <= n ? t1 = r + 1 : i = r;
            }
            return t1;
        }, t1.cr = function(e1, t1, i, n) {
            for(; t1 < i;){
                const r = t1 + i >> 1;
                e1[r] < n ? t1 = r + 1 : i = r;
            }
            return t1;
        }, t1.cs = nu, t1.ct = J, t1.cu = function(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[3], a = t1[4], s = t1[5], l = t1[6], u = t1[7], c = t1[8];
            return e1[0] = a * c - s * u, e1[1] = r * u - n * c, e1[2] = n * s - r * a, e1[3] = s * l - o * c, e1[4] = i * c - r * l, e1[5] = r * o - i * s, e1[6] = o * u - a * l, e1[7] = n * l - i * u, e1[8] = i * a - n * o, e1;
        }, t1.cv = s, t1.cw = async function(e1) {
            const t1 = document.createElement("video");
            t1.muted = !0;
            for (const i of e1){
                const e1 = document.createElement("source");
                mi(i) || (t1.crossOrigin = "Anonymous"), e1.src = i, t1.appendChild(e1);
            }
            return await new Promise((i, n)=>{
                t1.onloadstart = ()=>i(), t1.onerror = ()=>n(new Error(`Could not load video: ${e1.join(", ")}`));
            }), t1;
        }, t1.cx = tb, t1.cy = ub, t1.cz = hu, t1.d = class {
            constructor(e1){
                this.cache = new Map, this.textures = new Map, this.textureAccessTimes = new Map, this.textureMemoryUsed = 0, this.maxTextureMemory = 1024 * (e1 && e1.maxTextureMemoryMB ? e1.maxTextureMemoryMB : 256) * 1024, this.currentFrameAtlases = new Set, this.finalizationRegistry = new FinalizationRegistry((e1)=>{
                    this.cache.delete(e1), this.clearExpiredTextures();
                });
            }
            beginFrame() {
                this.currentFrameAtlases.clear();
            }
            calculateTextureMemory(e1) {
                return e1.image ? Math.ceil(e1.image.width * e1.image.height * 4 * (e1.patternPositions.size > 0 ? 1.33 : 1)) : 0;
            }
            evictTexture(e1) {
                const t1 = this.textures.get(e1);
                if (t1) {
                    const i = this.calculateTextureMemory(e1);
                    t1.destroy(), this.textures.delete(e1), this.textureAccessTimes.delete(e1), this.textureMemoryUsed -= i, e1.uploaded = !1;
                }
            }
            evictTexturesIfNeeded(e1) {
                for(; this.textureMemoryUsed + e1 > this.maxTextureMemory && this.textures.size > 0;){
                    let e1 = null, t1 = 1 / 0;
                    for (const [i] of this.textures.entries()){
                        if (this.currentFrameAtlases.has(i)) continue;
                        const n = this.textureAccessTimes.get(i) || 0;
                        n < t1 && (t1 = n, e1 = i);
                    }
                    if (!e1) break;
                    this.evictTexture(e1);
                }
            }
            findCachedAtlas(e1) {
                const t1 = this.cache.get(e1.hash);
                if (t1) {
                    const i = t1.deref();
                    if (i && i.contentDescriptor && this.isMipmapCompatible(e1, i.contentDescriptor)) return i;
                }
                for (const [, t1] of this.cache.entries()){
                    const i = t1.deref();
                    if (i && i.contentDescriptor) {
                        const t1 = e1.subsetOf(i.contentDescriptor), n = this.isMipmapCompatible(e1, i.contentDescriptor);
                        if (t1 && n) return i;
                    }
                }
            }
            getTextureForAtlas(e1, t1, i) {
                this.textureAccessTimes.set(e1, performance.now()), this.currentFrameAtlases.add(e1);
                let n = this.textures.get(e1);
                if (n) return n;
                if (e1.image) {
                    const r = this.calculateTextureMemory(e1);
                    return this.evictTexturesIfNeeded(r), n = new c_(t1, e1.image, i, {
                        useMipmap: !!e1.patternPositions.size
                    }), this.textures.set(e1, n), this.textureMemoryUsed += r, n;
                }
                return null;
            }
            clearExpiredTextures() {
                for (const [e1] of this.textures.entries())if (!this.isAtlasCached(e1)) {
                    const t1 = this.textures.get(e1);
                    if (t1) {
                        const i = this.calculateTextureMemory(e1);
                        t1.destroy(), this.textureMemoryUsed -= i;
                    }
                    this.textures.delete(e1), this.textureAccessTimes.delete(e1);
                }
            }
            isAtlasCached(e1) {
                if (!e1.contentDescriptor) return !1;
                const t1 = this.cache.get(e1.contentDescriptor.hash);
                return !!t1 && t1.deref() === e1;
            }
            getOrCache(e1) {
                if (!("image" in e1)) {
                    const t1 = this.cache.get(e1.sourceAtlasHash);
                    if (t1) {
                        const e1 = t1.deref();
                        if (e1) return e1;
                    }
                    return mt("ImageAtlasReference points to GC'd atlas - atlas may have been evicted"), null;
                }
                if (!e1.contentDescriptor) return e1;
                const t1 = e1.contentDescriptor, i = t1.hash, n = this.cache.get(i);
                if (n) {
                    const e1 = n.deref();
                    if (e1 && e1.contentDescriptor && this.isMipmapCompatible(t1, e1.contentDescriptor)) return e1;
                }
                return this.cache.set(i, new WeakRef(e1)), this.finalizationRegistry.register(e1, i, e1), e1;
            }
            isMipmapCompatible(e1, t1) {
                return !e1.requiresMipMaps || t1.requiresMipMaps;
            }
            destroyTextures() {
                for (const e1 of this.textures.values())e1 && e1.destroy();
                this.textures.clear(), this.textureAccessTimes.clear(), this.textureMemoryUsed = 0;
            }
            clear() {
                for (const e1 of this.textures.values())e1 && e1.destroy();
                this.cache.clear(), this.textures.clear(), this.textureAccessTimes.clear(), this.textureMemoryUsed = 0;
            }
        }, t1.d$ = function(e1, t1, i, n, r, o, a, s, l, u, c = 1) {
            const h = i.transform, d = n ? e1.textSizeData : e1.iconSizeData, f = ef(d, i.transform.zoom, c), p = "globe" === h.projection.name, _ = (()=>{
                if (!p) return null;
                const e1 = $f(h.zoom);
                return 0 === e1 ? null : {
                    t: e1,
                    invMatrix: h.projection.createInversionMatrix(h, u.canonical),
                    mercCenter: [
                        hr(h.center.lng),
                        dr(h.center.lat)
                    ]
                };
            })(), m = [
                256 / i.width * 2 + 1,
                256 / i.height * 2 + 1
            ], g = n ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
            g.clear();
            let y = null;
            p && (y = n ? e1.text.globeExtVertexArray : e1.icon.globeExtVertexArray);
            const x = e1.lineVertexArray, v = n ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, b = i.transform.width / i.transform.height;
            let w, E = !1;
            for(let c = 0; c < v.length; c++){
                const p = v.get(c), { numGlyphs: A, writingMode: I } = p;
                if (I !== Hd.vertical || E || w === Hd.horizontal || (E = !0), w = I, (p.hidden || I === Hd.vertical) && !E) {
                    hw(A, g);
                    continue;
                }
                E = !1;
                const T = new Pe(p.tileAnchorX, p.tileAnchorY), M = "road" === e1.elevationType, S = !!h.elevation || M;
                let { x: z, y: R, z: P } = h.projection.projectTilePoint(T.x, T.y, u.canonical);
                if (_) {
                    const [e1, t1, i] = sw(T, u.canonical, _);
                    z += (e1 - z) * _.t, R += (t1 - R) * _.t, P += (i - P) * _.t;
                }
                let D = null;
                if (S) {
                    D = M && e1.hdExt ? e1.hdExt.makeRoadSymbolElevationParams(e1, n ? e1.text : e1.icon, c, u, l, h.elevation, h.projection, h.center.lat, h.worldSize) : {
                        getElevation: l,
                        elevation: h.elevation,
                        elevationFeature: null
                    };
                    const [t1, i, r] = D.getElevation(T, h.elevation, D.elevationFeature);
                    z += t1, R += i, P += r;
                }
                const C = [
                    z,
                    R,
                    P,
                    1
                ];
                if (le(C, C, t1), !nw(C, m)) {
                    hw(A, g);
                    continue;
                }
                const F = C[3], O = iw(i.transform.getCameraToCenterDistance(h.projection), F), L = Qd(d, f, p), B = a ? L / O : L * O, N = tw(z, R, P, r);
                if (N[3] <= 0) {
                    hw(A, g);
                    continue;
                }
                let V = {};
                const k = Ye(e1.layers[0].layout.get("text-max-angle")), U = Math.cos(k), G = a ? null : D, j = aw(p, B, !1, s, t1, r, o, e1.glyphOffsetArray, x, g, y, N, T, V, b, G, h.projection, u, a, U, _);
                E = j.useVertical, G && j.needsFlipping && (V = {}), (j.notEnoughRoom || E || j.needsFlipping && aw(p, B, !0, s, t1, r, o, e1.glyphOffsetArray, x, g, y, N, T, V, b, G, h.projection, u, a, U, _).notEnoughRoom) && hw(A, g);
            }
            n ? (e1.text.dynamicLayoutVertexBuffer.updateData(g), y && e1.text.globeExtVertexBuffer && e1.text.globeExtVertexBuffer.updateData(y)) : (e1.icon.dynamicLayoutVertexBuffer.updateData(g), y && e1.icon.globeExtVertexBuffer && e1.icon.globeExtVertexBuffer.updateData(y));
        }, t1.d0 = d, t1.d1 = Gd, t1.d2 = .9, t1.d3 = re, t1.d4 = Qd, t1.d5 = pI, t1.d6 = function(e1) {
            return e1({
                pluginStatus: Ds,
                pluginURL: Cs
            }), Ls.on("pluginStateChange", e1), e1;
        }, t1.d7 = ui, t1.d8 = T_, t1.d9 = I_, t1.dA = function(e1, t1) {
            return [
                Math.pow(e1[0], 2.2) * t1,
                Math.pow(e1[1], 2.2) * t1,
                Math.pow(e1[2], 2.2) * t1
            ];
        }, t1.dB = k, t1.dC = O, t1.dD = Tt, t1.dE = W, t1.dF = vE, t1.dG = bE, t1.dH = (e1)=>({
                u_cutoff_params: new Kc(e1)
            }), t1.dI = (e1)=>({
                u_light_matrix_0: new eh(e1),
                u_light_matrix_1: new eh(e1),
                u_fade_range: new Xc(e1),
                u_shadow_normal_offset: new Yc(e1),
                u_shadow_intensity: new qc(e1),
                u_shadow_texel_size: new qc(e1),
                u_shadow_map_resolution: new qc(e1),
                u_shadow_direction: new Yc(e1),
                u_shadow_bias: new Yc(e1),
                u_shadowmap_0: new Wc(e1),
                u_shadowmap_1: new Wc(e1)
            }), t1.dJ = SE, t1.dK = jf, t1.dL = Qv, t1.dM = Mt, t1.dN = St, t1.dO = function(e1, t1) {
            const i = [
                0,
                0,
                0
            ];
            return Y(i, i, kf(Pf(t1.canonical))), Y(i, i, e1), i;
        }, t1.dP = Cb, t1.dQ = function(e1, t1, i, n, r, o) {
            const { width: a, height: s } = n.imageManager.getPixelSize(t1), l = Math.pow(2, o.tileID.overscaledZ), u = o.tileSize * Math.pow(2, n.transform.tileZoom) / l, c = u * (o.tileID.canonical.x + o.tileID.wrap * l), h = u * o.tileID.canonical.y;
            return {
                u_image: 0,
                u_pattern_tl: i.tl,
                u_pattern_br: i.br,
                u_texsize: [
                    a,
                    s
                ],
                u_pattern_size: i.displaySize,
                u_pattern_units_to_pixels: r ? [
                    n.transform.width,
                    -1 * n.transform.height
                ] : [
                    1 / Dv(o, 1, n.transform.tileZoom),
                    1 / Dv(o, 1, n.transform.tileZoom)
                ],
                u_pixel_coord_upper: [
                    c >> 16,
                    h >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & c,
                    65535 & h
                ]
            };
        }, t1.dR = (e1)=>({
                u_matrix: new eh(e1),
                u_texsize: new Xc(e1),
                u_pixels_to_tile_units: new th(e1),
                u_device_pixel_ratio: new qc(e1),
                u_width_scale: new qc(e1),
                u_floor_width_scale: new qc(e1),
                u_image: new Wc(e1),
                u_units_to_pixels: new Xc(e1),
                u_tile_units_to_pixels: new qc(e1),
                u_alpha_discard_threshold: new qc(e1),
                u_trim_offset: new Xc(e1),
                u_trim_fade_range: new Xc(e1),
                u_trim_gradient_mix_range: new Xc(e1),
                u_trim_color: new Kc(e1),
                u_zbias_factor: new qc(e1),
                u_tile_to_meter: new qc(e1),
                u_ground_shadow_factor: new Yc(e1),
                u_pattern_transition: new qc(e1),
                u_opacity_multiplier: new qc(e1)
            }), t1.dS = (e1)=>({
                u_matrix: new eh(e1),
                u_pixels_to_tile_units: new th(e1),
                u_device_pixel_ratio: new qc(e1),
                u_width_scale: new qc(e1),
                u_floor_width_scale: new qc(e1),
                u_units_to_pixels: new Xc(e1),
                u_dash_image: new Wc(e1),
                u_gradient_image: new Wc(e1),
                u_border_gradient_image: new Wc(e1),
                u_image_height: new qc(e1),
                u_texsize: new Xc(e1),
                u_tile_units_to_pixels: new qc(e1),
                u_alpha_discard_threshold: new qc(e1),
                u_trim_offset: new Xc(e1),
                u_trim_fade_range: new Xc(e1),
                u_trim_gradient_mix_range: new Xc(e1),
                u_trim_color: new Kc(e1),
                u_zbias_factor: new qc(e1),
                u_road_view_depth_bias: new qc(e1),
                u_road_clip_to_view: new Kc(e1),
                u_tile_to_meter: new qc(e1),
                u_ground_shadow_factor: new Yc(e1),
                u_opacity_multiplier: new qc(e1)
            }), t1.dT = (e1)=>({
                u_color: new Qc(e1),
                u_matrix: new eh(e1),
                u_overlay: new Wc(e1),
                u_overlay_scale: new qc(e1)
            }), t1.dU = (e1)=>({
                u_camera_to_center_distance: new qc(e1),
                u_extrude_scale: new th(e1),
                u_device_pixel_ratio: new qc(e1),
                u_matrix: new eh(e1),
                u_inv_rot_matrix: new eh(e1),
                u_merc_center: new Xc(e1),
                u_tile_id: new Yc(e1),
                u_zoom_transition: new qc(e1),
                u_up_dir: new Yc(e1),
                u_emissive_strength: new qc(e1)
            }), t1.dV = (e1)=>({
                u_matrix: new eh(e1),
                u_lightpos: new Yc(e1),
                u_lightintensity: new qc(e1),
                u_lightcolor: new Yc(e1),
                u_vertical_gradient: new qc(e1),
                u_height_factor: new qc(e1),
                u_edge_radius: new qc(e1),
                u_width_scale: new qc(e1),
                u_ao: new Xc(e1),
                u_height_type: new Wc(e1),
                u_base_type: new Wc(e1),
                u_tile_id: new Yc(e1),
                u_zoom_transition: new qc(e1),
                u_inv_rot_matrix: new eh(e1),
                u_merc_center: new Xc(e1),
                u_up_dir: new Yc(e1),
                u_height_lift: new qc(e1),
                u_image: new Wc(e1),
                u_texsize: new Xc(e1),
                u_pixel_coord_upper: new Xc(e1),
                u_pixel_coord_lower: new Xc(e1),
                u_tile_units_to_pixels: new qc(e1),
                u_opacity: new qc(e1),
                u_pattern_transition: new qc(e1)
            }), t1.dW = (e1)=>({
                u_matrix: new eh(e1),
                u_lightpos: new Yc(e1),
                u_lightintensity: new qc(e1),
                u_lightcolor: new Yc(e1),
                u_vertical_gradient: new qc(e1),
                u_opacity: new qc(e1),
                u_edge_radius: new qc(e1),
                u_width_scale: new qc(e1),
                u_ao: new Xc(e1),
                u_height_type: new Wc(e1),
                u_base_type: new Wc(e1),
                u_tile_id: new Yc(e1),
                u_zoom_transition: new qc(e1),
                u_inv_rot_matrix: new eh(e1),
                u_merc_center: new Xc(e1),
                u_up_dir: new Yc(e1),
                u_height_lift: new qc(e1),
                u_flood_light_color: new Yc(e1),
                u_vertical_scale: new qc(e1),
                u_flood_light_intensity: new qc(e1),
                u_ground_shadow_factor: new Yc(e1),
                u_front_cutoff_params: new Yc(e1)
            }), t1.dX = ew, t1.dY = hw, t1.dZ = iw, t1.d_ = j_, t1.da = Fs, t1.db = Zt, t1.dc = tn, t1.dd = ft, t1.de = xt, t1.df = function(e1) {
            return e1.includes(_l);
        }, t1.dg = function(e1) {
            const t1 = e1.lastIndexOf(_l);
            return t1 >= 0 ? e1.slice(t1 + 1) : "";
        }, t1.dh = function(e1) {
            const t1 = [], i = e1.id;
            return void 0 === i && t1.push({
                message: `layers.${i}: missing required property "id"`
            }), void 0 === e1.render && t1.push({
                message: `layers.${i}: missing required method "render"`
            }), e1.renderingMode && "2d" !== e1.renderingMode && "3d" !== e1.renderingMode && t1.push({
                message: `layers.${i}: property "renderingMode" must be either "2d" or "3d"`
            }), t1;
        }, t1.di = function(e1, t1, i, n) {
            return "custom" === e1.type ? new cb(e1, t1) : new iA[e1.type](e1, t1, i, n);
        }, t1.dj = dt, t1.dk = class extends Db {
            constructor(e1, t1){
                super(e1._vectorTileFeature, e1._z, e1._x, e1._y, e1.id), e1.state && (this.state = {
                    ...e1.state
                }), this.target = t1.target, this.namespace = t1.namespace, t1.properties && (this.properties = t1.properties), this.target && ("featuresetId" in this.target && !this.target.importId || "layerId" in this.target) && (this.source = e1.source, this.sourceLayer = e1.sourceLayer, this.layer = e1.layer);
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.target = this.target, e1.namespace = this.namespace, e1;
            }
        }, t1.dl = Ls, t1.dm = LE, t1.dn = function() {
            return {
                API_URL: Ut.API_URL,
                DRACO_URL: Ut.DRACO_URL,
                MESHOPT_URL: Ut.MESHOPT_URL,
                MESHOPT_SIMD_URL: Ut.MESHOPT_SIMD_URL,
                BUILDING_GEN_URL: Ut.BUILDING_GEN_URL
            };
        }, t1.dp = Qc, t1.dq = S, t1.dr = Qe, t1.ds = function(e1, t1, i) {
            const n = $f(i.zoom), r = e1.style.map._antialias, o = e1.terrain && e1.terrain.exaggeration() > 0;
            return 0 === n && !r && !o;
        }, t1.dt = function(e1, t1, i) {
            const n = d(new Float64Array(16)), r = (t1 / (1 << e1) - .5) * Math.PI * 2;
            return x(n, i.globeMatrix, r), Float32Array.from(n);
        }, t1.du = ad, t1.dv = pu, t1.dw = Tf, t1.dx = ae, t1.dy = L, t1.dz = U, t1.e = Vt, t1.e$ = Gi, t1.e0 = h_, t1.e1 = rv, t1.e2 = (e1, t1, i, n, r, o)=>{
            const a = e1.transform, s = "globe" === a.projection.name;
            let l;
            if ("map" === o.paint.get("circle-pitch-alignment")) {
                if (s) {
                    const e1 = jf(a.zoom, t1.canonical) * a._pixelsPerMercatorPixel;
                    l = Float32Array.from([
                        e1,
                        0,
                        0,
                        e1
                    ]);
                } else l = a.calculatePixelsToTileUnitsMatrix(i);
            } else l = new Float32Array([
                a.pixelsToGLUnits[0],
                0,
                0,
                a.pixelsToGLUnits[1]
            ]);
            const u = {
                u_camera_to_center_distance: e1.transform.getCameraToCenterDistance(a.projection),
                u_matrix: e1.translatePosMatrix(t1.projMatrix, i, o.paint.get("circle-translate"), o.paint.get("circle-translate-anchor")),
                u_device_pixel_ratio: Vt.devicePixelRatio,
                u_extrude_scale: l,
                u_inv_rot_matrix: nv,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_emissive_strength: o.paint.get("circle-emissive-strength")
            };
            if (s) {
                u.u_inv_rot_matrix = n, u.u_merc_center = r, u.u_tile_id = [
                    t1.canonical.x,
                    t1.canonical.y,
                    1 << t1.canonical.z
                ], u.u_zoom_transition = $f(a.zoom);
                const e1 = r[0] * Sr, i = r[1] * Sr;
                u.u_up_dir = a.projection.upVector(new Kf(0, 0, 0), e1, i);
            }
            return u;
        }, t1.e3 = Ov, t1.e4 = (e1, t1, i, n, r, o, a, s, l, u)=>{
            const c = e1.transform, h = c.pitch < 15 ? dn(.07, .7, tt((14 - c.zoom) / 5, 0, 1)) : .07, d = "none" === i.paint.get("line-trim-color-use-theme").constantOr("default");
            return {
                u_matrix: Fv(e1, t1, i, n),
                u_texsize: t1.imageAtlasTexture ? t1.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_pixels_to_tile_units: c.calculatePixelsToTileUnitsMatrix(t1),
                u_device_pixel_ratio: r,
                u_width_scale: o,
                u_floor_width_scale: a,
                u_image: 0,
                u_tile_units_to_pixels: Cv(t1, c),
                u_units_to_pixels: [
                    1 / c.pixelsToGLUnits[0],
                    1 / c.pixelsToGLUnits[1]
                ],
                u_alpha_discard_threshold: 0,
                u_trim_offset: s,
                u_trim_fade_range: i.paint.get("line-trim-fade-range"),
                u_trim_gradient_mix_range: [
                    1,
                    1
                ],
                u_trim_color: i.paint.get("line-trim-color").toPremultipliedRenderColor(d ? null : i.lut).toArray01(),
                u_zbias_factor: h,
                u_tile_to_meter: vu(t1.tileID.canonical, 0),
                u_ground_shadow_factor: l,
                u_pattern_transition: u,
                u_opacity_multiplier: 1
            };
        }, t1.e5 = (e1, t1, i, n, r, o, a, s, l, u)=>{
            const c = e1.transform, h = c.calculatePixelsToTileUnitsMatrix(t1), d = "none" === i.paint.get("line-trim-color-use-theme").constantOr("default"), f = c.pitch < 15 ? dn(.07, .7, tt((14 - c.zoom) / 5, 0, 1)) : .07;
            return {
                u_matrix: Fv(e1, t1, i, n),
                u_pixels_to_tile_units: h,
                u_device_pixel_ratio: o,
                u_width_scale: a,
                u_floor_width_scale: s,
                u_units_to_pixels: [
                    1 / c.pixelsToGLUnits[0],
                    1 / c.pixelsToGLUnits[1]
                ],
                u_dash_image: 0,
                u_gradient_image: 1,
                u_border_gradient_image: 2,
                u_image_height: r,
                u_texsize: Lv(i) && t1.lineAtlasTexture ? t1.lineAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: Cv(t1, e1.transform),
                u_alpha_discard_threshold: 0,
                u_trim_offset: l,
                u_trim_fade_range: i.paint.get("line-trim-fade-range"),
                u_trim_gradient_mix_range: [
                    1,
                    1
                ],
                u_trim_color: i.paint.get("line-trim-color").toPremultipliedRenderColor(d ? null : i.lut).toArray01(),
                u_zbias_factor: f,
                u_road_view_depth_bias: 0,
                u_road_clip_to_view: [
                    0,
                    0,
                    0,
                    0
                ],
                u_tile_to_meter: vu(t1.tileID.canonical, 0),
                u_ground_shadow_factor: u,
                u_opacity_multiplier: 1
            };
        }, t1.e6 = lt, t1.e7 = Iv, t1.e8 = 5, t1.e9 = eb, t1.eA = ie, t1.eB = du, t1.eC = lu, t1.eD = q, t1.eE = If, t1.eF = H, t1.eG = F, t1.eH = function([e1, t1, i]) {
            const n = Math.hypot(e1, t1, i), r = Math.atan2(e1, i), o = .5 * Math.PI - Math.acos(-t1 / n);
            return new hu(Je(r), Je(o));
        }, t1.eI = G, t1.eJ = se, t1.eK = Kg, t1.eL = Ut, t1.eM = bi, t1.eN = vi, t1.eO = pw, t1.eP = class {
            constructor(e1, t1, i){
                this._transformRequestFn = e1, this._customAccessToken = t1, this._silenceAuthErrors = !!i, this._createSkuToken();
            }
            _createSkuToken() {
                const e1 = function() {
                    let e1 = "";
                    for(let t1 = 0; t1 < 10; t1++)e1 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                    return {
                        token: [
                            "1",
                            xi,
                            e1
                        ].join(""),
                        tokenExpiresAt: Date.now() + 432e5
                    };
                }();
                this._skuToken = e1.token, this._skuTokenExpiresAt = e1.tokenExpiresAt;
            }
            _isSkuTokenExpired() {
                return Date.now() > this._skuTokenExpiresAt;
            }
            async transformRequest(e1, t1, i) {
                if (!this._transformRequestFn) return {
                    url: e1
                };
                const n = i ? {
                    signal: i
                } : {};
                return await this._transformRequestFn(e1, t1, n) || {
                    url: e1
                };
            }
            normalizeStyleURL(e1, t1) {
                if (!ii(e1)) return e1;
                const n = Ri(e1);
                return n.params.push(`sdk=js-${i}`), n.path = `/styles/v1${n.path}`, this._makeAPIURL(n, this._customAccessToken || t1);
            }
            normalizeGlyphsURL(e1, t1) {
                if (!ii(e1)) return e1;
                const i = Ri(e1);
                return i.path = `/fonts/v1${i.path}`, this._makeAPIURL(i, this._customAccessToken || t1);
            }
            normalizeModelURL(e1, t1) {
                if (!ii(e1)) return e1;
                const i = Ri(e1);
                return i.path = `/models/v1${i.path}`, this._makeAPIURL(i, this._customAccessToken || t1);
            }
            normalizeSourceURL(e1, t1, i, n) {
                if (!ii(e1)) return e1;
                const r = Ri(e1);
                return r.path = `/v4/${r.authority}.json`, r.params.push("secure"), i && r.params.push(`language=${i}`), n && r.params.push(`worldview=${n}`), this._makeAPIURL(r, this._customAccessToken || t1);
            }
            normalizeIconsetURL(e1, t1) {
                const i = Ri(e1);
                return ii(e1) ? (i.path = `/styles/v1${i.path}/iconset.pbf`, this._makeAPIURL(i, this._customAccessToken || t1)) : Pi(i);
            }
            normalizeSpriteURL(e1, t1, i, n) {
                const r = Ri(e1);
                return ii(e1) ? (r.path = `/styles/v1${r.path}/sprite${t1}${i}`, this._makeAPIURL(r, this._customAccessToken || n)) : (r.path += `${t1}${i}`, Pi(r));
            }
            normalizeTileURL(e1, t1, i) {
                if (this._isSkuTokenExpired() && this._createSkuToken(), e1 && !ii(e1)) return e1;
                const n = Ri(e1);
                n.path = n.path.replace(Ei, (t1 || i && "raster" !== n.authority && 512 === i ? "@2x" : "") + ".webp"), "raster" === n.authority ? n.path = `/${Ut.RASTER_URL_PREFIX}${n.path}` : "rasterarrays" === n.authority ? n.path = `/${Ut.RASTERARRAYS_URL_PREFIX}${n.path}` : "3dtiles" === n.authority ? n.path = `/${Ut.TILES3D_URL_PREFIX}${n.path}` : (n.path = n.path.replace(Ai, "/"), n.path = `/${Ut.TILE_URL_VERSION}${n.path}`);
                const r = this._customAccessToken || function(e1) {
                    for (const t1 of e1){
                        const e1 = t1.match(Mi);
                        if (e1) return e1[1];
                    }
                    return null;
                }(n.params) || Ut.ACCESS_TOKEN;
                return Ut.REQUIRE_ACCESS_TOKEN && r && this._skuToken && n.params.push(`sku=${this._skuToken}`), this._makeAPIURL(n, r);
            }
            canonicalizeTileURL(e1, t1) {
                const i = Ri(e1);
                if (!Ti.test(i.path) || !Ii.test(i.path)) return e1;
                let n = "mapbox://";
                i.path.startsWith("/raster/v1/") ? n += `raster/${i.path.replace(`/${Ut.RASTER_URL_PREFIX}/`, "")}` : i.path.startsWith("/rasterarrays/v1/") ? n += `rasterarrays/${i.path.replace(`/${Ut.RASTERARRAYS_URL_PREFIX}/`, "")}` : n += `tiles/${i.path.replace(`/${Ut.TILE_URL_VERSION}/`, "")}`;
                let r = i.params;
                return t1 && (r = r.filter((e1)=>!e1.match(Mi))), r.length && (n += `?${r.join("&")}`), n;
            }
            canonicalizeTileset(e1, t1) {
                const i = !!t1 && ii(t1), n = [];
                for (const t1 of e1.tiles || [])ti(t1) ? n.push(this.canonicalizeTileURL(t1, i)) : n.push(t1);
                return n;
            }
            _makeAPIURL(e1, t1) {
                const i = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", n = Ri(Ut.API_URL);
                if (e1.protocol = n.protocol, e1.authority = n.authority, "http" === e1.protocol) {
                    const t1 = e1.params.indexOf("secure");
                    t1 >= 0 && e1.params.splice(t1, 1);
                }
                if ("/" !== n.path && (e1.path = `${n.path}${e1.path}`), !Ut.REQUIRE_ACCESS_TOKEN) return Pi(e1);
                if (t1 = t1 || Ut.ACCESS_TOKEN, !this._silenceAuthErrors) {
                    if (!t1) throw new Error(`An API access token is required to use Mapbox GL. ${i}`);
                    if ("s" === t1[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${i}`);
                }
                return e1.params = e1.params.filter((e1)=>!e1.includes("access_token")), e1.params.push(`access_token=${t1 || ""}`), Pi(e1);
            }
        }, t1.eQ = Ci, t1.eR = function(e1, t1) {
            t1 ? en.add(e1) : en.delete(e1);
        }, t1.eS = Ji, t1.eT = Qi, t1.eU = Si, t1.eV = ji, t1.eW = $i, t1.eX = Wi, t1.eY = Xi, t1.eZ = function(e1) {
            en.delete(e1);
        }, t1.e_ = Ki, t1.ea = Zu, t1.eb = function(e1, t1) {
            var i = Math.sin(t1), n = Math.cos(t1);
            return e1[0] = n, e1[1] = 0, e1[2] = -i, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = i, e1[9] = 0, e1[10] = n, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, t1.ec = function(e1, t1) {
            var i = Math.sin(t1), n = Math.cos(t1);
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = n, e1[6] = i, e1[7] = 0, e1[8] = 0, e1[9] = -i, e1[10] = n, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, t1.ed = function(e1, t1) {
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[4], e1[4] = t1[5], e1[5] = t1[6], e1[6] = t1[8], e1[7] = t1[9], e1[8] = t1[10], e1;
        }, t1.ee = a, t1.ef = uc, t1.eg = 1, t1.eh = Ub, t1.ei = 0, t1.ej = cc, t1.ek = function(e1, t1, i, n, r) {
            return tt((e1 - t1) / (i - t1) * (r - n) + n, n, r);
        }, t1.el = D, t1.em = fe, t1.en = function(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[3], a = t1[4], s = t1[5], l = t1[6], u = t1[7], c = t1[8], h = c * a - s * u, d = -c * o + s * l, f = u * o - a * l, p = i * h + n * d + r * f;
            return p ? (e1[0] = h * (p = 1 / p), e1[1] = (-c * n + r * u) * p, e1[2] = (s * n - r * a) * p, e1[3] = d * p, e1[4] = (c * i - r * l) * p, e1[5] = (-s * i + r * o) * p, e1[6] = f * p, e1[7] = (-u * i + n * l) * p, e1[8] = (a * i - n * o) * p, e1) : null;
        }, t1.eo = ec, t1.ep = class {
            constructor(){
                this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [], this._globalClipBounds = {
                    min: new Pe(1 / 0, 1 / 0),
                    max: new Pe(-1 / 0, -1 / 0)
                };
            }
            clear() {
                this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
            }
            get updateTime() {
                return this._updateTime;
            }
            getReplacementRegionsForTile(e1, t1 = !1) {
                const i = Cp(new Pe(0, 0), new Pe(Sr, Sr), e1), n = [];
                if (t1 && !Pp(i, this._globalClipBounds)) return n;
                for (const t1 of this._activeRegions){
                    if (t1.hiddenByOverlap) continue;
                    if (!Pp(i, t1)) continue;
                    const r = Fp(t1.min, t1.max, e1);
                    n.push({
                        min: r.min,
                        max: r.max,
                        sourceId: this._sourceIds[t1.priority],
                        footprint: t1.footprint,
                        footprintTileId: t1.tileId,
                        order: t1.order,
                        clipMask: t1.clipMask,
                        clipScope: t1.clipScope
                    });
                }
                return n;
            }
            setSources(e1) {
                this._setSources(e1.map((e1)=>({
                        getSourceId: ()=>e1.cache.id,
                        getFootprints: ()=>{
                            const t1 = [];
                            for (const i of e1.cache.getVisibleCoordinates()){
                                const n = e1.cache.getTile(i).buckets[e1.layer];
                                n && n.updateFootprints(i.toUnwrapped(), t1);
                            }
                            return t1;
                        },
                        getOrder: ()=>e1.order,
                        getClipMask: ()=>e1.clipMask,
                        getClipScope: ()=>e1.clipScope
                    })));
            }
            _addSource(e1) {
                const t1 = e1.getFootprints();
                if (0 === t1.length) return;
                const i = e1.getOrder(), n = e1.getClipMask(), r = e1.getClipScope();
                for (const e1 of t1){
                    if (!e1.footprint) continue;
                    const t1 = Cp(e1.footprint.min, e1.footprint.max, e1.id);
                    this._activeRegions.push({
                        min: t1.min,
                        max: t1.max,
                        hiddenByOverlap: !1,
                        priority: this._sourceIds.length,
                        tileId: e1.id,
                        footprint: e1.footprint,
                        order: i,
                        clipMask: n,
                        clipScope: r
                    });
                }
                this._sourceIds.push(e1.getSourceId());
            }
            _computeReplacement() {
                this._activeRegions.sort((e1, t1)=>e1.priority - t1.priority || zp(e1.min, t1.min) || zp(e1.max, t1.max) || e1.order - t1.order || e1.clipMask - t1.clipMask || function(e1, t1) {
                        const i = (e1, t1)=>e1 + t1;
                        return e1.length - t1.length || e1.reduce(i, "").localeCompare(t1.reduce(i, ""));
                    }(e1.clipScope, t1.clipScope));
                let e1 = this._activeRegions.length !== this._prevRegions.length;
                if (!e1) {
                    let t1 = 0;
                    for(; !e1 && t1 !== this._activeRegions.length;){
                        const i = this._activeRegions[t1], n = this._prevRegions[t1];
                        e1 = i.priority !== n.priority || !Rp(i, n) || i.order !== n.order || i.clipMask !== n.clipMask || !De(i.clipScope, n.clipScope), this._activeRegions[t1].hiddenByOverlap = n.hiddenByOverlap, ++t1;
                    }
                }
                if (e1) {
                    ++this._updateTime;
                    for (const e1 of this._activeRegions)e1.order !== Tp && (this._globalClipBounds.min.x = Math.min(this._globalClipBounds.min.x, e1.min.x), this._globalClipBounds.min.y = Math.min(this._globalClipBounds.min.y, e1.min.y), this._globalClipBounds.max.x = Math.max(this._globalClipBounds.max.x, e1.max.x), this._globalClipBounds.max.y = Math.max(this._globalClipBounds.max.y, e1.max.y));
                    const e1 = (e1)=>{
                        const t1 = this._activeRegions;
                        if (e1 >= t1.length) return e1;
                        const i = t1[e1].priority;
                        for(; e1 < t1.length && t1[e1].priority === i;)++e1;
                        return e1;
                    };
                    if (this._sourceIds.length > 1) {
                        let t1 = 0, i = e1(t1);
                        for(; t1 !== i;){
                            let n = t1;
                            const r = t1;
                            for(; n !== i;){
                                const e1 = this._activeRegions[n];
                                e1.hiddenByOverlap = !1;
                                for(let t1 = 0; t1 < r; t1++){
                                    const i = this._activeRegions[t1];
                                    if (!i.hiddenByOverlap && e1.order === Tp && Pp(e1, i) && (e1.hiddenByOverlap = Lp(e1.footprint, e1.tileId, i.footprint, i.tileId), e1.hiddenByOverlap)) break;
                                }
                                ++n;
                            }
                            t1 = i, i = e1(t1);
                        }
                    }
                }
            }
            _setSources(e1) {
                [this._prevRegions, this._activeRegions] = [
                    this._activeRegions,
                    []
                ], this._sourceIds = [];
                for(let t1 = e1.length - 1; t1 >= 0; t1--)this._addSource(e1[t1]);
                this._computeReplacement();
            }
        }, t1.eq = Tp, t1.er = class {
            constructor(e1){
                this._createGrid(e1), this._createPoles(e1);
            }
            destroy() {
                this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
                for (const e1 of this._poleSegments)e1.destroy();
                for (const e1 of this._gridSegments)e1.withSkirts.destroy(), e1.withoutSkirts.destroy();
            }
            _fillGridMeshWithLods(e1, t1) {
                const i = new Bu, n = new oc, r = [], o = e1 + 1 + 2, a = t1[0] + 1, s = t1[0] + 1 + (1 + t1.length), l = (e1, t1, i)=>{
                    let n = e1 === o - 1 ? e1 - 2 : 0 === e1 ? e1 : e1 - 1;
                    return n += i ? 24575 : 0, [
                        n,
                        t1
                    ];
                };
                for(let e1 = 0; e1 < o; ++e1)i.emplaceBack(...l(e1, 0, !0));
                for(let e1 = 0; e1 < a; ++e1)for(let t1 = 0; t1 < o; ++t1)i.emplaceBack(...l(t1, e1, (0 === t1 || t1 === o - 1) && !0));
                for(let e1 = 0; e1 < t1.length; ++e1){
                    const n = t1[e1];
                    for(let e1 = 0; e1 < o; ++e1)i.emplaceBack(...l(e1, n, !0));
                }
                for(let e1 = 0; e1 < t1.length; ++e1){
                    const a = n.length, l = t1[e1] + 1 + 2, u = new oc;
                    for(let i = 0; i < l - 1; i++){
                        const r = i === l - 2, a = r ? o * (s - t1.length + e1 - i) : o;
                        for(let e1 = 0; e1 < o - 1; e1++){
                            const t1 = i * o + e1;
                            0 === i || r || 0 === e1 || e1 === o - 2 ? (u.emplaceBack(t1 + 1, t1, t1 + a), u.emplaceBack(t1 + a, t1 + a + 1, t1 + 1)) : (n.emplaceBack(t1 + 1, t1, t1 + a), n.emplaceBack(t1 + a, t1 + a + 1, t1 + 1));
                        }
                    }
                    const c = Bc.simpleSegment(0, a, i.length, n.length - a);
                    for(let e1 = 0; e1 < u.uint16.length; e1 += 3)n.emplaceBack(u.uint16[e1], u.uint16[e1 + 1], u.uint16[e1 + 2]);
                    const h = Bc.simpleSegment(0, a, i.length, n.length - a);
                    r.push({
                        withoutSkirts: c,
                        withSkirts: h
                    });
                }
                return {
                    vertices: i,
                    indices: n,
                    segments: r
                };
            }
            _createGrid(e1) {
                const t1 = this._fillGridMeshWithLods(nu, ru);
                this._gridSegments = t1.segments, this._gridBuffer = e1.createVertexBuffer(t1.vertices, _f.members), this._gridIndexBuffer = e1.createIndexBuffer(t1.indices, !0);
            }
            _createPoles(e1) {
                const t1 = new oc;
                for(let e1 = 0; e1 <= nu; e1++)t1.emplaceBack(0, e1 + 1, e1 + 2);
                this._poleIndexBuffer = e1.createIndexBuffer(t1, !0);
                const i = new uc, n = new uc, r = new uc, o = new uc;
                this._poleSegments = [];
                for(let e1 = 0, t1 = 0; e1 < 6; e1++){
                    const a = 360 / (1 << e1);
                    i.emplaceBack(0, -iu, 0, .5, 0), n.emplaceBack(0, -iu, 0, .5, 1), r.emplaceBack(0, -iu, 0, .5, .5), o.emplaceBack(0, -iu, 0, .5, .5);
                    for(let e1 = 0; e1 <= nu; e1++){
                        let t1 = e1 / nu, s = 0;
                        const l = dn(0, a, t1), [u, c, h] = su(Xf, Yf, l, iu);
                        i.emplaceBack(u, c, h, t1, s), n.emplaceBack(u, c, h, t1, 1 - s);
                        const d = Ye(l);
                        t1 = .5 + .5 * Math.sin(d), s = .5 + .5 * Math.cos(d), r.emplaceBack(u, c, h, t1, s), o.emplaceBack(u, c, h, t1, 1 - s);
                    }
                    this._poleSegments.push(Bc.simpleSegment(t1, 0, 66, 64)), t1 += 66;
                }
                this._poleNorthVertexBuffer = e1.createVertexBuffer(i, ff, !1), this._poleSouthVertexBuffer = e1.createVertexBuffer(n, ff, !1), this._texturedPoleNorthVertexBuffer = e1.createVertexBuffer(r, ff, !1), this._texturedPoleSouthVertexBuffer = e1.createVertexBuffer(o, ff, !1);
            }
            getGridBuffers(e1, t1) {
                return [
                    this._gridBuffer,
                    this._gridIndexBuffer,
                    t1 ? this._gridSegments[e1].withSkirts : this._gridSegments[e1].withoutSkirts
                ];
            }
            getPoleBuffers(e1, t1) {
                return [
                    t1 ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer,
                    t1 ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer,
                    this._poleIndexBuffer,
                    this._poleSegments[e1]
                ];
            }
        }, t1.es = function(e1) {
            return en.has(e1);
        }, t1.et = wE, t1.eu = Mp, t1.ev = Re, t1.ew = function() {
            return !!document.fullscreenElement || !!document.webkitFullscreenElement;
        }, t1.ex = et, t1.ey = xu, t1.ez = function(e1, t1, i) {
            return e1[0] = t1[0] / i[0], e1[1] = t1[1] / i[1], e1[2] = t1[2] / i[2], e1;
        }, t1.f = rn, t1.f$ = S_, t1.f0 = function(e1, t1) {
            qt = e1, Xt = t1;
        }, t1.f1 = i, t1.f2 = Wf, t1.f3 = Je, t1.f4 = Zf, t1.f5 = function(e1) {
            const t1 = [
                0,
                0,
                0
            ], i = d(new Float64Array(16));
            return _(i, e1.pixelMatrix, e1.globeMatrix), Y(t1, t1, i), new Pe(t1[0], t1[1]);
        }, t1.f6 = function(e1) {
            Bi = e1;
        }, t1.f7 = ni, t1.f8 = Jb, t1.f9 = function(e1, t1) {
            if (!e1 || !t1) throw new Error("TileProvider name and URL are required");
            Ut.TILE_PROVIDER_URLS[e1] = Vt.resolveURL(t1);
        }, t1.fA = function(e1) {
            let t1 = 0;
            if (new Uint32Array(e1, 0, 1)[0] !== Pg) {
                const i = new Uint32Array(e1, 0, 7), [, , n, r, o, a] = i;
                t1 = i.byteLength + r + o + a + o, (n !== e1.byteLength || t1 >= e1.byteLength) && mt("Invalid b3dm header information.");
            }
            return Bg(e1, t1);
        }, t1.fB = function(e1, t1) {
            const i = e1.json.extensionsUsed && e1.json.extensionsUsed.includes("mbx_bvh"), n = Sy(e1);
            for (const e1 of n){
                if (!i) for (const t1 of e1.meshes)zy(t1);
                e1.lights && (e1.lightMeshIndex = e1.meshes.length, e1.meshes.push(Py(e1.lights, t1)));
            }
            return n;
        }, t1.fC = vu, t1.fD = Ab, t1.fE = Ha, t1.fF = function(e1, t1) {
            let i = "";
            for(let n = 0; n < e1.length; n++){
                const r = e1.charCodeAt(n + 1) || null, o = e1.charCodeAt(n - 1) || null;
                i += !t1 && (r && Ts(r) && !qd[e1[n + 1]] || o && Ts(o) && !qd[e1[n - 1]]) || !qd[e1[n]] ? e1[n] : qd[e1[n]];
            }
            return i;
        }, t1.fG = Vs, t1.fH = function(e1) {
            return !(e1 < 11904 || !(as(e1) || os(e1) || xs(e1) || ms(e1) || cs(e1) || Qa(e1) || ss(e1) || is(e1) || hs(e1) || ds(e1) || us(e1) || ws(e1) || ns(e1) || ts(e1) || es(e1) || ls(e1) || rs(e1) || ys(e1) || ps(e1) || fs(e1)));
        }, t1.fI = Is, t1.fJ = function(e1) {
            return Ya(e1) || Ja(e1) || Ka(e1) || gs(e1) || bs(e1);
        }, t1.fK = function(e1) {
            return 12307 === e1 || 12312 === e1 || 12313 === e1 || 12316 === e1 || 12448 === e1 || 12540 === e1 || e1 >= 8592 && e1 <= 8595 || 8208 === e1 || 8229 === e1 || 8741 === e1 || e1 >= 9472 && e1 <= 9547 || 65294 === e1 || 65309 === e1 || 65374 === e1 || 65507 === e1;
        }, t1.fL = 3, t1.fM = Mr, t1.fN = Uh, t1.fO = ld, t1.fP = function(e1) {
            for (const t1 of e1)if (!As(t1.charCodeAt(0))) return !1;
            return !0;
        }, t1.fQ = Es, t1.fR = uf, t1.fS = Zd, t1.fT = cf, t1.fU = Wd, t1.fV = f_, t1.fW = 1, t1.fX = af, t1.fY = sf, t1.fZ = Ne, t1.f_ = Kd, t1.fa = function(e1) {
            "string" != typeof e1 || e1.length > 64 || !Li.test(e1) ? mt(`Invalid SDK info "${e1}"; expected a "Name/version" string. Ignoring.`) : Oi = e1;
        }, t1.fb = Bs, t1.fc = function(e1, t1, i = !1) {
            if (Ds === Rs.deferred || Ds === Rs.loading || Ds === Rs.loaded) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            Cs = Vt.resolveURL(e1), Ds = Rs.deferred, Ps = t1, Os(), i || Ns();
        }, t1.fd = function(e1) {
            Ut.BUILDING_GEN_URL = Vt.resolveURL(e1);
        }, t1.fe = Ht, t1.ff = function(e1) {
            const t1 = Vt.resolveURL(e1);
            Ut.MESHOPT_URL = t1, Ut.MESHOPT_SIMD_URL = t1;
        }, t1.fg = jt, t1.fh = function(e1) {
            Ut.DRACO_URL = Vt.resolveURL(e1);
        }, t1.fi = Gt, t1.fj = function(e1) {
            const t1 = Kt();
            if (!t1) return;
            const i = t1.delete(Wt);
            e1 && i.then(()=>e1()).catch(e1);
        }, t1.fk = function(e1) {
            Ut.MAX_PARALLEL_IMAGE_REQUESTS = e1;
        }, t1.fl = function(e1) {
            Ut.API_URL = e1;
        }, t1.fm = function(e1) {
            Ut.ACCESS_TOKEN = e1;
        }, t1.fn = "hd_road_elevation", t1.fo = class {
            static parseFrom(e1, t1) {
                const i = nm.parse(e1);
                if (!i) return [];
                let { vertices: n, features: r } = i;
                const o = 1 / vu(t1);
                r.sort((e1, t1)=>e1.id - t1.id), n.sort((e1, t1)=>e1.id - t1.id || e1.idx - t1.idx), n = n.filter((e1, t1, i)=>t1 === i.findIndex((t1)=>t1.id === e1.id && t1.idx === e1.idx));
                const a = new Array;
                let s = 0;
                const l = n.length;
                for (const e1 of r){
                    if (e1.constantHeight) {
                        a.push(new cm(e1.id, e1.bounds, e1.constantHeight));
                        continue;
                    }
                    for(; s !== l && n[s].id < e1.id;)s++;
                    if (s === l || n[s].id !== e1.id) continue;
                    const t1 = new Array, i = new Array, r = s;
                    for(; s !== l && n[s].id === e1.id;){
                        const e1 = n[s];
                        if (t1.push({
                            position: e1.position,
                            height: e1.height,
                            extent: e1.extent,
                            index: e1.idx
                        }), s !== r && n[s - 1].idx === e1.idx - 1) {
                            const e1 = s - r;
                            i.push({
                                a: e1 - 1,
                                b: e1
                            });
                        }
                        s++;
                    }
                    a.push(new cm(e1.id, e1.bounds, void 0, t1, i, o));
                }
                return a;
            }
        }, t1.fp = Y_, t1.fq = Jx, t1.fr = rg, t1.fs = je, t1.ft = Hr, t1.fu = function(e1, t1) {
            const i = e1.layers[0].layout.get("fill-elevation-reference"), n = "hd-road-base" === i || "hd-road-markup" === i ? i : null, r = !!t1 && t1.length > 0 && og(t1, e1.layers[0].source, e1.sourceLayerName);
            (n || r) && (e1.hdExt = new ag(e1, n, r));
        }, t1.fv = function(e1, t1) {
            const i = "hd-road-markup" === e1.layers[0].layout.get("line-elevation-reference"), n = !!t1 && t1.length > 0 && og(t1, e1.layers[0].source, e1.sourceLayerName);
            (i || n) && (e1.hdExt = new ug(i, n));
        }, t1.fw = yd, t1.fx = function(e1) {
            const t1 = e1.layers[0];
            "circle" === t1.type && "hd-road-markup" === t1.layout.get("circle-elevation-reference") && (e1.hdExt = new cg);
        }, t1.fy = function(e1) {
            "hd-road-markup" === e1.layers[0].layout.get("symbol-elevation-reference") && (e1.hdExt = new dg);
        }, t1.fz = KE, t1.g = pi, t1.g0 = hf, t1.g1 = function(e1, t1) {
            const i = e1.stretchY || [
                [
                    0,
                    e1.paddedRect.h - 2
                ]
            ];
            return e1.stretchX || e1.stretchY ? P_(e1.stretchX || [
                [
                    0,
                    e1.paddedRect.w - 2
                ]
            ]) * P_(i) : 1;
        }, t1.g2 = O_, t1.g3 = rd, t1.g4 = 2, t1.g5 = Rb, t1.g6 = sd, t1.g7 = og, t1.g8 = function(e1, t1) {
            const i = rg(e1);
            return null !== i && !!(t1 & 1 << i);
        }, t1.g9 = ht, t1.ga = p_, t1.gb = s_, t1.gc = __, t1.gd = m_, t1.ge = Ph, t1.gf = function(e1) {
            return e1 <= 1 ? 1 : Math.pow(2, Math.floor(Math.log2(e1)));
        }, t1.gg = vA, t1.gh = Mh, t1.gi = class {
            constructor(e1 = new Uint8Array(16)){
                this.buf = ArrayBuffer.isView(e1) ? e1 : new Uint8Array(e1), this.dataView = new DataView(this.buf.buffer, this.buf.byteOffset, this.buf.byteLength), this.pos = 0, this.length = this.buf.length;
            }
            writeTag(e1, t1) {
                this.writeVarint(e1 << 3 | t1);
            }
            realloc(e1) {
                let t1 = this.length || 16;
                for(; t1 < this.pos + e1;)t1 *= 2;
                if (t1 !== this.length) {
                    const e1 = new Uint8Array(t1);
                    e1.set(this.buf), this.buf = e1, this.dataView = new DataView(e1.buffer), this.length = t1;
                }
            }
            finish() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            }
            writeFixed32(e1) {
                this.realloc(4), this.dataView.setInt32(this.pos, e1, !0), this.pos += 4;
            }
            writeSFixed32(e1) {
                this.realloc(4), this.dataView.setInt32(this.pos, e1, !0), this.pos += 4;
            }
            writeFixed64(e1) {
                this.realloc(8), this.dataView.setInt32(this.pos, -1 & e1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e1 * kp), !0), this.pos += 8;
            }
            writeSFixed64(e1) {
                this.realloc(8), this.dataView.setInt32(this.pos, -1 & e1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e1 * kp), !0), this.pos += 8;
            }
            writeVarint(e1) {
                if ((e1 = +e1 || 0) >= 0 && e1 < 128) return this.pos >= this.length && this.realloc(1), void (this.buf[this.pos++] = e1);
                e1 > 268435455 || e1 < 0 ? function(e1, t1) {
                    let i, n;
                    if (e1 >= 0 ? (i = e1 % 4294967296 | 0, n = e1 / 4294967296 | 0) : (i = ~(-e1 % 4294967296), n = ~(-e1 / 4294967296), 4294967295 ^ i ? i = i + 1 | 0 : (i = 0, n = n + 1 | 0)), e1 >= 0x10000000000000000 || e1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    t1.realloc(10), function(e1, t1, i) {
                        i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, i.buf[i.pos] = 127 & (e1 >>>= 7);
                    }(i, 0, t1), function(e1, t1) {
                        const i = (7 & e1) << 4;
                        t1.buf[t1.pos++] |= i | ((e1 >>>= 3) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1)))));
                    }(n, t1);
                }(e1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & e1 | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = e1 >>> 7 & 127))));
            }
            writeSVarint(e1) {
                this.writeVarint(e1 < 0 ? 2 * -e1 - 1 : 2 * e1);
            }
            writeBoolean(e1) {
                this.writeVarint(+e1);
            }
            writeString(e1) {
                e1 = String(e1), this.realloc(4 * e1.length), this.pos++;
                const t1 = this.pos;
                this.pos = function(e1, t1, i) {
                    for(let n, r, o = 0; o < t1.length; o++){
                        if (n = t1.charCodeAt(o), n > 55295 && n < 57344) {
                            if (!r) {
                                n > 56319 || o + 1 === t1.length ? (e1[i++] = 239, e1[i++] = 191, e1[i++] = 189) : r = n;
                                continue;
                            }
                            if (n < 56320) {
                                e1[i++] = 239, e1[i++] = 191, e1[i++] = 189, r = n;
                                continue;
                            }
                            n = r - 55296 << 10 | n - 56320 | 65536, r = null;
                        } else r && (e1[i++] = 239, e1[i++] = 191, e1[i++] = 189, r = null);
                        n < 128 ? e1[i++] = n : (n < 2048 ? e1[i++] = n >> 6 | 192 : (n < 65536 ? e1[i++] = n >> 12 | 224 : (e1[i++] = n >> 18 | 240, e1[i++] = n >> 12 & 63 | 128), e1[i++] = n >> 6 & 63 | 128), e1[i++] = 63 & n | 128);
                    }
                    return i;
                }(this.buf, e1, this.pos);
                const i = this.pos - t1;
                i >= 128 && Hp(t1, i, this), this.pos = t1 - 1, this.writeVarint(i), this.pos += i;
            }
            writeFloat(e1) {
                this.realloc(4), this.dataView.setFloat32(this.pos, e1, !0), this.pos += 4;
            }
            writeDouble(e1) {
                this.realloc(8), this.dataView.setFloat64(this.pos, e1, !0), this.pos += 8;
            }
            writeBytes(e1) {
                const t1 = e1.length;
                this.writeVarint(t1), this.realloc(t1), this.buf.set(e1, this.pos), this.pos += t1;
            }
            writeRawMessage(e1, t1) {
                this.pos++;
                const i = this.pos;
                e1(t1, this);
                const n = this.pos - i;
                n >= 128 && Hp(i, n, this), this.pos = i - 1, this.writeVarint(n), this.pos += n;
            }
            writeMessage(e1, t1, i) {
                this.writeTag(e1, 2), this.writeRawMessage(t1, i);
            }
            writePackedVarint(e1, t1) {
                t1.length && this.writeMessage(e1, $p, t1);
            }
            writePackedSVarint(e1, t1) {
                t1.length && this.writeMessage(e1, Zp, t1);
            }
            writePackedBoolean(e1, t1) {
                t1.length && this.writeMessage(e1, Xp, t1);
            }
            writePackedFloat(e1, t1) {
                t1.length && this.writeMessage(e1, Wp, t1);
            }
            writePackedDouble(e1, t1) {
                t1.length && this.writeMessage(e1, qp, t1);
            }
            writePackedFixed32(e1, t1) {
                t1.length && this.writeMessage(e1, Yp, t1);
            }
            writePackedSFixed32(e1, t1) {
                t1.length && this.writeMessage(e1, Jp, t1);
            }
            writePackedFixed64(e1, t1) {
                t1.length && this.writeMessage(e1, Kp, t1);
            }
            writePackedSFixed64(e1, t1) {
                t1.length && this.writeMessage(e1, Qp, t1);
            }
            writeBytesField(e1, t1) {
                this.writeTag(e1, 2), this.writeBytes(t1);
            }
            writeFixed32Field(e1, t1) {
                this.writeTag(e1, 5), this.writeFixed32(t1);
            }
            writeSFixed32Field(e1, t1) {
                this.writeTag(e1, 5), this.writeSFixed32(t1);
            }
            writeFixed64Field(e1, t1) {
                this.writeTag(e1, 1), this.writeFixed64(t1);
            }
            writeSFixed64Field(e1, t1) {
                this.writeTag(e1, 1), this.writeSFixed64(t1);
            }
            writeVarintField(e1, t1) {
                this.writeTag(e1, 0), this.writeVarint(t1);
            }
            writeSVarintField(e1, t1) {
                this.writeTag(e1, 0), this.writeSVarint(t1);
            }
            writeStringField(e1, t1) {
                this.writeTag(e1, 2), this.writeString(t1);
            }
            writeFloatField(e1, t1) {
                this.writeTag(e1, 5), this.writeFloat(t1);
            }
            writeDoubleField(e1, t1) {
                this.writeTag(e1, 1), this.writeDouble(t1);
            }
            writeBooleanField(e1, t1) {
                this.writeVarintField(e1, +t1);
            }
        }, t1.gj = vt, t1.gk = Ip, t1.gl = Rs, t1.gm = tA, t1.gn = function(e1) {
            Qt(), null != Jt && Jt.then((t1)=>{
                t1.keys().then((i)=>{
                    for(let n = 0; n < i.length - e1; n++)t1.delete(i[n]).catch((e1)=>mt(e1.message));
                }).catch((e1)=>mt(e1.message));
            }).catch((e1)=>mt(e1.message));
        }, t1.h = nn, t1.i = Un, t1.j = 2, t1.k = d_, t1.l = er, t1.m = ml, t1.n = Qn, t1.o = Nt, t1.p = i_, t1.q = ir, t1.r = Ia, t1.s = Qs, t1.t = wa, t1.u = el, t1.v = Aa, t1.w = mt, t1.x = Oa, t1.y = tl, t1.z = Va;
    });
    define([
        "require",
        "./shared"
    ], function(e1, t1) {
        function o(e1) {
            const t1 = e1 ? e1.url.toString() : void 0;
            return t1 ? performance.getEntriesByName(t1) : [];
        }
        function i(e1, o) {
            if (Object.hasOwn(e1.layers, t1.fn)) return t1.fo.parseFrom(e1.layers[t1.fn], o);
        }
        function n({ buckets: e1, data: o, sourceLayerCoder: i, canonical: n, options: s }) {
            if (!s.elevationFeatures || 0 === s.elevationFeatures.length) return;
            const r = [];
            for (const o of Object.values(e1))if (o instanceof t1.bA && o.hdExt) {
                const e1 = o.hdExt.getUnevaluatedPortalGraph();
                e1 && r.push(e1);
            }
            const a = t1.fp.evaluate(r);
            for (const r of Object.values(e1))if (r instanceof t1.bA && r.hdExt) {
                const e1 = o.layers[i.decode(r.sourceLayerIndex)];
                r.hdExt.setEvaluatedPortalGraph(a, e1, n, s.availableImages, s.brightness, r.worldview);
            }
        }
        function s(e1) {
            const o = [];
            for(let i = 0; i < e1.length; i++){
                const n = e1.feature(i), s = n.properties.frc_mask;
                if (null == s) continue;
                const r = Number(s);
                if (!r) continue;
                const a = n.loadGeometry();
                if (a.length > 0) {
                    let e1 = !1;
                    for (const o of a[0])if (o.x < 0 || o.x > t1.a2 || o.y < 0 || o.y > t1.a2) {
                        e1 = !0;
                        break;
                    }
                    if (e1) continue;
                }
                const l = 1 === a.length && 5 === a[0].length && a[0].some((e1)=>e1.x <= 0 && e1.y <= 0) && a[0].some((e1)=>e1.x >= t1.a2 && e1.y <= 0) && a[0].some((e1)=>e1.x >= t1.a2 && e1.y >= t1.a2) && a[0].some((e1)=>e1.x <= 0 && e1.y >= t1.a2);
                o.push(new t1.fq(r, l ? [] : a));
            }
            return o;
        }
        function r(e1, o, i, n, s) {
            const r = t1.fr(o);
            if (null === r) return !1;
            let a = i.x, l = i.y;
            const c = s ?? n.z;
            if (n.z !== c) {
                const e1 = 1 << n.z - c, o = t1.a2 / e1;
                a = n.x % e1 * o + i.x / e1, l = n.y % e1 * o + i.y / e1;
            }
            for (const o of e1){
                if (!(o.hasGeometry() && o.frcMask & 1 << r)) continue;
                const e1 = o.rings.map((e1)=>e1.map((e1)=>[
                            e1.x,
                            e1.y
                        ]));
                if (t1.fs([
                    a,
                    l
                ], e1)) return !0;
            }
            return !1;
        }
        function a(e1, o, i, n) {
            const s = o.indoorState.activeFloorsVisible;
            if (!o.sourceLayers) return s ? o.indoorState.activeFloors : void 0;
            const r = function(e1, o) {
                if (!e1) return t1.w("No source layers defined in indoor specification"), o;
                if (0 === e1.size) return o;
                const i = e1.difference(o);
                for (const e1 of i)t1.w(`Missing source layer required in indoor specification: ${e1}`);
                return o.intersection(o);
            }(o.sourceLayers, new Set(Object.keys(e1.layers))), a = o.indoorState, d = function(e1, o, i, n, s) {
                const r = {};
                for (const i of o){
                    const o = e1.layers[i];
                    if (o) for(let e1 = 0; e1 < o.length; e1++){
                        const t1 = o.feature(e1);
                        if (f(t1)) {
                            const { id: e1, center: o } = u(t1);
                            l(r, e1, o);
                            continue;
                        }
                        if (g(t1)) {
                            const e1 = h(t1, s);
                            c(r, e1.buildings, e1.id, e1);
                        }
                    }
                    else t1.w(`indoor source layer not found: ${i}`);
                }
                return {
                    buildings: r,
                    activeFloors: t1.aW.calculate(r, n, i)
                };
            }(e1, r, a.activeFloors, a.selectedFloorId, n);
            return i.notify("setIndoorData", d), s ? d.activeFloors : void 0;
        }
        function l(e1, t1, o) {
            e1[t1] ? o && (e1[t1].center = o) : e1[t1] = {
                floorIds: new Set,
                center: o || [
                    0,
                    0
                ],
                floors: {}
            };
        }
        function c(e1, t1, o, i) {
            for (const n of t1)l(e1, n), e1[n].floors[o] = i, e1[n].floorIds.add(o);
        }
        function u(e1) {
            return {
                id: e1.properties.id.toString(),
                center: [
                    e1.properties.center_lon || 0,
                    e1.properties.center_lat || 0
                ]
            };
        }
        function h(e1, o) {
            const i = e1.properties.id.toString(), n = !!e1.properties.is_default && e1.properties.is_default, s = e1.properties.connected_floor_ids ? new Set(e1.properties.connected_floor_ids.toString().split(";")) : new Set, r = e1.properties.conflicted_floor_ids ? new Set(e1.properties.conflicted_floor_ids.toString().split(";")) : new Set, a = e1.properties.structure_ids ? new Set(e1.properties.structure_ids.toString().split(";")) : new Set, l = e1.properties.name.toString(), c = e1.properties.z_index, u = function(e1, o) {
                const i = e1.loadGeometry();
                if (!i || 0 === i.length) return;
                const n = i.map((i)=>i.map((i)=>t1.ft(i, o, e1.extent)));
                return 0 === n.length ? void 0 : {
                    type: "Polygon",
                    coordinates: [
                        n[0]
                    ]
                };
            }(e1, o);
            return {
                id: i,
                isDefault: n,
                connections: s,
                conflicts: r,
                buildings: a,
                name: l,
                zIndex: c,
                geometry: u
            };
        }
        function d(e1, t1) {
            return t1.every((t1)=>e1.properties && null != e1.properties[t1]);
        }
        function f(e1) {
            return d(e1, [
                "type",
                "id",
                "name"
            ]) && "structure" === e1.properties.type;
        }
        function g(e1) {
            return d(e1, [
                "type",
                "id",
                "name",
                "z_index"
            ]) && "floor" === e1.properties.type;
        }
        function p(e1, o) {
            e1 instanceof t1.bA ? t1.fu(e1, o) : e1 instanceof t1.bz ? t1.fv(e1, o) : e1 instanceof t1.fw ? t1.fx(e1) : e1 instanceof t1.bu && t1.fy(e1);
        }
        function m(e1) {
            for(const o in e1){
                const i = e1[o];
                if (i instanceof t1.bz && i.hdExt && i.hdExt.hasDeferredElevationFeatures) return !0;
                if (i instanceof t1.bu && i.hdExt && i.hdExt.hasDeferredElevationFeatures) return !0;
            }
            return !1;
        }
        class y {
            constructor(e1, o, i){
                this.tileID = new t1.bP(e1.tileID.overscaledZ, e1.tileID.wrap, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y), this.tileZoom = e1.tileZoom, this.uid = e1.uid, this.zoom = e1.zoom, this.canonical = e1.tileID.canonical, this.pixelRatio = e1.pixelRatio, this.tileSize = e1.tileSize, this.source = e1.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = e1.projection, this.brightness = o, this.worldview = i;
            }
            async parse(e1, o, i) {
                this.status = "parsing";
                const n = new t1.bP(i.tileID.overscaledZ, i.tileID.wrap, i.tileID.canonical.z, i.tileID.canonical.x, i.tileID.canonical.y), s = [], r = o.familiesBySource[i.source], a = new t1.fz(n, i.promoteId);
                a.bucketLayerIDs = [], a.is3DTile = !0;
                const l = await t1.fA(e1), c = l.json.extensionsUsed && l.json.extensionsUsed.includes("MAPBOX_mesh_features") || l.json.asset.extras && l.json.asset.extras.MAPBOX_mesh_features, u = l.json.extensionsUsed && l.json.extensionsUsed.includes("EXT_meshopt_compression"), h = new t1.ai(this.zoom, {
                    brightness: this.brightness,
                    worldview: this.worldview
                });
                for(const e1 in r)for (const o of r[e1]){
                    const e1 = o[0];
                    a.bucketLayerIDs.push(o.map((e1)=>t1.m(e1.id, e1.scope))), e1.recalculate(h, []);
                    const r = t1.fB(l, 1 / t1.fC(i.tileID.canonical)), d = new t1.fD(o, r, n, c, u, this.brightness, a, this.worldview);
                    c || (d.needsUpload = !0), s.push(d), d.evaluate(e1);
                }
                return this.status = "done", {
                    buckets: s,
                    featureIndex: a,
                    collisionBoxArray: null,
                    glyphAtlasImage: null,
                    lineAtlas: null,
                    imageAtlas: null,
                    brightness: null
                };
            }
        }
        class x {
            constructor({ actor: e1, layerIndex: t1, availableImages: o, availableModels: i, brightness: n, worldview: s }){
                this.actor = e1, this.layerIndex = t1, this.availableImages = o, this.availableModels = i, this.brightness = n, this.loading = {}, this.loaded = {}, this.worldview = s;
            }
            async loadTile(e1) {
                const o = e1.uid, i = new AbortController, n = this.loading[o] = new y(e1, this.brightness, this.worldview);
                n.abort = ()=>i.abort();
                const s = (e1, t1)=>{
                    const o = n.reloadCallback;
                    o && (delete n.reloadCallback, o(e1, t1));
                };
                let r;
                try {
                    r = (await t1.cC(e1.request, i.signal)).data;
                } catch (e1) {
                    if (delete this.loading[o], n.status = "done", this.loaded[o] = n, i.signal.aborted) return null;
                    throw e1;
                }
                if (delete this.loading[o], !r || 0 === r.byteLength) return n.status = "done", this.loaded[o] = n, null;
                try {
                    const t1 = await n.parse(r, this.layerIndex, e1);
                    return this.loaded[o] = n, s(null, t1), t1;
                } catch (e1) {
                    throw this.loaded[o] = n, s(e1), e1;
                }
            }
            async reloadTile(e1) {
                const t1 = this.loaded && this.loaded[e1.uid];
                if (t1) return t1.projection = e1.projection, t1.brightness = e1.brightness, "parsing" === t1.status && await new Promise((e1, o)=>{
                    t1.reloadCallback = (t1)=>{
                        t1 ? o(t1) : e1();
                    };
                }), this.loadTile(e1);
            }
            abortTile(e1) {
                const t1 = e1.uid, o = this.loading[t1];
                o && (o.abort && o.abort(), delete this.loading[t1]);
            }
            removeTile(e1) {
                const t1 = this.loaded, o = e1.uid;
                t1 && t1[o] && delete t1[o];
            }
        }
        function v(e1) {
            if ("number" == typeof e1 || "boolean" == typeof e1 || "string" == typeof e1 || null == e1) return JSON.stringify(e1);
            if (Array.isArray(e1)) {
                let t1 = "[";
                for (const o of e1)t1 += `${v(o)},`;
                return `${t1}]`;
            }
            let t1 = "{";
            for (const o of Object.keys(e1).sort())t1 += `${o}:${v(e1[o])},`;
            return `${t1}}`;
        }
        function w(e1) {
            let o = "";
            for (const i of t1.cD)o += `/${v(e1[i])}`;
            return o;
        }
        function b(e1, t1) {
            return function e1(o) {
                return "string" == typeof o && o === t1 || (Array.isArray(o) ? o.some(e1) : !(!o || "object" != typeof o) && Object.values(o).some(e1));
            }(e1);
        }
        class S {
            constructor(e1){
                this.keyCache = Object.create(null), this._layers = Object.create(null), this._layerConfigs = Object.create(null), e1 && this.replace(e1);
            }
            replace(e1, t1) {
                this._layerConfigs = Object.create(null), this._layers = Object.create(null), this.update(e1, [], t1);
            }
            update(e1, o, i) {
                this._options = i;
                for (const o of e1)this._layerConfigs[o.id] = o, (this._layers[o.id] = t1.di(o, this.scope, null, this._options)).compileFilter(i), this.keyCache[o.id] && delete this.keyCache[o.id];
                for (const e1 of o)delete this.keyCache[e1], delete this._layerConfigs[e1], delete this._layers[e1];
                this.familiesBySource = Object.create(null);
                const n = function(e1, t1) {
                    const o = Object.create(null);
                    for(let i = 0; i < e1.length; i++){
                        const n = e1[i];
                        let s = t1 && t1[n.id];
                        s || ("symbol" === n.type ? s = n.id : (s = w(n), "line" === n.type && n.paint && (b(n.paint["line-width"], "line-progress") && (s += `/${v(n.paint["line-width"])}`), b(n.paint["line-emissive-strength"], "line-progress") && (s += `/${v(n.paint["line-emissive-strength"])}`)))), t1 && (t1[n.id] = s);
                        let r = o[s];
                        r || (r = o[s] = []), r.push(n);
                    }
                    const i = [];
                    for(const e1 in o)i.push(o[e1]);
                    return i;
                }(Object.values(this._layerConfigs), this.keyCache);
                for (const e1 of n){
                    const t1 = e1.map((e1)=>this._layers[e1.id]), o = t1[0];
                    if ("none" === o.visibility) continue;
                    const i = o.source || "";
                    let n = this.familiesBySource[i];
                    n || (n = this.familiesBySource[i] = Object.create(null));
                    const s = o.sourceLayer || "_geojsonTileLayer";
                    let r = n[s];
                    r || (r = n[s] = []), r.push(t1);
                }
            }
        }
        class I extends t1.P {
            constructor(e1, t1, o, i, n){
                super(e1, t1), this.angle = i, this.z = o, void 0 !== n && (this.segment = n);
            }
            clone() {
                return new I(this.x, this.y, this.z, this.angle, this.segment);
            }
        }
        function P(e1, t1, o, i, n) {
            if (void 0 === t1.segment) return !0;
            let s = t1, r = t1.segment + 1, a = 0;
            for(; a > -o / 2;){
                if (r--, r < 0) return !1;
                a -= e1[r].dist(s), s = e1[r];
            }
            a += e1[r].dist(e1[r + 1]), r++;
            const l = [];
            let c = 0;
            for(; a < o / 2;){
                const t1 = e1[r], o = e1[r + 1];
                if (!o) return !1;
                let s = e1[r - 1].angleTo(t1) - t1.angleTo(o);
                for(s = Math.abs((s + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: a,
                    angleDelta: s
                }), c += s; a - l[0].distance > i;)c -= l.shift().angleDelta;
                if (c > n) return !1;
                r++, a += t1.dist(o);
            }
            return !0;
        }
        function M(e1) {
            let t1 = 0;
            for(let o = 0; o < e1.length - 1; o++)t1 += e1[o].dist(e1[o + 1]);
            return t1;
        }
        function T(e1, t1, o) {
            return e1 ? .6 * t1 * o : 0;
        }
        function z(e1, t1) {
            return Math.max(e1 ? e1.right - e1.left : 0, t1 ? t1.right - t1.left : 0);
        }
        function B(e1, o, i, n, s, r) {
            const a = T(i, s, r), l = z(i, n) * r;
            let c = 0;
            const u = M(e1) / 2;
            for(let i = 0; i < e1.length - 1; i++){
                const n = e1[i], s = e1[i + 1], r = n.dist(s);
                if (c + r > u) {
                    const h = (u - c) / r, d = t1.al(n.x, s.x, h), f = t1.al(n.y, s.y, h), g = new I(d, f, 0, s.angleTo(n), i);
                    return !a || P(e1, g, l, a, o) ? g : void 0;
                }
                c += r;
            }
        }
        function k(e1, t1, o, i, n, s, r, a, l) {
            const c = T(i, s, r), u = z(i, n), h = u * r, d = 0 === e1[0].x || e1[0].x === l || 0 === e1[0].y || e1[0].y === l;
            return t1 - h < t1 / 4 && (t1 = h + t1 / 4), C(e1, d ? t1 / 2 * a % t1 : (u / 2 + 2 * s) * r * a % t1, t1, c, o, h, d, !1, l);
        }
        function C(e1, o, i, n, s, r, a, l, c) {
            const u = r / 2, h = M(e1);
            let d = 0, f = o - i, g = [];
            for(let o = 0; o < e1.length - 1; o++){
                const a = e1[o], l = e1[o + 1], p = a.dist(l), m = l.angleTo(a);
                for(; f + i < d + p;){
                    f += i;
                    const y = (f - d) / p, x = t1.al(a.x, l.x, y), v = t1.al(a.y, l.y, y);
                    if (x >= 0 && x < c && v >= 0 && v < c && f - u >= 0 && f + u <= h) {
                        const t1 = new I(x, v, 0, m, o);
                        n && !P(e1, t1, r, n, s) || g.push(t1);
                    }
                }
                d += p;
            }
            return l || g.length || a || (g = C(e1, d / 2, i, n, s, r, a, !0, c)), g;
        }
        t1.fE(I, "Anchor");
        class L {
            constructor(){
                this.scale = 1, this.fontStack = "", this.image = null;
            }
            static forText(e1, t1) {
                const o = new L;
                return o.scale = e1 || 1, o.fontStack = t1, o;
            }
            static forImage(e1) {
                const t1 = new L;
                return t1.image = e1, t1;
            }
        }
        class D {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(e1, t1, o, i = 1) {
                const n = new D;
                for(let s = 0; s < e1.sections.length; s++){
                    const r = e1.sections[s];
                    r.image ? n.addImageSection(r, o, i) : n.addTextSection(r, t1);
                }
                return n;
            }
            length() {
                return this.text.length;
            }
            getSection(e1) {
                return this.sections[this.sectionIndex[e1]];
            }
            getSections() {
                return this.sections;
            }
            getSectionIndex(e1) {
                return this.sectionIndex[e1];
            }
            getCodePoint(e1) {
                return this.text.codePointAt(e1);
            }
            verticalizePunctuation(e1) {
                this.text = t1.fF(this.text, e1);
            }
            trim() {
                let e1 = 0;
                for(let t1 = 0; t1 < this.text.length && A[this.text.charCodeAt(t1)]; t1++)e1++;
                let t1 = this.text.length;
                for(let o = this.text.length - 1; o >= 0 && o >= e1 && A[this.text.charCodeAt(o)]; o--)t1--;
                this.text = this.text.substring(e1, t1), this.sectionIndex = this.sectionIndex.slice(e1, t1);
            }
            substring(e1, t1) {
                const o = new D;
                return o.text = this.text.substring(e1, t1), o.sectionIndex = this.sectionIndex.slice(e1, t1), o.sections = this.sections, o;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((e1, t1)=>Math.max(e1, this.sections[t1].scale), 0);
            }
            addTextSection(e1, t1) {
                this.text += e1.text, this.sections.push(L.forText(e1.scale, e1.fontStack || t1));
                const o = this.sections.length - 1;
                for(let t1 = 0; t1 < e1.text.length; ++t1)this.sectionIndex.push(o);
            }
            addImageSection(e1, o, i = 1) {
                const n = e1.image ? e1.image.getPrimary() : null;
                if (!n) return void t1.w("Can't add FormattedSection with an empty image.");
                n.scaleSelf(o * i);
                const s = this.getNextImageSectionCharCode();
                s ? (this.text += String.fromCodePoint(s), this.sections.push(L.forImage(n)), this.sectionIndex.push(this.sections.length - 1)) : t1.w("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function F(e1, o, i, n, s, r, a, l, c, u, h, d, f, g, p, m = 1, y = 1) {
            const x = D.fromFeature(e1, s, m, y);
            d === t1.cL.vertical && x.verticalizePunctuation(f);
            let v = [];
            const w = function(e1, o, i, n, s, r, a) {
                if (!e1) return [];
                const l = [], c = function(e1, t1, o, i, n, s, r) {
                    let a = 0;
                    for(let o = 0; o < e1.length(); o++){
                        const l = e1.getSection(o);
                        a += E(e1.getCodePoint(o), l, i, n, t1, s, r);
                    }
                    return a / Math.max(1, Math.ceil(a / o));
                }(e1, o, i, n, s, r, a), u = e1.text.includes("\u200B");
                let h = 0;
                for(let i = 0; i < e1.length(); i++){
                    const d = e1.getSection(i), f = e1.getCodePoint(i);
                    if (A[f] || (h += E(f, d, n, s, o, r, a)), i < e1.length() - 1) {
                        const o = t1.fH(f);
                        (_[f] || o || d.image) && l.push(j(i + 1, h, c, l, R(f, e1.getCodePoint(i + 1), o && u), !1));
                    }
                }
                return V(j(e1.length(), h, c, l, 0, !0));
            }(x, u, r, o, n, g, y), { processBidirectionalText: b, processStyledBidirectionalText: S } = t1.fG;
            if (b && 1 === x.sections.length) {
                const e1 = b(x.toString(), w);
                for (const t1 of e1){
                    const e1 = new D;
                    e1.text = t1, e1.sections = x.sections;
                    for(let o = 0; o < t1.length; o++)e1.sectionIndex.push(0);
                    v.push(e1);
                }
            } else if (S) {
                const e1 = S(x.text, x.sectionIndex, w);
                for (const t1 of e1){
                    const e1 = new D;
                    e1.text = t1[0], e1.sectionIndex = t1[1], e1.sections = x.sections, v.push(e1);
                }
            } else v = function(e1, t1) {
                const o = [], i = e1.text;
                let n = 0;
                for (const i of t1)o.push(e1.substring(n, i)), n = i;
                return n < i.length && o.push(e1.substring(n, i.length)), o;
            }(x, w);
            const I = [], P = {
                positionedLines: I,
                text: x.toString(),
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: d,
                iconsInText: !1,
                verticalizable: !1,
                hasBaseline: !1
            };
            if (function(e1, o, i, n, s, r, a, l, c, u, h, d, f) {
                let g = 0, p = 0, m = 0;
                const y = "right" === l ? 1 : "left" === l ? 0 : .5;
                let x = !1;
                for (const e1 of s){
                    const t1 = e1.getSections();
                    for (const e1 of t1){
                        if (e1.image) continue;
                        const t1 = o[e1.fontStack];
                        if (t1 && (x = void 0 !== t1.ascender && void 0 !== t1.descender, !x)) break;
                    }
                    if (!x) break;
                }
                let v = 0;
                for (const a of s){
                    a.trim();
                    const s = a.getMaxScale(), l = (s - 1) * t1.d1, w = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    e1.positionedLines[v] = w;
                    const b = w.positionedGlyphs;
                    let S = 0;
                    if (!a.length()) {
                        p += r, ++v;
                        continue;
                    }
                    let I = 0, P = 0;
                    for(let r = 0; r < a.length(); r++){
                        const l = a.getSection(r), m = a.getSectionIndex(r), y = a.getCodePoint(r);
                        let v = l.scale, w = null, M = null, T = null, z = t1.d1, B = 0, k = c;
                        k === t1.cL.vertical && t1.fK(y) && (k = t1.cL.horizontal);
                        const C = !(k === t1.cL.horizontal || !h && !t1.fI(y) || h && (A[y] || t1.fJ(y)));
                        if (l.image) {
                            const o = n.get(l.image.toString());
                            if (!o) continue;
                            T = l.image, e1.iconsInText = !0, M = o.paddedRect;
                            const i = o.displaySize, r = i[0] * f, a = i[1] * f;
                            v = v * t1.d1 / d, w = {
                                width: r,
                                height: a,
                                left: 0,
                                top: -t1.fL,
                                advance: C ? a : r,
                                localGlyph: !1
                            }, B = x ? -w.height * v : s * t1.d1 - 17 - a * v, z = w.advance;
                            const c = (C ? r : a) * v - t1.d1 * s;
                            c > 0 && c > S && (S = c);
                        } else {
                            const e1 = i[l.fontStack];
                            if (!e1) continue;
                            e1[y] && (M = e1[y]);
                            const n = o[l.fontStack];
                            if (!n) continue;
                            const r = n.glyphs[y];
                            if (!r) continue;
                            if (w = r.metrics, z = 8203 !== y ? t1.d1 : 0, x) {
                                const e1 = void 0 !== n.ascender ? Math.abs(n.ascender) : 0, t1 = void 0 !== n.descender ? Math.abs(n.descender) : 0, o = (e1 + t1) * v;
                                I < o && (I = o, P = (e1 - t1) / 2 * v), B = -e1 * v;
                            } else B = (s - v) * t1.d1 - 17;
                        }
                        b.push({
                            glyph: y,
                            image: T,
                            x: g,
                            y: p + B,
                            vertical: C,
                            scale: v,
                            localGlyph: w.localGlyph,
                            fontStack: l.fontStack,
                            sectionIndex: m,
                            metrics: w,
                            rect: M
                        }), C ? (e1.verticalizable = !0, g += z * v + u) : g += w.advance * v + u;
                    }
                    0 !== b.length && (m = Math.max(g - u, m), x ? G(b, y, S, P, r * s / 2) : G(b, y, S, 0, r / 2)), g = 0;
                    const M = r * s + S;
                    w.lineOffset = Math.max(S, l), p += M, ++v;
                }
                const w = p, { horizontalAlign: b, verticalAlign: S } = t1.cM(a);
                (function(e1, t1, o, i, n, s) {
                    const r = (t1 - o) * n, a = -s * i;
                    for (const t1 of e1)for (const e1 of t1.positionedGlyphs)e1.x += r, e1.y += a;
                })(e1.positionedLines, y, b, S, m, w), e1.top += -S * w, e1.bottom = e1.top + w, e1.left += -b * m, e1.right = e1.left + m, e1.hasBaseline = x;
            }(P, o, i, n, v, a, l, c, d, u, f, p, y), !function(e1) {
                for (const t1 of e1)if (0 !== t1.positionedGlyphs.length) return !1;
                return !0;
            }(I)) return P;
        }
        const A = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, _ = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function E(e1, o, i, n, s, r, a) {
            if (o.image) {
                const e1 = n.get(o.image.toString());
                return e1 ? e1.displaySize[0] * a * o.scale * t1.d1 / r + s : 0;
            }
            {
                const t1 = i[o.fontStack], n = t1 && t1.glyphs[e1];
                return n ? n.metrics.advance * o.scale + s : 0;
            }
        }
        function O(e1, t1, o, i) {
            const n = Math.pow(e1 - t1, 2);
            return i ? e1 < t1 ? n / 2 : 2 * n : n + Math.abs(o) * o;
        }
        function R(e1, t1, o) {
            let i = 0;
            return 10 === e1 && (i -= 1e4), o && (i += 150), 40 !== e1 && 65288 !== e1 || (i += 50), 41 !== t1 && 65289 !== t1 || (i += 50), i;
        }
        function j(e1, t1, o, i, n, s) {
            let r = null, a = O(t1, o, n, s);
            for (const e1 of i){
                const i = O(t1 - e1.x, o, n, s) + e1.badness;
                i <= a && (r = e1, a = i);
            }
            return {
                index: e1,
                x: t1,
                priorBreak: r,
                badness: a
            };
        }
        function V(e1) {
            return e1 ? V(e1.priorBreak).concat(e1.index) : [];
        }
        function G(e1, t1, o, i, n) {
            if (!(t1 || o || i || n)) return;
            const s = e1.length - 1, r = e1[s], a = (r.x + r.metrics.advance * r.scale) * t1;
            for(let t1 = 0; t1 <= s; t1++)e1[t1].x -= a, e1[t1].y += o + i + n;
        }
        function Z(e1, o = 1, i = !1) {
            let n = 1 / 0, s = 1 / 0, r = -1 / 0, a = -1 / 0;
            const l = e1[0];
            for(let e1 = 0; e1 < l.length; e1++){
                const t1 = l[e1];
                (!e1 || t1.x < n) && (n = t1.x), (!e1 || t1.y < s) && (s = t1.y), (!e1 || t1.x > r) && (r = t1.x), (!e1 || t1.y > a) && (a = t1.y);
            }
            const c = Math.min(r - n, a - s);
            let u = c / 2;
            const h = new t1.fM([], N);
            if (0 === c) return new t1.P(n, s);
            for(let t1 = n; t1 < r; t1 += c)for(let o = s; o < a; o += c)h.push(new U(t1 + u, o + u, u, e1));
            let d = function(e1) {
                let t1 = 0, o = 0, i = 0;
                const n = e1[0];
                for(let e1 = 0, s = n.length, r = s - 1; e1 < s; r = e1++){
                    const s = n[e1], a = n[r], l = s.x * a.y - a.x * s.y;
                    o += (s.x + a.x) * l, i += (s.y + a.y) * l, t1 += 3 * l;
                }
                return new U(o / t1, i / t1, 0, e1);
            }(e1), f = h.length;
            for(; h.length;){
                const t1 = h.pop();
                (t1.d > d.d || !d.d) && (d = t1, i && console.log("found best %d after %d probes", Math.round(1e4 * t1.d) / 1e4, f)), t1.max - d.d <= o || (u = t1.h / 2, h.push(new U(t1.p.x - u, t1.p.y - u, u, e1)), h.push(new U(t1.p.x + u, t1.p.y - u, u, e1)), h.push(new U(t1.p.x - u, t1.p.y + u, u, e1)), h.push(new U(t1.p.x + u, t1.p.y + u, u, e1)), f += 4);
            }
            return i && (console.log(`num probes: ${f}`), console.log(`best distance: ${d.d}`)), d.p;
        }
        function N(e1, t1) {
            return t1.max - e1.max;
        }
        class U {
            constructor(e1, o, i, n){
                this.p = new t1.P(e1, o), this.h = i, this.d = function(e1, o) {
                    let i = !1, n = 1 / 0;
                    for(let s = 0; s < o.length; s++){
                        const r = o[s];
                        for(let o = 0, s = r.length, a = s - 1; o < s; a = o++){
                            const s = r[o], l = r[a];
                            s.y > e1.y != l.y > e1.y && e1.x < (l.x - s.x) * (e1.y - s.y) / (l.y - s.y) + s.x && (i = !i), n = Math.min(n, t1.fN(e1, s, l));
                        }
                    }
                    return (i ? 1 : -1) * Math.sqrt(n);
                }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
            }
        }
        const Y = Object.keys;
        function X(e1) {
            return void 0 !== e1.imagePrimary && void 0 !== e1.top && void 0 !== e1.bottom && void 0 !== e1.left && void 0 !== e1.right;
        }
        function $(e1) {
            return !e1.imagePrimary.stretchX;
        }
        function q(e1) {
            return !e1.imagePrimary.stretchY;
        }
        function J(e1) {
            return {
                width: e1.right - e1.left,
                height: e1.bottom - e1.top
            };
        }
        const W = Number.POSITIVE_INFINITY;
        function H(e1, o, i, n, s, r) {
            const a = X(e1) && e1.collisionPadding ? e1.collisionPadding : [
                0,
                0,
                0,
                0
            ], l = {
                top: e1.top - a[1],
                bottom: e1.bottom + a[3],
                left: e1.left - a[0],
                right: e1.right + a[2],
                scaled: !1
            };
            return void 0 !== n && function(e1, t1) {
                e1.top *= t1, e1.bottom *= t1, e1.left *= t1, e1.right *= t1, e1.scaled = !0;
            }(l, n), r && (l.left += r[0], l.right += r[0], l.top += r[1], l.bottom += r[1]), i && function(e1, o, i) {
                if (!o) return;
                const n = t1.au(o), s = new t1.P(i ? i[0] : 0, i ? i[1] : 0), r = new t1.P(e1.left, e1.top), a = new t1.P(e1.right, e1.top), l = new t1.P(e1.left, e1.bottom), c = new t1.P(e1.right, e1.bottom);
                r._rotateAround(n, s), a._rotateAround(n, s), l._rotateAround(n, s), c._rotateAround(n, s), e1.left = Math.min(r.x, a.x, l.x, c.x), e1.right = Math.max(r.x, a.x, l.x, c.x), e1.top = Math.min(r.y, a.y, l.y, c.y), e1.bottom = Math.max(r.y, a.y, l.y, c.y);
            }(l, i, s), o ? {
                top: Math.min(o.top, l.top),
                bottom: Math.max(o.bottom, l.bottom),
                left: Math.min(o.left, l.left),
                right: Math.max(o.right, l.right),
                scaled: o.scaled || l.scaled
            } : l;
        }
        function Q(e1, o, i, n, s, r, a, l = 1, c, u, h, d, f, g, p, m, y) {
            e1.createArrays(), e1.tilePixelRatio = t1.a2 / (512 * e1.overscaling), e1.compareText = {}, e1.iconsNeedLinear = !1;
            const x = e1.layers[0].layout, v = e1.layers[0]._unevaluatedLayout._values, w = {};
            w.scaleFactor = l, w.textSizeScaleRange = x.get("text-size-scale-range"), w.iconSizeScaleRange = x.get("icon-size-scale-range");
            const [b, S] = w.textSizeScaleRange, [I, P] = w.iconSizeScaleRange;
            w.textScaleFactor = t1.b0(w.scaleFactor, b, S), w.iconScaleFactor = t1.b0(w.scaleFactor, I, P);
            const M = v["text-size"], T = v["icon-size"];
            if ("composite" === e1.textSizeData.kind) {
                const { minZoom: o, maxZoom: i } = e1.textSizeData;
                w.compositeTextSizes = [
                    M.possiblyEvaluate(new t1.ai(o, {
                        worldview: h
                    }), r),
                    M.possiblyEvaluate(new t1.ai(i, {
                        worldview: h
                    }), r)
                ];
            }
            if ("composite" === e1.iconSizeData.kind) {
                const { minZoom: o, maxZoom: i } = e1.iconSizeData;
                w.compositeIconSizes = [
                    T.possiblyEvaluate(new t1.ai(o, {
                        worldview: h
                    }), r, d),
                    T.possiblyEvaluate(new t1.ai(i, {
                        worldview: h
                    }), r, d)
                ];
            }
            w.layoutTextSize = M.possiblyEvaluate(new t1.ai(a + 1, {
                worldview: h
            }), r), w.layoutIconSize = T.possiblyEvaluate(new t1.ai(a + 1, {
                worldview: h
            }), r, d), w.textMaxSize = M.possiblyEvaluate(new t1.ai(18, {
                worldview: h
            }), r);
            const z = x.get("symbol-placement"), B = "map" === x.get("text-rotation-alignment") && "point" !== z, k = x.get("text-size");
            let C = !1;
            const L = [], D = null != f && 0 !== f;
            for (const a of e1.features){
                if (D && a.properties && m && m(a.properties, f)) continue;
                let l = 65535;
                if (e1.hdExt && a.properties && Object.hasOwn(a.properties, t1.fO)) {
                    const o = +a.properties[t1.fO];
                    if (!Number.isNaN(o)) {
                        const t1 = e1.hdExt.resolveRoadElevation(a, o);
                        if ("defer" === t1) continue;
                        l = t1;
                    }
                }
                const g = x.get("text-font").evaluate(a, {}, r).join(","), p = k.evaluate(a, {}, r) * w.textScaleFactor, y = w.layoutTextSize.evaluate(a, {}, r) * w.textScaleFactor, b = w.layoutIconSize.evaluate(a, {}, r, d) * w.iconScaleFactor, S = {
                    horizontal: {},
                    vertical: void 0
                }, I = a.text;
                let P, M = [
                    0,
                    0
                ];
                if (I) {
                    const n = I.toString(), l = x.get("text-letter-spacing").evaluate(a, {}, r) * t1.d1, u = x.get("text-line-height").evaluate(a, {}, r) * t1.d1, h = t1.fP(n) ? l : 0, d = x.get("text-anchor").evaluate(a, {}, r), f = x.get("text-variable-anchor");
                    if (!f) {
                        const e1 = x.get("text-radial-offset").evaluate(a, {}, r);
                        if (e1) M = t1.cN(d, [
                            e1 * t1.d1,
                            W
                        ]);
                        else {
                            const e1 = x.get("text-offset").evaluate(a, {}, r);
                            M = [
                                e1[0] * t1.d1,
                                e1[1] * t1.d1
                            ];
                        }
                    }
                    let m = B ? "center" : x.get("text-justify").evaluate(a, {}, r);
                    const v = "point" === z, b = v ? x.get("text-max-width").evaluate(a, {}, r) * t1.d1 : 1 / 0, P = (r)=>{
                        e1.allowVerticalPlacement && t1.fQ(n) && (S.vertical = F(I, o, i, s, g, b, u, d, r, h, M, t1.cL.vertical, !0, y, p, c, w.textScaleFactor));
                    };
                    if (!B && f) {
                        const e1 = "auto" === m ? f.map((e1)=>t1.cO(e1)) : [
                            m
                        ];
                        let n = !1;
                        for(let r = 0; r < e1.length; r++){
                            const a = e1[r];
                            if (!S.horizontal[a]) {
                                if (n) S.horizontal[a] = S.horizontal[0];
                                else {
                                    const e1 = F(I, o, i, s, g, b, u, "center", a, h, M, t1.cL.horizontal, !1, y, p, c, w.textScaleFactor);
                                    e1 && (S.horizontal[a] = e1, n = 1 === e1.positionedLines.length);
                                }
                            }
                        }
                        P("left");
                    } else {
                        if ("auto" === m && (m = t1.cO(d)), v || x.get("text-writing-mode").includes("horizontal") || !t1.fQ(n)) {
                            const e1 = F(I, o, i, s, g, b, u, d, m, h, M, t1.cL.horizontal, !1, y, p, c, w.textScaleFactor);
                            e1 && (S.horizontal[m] = e1);
                        }
                        P(v ? "left" : m);
                    }
                }
                let T, A, _, E, O, R, j = !1;
                const V = x.get("icon-text-fit").evaluate(a, {}, r);
                if (a.icon && a.icon.hasPrimary()) {
                    const o = t1.fR(a.icon, e1.iconSizeData, v["icon-size"], r, e1.zoom, a, c, w.iconScaleFactor, h, d);
                    T = o.iconPrimary, _ = o.iconSecondary;
                    const i = T.toString();
                    if (A = n.get(i), A && (O = x.get("icon-offset").evaluate(a, {}, r), R = x.get("icon-anchor").evaluate(a, {}, r), P = t1.fS(s.get(i), _ ? s.get(_.toString()) : void 0, O, R), j = A.sdf, void 0 === e1.sdfIcons ? e1.sdfIcons = A.sdf : e1.sdfIcons !== A.sdf && t1.w("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (A.pixelRatio !== e1.pixelRatio || 0 !== x.get("icon-rotate").constantOr(1)) && (e1.iconsNeedLinear = !0)), _) {
                        const e1 = _.toString();
                        E = n.get(e1);
                    }
                }
                C = C || !(!a.icon || !a.icon.hasSecondary());
                const G = de(S.horizontal) || S.vertical;
                e1.iconsInText || (e1.iconsInText = !!G && G.iconsInText);
                const Z = t1.fT(y, w.textScaleFactor), { defaultShapedIcon: N, verticallyShapedIcon: U } = ce(e1, P, x, a, r, S, Z, O, V);
                "none" !== V && P && ($(P) || q(P)) && (ie(A, T, P, N, V, u, n, s), ie(E, _, P, N, V, u, n, s), U && (ie(A, T, P, U, V, u, n, s), ie(E, _, P, U, V, u, n, s))), P = N;
                const { iconBBox: Y, iconVerticalBBox: X, textBBox: J, textVerticalBBox: H } = K(e1, P, U, x, a, r, b, O, w, s, R, S, y, M, d);
                L.push({
                    feature: a,
                    shapedTextOrientations: S,
                    shapedText: G,
                    shapedIcon: P,
                    iconPrimary: T,
                    iconSecondary: _,
                    iconOffset: O,
                    iconAnchor: R,
                    verticallyShapedIcon: U,
                    layoutTextSize: y,
                    layoutIconSize: b,
                    textOffset: M,
                    isSDFIcon: j,
                    iconTextFit: V,
                    iconCollisionBounds: Y,
                    iconVerticalCollisionBounds: X,
                    textCollisionBounds: J,
                    textVerticalCollisionBounds: H,
                    elevationFeatureIndex: l
                });
            }
            return e1.hdExt && e1.hdExt.clearWorkerState(), {
                featureData: L,
                sizes: w,
                hasAnySecondaryIcon: C,
                textAlongLine: B,
                symbolPlacement: z,
                coverageFrcMask: f,
                coveragePolygons: g,
                coverageTileZoom: p,
                isFeatureCoveredByFrcMask: m,
                symbolAnchorInFrcCoverage: y
            };
        }
        function K(e1, o, i, n, s, r, a, l, c, u, h, d, f, g, p) {
            const m = e1.layers[0], y = m.appearances;
            if (0 === y.length) return {
                iconBBox: null,
                iconVerticalBBox: null,
                textBBox: null,
                textVerticalBBox: null
            };
            const x = {
                iconBBox: null,
                iconVerticalBBox: null
            }, v = {
                textBBox: null,
                textVerticalBBox: null
            }, { baseIconRotate: w, baseTextRotate: b, iconScaleFactor: S } = function(e1, o, i) {
                const n = e1.get("icon-rotate").evaluate(o, {}, i), s = e1.get("text-rotate").evaluate(o, {}, i), [r, a] = e1.get("icon-size-scale-range");
                return {
                    baseIconRotate: n,
                    baseTextRotate: s,
                    iconScaleFactor: t1.b0(1, r, a)
                };
            }(n, s, r);
            o && (x.iconBBox = H(o, x.iconBBox, w), i) && (x.iconVerticalBBox = H(i, x.iconVerticalBBox, w + 90));
            const I = de(d.horizontal);
            I && (v.textBBox = H(I, v.textBBox, b, 1, g)), d.vertical && (v.textVerticalBBox = H(d.vertical, v.textVerticalBBox, b + 90, 1, g));
            for (const t1 of y)t1.hasIconLayoutProperties() && ee(x, e1, m, t1, s, r, l, w, a, c, o, u, S, h, p), t1.hasTextLayoutProperties() && oe(v, m, t1, s, r, g, b, f, I, d.vertical);
            return {
                iconBBox: x.iconBBox,
                iconVerticalBBox: x.iconVerticalBBox,
                textBBox: v.textBBox,
                textVerticalBBox: v.textVerticalBBox
            };
        }
        function ee(e1, o, i, n, s, r, a, l, c, u, h, d, f, g, p) {
            const { appearanceIconOffset: m, appearanceIconRotate: y, appearanceIconSize: x } = t1.fX(n, i, s, r, a, l, c, u.iconScaleFactor);
            let v = null, w = null, b = null;
            n.hasLayoutProperty("icon-image") ? b = te(o, i, n, s, r, d, f, p) : h && (b = h.imagePrimary), b && (v = t1.fS(b, null, m, g), o.allowVerticalPlacement && (w = v));
            const S = c > 0 ? x / c : 1;
            v && (e1.iconBBox = H(v, e1.iconBBox, y, 1 !== S ? S : void 0)), w && (e1.iconVerticalBBox = H(w, e1.iconVerticalBBox, y + 90, 1 !== S ? S : void 0));
        }
        function te(e1, o, i, n, s, r, a, l) {
            let c = null;
            const u = o.getAppearanceValueAndResolveTokens(i, "icon-image", n, s, l);
            if (u) {
                const h = e1.getResolvedImageFromTokens(u), d = i.hasLayoutProperty("icon-size") ? i.getUnevaluatedLayoutProperty("icon-size") : o._unevaluatedLayout._values["icon-size"], f = t1.f_(e1.zoom, d, e1.worldview, l), g = t1.fR(h, f, d, s, e1.zoom, n, e1.pixelRatio, a, e1.worldview, l);
                c = r.get(g.iconPrimary.toString());
            }
            return c;
        }
        function oe(e1, o, i, n, s, r, a, l, c, u) {
            const { appearanceTextOffset: h, appearanceTextRotate: d, appearanceTextSize: f } = t1.fY(i, o, n, s, r, a, l), g = f / l, p = [
                (h[0] - r[0]) * g,
                (h[1] - r[1]) * g
            ], m = 0 !== p[0] || 0 !== p[1];
            c && (e1.textBBox = H(c, e1.textBBox, d, g, h, m ? p : void 0)), u && (e1.textVerticalBBox = H(u, e1.textVerticalBBox, d + 90, g, h, m ? p : void 0));
        }
        function ie(e1, o, i, n, s, r, a, l) {
            if (!e1 || !e1.usvg) return;
            const c = J(i), u = J(n), h = "both" !== s && "width" !== s || !$(i) ? 1 : u.width / c.width, d = "both" !== s && "height" !== s || !q(i) ? 1 : u.height / c.height;
            o.scaleSelf(h, d);
            const f = o.toString();
            r.set(f, o), a.set(f, e1);
            const { imagePosition: g } = t1.fV(f, e1, t1.fW);
            l.set(f, g);
        }
        function ne(e1, o, i) {
            if (!o) return;
            const n = i.get(e1.toString()), s = i.get(o.toString());
            n && s && (n.paddedRect.w === s.paddedRect.w && n.paddedRect.h === s.paddedRect.h || t1.w(`Mismatch in icon variant sizes: ${e1.toString()} and ${o.toString()}`), n.usvg !== s.usvg && t1.w(`Mismatch in icon variant image types: ${e1.id} and ${o.id}`));
        }
        function se(e1, t1, o, i, n, s, r, a, l, c) {
            e1.iconAtlasPositions = c.iconPositions;
            const { featureData: u, sizes: h, textAlongLine: d, symbolPlacement: f, coveragePolygons: g, coverageTileZoom: p, symbolAnchorInFrcCoverage: m } = t1, y = t1.hasAnySecondaryIcon || e1.hasAnySecondaryIcon;
            for (const t1 of u){
                const { shapedIcon: o, verticallyShapedIcon: s, feature: u, shapedTextOrientations: x, shapedText: v, layoutTextSize: w, textOffset: b, isSDFIcon: S, iconPrimary: I, iconSecondary: P, iconTextFit: M, iconOffset: T, iconCollisionBounds: z, iconVerticalCollisionBounds: B, textCollisionBounds: k, elevationFeatureIndex: C } = t1;
                re(o, c.iconPositions, I, P), re(s, c.iconPositions, I, P), ae(x, c.iconPositions), ne(I, P, c.iconPositions), (v || o) && ue(e1, u, x, o, s, l, h, w, 0, b, S, i, n, r, a, y, M, T, d, f, z, B, k, 0, 0, g, p, m, C);
            }
            o && e1.generateCollisionDebugBuffers(s, e1.collisionBoxArray, h.textScaleFactor), e1.text.uboBinder && e1.text.uboBinder.finalize(), e1.icon.uboBinder && e1.icon.uboBinder.finalize();
        }
        function re(e1, t1, o, i) {
            if (!e1) return;
            const n = t1.get(o.toString());
            if (n && (e1.imagePrimary = n), i) {
                const o = t1.get(i.toString());
                e1.imageSecondary = o;
            }
        }
        function ae(e1, t1) {
            for(const o in e1.horizontal)le(e1.horizontal[o], t1);
            le(e1.vertical, t1);
        }
        function le(e1, t1) {
            if (e1) {
                for (const o of e1.positionedLines)for (const e1 of o.positionedGlyphs)if (null !== e1.image) {
                    const o = e1.image.toString();
                    e1.rect = t1.get(o).paddedRect;
                }
            }
        }
        function ce(e1, o, i, n, s, r, a, l, c) {
            const u = de(r.horizontal) || r.vertical, h = i.get("icon-text-fit-padding").evaluate(n, {}, s);
            let d, f = o;
            return o && "none" !== c && (e1.allowVerticalPlacement && r.vertical && (d = t1.fU(o, r.vertical, c, h, l, a)), u && (f = t1.fU(o, u, c, h, l, a))), {
                defaultShapedIcon: f,
                verticallyShapedIcon: d
            };
        }
        function ue(e1, o, i, n, s, r, a, l, c, u, h, d, f, g, p, m, y, x, v, w, b, S, P, M, T, z, C, L, D = 65535) {
            let F = a.textMaxSize.evaluate(o, {}, f);
            void 0 === F ? F = l * a.textScaleFactor : F *= a.textScaleFactor;
            const A = e1.layers[0].layout, _ = t1.d1, E = t1.fT(l, a.textScaleFactor), O = de(i.horizontal) || i.vertical, R = e1.hasAnyAppearanceLayoutProperty([
                "text-size",
                "text-offset",
                "text-rotate"
            ]), j = e1.getAppearanceFeatureData(o.index);
            ("none" !== y || R) && j && (j.textShaping = O, j.iconTextFitPadding = A.get("icon-text-fit-padding").evaluate(o, {}, f), j.fontScale = E, j.textScaleFactor = a.textScaleFactor);
            const V = "globe" === g.name, G = e1.tilePixelRatio * F / _, N = (H = e1.overscaling, e1.zoom > 18 && H > 2 && (H >>= 1), Math.max(t1.a2 / (512 * H), 1) * A.get("symbol-spacing")), U = A.get("text-padding") * e1.tilePixelRatio, X = A.get("icon-padding") * e1.tilePixelRatio, $ = t1.au(A.get("text-max-angle")), q = "map" === A.get("icon-rotation-alignment") && "point" !== w, J = N / 2;
            var H;
            !1 === e1.hasAnyIconTextFit && "none" !== y && (e1.hasAnyIconTextFit = !0);
            const Q = (l, c, w)=>{
                if (c.x < 0 || c.x >= t1.a2 || c.y < 0 || c.y >= t1.a2) return;
                if (z && z.length > 0 && o.properties && L && L(z, o.properties, c, f, C)) return;
                let M = null;
                if (V) {
                    const { x: e1, y: t1, z: o } = g.projectTilePoint(c.x, c.y, w);
                    M = {
                        anchor: new I(e1, t1, o, 0, void 0),
                        up: g.upVector(w, c.x, c.y)
                    };
                }
                !function(e1, o, i, n, s, r, a, l, c, u, h, d, f, g, p, m, y, x, v, w, b, S, I, P, M, T, z, B, k, C, L, D) {
                    const F = e1.addToLineVertexArray(o, n);
                    let A, _, E, O, R, j, V, G = 0, Z = 0, N = 0, U = 0, X = -1, $ = -1;
                    const q = {};
                    let J = t1.dc("");
                    const H = i ? i.anchor : o, Q = "none" !== B;
                    let K = 0, ee = 0;
                    if (void 0 === c._unevaluatedLayout.getValue("text-radial-offset")) {
                        const e1 = c.layout.get("text-offset").evaluate(b, {}, M);
                        K = e1[0] * t1.d1, ee = e1[1] * t1.d1;
                    } else K = c.layout.get("text-radial-offset").evaluate(b, {}, M) * t1.d1, ee = W;
                    if (e1.allowVerticalPlacement && s.vertical) {
                        const e1 = s.vertical;
                        if (p) j = ge(e1), l && (V = ge(l));
                        else {
                            const t1 = c.layout.get("text-rotate").evaluate(b, {}, M) + 90;
                            E = fe(u, H, o, h, d, f, e1, g, t1, m, D), l && (O = fe(u, H, o, h, d, f, l, x, t1, null, L));
                        }
                    }
                    if (r) {
                        const n = c.layout.get("icon-rotate").evaluate(b, {}, M), s = t1.f$(r, n, I, Q, S.iconScaleFactor), a = l ? t1.f$(l, n, I, Q, S.iconScaleFactor) : void 0;
                        _ = fe(u, H, o, h, d, f, r, x, n, null, C);
                        const g = function(e1, o, i, n, s, r, a, l, c) {
                            const u = e1.layers[0], h = u.appearances;
                            let d = o.length;
                            if (i && (d = Math.max(d, i.length)), 0 === h.length) return d;
                            const [f, g] = n.get("icon-size-scale-range"), p = t1.b0(1, f, g);
                            for (const o of h)if (o.hasLayoutProperty("icon-image")) {
                                const i = te(e1, u, o, s, r, a, p, c);
                                i && (d = Math.max(d, t1.g1(i)));
                            }
                            return d;
                        }(e1, s, a, c.layout, b, M, e1.iconAtlasPositions, 0, P);
                        G = 4 * g;
                        const p = c.layout.get("icon-size").evaluate(b, {}, M, P), m = S.compositeIconSizes ? S.compositeIconSizes[0].evaluate(b, {}, M, P) : 0, y = S.compositeIconSizes ? S.compositeIconSizes[1].evaluate(b, {}, M, P) : 0, B = t1.g0(e1.layerIds[0], e1.iconSizeData, p, r.imagePrimary.usvg ? 1 : S.iconScaleFactor, m, y);
                        e1.addSymbols(e1.icon, s, B, w, v, b, void 0, i, o, F.lineStartIndex, F.lineLength, -1, P, M, T, z, e1.symbolInstances.length, g), X = e1.icon.placedSymbolArray.length - 1, a && (Z = 4 * g, e1.addSymbols(e1.icon, a, B, w, v, b, t1.cL.vertical, i, o, F.lineStartIndex, F.lineLength, -1, P, M, T, z, e1.symbolInstances.length, g), $ = e1.icon.placedSymbolArray.length - 1);
                    }
                    for(const n in s.horizontal){
                        const r = n, l = s.horizontal[r];
                        A || (J = t1.dc(l.text), p ? R = ge(l) : A = fe(u, H, o, h, d, f, l, g, c.layout.get("text-rotate").evaluate(b, {}, M), m, D));
                        const y = 1 === l.positionedLines.length;
                        if (N += he(e1, i, o, l, a, c, p, b, m, F, s.vertical ? t1.cL.horizontal : t1.cL.horizontalOnly, y ? Y(s.horizontal) : [
                            r
                        ], q, X, S, P, M, e1.symbolInstances.length, T), y) break;
                    }
                    s.vertical && (U += he(e1, i, o, s.vertical, a, c, p, b, m, F, t1.cL.vertical, [
                        "vertical"
                    ], q, $, S, P, M, e1.symbolInstances.length, T));
                    let oe = -1;
                    const ie = (e1, t1)=>e1 ? Math.max(e1, t1) : t1;
                    oe = ie(R, oe), oe = ie(j, oe), oe = ie(V, oe);
                    const ne = oe > -1 ? 1 : 0;
                    e1.glyphOffsetArray.length >= 65535 && t1.w("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b.sortKey && e1.addToSortKeyRanges(e1.symbolInstances.length, b.sortKey), e1.symbolInstances.emplaceBack(o.x, o.y, H.x, H.y, H.z, q.right >= 0 ? q.right : -1, q.center >= 0 ? q.center : -1, q.left >= 0 ? q.left : -1, q.vertical >= 0 ? q.vertical : -1, X, $, J, void 0 !== A ? A : e1.collisionBoxArray.length, void 0 !== A ? A + 1 : e1.collisionBoxArray.length, void 0 !== E ? E : e1.collisionBoxArray.length, void 0 !== E ? E + 1 : e1.collisionBoxArray.length, void 0 !== _ ? _ : e1.collisionBoxArray.length, void 0 !== _ ? _ + 1 : e1.collisionBoxArray.length, O || e1.collisionBoxArray.length, O ? O + 1 : e1.collisionBoxArray.length, h, N, U, G, Z, ne, 0, K, ee, oe, 0, Q ? 1 : 0, k);
                }(e1, c, M, l, i, n, r, s, e1.layers[0], e1.collisionBoxArray, o.index, o.sourceLayerIndex, e1.index, U, v, u, 0, X, q, x, o, a, h, d, f, p, m, y, D, b, S, P);
            };
            if ("line" === w) for (const s of t1.cZ(o.geometry, 0, 0, t1.a2, t1.a2)){
                const o = k(s, N, $, i.vertical || O, n, _, G, e1.overscaling, t1.a2);
                for (const t1 of o)O && pe(e1, O.text, J, t1) || Q(s, t1, f);
            }
            else if ("line-center" === w) {
                for (const e1 of o.geometry)if (e1.length > 1) {
                    const t1 = B(e1, $, i.vertical || O, n, _, G);
                    t1 && Q(e1, t1, f);
                }
            } else if ("Polygon" === o.type) for (const e1 of t1.fZ(o.geometry, 0)){
                const t1 = Z(e1, 16);
                Q(e1[0], new I(t1.x, t1.y, 0, 0, void 0), f);
            }
            else if ("LineString" === o.type) for (const e1 of o.geometry)Q(e1, new I(e1[0].x, e1[0].y, 0, 0, void 0), f);
            else if ("Point" === o.type) for (const e1 of o.geometry)for (const t1 of e1)Q([
                t1
            ], new I(t1.x, t1.y, 0, 0, void 0), f);
        }
        function he(e1, o, i, n, s, r, a, l, c, u, h, d, f, g, p, m, y, x, v) {
            const w = t1.g2(i, n, c, r, a, l, s, e1.allowVerticalPlacement, void 0, p.textScaleFactor), b = r.layout.get("text-size").evaluate(l, {}, y), S = p.compositeTextSizes ? p.compositeTextSizes[0].evaluate(l, {}, y) : 0, I = p.compositeTextSizes ? p.compositeTextSizes[1].evaluate(l, {}, y) : 0, P = t1.g0(e1.layerIds[0], e1.textSizeData, b, p.textScaleFactor, S, I);
            e1.addSymbols(e1.text, w, P, c, a, l, h, o, i, u.lineStartIndex, u.lineLength, g, m, y, v, !1, x, w.length);
            for (const t1 of d)f[t1] = e1.text.placedSymbolArray.length - 1;
            return 4 * w.length;
        }
        function de(e1) {
            for(const t1 in e1)return e1[t1];
            return null;
        }
        function fe(e1, o, i, n, s, r, a, l, c, u, h) {
            let d, f, g, p;
            if (d = h ? h.top : a.top, f = h ? h.bottom : a.bottom, g = h ? h.left : a.left, p = h ? h.right : a.right, X(a) && a.collisionPadding) {
                const e1 = a.collisionPadding;
                g -= e1[0], d -= e1[1], p += e1[2], f += e1[3];
            }
            if (c) {
                const e1 = new t1.P(g, d), o = new t1.P(p, d), i = new t1.P(g, f), n = new t1.P(p, f), s = t1.au(c);
                let r = new t1.P(0, 0);
                u && (r = new t1.P(u[0], u[1])), e1._rotateAround(s, r), o._rotateAround(s, r), i._rotateAround(s, r), n._rotateAround(s, r), g = Math.min(e1.x, o.x, i.x, n.x), p = Math.max(e1.x, o.x, i.x, n.x), d = Math.min(e1.y, o.y, i.y, n.y), f = Math.max(e1.y, o.y, i.y, n.y);
            }
            return e1.emplaceBack(o.x, o.y, o.z, i.x, i.y, g, d, p, f, l, n, s, r), e1.length - 1;
        }
        function ge(e1) {
            X(e1) && e1.collisionPadding && (e1.top -= e1.collisionPadding[1], e1.bottom += e1.collisionPadding[3]);
            const t1 = e1.bottom - e1.top;
            return t1 > 0 ? Math.max(10, t1) : null;
        }
        function pe(e1, t1, o, i) {
            const n = e1.compareText;
            if (t1 in n) {
                const e1 = n[t1];
                for(let t1 = e1.length - 1; t1 >= 0; t1--)if (i.dist(e1[t1]) < o) return !0;
            } else n[t1] = [];
            return n[t1].push(i), !1;
        }
        const me = 1 * t1.g4;
        class ye {
            constructor(e1){
                const o = {}, i = [];
                for(const t1 in e1){
                    const n = e1[t1], s = o[t1] = {};
                    for(const e1 in n.glyphs){
                        const t1 = n.glyphs[+e1];
                        if (!t1 || 0 === t1.bitmap.width || 0 === t1.bitmap.height) continue;
                        const o = t1.metrics.localGlyph ? me : 1, r = {
                            x: 0,
                            y: 0,
                            w: t1.bitmap.width + 2 * o,
                            h: t1.bitmap.height + 2 * o
                        };
                        i.push(r), s[e1] = r;
                    }
                }
                const { w: n, h: s } = t1.p(i), r = new t1.g3({
                    width: n || 1,
                    height: s || 1
                });
                for(const i in e1){
                    const n = e1[i];
                    for(const e1 in n.glyphs){
                        const s = n.glyphs[+e1];
                        if (!s || 0 === s.bitmap.width || 0 === s.bitmap.height) continue;
                        const a = o[i][e1], l = s.metrics.localGlyph ? me : 1;
                        t1.g3.copy(s.bitmap, r, {
                            x: 0,
                            y: 0
                        }, {
                            x: a.x + l,
                            y: a.y + l
                        }, s.bitmap);
                    }
                }
                this.image = r, this.positions = o;
            }
        }
        function xe(e1) {
            for (const t1 of e1){
                if (null != t1.hdExt) return !0;
                if (t1.requiresHDRuntime) return !0;
            }
            return !1;
        }
        function ve(e1) {
            for (const t1 of e1)if (t1.requiresStandardRuntime) return !0;
            return !1;
        }
        function we(e1, o, i) {
            const n = null != e1 && !!t1.g7 && t1.g7(e1.sourceLayers, o, i);
            return {
                applies: n,
                frcMask: n && e1 ? e1.frcMask : null,
                polygons: n && e1 ? e1.polygons : null,
                tileZoom: n && e1 ? e1.tileZoom : null
            };
        }
        t1.fE(ye, "GlyphAtlas");
        class be {
            constructor(e1){
                this.tileID = new t1.bP(e1.tileID.overscaledZ, e1.tileID.wrap, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y), this.tileZoom = e1.tileZoom, this.uid = e1.uid, this.zoom = e1.zoom, this.lut = e1.lut, this.canonical = e1.tileID.canonical, this.pixelRatio = e1.pixelRatio, this.tileSize = e1.tileSize, this.source = e1.source, this.scope = e1.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = e1.showCollisionBoxes, this.showElevationIdDebug = e1.showElevationIdDebug, this.collectResourceTiming = !!e1.request && e1.request.collectResourceTiming, this.promoteId = e1.promoteId, this.renderSourceType = e1.renderSourceType, this.frcCoverage = e1.frcCoverage || null, this.elevation = e1.elevation || null, this.crossSourceElevationEnabled = !!e1.crossSourceElevationEnabled, this.terrainEnabled = !!e1.terrainEnabled, this.deferRoadStructure = !1, this.tileTransform = t1.bp(e1.tileID.canonical, e1.projection), this.projection = e1.projection, this.worldview = e1.worldview, this.localizableLayerIds = e1.localizableLayerIds, this.brightness = e1.brightness, this.extraShadowCaster = !!e1.extraShadowCaster, this.tessellationStep = e1.tessellationStep, this.scaleFactor = e1.scaleFactor, this.worldview = e1.worldview, this.indoor = e1.indoor;
            }
            isLayerActiveForTile(e1) {
                return !(this.renderSourceType === t1.bR.Symbol && "symbol" !== e1.type || this.renderSourceType === t1.bR.FillExtrusion && "fill-extrusion" !== e1.type || this.renderSourceType === t1.bR.Other && ("symbol" === e1.type || "fill-extrusion" === e1.type) || this.renderSourceType === t1.bR.HdRoadElevation || e1.minzoom && this.zoom < Math.floor(e1.minzoom) || e1.maxzoom && this.zoom >= e1.maxzoom || "none" === e1.visibility);
            }
            parse(e1, t1, o, i, n, s) {
                this._parseAfterHD(e1, t1, o, i, n, s);
            }
            _parseAfterHD(e1, o, l, c, u, h) {
                let d;
                if (this.status = "parsing", this.data = e1, this.renderSourceType === t1.bR.HdRoadCoverage) {
                    const o = e1.layers[t1.bU];
                    d = o && s ? s(o) : [];
                }
                this.collisionBoxArray = new t1.bt;
                const f = new t1.g5(Object.keys(e1.layers).sort()), g = new t1.fz(this.tileID, this.promoteId);
                g.bucketLayerIDs = [];
                const y = {}, x = new t1.g6(256, 256), v = {
                    featureIndex: g,
                    iconDependencies: new Map,
                    patternDependencies: new Map,
                    glyphDependencies: {},
                    lineAtlas: x,
                    availableImages: l,
                    brightness: this.brightness,
                    scaleFactor: this.scaleFactor,
                    showElevationIdDebug: this.showElevationIdDebug,
                    elevationFeatures: void 0,
                    elevationParams: this.elevation,
                    crossSourceElevationEnabled: this.crossSourceElevationEnabled,
                    terrainEnabled: this.terrainEnabled,
                    activeFloors: void 0
                };
                this.indoor && a && (v.activeFloors = a(e1, this.indoor, u, this.canonical));
                const w = [], b = o.familiesBySource[this.source];
                if (this.renderSourceType === t1.bR.HdRoadElevation) {
                    const t1 = i && i(e1, this.canonical) || [], o = new ye({});
                    return this.status = "done", void h(null, {
                        buckets: [],
                        containsHdExt: !1,
                        containsStandardExt: !1,
                        featureIndex: g,
                        collisionBoxArray: this.collisionBoxArray,
                        glyphAtlasImage: o.image,
                        lineAtlas: x,
                        imageAtlas: null,
                        brightness: this.brightness,
                        parsedElevationFeatures: t1
                    });
                }
                if (this.deferRoadStructure = !1, this.renderSourceType !== t1.bR.HdRoadCoverage && null != this.frcCoverage && !this.frcCoverage.resolved && null === this.frcCoverage.frcMask) {
                    for(const e1 in b)if (t1.g7 && t1.g7(this.frcCoverage.sourceLayers, this.source, e1)) {
                        this.deferRoadStructure = !0;
                        break;
                    }
                }
                for(const o in b){
                    const n = e1.layers[o];
                    if (!n) continue;
                    let s = !1, r = !1, a = !1, u = !1;
                    for (const e1 of b[o])"symbol" === e1[0].type ? s = !0 : "fill-extrusion" === e1[0].type ? r = !0 : a = !0, e1[0].is3D() && "model" !== e1[0].type && (u = !0);
                    if (this.extraShadowCaster && !u) continue;
                    if (this.renderSourceType === t1.bR.Symbol && !s) continue;
                    if (this.renderSourceType === t1.bR.FillExtrusion && !r) continue;
                    if ((this.renderSourceType === t1.bR.Other || this.renderSourceType === t1.bR.HdRoadCoverage) && !a) continue;
                    const h = null != this.frcCoverage && !!t1.g7 && t1.g7(this.frcCoverage.sourceLayers, this.source, o);
                    if (this.deferRoadStructure && h) continue;
                    1 === n.version && t1.w(`Vector tile source "${this.source}" layer "${o}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const d = f.encode(o), m = [], x = this.localizableLayerIds && this.localizableLayerIds.has(o);
                    let S = !1;
                    for(let e1 = 0, i = 0; e1 < n.length; e1++){
                        const s = n.feature(e1), r = g.getId(s, o), a = s.properties ? s.properties.worldview : null;
                        if (x && this.worldview && "string" == typeof a) {
                            if ("all" === a) s.properties.$localized = !0;
                            else {
                                if (!a.split(",").includes(this.worldview)) continue;
                                s.properties.$localized = !0, s.properties.worldview = this.worldview;
                            }
                        }
                        !S && s.properties && Object.hasOwn(s.properties, t1.fO) && (S = !0), h && this.frcCoverage && this.frcCoverage.frcMask && s.properties && t1.g8 && t1.g8(s.properties, this.frcCoverage.frcMask) || (m.push({
                            feature: s,
                            id: r,
                            index: i,
                            sourceLayerIndex: d
                        }), i++);
                    }
                    S && !v.elevationFeatures && i && (v.elevationFeatures = i(e1, this.canonical));
                    for (const e1 of b[o]){
                        const i = e1[0];
                        if (this.extraShadowCaster && (!i.is3D() || "model" === i.type)) continue;
                        if (this.renderSourceType === t1.bR.Symbol && "symbol" !== i.type) continue;
                        if (this.renderSourceType === t1.bR.FillExtrusion && "fill-extrusion" !== i.type) continue;
                        if (!(this.renderSourceType !== t1.bR.Other && this.renderSourceType !== t1.bR.HdRoadCoverage || "symbol" !== i.type && "fill-extrusion" !== i.type)) continue;
                        if (!this.isLayerActiveForTile(i)) continue;
                        const n = g.bucketLayerIDs.length;
                        g.bucketLayerIDs.push(e1.map((e1)=>t1.m(e1.id, e1.scope)));
                        const s = ()=>{
                            Se(e1, this.zoom, v.brightness, l, this.worldview, v.activeFloors);
                            const t1 = y[i.id] = i.createBucket({
                                index: n,
                                layers: e1,
                                zoom: this.zoom,
                                lut: this.lut,
                                canonical: this.canonical,
                                pixelRatio: this.pixelRatio,
                                overscaling: this.overscaling,
                                collisionBoxArray: this.collisionBoxArray,
                                sourceLayerIndex: d,
                                sourceLayerName: o,
                                sourceID: this.source,
                                projection: this.projection.spec,
                                tessellationStep: this.tessellationStep,
                                styleDefinedModelURLs: c,
                                worldview: this.worldview,
                                localizable: x,
                                availableImages: l,
                                maxUniformBufferBindings: this.maxUniformBufferBindings,
                                maxUniformBlockSizeDwords: this.maxUniformBlockSizeDwords
                            });
                            p && p(t1, this.frcCoverage ? this.frcCoverage.sourceLayers : null), t1.populate(m, v, this.tileID.canonical, this.tileTransform);
                        };
                        i.mayUse("HD") || i.mayUse("Standard") ? w.push(i.prepare().then(()=>s())) : s();
                    }
                }
                const S = ()=>{
                    x.trim();
                    const o = !(!v.elevationFeatures || !v.elevationFeatures.some((e1)=>e1.heightRange.min < 0));
                    let i, s, a, c, p, w, b;
                    const S = {
                        type: "maybePrepare",
                        renderSourceType: this.renderSourceType,
                        zoom: this.zoom
                    }, I = ()=>{
                        if (i) return this.status = "done", h(i);
                        if (this.extraShadowCaster) {
                            this.status = "done";
                            const e1 = Object.values(y).filter((e1)=>!e1.isEmpty()), t1 = v.elevationFeatures;
                            h(null, {
                                buckets: e1,
                                containsHdExt: xe(e1),
                                containsStandardExt: ve(e1),
                                featureIndex: g,
                                collisionBoxArray: null,
                                hasTunnelGeometry: o,
                                glyphAtlasImage: null,
                                lineAtlas: null,
                                imageAtlas: null,
                                brightness: v.brightness,
                                hasDeferredElevationFeatures: !!m && m(y),
                                parsedElevationFeatures: t1,
                                glyphMap: null,
                                iconMap: null,
                                glyphPositions: null
                            });
                        } else if (s && a && c && b) {
                            const e1 = void 0, o = new ye(s), i = new Map;
                            for (const [e1, o] of a.entries()){
                                const { imagePosition: n } = t1.fV(e1, o, t1.fW);
                                i.set(e1, n);
                            }
                            const n = {};
                            for(const e1 in y){
                                const c = y[e1];
                                if (c instanceof t1.bu) {
                                    Se(c.layers, this.zoom, v.brightness, l, this.worldview, v.activeFloors);
                                    const u = we(this.frcCoverage, this.source, c.layers[0].sourceLayer);
                                    n[e1] = Q(c, s, o.positions, a, i, this.tileID.canonical, this.tileZoom, this.scaleFactor, this.pixelRatio, p, this.worldview, l, u.frcMask, u.polygons, u.tileZoom, t1.g8 || null, r || null);
                                }
                            }
                            p.size || w.size ? this.rasterizeTask = u.sendCancelable("rasterizeImages", {
                                scope: this.scope,
                                iconTasks: p,
                                patternTasks: w
                            }, {}, (t1, i)=>{
                                if (!t1) for (const [e1, t1] of i.entries())a.has(e1) && a.set(e1, Object.assign(a.get(e1), {
                                    data: t1
                                })), c.has(e1) && c.set(e1, Object.assign(c.get(e1), {
                                    data: t1
                                }));
                                P(n, o, e1, b);
                            }) : P(n, o, e1, b);
                        }
                    }, P = (e1, i, n, s)=>{
                        const r = a.size > 0 || c.size > 0, f = Object.keys(e1).length > 0, p = v.elevationFeatures;
                        if (!r && !f) {
                            this.status = "done";
                            const e1 = Object.values(y).filter((e1)=>!e1.isEmpty());
                            return void h(null, {
                                buckets: e1,
                                containsHdExt: xe(e1),
                                containsStandardExt: ve(e1),
                                featureIndex: g,
                                collisionBoxArray: this.collisionBoxArray,
                                hasTunnelGeometry: o,
                                glyphAtlasImage: i.image,
                                lineAtlas: x,
                                imageAtlas: null,
                                brightness: v.brightness,
                                hasDeferredRoadStructure: this.deferRoadStructure,
                                frcCoveragePolygons: d,
                                hasDeferredElevationFeatures: !!m && m(y),
                                parsedElevationFeatures: p
                            });
                        }
                        const w = (n, s)=>{
                            for(const o in y){
                                const i = y[o];
                                if (o in e1) se(i, e1[o], this.showCollisionBoxes, l, this.tileID.canonical, this.tileZoom, this.projection, this.brightness, a, s);
                                else if (i.hasPattern && (i instanceof t1.bz || i instanceof t1.bA || i instanceof t1.aC)) {
                                    Se(i.layers, this.zoom, v.brightness, l, this.worldview, v.activeFloors);
                                    const e1 = Object.fromEntries(s.patternPositions);
                                    i.addFeatures(v, this.tileID.canonical, e1, l, this.tileTransform, this.brightness);
                                }
                            }
                            this.status = "done";
                            const r = Object.values(y).filter((e1)=>!e1.isEmpty());
                            h(null, {
                                buckets: r,
                                containsHdExt: xe(r),
                                containsStandardExt: ve(r),
                                featureIndex: g,
                                collisionBoxArray: this.collisionBoxArray,
                                hasTunnelGeometry: o,
                                glyphAtlasImage: i.image,
                                lineAtlas: x,
                                imageAtlas: n,
                                brightness: v.brightness,
                                hasDeferredRoadStructure: this.deferRoadStructure,
                                frcCoveragePolygons: d,
                                hasDeferredElevationFeatures: !!m && m(y),
                                parsedElevationFeatures: p
                            });
                        };
                        if (r) {
                            const e1 = new Map, o = t1.ga(a, e1), i = t1.ga(c, e1), n = new t1.gb(o, i, s, this.lut, this.scope, e1);
                            u.send("checkAtlasCache", {
                                descriptor: n,
                                scope: this.scope
                            }).then((e1)=>{
                                let o, i;
                                if (e1) o = new t1.gc(e1.sourceHash), i = e1;
                                else {
                                    const e1 = new t1.gd(a, c, this.lut, s, this.scope);
                                    o = e1, i = e1;
                                }
                                w(o, i);
                            }).catch((e1)=>{
                                "AbortError" !== e1.name && t1.w(`[Worker] Error checking atlas cache: ${e1.message}`);
                                const o = new t1.gd(a, c, this.lut, s, this.scope);
                                w(o, o);
                            });
                        } else w(null, {
                            iconPositions: new Map,
                            patternPositions: new Map
                        });
                    };
                    if (!this.extraShadowCaster) {
                        const e1 = t1.g9(v.glyphDependencies, (e1)=>Object.keys(e1).map(Number));
                        Object.keys(e1).length ? u.send("getGlyphs", {
                            uid: this.uid,
                            stacks: e1
                        }, {
                            metadata: S
                        }).then((e1)=>{
                            i || (s = e1, I());
                        }).catch((e1)=>{
                            i || (i = e1, I());
                        }) : s = {}, b = new Map;
                        const o = Array.from(v.iconDependencies.keys()).map((e1)=>t1.I.parse(e1)), n = Array.from(v.patternDependencies.keys()).map((e1)=>t1.I.parse(e1));
                        o.length || n.length ? u.send("getImages", {
                            icons: o,
                            patterns: n,
                            source: this.source,
                            scope: this.scope,
                            tileID: this.tileID
                        }, {
                            metadata: S
                        }).then((e1)=>{
                            if (!i) {
                                a = new Map, c = new Map, p = this.updateImageMapAndGetImageTaskQueue(a, e1.images, v.iconDependencies), w = this.updateImageMapAndGetImageTaskQueue(c, e1.images, v.patternDependencies);
                                for (const [t1, o] of e1.versions.entries())b.set(t1, o);
                                I();
                            }
                        }).catch((e1)=>{
                            i || (i = e1, I());
                        }) : (a = new Map, c = new Map, p = new Map, w = new Map);
                    }
                    n && n({
                        buckets: y,
                        data: e1,
                        sourceLayerCoder: f,
                        canonical: this.tileID.canonical,
                        options: v
                    }), I();
                };
                w.length > 0 ? Promise.allSettled(w).then(S).catch(h) : S();
            }
            updateParameters(e1) {
                this.scaleFactor = e1.scaleFactor, this.showCollisionBoxes = e1.showCollisionBoxes, this.showElevationIdDebug = e1.showElevationIdDebug, this.projection = e1.projection, this.brightness = e1.brightness, this.tileTransform = t1.bp(e1.tileID.canonical, e1.projection), this.extraShadowCaster = e1.extraShadowCaster, this.lut = e1.lut, this.worldview = e1.worldview, this.indoor = e1.indoor, this.frcCoverage = e1.frcCoverage || null, this.elevation = e1.elevation || null, this.terrainEnabled = !!e1.terrainEnabled;
            }
            updateImageMapAndGetImageTaskQueue(e1, t1, o) {
                const i = new Map;
                for (const n of t1.keys()){
                    const s = o.get(n) || [];
                    for (const o of s){
                        const n = o.toString(), s = t1.get(o.id.toString());
                        s.usvg ? i.has(n) || (i.set(n, o), e1.set(n, {
                            ...s
                        })) : e1.set(n, s);
                    }
                }
                return i;
            }
            cancelRasterize() {
                this.rasterizeTask && this.rasterizeTask.abort();
            }
        }
        function Se(e1, o, i, n, s, r) {
            const a = new t1.ai(o, {
                brightness: i,
                worldview: s,
                activeFloors: r
            });
            for (const t1 of e1)t1.recalculate(a, n);
        }
        class Ie extends t1.E {
            constructor({ actor: e1, layerIndex: o, availableImages: i, availableModels: n, isSpriteLoaded: s, tileProvider: r, brightness: a, maxUniformBufferBindings: l, maxUniformBlockSizeDwords: c }){
                super(), this.actor = e1, this.layerIndex = o, this.availableImages = i, this.availableModels = n, this.loadVectorData = t1.ch, this.tileProvider = r, this.loading = {}, this.loaded = {}, this.deduped = new t1.cc(e1.scheduler), this.isSpriteLoaded = s, this.scheduler = e1.scheduler, this.brightness = a, this.maxUniformBufferBindings = l, this.maxUniformBlockSizeDwords = c;
            }
            loadTileData(e1, t1) {
                if (!this.tileProvider) return this.loadVectorData(e1, t1);
                const o = new AbortController;
                return this.loadTileWithProvider(this.tileProvider, e1, o, t1), ()=>o.abort();
            }
            async loadTileWithProvider(e1, t1, o, i) {
                const { z: n, x: s, y: r } = t1.tileID.canonical;
                try {
                    const a = await e1.loadTile({
                        z: n,
                        x: s,
                        y: r
                    }, {
                        request: t1.request,
                        signal: o.signal
                    });
                    if (o.signal.aborted) return;
                    if (null == a) {
                        const e1 = new Error("Tile not found");
                        return e1.status = 404, i(e1);
                    }
                    if (null == a.data) return i(null, null);
                    if (a.data instanceof ImageBitmap) return i(new Error("Vector tiles require ArrayBuffer data"));
                    const l = new Headers;
                    a.expires && l.set("expires", a.expires), a.cacheControl && l.set("cache-control", a.cacheControl), i(null, {
                        rawData: a.data,
                        headers: l
                    });
                } catch (e1) {
                    if (o.signal.aborted) return;
                    i(e1 instanceof Error ? e1 : new Error(String(e1)));
                }
            }
            _fetchTileData(e1, t1) {
                return new Promise((o, i)=>{
                    e1.abort = this.loadTileData(t1, (e1, t1)=>{
                        e1 ? i(e1) : o(t1);
                    });
                });
            }
            async _parse(e1, t1) {
                const o = !this.isSpriteLoaded;
                return o && await this.once("isSpriteLoaded"), new Promise((i, n)=>{
                    const s = ()=>e1.parse(e1.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, (e1, t1)=>{
                            e1 ? n(e1) : i(t1);
                        });
                    o && this.scheduler ? this.scheduler.add(s, {
                        type: "parseTile",
                        renderSourceType: t1.renderSourceType,
                        zoom: t1.tileZoom
                    }) : s();
                });
            }
            async loadTile(e1) {
                const i = e1.uid, n = e1 && e1.request, s = n && n.collectResourceTiming, r = this.loading[i] = new be(e1);
                r.maxUniformBufferBindings = this.maxUniformBufferBindings, r.maxUniformBlockSizeDwords = this.maxUniformBlockSizeDwords;
                const a = (e1, t1)=>{
                    const o = r.reloadCallback;
                    o && (delete r.reloadCallback, e1 || !t1 ? o(e1, null) : r.parse(r.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, o));
                };
                let l, c;
                try {
                    l = await this._fetchTileData(r, e1);
                } catch (e1) {
                    c = e1;
                }
                const u = !this.loading[i];
                if (delete this.loading[i], r.cancelRasterize(), c || u || !l) {
                    if (r.status = "done", u || (this.loaded[i] = r), c) throw c;
                    return null;
                }
                const h = l.rawData;
                let d;
                r.vectorTile = l.vectorTile || new t1.ge(new t1.cB(h)), this.loaded = this.loaded || {}, this.loaded[i] = r;
                try {
                    d = await this._parse(r, e1);
                } catch (e1) {
                    throw a(e1), e1;
                }
                if (!d) return a(null, null), null;
                const f = {};
                if (s) {
                    const e1 = o(n);
                    e1.length > 0 && (f.resourceTiming = JSON.parse(JSON.stringify(e1)));
                }
                const g = {
                    rawTileData: h.slice(0),
                    headers: l.headers,
                    ...d,
                    ...f
                };
                return a(null, d), g;
            }
            async reloadTile(e1) {
                const t1 = this.loaded, o = e1.uid;
                if (t1 && t1[o]) return new Promise((i, n)=>{
                    const s = t1[o];
                    s.updateParameters(e1);
                    const r = (e1, t1)=>{
                        const o = s.reloadCallback;
                        o && (delete s.reloadCallback, s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, o)), e1 ? n(e1) : i(t1);
                    };
                    "parsing" === s.status ? s.reloadCallback = r : "done" === s.status ? s.vectorTile ? s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, r) : r() : i(void 0);
                });
            }
            abortTile(e1) {
                const t1 = e1.uid, o = this.loading[t1];
                o && (o.abort && o.abort(), delete this.loading[t1]);
            }
            removeTile(e1) {
                const t1 = this.loaded, o = e1.uid;
                t1 && t1[o] && delete t1[o];
            }
        }
        class Pe {
            constructor(e1){
                this.tileProvider = e1.tileProvider, this.loading = {};
            }
            async loadTile(e1) {
                const o = e1.uid, i = new AbortController;
                if (this.loading[o] = {
                    cancel: ()=>i.abort()
                }, this.tileProvider) return this.loadTileWithProvider(this.tileProvider, o, e1, i);
                try {
                    const { data: n, headers: s } = await t1.cC(e1.request, i.signal);
                    if (!n) return null;
                    const r = await this.decodeTile(o, n, e1.encoding);
                    return r.headers = s, r;
                } catch (e1) {
                    if (i.signal.aborted) return null;
                    throw e1;
                } finally{
                    delete this.loading[o];
                }
            }
            async decodeTile(e1, o, i) {
                const n = o instanceof ImageBitmap ? o : await createImageBitmap(new Blob([
                    new Uint8Array(o)
                ], {
                    type: "image/png"
                })), s = 1 - (n.width - t1.gf(n.width)) / 2, r = s < 1, a = this.getImageData(n, s);
                return n.close(), {
                    dem: new t1.gg(e1, a, i, r),
                    borderReady: r
                };
            }
            async loadTileWithProvider(e1, t1, o, i) {
                const { z: n, x: s, y: r } = o.tileID.canonical;
                try {
                    const a = await e1.loadTile({
                        z: n,
                        x: s,
                        y: r
                    }, {
                        request: o.request,
                        signal: i.signal
                    });
                    if (i.signal.aborted) return null;
                    if (null == a) {
                        const e1 = new Error("Tile not found");
                        throw e1.status = 404, e1;
                    }
                    if (null == a.data) return null;
                    const l = await this.decodeTile(t1, a.data, o.encoding);
                    if (i.signal.aborted) return null;
                    const c = new Headers;
                    return a.expires && c.set("expires", a.expires), a.cacheControl && c.set("cache-control", a.cacheControl), l.headers = c, l;
                } catch (e1) {
                    if (i.signal.aborted) return null;
                    throw e1;
                } finally{
                    delete this.loading[t1];
                }
            }
            async reloadTile(e1) {}
            abortTile(e1) {
                const t1 = e1.uid, o = this.loading[t1];
                o && (o.cancel(), delete this.loading[t1]);
            }
            removeTile(e1) {}
            getImageData(e1, t1) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e1.width, e1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", {
                    willReadFrequently: !0
                })), this.offscreenCanvas.width = e1.width, this.offscreenCanvas.height = e1.height, this.offscreenCanvasContext.drawImage(e1, 0, 0, e1.width, e1.height);
                const o = this.offscreenCanvasContext.getImageData(-t1, -t1, e1.width + 2 * t1, e1.height + 2 * t1);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), o;
            }
        }
        const Me = t1.gh.prototype.toGeoJSON;
        class Te {
            constructor(e1){
                this._feature = e1, this.extent = t1.a2, this.type = e1.type, this.properties = e1.tags, "id" in e1 && !isNaN(e1.id) && (this.id = parseInt(e1.id, 10));
            }
            loadGeometry() {
                if (1 === this._feature.type) {
                    const e1 = [];
                    for (const o of this._feature.geometry)e1.push([
                        new t1.P(o[0], o[1])
                    ]);
                    return e1;
                }
                {
                    const e1 = [];
                    for (const o of this._feature.geometry){
                        const i = [];
                        for (const e1 of o)i.push(new t1.P(e1[0], e1[1]));
                        e1.push(i);
                    }
                    return e1;
                }
            }
            toGeoJSON(e1, t1, o) {
                return Me.call(this, e1, t1, o);
            }
        }
        class ze {
            constructor(e1, o){
                this.name = e1, this.extent = t1.a2, this.length = o.length, this._jsonFeatures = o;
            }
            feature(e1) {
                return new Te(this._jsonFeatures[e1]);
            }
        }
        class Be {
            constructor(e1){
                this.layers = {}, this.extent = t1.a2;
                for (const t1 of Object.keys(e1))this.layers[t1] = new ze(t1, e1[t1]);
            }
        }
        const ke = 64 / 4096;
        class Ce {
            constructor(){
                this.features = new Map;
            }
            clear() {
                this.features.clear();
            }
            load(e1 = [], t1) {
                for (const o of e1){
                    const e1 = o.id;
                    if (null == e1) continue;
                    let i = this.features.get(e1);
                    i && this.updateCache(i, t1), o.geometry ? (i = De(o), this.updateCache(i, t1), this.features.set(e1, i)) : this.features.delete(e1), this.updateCache(i, t1);
                }
            }
            updateCache(e1, t1) {
                for (const { canonical: o, uid: i } of Object.values(t1)){
                    const { z: n, x: s, y: r } = o;
                    Le(e1, Math.pow(2, n), s, r) && delete t1[i];
                }
            }
            getTile(e1, t1, o) {
                const i = Math.pow(2, e1), n = [];
                for (const e1 of this.features.values())Le(e1, i, t1, o) && n.push(Ee(e1, i, t1, o));
                return {
                    features: n
                };
            }
            getFeatures() {
                return [
                    ...this.features.values()
                ];
            }
        }
        function Le({ minX: e1, minY: t1, maxX: o, maxY: i }, n, s, r) {
            return e1 < (s + 1 + ke) / n && t1 < (r + 1 + ke) / n && o > (s - ke) / n && i > (r - ke) / n;
        }
        function De(e1) {
            const { id: t1, geometry: o, properties: i } = e1;
            if (!o) return;
            if ("GeometryCollection" === o.type) throw new Error("GeometryCollection not supported in dynamic mode.");
            const { type: n, coordinates: s } = o, r = {
                id: t1,
                type: 1,
                geometry: [],
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            }, a = r.geometry;
            if ("Point" === n) Fe(s, a, r);
            else if ("MultiPoint" === n) for (const e1 of s)Fe(e1, a, r);
            else if ("LineString" === n) r.type = 2, Ae(s, a, r);
            else if ("MultiLineString" === n) r.type = 2, _e(s, a, r);
            else if ("Polygon" === n) r.type = 3, _e(s, a, r, !0);
            else {
                if ("MultiPolygon" !== n) throw new Error("Input data is not a valid GeoJSON object.");
                r.type = 3;
                for (const e1 of s)_e(e1, a, r, !0);
            }
            return r;
        }
        function Fe([e1, o], i, n) {
            const s = t1.a7(e1);
            let r = t1.a8(o);
            r = r < 0 ? 0 : r > 1 ? 1 : r, i.push(s, r), n.minX = Math.min(n.minX, s), n.minY = Math.min(n.minY, r), n.maxX = Math.max(n.maxX, s), n.maxY = Math.max(n.maxY, r);
        }
        function Ae(e1, t1, o, i = !1, n = !1) {
            const s = [];
            for (const t1 of e1)Fe(t1, s, o);
            t1.push(s), i && function(e1, t1) {
                let o = 0;
                for(let t1 = 0, i = e1.length, n = i - 2; t1 < i; n = t1, t1 += 2)o += (e1[t1] - e1[n]) * (e1[t1 + 1] + e1[n + 1]);
                if (o > 0 === t1) for(let t1 = 0, o = e1.length; t1 < o / 2; t1 += 2){
                    const i = e1[t1], n = e1[t1 + 1];
                    e1[t1] = e1[o - 2 - t1], e1[t1 + 1] = e1[o - 1 - t1], e1[o - 2 - t1] = i, e1[o - 1 - t1] = n;
                }
            }(s, n);
        }
        function _e(e1, t1, o, i = !1) {
            for(let n = 0; n < e1.length; n++)Ae(e1[n], t1, o, i, 0 === n);
        }
        function Ee(e1, o, i, n) {
            const { id: s, type: r, geometry: a, tags: l } = e1, c = [];
            if (1 === r) !function(e1, o, i, n, s) {
                for(let r = 0; r < e1.length; r += 2){
                    const a = Math.round(t1.a2 * (e1[r + 0] * o - i)), l = Math.round(t1.a2 * (e1[r + 1] * o - n));
                    s.push([
                        a,
                        l
                    ]);
                }
            }(a, o, i, n, c);
            else if (2 === r) for (const e1 of a)Oe(e1, o, i, n, c);
            else if (3 === r) for (const e1 of a)Re(e1, o, i, n, c);
            return {
                id: s,
                type: r,
                geometry: c,
                tags: l
            };
        }
        function Oe(e1, o, i, n, s) {
            const r = -128, a = t1.a2 + 128;
            let l;
            for(let c = 0; c < e1.length - 2; c += 2){
                let u = Math.round(t1.a2 * (e1[c + 0] * o - i)), h = Math.round(t1.a2 * (e1[c + 1] * o - n)), d = Math.round(t1.a2 * (e1[c + 2] * o - i)), f = Math.round(t1.a2 * (e1[c + 3] * o - n));
                const g = d - u, p = f - h;
                u < r && d < r || (u < r ? (h += Math.round(p * ((r - u) / g)), u = r) : d < r && (f = h + Math.round(p * ((r - u) / g)), d = r), h < r && f < r || (h < r ? (u += Math.round(g * ((r - h) / p)), h = r) : f < r && (d = u + Math.round(g * ((r - h) / p)), f = r), u >= a && d >= a || (u >= a ? (h += Math.round(p * ((a - u) / g)), u = a) : d >= a && (f = h + Math.round(p * ((a - u) / g)), d = a), h >= a && f >= a || (h >= a ? (u += Math.round(g * ((a - h) / p)), h = a) : f >= a && (d = u + Math.round(g * ((a - h) / p)), f = a), l && u === l.at(-1)[0] && h === l.at(-1)[1] || (l = [
                    [
                        u,
                        h
                    ]
                ], s.push(l)), l.push([
                    d,
                    f
                ])))));
            }
        }
        function Re(e1, o, i, n, s) {
            const r = (i - ke) / o, a = (n - ke) / o, l = (i + 1 + ke) / o, c = (n + 1 + ke) / o;
            function u(e1, t1) {
                let o = 0;
                return e1 < r ? o |= 1 : e1 > l && (o |= 2), t1 < a ? o |= 4 : t1 > c && (o |= 8), o;
            }
            let h = [];
            for(let t1 = 1; t1 <= 8; t1 *= 2){
                let o = e1[e1.length - 2], i = e1.at(-1), n = !(u(o, i) & t1);
                for(let s = 0; s < e1.length; s += 2){
                    const d = e1[s], f = e1[s + 1], g = !(u(d, f) & t1);
                    g !== n && (8 & t1 ? h.push(o + (d - o) * (c - i) / (f - i), c) : 4 & t1 ? h.push(o + (d - o) * (a - i) / (f - i), a) : 2 & t1 ? h.push(l, i + (f - i) * (l - o) / (d - o)) : 1 & t1 && h.push(r, i + (f - i) * (r - o) / (d - o))), g && h.push(d, f), o = d, i = f, n = g;
                }
                if (!(e1 = h).length || 8 === t1) break;
                h = [];
            }
            const d = [];
            for(let e1 = 0; e1 < h.length; e1 += 2)d.push([
                Math.round(t1.a2 * (h[e1] * o - i)),
                Math.round(t1.a2 * (h[e1 + 1] * o - n))
            ]);
            d.length && s.push(d);
        }
        function je({ name: e1, features: o }, i) {
            i.writeStringField(1, e1), i.writeVarintField(5, t1.a2);
            const n = new Map, s = new Map, r = {
                keys: n,
                values: s,
                feature: null
            };
            for (const e1 of o)r.feature = e1, i.writeMessage(2, Ve, r);
            for (const e1 of n.keys())i.writeStringField(3, e1);
            for (const e1 of s.keys())i.writeMessage(4, Ye, e1);
        }
        function Ve(e1, t1) {
            const o = e1.feature;
            void 0 !== o.id && Number.isSafeInteger(+o.id) && t1.writeVarintField(1, +o.id), o.tags && t1.writeMessage(2, Ge, e1), t1.writeVarintField(3, o.type), t1.writeMessage(4, Ue, o);
        }
        function Ge({ keys: e1, values: t1, feature: o }, i) {
            for (const n of Object.keys(o.tags)){
                let s = o.tags[n];
                if (null === s) continue;
                let r = e1.get(n);
                void 0 === r && (r = e1.size, e1.set(n, r)), i.writeVarint(r);
                const a = typeof s;
                "string" !== a && "boolean" !== a && "number" !== a && (s = JSON.stringify(s));
                let l = t1.get(s);
                void 0 === l && (l = t1.size, t1.set(s, l)), i.writeVarint(l);
            }
        }
        function Ze(e1, t1) {
            return (t1 << 3) + (7 & e1);
        }
        function Ne(e1) {
            return e1 << 1 ^ e1 >> 31;
        }
        function Ue(e1, t1) {
            const { geometry: o, type: i } = e1;
            let n = 0, s = 0;
            if (1 === i) {
                t1.writeVarint(Ze(1, o.length));
                for (const e1 of o){
                    const o = e1[0] - n, i = e1[1] - s;
                    t1.writeVarint(Ne(o)), t1.writeVarint(Ne(i)), n += o, s += i;
                }
            } else for (const e1 of o){
                if (0 === e1.length) continue;
                t1.writeVarint(Ze(1, 1));
                const o = e1.length - (3 === i ? 1 : 0);
                for(let i = 0; i < o; i++){
                    1 === i && t1.writeVarint(Ze(2, o - 1));
                    const r = e1[i][0] - n, a = e1[i][1] - s;
                    t1.writeVarint(Ne(r)), t1.writeVarint(Ne(a)), n += r, s += a;
                }
                3 === i && t1.writeVarint(Ze(7, 1));
            }
        }
        function Ye(e1, t1) {
            const o = typeof e1;
            "string" === o ? t1.writeStringField(1, e1) : "boolean" === o ? t1.writeBooleanField(7, e1) : "number" === o && (e1 % 1 != 0 ? t1.writeDoubleField(3, e1) : e1 < 0 ? t1.writeSVarintField(6, e1) : t1.writeVarintField(5, e1));
        }
        const Xe = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e1)=>e1
        }, $e = Math.fround || (qe = new Float32Array(1), (e1)=>(qe[0] = +e1, qe[0]));
        var qe;
        class Je {
            constructor(e1){
                this.options = Object.assign(Object.create(Xe), e1), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e1) {
                const { log: t1, minZoom: o, maxZoom: i } = this.options;
                t1 && console.time("total time");
                const n = `prepare ${e1.length} points`;
                t1 && console.time(n), this.points = e1;
                const s = [];
                for(let t1 = 0; t1 < e1.length; t1++){
                    const o = e1[t1];
                    if (!o.geometry) continue;
                    const [i, n] = o.geometry.coordinates, r = $e(Qe(i)), a = $e(Ke(n));
                    s.push(r, a, 1 / 0, t1, -1, 1), this.options.reduce && s.push(0);
                }
                let r = this.trees[i + 1] = this._createTree(s);
                t1 && console.timeEnd(n);
                for(let e1 = i; e1 >= o; e1--){
                    const o = +Date.now();
                    r = this.trees[e1] = this._createTree(this._cluster(r, e1)), t1 && console.log("z%d: %d clusters in %dms", e1, r.numItems, +Date.now() - o);
                }
                return t1 && console.timeEnd("total time"), this;
            }
            getClusters(e1, t1) {
                let o = ((e1[0] + 180) % 360 + 360) % 360 - 180;
                const i = Math.max(-90, Math.min(90, e1[1]));
                let n = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180;
                const s = Math.max(-90, Math.min(90, e1[3]));
                if (e1[2] - e1[0] >= 360) o = -180, n = 180;
                else if (o > n) {
                    const e1 = this.getClusters([
                        o,
                        i,
                        180,
                        s
                    ], t1), r = this.getClusters([
                        -180,
                        i,
                        n,
                        s
                    ], t1);
                    return e1.concat(r);
                }
                const r = this.trees[this._limitZoom(t1)], a = r.range(Qe(o), Ke(s), Qe(n), Ke(i)), l = r.data, c = [];
                for (const e1 of a){
                    const t1 = this.stride * e1;
                    c.push(l[t1 + 5] > 1 ? We(l, t1, this.clusterProps) : this.points[l[t1 + 3]]);
                }
                return c;
            }
            getChildren(e1) {
                const t1 = this._getOriginId(e1), o = this._getOriginZoom(e1), i = "No cluster with the specified id.", n = this.trees[o];
                if (!n) throw new Error(i);
                const s = n.data;
                if (t1 * this.stride >= s.length) throw new Error(i);
                const r = this.options.radius / (this.options.extent * Math.pow(2, o - 1)), a = n.within(s[t1 * this.stride], s[t1 * this.stride + 1], r), l = [];
                for (const t1 of a){
                    const o = t1 * this.stride;
                    s[o + 4] === e1 && l.push(s[o + 5] > 1 ? We(s, o, this.clusterProps) : this.points[s[o + 3]]);
                }
                if (0 === l.length) throw new Error(i);
                return l;
            }
            getLeaves(e1, t1, o) {
                const i = [];
                return this._appendLeaves(i, e1, t1 = t1 || 10, o = o || 0, 0), i;
            }
            getTile(e1, t1, o) {
                const i = this.trees[this._limitZoom(e1)], n = Math.pow(2, e1), { extent: s, radius: r } = this.options, a = r / s, l = (o - a) / n, c = (o + 1 + a) / n, u = {
                    features: []
                };
                return this._addTileFeatures(i.range((t1 - a) / n, l, (t1 + 1 + a) / n, c), i.data, t1, o, n, u), 0 === t1 && this._addTileFeatures(i.range(1 - a / n, l, 1, c), i.data, n, o, n, u), t1 === n - 1 && this._addTileFeatures(i.range(0, l, a / n, c), i.data, -1, o, n, u), u.features.length ? u : null;
            }
            getClusterExpansionZoom(e1) {
                let t1 = this._getOriginZoom(e1) - 1;
                for(; t1 <= this.options.maxZoom;){
                    const o = this.getChildren(e1);
                    if (t1++, 1 !== o.length) break;
                    e1 = o[0].properties.cluster_id;
                }
                return t1;
            }
            _appendLeaves(e1, t1, o, i, n) {
                const s = this.getChildren(t1);
                for (const t1 of s){
                    const s = t1.properties;
                    if (s && s.cluster ? n + s.point_count <= i ? n += s.point_count : n = this._appendLeaves(e1, s.cluster_id, o, i, n) : n < i ? n++ : e1.push(t1), e1.length === o) break;
                }
                return n;
            }
            _createTree(e1) {
                const o = new t1.d5(e1.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let t1 = 0; t1 < e1.length; t1 += this.stride)o.add(e1[t1], e1[t1 + 1]);
                return o.finish(), o.data = e1, o;
            }
            _addTileFeatures(e1, t1, o, i, n, s) {
                for (const r of e1){
                    const e1 = r * this.stride, a = t1[e1 + 5] > 1;
                    let l, c, u;
                    if (a) l = He(t1, e1, this.clusterProps), c = t1[e1], u = t1[e1 + 1];
                    else {
                        const o = this.points[t1[e1 + 3]];
                        l = o.properties;
                        const [i, n] = o.geometry.coordinates;
                        c = Qe(i), u = Ke(n);
                    }
                    const h = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * n - o)),
                                Math.round(this.options.extent * (u * n - i))
                            ]
                        ],
                        tags: l
                    };
                    let d;
                    d = a || this.options.generateId ? t1[e1 + 3] : this.points[t1[e1 + 3]].id, void 0 !== d && (h.id = d), s.features.push(h);
                }
            }
            _limitZoom(e1) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e1), this.options.maxZoom + 1));
            }
            _cluster(e1, t1) {
                const { radius: o, extent: i, reduce: n, minPoints: s } = this.options, r = o / (i * Math.pow(2, t1)), a = e1.data, l = [], c = this.stride;
                for(let o = 0; o < a.length; o += c){
                    if (a[o + 2] <= t1) continue;
                    a[o + 2] = t1;
                    const i = a[o], u = a[o + 1], h = e1.within(a[o], a[o + 1], r), d = a[o + 5];
                    let f = d;
                    for (const e1 of h){
                        const o = e1 * c;
                        a[o + 2] > t1 && (f += a[o + 5]);
                    }
                    if (f > d && f >= s) {
                        let e1, s = i * d, r = u * d, g = -1;
                        const p = (o / c << 5) + (t1 + 1) + this.points.length;
                        for (const i of h){
                            const l = i * c;
                            if (a[l + 2] <= t1) continue;
                            a[l + 2] = t1;
                            const u = a[l + 5];
                            s += a[l] * u, r += a[l + 1] * u, a[l + 4] = p, n && (e1 || (e1 = this._map(a, o, !0), g = this.clusterProps.length, this.clusterProps.push(e1)), n(e1, this._map(a, l)));
                        }
                        a[o + 4] = p, l.push(s / f, r / f, 1 / 0, p, -1, f), n && l.push(g);
                    } else {
                        for(let e1 = 0; e1 < c; e1++)l.push(a[o + e1]);
                        if (f > 1) for (const e1 of h){
                            const o = e1 * c;
                            if (!(a[o + 2] <= t1)) {
                                a[o + 2] = t1;
                                for(let e1 = 0; e1 < c; e1++)l.push(a[o + e1]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e1) {
                return e1 - this.points.length >> 5;
            }
            _getOriginZoom(e1) {
                return (e1 - this.points.length) % 32;
            }
            _map(e1, t1, o) {
                if (e1[t1 + 5] > 1) {
                    const i = this.clusterProps[e1[t1 + 6]];
                    return o ? Object.assign({}, i) : i;
                }
                const i = this.points[e1[t1 + 3]].properties, n = this.options.map(i);
                return o && n === i ? Object.assign({}, n) : n;
            }
        }
        function We(e1, t1, o) {
            var i;
            return {
                type: "Feature",
                id: e1[t1 + 3],
                properties: He(e1, t1, o),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (i = e1[t1], 360 * (i - .5)),
                        et(e1[t1 + 1])
                    ]
                }
            };
        }
        function He(e1, t1, o) {
            const i = e1[t1 + 5], n = i >= 1e4 ? `${Math.round(i / 1e3)}k` : i >= 1e3 ? Math.round(i / 100) / 10 + "k" : i, s = e1[t1 + 6], r = -1 === s ? {} : Object.assign({}, o[s]);
            return Object.assign(r, {
                cluster: !0,
                cluster_id: e1[t1 + 3],
                point_count: i,
                point_count_abbreviated: n
            });
        }
        function Qe(e1) {
            return e1 / 360 + .5;
        }
        function Ke(e1) {
            const t1 = Math.sin(e1 * Math.PI / 180), o = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function et(e1) {
            const t1 = (180 - 360 * e1) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t1)) / Math.PI - 90;
        }
        function tt(e1, t1, o, i) {
            let n = i;
            const s = t1 + (o - t1 >> 1);
            let r, a = o - t1;
            const l = e1[t1], c = e1[t1 + 1], u = e1[o], h = e1[o + 1];
            for(let i = t1 + 3; i < o; i += 3){
                const t1 = ot(e1[i], e1[i + 1], l, c, u, h);
                if (t1 > n) r = i, n = t1;
                else if (t1 === n) {
                    const e1 = Math.abs(i - s);
                    e1 < a && (r = i, a = e1);
                }
            }
            n > i && (r - t1 > 3 && tt(e1, t1, r, i), e1[r + 2] = n, o - r > 3 && tt(e1, r, o, i));
        }
        function ot(e1, t1, o, i, n, s) {
            let r = n - o, a = s - i;
            if (0 !== r || 0 !== a) {
                const l = ((e1 - o) * r + (t1 - i) * a) / (r * r + a * a);
                l > 1 ? (o = n, i = s) : l > 0 && (o += r * l, i += a * l);
            }
            return r = e1 - o, a = t1 - i, r * r + a * a;
        }
        function it(e1, t1, o, i) {
            const n = {
                id: e1 ?? null,
                type: t1,
                geometry: o,
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            if ("Point" === t1 || "MultiPoint" === t1 || "LineString" === t1) nt(n, o);
            else if ("Polygon" === t1) nt(n, o[0]);
            else if ("MultiLineString" === t1) for (const e1 of o)nt(n, e1);
            else if ("MultiPolygon" === t1) for (const e1 of o)nt(n, e1[0]);
            return n;
        }
        function nt(e1, t1) {
            for(let o = 0; o < t1.length; o += 3)e1.minX = Math.min(e1.minX, t1[o]), e1.minY = Math.min(e1.minY, t1[o + 1]), e1.maxX = Math.max(e1.maxX, t1[o]), e1.maxY = Math.max(e1.maxY, t1[o + 1]);
        }
        function st(e1, t1, o, i) {
            if (!t1.geometry) return;
            const n = t1.geometry.coordinates;
            if (n && 0 === n.length) return;
            const s = t1.geometry.type, r = Math.pow(o.tolerance / ((1 << o.maxZoom) * o.extent), 2);
            let a = [], l = t1.id;
            if (o.promoteId ? l = t1.properties[o.promoteId] : o.generateId && (l = i || 0), "Point" === s) rt(n, a);
            else if ("MultiPoint" === s) for (const e1 of n)rt(e1, a);
            else if ("LineString" === s) at(n, a, r, !1);
            else if ("MultiLineString" === s) {
                if (o.lineMetrics) {
                    for (const o of n)a = [], at(o, a, r, !1), e1.push(it(l, "LineString", a, t1.properties));
                    return;
                }
                lt(n, a, r, !1);
            } else if ("Polygon" === s) lt(n, a, r, !0);
            else {
                if ("MultiPolygon" !== s) {
                    if ("GeometryCollection" === s) {
                        for (const n of t1.geometry.geometries)st(e1, {
                            id: l,
                            geometry: n,
                            properties: t1.properties
                        }, o, i);
                        return;
                    }
                    throw new Error("Input data is not a valid GeoJSON object.");
                }
                for (const e1 of n){
                    const t1 = [];
                    lt(e1, t1, r, !0), a.push(t1);
                }
            }
            e1.push(it(l, s, a, t1.properties));
        }
        function rt(e1, t1) {
            t1.push(ct(e1[0]), ut(e1[1]), 0);
        }
        function at(e1, t1, o, i) {
            let n, s, r = 0;
            for(let o = 0; o < e1.length; o++){
                const a = ct(e1[o][0]), l = ut(e1[o][1]);
                t1.push(a, l, 0), o > 0 && (r += i ? (n * l - a * s) / 2 : Math.sqrt(Math.pow(a - n, 2) + Math.pow(l - s, 2))), n = a, s = l;
            }
            const a = t1.length - 3;
            t1[2] = 1, tt(t1, 0, a, o), t1[a + 2] = 1, t1.size = Math.abs(r), t1.start = 0, t1.end = t1.size;
        }
        function lt(e1, t1, o, i) {
            for(let n = 0; n < e1.length; n++){
                const s = [];
                at(e1[n], s, o, i), t1.push(s);
            }
        }
        function ct(e1) {
            return e1 / 360 + .5;
        }
        function ut(e1) {
            const t1 = Math.sin(e1 * Math.PI / 180), o = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function ht(e1, t1, o, i, n, s, r, a) {
            if (i /= t1, s >= (o /= t1) && r < i) return e1;
            if (r < o || s >= i) return null;
            const l = [];
            for (const t1 of e1){
                const e1 = t1.geometry;
                let s = t1.type;
                const r = 0 === n ? t1.minX : t1.minY, c = 0 === n ? t1.maxX : t1.maxY;
                if (r >= o && c < i) {
                    l.push(t1);
                    continue;
                }
                if (c < o || r >= i) continue;
                let u = [];
                if ("Point" === s || "MultiPoint" === s) dt(e1, u, o, i, n);
                else if ("LineString" === s) ft(e1, u, o, i, n, !1, a.lineMetrics);
                else if ("MultiLineString" === s) pt(e1, u, o, i, n, !1);
                else if ("Polygon" === s) pt(e1, u, o, i, n, !0);
                else if ("MultiPolygon" === s) for (const t1 of e1){
                    const e1 = [];
                    pt(t1, e1, o, i, n, !0), e1.length && u.push(e1);
                }
                if (u.length) {
                    if (a.lineMetrics && "LineString" === s) {
                        for (const e1 of u)l.push(it(t1.id, s, e1, t1.tags));
                        continue;
                    }
                    "LineString" !== s && "MultiLineString" !== s || (1 === u.length ? (s = "LineString", u = u[0]) : s = "MultiLineString"), "Point" !== s && "MultiPoint" !== s || (s = 3 === u.length ? "Point" : "MultiPoint"), l.push(it(t1.id, s, u, t1.tags));
                }
            }
            return l.length ? l : null;
        }
        function dt(e1, t1, o, i, n) {
            for(let s = 0; s < e1.length; s += 3){
                const r = e1[s + n];
                r >= o && r <= i && mt(t1, e1[s], e1[s + 1], e1[s + 2]);
            }
        }
        function ft(e1, t1, o, i, n, s, r) {
            let a = gt(e1);
            const l = 0 === n ? yt : xt;
            let c, u, h = e1.start;
            for(let d = 0; d < e1.length - 3; d += 3){
                const f = e1[d], g = e1[d + 1], p = e1[d + 2], m = e1[d + 3], y = e1[d + 4], x = 0 === n ? f : g, v = 0 === n ? m : y;
                let w = !1;
                r && (c = Math.sqrt(Math.pow(f - m, 2) + Math.pow(g - y, 2))), x < o ? v >= o && (u = l(a, f, g, m, y, o), r && (a.start = h + c * u)) : x > i ? v <= i && (u = l(a, f, g, m, y, i), r && (a.start = h + c * u)) : mt(a, f, g, p), v < o && x >= o && (u = l(a, f, g, m, y, o), w = !0), v > i && x <= i && (u = l(a, f, g, m, y, i), w = !0), !s && w && (r && (a.end = h + c * u), t1.push(a), a = gt(e1)), r && (h += c);
            }
            let d = e1.length - 3;
            const f = e1[d], g = e1[d + 1], p = 0 === n ? f : g;
            p >= o && p <= i && mt(a, f, g, e1[d + 2]), d = a.length - 3, s && d >= 3 && (a[d] !== a[0] || a[d + 1] !== a[1]) && mt(a, a[0], a[1], a[2]), a.length && t1.push(a);
        }
        function gt(e1) {
            const t1 = [];
            return t1.size = e1.size, t1.start = e1.start, t1.end = e1.end, t1;
        }
        function pt(e1, t1, o, i, n, s) {
            for (const r of e1)ft(r, t1, o, i, n, s, !1);
        }
        function mt(e1, t1, o, i) {
            e1.push(t1, o, i);
        }
        function yt(e1, t1, o, i, n, s) {
            const r = (s - t1) / (i - t1);
            return mt(e1, s, o + (n - o) * r, 1), r;
        }
        function xt(e1, t1, o, i, n, s) {
            const r = (s - o) / (n - o);
            return mt(e1, t1 + (i - t1) * r, s, 1), r;
        }
        function vt(e1, t1) {
            const o = [];
            for(let i = 0; i < e1.length; i++){
                const n = e1[i], s = n.type;
                let r;
                if ("Point" === s || "MultiPoint" === s || "LineString" === s) r = wt(n.geometry, t1);
                else if ("MultiLineString" === s || "Polygon" === s) {
                    r = [];
                    for (const e1 of n.geometry)r.push(wt(e1, t1));
                } else if ("MultiPolygon" === s) {
                    r = [];
                    for (const e1 of n.geometry){
                        const o = [];
                        for (const i of e1)o.push(wt(i, t1));
                        r.push(o);
                    }
                }
                o.push(it(n.id, s, r, n.tags));
            }
            return o;
        }
        function wt(e1, t1) {
            const o = [];
            o.size = e1.size, void 0 !== e1.start && (o.start = e1.start, o.end = e1.end);
            for(let i = 0; i < e1.length; i += 3)o.push(e1[i] + t1, e1[i + 1], e1[i + 2]);
            return o;
        }
        function bt(e1, t1) {
            if (e1.transformed) return e1;
            const o = 1 << e1.z, i = e1.x, n = e1.y;
            for (const s of e1.features){
                const e1 = s.geometry, r = s.type;
                if (s.geometry = [], 1 === r) for(let r = 0; r < e1.length; r += 2)s.geometry.push(St(e1[r], e1[r + 1], t1, o, i, n));
                else for(let r = 0; r < e1.length; r++){
                    const a = [];
                    for(let s = 0; s < e1[r].length; s += 2)a.push(St(e1[r][s], e1[r][s + 1], t1, o, i, n));
                    s.geometry.push(a);
                }
            }
            return e1.transformed = !0, e1;
        }
        function St(e1, t1, o, i, n, s) {
            return [
                Math.round(o * (e1 * i - n)),
                Math.round(o * (t1 * i - s))
            ];
        }
        function It(e1, t1, o, i, n) {
            const s = t1 === n.maxZoom ? 0 : n.tolerance / ((1 << t1) * n.extent), r = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: e1.length,
                source: null,
                x: o,
                y: i,
                z: t1,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            };
            for (const t1 of e1)Pt(r, t1, s, n);
            return r;
        }
        function Pt(e1, t1, o, i) {
            const n = t1.geometry, s = t1.type, r = [];
            if (e1.minX = Math.min(e1.minX, t1.minX), e1.minY = Math.min(e1.minY, t1.minY), e1.maxX = Math.max(e1.maxX, t1.maxX), e1.maxY = Math.max(e1.maxY, t1.maxY), "Point" === s || "MultiPoint" === s) for(let t1 = 0; t1 < n.length; t1 += 3)r.push(n[t1], n[t1 + 1]), e1.numPoints++, e1.numSimplified++;
            else if ("LineString" === s) Mt(r, n, e1, o, !1, !1);
            else if ("MultiLineString" === s || "Polygon" === s) for(let t1 = 0; t1 < n.length; t1++)Mt(r, n[t1], e1, o, "Polygon" === s, 0 === t1);
            else if ("MultiPolygon" === s) for(let t1 = 0; t1 < n.length; t1++){
                const i = n[t1];
                for(let t1 = 0; t1 < i.length; t1++)Mt(r, i[t1], e1, o, !0, 0 === t1);
            }
            if (r.length) {
                let o = t1.tags || null;
                if ("LineString" === s && i.lineMetrics) {
                    o = {};
                    for(const e1 in t1.tags)o[e1] = t1.tags[e1];
                    o.mapbox_clip_start = n.start / n.size, o.mapbox_clip_end = n.end / n.size;
                }
                const a = {
                    geometry: r,
                    type: "Polygon" === s || "MultiPolygon" === s ? 3 : "LineString" === s || "MultiLineString" === s ? 2 : 1,
                    tags: o
                };
                null !== t1.id && (a.id = t1.id), e1.features.push(a);
            }
        }
        function Mt(e1, t1, o, i, n, s) {
            const r = i * i;
            if (i > 0 && t1.size < (n ? r : i)) return void (o.numPoints += t1.length / 3);
            const a = [];
            for(let e1 = 0; e1 < t1.length; e1 += 3)(0 === i || t1[e1 + 2] > r) && (o.numSimplified++, a.push(t1[e1], t1[e1 + 1])), o.numPoints++;
            n && function(e1, t1) {
                let o = 0;
                for(let t1 = 0, i = e1.length, n = i - 2; t1 < i; n = t1, t1 += 2)o += (e1[t1] - e1[n]) * (e1[t1 + 1] + e1[n + 1]);
                if (o > 0 === t1) for(let t1 = 0, o = e1.length; t1 < o / 2; t1 += 2){
                    const i = e1[t1], n = e1[t1 + 1];
                    e1[t1] = e1[o - 2 - t1], e1[t1 + 1] = e1[o - 1 - t1], e1[o - 2 - t1] = i, e1[o - 1 - t1] = n;
                }
            }(a, s), e1.push(a);
        }
        const Tt = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        };
        class zt {
            constructor(e1, t1){
                const o = (t1 = this.options = function(e1, t1) {
                    for(const o in t1)e1[o] = t1[o];
                    return e1;
                }(Object.create(Tt), t1)).debug;
                if (o && console.time("preprocess data"), t1.maxZoom < 0 || t1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (t1.promoteId && t1.generateId) throw new Error("promoteId and generateId cannot be used together.");
                let i = function(e1, t1) {
                    const o = [];
                    if ("FeatureCollection" === e1.type) for(let i = 0; i < e1.features.length; i++)st(o, e1.features[i], t1, i);
                    else st(o, "Feature" === e1.type ? e1 : {
                        geometry: e1
                    }, t1);
                    return o;
                }(e1, t1);
                this.tiles = {}, this.tileCoords = [], o && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t1.indexMaxZoom, t1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), i = function(e1, t1) {
                    const o = t1.buffer / t1.extent;
                    let i = e1;
                    const n = ht(e1, 1, -1 - o, o, 0, -1, 2, t1), s = ht(e1, 1, 1 - o, 2 + o, 0, -1, 2, t1);
                    return (n || s) && (i = ht(e1, 1, -o, 1 + o, 0, -1, 2, t1) || [], n && (i = vt(n, 1).concat(i)), s && (i = i.concat(vt(s, -1)))), i;
                }(i, t1), i.length && this.splitTile(i, 0, 0, 0), o && (i.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            splitTile(e1, t1, o, i, n, s, r) {
                const a = [
                    e1,
                    t1,
                    o,
                    i
                ], l = this.options, c = l.debug;
                for(; a.length;){
                    i = a.pop(), o = a.pop(), t1 = a.pop(), e1 = a.pop();
                    const u = 1 << t1, h = Bt(t1, o, i);
                    let d = this.tiles[h];
                    if (!d && (c > 1 && console.time("creation"), d = this.tiles[h] = It(e1, t1, o, i, l), this.tileCoords.push({
                        z: t1,
                        x: o,
                        y: i
                    }), c)) {
                        c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t1, o, i, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                        const e1 = `z${t1}`;
                        this.stats[e1] = (this.stats[e1] || 0) + 1, this.total++;
                    }
                    if (d.source = e1, null == n) {
                        if (t1 === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                    } else {
                        if (t1 === l.maxZoom || t1 === n) continue;
                        if (null != n) {
                            const e1 = n - t1;
                            if (o !== s >> e1 || i !== r >> e1) continue;
                        }
                    }
                    if (d.source = null, 0 === e1.length) continue;
                    c > 1 && console.time("clipping");
                    const f = .5 * l.buffer / l.extent, g = .5 - f, p = .5 + f, m = 1 + f;
                    let y = null, x = null, v = null, w = null;
                    const b = ht(e1, u, o - f, o + p, 0, d.minX, d.maxX, l), S = ht(e1, u, o + g, o + m, 0, d.minX, d.maxX, l);
                    b && (y = ht(b, u, i - f, i + p, 1, d.minY, d.maxY, l), x = ht(b, u, i + g, i + m, 1, d.minY, d.maxY, l)), S && (v = ht(S, u, i - f, i + p, 1, d.minY, d.maxY, l), w = ht(S, u, i + g, i + m, 1, d.minY, d.maxY, l)), c > 1 && console.timeEnd("clipping"), a.push(y || [], t1 + 1, 2 * o, 2 * i), a.push(x || [], t1 + 1, 2 * o, 2 * i + 1), a.push(v || [], t1 + 1, 2 * o + 1, 2 * i), a.push(w || [], t1 + 1, 2 * o + 1, 2 * i + 1);
                }
            }
            getTile(e1, t1, o) {
                e1 = +e1, t1 = +t1, o = +o;
                const i = this.options, { extent: n, debug: s } = i;
                if (e1 < 0 || e1 > 24) return null;
                const r = 1 << e1, a = Bt(e1, t1 = t1 + r & r - 1, o);
                if (this.tiles[a]) return bt(this.tiles[a], n);
                s > 1 && console.log("drilling down to z%d-%d-%d", e1, t1, o);
                let l, c = e1, u = t1, h = o;
                for(; !l && c > 0;)c--, u >>= 1, h >>= 1, l = this.tiles[Bt(c, u, h)];
                return l && l.source ? (s > 1 && (console.log("found parent tile z%d-%d-%d", c, u, h), console.time("drilling down")), this.splitTile(l.source, c, u, h, e1, t1, o), s > 1 && console.timeEnd("drilling down"), this.tiles[a] ? bt(this.tiles[a], n) : null) : null;
            }
        }
        function Bt(e1, t1, o) {
            return 32 * ((1 << e1) * o + t1) + e1;
        }
        function kt(e1, o) {
            const i = e1.tileID.canonical;
            if (!this._geoJSONIndex) return void o(null, null);
            const n = this._geoJSONIndex.getTile(i.z, i.x, i.y);
            if (!n) return void o(null, null);
            const s = (e1)=>e1.tags && "3d_elevation_id" in e1.tags && "source" in e1.tags && "elevation" === e1.tags.source, r = n.features.filter((e1)=>s(e1));
            let a = {
                _geojsonTileLayer: n.features
            };
            r.length > 0 && (a = {
                _geojsonTileLayer: n.features.filter((e1)=>!s(e1)),
                hd_road_elevation: r
            });
            const l = new Be(a), c = function(e1) {
                const o = new t1.gi;
                for (const t1 of Object.keys(e1))o.writeMessage(3, je, {
                    name: t1,
                    features: e1[t1]
                });
                return o.finish();
            }(a).buffer;
            o(null, {
                vectorTile: l,
                rawData: c,
                headers: new Headers
            });
        }
        class Ct extends Ie {
            constructor(e1){
                super(e1), this.loadVectorData = kt, this._dynamicIndex = new Ce;
            }
            async loadData(e1) {
                const i = e1 && e1.request, n = i && i.collectResourceTiming;
                this._geoJSONIndex = null;
                let s = await new Promise((t1, o)=>{
                    this.loadGeoJSON(e1, (e1, i)=>{
                        e1 ? o(e1) : t1(i);
                    });
                });
                if (!s) return {};
                if ("object" != typeof s) throw new Error(`Input data given to '${e1.source}' is not a valid GeoJSON object.`);
                if (e1.filter) {
                    const o = t1.c(e1.filter, {
                        type: "boolean",
                        "property-type": "data-driven",
                        overridable: !1,
                        transition: !1
                    });
                    if ("error" === o.result) throw new Error(o.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                    s.features = s.features.filter((e1)=>o.value.evaluate({
                            zoom: 0
                        }, e1));
                }
                e1.dynamic ? ("Feature" === s.type && (s = {
                    type: "FeatureCollection",
                    features: [
                        s
                    ]
                }), e1.append || (this._dynamicIndex.clear(), this.loaded = {}), this._dynamicIndex.load(s.features, this.loaded), e1.cluster && (s.features = this._dynamicIndex.getFeatures())) : this.loaded = {}, this._geoJSONIndex = e1.cluster ? new Je(function({ superclusterOptions: e1, clusterProperties: o }) {
                    if (!o || !e1) return e1;
                    const i = {}, n = {}, s = {
                        accumulated: null,
                        zoom: 0
                    }, r = {
                        properties: null
                    }, a = Object.keys(o);
                    for (const e1 of a){
                        const [s, r] = o[e1], a = t1.c(r), l = t1.c("string" == typeof s ? [
                            s,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                e1
                            ]
                        ] : s);
                        i[e1] = a.value, n[e1] = l.value;
                    }
                    return e1.map = (e1)=>{
                        r.properties = e1;
                        const t1 = {};
                        for (const e1 of a)t1[e1] = i[e1].evaluate(s, r);
                        return t1;
                    }, e1.reduce = (e1, t1)=>{
                        r.properties = t1;
                        for (const t1 of a)s.accumulated = e1[t1], e1[t1] = n[t1].evaluate(s, r);
                    }, e1;
                }(e1)).load(s.features) : e1.dynamic ? this._dynamicIndex : function(e1, t1) {
                    return new zt(e1, t1);
                }(s, e1.geojsonVtOptions);
                const r = {};
                if (n) {
                    const t1 = o(i);
                    t1 && (r.resourceTiming = {}, r.resourceTiming[e1.source] = JSON.parse(JSON.stringify(t1)));
                }
                return r;
            }
            async reloadTile(e1) {
                const t1 = this.loaded;
                if (t1 && t1[e1.uid]) {
                    if (e1.partial) return;
                    return super.reloadTile(e1);
                }
                return this.loadTile(e1);
            }
            loadGeoJSON(e1, o) {
                if (e1.request) t1.g(e1.request).then(({ data: e1 })=>o(null, e1)).catch((e1)=>o(e1));
                else {
                    if ("string" != typeof e1.data) return o(new Error(`Input data given to '${e1.source}' is not a valid GeoJSON object.`));
                    setTimeout(()=>{
                        try {
                            return o(null, JSON.parse(e1.data));
                        } catch (t1) {
                            return o(new Error(`Input data given to '${e1.source}' is not a valid GeoJSON object.`));
                        }
                    }, 0);
                }
            }
            getClusterExpansionZoom(e1) {
                return this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId);
            }
            getClusterChildren(e1) {
                return this._geoJSONIndex.getChildren(e1.clusterId);
            }
            getClusterLeaves(e1) {
                return this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset);
            }
        }
        t1.cA.setPbf(t1.cB);
        class Lt {
            constructor(e1){
                this._mrt = new t1.cA(e1.partial ? 30 : 1 / 0), this._isHeaderLoaded = !1, this.uid = e1.uid, this.tileID = e1.tileID, this.source = e1.source;
            }
            async parse(e1) {
                const o = this._mrt;
                this.status = "parsing", this._entireBuffer = e1, o.parseHeader(e1), this._isHeaderLoaded = !0;
                const i = [];
                for(const n in o.layers){
                    const s = o.getLayer(n), r = s.getDataRange(s.getBandList()), a = o.createDecodingTask(r), l = e1.slice(r.firstByte, r.lastByte + 1);
                    i.push(t1.cA.performDecoding(l, a).then((e1)=>a.complete(null, e1)).catch((e1)=>a.complete(e1, null)));
                }
                return await Promise.allSettled(i), o;
            }
        }
        class Dt {
            constructor({ actor: e1 }){
                this.actor = e1, this.loading = {}, this.loaded = {};
            }
            async loadTile(e1) {
                const o = e1.uid, i = new AbortController, n = this.loading[o] = new Lt(e1);
                n.abort = ()=>i.abort();
                try {
                    const { data: s, headers: r } = await t1.cC(e1.request, i.signal);
                    return s ? (this.loaded[o] = n, {
                        mrt: await n.parse(s),
                        headers: r
                    }) : (n.status = "done", this.loaded[o] = n, null);
                } catch (e1) {
                    if (i.signal.aborted) return null;
                    throw n.status = "done", this.loaded[o] = n, e1;
                } finally{
                    delete this.loading[o];
                }
            }
            async reloadTile(e1) {}
            abortTile(e1) {
                const t1 = e1.uid, o = this.loading[t1];
                o && (o.abort && o.abort(), delete this.loading[t1]);
            }
            removeTile(e1) {
                const t1 = e1.uid;
                this.loaded[t1] && delete this.loaded[t1];
            }
            async decodeRasterArray(e1) {
                return t1.cA.performDecoding(e1.buffer, e1.task);
            }
        }
        class Ft {
            constructor(e1){
                this.self = e1, this.actor = new t1.aw(e1, this), this.layerIndexes = {}, this.availableImages = {}, this.availableModels = {}, this.isSpriteLoaded = {}, this.rtlPluginParsingListeners = [], this.projections = {}, this.defaultProjection = t1.gk({
                    name: "mercator"
                }), this.workerSourceTypes = {
                    vector: Ie,
                    geojson: Ct,
                    "raster-dem": Pe
                }, this.workerSources = {}, this.self.registerRTLTextPlugin = (e1)=>{
                    if (t1.fG.isParsed()) throw new Error("RTL text plugin already registered.");
                    t1.fG.setState({
                        pluginStatus: t1.gl.parsed,
                        pluginURL: t1.fG.getPluginURL()
                    }), t1.fG.applyArabicShaping = e1.applyArabicShaping, t1.fG.processBidirectionalText = e1.processBidirectionalText, t1.fG.processStyledBidirectionalText = e1.processStyledBidirectionalText;
                    for (const { resolve: e1 } of this.rtlPluginParsingListeners)e1(!0);
                    this.rtlPluginParsingListeners = [];
                };
            }
            clearCaches(e1, t1) {
                delete this.layerIndexes[e1], delete this.availableImages[e1], delete this.availableModels[e1], delete this.workerSources[e1], delete this.isSpriteLoaded[e1];
            }
            checkIfReady(e1, t1) {}
            spriteLoaded(e1, o) {
                const { scope: i } = o;
                if (this.isSpriteLoaded[e1] || (this.isSpriteLoaded[e1] = {}), this.isSpriteLoaded[e1][i] = !0, this.workerSources[e1] && this.workerSources[e1][i]) for(const o in this.workerSources[e1][i]){
                    const n = this.workerSources[e1][i][o];
                    for(const e1 in n){
                        const o = n[e1];
                        o instanceof Ie && (o.isSpriteLoaded = !0, o.fire(new t1.h("isSpriteLoaded")));
                    }
                }
            }
            setImages(e1, t1) {
                this.availableImages[e1] || (this.availableImages[e1] = {});
                const { scope: o, images: i } = t1;
                if (this.availableImages[e1][o] = i, t1.isSpriteLoaded && this.spriteLoaded(e1, {
                    scope: o
                }), this.workerSources[e1] && this.workerSources[e1][o]) for(const t1 in this.workerSources[e1][o]){
                    const n = this.workerSources[e1][o][t1];
                    for(const e1 in n)n[e1].availableImages = i;
                }
            }
            setModels(e1, { scope: t1, models: o }) {
                if (this.availableModels[e1] || (this.availableModels[e1] = {}), this.availableModels[e1][t1] = o, this.workerSources[e1] && this.workerSources[e1][t1]) for(const i in this.workerSources[e1][t1]){
                    const n = this.workerSources[e1][t1][i];
                    for(const e1 in n)n[e1].availableModels = o;
                }
            }
            setProjection(e1, o) {
                this.projections[e1] = t1.gk(o);
            }
            setGlobalParams(e1, o) {
                if (this.referrer = o.referrer, Object.assign(t1.eL, o.config), o.contextOptions) {
                    const { maxBindingPoints: e1, maxUniformBlockSizeDwords: t1 } = o.contextOptions;
                    this.maxUniformBufferBindings = e1, this.maxUniformBlockSizeDwords = t1;
                }
            }
            upsertRenderParams(e1, t1) {
                void 0 !== t1.brightness && (this.brightness = t1.brightness), void 0 !== t1.worldview && (this.worldview = t1.worldview);
            }
            setLayers(e1, t1) {
                this.getLayerIndex(e1, t1.scope).replace(t1.layers, t1.options);
            }
            updateLayers(e1, t1) {
                this.getLayerIndex(e1, t1.scope).update(t1.layers, t1.removedIds, t1.options);
            }
            async loadTile(e1, o) {
                if (o.projection = this.projections[e1] || this.defaultProjection, "batched-model" === o.type && !this.workerSourceTypes["batched-model"]) {
                    if (await t1.gm(), !x) throw new Error('Could not load Standard module for "batched-model" source.');
                    this.workerSourceTypes["batched-model"] = x;
                }
                return "raster-array" === o.type && await this.ensureRasterArrayWorkerSource(), this.getWorkerSource(e1, o).loadTile(o);
            }
            async ensureRasterArraySource(e1, t1) {
                await this.ensureRasterArrayWorkerSource();
            }
            async ensureRasterArrayWorkerSource() {
                if (!this.workerSourceTypes["raster-array"]) {
                    if (await async function() {
                        return Promise.resolve();
                    }(), !Dt) throw new Error('Could not load raster-array module for "raster-array" source.');
                    this.workerSourceTypes["raster-array"] = Dt;
                }
            }
            async decodeRasterArray(e1, t1) {
                return await this.ensureRasterArrayWorkerSource(), this.getWorkerSource(e1, t1).decodeRasterArray(t1);
            }
            reloadTile(e1, t1) {
                return t1.projection = this.projections[e1] || this.defaultProjection, this.getWorkerSource(e1, t1).reloadTile(t1);
            }
            abortTile(e1, t1) {
                const o = this.getExistingWorkerSource(e1, t1);
                return o ? o.abortTile(t1) : void 0;
            }
            removeTile(e1, t1) {
                const o = this.getExistingWorkerSource(e1, t1);
                return o ? o.removeTile(t1) : void 0;
            }
            getExistingWorkerSource(e1, t1) {
                const { type: o, source: i, scope: n } = t1, s = this.workerSources[e1];
                if (s && s[n] && s[n][o]) return s[n][o][i];
            }
            async removeSource(e1, t1) {
                const { type: o, source: i, scope: n } = t1, s = this.workerSources[e1] && this.workerSources[e1][n] && this.workerSources[e1][n][o], r = s && s[i];
                r && (delete s[i], r.removeSource && await r.removeSource({
                    source: i
                }));
            }
            async loadTileProvider(e1, o) {
                const i = new (await t1.cn(o.name, o.url))(o.options);
                return this.getWorkerSource(e1, {
                    type: o.type,
                    source: o.source,
                    scope: o.scope
                }, i), i.load && o.request ? i.load({
                    request: o.request
                }) : null;
            }
            async syncRTLPluginState(e1, o) {
                if (t1.fG.isParsed()) return !0;
                if (t1.fG.isParsing()) return new Promise((e1, t1)=>{
                    this.rtlPluginParsingListeners.push({
                        resolve: e1,
                        reject: t1
                    });
                });
                t1.fG.setState(o);
                const i = t1.fG.getPluginURL();
                if (!t1.fG.isLoaded() || t1.fG.isParsed() || t1.fG.isParsing()) return !1;
                t1.fG.setState({
                    pluginStatus: t1.gl.parsing,
                    pluginURL: i
                });
                try {
                    return await self.__mapboxImport(/* webpackIgnore: true */ /* @vite-ignore */ i), !!t1.fG.isParsed() || new Promise((e1, t1)=>{
                        this.rtlPluginParsingListeners.push({
                            resolve: e1,
                            reject: t1
                        });
                    });
                } catch (e1) {
                    t1.fG.setState({
                        pluginStatus: t1.gl.error,
                        pluginURL: i
                    });
                    for (const { reject: t1 } of this.rtlPluginParsingListeners)t1(e1);
                    throw this.rtlPluginParsingListeners = [], e1;
                }
            }
            getAvailableImages(e1, t1) {
                this.availableImages[e1] || (this.availableImages[e1] = {});
                let o = this.availableImages[e1][t1];
                return o || (o = []), o;
            }
            getAvailableModels(e1, t1) {
                this.availableModels[e1] || (this.availableModels[e1] = {});
                let o = this.availableModels[e1][t1];
                return o || (o = {}), o;
            }
            getLayerIndex(e1, t1) {
                this.layerIndexes[e1] || (this.layerIndexes[e1] = {});
                let o = this.layerIndexes[e1][t1];
                return o || (o = this.layerIndexes[e1][t1] = new S, o.scope = t1), o;
            }
            getWorkerSource(e1, t1, o) {
                const { type: i, source: n, scope: s } = t1, r = this.workerSources;
                if (r[e1] || (r[e1] = {}), r[e1][s] || (r[e1][s] = {}), r[e1][s][i] || (r[e1][s][i] = {}), this.isSpriteLoaded[e1] || (this.isSpriteLoaded[e1] = {}), this.getExistingWorkerSource(e1, t1)) o && (r[e1][s][i][n].tileProvider = o);
                else {
                    const t1 = this.actor.getWorkerSourceActor(e1), a = this.workerSourceTypes[i];
                    if (!a) throw new Error(`Unknown worker source type "${i}".`);
                    r[e1][s][i][n] = new a({
                        actor: t1,
                        layerIndex: this.getLayerIndex(e1, s),
                        availableImages: this.getAvailableImages(e1, s),
                        availableModels: this.getAvailableModels(e1, s),
                        isSpriteLoaded: this.isSpriteLoaded[e1][s],
                        tileProvider: o,
                        brightness: this.brightness,
                        worldview: this.worldview,
                        maxUniformBufferBindings: this.maxUniformBufferBindings,
                        maxUniformBlockSizeDwords: this.maxUniformBlockSizeDwords
                    });
                }
                return r[e1][s][i][n];
            }
            enforceCacheSizeLimit(e1, o) {
                t1.gn(o);
            }
        }
        return t1.gj(self) && (self.worker = new Ft(self)), Ft;
    });
    define([
        "./shared"
    ], function(e1) {
        const t1 = {
            antialias: !1,
            alpha: !0,
            stencil: !0,
            depth: !0
        };
        let i, s;
        function r(e1) {
            const i = document.createElement("canvas"), s = Object.create(t1);
            s.failIfMajorPerformanceCaveat = e1;
            const r = i.getContext("webgl2", s);
            if (!r) return !1;
            let o;
            try {
                o = r.createShader(r.VERTEX_SHADER);
            } catch (e1) {
                return !1;
            }
            return !(!o || r.isContextLost()) && (r.shaderSource(o, "void main() {}"), r.compileShader(o), !0 === r.getShaderParameter(o, r.COMPILE_STATUS));
        }
        const o = /firefox/i, n = /macintosh/i;
        function a(e1, t1, i) {
            const s = document.createElement(e1);
            return null != t1 && (s.className = t1), i && i.appendChild(s), s;
        }
        function l(e1, t1, i) {
            const s = document.createElementNS("http://www.w3.org/2000/svg", e1);
            for (const e1 of Object.keys(t1))s.setAttributeNS(null, e1, String(t1[e1]));
            return i && i.appendChild(s), s;
        }
        const c = "undefined" != typeof document ? document.documentElement && document.documentElement.style : null, h = c && void 0 !== c.userSelect ? "userSelect" : "WebkitUserSelect";
        let d;
        function u() {
            c && h && (d = c[h], c[h] = "none");
        }
        function p() {
            c && h && (c[h] = d);
        }
        function f(e1) {
            e1.preventDefault(), e1.stopPropagation(), window.removeEventListener("click", f, !0);
        }
        function m() {
            window.addEventListener("click", f, !0), window.setTimeout(()=>{
                window.removeEventListener("click", f, !0);
            }, 0);
        }
        function _(e1, t1) {
            const i = e1.getBoundingClientRect();
            return v(e1, i, t1);
        }
        function g(e1, t1) {
            const i = e1.getBoundingClientRect(), s = [];
            for(let r = 0; r < t1.length; r++)s.push(v(e1, i, t1[r]));
            return s;
        }
        function y(e1) {
            return o.test(navigator.userAgent) && n.test(navigator.userAgent) && 2 === e1.button && e1.ctrlKey ? 0 : e1.button;
        }
        function v(t1, i, s) {
            const r = t1.offsetWidth === i.width ? 1 : t1.offsetWidth / i.width;
            return new e1.P((s.clientX - i.left) * r, (s.clientY - i.top) * r);
        }
        class b {
            constructor(){
                this._changed = !1, this._updatedLayers = Object.create(null), this._removedLayers = Object.create(null), this._updatedSourceCaches = Object.create(null), this._updatedPaintProps = new Set, this._updatedImages = Object.create(null);
            }
            isDirty() {
                return this._changed;
            }
            setDirty() {
                this._changed = !0;
            }
            getUpdatedSourceCaches() {
                return this._updatedSourceCaches;
            }
            updateSourceCache(e1, t1) {
                this._updatedSourceCaches[e1] = t1, this.setDirty();
            }
            discardSourceCacheUpdate(e1) {
                delete this._updatedSourceCaches[e1];
            }
            updateLayer(e1) {
                const t1 = e1.scope;
                this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._updatedLayers[t1].add(e1.id), this.setDirty();
            }
            removeLayer(e1) {
                const t1 = e1.scope;
                this._removedLayers[t1] = this._removedLayers[t1] || {}, this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._removedLayers[t1][e1.id] = e1, this._updatedLayers[t1].delete(e1.id), this._updatedPaintProps.delete(e1.fqid), this.setDirty();
            }
            getRemovedLayer(e1) {
                return this._removedLayers[e1.scope] ? this._removedLayers[e1.scope][e1.id] : null;
            }
            discardLayerRemoval(e1) {
                this._removedLayers[e1.scope] && delete this._removedLayers[e1.scope][e1.id];
            }
            getLayerUpdatesByScope() {
                const e1 = {};
                for(const t1 in this._updatedLayers)e1[t1] = e1[t1] || {}, e1[t1].updatedIds = Array.from(this._updatedLayers[t1].values());
                for(const t1 in this._removedLayers)e1[t1] = e1[t1] || {}, e1[t1].removedIds = Object.keys(this._removedLayers[t1]);
                return e1;
            }
            getUpdatedPaintProperties() {
                return this._updatedPaintProps;
            }
            updatePaintProperties(e1) {
                this._updatedPaintProps.add(e1.fqid), this.setDirty();
            }
            getUpdatedImages(e1) {
                return this._updatedImages[e1] ? Array.from(this._updatedImages[e1].values()) : [];
            }
            updateImage(t1, i) {
                this._updatedImages[i] = this._updatedImages[i] || new Set, this._updatedImages[i].add(e1.I.toString(t1)), this.setDirty();
            }
            resetUpdatedImages(e1) {
                this._updatedImages[e1] && this._updatedImages[e1].clear();
            }
            reset() {
                this._changed = !1, this._updatedLayers = Object.create(null), this._removedLayers = Object.create(null), this._updatedSourceCaches = Object.create(null), this._updatedPaintProps.clear(), this._updatedImages = Object.create(null);
            }
        }
        class x {
            constructor(e1){
                this._layer = e1, this._filterDependencies = void 0;
            }
            invalidateFilter() {
                this._filterDependencies = void 0;
            }
            get _filterDeps() {
                return void 0 === this._filterDependencies && (this._filterDependencies = this._computeFilterDependencies()), this._filterDependencies;
            }
            _computeFilterDependencies() {
                const t1 = this._layer;
                if (!t1.type || "custom" === t1.type || "background" === t1.type || "sky" === t1.type || "slot" === t1.type) return null;
                const i = e1.c(t1.filter, e1.s[`filter_${t1.type}`]);
                return "error" === i.result ? null : {
                    configDependencies: i.value.configDependencies,
                    isIndoorDependent: i.value.isIndoorDependent
                };
            }
            hasConfigDependency(e1) {
                const { _unevaluatedLayout: t1, _transitionablePaint: i } = this._layer;
                if (t1 && t1.configDependencies.has(e1)) return !0;
                if (i && i.configDependencies.has(e1)) return !0;
                const s = this._filterDeps;
                return !!s && s.configDependencies.has(e1);
            }
            get isConfigDependent() {
                const { _unevaluatedLayout: e1, _transitionablePaint: t1 } = this._layer;
                if (e1 && 0 !== e1.configDependencies.size) return !0;
                if (t1 && 0 !== t1.configDependencies.size) return !0;
                const i = this._filterDeps;
                return !!i && 0 !== i.configDependencies.size;
            }
            get isIndoorDependent() {
                const { _unevaluatedLayout: e1, _transitionablePaint: t1 } = this._layer;
                if (e1 && e1.isIndoorDependent()) return !0;
                if (t1 && t1.isIndoorDependent()) return !0;
                const i = this._filterDeps;
                return !!i && i.isIndoorDependent;
            }
        }
        function w(e1) {
            const { userImage: t1 } = e1;
            return !!(t1 && t1.render && t1.render()) && (e1.data.replace(new Uint8Array(t1.data.buffer)), !0);
        }
        const T = new e1.C(0, 0, 0);
        function S(e1, t1) {
            const i = [], s = e1[`stretch_${t1}`];
            let r = null;
            for(let e1 = 0; e1 < s.length; e1++)null === r ? r = 0 === i.length ? s[0] : i.at(-1)[1] + s[e1] : (i.push([
                r,
                r + s[e1]
            ]), r = null);
            e1[`stretch_${t1}_areas`] = i;
        }
        function C(e1, t1) {
            const i = {
                name: void 0
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.name = e1.readString() : 2 === s ? i.metadata = E(e1, e1.readVarint() + e1.pos) : 3 === s && (i.usvg_tree = P(e1, e1.readVarint() + e1.pos), i.data = "usvg_tree");
            return function(e1) {
                if (e1.usvg_tree.height || (e1.usvg_tree.height = e1.usvg_tree.width), !e1.metadata) return e1;
                const { metadata: t1 } = e1;
                if (t1.content_area) {
                    const { content_area: i } = t1;
                    i.left ??= 0, i.top ??= i.left, i.width ??= e1.usvg_tree.width, i.height ??= i.width;
                }
                if (t1.text_placeholder) {
                    const { text_placeholder: e1 } = t1;
                    e1.top ??= e1.left, e1.height ??= e1.width;
                }
                return t1.stretch_x && t1.stretch_x.length && S(t1, "x"), t1.stretch_y && t1.stretch_y.length && S(t1, "y"), e1;
            }(i);
        }
        function E(e1, t1) {
            const i = {
                stretch_x: null,
                stretch_y: null,
                stretch_x_areas: null,
                stretch_y_areas: null,
                variables: []
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.stretch_x = e1.readPackedVarint() : 2 === s ? i.stretch_y = e1.readPackedVarint() : 3 === s ? i.content_area = I(e1, e1.readVarint() + e1.pos) : 4 === s ? i.variables.push(D(e1, e1.readVarint() + e1.pos)) : 5 === s && (i.text_placeholder = I(e1, e1.readVarint() + e1.pos));
            return i;
        }
        function I(e1, t1) {
            const i = {};
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.left = e1.readVarint() : 2 === s ? i.width = e1.readVarint() : 3 === s ? i.top = e1.readVarint() : 4 === s && (i.height = e1.readVarint());
            return i;
        }
        function D(e1, t1) {
            const i = {
                name: void 0
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.name = e1.readString() : 2 === s && (i.rgb_color = B(e1.readVarint()), i.value = "rgb_color");
            return i;
        }
        function P(e1, t1) {
            const i = {
                width: 20,
                children: [],
                linear_gradients: [],
                radial_gradients: [],
                clip_paths: [],
                masks: [],
                height: 20
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.width = i.height = e1.readVarint() : 2 === s ? i.height = e1.readVarint() : 3 === s ? i.children.push(L(e1, e1.readVarint() + e1.pos)) : 4 === s ? i.linear_gradients.push(k(e1, e1.readVarint() + e1.pos)) : 5 === s ? i.radial_gradients.push(U(e1, e1.readVarint() + e1.pos)) : 7 === s ? i.clip_paths.push(N(e1, e1.readVarint() + e1.pos)) : 8 === s && i.masks.push(j(e1, e1.readVarint() + e1.pos));
            return i;
        }
        function L(e1, t1) {
            const i = {};
            let s;
            for(; s = e1.nextField(t1);)1 === s ? (i.group = R(e1, e1.readVarint() + e1.pos), i.node = "group") : 2 === s && (i.path = M(e1, e1.readVarint() + e1.pos), i.node = "path");
            return i;
        }
        function R(e1, t1) {
            const i = {
                opacity: 255,
                children: []
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.transform = A(e1, e1.readVarint() + e1.pos) : 2 === s ? i.opacity = e1.readVarint() : 5 === s ? i.clip_path_idx = e1.readVarint() : 6 === s ? i.mask_idx = e1.readVarint() : 7 === s && i.children.push(L(e1, e1.readVarint() + e1.pos));
            return i;
        }
        function A(e1, t1) {
            const i = {
                sx: 1,
                ky: 0,
                kx: 0,
                sy: 1,
                tx: 0,
                ty: 0
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.sx = e1.readFloat() : 2 === s ? i.ky = e1.readFloat() : 3 === s ? i.kx = e1.readFloat() : 4 === s ? i.sy = e1.readFloat() : 5 === s ? i.tx = e1.readFloat() : 6 === s && (i.ty = e1.readFloat());
            return i;
        }
        function M(e1, t1) {
            const i = {
                paint_order: 1,
                commands: [],
                step: 1,
                diffs: [],
                rule: 1
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.fill = F(e1, e1.readVarint() + e1.pos) : 2 === s ? i.stroke = O(e1, e1.readVarint() + e1.pos) : 3 === s ? i.paint_order = e1.readVarint() : 5 === s ? e1.readPackedVarint(i.commands) : 6 === s ? i.step = e1.readFloat() : 7 === s ? e1.readPackedSVarint(i.diffs) : 8 === s && (i.rule = e1.readVarint());
            return i;
        }
        function F(e1, t1) {
            const i = {
                rgb_color: T,
                paint: "rgb_color",
                opacity: 255
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? (i.rgb_color = B(e1.readVarint()), i.paint = "rgb_color") : 2 === s ? (i.linear_gradient_idx = e1.readVarint(), i.paint = "linear_gradient_idx") : 3 === s ? (i.radial_gradient_idx = e1.readVarint(), i.paint = "radial_gradient_idx") : 5 === s && (i.opacity = e1.readVarint());
            return i;
        }
        function O(e1, t1) {
            const i = {
                rgb_color: T,
                paint: "rgb_color",
                dasharray: [],
                dashoffset: 0,
                miterlimit: 4,
                opacity: 255,
                width: 1,
                linecap: 1,
                linejoin: 1
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? (i.rgb_color = B(e1.readVarint()), i.paint = "rgb_color") : 2 === s ? (i.linear_gradient_idx = e1.readVarint(), i.paint = "linear_gradient_idx") : 3 === s ? (i.radial_gradient_idx = e1.readVarint(), i.paint = "radial_gradient_idx") : 5 === s ? e1.readPackedFloat(i.dasharray) : 6 === s ? i.dashoffset = e1.readFloat() : 7 === s ? i.miterlimit = e1.readFloat() : 8 === s ? i.opacity = e1.readVarint() : 9 === s ? i.width = e1.readFloat() : 10 === s ? i.linecap = e1.readVarint() : 11 === s && (i.linejoin = e1.readVarint());
            return i;
        }
        function B(t1) {
            return new e1.C((t1 >> 16 & 255) / 255, (t1 >> 8 & 255) / 255, (255 & t1) / 255, 1);
        }
        function k(e1, t1) {
            const i = {
                spread_method: 1,
                stops: [],
                x1: 0,
                y1: 0,
                x2: 1,
                y2: 0
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.transform = A(e1, e1.readVarint() + e1.pos) : 2 === s ? i.spread_method = e1.readVarint() : 3 === s ? i.stops.push(z(e1, e1.readVarint() + e1.pos)) : 4 === s ? i.x1 = e1.readFloat() : 5 === s ? i.y1 = e1.readFloat() : 6 === s ? i.x2 = e1.readFloat() : 7 === s && (i.y2 = e1.readFloat());
            return i;
        }
        function z(e1, t1) {
            const i = {
                offset: 0,
                opacity: 255,
                rgb_color: T
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.offset = e1.readFloat() : 2 === s ? i.opacity = e1.readVarint() : 3 === s && (i.rgb_color = B(e1.readVarint()));
            return i;
        }
        function U(e1, t1) {
            const i = {
                spread_method: 1,
                stops: [],
                cx: .5,
                cy: .5,
                r: .5,
                fx: .5,
                fy: .5,
                fr: 0
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.transform = A(e1, e1.readVarint() + e1.pos) : 2 === s ? i.spread_method = e1.readVarint() : 3 === s ? i.stops.push(z(e1, e1.readVarint() + e1.pos)) : 4 === s ? i.cx = e1.readFloat() : 5 === s ? i.cy = e1.readFloat() : 6 === s ? i.r = e1.readFloat() : 7 === s ? i.fx = e1.readFloat() : 8 === s ? i.fy = e1.readFloat() : 9 === s && (i.fr = e1.readFloat());
            return i;
        }
        function N(e1, t1) {
            const i = {
                children: []
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.transform = A(e1, e1.readVarint() + e1.pos) : 2 === s ? i.clip_path_idx = e1.readVarint() : 3 === s && i.children.push(L(e1, e1.readVarint() + e1.pos));
            return i;
        }
        function j(e1, t1) {
            const i = {
                left: 0,
                width: 20,
                mask_type: 1,
                children: []
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.left = i.top = e1.readFloat() : 2 === s ? i.width = i.height = e1.readFloat() : 3 === s ? i.top = e1.readFloat() : 4 === s ? i.height = e1.readFloat() : 5 === s ? i.mask_type = e1.readVarint() : 6 === s ? i.mask_idx = e1.readVarint() : 7 === s && i.children.push(L(e1, e1.readVarint() + e1.pos));
            return i.height ??= i.width, i.top ??= i.left, i;
        }
        class V {
            static calculate(t1 = {}, i = []) {
                const s = new Map, r = new Map;
                if (0 === Object.keys(t1).length) return s;
                i.forEach((t1)=>{
                    r.set(t1.name, t1.rgb_color || new e1.C(0, 0, 0));
                });
                for (const [e1, i] of Object.entries(t1))r.has(e1) ? s.set(r.get(e1).toString(), i) : console.warn(`Ignoring unknown image variable "${e1}"`);
                return s;
            }
        }
        function G(t1, i = 255, s) {
            const r = s.get(t1.toString()) || t1;
            return 255 === i ? r.toString() : new e1.C(r.r, r.g, r.b, r.a * i / 255).toString();
        }
        const q = [];
        let Z = 0;
        function $(t1, i) {
            if (Z >= q.length) {
                const s = e1.o() ? new OffscreenCanvas(t1, i).getContext("2d", {
                    willReadFrequently: !0
                }) : document.createElement("canvas").getContext("2d", {
                    willReadFrequently: !0
                });
                q.push(s);
            }
            const s = q[Z++];
            return s.canvas.width = t1, s.canvas.height = i, s;
        }
        function H() {
            Z--;
        }
        function W(e1, t1, i, s, r) {
            for (const o of s.children)X(e1, t1, i, o, r);
        }
        function X(e1, t1, i, s, r) {
            s.group ? (e1.save(), function(e1, t1, i, s, r) {
                const o = null != s.mask_idx ? i.masks[s.mask_idx] : null, n = null != s.clip_path_idx ? i.clip_paths[s.clip_path_idx] : null;
                if (s.transform && (t1 = re(s.transform).preMultiplySelf(t1)), !function(e1, t1, i) {
                    return 255 !== e1.opacity || t1 || i;
                }(s, null != n, null != o)) return void W(e1, t1, i, s, r);
                const a = $(e1.canvas.width, e1.canvas.height);
                W(a, t1, i, s, r), n && ie(a, t1, i, n), o && se(a, t1, i, o, r), e1.globalAlpha = s.opacity / 255, e1.drawImage(a.canvas, 0, 0), H();
            }(e1, t1, i, s.group, r), e1.restore()) : s.path && (e1.save(), function(e1, t1, i, s, r) {
                e1.setTransform(t1), 1 === s.paint_order ? (K(e1, i, s, r), Q(e1, i, s, r)) : (Q(e1, i, s, r), K(e1, i, s, r));
            }(e1, t1, i, s.path, r), e1.restore());
        }
        function K(e1, t1, i, s) {
            const r = i.fill;
            if (!r) return;
            const o = r.opacity / 255;
            switch(e1.save(), e1.beginPath(), oe(i, e1), r.paint){
                case "rgb_color":
                    e1.fillStyle = G(r.rgb_color, r.opacity, s);
                    break;
                case "linear_gradient_idx":
                    {
                        const i = t1.linear_gradients[r.linear_gradient_idx];
                        i.transform && e1.setTransform(re(i.transform).preMultiplySelf(e1.getTransform())), e1.fillStyle = J(e1, i, o, s);
                        break;
                    }
                case "radial_gradient_idx":
                    {
                        const i = t1.radial_gradients[r.radial_gradient_idx];
                        i.transform && e1.setTransform(re(i.transform).preMultiplySelf(e1.getTransform())), e1.fillStyle = ee(e1, i, o, s);
                    }
            }
            e1.fill(Y(i)), e1.restore();
        }
        function Y(e1) {
            return 1 === e1.rule ? "nonzero" : 2 === e1.rule ? "evenodd" : void 0;
        }
        function Q(e1, t1, i, s) {
            const r = i.stroke;
            if (!r) return;
            const o = ne(i);
            e1.lineWidth = r.width, e1.miterLimit = r.miterlimit, e1.setLineDash(r.dasharray), e1.lineDashOffset = r.dashoffset;
            const n = r.opacity / 255;
            switch(r.paint){
                case "rgb_color":
                    e1.strokeStyle = G(r.rgb_color, r.opacity, s);
                    break;
                case "linear_gradient_idx":
                    e1.strokeStyle = J(e1, t1.linear_gradients[r.linear_gradient_idx], n, s, !0);
                    break;
                case "radial_gradient_idx":
                    e1.strokeStyle = ee(e1, t1.radial_gradients[r.radial_gradient_idx], n, s, !0);
            }
            switch(r.linejoin){
                case 2:
                case 1:
                    e1.lineJoin = "miter";
                    break;
                case 3:
                    e1.lineJoin = "round";
                    break;
                case 4:
                    e1.lineJoin = "bevel";
            }
            switch(r.linecap){
                case 1:
                    e1.lineCap = "butt";
                    break;
                case 2:
                    e1.lineCap = "round";
                    break;
                case 3:
                    e1.lineCap = "square";
            }
            e1.stroke(o);
        }
        function J(e1, t1, i, s, r = !1) {
            if (1 === t1.stops.length) {
                const e1 = t1.stops[0];
                return G(e1.rgb_color, e1.opacity * i, s);
            }
            const { x1: o, y1: n, x2: a, y2: l } = t1;
            let c = new DOMPoint(o, n), h = new DOMPoint(a, l);
            if (r) {
                const e1 = re(t1.transform);
                c = e1.transformPoint(c), h = e1.transformPoint(h);
            }
            const d = e1.createLinearGradient(c.x, c.y, h.x, h.y);
            for (const e1 of t1.stops)d.addColorStop(e1.offset, G(e1.rgb_color, e1.opacity * i, s));
            return d;
        }
        function ee(e1, t1, i, s, r = !1) {
            if (1 === t1.stops.length) {
                const e1 = t1.stops[0];
                return G(e1.rgb_color, e1.opacity * i, s);
            }
            const o = re(t1.transform), { fx: n, fy: a, fr: l, cx: c, cy: h, r: d } = t1;
            let u = new DOMPoint(n, a), p = new DOMPoint(c, h), f = l, m = d;
            if (r) {
                u = o.transformPoint(u), p = o.transformPoint(p);
                const e1 = (o.a + o.d) / 2;
                f = l * e1, m = t1.r * e1;
            }
            const _ = e1.createRadialGradient(u.x, u.y, f, p.x, p.y, m);
            for (const e1 of t1.stops)_.addColorStop(e1.offset, G(e1.rgb_color, e1.opacity * i, s));
            return _;
        }
        function te(e1, t1, i, s) {
            const r = s.transform ? re(s.transform).preMultiplySelf(t1) : t1, o = $(e1.canvas.width, e1.canvas.height);
            for (const e1 of s.children)if (e1.group) te(o, r, i, e1.group);
            else if (e1.path) {
                const t1 = e1.path, i = new Path2D;
                i.addPath(ne(t1), r), o.fill(i, Y(t1));
            }
            const n = null != s.clip_path_idx ? i.clip_paths[s.clip_path_idx] : null;
            n && ie(o, r, i, n), e1.globalCompositeOperation = "source-over", e1.drawImage(o.canvas, 0, 0), H();
        }
        function ie(e1, t1, i, s) {
            const r = $(e1.canvas.width, e1.canvas.height);
            te(r, t1, i, s), e1.globalCompositeOperation = "destination-in", e1.drawImage(r.canvas, 0, 0), H();
        }
        function se(e1, t1, i, s, r) {
            if (0 === s.children.length) return;
            const o = null != s.mask_idx ? i.masks[s.mask_idx] : null;
            o && se(e1, t1, i, o, r);
            const n = e1.canvas.width, a = e1.canvas.height, l = $(n, a), c = s.width, h = s.height, d = s.left, u = s.top, p = new Path2D, f = new Path2D;
            f.rect(d, u, c, h), p.addPath(f, t1), l.clip(p);
            for (const e1 of s.children)X(l, t1, i, e1, r);
            const m = l.getImageData(0, 0, n, a), _ = m.data;
            if (1 === s.mask_type) for(let e1 = 0; e1 < _.length; e1 += 4)_[e1 + 3] = _[e1 + 3] / 255 * (.2126 * _[e1] + .7152 * _[e1 + 1] + .0722 * _[e1 + 2]);
            l.putImageData(m, 0, 0), e1.globalCompositeOperation = "destination-in", e1.drawImage(l.canvas, 0, 0), H();
        }
        function re(e1) {
            return e1 ? new DOMMatrix([
                e1.sx,
                e1.ky,
                e1.kx,
                e1.sy,
                e1.tx,
                e1.ty
            ]) : new DOMMatrix;
        }
        function oe(e1, t1) {
            const i = e1.step;
            let s = e1.diffs[0] * i, r = e1.diffs[1] * i;
            t1.moveTo(s, r);
            for(let o = 0, n = 2; o < e1.commands.length; o++)switch(e1.commands[o]){
                case 1:
                    s += e1.diffs[n++] * i, r += e1.diffs[n++] * i, t1.moveTo(s, r);
                    break;
                case 2:
                    s += e1.diffs[n++] * i, r += e1.diffs[n++] * i, t1.lineTo(s, r);
                    break;
                case 3:
                    {
                        const o = s + e1.diffs[n++] * i, a = r + e1.diffs[n++] * i;
                        s = o + e1.diffs[n++] * i, r = a + e1.diffs[n++] * i, t1.quadraticCurveTo(o, a, s, r);
                        break;
                    }
                case 4:
                    {
                        const o = s + e1.diffs[n++] * i, a = r + e1.diffs[n++] * i, l = o + e1.diffs[n++] * i, c = a + e1.diffs[n++] * i;
                        s = l + e1.diffs[n++] * i, r = c + e1.diffs[n++] * i, t1.bezierCurveTo(o, a, l, c, s, r);
                        break;
                    }
                case 5:
                    t1.closePath();
            }
            return t1;
        }
        function ne(e1) {
            return oe(e1, new Path2D);
        }
        class ae {
            constructor(){
                this.cacheMap = new Map, this.cacheDependenciesMap = new Map;
            }
            static _getImage(t1) {
                return new e1.b(t1, t1.data);
            }
            getFromCache(t1, i, s) {
                return this.cacheMap.has(s) || this.cacheMap.set(s, new e1.L(150)), this.cacheMap.get(s).get(e1.m(t1.toString(), i));
            }
            setInCache(t1, i, s, r) {
                this.cacheDependenciesMap.has(r) || this.cacheDependenciesMap.set(r, new Map), this.cacheMap.has(r) || this.cacheMap.set(r, new e1.L(150));
                const o = this.cacheDependenciesMap.get(r), n = e1.m(t1.id.toString(), s);
                o.get(n) || o.set(n, new Set);
                const a = this.cacheMap.get(r), l = t1.toString();
                o.get(n).add(l), a.put(e1.m(t1.toString(), s), i);
            }
            removeImagesFromCacheByIds(t1, i, s = 0) {
                if (!this.cacheMap.has(s) || !this.cacheDependenciesMap.has(s)) return;
                const r = this.cacheMap.get(s), o = this.cacheDependenciesMap.get(s);
                for (const s of t1){
                    const t1 = e1.m(s.toString(), i);
                    if (o.has(t1)) {
                        for (const e1 of o.get(t1))r.delete(e1);
                        o.delete(t1);
                    }
                }
            }
            rasterize(e1, t1, i, s) {
                const r = this.getFromCache(e1, i, s);
                if (r) return r.clone();
                const o = function(e1, t1) {
                    const i = V.calculate(t1.params, e1.metadata ? e1.metadata.variables : []), s = e1.usvg_tree, r = s.width, o = s.height, n = Math.max(1, Math.round(r * t1.sx)), a = Math.max(1, Math.round(o * t1.sy)), l = new DOMMatrix([
                        n / r,
                        0,
                        0,
                        a / o,
                        0,
                        0
                    ]), c = $(n, a);
                    W(c, l, s, s, i);
                    const h = c.getImageData(0, 0, n, a);
                    return H(), h;
                }(t1.icon, e1), n = ae._getImage(o);
                return this.setInCache(e1, n, i, s), n.clone();
            }
        }
        class le extends e1.E {
            constructor(t1){
                super(), this.imageProviders = new Map, this.images = new Map, this.updatedImages = new Map, this.callbackDispatchedThisFrame = new Map, this.imageVersions = new Map, this.loaded = new Map, this.requestors = [], this.patterns = new Map, this.patternsInFlight = new Set, this.atlasImage = new Map, this.atlasTexture = new Map, this.imageAtlasCache = new e1.d, this.dirty = !0, this.spriteFormat = t1, this.imageRasterizer = new ae;
            }
            addScope(t1) {
                this.loaded.set(t1, !1), this.imageProviders.set(t1, new Map), this.images.set(t1, new Map), this.updatedImages.set(t1, new Set), this.callbackDispatchedThisFrame.set(t1, new Set), this.imageVersions.set(t1, new Map), this.patterns.set(t1, new Map), this.atlasImage.set(t1, new e1.b({
                    width: 1,
                    height: 1
                }));
            }
            removeScope(e1) {
                this.loaded.delete(e1), this.imageProviders.delete(e1), this.images.delete(e1), this.updatedImages.delete(e1), this.callbackDispatchedThisFrame.delete(e1), this.imageVersions.delete(e1), this.patterns.delete(e1), this.atlasImage.delete(e1);
                const t1 = this.atlasTexture.get(e1);
                t1 && (t1.destroy(), this.atlasTexture.delete(e1));
            }
            addImageProvider(e1, t1) {
                this.imageProviders.has(t1) || this.imageProviders.set(t1, new Map), this.imageProviders.get(t1).set(e1.id, e1);
            }
            removeImageProvider(e1, t1) {
                this.imageProviders.has(t1) && this.imageProviders.get(t1).delete(e1);
            }
            getPendingImageProviders() {
                const e1 = [];
                for (const t1 of this.imageProviders.values())for (const i of t1.values())i.hasPendingRequests() && e1.push(i);
                return e1;
            }
            isLoaded() {
                for (const e1 of this.loaded.keys())if (!this.loaded.get(e1)) return !1;
                return !0;
            }
            setLoaded(e1, t1) {
                if (this.loaded.get(t1) !== e1 && (this.loaded.set(t1, e1), e1)) {
                    for (const { ids: e1, callback: i } of this.requestors)this._notify(e1, t1, i);
                    this.requestors = [];
                }
            }
            hasImage(e1, t1) {
                return !!this.getImage(e1, t1);
            }
            getImage(e1, t1) {
                return this.images.get(t1).get(e1.toString());
            }
            addImage(e1, t1, i) {
                if (this._validate(e1, i)) {
                    this.images.get(t1).set(e1.toString(), i);
                    const s = this.imageVersions.get(t1), r = s.get(e1.toString()) || 0;
                    s.set(e1.toString(), r + 1);
                }
            }
            _validate(t1, i) {
                let s = !0;
                return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new e1.f(new Error(`Image "${t1.name}" has invalid "stretchX" value`))), s = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new e1.f(new Error(`Image "${t1.name}" has invalid "stretchY" value`))), s = !1), this._validateContent(i.content, i) || (this.fire(new e1.f(new Error(`Image "${t1.name}" has invalid "content" value`))), s = !1), s;
            }
            _validateStretch(e1, t1) {
                if (!e1) return !0;
                let i = 0;
                for (const s of e1){
                    if (s[0] < i || s[1] < s[0] || t1 < s[1]) return !1;
                    i = s[1];
                }
                return !0;
            }
            _validateContent(e1, t1) {
                if (!e1) return !0;
                if (4 !== e1.length) return !1;
                if (!t1.usvg) {
                    if (e1[0] < 0 || t1.data.width < e1[0]) return !1;
                    if (e1[1] < 0 || t1.data.height < e1[1]) return !1;
                    if (e1[2] < 0 || t1.data.width < e1[2]) return !1;
                    if (e1[3] < 0 || t1.data.height < e1[3]) return !1;
                }
                return !(e1[2] < e1[0] || e1[3] < e1[1]);
            }
            updateImage(e1, t1, i) {
                const s = this.images.get(t1).get(e1.toString());
                i.version = s.version + 1, this.images.get(t1).set(e1.toString(), i), this.updatedImages.get(t1).add(e1);
                const r = this.imageVersions.get(t1), o = r.get(e1.toString()) || 0;
                r.set(e1.toString(), o + 1), this.removeFromImageRasterizerCache(e1, t1);
            }
            clearUpdatedImages(e1) {
                this.updatedImages.get(e1).clear();
            }
            removeFromImageRasterizerCache(e1, t1) {
                "raster" !== this.spriteFormat && this.imageRasterizer.removeImagesFromCacheByIds([
                    e1
                ], t1);
            }
            removeImage(e1, t1) {
                const i = this.images.get(t1), s = i.get(e1.toString());
                i.delete(e1.toString());
                const r = this.imageVersions.get(t1), o = r.get(e1.toString()) || 0;
                r.set(e1.toString(), o + 1), this.patterns.get(t1).delete(e1.toString()), this.removeFromImageRasterizerCache(e1, t1), s.userImage && s.userImage.onRemove && s.userImage.onRemove();
            }
            listImages(t1) {
                return Array.from(this.images.get(t1).keys()).map((t1)=>e1.I.from(t1));
            }
            getImageVersions(e1) {
                return this.imageVersions.get(e1) || new Map;
            }
            hasImageProviderForSource(e1, t1) {
                const i = this.imageProviders.get(t1);
                if (!i) return !1;
                for (const t1 of i.values())if (t1.sourceCache.getSource().id === e1) return !0;
                return !1;
            }
            getImages(e1, t1, i) {
                const s = [], r = [], o = this.imageProviders.get(t1);
                for (const i of e1){
                    if (!i.iconsetId) {
                        s.push(i);
                        continue;
                    }
                    const e1 = o.get(i.iconsetId);
                    e1 && (this.getImage(i, t1) ? r.push(i) : e1.addPendingRequest(i));
                }
                if (0 === s.length) return void this._notify(r, t1, i);
                let n = !0;
                const a = !!this.loaded.get(t1), l = this.images.get(t1);
                if (!a) for (const e1 of s)l.has(e1.toString()) || (n = !1);
                a || n ? this._notify(s, t1, i) : this.requestors.push({
                    ids: s,
                    scope: t1,
                    callback: i
                });
            }
            rasterizeImages(e1, t1) {
                const i = new Map, { iconTasks: s, patternTasks: r, scope: o } = e1;
                for (const e1 of [
                    s,
                    r
                ])for (const [t1, s] of e1.entries()){
                    const e1 = this.getImage(s.id, o);
                    e1 && i.set(t1, {
                        image: e1,
                        imageVariant: s
                    });
                }
                t1(null, this._rasterizeImages(o, i));
            }
            _rasterizeImages(e1, t1) {
                const i = new Map;
                for (const [s, { image: r, imageVariant: o }] of t1.entries())i.set(s, this.imageRasterizer.rasterize(o, r, e1, 0));
                return i;
            }
            getUpdatedImages(e1) {
                return this.updatedImages.get(e1) || new Set;
            }
            _notify(t1, i, s) {
                const r = this.images.get(i), o = new Map;
                for (const i of t1){
                    if (!r.get(i.toString())) {
                        if (i.iconsetId) continue;
                        this.fire(new e1.h("styleimagemissing", {
                            id: i.name
                        }));
                    }
                    const t1 = r.get(i.toString());
                    if (!t1) {
                        e1.w(`Image "${i.name}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                        continue;
                    }
                    const s = {
                        data: t1.usvg ? null : t1.data.clone(),
                        pixelRatio: t1.pixelRatio,
                        sdf: t1.sdf,
                        usvg: t1.usvg,
                        stretchX: t1.stretchX,
                        stretchY: t1.stretchY,
                        content: t1.content,
                        hasRenderCallback: Boolean(t1.userImage && t1.userImage.render)
                    };
                    t1.usvg && Object.assign(s, {
                        width: t1.icon.usvg_tree.width,
                        height: t1.icon.usvg_tree.height
                    }), o.set(e1.I.toString(i), s);
                }
                s(null, {
                    images: o,
                    versions: this.getImageVersions(i)
                });
            }
            getPixelSize(e1) {
                const { width: t1, height: i } = this.atlasImage.get(e1);
                return {
                    width: t1,
                    height: i
                };
            }
            getPattern(t1, i, s) {
                const r = t1.toString(), o = this.patterns.get(i), n = o.get(r), a = this.getImage(t1, i);
                if (!a) return null;
                if (n) {
                    if (n.position.version === a.version) return n.position;
                    n.position.version = a.version;
                } else {
                    if (a.usvg && !a.data) {
                        const o = this.getPatternInFlightId(r, i);
                        if (this.patternsInFlight.has(o)) return null;
                        this.patternsInFlight.add(o);
                        const n = new e1.i(t1).scaleSelf(e1.e.devicePixelRatio), l = new Map([
                            [
                                n.toString(),
                                {
                                    image: a,
                                    imageVariant: n
                                }
                            ]
                        ]), c = this._rasterizeImages(i, l);
                        return this.storePatternImage(n, i, a, s, c), null;
                    }
                    this.storePattern(t1, i, a);
                }
                return this._updatePatternAtlas(i, s), o.get(r).position;
            }
            getPatternInFlightId(t1, i) {
                return e1.m(t1, i);
            }
            hasPatternsInFlight() {
                return 0 !== this.patternsInFlight.size;
            }
            storePatternImage(e1, t1, i, s, r) {
                const o = e1.toString(), n = r ? r.get(o) : void 0;
                n && (i.data = n, this.storePattern(e1.id, t1, i), this._updatePatternAtlas(t1, s), this.patternsInFlight.delete(this.getPatternInFlightId(e1.id.toString(), t1)));
            }
            storePattern(t1, i, s) {
                const r = {
                    w: s.data.width + 2 * e1.j,
                    h: s.data.height + 2 * e1.j,
                    x: 0,
                    y: 0
                }, o = new e1.k(r, s, e1.j);
                this.patterns.get(i).set(t1.toString(), {
                    bin: r,
                    position: o
                });
            }
            destroyAtlasTextures() {
                for (const e1 of this.atlasTexture.values())e1 && e1.destroy();
                this.atlasTexture.clear();
            }
            bind(t1, i) {
                const s = t1.gl;
                let r = this.atlasTexture.get(i);
                r ? this.dirty && (r.update(this.atlasImage.get(i)), this.dirty = !1) : (r = new e1.T(t1, this.atlasImage.get(i), s.RGBA8), this.atlasTexture.set(i, r)), r.bind(s.LINEAR, s.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas(t1, i) {
                const s = this.patterns.get(t1), r = Array.from(s.values()).map(({ bin: e1 })=>e1), { w: o, h: n } = e1.p(r), a = this.atlasImage.get(t1);
                a.resize({
                    width: o || 1,
                    height: n || 1
                });
                const l = this.images.get(t1);
                for (const [t1, { bin: r, position: o }] of s.entries()){
                    let s = o.padding;
                    const n = r.x + s, c = r.y + s, h = l.get(t1).data, d = h.width, u = h.height;
                    s = s > 1 ? s - 1 : s, e1.b.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n,
                        y: c
                    }, {
                        width: d,
                        height: u
                    }, i), e1.b.copy(h, a, {
                        x: 0,
                        y: u - s
                    }, {
                        x: n,
                        y: c - s
                    }, {
                        width: d,
                        height: s
                    }, i), e1.b.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n,
                        y: c + u
                    }, {
                        width: d,
                        height: s
                    }, i), e1.b.copy(h, a, {
                        x: d - s,
                        y: 0
                    }, {
                        x: n - s,
                        y: c
                    }, {
                        width: s,
                        height: u
                    }, i), e1.b.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n + d,
                        y: c
                    }, {
                        width: s,
                        height: u
                    }, i), e1.b.copy(h, a, {
                        x: d - s,
                        y: u - s
                    }, {
                        x: n - s,
                        y: c - s
                    }, {
                        width: s,
                        height: s
                    }, i), e1.b.copy(h, a, {
                        x: 0,
                        y: u - s
                    }, {
                        x: n + d,
                        y: c - s
                    }, {
                        width: s,
                        height: s
                    }, i), e1.b.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n + d,
                        y: c + u
                    }, {
                        width: s,
                        height: s
                    }, i), e1.b.copy(h, a, {
                        x: d - s,
                        y: 0
                    }, {
                        x: n - s,
                        y: c + u
                    }, {
                        width: s,
                        height: s
                    }, i);
                }
                this.dirty = !0;
            }
            beginFrame() {
                for (const e1 of this.images.keys())this.callbackDispatchedThisFrame.set(e1, new Set);
                this.imageAtlasCache.beginFrame();
            }
            dispatchRenderCallbacks(e1, t1) {
                const i = this.images.get(t1);
                for (const s of e1){
                    if (this.callbackDispatchedThisFrame.get(t1).has(s.toString())) continue;
                    this.callbackDispatchedThisFrame.get(t1).add(s.toString());
                    const e1 = i.get(s.toString());
                    w(e1) && this.updateImage(s, t1, e1);
                }
            }
        }
        class ce {
            constructor(e1, t1, i, s){
                this.message = (e1 ? `${e1}: ` : "") + i, s && (this.identifier = s), null != t1 && t1.__line__ && (this.line = t1.__line__);
            }
        }
        class he extends ce {
        }
        function de(t1) {
            const i = t1.value, s = t1.valueSpec, r = t1.style, o = t1.styleSpec, n = t1.key, a = t1.arrayElementValidator || ze;
            if (!Array.isArray(i)) return [
                new ce(n, i, `array expected, ${e1.n(i)} found`)
            ];
            if (s.length && i.length !== s.length) return [
                new ce(n, i, `array length ${s.length} expected, length ${i.length} found`)
            ];
            if (s["min-length"] && i.length < s["min-length"]) return [
                new ce(n, i, `array length at least ${s["min-length"]} expected, length ${i.length} found`)
            ];
            let l = {
                type: s.value,
                values: s.values,
                minimum: s.minimum,
                maximum: s.maximum,
                function: void 0
            };
            o.$version < 7 && (l.function = s.function), e1.l(s.value) && (l = s.value);
            let c = [];
            for(let e1 = 0; e1 < i.length; e1++)c = c.concat(a({
                array: i,
                arrayIndex: e1,
                value: i[e1],
                valueSpec: l,
                style: r,
                styleSpec: o,
                key: `${n}[${e1}]`
            }, !0));
            return c;
        }
        function ue(t1) {
            const i = t1.key, s = t1.value, r = t1.valueSpec;
            if (!e1.q(s)) return [
                new ce(i, s, `number expected, ${e1.n(s)} found`)
            ];
            if (s != s) return [
                new ce(i, s, "number expected, NaN found")
            ];
            if ("minimum" in r) {
                let e1 = r.minimum;
                if (Array.isArray(r.minimum) && (e1 = r.minimum[t1.arrayIndex]), s < e1) return [
                    new ce(i, s, `${s} is less than the minimum value ${e1}`)
                ];
            }
            if ("maximum" in r) {
                let e1 = r.maximum;
                if (Array.isArray(r.maximum) && (e1 = r.maximum[t1.arrayIndex]), s > e1) return [
                    new ce(i, s, `${s} is greater than the maximum value ${e1}`)
                ];
            }
            return [];
        }
        function pe(t1) {
            const i = t1.key, s = t1.value;
            if (!e1.l(s)) return [
                new ce(i, s, `object expected, ${e1.n(s)} found`)
            ];
            const r = t1.valueSpec, o = e1.u(s.type);
            let n, a, l, c = {};
            const h = "categorical" !== o && void 0 === s.property, d = !h, u = function(t1) {
                const i = t1.stops;
                return Array.isArray(i) && Array.isArray(i[0]) && e1.l(i[0][0]);
            }(s), p = Ue({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(e1) {
                        if ("identity" === o) return [
                            new ce(e1.key, e1.value, 'identity function may not have a "stops" property')
                        ];
                        let t1 = [];
                        const i = e1.value;
                        return t1 = t1.concat(de({
                            key: e1.key,
                            value: i,
                            valueSpec: e1.valueSpec,
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            arrayElementValidator: f
                        })), Array.isArray(i) && 0 === i.length && t1.push(new ce(e1.key, i, "array must have at least one stop")), t1;
                    },
                    default: function(e1) {
                        return ze({
                            key: e1.key,
                            value: e1.value,
                            valueSpec: r,
                            style: e1.style,
                            styleSpec: e1.styleSpec
                        });
                    }
                }
            });
            return "identity" === o && h && p.push(new ce(t1.key, t1.value, 'missing required property "property"')), "identity" === o || s.stops || p.push(new ce(t1.key, t1.value, 'missing required property "stops"')), "exponential" === o && r.expression && !e1.r(r) && p.push(new ce(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (d && !e1.t(r) ? p.push(new ce(t1.key, t1.value, "property functions not supported")) : h && !e1.v(r) && p.push(new ce(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== o && !u || void 0 !== s.property || p.push(new ce(t1.key, t1.value, '"property" property is required')), p;
            function f(t1) {
                let i = [];
                const s = t1.value, o = t1.key;
                if (!Array.isArray(s)) return [
                    new ce(o, s, `array expected, ${e1.n(s)} found`)
                ];
                if (2 !== s.length) return [
                    new ce(o, s, `array length 2 expected, length ${s.length} found`)
                ];
                if (u) {
                    if (!e1.l(s[0])) return [
                        new ce(o, s, `object expected, ${e1.n(s[0])} found`)
                    ];
                    const r = s[0];
                    if (void 0 === r.zoom) return [
                        new ce(o, s, "object stop key must have zoom")
                    ];
                    if (void 0 === r.value) return [
                        new ce(o, s, "object stop key must have value")
                    ];
                    const n = e1.u(r.zoom);
                    if ("number" != typeof n) return [
                        new ce(o, r.zoom, "stop zoom values must be numbers")
                    ];
                    if (l && l > n) return [
                        new ce(o, r.zoom, "stop zoom values must appear in ascending order")
                    ];
                    n !== l && (l = n, a = void 0, c = {}), i = i.concat(Ue({
                        key: `${o}[0]`,
                        value: s[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: ue,
                            value: m
                        }
                    }));
                } else i = i.concat(m({
                    key: `${o}[0]`,
                    value: s[0],
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, s));
                return e1.x(e1.y(s[1])) ? i.concat([
                    new ce(`${o}[1]`, s[1], "expressions are not allowed in function stops.")
                ]) : i.concat(ze({
                    key: `${o}[1]`,
                    value: s[1],
                    valueSpec: r,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function m(t1, i) {
                const s = e1.n(t1.value), l = e1.u(t1.value), h = null !== t1.value ? t1.value : i;
                if (n) {
                    if (s !== n) return [
                        new ce(t1.key, h, `${s} stop domain type must match previous stop domain type ${n}`)
                    ];
                } else n = s;
                if ("number" !== s && "string" !== s && "boolean" !== s && "number" != typeof l && "string" != typeof l && "boolean" != typeof l) return [
                    new ce(t1.key, h, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== s && "categorical" !== o) {
                    let i = `number expected, ${s} found`;
                    return e1.t(r) && void 0 === o && (i += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new ce(t1.key, h, i)
                    ];
                }
                return "categorical" !== o || "number" !== s || "number" == typeof l && isFinite(l) && Math.floor(l) === l ? "categorical" !== o && "number" === s && "number" == typeof l && "number" == typeof a && void 0 !== a && l < a ? [
                    new ce(t1.key, h, "stop domain values must appear in ascending order")
                ] : (a = l, "categorical" === o && l in c ? [
                    new ce(t1.key, h, "stop domain values must be unique")
                ] : (c[l] = !0, [])) : [
                    new ce(t1.key, h, `integer expected, found ${String(l)}`)
                ];
            }
        }
        function fe(t1) {
            const i = ("property" === t1.expressionContext ? e1.z : e1.c)(e1.y(t1.value), t1.valueSpec);
            if ("error" === i.result) return i.value.map((e1)=>new ce(`${t1.key}${e1.key}`, t1.value, e1.message));
            const s = i.value.expression || i.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !s.outputDefined()) return [
                new ce(t1.key, t1.value, `Invalid data expression for "${t1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !e1.A(s)) return [
                new ce(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext) return me(s, t1);
            if ("appearance" === t1.expressionContext) return ye(s, t1);
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!e1.B(s, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new ce(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !e1.D(s)) return [
                    new ce(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function me(t1, i) {
            const s = new Set([
                "zoom",
                "feature-state",
                "pitch",
                "distance-from-center"
            ]);
            if (i.valueSpec && i.valueSpec.expression) for (const e1 of i.valueSpec.expression.parameters)s.delete(e1);
            if (0 === s.size) return [];
            const r = [];
            return t1 instanceof e1.F && s.has(t1.name) ? [
                new ce(i.key, i.value, `["${t1.name}"] expression is not supported in a filter for a ${i.object.type} layer with id: ${i.object.id}`)
            ] : (t1.eachChild((e1)=>{
                r.push(...me(e1, i));
            }), r);
        }
        const _e = new Set([
            "get",
            "has",
            "properties",
            "geometry-type",
            "id"
        ]), ge = new Set([
            "zoom",
            "pitch",
            "distance-from-center",
            "feature",
            "feature-state",
            "measure-light",
            "heatmap-density",
            "line-progress",
            "raster-value",
            "raster-particle-speed",
            "sky-radial-progress"
        ]);
        function ye(t1, i) {
            if (i.valueSpec && i.valueSpec.expression) for (const e1 of i.valueSpec.expression.parameters)ge.delete(e1);
            if (0 === ge.size) return [];
            const s = [];
            if (t1 instanceof e1.F) {
                const e1 = _e.has(t1.name) ? "feature" : t1.name;
                if (ge.has(e1)) return [
                    new ce(i.key, i.value, `["${t1.name}"] is not an allowed parameter`)
                ];
            }
            return t1.eachChild((e1)=>{
                s.push(...ye(e1, i));
            }), s;
        }
        function ve(t1) {
            const i = t1.key, s = t1.value, r = t1.valueSpec, o = [];
            return Array.isArray(r.values) ? r.values.includes(e1.u(s)) || o.push(new ce(i, s, `expected one of [${r.values.join(", ")}], ${JSON.stringify(s)} found`)) : Object.keys(r.values).includes(e1.u(s)) || o.push(new ce(i, s, `expected one of [${Object.keys(r.values).join(", ")}], ${JSON.stringify(s)} found`)), o;
        }
        function be(t1) {
            if (e1.J(e1.y(t1.value))) {
                const e1 = t1.layerType || "fill";
                return fe({
                    ...t1,
                    expressionContext: "filter",
                    valueSpec: t1.styleSpec[`filter_${e1}`]
                });
            }
            return xe(t1);
        }
        function xe(t1) {
            const i = t1.value, s = t1.key;
            if (!Array.isArray(i)) return [
                new ce(s, i, `array expected, ${e1.n(i)} found`)
            ];
            if (i.length < 1) return [
                new ce(s, i, "filter array must have at least 1 element")
            ];
            const r = t1.styleSpec;
            let o = ve({
                key: `${s}[0]`,
                value: i[0],
                valueSpec: r.filter_operator
            });
            const n = ()=>{
                i.length >= 2 && (e1.H(i[1]) || o.push(new ce(`${s}[1]`, i[1], `string expected, ${e1.n(i[1])} found`)));
                for(let t1 = 2; t1 < i.length; t1++)"$type" === e1.u(i[1]) ? o = o.concat(ve({
                    key: `${s}[${t1}]`,
                    value: i[t1],
                    valueSpec: r.geometry_type
                })) : e1.H(i[t1]) || e1.q(i[t1]) || e1.G(i[t1]) || o.push(new ce(`${s}[${t1}]`, i[t1], `string, number, or boolean expected, ${e1.n(i[t1])} found.`));
            };
            switch(e1.u(i[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    i.length >= 2 && "$type" === e1.u(i[1]) && o.push(new ce(s, i, `"$type" cannot be use with operator "${i[0]}"`)), 3 !== i.length && o.push(new ce(s, i, `filter array for operator "${i[0]}" must have 3 elements`)), n();
                    break;
                case "==":
                case "!=":
                    3 !== i.length && o.push(new ce(s, i, `filter array for operator "${i[0]}" must have 3 elements`)), n();
                    break;
                case "in":
                case "!in":
                    n();
                    break;
                case "any":
                case "all":
                case "none":
                    for(let e1 = 1; e1 < i.length; e1++)o = o.concat(xe({
                        key: `${s}[${e1}]`,
                        value: i[e1],
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    2 !== i.length ? o.push(new ce(s, i, `filter array for "${i[0]}" operator must have 2 elements`)) : e1.H(i[1]) || o.push(new ce(`${s}[1]`, i[1], `string expected, ${e1.n(i[1])} found`));
            }
            return o;
        }
        const we = /^{([^}]+)}$/;
        function Te(t1, i) {
            const s = t1.key, r = t1.style, o = t1.layer, n = t1.styleSpec, a = t1.value, l = t1.objectKey, c = n[`${i}_${t1.layerType}`];
            if (!c) return [];
            const h = l.match(e1.U);
            if (h && c[h[1]]) return e1.x(e1.y(a)) ? [].concat(ze({
                key: s,
                value: a,
                valueSpec: {
                    type: "string",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                style: r,
                styleSpec: n,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            })) : ze({
                key: s,
                value: a,
                valueSpec: {
                    type: "string"
                },
                style: r,
                styleSpec: n
            });
            const d = l.match(e1.K);
            if ("paint" === i && d && c[d[1]] && c[d[1]].transition) return ze({
                key: s,
                value: a,
                valueSpec: n.transition,
                style: r,
                styleSpec: n
            });
            const u = t1.valueSpec || c[l];
            if (!u) return [
                new he(s, a, `unknown property "${l}"`)
            ];
            let p;
            if (e1.H(a) && e1.t(u) && !u.tokens && (p = we.exec(a))) {
                const e1 = `\`{ "type": "identity", "property": ${p ? JSON.stringify(p[1]) : '"_"'} }\``;
                return [
                    new ce(s, a, `"${l}" does not support interpolation syntax\nUse an identity property function instead: ${e1}.`)
                ];
            }
            const f = [];
            if ("symbol" === t1.layerType) "text-field" !== l || !r || r.glyphs || r.imports || f.push(new ce(s, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === l && e1.M(e1.y(a)) && "identity" === e1.u(a.type) && f.push(new ce(s, a, '"text-font" does not support identity functions'));
            else if ("model" === t1.layerType && "paint" === i && o && o.layout && Object.hasOwn(o.layout, "model-id") && e1.t(u) && (e1.N(u) || e1.v(u))) {
                const t1 = e1.z(e1.y(a), u).value, i = "expression" in t1 && t1.expression || "_styleExpression" in t1 && t1._styleExpression && t1._styleExpression.expression;
                i && !e1.B(i, [
                    "measure-light"
                ]) && ("model-emissive-strength" === l && e1.D(i) && e1.A(i) || f.push(new ce(s, a, `${l} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
            }
            return f.concat(ze({
                key: t1.key,
                value: a,
                valueSpec: u,
                style: r,
                styleSpec: n,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            }));
        }
        function Se(e1) {
            return Te(e1, "paint");
        }
        function Ce(e1) {
            return Te(e1, "layout");
        }
        function Ee(t1) {
            let i = [];
            const s = t1.value, r = t1.key, o = t1.style, n = t1.styleSpec;
            if (!e1.l(s)) return [
                new ce(r, s, "object expected")
            ];
            s.type || s.ref || i.push(new ce(r, s, 'either "type" or "ref" is required'));
            let a = e1.u(s.type);
            const l = e1.u(s.ref);
            if (s.id) {
                const n = e1.u(s.id);
                for(let a = 0; a < t1.arrayIndex; a++){
                    const t1 = o.layers[a];
                    e1.u(t1.id) === n && i.push(new ce(r, s.id, `duplicate layer id "${n}", previously used at line ${t1.id.__line__}`));
                }
            }
            if ("ref" in s) {
                let t1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((e1)=>{
                    e1 in s && i.push(new ce(r, s[e1], `"${e1}" is prohibited for ref layers`));
                }), o.layers.forEach((i)=>{
                    e1.u(i.id) === l && (t1 = i);
                }), t1 ? t1.ref ? i.push(new ce(r, s.ref, "ref cannot reference another ref layer")) : a = e1.u(t1.type) : "string" == typeof l && i.push(new ce(r, s.ref, `ref layer "${l}" not found`));
            } else if ("background" !== a && "sky" !== a && "slot" !== a) {
                if (s.source) {
                    if (e1.H(s.source)) {
                        const t1 = o.sources && Object.hasOwn(o.sources, s.source) ? o.sources[s.source] : void 0, n = t1 && e1.u(t1.type);
                        t1 ? "vector" === n && "raster" === a ? i.push(new ce(r, s.source, `layer "${s.id}" requires a raster source`)) : "raster" === n && "raster" !== a ? i.push(new ce(r, s.source, `layer "${s.id}" requires a vector source`)) : "vector" !== n || s["source-layer"] ? "raster-dem" === n && "hillshade" !== a ? i.push(new ce(r, s.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "raster-array" !== n || [
                            "raster",
                            "raster-particle"
                        ].includes(a) ? "line" === a && s.paint && s.paint["line-gradient"] && "geojson" === n && !t1.lineMetrics ? i.push(new ce(r, s, `layer "${s.id}" specifies a line-gradient, which requires the GeoJSON source to have \`lineMetrics\` enabled.`)) : "line" === a && s.paint && s.paint["line-trim-offset"] && "geojson" === n && !t1.lineMetrics ? i.push(new ce(r, s, `layer "${s.id}" specifies a line-trim-offset, which requires the GeoJSON source to have \`lineMetrics\` enabled.`)) : "raster-particle" === a && "raster-array" !== n && i.push(new ce(r, s.source, `layer "${s.id}" requires a 'raster-array' source.`)) : i.push(new ce(r, s.source, "raster-array source can only be used with layer type 'raster'.")) : i.push(new ce(r, s, `layer "${s.id}" must specify a "source-layer"`)) : i.push(new ce(r, s.source, `source "${s.source}" not found`));
                    } else i.push(new ce(`${r}.source`, s.source, '"source" must be a string'));
                } else i.push(new ce(r, s, 'missing required property "source"'));
            }
            return i = i.concat(Ue({
                key: r,
                value: s,
                valueSpec: n.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>ze({
                            key: `${r}.type`,
                            value: s.type,
                            valueSpec: n.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            object: s,
                            objectKey: "type"
                        }),
                    filter: (e1)=>be({
                            layerType: a,
                            ...e1
                        }),
                    layout: (e1)=>Ue({
                            layer: s,
                            key: e1.key,
                            value: e1.value,
                            valueSpec: {},
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            objectElementValidators: {
                                "*": (e1)=>Ce({
                                        layerType: a,
                                        ...e1
                                    })
                            }
                        }),
                    paint: (e1)=>Ue({
                            layer: s,
                            key: e1.key,
                            value: e1.value,
                            valueSpec: {},
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            objectElementValidators: {
                                "*": (e1)=>Se({
                                        layerType: a,
                                        layer: s,
                                        ...e1
                                    })
                            }
                        }),
                    appearances (t1) {
                        const i = de({
                            key: t1.key,
                            value: t1.value,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: (t1)=>(function(t1) {
                                    const { key: i, layer: s, layerType: r } = t1, o = e1.u(t1.value), n = e1.u(o.name), a = e1.u(o.condition), l = Ue({
                                        key: i,
                                        value: o,
                                        valueSpec: t1.styleSpec.appearance,
                                        style: t1.style,
                                        styleSpec: t1.styleSpec,
                                        objectElementValidators: {
                                            condition: (t1)=>(function(t1) {
                                                    const i = [];
                                                    return i.push(...fe({
                                                        key: t1.key,
                                                        value: t1.object.condition,
                                                        valueSpec: e1.s.appearance.condition,
                                                        expressionContext: "appearance"
                                                    })), i;
                                                })({
                                                    ...t1
                                                }),
                                            properties: (e1)=>(function(e1) {
                                                    const t1 = [], { styleSpec: i, layer: s, layerType: r } = e1, o = i[`paint_${r}`], n = i[`layout_${r}`], a = e1.object[e1.objectKey];
                                                    for(const i in a){
                                                        const l = i in o ? "paint" : i in n ? "layout" : void 0;
                                                        if (!l) {
                                                            t1.push(new ce(e1.key, i, `unknown property "${i}" for layer type "${r}"`));
                                                            continue;
                                                        }
                                                        const c = {
                                                            ...e1,
                                                            key: `${e1.key}.${i}`,
                                                            objectKey: i,
                                                            layer: s,
                                                            layerType: r,
                                                            value: a[i],
                                                            valueSpec: "paint" === l ? o[i] : n[i]
                                                        };
                                                        t1.push(...Te(c, l));
                                                    }
                                                    return t1;
                                                })({
                                                    layer: s,
                                                    layerType: r,
                                                    ...e1
                                                })
                                        }
                                    });
                                    return "hidden" !== n && void 0 === a && l.push(new ce(t1.key, "name", 'Appearance with name different than "hidden" must have a condition')), l;
                                })({
                                    layerType: a,
                                    layer: s,
                                    ...t1
                                })
                        }), r = Array.isArray(t1.value) ? t1.value : [], o = new Set;
                        return r.forEach((r, n)=>{
                            const a = e1.u(r.name);
                            if (a) {
                                if (o.has(a)) {
                                    const r = e1.u(s.id);
                                    i.push(new ce(t1.key, a, `Duplicated appearance name "${a}" for layer "${r}"`));
                                } else o.add(a);
                            }
                        }), i;
                    }
                }
            })), i;
        }
        function Ie({ key: t1, value: i }) {
            return e1.H(i) ? [] : [
                new ce(t1, i, `string expected, ${e1.n(i)} found`)
            ];
        }
        const De = {
            promoteId: function t1({ key: i, value: s }) {
                if (e1.H(s)) return Ie({
                    key: i,
                    value: s
                });
                if (Array.isArray(s)) {
                    const t1 = [], r = e1.y(s), o = e1.c(r);
                    return "error" === o.result ? (o.value.forEach((e1)=>{
                        t1.push(new ce(`${i}${e1.key}`, null, `${e1.message}`));
                    }), t1) : (e1.B(o.value.expression, [
                        "zoom",
                        "heatmap-density",
                        "line-progress",
                        "raster-value",
                        "sky-radial-progress",
                        "accumulated",
                        "is-supported-script",
                        "pitch",
                        "distance-from-center",
                        "measure-light",
                        "raster-particle-speed"
                    ]) || t1.push(new ce(`${i}`, null, "promoteId expression should be only feature dependent")), t1);
                }
                if (!e1.l(s)) return [
                    new ce(i, s, `string, expression or object expected, "${e1.n(s)}" found`)
                ];
                const r = [];
                for(const e1 in s)r.push(...t1({
                    key: `${i}.${e1}`,
                    value: s[e1]
                }));
                return r;
            }
        };
        function Pe(t1) {
            const i = t1.value, s = t1.key, r = t1.styleSpec, o = t1.style;
            if (!e1.l(i)) return [
                new ce(s, i, `object expected, ${e1.n(i)} found`)
            ];
            if (!("type" in i)) return [
                new ce(s, i, '"type" is required')
            ];
            const n = e1.u(i.type);
            let a = [];
            switch([
                "vector",
                "raster",
                "raster-dem",
                "raster-array"
            ].includes(n) && ("url" in i || "tiles" in i || a.push(new he(s, i, 'Either "url" or "tiles" is required.'))), n){
                case "vector":
                case "raster":
                case "raster-dem":
                case "raster-array":
                    return a = a.concat(Ue({
                        key: s,
                        value: i,
                        valueSpec: r[`source_${n.replace("-", "_")}`],
                        style: t1.style,
                        styleSpec: r,
                        objectElementValidators: De
                    })), a;
                case "geojson":
                    if (a = Ue({
                        key: s,
                        value: i,
                        valueSpec: r.source_geojson,
                        style: o,
                        styleSpec: r,
                        objectElementValidators: De
                    }), "cluster" in i && "clusterProperties" in i) {
                        if (!e1.l(i.clusterProperties)) return [
                            new ce(`${s}.clusterProperties`, i, `object expected, ${e1.n(i)} found`)
                        ];
                        for(const e1 in i.clusterProperties){
                            const t1 = i.clusterProperties[e1];
                            if (!Array.isArray(t1)) return [
                                new ce(`${s}.clusterProperties.${e1}`, t1, "array expected")
                            ];
                            const [r, o] = t1, n = "string" == typeof r ? [
                                r,
                                [
                                    "accumulated"
                                ],
                                [
                                    "get",
                                    e1
                                ]
                            ] : r;
                            a.push(...fe({
                                key: `${s}.${e1}.map`,
                                value: o,
                                expressionContext: "cluster-map"
                            })), a.push(...fe({
                                key: `${s}.${e1}.reduce`,
                                value: n,
                                expressionContext: "cluster-reduce"
                            }));
                        }
                    }
                    return a;
                case "video":
                    return Ue({
                        key: s,
                        value: i,
                        valueSpec: r.source_video,
                        style: o,
                        styleSpec: r
                    });
                case "image":
                    return Ue({
                        key: s,
                        value: i,
                        valueSpec: r.source_image,
                        style: o,
                        styleSpec: r
                    });
                case "canvas":
                    return [
                        new ce(s, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return ve({
                        key: `${s}.type`,
                        value: i.type,
                        valueSpec: {
                            values: Le(r)
                        }
                    });
            }
        }
        function Le(e1) {
            return e1.source.reduce((t1, i)=>{
                const s = e1[i];
                return "enum" === s.type.type && (t1 = t1.concat(Object.keys(s.type.values || {}))), t1;
            }, []);
        }
        function Re(e1, t1) {
            const i = !e1.includes("://");
            try {
                return new URL(e1, i && t1 ? "http://example.com" : void 0), !0;
            } catch (e1) {
                return !1;
            }
        }
        function Ae(t1) {
            const i = t1.value;
            return i ? e1.H(i) ? Re(i, !0) ? [] : [
                new ce(t1.key, i, `invalid url "${i}"`)
            ] : [
                new ce(t1.key, i, `string expected, "${e1.n(i)}" found`)
            ] : [];
        }
        function Me(t1) {
            const i = t1.value, s = t1.styleSpec, r = s.light, o = t1.style;
            if (void 0 === i) return [];
            if (!e1.l(i)) return [
                new ce("light", i, `object expected, ${e1.n(i)} found`)
            ];
            let n = [];
            for(const t1 in i){
                const a = t1.match(e1.K), l = t1.match(e1.U);
                n = n.concat(l && r[l[1]] ? ze({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: o,
                    styleSpec: s
                }) : a && r[a[1]] && r[a[1]].transition ? ze({
                    key: t1,
                    value: i[t1],
                    valueSpec: s.transition,
                    style: o,
                    styleSpec: s
                }) : r[t1] ? ze({
                    key: t1,
                    value: i[t1],
                    valueSpec: r[t1],
                    style: o,
                    styleSpec: s
                }) : [
                    new ce(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return n;
        }
        function Fe(t1) {
            const i = t1.value;
            if (!i) return [];
            const s = t1.key;
            if (!e1.l(i)) return [
                new ce(s, i, `object expected, ${e1.n(i)} found`)
            ];
            let r = [];
            const o = t1.styleSpec, n = o["light-3d"], a = t1.style, l = t1.style.lights;
            for (const e1 of [
                "type",
                "id"
            ])if (!(e1 in i)) return r = r.concat([
                new ce(s, i, `missing property "${e1}"`)
            ]), r;
            if (!e1.H(i.type)) return r = r.concat([
                new ce(`${s}.type`, i.type, "string expected")
            ]), r;
            if (l) for(let o = 0; o < t1.arrayIndex; o++){
                const t1 = e1.u(i.type), n = l[o];
                e1.u(n.type) === t1 && r.push(new ce(s, i.id, `duplicate light type "${i.type}", previously defined at line ${n.id.__line__}`));
            }
            const c = `properties_light_${i.type}`;
            if (!(c in o)) return r = r.concat([
                new ce(`${s}.type`, i, `Invalid light type ${i.type}`)
            ]), r;
            const h = o[c];
            for(const s in i)if ("properties" === s) {
                const n = i[s];
                if (!e1.l(n)) return r = r.concat([
                    new ce("properties", n, `object expected, ${e1.n(n)} found`)
                ]), r;
                for(const l in n){
                    const c = l.match(e1.K), d = l.match(e1.U);
                    r = r.concat(d && h[d[1]] ? ze({
                        key: s,
                        value: n[l],
                        valueSpec: {
                            type: "string"
                        },
                        style: a,
                        styleSpec: o
                    }) : c && h[c[1]] && h[c[1]].transition ? ze({
                        key: s,
                        value: i[s],
                        valueSpec: o.transition,
                        style: a,
                        styleSpec: o
                    }) : h[l] ? ze({
                        key: l,
                        value: n[l],
                        valueSpec: h[l],
                        style: a,
                        styleSpec: o
                    }) : [
                        new he(t1.key, n[l], `unknown property "${l}"`)
                    ]);
                }
            } else r = r.concat(n[s] ? ze({
                key: s,
                value: i[s],
                valueSpec: n[s],
                style: a,
                styleSpec: o
            }) : [
                new he(s, i[s], `unknown property "${s}"`)
            ]);
            return r;
        }
        function Oe(t1) {
            const i = t1.value, s = t1.key, r = t1.style, o = t1.styleSpec, n = o.terrain;
            if (null == i) return [];
            if (!e1.l(i)) return [
                new ce("terrain", i, `object expected, ${e1.n(i)} found`)
            ];
            let a = [];
            for(const t1 in i){
                const s = t1.match(e1.K), l = t1.match(e1.U);
                a = a.concat(l && n[l[1]] ? ze({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: r,
                    styleSpec: o
                }) : s && n[s[1]] && n[s[1]].transition ? ze({
                    key: t1,
                    value: i[t1],
                    valueSpec: o.transition,
                    style: r,
                    styleSpec: o
                }) : n[t1] ? ze({
                    key: t1,
                    value: i[t1],
                    valueSpec: n[t1],
                    style: r,
                    styleSpec: o
                }) : [
                    new he(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            if (i.source) {
                if (e1.H(i.source)) {
                    const t1 = r.sources && Object.hasOwn(r.sources, i.source) ? r.sources[i.source] : void 0, o = t1 && e1.u(t1.type);
                    t1 ? "raster-dem" !== o && a.push(new ce(`${s}.source`, i.source, `terrain cannot be used with a source of type ${o}, it only be used with a "raster-dem" source type`)) : a.push(new ce(`${s}.source`, i.source, `source "${i.source}" not found`));
                } else a.push(new ce(`${s}.source`, i.source, "source must be a string"));
            } else a.push(new ce(s, i, 'terrain is missing required property "source"'));
            return a;
        }
        function Be(t1) {
            const i = t1.value, s = t1.style, r = t1.styleSpec, o = r.fog;
            if (void 0 === i) return [];
            if (!e1.l(i)) return [
                new ce("fog", i, `object expected, ${e1.n(i)} found`)
            ];
            let n = [];
            for(const t1 in i){
                const a = t1.match(e1.K), l = t1.match(e1.U);
                n = n.concat(l && o[l[1]] ? ze({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: s,
                    styleSpec: r
                }) : a && o[a[1]] && o[a[1]].transition ? ze({
                    key: t1,
                    value: i[t1],
                    valueSpec: r.transition,
                    style: s,
                    styleSpec: r
                }) : o[t1] ? ze({
                    key: t1,
                    value: i[t1],
                    valueSpec: o[t1],
                    style: s,
                    styleSpec: r
                }) : [
                    new he(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return n;
        }
        const ke = {
            "*": ()=>[],
            array: de,
            boolean: function(t1) {
                const i = t1.value, s = t1.key;
                return e1.G(i) ? [] : [
                    new ce(s, i, `boolean expected, ${e1.n(i)} found`)
                ];
            },
            number: ue,
            color: function({ key: t1, value: i }) {
                return e1.H(i) ? void 0 === e1.C.parse(e1.u(i)) ? [
                    new ce(t1, i, `color expected, "${i}" found`)
                ] : [] : [
                    new ce(t1, i, `color expected, ${e1.n(i)} found`)
                ];
            },
            enum: ve,
            filter: be,
            function: pe,
            layer: Ee,
            object: Ue,
            source: Pe,
            model: Ae,
            light: Me,
            "light-3d": Fe,
            terrain: Oe,
            fog: Be,
            string: Ie,
            formatted: function(e1) {
                return 0 === Ie(e1).length ? [] : fe(e1);
            },
            resolvedImage: function(e1) {
                return 0 === Ie(e1).length ? [] : fe(e1);
            },
            projection: function(t1) {
                const i = t1.value, s = t1.styleSpec, r = s.projection, o = t1.style;
                if (e1.l(i)) {
                    let e1 = [];
                    for(const t1 in i)e1 = e1.concat(ze({
                        key: t1,
                        value: i[t1],
                        valueSpec: r[t1],
                        style: o,
                        styleSpec: s
                    }));
                    return e1;
                }
                return e1.H(i) ? [] : [
                    new ce("projection", i, `object or string expected, ${e1.n(i)} found`)
                ];
            },
            import: function(t1) {
                const i = t1.key, { value: s, styleSpec: r } = t1;
                if (!e1.l(s)) return [
                    new ce(i, s, "import must be an object")
                ];
                const { data: o, ...n } = s;
                Object.defineProperty(n, "__line__", {
                    value: s.__line__,
                    enumerable: !1
                });
                let a = Ue({
                    ...t1,
                    value: n,
                    valueSpec: r.import
                });
                "" === e1.u(n.id) && a.push(new ce(`${t1.key}.id`, n, "import id can't be an empty string"));
                const l = e1.u(n.id);
                return "__proto__" !== l && "constructor" !== l && "prototype" !== l || a.push(new ce(`${t1.key}.id`, n, `import id can't be "${String(l)}"`)), o && (a = a.concat(je(o, r, {
                    key: `${t1.key}.data`
                }))), a;
            },
            iconset: function(t1) {
                const i = t1.value, s = t1.key, r = t1.styleSpec, o = t1.style;
                if (!e1.l(i)) return [
                    new ce(s, i, "object expected")
                ];
                if (!i.type) return [
                    new ce(s, i, '"type" is required')
                ];
                const n = e1.u(i.type);
                let a = [];
                if (a = a.concat(Ue({
                    key: s,
                    value: i,
                    valueSpec: r[`iconset_${n}`],
                    style: o,
                    styleSpec: r
                })), function(e1, t1) {
                    return !("source" !== e1 || !t1.source);
                }(n, i)) {
                    const t1 = o.sources && Object.hasOwn(o.sources, i.source) ? o.sources[i.source] : void 0, r = t1 && e1.u(t1.type);
                    t1 ? "raster-array" !== r && a.push(new ce(s, i.source, `iconset cannot be used with a source of type ${String(r)}, it only be used with a "raster-array" source type`)) : a.push(new ce(s, i.source, `source "${i.source}" not found`));
                }
                return a;
            },
            option: function(t1) {
                const i = t1.styleSpec, s = t1.value, r = e1.l(s) && !0 === e1.u(s.array) || !e1.l(s) ? void 0 : e1.u(s.type);
                return Ue({
                    ...t1,
                    valueSpec: i.option,
                    objectElementValidators: r ? {
                        default: (e1)=>Array.isArray(e1.value) ? ze({
                                ...e1,
                                valueSpec: {
                                    ...e1.valueSpec,
                                    type: r
                                }
                            }) : ze(e1)
                    } : void 0
                });
            }
        };
        function ze(t1, i = !1) {
            const s = t1.value, r = t1.valueSpec, o = t1.styleSpec;
            if (r.expression) {
                if (e1.M(e1.u(s))) return pe(t1);
                if (e1.x(e1.y(s))) return fe(t1);
            }
            if (r.type && ke[r.type]) {
                const e1 = ke[r.type](t1);
                return !0 === i && e1.length > 0 && Array.isArray(t1.value) ? fe(t1) : e1;
            }
            return Ue({
                ...t1,
                valueSpec: r.type ? o[r.type] : r
            });
        }
        function Ue(t1) {
            const i = t1.key, s = t1.value, r = t1.valueSpec || {}, o = t1.objectElementValidators || {}, n = t1.style, a = t1.styleSpec;
            if (!e1.l(s)) return [
                new ce(i, s, `object expected, ${e1.n(s)} found`)
            ];
            let l = [];
            for(const e1 in s){
                if (!Object.hasOwn(s, e1)) continue;
                const t1 = e1.split(".")[0], c = Object.hasOwn(r, t1), h = Object.hasOwn(r, "*"), d = c ? r[t1] : h ? r["*"] : void 0;
                let u;
                Object.hasOwn(o, t1) ? u = o[t1] : c ? u = ze : Object.hasOwn(o, "*") ? u = o["*"] : h && (u = ze), u ? l = l.concat(u({
                    key: (i ? `${i}.` : i) + e1,
                    value: s[e1],
                    valueSpec: d,
                    style: n,
                    styleSpec: a,
                    object: s,
                    objectKey: e1
                }, s)) : l.push(new he(i, s[e1], `unknown property "${e1}"`));
            }
            for(const e1 in r){
                if (!Object.hasOwn(r, e1)) continue;
                if (Object.hasOwn(o, e1)) continue;
                const t1 = r[e1];
                !t1.required || void 0 !== t1.default || Object.hasOwn(s, e1) && void 0 !== s[e1] || l.push(new ce(i, s, `missing required property "${e1}"`));
            }
            return l;
        }
        function Ne({ key: e1, value: t1 }) {
            const i = Ie({
                key: e1,
                value: t1
            });
            if (i.length) return i;
            const s = t1;
            return s.includes("{fontstack}") || i.push(new ce(e1, t1, '"glyphs" url must include a "{fontstack}" token')), s.includes("{range}") || i.push(new ce(e1, t1, '"glyphs" url must include a "{range}" token')), i;
        }
        function je(t1, i = e1.s, s = {}) {
            return Ue({
                key: s.key || "",
                value: t1,
                valueSpec: {
                    ...i.$root,
                    "*": {
                        type: "*"
                    }
                },
                styleSpec: i,
                style: t1,
                objectElementValidators: {
                    glyphs: Ne
                }
            });
        }
        function Ve(e1) {
            return e1.slice().sort((e1, t1)=>e1.line && t1.line ? e1.line - t1.line : 0);
        }
        const Ge = "setStyle", qe = "addLayer", Ze = "removeLayer", $e = "setPaintProperty", He = "setLayerProperty", We = "setTerrain", Xe = "removeImport", Ke = "addIconset", Ye = "removeIconset";
        function Qe(e1, t1, i) {
            i.push({
                command: "addSource",
                args: [
                    e1,
                    t1[e1]
                ]
            });
        }
        function Je(e1, t1, i) {
            t1.push({
                command: "removeSource",
                args: [
                    e1
                ]
            }), i[e1] = !0;
        }
        function et(e1, t1, i, s) {
            Je(e1, i, s), Qe(e1, t1, i);
        }
        function tt(t1, i, s) {
            let r;
            for(r in t1[s])if (Object.hasOwn(t1[s], r) && "data" !== r && !e1.O(t1[s][r], i[s][r])) return !1;
            for(r in i[s])if (Object.hasOwn(i[s], r) && "data" !== r && !e1.O(t1[s][r], i[s][r])) return !1;
            return !0;
        }
        function it(t1, i, s, r, o, n) {
            let a;
            for(a in i = i || {}, t1 = t1 || {})Object.hasOwn(t1, a) && (e1.O(t1[a], i[a]) || s.push({
                command: n,
                args: [
                    r,
                    a,
                    i[a],
                    o
                ]
            }));
            for(a in i)Object.hasOwn(i, a) && !Object.hasOwn(t1, a) && (e1.O(t1[a], i[a]) || s.push({
                command: n,
                args: [
                    r,
                    a,
                    i[a],
                    o
                ]
            }));
        }
        function st(e1) {
            return e1.id;
        }
        function rt(e1, t1) {
            return e1[t1.id] = t1, e1;
        }
        const ot = new e1.C(1, 0, 0, 1), nt = new e1.C(0, 1, 0, 1), at = new e1.C(0, 0, 1, 1), lt = new e1.C(1, 0, 1, 1), ct = new e1.C(0, 1, 1, 1);
        function ht(t1, i, s, r, o, n, a) {
            const l = t1.context, c = t1.transform, h = l.gl, d = "globe" === c.projection.name, u = d ? [
                "PROJECTION_GLOBE_VIEW"
            ] : [];
            let p = e1.Q(s.projMatrix);
            if (d && e1.S(c.zoom) > 0) {
                const t1 = e1.V(s.canonical, c), i = e1.W(t1);
                p = e1.X(new Float32Array(16), c.globeMatrix, i), e1.X(p, c.projMatrix, p);
            }
            const f = e1.Y();
            f[12] += 2 * o / (e1.e.devicePixelRatio * c.width), f[13] += 2 * n / (e1.e.devicePixelRatio * c.height), e1.X(p, f, p);
            const m = t1.getOrCreateProgram("debug", {
                defines: u
            }), _ = i.getTileByID(s.key);
            t1.terrain && t1.terrain.setupElevationDraw(_, m);
            const g = e1.Z.disabled, y = e1._.disabled, v = t1.colorModeForRenderPass(), b = "$debug";
            l.activeTexture.set(h.TEXTURE0), t1.emptyTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), d ? _._makeGlobeTileDebugBuffers(t1.context, c) : _._makeDebugTileBoundsBuffers(t1.context, c.projection);
            const x = _._tileDebugBuffer || t1.debugBuffer, w = _._tileDebugIndexBuffer || t1.debugIndexBuffer, T = _._tileDebugSegments || t1.debugSegments;
            if (m.draw(t1, h.LINE_STRIP, g, y, v, e1.$.disabled, e1.a0(p, r.toPremultipliedRenderColor(null)), b, x, w, T, null, null, null, [
                _._globeTileDebugBorderBuffer
            ]), a) {
                const e1 = _.latestRawTileData, i = Math.floor((e1 && e1.byteLength || 0) / 1024);
                let r = s.canonical.toString();
                s.overscaledZ !== s.canonical.z && (r += ` => ${s.overscaledZ}`), r += ` ${_.state}`, r += ` ${i}kb`, function(e1, t1) {
                    e1.initDebugOverlayCanvas();
                    const i = e1.debugOverlayCanvas, s = e1.context.gl, r = e1.debugOverlayCanvas.getContext("2d");
                    r.clearRect(0, 0, i.width, i.height), r.shadowColor = "white", r.shadowBlur = 2, r.lineWidth = 1.5, r.strokeStyle = "white", r.textBaseline = "top", r.font = "bold 36px Open Sans, sans-serif", r.fillText(t1, 5, 5), r.strokeText(t1, 5, 5), e1.debugOverlayTexture.update(i), e1.debugOverlayTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                }(t1, r);
            }
            const S = i.getTile(s).tileSize, C = 512 / Math.min(S, 512) * (s.overscaledZ / c.zoom) * .5, E = _._tileDebugTextBuffer || t1.debugBuffer, I = _._tileDebugTextIndexBuffer || t1.quadTriangleIndexBuffer, D = _._tileDebugTextSegments || t1.debugSegments;
            m.draw(t1, h.TRIANGLES, g, y, e1.a1.alphaBlended, e1.$.disabled, e1.a0(p, e1.C.transparent.toPremultipliedRenderColor(null), C), b, E, I, D, null, null, null, [
                _._globeTileDebugTextBuffer
            ]);
        }
        function dt(e1, t1, i, s) {
            pt(e1, 0, t1 + i / 2, e1.transform.width, i, s);
        }
        function ut(e1, t1, i, s) {
            pt(e1, t1 - i / 2, 0, i, e1.transform.height, s);
        }
        function pt(t1, i, s, r, o, n) {
            const a = t1.context, l = a.gl;
            l.enable(l.SCISSOR_TEST), l.scissor(i * e1.e.devicePixelRatio, s * e1.e.devicePixelRatio, r * e1.e.devicePixelRatio, o * e1.e.devicePixelRatio), a.clear({
                color: n
            }), l.disable(l.SCISSOR_TEST);
        }
        function ft(t1, i, s) {
            const r = t1.context, o = r.gl, n = s.projMatrix, a = t1.getOrCreateProgram("debug"), l = i.getTileByID(s.key);
            t1.terrain && t1.terrain.setupElevationDraw(l, a);
            const c = e1.Z.disabled, h = e1._.disabled, d = t1.colorModeForRenderPass(), u = "$debug";
            r.activeTexture.set(o.TEXTURE0), t1.emptyTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            const p = l.queryGeometryDebugViz, f = l.queryBoundsDebugViz;
            if (p && p.vertices.length > 0) {
                p.lazyUpload(r);
                const i = p.vertexBuffer, s = p.indexBuffer, l = p.segments;
                null != i && null != s && null != l && a.draw(t1, o.LINE_STRIP, c, h, d, e1.$.disabled, e1.a0(n, p.color.toPremultipliedRenderColor(null)), u, i, s, l);
            }
            if (f && f.vertices.length > 0) {
                f.lazyUpload(r);
                const i = f.vertexBuffer, s = f.indexBuffer, l = f.segments;
                null != i && null != s && null != l && a.draw(t1, o.LINE_STRIP, c, h, d, e1.$.disabled, e1.a0(n, f.color.toPremultipliedRenderColor(null)), u, i, s, l);
            }
        }
        const mt = (t1, i, s, r, o, n, a, l)=>{
            const c = e1.a2 / n.tileSize;
            return {
                u_matrix: t1,
                u_inv_rot_matrix: i,
                u_camera_to_center_distance: s.getCameraToCenterDistance(l),
                u_extrude_scale: [
                    s.pixelsToGLUnits[0] / c,
                    s.pixelsToGLUnits[1] / c
                ],
                u_zoom_transition: r,
                u_tile_id: a,
                u_merc_center: o
            };
        }, _t = (e1, t1, i, s)=>({
                u_matrix: e1,
                u_inv_matrix: t1,
                u_camera_to_center_distance: i.getCameraToCenterDistance(s),
                u_viewport_size: [
                    i.width,
                    i.height
                ]
            });
        function gt(t1, i, s) {
            const r = i.createTileMatrix(t1, t1.worldSize, s.toUnwrapped());
            return e1.X(new Float32Array(16), t1.projMatrix, r);
        }
        function yt(e1, t1, i) {
            if (t1.projection.name === i.projection.name) return e1.projMatrix;
            const s = i.clone();
            return s.setProjection(t1.projection), gt(s, t1.getProjection(), e1);
        }
        function vt(e1, t1, i) {
            return t1.name === i.projection.name ? e1.projMatrix : gt(i, t1, e1);
        }
        let bt;
        const xt = {
            loaded: !0,
            validateStyle: function(t1, i = e1.s) {
                return Ve(je(t1, i));
            },
            validateSource: (e1)=>Ve(Pe(e1)),
            validateLight: (e1)=>Ve(Me(e1)),
            validateLights: (e1)=>Ve(Fe(e1)),
            validateTerrain: (e1)=>Ve(Oe(e1)),
            validateFog: (e1)=>Ve(Be(e1)),
            validateSnow: (t1)=>Ve(function(t1) {
                    const i = t1.value, s = t1.style, r = t1.styleSpec, o = r.snow;
                    if (void 0 === i) return [];
                    if (!e1.l(i)) return [
                        new ce("snow", i, `object expected, ${e1.n(i)} found`)
                    ];
                    let n = [];
                    for(const t1 in i){
                        const a = t1.match(e1.K);
                        n = n.concat(a && o[a[1]] && o[a[1]].transition ? ze({
                            key: t1,
                            value: i[t1],
                            valueSpec: r.transition,
                            style: s,
                            styleSpec: r
                        }) : o[t1] ? ze({
                            key: t1,
                            value: i[t1],
                            valueSpec: o[t1],
                            style: s,
                            styleSpec: r
                        }) : [
                            new he(t1, i[t1], `unknown property "${t1}"`)
                        ]);
                    }
                    return n;
                }(t1)),
            validateRain: (t1)=>Ve(function(t1) {
                    const i = t1.value, s = t1.style, r = t1.styleSpec, o = r.rain;
                    if (void 0 === i) return [];
                    if (!e1.l(i)) return [
                        new ce("rain", i, `object expected, ${e1.n(i)} found`)
                    ];
                    let n = [];
                    for(const t1 in i){
                        const a = t1.match(e1.K);
                        n = n.concat(a && o[a[1]] && o[a[1]].transition ? ze({
                            key: t1,
                            value: i[t1],
                            valueSpec: r.transition,
                            style: s,
                            styleSpec: r
                        }) : o[t1] ? ze({
                            key: t1,
                            value: i[t1],
                            valueSpec: o[t1],
                            style: s,
                            styleSpec: r
                        }) : [
                            new he(t1, i[t1], `unknown property "${t1}"`)
                        ]);
                    }
                    return n;
                }(t1)),
            validateLayer: (e1)=>Ve(Ee(e1)),
            validateFilter: (e1)=>Ve(be(e1)),
            validatePaintProperty: (e1)=>Ve(Se(e1)),
            validateLayoutProperty: (e1)=>Ve(Ce(e1)),
            validateModel: (e1)=>Ve(Ae(e1)),
            diffStyles: function(t1, i) {
                if (!t1) return [
                    {
                        command: Ge,
                        args: [
                            i
                        ]
                    }
                ];
                let s = [];
                try {
                    if (!e1.O(t1.version, i.version)) return [
                        {
                            command: Ge,
                            args: [
                                i
                            ]
                        }
                    ];
                    if (e1.O(t1.center, i.center) || s.push({
                        command: "setCenter",
                        args: [
                            i.center
                        ]
                    }), e1.O(t1.zoom, i.zoom) || s.push({
                        command: "setZoom",
                        args: [
                            i.zoom
                        ]
                    }), e1.O(t1.bearing, i.bearing) || s.push({
                        command: "setBearing",
                        args: [
                            i.bearing
                        ]
                    }), e1.O(t1.pitch, i.pitch) || s.push({
                        command: "setPitch",
                        args: [
                            i.pitch
                        ]
                    }), e1.O(t1.sprite, i.sprite) || s.push({
                        command: "setSprite",
                        args: [
                            i.sprite
                        ]
                    }), e1.O(t1.glyphs, i.glyphs) || s.push({
                        command: "setGlyphs",
                        args: [
                            i.glyphs
                        ]
                    }), e1.O(t1.imports, i.imports) || function(t1 = [], i = [], s) {
                        i = i || [];
                        const r = (t1 = t1 || []).map(st), o = i.map(st), n = t1.reduce(rt, {}), a = i.reduce(rt, {}), l = r.slice();
                        let c, h, d, u;
                        for(c = 0, h = 0; c < r.length; c++)d = r[c], Object.hasOwn(a, d) ? h++ : (s.push({
                            command: Xe,
                            args: [
                                d
                            ]
                        }), l.splice(l.indexOf(d, h), 1));
                        for(c = 0, h = 0; c < o.length; c++)d = o[o.length - 1 - c], l[l.length - 1 - c] !== d && (Object.hasOwn(n, d) ? (s.push({
                            command: Xe,
                            args: [
                                d
                            ]
                        }), l.splice(l.lastIndexOf(d, l.length - h), 1)) : h++, u = l[l.length - c], s.push({
                            command: "addImport",
                            args: [
                                a[d],
                                u
                            ]
                        }), l.splice(l.length - c, 0, d));
                        for (const t1 of i){
                            const i = n[t1.id];
                            i && (delete i.data, e1.O(i, t1) || s.push({
                                command: "updateImport",
                                args: [
                                    t1.id,
                                    t1
                                ]
                            }));
                        }
                    }(t1.imports, i.imports, s), e1.O(t1.transition, i.transition) || s.push({
                        command: "setTransition",
                        args: [
                            i.transition
                        ]
                    }), e1.O(t1.light, i.light) || s.push({
                        command: "setLight",
                        args: [
                            i.light
                        ]
                    }), e1.O(t1.fog, i.fog) || s.push({
                        command: "setFog",
                        args: [
                            i.fog
                        ]
                    }), e1.O(t1.snow, i.snow) || s.push({
                        command: "setSnow",
                        args: [
                            i.snow
                        ]
                    }), e1.O(t1.rain, i.rain) || s.push({
                        command: "setRain",
                        args: [
                            i.rain
                        ]
                    }), e1.O(t1.projection, i.projection) || s.push({
                        command: "setProjection",
                        args: [
                            i.projection
                        ]
                    }), e1.O(t1.lights, i.lights) || s.push({
                        command: "setLights",
                        args: [
                            i.lights
                        ]
                    }), e1.O(t1.camera, i.camera) || s.push({
                        command: "setCamera",
                        args: [
                            i.camera
                        ]
                    }), e1.O(t1.iconsets, i.iconsets) || function(t1, i, s) {
                        let r;
                        for(r in i = i || {}, t1 = t1 || {})Object.hasOwn(t1, r) && (Object.hasOwn(i, r) || s.push({
                            command: Ye,
                            args: [
                                r
                            ]
                        }));
                        for(r in i){
                            if (!Object.hasOwn(i, r)) continue;
                            const o = i[r];
                            Object.hasOwn(t1, r) ? e1.O(t1[r], o) || (s.push({
                                command: Ye,
                                args: [
                                    r
                                ]
                            }), s.push({
                                command: Ke,
                                args: [
                                    r,
                                    o
                                ]
                            })) : s.push({
                                command: Ke,
                                args: [
                                    r,
                                    o
                                ]
                            });
                        }
                    }(t1.iconsets, i.iconsets, s), !e1.O(t1["color-theme"], i["color-theme"])) return [
                        {
                            command: Ge,
                            args: [
                                i
                            ]
                        }
                    ];
                    const r = {}, o = [];
                    !function(t1, i, s, r) {
                        let o;
                        for(o in i = i || {}, t1 = t1 || {})Object.hasOwn(t1, o) && (Object.hasOwn(i, o) || Je(o, s, r));
                        for(o in i){
                            if (!Object.hasOwn(i, o)) continue;
                            const n = i[o];
                            Object.hasOwn(t1, o) ? e1.O(t1[o], n) || ("geojson" === t1[o].type && "geojson" === n.type && tt(t1, i, o) ? s.push({
                                command: "setGeoJSONSourceData",
                                args: [
                                    o,
                                    n.data
                                ]
                            }) : et(o, i, s, r)) : Qe(o, i, s);
                        }
                    }(t1.sources, i.sources, o, r);
                    const n = [];
                    t1.layers && t1.layers.forEach((e1)=>{
                        e1.source && r[e1.source] ? s.push({
                            command: Ze,
                            args: [
                                e1.id
                            ]
                        }) : n.push(e1);
                    });
                    let a = t1.terrain;
                    a && r[a.source] && (s.push({
                        command: We,
                        args: [
                            void 0
                        ]
                    }), a = void 0), s = s.concat(o), e1.O(a, i.terrain) || s.push({
                        command: We,
                        args: [
                            i.terrain
                        ]
                    }), function(t1, i, s) {
                        i = i || [];
                        const r = (t1 = t1 || []).map(st), o = i.map(st), n = t1.reduce(rt, {}), a = i.reduce(rt, {}), l = r.slice(), c = Object.create(null);
                        let h, d, u, p, f, m, _;
                        for(h = 0, d = 0; h < r.length; h++)u = r[h], Object.hasOwn(a, u) ? d++ : (s.push({
                            command: Ze,
                            args: [
                                u
                            ]
                        }), l.splice(l.indexOf(u, d), 1));
                        for(h = 0, d = 0; h < o.length; h++)u = o[o.length - 1 - h], l[l.length - 1 - h] !== u && (Object.hasOwn(n, u) ? (s.push({
                            command: Ze,
                            args: [
                                u
                            ]
                        }), l.splice(l.lastIndexOf(u, l.length - d), 1)) : d++, m = l[l.length - h], s.push({
                            command: qe,
                            args: [
                                a[u],
                                m
                            ]
                        }), l.splice(l.length - h, 0, u), c[u] = !0);
                        for(h = 0; h < o.length; h++)if (u = o[h], p = n[u], f = a[u], !c[u] && !e1.O(p, f)) {
                            if (e1.O(p.source, f.source) && e1.O(p["source-layer"], f["source-layer"]) && e1.O(p.type, f.type)) {
                                for(_ in it(p.layout, f.layout, s, u, null, "setLayoutProperty"), it(p.paint, f.paint, s, u, null, $e), e1.O(p.slot, f.slot) || s.push({
                                    command: "setSlot",
                                    args: [
                                        u,
                                        f.slot
                                    ]
                                }), e1.O(p.filter, f.filter) || s.push({
                                    command: "setFilter",
                                    args: [
                                        u,
                                        f.filter
                                    ]
                                }), e1.O(p.minzoom, f.minzoom) && e1.O(p.maxzoom, f.maxzoom) || s.push({
                                    command: "setLayerZoomRange",
                                    args: [
                                        u,
                                        f.minzoom,
                                        f.maxzoom
                                    ]
                                }), p)Object.hasOwn(p, _) && "layout" !== _ && "paint" !== _ && "filter" !== _ && "metadata" !== _ && "minzoom" !== _ && "maxzoom" !== _ && "slot" !== _ && (0 === _.indexOf("paint.") ? it(p[_], f[_], s, u, _.slice(6), $e) : e1.O(p[_], f[_]) || s.push({
                                    command: He,
                                    args: [
                                        u,
                                        _,
                                        f[_]
                                    ]
                                }));
                                for(_ in f)Object.hasOwn(f, _) && !Object.hasOwn(p, _) && "layout" !== _ && "paint" !== _ && "filter" !== _ && "metadata" !== _ && "minzoom" !== _ && "maxzoom" !== _ && "slot" !== _ && (0 === _.indexOf("paint.") ? it(p[_], f[_], s, u, _.slice(6), $e) : e1.O(p[_], f[_]) || s.push({
                                    command: He,
                                    args: [
                                        u,
                                        _,
                                        f[_]
                                    ]
                                }));
                            } else s.push({
                                command: Ze,
                                args: [
                                    u
                                ]
                            }), m = l[l.lastIndexOf(u) + 1], s.push({
                                command: qe,
                                args: [
                                    f,
                                    m
                                ]
                            });
                        }
                    }(n, i.layers, s);
                } catch (e1) {
                    console.warn("Unable to compute style diff:", e1), s = [
                        {
                            command: Ge,
                            args: [
                                i
                            ]
                        }
                    ];
                }
                return s;
            },
            drawDebug: function(t1, i, s, r, o, n) {
                for(let a = 0; a < s.length; a++)if (o) {
                    const o = 1, l = .8, c = new e1.C(r.r * l, r.g * l, r.b * l, 1);
                    ht(t1, i, s[a], r, -o, -o, n), ht(t1, i, s[a], r, -o, o, n), ht(t1, i, s[a], r, o, o, n), ht(t1, i, s[a], r, o, -o, n), ht(t1, i, s[a], c, 0, 0, n);
                } else ht(t1, i, s[a], r, 0, 0, n);
            },
            drawDebugPadding: function(e1) {
                const t1 = e1.transform.padding;
                dt(e1, e1.transform.height - (t1.top || 0), 3, ot), dt(e1, t1.bottom || 0, 3, nt), ut(e1, t1.left || 0, 3, at), ut(e1, e1.transform.width - (t1.right || 0), 3, lt);
                const i = e1.transform.centerPoint;
                !function(e1, t1, i, s) {
                    pt(e1, t1 - 1, i - 10, 2, 20, s), pt(e1, t1 - 10, i - 1, 20, 2, s);
                }(e1, i.x, e1.transform.height - i.y, ct);
            },
            drawDebugQueryGeometry: function(e1, t1, i) {
                for(let s = 0; s < i.length; s++)ft(e1, t1, i[s]);
            },
            drawCollisionDebug: function(t1, i, s, r, o, n, a) {
                const l = t1.context, c = l.gl, h = t1.transform, d = [
                    e1.a7(h.center.lng),
                    e1.a8(h.center.lat)
                ], u = s.layout.get("symbol-placement"), p = s.layout.get("text-variable-anchor"), f = "map" === s.layout.get("icon-rotation-alignment"), m = "map" === s.layout.get("text-rotation-alignment"), _ = "point" !== u, g = [];
                let y = 0, v = 0;
                for(let l = 0; l < r.length; l++){
                    const u = r[l], b = i.getTile(u), x = b.getBucket(s);
                    if (!x) continue;
                    const w = x.getProjection().createInversionMatrix(h, u.canonical), T = [], S = yt(u, x, h), C = !a && f && _, E = a && m && _, I = p && x.hasTextData(), D = x.hasIconTextFit() && I && x.hasIconData(), P = C || E || a && I || D, L = "globe" === x.projection.name, R = L ? e1.S(h.zoom) : 0;
                    L && (T.push("PROJECTION_GLOBE_VIEW"), P && T.push("PROJECTED_POS_ON_VIEWPORT"));
                    const A = t1.getOrCreateProgram("collisionBox", {
                        defines: T
                    });
                    let M = S;
                    0 === o[0] && 0 === o[1] || (M = t1.translatePosMatrix(S, b, o, n));
                    const F = a ? x.textCollisionBox : x.iconCollisionBox, O = x.collisionCircleArray;
                    if (O.length > 0) {
                        const t1 = e1.Y(), i = M;
                        e1.a9(t1, x.placementInvProjMatrix, h.glCoordMatrix), e1.a9(t1, t1, x.placementViewportMatrix), g.push({
                            circleArray: O,
                            circleOffset: v,
                            transform: i,
                            invTransform: t1,
                            projection: x.getProjection()
                        }), y += O.length / 4, v = y;
                    }
                    if (!F) continue;
                    t1.terrain && t1.terrain.setupElevationDraw(b, A);
                    const B = L ? [
                        u.canonical.x,
                        u.canonical.y,
                        1 << u.canonical.z
                    ] : [
                        0,
                        0,
                        0
                    ];
                    A.draw(t1, c.LINES, e1.Z.disabled, e1._.disabled, t1.colorModeForRenderPass(), e1.$.disabled, mt(M, w, h, R, d, b, B, x.getProjection()), s.id, F.layoutVertexBuffer, F.indexBuffer, F.segments, null, h.zoom, null, [
                        F.collisionVertexBuffer,
                        F.collisionVertexBufferExt
                    ]);
                }
                if (!a || !g.length) return;
                const b = t1.getOrCreateProgram("collisionCircle"), x = new e1.aa;
                x.resize(4 * y), x._trim();
                let w = 0;
                for (const e1 of g)for(let t1 = 0; t1 < e1.circleArray.length / 4; t1++){
                    const i = 4 * t1, s = e1.circleArray[i + 0], r = e1.circleArray[i + 1], o = e1.circleArray[i + 2], n = e1.circleArray[i + 3];
                    x.emplace(w++, s, r, o, n, 0), x.emplace(w++, s, r, o, n, 1), x.emplace(w++, s, r, o, n, 2), x.emplace(w++, s, r, o, n, 3);
                }
                (!bt || bt.length < 2 * y) && (bt = function(t1) {
                    const i = 2 * t1, s = new e1.ad;
                    s.resize(i), s._trim();
                    for(let e1 = 0; e1 < i; e1++){
                        const t1 = 6 * e1;
                        s.uint16[t1 + 0] = 4 * e1 + 0, s.uint16[t1 + 1] = 4 * e1 + 1, s.uint16[t1 + 2] = 4 * e1 + 2, s.uint16[t1 + 3] = 4 * e1 + 2, s.uint16[t1 + 4] = 4 * e1 + 3, s.uint16[t1 + 5] = 4 * e1 + 0;
                    }
                    return s;
                }(y));
                const T = l.createIndexBuffer(bt, !0), S = l.createVertexBuffer(x, e1.ab.members, !0);
                for (const i of g){
                    const r = _t(i.transform, i.invTransform, h, i.projection);
                    b.draw(t1, c.TRIANGLES, e1.Z.disabled, e1._.disabled, t1.colorModeForRenderPass(), e1.$.disabled, r, s.id, S, T, e1.ac.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, h.zoom);
                }
                S.destroy(), T.destroy();
            }
        };
        async function wt() {
            return Promise.resolve();
        }
        function Tt(t1, i) {
            let s = !1;
            if (i && i.length) for (const r of i)r instanceof he ? e1.w(r.message) : (t1.fire(new e1.f(new Error(r.message))), s = !0);
            return s;
        }
        function St(e1) {
            return (...t1)=>{
                const i = xt[e1];
                return i ? i(...t1) : [];
            };
        }
        const Ct = St("validateStyle"), Et = St("validateSource"), It = St("validateLight"), Dt = St("validateLights"), Pt = St("validateTerrain"), Lt = St("validateFog"), Rt = St("validateSnow"), At = St("validateRain"), Mt = St("validateLayer"), Ft = St("validateFilter"), Ot = St("validatePaintProperty"), Bt = St("validateLayoutProperty"), kt = St("validateModel"), zt = e1.s.light;
        let Ut;
        class Nt extends e1.E {
            constructor(t1, i = "flat"){
                super(), this._transitionable = new e1.ae(Ut || (Ut = new e1.af({
                    anchor: new e1.ag(zt.anchor),
                    position: new e1.ah(zt.position),
                    color: new e1.ag(zt.color),
                    intensity: new e1.ag(zt.intensity)
                }))), this.setLight(t1, i), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e1, t1, i = {}) {
                this._validate(It, e1, i) || (this._transitionable.setTransitionOrValue(e1), this.id = t1);
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(t1, i, s) {
                return (!s || !1 !== s.validate) && Tt(this, t1.call(Ct, {
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.s
                }));
            }
        }
        const jt = e1.s.terrain;
        let Vt = class extends e1.E {
            constructor(t1, i, s, r, o){
                super(), this.scope = s, this._transitionable = new e1.ae(new e1.af({
                    source: new e1.ag(jt.source),
                    exaggeration: new e1.ag(jt.exaggeration)
                }), s, r), this._transitionable.setTransitionOrValue(t1, r), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = i, this.worldview = o;
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e1, t1) {
                this._transitionable.setTransitionOrValue(e1, t1);
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            getExaggeration(t1) {
                return this._transitioning.possiblyEvaluate(new e1.ai(t1, {
                    worldview: this.worldview
                })).get("exaggeration");
            }
            getAttenuationRange() {
                if (!this.isZoomDependent()) return null;
                const t1 = this._transitionable._values.exaggeration;
                if (!t1) return null;
                const i = t1.value.expression;
                if (!i) return null;
                let s = -1, r = -1, o = 1;
                for (const t1 of i.zoomStops)o = i.evaluate(new e1.ai(t1, {
                    worldview: this.worldview
                })), o > .01 ? (s = t1, r = -1) : r = t1;
                return o < .01 && s > 0 && r > s ? [
                    s,
                    r
                ] : null;
            }
            isZoomDependent() {
                const t1 = this._transitionable._values.exaggeration;
                return null != t1 && null != t1.value && null != t1.value.expression && t1.value.expression instanceof e1.aj;
            }
        };
        function Gt(e1, t1) {
            const i = e1 ? e1.terrain : null;
            return !!i && (!t1 || !!t1.projection.requiresDraping || !i.isZoomDependent() || i.getExaggeration(t1.zoom) > 0);
        }
        const qt = e1.s.fog;
        class Zt extends e1.E {
            constructor(t1, i, s, r){
                super();
                const o = new e1.af({
                    range: new e1.ag(qt.range),
                    color: new e1.ag(qt.color),
                    "color-use-theme": new e1.ag({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "high-color": new e1.ag(qt["high-color"]),
                    "high-color-use-theme": new e1.ag({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "space-color": new e1.ag(qt["space-color"]),
                    "space-color-use-theme": new e1.ag({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "horizon-blend": new e1.ag(qt["horizon-blend"]),
                    "star-intensity": new e1.ag(qt["star-intensity"]),
                    "vertical-range": new e1.ag(qt["vertical-range"])
                });
                this._transitionable = new e1.ae(o, s, r), this.set(t1, r), this._transitioning = this._transitionable.untransitioned(), this._transform = i, this.properties = new e1.ak(o), this.scope = s;
            }
            get state() {
                const t1 = this._transform, i = "globe" === t1.projection.name, s = e1.S(t1.zoom), r = this.properties.get("range"), o = [
                    2,
                    4.5
                ], n = .5 / Math.tan(.5 * t1._fov), a = [
                    r[0] + n,
                    r[1] + n
                ];
                return {
                    range: i ? [
                        e1.al(o[0], a[0], s),
                        e1.al(o[1], a[1], s)
                    ] : a,
                    horizonBlend: this.properties.get("horizon-blend"),
                    alpha: this.properties.get("color").a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e1, t1, i = {}) {
                if (this._validate(Lt, e1, i)) return;
                const s = {
                    ...e1
                };
                for (const e1 of Object.keys(qt))void 0 === s[e1] && (s[e1] = qt[e1].default);
                this._options = s, this._transitionable.setTransitionOrValue(this._options, t1);
            }
            getOpacity(t1) {
                if (!this._transform.projection.supportsFog) return 0;
                const i = this.properties && this.properties.get("color") || 1;
                return ("globe" === this._transform.projection.name ? 1 : e1.am(e1.ao, e1.an, t1)) * i.a;
            }
            getOpacityAtLatLng(t1, i) {
                return this._transform.projection.supportsFog ? e1.ap(this.state, t1, i) : 0;
            }
            getOpacityForTile(t1) {
                if (!this._transform.projection.supportsFog) return [
                    1,
                    1
                ];
                const i = this._transform.calculateFogTileMatrix(t1.toUnwrapped());
                return e1.aq(this.state, i, 0, 0, e1.a2, e1.a2, this._transform);
            }
            getOpacityForBounds(t1, i, s, r, o) {
                return this._transform.projection.supportsFog ? e1.aq(this.state, t1, i, s, r, o, this._transform) : [
                    1,
                    1
                ];
            }
            getRangeForProjection() {
                return this._transform.projection.supportsFog ? this.state.range : [
                    0,
                    1
                ];
            }
            isVisibleOnFrustum(t1) {
                if (!this._transform.projection.supportsFog) return !1;
                const i = [
                    4,
                    5,
                    6,
                    7
                ];
                for (const s of i){
                    const i = t1.points[s];
                    let r;
                    if (i[2] >= 0) r = i;
                    else {
                        const o = t1.points[s - 4];
                        r = e1.ar(o, i, o[2] / (o[2] - i[2]));
                    }
                    if (e1.as(this.state, r[0], r[1], 0, this._transform) >= e1.at) return !0;
                }
                return !1;
            }
            updateConfig(e1) {
                this._transitionable.setTransitionOrValue(this._options, e1);
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(t1, i, s) {
                return (!s || !1 !== s.validate) && Tt(this, t1.call(Ct, {
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.s
                }));
            }
        }
        let $t, Ht, Wt = class extends e1.E {
            constructor(t1, i, s, r){
                super();
                const o = $t || ($t = new e1.af({
                    density: new e1.ag(e1.s.snow.density),
                    intensity: new e1.ag(e1.s.snow.intensity),
                    color: new e1.ag(e1.s.snow.color),
                    opacity: new e1.ag(e1.s.snow.opacity),
                    vignette: new e1.ag(e1.s.snow.vignette),
                    "vignette-color": new e1.ag(e1.s.snow["vignette-color"]),
                    "center-thinning": new e1.ag(e1.s.snow["center-thinning"]),
                    direction: new e1.ag(e1.s.snow.direction),
                    "flake-size": new e1.ag(e1.s.snow["flake-size"])
                }));
                this._transitionable = new e1.ae(o, s, r), this.set(t1, r), this._transitioning = this._transitionable.untransitioned(), this.properties = new e1.ak(o), this.scope = s;
            }
            get state() {
                const t1 = this.properties.get("opacity"), i = this.properties.get("color"), s = this.properties.get("direction"), r = e1.au(s[0]), o = -Math.max(e1.au(s[1]), .01), n = [
                    Math.cos(r) * Math.cos(o),
                    Math.sin(r) * Math.cos(o),
                    Math.sin(o)
                ], a = this.properties.get("vignette"), l = this.properties.get("vignette-color"), c = new e1.C(l.r, l.g, l.b, a);
                return {
                    density: this.properties.get("density"),
                    intensity: this.properties.get("intensity"),
                    color: new e1.C(i.r, i.g, i.b, i.a * t1),
                    direction: n,
                    centerThinning: this.properties.get("center-thinning"),
                    flakeSize: this.properties.get("flake-size"),
                    vignetteColor: c
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, s = {}) {
                if (this._validate(Rt, t1, s)) return;
                const r = {
                    ...t1
                }, o = e1.s.snow;
                for (const e1 of Object.keys(o))void 0 === r[e1] && (r[e1] = o[e1].default);
                this._options = r, this._transitionable.setTransitionOrValue(this._options, i);
            }
            updateConfig(e1) {
                this._transitionable.setTransitionOrValue(this._options, e1);
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(t1, i, s) {
                return (!s || !1 !== s.validate) && Tt(this, t1.call(Ct, {
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.s
                }));
            }
        }, Xt = class extends e1.E {
            constructor(t1, i, s, r){
                super();
                const o = Ht || (Ht = new e1.af({
                    density: new e1.ag(e1.s.rain.density),
                    intensity: new e1.ag(e1.s.rain.intensity),
                    color: new e1.ag(e1.s.rain.color),
                    opacity: new e1.ag(e1.s.rain.opacity),
                    vignette: new e1.ag(e1.s.rain.vignette),
                    "vignette-color": new e1.ag(e1.s.rain["vignette-color"]),
                    "center-thinning": new e1.ag(e1.s.rain["center-thinning"]),
                    direction: new e1.ag(e1.s.rain.direction),
                    "droplet-size": new e1.ag(e1.s.rain["droplet-size"]),
                    "distortion-strength": new e1.ag(e1.s.rain["distortion-strength"])
                }));
                this._transitionable = new e1.ae(o, s, r), this.set(t1, r), this._transitioning = this._transitionable.untransitioned(), this.properties = new e1.ak(o), this.scope = s;
            }
            get state() {
                const t1 = this.properties.get("opacity"), i = this.properties.get("color"), s = this.properties.get("direction"), r = e1.au(s[0]), o = -Math.max(e1.au(s[1]), .01), n = [
                    Math.cos(r) * Math.cos(o),
                    Math.sin(r) * Math.cos(o),
                    Math.sin(o)
                ], a = this.properties.get("vignette-color"), l = new e1.C(a.r, a.g, a.b, this.properties.get("vignette"));
                return {
                    density: this.properties.get("density"),
                    intensity: this.properties.get("intensity"),
                    color: new e1.C(i.r, i.g, i.b, i.a * t1),
                    direction: n,
                    centerThinning: this.properties.get("center-thinning"),
                    dropletSize: this.properties.get("droplet-size"),
                    distortionStrength: this.properties.get("distortion-strength"),
                    vignetteColor: l
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, s = {}) {
                if (this._validate(At, t1, s)) return;
                const r = {
                    ...t1
                }, o = e1.s.rain;
                for (const e1 of Object.keys(o))void 0 === r[e1] && (r[e1] = o[e1].default);
                this._options = r, this._transitionable.setTransitionOrValue(this._options, i);
            }
            updateConfig(e1) {
                this._transitionable.setTransitionOrValue(this._options, e1);
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(t1, i, s) {
                return (!s || !1 !== s.validate) && Tt(this, t1.call(Ct, {
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.s
                }));
            }
        };
        const Kt = {
            workerUrl: "",
            workerClass: null,
            workerParams: void 0
        };
        function Yt(e1) {
            return null != Kt.workerClass ? new Kt.workerClass : new self.Worker(Kt.workerUrl, {
                name: e1,
                type: "module",
                ...Kt.workerParams
            });
        }
        const Qt = "mapboxgl_preloaded_worker_pool";
        class Jt {
            constructor(e1){
                this.active = {}, this.name = e1;
            }
            acquire(e1, t1 = Jt.workerCount) {
                if (!this.workers) for(this.workers = []; this.workers.length < t1;){
                    const t1 = Yt(`${this.name || ""}WorkerPool: ${e1}-${this.workers.length}`);
                    this.workers.push(t1);
                }
                return this.active[e1] = !0, this.workers.slice();
            }
            release(e1) {
                delete this.active[e1], this.workers && 0 === this.numActive() && (this.workers.forEach((e1)=>{
                    e1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[Qt];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        Jt.workerCount = 2;
        class ei {
            constructor(t1, i, s = "Worker", r = Jt.workerCount){
                this.workerPool = t1, this.actors = [], this.currentActor = 0, this.id = e1.av();
                const o = this.workerPool.acquire(this.id, r);
                for(let e1 = 0; e1 < o.length; e1++){
                    const t1 = new ei.Actor(o[e1], i, this.id);
                    t1.name = `${s} ${e1}`, this.actors.push(t1);
                }
                this.ready = !1, this.send("checkIfReady", null).then(()=>{
                    this.ready = !0;
                }).catch(()=>{});
            }
            send(e1, t1, i) {
                return Promise.all(this.actors.map((s)=>s.send(e1, t1, i)));
            }
            broadcast(e1, t1) {
                for (const i of this.actors)i.notify(e1, t1);
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
                this.actors.forEach((e1)=>{
                    e1.remove();
                }), this.actors = [], this.workerPool.release(this.id);
            }
        }
        ei.Actor = e1.aw;
        class ti extends e1.E {
            constructor(t1, i, s, r){
                super(), this.scope = s, this._options = t1, this.properties = new e1.ak(i), this._transitionable = new e1.ae(i, s, r), this._transitionable.setTransitionOrValue(t1.properties), this._transitioning = this._transitionable.untransitioned();
            }
            updateConfig(e1) {
                this._transitionable.setTransitionOrValue(this._options.properties, e1);
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            get() {
                return this._options.properties = this._transitionable.serialize(), this._options;
            }
            set(e1, t1) {
                this._options = e1, this._transitionable.setTransitionOrValue(e1.properties, t1);
            }
            shadowsEnabled() {
                return !!this.properties && !0 === this.properties.get("cast-shadows");
            }
        }
        let ii;
        const si = ()=>ii || (ii = new e1.af({
                color: new e1.ag(e1.s.properties_light_ambient.color),
                "color-use-theme": new e1.ag({
                    type: "string",
                    default: "default",
                    "property-type": "data-constant"
                }),
                intensity: new e1.ag(e1.s.properties_light_ambient.intensity)
            }));
        let ri;
        const oi = ()=>ri || (ri = new e1.af({
                direction: new e1.ax(e1.s.properties_light_directional.direction),
                color: new e1.ag(e1.s.properties_light_directional.color),
                "color-use-theme": new e1.ag({
                    type: "string",
                    default: "default",
                    "property-type": "data-constant"
                }),
                intensity: new e1.ag(e1.s.properties_light_directional.intensity),
                "cast-shadows": new e1.ag(e1.s.properties_light_directional["cast-shadows"]),
                "shadow-quality": new e1.ag(e1.s.properties_light_directional["shadow-quality"]),
                "shadow-intensity": new e1.ag(e1.s.properties_light_directional["shadow-intensity"]),
                "shadow-draw-before-layer": new e1.ag(e1.s.properties_light_directional["shadow-draw-before-layer"])
            })), ni = (e1, t1, i, s, r, o, n, a, l, c = [
            0,
            0,
            1
        ])=>({
                u_matrix: e1,
                u_normal_matrix: t1,
                u_opacity: i,
                u_faux_facade_ao_intensity: s,
                u_camera_pos: r,
                u_tile_to_meter: o,
                u_facade_emissive_chance: n,
                u_flood_light_color: a,
                u_flood_light_intensity: l,
                u_front_cutoff_params: c
            }), ai = (e1)=>({
                u_matrix: e1
            }), li = (e1)=>({
                u_matrix: e1
            }), ci = e1.ay;
        async function hi() {
            return Promise.resolve();
        }
        function di(t1, i, s, r, o, n, a, l) {
            s.resetLayerRenderingStats(t1);
            const c = t1.context, h = c.gl, d = t1.transform, u = s.paint.get("fill-extrusion-pattern"), p = s.paint.get("fill-extrusion-pattern-cross-fade"), f = u.constantOr(null), m = u.constantOr(1), _ = s.paint.get("fill-extrusion-opacity"), g = t1.style.enable3dLights(), y = s.paint.get(g && !m ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), v = [
                s.paint.get("fill-extrusion-ambient-occlusion-intensity"),
                y
            ], b = s.layout.get("fill-extrusion-edge-radius"), x = b > 0 && !s.paint.get("fill-extrusion-rounded-roof"), w = x ? 0 : b, T = "globe" === d.projection.name ? e1.aD() : 0, S = "globe" === d.projection.name, C = S ? e1.S(d.zoom) : 0, E = [
                e1.a7(d.center.lng),
                e1.a8(d.center.lat)
            ], I = "none" === s.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), D = s.paint.get("fill-extrusion-flood-light-color").toNonPremultipliedRenderColor(I ? null : s.lut).toArray01().slice(0, 3), P = s.paint.get("fill-extrusion-flood-light-intensity"), L = s.paint.get("fill-extrusion-vertical-scale"), R = 0 !== s.paint.get("fill-extrusion-line-width").constantOr(1), A = s.paint.get("fill-extrusion-height-alignment"), M = s.paint.get("fill-extrusion-base-alignment"), F = e1.aE(t1, s.paint.get("fill-extrusion-cutoff-fade-range")), O = s.paint.get("fill-extrusion-front-cutoff"), B = pi(d.pitch, O, !!t1.terrain), k = B[2] < 1;
            k && (t1.maxFrontCutoffRawStart = Math.max(t1.maxFrontCutoffRawStart, O[0]));
            const z = [];
            let U;
            S && z.push("PROJECTION_GLOBE_VIEW"), v[0] > 0 && z.push("FAUX_AO"), x && z.push("ZERO_ROOF_RADIUS"), l && z.push("HAS_CENTROID"), P > 0 && z.push("FLOOD_LIGHT"), F.shouldRenderCutoff && z.push("RENDER_CUTOFF"), k && z.push("RENDER_FRONT_CUTOFF"), R && z.push("RENDER_WALL_MODE");
            const N = "shadow" === t1.renderPass, j = t1.shadowRenderer, V = N && !!j, G = N ? e1.$.disabled : e1.$.backCCW;
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !0);
            let q = [
                0,
                0,
                0
            ];
            if (j) {
                const i = t1.style.directionalLight, s = t1.style.ambientLight;
                i && s && (q = e1.aF(t1.style, i, s)), N || (z.push("RENDER_SHADOWS"), j.useNormalOffset && z.push("NORMAL_OFFSET")), U = z.concat([
                    "SHADOWS_SINGLE_CASCADE"
                ]);
            }
            const Z = V ? "fillExtrusionDepth" : m ? "fillExtrusionPattern" : "fillExtrusion", $ = s.getLayerRenderingStats();
            for (const u of r){
                const r = i.getTile(u), g = r.getBucket(s);
                if (!g || g.projection.name !== d.projection.name) continue;
                let y = !1;
                j && (y = 0 === j.getMaxCascadeForTile(u.toUnwrapped()));
                const b = t1.isTileAffectedByFog(u), x = g.programConfigurations.get(s.id);
                let I = !1;
                if (f && r.imageAtlas) {
                    const t1 = r.imageAtlas, i = e1.aG.from(f), s = i.getPrimary().scaleSelf(e1.e.devicePixelRatio).toString(), o = i.getSecondary(), n = t1.patternPositions.get(s), a = o ? t1.patternPositions.get(o.scaleSelf(e1.e.devicePixelRatio).toString()) : null;
                    I = !!n && !!a, n && x.setConstantPatternPositions(n, a);
                }
                p > 0 && (I || x.getPatternTransitionVertexBuffer("fill-extrusion-pattern")) && z.push("FILL_EXTRUSION_PATTERN_TRANSITION");
                const O = t1.getOrCreateProgram(Z, {
                    config: x,
                    defines: y ? U : z,
                    overrideFog: b
                });
                if (t1.terrain && t1.terrain.setupElevationDraw(r, O, {
                    useMeterToDem: !0
                }), !g.centroidVertexBuffer) {
                    const e1 = O.getAttributeLocation(h, "a_centroid_pos");
                    -1 !== e1 && h.vertexAttribI4ui(e1, 0, 0, 0, 0);
                }
                !N && j && j.setupShadows(r.tileID.toUnwrapped(), O, "vector-tile"), m && (t1.context.activeTexture.set(h.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), x.updatePaintBuffers());
                const k = s.paint.get("fill-extrusion-vertical-gradient"), V = 1 / g.tileToMeter;
                let H;
                if (N && j) {
                    if (yi(r.tileID, g.maxHeight, t1)) continue;
                    const i = j.calculateShadowPassMatrixFromTile(r.tileID.toUnwrapped());
                    H = e1.aM(i, w, V, L, A, M);
                } else {
                    const i = t1.translatePosMatrix(u.expandedProjMatrix, r, s.paint.get("fill-extrusion-translate"), s.paint.get("fill-extrusion-translate-anchor")), o = d.projection.createInversionMatrix(d, u.canonical), n = O.fixedDefines.includes("LIGHTING_3D_MODE");
                    H = m ? e1.aH(i, t1, k, _, v, w, V, u, r, T, A, M, C, E, o, D, L, p, n) : e1.aI(i, t1, k, _, v, w, V, u, T, A, M, C, E, o, D, L, P, q, B, n);
                }
                t1.uploadCommonUniforms(c, O, u.toUnwrapped(), null, F);
                let W = g.segments;
                if ("mercator" === d.projection.name && !N && (W = g.getVisibleSegments(r.tileID, t1.terrain, t1.transform.getFrustum(0)), !W.get().length)) continue;
                if ($) {
                    if (N) for (const e1 of W.get())$.numRenderedVerticesInShadowPass += e1.primitiveLength;
                    else for (const e1 of W.get())$.numRenderedVerticesInTransparentPass += e1.primitiveLength;
                }
                const X = [];
                (t1.terrain || l) && X.push(g.centroidVertexBuffer), S && X.push(g.layoutVertexExtBuffer), R && X.push(g.wallVertexBuffer), O.draw(t1, c.gl.TRIANGLES, o, n, a, G, H, s.id, g.layoutVertexBuffer, g.indexBuffer, W, s.paint, t1.transform.zoom, x, X);
            }
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !1);
        }
        class ui {
            constructor(){
                this.translate = [
                    0,
                    0
                ], this.translateAnchor = "map", this.edgeRadius = 0, this.cutoffFadeRange = 0;
            }
        }
        function pi(e1, t1, i) {
            if (!(t1[2] < 1) || i) return [
                0,
                0,
                1
            ];
            const s = 180 * e1 / Math.PI;
            if (s < 15) return [
                -0.5,
                t1[1],
                t1[2]
            ];
            const r = Math.min(1, Math.max(0, (s - 15) / 5)), o = r * r * (3 - 2 * r);
            return [
                -0.5 * (1 - o) + t1[0] * o,
                t1[1],
                t1[2]
            ];
        }
        function fi(t1, i, s, r, o, n, a) {
            0 === r.centroidVertexArray.length && r.createCentroidsBuffer();
            const l = n ? n.findDEMTileFor(s) : null;
            if (!(l && l.dem || a)) return;
            n && l && l.dem && r.selfDEMTileTimestamp !== l.dem._timestamp && (r.borderDoneWithNeighborZ = [
                -1,
                -1,
                -1,
                -1
            ], r.selfDEMTileTimestamp = l.dem._timestamp);
            const c = (t1, i)=>{
                (t1.flags | i.flags) & e1.aJ ? (t1.flags |= e1.aJ, i.flags |= e1.aJ) : (t1.flags &= ~e1.aJ, i.flags &= ~e1.aJ);
            }, h = (t1)=>new e1.P(Math.ceil((t1 + e1.aK) * e1.aL), 0), d = (t1, i, s)=>{
                const r = Math.ceil((t1 + e1.aK) * e1.aL), o = Math.floor(Math.max(0, Math.min(e1.a2 - 1, s)) / 4);
                return new e1.P(r, o << 5 | (3 & i) << 3 | 7);
            }, u = (e1)=>{
                const t1 = i.getSource().minzoom, s = (e1)=>{
                    const t1 = i.getTileByID(e1);
                    if (t1 && t1.hasData()) return t1.getBucket(o);
                }, r = [
                    0,
                    -1,
                    1
                ];
                for (const i of r){
                    if (e1.overscaledZ + i < t1) continue;
                    const r = s(e1.calculateScaledKey(e1.overscaledZ + i));
                    if (r) return r;
                }
            }, p = [
                0,
                0,
                0
            ], f = (t1, i)=>(p[0] = Math.min(t1.min.y, i.min.y), p[1] = Math.max(t1.max.y, i.max.y), p[2] = e1.a2 - i.min.x > t1.max.x ? i.min.x - e1.a2 : t1.max.x, p), m = (t1, i)=>(p[0] = Math.min(t1.min.x, i.min.x), p[1] = Math.max(t1.max.x, i.max.x), p[2] = e1.a2 - i.min.y > t1.max.y ? i.min.y - e1.a2 : t1.max.y, p), _ = [
                (e1, t1)=>f(e1, t1),
                (e1, t1)=>f(t1, e1),
                (e1, t1)=>m(e1, t1),
                (e1, t1)=>m(t1, e1)
            ], g = (t1, i, r, o, a, c, h)=>{
                if (!n) return 0;
                const d = [
                    [
                        c ? r : t1,
                        c ? t1 : r,
                        0
                    ],
                    [
                        c ? r : i,
                        c ? i : r,
                        0
                    ]
                ], u = h < 0 ? e1.a2 + h : h, p = [
                    c ? u : (t1 + i) / 2,
                    c ? (t1 + i) / 2 : u,
                    0
                ];
                return 0 === r && h < 0 || 0 !== r && h > 0 ? n.getForTilePoints(a, [
                    p
                ], !0, o) : d.push(p), n.getForTilePoints(s, d, !0, l), Math.max(d[0][2], d[1][2], p[2]) / n.exaggeration();
            };
            for(let t1 = 0; t1 < 4; t1++){
                const i = r.borderFeatureIndices[t1];
                if (0 === i.length) continue;
                const o = e1.aB[t1](s), l = u(o);
                if (!(l && l instanceof e1.aC)) continue;
                const p = n ? n.findDEMTileFor(o) : null;
                if (!(p && p.dem || a)) continue;
                if (n && p && p.dem && r.borderDEMTileTimestamp[t1] !== p.dem._timestamp && (r.borderDoneWithNeighborZ[t1] = -1, r.borderDEMTileTimestamp[t1] = p.dem._timestamp), r.borderDoneWithNeighborZ[t1] === l.canonical.z) continue;
                0 === l.centroidVertexArray.length && l.createCentroidsBuffer();
                const f = (t1 < 2 ? 1 : 5) - t1, m = l.borderDoneWithNeighborZ[f] !== r.canonical.z, y = l.borderFeatureIndices[f];
                let v = 0;
                if (r.canonical.z !== l.canonical.z) {
                    for (const e1 of i)r.showCentroid(r.featuresOnBorder[e1]);
                    if (m) for (const e1 of y)l.showCentroid(l.featuresOnBorder[e1]);
                    r.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[f] = r.canonical.z;
                    continue;
                }
                const b = new Map, x = new Set, w = new Set;
                for(let e1 = 0; e1 < y.length; e1++){
                    const t1 = l.featuresOnBorder[y[e1]];
                    void 0 !== t1.buildingId && b.set(t1.buildingId, e1);
                }
                for (const s of i){
                    const i = r.featuresOnBorder[s], n = r.centroidData.get(i.centroidDataIndex);
                    if (void 0 === i.buildingId) continue;
                    const h = b.get(i.buildingId);
                    if (void 0 === h) continue;
                    const u = l.featuresOnBorder[y[h]], m = l.centroidData.get(u.centroidDataIndex);
                    x.add(s), w.add(h), a && c(n, m);
                    const v = 0 !== n.groupCentroidPos.x || 0 !== n.groupCentroidPos.y ? n.groupCentroidPos : i.centroid(), T = 0 !== m.groupCentroidPos.x || 0 !== m.groupCentroidPos.y ? m.groupCentroidPos : u.centroid(), S = t1 < 2 ? Math.round((v.y + T.y) / 2) : Math.round((v.x + T.x) / 2), C = i.intersectsCount() > 1 || u.intersectsCount() > 1;
                    {
                        let i = 0;
                        if (p && p.dem && !C) {
                            const s = _[t1](n, m), r = t1 % 2 ? e1.a2 - 1 : 0;
                            i = g(s[0], Math.min(e1.a2 - 1, s[1]), r, p, o, t1 < 2, s[2]);
                        }
                        n.centroidXY = d(i, t1, S), m.centroidXY = d(i, f, S);
                    }
                    if (r.writeCentroidToBuffer(n), l.writeCentroidToBuffer(m), void 0 !== i.buildingId) {
                        for (const e1 of r.centroidData)e1.buildingId === i.buildingId && e1 !== n && (e1.centroidXY = n.centroidXY, r.writeCentroidToBuffer(e1));
                        for (const e1 of l.centroidData)e1.buildingId === i.buildingId && e1 !== m && (e1.centroidXY = m.centroidXY, l.writeCentroidToBuffer(e1));
                    }
                }
                for (const s of i){
                    if (x.has(s)) continue;
                    const i = r.featuresOnBorder[s], n = r.centroidData.get(i.centroidDataIndex), d = i.borders[t1];
                    let u;
                    for(; v < y.length;){
                        if (w.has(v)) {
                            v++;
                            continue;
                        }
                        u = l.featuresOnBorder[y[v]];
                        const e1 = u.borders[f];
                        if (e1[1] > d[0] + 3 || e1[0] > d[0] - 3) break;
                        l.showCentroid(u), v++;
                    }
                    if (u && v < y.length) {
                        let s = v, m = 0;
                        for(;;)if (w.has(v)) {
                            if (++v === y.length) break;
                            u = l.featuresOnBorder[y[v]];
                        } else {
                            if (u.borders[f][0] > d[1] - 3) break;
                            if (m++, ++v === y.length) break;
                            u = l.featuresOnBorder[y[v]];
                        }
                        for(; s < y.length && w.has(s);)s++;
                        if (s >= y.length) {
                            r.showCentroid(i);
                            continue;
                        }
                        u = l.featuresOnBorder[y[s]];
                        let b = !1;
                        if (m >= 1) {
                            const e1 = u.borders[f];
                            Math.abs(d[0] - e1[0]) < 3 && Math.abs(d[1] - e1[1]) < 3 && (m = 1, b = !0, v = s + 1);
                        } else if (0 === m) {
                            r.showCentroid(i);
                            continue;
                        }
                        const x = l.centroidData.get(u.centroidDataIndex);
                        a && b && c(n, x);
                        const T = i.intersectsCount() > 1 || u.intersectsCount() > 1;
                        if (m > 1) v = s, n.centroidXY = x.centroidXY = new e1.P(0, 0);
                        else if (p && p.dem && !T) {
                            const i = _[t1](n, x), s = t1 % 2 ? e1.a2 - 1 : 0, r = g(i[0], Math.min(e1.a2 - 1, i[1]), s, p, o, t1 < 2, i[2]);
                            n.centroidXY = x.centroidXY = h(r);
                        } else T ? n.centroidXY = x.centroidXY = new e1.P(0, 0) : (n.centroidXY = r.encodeBorderCentroid(i), x.centroidXY = l.encodeBorderCentroid(u));
                        r.writeCentroidToBuffer(n), l.writeCentroidToBuffer(x);
                    } else r.showCentroid(i);
                }
                r.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[f] = r.canonical.z;
            }
            (r.needsCentroidUpdate || !r.centroidVertexBuffer && 0 !== r.centroidVertexArray.length) && r.uploadCentroid(t1);
        }
        const mi = [
            1,
            0,
            0
        ], _i = [
            0,
            1,
            0
        ], gi = [
            0,
            0,
            1
        ];
        function yi(t1, i, s) {
            const r = s.transform, o = s.shadowRenderer;
            if (!o) return !0;
            const n = s.frameCounter, a = s.currentShadowCascade;
            let l = s._shadowCullCache;
            if (!l || l.frame !== n || l.cascade !== a) {
                const t1 = r.tileSize * o._cascades[a].scale, i = r.scaleZoom(t1), c = o.shadowDirection, h = [
                    c[0],
                    c[1],
                    -c[2]
                ], d = [
                    mi,
                    _i,
                    gi,
                    h,
                    [
                        h[0],
                        0,
                        h[2]
                    ],
                    [
                        0,
                        h[1],
                        h[2]
                    ]
                ];
                l = {
                    frame: n,
                    cascade: a,
                    cameraFrustum: e1.az.fromInvProjectionMatrix(r.invProjMatrix, r.worldSize, i, !("globe" === r.projection.name)),
                    edges: d,
                    shadowDir: h,
                    ws: t1,
                    zoom: i
                }, s._shadowCullCache = l;
            }
            const { cameraFrustum: c, edges: h, shadowDir: d, ws: u, zoom: p } = l;
            let f = i;
            if (r.elevation) {
                const e1 = r.elevation.getMinMaxForTile(t1);
                e1 && (f += e1.max);
            }
            f /= e1.aA(r.center.lat, p);
            const m = o.computeSimplifiedTileShadowVolume(t1.toUnwrapped(), f, u, d);
            if (!m) return !1;
            const { vertices: _, planes: g } = m;
            return 0 === c.intersectsPrecise(_, g, h) || 0 === o.getCurrentCascadeFrustum().intersectsPrecise(_, g, h);
        }
        const vi = new Float32Array(16), bi = new Float32Array(16);
        function xi(t1) {
            const { painter: i, source: s, layer: r, coords: o } = t1;
            let n = t1.defines;
            const a = i.context, l = "shadow" === i.renderPass, c = "light-beam" === i.renderPass, h = i.shadowRenderer, d = e1.aA(i.transform.center.lat, i.transform.zoom), u = e1.aE(i, r.paint.get("building-cutoff-fade-range"));
            u.shouldRenderCutoff && (n = n.concat("RENDER_CUTOFF"));
            const p = r.paint.get("building-front-cutoff"), f = p[2] < 1 && !i.terrain, m = pi(i.transform.pitch, p, !!i.terrain);
            f && (n = n.concat("RENDER_FRONT_CUTOFF"), i.maxFrontCutoffRawStart = Math.max(i.maxFrontCutoffRawStart, p[0])), t1.floodLightIntensity > 0 && (n = n.concat("FLOOD_LIGHT"));
            for (const p of o){
                const o = s.getTile(p), f = o.getBucket(r);
                if (!f) continue;
                h && 0 === h.getMaxCascadeForTile(p.toUnwrapped()) && (n = n.concat("SHADOWS_SINGLE_CASCADE"));
                const _ = f.programConfigurations.get(r.id);
                let g, y;
                const v = i.translatePosMatrix(p.expandedProjMatrix, o, [
                    0,
                    0
                ], "map");
                e1.aN(vi, v, [
                    1,
                    1,
                    t1.verticalScale
                ]);
                const b = vi;
                let x;
                if (l && h) {
                    if (yi(o.tileID, f.maxHeight * d, i)) continue;
                    const s = h.calculateShadowPassMatrixFromTile(o.tileID.toUnwrapped());
                    e1.aN(s, s, [
                        1,
                        1,
                        t1.verticalScale
                    ]), x = li(s), g = y = i.getOrCreateProgram("buildingDepth", {
                        config: _,
                        defines: n,
                        overrideFog: !1
                    });
                } else if (c) g = y = i.getOrCreateProgram("buildingBloom", {
                    config: _,
                    defines: n,
                    overrideFog: !1
                }), x = ai(b);
                else {
                    const s = i.transform.calculatePosMatrix(p.toUnwrapped(), i.transform.worldSize);
                    e1.aN(s, s, [
                        1,
                        1,
                        t1.verticalScale
                    ]), e1.aN(bi, s, [
                        1,
                        -1,
                        1 / d
                    ]), e1.aO(bi, bi), e1.aP(bi, bi);
                    const r = bi, o = i.transform.getFreeCameraOptions().position, l = 1 << p.canonical.z;
                    if (x = ni(b, r, t1.opacity, t1.facadeAOIntensity, [
                        ((o.x - p.wrap) * l - p.canonical.x) * e1.a2,
                        (o.y * l - p.canonical.y) * e1.a2,
                        o.z * l * e1.a2
                    ], f.tileToMeter, t1.facadeEmissiveChance, t1.floodLightColor, t1.floodLightIntensity, m), y = i.getOrCreateProgram("building", {
                        config: _,
                        defines: n,
                        overrideFog: !1
                    }), !0 === t1.depthOnly) g = y;
                    else {
                        const e1 = n.concat([
                            "BUILDING_FAUX_FACADE",
                            "HAS_ATTRIBUTE_a_faux_facade_color_emissive"
                        ]);
                        g = i.getOrCreateProgram("building", {
                            config: _,
                            defines: e1,
                            overrideFog: !1
                        });
                    }
                    h && (h.setupShadowsFromMatrix(s, y, !0), g !== y && g.setShadowUniformValues(a, h.getShadowUniformValues()));
                }
                const w = (s, o)=>{
                    if (c) {
                        const n = s.entranceBloom;
                        o.draw(i, a.gl.TRIANGLES, t1.depthMode, e1._.disabled, t1.blendMode, e1.$.disabled, x, r.id, n.layoutVertexBuffer, n.indexBuffer, n.segmentsBucket, r.paint, i.transform.zoom, _, [
                            n.layoutAttenuationBuffer,
                            n.layoutColorBuffer
                        ]);
                    } else {
                        const n = s.segmentsBucket;
                        let c = [
                            s.layoutNormalBuffer,
                            s.layoutCentroidBuffer,
                            s.layoutColorBuffer,
                            s.layoutFloodLightDataBuffer
                        ];
                        s.layoutFacadePaintBuffer && (c = c.concat([
                            s.layoutFacadeDataBuffer,
                            s.layoutFacadeVerticalRangeBuffer,
                            s.layoutFacadePaintBuffer
                        ])), o.draw(i, a.gl.TRIANGLES, t1.depthMode, e1._.disabled, t1.blendMode, l ? e1.$.disabled : e1.$.backCW, x, r.id, s.layoutVertexBuffer, s.indexBuffer, n, r.paint, i.transform.zoom, _, c);
                    }
                };
                i.uploadCommonUniforms(a, y, p.toUnwrapped(), null, u), f.buildingWithoutFacade && w(f.buildingWithoutFacade, y), f.buildingWithFacade && (g !== y && i.uploadCommonUniforms(a, g, p.toUnwrapped(), null, u), w(f.buildingWithFacade, g));
            }
        }
        function wi(t1, i, s, r, o, n, a, l, c, h, d, u, p, f) {
            const m = t1.context.gl, _ = t1.depthModeForSublayer(1, e1.Z.ReadOnly, m.LEQUAL, !0), g = e1.al(.1, 3, d), y = t1._showOverdrawInspector, v = u, b = new ui;
            if (!y) {
                const d = new e1._({
                    func: m.ALWAYS,
                    mask: 255
                }, 255, 255, m.KEEP, m.KEEP, m.REPLACE), u = new e1.a1([
                    m.ONE,
                    m.ONE,
                    m.ONE,
                    m.ONE
                ], e1.C.transparent, [
                    !1,
                    !1,
                    !1,
                    !0
                ], m.MIN);
                e1.aQ(b, t1, i, s, r, _, d, u, e1.$.disabled, o, "sdf", n, a, l, c, h, g, v, !1, void 0);
            }
            {
                const d = y ? e1._.disabled : new e1._({
                    func: m.EQUAL,
                    mask: 255
                }, 255, 255, m.KEEP, m.DECR, m.DECR), u = y ? t1.colorModeForRenderPass() : new e1.a1([
                    m.ONE_MINUS_DST_ALPHA,
                    m.DST_ALPHA,
                    m.ONE,
                    m.ONE
                ], e1.C.transparent, [
                    !0,
                    !0,
                    !0,
                    !0
                ]);
                e1.aQ(b, t1, i, s, r, _, d, u, e1.$.disabled, o, "color", n, a, l, c, h, g, v, !1, void 0);
            }
        }
        class Ti {
            constructor(){
                this._previousClosestBuildingId = null, this._hysteresisRatio = .8, this._indoorMinimumZoom = 16;
            }
            findClosestBuilding(e1, t1, i, s, r) {
                if (i < this._indoorMinimumZoom) return this._previousClosestBuildingId = null, null;
                let o = null, n = Number.MAX_VALUE, a = Number.MAX_VALUE, l = !1;
                const c = this._previousClosestBuildingId ? e1[this._previousClosestBuildingId] : null;
                this._previousClosestBuildingId && c && this._isBuildingVisible(c, s, r) && (l = !0, a = this._calculateDistance(t1, c));
                for (const [i, a] of Object.entries(e1)){
                    if (!this._isBuildingVisible(a, s, r)) continue;
                    const e1 = this._calculateDistance(t1, a);
                    e1 < n && (n = e1, o = i);
                }
                return l && o && this._previousClosestBuildingId && o !== this._previousClosestBuildingId ? n > a * this._hysteresisRatio && (o = this._previousClosestBuildingId) : l && !o && (o = this._previousClosestBuildingId), this._previousClosestBuildingId = o, o;
            }
            _calculateDistance(e1, t1) {
                if (!t1.center) return Number.MAX_VALUE;
                const i = e1.lat - t1.center[1], s = e1.lng - t1.center[0];
                return i * i + s * s;
            }
            _isBuildingVisible(t1, i, s) {
                if (!s) return !1;
                for (const i of t1.floorIds){
                    const r = t1.floors[i];
                    if (!r.geometry) continue;
                    const o = r.geometry;
                    if ("Polygon" === o.type) {
                        const t1 = this._convertRingToPoints(o.coordinates[0]);
                        if (e1.aT(t1, s)) return !0;
                    } else if ("MultiPolygon" === o.type) {
                        const t1 = this._convertMultiPolygonToPoints(o.coordinates);
                        if (e1.aU(s, t1)) return !0;
                    }
                }
                return !1;
            }
            _convertRingToPoints(t1) {
                return t1.map((t1)=>new e1.P(t1[0], t1[1]));
            }
            _convertMultiPolygonToPoints(t1) {
                return t1.map((t1)=>0 === t1.length ? [] : t1[0].map((t1)=>new e1.P(t1[0], t1[1])));
            }
        }
        const Si = .05, Ci = (e1, t1, i, s, r, o, n, a, l, c, h, d)=>({
                u_matrix: e1,
                u_normalize_matrix: t1,
                u_globe_matrix: i,
                u_merc_matrix: s,
                u_grid_matrix: r,
                u_tl_parent: o,
                u_scale_parent: c,
                u_fade_t: h.mix,
                u_opacity: h.opacity,
                u_image0: 0,
                u_image1: 1,
                u_raster_elevation: d,
                u_zoom_transition: n,
                u_merc_center: a,
                u_cutoff_params: l
            }), Ei = (e1, t1, i, s, r, o, n, a, l, c)=>({
                u_particle_texture: e1,
                u_particle_texture_side_len: t1,
                u_tile_offset: i,
                u_velocity: s,
                u_color_ramp: o,
                u_velocity_res: r,
                u_max_speed: n,
                u_uv_offset: a,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    Si,
                    Si
                ]
            }), Ii = (e1, t1, i, s, r, o, n, a, l, c)=>({
                u_particle_texture: e1,
                u_particle_texture_side_len: t1,
                u_velocity: i,
                u_velocity_res: s,
                u_max_speed: r,
                u_speed_factor: o,
                u_reset_rate: n,
                u_rand_seed: Math.random(),
                u_uv_offset: a,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    Si,
                    Si
                ]
            });
        function Di(e1, [t1, i, s, r], [o, n]) {
            if (o === n) return [
                0,
                0,
                0,
                0
            ];
            const a = 255 * (e1 - 1) / (e1 * (n - o));
            return [
                t1 * a,
                i * a,
                s * a,
                r * a
            ];
        }
        function Pi(e1, t1, [i, s]) {
            return i === s ? 0 : .5 / e1 + (t1 - i) * (e1 - 1) / (e1 * (s - i));
        }
        var Li = e1.a_([
            {
                name: "a_index",
                type: "Int16",
                components: 1
            }
        ]);
        class Ri {
            constructor(t1, i, s, r){
                const o = {
                    width: s[0],
                    height: s[1],
                    data: null
                }, n = t1.gl;
                this.targetColorTexture = new e1.T(t1, o, n.RGBA8, {
                    useMipmap: !1
                }), this.backgroundColorTexture = new e1.T(t1, o, n.RGBA8, {
                    useMipmap: !1
                }), this.context = t1, this.updateParticleTexture(i, r), this.lastInvalidatedAt = 0;
            }
            updateParticleTexture(t1, i) {
                if (this.particleTextureDimension === i.width) return;
                (this.particleTexture0 || this.particleTexture1 || this.particleIndexBuffer || this.particleSegment) && (this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleIndexBuffer.destroy(), this.particleSegment.destroy());
                const s = this.context.gl, r = i.width * i.height;
                this.particleTexture0 = new e1.T(this.context, i, s.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                }), this.particleTexture1 = new e1.T(this.context, i, s.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                });
                const o = new e1.a$;
                o.reserve(r);
                for(let e1 = 0; e1 < r; e1++)o.emplaceBack(e1);
                this.particleIndexBuffer = this.context.createVertexBuffer(o, Li.members, !0), this.particleSegment = e1.ac.simpleSegment(0, 0, this.particleIndexBuffer.length, 0), this.particleTextureDimension = i.width;
            }
            update(t1) {
                return !(this.lastInvalidatedAt < t1 && (this.lastInvalidatedAt = e1.e.now(), 1));
            }
            destroy() {
                this.targetColorTexture.destroy(), this.backgroundColorTexture.destroy(), this.particleIndexBuffer.destroy(), this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleSegment.destroy();
            }
        }
        function Ai(t1, i, s, r, o) {
            if (o > 0) {
                const n = e1.e.now(), a = (n - t1.timeAdded) / o, l = i ? (n - i.timeAdded) / o : -1, c = s.getSource(), h = r.coveringZoomLevel({
                    tileSize: c.tileSize,
                    roundZoom: c.roundZoom
                }), d = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(t1.tileID.overscaledZ - h), u = d && t1.refreshedUponExpiration ? 1 : e1.b0(d ? a : 1 - l, 0, 1);
                return i ? {
                    opacity: 1,
                    mix: 1 - u,
                    isFading: a < 1
                } : {
                    opacity: u,
                    mix: 0,
                    isFading: a < 1
                };
            }
            return {
                opacity: 1,
                mix: 0,
                isFading: !1
            };
        }
        function Mi(t1, i, s) {
            if (!t1) return null;
            const r = i.getTextureDescriptor(t1, s, !0);
            if (!r) return null;
            let { texture: o, mix: n, offset: a, tileSize: l, buffer: c, format: h } = r;
            if (!o || !h) return null;
            let d = !1;
            return "uint32" === h && (d = !0, n[3] = 0, n = Di(e1.b9, n, [
                0,
                s.paint.get("raster-particle-max-speed")
            ]), a = Pi(e1.b9, a, [
                0,
                s.paint.get("raster-particle-max-speed")
            ])), {
                texture: o,
                textureOffset: [
                    c / (l + 2 * c),
                    l / (l + 2 * c)
                ],
                tileSize: l,
                scalarData: d,
                scale: n,
                offset: a,
                defines: [
                    "RASTER_ARRAY",
                    {
                        uint8: "DATA_FORMAT_UINT8",
                        uint16: "DATA_FORMAT_UINT16",
                        uint32: "DATA_FORMAT_UINT32"
                    }[h]
                ]
            };
        }
        function Fi(e1) {
            const t1 = e1._nearZ, i = e1.projection.farthestPixelDistance(e1), s = i - t1, r = .2 * e1.height, o = t1 + r;
            return [
                t1,
                i,
                (o - r - t1) / s,
                (o - t1) / s
            ];
        }
        var Oi = "#ifdef RASTER_ARRAY\nuniform sampler2D u_velocity;uniform mediump vec2 u_velocity_res;uniform mediump float u_max_speed;const vec4 NO_DATA=vec4(1);const vec2 INVALID_VELOCITY=vec2(-1);uniform highp vec2 u_uv_offset;uniform highp float u_data_offset;uniform highp vec2 u_data_scale;ivec4 rasterArrayLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}highp vec2 lookup_velocity(highp vec2 uv) {uv=u_uv_offset.x+u_uv_offset.y*uv;highp vec2 fxy;ivec4 c=rasterArrayLinearCoord(uv,u_velocity_res,fxy);highp vec4 tl=texelFetch(u_velocity,c.yz,0);highp vec4 tr=texelFetch(u_velocity,c.xz,0);highp vec4 bl=texelFetch(u_velocity,c.yw,0);highp vec4 br=texelFetch(u_velocity,c.xw,0);if (tl==NO_DATA) {return INVALID_VELOCITY;}if (tr==NO_DATA) {return INVALID_VELOCITY;}if (bl==NO_DATA) {return INVALID_VELOCITY;}if (br==NO_DATA) {return INVALID_VELOCITY;}highp vec4 t=mix(mix(bl,br,fxy.x),mix(tl,tr,fxy.x),fxy.y);highp vec2 velocity=u_data_offset+vec2(dot(t.rg,u_data_scale),dot(t.ba,u_data_scale));velocity.y=-velocity.y;velocity/=max(u_max_speed,length(velocity));return velocity;}\n#endif\nuniform highp float u_particle_pos_scale;uniform highp vec2 u_particle_pos_offset;highp vec4 pack_pos_to_rgba(highp vec2 p) {highp vec2 v=(p+u_particle_pos_offset)/u_particle_pos_scale;highp vec4 r=vec4(v.x,fract(v.x*255.0),v.y,fract(v.y*255.0));return vec4(r.x-r.y/255.0,r.y,r.z-r.w/255.0,r.w);}highp vec2 unpack_pos_from_rgba(highp vec4 v) {v=floor(v*255.0+0.5)/255.0;highp vec2 p=vec2(v.x+(v.y/255.0),v.z+(v.w/255.0));return u_particle_pos_scale*p-u_particle_pos_offset;}";
        e1.ba["_prelude_raster_particle.glsl"] || (e1.ba["_prelude_raster_particle.glsl"] = Oi);
        var Bi = {
            building: e1.bb('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nconst float window_depth=0.5;const float ao_radius=0.2;in vec4 v_color;in highp vec3 v_normal;in highp vec3 v_pos;\n#ifdef RENDER_FRONT_CUTOFF\nin float v_front_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\nin vec4 v_ground_roof;\n#endif\n#endif\n#ifdef BUILDING_FAUX_FACADE\nin lowp float v_faux_facade;in highp float v_faux_facade_ed;in highp vec2 v_faux_facade_window;in highp vec2 v_faux_facade_floor;in highp vec2 v_faux_facade_range;in highp float v_aspect;in highp vec3 v_tbn_0;in highp vec3 v_tbn_1;in highp vec3 v_tbn_2;in highp vec4 v_faux_color_emissive;uniform float u_faux_facade_ao_intensity;\n#endif\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\n#ifdef FLOOD_LIGHT\nin highp float v_flood_radius;in float v_has_flood_light;\n#endif\nuniform lowp float u_opacity;uniform vec3 u_camera_pos;uniform highp float u_tile_to_meter;uniform float u_facade_emissive_chance;uniform vec3 u_flood_light_color;uniform float u_flood_light_intensity;vec3 linearTosRGB(in vec3 color) {return pow(color,vec3(1./2.2));}\n#ifdef BUILDING_FAUX_FACADE\nhighp float hash12(in highp vec2 p) {highp vec3 p3 =fract(vec3(p.xyx)*0.1031);p3+=dot(p3,p3.yzx+33.33);return fract((p3.x+p3.y)*p3.z);}float min3(in vec3 v) {return min(min(v.x,v.y),v.z);}highp vec2 get_uv_mask_id(in highp vec2 q,out highp float mask,out highp vec2 id) {highp vec2 p=q;mask=step(v_faux_facade_range.x,p.y)*step(p.y,v_faux_facade_range.y);p.y=p.y-v_faux_facade_range.x;highp vec2 uv=modf(p/v_faux_facade_floor,id);highp vec4 d=(v_faux_facade_floor.xyxy+vec4(-v_faux_facade_window,v_faux_facade_window))*0.5;highp vec4 edge=d/v_faux_facade_floor.xyxy;highp vec2 m=step(edge.xy,uv)*step(uv,edge.zw);mask*=m.x*m.y;uv-=vec2(0.5);uv*=vec2(0.5)/(vec2(0.5)-edge.xy);uv+=vec2(0.5);return uv;}highp float ray_unit_box(in highp vec3 ray_o,in highp vec3 ray_d,in highp vec3 bmin,in highp vec3 bmax) {highp vec3 planes=mix(bmin,bmax,step(0.0,ray_d));highp vec3 t=(planes-ray_o)/ray_d;return min3(t);}float get_emissive(in vec2 id) {if (u_facade_emissive_chance > 0.0) {return (step(hash12(id),u_facade_emissive_chance)+0.05)*v_faux_color_emissive.a;}return 0.0;}vec3 get_shade_info(in highp vec3 v,in highp vec3 v_normalized,in vec3 color,in vec2 id,in mat3 tbn,inout vec3 out_normal,inout float out_emissive) {vec3 out_color=color;highp vec3 abs_v=abs(v_normalized);bool x_major=abs_v.x >=abs_v.y && abs_v.x >=abs_v.z;bool y_major=abs_v.y >=abs_v.x && abs_v.y >=abs_v.z;bool z_major=abs_v.z >=abs_v.x && abs_v.z >=abs_v.y;\n#if 0\nif (x_major) {out_color=v.x > 0.0 ? vec3(1.0,0.0,0.0) : vec3(0.0,1.0,1.0);} else if (y_major) {out_color=v.y > 0.0 ? vec3(0.0,1.0,0.0) : vec3(1.0,0.0,1.0);} else if (z_major) {out_color=v.z > 0.0 ? vec3(0.0,0.0,1.0) : vec3(1.0,1.0,0.0);}out_emissive=1.0;\n#else\nif (x_major) {out_normal=-sign(v.x)*tbn[0];} else if (y_major) {out_normal=vec3(0.0,0.0,-sign(v.y));} else if (z_major) {out_color=v_faux_color_emissive.rgb;out_emissive=v.z <=0.0 ? get_emissive(id) : out_emissive;}float ao=1.0;if (u_faux_facade_ao_intensity > 0.0) {vec4 ao_range=v_faux_facade_window.xxyy*0.5-vec4(0,ao_radius,0,ao_radius);vec2 ao_range_z=vec2(window_depth*0.5)-vec2(0.0,ao_radius);if (x_major || y_major) {ao*=smoothstep(-ao_range_z.x,-ao_range_z.y,v.z);} else if (z_major) {ao*=smoothstep(-ao_range.x,-ao_range.y,v.x)*(1.0-smoothstep(ao_range.y,ao_range.x,v.x));ao*=smoothstep(-ao_range.z,-ao_range.w,v.y)*(1.0-smoothstep(ao_range.w,ao_range.z,v.y));}ao=mix(1.0,min(1.0,ao+0.25),u_faux_facade_ao_intensity);}out_color*=ao;\n#endif\nreturn out_color;}\n#endif\nvec3 apply_lighting_linear(in vec3 color,in vec3 normal,in float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return color*(ambient_contrib+directional_contrib);}void main() {vec3 normal=normalize(v_normal);vec3 base_color=v_color.rgb;float emissive=v_color.a;\n#ifdef BUILDING_FAUX_FACADE\nif (v_faux_facade > 0.0) {highp mat3 tbn=mat3(v_tbn_0,v_tbn_1,v_tbn_2);highp vec3 v=vec3(v_pos.xy,v_pos.z/u_tile_to_meter)-u_camera_pos;highp vec3 view_tangent=transpose(tbn)*v;highp vec2 q=vec2(v_faux_facade_ed,v_pos.z);float mask=0.0;vec2 id=vec2(0.0);highp vec2 uv=get_uv_mask_id(q,mask,id);uv*=v_faux_facade_window;highp vec3 bmin=vec3(0.0,0.0,-window_depth);highp vec3 bmax=bmin+vec3(v_faux_facade_window,window_depth);highp vec3 ray_o=vec3(uv,0.0);highp vec3 ray_d=normalize(view_tangent);highp float t_min=ray_unit_box(ray_o,ray_d,bmin,bmax);highp vec3 hit=ray_o+t_min*ray_d;highp vec3 r=vec3(v_faux_facade_window,-window_depth);hit-=r*0.5;highp vec3 normalized=hit/r;vec3 out_normal=normal;float out_emissive=emissive;vec3 room_color=get_shade_info(hit,normalized,base_color,id,tbn,out_normal,out_emissive);base_color=mix(base_color,room_color,mask);normal=mix(normal,out_normal,mask);emissive=mix(emissive,out_emissive,mask);}\n#endif\nvec4 color=vec4(base_color,1.0);vec3 xy_flipped_normal=vec3(-normal.xy,normal.z);float shadowed_lighting_factor=0.0;\n#ifdef RENDER_SHADOWS\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(xy_flipped_normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(xy_flipped_normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\n#else\nshadowed_lighting_factor=max(0.0,dot(xy_flipped_normal,u_lighting_directional_dir));\n#endif\ncolor.rgb=apply_lighting_linear(color.rgb,xy_flipped_normal,shadowed_lighting_factor);color.rgb=linearTosRGB(color.rgb);\n#ifdef FLOOD_LIGHT\nfloat flood_radiance=(1.0-min(v_pos.z/v_flood_radius,1.0))*u_flood_light_intensity*v_has_flood_light;color.rgb=mix(color.rgb,u_flood_light_color,flood_radiance);\n#endif\ncolor.rgb=mix(color.rgb,linearTosRGB(base_color.rgb),emissive);\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,v_pos.z));\n#endif\ncolor*=u_opacity;\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\n{float ditherOpacity=cutoutGroundRoofOpacity(v_ground_roof);if (ditherOpacity < 1.0) {int index=viewport_dither_index(gl_FragCoord.xy);if (ditherOpacity < DITHER_THRESHOLDS[index]) {discard;}}}\n#else\ncolor=applyCutout(color,v_pos.z);\n#endif\n#endif\n#ifdef RENDER_FRONT_CUTOFF\nif (v_front_cutoff_opacity < 1.0) {int index=viewport_dither_index(gl_FragCoord.xy);if (v_front_cutoff_opacity < DITHER_THRESHOLDS[index]) {discard;}}\n#endif\n#ifdef FEATURE_CUTOUT\ncolor=apply_feature_cutout(color,gl_FragCoord,get_cutout_factors(gl_FragCoord).x,0.0);\n#endif\nglFragColor=color;\n#ifdef DEBUG_SHOW_NORMALS\ncolor.rgb=xy_flipped_normal*0.5+vec3(0.5,0.5,0.5);color.a=1.0;glFragColor=color;\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;in ivec4 a_normal_3;in ivec4 a_centroid_3;\n#ifdef FLOOD_LIGHT\nin int a_flood_light_wall_radius_1i16;\n#endif\n#ifdef BUILDING_FAUX_FACADE\nin uvec4 a_faux_facade_data;in uvec2 a_faux_facade_vertical_range;\n#endif\nuniform mat4 u_matrix;uniform mat4 u_normal_matrix;uniform highp float u_tile_to_meter;\n#ifdef RENDER_FRONT_CUTOFF\nuniform vec3 u_front_cutoff_params;out float v_front_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\nout vec4 v_ground_roof;\n#endif\n#endif\nout vec4 v_color;out vec3 v_normal;out highp vec3 v_pos;\n#ifdef BUILDING_FAUX_FACADE\nout lowp float v_faux_facade;out highp float v_faux_facade_ed;out highp vec2 v_faux_facade_window;out highp vec2 v_faux_facade_floor;out highp vec2 v_faux_facade_range;out highp float v_aspect;out highp vec3 v_tbn_0;out highp vec3 v_tbn_1;out highp vec3 v_tbn_2;out highp vec4 v_faux_color_emissive;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#ifdef FLOOD_LIGHT\nout highp float v_flood_radius;out float v_has_flood_light;\n#endif\nconst float MAX_UINT_16=65535.0;const float MAX_INT_16=32767.0;const float MAX_UINT_8=255.0;const float TWO_POW_8=256.0;const float FLOOD_LIGHT_MAX_RADIUS_METER=2048.0;vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#ifdef BUILDING_FAUX_FACADE\nmat3 get_tbn(in vec3 normal) {const vec3 bitangent=vec3(0.0,0.0,1.0);vec3 tangent=normalize(vec3(normal.y,-normal.x,0.0));return mat3(tangent,bitangent,normal);}\n#endif\n#pragma mapbox: define-attribute-vertex-shader-only highp uvec2 part_color_emissive\n#pragma mapbox: define-attribute-vertex-shader-only highp uvec2 faux_facade_color_emissive\nvoid main() {\n#pragma mapbox: initialize-attribute-custom highp uvec2 part_color_emissive\n#pragma mapbox: initialize-attribute-custom highp uvec2 faux_facade_color_emissive\n#ifdef FLOOD_LIGHT\nv_flood_radius=(float(a_flood_light_wall_radius_1i16)/MAX_INT_16*FLOOD_LIGHT_MAX_RADIUS_METER);v_has_flood_light=step(0.0,v_flood_radius);\n#endif\nvec4 color_emissive=decode_color(vec2(part_color_emissive));v_color=vec4(sRGBToLinear(color_emissive.rgb),color_emissive.a);vec3 a_normal_3f=vec3(a_normal_3)/MAX_INT_16;v_normal=vec3(u_normal_matrix*vec4(a_normal_3f,0.0));float hidden=0.0;float depth_offset=0.0;vec2 centroid_xy=vec2(a_centroid_3.xy >> 2);vec2 spanBits=vec2(a_centroid_3.xy & 3);\n#ifdef BUILDING_FAUX_FACADE\nvec4 faux_facade_data=vec4(a_faux_facade_data);v_faux_facade=faux_facade_data.x;if (v_faux_facade > 0.0) {v_faux_facade_ed=faux_facade_data.x *u_tile_to_meter;float window_x_perc=floor(faux_facade_data.y/TWO_POW_8);float window_y_perc=faux_facade_data.y-TWO_POW_8*window_x_perc;vec2 window_perc=vec2(window_x_perc,window_y_perc)/MAX_UINT_8;v_faux_facade_floor=(faux_facade_data.zw/MAX_UINT_16*EXTENT)*u_tile_to_meter;v_faux_facade_window=window_perc*v_faux_facade_floor;v_faux_facade_range=(vec2(a_faux_facade_vertical_range)/MAX_UINT_16*EXTENT)*u_tile_to_meter;v_aspect=v_faux_facade_window.x/v_faux_facade_window.y;mat3 tbn=get_tbn(normalize(v_normal));v_tbn_0=tbn[0];v_tbn_1=tbn[1];v_tbn_2=tbn[2];v_faux_color_emissive=decode_color(vec2(faux_facade_color_emissive));v_faux_color_emissive.rgb=sRGBToLinear(v_faux_color_emissive.rgb);depth_offset=min(1000.0,float(a_centroid_3.z))*0.0000002;}\n#endif\nv_pos=a_pos_3f;\n#if defined(RENDER_CUTOFF) || defined(RENDER_FRONT_CUTOFF)\nfloat halfSpanX=spanBits.x*10.0/u_tile_to_meter;float halfSpanY=spanBits.y*10.0/u_tile_to_meter;vec2 screenUpInTile=vec2(u_matrix[0][1],u_matrix[1][1]);vec2 spanOffset=vec2(halfSpanX,halfSpanY)*sign(screenUpInTile);vec2 cutoff_highestCorner=centroid_xy+spanOffset;vec2 cutoff_lowestCorner=centroid_xy-spanOffset;\n#endif\n#if defined(RENDER_CUTOFF) || defined(RENDER_FRONT_CUTOFF)\nvec4 ground=u_matrix*vec4(centroid_xy,0.0,1.0);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,ground.z);hidden=float(v_cutoff_opacity==0.0);v_pos.z*=v_cutoff_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nvec3 shadow_pos=v_pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset_model(v_normal);shadow_pos+=offset*shadow_normal_offset_multiplier0();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shadow_pos,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(shadow_pos,1.0);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(v_pos);\n#endif\n#ifdef RENDER_FRONT_CUTOFF\nv_front_cutoff_opacity=1.0;{hidden=max(hidden,float(ground.w <=0.0));float ndc_y=ground.y/max(ground.w,0.001);float threshold=u_front_cutoff_params.x*2.0-1.0;float range_ndc=u_front_cutoff_params.y*2.0;hidden=max(hidden,float(ndc_y < threshold-range_ndc));float t=clamp((ndc_y-(threshold-range_ndc))/max(range_ndc,0.001),0.0,1.0);v_front_cutoff_opacity=mix(u_front_cutoff_params.z,1.0,t);}\n#endif\ngl_Position=mix(u_matrix*vec4(v_pos,1),AWAY,hidden);gl_Position.z-=depth_offset*gl_Position.w;\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\nvec4 ic_ground=u_matrix*vec4(v_pos.xy,0.0,1.0);vec4 ic_roof=u_matrix*vec4(v_pos.xy,v_pos.z,1.0);v_ground_roof=vec4(ic_ground.xy/ic_ground.w,ic_roof.xy/ic_roof.w);\n#endif\n#endif\n}'),
            buildingBloom: e1.bb("in vec4 v_color_emissive;\n#pragma mapbox: define-attribute highp vec4 bloom_attenuation\nfloat saturate(float val) {return clamp(val,0.0,1.0);}void main() {\n#pragma mapbox: initialize-attribute highp vec4 bloom_attenuation\nfloat emission=v_color_emissive.a;float opacity=1.0;\n#ifdef HAS_ATTRIBUTE_a_bloom_attenuation\nfloat distance=length(vec2(1.3*max(0.0,abs(bloom_attenuation.x)-bloom_attenuation.z),bloom_attenuation.y));distance+= mix(0.5,0.0,clamp(emission-1.0,0.0,1.0));opacity*=saturate(1.0-distance*distance);\n#endif\n#ifdef RENDER_CUTOFF\nopacity*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(v_color_emissive.rgb,1.0)*opacity;}", "in vec3 a_pos_3f;\n#pragma mapbox: define-attribute-vertex-shader-only highp uvec2 part_color_emissive\n#pragma mapbox: define-attribute highp vec4 bloom_attenuation\nout vec4 v_color_emissive;uniform mat4 u_matrix;vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute-custom highp uvec2 part_color_emissive\n#pragma mapbox: initialize-attribute highp vec4 bloom_attenuation\n#ifdef HAS_ATTRIBUTE_a_part_color_emissive\nvec4 color_emissive=decode_color(vec2(part_color_emissive));float part_emissive=color_emissive.a*5.0;v_color_emissive=vec4(sRGBToLinear(color_emissive.rgb),part_emissive);\n#else\nv_color_emissive=vec4(1.0);\n#endif\ngl_Position=u_matrix*vec4(a_pos_3f,1.0);\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}"),
            buildingDepth: e1.bb("void main() {}", "in vec3 a_pos_3f;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos_3f,1.0);}"),
            rasterParticle: e1.bb('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;uniform sampler2D u_image0;uniform sampler2D u_image1;void main() {vec4 color0,color1,color;color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 out_color=color.rgb;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),1.0).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\nin ivec2 a_pos;in uvec2 a_texture_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {float w=1.0;vec2 uv;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvX=mercatorX*tiles-idx;float uvY=mercatorY*tiles-idy;uv=vec2(uvX,uvY);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nuv=vec2(a_texture_pos)/8192.0;gl_Position=u_matrix*vec4(vec2(a_pos)*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n#endif\nv_pos0=uv;\n#ifdef VIEWPORT_ORIGIN_TOP_LEFT\nv_pos0.y=1.0-v_pos0.y;\n#endif\nv_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}'),
            rasterParticleDraw: e1.bb("uniform sampler2D u_color_ramp;in float v_particle_speed;void main() {glFragColor=texture(u_color_ramp,vec2(v_particle_speed,0.5));}", '#include "_prelude_raster_particle.glsl"\nin int a_index;uniform sampler2D u_particle_texture;uniform float u_particle_texture_side_len;uniform vec2 u_tile_offset;out float v_particle_speed;void main() {ivec2 pixel_coord=ivec2(\nmod(float(a_index),u_particle_texture_side_len),float(a_index)/u_particle_texture_side_len);vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);vec2 pos=unpack_pos_from_rgba(pixel)+u_tile_offset;vec2 tex_coord=fract(pos);vec2 velocity=lookup_velocity(tex_coord);if (velocity==INVALID_VELOCITY) {gl_Position=AWAY;v_particle_speed=0.0;} else {gl_Position=vec4(2.0*pos-1.0,0,1);v_particle_speed=length(velocity);}gl_PointSize=1.0;}'),
            rasterParticleTexture: e1.bb("uniform sampler2D u_texture;uniform float u_opacity;in vec2 v_tex_pos;void main() {vec4 color=texture(u_texture,v_tex_pos);glFragColor=vec4(floor(255.0*color*u_opacity)/255.0);}", "in ivec2 a_pos;out vec2 v_tex_pos;void main() {vec2 uv=0.5*vec2(a_pos)+vec2(0.5);v_tex_pos=uv;\n#ifdef VIEWPORT_ORIGIN_TOP_LEFT\nv_tex_pos.y=1.0-v_tex_pos.y;\n#endif\ngl_Position=vec4(a_pos,0.0,1.0);}"),
            rasterParticleUpdate: e1.bb('#include "_prelude_raster_particle.glsl"\nuniform sampler2D u_particle_texture;uniform mediump float u_particle_texture_side_len;uniform mediump float u_speed_factor;uniform highp float u_reset_rate;uniform highp float u_rand_seed;in highp vec2 v_tex_coord;vec2 linearstep(vec2 edge0,vec2 edge1,vec2 x) {return  clamp((x-edge0)/(edge1-edge0),vec2(0),vec2(1));}const highp vec3 rand_constants=vec3(12.9898,78.233,4375.85453);highp float rand(const highp vec2 co) {highp float t=dot(rand_constants.xy,co);return fract(sin(t)*(rand_constants.z+t));}void main() {ivec2 pixel_coord=ivec2(v_tex_coord*u_particle_texture_side_len);highp vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);highp vec2 pos=unpack_pos_from_rgba(pixel);highp vec2 velocity=lookup_velocity(clamp(pos,0.0,1.0));highp vec2 dp=velocity==INVALID_VELOCITY ? vec2(0) : velocity*u_speed_factor;pos=pos+dp;highp vec2 seed=(pos+v_tex_coord)*u_rand_seed;highp vec2 random_pos=vec2(rand(seed+1.3),rand(seed+2.1));highp vec2 persist_rate=pow(\nlinearstep(vec2(-u_particle_pos_offset),vec2(0),pos)*linearstep(vec2(1.0+u_particle_pos_offset),vec2(1),pos),vec2(4)\n);highp vec2 per_frame_persist=pow(persist_rate,abs(dp)/u_particle_pos_offset);highp float drop_rate=1.0-per_frame_persist.x*per_frame_persist.y;drop_rate=any(greaterThanEqual(abs(pos-0.5),vec2(0.5+u_particle_pos_offset))) ? 1.0 : drop_rate;highp float drop=step(1.0-drop_rate-u_reset_rate,rand(seed));highp vec2 next_pos=mix(pos,random_pos,drop);glFragColor=pack_pos_to_rgba(next_pos);}', "in ivec2 a_pos;out vec2 v_tex_coord;void main() {v_tex_coord=0.5*vec2(a_pos+ivec2(1));gl_Position=vec4(a_pos,0.0,1.0);}"),
            snowParticle: e1.bb("in highp vec2 uv;in highp float alphaMultiplier;uniform vec4 u_particleColor;uniform vec2 u_simpleShapeParameters;void main() {float t=clamp((length(uv)-u_simpleShapeParameters.x)/(1.0-u_simpleShapeParameters.x),0.0,1.0);float alpha=1.0-pow(t,pow(10.0,u_simpleShapeParameters.y));alpha*=alphaMultiplier;alpha*=u_particleColor.a;vec3 color=u_particleColor.rgb*alpha;glFragColor=vec4(color,alpha) ;HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_snowParticleData;in highp vec4 a_snowParticleDataHorizontalOscillation;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform vec2 u_screenSize;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity;uniform vec3 u_direction;uniform float u_horizontalOscillationRadius; \nuniform float u_horizontalOscillationRate; \nuniform float u_billboardSize;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;out highp vec2 uv;out highp float alphaMultiplier;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos.xyz*=halfBoxSize;pos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_snowParticleData.z;float coneAngleHeadingRad=a_snowParticleData.w*radians(360.0);vec3 localZ=normalize(u_direction);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 direction;direction.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.z=cos(coneAnglePichRad);direction=normalize(direction);vec3 simPosLocal=vec3(0,0,0);float velocityScale=(1.0+3.0*a_snowParticleData.y)*u_velocity;simPosLocal+=direction*velocityScale*u_time;float horizontalOscillationRadius=u_horizontalOscillationRadius*a_snowParticleDataHorizontalOscillation.x;float horizontalOscillationAngle=u_horizontalOscillationRate*u_time*(-1.0+2.0*a_snowParticleDataHorizontalOscillation.y);simPosLocal.xy+=horizontalOscillationRadius*vec2(cos(horizontalOscillationAngle),sin(horizontalOscillationAngle));vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);float clipZ=-u_cam_pos.z+pos.z;vec4 posView=u_modelview*vec4(pos,1.0);float size=u_billboardSize;alphaMultiplier=1.0;vec4 posScreen=u_projection*posView;posScreen/=posScreen.w;posScreen.xy=vec2(0.5)+posScreen.xy*0.5;posScreen.xy*=u_screenSize;vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=u_screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-posScreen.xy)/(0.5*u_screenSize));screenDist+=a_snowParticleData.x*u_thinningParticleOffset;float scaleFactorMode=0.0;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);if (a_snowParticleData.x < u_thinningAffectedRatio) {scaleFactorMode=1.0-thinningFadeRatio;alphaMultiplier=thinningFadeRatio;}}vec4 posScreen1=u_projection*vec4(posView.x-size,posView.yzw);posScreen1/=posScreen1.w;vec4 posScreen2=u_projection*vec4(posView.x+size,posView.yzw);posScreen2/=posScreen2.w;posScreen1.xy=vec2(0.5)+posScreen1.xy*0.5;posScreen1.xy*=u_screenSize;posScreen2.xy=vec2(0.5)+posScreen2.xy*0.5;posScreen2.xy*=u_screenSize;float screenLength=length(posScreen1.xy-posScreen2.xy);float screenEpsilon=3.0;float scaleFactor=1.0;if (screenLength < screenEpsilon) {scaleFactor=screenEpsilon/max(screenLength,0.01);scaleFactor=mix(scaleFactor,1.0,scaleFactorMode);}float screenEpsilon2=15.0;if (screenLength > screenEpsilon2) {scaleFactor=screenEpsilon2/max(screenLength,0.01);}size*=scaleFactor;vec2 right=size*vec2(1,0);vec2 up=size*vec2(0,1);posView.xy+=right*a_uv.x;posView.xy+=up*a_uv.y;uv=a_uv;gl_Position=u_projection*posView;}"),
            rainParticle: e1.bb("in highp vec2 uv;in highp float particleRandomValue;uniform sampler2D u_texScreen;uniform float u_distortionStrength;uniform vec4 u_color;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;uniform float u_shapeDirectionalPower;uniform float u_mode;void main() {vec2 st=uv*0.5+vec2(0.5);vec2 uvm=uv;uvm.y=-1.0+2.0*pow(st.y,u_shapeDirectionalPower);float shape=clamp(1.0-length(uvm),0.0,1.0);float alpha=abs(shape)*u_color.a;vec2 screenSize=vec2(textureSize(u_texScreen,0));vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-gl_FragCoord.xy)/(0.5*screenSize));screenDist+=(0.5+0.5*particleRandomValue)*u_thinningParticleOffset;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;float thinningAlpha=1.0;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);thinningAlpha*=thinningFadeRatio;}vec2 offsetXY=normalize(uvm)*abs(shape);vec2 stScreen=(gl_FragCoord.xy+offsetXY*u_distortionStrength*thinningAlpha)/screenSize;vec3 colorScreen=texture(u_texScreen,stScreen).rgb;alpha*=thinningAlpha;glFragColor=mix(vec4(colorScreen,1.0),vec4(u_color.rgb*alpha,alpha),u_mode);HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_rainParticleData;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity; \nuniform vec2 u_rainDropletSize;uniform vec3 u_rainDirection;out highp vec2 uv;out highp float particleRandomValue;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos*=halfBoxSize; \npos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_rainParticleData.z;float coneAngleHeadingRad=a_rainParticleData.w*radians(360.0);vec3 localZ=normalize(u_rainDirection);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 directionLocal;directionLocal.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.z=cos(coneAnglePichRad);directionLocal=normalize(directionLocal);vec3 directionWorld=localX*directionLocal.x+localY*directionLocal.y+localZ*directionLocal.z;float velocityScale=(1.0+3.0*a_rainParticleData.y)*u_velocity;vec3 simPosLocal=vec3(0,0,0);simPosLocal+=directionLocal*velocityScale*u_time;vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);vec4 posView=u_modelview*vec4(pos,1.0);vec3 directionView=normalize((u_modelview*vec4(directionWorld,0.0)).xyz);vec3 side=cross(directionView,normalize(posView.xyz));posView.xyz+=side*a_uv.x*u_rainDropletSize.x;posView.xyz+=directionView*a_uv.y*u_rainDropletSize.y;uv=a_uv;particleRandomValue=a_rainParticleData.x;gl_Position=u_projection*posView;}"),
            vignette: e1.bb("uniform vec3 u_vignetteShape;uniform vec4 u_vignetteColor;in vec2 st;void main() {float screenDist=length(st);float alpha=clamp((screenDist-u_vignetteShape.x)/u_vignetteShape.y,0.0,1.0);alpha=pow(alpha,u_vignetteShape.z)*u_vignetteColor.a;vec3 color=u_vignetteColor.rgb;glFragColor=vec4(color*alpha,alpha) ;}", "in vec2 a_pos_2f;out vec2 st;void main() {st=a_pos_2f;gl_Position=vec4(a_pos_2f,0,1);}"),
            elevatedStructuresDepth: e1.bb("void main() {}", "in ivec2 a_pos;in float a_height;uniform mat4 u_matrix;uniform float u_depth_bias;void main() {gl_Position=u_matrix*vec4(a_pos,a_height,1);gl_Position.z=gl_Position.z+u_depth_bias;}"),
            elevatedStructures: e1.bb('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nin vec3 v_normal;in float v_height;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth;\n#endif\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}vec3 compute_view_dependent_emissive_color(float ndotl,float emissive_strength,vec3 color)\n{color=sRGBToLinear(color);color=color*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);color=linearTosRGB(color.rgb);return color;}uniform float u_emissive_strength;uniform float u_opacity_multiplier;\n#pragma mapbox: define highp vec4 structure_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 structure_color\nvec3 color=structure_color.xyz;vec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\n#ifdef LIGHTING_3D_MODE\nvec3 normal=normalize(v_normal);vec3 transformed_normal=vec3(-normal.xy,normal.z);float ndotl=calculate_NdotL(transformed_normal);float emissive_strength=u_emissive_strength;emissive_strength=0.0;vec3 emissive_color=compute_view_dependent_emissive_color(ndotl,emissive_strength,color.xyz);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);color.rgb=apply_lighting(color.rgb,transformed_normal,light);\n#else\ncolor=apply_lighting(color,transformed_normal);\n#endif\ncolor=mix(color,emissive_color,emissive_strength);if (v_height < 0.0) {float penetration=max(v_height+7.5,0.0);float occlusion=1.0-1.0/PI*acos(1.0-penetration/4.0);color=color*(1.0-pow(occlusion,2.0)*0.3);}\n#endif\n#ifdef FOG\ncolor=fog_apply(color,v_fog_pos);\n#endif\nvec4 out_color=vec4(color,1.0);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_height);\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x,v_height);\n#endif\nout_color*=u_opacity_multiplier;glFragColor=out_color;HANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin ivec2 a_pos;in float a_height;in ivec4 a_pos_normal_3;uniform mat4 u_matrix;out vec3 v_normal;out float v_height;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth;\n#endif\n#pragma mapbox: define highp vec4 structure_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 structure_color\nv_normal=vec3(a_pos_normal_3)/16384.0;v_height=a_height;vec3 pos=vec3(vec2(a_pos),a_height);gl_Position=u_matrix*vec4(pos,1);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(-v_normal.xy,v_normal.z));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n}'),
            elevatedStructuresDepthReconstruct: e1.bb('#include "_prelude_feature_cutout.fragment.glsl"\n#ifdef DEPTH_RECONSTRUCTION\nin float v_height;\n#endif\nvoid main() {\n#ifdef DEPTH_RECONSTRUCTION\nif (v_height >=0.0)\ndiscard;\n#else\n#ifdef FEATURE_CUTOUT\napply_feature_cutout(vec4(0.0,0.0,0.0,1.0),gl_FragCoord,get_cutout_factors(gl_FragCoord).x,0.0);\n#endif\n#endif\nglFragColor=vec4(1.0,0.0,0.0,1.0);}', "in ivec2 a_pos;in float a_height;uniform mat4 u_matrix;uniform vec3 u_camera_pos;uniform highp float u_depth_bias;uniform lowp float u_height_scale;uniform lowp float u_reset_depth;\n#ifdef DEPTH_RECONSTRUCTION\nout float v_height;\n#endif\nvoid main() {vec3 vpos=vec3(a_pos,a_height*u_height_scale);\n#ifdef DEPTH_RECONSTRUCTION\nif (u_camera_pos.z > vpos.z) {vpos-=(u_camera_pos-vpos)*(vpos.z/(u_camera_pos.z-vpos.z));}v_height=a_height;\n#endif\ngl_Position=u_matrix*vec4(vpos,1);gl_Position.z=u_reset_depth==1.0 ? gl_Position.w : gl_Position.z+u_depth_bias;}")
        };
        e1.bb(Oi, "");
        const ki = e1.a_([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_rainParticleData",
                components: 4
            }
        ]), zi = e1.a_([
            {
                type: "Float32",
                name: "a_pos_2f",
                components: 2
            }
        ]);
        class Ui {
            destroy() {
                this.vignetteVx && this.vignetteVx.destroy(), this.vignetteIdx && this.vignetteIdx.destroy();
            }
            draw(t1, i) {
                const s = t1.getOrCreateProgram("vignette");
                if (!this.vignetteVx || !this.vignetteIdx) {
                    const i = new e1.bc, s = new e1.ad;
                    i.emplaceBack(-1, -1), i.emplaceBack(1, -1), i.emplaceBack(1, 1), i.emplaceBack(-1, 1), s.emplaceBack(0, 1, 2), s.emplaceBack(0, 2, 3), this.vignetteVx = t1.context.createVertexBuffer(i, zi.members), this.vignetteIdx = t1.context.createIndexBuffer(s);
                }
                const r = e1.ac.simpleSegment(0, 0, 4, 6);
                if (this.vignetteVx && this.vignetteIdx) {
                    t1.uploadCommonUniforms(t1.context, s);
                    const n = {
                        u_vignetteShape: (o = {
                            vignetteShape: [
                                i.start,
                                i.range,
                                Math.pow(10, i.fadePower)
                            ],
                            vignetteColor: [
                                i.color.r,
                                i.color.g,
                                i.color.b,
                                i.color.a * i.strength
                            ]
                        }).vignetteShape,
                        u_vignetteColor: o.vignetteColor
                    };
                    s.draw(t1, t1.context.gl.TRIANGLES, e1.Z.disabled, e1._.disabled, e1.a1.alphaBlended, e1.$.disabled, n, "vignette", this.vignetteVx, this.vignetteIdx, r);
                }
                var o;
            }
        }
        class Ni {
            constructor(){
                this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
            }
            update(t1, i) {
                const s = t1.getFreeCameraOptions().position, r = s.toAltitude(), o = s.toLngLat(), n = e1.au(o.lng), a = e1.au(o.lat), l = t1.pixelsPerMeter / i, c = n * e1.bj, h = e1.bj * Math.log(Math.tan(Math.PI / 4 + a / 2));
                if (void 0 === this._offsetXPrev) this._offsetXPrev = 0, this._offsetYPrev = 0, this._elevationPrev = 0, this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
                else {
                    const e1 = -this._offsetYPrev + h, t1 = -this._elevationPrev + r;
                    this._accumulatedOffsetX += (-this._offsetXPrev + c) * l, this._accumulatedOffsetY += e1 * l, this._accumulatedElevation += t1 * l, this._offsetXPrev = c, this._offsetYPrev = h, this._elevationPrev = r;
                }
            }
            getPosition() {
                return [
                    this._accumulatedOffsetX,
                    this._accumulatedOffsetY,
                    this._accumulatedElevation
                ];
            }
        }
        function ji(e1, t1) {
            return [
                -(e1[0] - Math.floor(e1[0] / t1) * t1),
                -(e1[1] - Math.floor(e1[1] / t1) * t1),
                -(e1[2] - Math.floor(e1[2] / t1) * t1)
            ];
        }
        function Vi(t1) {
            const i = e1.bi(1323123451230), s = [];
            for(let r = 0; r < t1; ++r){
                const t1 = 2 * i() - 1, r = 2 * i() - 1, o = 2 * i() - 1;
                s.push(e1.bh(t1, r, o));
            }
            return s;
        }
        function Gi(t1, i, s, r, o) {
            const n = e1.b0((o - s) / (r - s), 0, 1);
            return e1.al(t1, i, n);
        }
        class qi {
            constructor(e1){
                this._movement = new Ni, this._accumulatedTimeFromStart = 0, this._prevTime = Date.now() / 1e3, this._vignette = new Ui, this._ppmScaleFactor = e1;
            }
            destroy() {
                this.particlesVx && this.particlesVx.destroy(), this.particlesIdx && this.particlesIdx.destroy(), this._vignette && this._vignette.destroy();
            }
            updateOnRender(t1, i) {
                const s = t1.transform;
                this._movement.update(s, this._ppmScaleFactor);
                const r = s.starsProjMatrix, o = e1.bd([]);
                e1.be(o, o, e1.au(90) - s._pitch), e1.bf(o, o, -s.angle);
                const n = e1.bg(new Float32Array(16), o), a = new Float32Array([
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ]), l = e1.aP([], a), c = e1.X([], l, n), h = Date.now() / 1e3;
                return this._accumulatedTimeFromStart += (h - this._prevTime) * i, this._prevTime = h, {
                    projectionMatrix: r,
                    modelviewMatrix: c
                };
            }
        }
        const Zi = e1.a_([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_snowParticleData",
                components: 4
            },
            {
                type: "Float32",
                name: "a_snowParticleDataHorizontalOscillation",
                components: 2
            }
        ]), $i = (e1, t1)=>({
                u_matrix: e1,
                u_depth_bias: t1
            }), Hi = (e1, t1)=>({
                u_matrix: e1,
                u_ground_shadow_factor: t1,
                u_opacity_multiplier: 1
            }), Wi = (e1, t1, i, s, r)=>({
                u_matrix: e1,
                u_camera_pos: [
                    t1[0],
                    t1[1],
                    t1[2]
                ],
                u_depth_bias: i,
                u_height_scale: s,
                u_reset_depth: r
            }), Xi = {
            building: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_normal_matrix: new e1.a5(t1),
                    u_opacity: new e1.a4(t1),
                    u_faux_facade_ao_intensity: new e1.a4(t1),
                    u_camera_pos: new e1.a6(t1),
                    u_tile_to_meter: new e1.a4(t1),
                    u_facade_emissive_chance: new e1.a4(t1),
                    u_flood_light_color: new e1.a6(t1),
                    u_flood_light_intensity: new e1.a4(t1),
                    u_front_cutoff_params: new e1.a6(t1)
                }),
            buildingBloom: (t1)=>({
                    u_matrix: new e1.a5(t1)
                }),
            buildingDepth: (t1)=>({
                    u_matrix: new e1.a5(t1)
                }),
            elevatedStructuresDepth: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_depth_bias: new e1.a4(t1)
                }),
            elevatedStructures: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_ground_shadow_factor: new e1.a6(t1),
                    u_opacity_multiplier: new e1.a4(t1)
                }),
            elevatedStructuresDepthReconstruct: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_camera_pos: new e1.a6(t1),
                    u_depth_bias: new e1.a4(t1),
                    u_height_scale: new e1.a4(t1),
                    u_reset_depth: new e1.a4(t1)
                }),
            rasterParticle: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_normalize_matrix: new e1.a5(t1),
                    u_globe_matrix: new e1.a5(t1),
                    u_merc_matrix: new e1.a5(t1),
                    u_grid_matrix: new e1.aZ(t1),
                    u_tl_parent: new e1.a3(t1),
                    u_scale_parent: new e1.a4(t1),
                    u_fade_t: new e1.a4(t1),
                    u_opacity: new e1.a4(t1),
                    u_image0: new e1.aX(t1),
                    u_image1: new e1.aX(t1),
                    u_raster_elevation: new e1.a4(t1),
                    u_zoom_transition: new e1.a4(t1),
                    u_merc_center: new e1.a3(t1),
                    u_cutoff_params: new e1.aY(t1)
                }),
            rasterParticleTexture: (t1)=>({
                    u_texture: new e1.aX(t1),
                    u_opacity: new e1.a4(t1)
                }),
            rasterParticleDraw: (t1)=>({
                    u_particle_texture: new e1.aX(t1),
                    u_particle_texture_side_len: new e1.a4(t1),
                    u_tile_offset: new e1.a3(t1),
                    u_velocity: new e1.aX(t1),
                    u_color_ramp: new e1.aX(t1),
                    u_velocity_res: new e1.a3(t1),
                    u_max_speed: new e1.a4(t1),
                    u_uv_offset: new e1.a3(t1),
                    u_data_scale: new e1.a3(t1),
                    u_data_offset: new e1.a4(t1),
                    u_particle_pos_scale: new e1.a4(t1),
                    u_particle_pos_offset: new e1.a3(t1)
                }),
            rasterParticleUpdate: (t1)=>({
                    u_particle_texture: new e1.aX(t1),
                    u_particle_texture_side_len: new e1.a4(t1),
                    u_velocity: new e1.aX(t1),
                    u_velocity_res: new e1.a3(t1),
                    u_max_speed: new e1.a4(t1),
                    u_speed_factor: new e1.a4(t1),
                    u_reset_rate: new e1.a4(t1),
                    u_rand_seed: new e1.a4(t1),
                    u_uv_offset: new e1.a3(t1),
                    u_data_scale: new e1.a3(t1),
                    u_data_offset: new e1.a4(t1),
                    u_particle_pos_scale: new e1.a4(t1),
                    u_particle_pos_offset: new e1.a3(t1)
                }),
            snowParticle: (t1)=>({
                    u_modelview: new e1.a5(t1),
                    u_projection: new e1.a5(t1),
                    u_time: new e1.a4(t1),
                    u_cam_pos: new e1.a6(t1),
                    u_velocityConeAperture: new e1.a4(t1),
                    u_velocity: new e1.a4(t1),
                    u_horizontalOscillationRadius: new e1.a4(t1),
                    u_horizontalOscillationRate: new e1.a4(t1),
                    u_boxSize: new e1.a4(t1),
                    u_billboardSize: new e1.a4(t1),
                    u_simpleShapeParameters: new e1.a3(t1),
                    u_screenSize: new e1.a3(t1),
                    u_thinningCenterPos: new e1.a3(t1),
                    u_thinningShape: new e1.a6(t1),
                    u_thinningAffectedRatio: new e1.a4(t1),
                    u_thinningParticleOffset: new e1.a4(t1),
                    u_particleColor: new e1.aY(t1),
                    u_direction: new e1.a6(t1)
                }),
            rainParticle: (t1)=>({
                    u_modelview: new e1.a5(t1),
                    u_projection: new e1.a5(t1),
                    u_time: new e1.a4(t1),
                    u_cam_pos: new e1.a6(t1),
                    u_texScreen: new e1.aX(t1),
                    u_velocityConeAperture: new e1.a4(t1),
                    u_velocity: new e1.a4(t1),
                    u_boxSize: new e1.a4(t1),
                    u_rainDropletSize: new e1.a3(t1),
                    u_distortionStrength: new e1.a4(t1),
                    u_rainDirection: new e1.a6(t1),
                    u_color: new e1.aY(t1),
                    u_screenSize: new e1.a3(t1),
                    u_thinningCenterPos: new e1.a3(t1),
                    u_thinningShape: new e1.a6(t1),
                    u_thinningAffectedRatio: new e1.a4(t1),
                    u_thinningParticleOffset: new e1.a4(t1),
                    u_shapeDirectionalPower: new e1.a4(t1),
                    u_shapeNormalPower: new e1.a4(t1),
                    u_mode: new e1.a4(t1)
                }),
            vignette: (t1)=>({
                    u_vignetteShape: new e1.a6(t1),
                    u_vignetteColor: new e1.aY(t1)
                })
        };
        function Ki(t1, i) {
            const s = 1 << t1.canonical.z, r = (i.x * s - t1.canonical.x - t1.wrap * s) * e1.a2, o = (i.y * s - t1.canonical.y) * e1.a2, n = e1.bm(i.z, i.y);
            return e1.bh(r, o, n);
        }
        function Yi(e1) {
            let t1 = 0;
            for (const i of e1)t1 |= i.frcMask;
            return t1;
        }
        class Qi {
            constructor(e1 = []){
                this.tiles = e1;
            }
            getTile(e1) {
                for (const t1 of this.tiles)if (t1.tileId.z === e1.z && t1.tileId.x === e1.x && t1.tileId.y === e1.y) return t1;
                return null;
            }
            getTileOrParent(e1) {
                for(let t1 = e1.z; t1 > 0; --t1){
                    const i = Math.floor(e1.x / (1 << e1.z - t1)), s = Math.floor(e1.y / (1 << e1.z - t1));
                    for (const e1 of this.tiles)if (e1.tileId.z === t1 && e1.tileId.x === i && e1.tileId.y === s && 0 !== e1.frcMask) return e1;
                }
                return null;
            }
            getFullCoverageMask(t1) {
                let i = null, s = 0;
                for(let e1 = t1.z; e1 > 0; --e1){
                    const r = Math.floor(t1.x / (1 << t1.z - e1)), o = Math.floor(t1.y / (1 << t1.z - e1));
                    for (const t1 of this.tiles)if (t1.tileId.z === e1 && t1.tileId.x === r && t1.tileId.y === o) {
                        i = t1, s = e1;
                        break;
                    }
                    if (i) break;
                }
                if (!i || 0 === i.frcMask) return null;
                const r = 1 << t1.z - s, o = e1.a2 / r, n = t1.x % r * o, a = t1.y % r * o, l = n + o, c = a + o;
                let h = 0;
                for (const e1 of i.polygons)0 !== e1.frcMask && (e1.hasGeometry() ? 0 === e1.rings.length || t1.z <= s || Ji(e1.rings, n, a, l, c) && (h |= e1.frcMask) : h |= e1.frcMask);
                return 0 !== h ? h : null;
            }
            equals(e1) {
                if (this.tiles.length !== e1.length) return !1;
                for(let t1 = 0; t1 < this.tiles.length; ++t1){
                    const i = this.tiles[t1], s = e1[t1];
                    if (i.tileId.z !== s.tileId.z || i.tileId.x !== s.tileId.x || i.tileId.y !== s.tileId.y || i.frcMask !== s.frcMask || i.polygons.length !== s.polygons.length) return !1;
                }
                return !0;
            }
            empty() {
                return 0 === this.tiles.length;
            }
        }
        function Ji(e1, t1, i, s, r) {
            const o = [
                0,
                0,
                0,
                0
            ], n = [
                t1,
                s,
                s,
                t1
            ], a = [
                i,
                i,
                r,
                r
            ];
            for (const l of e1){
                const e1 = l.length;
                if (!(e1 < 2)) for(let c = 0, h = e1 - 1; c < e1; h = c++){
                    const e1 = l[h].x, d = l[h].y, u = l[c].x, p = l[c].y;
                    for(let t1 = 0; t1 < 4; ++t1)d > a[t1] != p > a[t1] && n[t1] < e1 + (u - e1) * (a[t1] - d) / (p - d) && o[t1]++;
                    let f = 0, m = 0;
                    if (e1 < t1 ? f |= 1 : e1 > s && (f |= 2), d < i ? f |= 4 : d > r && (f |= 8), u < t1 ? m |= 1 : u > s && (m |= 2), p < i ? m |= 4 : p > r && (m |= 8), !(f & m)) {
                        if (0 === f || 0 === m) return !1;
                        if (es(e1, d, u, p, t1, i, s, r)) return !1;
                    }
                }
            }
            for(let e1 = 0; e1 < 4; ++e1)if (!(1 & o[e1])) return !1;
            return !0;
        }
        function es(e1, t1, i, s, r, o, n, a) {
            const l = (e1, t1, i, s, r, o, n, a)=>{
                const l = (i - e1) * (o - t1) - (s - t1) * (r - e1), c = (i - e1) * (a - t1) - (s - t1) * (n - e1);
                if (l > 0 && c > 0 || l < 0 && c < 0) return !1;
                const h = (n - r) * (t1 - o) - (a - o) * (e1 - r), d = (n - r) * (s - o) - (a - o) * (i - r);
                return !(h > 0 && d > 0 || h < 0 && d < 0);
            };
            return !!(l(e1, t1, i, s, r, o, n, o) || l(e1, t1, i, s, n, o, n, a) || l(e1, t1, i, s, r, a, n, a) || l(e1, t1, i, s, r, o, r, a));
        }
        class ts {
            constructor(){
                this._tileCoverages = [], this._snapshot = new Qi;
            }
            clear() {
                this._tileCoverages = [];
            }
            addTileCoverage(e1, t1) {
                this._tileCoverages.push({
                    tileId: e1,
                    polygons: t1,
                    frcMask: Yi(t1)
                });
            }
            empty() {
                return 0 === this._tileCoverages.length;
            }
            updateSnapshotIfNeeded() {
                if (this._snapshot.equals(this._tileCoverages)) return this._snapshot;
                const e1 = this._tileCoverages.map((e1)=>({
                        tileId: e1.tileId,
                        polygons: e1.polygons,
                        frcMask: e1.frcMask
                    }));
                return this._snapshot = new Qi(e1), this._snapshot;
            }
        }
        function is(e1, t1) {
            const i = {};
            if (!t1) return i;
            for (const s of e1){
                const e1 = s.layerIds.map((e1)=>t1.getLayer(e1)).filter(Boolean);
                if (0 !== e1.length) {
                    s.layers = e1, s.stateDependentLayerIds && (s.stateDependentLayers = s.stateDependentLayerIds.map((t1)=>e1.filter((e1)=>e1.id === t1)[0])), s.updateExpressions && s.updateExpressions(e1);
                    for (const t1 of e1)i[t1.fqid] = s;
                }
            }
            return i;
        }
        const ss = 32, rs = 33, os = new Uint16Array(8184);
        for(let e1 = 0; e1 < 2046; e1++){
            let t1 = e1 + 2, i = 0, s = 0, r = 0, o = 0, n = 0, a = 0;
            for(1 & t1 ? r = o = n = ss : i = s = a = ss; (t1 >>= 1) > 1;){
                const e1 = i + r >> 1, l = s + o >> 1;
                1 & t1 ? (r = i, o = s, i = n, s = a) : (i = r, s = o, r = n, o = a), n = e1, a = l;
            }
            const l = 4 * e1;
            os[l + 0] = i, os[l + 1] = s, os[l + 2] = r, os[l + 3] = o;
        }
        const ns = new Uint16Array(2178), as = new Uint8Array(1089), ls = new Uint16Array(1089);
        function cs(e1) {
            return 0 === e1 ? -0.03125 : 32 === e1 ? .03125 : 0;
        }
        var hs = e1.a_([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Uint16",
                components: 2
            }
        ]);
        const ds = (()=>({
                type: 2,
                extent: e1.a2,
                loadGeometry: ()=>[
                        [
                            new e1.P(0, 0),
                            new e1.P(e1.a2 + 1, 0),
                            new e1.P(e1.a2 + 1, e1.a2 + 1),
                            new e1.P(0, e1.a2 + 1),
                            new e1.P(0, 0)
                        ]
                    ]
            }))();
        let us, ps = 0;
        class fs {
            constructor(t1, i, s, r, o, n){
                this.tileID = t1, this.uid = e1.av(), this.uses = 0, this.tileSize = i, this.tileZoom = s, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasTunnelGeometry = !1, this.hasRTLText = !1, this.dependencies = {}, this.isRaster = o, r && r.style && (this._lastUpdatedBrightness = r.style.getBrightness()), this._lastAvailableImagesCount = 0, this._firstPrepareComplete = !1, this.expiredRequestCount = 0, this.state = "loading", r && r.transform && (this.projection = r.transform.projection), this.worldview = n, this._hasAppearances = null;
            }
            registerFadeDuration(t1) {
                const i = t1 + this.timeAdded;
                i < e1.e.now() || void 0 !== this.fadeEndTime && i < this.fadeEndTime || (this.fadeEndTime = i);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            get tileTransform() {
                return this._tileTransform || (this._tileTransform = e1.bp(this.tileID.canonical, this.projection)), this._tileTransform;
            }
            loadVectorData(t1, i, s) {
                if (this.unloadVectorData(), this.state = "loaded", t1) {
                    t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = is(t1.buckets, i.style), t1.frcCoveragePolygons && t1.frcCoveragePolygons.length > 0 && (this.frcCoveragePolygons = t1.frcCoveragePolygons), this.hasDeferredRoadStructure = !!t1.hasDeferredRoadStructure, void 0 !== t1.parsedElevationFeatures && (this.parsedElevationFeatures = t1.parsedElevationFeatures, this.parsedElevationGeneration = ++ps), this.hasDeferredElevationFeatures = !!t1.hasDeferredElevationFeatures, this.hasSymbolBuckets = !1, this.hasTunnelGeometry = !!t1.hasTunnelGeometry;
                    for(const t1 in this.buckets){
                        const i = this.buckets[t1];
                        if (i instanceof e1.bu) {
                            if (this.hasSymbolBuckets = !0, !s) break;
                            i.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const t1 in this.buckets){
                        const i = this.buckets[t1];
                        if (i instanceof e1.bu && i.hasRTLText) {
                            this.hasRTLText = !0, e1.bN();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const e1 in this.buckets){
                        const t1 = this.buckets[e1], s = i.style.getOwnLayer(e1);
                        if (!s) continue;
                        const r = s.queryRadius(t1) || 0;
                        this.queryPadding = Math.max(this.queryPadding, r);
                    }
                    t1.imageAtlas && (this.imageAtlas = i.style.imageManager.imageAtlasCache.getOrCache(t1.imageAtlas)), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage), t1.lineAtlas && (this.lineAtlas = t1.lineAtlas), this._lastUpdatedBrightness = t1.brightness;
                } else this.collisionBoxArray = new e1.bt;
            }
            unloadVectorData() {
                if (this.hasData()) {
                    for(const e1 in this.buckets)this.buckets[e1].destroy();
                    this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
                }
            }
            loadModelData(e1, t1, i) {
                e1 && (e1.resourceTiming && (this.resourceTiming = e1.resourceTiming), this.buckets = {
                    ...this.buckets,
                    ...is(e1.buckets, t1.style)
                }, e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex));
            }
            getBucket(e1) {
                return this.buckets[e1.fqid];
            }
            upload(t1, i) {
                for(const e1 in this.buckets){
                    const s = this.buckets[e1];
                    if (s.uploadPending()) {
                        let e1 = {}, r = [], o = {
                            zoom: 0,
                            pitch: 0,
                            brightness: 0,
                            worldview: ""
                        };
                        if (i) {
                            if (i.style) {
                                r = i.style.listImages();
                                const t1 = s.layers[0], o = t1.sourceLayer || "_geojsonTileLayer", n = i.style.getLayerSourceCache(t1);
                                n && (e1 = n._state.getState(o, void 0));
                            }
                            o = {
                                zoom: i.transform.zoom || 0,
                                pitch: i.transform.pitch || 0,
                                brightness: i.style.getBrightness() || 0,
                                worldview: i.worldview || ""
                            };
                        }
                        s.upload(t1, this.tileID.canonical, e1, r, o);
                    }
                }
                const s = t1.gl, r = this.imageAtlas;
                r && i && (this.imageAtlasTexture = i.style.imageManager.imageAtlasCache.getTextureForAtlas(r, t1, s.RGBA8), r.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new e1.T(t1, this.glyphAtlasImage, s.R8), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new e1.T(t1, this.lineAtlas.image, s.R8), this.lineAtlas.uploaded = !0);
            }
            prepare(e1, t1, i) {
                if (this.imageAtlas && this.imageAtlasTexture && t1) {
                    const s = t1.style.getLut(i);
                    this.imageAtlas.patchUpdatedImages(e1, this.imageAtlasTexture, i, s);
                }
                if (!t1 || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) return;
                const s = t1.style.getBrightness(), r = t1.style.listImages(), o = r.length, n = t1.style._changes.getUpdatedPaintProperties(), a = Object.keys(this.buckets).some((e1)=>this.buckets[e1].layers.some((e1)=>n.has(e1.fqid))), l = Object.keys(this.buckets).some((e1)=>this.buckets[e1].layers.some((e1)=>e1.hasTransition && e1.hasTransition())), c = this._firstPrepareComplete && o !== this._lastAvailableImagesCount;
                null === this._hasAppearances && (this._hasAppearances = this.hasAppearances(t1));
                const h = this._lastUpdatedBrightness !== s;
                this._lastAvailableImagesCount = o, this._firstPrepareComplete = !0, (this._lastUpdatedBrightness || s || this._hasAppearances || a || l || c) && (!(this._hasAppearances || a || l || c) && this._lastUpdatedBrightness && s && Math.abs(this._lastUpdatedBrightness - s) < .001 || (this.updateBuckets(t1, h, void 0, c || a || l, n, r), this._lastUpdatedBrightness = s));
            }
            evaluateQueryRenderedFeaturePadding() {
                let e1 = 0;
                for(const t1 in this.buckets){
                    const i = this.buckets[t1];
                    i.evaluateQueryRenderedFeaturePadding && (e1 = Math.max(e1, i.evaluateQueryRenderedFeaturePadding()));
                }
                return e1;
            }
            queryRenderedFeatures(t1, i, s, r, o, n, a) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData && !this.latestFeatureIndex.is3DTile) return {};
                const l = this.evaluateQueryRenderedFeaturePadding(), c = function(t1, i) {
                    const s = e1.bL([], [
                        .5 * t1.width,
                        .5 * -t1.height,
                        1
                    ]);
                    return e1.bM(s, s, [
                        1,
                        -1,
                        0
                    ]), e1.X(s, s, t1.calculateProjMatrix(i.toUnwrapped())), Float32Array.from(s);
                }(o, this.tileID);
                return this.latestFeatureIndex.query(t1, {
                    tilespaceGeometry: i,
                    pixelPosMatrix: c,
                    transform: r,
                    availableImages: s,
                    tileTransform: this.tileTransform,
                    worldview: this.worldview,
                    queryRadius: l,
                    scope: a
                });
            }
            querySourceFeatures(t1, i) {
                const s = this.latestFeatureIndex;
                if (!s || !s.rawTileData) return;
                const r = s.loadVTLayers(), o = i ? i.sourceLayer : "", n = r._geojsonTileLayer || r[o];
                if (!n) return;
                const a = e1.bv(i && i.filter), { z: l, x: c, y: h } = this.tileID.canonical, d = {
                    z: l,
                    x: c,
                    y: h
                };
                for(let i = 0; i < n.length; i++){
                    const r = n.feature(i);
                    if (a.needGeometry) {
                        const t1 = e1.bw(r, !0);
                        if (!a.filter(new e1.ai(this.tileID.overscaledZ, {
                            worldview: this.worldview
                        }), t1, this.tileID.canonical)) continue;
                    } else if (!a.filter(new e1.ai(this.tileID.overscaledZ, {
                        worldview: this.worldview
                    }), r)) continue;
                    const u = s.getId(r, o), p = new e1.bx(r, l, c, h, u);
                    p.tile = d, t1.push(p);
                }
            }
            loaded() {
                return "loaded" === this.state || "errored" === this.state;
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return !!this.imageAtlas && !!this.imageAtlas.patternPositions.size;
            }
            setExpiryData(t1) {
                const i = this.expirationTime;
                if (t1.cacheControl) {
                    const i = e1.by(t1.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
                if (this.expirationTime) {
                    const e1 = Date.now();
                    let t1 = !1;
                    if (this.expirationTime > e1) t1 = !1;
                    else if (i) {
                        if (this.expirationTime < i) t1 = !0;
                        else {
                            const s = this.expirationTime - i;
                            s ? this.expirationTime = e1 + Math.max(s, 3e4) : t1 = !0;
                        }
                    } else t1 = !0;
                    t1 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - Date.now(), Math.pow(2, 31) - 1);
            }
            refreshFeatureState(e1, t1) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData && !this.latestFeatureIndex.is3DTile || !e1) return;
                const i = e1.style.listImages();
                this.updateBuckets(e1, !1, t1, void 0, void 0, i);
            }
            hasAppearances(e1) {
                for(const t1 in this.buckets)if (e1.style.hasLayer(t1) && this.buckets[t1].layers.some((e1)=>e1.appearances && e1.appearances.length > 0)) return !0;
                return !1;
            }
            updateBuckets(t1, i, s, r, o, n) {
                if (!this.latestFeatureIndex) return;
                if (!t1.style) return;
                const a = n || t1.style.listImages(), l = t1.style.getBrightness(), c = o || new Set;
                for(const o in this.buckets){
                    if (!t1.style.hasLayer(o)) continue;
                    const n = this.buckets[o], h = n.layers[0], d = h.sourceLayer || "_geojsonTileLayer", u = t1.style.getLayerSourceCache(h), p = n.layers.some((e1)=>c.has(e1.fqid)), f = (r || p) && n instanceof e1.bu ? t1.style.getOwnLayer(o) : void 0;
                    let m = s && s[d] || {};
                    u && !s && (m = u._state.getState(d, void 0));
                    const _ = this.imageAtlas ? Object.fromEntries(this.imageAtlas.patternPositions) : {}, g = Object.keys(m).length > 0 && !i;
                    n.hasAppearances = n.layers.some((e1)=>e1.appearances && e1.appearances.length > 0);
                    const y = g ? n.stateDependentLayers : n.layers;
                    if (g && 0 !== n.stateDependentLayers.length || i || p || r) {
                        const s = this.latestFeatureIndex.loadVTLayers()[d];
                        if (n.update(m, s, a, _, y, i, l, this.tileID.canonical), (r || p) && (!i || i && n instanceof e1.bu && (!n.text.uboBinder || n.text.uboBinder.isLightConstant || !n.icon.uboBinder || n.icon.uboBinder.isLightConstant)) && n instanceof e1.bu && f && "symbol" === f.type) {
                            const e1 = n;
                            e1.text && e1.text.uboBinder && e1.text.uboBinder.updateDynamicExpressions(f, s, this.tileID.canonical, a, m, l), e1.icon && e1.icon.uboBinder && e1.icon.uboBinder.updateDynamicExpressions(f, s, this.tileID.canonical, a, m, l);
                        }
                        if (n instanceof e1.bu) {
                            const e1 = n, i = t1.context;
                            e1.text && e1.text.uboBinder && e1.text.uboBinder.upload(i), e1.icon && e1.icon.uboBinder && e1.icon.uboBinder.upload(i);
                        }
                    }
                    if (g && 0 !== n.stateDependentLayers.length || i || n.hasAppearances) {
                        const i = {
                            zoom: t1.transform.zoom,
                            pitch: t1.transform.pitch,
                            brightness: t1.style.getBrightness() || 0,
                            worldview: t1.worldview
                        }, s = n.updateAppearances(this.tileID.canonical, m, a, i, t1.imageManager, g && 0 !== n.stateDependentLayers.length);
                        if (s && s.hasUboChanges) {
                            const i = t1.context;
                            n instanceof e1.bu && n.text && n.text.uboBinder && n.text.uboBinder.upload(i), n instanceof e1.bu && n.icon && n.icon.uboBinder && n.icon.uboBinder.upload(i);
                        }
                    }
                    (n instanceof e1.bz || n instanceof e1.bA) && t1._terrain && t1._terrain.enabled && u && n.uploadPending() && t1._terrain._clearRenderCacheForTile(u.id, this.tileID);
                    const v = t1 && t1.style && t1.style.getOwnLayer(o);
                    v && (this.queryPadding = Math.max(this.queryPadding, v.queryRadius(n) || 0));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < e1.e.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(t1) {
                this.symbolFadeHoldUntil = e1.e.now() + t1;
            }
            setTexture(t1, i) {
                const s = i.context, r = s.gl;
                this.texture = this.texture || i.getTileTexture(t1.width), this.texture && this.texture instanceof e1.T ? this.texture.update(t1) : (this.texture = new e1.T(s, t1, r.RGBA8, {
                    useMipmap: !0
                }), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE));
            }
            setDependencies(e1, t1) {
                const i = {};
                for (const e1 of t1)i[e1] = !0;
                this.dependencies[e1] = i;
            }
            hasDependency(e1, t1) {
                for (const i of e1){
                    const e1 = this.dependencies[i];
                    if (e1) {
                        for (const i of t1)if (e1[i]) return !0;
                    }
                }
                return !1;
            }
            clearQueryDebugViz() {}
            _makeDebugTileBoundsBuffers(t1, i) {
                if (!i || "mercator" === i.name || this._tileDebugBuffer) return;
                const s = e1.bB(ds, this.tileID.canonical, this.tileTransform)[0], r = new e1.bC, o = new e1.bD;
                for(let e1 = 0; e1 < s.length; e1++){
                    const { x: t1, y: i } = s[e1];
                    r.emplaceBack(t1, i), o.emplaceBack(e1);
                }
                o.emplaceBack(0), this._tileDebugIndexBuffer = t1.createIndexBuffer(o), this._tileDebugBuffer = t1.createVertexBuffer(r, e1.bE.members), this._tileDebugSegments = e1.ac.simpleSegment(0, 0, r.length, o.length);
            }
            _makeTileBoundsBuffers(t1, i) {
                if (this._tileBoundsBuffer || !i || "mercator" === i.name) return;
                const s = e1.bB(ds, this.tileID.canonical, this.tileTransform)[0];
                let r, o;
                if (this.isRaster) {
                    const t1 = function(t1, i) {
                        const s = e1.bp(t1, i), r = Math.pow(2, t1.z);
                        for(let o = 0; o < rs; o++)for(let n = 0; n < rs; n++){
                            const a = e1.bq((t1.x + (n + cs(n)) / ss) / r), l = e1.br((t1.y + (o + cs(o)) / ss) / r), c = i.project(a, l), h = o * rs + n;
                            ns[2 * h + 0] = Math.round((c.x * s.scale - s.x) * e1.a2), ns[2 * h + 1] = Math.round((c.y * s.scale - s.y) * e1.a2);
                        }
                        as.fill(0), ls.fill(0);
                        for(let e1 = 2045; e1 >= 0; e1--){
                            const t1 = 4 * e1, i = os[t1 + 0], s = os[t1 + 1], r = os[t1 + 2], o = os[t1 + 3], n = i + r >> 1, a = s + o >> 1, l = n + a - s, c = a + i - n, h = s * rs + i, d = o * rs + r, u = a * rs + n, p = Math.hypot((ns[2 * h + 0] + ns[2 * d + 0]) / 2 - ns[2 * u + 0], (ns[2 * h + 1] + ns[2 * d + 1]) / 2 - ns[2 * u + 1]) >= 16;
                            as[u] = as[u] || (p ? 1 : 0), e1 < 1022 && (as[u] = as[u] || as[(s + c >> 1) * rs + (i + l >> 1)] || as[(o + c >> 1) * rs + (r + l >> 1)]);
                        }
                        const o = new e1.bs, n = new e1.ad;
                        let a = 0;
                        function l(t1, i) {
                            const s = i * rs + t1;
                            return 0 === ls[s] && (o.emplaceBack(ns[2 * s + 0], ns[2 * s + 1], t1 * e1.a2 / ss, i * e1.a2 / ss), ls[s] = ++a), ls[s] - 1;
                        }
                        function c(e1, t1, i, s, r, o) {
                            const a = e1 + i >> 1, h = t1 + s >> 1;
                            if (Math.abs(e1 - r) + Math.abs(t1 - o) > 1 && as[h * rs + a]) c(r, o, e1, t1, a, h), c(i, s, r, o, a, h);
                            else {
                                const a = l(e1, t1), c = l(i, s), h = l(r, o);
                                n.emplaceBack(a, c, h);
                            }
                        }
                        return c(0, 0, ss, ss, ss, 0), c(ss, ss, 0, 0, 0, ss), {
                            vertices: o,
                            indices: n
                        };
                    }(this.tileID.canonical, i);
                    r = t1.vertices, o = t1.indices;
                } else {
                    r = new e1.bs, o = new e1.ad;
                    for (const { x: e1, y: t1 } of s)r.emplaceBack(e1, t1, 0, 0);
                    const t1 = e1.bF(r.int16.subarray(0, 4 * r.length), void 0, 4);
                    for(let e1 = 0; e1 < t1.length; e1 += 3)o.emplaceBack(t1[e1], t1[e1 + 1], t1[e1 + 2]);
                }
                this._tileBoundsBuffer = t1.createVertexBuffer(r, hs.members), this._tileBoundsIndexBuffer = t1.createIndexBuffer(o), this._tileBoundsSegments = e1.ac.simpleSegment(0, 0, r.length, o.length);
            }
            _makeGlobeTileDebugBuffers(t1, i) {
                const s = i.projection;
                if (!s || "globe" !== s.name || i.freezeTileCoverage) return;
                const r = this.tileID.canonical, o = e1.V(r, i), n = e1.b4(o), a = e1.S(i.zoom);
                let l;
                a > 0 && (l = e1.aO(new Float64Array(16), i.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(t1, r, i, n, l, a), this._makeGlobeTileDebugTextBuffer(t1, r, i, n, l, a);
            }
            _globePoint(t1, i, s, r, o, n, a) {
                let l = e1.bG(t1, i, s);
                if (n) {
                    const o = 1 << s.z, c = e1.a7(r.center.lng), h = e1.a8(r.center.lat), d = (s.x + .5) / o - c;
                    let u = 0;
                    d > .5 ? u = -1 : d < -0.5 && (u = 1);
                    let p = (t1 / e1.a2 + s.x) / o + u, f = (i / e1.a2 + s.y) / o;
                    p = (p - c) * r._pixelsPerMercatorPixel + c, f = (f - h) * r._pixelsPerMercatorPixel + h;
                    const m = [
                        p * r.worldSize,
                        f * r.worldSize,
                        0
                    ];
                    e1.bH(m, m, n), l = e1.bI(l, m, a);
                }
                return e1.bH(l, l, o);
            }
            _makeGlobeTileDebugBorderBuffer(t1, i, s, r, o, n) {
                const a = new e1.bC, l = new e1.bD, c = new e1.bJ, h = (e1, t1, h, d, u)=>{
                    const p = (h - e1) / (u - 1), f = (d - t1) / (u - 1), m = a.length;
                    for(let h = 0; h < u; h++){
                        const d = e1 + h * p, u = t1 + h * f;
                        a.emplaceBack(d, u);
                        const _ = this._globePoint(d, u, i, s, r, o, n);
                        c.emplaceBack(_[0], _[1], _[2]), l.emplaceBack(m + h);
                    }
                }, d = e1.a2;
                h(0, 0, d, 0, 16), h(d, 0, d, d, 16), h(d, d, 0, d, 16), h(0, d, 0, 0, 16), this._tileDebugIndexBuffer = t1.createIndexBuffer(l), this._tileDebugBuffer = t1.createVertexBuffer(a, e1.bE.members), this._globeTileDebugBorderBuffer = t1.createVertexBuffer(c, e1.bK.members), this._tileDebugSegments = e1.ac.simpleSegment(0, 0, a.length, l.length);
            }
            _makeGlobeTileDebugTextBuffer(t1, i, s, r, o, n) {
                const a = e1.a2 / 4, l = new e1.bC, c = new e1.ad, h = new e1.bJ, d = 25;
                c.reserve(32), l.reserve(d), h.reserve(d);
                const u = (e1, t1)=>d * e1 + t1;
                for(let e1 = 0; e1 < d; e1++){
                    const t1 = e1 * a;
                    for(let e1 = 0; e1 < d; e1++){
                        const c = e1 * a;
                        l.emplaceBack(c, t1);
                        const d = this._globePoint(c, t1, i, s, r, o, n);
                        h.emplaceBack(d[0], d[1], d[2]);
                    }
                }
                for(let e1 = 0; e1 < 4; e1++)for(let t1 = 0; t1 < 4; t1++){
                    const i = u(e1, t1), s = u(e1, t1 + 1), r = u(e1 + 1, t1), o = u(e1 + 1, t1 + 1);
                    c.emplaceBack(i, s, r), c.emplaceBack(r, s, o);
                }
                this._tileDebugTextIndexBuffer = t1.createIndexBuffer(c), this._tileDebugTextBuffer = t1.createVertexBuffer(l, e1.bE.members), this._globeTileDebugTextBuffer = t1.createVertexBuffer(h, e1.bK.members), this._tileDebugTextSegments = e1.ac.simpleSegment(0, 0, d, 32);
            }
            destroy(t1 = !0) {
                for(const e1 in this.buckets)this.buckets[e1].destroy(t1);
                this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && delete this.imageAtlasTexture, this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), t1 && this.texture && this.texture instanceof e1.T && (this.texture.destroy(), delete this.texture), this.emissiveTexture && this.emissiveTexture instanceof e1.T && (this.emissiveTexture.destroy(), delete this.emissiveTexture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.rasterParticleState && (this.rasterParticleState.destroy(), delete this.rasterParticleState), this.latestFeatureIndex = null, this.state = "unloaded";
            }
        }
        class ms {
            constructor(e1, t1){
                this.max = e1, this.onRemove = t1, this.reset();
            }
            reset() {
                for(const e1 in this.data)for (const t1 of this.data[e1])t1.timeout && clearTimeout(t1.timeout), this.onRemove(t1.value);
                return this.data = {}, this.order = [], this;
            }
            add(e1, t1, i) {
                const s = e1.wrapped().key;
                void 0 === this.data[s] && (this.data[s] = []);
                const r = {
                    value: t1,
                    timeout: void 0
                };
                if (void 0 !== i && (r.timeout = setTimeout(()=>{
                    this.remove(e1, r);
                }, i)), this.data[s].push(r), this.order.push(s), this.order.length > this.max) {
                    const e1 = this._getAndRemoveByKey(this.order[0]);
                    e1 && this.onRemove(e1);
                }
                return this;
            }
            has(e1) {
                return e1.wrapped().key in this.data;
            }
            getAndRemove(e1) {
                return this.has(e1) ? this._getAndRemoveByKey(e1.wrapped().key) : null;
            }
            _getAndRemoveByKey(e1) {
                const t1 = this.data[e1].shift();
                return t1.timeout && clearTimeout(t1.timeout), 0 === this.data[e1].length && delete this.data[e1], this.order.splice(this.order.indexOf(e1), 1), t1.value;
            }
            getByKey(e1) {
                const t1 = this.data[e1];
                return t1 ? t1[0].value : null;
            }
            get(e1) {
                return this.has(e1) ? this.data[e1.wrapped().key][0].value : null;
            }
            remove(e1, t1) {
                if (!this.has(e1)) return this;
                const i = e1.wrapped().key, s = void 0 === t1 ? 0 : this.data[i].indexOf(t1), r = this.data[i][s];
                return this.data[i].splice(s, 1), r.timeout && clearTimeout(r.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(r.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(e1) {
                for(this.max = e1; this.order.length > this.max;){
                    const e1 = this._getAndRemoveByKey(this.order[0]);
                    e1 && this.onRemove(e1);
                }
                return this;
            }
            filter(e1) {
                const t1 = [];
                for(const i in this.data)for (const s of this.data[i])e1(s.value) || t1.push(s);
                for (const e1 of t1)this.remove(e1.value.tileID, e1);
            }
        }
        class _s {
            constructor(){
                this.state = Object.create(null), this.stateChanges = Object.create(null), this.deletedStates = Object.create(null);
            }
            updateState(e1, t1, i) {
                const s = String(t1);
                if (this.stateChanges[e1] = this.stateChanges[e1] || Object.create(null), this.stateChanges[e1][s] = this.stateChanges[e1][s] || Object.create(null), Object.assign(this.stateChanges[e1][s], i), null === this.deletedStates[e1]) {
                    this.deletedStates[e1] = Object.create(null);
                    for(const t1 in this.state[e1])t1 !== s && (this.deletedStates[e1][t1] = null);
                } else if (this.deletedStates[e1] && null === this.deletedStates[e1][s]) {
                    this.deletedStates[e1][s] = Object.create(null);
                    for(const t1 in this.state[e1][s])i[t1] || (this.deletedStates[e1][s][t1] = null);
                } else for(const t1 in i)this.deletedStates[e1] && this.deletedStates[e1][s] && null === this.deletedStates[e1][s][t1] && delete this.deletedStates[e1][s][t1];
            }
            removeFeatureState(e1, t1, i) {
                if (null === this.deletedStates[e1]) return;
                const s = String(t1);
                if (this.deletedStates[e1] = this.deletedStates[e1] || Object.create(null), i && void 0 !== t1) null !== this.deletedStates[e1][s] && (this.deletedStates[e1][s] = this.deletedStates[e1][s] || Object.create(null), this.deletedStates[e1][s][i] = null);
                else if (void 0 !== t1) {
                    if (this.stateChanges[e1] && this.stateChanges[e1][s]) for(i in this.deletedStates[e1][s] = Object.create(null), this.stateChanges[e1][s])this.deletedStates[e1][s][i] = null;
                    else this.deletedStates[e1][s] = null;
                } else this.deletedStates[e1] = null;
            }
            getState(e1, t1) {
                const i = this.state[e1] || Object.create(null), s = this.stateChanges[e1] || Object.create(null), r = this.deletedStates[e1];
                if (null === r) return Object.create(null);
                if (void 0 !== t1) {
                    const e1 = String(t1), o = Object.assign(Object.create(null), i[e1], s[e1]);
                    if (r) {
                        const e1 = r[t1];
                        if (null === e1) return Object.create(null);
                        for(const t1 in e1)delete o[t1];
                    }
                    return o;
                }
                const o = Object.assign(Object.create(null), i, s);
                if (r) for(const e1 in r)delete o[e1];
                return o;
            }
            initializeTileState(e1, t1) {
                e1.refreshFeatureState(t1);
            }
            coalesceChanges(e1, t1) {
                const i = Object.create(null);
                for(const e1 in this.stateChanges){
                    this.state[e1] = this.state[e1] || Object.create(null);
                    const t1 = Object.create(null);
                    for(const i in this.stateChanges[e1])this.state[e1][i] || (this.state[e1][i] = Object.create(null)), Object.assign(this.state[e1][i], this.stateChanges[e1][i]), t1[i] = this.state[e1][i];
                    i[e1] = t1;
                }
                for(const e1 in this.deletedStates){
                    this.state[e1] = this.state[e1] || Object.create(null);
                    const t1 = Object.create(null);
                    if (null === this.deletedStates[e1]) for(const i in this.state[e1])t1[i] = Object.create(null), this.state[e1][i] = Object.create(null);
                    else for(const i in this.deletedStates[e1]){
                        if (null === this.deletedStates[e1][i]) this.state[e1][i] = Object.create(null);
                        else if (this.state[e1][i]) for (const t1 of Object.keys(this.deletedStates[e1][i]))delete this.state[e1][i][t1];
                        t1[i] = this.state[e1][i];
                    }
                    i[e1] = i[e1] || Object.create(null), Object.assign(i[e1], t1);
                }
                if (this.stateChanges = Object.create(null), this.deletedStates = Object.create(null), 0 !== Object.keys(i).length) for(const s in e1)e1[s].refreshFeatureState(t1, i);
            }
        }
        class gs extends e1.E {
            constructor(e1, t1, i){
                super(), this.id = e1, this._renderSourceType = i, this._maxzoomOverride = null, this.setSource(t1), this._tiles = {}, this._cache = new ms(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._loadedParentTiles = {}, this.castsShadows = !1, this.tileCoverLift = 0, this._coveredTiles = {}, this._shadowCasterTiles = {}, this._state = new _s, this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "raster-array" === this._source.type || "custom" === this._source.type && "_dataType" in this._source && "raster" === this._source._dataType, this._supportsFading = "raster" === this._source.type || "raster-array" === this._source.type || "image" === this._source.type || "video" === this._source.type || "custom" === this._source.type, this._isRasterElevatedOverTerrain = !1;
            }
            onAdd(e1) {
                this.map = e1, this._minTileCacheSize = void 0 === this._minTileCacheSize && e1 ? e1._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && e1 ? e1._maxTileCacheSize : this._maxTileCacheSize;
            }
            setSource(e1) {
                e1.on("data", (e1)=>{
                    "source" === e1.dataType && "metadata" === e1.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === e1.dataType && "content" === e1.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
                }), e1.on("error", ()=>{
                    this._sourceErrored = !0;
                }), this._source = e1;
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(const e1 in this._tiles)if (!this._tiles[e1].loaded()) return !1;
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const e1 = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, e1 && this.reload(), this.transform && this.update(this.transform);
            }
            setMaxzoomOverride(e1) {
                this._maxzoomOverride = e1;
            }
            _loadTile(e1, t1) {
                return e1.renderSourceType = this._renderSourceType, e1.isExtraShadowCaster = this._shadowCasterTiles[e1.tileID.key], this._source.loadTile(e1, t1);
            }
            _unloadTile(e1) {
                if (this._source.unloadTile) return this._source.unloadTile(e1);
            }
            _abortTile(e1) {
                if (this._source.abortTile) return this._source.abortTile(e1);
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(e1) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const t1 in this._tiles){
                    const i = this._tiles[t1];
                    i.upload(e1, this.map ? this.map.painter : void 0), i.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
                }
            }
            getIds() {
                return Object.values(this._tiles).map((e1)=>e1.tileID).sort(ys).map((e1)=>e1.key);
            }
            getRenderableIds(t1, i) {
                const s = [];
                for(const e1 in this._tiles)this._isIdRenderable(+e1, t1, i) && s.push(this._tiles[e1]);
                return t1 ? s.sort((t1, i)=>{
                    const s = t1.tileID, r = i.tileID, o = new e1.P(s.canonical.x, s.canonical.y)._rotate(this.transform.angle), n = new e1.P(r.canonical.x, r.canonical.y)._rotate(this.transform.angle);
                    return s.overscaledZ - r.overscaledZ || n.y - o.y || n.x - o.x;
                }).map((e1)=>e1.tileID.key) : s.map((e1)=>e1.tileID).sort(ys).map((e1)=>e1.key);
            }
            hasRenderableParent(e1) {
                const t1 = this.findLoadedParent(e1, 0);
                return !!t1 && this._isIdRenderable(t1.tileID.key);
            }
            _isIdRenderable(e1, t1, i) {
                return this._tiles[e1] && this._tiles[e1].hasData() && !this._coveredTiles[e1] && (t1 || !this._tiles[e1].holdingForFade()) && (i || !this._shadowCasterTiles[e1]);
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const e1 in this._tiles)"errored" !== this._tiles[e1].state && this._reloadTile(+e1, "reloading");
                }
            }
            _reloadTile(e1, t1) {
                const i = this._tiles[e1];
                i && ("loading" !== i.state && (i.state = t1), this._loadTile(i, this._tileLoaded.bind(this, i, e1, t1)));
            }
            _tileLoaded(t1, i, s, r, o) {
                if (r) {
                    if (t1.state = "errored", e1.bO(r)) {
                        if (this._source.fire(new e1.h("data", {
                            dataType: "source",
                            sourceDataType: "error",
                            sourceId: this._source.id,
                            tile: t1
                        })), !(t1.tileID.key in this._loadedParentTiles)) return;
                        if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                            const e1 = this.map.painter.terrain;
                            this.update(this.transform, e1.getScaledDemTileSize(), !0), e1.resetTileLookupCache(this.id);
                        } else this.update(this.transform);
                    } else this._source.fire(new e1.f(r, {
                        tile: t1
                    }));
                    return;
                }
                t1.timeAdded = e1.e.now(), "expired" === s && (t1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, t1), "raster-dem" === this._source.type && t1.dem && this._backfillDEM(t1), this._state.initializeTileState(t1, this.map ? this.map.painter : null);
                let n = new Headers;
                o && o.headers && (n = o.headers), this._source.fire(new e1.h("data", {
                    dataType: "source",
                    tile: t1,
                    coord: t1.tileID,
                    sourceCacheId: this.id,
                    responseHeaders: n
                }));
            }
            _hasTunnelGeometry() {
                for(const e1 in this._tiles){
                    const t1 = this._tiles[e1];
                    if (t1 && t1.hasTunnelGeometry) return !0;
                }
                return !1;
            }
            _backfillDEM(e1) {
                const t1 = this.getRenderableIds();
                for(let s = 0; s < t1.length; s++){
                    const r = t1[s];
                    if (e1.neighboringTiles && e1.neighboringTiles[r]) {
                        const t1 = this.getTileByID(r);
                        i(e1, t1), i(t1, e1);
                    }
                }
                function i(e1, t1) {
                    if (!e1.dem || e1.dem.borderReady) return;
                    e1.needsHillshadePrepare = !0, e1.needsDEMTextureUpload = !0;
                    let i = t1.tileID.canonical.x - e1.tileID.canonical.x;
                    const s = t1.tileID.canonical.y - e1.tileID.canonical.y, r = Math.pow(2, e1.tileID.canonical.z), o = t1.tileID.key;
                    0 === i && 0 === s || Math.abs(s) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + r) ? i += r : 1 === Math.abs(i - r) && (i -= r)), t1.dem && e1.dem && (e1.dem.backfillBorder(t1.dem, i, s), e1.neighboringTiles && e1.neighboringTiles[o] && (e1.neighboringTiles[o].backfilled = !0)));
                }
            }
            getTile(e1) {
                return this.getTileByID(e1.key);
            }
            getTileByID(e1) {
                return this._tiles[e1];
            }
            _retainLoadedChildren(e1, t1, i, s) {
                for(const r in this._tiles){
                    let o = this._tiles[r];
                    if (s[r] || !o.hasData() || o.tileID.overscaledZ <= t1 || o.tileID.overscaledZ > i) continue;
                    let n = o.tileID;
                    for(; o && o.tileID.overscaledZ > t1 + 1;){
                        const e1 = o.tileID.scaledTo(o.tileID.overscaledZ - 1);
                        o = this._tiles[e1.key], o && o.hasData() && (n = e1);
                    }
                    let a = n;
                    for(; a.overscaledZ > t1;)if (a = a.scaledTo(a.overscaledZ - 1), e1[a.key]) {
                        s[n.key] = n;
                        break;
                    }
                }
            }
            findLoadedParent(e1, t1) {
                if (e1.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[e1.key];
                    return i && i.tileID.overscaledZ >= t1 ? i : null;
                }
                for(let i = e1.overscaledZ - 1; i >= t1; i--){
                    const t1 = e1.scaledTo(i), s = this._getLoadedTile(t1);
                    if (s) return s;
                }
            }
            _getLoadedTile(e1) {
                const t1 = this._tiles[e1.key];
                return t1 && t1.hasData() ? t1 : this._cache.getByKey(this._source.reparseOverscaled ? e1.wrapped().key : e1.canonical.key);
            }
            updateCacheSize(e1, t1) {
                t1 = t1 || this._source.tileSize;
                const i = Math.ceil(e1.width / t1) + 1, s = Math.ceil(e1.height / t1) + 1, r = Math.floor(i * s * 5), o = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, r) : r, n = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, o) : o;
                this._cache.setMaxSize(n);
            }
            handleWrapJump(e1) {
                const t1 = Math.round((e1 - (void 0 === this._prevLng ? e1 : this._prevLng)) / 360);
                if (this._prevLng = e1, t1) {
                    const e1 = {};
                    for(const i in this._tiles){
                        const s = this._tiles[i];
                        s.tileID = s.tileID.unwrapTo(s.tileID.wrap + t1), e1[s.tileID.key] = s;
                    }
                    this._tiles = e1;
                    for(const e1 in this._timers)clearTimeout(this._timers[e1]), delete this._timers[e1];
                    for(const e1 in this._tiles)this._setTileReloadTimer(+e1, this._tiles[e1]);
                }
            }
            update(t1, i, s, r, o) {
                if (this.transform = t1, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
                if (this.usedForTerrain && !s) return;
                this.updateCacheSize(t1, i), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {};
                const n = "batched-model" === this._source.type;
                let a, l = this._source.maxzoom;
                null !== this._maxzoomOverride && (l = Math.min(l, this._maxzoomOverride));
                const c = this.map && this.map.painter ? this.map.painter._terrain : null;
                if (c && c.sourceCache === this && c.attenuationRange()) {
                    const e1 = c.attenuationRange()[0], t1 = Math.floor(e1) - Math.log2(c.getDemUpscale());
                    l > t1 && (l = t1);
                }
                const h = null === this._maxzoomOverride && this._source.reparseOverscaled;
                if (this.used || this.usedForTerrain) {
                    if (this._source.tileID) a = t1.getVisibleUnwrappedCoordinates(this._source.tileID).map((t1)=>new e1.bP(t1.canonical.z, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y));
                    else if (0 !== this.tileCoverLift) {
                        const r = t1.clone();
                        r.tileCoverLift = this.tileCoverLift, a = r.coveringTiles({
                            tileSize: i || this._source.tileSize,
                            minzoom: this._source.minzoom,
                            maxzoom: l,
                            roundZoom: this._source.roundZoom && !s,
                            reparseOverscaled: h,
                            isTerrainDEM: this.usedForTerrain,
                            calculateQuadrantVisibility: n
                        }), this._source.minzoom <= 1 && "globe" === t1.projection.name && (a.push(new e1.bP(1, 0, 1, 0, 0)), a.push(new e1.bP(1, 0, 1, 1, 0)), a.push(new e1.bP(1, 0, 1, 0, 1)), a.push(new e1.bP(1, 0, 1, 1, 1)));
                    } else if (a = t1.coveringTiles({
                        tileSize: i || this._source.tileSize,
                        minzoom: this._source.minzoom,
                        maxzoom: l,
                        roundZoom: this._source.roundZoom && !s,
                        reparseOverscaled: h,
                        isTerrainDEM: this.usedForTerrain,
                        calculateQuadrantVisibility: n
                    }), this._source.hasTile) {
                        const e1 = this._source.hasTile.bind(this._source);
                        a = a.filter((t1)=>e1(t1));
                    }
                } else a = [];
                if (a.length > 0 && "globe" !== this.transform.projection.name && !this.usedForTerrain && !this._supportsFading) {
                    const e1 = t1.coveringZoomLevel({
                        tileSize: i || this._source.tileSize,
                        roundZoom: this._source.roundZoom && !s
                    }), c = Math.min(e1, l);
                    if (n) {
                        const e1 = t1.extendTileCover(a, c);
                        for (const t1 of e1)a.push(t1);
                    } else if (o) {
                        const e1 = this.transform.getFrustum(c), i = t1.extendTileCoverToNearPlane(a, e1, c);
                        for (const e1 of i)a.push(e1);
                        if (c >= 18 && this._hasTunnelGeometry()) {
                            const i = t1.extendTileCoverForTunnels(a, e1, c, 20);
                            for (const e1 of i)a.push(e1);
                        }
                    } else if (this.castsShadows && r) {
                        const e1 = t1.extendTileCover(a, c, r, 16);
                        for (const t1 of e1)this._shadowCasterTiles[t1.key] = !0, a.push(t1);
                    }
                }
                const d = this._updateRetainedTiles(a);
                if (this._supportsFading && 0 !== a.length) {
                    const t1 = {}, i = {}, s = e1.e.now(), r = Object.keys(d);
                    for (const e1 of r){
                        const r = d[e1], o = this._tiles[e1];
                        if (!o || void 0 !== o.fadeEndTime && o.fadeEndTime <= s) continue;
                        const n = this.findLoadedParent(r, Math.max(r.overscaledZ - gs.maxOverzooming, this._source.minzoom));
                        n && (this._addTile(n.tileID), t1[n.tileID.key] = n.tileID), i[e1] = r;
                    }
                    const o = a.at(-1).overscaledZ;
                    for(const e1 in this._tiles){
                        const t1 = this._tiles[e1];
                        if (d[e1] || !t1.hasData()) continue;
                        let s = t1.tileID;
                        for(; s.overscaledZ > o;){
                            s = s.scaledTo(s.overscaledZ - 1);
                            const r = this._tiles[s.key];
                            if (r && r.hasData() && i[s.key]) {
                                d[e1] = t1.tileID;
                                break;
                            }
                        }
                    }
                    for(const e1 in t1)d[e1] || (this._coveredTiles[e1] = !0, d[e1] = t1[e1]);
                }
                for(const e1 in d)this._tiles[e1].clearFadeHold();
                const u = e1.bQ(this._tiles, d);
                for (const e1 of u){
                    const t1 = this._tiles[e1];
                    t1.hasSymbolBuckets && !t1.holdingForFade() ? t1.setHoldDuration(this.map._fadeDuration) : t1.hasSymbolBuckets && !t1.symbolFadeFinished() || this._removeTile(+e1);
                }
                this._updateLoadedParentTileCache(), this._renderSourceType === e1.bR.Symbol && this._source.afterUpdate && this._source.afterUpdate();
            }
            releaseSymbolFadeTiles() {
                for(const e1 in this._tiles)this._tiles[e1].holdingForFade() && this._removeTile(+e1);
            }
            _updateRetainedTiles(e1) {
                const t1 = {};
                if (0 === e1.length) return t1;
                const i = {}, s = e1.reduce((e1, t1)=>Math.min(e1, t1.overscaledZ), 1 / 0), r = e1[0].overscaledZ, o = Math.max(r - gs.maxOverzooming, this._source.minzoom), n = Math.max(r + gs.maxUnderzooming, this._source.minzoom), a = {};
                for (const i of e1){
                    const e1 = this._addTile(i);
                    t1[i.key] = i, e1.hasData() || s < this._source.maxzoom && (a[i.key] = i);
                }
                this._retainLoadedChildren(a, s, n, t1);
                for (const s of e1){
                    let e1 = this._tiles[s.key];
                    if (e1.hasData()) continue;
                    if (s.canonical.z >= this._source.maxzoom) {
                        const e1 = s.children(this._source.maxzoom)[0], i = this.getTile(e1);
                        if (i && i.hasData()) {
                            t1[e1.key] = e1;
                            continue;
                        }
                    } else {
                        const e1 = s.children(this._source.maxzoom);
                        if (t1[e1[0].key] && t1[e1[1].key] && t1[e1[2].key] && t1[e1[3].key]) continue;
                    }
                    let r = e1.wasRequested();
                    for(let n = s.overscaledZ - 1; n >= o; --n){
                        const o = s.scaledTo(n);
                        if (i[o.key]) break;
                        if (i[o.key] = !0, e1 = this.getTile(o), !e1 && r && (e1 = this._addTile(o)), e1 && (t1[o.key] = o, r = e1.wasRequested(), e1.hasData())) break;
                    }
                }
                return t1;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const e1 in this._tiles){
                    const t1 = [];
                    let i, s = this._tiles[e1].tileID;
                    for(; s.overscaledZ > 0;){
                        if (s.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[s.key];
                            break;
                        }
                        t1.push(s.key);
                        const e1 = s.scaledTo(s.overscaledZ - 1);
                        if (i = this._getLoadedTile(e1), i) break;
                        s = e1;
                    }
                    for (const e1 of t1)this._loadedParentTiles[e1] = i;
                }
            }
            _addTile(t1) {
                let i = this._tiles[t1.key];
                if (i) return !0 !== i.isExtraShadowCaster || !!this._shadowCasterTiles[t1.key] || this._reloadTile(t1.key, "reloading"), i;
                i = this._cache.getAndRemove(t1), i && (this._setTileReloadTimer(t1.key, i), i.tileID = t1, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[t1.key] && (clearTimeout(this._cacheTimers[t1.key]), delete this._cacheTimers[t1.key], this._setTileReloadTimer(t1.key, i)));
                const s = Boolean(i);
                if (!s) {
                    const e1 = this.map ? this.map.painter : null, s = this._source.tileSize * t1.overscaleFactor();
                    i = "raster-array" === this._source.type ? function(e1, t1, i, s, r) {
                        if (!us) throw new Error("Raster-array module is not loaded.");
                        return us(e1, t1, i, s, r);
                    }(t1, s, this.transform.tileZoom, e1, this._isRaster) : new fs(t1, s, this.transform.tileZoom, e1, this._isRaster, this._source.worldview), this._loadTile(i, this._tileLoaded.bind(this, i, t1.key, i.state));
                }
                return i.uses++, this._tiles[t1.key] = i, s || this._source.fire(new e1.h("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(e1, t1) {
                e1 in this._timers && (clearTimeout(this._timers[e1]), delete this._timers[e1]);
                const i = t1.getExpiryTimeout();
                i && (this._timers[e1] = setTimeout(()=>{
                    this._reloadTile(e1, "expired"), delete this._timers[e1];
                }, i));
            }
            _removeTile(e1) {
                const t1 = this._tiles[e1];
                t1 && (t1.uses--, delete this._tiles[e1], this._timers[e1] && (clearTimeout(this._timers[e1]), delete this._timers[e1]), t1.uses > 0 || (t1.hasData() && "reloading" !== t1.state || "empty" === t1.state ? this._cache.add(t1.tileID, t1, t1.getExpiryTimeout()) : (t1.aborted = !0, this._abortTile(t1), this._unloadTile(t1))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const e1 in this._tiles)this._removeTile(+e1);
                this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
            }
            tilesIn(t1, i, s) {
                const r = [], o = this.transform;
                if (!o) return r;
                const n = "globe" === o.projection.name, a = e1.a7(o.center.lng), l = o.getFreeCameraOptions().position || new e1.bS(0, 0, 0);
                for(const c in this._tiles){
                    const h = this._tiles[c];
                    if (s && h.clearQueryDebugViz(), h.holdingForFade()) continue;
                    let d;
                    if (n) {
                        const t1 = h.tileID.canonical;
                        if (0 === t1.z) {
                            const i = [
                                Math.abs(e1.b0(a, ...vs(t1, -1)) - a),
                                Math.abs(e1.b0(a, ...vs(t1, 1)) - a)
                            ];
                            d = [
                                0,
                                2 * i.indexOf(Math.min(...i)) - 1
                            ];
                        } else {
                            const i = [
                                Math.abs(e1.b0(a, ...vs(t1, -1)) - a),
                                Math.abs(e1.b0(a, ...vs(t1, 0)) - a),
                                Math.abs(e1.b0(a, ...vs(t1, 1)) - a)
                            ];
                            d = [
                                i.indexOf(Math.min(...i)) - 1
                            ];
                        }
                    } else d = [
                        0
                    ];
                    for (const e1 of d){
                        const s = t1.containsTile(h, o, i, e1, l);
                        s && r.push(s);
                    }
                }
                return r;
            }
            getShadowCasterCoordinates() {
                return this._getRenderableCoordinates(!1, !0);
            }
            getVisibleCoordinates(e1) {
                return this._getRenderableCoordinates(e1);
            }
            _getRenderableCoordinates(e1, t1) {
                if (!this.transform) return [];
                const i = this.getRenderableIds(e1, t1).map((e1)=>this._tiles[e1].tileID), s = "globe" === this.transform.projection.name;
                for (const e1 of i)e1.projMatrix = this.transform.calculateProjMatrix(e1.toUnwrapped()), e1.expandedProjMatrix = s ? this.transform.calculateProjMatrix(e1.toUnwrapped(), !1, !0) : e1.projMatrix;
                return i;
            }
            sortCoordinatesByDistance(e1) {
                if (!this.transform) return e1.slice();
                const t1 = e1.slice(), i = this.transform._camera.position, s = this.transform._camera.forward(), r = {};
                for (const e1 of t1){
                    const t1 = 1 / (1 << e1.canonical.z);
                    r[e1.key] = ((e1.canonical.x + .5) * t1 + e1.wrap - i[0]) * s[0] + ((e1.canonical.y + .5) * t1 - i[1]) * s[1] - i[2] * s[2];
                }
                return t1.sort((e1, t1)=>r[e1.key] - r[t1.key]), t1;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (this._supportsFading) {
                    const t1 = e1.e.now();
                    for(const e1 in this._tiles){
                        const i = this._tiles[e1];
                        if (void 0 !== i.fadeEndTime && i.fadeEndTime >= t1) return !0;
                    }
                }
                return !1;
            }
            setFeatureState(e1, t1, i) {
                this._state.updateState(e1 = e1 || "_geojsonTileLayer", t1, i);
            }
            removeFeatureState(e1, t1, i) {
                this._state.removeFeatureState(e1 = e1 || "_geojsonTileLayer", t1, i);
            }
            getFeatureState(e1, t1) {
                return this._state.getState(e1 = e1 || "_geojsonTileLayer", t1);
            }
            setDependencies(e1, t1, i) {
                const s = this._tiles[e1];
                s && s.setDependencies(t1, i);
            }
            reloadTilesForDependencies(e1, t1) {
                for(const i in this._tiles)this._tiles[i].hasDependency(e1, t1) && this._reloadTile(+i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(e1, t1));
            }
            _preloadTiles(t1, i) {
                if (!this._sourceLoaded) {
                    const e1 = ()=>{
                        this._sourceLoaded && (this._source.off("data", e1), this._preloadTiles(t1, i));
                    };
                    return void this._source.on("data", e1);
                }
                const s = new Map, r = Array.isArray(t1) ? t1 : [
                    t1
                ], o = this.map.painter.terrain, n = this.usedForTerrain && o ? o.getScaledDemTileSize() : this._source.tileSize;
                for (const e1 of r){
                    const t1 = e1.coveringTiles({
                        tileSize: n,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom && !this.usedForTerrain,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain
                    });
                    for (const e1 of t1)s.set(e1.key, e1);
                    this.usedForTerrain && e1.updateElevation(!1);
                }
                const a = Array.from(s.values());
                e1.bT(a, (e1, t1)=>{
                    const i = new fs(e1, this._source.tileSize * e1.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster, this._source.worldview);
                    this._loadTile(i, (e1)=>{
                        "raster-dem" === this._source.type && i.dem && this._backfillDEM(i), t1(e1, i);
                    });
                }, i);
            }
        }
        function ys(e1, t1) {
            const i = Math.abs(2 * e1.wrap) - +(e1.wrap < 0), s = Math.abs(2 * t1.wrap) - +(t1.wrap < 0);
            return e1.overscaledZ - t1.overscaledZ || s - i || t1.canonical.y - e1.canonical.y || t1.canonical.x - e1.canonical.x;
        }
        function vs(e1, t1) {
            const i = 1 << e1.z;
            return [
                e1.x / i + t1,
                (e1.x + 1) / i + t1
            ];
        }
        function bs(e1, t1) {
            if (e1.z <= t1.z) {
                const i = t1.z - e1.z;
                return t1.x >> i === e1.x && t1.y >> i === e1.y;
            }
            const i = e1.z - t1.z;
            return e1.x >> i === t1.x && e1.y >> i === t1.y;
        }
        function xs(e1, t1) {
            return e1.sourceFQID !== t1.sourceFQID ? e1.sourceFQID < t1.sourceFQID ? -1 : 1 : e1.tileId.z !== t1.tileId.z ? e1.tileId.z - t1.tileId.z : e1.tileId.x !== t1.tileId.x ? e1.tileId.x - t1.tileId.x : e1.tileId.y - t1.tileId.y;
        }
        gs.maxOverzooming = 10, gs.maxUnderzooming = 3;
        class ws {
            constructor(e1 = []){
                this.tiles = e1;
            }
            getTilesIntersecting(e1) {
                const t1 = [];
                for (const i of this.tiles)bs(i.tileId, e1) && t1.push(i);
                return t1;
            }
            equals(e1) {
                if (this.tiles.length !== e1.length) return !1;
                for(let t1 = 0; t1 < this.tiles.length; ++t1){
                    const i = this.tiles[t1], s = e1[t1];
                    if (i.sourceFQID !== s.sourceFQID || i.tileId.z !== s.tileId.z || i.tileId.x !== s.tileId.x || i.tileId.y !== s.tileId.y || i.generation !== s.generation) return !1;
                }
                return !0;
            }
            empty() {
                return 0 === this.tiles.length;
            }
        }
        class Ts {
            constructor(){
                this._tiles = [], this._snapshot = new ws, this._snapshotChanged = !1;
            }
            clear() {
                this._tiles.length = 0;
            }
            consumeSnapshotChanged() {
                const e1 = this._snapshotChanged;
                return this._snapshotChanged = !1, e1;
            }
            addTileElevation(e1, t1, i, s) {
                this._tiles.push({
                    sourceFQID: e1,
                    tileId: t1,
                    features: i,
                    generation: s
                });
            }
            updateSnapshotIfNeeded() {
                return this._tiles.sort(xs), this._snapshot.equals(this._tiles) || (this._snapshot = new ws(this._tiles.slice()), this._snapshotChanged = !0), this._snapshot;
            }
        }
        function Ss(e1, t1) {
            const i = [];
            for (const s of e1.getTilesIntersecting(t1))i.push(`${s.tileId.z}/${s.tileId.x}/${s.tileId.y}:${s.generation}`);
            return i.sort(), i.join("|");
        }
        function Cs(t1, i) {
            const s = e1.bW(t1);
            return s === i || !s && !i;
        }
        function Es(e1, t1) {
            return e1._mergedOtherSourceCaches[t1] || e1._mergedSymbolSourceCaches[t1] || e1._mergedHdRoadElevationSourceCaches[t1];
        }
        function Is(e1) {
            const t1 = e1.sourceLayer;
            return !!t1 && t1.startsWith("hd_road_");
        }
        function Ds(e1) {
            return !!e1.layout && ("line" === e1.type && "hd-road-markup" === e1.layout.get("line-elevation-reference") || "circle" === e1.type && "hd-road-markup" === e1.layout.get("circle-elevation-reference") || "symbol" === e1.type && "hd-road-markup" === e1.layout.get("symbol-elevation-reference") || "fill" === e1.type && "hd-road-markup" === e1.layout.get("fill-elevation-reference"));
        }
        function Ps(t1) {
            const i = new Set;
            for(const s in t1._mergedLayers){
                const r = t1._mergedLayers[s];
                Ds(r) && i.add(e1.m(r.source, r.scope));
            }
            return i;
        }
        function Ls(t1) {
            const i = Ps(t1), s = new Set;
            for(const r in t1._mergedLayers){
                const o = t1._mergedLayers[r];
                if (!o.source || !Is(o)) continue;
                const n = e1.m(o.source, o.scope);
                i.has(n) || s.add(n);
            }
            return s;
        }
        function Rs(e1) {
            const t1 = Ps(e1);
            if (0 === t1.size) return !1;
            const i = As(e1);
            for (const e1 of t1)for (const t1 of i)if (e1 !== t1) return !0;
            return !1;
        }
        function As(t1) {
            const i = new Set;
            for(const s in t1._mergedLayers){
                const r = t1._mergedLayers[s];
                r.source && Is(r) && i.add(e1.m(r.source, r.scope));
            }
            return i;
        }
        function Ms(e1, t1, i) {
            const s = Ps(e1);
            if (0 === s.size) return;
            if (!i) {
                const t1 = As(e1);
                for (const e1 of t1)s.delete(e1);
            }
            if (0 === s.size) return;
            const r = [
                e1._mergedOtherSourceCaches,
                e1._mergedSymbolSourceCaches
            ];
            for (const e1 of r)for(const i in e1){
                if (!s.has(i)) continue;
                const r = e1[i];
                for(const e1 in r._tiles){
                    const i = r._tiles[e1];
                    i && (t1 && !t1(i) || (i.hasDeferredElevationFeatures = !1, r._reloadTile(+e1, "reloading")));
                }
            }
        }
        class Fs {
            constructor(){
                this.elevationSourceCaches = {}, this.manager = new Ts, this._needsCrossSourceElevation = !1, this._ingestFQIDs = new Set, this._terrainActiveLast = void 0;
            }
        }
        function Os(e1) {
            e1.map && e1.map.painter && (e1.map.painter.elevationCoverageSnapshot = null, e1.map.painter.elevationProvidersReady = void 0);
        }
        function Bs(e1) {
            e1._crossSourceElevationActive = !1, function(e1) {
                const t1 = e1._hdElevation, i = !!(e1.map && e1.map.painter && e1.map.painter.elevationCoverageSnapshot);
                return t1 ? !t1._needsCrossSourceElevation && 0 === t1._ingestFQIDs.size && 0 === t1.manager._tiles.length && !i : !i;
            }(e1) || (Os(e1), e1._hdElevation && (e1._hdElevation._needsCrossSourceElevation = !1, e1._hdElevation._ingestFQIDs.clear(), e1._hdElevation.manager.clear(), e1._hdElevation._terrainActiveLast = void 0));
        }
        function ks(t1, i, s) {
            const r = e1.m(s.id, t1.scope);
            if (i.elevationSourceCaches[r]) return;
            const o = `hd-road-elevation:${s.id}`, n = e1.m(o, t1.scope), a = t1._sourceCaches[o] = new gs(n, s, e1.bR.HdRoadElevation);
            i.elevationSourceCaches[r] = a, a.onAdd(t1.map);
            const l = t1._otherSourceCaches[s.id];
            l && l._sourceLoaded && (a._sourceLoaded = !0);
        }
        function zs(e1, t1) {
            if (Gt(e1, e1.map && e1.map.transform)) return t1.manager.clear(), void (e1.map.painter && (e1.map.painter.elevationCoverageSnapshot = null));
            if (!t1._needsCrossSourceElevation) return void Os(e1);
            for (const i of t1._ingestFQIDs){
                const t1 = Es(e1, i);
                t1 && (t1.used = !0);
            }
            t1.manager.clear();
            let i = !0;
            for (const s of t1._ingestFQIDs){
                const r = Es(e1, s);
                if (!r) continue;
                const o = r._tiles;
                for(const e1 in o){
                    const r = o[e1];
                    if (!r || !r.loaded()) continue;
                    const n = r.parsedElevationFeatures;
                    void 0 !== n ? t1.manager.addTileElevation(s, r.tileID.canonical, n, r.parsedElevationGeneration) : i = !1;
                }
            }
            const s = t1.manager._snapshot, r = t1.manager.updateSnapshotIfNeeded();
            e1.map.painter && (e1.map.painter.elevationCoverageSnapshot = r.empty() ? null : r);
            const o = i && function(e1, t1) {
                for (const i of t1){
                    const t1 = Es(e1, i);
                    if (!t1) return !1;
                    if (!t1._sourceLoaded) return !1;
                    for(const e1 in t1._tiles){
                        const i = t1._tiles[e1];
                        if (i && ("loading" === i.state || "reloading" === i.state)) return !1;
                    }
                }
                return !0;
            }(e1, Ls(e1));
            e1.map.painter && (e1.map.painter.elevationProvidersReady = o);
            const n = t1.manager.consumeSnapshotChanged();
            (n || o) && Ms(e1, (e1)=>{
                var t1, i;
                return !!e1.hasDeferredElevationFeatures || n && (t1 = r, Ss(s, i = e1.tileID.canonical) !== Ss(t1, i));
            });
        }
        const Us = (e1)=>({
                u_matrix: e1
            });
        function Ns(t1, i) {
            const s = t1.context.gl;
            return new e1._({
                func: s.EQUAL,
                mask: 255
            }, t1._tileClippingMaskIDs[i.key] || 0, 0, s.KEEP, s.KEEP, s.KEEP);
        }
        function js(t1, i) {
            const s = t1.context.gl;
            return new e1._({
                func: s.EQUAL,
                mask: 255
            }, 255 & ~(t1._tileClippingMaskIDs[i.key] || 0), 0, s.KEEP, s.KEEP, s.KEEP);
        }
        function Vs(t1, i) {
            if (!t1.frcCoverageSnapshot || !t1.frcCoverageRenderer) return null;
            const s = t1.frcCoverageSnapshot.getTileOrParent(i.canonical);
            if (!s || 0 === s.frcMask) return null;
            const r = t1.frcCoverageRenderer.getBuffers(s.tileId);
            if (!r) return null;
            const o = new e1.bX(s.tileId.z, s.tileId.x, s.tileId.y), n = new e1.bY(i.wrap, o);
            return {
                buffers: r,
                projMatrix: t1.transform.calculateProjMatrix(n),
                coverageTile: s
            };
        }
        function Gs(t1, i, s) {
            if (!t1.frcCoverageSnapshot) return;
            const r = t1.context, o = r.gl, n = t1.getOrCreateProgram("clippingMask");
            r.setColorMode(e1.a1.disabled), r.setDepthMode(e1.Z.disabled);
            for (const r of i){
                const i = Vs(t1, r);
                if (!i) continue;
                const a = i.buffers.frcLevelSegments[s];
                a && n.draw(t1, o.TRIANGLES, e1.Z.disabled, new e1._({
                    func: o.EQUAL,
                    mask: 255
                }, t1._tileClippingMaskIDs[r.key] || 0, 255, o.KEEP, o.KEEP, o.INVERT), e1.a1.disabled, e1.$.disabled, Us(i.projMatrix), `$frc_coverage_${s}`, i.buffers.vertexBuffer, i.buffers.indexBuffer, a);
            }
        }
        function qs(t1, i, s) {
            if (!t1.frcCoverageSnapshot) return;
            const r = t1.context, o = r.gl, n = t1.getOrCreateProgram("clippingMask");
            r.setColorMode(e1.a1.disabled), r.setDepthMode(e1.Z.disabled);
            for (const r of i){
                const i = Vs(t1, r);
                if (!i) continue;
                const a = i.buffers.frcLevelSegments[s];
                a && n.draw(t1, o.TRIANGLES, e1.Z.disabled, new e1._({
                    func: o.EQUAL,
                    mask: 255
                }, 255 & ~(t1._tileClippingMaskIDs[r.key] || 0), 255, o.KEEP, o.KEEP, o.INVERT), e1.a1.disabled, e1.$.disabled, Us(i.projMatrix), `$frc_coverage_restore_${s}`, i.buffers.vertexBuffer, i.buffers.indexBuffer, a);
            }
        }
        function Zs(e1, t1, i, s, r) {
            if (0 === t1.length) return;
            let o = 0;
            for (const e1 of t1)o |= e1.frcMask;
            const n = t1.map((e1)=>e1.coord);
            for(let a = 0; a < 9; ++a)if (o & 1 << a) {
                if (Gs(e1, n, a), s) for (const i of t1)i.frcMask & 1 << a && s(i, a, Ns(e1, i.coord));
                if (i > 0 && r) for (const i of t1)i.frcMask & 1 << a && r(i, a, js(e1, i.coord));
                qs(e1, n, a);
            }
        }
        function $s(e1) {
            for (const t1 of e1)if (t1.rings.length > 0 && t1.rings[0].length > 0) return !0;
            return !1;
        }
        function Hs(e1) {
            const t1 = e1.frcCoverageFadeRange;
            return !t1 || t1[1] <= t1[0] ? 0 : 1 - Math.max(0, Math.min(1, (e1.transform.zoom - t1[0]) / (t1[1] - t1[0])));
        }
        const Ws = {
            loaded: !0,
            drawBuilding: function(t1, i, s, r) {
                t1.currentLayer < t1.firstLightBeamLayer && (t1.firstLightBeamLayer = t1.currentLayer);
                const o = s.paint.get("building-ambient-occlusion-ground-intensity"), n = s.paint.get("building-ambient-occlusion-ground-radius"), a = s.paint.get("building-ambient-occlusion-ground-attenuation"), l = s.paint.get("building-opacity");
                if (l <= 0) return;
                let c = o > 0 && n > 0, h = !0;
                const d = s.paint.get("building-vertical-scale");
                if (d <= 0) return;
                t1.shadowRenderer || (h = !1);
                const u = t1.conflationActive && t1.style.isLayerClipped(s, i.getSource()), p = t1.style.order.indexOf(s.fqid);
                if (function(e1, t1, i, s, r, o) {
                    for (const n of o){
                        const o = t1.getTile(n).getBucket(i);
                        o && (r && o.updateReplacement(n, e1.replacementSource, s), o.uploadUpdatedIndexBuffer(e1.context));
                    }
                }(t1, i, s, p, u, r), function(e1, t1, i, s) {
                    for (const r of s){
                        const s = t1.getTile(r).getBucket(i);
                        s && s.needsEvaluation() && s.uploadUpdatedColorBuffer(e1.context);
                    }
                }(t1, i, s, r), s.resetLayerRenderingStats(t1), t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !0), "shadow" === t1.renderPass && t1.shadowRenderer) {
                    const o = [], n = t1.shadowRenderer.getShadowPassDepthMode();
                    xi({
                        painter: t1,
                        source: i,
                        layer: s,
                        coords: r,
                        defines: o,
                        blendMode: e1.a1.disabled,
                        depthMode: n,
                        opacity: l,
                        verticalScale: d,
                        facadeEmissiveChance: 0,
                        facadeAOIntensity: 0,
                        floodLightIntensity: 0,
                        floodLightColor: [
                            0,
                            0,
                            0
                        ]
                    });
                } else if ("translucent" === t1.renderPass) {
                    let p = [
                        "HAS_ATTRIBUTE_a_part_color_emissive",
                        "LIGHTING_3D_MODE"
                    ];
                    h && (p = p.concat("RENDER_SHADOWS")), t1.shadowRenderer && t1.shadowRenderer.useNormalOffset && (p = p.concat("NORMAL_OFFSET"));
                    const f = s.paint.get("building-facade-emissive-chance"), m = s.paint.get("building-ambient-occlusion-intensity"), _ = s.paint.get("building-flood-light-intensity"), g = "none" === s.paint.get("building-flood-light-color-use-theme").constantOr("default"), y = s.paint.get("building-flood-light-color").toNonPremultipliedRenderColor(g ? null : s.lut).toArray01().slice(0, 3), v = s.paint.get("building-flood-light-ground-attenuation"), b = _ > 0, x = new e1.Z(t1.context.gl.LEQUAL, e1.Z.ReadWrite, t1.depthRangeFor3D);
                    l < 1 && xi({
                        painter: t1,
                        source: i,
                        layer: s,
                        coords: r,
                        defines: p,
                        blendMode: e1.a1.disabled,
                        depthMode: x,
                        opacity: l,
                        verticalScale: d,
                        facadeEmissiveChance: f,
                        facadeAOIntensity: m,
                        floodLightIntensity: _,
                        floodLightColor: y,
                        depthOnly: !0
                    });
                    const w = t1.colorModeForRenderPass();
                    xi({
                        painter: t1,
                        source: i,
                        layer: s,
                        coords: r,
                        defines: p,
                        blendMode: w,
                        depthMode: x,
                        opacity: l,
                        verticalScale: d,
                        facadeEmissiveChance: f,
                        facadeAOIntensity: m,
                        floodLightIntensity: _,
                        floodLightColor: y
                    });
                    const T = s.paint.get("building-front-cutoff");
                    pi(t1.transform.pitch, T, !!t1.terrain), c && wi(t1, i, s, r, !0, l, o, n, _, y, a, u), b && wi(t1, i, s, r, !1, l, o, n, _, y, v, u);
                } else if ("light-beam" === t1.renderPass) {
                    const o = [
                        "HAS_ATTRIBUTE_a_part_color_emissive",
                        "HAS_ATTRIBUTE_a_bloom_attenuation"
                    ], n = new e1.Z(t1.context.gl.LEQUAL, e1.Z.ReadOnly, t1.depthRangeFor3D);
                    xi({
                        painter: t1,
                        source: i,
                        layer: s,
                        coords: r,
                        defines: o,
                        blendMode: e1.a1.alphaBlended,
                        depthMode: n,
                        opacity: l,
                        verticalScale: d,
                        facadeEmissiveChance: 0,
                        facadeAOIntensity: 0,
                        floodLightIntensity: 0,
                        floodLightColor: [
                            0,
                            0,
                            0
                        ]
                    });
                }
                t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !1), t1.resetStencilClippingMasks();
            },
            BuildingTileBorderManager: class {
                constructor(){
                    this.visibleTiles = [];
                }
                updateBorders(t1, i) {
                    const s = [], r = [], o = t1._getRenderableCoordinates(!1, !0);
                    for (const e1 of o){
                        const o = t1.getTile(e1);
                        if (!o.hasData()) continue;
                        const n = o.getBucket(i);
                        n && (n.isEmpty() || (s.push(e1.key), r.push({
                            bucket: n,
                            tileID: e1.canonical
                        })));
                    }
                    let n = s.length !== this.visibleTiles.length;
                    if (!n) {
                        s.sort();
                        for(let e1 = 0; e1 < s.length; e1++)if (s[e1] !== this.visibleTiles[e1]) {
                            n = !0;
                            break;
                        }
                    }
                    if (!n) return;
                    const a = new Set;
                    this.visibleTiles = s, r.sort((e1, t1)=>e1.tileID.z - t1.tileID.z || e1.tileID.x - t1.tileID.x || e1.tileID.y - t1.tileID.y);
                    for (const t1 of r){
                        const i = new Array, s = new Array, r = t1.bucket;
                        for (const t1 of r.featuresOnBorder)r.footprints[t1.footprintIndex].hiddenFlags & e1.aR || (a.has(t1.featureId) ? s.push(t1.footprintIndex) : (a.add(t1.featureId), i.push(t1.footprintIndex)));
                        r.updateFootprintHiddenFlags(i, e1.aS, !1), r.updateFootprintHiddenFlags(s, e1.aS, !0);
                    }
                }
            },
            drawRasterParticle: function(t1, i, s, r, o, n) {
                "offscreen" === t1.renderPass && function(t1, i, s, r) {
                    if (!r.length) return;
                    const o = t1.context, n = o.gl, a = i.getSource();
                    if ("raster-array" !== a.type) return;
                    const l = Math.ceil(Math.sqrt(s.paint.get("raster-particle-count")));
                    let c = s.particlePositionRGBAImage;
                    if (!c || c.width !== l) {
                        const t1 = function(t1) {
                            const i = t1 * t1, s = new Uint8Array(4 * i), r = .9090909090909091;
                            for(let t1 = 0; t1 < i; t1++){
                                const i = r * (e1.b8(2 * t1 + 0) + Si), o = r * (e1.b8(2 * t1 + 1) + Si), n = 255 * i % 1, a = 255 * o % 1, l = n, c = o - a / 255, h = a;
                                s[4 * t1 + 0] = 255 * (i - n / 255), s[4 * t1 + 1] = 255 * l, s[4 * t1 + 2] = 255 * c, s[4 * t1 + 3] = 255 * h;
                            }
                            return s;
                        }(l);
                        c = s.particlePositionRGBAImage = new e1.b({
                            width: l,
                            height: l
                        }, t1);
                    }
                    let h = s.particleFramebuffer;
                    h ? h.width !== l && (h.destroy(), h = s.particleFramebuffer = o.createFramebuffer(l, l, 1, null)) : h = s.particleFramebuffer = o.createFramebuffer(l, l, 1, null);
                    const d = [];
                    for (const e1 of r){
                        const t1 = i.getTile(e1);
                        if (!t1) continue;
                        const r = Mi(t1, a, s);
                        if (!r) continue;
                        const n = [
                            t1.tileSize,
                            t1.tileSize
                        ];
                        let h = s.tileFramebuffer;
                        h || (h = s.tileFramebuffer = o.createFramebuffer(n[0], n[1], 1, null));
                        let u = t1.rasterParticleState;
                        u || (u = t1.rasterParticleState = new Ri(o, e1, n, c));
                        const p = u.update(s.lastInvalidatedAt);
                        u.particleTextureDimension !== l && u.updateParticleTexture(e1, c);
                        const f = u.targetColorTexture;
                        u.targetColorTexture = u.backgroundColorTexture, u.backgroundColorTexture = f;
                        const m = u.particleTexture0;
                        u.particleTexture0 = u.particleTexture1, u.particleTexture1 = m, d.push([
                            e1,
                            r,
                            u,
                            p
                        ]);
                    }
                    if (0 === d.length) return;
                    const u = e1.e.now(), p = s.previousDrawTimestamp ? .001 * (u - s.previousDrawTimestamp) : .0167;
                    if (s.previousDrawTimestamp = u, s.hasColorMap()) {
                        o.activeTexture.set(n.TEXTURE0 + 2);
                        let t1 = s.colorRampTexture;
                        t1 || (t1 = s.colorRampTexture = new e1.T(o, s.colorRamp, n.RGBA8)), t1.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                    }
                    o.bindFramebuffer.set(s.tileFramebuffer.framebuffer), function(t1, i, s) {
                        const r = t1.context, o = r.gl, n = i.tileFramebuffer;
                        r.activeTexture.set(o.TEXTURE0);
                        const a = {
                            u_texture: 0,
                            u_opacity: 1.05 * (c = i.paint.get("raster-particle-fade-opacity-factor")) / (c + .05)
                        }, l = t1.getOrCreateProgram("rasterParticleTexture", {
                            defines: [],
                            overrideFog: !1
                        });
                        var c;
                        for (const c of s){
                            const [, , s, h] = c;
                            n.colorAttachment0.set(s.targetColorTexture.texture), r.viewport.set([
                                0,
                                0,
                                n.width,
                                n.height
                            ]), r.clear({
                                color: e1.C.transparent
                            }), h && (s.backgroundColorTexture.bind(o.NEAREST, o.CLAMP_TO_EDGE), l.draw(t1, o.TRIANGLES, e1.Z.disabled, e1._.disabled, e1.a1.alphaBlended, e1.$.disabled, a, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments));
                        }
                    }(t1, s, d), function(t1, i, s, r) {
                        const o = t1.context, n = o.gl, a = s.tileFramebuffer, l = "globe" === t1.transform.projection.name, c = s.paint.get("raster-particle-max-speed");
                        for (const h of r){
                            const [r, d, u] = h;
                            o.activeTexture.set(n.TEXTURE0 + 0), d.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE), a.colorAttachment0.set(u.targetColorTexture.texture);
                            const p = t1.getOrCreateProgram("rasterParticleDraw", {
                                defines: d.defines,
                                overrideFog: !1
                            });
                            o.activeTexture.set(n.TEXTURE0 + 1);
                            const f = d.scalarData ? [] : [
                                0,
                                1,
                                2,
                                3
                            ].map((t1)=>e1.aB[t1](r));
                            f.push(r);
                            const m = r.canonical.x, _ = r.canonical.y;
                            for (const o of f){
                                const a = i.getTile(l ? o.wrapped() : o);
                                if (!a) continue;
                                const h = a.rasterParticleState;
                                if (!h) continue;
                                const u = o.canonical.x + (1 << o.canonical.z) * (o.wrap - r.wrap), f = o.canonical.y;
                                h.particleTexture0.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                                const g = Ei(1, h.particleTexture0.size[0], [
                                    u - m,
                                    f - _
                                ], 0, d.texture.size, 2, c, d.textureOffset, d.scale, d.offset);
                                p.draw(t1, n.POINTS, e1.Z.disabled, e1._.disabled, e1.a1.alphaBlended, e1.$.disabled, g, s.id, h.particleIndexBuffer, void 0, h.particleSegment);
                            }
                        }
                    }(t1, i, s, d), o.bindFramebuffer.set(s.particleFramebuffer.framebuffer), function(t1, i, s, r) {
                        const o = t1.context, n = o.gl, a = i.paint.get("raster-particle-max-speed"), l = r * i.paint.get("raster-particle-speed-factor") * .15, c = function(e1) {
                            return Math.pow(e1, 6);
                        }(.01 + 1 * i.paint.get("raster-particle-reset-rate-factor")), h = i.particleFramebuffer;
                        o.viewport.set([
                            0,
                            0,
                            h.width,
                            h.height
                        ]);
                        for (const r of s){
                            const [, s, d] = r;
                            o.activeTexture.set(n.TEXTURE0 + 0), s.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE), o.activeTexture.set(n.TEXTURE0 + 1);
                            const u = d.particleTexture0;
                            u.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                            const p = Ii(1, u.size[0], 0, s.texture.size, a, l, c, s.textureOffset, s.scale, s.offset);
                            h.colorAttachment0.set(d.particleTexture1.texture), o.clear({
                                color: e1.C.transparent
                            }), t1.getOrCreateProgram("rasterParticleUpdate", {
                                defines: s.defines
                            }).draw(t1, n.TRIANGLES, e1.Z.disabled, e1._.disabled, e1.a1.unblended, e1.$.disabled, p, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                        }
                    }(t1, s, d, p);
                }(t1, i, s, r), "translucent" === t1.renderPass && (function(t1, i, s, r) {
                    const o = t1.context, n = o.gl, a = i.getSource().tileSize, l = 5 * (1 - e1.am(e1.b1, e1.b1 + 1, t1.transform.zoom)) * a + s.paint.get("raster-particle-elevation"), c = !t1.options.moving, h = "globe" === t1.transform.projection.name;
                    if (!r.length) return;
                    const [d, u] = t1.stencilConfigForOverlap(r), p = [];
                    h && p.push("PROJECTION_GLOBE_VIEW");
                    const f = t1.stencilModeFor3D();
                    for (const r of u){
                        const a = r.toUnwrapped(), u = i.getTile(r);
                        if (!u.rasterParticleState) continue;
                        const m = u.rasterParticleState, _ = 100;
                        u.registerFadeDuration(_);
                        const g = i.findLoadedParent(r, 0), y = Ai(u, g, i, t1.transform, _);
                        let v, b;
                        t1.terrain && t1.terrain.prepareDrawTile(), o.activeTexture.set(n.TEXTURE0), m.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), o.activeTexture.set(n.TEXTURE1), g && g.rasterParticleState ? (g.rasterParticleState.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), v = Math.pow(2, g.tileID.overscaledZ - u.tileID.overscaledZ), b = [
                            u.tileID.canonical.x * v % 1,
                            u.tileID.canonical.y * v % 1
                        ]) : m.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                        const x = h ? t1.transform.expandedFarZProjMatrix : t1.transform.calculateProjMatrix(a, c), w = t1.transform, T = Fi(w), S = e1.b2(r.canonical), C = e1.b3(S.getCenter().lat);
                        let E, I, D, P, L;
                        h ? (E = Float32Array.from(e1.b4(e1.b5(r.canonical))), I = Float32Array.from(w.globeMatrix), D = Float32Array.from(e1.b6(w)), P = [
                            e1.a7(w.center.lng),
                            e1.a8(w.center.lat)
                        ], L = Float32Array.from(e1.b7(r.canonical, S, C, w.worldSize / w._pixelsPerMercatorPixel))) : (E = new Float32Array(16), I = new Float32Array(9), D = new Float32Array(16), P = [
                            0,
                            0
                        ], L = new Float32Array(9));
                        const R = Ci(x, E, I, D, L, b || [
                            0,
                            0
                        ], e1.S(t1.transform.zoom), P, T, v || 1, y, l), A = t1.isTileAffectedByFog(r), M = t1.getOrCreateProgram("rasterParticle", {
                            defines: p,
                            overrideFog: A
                        });
                        if (t1.uploadCommonUniforms(o, M, a), h) {
                            const i = new e1.Z(n.LEQUAL, e1.Z.ReadOnly, t1.depthRangeFor3D), r = 0, o = t1.globeSharedBuffers;
                            if (o) {
                                const [a, l, c] = o.getGridBuffers(C, 0 !== r);
                                M.draw(t1, n.TRIANGLES, i, f, e1.a1.alphaBlended, t1.renderElevatedRasterBackface ? e1.$.frontCCW : e1.$.backCCW, R, s.id, a, l, c);
                            }
                        } else {
                            const i = t1.depthModeForSublayer(0, e1.Z.ReadOnly), o = d[r.overscaledZ], { tileBoundsBuffer: a, tileBoundsIndexBuffer: l, tileBoundsSegments: c } = t1.getTileBoundsBuffers(u);
                            M.draw(t1, n.TRIANGLES, i, o, e1.a1.alphaBlended, e1.$.disabled, R, s.id, a, l, c);
                        }
                    }
                    t1.resetStencilClippingMasks();
                }(t1, i, s, r), t1.style.map.triggerRepaint());
            },
            prepareRasterParticle: function(e1, t1, i) {
                const s = t1.getSource();
                if ("raster-array" !== s.type || !s.loaded()) return;
                const r = e1.sourceLayer || s.rasterLayerIds && s.rasterLayerIds[0];
                if (!r) return;
                const o = e1.paint.get("raster-particle-array-band") || s.getInitialBand(r);
                if (null == o) return;
                const n = t1.getIds().map((e1)=>t1.getTileByID(e1));
                for (const t1 of n)t1.updateNeeded(e1.id, o) && s.prepareTile(t1, r, e1.id, o);
            },
            Rain: class extends qi {
                constructor(){
                    super(4.25), this._params = {
                        intensity: .5,
                        timeFactor: 1,
                        velocityConeAperture: 0,
                        velocity: 300,
                        boxSize: 2500,
                        dropletSizeX: 1,
                        dropletSizeYScale: 10,
                        distortionStrength: 70,
                        screenThinning: {
                            intensity: .57,
                            start: .46,
                            range: 1.17,
                            fadePower: .17,
                            affectedRatio: 1,
                            particleOffset: -0.2
                        },
                        color: {
                            r: .66,
                            g: .68,
                            b: .74,
                            a: .7
                        },
                        direction: {
                            x: -50,
                            y: -35
                        },
                        shapeDirPower: 2,
                        shapeNormalPower: 1
                    }, this._vignetteParams = {
                        strength: 1,
                        start: .7,
                        range: 1,
                        fadePower: .4,
                        color: {
                            r: .27,
                            g: .27,
                            b: .27,
                            a: 1
                        }
                    }, this.particlesCount = 16e3, this._devtoolsFolder = null, this._painter = null;
                }
                destroy() {
                    super.destroy();
                }
                update(t1) {
                    const i = t1.context;
                    if (!this.particlesVx) {
                        const t1 = Vi(this.particlesCount), s = new e1.bk, r = new e1.ad;
                        let o = 0;
                        const n = e1.bi(1323123451230);
                        for(let e1 = 0; e1 < t1.length; ++e1){
                            const i = t1[e1], a = [
                                2 * n() - 1,
                                n(),
                                n(),
                                n()
                            ];
                            s.emplaceBack(i[0], i[1], i[2], -1, -1, ...a), s.emplaceBack(i[0], i[1], i[2], 1, -1, ...a), s.emplaceBack(i[0], i[1], i[2], 1, 1, ...a), s.emplaceBack(i[0], i[1], i[2], -1, 1, ...a), r.emplaceBack(o + 0, o + 1, o + 2), r.emplaceBack(o + 0, o + 2, o + 3), o += 4;
                        }
                        this.particlesVx = i.createVertexBuffer(s, ki.members), this.particlesIdx = i.createIndexBuffer(r);
                    }
                }
                getDrawParams(e1) {
                    if (!e1.style.rain) return null;
                    const t1 = e1.style.rain.state, i = structuredClone(this._params);
                    i.intensity = t1.density, i.timeFactor = t1.intensity, i.color = structuredClone(t1.color), i.screenThinning.intensity = t1.centerThinning, i.dropletSizeX = t1.dropletSize[0], i.dropletSizeYScale = t1.dropletSize[1] / t1.dropletSize[0], i.distortionStrength = 100 * t1.distortionStrength;
                    const s = structuredClone(this._vignetteParams);
                    return s.strength = 1, s.color = structuredClone(t1.vignetteColor), {
                        params: i,
                        vignetteParams: s,
                        revealParams: {
                            revealStart: 0,
                            revealRange: .01
                        },
                        direction: structuredClone(t1.direction)
                    };
                }
                draw(t1) {
                    const i = this.getDrawParams(t1);
                    if (!i) return;
                    const { params: s, revealParams: r, direction: o, vignetteParams: n } = i, a = t1.transform.zoom;
                    if (r.revealStart > a) return;
                    const l = Gi(0, 1, r.revealStart, r.revealStart + r.revealRange, a);
                    if (!this.particlesVx || !this.particlesIdx) return;
                    n.strength *= l;
                    const c = this.updateOnRender(t1, s.timeFactor), h = t1.context, d = h.gl, u = t1.transform;
                    this.screenTexture && this.screenTexture.size[0] === t1.width && this.screenTexture.size[1] === t1.height || (this.screenTexture = new e1.T(h, {
                        width: t1.width,
                        height: t1.height,
                        data: null
                    }, d.RGBA8)), s.distortionStrength > 0 && (h.activeTexture.set(d.TEXTURE0), this.screenTexture.bind(d.LINEAR, d.CLAMP_TO_EDGE), d.copyTexSubImage2D(d.TEXTURE_2D, 0, 0, 0, 0, 0, t1.width, t1.height));
                    const p = t1.getOrCreateProgram("rainParticle");
                    t1.uploadCommonUniforms(h, p), h.activeTexture.set(d.TEXTURE0), this.screenTexture.bind(d.LINEAR, d.CLAMP_TO_EDGE);
                    const f = [
                        s.color.r,
                        s.color.g,
                        s.color.b,
                        s.color.a
                    ], m = (i, r)=>{
                        const n = ji(this._movement.getPosition(), i), a = s.dropletSizeX, l = s.dropletSizeX * s.dropletSizeYScale, h = t1.width / 2, m = t1.height / 2, _ = Gi(0, s.screenThinning.start, 0, 1, s.screenThinning.intensity), g = Gi(.001, s.screenThinning.range, 0, 1, s.screenThinning.intensity), y = Gi(0, s.screenThinning.particleOffset, 0, 1, s.screenThinning.intensity), v = (b = {
                            modelview: c.modelviewMatrix,
                            projection: c.projectionMatrix,
                            time: this._accumulatedTimeFromStart,
                            camPos: n,
                            velocityConeAperture: s.velocityConeAperture,
                            velocity: s.velocity,
                            boxSize: i,
                            rainDropletSize: [
                                a,
                                l
                            ],
                            distortionStrength: s.distortionStrength,
                            rainDirection: o,
                            color: f,
                            screenSize: [
                                u.width,
                                u.height
                            ],
                            thinningCenterPos: [
                                h,
                                m
                            ],
                            thinningShape: [
                                _,
                                g,
                                Math.pow(10, s.screenThinning.fadePower)
                            ],
                            thinningAffectedRatio: s.screenThinning.affectedRatio,
                            thinningParticleOffset: y,
                            shapeDirectionalPower: s.shapeDirPower,
                            shapeNormalPower: s.shapeNormalPower,
                            mode: r ? 0 : 1
                        }, {
                            u_modelview: Float32Array.from(b.modelview),
                            u_projection: Float32Array.from(b.projection),
                            u_time: b.time,
                            u_cam_pos: b.camPos,
                            u_texScreen: 0,
                            u_velocityConeAperture: b.velocityConeAperture,
                            u_velocity: b.velocity,
                            u_boxSize: b.boxSize,
                            u_rainDropletSize: b.rainDropletSize,
                            u_distortionStrength: b.distortionStrength,
                            u_rainDirection: b.rainDirection,
                            u_color: b.color,
                            u_screenSize: b.screenSize,
                            u_thinningCenterPos: b.thinningCenterPos,
                            u_thinningShape: b.thinningShape,
                            u_thinningAffectedRatio: b.thinningAffectedRatio,
                            u_thinningParticleOffset: b.thinningParticleOffset,
                            u_shapeDirectionalPower: b.shapeDirectionalPower,
                            u_shapeNormalPower: b.shapeNormalPower,
                            u_mode: b.mode
                        });
                        var b;
                        const x = Math.round(s.intensity * this.particlesCount), w = e1.ac.simpleSegment(0, 0, 4 * x, 2 * x);
                        p.draw(t1, d.TRIANGLES, e1.Z.disabled, e1._.disabled, e1.a1.alphaBlended, e1.$.disabled, v, "rain_particles", this.particlesVx, this.particlesIdx, w);
                    };
                    s.distortionStrength > 0 && m(s.boxSize, !0), m(s.boxSize, !1), this._vignette.draw(t1, n);
                }
            },
            Snow: class extends qi {
                constructor(){
                    super(2.25), this._params = {
                        intensity: .85,
                        timeFactor: .75,
                        velocityConeAperture: 70,
                        velocity: 40,
                        horizontalOscillationRadius: 4,
                        horizontalOscillationRate: 1.5,
                        boxSize: 2e3,
                        billboardSize: 2,
                        shapeFadeStart: .27,
                        shapeFadePower: .21,
                        screenThinning: {
                            intensity: .4,
                            start: .15,
                            range: 1.4,
                            fadePower: .24,
                            affectedRatio: 1,
                            particleOffset: -0.2
                        },
                        color: {
                            r: 1,
                            g: 1,
                            b: 1,
                            a: 1
                        },
                        direction: {
                            x: -50,
                            y: -35
                        }
                    }, this._vignetteParams = {
                        strength: .3,
                        start: .78,
                        range: .46,
                        fadePower: .2,
                        color: {
                            r: 1,
                            g: 1,
                            b: 1,
                            a: 1
                        }
                    }, this.particlesCount = 16e3, this._devtoolsFolder = null, this._painter = null;
                }
                destroy() {
                    super.destroy();
                }
                update(t1) {
                    const i = t1.context;
                    if (!this.particlesVx) {
                        const t1 = Vi(this.particlesCount), s = new e1.bl, r = new e1.ad;
                        let o = 0;
                        const n = e1.bi(1323123451230);
                        for(let e1 = 0; e1 < t1.length; ++e1){
                            const i = t1[e1], a = n(), l = n(), c = n(), h = [
                                e1 / t1.length,
                                a,
                                l,
                                c
                            ], d = [
                                n(),
                                n()
                            ];
                            s.emplaceBack(i[0], i[1], i[2], -1, -1, ...h, ...d), s.emplaceBack(i[0], i[1], i[2], 1, -1, ...h, ...d), s.emplaceBack(i[0], i[1], i[2], 1, 1, ...h, ...d), s.emplaceBack(i[0], i[1], i[2], -1, 1, ...h, ...d), r.emplaceBack(o + 0, o + 1, o + 2), r.emplaceBack(o + 0, o + 2, o + 3), o += 4;
                        }
                        this.particlesVx = i.createVertexBuffer(s, Zi.members), this.particlesIdx = i.createIndexBuffer(r);
                    }
                }
                getDrawParams(e1) {
                    if (!e1.style.snow) return null;
                    const t1 = e1.style.snow.state, i = structuredClone(this._params);
                    i.intensity = t1.density, i.timeFactor = t1.intensity, i.color = structuredClone(t1.color), i.screenThinning.intensity = t1.centerThinning, i.billboardSize = 2.79 * t1.flakeSize;
                    const s = structuredClone(this._vignetteParams);
                    return s.strength = 1, s.color = structuredClone(t1.vignetteColor), {
                        params: i,
                        vignetteParams: s,
                        revealParams: {
                            revealStart: 0,
                            revealRange: .01
                        },
                        direction: structuredClone(t1.direction)
                    };
                }
                draw(t1) {
                    const i = this.getDrawParams(t1);
                    if (!i) return;
                    const { params: s, revealParams: r, direction: o, vignetteParams: n } = i, a = t1.transform.zoom;
                    if (r.revealStart > a) return;
                    const l = Gi(0, 1, r.revealStart, r.revealStart + r.revealRange, a);
                    n.strength *= l;
                    const c = this.updateOnRender(t1, s.timeFactor);
                    if (!this.particlesVx || !this.particlesIdx) return;
                    const h = t1.context, d = h.gl, u = t1.transform, p = t1.getOrCreateProgram("snowParticle");
                    t1.uploadCommonUniforms(h, p), ((i, s, r)=>{
                        const n = ji(this._movement.getPosition(), i), a = u.width / 2, l = u.height / 2, h = Gi(0, r.screenThinning.start, 0, 1, r.screenThinning.intensity), f = Gi(.001, r.screenThinning.range, 0, 1, r.screenThinning.intensity), m = Gi(0, r.screenThinning.particleOffset, 0, 1, r.screenThinning.intensity), _ = (g = {
                            modelview: c.modelviewMatrix,
                            projection: c.projectionMatrix,
                            time: this._accumulatedTimeFromStart,
                            camPos: n,
                            velocityConeAperture: r.velocityConeAperture,
                            velocity: r.velocity,
                            horizontalOscillationRadius: r.horizontalOscillationRadius,
                            horizontalOscillationRate: r.horizontalOscillationRate,
                            boxSize: i,
                            billboardSize: 1 * r.billboardSize,
                            simpleShapeParameters: [
                                r.shapeFadeStart,
                                r.shapeFadePower
                            ],
                            screenSize: [
                                u.width,
                                u.height
                            ],
                            thinningCenterPos: [
                                a,
                                l
                            ],
                            thinningShape: [
                                h,
                                f,
                                Math.pow(10, r.screenThinning.fadePower)
                            ],
                            thinningAffectedRatio: r.screenThinning.affectedRatio,
                            thinningParticleOffset: m,
                            color: [
                                r.color.r,
                                r.color.g,
                                r.color.b,
                                r.color.a
                            ],
                            direction: o
                        }, {
                            u_modelview: Float32Array.from(g.modelview),
                            u_projection: Float32Array.from(g.projection),
                            u_time: g.time,
                            u_cam_pos: g.camPos,
                            u_velocityConeAperture: g.velocityConeAperture,
                            u_velocity: g.velocity,
                            u_horizontalOscillationRadius: g.horizontalOscillationRadius,
                            u_horizontalOscillationRate: g.horizontalOscillationRate,
                            u_boxSize: g.boxSize,
                            u_billboardSize: g.billboardSize,
                            u_simpleShapeParameters: g.simpleShapeParameters,
                            u_screenSize: g.screenSize,
                            u_thinningCenterPos: g.thinningCenterPos,
                            u_thinningShape: g.thinningShape,
                            u_thinningAffectedRatio: g.thinningAffectedRatio,
                            u_thinningParticleOffset: g.thinningParticleOffset,
                            u_particleColor: g.color,
                            u_direction: g.direction
                        });
                        var g;
                        const y = Math.round(r.intensity * this.particlesCount), v = e1.ac.simpleSegment(0, 0, 4 * y, 2 * y);
                        this.particlesVx && this.particlesIdx && p.draw(t1, d.TRIANGLES, e1.Z.disabled, e1._.disabled, e1.a1.alphaBlended, e1.$.disabled, _, "snow_particles", this.particlesVx, this.particlesIdx, v);
                    })(s.boxSize, 0, s), this._vignette.draw(t1, n);
                }
            },
            shaders: Bi,
            programUniforms: Xi,
            drawElevatedStructures: function(t1) {
                const { painter: i, sourceCache: s, layer: r, coords: o, colorMode: n } = t1, a = i.context.gl, l = t1.painter.shadowRenderer, c = !!l && l.enabled, h = new e1.Z(i.context.gl.LEQUAL, e1.Z.ReadOnly, i.depthRangeFor3D);
                let d = [
                    0,
                    0,
                    0
                ];
                if (c) {
                    const t1 = i.style.directionalLight, s = i.style.ambientLight;
                    t1 && s && (d = e1.aF(i.style, t1, s));
                }
                const u = (t1)=>{
                    for (const u of o){
                        const o = s.getTile(u), p = o.getBucket(r);
                        if (!p) continue;
                        const f = p.hdExt ? p.hdExt.elevatedStructures : void 0;
                        if (!f) continue;
                        let m, _;
                        if (t1 ? (m = f.renderableBridgeSegments, _ = f.bridgeProgramConfigurations.get(r.id)) : (m = f.renderableTunnelSegments, _ = f.tunnelProgramConfigurations.get(r.id)), !m || 0 === m.segments[0].primitiveLength) continue;
                        _.updatePaintBuffers(), i.prepareDrawTile();
                        const g = i.isTileAffectedByFog(u), y = [];
                        c && y.push("RENDER_SHADOWS", "NORMAL_OFFSET");
                        const v = i.getOrCreateProgram("elevatedStructures", {
                            config: _,
                            overrideFog: g,
                            defines: y
                        }), b = i.translatePosMatrix(u.projMatrix, o, r.paint.get("fill-translate"), r.paint.get("fill-translate-anchor"));
                        c && l.setupShadows(o.tileID.toUnwrapped(), v, "vector-tile");
                        const x = Hi(b, d);
                        i.uploadCommonUniforms(i.context, v, u.toUnwrapped()), v.draw(i, a.TRIANGLES, h, e1._.disabled, n, e1.$.backCCW, x, r.id, f.vertexBuffer, f.indexBuffer, m, r.paint, i.transform.zoom, _, [
                            f.vertexBufferNormal
                        ]);
                    }
                };
                u(!0), u(!1);
            },
            drawElevatedFillShadows: function(t1) {
                const { painter: i, sourceCache: s, layer: r, coords: o } = t1, n = i.context.gl, a = t1.painter.shadowRenderer;
                for (const t1 of o){
                    const o = s.getTile(t1), l = o.getBucket(r);
                    if (!l) continue;
                    const c = l.hdExt ? l.hdExt.elevatedStructures : void 0;
                    if (!c) continue;
                    if (!c.shadowCasterSegments || 0 === c.shadowCasterSegments.segments[0].primitiveLength) continue;
                    i.prepareDrawTile();
                    const h = l.bufferData.programConfigurations.get(r.id), d = i.isTileAffectedByFog(t1), u = i.getOrCreateProgram("elevatedStructuresDepth", {
                        config: h,
                        overrideFog: d
                    }), p = a.calculateShadowPassMatrixFromTile(o.tileID.toUnwrapped());
                    i.uploadCommonUniforms(i.context, u, t1.toUnwrapped());
                    const f = $i(p, 0);
                    u.draw(i, n.TRIANGLES, a.getShadowPassDepthMode(), e1._.disabled, e1.a1.disabled, e1.$.disabled, f, r.id, c.vertexBuffer, c.indexBuffer, c.shadowCasterSegments, r.paint, i.transform.zoom, h);
                }
            },
            drawDepthPrepass: function(t1, i, s, r, o) {
                if (!i) return;
                if (!s.layout || "none" === s.layout.get("fill-elevation-reference") || 0 === s.paint.get("fill-opacity").constantOr(1)) return;
                const n = t1.context.gl, a = new e1.Z(t1.context.gl.LEQUAL, e1.Z.ReadWrite, t1.depthRangeFor3D), l = new e1.Z(t1.context.gl.GREATER, e1.Z.ReadWrite, t1.depthRangeFor3D), c = function(t1) {
                    let i = .01;
                    return t1.isOrthographic && (i = e1.al(1e-4, i, e1.bo(t1.pitch >= e1.bn ? 1 : t1.pitch / e1.bn))), 2 * i;
                }(t1.transform), h = t1.transform.getFreeCameraOptions().position, d = "elevatedStructuresDepthReconstruct", u = t1.getOrCreateProgram(d, {
                    defines: [
                        "DEPTH_RECONSTRUCTION"
                    ]
                }), p = t1.getOrCreateProgram(d);
                for (const d of r){
                    const r = i.getTile(d), f = r.getBucket(s);
                    if (!f) continue;
                    if (!f.hdExt) continue;
                    const m = f.hdExt.elevatedStructures, _ = f.hdExt.elevationBufferData;
                    if (!m || !m.depthSegments || !_) continue;
                    const g = _.heightRange, y = Ki(d.toUnwrapped(), h), v = t1.translatePosMatrix(d.projMatrix, r, s.paint.get("fill-translate"), s.paint.get("fill-translate-anchor"));
                    let b, x, w, T;
                    if ("initialize" === o) {
                        if (!g || g.min >= 1 || 0 === m.depthSegments.segments[0].primitiveLength) continue;
                        b = Wi(v, y, c, 1, 0), x = a, w = m.depthSegments, T = u;
                    } else if ("reset" === o) {
                        if (!g || g.min >= 0 || 0 === m.maskSegments.segments[0].primitiveLength) continue;
                        b = Wi(v, y, 0, 0, 1), x = l, w = m.maskSegments, T = u;
                    } else if ("geometry" === o) {
                        if (0 === m.depthSegments.segments[0].primitiveLength) continue;
                        b = Wi(v, y, c, 1, 0), x = a, w = m.depthSegments, T = p;
                    }
                    T.draw(t1, n.TRIANGLES, x, e1._.disabled, e1.a1.disabled, e1.$.disabled, b, s.id, m.vertexBuffer, m.indexBuffer, w, s.paint, t1.transform.zoom);
                }
            },
            drawGroundShadowMask: function(t1, i, s, r) {
                if (!i) return;
                if (!s.layout || "none" === s.layout.get("fill-elevation-reference") || 0 === s.paint.get("fill-opacity").constantOr(1)) return;
                const o = t1.context.gl, n = new e1.Z(o.LEQUAL, e1.Z.ReadOnly, t1.depthRangeFor3D), a = new e1._({
                    func: o.ALWAYS,
                    mask: 255
                }, 255, 255, o.KEEP, o.KEEP, o.REPLACE), l = t1.transform.getFreeCameraOptions().position, c = t1.getOrCreateProgram("elevatedStructuresDepthReconstruct");
                for (const h of r){
                    const r = i.getTile(h), d = r.getBucket(s);
                    if (!d) continue;
                    const u = d.hdExt ? d.hdExt.elevatedStructures : void 0;
                    if (!u || !u.depthSegments || 0 === u.depthSegments.segments[0].primitiveLength) continue;
                    const p = Ki(h.toUnwrapped(), l), f = t1.translatePosMatrix(h.projMatrix, r, s.paint.get("fill-translate"), s.paint.get("fill-translate-anchor")), m = Wi(f, p, 0, 1, 0);
                    c.draw(t1, o.TRIANGLES, n, a, e1.a1.disabled, e1.$.disabled, m, s.id, u.vertexBuffer, u.indexBuffer, u.depthSegments, s.paint, t1.transform.zoom);
                }
            },
            IndoorManager: class extends e1.E {
                constructor(t1, i = !1){
                    super(), this._style = t1, this._buildings = {}, this._activeFloors = new Set, this._closestBuildingId = null, this._indoorState = {
                        selectedFloorId: null,
                        activeFloorsVisible: !0,
                        activeFloors: this._activeFloors
                    }, this._buildingDetectionStrategy = new Ti, this._initialLoadDone = !1, e1.aV([
                        "_updateUI"
                    ], this);
                    const s = ()=>{
                        this._style.isIndoorEnabled() && (this._style.map.on("load", ()=>{
                            this._initialLoadDone = !0, this._indoorState && this._indoorState.needsUpdate && (this._indoorState.needsUpdate = !1, this._style.updateIndoorDependentLayers()), this._updateUI();
                        }), this._style.map.on("move", this._updateUI), this._style.map.on("idle", this._updateUI));
                    };
                    i ? (this._initialLoadDone = !0, s()) : this._style.on("style.load", s);
                }
                destroy() {
                    this._buildings = {}, this._activeFloors = new Set, this._indoorState = null;
                }
                selectFloor(e1) {
                    e1 === this._selectedFloorId && this._indoorState && this._indoorState.activeFloorsVisible || (this._selectedFloorId = e1, this._recalculateActiveFloors());
                }
                setActiveFloorsVisibility(e1) {
                    this._updateActiveFloors(e1), this._updateIndoorSelector();
                }
                setIndoorData(e1) {
                    let t1 = !1;
                    for (const [i, s] of Object.entries(e1.buildings))if (this._buildings[i]) for (const e1 of s.floorIds)this._buildings[i].floorIds.add(e1), this._buildings[i].floors[e1] ? this._mergeFloors(this._buildings[i].floors[e1], s.floors[e1]) : (this._buildings[i].floors[e1] = s.floors[e1], t1 = !0);
                    else this._buildings[i] = s, t1 = !0;
                    t1 && this._recalculateActiveFloors();
                }
                getIndoorTileOptions(e1, t1) {
                    return this._indoorState ? {
                        sourceLayers: this._style.getIndoorSourceLayers(e1, t1),
                        indoorState: this._indoorState
                    } : null;
                }
                getControlState() {
                    const e1 = this._buildings, t1 = this._closestBuildingId, i = t1 && e1 ? e1[t1] : void 0;
                    if (!i) return {
                        selectedFloorId: null,
                        activeFloorsVisible: !!this._indoorState && this._indoorState.activeFloorsVisible,
                        floors: []
                    };
                    let s = null;
                    for (const e1 of i.floorIds)if (this._activeFloors && this._activeFloors.has(e1)) {
                        s = e1;
                        break;
                    }
                    const r = Array.from(i.floorIds).map((e1)=>({
                            id: e1,
                            name: i.floors[e1].name,
                            zIndex: i.floors[e1].zIndex
                        })).sort((e1, t1)=>t1.zIndex - e1.zIndex).filter((e1, t1, i)=>0 === t1 || e1.zIndex !== i[t1 - 1].zIndex);
                    return {
                        selectedFloorId: s,
                        activeFloorsVisible: !!this._indoorState && this._indoorState.activeFloorsVisible,
                        floors: r
                    };
                }
                _updateUI() {
                    this._initialLoadDone = !0;
                    const e1 = this._style.map.transform, t1 = this._buildingDetectionStrategy.findClosestBuilding(this._buildings, e1.center, e1.zoom, e1.getBounds(), this._makeViewportPolygon());
                    if (t1 !== this._closestBuildingId) {
                        const e1 = this._closestBuildingId;
                        this._closestBuildingId = t1, this._onBuildingTransition(e1, t1), this._updateIndoorSelector();
                    }
                }
                _onBuildingTransition(e1, t1) {
                    if (!this._indoorState) return;
                    const i = !!t1 && !e1;
                    !t1 && e1 ? (this._indoorState.activeFloors = new Set, this._indoorState.activeFloorsVisible = !1, this._style.updateIndoorDependentLayers()) : i && (this._recalculateActiveFloors(), this._updateActiveFloors(!0));
                }
                _updateIndoorSelector() {
                    this.fire(new e1.h("selector-update", this.getControlState()));
                }
                _updateActiveFloors(e1) {
                    this._indoorState = {
                        selectedFloorId: this._selectedFloorId,
                        activeFloorsVisible: e1,
                        activeFloors: this._activeFloors
                    }, this._initialLoadDone ? this._style.updateIndoorDependentLayers() : this._indoorState.needsUpdate = !0;
                }
                _recalculateActiveFloors() {
                    if (!this._buildings) return;
                    const t1 = e1.aW.calculate(this._buildings, this._selectedFloorId, this._activeFloors);
                    (function(e1, t1) {
                        if (e1 === t1) return !0;
                        if (!e1 || !t1) return !1;
                        if (e1.size !== t1.size) return !1;
                        for (const i of e1)if (!t1.has(i)) return !1;
                        return !0;
                    })(t1, this._activeFloors) || (this._activeFloors = t1, this._updateActiveFloors(!!this._indoorState && this._indoorState.activeFloorsVisible), this._updateIndoorSelector());
                }
                _mergeFloors(e1, t1) {
                    t1.geometry && (e1.geometry ? ("Polygon" === e1.geometry.type && (e1.geometry = {
                        type: "MultiPolygon",
                        coordinates: [
                            e1.geometry.coordinates
                        ]
                    }), "Polygon" === t1.geometry.type ? e1.geometry.coordinates.push(t1.geometry.coordinates) : "MultiPolygon" === t1.geometry.type && e1.geometry.coordinates.push(...t1.geometry.coordinates)) : e1.geometry = t1.geometry);
                }
                _makeViewportPolygon() {
                    const t1 = this._style.map.transform, i = t1.width, s = t1.height;
                    return [
                        t1.pointLocation(new e1.P(0, 0)),
                        t1.pointLocation(new e1.P(i, 0)),
                        t1.pointLocation(new e1.P(i, s)),
                        t1.pointLocation(new e1.P(0, s))
                    ].map((t1)=>new e1.P(t1.lng, t1.lat));
                }
            },
            HdCoverageState: class {
                constructor(){
                    this.coverageSourceCaches = {}, this.manager = new ts;
                }
            },
            updateFrcCoverage: function(e1, t1) {
                t1.manager.clear();
                for(const i in e1._mergedHdRoadCoverageSourceCaches){
                    const s = e1._mergedHdRoadCoverageSourceCaches[i]._tiles;
                    for(const e1 in s){
                        const i = s[e1];
                        if (!i || !i.loaded()) continue;
                        const r = i.frcCoveragePolygons;
                        t1.manager.addTileCoverage(i.tileID.canonical, r && r.length > 0 ? r : []);
                    }
                }
                const i = t1.manager.updateSnapshotIfNeeded();
                if (e1.map.painter && (e1.map.painter.frcCoverageSnapshot = i.empty() ? null : i), !i.empty()) {
                    const t1 = [
                        e1._mergedOtherSourceCaches,
                        e1._mergedSymbolSourceCaches
                    ];
                    for (const e1 of t1)for(const t1 in e1){
                        const i = e1[t1];
                        for(const e1 in i._tiles){
                            const t1 = i._tiles[e1];
                            t1 && t1.hasDeferredRoadStructure && (t1.hasDeferredRoadStructure = !1, i._reloadTile(+e1, "reloading"));
                        }
                    }
                }
            },
            updateHdCoverageSourceCache: function(t1, i, s) {
                if ("fill" !== s.type || s.sourceLayer !== e1.bU) return;
                if (i.coverageSourceCaches[s.source]) return;
                const r = t1.getOwnSource(s.source);
                if (!r || "vector" !== r.type) return;
                const o = `hd-road-coverage:${s.source}`, n = e1.m(o, t1.scope), a = t1._sourceCaches[o] = new gs(n, r, e1.bR.HdRoadCoverage);
                i.coverageSourceCaches[s.source] = a, a.setMaxzoomOverride(14), a.onAdd(t1.map);
                const l = t1._otherSourceCaches[s.source];
                l && l._sourceLoaded && (a._sourceLoaded = !0);
            },
            updateFrcCoverageFadeRange: function(t1, i) {
                let s = null, r = null;
                const o = {
                    globals: {
                        zoom: 0
                    }
                };
                t1.forEachFragmentStyle((i)=>{
                    if (s) return;
                    const n = i.stylesheet ? i.stylesheet.schema : null;
                    if (!n || !n.sdCoverageFadeRange) return;
                    const a = e1.m("sdCoverageFadeRange", i.scope), l = i.options ? i.options.get(a) : void 0, c = l ? l.value || l.default : null;
                    if (c) {
                        const e1 = c.evaluate(o);
                        Array.isArray(e1) && 2 === e1.length && (e1[0] > 0 || e1[1] > 0) && (s = [
                            e1[0],
                            e1[1]
                        ]);
                    }
                    const h = e1.m("sdCoverageSourceLayers", i.scope), d = i.options ? i.options.get(h) : void 0, u = d ? d.value || d.default : null;
                    if (u) {
                        const e1 = u.evaluate(o);
                        Array.isArray(e1) && e1.length > 0 && (r = e1);
                    } else {
                        const e1 = t1.stylesheet && t1.stylesheet.imports || [];
                        for (const t1 of e1)if (t1.id === i.scope) {
                            const e1 = t1.config ? t1.config.sdCoverageSourceLayers : void 0;
                            Array.isArray(e1) && e1.length > 0 && (r = e1);
                            break;
                        }
                    }
                }), i.frcCoverageFadeRange = s, i.frcCoverageSourceLayers = null != s ? r || [
                    "road",
                    "structure"
                ] : [];
            },
            HdElevationState: Fs,
            setupAndUpdateElevationCoverage: function(t1) {
                if (!function(e1) {
                    for(const t1 in e1._mergedLayers)if (Ds(e1._mergedLayers[t1])) return !0;
                    return !1;
                }(t1)) return void Bs(t1);
                const i = Gt(t1, t1.map && t1.map.transform);
                t1._hdElevation || (t1._hdElevation = new Fs);
                const s = t1._hdElevation._terrainActiveLast;
                if (t1._hdElevation._terrainActiveLast = i, void 0 !== s && s !== i && Ms(t1, void 0, !0), i) return void (t1.map.painter && (t1.map.painter.elevationCoverageSnapshot = null));
                if (!Rs(t1)) return void Bs(t1);
                void 0 === s && Ms(t1, void 0, !0);
                const r = t1._hdElevation;
                r._needsCrossSourceElevation = !0, t1._crossSourceElevationActive = !0, r._ingestFQIDs = As(t1);
                const o = Ls(t1);
                t1.forEachFragmentStyle((t1)=>{
                    for (const i of o){
                        if (!Cs(i, t1.scope)) continue;
                        const s = e1.bV(i);
                        if (t1._otherSourceCaches[s] || t1._symbolSourceCaches[s]) continue;
                        const r = t1.getOwnSource(s);
                        r && "vector" === r.type && (t1._hdElevation || (t1._hdElevation = new Fs), ks(t1, t1._hdElevation, r));
                    }
                }), t1.mergeSources(), zs(t1, r);
            },
            updateElevationCoverage: zs,
            updateHdElevationSourceCache: ks,
            markElevationIngestSourceCachesUsed: function(e1) {
                if (!e1._hdElevation || !e1._hdElevation._needsCrossSourceElevation) return;
                const t1 = e1._hdElevation._ingestFQIDs;
                if (t1) for (const i of t1){
                    const t1 = Es(e1, i);
                    t1 && (t1.used = !0);
                }
            },
            updateCrossSourceElevationGate: function(e1) {
                e1._crossSourceElevationActive = Rs(e1);
                const t1 = e1._mergedHdRoadElevationSourceCaches;
                t1 && 0 !== Object.keys(t1).length && (e1._hdElevation || (e1._hdElevation = new Fs), e1._hdElevation._needsCrossSourceElevation = e1._crossSourceElevationActive);
            },
            buildElevationRequestParams: function(t1, i, s) {
                if (i.renderSourceType === e1.bR.HdRoadElevation) return null;
                if (Gt(t1.style, t1.transform)) return null;
                if (!s) return null;
                const r = t1.painter ? t1.painter.elevationCoverageSnapshot : null, o = !(!t1.painter || !t1.painter.elevationProvidersReady);
                return r ? function(e1, t1, i) {
                    const s = e1.getTilesIntersecting(t1);
                    if (0 === s.length) return {
                        registry: [],
                        hasCoveringTile: !1,
                        allProvidersReady: i
                    };
                    const r = [];
                    for (const e1 of s)for (const t1 of e1.features)r.push({
                        tileId: e1.tileId,
                        feature: t1
                    });
                    return r.sort((e1, t1)=>e1.feature.id - t1.feature.id), {
                        registry: r,
                        hasCoveringTile: !0,
                        allProvidersReady: i
                    };
                }(r, i.tileID.canonical, o) : {
                    registry: [],
                    hasCoveringTile: !1,
                    allProvidersReady: o
                };
            },
            FrcCoverageRenderer: class {
                constructor(){
                    this.tileBuffers = new Map, this._context = null;
                }
                update(e1, t1) {
                    this._context = e1;
                    const i = new Set;
                    for (const s of t1){
                        if (0 === s.frcMask) continue;
                        let t1 = !1;
                        for (const e1 of s.polygons)if (e1.hasGeometry()) {
                            t1 = !0;
                            break;
                        }
                        if (!t1) continue;
                        const r = `${s.tileId.z}/${s.tileId.x}/${s.tileId.y}`;
                        if (i.add(r), !this.tileBuffers.has(r)) {
                            const t1 = this._createBuffers(e1, s);
                            t1 && this.tileBuffers.set(r, t1);
                        }
                    }
                    for (const e1 of this.tileBuffers.keys())if (!i.has(e1)) {
                        const t1 = this.tileBuffers.get(e1);
                        t1.vertexBuffer.destroy(), t1.indexBuffer.destroy();
                        for (const e1 of t1.frcLevelSegments)e1 && e1.destroy();
                        this.tileBuffers.delete(e1);
                    }
                }
                getBuffers(e1) {
                    return this.tileBuffers.get(`${e1.z}/${e1.x}/${e1.y}`) || null;
                }
                destroy() {
                    for (const e1 of this.tileBuffers.values()){
                        e1.vertexBuffer.destroy(), e1.indexBuffer.destroy();
                        for (const t1 of e1.frcLevelSegments)t1 && t1.destroy();
                    }
                    this.tileBuffers.clear();
                }
                _createBuffers(t1, i) {
                    const s = new e1.bC, r = new e1.ad, o = [];
                    for (const t1 of i.polygons){
                        if (!t1.hasGeometry() || 0 === t1.rings.length) continue;
                        const i = s.length, n = r.length, a = s.length, l = [], c = [];
                        let h = 0;
                        for(let e1 = 0; e1 < t1.rings.length; e1++){
                            const i = t1.rings[e1];
                            if (!(i.length < 3)) {
                                e1 > 0 && c.push(h);
                                for (const e1 of i)s.emplaceBack(e1.x, e1.y), l.push(e1.x, e1.y), h++;
                            }
                        }
                        const d = e1.bF(l, c.length > 0 ? c : void 0);
                        for(let e1 = 0; e1 < d.length; e1 += 3)r.emplaceBack(a + d[e1], a + d[e1 + 1], a + d[e1 + 2]);
                        o.push({
                            vertexOffset: i,
                            indexOffset: n,
                            vertexCount: s.length - i,
                            indexCount: r.length - n,
                            frcMask: t1.frcMask
                        });
                    }
                    if (0 === s.length) return null;
                    const n = new Array(9).fill(null);
                    for(let t1 = 0; t1 < 9; ++t1){
                        const s = 1 << t1;
                        if (0 === (i.frcMask & s)) continue;
                        let r = 1 / 0, a = 0, l = 0, c = !1;
                        for (const e1 of o)0 !== (e1.frcMask & s) && (r = Math.min(r, e1.indexOffset), a = Math.max(a, e1.indexOffset + e1.indexCount), l = Math.max(l, e1.vertexOffset + e1.vertexCount), c = !0);
                        c && (n[t1] = e1.ac.simpleSegment(0, r, l, a - r));
                    }
                    return {
                        vertexBuffer: t1.createVertexBuffer(s, e1.bE.members),
                        indexBuffer: t1.createIndexBuffer(r),
                        frcLevelSegments: n
                    };
                }
            },
            drawFillFrcCoverageFirstPass: function(t1) {
                const { painter: i, bucket: s, coord: r, elevatedGeometry: o } = t1, n = "road" === s.sourceLayerName, a = "structure" === s.sourceLayerName;
                if (!n && !a) return "fallthrough";
                if (!i.frcCoverageSnapshot || o) return "fallthrough";
                const l = i.frcCoverageSnapshot.getTileOrParent(r.canonical);
                if (!l || 0 === l.frcMask) return "fallthrough";
                const c = s.hdExt && s.hdExt.frcData, h = !!c && !c.empty(), d = $s(l.polygons);
                if (a && !d) return "skip";
                if (a && d) return t1.polygonCoverageTiles.push({
                    coord: t1.coord,
                    bufferData: t1.bufferData,
                    program: t1.program,
                    programConfiguration: t1.programConfiguration,
                    uniformValues: t1.uniformValues,
                    depthMode: t1.depthMode,
                    dynamicBuffers: t1.dynamicBuffers,
                    indexBuffer: t1.indexBuffer,
                    segments: t1.segments,
                    frcMask: l.frcMask
                }), "deferred";
                if (n && h && c) {
                    const s = l.frcMask, r = i.transform.zoom;
                    for (const [o, n] of c.frcPerLevel)s & 1 << o || 0 !== n.segments.length && t1.program.draw(i, t1.drawMode, t1.depthMode, t1.stencilMode, t1.colorMode, e1.$.disabled, t1.uniformValues, t1.layer.id, t1.bufferData.layoutVertexBuffer, t1.indexBuffer, n, t1.layer.paint, r, t1.programConfiguration, t1.dynamicBuffers);
                    return c.frcNonRoadSegments.segments.length > 0 && t1.program.draw(i, t1.drawMode, t1.depthMode, t1.stencilMode, t1.colorMode, e1.$.disabled, t1.uniformValues, t1.layer.id, t1.bufferData.layoutVertexBuffer, t1.indexBuffer, c.frcNonRoadSegments, t1.layer.paint, r, t1.programConfiguration, t1.dynamicBuffers), "drawn";
                }
                return "fallthrough";
            },
            drawFillFrcCoverageSecondPass: function(t1, i, s, r, o) {
                if (0 === s.length) return;
                const n = Hs(t1), a = t1.transform.zoom, l = (s, n, l)=>{
                    1 !== l && (s.uniformValues.u_opacity_multiplier = l), s.program.draw(t1, r, s.depthMode, n, o, e1.$.disabled, s.uniformValues, i.id, s.bufferData.layoutVertexBuffer, s.indexBuffer, s.segments, i.paint, a, s.programConfiguration, s.dynamicBuffers), 1 !== l && (s.uniformValues.u_opacity_multiplier = 1);
                };
                Zs(t1, s, n, (e1, t1, i)=>l(e1, i, 1), (e1, t1, i)=>l(e1, i, n));
            },
            drawLineFrcCoverageDetect: function(e1, t1, i, s, r, o, n, a, l, c) {
                const h = t1.hdExt && t1.hdExt.frcData;
                if (!h || 0 === h.frcPerLevel.size) return null;
                if (!e1.frcCoverageSnapshot || s) return null;
                const d = e1.frcCoverageSnapshot.getTileOrParent(i.canonical);
                if (!d || 0 === d.frcMask) return null;
                const u = $s(d.polygons), p = e1.frcCoverageFadeRange, f = null != p && e1.transform.zoom >= p[0];
                if (u && f) {
                    let e1 = !1;
                    for (const t1 of h.frcPerLevel.keys())if (d.frcMask & 1 << t1) {
                        e1 = !0;
                        break;
                    }
                    e1 && c.push({
                        coord: i,
                        bucket: t1,
                        uniformValues: r,
                        programConfiguration: o,
                        program: n,
                        depthMode: a,
                        colorMode: l,
                        frcMask: d.frcMask
                    });
                }
                return {
                    coverageTile: d,
                    frcMask: d.frcMask,
                    active: f,
                    hasPolygonGeometry: u
                };
            },
            drawLineFrcRenderLine: function(e1, t1, i, s) {
                const r = e1.hdExt && e1.hdExt.frcData;
                if (!r) return;
                const o = t1.frcMask;
                for (const [e1, t1] of r.frcPerLevel)o & 1 << e1 || s(i, t1);
                const n = r.frcNonRoadSegments;
                n.segments.length > 0 && s(i, n);
            },
            drawLineFrcFadePass: function(e1, t1, i, s, r, o, n) {
                if (s.hasPolygonGeometry) return;
                const a = t1.hdExt && t1.hdExt.frcData;
                if (!a || !e1.frcCoverageFadeRange) return;
                const [l, c] = e1.frcCoverageFadeRange;
                if (l >= c) return;
                const h = 1 - Math.max(0, Math.min(1, (e1.transform.zoom - l) / (c - l)));
                if (h <= 0) return;
                const d = r ? o : e1.stencilModeForClipping(i), u = s.frcMask;
                for (const [e1, t1] of a.frcPerLevel)u & 1 << e1 && n(d, t1, h);
            },
            drawLineFrcCoverageSecondPass: function(t1, i, s) {
                if (0 === s.length) return;
                const r = t1.context.gl, o = Hs(t1), n = t1.transform.zoom, a = (s, o, a, l)=>{
                    const c = s.bucket.hdExt && s.bucket.hdExt.frcData, h = c && c.frcPerLevel.get(o);
                    h && 0 !== h.segments.length && (1 !== l && (s.uniformValues.u_opacity_multiplier = l), s.program.draw(t1, r.TRIANGLES, s.depthMode, a, s.colorMode, e1.$.disabled, s.uniformValues, i.id, s.bucket.layoutVertexBuffer, s.bucket.indexBuffer, h, i.paint, n, s.programConfiguration, [
                        s.bucket.layoutVertexBuffer2,
                        s.bucket.patternVertexBuffer,
                        s.bucket.zOffsetVertexBuffer,
                        s.bucket.elevationIdColVertexBuffer,
                        s.bucket.elevationGroundScaleVertexBuffer
                    ]), 1 !== l && (s.uniformValues.u_opacity_multiplier = 1));
                };
                Zs(t1, s, o, (e1, t1, i)=>a(e1, t1, i, 1), (e1, t1, i)=>a(e1, t1, i, o));
            }
        }, Xs = Ws;
        async function Ks() {
            return Promise.resolve();
        }
        class Ys {
            constructor(e1, t1, i){
                this.screenBounds = e1, this.cameraPoint = i.getCameraPoint(), this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = t1, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, i);
            }
            static createFromScreenPoints(t1, i) {
                let s, r;
                if (t1 instanceof e1.P || "number" == typeof t1[0]) {
                    const o = e1.P.convert(t1);
                    s = [
                        o
                    ], r = i.isPointAboveHorizon(o);
                } else {
                    const o = e1.P.convert(t1[0]), n = e1.P.convert(t1[1]), a = o.add(n)._div(2);
                    s = [
                        o,
                        n
                    ], r = e1.bZ(o, n).every((e1)=>i.isPointAboveHorizon(e1)) && i.isPointAboveHorizon(a);
                }
                return new Ys(s, r, i);
            }
            isPointQuery() {
                return 1 === this.screenBounds.length;
            }
            bufferedScreenGeometry(t1) {
                return e1.bZ(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t1);
            }
            bufferedCameraGeometry(t1) {
                const i = this.screenBounds[0], s = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e1.P(1, 1)) : this.screenBounds[1], r = e1.bZ(i, s, 0, !1);
                return this.cameraPoint.y > s.y && (this.cameraPoint.x > i.x && this.cameraPoint.x < s.x ? r.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= s.x ? r[2] = this.cameraPoint : this.cameraPoint.x <= i.x && (r[3] = this.cameraPoint)), e1.b_(r, t1);
            }
            bufferedCameraGeometryGlobe(t1) {
                const i = this.screenBounds[0], s = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e1.P(1, 1)) : this.screenBounds[1], r = e1.bZ(i, s, t1), o = this.cameraPoint.clone(), n = Number(o.x > i.x) + Number(o.x > s.x);
                switch(3 * (Number(o.y > i.y) + Number(o.y > s.y)) + n){
                    case 0:
                        r[0] = o, r[4] = o.clone();
                        break;
                    case 1:
                        r.splice(1, 0, o);
                        break;
                    case 2:
                        r[1] = o;
                        break;
                    case 3:
                        r.splice(4, 0, o);
                        break;
                    case 5:
                        r.splice(2, 0, o);
                        break;
                    case 6:
                        r[3] = o;
                        break;
                    case 7:
                        r.splice(3, 0, o);
                        break;
                    case 8:
                        r[2] = o;
                }
                return r;
            }
            containsTile(t1, i, s, r = 0, o) {
                const n = Math.max(t1.queryPadding, t1.evaluateQueryRenderedFeaturePadding()) / i._pixelsPerMercatorPixel + 1, a = s ? this._bufferedCameraMercator(n, i) : this._bufferedScreenMercator(n, i);
                let l = t1.tileID.wrap + (a.unwrapped ? r : 0);
                const c = a.polygon.map((i)=>e1.b$(t1.tileTransform, i, l));
                if (!e1.c0(c, 0, 0, e1.a2, e1.a2)) return;
                l = t1.tileID.wrap + (this.screenGeometryMercator.unwrapped ? r : 0);
                const h = this.screenGeometryMercator.polygon.map((i)=>e1.c1(t1.tileTransform, i, l)), d = h.map((t1)=>new e1.P(t1[0], t1[1])), u = e1.c1(t1.tileTransform, o, l), p = h.map((t1)=>{
                    const i = e1.c2(t1, t1, u);
                    return e1.c3(i, i), new e1.c4(u, i);
                }), f = e1.c5(t1, 1, i.zoom) * i._pixelsPerMercatorPixel;
                var m;
                return {
                    queryGeometry: this,
                    tilespaceGeometry: d,
                    tilespaceRays: p,
                    bufferedTilespaceGeometry: c,
                    bufferedTilespaceBounds: (m = e1.c6(c), m.min.x = e1.b0(m.min.x, 0, e1.a2), m.min.y = e1.b0(m.min.y, 0, e1.a2), m.max.x = e1.b0(m.max.x, 0, e1.a2), m.max.y = e1.b0(m.max.y, 0, e1.a2), m),
                    tile: t1,
                    tileID: t1.tileID,
                    pixelToTileUnitsFactor: f
                };
            }
            _bufferedScreenMercator(e1, t1) {
                const i = er(e1);
                if (this._screenRaycastCache[i]) return this._screenRaycastCache[i];
                {
                    let s;
                    return s = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e1), t1) : {
                        polygon: this.bufferedScreenGeometry(e1).map((e1)=>t1.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._screenRaycastCache[i] = s, s;
                }
            }
            _bufferedCameraMercator(e1, t1) {
                const i = er(e1);
                if (this._cameraRaycastCache[i]) return this._cameraRaycastCache[i];
                {
                    let s;
                    return s = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e1), t1) : {
                        polygon: this.bufferedCameraGeometry(e1).map((e1)=>t1.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._cameraRaycastCache[i] = s, s;
                }
            }
            _projectAndResample(t1, i) {
                const s = function(t1, i) {
                    const s = e1.X([], i.pixelMatrix, i.globeMatrix), r = [
                        0,
                        -e1.c8,
                        0,
                        1
                    ], o = [
                        0,
                        e1.c8,
                        0,
                        1
                    ], n = [
                        0,
                        0,
                        0,
                        1
                    ];
                    e1.c7(r, r, s), e1.c7(o, o, s), e1.c7(n, n, s);
                    const a = new e1.P(r[0] / r[3], r[1] / r[3]), l = new e1.P(o[0] / o[3], o[1] / o[3]), c = e1.c9(t1, a) && r[3] < n[3], h = e1.c9(t1, l) && o[3] < n[3];
                    if (!c && !h) return null;
                    const d = function(e1, t1, i) {
                        for(let s = 1; s < e1.length; s++){
                            const r = Js(t1.pointCoordinate3D(e1[s - 1]).x), o = Js(t1.pointCoordinate3D(e1[s]).x);
                            if (i < 0) {
                                if (r < o) return {
                                    idx: s,
                                    t: -r / (o - 1 - r)
                                };
                            } else if (o < r) return {
                                idx: s,
                                t: (1 - r) / (o + 1 - r)
                            };
                        }
                        return null;
                    }(t1, i, c ? -1 : 1);
                    if (!d) return null;
                    const { idx: u, t: p } = d;
                    let f = u > 1 ? Qs(t1.slice(0, u), i) : [], m = u < t1.length ? Qs(t1.slice(u), i) : [];
                    f = f.map((t1)=>new e1.P(Js(t1.x), t1.y)), m = m.map((t1)=>new e1.P(Js(t1.x), t1.y));
                    const _ = [
                        ...f
                    ];
                    0 === _.length && _.push(m.at(-1));
                    const g = _.at(-1), y = e1.al(g.y, (0 === m.length ? f[0] : m[0]).y, p);
                    let v;
                    return v = c ? [
                        new e1.P(0, y),
                        new e1.P(0, 0),
                        new e1.P(1, 0),
                        new e1.P(1, y)
                    ] : [
                        new e1.P(1, y),
                        new e1.P(1, 1),
                        new e1.P(0, 1),
                        new e1.P(0, y)
                    ], _.push(...v), 0 === m.length ? _.push(f[0]) : _.push(...m), {
                        polygon: _.map((t1)=>new e1.bS(t1.x, t1.y)),
                        unwrapped: !1
                    };
                }(t1, i);
                if (s) return s;
                const r = function(t1, i) {
                    let s = !1, r = -1 / 0, o = 0;
                    for(let e1 = 0; e1 < t1.length - 1; e1++)t1[e1].x > r && (r = t1[e1].x, o = e1);
                    for(let e1 = 0; e1 < t1.length - 1; e1++){
                        const i = (o + e1) % (t1.length - 1), r = t1[i], n = t1[i + 1];
                        Math.abs(r.x - n.x) > .5 && (r.x < n.x ? (r.x += 1, 0 === i && (t1.at(-1).x += 1)) : (n.x += 1, i + 1 === t1.length - 1 && (t1[0].x += 1)), s = !0);
                    }
                    const n = e1.a7(i.center.lng);
                    return s && n < Math.abs(n - 1) && t1.forEach((e1)=>{
                        e1.x -= 1;
                    }), {
                        polygon: t1,
                        unwrapped: s
                    };
                }(Qs(t1, i).map((t1)=>new e1.P(Js(t1.x), t1.y)), i);
                return {
                    polygon: r.polygon.map((t1)=>new e1.bS(t1.x, t1.y)),
                    unwrapped: r.unwrapped
                };
            }
        }
        function Qs(t1, i) {
            return e1.ca(t1, (e1)=>{
                const t1 = i.pointCoordinate3D(e1);
                e1.x = t1.x, e1.y = t1.y;
            }, 1 / 256);
        }
        function Js(e1) {
            return e1 < 0 ? 1 + e1 % 1 : e1 % 1;
        }
        function er(e1) {
            return 100 * e1 | 0;
        }
        class tr extends e1.E {
            constructor(t1, i, s, r){
                if (super(), this.id = t1, this.dispatcher = s, this.type = "vector", this.provider = i.provider, this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, Object.assign(this, e1.cb(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = {
                    type: "vector",
                    ...i
                }, this._collectResourceTiming = !!i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(r), this._tileWorkers = {}, this._deduped = new e1.cc;
            }
            load(t1) {
                this._loaded = !1, this.fire(new e1.h("dataloading", {
                    dataType: "source"
                }));
                const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, s = this.map.getWorldview(), r = (r, o)=>{
                    this._tileJSONRequest = null, this._loaded = !0, r ? (i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), s && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${s}`), this.fire(new e1.f(r))) : o && (this._setTileJSON(o), Xs.updateCrossSourceElevationGate && this.map.style && Xs.updateCrossSourceElevationGate(this.map.style), e1.ck(o.tiles, this.map._requestManager._customAccessToken), this.fire(new e1.h("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.h("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), t1 && t1(r);
                };
                this.provider = this._options.provider;
                const o = e1.cd(this._options);
                return o instanceof Error ? (this._loaded = !0, this.fire(new e1.f(o)), void (t1 && t1())) : this.provider && !o ? (this._loaded = !0, this.fire(new e1.f(new Error(`TileProvider "${this.provider}" is not registered`))), void (t1 && t1())) : void (this._tileJSONRequest = o ? this.loadTileJSONWithProvider(o, r) : e1.ce(this._options, this.map._requestManager, i, s, r));
            }
            loadTileJSONWithProvider(t1, i) {
                this.provider = t1.name;
                const s = new AbortController;
                return (async ()=>{
                    const { request: r, options: o } = await e1.cl(this._options, this.map._requestManager, s.signal);
                    if (s.signal.aborted) return;
                    const n = await this.dispatcher.send("loadTileProvider", {
                        name: t1.name,
                        url: t1.url,
                        source: this.id,
                        scope: this.scope,
                        type: this.type,
                        options: o,
                        request: r
                    }, {
                        signal: s.signal
                    });
                    if (s.signal.aborted) return;
                    const a = n ? n.find((e1)=>null != e1) : null, l = e1.cm(this._options, a, this.map._requestManager);
                    l instanceof Error ? i(l) : i(null, l);
                })().catch((e1)=>{
                    s.signal.aborted || i(e1);
                }), {
                    cancel: ()=>s.abort()
                };
            }
            _setTileJSON(t1) {
                if (Object.assign(this, t1), this.hasWorldviews = !!t1.worldview_options, t1.worldview_default && (this.worldviewDefault = t1.worldview_default), t1.vector_layers) {
                    this.vectorLayers = t1.vector_layers, this.vectorLayerIds = [], this.localizableLayerIds = new Set;
                    for (const e1 of t1.vector_layers)this.vectorLayerIds.push(e1.id), t1.worldview && t1.worldview[e1.source] && this.localizableLayerIds.add(e1.id);
                }
                this.tileBounds = e1.cf.fromTileJSON(t1);
            }
            loaded() {
                return this._loaded;
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e1.m(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e1) {
                return this._options.tiles = e1, this.reload(), this;
            }
            setUrl(e1) {
                return this.url = e1, this._options.url = e1, this.reload(), this;
            }
            onRemove(e1) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return {
                    ...this._options
                };
            }
            async loadTile(t1, i) {
                const s = t1.tileID.canonical.url(this.tiles, this.scheme), r = this.map._requestManager.normalizeTileURL(s), o = !t1.actor || "expired" === t1.state;
                if (!o && "loading" === t1.state) return void (t1.reloadCallback = i);
                o && (t1.actor = this._tileWorkers[r] = this._tileWorkers[r] || this.dispatcher.getActor());
                const n = new AbortController;
                t1.request = n;
                try {
                    const a = await this.map._requestManager.transformRequest(r, e1.R.Tile, n.signal);
                    if (n.signal.aborted) return i(null);
                    this.dispatchTile(t1, r, s, a, n, o, i);
                } catch (e1) {
                    if (n.signal.aborted) return i(null);
                    i(e1);
                }
            }
            dispatchTile(t1, i, s, r, o, n, a) {
                const l = this.map.style ? this.map.style.getLut(this.scope) : null, c = l ? {
                    image: l.image.clone()
                } : null, h = !(!this.map.style || !this.map.style._crossSourceElevationActive), d = !(!this.map.style || !h), u = {
                    request: r,
                    data: void 0,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    tileZoom: t1.tileZoom,
                    zoom: t1.tileID.overscaledZ,
                    maxZoom: this.maxzoom,
                    lut: c,
                    tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    pixelRatio: e1.e.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    showElevationIdDebug: !!this.map.painter && this.map.painter._debugParams.showElevationIdDebug,
                    promoteId: this.promoteId,
                    renderSourceType: t1.renderSourceType,
                    frcCoverage: (()=>{
                        const e1 = this.map.painter, i = e1 ? e1.frcCoverageFadeRange : null;
                        if (null == i) return null;
                        const s = e1 ? e1.frcCoverageSnapshot : null, r = this.map.transform.zoom < i[0], o = s ? s.getTileOrParent(t1.tileID.canonical) : null, n = t1.tileID.overscaledZ >= Math.ceil(i[1]), a = s && n ? s.getFullCoverageMask(t1.tileID.canonical) : null;
                        return {
                            frcMask: n ? a ?? null : null,
                            resolved: r || null != s,
                            polygons: o && 0 !== o.frcMask ? o.polygons : null,
                            tileZoom: o && 0 !== o.frcMask ? o.tileId.z : null,
                            sourceLayers: e1 ? e1.frcCoverageSourceLayers : [
                                "road",
                                "structure"
                            ]
                        };
                    })(),
                    terrainEnabled: Gt(this.map.style, this.map.transform),
                    crossSourceElevationEnabled: d,
                    elevation: Xs.buildElevationRequestParams ? Xs.buildElevationRequestParams(this.map, t1, h) : null,
                    brightness: this.map.style && this.map.style.getBrightness() || 0,
                    extraShadowCaster: t1.isExtraShadowCaster,
                    tessellationStep: this.map._tessellationStep,
                    scaleFactor: this.map.getScaleFactor(),
                    worldview: this.map.getWorldview() || this.worldviewDefault,
                    indoor: this.map.getIndoorTileOptions(this.id, this.scope)
                };
                if (this.hasWorldviews && e1.cg(s) && (u.localizableLayerIds = this.localizableLayerIds), u.request.collectResourceTiming = this._collectResourceTiming, n) {
                    if (this.dispatcher.ready || this.provider) t1.request = t1.actor.sendCancelable("loadTile", u, {}, p.bind(this));
                    else {
                        const i = e1.ch.call({
                            deduped: this._deduped
                        }, u, (e1, i)=>{
                            t1.aborted || (e1 || !i ? p.call(this, e1) : (u.data = {
                                rawData: i.rawData.slice(0),
                                headers: i.headers
                            }, t1.actor && (t1.request = t1.actor.sendCancelable("loadTile", u, {}, p.bind(this)))));
                        }, !0);
                        o.signal.addEventListener("abort", i, {
                            once: !0
                        });
                    }
                } else t1.request = t1.actor.sendCancelable("reloadTile", u, {}, p.bind(this));
                function p(i, s) {
                    return delete t1.request, t1.aborted ? a(null) : i ? a(i) : (s && s.resourceTiming && (t1.resourceTiming = s.resourceTiming), this.map._refreshExpiredTiles && s && t1.setExpiryData(e1.ci(s.headers)), void (function() {
                        if (t1.aborted) return a(null);
                        t1.loadVectorData(s, this.map.painter), e1.cj(this.dispatcher), a(null, s), t1.reloadCallback && (this.loadTile(t1, t1.reloadCallback), t1.reloadCallback = null);
                    }).call(this));
                }
            }
            abortTile(e1) {
                e1.request && (e1.request.abort(), delete e1.request), e1.actor && e1.actor.notify("abortTile", {
                    uid: e1.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                });
            }
            unloadTile(e1, t1) {
                e1.actor && e1.actor.notify("removeTile", {
                    uid: e1.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                }), e1.destroy();
            }
            hasTransition() {
                return !1;
            }
            afterUpdate() {
                this._tileWorkers = {};
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        class ir extends e1.E {
            constructor(t1, i, s, r){
                super(), this.id = t1, this.dispatcher = s, this.setEventedParent(r), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = {
                    type: "raster",
                    ...i
                }, Object.assign(this, e1.cb(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load(t1) {
                this._loaded = !1, this.fire(new e1.h("dataloading", {
                    dataType: "source"
                }));
                const i = this.map.getWorldview(), s = (i, s)=>{
                    this._tileJSONRequest = null, this._loaded = !0, i ? this.fire(new e1.f(i)) : s && (Object.assign(this, s), s.raster_layers && (this.rasterLayers = s.raster_layers, this.rasterLayerIds = this.rasterLayers.map((e1)=>e1.id)), this.tileBounds = e1.cf.fromTileJSON(s), e1.ck(s.tiles), this.fire(new e1.h("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.h("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), t1 && t1(i);
                };
                this.provider = "string" == typeof this._options.provider ? this._options.provider : void 0, this._tileProvider = void 0;
                const r = e1.cd(this._options);
                return r instanceof Error ? (this._loaded = !0, this.fire(new e1.f(r)), void (t1 && t1())) : this.provider && !r ? (this._loaded = !0, this.fire(new e1.f(new Error(`TileProvider "${this.provider}" is not registered`))), void (t1 && t1())) : void (this._tileJSONRequest = r ? this.loadTileJSONWithProvider(r, s) : e1.ce(this._options, this.map._requestManager, null, i, s));
            }
            loadTileJSONWithProvider(t1, i) {
                this.provider = t1.name;
                const s = new AbortController;
                return (async ()=>{
                    const { request: r, options: o } = await e1.cl(this._options, this.map._requestManager, s.signal);
                    if (s.signal.aborted) return;
                    const n = await e1.cn(t1.name, t1.url);
                    if (s.signal.aborted) return;
                    const a = new n(o);
                    let l = null;
                    if (a.load && r && (l = await a.load({
                        request: r
                    }), s.signal.aborted)) return;
                    this._tileProvider = a;
                    const c = e1.cm(this._options, l, this.map._requestManager);
                    c instanceof Error ? i(c) : i(null, c);
                })().catch((e1)=>{
                    s.signal.aborted || i(new Error(`Could not load tile provider ${t1.name}`, {
                        cause: e1
                    }));
                }), {
                    cancel: ()=>s.abort()
                };
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e1.m(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e1) {
                return this._options.tiles = e1, this.reload(), this;
            }
            setUrl(e1) {
                return this.url = e1, this._options.url = e1, this.reload(), this;
            }
            onRemove(e1) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return {
                    ...this._options
                };
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            async loadTile(t1, i) {
                const s = e1.e.devicePixelRatio >= 2, r = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), s, this.tileSize), o = new AbortController;
                if (t1.request = o, this._tileProvider) this.loadTileWithProvider(t1, this._tileProvider, r, o, i);
                else try {
                    const s = await this.map._requestManager.transformRequest(r, e1.R.Tile, o.signal);
                    if (o.signal.aborted) return delete t1.request, i(null);
                    const { data: n, headers: a } = await e1.a(s, o.signal);
                    if (delete t1.request, t1.aborted) return i(null);
                    const l = e1.ci(a);
                    this.map._refreshExpiredTiles && t1.setExpiryData(l), t1.setTexture(n, this.map.painter), t1.state = "loaded", e1.cj(this.dispatcher), i(null);
                } catch (e1) {
                    if (delete t1.request, o.signal.aborted) return i(null);
                    t1.state = "errored", i(e1);
                }
            }
            async loadTileWithProvider(t1, i, s, r, o) {
                const { z: n, x: a, y: l } = t1.tileID.canonical;
                try {
                    const c = await this.map._requestManager.transformRequest(s, e1.R.Tile, r.signal);
                    if (r.signal.aborted) return o(null);
                    const h = await i.loadTile({
                        z: n,
                        x: a,
                        y: l
                    }, {
                        request: c,
                        signal: r.signal
                    });
                    if (r.signal.aborted) return o(null);
                    if (null == h) {
                        const e1 = new Error("Tile not found");
                        return e1.status = 404, t1.state = "errored", o(e1);
                    }
                    if (null == h.data) return t1.state = "loaded", o(null);
                    const d = h.data instanceof ImageBitmap ? h.data : await createImageBitmap(new Blob([
                        h.data
                    ]));
                    if (r.signal.aborted) return o(null);
                    t1.setTexture(d, this.map.painter), t1.state = "loaded", this.map._refreshExpiredTiles && t1.setExpiryData({
                        cacheControl: h.cacheControl,
                        expires: h.expires
                    }), o(null);
                } catch (e1) {
                    if (r.signal.aborted) return o(null);
                    t1.state = "errored", o(new Error(`Could not load tile from ${s}`, {
                        cause: e1
                    }));
                } finally{
                    delete t1.request;
                }
            }
            abortTile(e1, t1) {
                e1.request && (e1.request.abort(), delete e1.request), t1 && t1();
            }
            unloadTile(t1, i) {
                t1.texture && t1.texture instanceof e1.T ? (t1.destroy(!1), t1.texture && t1.texture instanceof e1.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), i && i();
            }
            hasTransition() {
                return !1;
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        function sr(t1, i, s, r, o, n, a, l) {
            const c = [
                t1,
                i,
                1,
                s,
                r,
                1,
                o,
                n,
                1
            ], h = [
                a,
                l,
                1
            ], d = e1.cu([], c), [u, p, f] = e1.ct(h, h, d);
            return e1.cv(c, c, [
                u,
                0,
                0,
                0,
                p,
                0,
                0,
                0,
                f
            ]);
        }
        function rr(t1, i, s, r, o, n, a, l) {
            const c = function(t1, i, s, r, o, n, a, l) {
                const c = sr(0, 0, 1, 0, 1, 1, 0, 1), h = sr(t1, i, s, r, o, n, a, l), d = e1.cu([], c);
                return e1.cv(h, h, d);
            }(t1, i, s, r, o, n, a, l);
            return [
                c[2] / c[8] / e1.a2,
                c[5] / c[8] / e1.a2
            ];
        }
        function or(t1) {
            return [
                t1[0],
                Math.min(Math.max(t1[1], -e1.cp), e1.cp)
            ];
        }
        class nr extends e1.E {
            constructor(e1, t1, i, s){
                super(), this.id = e1, this.dispatcher = i, this.coordinates = t1.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.onNorthPole = !1, this.onSouthPole = !1, this.setEventedParent(s), this.options = t1, this._dirty = !1;
            }
            async load(t1, i) {
                if (this._loaded = i || !1, this.fire(new e1.h("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, !this.url) return t1 && (this.coordinates = t1), this._loaded = !0, void this._finishLoading();
                const s = new AbortController;
                this._imageRequest = s;
                try {
                    const i = await this.map._requestManager.transformRequest(this.url, e1.R.Image, s.signal), { data: r } = await e1.a(i, s.signal);
                    this._imageRequest = null, this._loaded = !0, this.image = r, this._dirty = !0, this.width = this.image.width, this.height = this.image.height, t1 && (this.coordinates = t1), this._finishLoading();
                } catch (t1) {
                    if (s.signal.aborted) return;
                    this._imageRequest = null, this._loaded = !0, this.fire(new e1.f(t1));
                }
            }
            loaded() {
                return this._loaded;
            }
            updateImage(e1) {
                return e1.url ? (this._imageRequest && e1.url !== this.options.url && (this._imageRequest.abort(), this._imageRequest = null), this.options.url = e1.url, this.load(e1.coordinates, this._loaded), this) : this;
            }
            setTexture(t1) {
                if (!(t1.handle instanceof WebGLTexture)) throw new Error("The provided handle is not a WebGLTexture instance");
                return this.texture = new e1.co(this.map.painter.context, t1.handle), this.width = t1.dimensions[0], this.height = t1.dimensions[1], this._dirty = !1, this._loaded = !0, this._finishLoading(), this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new e1.h("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            onRemove(t1) {
                this._imageRequest && (this._imageRequest.abort(), this._imageRequest = null), !this.texture || this.texture instanceof e1.co || this.texture.destroy(), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy());
            }
            setCoordinates(t1) {
                if (this.coordinates = t1, this._boundsArray = void 0, this._unsupportedCoords = !1, !t1.length) return this;
                this.onNorthPole = !1, this.onSouthPole = !1;
                let i = t1[0][1], s = t1[0][1];
                for (const e1 of t1)e1[1] > s && (s = e1[1]), e1[1] < i && (i = e1[1]);
                const r = (s + i) / 2;
                if (r > e1.cp ? this.onNorthPole = !0 : r < -e1.cp && (this.onSouthPole = !0), !this.onNorthPole && !this.onSouthPole) {
                    const i = t1.map(e1.bS.fromLngLat);
                    this.tileID = function(t1) {
                        let i = 1 / 0, s = 1 / 0, r = -1 / 0, o = -1 / 0;
                        for (const e1 of t1)i = Math.min(i, e1.x), s = Math.min(s, e1.y), r = Math.max(r, e1.x), o = Math.max(o, e1.y);
                        const n = Math.max(r - i, o - s), a = Math.max(0, Math.floor(-Math.log2(n))), l = Math.pow(2, a);
                        let c = Math.floor((i + r) / 2 * l);
                        return c > 1 && (c -= 1), new e1.bX(a, c, Math.floor((s + o) / 2 * l));
                    }(i), this.minzoom = this.maxzoom = this.tileID.z;
                }
                return this.fire(new e1.h("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            _clear() {
                !this.texture || this.texture instanceof e1.co || (this.texture.destroy(), this._dirty = !0), this.texture = null, this._boundsArray = void 0, this._unsupportedCoords = !1;
            }
            _prepareData(t1) {
                for(const e1 in this.tiles){
                    const t1 = this.tiles[e1];
                    "loaded" !== t1.state && (t1.state = "loaded", t1.texture = this.texture);
                }
                if (this._boundsArray || this.onNorthPole || this.onSouthPole || this._unsupportedCoords) return;
                const i = e1.bp(new e1.bX(0, 0, 0), this.map.transform.projection), s = [
                    i.projection.project(this.coordinates[0][0], this.coordinates[0][1]),
                    i.projection.project(this.coordinates[1][0], this.coordinates[1][1]),
                    i.projection.project(this.coordinates[2][0], this.coordinates[2][1]),
                    i.projection.project(this.coordinates[3][0], this.coordinates[3][1])
                ];
                if (!function(e1) {
                    const t1 = e1[1].x - e1[0].x, i = e1[1].y - e1[0].y, s = e1[2].x - e1[1].x, r = e1[2].y - e1[1].y, o = e1[3].x - e1[2].x, n = e1[3].y - e1[2].y, a = e1[0].x - e1[3].x, l = e1[0].y - e1[3].y, c = t1 * r - s * i, h = s * n - o * r, d = o * l - a * n, u = a * i - t1 * l;
                    return c > 0 && h > 0 && d > 0 && u > 0 || c < 0 && h < 0 && d < 0 && u < 0;
                }(s)) return console.warn("Image source coordinates are defining non-convex area in the Mercator projection"), void (this._unsupportedCoords = !0);
                const r = e1.bp(this.tileID, this.map.transform.projection), [o, n, a, l] = this.coordinates.map((t1)=>{
                    const i = r.projection.project(t1[0], t1[1]);
                    return e1.b$(r, i)._round();
                });
                this.perspectiveTransform = rr(o.x, o.y, n.x, n.y, a.x, a.y, l.x, l.y);
                const c = this._boundsArray = new e1.bs;
                c.emplaceBack(o.x, o.y, 0, 0), c.emplaceBack(n.x, n.y, e1.a2, 0), c.emplaceBack(l.x, l.y, 0, e1.a2), c.emplaceBack(a.x, a.y, e1.a2, e1.a2), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy()), this.boundsBuffer = t1.createVertexBuffer(c, hs.members), this.boundsSegments = e1.ac.simpleSegment(0, 0, 4, 2);
                const h = e1.cs, d = h + 1, u = h + 1, p = d * u, f = h * h * 2, m = [], _ = function(e1) {
                    return [
                        or(e1[0]),
                        or(e1[1]),
                        or(e1[2]),
                        or(e1[3])
                    ];
                }(this.coordinates), [g, y, v, b] = function(e1) {
                    let t1 = e1[0][0], i = t1, s = e1[0][1], r = s;
                    for(let o = 1; o < e1.length; o++)e1[o][0] < t1 ? t1 = e1[o][0] : e1[o][0] > i && (i = e1[o][0]), e1[o][1] < s ? s = e1[o][1] : e1[o][1] > r && (r = e1[o][1]);
                    return [
                        t1,
                        s,
                        i - t1,
                        r - s
                    ];
                }(_);
                {
                    const r = new e1.bs, [o, n, a, l] = function(e1) {
                        let t1 = e1[0].x, i = t1, s = e1[0].y, r = s;
                        for(let o = 1; o < e1.length; o++)e1[o].x < t1 ? t1 = e1[o].x : e1[o].x > i && (i = e1[o].x), e1[o].y < s ? s = e1[o].y : e1[o].y > r && (r = e1[o].y);
                        return [
                            t1,
                            s,
                            i - t1,
                            r - s
                        ];
                    }(s), c = (e1)=>[
                            (e1.x - o) / a,
                            (e1.y - n) / l
                        ], [p, f, _, x] = s.map(c), w = function(t1, i, s, r, o, n, a, l) {
                        const c = sr(0, 0, 1, 0, 1, 1, 0, 1), h = sr(t1, i, s, r, o, n, a, l), d = e1.cu([], h);
                        return e1.cv(c, c, d);
                    }(p[0], p[1], f[0], f[1], _[0], _[1], x[0], x[1]);
                    this.elevatedGlobePerspectiveTransform = rr(p[0], p[1], f[0], f[1], _[0], _[1], x[0], x[1]);
                    const T = (t1, i)=>{
                        m.push(t1.lng);
                        const s = Math.round((t1.lng - g) / v * e1.a2), o = Math.round((t1.lat - y) / b * e1.a2), n = c(i), a = e1.ct([], [
                            n[0],
                            n[1],
                            1
                        ], w), l = Math.round(a[0] / a[2] * e1.a2), h = Math.round(a[1] / a[2] * e1.a2);
                        r.emplaceBack(s, o, l, h);
                    }, S = s[3].x - s[0].x, C = s[3].y - s[0].y, E = s[2].x - s[1].x, I = s[2].y - s[1].y;
                    for(let e1 = 0; e1 < u; e1++){
                        const t1 = e1 / h, r = [
                            s[0].x + t1 * S,
                            s[0].y + t1 * C
                        ], o = [
                            s[1].x + t1 * E,
                            s[1].y + t1 * I
                        ], n = o[0] - r[0], a = o[1] - r[1];
                        for(let e1 = 0; e1 < d; e1++){
                            const t1 = e1 / h, s = {
                                x: r[0] + n * t1,
                                y: r[1] + a * t1
                            };
                            T(i.projection.unproject(s.x, s.y), s);
                        }
                    }
                    this.elevatedGlobeVertexBuffer = t1.createVertexBuffer(r, hs.members);
                }
                {
                    this.maxLongitudeTriangleSize = 0;
                    let i = [], s = new e1.ad;
                    const r = (e1, t1, r)=>{
                        s.emplaceBack(e1, t1, r);
                        const o = m[e1], n = m[t1], a = m[r], l = Math.min(Math.min(o, n), a), c = Math.max(Math.max(o, n), a) - l;
                        c > this.maxLongitudeTriangleSize && (this.maxLongitudeTriangleSize = c), i.push(l + c / 2);
                    };
                    for(let e1 = 0; e1 < h; e1++)for(let t1 = 0; t1 < h; t1++){
                        const i = e1 * d + t1, s = i + 1, o = i + d, n = o + 1;
                        r(i, o, s), r(s, o, n);
                    }
                    [i, s] = function(t1, i) {
                        const s = Array.from({
                            length: t1.length
                        }, (e1, t1)=>t1);
                        s.sort((e1, i)=>t1[e1] - t1[i]);
                        const r = [], o = new e1.ad;
                        for(let e1 = 0; e1 < s.length; e1++){
                            const n = s[e1];
                            r.push(t1[n]);
                            const a = 3 * n, l = a + 1;
                            o.emplaceBack(i.uint16[a], i.uint16[l], i.uint16[l + 1]);
                        }
                        return [
                            r,
                            o
                        ];
                    }(i, s), this.elevatedGlobeTrianglesCenterLongitudes = i, this.elevatedGlobeIndexBuffer = t1.createIndexBuffer(s);
                }
                this.elevatedGlobeSegments = e1.ac.simpleSegment(0, 0, p, f), this.elevatedGlobeGridMatrix = new Float32Array([
                    0,
                    v / e1.a2,
                    0,
                    b / e1.a2,
                    0,
                    0,
                    y,
                    g,
                    0
                ]);
            }
            prepare() {
                const t1 = 0 !== Object.keys(this.tiles).length;
                if (this.tileID && !t1) return;
                const i = this.map.painter.context, s = i.gl;
                !this._dirty || this.texture instanceof e1.co || (this.texture ? this.texture.update(this.image) : (this.texture = new e1.T(i, this.image, s.RGBA8), this.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE)), this._dirty = !1), t1 && this._prepareData(i);
            }
            loadTile(e1, t1) {
                this.tileID && this.tileID.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}, t1(null)) : (e1.state = "errored", t1(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            getSegmentsForLongitude(t1) {
                const i = this.elevatedGlobeSegments;
                if (!this.elevatedGlobeTrianglesCenterLongitudes || !i) return null;
                const s = this.elevatedGlobeTrianglesCenterLongitudes;
                let r = (o = t1 + 180) + 360 * Math.round((s[0] - o) / 360);
                var o;
                const n = new e1.ac, a = (e1, t1)=>{
                    n.segments.push({
                        vertexOffset: 0,
                        primitiveOffset: e1,
                        vertexLength: i.segments[0].vertexLength,
                        primitiveLength: t1,
                        sortKey: void 0,
                        vaos: {}
                    });
                }, l = .51 * this.maxLongitudeTriangleSize;
                if (Math.abs(s[0] - r) <= l) {
                    const t1 = e1.cq(s, 0, s.length, r + l);
                    return t1 === s.length || a(t1, e1.cr(s, t1 + 1, s.length, r + 360 - l) - t1), n;
                }
                r < s[0] && (r += 360);
                const c = e1.cr(s, 0, s.length, r - l);
                if (c === s.length) return a(0, s.length), n;
                a(0, c - 0);
                const h = e1.cq(s, c + 1, s.length, r + l);
                return h !== s.length && a(h, s.length - h), n;
            }
        }
        const ar = {
            vector: tr,
            raster: ir,
            "raster-dem": class extends ir {
                constructor(e1, t1, i, s){
                    super(e1, t1, i, s), this.type = "raster-dem", this.maxzoom = 22, this._options = {
                        type: "raster-dem",
                        ...t1
                    }, this.encoding = t1.encoding || "mapbox";
                }
                loadTileJSONWithProvider(t1, i) {
                    this.provider = t1.name;
                    const s = new AbortController;
                    return (async ()=>{
                        const { request: r, options: o } = await e1.cl(this._options, this.map._requestManager, s.signal);
                        if (s.signal.aborted) return;
                        const n = await this.dispatcher.send("loadTileProvider", {
                            name: t1.name,
                            url: t1.url,
                            source: this.id,
                            scope: this.scope,
                            type: this.type,
                            options: o,
                            request: r
                        }, {
                            signal: s.signal
                        });
                        if (s.signal.aborted) return;
                        const a = n ? n.find((e1)=>null != e1) : null, l = e1.cm(this._options, a, this.map._requestManager);
                        l instanceof Error ? i(l) : i(null, l);
                    })().catch((e1)=>{
                        s.signal.aborted || i(e1);
                    }), {
                        cancel: ()=>s.abort()
                    };
                }
                async loadTile(t1, i) {
                    if (t1.actor && "expired" !== t1.state) return;
                    const s = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    t1.actor = this.dispatcher.getActor();
                    const r = new AbortController;
                    t1.request = r;
                    try {
                        const o = await this.map._requestManager.transformRequest(s, e1.R.Tile, r.signal);
                        if (r.signal.aborted) return i(null);
                        t1.request = t1.actor.sendCancelable("loadTile", {
                            uid: t1.uid,
                            tileID: t1.tileID,
                            source: this.id,
                            type: this.type,
                            scope: this.scope,
                            request: o,
                            encoding: this.encoding
                        }, {}, (function(s, r) {
                            return delete t1.request, t1.aborted ? i(null) : s ? (t1.state = "errored", i(s)) : (r && (this.map._refreshExpiredTiles && t1.setExpiryData(e1.ci(r.headers)), r.borderReady || t1.neighboringTiles || (t1.neighboringTiles = this._getNeighboringTiles(t1.tileID)), t1.dem = r.dem, t1.dem.onDeserialize(), t1.needsHillshadePrepare = !0, t1.needsDEMTextureUpload = !0), t1.state = "loaded", void i(null));
                        }).bind(this));
                    } catch (e1) {
                        if (r.signal.aborted) return i(null);
                        t1.state = "errored", i(e1);
                    }
                }
                abortTile(e1, t1) {
                    e1.request && (e1.request.abort(), delete e1.request), e1.actor && e1.actor.notify("abortTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    }), t1 && t1();
                }
                _getNeighboringTiles(t1) {
                    const i = t1.canonical, s = Math.pow(2, i.z), r = (i.x - 1 + s) % s, o = 0 === i.x ? t1.wrap - 1 : t1.wrap, n = (i.x + 1 + s) % s, a = i.x + 1 === s ? t1.wrap + 1 : t1.wrap, l = {};
                    return l[new e1.bP(t1.overscaledZ, o, i.z, r, i.y).key] = {
                        backfilled: !1
                    }, l[new e1.bP(t1.overscaledZ, a, i.z, n, i.y).key] = {
                        backfilled: !1
                    }, i.y > 0 && (l[new e1.bP(t1.overscaledZ, o, i.z, r, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e1.bP(t1.overscaledZ, t1.wrap, i.z, i.x, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e1.bP(t1.overscaledZ, a, i.z, n, i.y - 1).key] = {
                        backfilled: !1
                    }), i.y + 1 < s && (l[new e1.bP(t1.overscaledZ, o, i.z, r, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e1.bP(t1.overscaledZ, t1.wrap, i.z, i.x, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e1.bP(t1.overscaledZ, a, i.z, n, i.y + 1).key] = {
                        backfilled: !1
                    }), l;
                }
            },
            geojson: class extends e1.E {
                constructor(t1, i, s, r){
                    super(), this.id = t1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._loaded = !1, this.actor = s.getActor(), this.setEventedParent(r), this._data = i.data, this._options = {
                        ...i
                    }, this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), void 0 !== i.minzoom && (this.minzoom = i.minzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                    const o = e1.a2 / this.tileSize;
                    this.workerOptions = {
                        source: this.id,
                        scope: this.scope,
                        cluster: i.cluster || !1,
                        geojsonVtOptions: {
                            buffer: (void 0 !== i.buffer ? i.buffer : 128) * o,
                            tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * o,
                            extent: e1.a2,
                            maxZoom: this.maxzoom,
                            lineMetrics: i.lineMetrics || !1,
                            generateId: i.generateId || !1
                        },
                        superclusterOptions: {
                            maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                            minPoints: Math.max(2, i.clusterMinPoints || 2),
                            extent: e1.a2,
                            radius: (void 0 !== i.clusterRadius ? i.clusterRadius : 50) * o,
                            log: !1,
                            generateId: i.generateId || !1
                        },
                        clusterProperties: i.clusterProperties,
                        filter: i.filter,
                        dynamic: i.dynamic,
                        ...i.workerOptions
                    };
                }
                onAdd(e1) {
                    this.map = e1, this.setData(this._data);
                }
                setData(e1) {
                    return this._data = e1, this._updateWorkerData(), this;
                }
                updateData(t1) {
                    if (!this._options.dynamic) return this.fire(new e1.f(new Error("Can't call updateData on a GeoJSON source with dynamic set to false.")));
                    if ("string" != typeof t1 && ("Feature" === t1.type && (t1 = {
                        type: "FeatureCollection",
                        features: [
                            t1
                        ]
                    }), "FeatureCollection" !== t1.type)) return this.fire(new e1.f(new Error("Data to update should be a feature or a feature collection.")));
                    if (this._coalesce && "string" != typeof t1 && "string" != typeof this._data && "FeatureCollection" === this._data.type) {
                        const e1 = new Map;
                        for (const t1 of this._data.features)e1.set(t1.id, t1);
                        for (const i of t1.features)e1.set(i.id, i);
                        this._data.features = [
                            ...e1.values()
                        ];
                    } else this._data = t1;
                    return this._updateWorkerData(!0), this;
                }
                getClusterExpansionZoom(e1, t1) {
                    return this.actor.send("geojson.getClusterExpansionZoom", {
                        clusterId: e1,
                        source: this.id,
                        scope: this.scope
                    }).then((e1)=>t1(null, e1)).catch((e1)=>t1(e1)), this;
                }
                getClusterChildren(e1, t1) {
                    return this.actor.send("geojson.getClusterChildren", {
                        clusterId: e1,
                        source: this.id,
                        scope: this.scope
                    }).then((e1)=>t1(null, e1)).catch((e1)=>t1(e1)), this;
                }
                getClusterLeaves(e1, t1, i, s) {
                    return this.actor.send("geojson.getClusterLeaves", {
                        source: this.id,
                        scope: this.scope,
                        clusterId: e1,
                        limit: t1,
                        offset: i
                    }).then((e1)=>s(null, e1)).catch((e1)=>s(e1)), this;
                }
                async _updateWorkerData(t1 = !1) {
                    if (this._pendingLoad) return void (this._coalesce = !0);
                    this.fire(new e1.h("dataloading", {
                        dataType: "source"
                    })), this._loaded = !1;
                    const i = {
                        append: t1,
                        ...this.workerOptions
                    };
                    i.scope = this.scope;
                    const s = this._data, r = new AbortController;
                    this._pendingLoad = r;
                    try {
                        if ("string" == typeof s) {
                            if (i.request = await this.map._requestManager.transformRequest(e1.e.resolveURL(s), e1.R.Source, r.signal), r.signal.aborted) return this._pendingLoad = null, void (this._coalesce = !1);
                            i.request.collectResourceTiming = this._collectResourceTiming;
                        } else i.data = JSON.stringify(s);
                        const o = await this.actor.send(`${this.type}.loadData`, i, {
                            signal: r.signal
                        });
                        this._loaded = !0, this._pendingLoad = null;
                        const n = {
                            dataType: "source",
                            sourceDataType: this._metadataFired ? "content" : "metadata"
                        };
                        this._collectResourceTiming && o && o.resourceTiming && o.resourceTiming[this.id] && (n.resourceTiming = o.resourceTiming[this.id]), t1 && (this._partialReload = !0), this.fire(new e1.h("data", n)), this._partialReload = !1, this._metadataFired = !0;
                    } catch (t1) {
                        if (r.signal.aborted) return this._pendingLoad = null, void (this._coalesce = !1);
                        this._loaded = !0, this._pendingLoad = null, this.fire(new e1.f(t1));
                    }
                    this._coalesce && (this._updateWorkerData(t1), this._coalesce = !1);
                }
                loaded() {
                    return this._loaded;
                }
                reload() {
                    const t1 = e1.m(this.id, this.scope);
                    this.map.style.clearSource(t1), this._updateWorkerData();
                }
                loadTile(t1, i) {
                    const s = t1.actor ? "reloadTile" : "loadTile";
                    t1.actor = this.actor;
                    const r = this.map.style ? this.map.style.getLut(this.scope) : null, o = r ? {
                        image: r.image.clone()
                    } : null, n = this._partialReload, a = {
                        type: this.type,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        lut: o,
                        scope: this.scope,
                        pixelRatio: e1.e.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        showElevationIdDebug: !!this.map.painter && this.map.painter._debugParams.showElevationIdDebug,
                        promoteId: this.promoteId,
                        brightness: this.map.style && this.map.style.getBrightness() || 0,
                        extraShadowCaster: t1.isExtraShadowCaster,
                        scaleFactor: this.map.getScaleFactor(),
                        partial: n,
                        worldview: this.map.getWorldview(),
                        indoor: this.map.getIndoorTileOptions(this.id, this.scope)
                    };
                    t1.request = this.actor.sendCancelable(s, a, {}, (e1, r)=>n && !r ? (t1.state = "loaded", i(null)) : (delete t1.request, t1.destroy(!1), t1.aborted ? i(null) : e1 ? i(e1) : (t1.loadVectorData(r, this.map.painter, "reloadTile" === s), void i(null))));
                }
                abortTile(e1) {
                    e1.request && (e1.request.abort(), delete e1.request), e1.aborted = !0;
                }
                unloadTile(e1, t1) {
                    this.actor.notify("removeTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    }), e1.destroy();
                }
                onRemove(e1) {
                    this._pendingLoad && this._pendingLoad.abort();
                }
                serialize() {
                    return {
                        ...this._options,
                        type: this.type,
                        data: this._data
                    };
                }
                hasTransition() {
                    return !1;
                }
            },
            video: class extends nr {
                constructor(e1, t1, i, s){
                    super(e1, t1, i, s), this.roundZoom = !0, this.type = "video", this.options = t1;
                }
                async load() {
                    this._loaded = !1;
                    const t1 = this.options, i = new AbortController;
                    this._imageRequest = i;
                    try {
                        const s = await Promise.all(t1.urls.map(async (t1)=>(await this.map._requestManager.transformRequest(t1, e1.R.Source, i.signal)).url));
                        if (i.signal.aborted) return;
                        this.urls = s;
                        const r = await e1.cw(s);
                        if (i.signal.aborted) return;
                        this._imageRequest = null, this.video = r, this.video.loop = !0, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading();
                    } catch (t1) {
                        if (i.signal.aborted) return;
                        this.fire(new e1.f(t1));
                    } finally{
                        this._loaded = !0;
                    }
                }
                pause() {
                    this.video && this.video.pause();
                }
                play() {
                    this.video && this.video.play();
                }
                seek(t1) {
                    if (this.video) {
                        const i = this.video.seekable;
                        t1 < i.start(0) || t1 > i.end(0) ? this.fire(new e1.f(new ce(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = t1;
                    }
                }
                getVideo() {
                    return this.video;
                }
                onAdd(e1) {
                    this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                }
                prepare() {
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const t1 = this.map.painter.context, i = t1.gl;
                    this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new e1.T(t1, this.video, i.RGBA8), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t1);
                }
                serialize() {
                    return {
                        type: "video",
                        urls: this.options.urls,
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this.video && !this.video.paused;
                }
            },
            image: nr,
            canvas: class extends nr {
                constructor(t1, i, s, r){
                    super(t1, i, s, r), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e1)=>!Array.isArray(e1) || 2 !== e1.length || e1.some((e1)=>"number" != typeof e1)) || this.fire(new e1.f(new ce(`sources.${t1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e1.f(new ce(`sources.${t1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new e1.f(new ce(`sources.${t1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new e1.f(new ce(`sources.${t1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e1.f(new ce(`sources.${t1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
                }
                async load() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e1.f(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }
                getCanvas() {
                    return this.canvas;
                }
                onAdd(e1) {
                    this.map = e1, this.load(), this.canvas && this.animate && this.play();
                }
                onRemove(e1) {
                    this.pause();
                }
                prepare() {
                    let t1 = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, t1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, t1 = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const i = this.map.painter.context;
                    this.texture ? !t1 && !this._playing || this.texture instanceof e1.co || this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new e1.T(i, this.canvas, i.gl.RGBA8, {
                        premultiply: !0
                    }), this._prepareData(i);
                }
                serialize() {
                    return {
                        type: "canvas",
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this._playing;
                }
                _hasInvalidDimensions() {
                    for (const e1 of [
                        this.canvas.width,
                        this.canvas.height
                    ])if (isNaN(e1) || e1 <= 0) return !0;
                    return !1;
                }
            },
            custom: class extends e1.E {
                constructor(t1, i, s, r){
                    super(), this.id = t1, this.type = "custom", this._dataType = "raster", this._dispatcher = s, this._implementation = i, this.setEventedParent(r), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = !1, this.roundZoom = !0, this._implementation || this.fire(new e1.f(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new e1.f(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new e1.cf(this._implementation.bounds, this.minzoom, this.maxzoom));
                    const o = i;
                    o.update = this._update.bind(this), o.clearTiles = this._clearTiles.bind(this), o.coveringTiles = this._coveringTiles.bind(this), Object.assign(this, e1.cb(i, [
                        "dataType",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution",
                        "minTileCacheSize",
                        "maxTileCacheSize"
                    ]));
                }
                serialize() {
                    return e1.cb(this, [
                        "type",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution"
                    ]);
                }
                load() {
                    this._loaded = !0, this.fire(new e1.h("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.h("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                loaded() {
                    return this._loaded;
                }
                onAdd(t1) {
                    this.map = t1, this._loaded = !1, this.fire(new e1.h("dataloading", {
                        dataType: "source"
                    })), this._implementation.onAdd && this._implementation.onAdd(t1), this.load();
                }
                onRemove(e1) {
                    this._implementation.onRemove && this._implementation.onRemove(e1);
                }
                hasTile(e1) {
                    if (this._implementation.hasTile) {
                        const { x: t1, y: i, z: s } = e1.canonical;
                        return this._implementation.hasTile({
                            x: t1,
                            y: i,
                            z: s
                        });
                    }
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                async loadTile(e1, t1) {
                    const { x: i, y: s, z: r } = e1.tileID.canonical, o = new AbortController;
                    e1.request = o;
                    try {
                        const n = await this._implementation.loadTile({
                            x: i,
                            y: s,
                            z: r
                        }, {
                            signal: o.signal
                        });
                        if (delete e1.request, e1.aborted) return e1.state = "unloaded", t1(null);
                        if (void 0 === n) return e1.state = "errored", t1(null);
                        if (null === n) return this.loadTileData(e1, {
                            width: this.tileSize,
                            height: this.tileSize,
                            data: null
                        }), e1.state = "loaded", t1(null);
                        if (!function(e1) {
                            return e1 instanceof ImageData || e1 instanceof HTMLCanvasElement || e1 instanceof ImageBitmap || e1 instanceof HTMLImageElement;
                        }(n)) return e1.state = "errored", t1(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`));
                        this.loadTileData(e1, n), e1.state = "loaded", t1(null);
                    } catch (i) {
                        if (o.signal.aborted) return;
                        e1.state = "errored", t1(i);
                    }
                }
                loadTileData(e1, t1) {
                    e1.setTexture(t1, this.map.painter);
                }
                unloadTile(t1, i) {
                    if (t1.texture && t1.texture instanceof e1.T ? (t1.destroy(!1), t1.texture && t1.texture instanceof e1.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), this._implementation.unloadTile) {
                        const { x: e1, y: i, z: s } = t1.tileID.canonical;
                        this._implementation.unloadTile({
                            x: e1,
                            y: i,
                            z: s
                        });
                    }
                    i && i();
                }
                abortTile(e1, t1) {
                    e1.request && (e1.request.abort(), delete e1.request), t1 && t1();
                }
                hasTransition() {
                    return !1;
                }
                _coveringTiles() {
                    return this.map.transform.coveringTiles({
                        tileSize: this.tileSize,
                        minzoom: this.minzoom,
                        maxzoom: this.maxzoom,
                        roundZoom: this.roundZoom
                    }).map((e1)=>({
                            x: e1.canonical.x,
                            y: e1.canonical.y,
                            z: e1.canonical.z
                        }));
                }
                _clearTiles() {
                    const t1 = e1.m(this.id, this.scope);
                    this.map.style.clearSource(t1);
                }
                _update() {
                    this.fire(new e1.h("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
            }
        }, lr = function(t1, i, s, r) {
            const o = cr(i.type);
            if (!o) throw new Error(`Unknown source type "${i.type}"`);
            const n = new o(t1, i, s, r);
            if (n.id !== t1) throw new Error(`Expected Source id to be ${t1} instead of ${n.id}`);
            return e1.aV([
                "load",
                "abort",
                "unload",
                "serialize",
                "prepare"
            ], n), n;
        }, cr = function(e1) {
            return Object.hasOwn(ar, e1) ? ar[e1] : void 0;
        };
        function hr([t1, i], s, r, { scaled: o = !0 } = {}) {
            const { tileSize: n, buffer: a } = r, { x: l, y: c, z: h } = s;
            if (!isFinite(l) || !isFinite(c) || !isFinite(h)) throw new Error("Invalid MRT header");
            const d = 2 ** h, u = d * e1.a7(t1), p = d * e1.a8(i);
            return function([e1, t1], i, { scaled: s = !0 } = {}) {
                if (!i) throw new Error("bandView is undefined");
                const { data: r, tileSize: o, buffer: n, offset: a, scale: l, dimension: c } = i;
                if (e1 < -n || e1 > o + n || t1 < -n || t1 > o + n) throw new Error(`Point (${e1}, ${t1}) out of bounds for tileSize=${o}, buffer=${n}`);
                const h = (t1 + n) * (o + 2 * n) + (e1 + n);
                if (4294967295 === new Uint32Array(r.buffer)[h]) return null;
                let d = [];
                d = s ? [] : new i.data.constructor(c);
                for(let e1 = 0; e1 < c; e1++)d[e1] = Math.round(1e12 * (r[c * h + e1] * l + a)) / 1e12;
                return d;
            }([
                Math.min(Math.max(-a, Math.floor((u - l) * n)), n - 1 + a),
                Math.min(Math.max(-a, Math.floor((p - c) * n)), n - 1 + a)
            ], r, {
                scaled: o
            });
        }
        e1.cA.setPbf(e1.cB);
        class dr extends fs {
            constructor(e1, t1, i, s, r){
                super(e1, t1, i, s, r), this._workQueuePerLayer = new Map, this._fetchQueuePerLayer = new Map, this._taskQueue = new Map, this._isHeaderLoaded = !1, this.textureDescriptorPerLayer = new Map, this.texturePerLayer = new Map;
            }
            getLayers() {
                return this._mrt ? Object.values(this._mrt.layers) : [];
            }
            getLayer(e1) {
                return this._mrt && this._mrt.getLayer(e1);
            }
            setTexturePerLayer(t1, i, s) {
                const r = s.context, o = r.gl;
                let n = this.texturePerLayer.get(t1) || s.getTileTexture(i.width);
                n && n instanceof e1.T ? n.update(i, {
                    premultiply: !1
                }) : n = new e1.T(r, i, o.RGBA8, {
                    premultiply: !1
                }), this.texturePerLayer.has(t1) || this.texturePerLayer.set(t1, n);
            }
            flushQueues(e1) {
                const t1 = this._workQueuePerLayer.get(e1) || [], i = this._fetchQueuePerLayer.get(e1) || [];
                for(; t1.length;)t1.pop()();
                for(; i.length;)i.pop()();
            }
            flushAllQueues() {
                for (const e1 of this._workQueuePerLayer.keys()){
                    const t1 = this._workQueuePerLayer.get(e1) || [];
                    for(; t1.length;)t1.pop()();
                }
                for (const e1 of this._fetchQueuePerLayer.keys()){
                    const t1 = this._fetchQueuePerLayer.get(e1) || [];
                    for(; t1.length;)t1.pop()();
                }
            }
            fetchHeader(t1 = 16384, i) {
                const s = this._mrt = new e1.cA(30), r = {
                    ...this.requestParams,
                    headers: {
                        Range: "bytes=0-" + (t1 - 1)
                    }
                };
                this.entireBuffer = null;
                const o = new AbortController;
                return this.request = o, e1.cC(r, o.signal).then(({ data: e1, headers: r })=>{
                    try {
                        const o = s.getHeaderLength(e1);
                        if (o > t1) return void (this.request = this.fetchHeader(o, i));
                        s.parseHeader(e1), this._isHeaderLoaded = !0;
                        let n = 0;
                        for (const e1 of Object.values(s.layers))n = Math.max(n, e1.dataIndex.at(-1).lastByte);
                        e1.byteLength >= n && (this.entireBuffer = e1), i(null, this.entireBuffer || e1, r);
                    } catch (e1) {
                        i(e1);
                    }
                }).catch((e1)=>{
                    o.signal.aborted || i(e1);
                }), this.request;
            }
            fetchBandForRender(e1, t1, i, s) {
                this.fetchBand(e1, t1, i, (r)=>{
                    if (r) return void s(r);
                    this.updateTextureDescriptor(e1, t1, i);
                    const o = this.textureDescriptorPerLayer.get(t1);
                    s(null, o ? o.img : null);
                });
            }
            fetchBand(t1, i, s, r) {
                const o = this._mrt;
                if (!this._isHeaderLoaded || !o) return void r(new Error("Tile header is not ready"));
                const n = this.actor;
                if (!n) return void r(new Error("Can't fetch tile band without an actor"));
                let a;
                const l = e1.m(String(s), e1.m(this.tileID.key, t1));
                let c = this._taskQueue.get(l);
                c ? c.add(r) : (c = new Set, c.add(r), this._taskQueue.set(l, c));
                const h = (e1, t1)=>{
                    a.complete(e1, t1), e1 ? r(e1) : (c.forEach((e1)=>e1(null, t1)), this._taskQueue.delete(l));
                }, d = (e1, t1)=>{
                    if (e1) return r(e1);
                    let s, o = !1;
                    if (null !== i) {
                        const e1 = this._workQueuePerLayer.get(i) || [];
                        e1.push(()=>{
                            o = !0, s && s.abort(), a.cancel();
                        }), this._workQueuePerLayer.has(i) || this._workQueuePerLayer.set(i, e1);
                    }
                    const l = ()=>{
                        o || (s = n.sendCancelable("decodeRasterArray", {
                            type: "raster-array",
                            source: this.source,
                            scope: this.scope,
                            tileID: this.tileID,
                            uid: this.uid,
                            buffer: t1,
                            task: a
                        }, {}, h));
                    };
                    void 0 !== this.workerReady ? this.workerReady.then(l).catch((e1)=>r(e1)) : l();
                };
                let u;
                try {
                    u = o.getLayer(t1);
                } catch (e1) {
                    if ("reloading" === this.state) return;
                    throw e1;
                }
                if (!u) return void r(new Error(`Unknown sourceLayer "${t1}"`));
                if (u.hasDataForBand(s)) return c.forEach((e1)=>e1(null, null)), void this._taskQueue.delete(l);
                const p = u.getDataRange([
                    s
                ]);
                if (a = o.createDecodingTask(p), !a || a.tasks.length) {
                    if (null !== i && this.flushQueues(i), this.entireBuffer) d(null, this.entireBuffer.slice(p.firstByte, p.lastByte + 1));
                    else {
                        const t1 = {
                            ...this.requestParams,
                            headers: {
                                Range: `bytes=${p.firstByte}-${p.lastByte}`
                            }
                        }, s = new AbortController;
                        if (e1.cC(t1, s.signal).then(({ data: e1 })=>d(null, e1)).catch((e1)=>{
                            s.signal.aborted || d(e1);
                        }), null !== i) {
                            const e1 = this._fetchQueuePerLayer.get(i) || [];
                            e1.push(()=>{
                                s.abort(), a.cancel();
                            }), this._fetchQueuePerLayer.has(i) || this._fetchQueuePerLayer.set(i, e1);
                        }
                    }
                }
            }
            updateNeeded(e1, t1) {
                return (!this.textureDescriptorPerLayer.get(e1) || this.textureDescriptorPerLayer.get(e1).band !== t1 || this.refreshedUponExpiration) && "errored" !== this.state;
            }
            updateTextureDescriptor(t1, i, s) {
                if (!this._mrt) return;
                const r = this._mrt.getLayer(t1);
                if (!r || !r.hasBand(s) || !r.hasDataForBand(s)) return;
                const { bytes: o, tileSize: n, buffer: a, offset: l, scale: c } = r.getBandView(s), h = n + 2 * a, d = new e1.b({
                    width: h,
                    height: h
                }, o), u = this.texturePerLayer.get(i);
                u && u instanceof e1.T && u.update(d, {
                    premultiply: !1
                }), this.textureDescriptorPerLayer.set(i, {
                    layer: t1,
                    band: s,
                    img: d,
                    buffer: a,
                    offset: l,
                    tileSize: n,
                    format: r.pixelFormat,
                    mix: [
                        c,
                        256 * c,
                        65536 * c,
                        16777216 * c
                    ]
                });
            }
            destroy(t1 = !1) {
                if (super.destroy(t1), delete this._mrt, !t1) for (const t1 of this.texturePerLayer.values())t1 && t1 instanceof e1.T && t1.destroy();
                this.texturePerLayer.clear(), this.textureDescriptorPerLayer.clear(), this.fbo && (this.fbo.destroy(), delete this.fbo), delete this.request, delete this.requestParams, this._isHeaderLoaded = !1;
            }
        }
        us = (e1, t1, i, s, r)=>new dr(e1, t1, i, s, r);
        const ur = {
            RasterArrayTileSource: class extends ir {
                get partial() {
                    return !this.map.style.imageManager.hasImageProviderForSource(this.id, this.scope);
                }
                constructor(e1, t1, i, s){
                    super(e1, t1, i, s), this.type = "raster-array", this.maxzoom = 22, this._loadTilePending = {}, this._loadTileLoaded = {}, this._options = {
                        type: "raster-array",
                        ...t1
                    };
                }
                triggerRepaint(e1) {
                    const t1 = this.map.painter._terrain, i = this.map.style.getSourceCache(this.id);
                    t1 && t1.enabled && i && t1._clearRenderCacheForTile(i.id, e1.tileID), this.map.triggerRepaint();
                }
                async loadTile(t1, i) {
                    const s = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    t1.source = this.id, t1.scope = this.scope, void 0 === this._workerReady && (this._workerReady = this.dispatcher.send("ensureRasterArraySource", void 0).then(()=>{}), this._workerReady.catch(()=>{})), t1.workerReady = this._workerReady, t1.actor || (t1.actor = this.dispatcher.getActor());
                    const r = new AbortController;
                    t1.request = r;
                    const o = (s, r, o)=>{
                        if (delete t1.request, t1.aborted) return i(null);
                        if (s) return t1.state = "errored", i(s);
                        if (this.map._refreshExpiredTiles && r && t1.setExpiryData(e1.ci(o)), this.partial && "expired" !== t1.state) t1.state = "empty";
                        else if (!this.partial) {
                            if (!r) return i(null);
                            t1.state = "loaded", t1._isHeaderLoaded = !0, t1._mrt = r;
                        }
                        i(null);
                    };
                    try {
                        const n = await this.map._requestManager.transformRequest(s, e1.R.Tile, r.signal);
                        if (r.signal.aborted) return i(null);
                        t1.requestParams = n;
                        const a = {
                            request: n,
                            uid: t1.uid,
                            tileID: t1.tileID,
                            type: this.type,
                            source: this.id,
                            scope: this.scope,
                            partial: this.partial
                        };
                        t1.request = this.partial ? t1.fetchHeader(void 0, (e1, t1, i)=>{
                            o(e1, t1, i);
                        }) : t1.actor.sendCancelable("loadTile", a, {}, (e1, t1)=>e1 ? o(e1) : t1 ? void o(null, t1.mrt, t1.headers) : o(null, null));
                    } catch (e1) {
                        if (r.signal.aborted) return i(null);
                        t1.state = "errored", i(e1);
                    }
                }
                abortTile(e1) {
                    e1.request && (e1.request.abort(), delete e1.request), e1.actor && e1.actor.notify("abortTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    });
                }
                unloadTile(e1, t1) {
                    const i = e1.texturePerLayer;
                    if (e1.flushAllQueues(), i.size) {
                        e1.destroy(!1);
                        for (const e1 of i.values())this.map.painter.saveTileTexture(e1);
                    } else e1.destroy();
                }
                prepareTile(t1, i, s, r) {
                    t1._isHeaderLoaded && ("empty" !== t1.state && (t1.state = "reloading"), t1.fetchBandForRender(i, s, r, (i, r)=>{
                        i ? (t1.state = "errored", this.fire(new e1.f(i))) : r && (t1._isHeaderLoaded = !0, t1.setTexturePerLayer(s, r, this.map.painter), t1.state = "loaded"), this.triggerRepaint(t1);
                    }));
                }
                getInitialBand(e1) {
                    if (!this.rasterLayers) return 0;
                    const t1 = this.rasterLayers.find(({ id: t1 })=>t1 === e1), i = t1 && t1.fields, s = i && i.bands && i.bands;
                    return s ? s[0] : 0;
                }
                getTextureDescriptor(t1, i, s) {
                    if (!t1) return;
                    const r = i.sourceLayer || this.rasterLayerIds && this.rasterLayerIds[0];
                    if (!r) return;
                    let o = null;
                    i instanceof e1.cx ? o = i.paint.get("raster-array-band") : i instanceof e1.cy && (o = i.paint.get("raster-particle-array-band"));
                    const n = o || this.getInitialBand(r);
                    if (null != n) {
                        if (t1.textureDescriptorPerLayer.get(i.id)) {
                            if (!t1.updateNeeded(i.id, n) || s) return {
                                ...t1.textureDescriptorPerLayer.get(i.id),
                                texture: t1.texturePerLayer.get(i.id)
                            };
                        } else this.prepareTile(t1, r, i.id, n);
                    }
                }
                getImages(t1, i) {
                    const s = new Map;
                    for (const r of t1)for (const t1 of i){
                        const [i, o] = t1.split("/"), n = r.getLayer(i);
                        if (!n) continue;
                        if (!n.hasBand(o) || !n.hasDataForBand(o)) continue;
                        const { bytes: a, tileSize: l, buffer: c } = n.getBandView(o), h = l + 2 * c, d = {
                            data: new e1.b({
                                width: h,
                                height: h
                            }, a),
                            pixelRatio: 2,
                            sdf: !1,
                            usvg: !1,
                            version: 0
                        };
                        s.set(t1, d);
                    }
                    return s;
                }
                queryRasterArrayValueByBandId(t1, i, s) {
                    const r = i._mrt;
                    return new Promise((o)=>{
                        const n = {}, a = new Set;
                        for (const [l, c] of Object.entries(r.layers)){
                            if (s.layerName && l !== s.layerName) continue;
                            const h = {};
                            n[l] = h;
                            for (const { bands: d } of c.dataIndex)for (const u of d)s.bands && !s.bands.includes(u) || (a.add(e1.m(l, u)), i.fetchBand(l, null, u, (i)=>{
                                e1.e.frame(()=>{
                                    h[u] = i ? null : hr([
                                        t1.lng,
                                        t1.lat
                                    ], r, c.getBandView(u)), a.delete(e1.m(l, u)), 0 === a.size && o(n);
                                });
                            }));
                        }
                        0 === a.size && o(n);
                    });
                }
                _loadTileForQuery(e1) {
                    if (this._loadTileLoaded[e1.uid]) return Promise.resolve(e1._mrt);
                    if (e1.uid in this._loadTilePending) return this._loadTilePending[e1.uid];
                    const t1 = this._fetchTileForQuery(e1);
                    return this._loadTilePending[e1.uid] = t1, t1;
                }
                async _fetchTileForQuery(t1) {
                    const i = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    try {
                        const s = {
                            request: await this.map._requestManager.transformRequest(i, e1.R.Tile),
                            uid: t1.uid,
                            tileID: t1.tileID,
                            type: this.type,
                            source: this.id,
                            scope: this.scope,
                            partial: !1
                        }, r = await t1.actor.send("loadTile", s);
                        if (!r) return null;
                        const o = r.mrt;
                        return this.map._refreshExpiredTiles && t1.setExpiryData(e1.ci(r.headers)), t1._mrt = o, t1._isHeaderLoaded = !0, t1.state = "loaded", this._loadTileLoaded[t1.uid] = !0, o;
                    } finally{
                        delete this._loadTilePending[t1.uid];
                    }
                }
                async queryRasterArrayValueByAllBands(e1, t1, i) {
                    return await this._loadTileForQuery(t1) ? this.queryRasterArrayValueByBandId(e1, t1, i) : null;
                }
                queryRasterArrayValue(t1, i) {
                    const s = e1.cz.convert(t1), r = this.findLoadedParent(s);
                    return r && r._mrt ? i.bands || !this.partial ? this.queryRasterArrayValueByBandId(s, r, i) : this.queryRasterArrayValueByAllBands(s, r, i) : Promise.resolve(null);
                }
                findLoadedParent(t1) {
                    const i = e1.bS.fromLngLat(t1, this.map.transform.tileSize), s = this.maxzoom + 1, r = 1 << s, o = Math.floor(i.x), n = Math.floor((i.x - o) * r), a = Math.floor(i.y * r);
                    if (n < 0 || n >= r || a < 0 || a >= r) return null;
                    const l = this.map.style.getSourceCache(this.id), c = new e1.bP(s, o, s, n, a);
                    return l.findLoadedParent(c, this.minzoom);
                }
            }
        }, pr = ur, fr = {
            model: ()=>hi().then(()=>ci.ModelSource),
            "batched-model": ()=>hi().then(()=>ci.Tiled3dModelSource),
            "raster-array": ()=>(async function() {
                    return Promise.resolve();
                })().then(()=>pr.RasterArrayTileSource)
        };
        class mr extends e1.E {
            constructor(e1, t1, i, s){
                super(), this.id = e1, this.type = t1.type, this._options = t1, this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.setEventedParent(s);
            }
            hasTransition() {
                return !1;
            }
            loaded() {
                return !1;
            }
            onAdd(e1) {}
            onRemove(e1) {}
            loadTile(e1, t1) {}
            serialize() {
                return this._options;
            }
        }
        function _r(e1, t1, i = "") {
            return `${i}:${t1.id || ""}:${t1.layer.id}:${function(e1) {
                if ("layerId" in e1) return `layer:${e1.layerId}`;
                {
                    const { featuresetId: t1, importId: i } = e1;
                    return `featureset:${t1}${i ? `:import:${i}` : ""}`;
                }
            }(e1.target)}`;
        }
        function gr(e1, t1, i, s = "") {
            if (e1.uniqueFeatureID) {
                const r = _r(e1, t1, s);
                if (i.has(r)) return !0;
                i.add(r);
            }
            return !1;
        }
        function yr(e1, t1, i, s, r = !1, o) {
            const n = t1.sourceCache.transform, a = t1.sourceCache.tilesIn(e1, t1.has3DLayers, r);
            a.sort(xr);
            const l = [];
            for (const e1 of a){
                const a = e1.tile.queryRenderedFeatures(t1, e1, i, s, n, r, o);
                Object.keys(a).length && l.push({
                    wrappedTileID: e1.tile.tileID.wrapped().key,
                    queryResults: a
                });
            }
            for(const i in t1.layers){
                const r = t1.layers[i];
                if (r.styleLayer) {
                    const i = r.styleLayer.queryRenderedFeatures(e1, t1.sourceCache, s);
                    Object.keys(i).length && l.push({
                        wrappedTileID: 0,
                        queryResults: i
                    });
                }
            }
            return 0 === l.length ? {} : function(e1) {
                const t1 = {}, i = {};
                for (const s of e1){
                    const e1 = s.queryResults, r = s.wrappedTileID, o = i[r] = i[r] || {};
                    for(const i in e1){
                        const s = e1[i], r = o[i] = o[i] || {}, n = t1[i] = t1[i] || [];
                        for (const e1 of s)r[e1.featureIndex] || (r[e1.featureIndex] = !0, n.push(e1));
                    }
                }
                return t1;
            }(l);
        }
        function vr(e1, t1, i, s, r, o) {
            const n = {}, a = s.queryRenderedSymbols(e1), l = [];
            for (const e1 of Object.keys(a).map(Number))l.push(r[e1]);
            l.sort(xr);
            for (const e1 of l){
                const s = e1.featureIndex.lookupSymbolFeatures(a[e1.bucketInstanceId], e1.bucketIndex, e1.sourceLayerIndex, t1, i, o);
                for(const t1 in s){
                    const i = n[t1] = n[t1] || [], r = s[t1];
                    r.sort((t1, i)=>{
                        const s = e1.featureSortOrder;
                        if (s) {
                            const e1 = s.indexOf(t1.featureIndex);
                            return s.indexOf(i.featureIndex) - e1;
                        }
                        return i.featureIndex - t1.featureIndex;
                    });
                    for (const e1 of r)i.push(e1);
                }
            }
            return n;
        }
        function br(e1, t1) {
            const i = e1.getRenderableIds().map((t1)=>e1.getTileByID(t1)), s = [], r = {};
            for(let e1 = 0; e1 < i.length; e1++){
                const o = i[e1], n = o.tileID.canonical.key;
                r[n] || (r[n] = !0, o.querySourceFeatures(s, t1));
            }
            return s;
        }
        function xr(e1, t1) {
            const i = e1.tileID, s = t1.tileID;
            return i.overscaledZ - s.overscaledZ || i.canonical.y - s.canonical.y || i.wrap - s.wrap || i.canonical.x - s.canonical.x;
        }
        class wr {
            constructor(e1){
                this.style = e1, this.layersGotHidden = !1, this.layers = [];
            }
            processLayersChanged() {
                this.layers = [];
                const e1 = !1, t1 = !1;
                for(const i in this.style._mergedLayers){
                    const s = this.style._mergedLayers[i];
                    if ("fill-extrusion" === s.type || "building" === s.type) this.layers.push({
                        layer: s,
                        visible: e1,
                        visibilityChanged: t1
                    });
                    else if ("model" === s.type) {
                        const i = this.style.getLayerSource(s);
                        i && "batched-model" === i.type && this.layers.push({
                            layer: s,
                            visible: e1,
                            visibilityChanged: t1
                        });
                    }
                }
            }
            onNewFrame(e1) {
                this.layersGotHidden = !1;
                for (const t1 of this.layers){
                    const i = t1.layer;
                    let s = !1;
                    "fill-extrusion" === i.type ? s = !i.isHidden(e1) && i.paint.get("fill-extrusion-opacity") > 0 : "building" === i.type ? s = !i.isHidden(e1) && i.paint.get("building-opacity") > 0 : "model" === i.type && (s = !i.isHidden(e1) && i.paint.get("model-opacity").constantOr(1) > 0), this.layersGotHidden = this.layersGotHidden || !s && t1.visible, t1.visible = s;
                }
            }
            updateZOffset(e1, t1) {
                this.currentBuildingBuckets = [];
                for (const e1 of this.layers){
                    const i = e1.layer, s = this.style.getLayerSourceCache(i);
                    let r = 1;
                    "fill-extrusion" === i.type ? r = e1.visible ? i.paint.get("fill-extrusion-vertical-scale") : 0 : "building" === i.type && (r = e1.visible ? i.paint.get("building-vertical-scale") : 0);
                    let o = s ? s.getTile(t1) : null;
                    if (!o && s) for(const e1 in s._tiles){
                        const i = s._tiles[e1];
                        if (t1.canonical.isChildOf(i.tileID.canonical)) {
                            o = i;
                            break;
                        }
                    }
                    this.currentBuildingBuckets.push({
                        bucket: o ? o.getBucket(i) : null,
                        tileID: o ? o.tileID : t1,
                        verticalScale: r
                    });
                }
                e1.hasAnyZOffset = !1;
                let i = !1;
                for(let s = 0; s < e1.symbolInstances.length; s++){
                    const r = e1.symbolInstances.get(s), o = r.zOffset, n = this._getHeightAtTileOffset(t1, r.tileAnchorX, r.tileAnchorY);
                    r.zOffset = n !== Number.NEGATIVE_INFINITY ? n : o, i || o === r.zOffset || (i = !0), e1.hasAnyZOffset || 0 === r.zOffset || (e1.hasAnyZOffset = !0);
                }
                i && (e1.zOffsetBuffersNeedUpload = !0, e1.zOffsetSortDirty = !0);
            }
            hasLayerForSourceCache(e1) {
                for (const { layer: t1 } of this.layers){
                    const i = this.style.getLayerSourceCache(t1);
                    if (i && i.id === e1) return !0;
                }
                return !1;
            }
            _mapCoordToOverlappingTile(t1, i, s, r) {
                let o = i, n = s;
                if (t1.canonical.z !== r.canonical.z) {
                    const a = r.canonical, l = 1 / (1 << t1.canonical.z - a.z);
                    o = (i + t1.canonical.x * e1.a2) * l - a.x * e1.a2 | 0, n = (s + t1.canonical.y * e1.a2) * l - a.y * e1.a2 | 0;
                }
                return {
                    tileX: o,
                    tileY: n
                };
            }
            _getHeightAtTileOffset(e1, t1, i) {
                let s, r;
                for(let o = 0; o < this.layers.length; ++o){
                    const n = this.layers[o].layer;
                    if ("fill-extrusion" !== n.type && "building" !== n.type) continue;
                    const { bucket: a, tileID: l, verticalScale: c } = this.currentBuildingBuckets[o];
                    if (!a) continue;
                    const { tileX: h, tileY: d } = this._mapCoordToOverlappingTile(e1, t1, i, l), u = a.getHeightAtTileCoord(h, d);
                    u && void 0 !== u.height && (u.hidden ? s = u.height : r = Math.max(u.height * c, r || 0));
                }
                if (void 0 !== r) return r;
                for(let r = 0; r < this.layers.length; ++r){
                    const o = this.layers[r];
                    if ("model" !== o.layer.type || !o.visible) continue;
                    const { bucket: n, tileID: a } = this.currentBuildingBuckets[r];
                    if (!n) continue;
                    const { tileX: l, tileY: c } = this._mapCoordToOverlappingTile(e1, t1, i, a), h = n.getHeightAtTileCoord(l, c);
                    if (h && !h.hidden) return void 0 === h.height && void 0 !== s ? Math.min(h.maxHeight, s) * h.verticalScale : h.height ? h.height * h.verticalScale : Number.NEGATIVE_INFINITY;
                }
                return this.layersGotHidden ? 0 : Number.NEGATIVE_INFINITY;
            }
        }
        let Tr;
        function Sr() {
            return Tr || (Tr = new Jt), Tr;
        }
        function Cr(t1, i) {
            const s = {}, r = t1, o = i, n = s;
            for(const e1 in r)"ref" !== e1 && (n[e1] = r[e1]);
            return e1.cD.forEach((e1)=>{
                e1 in o && (n[e1] = o[e1]);
            }), s;
        }
        function Er(e1) {
            e1 = e1.slice();
            const t1 = Object.create(null);
            for (const i of e1)t1[i.id] = i;
            for(let i = 0; i < e1.length; i++){
                const s = e1[i];
                if (s && "ref" in s) {
                    const r = t1[s.ref];
                    r && (e1[i] = Cr(s, r));
                }
            }
            return e1;
        }
        class Ir {
            constructor(e1, t1, i, s){
                this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t1 : -t1))) : s && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class Dr {
            constructor(e1, t1, i, s, r, o = !1){
                this.text = new Ir(e1 ? e1.text : null, t1, i, r), this.icon = new Ir(e1 ? e1.icon : null, t1, s, r), this.clipped = o;
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class Pr {
            constructor(e1, t1, i, s = !1){
                this.text = e1, this.icon = t1, this.skipFade = i, this.clipped = s;
            }
        }
        class Lr {
            constructor(){
                this.invProjMatrix = e1.Y(), this.viewportMatrix = e1.Y(), this.circles = [];
            }
        }
        class Rr {
            constructor(e1, t1, i, s, r){
                this.bucketInstanceId = e1, this.featureIndex = t1, this.sourceLayerIndex = i, this.bucketIndex = s, this.tileID = r;
            }
        }
        class Ar {
            constructor(e1){
                this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(e1) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e1]) {
                    const t1 = ++this.maxGroupID;
                    this.collisionGroups[e1] = {
                        ID: t1,
                        predicate: (e1)=>e1.collisionGroupID === t1
                    };
                }
                return this.collisionGroups[e1];
            }
        }
        function Mr(t1, i, s, r, o) {
            const { horizontalAlign: n, verticalAlign: a } = e1.cM(t1), l = -(n - .5) * i, c = -(a - .5) * s, h = e1.cN(t1, r);
            return new e1.P(l + h[0] * o, c + h[1] * o);
        }
        function Fr(t1, i, s, r, o) {
            const n = new e1.P(t1, i);
            return s && n._rotate(r ? o : -o), n;
        }
        function Or(t1, i, s, r) {
            const { leftJustifiedTextSymbolIndex: o, centerJustifiedTextSymbolIndex: n, rightJustifiedTextSymbolIndex: a, verticalPlacedTextSymbolIndex: l, crossTileID: c } = s, h = e1.cO(i), d = r === e1.cL.vertical ? l : "left" === h ? o : "center" === h ? n : "right" === h ? a : -1;
            o >= 0 && (t1.text.placedSymbolArray.get(o).crossTileID = d >= 0 && o !== d ? 0 : c), n >= 0 && (t1.text.placedSymbolArray.get(n).crossTileID = d >= 0 && n !== d ? 0 : c), a >= 0 && (t1.text.placedSymbolArray.get(a).crossTileID = d >= 0 && a !== d ? 0 : c), l >= 0 && (t1.text.placedSymbolArray.get(l).crossTileID = d >= 0 && l !== d ? 0 : c);
        }
        function Br(t1, i, s) {
            const r = i === e1.cL.horizontal || i === e1.cL.horizontalOnly ? i : 0, o = i === e1.cL.vertical ? i : 0, { leftJustifiedTextSymbolIndex: n, centerJustifiedTextSymbolIndex: a, rightJustifiedTextSymbolIndex: l, verticalPlacedTextSymbolIndex: c } = s, h = t1.text.placedSymbolArray;
            n >= 0 && (h.get(n).placedOrientation = r), a >= 0 && (h.get(a).placedOrientation = r), l >= 0 && (h.get(l).placedOrientation = r), c >= 0 && (h.get(c).placedOrientation = o);
        }
        class kr {
            constructor(e1, t1, i, s, r, o, n, a){
                this.transform = e1.clone(), this.projection = e1.projection.name, this.algorithm = s, this.collisionIndex = this.algorithm.createCollisionDetector(this.transform, o, a), this.buildingIndex = n, this.frontCutoffStart = 0, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = t1, this.retainedQueryData = {}, this.collisionGroups = new Ar(i), this.collisionCircleArrays = {}, this.prevPlacement = r, r && (r.prevPlacement = void 0), this.placedOrientations = {}, this.lastReplacementSourceUpdateTime = 0;
            }
            getBucketParts(t1, i, s, r, o = 1) {
                const n = s.getBucket(i), a = s.latestFeatureIndex;
                if (!n || !a || i.fqid !== n.layerIds[0]) return;
                const l = n.layers[0].layout, c = n.layers[0].paint, h = s.collisionBoxArray, d = Math.pow(2, this.transform.zoom - s.tileID.overscaledZ), u = s.tileSize / e1.a2, p = s.tileID.toUnwrapped();
                this.transform.setProjection(n.projection);
                const f = (m = s.tileID, _ = n.getProjection(), g = this.transform, _.name === this.projection ? g.calculateProjMatrix(m.toUnwrapped()) : gt(g, _, m));
                var m, _, g;
                const y = "map" === l.get("text-pitch-alignment"), v = "map" === l.get("text-rotation-alignment");
                i.compileFilter(i.options);
                const b = i.dynamicFilter(), x = i.dynamicFilterNeedsFeature(), w = i.dynamicFilterNeedsGeometry(), T = this.transform.calculatePixelsToTileUnitsMatrix(s), S = e1.cE(f, s.tileID.canonical, y, v, this.transform, n.getProjection(), T);
                let C = null;
                const E = n.getProjection().createInversionMatrix(this.transform, s.tileID.canonical);
                if (y) {
                    const t1 = e1.cF(f, s.tileID.canonical, y, v, this.transform, n.getProjection(), T);
                    C = e1.X([], this.transform.labelPlaneMatrix, t1);
                }
                let I = null;
                b && s.latestFeatureIndex && (I = {
                    unwrappedTileID: p,
                    dynamicFilter: b,
                    dynamicFilterNeedsFeature: x,
                    needGeometry: w
                }), this.retainedQueryData[n.bucketInstanceId] = new Rr(n.bucketInstanceId, a, n.sourceLayerIndex, n.index, s.tileID);
                const [D, P] = n.layers[0].layout.get("text-size-scale-range"), L = e1.b0(o, D, P), [R, A] = l.get("icon-size-scale-range"), M = e1.b0(o, R, A), F = {
                    bucket: n,
                    layout: l,
                    paint: c,
                    posMatrix: f,
                    invMatrix: E,
                    mercatorCenter: [
                        e1.a7(this.transform.center.lng),
                        e1.a8(this.transform.center.lat)
                    ],
                    textLabelPlaneMatrix: S,
                    labelToScreenMatrix: C,
                    clippingData: I,
                    scale: d,
                    textPixelRatio: u,
                    holdingForFade: s.holdingForFade(),
                    collisionBoxArray: h,
                    partiallyEvaluatedTextSize: e1.cG(n.textSizeData, this.transform.zoom, L),
                    partiallyEvaluatedIconSize: e1.cG(n.iconSizeData, this.transform.zoom, M),
                    collisionGroup: this.collisionGroups.get(n.sourceID),
                    latestFeatureIndex: s.latestFeatureIndex
                };
                if (r) for (const e1 of n.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: s, symbolInstanceEnd: r } = e1;
                    t1.push({
                        sortKey: i,
                        symbolInstanceStart: s,
                        symbolInstanceEnd: r,
                        parameters: F
                    });
                }
                else t1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: n.symbolInstances.length,
                    parameters: F
                });
            }
            placeLayerBucketPart(e1, t1, i, s = 1) {
                this.algorithm.placeLayerBucketPart(this, e1, t1, i, s);
            }
            commit(e1) {
                this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t1 = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t1 ? t1.zoomAdjustment(this.transform.zoom) : 0;
                const s = t1 ? t1.symbolFadeChange(e1) : 1, r = t1 ? t1.opacities : {}, o = t1 ? t1.variableOffsets : {}, n = t1 ? t1.placedOrientations : {};
                for(const e1 in this.placements){
                    const t1 = this.placements[e1], o = r[e1];
                    o ? (this.opacities[e1] = new Dr(o, s, t1.text, t1.icon, null, t1.clipped), i = i || t1.text !== o.text.placed || t1.icon !== o.icon.placed) : (this.opacities[e1] = new Dr(null, s, t1.text, t1.icon, t1.skipFade, t1.clipped), i = i || t1.text || t1.icon);
                }
                for(const e1 in r){
                    const t1 = r[e1];
                    if (!this.opacities[e1]) {
                        const r = new Dr(t1, s, !1, !1);
                        r.isHidden() || (this.opacities[e1] = r, i = i || t1.text.placed || t1.icon.placed);
                    }
                }
                for(const e1 in o)this.variableOffsets[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.variableOffsets[e1] = o[e1]);
                for(const e1 in n)this.placedOrientations[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.placedOrientations[e1] = n[e1]);
                i ? this.lastPlacementChangeTime = e1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t1 ? t1.lastPlacementChangeTime : e1);
            }
            updateLayerOpacities(t1, i, s, r, o = !1, n = 1) {
                r && (this.lastReplacementSourceUpdateTime = r.updateTime);
                const a = new Set;
                for (const l of i){
                    const i = l.getBucket(t1);
                    if (i && l.latestFeatureIndex && t1.fqid === i.layerIds[0] && (this.updateBucketOpacities(i, a, l, l.collisionBoxArray, s, r, l.tileID, t1.scope), "offset" === i.elevationType && this.buildingIndex && this.buildingIndex.updateZOffset(i, l.tileID), "road" === i.elevationType && i.hdExt && i.hdExt.updateRoadElevation(i, l.tileID.canonical), i.updateZOffset(), o && l.collisionBoxArray)) {
                        const t1 = i.layers[0].layout, [s, r] = t1.get("text-size-scale-range"), [o, a] = t1.get("icon-size-scale-range"), c = e1.b0(n, s, r), h = e1.b0(n, o, a);
                        i.updateCollisionDebugBuffers(this.transform.zoom, l.collisionBoxArray, c, h);
                    }
                }
            }
            updateBucketOpacities(t1, i, s, r, o, n, a, l) {
                t1.hasTextData() && t1.text.opacityVertexArray.clear(), t1.hasIconData() && t1.icon.opacityVertexArray.clear(), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexArray.clear(), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexArray.clear();
                const c = t1.layers[0].layout, h = t1.layers[0].paint, d = !!t1.layers[0].dynamicFilter(), u = new Dr(null, 0, !1, !1, !0), p = c.get("text-allow-overlap"), f = c.get("icon-allow-overlap"), m = c.get("text-variable-anchor"), _ = "map" === c.get("text-rotation-alignment"), g = "map" === c.get("text-pitch-alignment"), y = h.get("symbol-z-offset"), v = "sea" === c.get("symbol-elevation-reference"), b = !y.isConstant(), x = new Dr(null, 0, p && (f || !t1.hasIconData() || c.get("icon-optional")), f && (p || !t1.hasTextData() || c.get("text-optional")), !0);
                !t1.collisionArrays && r && (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) && t1.deserializeCollisionBoxes(r);
                const w = (e1, t1, i)=>{
                    for(let s = 0; s < t1 / 4; s++)e1.opacityVertexArray.emplaceBack(i);
                };
                let T = 0;
                n && t1.updateReplacement(a, n), this.collisionIndex.clearClippedSymbolsForBucket(t1.bucketInstanceId);
                for(let r = 0; r < t1.symbolInstances.length; r++){
                    const c = t1.symbolInstances.get(r), { numHorizontalGlyphVertices: h, numVerticalGlyphVertices: p, crossTileID: f, numIconVertices: S, tileAnchorX: C, tileAnchorY: E } = c;
                    let I = null;
                    const D = this.retainedQueryData[t1.bucketInstanceId];
                    b && c && D && (I = s.latestFeatureIndex.loadFeature({
                        featureIndex: c.featureIndex,
                        bucketIndex: D.bucketIndex,
                        sourceLayerIndex: D.sourceLayerIndex,
                        layoutVertexArrayOffset: 0
                    }));
                    const P = y.evaluate(I, {}), L = i.has(f);
                    let R = this.opacities[f];
                    L ? R = u : R || (R = x, this.opacities[f] = R), i.add(f);
                    const A = h > 0 || p > 0, M = S > 0, F = this.placedOrientations[f], O = F === e1.cL.vertical, B = F === e1.cL.horizontal || F === e1.cL.horizontalOnly;
                    !A && !M || R.isHidden() || T++;
                    let k = !1;
                    if ((A || M) && n) for (const i of t1.activeReplacements){
                        if (e1.cH(i, o, e1.cI.Symbol, l)) continue;
                        if (i.min.x > C || C > i.max.x || i.min.y > E || E > i.max.y) continue;
                        const t1 = e1.cJ(C, E, a.canonical, i.footprintTileId.canonical);
                        if (k = e1.cK(t1, i.footprint), k) break;
                    }
                    if (k && this.collisionIndex.markSymbolAsClipped(t1.bucketInstanceId, c.featureIndex), A) {
                        const e1 = k ? Hr : $r(R.text);
                        w(t1.text, h, O ? Hr : e1), w(t1.text, p, B ? Hr : e1);
                        const i = R.text.isHidden(), { leftJustifiedTextSymbolIndex: s, centerJustifiedTextSymbolIndex: r, rightJustifiedTextSymbolIndex: o, verticalPlacedTextSymbolIndex: n } = c, a = t1.text.placedSymbolArray, l = i || O ? 1 : 0;
                        s >= 0 && (a.get(s).hidden = l), r >= 0 && (a.get(r).hidden = l), o >= 0 && (a.get(o).hidden = l), n >= 0 && (a.get(n).hidden = i || B ? 1 : 0);
                        const d = this.variableOffsets[f];
                        d && Or(t1, d.anchor, c, F);
                        const u = this.placedOrientations[f];
                        u && (Or(t1, "left", c, u), Br(t1, u, c));
                    }
                    if (M) {
                        const e1 = k ? Hr : $r(R.icon), { placedIconSymbolIndex: i, verticalPlacedIconSymbolIndex: s } = c, r = t1.icon.placedSymbolArray, o = R.icon.isHidden() ? 1 : 0;
                        i >= 0 && (w(t1.icon, S, O ? Hr : e1), r.get(i).hidden = o), s >= 0 && (w(t1.icon, c.numVerticalIconVertices, B ? Hr : e1), r.get(s).hidden = o);
                    }
                    if (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) {
                        const i = t1.collisionArrays[r];
                        if (i) {
                            let s = new e1.P(0, 0), r = !0;
                            if (i.textBox || i.verticalTextBox) {
                                if (m) {
                                    const e1 = this.variableOffsets[f];
                                    e1 ? (s = Mr(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textScale), _ && s._rotate(g ? this.transform.angle : -this.transform.angle)) : r = !1;
                                }
                                d && (r = !R.clipped), i.textBox && zr(t1.textCollisionBox.collisionVertexArray, R.text.placed, !r || O, P, v, s.x, s.y), i.verticalTextBox && zr(t1.textCollisionBox.collisionVertexArray, R.text.placed, !r || B, P, v, s.x, s.y);
                            }
                            const o = r && Boolean(!B && i.verticalIconBox);
                            i.iconBox && zr(t1.iconCollisionBox.collisionVertexArray, R.icon.placed, o, P, v, c.hasIconTextFit ? s.x : 0, c.hasIconTextFit ? s.y : 0), i.verticalIconBox && zr(t1.iconCollisionBox.collisionVertexArray, R.icon.placed, !o, P, v, c.hasIconTextFit ? s.x : 0, c.hasIconTextFit ? s.y : 0);
                        }
                    }
                }
                if (t1.fullyClipped = 0 === T, t1.sortFeatures(this.transform.angle), this.retainedQueryData[t1.bucketInstanceId] && (this.retainedQueryData[t1.bucketInstanceId].featureSortOrder = t1.featureSortOrder), t1.hasTextData() && t1.text.opacityVertexBuffer && t1.text.opacityVertexBuffer.updateData(t1.text.opacityVertexArray), t1.hasIconData() && t1.icon.opacityVertexBuffer && t1.icon.opacityVertexBuffer.updateData(t1.icon.opacityVertexArray), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexBuffer && t1.iconCollisionBox.collisionVertexBuffer.updateData(t1.iconCollisionBox.collisionVertexArray), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexBuffer && t1.textCollisionBox.collisionVertexBuffer.updateData(t1.textCollisionBox.collisionVertexArray), t1.bucketInstanceId in this.collisionCircleArrays) {
                    const e1 = this.collisionCircleArrays[t1.bucketInstanceId];
                    t1.placementInvProjMatrix = e1.invProjMatrix, t1.placementViewportMatrix = e1.viewportMatrix, t1.collisionCircleArray = e1.circles, delete this.collisionCircleArrays[t1.bucketInstanceId];
                }
            }
            symbolFadeChange(e1) {
                return 0 === this.fadeDuration ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e1) {
                return Math.max(0, (this.transform.zoom - e1) / 1.5);
            }
            hasTransitions(e1) {
                return e1 - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e1, t1) {
                const i = this.zoomAtLastRecencyCheck === t1 ? 1 - this.zoomAdjustment(t1) : 1;
                return this.zoomAtLastRecencyCheck = t1, this.commitTime + this.fadeDuration * i > e1;
            }
            isStale() {
                return this.stale;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function zr(e1, t1, i, s, r, o, n) {
            e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, n || 0, s, r ? 1 : 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, n || 0, s, r ? 1 : 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, n || 0, s, r ? 1 : 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, n || 0, s, r ? 1 : 0);
        }
        const Ur = Math.pow(2, 25), Nr = Math.pow(2, 24), jr = Math.pow(2, 17), Vr = Math.pow(2, 16), Gr = Math.pow(2, 9), qr = Math.pow(2, 8), Zr = Math.pow(2, 1);
        function $r(e1) {
            if (0 === e1.opacity && !e1.placed) return 0;
            if (1 === e1.opacity && e1.placed) return 4294967295;
            const t1 = e1.placed ? 1 : 0, i = Math.floor(127 * e1.opacity);
            return i * Ur + t1 * Nr + i * jr + t1 * Vr + i * Gr + t1 * qr + i * Zr + t1;
        }
        const Hr = 0;
        class Wr {
            constructor(e1, t1){
                this.reset(e1, t1);
            }
            reset(e1, t1) {
                this.points = e1 || [], this._distances = [
                    0
                ];
                for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
                this.length = this._distances.at(-1), this.padding = Math.min(t1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(t1) {
                if (1 === this.points.length) return this.points[0];
                t1 = e1.b0(t1, 0, 1);
                let i = 1, s = this._distances[i];
                const r = t1 * this.paddedLength + this.padding;
                for(; s < r && i < this._distances.length;)s = this._distances[++i];
                const o = i - 1, n = this._distances[o], a = s - n, l = a > 0 ? (r - n) / a : 0;
                return this.points[o].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        const Xr = 100;
        class Kr {
            constructor(e1, t1){
                this.gridRightBoundary = 0, this.gridBottomBoundary = 0, this.clippedSymbols = new Map, this.reset(e1, t1);
            }
            reset(t1, i) {
                const s = t1.width + 200, r = t1.height + 200;
                s !== this.gridRightBoundary || r !== this.gridBottomBoundary ? (this.grid = new e1.cP(s, r, 25), this.ignoredGrid = new e1.cP(s, r, 25)) : (this.grid.clear(), this.ignoredGrid.clear()), this.transform = t1, this.fogState = i, this.pitchfactor = Math.cos(t1._pitch) * t1.cameraToCenterDistance, this.screenRightBoundary = t1.width + Xr, this.screenBottomBoundary = t1.height + Xr, this.gridRightBoundary = s, this.gridBottomBoundary = r, this.clippedSymbols.clear();
            }
            clearClippedSymbolsForBucket(e1) {
                this.clippedSymbols.delete(e1);
            }
            markSymbolAsClipped(e1, t1) {
                let i = this.clippedSymbols.get(e1);
                i || (i = new Set, this.clippedSymbols.set(e1, i)), i.add(t1);
            }
            placeCollisionBox(t1, i, s, r, o, n, a, l, c, h, d) {
                let u = s.projectedAnchorX, p = s.projectedAnchorY, f = s.projectedAnchorZ;
                const m = s.tileAnchorX, _ = s.tileAnchorY, g = s.elevation, y = s.tileID, v = t1.getProjection();
                if (g && y) {
                    const [e1, t1, i] = v.upVector(y.canonical, s.tileAnchorX, s.tileAnchorY), r = v.upVectorScale(y.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
                    u += e1 * g * r, p += t1 * g * r, f += i * g * r;
                }
                const b = "globe" === t1.projection.name, x = "globe" === t1.projection.name ? e1.S(this.transform.zoom) : 0;
                if (y && b && x < 1 && !n) {
                    const t1 = 1 << y.canonical.z, i = e1.cQ(m, _);
                    e1.cR(i, i, 1 / e1.a2), e1.cS(i, i, e1.cQ(y.canonical.x, y.canonical.y)), e1.cR(i, i, 1 / t1), e1.cT(i, i, e1.cQ(r[0], r[1])), i[0] = e1.cU(i[0], -0.5, .5), e1.cR(i, i, e1.a2);
                    const s = e1.cV(i[0], i[1], e1.a2 / (2 * Math.PI), 1);
                    e1.c7(s, s, o), u = e1.al(u, s[0], x), p = e1.al(p, s[1], x), f = e1.al(f, s[2], x);
                }
                const w = this.projectAndGetPerspectiveRatio(h, u, p, f, s.tileID, "globe" === v.name || !!g || this.transform.pitch > 0, v), T = c * w.perspectiveRatio, S = (s.x1 * i + a.x - s.padding) * T + w.point.x, C = (s.y1 * i + a.y - s.padding) * T + w.point.y, E = (s.x2 * i + a.x + s.padding) * T + w.point.x, I = (s.y2 * i + a.y + s.padding) * T + w.point.y, D = w.perspectiveRatio <= .55 || w.occluded;
                return !this.isInsideGrid(S, C, E, I) || !l && this.grid.hitTest(S, C, E, I, d) || D ? {
                    box: [],
                    offscreen: !1,
                    occluded: w.occluded
                } : {
                    box: [
                        S,
                        C,
                        E,
                        I
                    ],
                    offscreen: this.isOffscreen(S, C, E, I),
                    occluded: !1
                };
            }
            placeCollisionCircles(t1, i, s, r, o, n, a, l, c, h, d, u, p, f, m, _) {
                const g = [], y = this.transform.elevation, v = t1.getProjection(), b = "road" === t1.elevationType, x = !!y || b, w = e1.cW.getAtTileOffsetFunc(_, this.transform.center.lat, this.transform.worldSize, v), T = new e1.P(s.tileAnchorX, s.tileAnchorY), S = new e1.P(s.tileAnchorX, s.tileAnchorY);
                let { x: C, y: E, z: I } = v.projectTilePoint(S.x, S.y, _.canonical), D = null;
                if (x) {
                    D = b && t1.hdExt ? t1.hdExt.makeRoadSymbolElevationParams(t1, t1.text, r, _, w, y, v, this.transform.center.lat, this.transform.worldSize) : {
                        getElevation: w,
                        elevation: y,
                        elevationFeature: null
                    };
                    const [e1, i, s] = D.getElevation(T, y, D.elevationFeature);
                    C += e1, E += i, I += s;
                }
                const P = "globe" === v.name, L = this.projectAndGetPerspectiveRatio(l, C, E, I, _, P || !!y || this.transform.pitch > 0, v), { perspectiveRatio: R } = L, A = (u ? a / R : a * R) / e1.d1, M = e1.cX(C, E, I, c), F = s.lineOffsetX * A, O = s.lineOffsetY * A, B = e1.au(t1.layers[0].layout.get("text-max-angle")), k = Math.cos(B), z = L.signedDistanceFromCamera > 0 ? e1.cY(A, n, F, O, b && 1 === s.flipState, M, S, s, o, c, {}, x && !u ? D : null, u && x, v, _, u, k) : null;
                let U = !1, N = !1, j = !0;
                if (z && !L.occluded) {
                    const t1 = .5 * f * R + m, s = new e1.P(-100, -100), r = new e1.P(this.screenRightBoundary, this.screenBottomBoundary), o = new Wr, { first: n, last: a } = z, l = n.path.length;
                    let c = [];
                    for(let e1 = l - 1; e1 >= 1; e1--)c.push(n.path[e1]);
                    for(let e1 = 1; e1 < a.path.length; e1++)c.push(a.path[e1]);
                    const u = 2.5 * t1;
                    h && (c = c.map(([t1, i, s], r)=>(x && !P && (s = D.getElevation(r < l - 1 ? n.tilePath[l - 1 - r] : a.tilePath[r - l + 2], y, D.elevationFeature)[2]), e1.cX(t1, i, s, h))), c.some((e1)=>e1[3] <= 0) && (c = []));
                    let _ = [];
                    if (c.length > 0) {
                        let t1 = 1 / 0, i = -1 / 0, o = 1 / 0, n = -1 / 0;
                        for (const e1 of c)t1 = Math.min(t1, e1[0]), o = Math.min(o, e1[1]), i = Math.max(i, e1[0]), n = Math.max(n, e1[1]);
                        i >= s.x && t1 <= r.x && n >= s.y && o <= r.y && (_ = [
                            c.map((t1)=>new e1.P(t1[0], t1[1]))
                        ], (t1 < s.x || i > r.x || o < s.y || n > r.y) && (_ = e1.cZ(_, s.x, s.y, r.x, r.y)));
                    }
                    for (const e1 of _){
                        o.reset(e1, .25 * t1);
                        let s = 0;
                        s = o.length <= .5 * t1 ? 1 : Math.ceil(o.paddedLength / u) + 1;
                        for(let e1 = 0; e1 < s; e1++){
                            const r = e1 / Math.max(s - 1, 1), n = o.lerp(r), a = n.x + Xr, l = n.y + Xr;
                            g.push(a, l, t1, 0);
                            const c = a - t1, h = l - t1, u = a + t1, f = l + t1;
                            if (j = j && this.isOffscreen(c, h, u, f), N = N || this.isInsideGrid(c, h, u, f), !i && this.grid.hitTestCircle(a, l, t1, p) && (U = !0, !d)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: U,
                                occluded: !1
                            };
                        }
                    }
                }
                return {
                    circles: !d && U || !N ? [] : g,
                    offscreen: j,
                    collisionDetected: U,
                    occluded: L.occluded
                };
            }
            queryRenderedSymbols(t1) {
                if (0 === t1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let s = 1 / 0, r = 1 / 0, o = -1 / 0, n = -1 / 0;
                for (const a of t1){
                    const t1 = new e1.P(a.x + Xr, a.y + Xr);
                    s = Math.min(s, t1.x), r = Math.min(r, t1.y), o = Math.max(o, t1.x), n = Math.max(n, t1.y), i.push(t1);
                }
                const a = this.grid.query(s, r, o, n).concat(this.ignoredGrid.query(s, r, o, n)), l = {}, c = {};
                for (const t1 of a){
                    const s = t1.key;
                    if (void 0 === l[s.bucketInstanceId] && (l[s.bucketInstanceId] = {}), l[s.bucketInstanceId][s.featureIndex]) continue;
                    const r = this.clippedSymbols.get(s.bucketInstanceId);
                    if (r && r.has(s.featureIndex)) continue;
                    const o = [
                        new e1.P(t1.x1, t1.y1),
                        new e1.P(t1.x2, t1.y1),
                        new e1.P(t1.x2, t1.y2),
                        new e1.P(t1.x1, t1.y2)
                    ];
                    e1.aT(i, o) && (l[s.bucketInstanceId][s.featureIndex] = !0, void 0 === c[s.bucketInstanceId] && (c[s.bucketInstanceId] = []), c[s.bucketInstanceId].push(s.featureIndex));
                }
                return c;
            }
            insertCollisionBox(e1, t1, i, s, r) {
                (t1 ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: i,
                    featureIndex: s,
                    collisionGroupID: r
                }, e1[0], e1[1], e1[2], e1[3]);
            }
            insertCollisionCircles(e1, t1, i, s, r) {
                const o = t1 ? this.ignoredGrid : this.grid, n = {
                    bucketInstanceId: i,
                    featureIndex: s,
                    collisionGroupID: r
                };
                for(let t1 = 0; t1 < e1.length; t1 += 4)o.insertCircle(n, e1[t1], e1[t1 + 1], e1[t1 + 2]);
            }
            projectAndGetPerspectiveRatio(t1, i, s, r, o, n, a) {
                const l = [
                    i,
                    s,
                    r,
                    1
                ];
                let c = !1;
                r || this.transform.pitch > 0 ? (e1.c7(l, l, t1), this.fogState && o && "globe" !== a.name && (c = e1.c_(this.fogState, i, s, r, o.toUnwrapped(), this.transform) > e1.d2)) : e1.c$(l, l, t1);
                const h = l[3];
                return {
                    point: new e1.P((l[0] / h + 1) / 2 * this.transform.width + Xr, (-l[1] / h + 1) / 2 * this.transform.height + Xr),
                    perspectiveRatio: Math.min(.5 + this.transform.getCameraToCenterDistance(a) / h * .5, 1.5),
                    signedDistanceFromCamera: h,
                    occluded: n && l[2] > h || c
                };
            }
            isOffscreen(e1, t1, i, s) {
                return i < Xr || e1 >= this.screenRightBoundary || s < Xr || t1 > this.screenBottomBoundary;
            }
            isInsideGrid(e1, t1, i, s) {
                return i >= 0 && e1 < this.gridRightBoundary && s >= 0 && t1 < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const t1 = e1.d0([]);
                return e1.bM(t1, t1, [
                    -100,
                    -100,
                    0
                ]), t1;
            }
        }
        const Yr = {
            default: new class {
                createCollisionDetector(e1, t1, i) {
                    return i instanceof Kr ? (i.reset(e1, t1), i) : new Kr(e1, t1);
                }
                shouldPause(e1) {
                    return e1 > 2;
                }
                placeLayerBucketPart(t1, i, s, r, o = 1) {
                    const { bucket: n, layout: a, paint: l, posMatrix: c, textLabelPlaneMatrix: h, labelToScreenMatrix: d, clippingData: u, textPixelRatio: p, mercatorCenter: f, invMatrix: m, holdingForFade: _, collisionBoxArray: g, partiallyEvaluatedTextSize: y, partiallyEvaluatedIconSize: v, collisionGroup: b, latestFeatureIndex: x } = i.parameters, w = a.get("text-optional"), T = a.get("icon-optional"), S = a.get("text-allow-overlap"), C = a.get("icon-allow-overlap"), E = "map" === a.get("text-rotation-alignment"), I = "map" === a.get("icon-rotation-alignment"), D = "map" === a.get("text-pitch-alignment"), P = l.get("symbol-z-offset"), L = "sea" === a.get("symbol-elevation-reference"), R = a.get("symbol-placement"), A = a.get("text-variable-anchor"), M = E && "point" !== R, F = I && "point" !== R, O = A && n.hasTextData(), B = n.hasIconTextFit() && O && n.hasIconData();
                    t1.transform.setProjection(n.projection);
                    const k = O || M, z = F || B;
                    let U = S && (C || !n.hasIconData() || T), N = C && (S || !n.hasTextData() || w);
                    const j = !P.isConstant();
                    !n.collisionArrays && g && n.deserializeCollisionBoxes(g);
                    const V = (i, o, l)=>{
                        const { crossTileID: g, numVerticalGlyphVertices: I } = i;
                        let R = null;
                        if (u && u.dynamicFilterNeedsFeature || j) {
                            const s = t1.retainedQueryData[n.bucketInstanceId], r = x.loadFeature({
                                featureIndex: i.featureIndex,
                                bucketIndex: s.bucketIndex,
                                sourceLayerIndex: s.sourceLayerIndex,
                                layoutVertexArrayOffset: 0
                            }), o = r.properties ? r.properties.worldview : null;
                            if (n.localizable && n.worldview && "string" == typeof o) {
                                if ("all" === o) r.properties.$localized = !0;
                                else {
                                    if (!o.split(",").includes(n.worldview)) return;
                                    r.properties.$localized = !0, r.properties.worldview = n.worldview;
                                }
                            }
                            R = u && u.needGeometry ? e1.bw(r, !0) : r;
                        }
                        if (u && !(0, u.dynamicFilter)({
                            zoom: t1.transform.zoom,
                            pitch: t1.transform.pitch,
                            worldview: n.worldview
                        }, R, t1.retainedQueryData[n.bucketInstanceId].tileID.canonical, new e1.P(i.tileAnchorX, i.tileAnchorY), t1.transform.calculateDistanceTileData(u.unwrappedTileID))) return t1.placements[g] = new Pr(!1, !1, !1, !0), void s.add(g);
                        const M = P.evaluate(R, {});
                        if ((i.zOffset || 0) + (M || 0) > 0 && t1.frontCutoffStart > 0) {
                            const r = 2 * t1.frontCutoffStart - 1, o = [
                                i.tileAnchorX,
                                i.tileAnchorY,
                                0,
                                1
                            ], n = e1.c7(e1.d3(), o, c);
                            if (n[1] / n[3] < r) return t1.placements[g] = new Pr(!1, !1, !1, !0), void s.add(g);
                        }
                        if (s.has(g)) return;
                        if (_) return void (t1.placements[g] = new Pr(!1, !1, !1));
                        let F = !1, O = !1, B = !0, V = !1, G = !1, q = null, Z = {
                            box: null,
                            offscreen: null,
                            occluded: null
                        }, $ = {
                            box: null
                        }, H = null, W = null, X = null, K = 0, Y = 0, Q = 0;
                        l.textFeatureIndex ? K = l.textFeatureIndex : i.useRuntimeCollisionCircles && (K = i.featureIndex), l.verticalTextFeatureIndex && (Y = l.verticalTextFeatureIndex);
                        const J = (s)=>{
                            s.tileID = t1.retainedQueryData[n.bucketInstanceId].tileID;
                            const r = t1.transform.elevation;
                            if ("road" === n.elevationType) s.elevation = L ? M : M + e1.cW.getAtTileOffset(s.tileID, new e1.P(s.tileAnchorX, s.tileAnchorY), r, null);
                            else {
                                const t1 = n.hdExt ? n.hdExt.elevationFeatures[i.elevationFeatureIndex] : void 0;
                                s.elevation = L ? M : M + e1.cW.getAtTileOffset(s.tileID, new e1.P(s.tileAnchorX, s.tileAnchorY), r, t1);
                            }
                            s.elevation += i.zOffset;
                        }, ee = l.textBox;
                        if (ee) {
                            J(ee);
                            const s = (s)=>{
                                let r = e1.cL.horizontal;
                                if (n.allowVerticalPlacement && !s && t1.prevPlacement) {
                                    const e1 = t1.prevPlacement.placedOrientations[g];
                                    e1 && (t1.placedOrientations[g] = e1, r = e1, Br(n, r, i));
                                }
                                return r;
                            }, r = (t1, i)=>{
                                if (n.allowVerticalPlacement && I > 0 && l.verticalTextBox) {
                                    for (const s of n.writingModes)if (s === e1.cL.vertical ? (Z = i(), $ = Z) : Z = t1(), Z && Z.box && Z.box.length) break;
                                } else Z = t1();
                            };
                            if (A) {
                                let a = A;
                                if (t1.prevPlacement && t1.prevPlacement.variableOffsets[g]) {
                                    const e1 = t1.prevPlacement.variableOffsets[g];
                                    a.indexOf(e1.anchor) > 0 && (a = a.filter((t1)=>t1 !== e1.anchor), a.unshift(e1.anchor));
                                }
                                const h = (e1, s, r)=>{
                                    const l = n.getSymbolInstanceTextSize(y, i, t1.transform.zoom, o), h = (e1.x2 - e1.x1) * l + 2 * e1.padding, d = (e1.y2 - e1.y1) * l + 2 * e1.padding, u = i.hasIconTextFit && !C ? s : null;
                                    u && J(u);
                                    let _ = {
                                        box: [],
                                        offscreen: !1,
                                        occluded: !1
                                    };
                                    const g = S ? 2 * a.length : a.length;
                                    for(let s = 0; s < g; ++s){
                                        const g = this.attemptAnchorPlacement(t1, a[s % a.length], e1, f, m, k, h, d, l, E, D, p, c, b, s >= a.length, i, o, n, r, u, y, v);
                                        if (g && (_ = g.placedGlyphBoxes, _ && _.box && _.box.length)) {
                                            F = !0, q = g.shift;
                                            break;
                                        }
                                    }
                                    return _;
                                };
                                r(()=>h(ee, l.iconBox, e1.cL.horizontal), ()=>{
                                    const t1 = l.verticalTextBox;
                                    return t1 && J(t1), n.allowVerticalPlacement && !(Z && Z.box && Z.box.length) && I > 0 && t1 ? h(t1, l.verticalIconBox, e1.cL.vertical) : {
                                        box: null,
                                        offscreen: null,
                                        occluded: null
                                    };
                                }), Z && (F = Z.box, B = Z.offscreen, V = Z.occluded);
                                const d = s(!(!Z || !Z.box));
                                if (!F && t1.prevPlacement) {
                                    const e1 = t1.prevPlacement.variableOffsets[g];
                                    e1 && (t1.variableOffsets[g] = e1, Or(n, e1.anchor, i, d));
                                }
                            } else {
                                const a = (s, r)=>{
                                    const a = n.getSymbolInstanceTextSize(y, i, t1.transform.zoom, o), l = t1.collisionIndex.placeCollisionBox(n, a, s, f, m, k, new e1.P(0, 0), S, p, c, b.predicate);
                                    return l && l.box && l.box.length && (Br(n, r, i), t1.placedOrientations[g] = r), l;
                                };
                                r(()=>a(ee, e1.cL.horizontal), ()=>{
                                    const t1 = l.verticalTextBox;
                                    return n.allowVerticalPlacement && I > 0 && t1 ? (J(t1), a(t1, e1.cL.vertical)) : {
                                        box: null,
                                        offscreen: null,
                                        occluded: null
                                    };
                                }), s(!!(Z && Z.box && Z.box.length));
                            }
                        }
                        if (H = Z, F = H && H.box && H.box.length > 0, B = H && H.offscreen, V = H && H.occluded, i.useRuntimeCollisionCircles) {
                            const s = i.centerJustifiedTextSymbolIndex >= 0 ? i.centerJustifiedTextSymbolIndex : i.verticalPlacedTextSymbolIndex, o = n.text.placedSymbolArray.get(s), l = e1.d4(n.textSizeData, y, o), u = a.get("text-padding");
                            W = t1.collisionIndex.placeCollisionCircles(n, S, o, s, n.lineVertexArray, n.glyphOffsetArray, l, c, h, d, r, D, b.predicate, i.collisionCircleDiameter * l / e1.d1, u, t1.retainedQueryData[n.bucketInstanceId].tileID), F = S || W.circles.length > 0 && !W.collisionDetected, B = B && W.offscreen, V = W.occluded;
                        }
                        if (l.iconFeatureIndex && (Q = l.iconFeatureIndex), l.iconBox) {
                            const s = (s)=>{
                                J(s);
                                const r = i.hasIconTextFit && q ? Fr(q.x, q.y, E, D, t1.transform.angle) : new e1.P(0, 0), o = n.getSymbolInstanceIconSize(v, t1.transform.zoom, i.placedIconSymbolIndex);
                                return t1.collisionIndex.placeCollisionBox(n, o, s, f, m, z, r, C, p, c, b.predicate);
                            };
                            $ && $.box && $.box.length && l.verticalIconBox ? (X = s(l.verticalIconBox), O = X.box.length > 0) : (X = s(l.iconBox), O = X.box.length > 0), B = B && X.offscreen, G = X.occluded;
                        }
                        const te = w || 0 === i.numHorizontalGlyphVertices && 0 === I, ie = T || 0 === i.numIconVertices;
                        if (te || ie ? ie ? te || (O = O && F) : F = O && F : O = F = O && F, F && H && H.box && t1.collisionIndex.insertCollisionBox(H.box, a.get("text-ignore-placement"), n.bucketInstanceId, $ && $.box && Y ? Y : K, b.ID), O && X && t1.collisionIndex.insertCollisionBox(X.box, a.get("icon-ignore-placement"), n.bucketInstanceId, Q, b.ID), W && (F && t1.collisionIndex.insertCollisionCircles(W.circles, a.get("text-ignore-placement"), n.bucketInstanceId, K, b.ID), r)) {
                            const e1 = n.bucketInstanceId;
                            let i = t1.collisionCircleArrays[e1];
                            void 0 === i && (i = t1.collisionCircleArrays[e1] = new Lr);
                            for(let e1 = 0; e1 < W.circles.length; e1 += 4)i.circles.push(W.circles[e1 + 0]), i.circles.push(W.circles[e1 + 1]), i.circles.push(W.circles[e1 + 2]), i.circles.push(W.collisionDetected ? 1 : 0);
                        }
                        const se = "globe" !== n.projection.name;
                        U = U && (se || !V), N = N && (se || !G), t1.placements[g] = new Pr(F || U, O || N, B || n.justReloaded), s.add(g);
                    }, G = t1.retainedQueryData[n.bucketInstanceId].tileID;
                    if ("offset" === n.elevationType && t1.buildingIndex && t1.buildingIndex.updateZOffset(n, G), "road" === n.elevationType && n.hdExt && n.hdExt.updateRoadElevation(n, G.canonical), n.updateZOffset(), n.sortFeaturesByY) {
                        const i = n.getSortedSymbolIndexes(t1.transform.angle);
                        for(let e1 = i.length - 1; e1 >= 0; --e1){
                            const t1 = i[e1];
                            V(n.symbolInstances.get(t1), t1, n.collisionArrays[t1]);
                        }
                        n.hasAnyZOffset && e1.w(`${n.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
                    } else if (n.hasAnyZOffset) {
                        const e1 = n.getSortedIndexesByZOffset();
                        for(let t1 = 0; t1 < e1.length; ++t1){
                            const i = e1[t1];
                            V(n.symbolInstances.get(i), i, n.collisionArrays[i]);
                        }
                    } else for(let e1 = i.symbolInstanceStart; e1 < i.symbolInstanceEnd; e1++)V(n.symbolInstances.get(e1), e1, n.collisionArrays[e1]);
                    if (r && n.bucketInstanceId in t1.collisionCircleArrays) {
                        const i = t1.collisionCircleArrays[n.bucketInstanceId];
                        e1.aO(i.invProjMatrix, c), i.viewportMatrix = t1.collisionIndex.getViewportMatrix();
                    }
                    n.justReloaded = !1;
                }
                attemptAnchorPlacement(e1, t1, i, s, r, o, n, a, l, c, h, d, u, p, f, m, _, g, y, v, b, x) {
                    const { textOffset0: w, textOffset1: T, crossTileID: S } = m, C = [
                        w,
                        T
                    ], E = Mr(t1, n, a, C, l), I = e1.collisionIndex.placeCollisionBox(g, l, i, s, r, o, Fr(E.x, E.y, c, h, e1.transform.angle), f, d, u, p.predicate);
                    if (v) {
                        const t1 = g.getSymbolInstanceIconSize(x, e1.transform.zoom, m.placedIconSymbolIndex);
                        if (0 === e1.collisionIndex.placeCollisionBox(g, t1, v, s, r, o, Fr(E.x, E.y, c, h, e1.transform.angle), f, d, u, p.predicate).box.length) return;
                    }
                    if (I.box.length > 0) {
                        let i;
                        return e1.prevPlacement && e1.prevPlacement.variableOffsets[S] && e1.prevPlacement.placements[S] && e1.prevPlacement.placements[S].text && (i = e1.prevPlacement.variableOffsets[S].anchor), e1.variableOffsets[S] = {
                            textOffset: C,
                            width: n,
                            height: a,
                            anchor: t1,
                            textScale: l,
                            prevAnchor: i
                        }, Or(g, t1, m, y), g.allowVerticalPlacement && (Br(g, y, m), e1.placedOrientations[S] = y), {
                            shift: E,
                            placedGlyphBoxes: I
                        };
                    }
                }
            }
        };
        class Qr {
            constructor(e1){
                this._sortAcrossTiles = "viewport-y" !== e1.layout.get("symbol-z-order") && void 0 !== e1.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = new Set, this._bucketParts = [];
            }
            continuePlacement(e1, t1, i, s, r, o) {
                const n = this._bucketParts;
                for(; this._currentTileIndex < e1.length;)if (t1.getBucketParts(n, s, e1[this._currentTileIndex], this._sortAcrossTiles, o), this._currentTileIndex++, r()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, n.sort((e1, t1)=>e1.sortKey - t1.sortKey)); this._currentPartIndex < n.length;)if (t1.placeLayerBucketPart(n[this._currentPartIndex], this._seenCrossTileIDs, i, o), this._currentPartIndex++, r()) return !0;
                return !1;
            }
        }
        class Jr {
            constructor(){
                this._retiredCI = null;
            }
            startNewPlacement(e1, t1, i, s, r, o, n, a, l) {
                return this.placement = new kr(e1, s, r, Yr[l || "default"], o, n, a, this._retiredCI), this._retiredCI = null, this._currentPlacementIndex = t1.length - 1, this._forceFullPlacement = !1, this._showCollisionBoxes = i, this._fadeDuration = s, this._done = !1, this._inProgressLayer = null, this;
            }
            requestFullPlacement() {
                this._forceFullPlacement = !0;
            }
            isFullPlacementRequested() {
                return this._forceFullPlacement;
            }
            setStale() {
                this.placement && (this.placement.stale = !0);
            }
            isStale() {
                return !!this.placement && this.placement.stale;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(t1, i, s, r, o) {
                const n = e1.e.now(), a = ()=>!this.isFullPlacementRequested() && 0 !== this._fadeDuration && this.placement.algorithm.shouldPause(e1.e.now() - n);
                for(; this._currentPlacementIndex >= 0;){
                    const n = i[t1[this._currentPlacementIndex]], l = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === n.type && "none" !== n.visibility && (!n.minzoom || n.minzoom <= l) && (!n.maxzoom || n.maxzoom > l)) {
                        const t1 = n, i = t1.layout.get("symbol-z-elevate"), l = void 0 !== t1.layout.get("symbol-sort-key").constantOr(1), c = t1.layout.get("symbol-z-order"), h = "viewport-y" === c || "auto" === c && !("viewport-y" !== c && l), d = t1.layout.get("text-allow-overlap") || t1.layout.get("icon-allow-overlap") || t1.layout.get("text-ignore-placement") || t1.layout.get("icon-ignore-placement"), u = h && d, p = this._inProgressLayer = this._inProgressLayer || new Qr(t1), f = e1.m(n.source, n.scope);
                        if (p.continuePlacement(i || u ? r[f] : s[f], this.placement, this._showCollisionBoxes, n, a, o)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._forceFullPlacement = !1, this._done = !0;
            }
            commit(e1) {
                return this._retiredCI = this.placement.prevPlacement ? this.placement.prevPlacement.collisionIndex : null, this.placement.commit(e1), this.placement;
            }
        }
        const eo = 512 / e1.a2 / 2;
        class to {
            constructor(t1, i, s){
                this.tileID = t1, this.bucketInstanceId = s, this.index = new e1.d5(i.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
                const r = t1.canonical.x * e1.a2, o = t1.canonical.y * e1.a2;
                for(let e1 = 0; e1 < i.length; e1++){
                    const { key: t1, crossTileID: s, tileAnchorX: n, tileAnchorY: a } = i.get(e1), l = Math.floor((r + n) * eo), c = Math.floor((o + a) * eo);
                    this.index.add(l, c), this.keys.push(t1), this.crossTileIDs.push(s);
                }
                this.index.finish();
            }
            findMatches(t1, i, s) {
                const r = this.tileID.canonical.z < i.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - i.canonical.z), o = eo / Math.pow(2, i.canonical.z - this.tileID.canonical.z), n = i.canonical.x * e1.a2, a = i.canonical.y * e1.a2;
                for(let e1 = 0; e1 < t1.length; e1++){
                    const i = t1.get(e1);
                    if (i.crossTileID) continue;
                    const { key: l, tileAnchorX: c, tileAnchorY: h } = i, d = Math.floor((n + c) * o), u = Math.floor((a + h) * o), p = this.index.range(d - r, u - r, d + r, u + r).sort((e1, t1)=>e1 - t1);
                    for (const e1 of p){
                        const t1 = this.crossTileIDs[e1];
                        if (this.keys[e1] === l && !s.has(t1)) {
                            s.add(t1), i.crossTileID = t1;
                            break;
                        }
                    }
                }
            }
        }
        class io {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class so {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(e1) {
                const t1 = Math.round((e1 - this.lng) / 360);
                if (0 !== t1) for(const e1 in this.indexes){
                    const i = this.indexes[e1], s = {};
                    for(const e1 in i){
                        const r = i[e1];
                        r.tileID = r.tileID.unwrapTo(r.tileID.wrap + t1), s[r.tileID.key] = r;
                    }
                    this.indexes[e1] = s;
                }
                this.lng = e1;
            }
            addBucket(e1, t1, i) {
                if (this.indexes[e1.overscaledZ] && this.indexes[e1.overscaledZ][e1.key]) {
                    if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t1.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
                }
                for(let e1 = 0; e1 < t1.symbolInstances.length; e1++)t1.symbolInstances.get(e1).crossTileID = 0;
                this.usedCrossTileIDs[e1.overscaledZ] || (this.usedCrossTileIDs[e1.overscaledZ] = new Set);
                const s = this.usedCrossTileIDs[e1.overscaledZ];
                for(const i in this.indexes){
                    const r = this.indexes[i];
                    if (Number(i) > e1.overscaledZ) for(const i in r){
                        const o = r[i];
                        o.tileID.isChildOf(e1) && o.findMatches(t1.symbolInstances, e1, s);
                    }
                    else {
                        const o = r[e1.scaledTo(Number(i)).key];
                        o && o.findMatches(t1.symbolInstances, e1, s);
                    }
                }
                for(let e1 = 0; e1 < t1.symbolInstances.length; e1++){
                    const r = t1.symbolInstances.get(e1);
                    r.crossTileID || (r.crossTileID = i.generate(), s.add(r.crossTileID));
                }
                return void 0 === this.indexes[e1.overscaledZ] && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new to(e1, t1.symbolInstances, t1.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e1, t1) {
                for (const i of t1.crossTileIDs)this.usedCrossTileIDs[e1].delete(i);
            }
            removeStaleBuckets(e1) {
                let t1 = !1;
                for(const i in this.indexes){
                    const s = this.indexes[i];
                    for(const r in s)e1[s[r].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, s[r]), delete s[r], t1 = !0);
                }
                return t1;
            }
        }
        class ro {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new io, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(e1, t1, i, s) {
                let r = this.layerIndexes[e1.fqid];
                void 0 === r && (r = this.layerIndexes[e1.fqid] = new so);
                let o = !1;
                const n = {};
                "globe" !== s.name && r.handleWrapJump(i);
                for (const i of t1){
                    const t1 = i.getBucket(e1);
                    t1 && e1.fqid === t1.layerIds[0] && (t1.bucketInstanceId || (t1.bucketInstanceId = ++this.maxBucketInstanceId), r.addBucket(i.tileID, t1, this.crossTileIDs) && (o = !0), n[t1.bucketInstanceId] = !0);
                }
                return r.removeStaleBuckets(n) && (o = !0), o;
            }
            pruneUnusedLayers(e1) {
                const t1 = {};
                e1.forEach((e1)=>{
                    t1[e1] = !0;
                });
                for(const e1 in this.layerIndexes)t1[e1] || delete this.layerIndexes[e1];
            }
        }
        class oo extends e1.E {
            constructor(e1){
                super(), this.requestManager = e1, this.models = Object.create(null), this.models[""] = Object.create(null), this.modelUris = Object.create(null), this.modelUris[""] = Object.create(null), this.modelByURL = Object.create(null), this.numModelsLoading = Object.create(null);
            }
            async loadModel(t1, i) {
                try {
                    const s = await this.requestManager.transformRequest(i, e1.R.Model);
                    return this.modelByURL[i] ? (await hi(), ci.loadModel ? await ci.loadModel(s.url, t1, i) : null) : null;
                } catch (s) {
                    if (404 === s.status) return null;
                    this.fire(new e1.f(new Error(`Could not load model ${t1} from ${i}`, {
                        cause: s
                    })));
                }
            }
            load(t1, i, s = {
                forceReload: !1
            }) {
                this.models[i] || (this.models[i] = Object.create(null));
                const r = Object.keys(t1), o = [], n = [];
                for (const e1 of r){
                    const r = t1[e1];
                    this.hasURLBeenRequested(r) && !s.forceReload || (this.modelByURL[r] = {
                        modelId: e1,
                        scope: i
                    }, o.push(this.loadModel(e1, r)), n.push(e1)), this.models[i][e1] || (this.models[i][e1] = {
                        model: null,
                        numReferences: 1
                    });
                }
                this.numModelsLoading[i] = (this.numModelsLoading[i] || 0) + n.length, Promise.allSettled(o).then((t1)=>{
                    for(let e1 = 0; e1 < t1.length; e1++){
                        const { status: s } = t1[e1];
                        if ("rejected" === s) continue;
                        const { value: r } = t1[e1];
                        this.models[i][n[e1]] || (this.models[i][n[e1]] = {
                            model: null,
                            numReferences: 1
                        }), this.models[i][n[e1]].model = r;
                    }
                    this.numModelsLoading[i] -= n.length, this.fire(new e1.h("data", {
                        dataType: "style"
                    }));
                }).catch((t1)=>{
                    this.fire(new e1.f(new Error(`Could not load models: ${t1.message}`)));
                });
            }
            isLoaded() {
                for(const e1 in this.numModelsLoading)if (this.numModelsLoading[e1] > 0) return !1;
                return !0;
            }
            hasModel(e1, t1, i = {
                exactIdMatch: !1
            }) {
                return !!(i.exactIdMatch ? this.getModel(e1, t1) : this.getModelByURL(this.modelUris[t1][e1]));
            }
            getModel(e1, t1) {
                return this.models[t1] || (this.models[t1] = Object.create(null)), this.models[t1][e1] ? this.models[t1][e1].model : void 0;
            }
            getModelByURL(e1) {
                if (!e1) return null;
                const t1 = this.modelByURL[e1];
                return t1 ? this.models[t1.scope][t1.modelId].model : null;
            }
            hasModelBeenAdded(e1, t1) {
                return this.models[t1] && void 0 !== this.models[t1][e1];
            }
            getModelURIs(e1) {
                return this.modelUris[e1] || Object.create(null);
            }
            addModel(e1, t1, i) {
                this.models[i] || (this.models[i] = Object.create(null)), this.modelUris[i] || (this.modelUris[i] = Object.create(null));
                const s = this.requestManager.normalizeModelURL(t1);
                if ((this.hasModel(e1, i, {
                    exactIdMatch: !0
                }) || this.hasModelBeenAdded(e1, i)) && this.modelUris[i][e1] === s) this.models[i][e1].numReferences++;
                else if (this.hasURLBeenRequested(s)) {
                    const { scope: e1, modelId: t1 } = this.modelByURL[s];
                    this.models[e1][t1].numReferences++;
                } else this.modelUris[i][e1] = s, this.load({
                    [e1]: this.modelUris[i][e1]
                }, i);
            }
            addModelURLs(e1, t1) {
                this.models[t1] || (this.models[t1] = Object.create(null)), this.modelUris[t1] || (this.modelUris[t1] = Object.create(null));
                const i = this.modelUris[t1];
                for (const t1 of Object.keys(e1))i[t1] = this.requestManager.normalizeModelURL(e1[t1]);
            }
            reloadModels(e1) {
                this.load(this.modelUris[e1], e1, {
                    forceReload: !0
                });
            }
            addModelsFromBucket(e1, t1) {
                this.models[t1] || (this.models[t1] = Object.create(null)), this.modelUris[t1] || (this.modelUris[t1] = Object.create(null));
                const i = Object.create(null);
                for (const s of e1)this.hasModel(s, t1, {
                    exactIdMatch: !0
                }) || this.hasURLBeenRequested(s) ? this.models[t1][s].numReferences++ : this.modelUris[t1][s] && !this.hasURLBeenRequested(s) ? i[s] = this.modelUris[t1][s] : !this.hasURLBeenRequested(s) && Re(s, !1) && (this.modelUris[t1][s] = this.requestManager.normalizeModelURL(s), i[s] = this.modelUris[t1][s]);
                this.load(i, t1);
            }
            hasURLBeenRequested(e1) {
                return void 0 !== this.modelByURL[e1];
            }
            removeModel(e1, t1, i = !1, s = !1) {
                if (this.models[t1] && this.models[t1][e1] && (this.models[t1][e1].numReferences--, 0 === this.models[t1][e1].numReferences || s)) {
                    const s = this.modelUris[t1][e1];
                    i || delete this.modelUris[t1][e1], delete this.modelByURL[s];
                    const r = this.models[t1][e1].model;
                    if (!r) return;
                    delete this.models[t1][e1], r.destroy();
                }
            }
            destroy() {
                for (const e1 of Object.keys(this.models))for (const t1 of Object.keys(this.models[e1])){
                    const i = this.models[e1][t1].model;
                    delete this.models[e1][t1], i && i.destroy();
                }
                this.models = Object.create(null), this.models[""] = Object.create(null), this.modelUris = Object.create(null), this.modelUris[""] = Object.create(null), this.modelByURL = Object.create(null), this.numModelsLoading = Object.create(null);
            }
            listModels(e1) {
                return this.models[e1] || (this.models[e1] = Object.create(null)), Object.keys(this.models[e1]);
            }
            upload(e1, t1) {
                this.models[t1] || (this.models[t1] = Object.create(null));
                for(const i in this.models[t1])this.models[t1][i].model && this.models[t1][i].model.upload(e1.context);
            }
        }
        const no = [
            "RENDER_SHADOWS",
            "NORMAL_OFFSET"
        ], ao = new Set([
            "symbol",
            "circle"
        ]), lo = class t1 {
            constructor(){
                this._queue = [], this._needsBuild = !0, this._idleHandle = null;
            }
            needsBuild() {
                return this._needsBuild;
            }
            buildQueue(e1, t1, i) {
                null != this._idleHandle && "undefined" != typeof cancelIdleCallback && cancelIdleCallback(this._idleHandle), this._idleHandle = null, this._queue = [], this._needsBuild = !1;
                const s = !!i.fog, r = i.hasTerrain(), o = !(!i.projection || "globe" !== i.projection.name), n = r || o, a = !(!i.directionalLight || !i.directionalLight.shadowsEnabled()), l = i.map && i.map.painter, c = !l || !l.context.extParallelShaderCompile, h = !!l && "mrt-fallback" === l.emissiveMode, d = (e1, t1 = [], i = {})=>{
                    this._queue.push({
                        programId: e1,
                        params: {
                            ...i.params,
                            defines: t1,
                            overrideFog: !!i.fog,
                            overrideTerrain: !!i.terrain,
                            overrideGlobe: !!i.globe,
                            overrideRtt: !!i.rtt,
                            precompiled: !0
                        }
                    });
                };
                for (const u of e1){
                    if ("none" === u.visibility) continue;
                    const e1 = u.getProgramIds();
                    if (e1) for (const p of e1){
                        if (ao.has(p)) continue;
                        const e1 = u.getDefaultProgramParams(p, t1.zoom, i._styleColorTheme.lut);
                        if (!e1) continue;
                        const f = l ? l.getShaderSource(p) : null, m = n && (!f || f.usedDefines.has("RENDER_TO_TEXTURE")), _ = h && m ? (e1.defines || []).concat("USE_MRT1") : e1.defines;
                        if (c) {
                            d(p, e1.defines, {
                                params: e1
                            }), m && d(p, _, {
                                params: e1,
                                rtt: !0
                            });
                            continue;
                        }
                        const g = s && (!f || f.usedDefines.has("FOG")), y = r && !u.isDraped() && (!f || f.usedDefines.has("TERRAIN")), v = o && (!f || f.usedDefines.has("GLOBE")), b = a && u.hasElevation() && (!f || f.usedDefines.has("RENDER_SHADOWS"));
                        for (const t1 of b ? [
                            !1,
                            !0
                        ] : [
                            !1
                        ]){
                            const i = t1 ? (e1.defines || []).concat(no) : e1.defines || [];
                            for (const t1 of y ? [
                                !1,
                                !0
                            ] : [
                                !1
                            ])for (const s of v ? [
                                !1,
                                !0
                            ] : [
                                !1
                            ])for (const r of g ? [
                                !1,
                                !0
                            ] : [
                                !1
                            ])d(p, i, {
                                params: e1,
                                fog: r,
                                terrain: t1,
                                globe: s
                            });
                        }
                        m && d(p, _, {
                            params: e1,
                            rtt: !0
                        });
                    }
                }
                if (d("clippingMask"), r) for (const e1 of [
                    !1,
                    !0
                ])d("terrainRaster", e1 ? [
                    "TERRAIN_VERTEX_MORPHING"
                ] : [], {
                    terrain: !0,
                    fog: s
                });
                if (!c) {
                    if (e1.some((e1)=>"hillshade" === e1.type) && d("hillshadePrepare"), a) for (const e1 of [
                        !1,
                        !0
                    ])for (const t1 of [
                        !1,
                        !0
                    ]){
                        const i = [];
                        e1 && i.push("RENDER_CUTOFF"), i.push("RENDER_SHADOWS"), t1 && i.push("NORMAL_OFFSET"), d("groundShadow", i), s && d("groundShadow", i, {
                            fog: !0
                        });
                    }
                    if (o) {
                        for (const e1 of [
                            [],
                            [
                                "TERRAIN_VERTEX_MORPHING"
                            ],
                            [
                                "GLOBE_POLES"
                            ]
                        ])for (const t1 of [
                            !1,
                            !0
                        ]){
                            const i = [
                                ...e1,
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            t1 && i.push("CUSTOM_ANTIALIASING"), d("globeRaster", i, {
                                terrain: r,
                                globe: !0,
                                fog: s
                            });
                        }
                        for (const e1 of [
                            !1,
                            !0
                        ]){
                            const t1 = e1 ? [
                                "PROJECTION_GLOBE_VIEW",
                                "FOG"
                            ] : [
                                "FOG"
                            ];
                            d("globeAtmosphere", t1, {
                                fog: !0,
                                terrain: r,
                                globe: e1
                            }), d("globeAtmosphere", [
                                ...t1,
                                "ALPHA_PASS"
                            ], {
                                fog: !0,
                                terrain: r,
                                globe: e1
                            });
                        }
                        d("stars", [], {
                            fog: s,
                            terrain: r,
                            globe: !0
                        });
                    }
                }
            }
            _executeBatch(i, s, r) {
                if (r.map && r.map.isMoving()) return void (this._idleHandle = e1.e.requestIdleCallback((e1)=>this._executeBatch(e1, s, r)));
                s.context.sweepPendingPrograms();
                const o = s.context.extParallelShaderCompile ? t1.DEADLINE_MARGIN_KHR_MS : t1.DEADLINE_MARGIN_SYNC_MS;
                let n = 0;
                for(; this._queue.length > 0;){
                    const e1 = this._queue.shift();
                    if (!e1) break;
                    if (s.style = r, s._fogVisible = !!e1.params.overrideFog, s.getOrCreateProgram(e1.programId, e1.params), n++, i.timeRemaining() <= o) break;
                }
                const a = 0 === this._queue.length || i.timeRemaining() > o;
                n > 0 && a && s.context.gl.flush(), this._idleHandle = this._queue.length > 0 || s.context._pendingPrograms.size > 0 ? e1.e.requestIdleCallback((e1)=>this._executeBatch(e1, s, r)) : null;
            }
            processQueue(t1, i) {
                0 !== this._queue.length && (null != this._idleHandle && "undefined" != typeof cancelIdleCallback && cancelIdleCallback(this._idleHandle), this._idleHandle = e1.e.requestIdleCallback((e1)=>this._executeBatch(e1, t1, i)));
            }
            reset() {
                null != this._idleHandle && "undefined" != typeof cancelIdleCallback && cancelIdleCallback(this._idleHandle), this._queue = [], this._idleHandle = null, this._needsBuild = !0;
            }
        };
        lo.DEADLINE_MARGIN_KHR_MS = 5, lo.DEADLINE_MARGIN_SYNC_MS = 25;
        let co = lo;
        const ho = e1.s.colorTheme, uo = new e1.af({
            data: new e1.ag(ho.data)
        });
        function po(t1) {
            if (!t1.metadata || !t1.metadata.content_area) return;
            const i = e1.e.devicePixelRatio, { left: s, top: r, width: o, height: n } = t1.metadata.content_area, a = s * i, l = r * i;
            return [
                a,
                l,
                a + o * i,
                l + n * i
            ];
        }
        function fo(t1) {
            if (t1) return t1.map(([t1, i])=>[
                    t1 * e1.e.devicePixelRatio,
                    i * e1.e.devicePixelRatio
                ]);
        }
        class mo {
            constructor(e1, t1, i){
                this.id = e1, this.scope = t1, this.sourceCache = i, this.pendingRequests = new Set, this.missingRequests = new Set;
            }
            addPendingRequest(e1) {
                this.missingRequests.has(e1.name) || this.pendingRequests.has(e1.name) || this.pendingRequests.add(e1.name);
            }
            hasPendingRequests() {
                return this.pendingRequests.size > 0;
            }
            resolvePendingRequests() {
                const t1 = new Map;
                if (!this.sourceCache.loaded()) return t1;
                const i = this.sourceCache.getVisibleCoordinates();
                if (0 === i.length) return t1;
                const s = this.sourceCache.getSource();
                if ("raster-array" !== s.type) return t1;
                const r = i.map((e1)=>this.sourceCache.getTile(e1)), o = s.getImages(r, Array.from(this.pendingRequests));
                for (const [i, s] of o)t1.set(e1.I.from({
                    name: i,
                    iconsetId: this.id
                }), s), this.pendingRequests.delete(i);
                for (const e1 of this.pendingRequests)this.missingRequests.add(e1);
                return this.pendingRequests.clear(), t1;
            }
        }
        const _o = (e1, t1)=>Tt(e1, t1 && t1.filter((e1)=>"source.canvas" !== e1.identifier)), go = (t1, i)=>{
            const s = t1.type && !t1.array && Array.isArray(i) ? {
                type: t1.type,
                "property-type": "data-constant"
            } : void 0;
            return e1.c(i, s);
        }, yo = new Set([
            "addLayer",
            "removeLayer",
            "setLights",
            "setPaintProperty",
            "setLayoutProperty",
            "setLayerProperty",
            "setSlot",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setTerrain",
            "setFog",
            "setSnow",
            "setRain",
            "setProjection",
            "setCamera",
            "addImport",
            "removeImport",
            "updateImport",
            "addIconset",
            "removeIconset"
        ]), vo = new Set([
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), bo = new Set([
            "background",
            "sky",
            "slot",
            "custom"
        ]), xo = {
            version: 8,
            layers: [],
            sources: {}
        }, wo = {
            duration: 300,
            delay: 0
        };
        class To extends e1.E {
            constructor(t1, i = {}){
                super(), this.map = t1, this.scope = i.scope || "", this.globalId = null, this.fragments = [], this.importDepth = i.importDepth || 0, this.importsCache = i.importsCache || new Map, this.resolvedImports = i.resolvedImports || new Set, this.transition = {
                    ...wo
                }, this._buildingIndex = new wr(this), this.crossTileSymbolIndex = new ro, this._mergedOrder = [], this._drapedFirstOrder = [], this._mergedLayers = Object.create(null), this._mergedIndoor = {}, this._indoorEnabled = !1, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = Object.create(null), this._mergedSymbolSourceCaches = Object.create(null), this._mergedFillExtrusionSourceCaches = Object.create(null), this._mergedHdRoadCoverageSourceCaches = Object.create(null), this._mergedHdRoadElevationSourceCaches = Object.create(null), this._hdCoverage = null, this._hdElevation = null, this._crossSourceElevationActive = !1, this._clipLayerPresent = !1, this._hasAppearances = !1, this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this._importedAsBasemap = !1, this._changes = i.styleChanges || new b, this._hasDataDrivenEmissive = !1, this.indoorManager = null, this.dispatcher = i.dispatcher ? i.dispatcher : new ei(Sr(), this);
                const s = {
                    referrer: e1.d7(),
                    config: e1.dn()
                };
                if (this.map.painter && this.map.painter.context) {
                    const e1 = this.map.painter.context.maxUniformBufferBindings, t1 = Math.floor(this.map.painter.context.maxUniformBlockSize / 4);
                    s.contextOptions = {
                        maxBindingPoints: e1,
                        maxUniformBlockSizeDwords: t1
                    };
                }
                this.isRootStyle() && this.dispatcher.broadcast("setGlobalParams", s), i.imageManager ? this.imageManager = i.imageManager : (this.imageManager = new le(this.map._spriteFormat), this.imageManager.setEventedParent(this)), this.imageManager.addScope(this.scope), this.glyphManager = i.glyphManager ? i.glyphManager : new e1.d8(t1._requestManager, i.localFontFamily ? e1.d9.all : i.localIdeographFontFamily ? e1.d9.ideographs : e1.d9.none, i.localFontFamily || i.localIdeographFontFamily, i.fontstackCompositing), i.modelManager ? this.modelManager = i.modelManager : (this.modelManager = new oo(t1._requestManager), this.modelManager.setEventedParent(this)), this._layers = Object.create(null), this._sourceCaches = {}, this._otherSourceCaches = Object.create(null), this._symbolSourceCaches = Object.create(null), this._fillExtrusionSourceCaches = Object.create(null), this._hdCoverage = null, this._hdElevation = null, this._crossSourceElevationActive = !1, this._loaded = !1, this._initialBroadcastDone = !1, this._programPrecompiler = this.map._precompilePrograms && this.isRootStyle() ? new co : null, this._availableImages = [], this._availableModels = {}, this._order = [], this._markersNeedUpdate = !1, this.options = i.configOptions ? i.configOptions : new Map, this._layerExpressionDependencies = i.layerExpressionDependencies ? i.layerExpressionDependencies : new Map, this._config = i.config, this._styleColorTheme = {
                    lut: null,
                    lutLoading: !1,
                    lutLoadingCorrelationID: 0,
                    colorTheme: null,
                    colorThemeOverride: i.colorThemeOverride
                }, this._styleColorThemeForScope = {}, this._initialConfig = i.initialConfig;
                const r = this;
                this._rtlTextPluginCallback = To.registerForPluginStateChange((t1)=>{
                    r.dispatcher.send("syncRTLPluginState", {
                        pluginStatus: t1.pluginStatus,
                        pluginURL: t1.pluginURL
                    }).then((t1)=>{
                        if (e1.da(null), t1.every((e1)=>e1)) for(const e1 in r._sourceCaches){
                            const t1 = r._sourceCaches[e1], i = t1.getSource().type;
                            "vector" !== i && "geojson" !== i || t1.reload();
                        }
                    }).catch((t1)=>{
                        e1.da(t1);
                    });
                }), this.on("data", (e1)=>{
                    if ("source" !== e1.dataType || "metadata" !== e1.sourceDataType) return;
                    const t1 = this.getOwnSource(e1.sourceId);
                    if (t1 && t1.vectorLayerIds) for(const e1 in this._layers){
                        const i = this._layers[e1];
                        i.source === t1.id && this._validateLayer(i);
                    }
                });
            }
            load(e1) {
                return e1 ? ("string" == typeof e1 ? this.loadURL(e1) : this.loadJSON(e1), this) : this;
            }
            _getGlobalId(t1) {
                if (!t1) return null;
                if ("string" == typeof t1) {
                    if (e1.cg(t1)) return t1;
                    const i = e1.db(t1);
                    if (!i.startsWith("http")) try {
                        return new URL(i, location.href).toString();
                    } catch (e1) {
                        return i;
                    }
                    return i;
                }
                return `json://${e1.dc(JSON.stringify(t1))}`;
            }
            _diffStyle(t1, i, s) {
                this.globalId = this._getGlobalId(t1), wt();
                const r = (e1, t1)=>{
                    try {
                        t1(null, this.setState(e1, s));
                    } catch (e1) {
                        t1(e1, !1);
                    }
                };
                if ("string" == typeof t1) {
                    const s = this.map._requestManager.normalizeStyleURL(t1), o = new AbortController;
                    this._request = {
                        cancel: ()=>o.abort()
                    }, (async ()=>{
                        const t1 = await this.map._requestManager.transformRequest(s, e1.R.Style, o.signal), { data: n } = await e1.g(t1, o.signal);
                        this._request = null, r(n, i);
                    })().catch((t1)=>{
                        this._request = null, o.signal.aborted || this.fire(new e1.f(t1));
                    });
                } else "object" == typeof t1 && r(t1, i);
            }
            loadURL(t1, i = {}) {
                this.fire(new e1.h("dataloading", {
                    dataType: "style"
                }));
                const s = "boolean" == typeof i.validate ? i.validate : !e1.cg(t1);
                s && wt(), this.globalId = this._getGlobalId(t1), t1 = this.map._requestManager.normalizeStyleURL(t1, i.accessToken), this.resolvedImports.add(t1);
                const r = this.importsCache.get(t1);
                if (r) return void this._load(r, s);
                const o = new AbortController;
                this._request = {
                    cancel: ()=>o.abort()
                }, (async ()=>{
                    const i = await this.map._requestManager.transformRequest(t1, e1.R.Style, o.signal), { data: r } = await e1.g(i, o.signal);
                    this._request = null, this.importsCache.set(t1, r), this._load(r, s);
                })().catch((t1)=>{
                    this._request = null, o.signal.aborted || this.fire(new e1.f(t1));
                });
            }
            loadJSON(t1, i = {}) {
                this.fire(new e1.h("dataloading", {
                    dataType: "style"
                }));
                const s = !1 !== i.validate;
                s && wt(), this.globalId = this._getGlobalId(t1), this._request = e1.e.frame(()=>{
                    this._request = null, this._load(t1, s);
                });
            }
            loadEmpty() {
                this.fire(new e1.h("dataloading", {
                    dataType: "style"
                })), this._load(xo, !1);
            }
            _loadImports(t1, i, s) {
                if (this.importDepth >= 4) return e1.w("Style doesn't support nesting deeper than 5"), Promise.resolve();
                const r = [];
                for (const o of t1){
                    const t1 = this._createFragmentStyle(o), n = new Promise((e1)=>{
                        t1.once("style.import.load", e1), t1.once("error", e1);
                    }).then(()=>{
                        this.mergeAll(), this.fire(new e1.h("data", {
                            dataType: "style"
                        }));
                    });
                    if (r.push(n), this.resolvedImports.has(o.url)) {
                        t1.loadEmpty();
                        continue;
                    }
                    const a = o.data || this.importsCache.get(o.url);
                    a ? (o.data ? (t1.fire(new e1.h("dataloading", {
                        dataType: "style"
                    })), t1.globalId = t1._getGlobalId(a), i && wt(), queueMicrotask(()=>{
                        t1._load(a, i);
                    })) : t1.loadJSON(a, {
                        validate: i
                    }), this._isInternalStyle(a) && (t1.globalId = null)) : o.url ? t1.loadURL(o.url, {
                        validate: i
                    }) : t1.loadEmpty();
                    const l = {
                        style: t1,
                        id: o.id,
                        config: o.config
                    };
                    if (s) {
                        const e1 = this.fragments.findIndex(({ id: e1 })=>e1 === s);
                        this.fragments = this.fragments.slice(0, e1).concat(l).concat(this.fragments.slice(e1));
                    } else this.fragments.push(l);
                }
                return Promise.allSettled(r);
            }
            getImportGlobalIds(e1 = this, t1 = new Set) {
                for (const i of e1.fragments)i.style.globalId && t1.add(i.style.globalId), this.getImportGlobalIds(i.style, t1);
                return [
                    ...t1.values()
                ];
            }
            _createFragmentStyle(t1) {
                const i = this.scope ? e1.m(t1.id, this.scope) : t1.id;
                let s;
                const r = this._initialConfig && this._initialConfig[i];
                (t1.config || r) && (s = {
                    ...t1.config,
                    ...r
                });
                const o = new To(this.map, {
                    scope: i,
                    styleChanges: this._changes,
                    importDepth: this.importDepth + 1,
                    importsCache: this.importsCache,
                    resolvedImports: new Set(this.resolvedImports),
                    dispatcher: this.dispatcher,
                    imageManager: this.imageManager,
                    glyphManager: this.glyphManager,
                    modelManager: this.modelManager,
                    config: s,
                    configOptions: this.options,
                    colorThemeOverride: t1["color-theme"],
                    layerExpressionDependencies: this._layerExpressionDependencies
                });
                return o.setEventedParent(this.map, {
                    style: o
                }), o;
            }
            _reloadImports(e1 = !1) {
                this.mergeAll(), this._updateMapProjection(), e1 || this.updateConfigDependencies(), this._updateLayers(this._dependentLayerIds((e1)=>e1.isIndoorDependent)), this.map._triggerCameraUpdate(this.camera), (!e1 || this.isRootStyle() || this.map.style._initialBroadcastDone) && (e1 && this.isRootStyle() ? (this.forEachFragmentStyle((e1)=>{
                    this.dispatcher.broadcast("setLayers", {
                        layers: e1._serializeLayers(e1._order),
                        scope: e1.scope,
                        options: e1.options
                    });
                }), this._initialBroadcastDone = !0) : this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }));
            }
            _isInternalStyle(e1) {
                return this.isRootStyle() && (e1.fragment || !!e1.schema && !1 !== e1.fragment);
            }
            async _load(t1, i) {
                if (this._isInternalStyle(t1)) {
                    const e1 = {
                        id: "basemap",
                        data: t1,
                        url: ""
                    }, s = {
                        ...xo,
                        imports: [
                            e1
                        ],
                        ...t1.center ? {
                            center: t1.center
                        } : {},
                        ...t1.bearing ? {
                            bearing: t1.bearing
                        } : {},
                        ...t1.pitch ? {
                            pitch: t1.pitch
                        } : {},
                        ...t1.zoom ? {
                            zoom: t1.zoom
                        } : {},
                        ...t1.light ? {
                            light: t1.light
                        } : {}
                    };
                    return this._importedAsBasemap = !0, void this._load(s, i);
                }
                if (this.updateConfig(this._config, t1.schema), i) {
                    if (await wt(), !this.dispatcher.actors.length) return;
                    if (_o(this, Ct(t1))) return;
                }
                this._loaded = !0;
                for(const e1 in t1.sources)this.addSource(e1, t1.sources[e1], {
                    validate: !1,
                    isInitialLoad: !0
                });
                this.stylesheet = e1.dd(t1);
                const s = ()=>{
                    if (t1.iconsets) for(const e1 in t1.iconsets)this.addIconset(e1, t1.iconsets[e1]);
                    t1.sprite ? this._loadIconset(t1.sprite) : (this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope
                    })), !this.glyphManager.url && t1.glyphs && this.glyphManager.setURL(t1.glyphs);
                    const s = Er(this.stylesheet.layers);
                    if (this._order = s.map((e1)=>e1.id), this.stylesheet.light && e1.w("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights) {
                        if (1 === this.stylesheet.lights.length && "flat" === this.stylesheet.lights[0].type) {
                            const e1 = this.stylesheet.lights[0];
                            this.light = new Nt(e1.properties, e1.id);
                        } else this.setLights(this.stylesheet.lights);
                    }
                    this.light || (this.light = new Nt(this.stylesheet.light)), this._layers = Object.create(null);
                    let r = !1;
                    for (const t1 of s){
                        const i = e1.di(t1, this.scope, this._styleColorTheme.lut, this.options);
                        this._layerExpressionDependencies.set(i.fqid, new x(i)), this._hasAppearances = this._hasAppearances || 0 !== i.getAppearances().length, i.setEventedParent(this, {
                            layer: {
                                id: i.id
                            }
                        }), this._layers[i.id] = i, this._updateHdCoverageSourceCache(i) && (r = !0);
                        const s = this.getOwnLayerSourceCache(i), o = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                        s && i.canCastShadows() && o && (s.castsShadows = !0);
                    }
                    if (r && Ks().then(()=>{
                        if (!this.map) return;
                        for(const e1 in this._layers)this._updateHdCoverageSourceCache(this._layers[e1]);
                        this.map.style.mergeAll();
                        const e1 = this.map.transform;
                        for(const t1 in this.map.style._mergedHdRoadCoverageSourceCaches){
                            const i = this.map.style._mergedHdRoadCoverageSourceCaches[t1];
                            i.used = !0, e1 && i.update(e1);
                        }
                        this.map._update();
                    }), this.glyphManager.url) {
                        const e1 = new Set;
                        for(const t1 in this._layers){
                            const i = this._layers[t1];
                            if ("symbol" === i.type && i.layout) {
                                const t1 = i.layout.get("text-font");
                                t1 && t1.value && "constant" === t1.value.kind && e1.add(t1.value.value.join(","));
                            }
                        }
                        for (const t1 of e1)this.glyphManager.prefetchRange(t1, 0);
                    }
                    this.stylesheet.featuresets && this.setFeaturesetSelectors(this.stylesheet.featuresets), this.stylesheet.models && this.addModelURLs(this.stylesheet.models);
                    const o = this.stylesheet.terrain;
                    o && (this.checkCanvasFingerprintNoise(), this.disableElevatedTerrain || this.terrainSetForDrapingOnly() || this._createTerrain(o, 1)), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.snow && this._createSnow(this.stylesheet.snow), this.stylesheet.rain && this._createRain(this.stylesheet.rain), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new e1.h("data", {
                        dataType: "style"
                    }));
                    const n = this.isRootStyle();
                    t1.imports ? this._loadImports(t1.imports, i).then(()=>{
                        this._reloadImports(!0), this.fire(new e1.h(n ? "style.load" : "style.import.load"));
                    }).catch((t1)=>{
                        this.fire(new e1.f(new Error("Failed to load imports", t1))), this.fire(new e1.h(n ? "style.load" : "style.import.load"));
                    }) : (this._reloadImports(!0), this.fire(new e1.h(n ? "style.load" : "style.import.load")));
                };
                this._styleColorTheme.colorTheme = this.stylesheet["color-theme"];
                const r = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
                if (r) {
                    const t1 = this._evaluateColorThemeData(r);
                    this._loadColorTheme(t1).then(()=>{
                        s();
                    }).catch((t1)=>{
                        e1.w(`Couldn't load color theme from the stylesheet: ${t1}`), s();
                    });
                } else this._styleColorTheme.lut = null, s();
            }
            isRootStyle() {
                return 0 === this.importDepth;
            }
            hasAppearances() {
                return this._hasAppearances || this.fragments.some((e1)=>e1.style.hasAppearances());
            }
            mergeAll() {
                let e1, t1, i, s, r, o, n, a, l, c;
                const h = {};
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((d)=>{
                    if (d.stylesheet) {
                        if (d.disableElevatedTerrain && (this.disableElevatedTerrain = !0), null != d.light && (e1 = d.light), d.stylesheet.lights) for (const e1 of d.stylesheet.lights)"ambient" === e1.type && null != d.ambientLight && (t1 = d.ambientLight), "directional" === e1.type && null != d.directionalLight && (i = d.directionalLight);
                        s = this._prioritizeTerrain(s, d.terrain, d.stylesheet.terrain), d.stylesheet.fog && null != d.fog && (r = d.fog), d.stylesheet.snow && null != d.snow && (o = d.snow), d.stylesheet.rain && null != d.rain && (n = d.rain), null != d.stylesheet.camera && (c = d.stylesheet.camera), null != d.stylesheet.projection && (a = d.stylesheet.projection), null != d.stylesheet.transition && (l = d.stylesheet.transition), h[d.scope] = d._styleColorTheme;
                    }
                }), this.light = e1, this.ambientLight = t1, this.directionalLight = i, this.fog = r, this.snow = o, this.rain = n, this._styleColorThemeForScope = h, null === s ? delete this.terrain : this.terrain = s, this.camera = c || {
                    "camera-projection": "perspective"
                }, this.projection = a || {
                    name: "mercator"
                }, this.transition = {
                    ...wo,
                    ...l
                }, this.mergeSources(), this.mergeLayers(), this.mergeIndoor(), this._programPrecompiler && this._programPrecompiler.reset();
            }
            forEachFragmentStyle(e1) {
                const t1 = (i)=>{
                    for (const e1 of i.fragments)t1(e1.style);
                    e1(i);
                };
                t1(this);
            }
            _prioritizeTerrain(e1, t1, i) {
                const s = e1 && 0 === e1.drapeRenderMode;
                return null === i ? t1 && 0 === t1.drapeRenderMode ? t1 : s ? e1 : null : null != t1 && (!e1 || s || t1 && 1 === t1.drapeRenderMode) ? t1 : e1;
            }
            mergeTerrain() {
                let e1;
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((t1)=>{
                    e1 = this._prioritizeTerrain(e1, t1.terrain, t1.stylesheet.terrain);
                }), null === e1 ? delete this.terrain : this.terrain = e1, this._programPrecompiler && this._programPrecompiler.reset();
            }
            mergeProjection() {
                let e1;
                this.forEachFragmentStyle((t1)=>{
                    null != t1.stylesheet.projection && (e1 = t1.stylesheet.projection);
                }), this.projection = e1 || {
                    name: "mercator"
                }, this._programPrecompiler && this._programPrecompiler.reset();
            }
            mergeSources() {
                const t1 = {}, i = Object.create(null), s = Object.create(null), r = Object.create(null), o = Object.create(null), n = Object.create(null);
                this.forEachFragmentStyle((a)=>{
                    for(const i in a._sourceCaches){
                        const s = e1.m(i, a.scope);
                        t1[s] = a._sourceCaches[i];
                    }
                    for(const t1 in a._otherSourceCaches){
                        const s = e1.m(t1, a.scope);
                        i[s] = a._otherSourceCaches[t1];
                    }
                    for(const t1 in a._symbolSourceCaches){
                        const i = e1.m(t1, a.scope);
                        s[i] = a._symbolSourceCaches[t1];
                    }
                    for(const t1 in a._fillExtrusionSourceCaches){
                        const i = e1.m(t1, a.scope);
                        r[i] = a._fillExtrusionSourceCaches[t1];
                    }
                    if (a._hdCoverage) {
                        const t1 = a._hdCoverage.coverageSourceCaches;
                        for(const i in t1)o[e1.m(i, a.scope)] = t1[i];
                    }
                    if (a._hdElevation) {
                        const e1 = a._hdElevation.elevationSourceCaches;
                        for(const t1 in e1)n[t1] = e1[t1];
                    }
                }), this._mergedSourceCaches = t1, this._mergedOtherSourceCaches = i, this._mergedSymbolSourceCaches = s, this._mergedFillExtrusionSourceCaches = r, this._mergedHdRoadCoverageSourceCaches = o, this._mergedHdRoadElevationSourceCaches = n, Object.keys(o).length > 0 && !this._hdCoverage && Xs.HdCoverageState && (this._hdCoverage = new Xs.HdCoverageState), Xs.updateCrossSourceElevationGate && Xs.updateCrossSourceElevationGate(this);
            }
            mergeIndoor() {
                this._mergedIndoor = {}, this.forEachFragmentStyle((t1)=>{
                    if (t1.stylesheet && t1.stylesheet.indoor) for (const i of Object.values(t1.stylesheet.indoor)){
                        const s = i, r = e1.m(s.sourceId, t1.scope);
                        this._mergedIndoor[r] = new Set(s.sourceLayers || []);
                    }
                }), this._updateIndoorEnabled();
            }
            _updateIndoorEnabled() {
                const t1 = this._indoorEnabled;
                if (this._indoorEnabled = !1, Object.keys(this._mergedIndoor).length > 0) for (const t1 of this._mergedOrder){
                    const i = this._mergedLayers[t1];
                    if ("none" !== i.visibility && this._mergedIndoor[e1.m(i.source, i.scope)]) {
                        this._indoorEnabled = !0;
                        break;
                    }
                }
                !this._indoorEnabled || t1 || this.indoorManager || Ks().then(()=>{
                    this._initIndoorManager();
                });
            }
            _initIndoorManager() {
                if (!this.indoorManager && Xs.IndoorManager && this.isRootStyle() && 0 !== Object.keys(this._mergedIndoor).length && (this.indoorManager = new Xs.IndoorManager(this, this._loaded), this._loaded)) for (const e1 of Object.keys(this._mergedIndoor)){
                    const t1 = this._mergedSourceCaches[e1] || this._mergedOtherSourceCaches[e1];
                    t1 && t1.reload();
                }
            }
            mergeLayers() {
                const t1 = {}, i = [], s = Object.create(null);
                this._mergedSlots = [], this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this.forEachFragmentStyle((s)=>{
                    for (const r of s._order){
                        const o = s._layers[r];
                        if ("slot" === o.type) {
                            const i = e1.bV(r);
                            if (t1[i]) continue;
                            t1[i] = [];
                        }
                        o.slot && t1[o.slot] ? t1[o.slot].push(o) : i.push(o);
                    }
                }), this._mergedOrder = [];
                let r = -1;
                const o = (i = [])=>{
                    for (const n of i)if ("slot" === n.type) {
                        const i = e1.bV(n.id);
                        t1[i] && o(t1[i]), this._mergedSlots.push(i);
                    } else {
                        const t1 = e1.m(n.id, n.scope);
                        this._mergedOrder.push(t1), s[t1] = n, n.is3D(!!this.terrain) && (this._has3DLayers = !0, r = this._mergedOrder.length - 1), "circle" === n.type && (this._hasCircleLayers = !0), "symbol" === n.type && (this._hasSymbolLayers = !0), "clip" === n.type && (this._clipLayerPresent = !0);
                    }
                };
                if (o(i), this._has3DLayers) {
                    const e1 = {};
                    for(let t1 = 0; t1 < this._mergedOrder.length; ++t1){
                        const i = this._mergedOrder[t1];
                        e1[i] = t1 === r ? 1 : t1 < r ? s[i].hasOcclusionOpacityProperties ? 2 : 0 : 4;
                    }
                    this._mergedOrder.sort((t1, i)=>e1[t1] - e1[i]);
                }
                this._mergedLayers = s, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged(), this._updateDataDrivenEmissiveStrength();
            }
            terrainSetForDrapingOnly() {
                return !!this.terrain && 0 === this.terrain.drapeRenderMode;
            }
            getCamera() {
                return this.stylesheet.camera;
            }
            setCamera(e1) {
                return this.stylesheet.camera = {
                    ...this.stylesheet.camera,
                    ...e1
                }, this.camera = this.stylesheet.camera, this;
            }
            _evaluateColorThemeData(t1) {
                return t1.data ? (function(t1, i, s) {
                    const r = {
                        ...i
                    };
                    for (const e1 of Object.keys(ho))void 0 === r[e1] && (r[e1] = ho[e1].default);
                    const o = new e1.ae(uo, t1, new Map(s));
                    return o.setTransitionOrValue(r, s), o.untransitioned().possiblyEvaluate(new e1.ai(0, {
                        worldview: void 0
                    }));
                })(this.scope, t1, this.options).get("data") : null;
            }
            _loadColorTheme(t1) {
                this._styleColorTheme.lutLoading = !0, this._styleColorTheme.lutLoadingCorrelationID += 1;
                const i = this._styleColorTheme.lutLoadingCorrelationID;
                return new Promise((s, r)=>{
                    const o = "data:image/png;base64,";
                    if (!t1 || 0 === t1.length) return this._styleColorTheme.lut = null, this._styleColorTheme.lutLoading = !1, void s();
                    let n = t1;
                    n.startsWith(o) || (n = o + n);
                    const a = e1.I.from("mapbox-reserved-lut"), l = new Image;
                    l.src = n, l.onerror = ()=>{
                        this._styleColorTheme.lutLoading = !1, r(new Error("Failed to load image data"));
                    }, l.onload = ()=>{
                        if (this._styleColorTheme.lutLoadingCorrelationID !== i) return void s();
                        this._styleColorTheme.lutLoading = !1;
                        const { width: o, height: n, data: c } = e1.e.getImageData(l);
                        if (n > 32) return void r(new Error("The height of the image must be less than or equal to 32 pixels."));
                        if (o !== n * n) return void r(new Error("The width of the image must be equal to the height squared."));
                        this.getImage(a) && this.removeImage(a), this.addImage(a, {
                            data: new e1.b({
                                width: o,
                                height: n
                            }, c),
                            pixelRatio: 1,
                            sdf: !1,
                            usvg: !1,
                            version: 0
                        });
                        const h = this.imageManager.getImage(a, this.scope);
                        h ? (this._styleColorTheme.lut = {
                            image: h.data,
                            data: t1
                        }, s()) : r(new Error("Missing LUT image."));
                    };
                });
            }
            getLut(e1) {
                const t1 = this._styleColorThemeForScope[e1];
                return t1 ? t1.lut : null;
            }
            setProjection(e1) {
                e1 ? this.stylesheet.projection = e1 : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
            }
            applyProjectionUpdate() {
                this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? this.hasTerrain() || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null, 0));
            }
            _updateMapProjection() {
                this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
            }
            _loadSprite(t1) {
                const i = new AbortController;
                this._spriteRequest = i, function(t1, i, s, r) {
                    let o, n, a;
                    const l = e1.e.devicePixelRatio > 1 ? "@2x" : "";
                    function c(t1) {
                        a || t1 && s.aborted || (t1 && (a = t1), function() {
                            if (a) r(a);
                            else if (o && n) {
                                const t1 = e1.e.getImageData(n), i = {};
                                for(const s in o){
                                    const { width: r, height: n, x: a, y: l, sdf: c, pixelRatio: h, stretchX: d, stretchY: u, content: p } = o[s], f = new e1.b({
                                        width: r,
                                        height: n
                                    });
                                    e1.b.copy(t1, f, {
                                        x: a,
                                        y: l
                                    }, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        width: r,
                                        height: n
                                    }, null), i[s] = {
                                        data: f,
                                        pixelRatio: void 0 !== h ? h : 1,
                                        sdf: void 0 !== c && c,
                                        stretchX: d,
                                        stretchY: u,
                                        content: p,
                                        usvg: !1,
                                        version: 0
                                    };
                                }
                                r(null, i);
                            }
                        }());
                    }
                    (async function() {
                        const r = await i.transformRequest(i.normalizeSpriteURL(t1, l, ".json"), e1.R.SpriteJSON, s), { data: n } = await e1.g(r, s);
                        a || (o = n);
                    })().then(()=>c(void 0), (e1)=>c(e1)), (async function() {
                        const r = await i.transformRequest(i.normalizeSpriteURL(t1, l, ".png"), e1.R.SpriteImage, s), { data: o } = await e1.a(r, s);
                        a || (n = o);
                    })().then(()=>c(void 0), (e1)=>c(e1));
                }(t1, this.map._requestManager, i.signal, (t1, i)=>{
                    if (this._spriteRequest = null, t1) this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope
                    }), this.fire(new e1.f(t1));
                    else if (i) {
                        const t1 = new Map;
                        for(const s in i)t1.set(e1.I.from(s), i[s]);
                        this.addImages(t1, !0);
                    }
                    this.imageManager.setLoaded(!0, this.scope), this.fire(new e1.h("data", {
                        dataType: "style"
                    }));
                });
            }
            addIconset(t1, i) {
                if ("sprite" === i.type) return void this._loadSprite(i.url);
                const s = this.getOwnSourceCache(i.source);
                if (!s) return void this.fire(new e1.f(new Error(`Source "${i.source}" as specified by iconset "${t1}" does not exist and cannot be used as an iconset source`)));
                if ("raster-array" !== s.getSource().type) return void this.fire(new e1.f(new Error(`Source "${i.source}" as specified by iconset "${t1}" is not a "raster-array" source and cannot be used as an iconset source`)));
                const r = new mo(t1, this.scope, s);
                this.imageManager.addImageProvider(r, this.scope);
            }
            removeIconset(e1) {
                this.imageManager.removeImageProvider(e1, this.scope);
            }
            _loadIconset(t1) {
                if (!e1.cg(t1) && "icon_set" !== this.map._spriteFormat || "raster" === this.map._spriteFormat) return void this._loadSprite(t1);
                const i = "auto" === this.map._spriteFormat, s = new AbortController;
                this._spriteRequest = s, async function(t1, i, s, r) {
                    try {
                        const o = await i.transformRequest(i.normalizeIconsetURL(t1), e1.R.Iconset, s), { data: n } = await e1.cC(o, s), a = {}, l = function(e1) {
                            const t1 = {
                                icons: []
                            };
                            let i;
                            for(; i = e1.nextField(void 0);)1 === i && t1.icons.push(C(e1, e1.readVarint() + e1.pos));
                            return t1;
                        }(new e1.cB(n));
                        for (const t1 of l.icons){
                            const i = {
                                version: 1,
                                pixelRatio: e1.e.devicePixelRatio,
                                content: po(t1),
                                stretchX: t1.metadata ? fo(t1.metadata.stretch_x_areas) : void 0,
                                stretchY: t1.metadata ? fo(t1.metadata.stretch_y_areas) : void 0,
                                sdf: !1,
                                usvg: !0,
                                icon: t1
                            };
                            a[t1.name] = i;
                        }
                        r(null, a);
                    } catch (e1) {
                        s.aborted || r(e1);
                    }
                }(t1, this.map._requestManager, s.signal, (s, r)=>{
                    if (this._spriteRequest = null, s) i ? this._loadSprite(t1) : (this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope
                    }), this.fire(new e1.f(s)));
                    else if (r) {
                        const t1 = new Map;
                        for(const i in r)t1.set(e1.I.from(i), r[i]);
                        this.addImages(t1, !0);
                    }
                    this.imageManager.setLoaded(!0, this.scope), this.fire(new e1.h("data", {
                        dataType: "style"
                    }));
                });
            }
            _validateLayer(t1) {
                const i = this.getOwnSource(t1.source);
                if (!i) return;
                const s = t1.sourceLayer;
                s && ("geojson" === i.type || i.vectorLayerIds && !i.vectorLayerIds.includes(s)) && this.fire(new e1.f(new Error(`Source layer "${s}" does not exist on source "${i.id}" as specified by style layer "${t1.id}"`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._changes.getUpdatedSourceCaches()).length) return !1;
                for(const e1 in this._sourceCaches)if (!this._sourceCaches[e1].loaded()) return !1;
                if (!this.imageManager.isLoaded()) return !1;
                if (this.imageManager.hasPatternsInFlight()) return !1;
                if (!this.modelManager.isLoaded()) return !1;
                if (this._styleColorTheme.lutLoading) return !1;
                for (const { style: e1 } of this.fragments)if (!e1.loaded()) return !1;
                return !0;
            }
            _serializeImports() {
                if (this.stylesheet.imports) return this.stylesheet.imports.map((e1, t1)=>{
                    const i = this.fragments[t1];
                    return i && i.style && (e1.data = i.style.serialize()), e1;
                });
            }
            _serializeSources() {
                const e1 = {};
                for(const t1 in this._sourceCaches){
                    const i = this._sourceCaches[t1].getSource();
                    e1[i.id] || (e1[i.id] = i.serialize());
                }
                return e1;
            }
            _serializeLayers(e1) {
                const t1 = [];
                for (const i of e1){
                    const e1 = this._layers[i];
                    e1 && "custom" !== e1.type && t1.push(e1.serialize());
                }
                return t1;
            }
            hasLightTransitions() {
                return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
            }
            hasFogTransition() {
                return !!this.fog && this.fog.hasTransition();
            }
            hasSnowTransition() {
                return !!this.snow && this.snow.hasTransition();
            }
            hasRainTransition() {
                return !!this.rain && this.rain.hasTransition();
            }
            hasTransitions() {
                if (this.hasLightTransitions()) return !0;
                if (this.hasFogTransition()) return !0;
                if (this.hasSnowTransition()) return !0;
                if (this.hasRainTransition()) return !0;
                for(const e1 in this._sourceCaches)if (this._sourceCaches[e1].hasTransition()) return !0;
                for(const e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
                return !1;
            }
            _updateDataDrivenEmissiveStrength() {
                for(const e1 in this._mergedLayers){
                    const t1 = this._mergedLayers[e1];
                    if (t1._transitionablePaint && t1._transitionablePaint._values) {
                        const e1 = t1._transitionablePaint._values["line-emissive-strength"];
                        if (e1 && e1.value && e1.value.isDataDriven()) return void (this._hasDataDrivenEmissive = !0);
                    }
                }
                this._hasDataDrivenEmissive = !1;
            }
            hasDataDrivenEmissiveStrength() {
                return this._hasDataDrivenEmissive;
            }
            get order() {
                return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
            }
            _getOrder(e1) {
                return e1 ? this.order : this._mergedOrder;
            }
            isLayerDraped(e1) {
                return !!this.terrain && e1.isDraped(this.getLayerSourceCache(e1));
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }
            _checkLayer(t1) {
                const i = this.getOwnLayer(t1);
                if (i) return i;
                this.fire(new e1.f(new Error(`The layer '${t1}' does not exist in the map's style.`)));
            }
            _checkSource(t1) {
                const i = this.getOwnSource(t1);
                if (i) return i;
                this.fire(new e1.f(new Error(`The source '${t1}' does not exist in the map's style.`)));
            }
            handleIdle() {
                const e1 = this.map.painter;
                e1 && (e1.context.sweepPendingPrograms(), this._programPrecompiler && this._programPrecompiler.processQueue(e1, this));
            }
            handleContextLost() {
                this._programPrecompiler && this._programPrecompiler.reset();
            }
            update(t1) {
                if (!this._loaded) return;
                this.ambientLight && this.ambientLight.recalculate(t1), this.directionalLight && this.directionalLight.recalculate(t1);
                const i = this.calculateLightsBrightness();
                t1.brightness = i || 0;
                let s = !1;
                i !== this._brightness && (this._brightness = i, s = !0), t1.worldview !== this._worldview && (this._worldview = t1.worldview, s = !0), s && this.dispatcher.broadcast("upsertRenderParams", {
                    brightness: this._brightness,
                    worldview: this._worldview
                });
                const r = this._changes.isDirty();
                let o = !1;
                if (this._changes.isDirty()) {
                    const e1 = this._changes.getLayerUpdatesByScope();
                    for(const t1 in e1){
                        const { updatedIds: i, removedIds: s } = e1[t1];
                        (i || s) && (this._updateWorkerLayers(t1, i, s), o = !0);
                    }
                    this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(t1), this.light && this.light.updateTransitions(t1), this.ambientLight && this.ambientLight.updateTransitions(t1), this.directionalLight && this.directionalLight.updateTransitions(t1), this.fog && this.fog.updateTransitions(t1), this.snow && this.snow.updateTransitions(t1), this.rain && this.rain.updateTransitions(t1), this._changes.reset();
                }
                const n = {};
                for(const e1 in this._mergedSourceCaches){
                    const t1 = this._mergedSourceCaches[e1];
                    n[e1] = t1.used, t1.used = !1, t1.tileCoverLift = 0;
                }
                const a = {};
                for (const i of this._mergedOrder){
                    const s = this._mergedLayers[i];
                    if (("none" !== s.visibility || s.hasTransition()) && s.recalculate(t1, this._availableImages), !s.isHidden(t1.zoom)) {
                        s.mayUse("HD") && (s.prepare(), Ks()), s.mayUse("Standard") && (s.prepare(), hi());
                        const e1 = this.getLayerSourceCache(s);
                        e1 && (e1.used = !0, e1.tileCoverLift = Math.max(e1.tileCoverLift, s.tileCoverLift()));
                    }
                    if (s.source) {
                        const t1 = e1.m(s.source, s.scope), i = this._mergedHdRoadCoverageSourceCaches[t1];
                        i && !i.used && (i.used = !0);
                    }
                    if ("fill-extrusion" === s.type) {
                        const t1 = e1.m(s.source, s.scope);
                        if (t1 in this._mergedFillExtrusionSourceCaches) {
                            const e1 = s.layout && s.layout.get("source-max-zoom");
                            if (null != e1) {
                                const i = a[t1];
                                a[t1] = null == i ? e1 : Math.min(i, e1);
                            }
                        }
                    }
                }
                if (this._programPrecompiler && this._programPrecompiler.needsBuild()) {
                    const e1 = this._mergedOrder.map((e1)=>this._mergedLayers[e1]);
                    this._programPrecompiler.buildQueue(e1, t1, this);
                }
                for(const e1 in this._mergedFillExtrusionSourceCaches)this._mergedFillExtrusionSourceCaches[e1].setMaxzoomOverride(a[e1] ?? null);
                this.terrain && o && this.mergeLayers();
                const l = this.imageManager.getPendingImageProviders();
                for (const e1 of l)e1.sourceCache.used = !0;
                for(const t1 in n){
                    const i = this._mergedSourceCaches[t1];
                    n[t1] !== i.used && i.getSource().fire(new e1.h("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: i.getSource().id
                    }));
                }
                this.light && this.light.recalculate(t1), this.terrain && this.terrain.recalculate(t1), this.fog && this.fog.recalculate(t1), this.snow && this.snow.recalculate(t1), this.rain && this.rain.recalculate(t1), this.z = t1.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), this.imageManager.clearUpdatedImages(this.scope), r && this.fire(new e1.h("data", {
                    dataType: "style"
                }));
            }
            updateImageProviders() {
                const e1 = this.imageManager.getPendingImageProviders();
                for (const t1 of e1){
                    const e1 = t1.resolvePendingRequests(), i = this.getFragmentStyle(t1.scope);
                    i && i.addImages(e1);
                }
            }
            _updateTilesForChangedImages() {
                const e1 = {};
                for(const t1 in this._mergedSourceCaches){
                    const i = this._mergedSourceCaches[t1].getSource().scope;
                    e1[i] = e1[i] || this._changes.getUpdatedImages(i), 0 !== e1[i].length && this._mergedSourceCaches[t1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e1[i]);
                }
                for(const t1 in e1)this._changes.resetUpdatedImages(t1);
            }
            _updateWorkerLayers(e1, t1, i) {
                const s = this.getFragmentStyle(e1);
                s && this.dispatcher.broadcast("updateLayers", {
                    layers: t1 ? s._serializeLayers(t1) : [],
                    scope: e1,
                    removedIds: i || [],
                    options: s.options
                });
            }
            setState(t1, i) {
                if (this._checkLoaded(), _o(this, Ct(t1))) return !1;
                if ((t1 = e1.dd(t1)).layers = Er(t1.layers), !xt.diffStyles) throw new Error("Debug module not loaded; cannot diff style.");
                const s = xt.diffStyles(this.serialize(), t1).filter((e1)=>!vo.has(e1.command));
                if (0 === s.length) return !1;
                const r = s.filter((e1)=>!yo.has(e1.command));
                if (r.length > 0) throw new Error(`Unimplemented: ${r.map((e1)=>e1.command).join(", ")}.`);
                const o = [];
                return s.forEach((e1)=>{
                    o.push(this[e1.command](...e1.args));
                }), i && Promise.all(o).then(i).catch(i), this.stylesheet = t1, this.mergeAll(), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), !0;
            }
            _updateWorkerImages(e1 = !1) {
                this._availableImages = this.imageManager.listImages(this.scope);
                const t1 = {
                    scope: this.scope,
                    images: this._availableImages
                };
                e1 && (t1.isSpriteLoaded = !0), this.dispatcher.broadcast("setImages", t1);
            }
            _updateWorkerModels() {
                this._availableModels = this.modelManager.getModelURIs(this.scope), this.dispatcher.broadcast("setModels", {
                    scope: this.scope,
                    models: this._availableModels
                });
            }
            addImages(t1, i) {
                if (0 === t1.size) return i && this.dispatcher.broadcast("spriteLoaded", {
                    scope: this.scope
                }), this;
                for (const [i, s] of t1.entries()){
                    if (this.getImage(i)) return this.fire(new e1.f(new Error(`An image with the name "${i.name}" already exists.`)));
                    this.imageManager.addImage(i, this.scope, s), this._changes.updateImage(i, this.scope);
                }
                return this._updateWorkerImages(i), this.fire(new e1.h("data", {
                    dataType: "style"
                })), this;
            }
            addImage(t1, i) {
                return this.getImage(t1) ? this.fire(new e1.f(new Error(`An image with the name "${t1.name}" already exists.`))) : (this.imageManager.addImage(t1, this.scope, i), this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e1.h("data", {
                    dataType: "style"
                })), this);
            }
            updateImage(t1, i, s = !1) {
                this.imageManager.updateImage(t1, this.scope, i), s && (this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e1.h("data", {
                    dataType: "style"
                })));
            }
            getImage(e1) {
                return this.imageManager.getImage(e1, this.scope);
            }
            removeImage(t1) {
                return this.getImage(t1) ? (this.imageManager.removeImage(t1, this.scope), this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e1.h("data", {
                    dataType: "style"
                })), this) : this.fire(new e1.f(new Error("No image with this name exists.")));
            }
            listImages() {
                return this._checkLoaded(), this._availableImages.slice();
            }
            getActualScope() {
                return this._importedAsBasemap ? "basemap" : this.scope;
            }
            addModelURLs(t1) {
                return this.modelManager.addModelURLs(t1, this.getActualScope()), this._updateWorkerModels(), this.fire(new e1.h("data", {
                    dataType: "style"
                })), this;
            }
            addModel(t1, i, s = {}) {
                return this._checkLoaded(), this._validate(kt, `models.${t1}`, i, null, s) || (this.modelManager.addModel(t1, i, this.getActualScope()), this.fire(new e1.h("data", {
                    dataType: "style"
                }))), this;
            }
            hasModel(e1) {
                return this.modelManager.hasModel(e1, this.getActualScope());
            }
            removeModel(t1) {
                return this.hasModel(t1) ? (this.modelManager.removeModel(t1, this.getActualScope(), !1, !0), this.fire(new e1.h("data", {
                    dataType: "style"
                })), this) : this.fire(new e1.f(new Error("No model with this ID exists.")));
            }
            listModels() {
                return this._checkLoaded(), this.modelManager.listModels(this.getActualScope());
            }
            addSource(t1, i, s = {}) {
                if (this._checkLoaded(), void 0 !== this.getOwnSource(t1)) throw new Error(`There is already a source with ID "${t1}".`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].includes(i.type) && this._validate(Et, `sources.${t1}`, i, null, s)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const r = Object.hasOwn(fr, i.type) && !cr(i.type), o = r ? new mr(t1, i, this.dispatcher, this) : lr(t1, i, this.dispatcher, this);
                o.scope = this.scope;
                const n = (e1)=>{
                    e1.setEventedParent(this, ()=>({
                            isSourceLoaded: this._isSourceCacheLoaded(e1.id),
                            source: e1.serialize(),
                            sourceId: e1.id
                        }));
                };
                n(o);
                const a = (t1)=>{
                    const i = (t1 === e1.bR.Symbol ? "symbol:" : t1 === e1.bR.FillExtrusion ? "fill-extrusion:" : "other:") + o.id, s = e1.m(i, this.scope), r = this._sourceCaches[i] = new gs(s, o, t1);
                    t1 === e1.bR.Symbol ? this._symbolSourceCaches[o.id] = r : t1 === e1.bR.FillExtrusion ? this._fillExtrusionSourceCaches[o.id] = r : this._otherSourceCaches[o.id] = r, r.onAdd(this.map);
                };
                a(e1.bR.Other), "vector" !== i.type && "geojson" !== i.type || (a(e1.bR.Symbol), "vector" === i.type && a(e1.bR.FillExtrusion)), o.onAdd && o.onAdd(this.map), r && (async function(e1) {
                    if (cr(e1)) return;
                    const t1 = fr[e1];
                    if (!t1) throw new Error(`Unknown source type "${e1}"`);
                    const i = await t1();
                    i && !cr(e1) && function(e1, t1) {
                        ar[e1] = t1;
                    }(e1, i);
                })(i.type).then(()=>{
                    const s = cr(i.type), r = this._otherSourceCaches[t1];
                    if (!r || r.getSource() !== o) return;
                    if (!s) return void this.fire(new e1.f(new Error(`Could not load module for source type "${i.type}".`)));
                    const a = lr(t1, i, this.dispatcher, this);
                    a.scope = this.scope, n(a), r.setSource(a), a.onAdd && a.onAdd(this.map), this._changes.setDirty();
                }), s.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
            }
            removeSource(t1) {
                this._checkLoaded();
                const i = this.getOwnSource(t1);
                if (!i) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === t1) return this.fire(new e1.f(new Error(`Source "${t1}" cannot be removed while layer "${i}" is using it.`)));
                if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === t1) return this.fire(new e1.f(new Error(`Source "${t1}" cannot be removed while terrain is using it.`)));
                if (this.stylesheet.iconsets) {
                    const i = Object.entries(this.stylesheet.iconsets).find(([e1, i])=>"source" === i.type && i.source === t1);
                    if (i) return this.fire(new e1.f(new Error(`Source "${t1}" cannot be removed while iconset "${i[0]}" is using it.`)));
                }
                const s = this.getOwnSourceCaches(t1);
                for (const t1 of s){
                    const i = e1.bV(t1.id);
                    delete this._sourceCaches[i], this._changes.discardSourceCacheUpdate(t1.id), t1.fire(new e1.h("data", {
                        sourceDataType: "metadata",
                        dataType: "source",
                        sourceId: t1.getSource().id
                    })), t1.setEventedParent(null), t1.clearTiles();
                }
                return delete this._otherSourceCaches[t1], delete this._symbolSourceCaches[t1], delete this._fillExtrusionSourceCaches[t1], this._hdCoverage && delete this._hdCoverage.coverageSourceCaches[t1], this._hdElevation && delete this._hdElevation.elevationSourceCaches[e1.m(t1, this.scope)], this.mergeSources(), i.setEventedParent(null), i.onRemove && i.onRemove(this.map), this.dispatcher.broadcast("removeSource", {
                    type: i.type,
                    source: t1,
                    scope: i.scope
                }), this._changes.setDirty(), this;
            }
            setGeoJSONSourceData(e1, t1) {
                this._checkLoaded(), this.getOwnSource(e1).setData(t1), this._changes.setDirty();
            }
            getOwnSource(e1) {
                const t1 = this.getOwnSourceCache(e1);
                return t1 && t1.getSource();
            }
            getOwnSources() {
                const e1 = [];
                for(const t1 in this._otherSourceCaches){
                    const i = this.getOwnSourceCache(t1);
                    i && e1.push(i.getSource());
                }
                return e1;
            }
            areTilesLoaded() {
                const e1 = this._mergedSourceCaches;
                for(const t1 in e1){
                    const i = e1[t1]._tiles;
                    for(const e1 in i){
                        const t1 = i[e1];
                        if ("loaded" !== t1.state && "errored" !== t1.state) return !1;
                    }
                }
                return !0;
            }
            setLights(t1) {
                if (this._checkLoaded(), this._programPrecompiler && this._programPrecompiler.reset(), !t1) return delete this.ambientLight, void delete this.directionalLight;
                const i = this._getTransitionParameters();
                for (const e1 of t1){
                    if (this._validate(Dt, "lights", e1)) return;
                    switch(e1.type){
                        case "ambient":
                            if (this.ambientLight) {
                                const t1 = this.ambientLight;
                                t1.set(e1), t1.updateTransitions(i);
                            } else this.ambientLight = new ti(e1, si(), this.scope, this.options);
                            break;
                        case "directional":
                            if (this.directionalLight) {
                                const t1 = this.directionalLight;
                                t1.set(e1), t1.updateTransitions(i);
                            } else this.directionalLight = new ti(e1, oi(), this.scope, this.options);
                    }
                }
                const s = Object.assign(i, {
                    worldview: this.map.getWorldview()
                }), r = new e1.ai(this.z || 0, s);
                this.ambientLight && this.ambientLight.recalculate(r), this.directionalLight && this.directionalLight.recalculate(r), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("upsertRenderParams", {
                    brightness: this._brightness
                });
            }
            calculateLightsBrightness() {
                const t1 = this.directionalLight, i = this.ambientLight;
                if (!t1 || !i) return;
                const s = (e1)=>.2126 * (e1[0] <= .03928 ? e1[0] / 12.92 : Math.pow((e1[0] + .055) / 1.055, 2.4)) + .7152 * (e1[1] <= .03928 ? e1[1] / 12.92 : Math.pow((e1[1] + .055) / 1.055, 2.4)) + .0722 * (e1[2] <= .03928 ? e1[2] / 12.92 : Math.pow((e1[2] + .055) / 1.055, 2.4)), r = t1.properties.get("color").toNonPremultipliedRenderColor(null).toArray01(), o = t1.properties.get("intensity"), n = t1.properties.get("direction"), a = 1 - e1.de(n.x, n.y, n.z)[2] / 90, l = s(r) * o * a, c = i.properties.get("color").toNonPremultipliedRenderColor(null).toArray01(), h = i.properties.get("intensity"), d = s(c) * h;
                return Number(((l + d) / 2).toFixed(6));
            }
            getBrightness() {
                return this._brightness;
            }
            getLights() {
                if (!this.enable3dLights()) return null;
                const e1 = [];
                return this.directionalLight && e1.push(this.directionalLight.get()), this.ambientLight && e1.push(this.ambientLight.get()), e1;
            }
            enable3dLights() {
                return !!this.ambientLight && !!this.directionalLight;
            }
            getFragmentStyle(t1) {
                if (null == t1 || "" === t1 && this.isRootStyle()) return this;
                if (e1.df(t1)) {
                    const i = e1.dg(t1), s = this.fragments.find(({ id: e1 })=>e1 === i);
                    if (!s) return;
                    const r = e1.bV(t1);
                    return s.style.getFragmentStyle(r);
                }
                {
                    const e1 = this.fragments.find(({ id: e1 })=>e1 === t1);
                    return e1 ? e1.style : void 0;
                }
            }
            setFeaturesetSelectors(t1) {
                if (!t1) return;
                const i = (e1, t1 = "")=>`${e1}::${t1}`;
                this._featuresetSelectors = {};
                for(const s in t1){
                    const r = {}, o = this._featuresetSelectors[s] = [];
                    for (const n of t1[s].selectors){
                        if (n.featureNamespace) {
                            const t1 = this.getOwnLayer(n.layer);
                            if (!t1) {
                                e1.w(`Layer is undefined for selector: ${n.layer}`);
                                continue;
                            }
                            const o = i(t1.source, t1.sourceLayer);
                            if (o in r && r[o] !== n.featureNamespace) {
                                e1.w(`"featureNamespace ${n.featureNamespace} of featureset ${s}'s selector is not associated to the same source, skip this selector`);
                                continue;
                            }
                            r[o] = n.featureNamespace;
                        }
                        let t1;
                        if (n.properties) for(const i in n.properties){
                            const s = e1.c(n.properties[i]);
                            "success" === s.result && (t1 = t1 || {}, t1[i] = s.value);
                        }
                        o.push({
                            layerId: n.layer,
                            namespace: n.featureNamespace,
                            properties: t1,
                            uniqueFeatureID: n._uniqueFeatureID
                        });
                    }
                }
            }
            getFeaturesetDescriptors(e1) {
                const t1 = this.getFragmentStyle(e1);
                if (!t1 || !t1.stylesheet.featuresets) return [];
                const i = [];
                for(const e1 in t1.stylesheet.featuresets)i.push({
                    featuresetId: e1,
                    importId: t1.scope ? t1.scope : void 0
                });
                return i;
            }
            getFeaturesetLayers(t1, i) {
                const s = this.getFragmentStyle(i), r = s.stylesheet.featuresets;
                if (!r || !r[t1]) return this.fire(new e1.f(new Error(`The featureset '${t1}' does not exist in the map's style and cannot be queried.`))), [];
                const o = [];
                for (const e1 of r[t1].selectors){
                    const t1 = s.getOwnLayer(e1.layer);
                    t1 && o.push(t1);
                }
                return o;
            }
            getConfigProperty(t1, i) {
                const s = this.getFragmentStyle(t1);
                if (!s) return null;
                const r = e1.m(i, s.scope), o = s.options.get(r), n = o ? o.value || o.default : null;
                return n ? n.serialize() : null;
            }
            isIndoorEnabled() {
                return this._indoorEnabled;
            }
            getIndoorSourceLayers(t1, i) {
                const s = e1.m(t1, i);
                return this._mergedIndoor[s];
            }
            setIndoorData(e1, t1) {
                this.indoorManager && this.indoorManager.setIndoorData(t1);
            }
            updateIndoorDependentLayers() {
                this._updateLayers(this._dependentLayerIds((e1)=>e1.isIndoorDependent)), this.map._styleDirty = !0, this.map.triggerRepaint();
            }
            setConfigProperty(t1, i, s) {
                const r = this.getFragmentStyle(t1);
                if (!r) return;
                const o = r.stylesheet.schema;
                if (!o || !o[i]) return;
                const n = go(o[i], s);
                if ("success" !== n.result) return void _o(this, n.value);
                const a = n.value.expression, l = e1.m(i, r.scope), c = r.options.get(l);
                if (!c) return;
                let h;
                const { minValue: d, maxValue: u, stepValue: p, type: f, values: m } = o[i], _ = go(o[i], o[i].default);
                "success" === _.result && (h = _.value.expression), h ? (this.options.set(l, {
                    ...c,
                    value: a,
                    default: h,
                    minValue: d,
                    maxValue: u,
                    stepValue: p,
                    type: f,
                    values: m
                }), this.updateConfigDependencies(i)) : this.fire(new e1.f(new Error(`No schema defined for the config option "${i}" in the "${t1}" fragment.`)));
            }
            getConfig(t1) {
                const i = this.getFragmentStyle(t1);
                if (!i) return null;
                const s = i.stylesheet.schema;
                if (!s) return null;
                const r = {};
                for(const t1 in s){
                    const s = e1.m(t1, i.scope), o = i.options.get(s), n = o ? o.value || o.default : null;
                    r[t1] = n ? n.serialize() : null;
                }
                return r;
            }
            setConfig(e1, t1) {
                const i = this.getFragmentStyle(e1);
                i && (i.updateConfig(t1, i.stylesheet.schema), this.updateConfigDependencies());
            }
            getSchema(e1) {
                const t1 = this.getFragmentStyle(e1);
                return t1 ? t1.stylesheet.schema : null;
            }
            setSchema(e1, t1) {
                const i = this.getFragmentStyle(e1);
                i && (i.stylesheet.schema = t1, i.updateConfig(i._config, t1), this.updateConfigDependencies());
            }
            updateConfig(t1, i) {
                if (this._config = t1, t1 || i) {
                    if (i) for(const s in i){
                        let r, o;
                        const n = go(i[s], i[s].default);
                        if ("success" === n.result && (r = n.value.expression), t1 && void 0 !== t1[s]) {
                            const e1 = go(i[s], t1[s]);
                            "success" === e1.result && (o = e1.value.expression);
                        }
                        const { minValue: a, maxValue: l, stepValue: c, type: h, values: d } = i[s];
                        if (r) {
                            const t1 = e1.m(s, this.scope);
                            this.options.set(t1, {
                                default: r,
                                value: o,
                                minValue: a,
                                maxValue: l,
                                stepValue: c,
                                type: h,
                                values: d
                            });
                        } else this.fire(new e1.f(new Error(`No schema defined for config option "${s}".`)));
                    }
                    else this.fire(new e1.f(new Error("Attempting to set config for a style without schema.")));
                }
            }
            _updateLayers(e1) {
                for (const t1 of e1){
                    const e1 = this.getLayer(t1);
                    e1 && (e1.possiblyEvaluateVisibility(), this._updateLayer(e1), this._changes.setDirty());
                }
            }
            _dependentLayerIds(e1) {
                const t1 = [];
                for (const [i, s] of this._layerExpressionDependencies)e1(s) && t1.push(i);
                return t1;
            }
            updateConfigDependencies(e1) {
                this._updateLayers(this._dependentLayerIds((t1)=>e1 ? t1.hasConfigDependency(e1) : t1.isConfigDependent)), this.ambientLight && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.updateConfig(this.options), this.fog && this.fog.updateConfig(this.options), this.snow && this.snow.updateConfig(this.options), this.rain && this.rain.updateConfig(this.options), this.forEachFragmentStyle((e1)=>{
                    const t1 = e1._styleColorTheme.colorThemeOverride ? e1._styleColorTheme.colorThemeOverride : e1._styleColorTheme.colorTheme;
                    if (t1) {
                        const i = e1._evaluateColorThemeData(t1);
                        (!e1._styleColorTheme.lut && "" !== i || e1._styleColorTheme.lut && i !== e1._styleColorTheme.lut.data) && e1.setColorTheme(t1);
                    }
                }), this._updateIndoorEnabled(), this._changes.setDirty();
            }
            addLayer(t1, i, s = {}) {
                this._checkLoaded();
                const r = t1.id;
                if (this._layers[r]) return void this.fire(new e1.f(new Error(`Layer with id "${r}" already exists on this map`)));
                let o;
                if ("custom" === t1.type) {
                    if (_o(this, e1.dh(t1))) return;
                    o = e1.di(t1, this.scope, this._styleColorTheme.lut, this.options);
                } else {
                    if ("object" == typeof t1.source && (this.addSource(r, t1.source), t1 = e1.dd(t1), t1 = Object.assign(t1, {
                        source: r
                    })), this._validate(Mt, `layers.${r}`, t1, {
                        arrayIndex: -1
                    }, s)) return;
                    o = e1.di(t1, this.scope, this._styleColorTheme.lut, this.options), this._validateLayer(o), o.setEventedParent(this, {
                        layer: {
                            id: r
                        }
                    });
                }
                this._layerExpressionDependencies.set(o.fqid, new x(o));
                let n = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e1.f(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    o.slot && o.slot !== this._layers[i].slot ? e1.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`) : n = t1;
                }
                this._order.splice(n, 0, r), this._handleLayerOrderChange(), this._layers[r] = o;
                const a = this.getOwnLayerSourceCache(o), l = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                a && o.canCastShadows() && l && (a.castsShadows = !0);
                const c = this._changes.getRemovedLayer(o);
                if (c && o.source && a && "custom" !== o.type) {
                    this._changes.discardLayerRemoval(o);
                    const t1 = e1.m(o.source, o.scope);
                    c.type !== o.type ? this._changes.updateSourceCache(t1, "clear") : (this._changes.updateSourceCache(t1, "reload"), a.pause());
                }
                this._updateLayer(o), o.onAdd && o.onAdd(this.map), o.scope = this.scope, this.mergeLayers();
            }
            moveLayer(t1, i) {
                this._checkLoaded();
                const s = this._checkLayer(t1);
                if (!s) return;
                if (t1 === i) return;
                const r = this._order.indexOf(t1);
                this._order.splice(r, 1);
                let o = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e1.f(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    s.slot && s.slot !== this._layers[i].slot ? e1.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`) : o = t1;
                }
                this._order.splice(o, 0, t1), this._changes.setDirty(), this._handleLayerOrderChange(), this.mergeLayers();
            }
            removeLayer(e1) {
                this._checkLoaded();
                const t1 = this._checkLayer(e1);
                if (!t1) return;
                t1.setEventedParent(null);
                const i = this._order.indexOf(e1);
                this._order.splice(i, 1), delete this._layers[e1], this._changes.setDirty(), this._handleLayerOrderChange(), this._layerExpressionDependencies.delete(t1.fqid), this._changes.removeLayer(t1);
                const s = this.getOwnLayerSourceCache(t1);
                if (s && s.castsShadows) {
                    let e1 = !1;
                    for(const i in this._layers)if (this._layers[i].source === t1.source && this._layers[i].canCastShadows()) {
                        e1 = !0;
                        break;
                    }
                    s.castsShadows = e1;
                }
                t1.onRemove && t1.onRemove(this.map), this.mergeLayers();
            }
            getOwnLayer(e1) {
                return this._layers[e1];
            }
            hasLayer(e1) {
                return e1 in this._mergedLayers;
            }
            hasLayerType(e1) {
                for(const t1 in this._layers)if (this._layers[t1].type === e1) return !0;
                return !1;
            }
            setLayerZoomRange(e1, t1, i) {
                this._checkLoaded();
                const s = this._checkLayer(e1);
                s && (s.minzoom === t1 && s.maxzoom === i || (null != t1 && (s.minzoom = t1), null != i && (s.maxzoom = i), this._updateLayer(s)));
            }
            getSlots() {
                return this._checkLoaded(), this._mergedSlots;
            }
            setSlot(e1, t1) {
                this._checkLoaded();
                const i = this._checkLayer(e1);
                i && i.slot !== t1 && (i.slot = t1, this._updateLayer(i));
            }
            setFilter(t1, i, s = {}) {
                this._checkLoaded();
                const r = this._checkLayer(t1);
                if (!r) return;
                if (e1.O(r.filter, i)) return;
                const o = this._layerExpressionDependencies.get(r.fqid);
                if (null == i) return r.filter = void 0, o && o.invalidateFilter(), void this._updateLayer(r);
                this._validate(Ft, `layers.${r.id}.filter`, i, {
                    layerType: r.type
                }, s) || (r.filter = e1.dd(i), o && o.invalidateFilter(), this._updateLayer(r));
            }
            getFilter(t1) {
                const i = this._checkLayer(t1);
                if (i) return e1.dd(i.filter);
            }
            setLayoutProperty(t1, i, s, r = {}) {
                this._checkLoaded();
                const o = this._checkLayer(t1);
                if (o && !e1.O(o.getLayoutProperty(i), s)) {
                    if (null != s && (!r || !1 !== r.validate) && _o(o, Bt.call(Ct, {
                        key: `layers.${t1}.layout.${i}`,
                        layerType: o.type,
                        objectKey: i,
                        value: s,
                        styleSpec: e1.s,
                        style: {
                            glyphs: !0,
                            sprite: !0
                        }
                    }))) return;
                    o.setLayoutProperty(i, s), this._updateLayer(o);
                }
            }
            getLayerProperty(e1, t1) {
                const i = this._checkLayer(e1);
                if (i) {
                    switch(t1){
                        case "minzoom":
                            return i.minzoom;
                        case "maxzoom":
                            return i.maxzoom;
                        case "filter":
                            return this.getFilter(e1);
                        case "slot":
                            return i.slot;
                        case "appearances":
                            return i.getAppearances().map((e1)=>e1.serialize());
                    }
                    return i.isPaintProperty(t1) ? this.getPaintProperty(e1, t1) : this.getLayoutProperty(e1, t1);
                }
            }
            setLayerProperty(e1, t1, i, s = {}) {
                this._checkLoaded();
                const r = this._checkLayer(e1);
                if (r) {
                    switch(t1){
                        case "appearances":
                            return r.setAppearances(i), void this._updateLayer(r);
                        case "minzoom":
                            return this.setLayerZoomRange(e1, i);
                        case "maxzoom":
                            return this.setLayerZoomRange(e1, null, i);
                        case "filter":
                            return this.setFilter(e1, i, s);
                        case "slot":
                            return this.setSlot(e1, i);
                    }
                    r.isPaintProperty(t1) ? this.setPaintProperty(e1, t1, i, s) : this.setLayoutProperty(e1, t1, i, s);
                }
            }
            getLayoutProperty(e1, t1) {
                const i = this._checkLayer(e1);
                if (i) return i.getLayoutProperty(t1);
            }
            setPaintProperty(t1, i, s, r = {}) {
                this._checkLoaded();
                const o = this._checkLayer(t1);
                o && (e1.O(o.getPaintProperty(i), s) || (null == s || r && !1 === r.validate || !_o(o, Ot.call(Ct, {
                    key: `layers.${t1}.paint.${i}`,
                    layerType: o.type,
                    objectKey: i,
                    value: s,
                    styleSpec: e1.s
                }))) && (o.setPaintProperty(i, s) && this._updateLayer(o), this._changes.updatePaintProperties(o)));
            }
            getPaintProperty(e1, t1) {
                const i = this._checkLayer(e1);
                if (i) return i.getPaintProperty(t1);
            }
            setFeatureState(t1, i) {
                if (this._checkLoaded(), "target" in t1) {
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: e1, importId: s } = t1.target, r = this.getFragmentStyle(s), o = r.getFeaturesetLayers(e1);
                        for (const { source: e1, sourceLayer: s } of o)r.setFeatureState({
                            id: t1.id,
                            source: e1,
                            sourceLayer: s
                        }, i);
                    } else if ("layerId" in t1.target) {
                        const { layerId: e1 } = t1.target, s = this.getLayer(e1);
                        if (!s) return;
                        const r = this.getFragmentStyle(s.scope);
                        if (!r) return;
                        r.setFeatureState({
                            id: t1.id,
                            source: s.source,
                            sourceLayer: s.sourceLayer
                        }, i);
                    }
                    return;
                }
                const s = t1.source, r = t1.sourceLayer, o = this._checkSource(s);
                if (!o) return;
                const n = o.type;
                if ("geojson" === n && r) return void this.fire(new e1.f(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
                if ("vector" === n && !r) return void this.fire(new e1.f(new Error("The sourceLayer parameter must be provided for vector source types.")));
                void 0 === t1.id && this.fire(new e1.f(new Error("The feature id parameter must be provided.")));
                const a = this.getOwnSourceCaches(s);
                for (const e1 of a)e1.setFeatureState(r, t1.id, i);
            }
            removeFeatureState(t1, i) {
                if (this._checkLoaded(), "target" in t1) {
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: e1, importId: s } = t1.target, r = this.getFragmentStyle(s), o = r.getFeaturesetLayers(e1);
                        for (const { source: e1, sourceLayer: s } of o)r.removeFeatureState({
                            id: t1.id,
                            source: e1,
                            sourceLayer: s
                        }, i);
                    } else if ("layerId" in t1.target) {
                        const { layerId: e1 } = t1.target, s = this.getLayer(e1);
                        if (!s) return;
                        const r = this.getFragmentStyle(s.scope);
                        if (!r) return;
                        r.removeFeatureState({
                            id: t1.id,
                            source: s.source,
                            sourceLayer: s.sourceLayer
                        }, i);
                    }
                    return;
                }
                const s = t1.source, r = this._checkSource(s);
                if (!r) return;
                const o = r.type, n = "vector" === o ? t1.sourceLayer : void 0;
                if ("vector" === o && !n) return void this.fire(new e1.f(new Error("The sourceLayer parameter must be provided for vector source types.")));
                if (i && "string" != typeof t1.id && "number" != typeof t1.id) return void this.fire(new e1.f(new Error("A feature id is required to remove its specific state property.")));
                const a = this.getOwnSourceCaches(s);
                for (const e1 of a)e1.removeFeatureState(n, t1.id, i);
            }
            getFeatureState(t1) {
                if (this._checkLoaded(), "target" in t1) {
                    let i;
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: s, importId: r } = t1.target, o = this.getFragmentStyle(r), n = o.getFeaturesetLayers(s);
                        for (const { source: s, sourceLayer: r } of n){
                            const n = o.getFeatureState({
                                id: t1.id,
                                source: s,
                                sourceLayer: r
                            });
                            if (n && !i) i = n;
                            else if (!e1.O(i, n)) return void this.fire(new e1.f(new Error("The same feature id exists in multiple sources in the featureset, but their feature states are not consistent through the sources.")));
                        }
                    } else if ("layerId" in t1.target) {
                        const { layerId: e1 } = t1.target, s = this.getLayer(e1);
                        if (!s) return;
                        const r = this.getFragmentStyle(s.scope);
                        if (!r) return;
                        i = r.getFeatureState({
                            id: t1.id,
                            source: s.source,
                            sourceLayer: s.sourceLayer
                        });
                    }
                    return i;
                }
                const i = t1.source, s = t1.sourceLayer, r = this._checkSource(i);
                if (r) {
                    if ("vector" !== r.type || s) return void 0 === t1.id && this.fire(new e1.f(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(i)[0].getFeatureState(s, t1.id);
                    this.fire(new e1.f(new Error("The sourceLayer parameter must be provided for vector source types.")));
                }
            }
            resetFeatureStates(t1) {
                if (this._checkLoaded(), "featuresetId" in t1) {
                    const { featuresetId: e1, importId: i } = t1, s = this.getFragmentStyle(i);
                    if (!s) return;
                    const r = s.getFeaturesetLayers(e1);
                    for (const { source: e1, sourceLayer: t1 } of r)s.removeFeatureState({
                        source: e1,
                        sourceLayer: t1
                    });
                } else {
                    const { layerId: i } = t1, s = this.getLayer(i);
                    if (!s) return void this.fire(new e1.f(new Error(`The layer '${i}' does not exist in the map's style and cannot be used to reset feature states.`)));
                    this.removeFeatureState({
                        source: s.source,
                        sourceLayer: s.sourceLayer
                    });
                }
            }
            setTransition(e1) {
                return this.stylesheet.transition = {
                    ...this.stylesheet.transition,
                    ...e1
                }, this.transition = this.stylesheet.transition, this;
            }
            getTransition() {
                return {
                    ...this.stylesheet.transition
                };
            }
            setWorldview(e1) {
                e1 !== this._worldview && (this._worldview = e1, this.dispatcher.broadcast("upsertRenderParams", {
                    worldview: this._worldview
                }), this.reloadSources());
            }
            serialize() {
                this._checkLoaded();
                const t1 = this.getTerrain(), i = t1 && this.terrain && this.terrain.scope === this.scope ? t1 : this.stylesheet.terrain;
                return e1.dj({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    fragment: this.stylesheet.fragment,
                    iconsets: this.stylesheet.iconsets,
                    featuresets: this.stylesheet.featuresets,
                    imports: this._serializeImports(),
                    schema: this.stylesheet.schema,
                    camera: this.stylesheet.camera,
                    light: this.stylesheet.light,
                    lights: this.stylesheet.lights,
                    terrain: i,
                    fog: this.stylesheet.fog,
                    snow: this.stylesheet.snow,
                    rain: this.stylesheet.rain,
                    indoor: this.stylesheet.indoor,
                    center: this.stylesheet.center,
                    "color-theme": this.stylesheet["color-theme"],
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    projection: this.stylesheet.projection,
                    sources: this._serializeSources(),
                    layers: this._serializeLayers(this._order)
                }, (e1)=>void 0 !== e1);
            }
            _updateFilteredLayers(e1) {
                for (const t1 of Object.values(this._mergedLayers))e1(t1) && this._updateLayer(t1);
            }
            _updateLayer(t1) {
                this._changes.updateLayer(t1);
                const i = this.getLayerSourceCache(t1), s = e1.m(t1.source, t1.scope), r = this._changes.getUpdatedSourceCaches();
                t1.source && !r[s] && i && "raster" !== i.getSource().type && (this._changes.updateSourceCache(s, "reload"), i.pause()), t1.invalidateCompiledFilter();
            }
            _flattenAndSortRenderedFeatures(e1) {
                const t1 = (e1)=>this._mergedLayers[e1].is3D(!!this.terrain), i = this.order, s = {}, r = [];
                for(let o = i.length - 1; o >= 0; o--){
                    const n = i[o];
                    if (t1(n)) {
                        s[n] = o;
                        for (const t1 of e1){
                            const e1 = t1[n];
                            if (e1) for (const t1 of e1)r.push(t1);
                        }
                    }
                }
                r.sort((e1, t1)=>t1.intersectionZ - e1.intersectionZ);
                const o = [];
                for(let n = i.length - 1; n >= 0; n--){
                    const a = i[n];
                    if (t1(a)) for(let e1 = r.length - 1; e1 >= 0; e1--){
                        const t1 = r[e1].feature;
                        if (t1.layer && s[t1.layer.id] < n) break;
                        o.push(t1), r.pop();
                    }
                    else for (const t1 of e1){
                        const e1 = t1[a];
                        if (e1) for (const t1 of e1)o.push(t1.feature);
                    }
                }
                return o;
            }
            queryRasterValue(t1, i, s) {
                const r = this.getOwnSource(t1);
                return r ? "raster-array" !== r.type ? (this.fire(new e1.f(new Error('queryRasterValue support only "raster-array" sources.'))), Promise.resolve(null)) : r.queryRasterArrayValue(i, s) : (this.fire(new e1.f(new Error(`Source with id "${t1}" does not exist in the style.`))), Promise.resolve(null));
            }
            queryRenderedFeatures(t1, i, s) {
                let r;
                i && !Array.isArray(i) && i.filter && (this._validate(Ft, "queryRenderedFeatures.filter", i.filter, null, i), r = e1.bv(i.filter));
                const o = {}, n = (e1)=>{
                    if (bo.has(e1.type)) return;
                    const t1 = this.getOwnLayerSourceCache(e1), i = o[t1.id] = o[t1.id] || {
                        sourceCache: t1,
                        layers: {},
                        has3DLayers: !1
                    };
                    e1.is3D(!!this.terrain) && (i.has3DLayers = !0), i.layers[e1.fqid] = i.layers[e1.fqid] || {
                        styleLayer: e1,
                        targets: []
                    }, i.layers[e1.fqid].targets.push({
                        filter: r
                    });
                };
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new e1.f(new Error("parameters.layers must be an Array."))), [];
                    for (const t1 of i.layers){
                        const i = this._layers[t1];
                        if (!i) return this.fire(new e1.f(new Error(`The layer '${t1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        n(i);
                    }
                } else for(const e1 in this._layers)n(this._layers[e1]);
                const a = this._queryRenderedFeatures(t1, o, s), l = this._flattenAndSortRenderedFeatures(a), c = [];
                for (const t1 of l)e1.bW(t1.layer.id) === this.scope && c.push(t1);
                return c;
            }
            queryRenderedFeatureset(t1, i, s) {
                let r;
                i && !Array.isArray(i) && i.filter && (this._validate(Ft, "queryRenderedFeatures.filter", i.filter, null, i), r = e1.bv(i.filter));
                const o = "mock", n = [];
                if (i && i.target) n.push({
                    ...i,
                    targetId: o,
                    filter: r
                });
                else {
                    const e1 = this.getFeaturesetDescriptors();
                    for (const t1 of e1)n.push({
                        targetId: o,
                        filter: r,
                        target: t1
                    });
                    for (const { style: e1 } of this.fragments){
                        const t1 = e1.getFeaturesetDescriptors();
                        for (const e1 of t1)n.push({
                            targetId: o,
                            filter: r,
                            target: e1
                        });
                    }
                }
                const a = this.queryRenderedTargets(t1, n, s), l = [], c = new Set;
                for (const t1 of a)for (const i of t1.variants[o])gr(i, t1, c) || l.push(new e1.dk(t1, i));
                return l;
            }
            queryRenderedTargets(t1, i, s) {
                const r = {}, o = (e1, t1, i, s)=>{
                    const o = r[t1.id] = r[t1.id] || {
                        sourceCache: t1,
                        layers: {},
                        has3DLayers: !1
                    };
                    if (o.layers[e1.fqid] = o.layers[e1.fqid] || {
                        styleLayer: e1,
                        targets: []
                    }, e1.is3D(!!this.terrain) && (o.has3DLayers = !0), !s) return i.uniqueFeatureID = !1, void o.layers[e1.fqid].targets.push(i);
                    o.layers[e1.fqid].targets.push({
                        ...i,
                        namespace: s.namespace,
                        properties: s.properties,
                        uniqueFeatureID: s.uniqueFeatureID
                    });
                };
                for (const t1 of i)if ("featuresetId" in t1.target) {
                    const { featuresetId: i, importId: s } = t1.target, r = this.getFragmentStyle(s);
                    if (!r || !r._featuresetSelectors) continue;
                    const n = r._featuresetSelectors[i];
                    if (!n) {
                        this.fire(new e1.f(new Error(`The featureset '${i}' does not exist in the map's style and cannot be queried for features.`)));
                        continue;
                    }
                    for (const e1 of n){
                        const i = r.getOwnLayer(e1.layerId);
                        i && !bo.has(i.type) && o(i, r.getOwnLayerSourceCache(i), t1, e1);
                    }
                } else if ("layerId" in t1.target) {
                    const { layerId: e1 } = t1.target, i = this.getLayer(e1);
                    if (!i || bo.has(i.type)) continue;
                    o(i, this.getLayerSourceCache(i), t1);
                }
                const n = this._queryRenderedFeatures(t1, r, s);
                return this._flattenAndSortRenderedFeatures(n);
            }
            _queryRenderedFeatures(t1, i, s) {
                const r = [], o = !!this.map._showQueryGeometry, n = Ys.createFromScreenPoints(t1, s);
                for(const e1 in i){
                    const t1 = yr(n, i[e1], this._availableImages, s, o, this.getActualScope());
                    Object.keys(t1).length && r.push(t1);
                }
                if (this.placement) for(const t1 in i){
                    if (i[t1].sourceCache._renderSourceType !== e1.bR.Symbol) continue;
                    const s = vr(n.screenGeometry, i[t1], this._availableImages, this.placement.collisionIndex, this.placement.retainedQueryData, this.map.getWorldview());
                    Object.keys(s).length && r.push(s);
                }
                return r;
            }
            querySourceFeatures(e1, t1) {
                const i = t1 && t1.filter;
                i && this._validate(Ft, "querySourceFeatures.filter", i, null, t1);
                let s = [];
                const r = this.getOwnSourceCaches(e1);
                for (const e1 of r)s = s.concat(br(e1, t1));
                return s;
            }
            getFlatLight() {
                return this.light.getLight();
            }
            setFlatLight(t1, i, s = {}) {
                this._checkLoaded();
                const r = this.light.getLight();
                let o = !1;
                for(const i in t1)if (!e1.O(t1[i], r[i])) {
                    o = !0;
                    break;
                }
                if (!o) return;
                const n = this._getTransitionParameters();
                this.light.setLight(t1, i, s), this.light.updateTransitions(n);
            }
            hasTerrain() {
                return !!this.terrain && 1 === this.terrain.drapeRenderMode;
            }
            getTerrain() {
                return this.hasTerrain() ? this.terrain.get() : null;
            }
            setTerrainForDraping() {
                this.setTerrain({
                    source: "",
                    exaggeration: 0
                }, 0);
            }
            checkCanvasFingerprintNoise() {
                void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = e1.e.hasCanvasFingerprintNoise(), this.disableElevatedTerrain && e1.w("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode)."));
            }
            setTerrain(t1, i = 1) {
                if (this._checkLoaded(), !t1) return this.terrainSetForDrapingOnly() || (delete this.terrain, this.map.transform.projection.requiresDraping && this.setTerrainForDraping()), 0 === i && delete this.terrain, null === t1 ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
                this.checkCanvasFingerprintNoise();
                let s = t1;
                const r = !("source" in t1) || null == t1.source;
                if (1 === i) {
                    if (this.disableElevatedTerrain) return;
                    if ("source" in s && "object" == typeof s.source) {
                        const t1 = "terrain-dem-src";
                        this.addSource(t1, s.source), s = e1.dd(s), s = Object.assign(s, {
                            source: t1
                        });
                    }
                    const t1 = {
                        ...s
                    }, i = {};
                    if (this.terrain && r) {
                        t1.source = this.terrain.get().source;
                        const e1 = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
                        e1 && (i.style = e1.serialize());
                    }
                    if (this._validate(Pt, "terrain", t1, i)) return;
                }
                if (!this.terrain || this.terrain.scope !== this.scope && !r || this.terrain && i !== this.terrain.drapeRenderMode) {
                    if (!s) return;
                    this._createTerrain(s, i), this.fire(new e1.h("data", {
                        dataType: "style"
                    }));
                } else {
                    const i = this.terrain, r = i.get();
                    for (const t1 of Object.keys(e1.s.terrain))!Object.hasOwn(s, t1) && e1.s.terrain[t1].default && (s[t1] = e1.s.terrain[t1].default);
                    for(const s in t1)if (!e1.O(t1[s], r[s])) {
                        i.set(t1, this.options), this.stylesheet.terrain = t1;
                        const s = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(s), this.fire(new e1.h("data", {
                            dataType: "style"
                        }));
                        break;
                    }
                }
                this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
            }
            _createFog(e1) {
                const t1 = this.fog = new Zt(e1, this.map.transform, this.scope, this.options);
                this.stylesheet.fog = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _createSnow(e1) {
                const t1 = this.snow = new Wt(e1, this.map.transform, this.scope, this.options);
                this.stylesheet.snow = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _createRain(e1) {
                const t1 = this.rain = new Xt(e1, this.map.transform, this.scope, this.options);
                this.stylesheet.rain = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _updateMarkersOpacity() {
                0 !== this.map._markers.length && this.map._requestDomTask(()=>{
                    for (const e1 of this.map._markers)e1._evaluateOpacity();
                });
            }
            getFog() {
                return this.fog ? this.fog.get() : null;
            }
            setFog(t1) {
                if (this._checkLoaded(), t1) {
                    if (this.fog) {
                        const i = this.fog;
                        if (!e1.O(i.get(), t1)) {
                            i.set(t1, this.options), this.stylesheet.fog = i.get();
                            const e1 = this._getTransitionParameters({
                                duration: 0
                            });
                            i.updateTransitions(e1);
                        }
                    } else this._createFog(t1);
                } else delete this.fog, delete this.stylesheet.fog;
                this._markersNeedUpdate = !0, this._programPrecompiler && this._programPrecompiler.reset();
            }
            getSnow() {
                return this.snow ? this.snow.get() : null;
            }
            setSnow(t1) {
                if (this._checkLoaded(), !t1) return delete this.snow, void delete this.stylesheet.snow;
                if (this.snow) {
                    const i = this.snow;
                    if (!e1.O(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.snow = i.get();
                        const e1 = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e1);
                    }
                } else this._createSnow(t1);
                this._markersNeedUpdate = !0;
            }
            getRain() {
                return this.rain ? this.rain.get() : null;
            }
            setRain(t1) {
                if (this._checkLoaded(), !t1) return delete this.rain, void delete this.stylesheet.rain;
                if (this.rain) {
                    const i = this.rain;
                    if (!e1.O(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.rain = i.get();
                        const e1 = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e1);
                    }
                } else this._createRain(t1);
                this._markersNeedUpdate = !0;
            }
            _reloadColorTheme() {
                const t1 = ()=>{
                    for(const e1 in this._layers)this._layers[e1].lut = this._styleColorTheme.lut;
                    for(const e1 in this._sourceCaches)this._sourceCaches[e1].clearTiles();
                }, i = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
                if (!i) return this._styleColorTheme.lut = null, void t1();
                const s = this._evaluateColorThemeData(i);
                this._loadColorTheme(s).then(()=>{
                    this.fire(new e1.h("colorthemeset")), t1();
                }).catch((t1)=>{
                    e1.w(`Couldn't set color theme: ${t1}`);
                });
            }
            setColorTheme(t1) {
                this._checkLoaded(), this._styleColorTheme.colorThemeOverride && e1.w("Note: setColorTheme is called on a style with a color-theme override, the passed color-theme won't be visible."), this._styleColorTheme.colorTheme = t1, this._reloadColorTheme();
            }
            setImportColorTheme(e1, t1) {
                const i = this.getFragmentStyle(e1);
                i && (i._styleColorTheme.colorThemeOverride = t1, i._reloadColorTheme());
            }
            _getTransitionParameters(t1) {
                return {
                    now: e1.e.now(),
                    transition: Object.assign(this.transition, t1)
                };
            }
            updateDrapeFirstLayers() {
                if (!this.terrain) return;
                const e1 = [], t1 = [];
                for (const i of this._mergedOrder)this.isLayerDraped(this._mergedLayers[i]) ? e1.push(i) : t1.push(i);
                this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e1), this._drapedFirstOrder.push(...t1);
            }
            _createTerrain(e1, t1) {
                const i = this.terrain = new Vt(e1, t1, this.scope, this.options, this.map.getWorldview());
                1 === t1 && (this.stylesheet.terrain = e1), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
                const s = this._getTransitionParameters({
                    duration: 0
                });
                i.updateTransitions(s);
            }
            _force3DLayerUpdate() {
                for(const e1 in this._layers){
                    const t1 = this._layers[e1];
                    "fill-extrusion" === t1.type && this._updateLayer(t1);
                }
            }
            _forceSymbolLayerUpdate() {
                for(const e1 in this._layers){
                    const t1 = this._layers[e1];
                    "symbol" === t1.type && this._updateLayer(t1);
                }
            }
            _validate(t1, i, s, r, o = {}) {
                if (o && !1 === o.validate) return !1;
                const n = {
                    ...this.serialize()
                };
                return _o(this, t1.call(Ct, {
                    key: i,
                    style: n,
                    value: s,
                    styleSpec: e1.s,
                    ...r
                }));
            }
            _remove() {
                this._programPrecompiler && (this._programPrecompiler.reset(), this._programPrecompiler = null), this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null), e1.dl.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const e1 in this._mergedLayers)this._mergedLayers[e1].setEventedParent(null);
                for(const e1 in this._mergedSourceCaches){
                    const t1 = this._mergedSourceCaches[e1];
                    t1.clearTiles(), t1.setEventedParent(null);
                    const i = t1.getSource();
                    i && i.onRemove && i.onRemove(this.map);
                }
                this.imageManager.removeScope(this.scope), this.imageManager.imageAtlasCache.clear(), this.setEventedParent(null), delete this.fog, delete this.snow, delete this.rain, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.indoorManager && this.indoorManager.destroy(), this.isRootStyle() && (this.imageManager.setEventedParent(null), this.modelManager.setEventedParent(null), this.modelManager.destroy(), this.dispatcher.remove());
            }
            clearSource(e1) {
                const t1 = this.getSourceCaches(e1);
                for (const e1 of t1)e1.clearTiles();
            }
            clearSources() {
                for(const e1 in this._mergedSourceCaches)this._mergedSourceCaches[e1].clearTiles();
            }
            clearLayers() {
                for(const e1 in this._mergedLayers){
                    const t1 = this._mergedLayers[e1];
                    t1._clear && t1._clear();
                }
            }
            reloadSource(e1) {
                const t1 = this.getSourceCaches(e1);
                for (const e1 of t1)e1.resume(), e1.reload();
            }
            reloadSources() {
                for (const e1 of this.getSources())e1.reload && e1.reload();
            }
            reloadModels() {
                this.modelManager.reloadModels(""), this.forEachFragmentStyle((e1)=>{
                    e1.modelManager.reloadModels(e1.scope);
                });
            }
            updateSources(t1) {
                let i;
                this.directionalLight && (i = e1.dm(this.directionalLight));
                const s = new Set, r = new Set, o = new Set;
                for(const e1 in this._mergedLayers){
                    const t1 = this._mergedLayers[e1];
                    "building" === t1.type ? s.add(t1.source) : "raster" === t1.type && t1.paint && "ground" === t1.paint.get("raster-elevation-reference") && o.add(t1.source), t1.hasElevation() && !r.has(t1.source) && r.add(t1.source);
                }
                this.updateFrcCoverageFadeRange();
                for(const e1 in this._mergedSourceCaches){
                    const n = this._mergedSourceCaches[e1], a = r.has(n._source.id);
                    n._isRasterElevatedOverTerrain = o.has(n._source.id), s.has(n._source.id) && (n._source.reparseOverscaled = !1), n.update(t1, void 0, void 0, i, a);
                }
                this.updateFrcCoverage(), this.updateElevationCoverage(), Xs.markElevationIngestSourceCachesUsed && Xs.markElevationIngestSourceCachesUsed(this);
            }
            _reloadSources() {
                for(const e1 in this._sourceCaches){
                    const t1 = this._sourceCaches[e1];
                    t1.resume(), t1.reload();
                }
            }
            updateFrcCoverageFadeRange() {
                this.map.painter && Xs.updateFrcCoverageFadeRange && Xs.updateFrcCoverageFadeRange(this, this.map.painter);
            }
            updateFrcCoverage() {
                this._hdCoverage && Xs.updateFrcCoverage && Xs.updateFrcCoverage(this, this._hdCoverage);
            }
            updateElevationCoverage() {
                this.isRootStyle() && Xs.setupAndUpdateElevationCoverage && Xs.setupAndUpdateElevationCoverage(this);
            }
            _handleLayerOrderChange() {
                this._requestFullLabelPlacement(), this.fire(new e1.h("neworder"));
            }
            _requestFullLabelPlacement() {
                this.pauseablePlacement || (this.pauseablePlacement = new Jr), this.pauseablePlacement.requestFullPlacement();
            }
            _setLabelPlacementStale() {
                this.placement && this.placement.setStale();
            }
            _updatePlacement(t1, i, s, r, o, n) {
                this.pauseablePlacement || (this.pauseablePlacement = new Jr);
                let a = !1, l = !1;
                const c = {}, h = {};
                for (const i of this._mergedOrder){
                    const s = this._mergedLayers[i];
                    if ("symbol" !== s.type) continue;
                    const r = e1.m(s.source, s.scope);
                    let o = c[r];
                    if (!o) {
                        const e1 = this.getLayerSourceCache(s);
                        if (!e1) continue;
                        const t1 = e1.getRenderableIds(!0).map((t1)=>e1.getTileByID(t1));
                        h[r] = t1.slice(), o = c[r] = t1.sort((e1, t1)=>t1.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t1.tileID) ? -1 : 1));
                    }
                    const n = this.crossTileSymbolIndex.addLayer(s, o, t1.center.lng, t1.projection);
                    a = a || n;
                }
                this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder);
                const d = Boolean(this.placement && !t1.equals(this.placement.transform)), u = Boolean(this.placement && (0 !== this.placement.lastReplacementSourceUpdateTime && !o || this.placement.lastReplacementSourceUpdateTime !== o.updateTime)), p = d || u || a, f = (p || this.pauseablePlacement.isStale()) && 0 === s, m = this.pauseablePlacement.isDone() && !this.placement.stillRecent(e1.e.now(), t1.zoom) && 0 !== s;
                if ((this.pauseablePlacement.isFullPlacementRequested() || !this.pauseablePlacement.placement || f || m) && (this.pauseablePlacement = this.pauseablePlacement.startNewPlacement(t1, this._mergedOrder, i, s, r, this.placement, this.fog && t1.projection.supportsFog ? this.fog.state : null, this._buildingIndex, n), this.map.painter)) {
                    const e1 = this.map.painter.maxFrontCutoffRawStart;
                    if (e1 > 0) {
                        const i = 180 * t1.pitch / Math.PI;
                        if (i >= 15) {
                            const t1 = Math.min(1, Math.max(0, (i - 15) / 5)), s = t1 * t1 * (3 - 2 * t1);
                            this.pauseablePlacement.placement.frontCutoffStart = -0.5 * (1 - s) + e1 * s;
                        }
                    }
                }
                if (this.pauseablePlacement.isDone() ? p && 0 !== s && this.pauseablePlacement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, c, h, this.map.painter.scaleFactor), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e1.e.now()), l = !0), a && this.pauseablePlacement.setStale()), l || a) {
                    this._buildingIndex.onNewFrame(t1.zoom);
                    for(let t1 = 0; t1 < this._mergedOrder.length; t1++){
                        const s = this._mergedLayers[this._mergedOrder[t1]];
                        if ("symbol" !== s.type) continue;
                        if ("none" === s.visibility) continue;
                        const r = this.isLayerClipped(s);
                        this.placement.updateLayerOpacities(s, c[e1.m(s.source, s.scope)], t1, r ? o : null, i, this.map.painter.scaleFactor);
                    }
                }
                return !this.pauseablePlacement.isDone() || this.placement.isStale() || this.placement.hasTransitions(e1.e.now());
            }
            _releaseSymbolFadeTiles() {
                for(const e1 in this._sourceCaches)this._sourceCaches[e1].releaseSymbolFadeTiles();
            }
            addImport(t1, i) {
                if (this._checkLoaded(), new Set([
                    "__proto__",
                    "constructor",
                    "prototype"
                ]).has(t1.id)) return void this.fire(new e1.f(new Error(`Import id can't be "${t1.id}".`)));
                const s = this.stylesheet.imports = this.stylesheet.imports || [];
                if (-1 !== s.findIndex(({ id: e1 })=>e1 === t1.id)) return void this.fire(new e1.f(new Error(`Import with id '${t1.id}' already exists in the map's style.`)));
                if (!i) return s.push(t1), this._loadImports([
                    t1
                ], !0);
                const r = s.findIndex(({ id: e1 })=>e1 === i);
                return -1 === r && this.fire(new e1.f(new Error(`Import with id "${i}" does not exist on this map.`))), this.stylesheet.imports = s.slice(0, r).concat(t1).concat(s.slice(r)), this._loadImports([
                    t1
                ], !0, i);
            }
            updateImport(t1, i) {
                this._checkLoaded();
                const s = this.stylesheet.imports || [], r = this.getImportIndex(t1);
                return -1 === r ? this : "string" == typeof i ? (this.setImportUrl(t1, i), this) : (i.url && i.url !== s[r].url && this.setImportUrl(t1, i.url), e1.O(i.config, s[r].config) || this.setImportConfig(t1, i.config, i.data.schema), e1.O(i.data, s[r].data) || this.setImportData(t1, i.data), this);
            }
            moveImport(e1, t1) {
                this._checkLoaded();
                let i = this.stylesheet.imports || [];
                const s = this.getImportIndex(e1);
                if (-1 === s) return this;
                const r = this.getImportIndex(t1);
                if (-1 === r) return this;
                const o = i[s], n = this.fragments[s];
                return i = i.filter(({ id: t1 })=>t1 !== e1), this.fragments = this.fragments.filter(({ id: t1 })=>t1 !== e1), this.stylesheet.imports = i.slice(0, r).concat(o).concat(i.slice(r)), this.fragments = this.fragments.slice(0, r).concat(n).concat(this.fragments.slice(r)), this.mergeLayers(), this;
            }
            setImportUrl(e1, t1) {
                this._checkLoaded();
                const i = this.stylesheet.imports || [], s = this.getImportIndex(e1);
                if (-1 === s) return this;
                i[s].url = t1;
                const r = this.fragments[s];
                return r.style = this._createFragmentStyle(i[s]), r.style.on("style.import.load", ()=>this.mergeAll()), r.style.loadURL(t1), this;
            }
            setImportData(e1, t1) {
                this._checkLoaded();
                const i = this.getImportIndex(e1), s = this.stylesheet.imports || [];
                return -1 === i ? this : t1 ? (this.fragments[i].style.setState(t1), this._reloadImports(), this) : (delete s[i].data, this.setImportUrl(e1, s[i].url));
            }
            setImportConfig(e1, t1, i) {
                this._checkLoaded();
                const s = this.getImportIndex(e1), r = this.stylesheet.imports || [];
                if (-1 === s) return this;
                t1 ? r[s].config = t1 : delete r[s].config;
                const o = this.fragments[s];
                i && o.style.stylesheet && (o.style.stylesheet.schema = i);
                const n = o.style.stylesheet && o.style.stylesheet.schema;
                return o.config = t1, o.style.updateConfig(t1, n), this.updateConfigDependencies(), this;
            }
            removeImport(e1) {
                this._checkLoaded();
                const t1 = this.stylesheet.imports || [], i = this.getImportIndex(e1);
                -1 !== i && (t1.splice(i, 1), this.fragments[i].style._remove(), this.fragments.splice(i, 1), this._reloadImports());
            }
            getImportIndex(t1) {
                const i = (this.stylesheet.imports || []).findIndex((e1)=>e1.id === t1);
                return -1 === i && this.fire(new e1.f(new Error(`Import '${t1}' does not exist in the map's style and cannot be updated.`))), i;
            }
            getLayer(e1) {
                return this._mergedLayers[e1];
            }
            getSources() {
                const e1 = [];
                for(const t1 in this._mergedOtherSourceCaches){
                    const i = this._mergedOtherSourceCaches[t1];
                    i && e1.push(i.getSource());
                }
                return e1;
            }
            getSource(e1, t1) {
                const i = this.getSourceCache(e1, t1);
                return i && i.getSource();
            }
            getLayerSource(e1) {
                const t1 = this.getLayerSourceCache(e1);
                return t1 && t1.getSource();
            }
            getSourceCache(t1, i) {
                const s = e1.m(t1, i);
                return this._mergedOtherSourceCaches[s];
            }
            getLayerSourceCache(t1) {
                const i = e1.m(t1.source, t1.scope);
                return "symbol" === t1.type ? this._mergedSymbolSourceCaches[i] : "fill-extrusion" === t1.type ? this._mergedFillExtrusionSourceCaches[i] || this._mergedOtherSourceCaches[i] : "fill" === t1.type && t1.sourceLayer === e1.bU && this._mergedHdRoadCoverageSourceCaches[i] ? this._mergedHdRoadCoverageSourceCaches[i] : this._mergedOtherSourceCaches[i];
            }
            getSourceCaches(e1) {
                return null == e1 ? Object.values(this._mergedSourceCaches) : [
                    this._mergedOtherSourceCaches[e1],
                    this._mergedSymbolSourceCaches[e1],
                    this._mergedFillExtrusionSourceCaches[e1],
                    this._mergedHdRoadCoverageSourceCaches[e1],
                    this._mergedHdRoadElevationSourceCaches[e1]
                ].filter(Boolean);
            }
            updateSourceCaches() {
                const e1 = this._changes.getUpdatedSourceCaches();
                for(const t1 in e1){
                    const i = e1[t1];
                    "reload" === i ? this.reloadSource(t1) : "clear" === i && this.clearSource(t1);
                }
            }
            updateLayers(e1) {
                const t1 = this._changes.getUpdatedPaintProperties();
                for (const i of t1){
                    const t1 = this.getLayer(i);
                    t1 && t1.updateTransitions(e1);
                }
            }
            getGlyphsUrl() {
                return this.stylesheet.glyphs;
            }
            setGlyphsUrl(e1) {
                this.stylesheet.glyphs = e1, this.glyphManager.setURL(e1);
            }
            getOwnSourceCache(e1) {
                return this._otherSourceCaches[e1];
            }
            getOwnLayerSourceCache(e1) {
                return "symbol" === e1.type ? this._symbolSourceCaches[e1.source] : "fill-extrusion" === e1.type && this._fillExtrusionSourceCaches[e1.source] || this._otherSourceCaches[e1.source];
            }
            getOwnSourceCaches(t1) {
                return [
                    this._otherSourceCaches[t1],
                    this._symbolSourceCaches[t1],
                    this._fillExtrusionSourceCaches[t1],
                    this._hdCoverage && this._hdCoverage.coverageSourceCaches[t1],
                    this._hdElevation && this._hdElevation.elevationSourceCaches[e1.m(t1, this.scope)]
                ].filter(Boolean);
            }
            _updateHdCoverageSourceCache(t1) {
                return Xs.HdCoverageState && Xs.updateHdCoverageSourceCache ? (this._hdCoverage || (this._hdCoverage = new Xs.HdCoverageState), Xs.updateHdCoverageSourceCache(this, this._hdCoverage, t1), !1) : "fill" === t1.type && t1.sourceLayer === e1.bU;
            }
            _isSourceCacheLoaded(t1) {
                const i = this.getOwnSourceCaches(t1);
                return 0 === i.length ? (this.fire(new e1.f(new Error(`There is no source with ID '${t1}'`))), !1) : i.every((e1)=>e1.loaded());
            }
            has3DLayers() {
                return this._has3DLayers;
            }
            hasSymbolLayers() {
                return this._hasSymbolLayers;
            }
            hasCircleLayers() {
                return this._hasCircleLayers;
            }
            isLayerClipped(e1, t1) {
                if (!this._clipLayerPresent && "fill-extrusion" !== e1.type && "building" !== e1.type) return !1;
                const i = "fill-extrusion" === e1.type && ("building" === e1.sourceLayer || "procedural_buildings" === e1.sourceLayer), s = "building" === e1.type;
                if (e1.is3D(!!this.terrain)) {
                    if (i || s || t1 && "batched-model" === t1.type) return !0;
                    if ("model" === e1.type) return !0;
                } else if ("symbol" === e1.type) return !0;
                return !1;
            }
            _clearWorkerCaches() {
                this.dispatcher.broadcast("clearCaches");
            }
            getBOMObject() {}
            destroy() {
                this._clearWorkerCaches(), this.imageManager.imageAtlasCache.clear(), this.fragments.forEach((e1)=>{
                    e1.style._remove();
                }), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
            }
            async getImages(t1, i) {
                const s = new Promise((e1, t1)=>{
                    this.imageManager.getImages(i.icons.concat(i.patterns), i.scope, (i, s)=>{
                        i ? t1(i) : e1(s);
                    });
                });
                this._updateTilesForChangedImages();
                const r = i.icons.map((t1)=>e1.I.toString(t1)), o = i.patterns.map((t1)=>e1.I.toString(t1)), n = (e1)=>{
                    e1 && (e1.setDependencies(i.tileID.key, "icons", r), e1.setDependencies(i.tileID.key, "patterns", o));
                }, a = e1.m(i.source, i.scope);
                return n(this._mergedOtherSourceCaches[a]), n(this._mergedSymbolSourceCaches[a]), (i.icons.some((e1)=>e1.iconsetId) || i.patterns.some((e1)=>e1.iconsetId)) && this.fire(new e1.h("data", {
                    dataType: "style"
                })), s;
            }
            async rasterizeImages(e1, t1) {
                return new Promise((e1, i)=>{
                    this.imageManager.rasterizeImages(t1, (t1, s)=>{
                        t1 ? i(t1) : e1(s);
                    });
                });
            }
            async checkAtlasCache(e1, t1) {
                const i = this.imageManager.imageAtlasCache.findCachedAtlas(t1.descriptor);
                return i && i.contentDescriptor ? {
                    iconPositions: i.iconPositions,
                    patternPositions: i.patternPositions,
                    sourceHash: i.contentDescriptor.hash
                } : null;
            }
            async getGlyphs(e1, t1) {
                return new Promise((e1, i)=>{
                    this.glyphManager.getGlyphs(t1.stacks, (t1, s)=>{
                        t1 ? i(t1) : e1(s);
                    });
                });
            }
        }
        To.registerForPluginStateChange = e1.d6;
        class So {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
            }
            bind(e1, t1, i, s, r, o, n, a) {
                this.context = e1;
                let l = this.boundPaintVertexBuffers.length !== s.length;
                for(let e1 = 0; !l && e1 < s.length; e1++)this.boundPaintVertexBuffers[e1] !== s[e1] && (l = !0);
                let c = this.boundDynamicVertexBuffers.length !== n.length;
                for(let e1 = 0; !c && e1 < n.length; e1++)this.boundDynamicVertexBuffers[e1] !== n[e1] && (c = !0);
                if (!this.vao || this.boundProgram !== t1 || this.boundLayoutVertexBuffer !== i || l || c || this.boundIndexBuffer !== r || this.boundVertexOffset !== o) this.freshBind(t1, i, s, r, o, n, a);
                else {
                    e1.bindVertexArrayOES.set(this.vao);
                    for (const i of n)i && (i.bind(), a && i.instanceCount && i.setVertexAttribDivisor(e1.gl, t1, a));
                    r && r.dynamicDraw && r.bind();
                }
            }
            freshBind(e1, t1, i, s, r, o, n) {
                const a = this.context, l = a.gl;
                this.vao && this.destroy(), this.vao = a.gl.createVertexArray(), a.bindVertexArrayOES.set(this.vao), this.boundProgram = e1, this.boundLayoutVertexBuffer = t1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = s, this.boundVertexOffset = r, this.boundDynamicVertexBuffers = o, t1.enableAttributes(l, e1), t1.bind(), t1.setVertexAttribPointers(l, e1, r);
                for (const t1 of i)t1.enableAttributes(l, e1), t1.bind(), t1.setVertexAttribPointers(l, e1, r);
                for (const t1 of o)t1 && (t1.enableAttributes(l, e1), t1.bind(), t1.setVertexAttribPointers(l, e1, r), n && t1.instanceCount && t1.setVertexAttribDivisor(l, e1, n));
                s && s.bind();
            }
            destroy() {
                this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        function Co(t1, i) {
            const s = Math.pow(2, i.canonical.z), r = i.canonical.y;
            return [
                new e1.bS(0, r / s).toLngLat().lat,
                new e1.bS(0, (r + 1) / s).toLngLat().lat
            ];
        }
        function Eo(t1, i, s, r, o, n, a) {
            const l = t1.context, c = l.gl, h = s.hillshadeFBO;
            if (!h) return;
            t1.prepareDrawTile();
            const d = t1.isTileAffectedByFog(i), u = [];
            t1.terrain && t1.terrain.renderingToTexture && "mrt-fallback" === t1.emissiveMode && u.push("USE_MRT1");
            const p = t1.getOrCreateProgram("hillshade", {
                overrideFog: d,
                defines: u
            });
            l.activeTexture.set(c.TEXTURE0), c.bindTexture(c.TEXTURE_2D, h.colorAttachment0.get());
            const f = ((t1, i, s, r)=>{
                const o = s.paint.get("hillshade-shadow-color"), n = "none" === s.paint.get("hillshade-shadow-color-use-theme").constantOr("default"), a = s.paint.get("hillshade-highlight-color"), l = "none" === s.paint.get("hillshade-highlight-color-use-theme").constantOr("default"), c = s.paint.get("hillshade-accent-color"), h = "none" === s.paint.get("hillshade-accent-color-use-theme").constantOr("default"), d = s.paint.get("hillshade-emissive-strength");
                let u = e1.au(s.paint.get("hillshade-illumination-direction"));
                if ("viewport" === s.paint.get("hillshade-illumination-anchor")) u -= t1.transform.angle;
                else if (t1.style && t1.style.enable3dLights() && t1.style.directionalLight) {
                    const i = t1.style.directionalLight.properties.get("direction"), s = e1.de(i.x, i.y, i.z);
                    u = e1.au(s[1]);
                }
                const p = !t1.options.moving;
                return {
                    u_matrix: r || t1.transform.calculateProjMatrix(i.tileID.toUnwrapped(), p),
                    u_image: 0,
                    u_latrange: Co(0, i.tileID),
                    u_light: [
                        s.paint.get("hillshade-exaggeration"),
                        u
                    ],
                    u_shadow: o.toPremultipliedRenderColor(n ? null : s.lut),
                    u_highlight: a.toPremultipliedRenderColor(l ? null : s.lut),
                    u_emissive_strength: d,
                    u_accent: c.toPremultipliedRenderColor(h ? null : s.lut)
                };
            })(t1, s, r, t1.terrain ? i.projMatrix : null);
            t1.uploadCommonUniforms(l, p, i.toUnwrapped());
            const { tileBoundsBuffer: m, tileBoundsIndexBuffer: _, tileBoundsSegments: g } = t1.getTileBoundsBuffers(s);
            p.draw(t1, c.TRIANGLES, o, n, a, e1.$.disabled, f, r.id, m, _, g);
        }
        function Io(t1, i, s) {
            if (!i.needsDEMTextureUpload) return;
            const r = t1.context, o = r.gl;
            r.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || t1.getTileTexture(s.stride);
            const n = s.getPixels();
            i.demTexture ? i.demTexture.update(n, {
                premultiply: !1
            }) : i.demTexture = new e1.T(r, n, o.R32F, {
                premultiply: !1
            }), i.needsDEMTextureUpload = !1;
        }
        function Do(t1, i, s) {
            const r = t1.context, o = r.gl;
            if (!i.dem) return;
            const n = i.dem;
            if (r.activeTexture.set(o.TEXTURE1), Io(t1, i, n), !i.demTexture) return;
            i.demTexture.bind(o.NEAREST, o.CLAMP_TO_EDGE);
            const a = n.dim;
            r.activeTexture.set(o.TEXTURE0);
            let l = i.hillshadeFBO;
            if (!l) {
                const t1 = new e1.T(r, {
                    width: a,
                    height: a,
                    data: null
                }, o.RGBA8);
                t1.bind(o.LINEAR, o.CLAMP_TO_EDGE), l = i.hillshadeFBO = r.createFramebuffer(a, a, 1, "renderbuffer"), l.colorAttachment0.set(t1.texture);
            }
            r.bindFramebuffer.set(l.framebuffer), r.viewport.set([
                0,
                0,
                a,
                a
            ]);
            const { tileBoundsBuffer: c, tileBoundsIndexBuffer: h, tileBoundsSegments: d } = t1.getMercatorTileBoundsBuffers(), u = [];
            t1.linearFloatFilteringSupported() && u.push("TERRAIN_DEM_FLOAT_FORMAT"), t1.terrain && t1.terrain.renderingToTexture && "mrt-fallback" === t1.emissiveMode && u.push("USE_MRT1"), t1.getOrCreateProgram("hillshadePrepare", {
                defines: u
            }).draw(t1, o.TRIANGLES, e1.Z.disabled, e1._.disabled, e1.a1.unblended, e1.$.disabled, ((t1, i)=>{
                const s = i.stride, r = e1.Y();
                return e1.dq(r, 0, e1.a2, -e1.a2, 0, 0, 1), e1.bM(r, r, [
                    0,
                    -e1.a2,
                    0
                ]), {
                    u_matrix: r,
                    u_image: 1,
                    u_dimension: [
                        s,
                        s
                    ],
                    u_zoom: t1.overscaledZ
                };
            })(i.tileID, n), s.id, c, h, d), i.needsHillshadePrepare = !1;
        }
        class Po {
            constructor(e1){
                this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(e1) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class Lo extends Po {
            getDefault() {
                return e1.C.transparent.toNonPremultipliedRenderColor(null);
            }
            set(e1) {
                const t1 = this.current;
                (e1.r !== t1.r || e1.g !== t1.g || e1.b !== t1.b || e1.a !== t1.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class Ro extends Po {
            getDefault() {
                return 1;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Ao extends Po {
            getDefault() {
                return 0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Mo extends Po {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class Fo extends Po {
            getDefault() {
                return !0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Oo extends Po {
            getDefault() {
                return 255;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Bo extends Po {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e1) {
                const t1 = this.current;
                (e1.func !== t1.func || e1.ref !== t1.ref || e1.mask !== t1.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
            }
        }
        class ko extends Po {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.KEEP,
                    e1.KEEP,
                    e1.KEEP
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
            }
        }
        class zo extends Po {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.STENCIL_TEST) : t1.disable(t1.STENCIL_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class Uo extends Po {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class No extends Po {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.DEPTH_TEST) : t1.disable(t1.DEPTH_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class jo extends Po {
            getDefault() {
                return this.gl.LESS;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Vo extends Po {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.BLEND) : t1.disable(t1.BLEND), this.current = e1, this.dirty = !1;
            }
        }
        class Go extends Po {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.ONE,
                    e1.ZERO,
                    e1.ONE,
                    e1.ZERO
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.blendFuncSeparate(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class qo extends Po {
            getDefault() {
                return e1.C.transparent.toNonPremultipliedRenderColor(null);
            }
            set(e1) {
                const t1 = this.current;
                (e1.r !== t1.r || e1.g !== t1.g || e1.b !== t1.b || e1.a !== t1.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class Zo extends Po {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e1, e1), this.current = e1, this.dirty = !1);
            }
        }
        class $o extends Po {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.CULL_FACE) : t1.disable(t1.CULL_FACE), this.current = e1, this.dirty = !1;
            }
        }
        class Ho extends Po {
            getDefault() {
                return this.gl.BACK;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Wo extends Po {
            getDefault() {
                return this.gl.CCW;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        let Xo = class extends Po {
            getDefault() {
                return null;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
            }
        };
        class Ko extends Po {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Yo extends Po {
            getDefault() {
                const e1 = this.gl;
                return [
                    0,
                    0,
                    e1.drawingBufferWidth,
                    e1.drawingBufferHeight
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class Qo extends Po {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindFramebuffer(t1.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Jo extends Po {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindRenderbuffer(t1.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class en extends Po {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindTexture(t1.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
            }
        }
        class tn extends Po {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindBuffer(t1.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class sn extends Po {
            getDefault() {
                return null;
            }
            set(e1) {
                const t1 = this.gl;
                t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class rn extends Po {
            getDefault() {
                return null;
            }
            set(e1) {
                this.gl && (e1 !== this.current || this.dirty) && (this.gl.bindVertexArray(e1), this.current = e1, this.dirty = !1);
            }
        }
        class on extends Po {
            getDefault() {
                return 4;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
            }
        }
        class nn extends Po {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class an extends Po {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class ln extends Po {
            constructor(e1, t1){
                super(e1), this.context = e1, this.parent = t1;
            }
            getDefault() {
                return null;
            }
        }
        class cn extends ln {
            constructor(e1, t1, i = 0){
                super(e1, t1), this.attachmentPoint = e1.gl.COLOR_ATTACHMENT0 + i;
            }
            setDirty() {
                this.dirty = !0;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, this.attachmentPoint, t1.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class hn extends ln {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferRenderbuffer(t1.FRAMEBUFFER, this.attachment(), t1.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class dn extends ln {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, this.attachment(), t1.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class un extends hn {
            attachment() {
                return this.gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        const pn = (e1, t1, i, s)=>({
                u_matrix: e1,
                u_image0: 0,
                u_image1: 1,
                u_skirt_height: t1,
                u_ground_shadow_factor: i,
                u_emissive_texture_available: s
            }), fn = (e1, t1, i, s, r, o, n, a, l, c, h, d, u, p, f, m, _)=>({
                u_proj_matrix: Float32Array.from(e1),
                u_globe_matrix: t1,
                u_normalize_matrix: Float32Array.from(s),
                u_merc_matrix: i,
                u_zoom_transition: r,
                u_merc_center: o,
                u_image0: 0,
                u_image1: 1,
                u_frustum_tl: n,
                u_frustum_tr: a,
                u_frustum_br: l,
                u_frustum_bl: c,
                u_globe_pos: h,
                u_globe_radius: d,
                u_viewport: u,
                u_grid_matrix: _ ? Float32Array.from(_) : new Float32Array(9),
                u_skirt_height: p,
                u_far_z_cutoff: f,
                u_emissive_texture_available: m
            });
        function mn(e1, t1) {
            return null != e1 && null != t1 && !(!e1.hasData() || !t1.hasData()) && null != e1.demTexture && null != t1.demTexture && e1.tileID.key !== t1.tileID.key;
        }
        const _n = new class {
            constructor(){
                this.operations = {};
            }
            newMorphing(e1, t1, i, s, r) {
                if (e1 in this.operations) {
                    const t1 = this.operations[e1];
                    t1.to.tileID.key !== i.tileID.key && (t1.queued = i);
                } else this.operations[e1] = {
                    startTime: s,
                    phase: 0,
                    duration: r,
                    from: t1,
                    to: i,
                    queued: null
                };
            }
            getMorphValuesForProxy(e1) {
                if (!(e1 in this.operations)) return null;
                const t1 = this.operations[e1];
                return {
                    from: t1.from,
                    to: t1.to,
                    phase: t1.phase
                };
            }
            update(e1) {
                for(const t1 in this.operations){
                    const i = this.operations[t1];
                    for(i.phase = (e1 - i.startTime) / i.duration; i.phase >= 1 || !this._validOp(i);)if (!this._nextOp(i, e1)) {
                        delete this.operations[t1];
                        break;
                    }
                }
            }
            _nextOp(e1, t1) {
                return !!e1.queued && (e1.from = e1.to, e1.to = e1.queued, e1.queued = null, e1.phase = 0, e1.startTime = t1, !0);
            }
            _validOp(e1) {
                return e1.from.hasData() && e1.to.hasData();
            }
        };
        function gn(e1, t1, i) {
            if (0 === t1) return 0;
            const s = t1 < 1 && 514 === i ? .25 / t1 : 1;
            return 6 * Math.pow(1.5, 22 - e1) * Math.max(t1, 1) * s;
        }
        function yn(e1, t1) {
            const i = 1 << e1.z;
            return !t1 && (0 === e1.x || e1.x === i - 1) || 0 === e1.y || e1.y === i - 1;
        }
        function vn(e1, t1) {
            if (!e1.style || !e1.style.enable3dLights()) return;
            const i = e1.context, s = i.gl;
            i.activeTexture.set(s.TEXTURE1), t1 ? t1.bind(s.LINEAR, s.CLAMP_TO_EDGE) : e1.emptyTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
        }
        class bn extends gs {
            constructor(e1){
                const t1 = {
                    type: "raster-dem",
                    maxzoom: Math.ceil(e1.transform.maxZoom)
                }, i = lr("mock-dem", t1, e1.style.dispatcher, e1.style);
                super("mock-dem", i, null), i.setEventedParent(this), this._sourceLoaded = !0;
            }
            _loadTile(e1, t1) {
                e1.state = "loaded", t1(null);
            }
        }
        class xn extends gs {
            constructor(e1){
                const t1 = lr("proxy", {
                    type: "geojson",
                    maxzoom: Math.ceil(e1.transform.maxZoom)
                }, e1.style.dispatcher, e1.style);
                super("proxy", t1, null), t1.setEventedParent(this), this.map = this.getSource().map = e1, this.used = this._sourceLoaded = !0, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
            update(e1, t1, i) {
                if (e1.freezeTileCoverage) return;
                this.transform = e1;
                const s = e1.coveringTiles({
                    tileSize: this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled
                }).reduce((t1, i)=>{
                    if (t1[i.key] = "", !this._tiles[i.key]) {
                        const t1 = new fs(i, this._source.tileSize * i.overscaleFactor(), e1.tileZoom, void 0, void 0, this._source.worldview);
                        t1.state = "loaded", this._tiles[i.key] = t1;
                    }
                    return t1;
                }, {});
                for(const e1 in this._tiles)e1 in s || (this.freeFBO(e1), this._tiles[e1].unloadVectorData(), delete this._tiles[e1]);
            }
            freeFBO(e1) {
                const t1 = this.proxyCachedFBO[e1];
                if (void 0 !== t1) {
                    const i = Object.values(t1);
                    this.renderCachePool.push(...i), delete this.proxyCachedFBO[e1];
                }
            }
            deallocRenderCache() {
                this.renderCache.forEach((e1)=>e1.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
        }
        class wn extends e1.bP {
            constructor(e1, t1, i){
                super(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y), this.proxyTileKey = t1, this.projMatrix = i;
            }
        }
        class Tn extends e1.cW {
            constructor(t1, i){
                super(), this.painter = t1, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
                const [s, r, o] = function() {
                    const t1 = new e1.bC, i = new e1.ad, s = 131;
                    t1.reserve(17161), i.reserve(33800);
                    const r = e1.a2 / 128, o = e1.a2 + r / 2, n = o + r;
                    for(let i = -r; i < n; i += r)for(let s = -r; s < n; s += r){
                        const r = s < 0 || s > o || i < 0 || i > o ? 24575 : 0, n = e1.b0(Math.round(s), 0, e1.a2), a = e1.b0(Math.round(i), 0, e1.a2);
                        t1.emplaceBack(n + r, a);
                    }
                    const a = (e1, t1)=>{
                        const r = t1 * s + e1;
                        i.emplaceBack(r + 1, r, r + s), i.emplaceBack(r + s, r + s + 1, r + 1);
                    };
                    for(let e1 = 1; e1 < 129; e1++)for(let t1 = 1; t1 < 129; t1++)a(t1, e1);
                    return [
                        0,
                        129
                    ].forEach((e1)=>{
                        for(let t1 = 0; t1 < 130; t1++)a(t1, e1), a(e1, t1);
                    }), [
                        t1,
                        i,
                        32768
                    ];
                }(), n = t1.context;
                this.gridBuffer = n.createVertexBuffer(s, e1.bE.members), this.gridIndexBuffer = n.createIndexBuffer(r), this.gridSegments = e1.ac.simpleSegment(0, 0, s.length, r.length), this.gridNoSkirtSegments = e1.ac.simpleSegment(0, 0, s.length, o), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new xn(i.map), this.orthoMatrix = e1.Y(), e1.dq(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? .015 : 0, e1.a2, 0, e1.a2, 0, 1);
                const a = n.gl;
                this._overlapStencilMode = new e1._({
                    func: a.GEQUAL,
                    mask: 255
                }, 0, 255, a.KEEP, a.KEEP, a.REPLACE), this._previousZoom = t1.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i, this._useVertexMorphing = !0, this._exaggeration = 1, this._mockSourceCache = new bn(i.map), this._pendingGroundEffectLayers = [], this._emissiveTexture = !1, this._devtoolsFolder = null;
            }
            set style(e1) {
                e1.on("data", this._onStyleDataEvent.bind(this)), this._style = e1, this._style.map.on("moveend", ()=>{
                    this._clearLineLayersFromRenderCache();
                });
            }
            update(t1, i, s) {
                if (t1 && t1.terrain) {
                    this._style !== t1 && (this.style = t1, this._evaluationZoom = void 0);
                    const r = t1.terrain.properties, o = 0 === t1.terrain.drapeRenderMode, n = t1.terrain.isZoomDependent();
                    this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = e1.e.now();
                    const a = t1.terrain && t1.terrain.scope, l = r.get("source"), c = o ? this._mockSourceCache : t1.getSourceCache(l, a);
                    if (!c) return void e1.w(`Couldn't find terrain source "${l}".`);
                    if (this.sourceCache = c, this._attenuationRange = t1.terrain.getAttenuationRange(), this._exaggeration = n ? this.calculateExaggeration(i) : r.get("exaggeration"), !i.projection.requiresDraping && n && 0 === this._exaggeration) return void this._disable();
                    this.enabled = !0;
                    const h = ()=>{
                        this.sourceCache.used && e1.w(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                        const t1 = this.getScaledDemTileSize();
                        this.sourceCache.update(i, t1, !0), this.resetTileLookupCache(this.sourceCache.id);
                    };
                    this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, h(), this._initializing = !0), h(), i.updateElevation(!0, s), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i), this._emptyDEMTextureDirty = !0, this._previousZoom = i.zoom;
                } else this._disable();
            }
            calculateExaggeration(t1) {
                if (this._attenuationRange && t1.zoom >= Math.ceil(this._attenuationRange[1])) return this._style.terrain.getExaggeration(t1.zoom);
                const i = this._previousCameraAltitude, s = t1.getFreeCameraOptions().position.z / t1.pixelsPerMeter * t1.worldSize;
                this._previousCameraAltitude = s;
                const r = null != i ? s - i : Number.MAX_VALUE;
                if (Math.abs(r) < 2) return this._exaggeration;
                const o = t1.zoom, n = this._style.terrain;
                if (!this._previousUpdateTimestamp) return n.getExaggeration(o);
                let a = o - this._previousZoom;
                const l = this._previousUpdateTimestamp;
                let c = o;
                null != this._evaluationZoom && (c = this._evaluationZoom, Math.abs(o - c) > .5 && (a = .5 * (o - c + a)), a * r < 0 && (c += a)), this._evaluationZoom = c;
                const h = n.getExaggeration(c), d = h === n.getExaggeration(Math.max(0, c - .1));
                if (d && Math.abs(h - this._exaggeration) < .01) return h;
                let u = Math.min(.1, .00375 * (this._updateTimestamp - l));
                return (d || h < .1 || Math.abs(a) < 1e-4) && (u = Math.min(.2, 4 * u)), e1.al(this._exaggeration, h, u);
            }
            resetTileLookupCache(e1) {
                this._findCoveringTileCache[e1] = {};
            }
            attenuationRange() {
                return this._attenuationRange;
            }
            getDemUpscale() {
                return this.proxySourceCache.getSource().tileSize / 128;
            }
            getScaledDemTileSize() {
                return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
            }
            _onStyleDataEvent(e1) {
                "source" === e1.dataType && e1.coord ? this._clearRenderCacheForTile(e1.sourceCacheId, e1.coord) : "style" === e1.dataType && (this.invalidateRenderCache = !0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
            }
            _disable() {
                if (this.enabled && (this.enabled = !1, this._emptyDEMTextureDirty = !0, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for(const e1 in this._style._mergedSourceCaches)this._style._mergedSourceCaches[e1].usedForTerrain = !1;
            }
            destroy() {
                this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this.pool.forEach((e1)=>e1.fb.destroy()), this.pool = [], this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
            }
            _source() {
                return this.enabled ? this.sourceCache : null;
            }
            isUsingMockSource() {
                return this.sourceCache === this._mockSourceCache;
            }
            exaggeration() {
                return this.enabled ? this._exaggeration : 0;
            }
            get visibleDemTiles() {
                return this._visibleDemTiles;
            }
            get drapeBufferSize() {
                const e1 = 2 * this.proxySourceCache.getSource().tileSize;
                return [
                    e1,
                    e1
                ];
            }
            set useVertexMorphing(e1) {
                this._useVertexMorphing = e1;
            }
            updateTileBinding(t1) {
                if (!this.enabled) return;
                this.prevTerrainTileForTile = this.terrainTileForTile;
                const i = this.proxySourceCache, s = this.painter.transform;
                this._initializing && (this._initializing = 0 === s._centerAltitude && -1 === this.getAtPointOrZero(e1.bS.fromLngLat(s.center), -1), this._emptyDEMTextureDirty = !this._initializing);
                const r = this.proxyCoords = i.getIds().map((e1)=>{
                    const t1 = i.getTileByID(e1).tileID;
                    return t1.projMatrix = s.calculateProjMatrix(t1.toUnwrapped()), t1;
                });
                !function(t1, i) {
                    const s = i.transform.pointCoordinate(i.transform.getCameraPoint()), r = new e1.P(s.x, s.y);
                    t1.sort((t1, i)=>{
                        if (i.overscaledZ - t1.overscaledZ) return i.overscaledZ - t1.overscaledZ;
                        const s = new e1.P(t1.canonical.x + (1 << t1.canonical.z) * t1.wrap, t1.canonical.y), o = new e1.P(i.canonical.x + (1 << i.canonical.z) * i.wrap, i.canonical.y), n = r.mult(1 << t1.canonical.z);
                        return n.x -= .5, n.y -= .5, n.distSqr(s) - n.distSqr(o);
                    });
                }(r, this.painter);
                const o = this.proxyToSource || {};
                this.proxyToSource = {}, r.forEach((e1)=>{
                    this.proxyToSource[e1.key] = {};
                }), this.terrainTileForTile = {};
                const n = this._style._mergedSourceCaches;
                for(const e1 in n){
                    const i = n[e1];
                    if (!i.used) continue;
                    if (!i.transform) continue;
                    if (i !== this.sourceCache && this.resetTileLookupCache(i.id), this._setupProxiedCoordsForOrtho(i, t1[e1], o), i.usedForTerrain) continue;
                    const s = t1[e1];
                    (i.getSource().reparseOverscaled || i._isRasterElevatedOverTerrain) && this._assignTerrainTiles(s);
                }
                this.proxiedCoords[i.id] = r.map((e1)=>new wn(e1, e1.key, this.orthoMatrix)), this._assignTerrainTiles(r), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(o), this.renderingToTexture = !1;
                const a = {};
                this._visibleDemTiles = [];
                for (const e1 of this.proxyCoords){
                    const t1 = this.terrainTileForTile[e1.key];
                    if (!t1) continue;
                    const i = t1.tileID.key;
                    i in a || (this._visibleDemTiles.push(t1), a[i] = i);
                }
            }
            _assignTerrainTiles(e1) {
                this._initializing || e1.forEach((e1)=>{
                    if (this.terrainTileForTile[e1.key]) return;
                    const t1 = this._findTileCoveringTileID(e1, this.sourceCache);
                    t1 && (this.terrainTileForTile[e1.key] = t1);
                });
            }
            _prepareDEMTextures() {
                const e1 = this.painter.context, t1 = e1.gl;
                for(const i in this.terrainTileForTile){
                    const s = this.terrainTileForTile[i], r = s.dem;
                    !r || s.demTexture && !s.needsDEMTextureUpload || (e1.activeTexture.set(t1.TEXTURE1), Io(this.painter, s, r));
                }
            }
            _prepareDemTileUniforms(e1, t1, i, s) {
                if (!t1 || null == t1.demTexture) return !1;
                const r = e1.tileID.canonical, o = Math.pow(2, t1.tileID.canonical.z - r.z), n = s || "";
                return i[`u_dem_tl${n}`] = [
                    r.x * o % 1,
                    r.y * o % 1
                ], i[`u_dem_scale${n}`] = o, !0;
            }
            get emptyDEMTexture() {
                return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
            }
            _getLoadedAreaMinimum() {
                if (!this.enabled) return 0;
                let e1 = 0;
                const t1 = this._visibleDemTiles.reduce((t1, i)=>{
                    if (!i.dem) return t1;
                    const s = i.dem.tree.minimums[0];
                    return s > 0 && e1++, t1 + s;
                }, 0);
                return e1 ? t1 / e1 : 0;
            }
            _updateEmptyDEMTexture() {
                const t1 = this.painter.context, i = t1.gl;
                t1.activeTexture.set(i.TEXTURE2);
                const s = this._getLoadedAreaMinimum(), r = new e1.du({
                    width: 1,
                    height: 1
                }, new Float32Array([
                    s
                ]));
                this._emptyDEMTextureDirty = !1;
                let o = this._emptyDEMTexture;
                return o ? o.update(r, {
                    premultiply: !1
                }) : o = this._emptyDEMTexture = new e1.T(t1, r, i.R32F, {
                    premultiply: !1
                }), o;
            }
            setupElevationDraw(t1, i, s) {
                const r = this.painter.context, o = r.gl, n = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                };
                n.u_exaggeration = this.exaggeration();
                let a = null, l = null, c = 1;
                if (s && s.morphing && this._useVertexMorphing) {
                    const e1 = s.morphing.srcDemTile, i = s.morphing.dstDemTile;
                    c = s.morphing.phase, e1 && i && (this._prepareDemTileUniforms(t1, e1, n, "_prev") && (l = e1), this._prepareDemTileUniforms(t1, i, n) && (a = i));
                }
                const h = (e1)=>e1 && e1.demTexture && this.painter.linearFloatFilteringSupported() ? o.LINEAR : o.NEAREST;
                let d = null;
                var u;
                if (this.enabled ? l && a ? (d = a.demTexture, r.activeTexture.set(o.TEXTURE4), l.demTexture.bind(h(l), o.CLAMP_TO_EDGE), n.u_dem_lerp = c) : (a = this.terrainTileForTile[t1.tileID.key], d = this._prepareDemTileUniforms(t1, a, n) ? a.demTexture : this.emptyDEMTexture) : d = this.emptyDEMTexture, r.activeTexture.set(o.TEXTURE2), d && (n.u_dem_size = 1 === (u = d).size[0] ? 1 : u.size[0] - 2, d.bind(h(a), o.CLAMP_TO_EDGE)), this.painter.setupDepthForOcclusion(s && s.useDepthForOcclusion, i, n), s && s.useMeterToDem && a) {
                    const t1 = (1 << a.tileID.canonical.z) * e1.dv(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
                    n.u_meter_to_dem = t1;
                }
                if (s && s.labelPlaneMatrixInv && (n.u_label_plane_matrix_inv = s.labelPlaneMatrixInv), i.setTerrainUniformValues(r, n), "globe" === this.painter.transform.projection.name) {
                    const e1 = this.globeUniformValues(this.painter.transform, t1.tileID.canonical, s && s.useDenormalizedUpVectorScale);
                    i.setGlobeUniformValues(r, e1);
                }
            }
            globeUniformValues(t1, i, s) {
                const r = t1.projection;
                return {
                    u_tile_tl_up: r.upVector(i, 0, 0),
                    u_tile_tr_up: r.upVector(i, e1.a2, 0),
                    u_tile_br_up: r.upVector(i, e1.a2, e1.a2),
                    u_tile_bl_up: r.upVector(i, 0, e1.a2),
                    u_tile_up_scale: s ? e1.dw(1) : r.upVectorScale(i, t1.center.lat, t1.worldSize).metersToTile
                };
            }
            renderToBackBuffer(t1) {
                const i = this.painter, s = this.painter.context;
                0 !== t1.length && (s.bindFramebuffer.set(null), s.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), i.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function(t1, i, s, r, o) {
                    if ("globe" === t1.transform.projection.name) !function(t1, i, s, r, o) {
                        const n = t1.context, a = n.gl;
                        let l, c;
                        const h = t1.transform, d = e1.ds(t1, n, h), u = (e1, i)=>{
                            if (c === i) return;
                            const s = [];
                            1 === i && s.push("TERRAIN_VERTEX_MORPHING"), s.push("PROJECTION_GLOBE_VIEW"), d && s.push("CUSTOM_ANTIALIASING");
                            const r = t1.isTileAffectedByFog(e1);
                            l = t1.getOrCreateProgram("globeRaster", {
                                defines: s,
                                overrideFog: r
                            }), c = i;
                        }, p = t1.colorModeForRenderPass(), f = new e1.Z(a.LEQUAL, e1.Z.ReadWrite, t1.depthRangeFor3D);
                        _n.update(o);
                        const m = e1.b6(h), _ = [
                            e1.a7(h.center.lng),
                            e1.a8(h.center.lat)
                        ], g = t1.globeSharedBuffers, y = [
                            h.width * e1.e.devicePixelRatio,
                            h.height * e1.e.devicePixelRatio
                        ], v = Float32Array.from(h.globeMatrix), b = {
                            useDenormalizedUpVectorScale: !0
                        };
                        {
                            const h = t1.transform, d = gn(h.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                            c = -1;
                            const x = a.TRIANGLES;
                            for (const c of r){
                                const r = s.getTile(c), w = e1._.disabled, T = i.prevTerrainTileForTile[c.key], S = i.terrainTileForTile[c.key];
                                mn(T, S) && _n.newMorphing(c.key, T, S, o, 250), vn(t1, r.emissiveTexture), n.activeTexture.set(a.TEXTURE0), r.texture && r.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                const C = _n.getMorphValuesForProxy(c.key), E = C ? 1 : 0;
                                C && Object.assign(b, {
                                    morphing: {
                                        srcDemTile: C.from,
                                        dstDemTile: C.to,
                                        phase: e1.dr(C.phase)
                                    }
                                });
                                const I = e1.b2(c.canonical), D = e1.b3(I.getCenter().lat), P = e1.b7(c.canonical, I, D, h.worldSize / h._pixelsPerMercatorPixel), L = e1.b4(e1.b5(c.canonical)), R = "mrt-fallback" === t1.emissiveMode ? 1 : 0, A = fn(h.expandedFarZProjMatrix, v, m, L, e1.S(h.zoom), _, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, y, d, h._farZ, R, P);
                                if (u(c, E), l && (i.setupElevationDraw(r, l, b), t1.uploadCommonUniforms(n, l, c.toUnwrapped()), g)) {
                                    const [i, s, r] = g.getGridBuffers(D, 0 !== d);
                                    l.draw(t1, x, f, w, p, e1.$.backCCW, A, "globe_raster", i, s, r);
                                }
                            }
                        }
                        if (g && (t1.renderDefaultNorthPole || t1.renderDefaultSouthPole)) {
                            const o = [
                                "GLOBE_POLES",
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            d && o.push("CUSTOM_ANTIALIASING"), l = t1.getOrCreateProgram("globeRaster", {
                                defines: o
                            });
                            for (const o of r){
                                const { x: r, y: c, z: d } = o.canonical, u = 0 === c, m = c === (1 << d) - 1, [v, x, w, T] = g.getPoleBuffers(d, !1);
                                if (T && (u || m)) {
                                    const c = s.getTile(o);
                                    vn(t1, c.emissiveTexture), n.activeTexture.set(a.TEXTURE0), c.texture && c.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                    let g = e1.dt(d, r, h);
                                    const S = e1.b4(e1.b5(o.canonical)), C = "mrt-fallback" === t1.emissiveMode ? 1 : 0, E = (i, s)=>i.draw(t1, a.TRIANGLES, f, e1._.disabled, p, e1.$.disabled, fn(h.expandedFarZProjMatrix, g, g, S, 0, _, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, y, 0, h._farZ, C), "globe_pole_raster", s, w, T);
                                    i.setupElevationDraw(c, l, b), t1.uploadCommonUniforms(n, l, o.toUnwrapped()), u && t1.renderDefaultNorthPole && E(l, v), m && t1.renderDefaultSouthPole && (g = e1.aN(e1.Y(), g, [
                                        1,
                                        -1,
                                        1
                                    ]), E(l, x));
                                }
                            }
                        }
                    }(t1, i, s, r, o);
                    else {
                        const n = t1.context, a = n.gl;
                        let l, c;
                        const h = t1.shadowRenderer, d = e1.aE(t1, t1.longestCutoffRange), u = (e1)=>{
                            if (c === e1) return;
                            const i = [];
                            1 === e1 && i.push("TERRAIN_VERTEX_MORPHING"), d.shouldRenderCutoff && i.push("RENDER_CUTOFF"), h && (i.push("RENDER_SHADOWS"), h.useNormalOffset && i.push("NORMAL_OFFSET")), l = t1.getOrCreateProgram("terrainRaster", {
                                defines: i
                            }), c = e1;
                        }, p = t1.colorModeForRenderPass(), f = new e1.Z(a.LEQUAL, e1.Z.ReadWrite, t1.depthRangeFor3D);
                        _n.update(o);
                        const m = t1.transform, _ = gn(m.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                        let g = [
                            0,
                            0,
                            0
                        ];
                        if (h) {
                            const i = t1.style.directionalLight, s = t1.style.ambientLight;
                            i && s && (g = e1.aF(t1.style, i, s));
                        }
                        {
                            c = -1;
                            const y = a.TRIANGLES, [v, b] = [
                                i.gridIndexBuffer,
                                i.gridSegments
                            ];
                            for (const c of r){
                                const r = s.getTile(c), x = e1._.disabled, w = i.prevTerrainTileForTile[c.key], T = i.terrainTileForTile[c.key];
                                mn(w, T) && _n.newMorphing(c.key, w, T, o, 250), vn(t1, r.emissiveTexture), n.activeTexture.set(a.TEXTURE0), r.texture && r.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                const S = _n.getMorphValuesForProxy(c.key), C = S ? 1 : 0;
                                let E;
                                S && (E = {
                                    morphing: {
                                        srcDemTile: S.from,
                                        dstDemTile: S.to,
                                        phase: e1.dr(S.phase)
                                    }
                                });
                                const I = "mrt-fallback" === t1.emissiveMode ? 1 : 0, D = pn(c.projMatrix, yn(c.canonical, m.renderWorldCopies) ? _ / 10 : _, g, I);
                                if (u(C), !l) continue;
                                i.setupElevationDraw(r, l, E);
                                const P = c.toUnwrapped();
                                h && h.setupShadows(P, l), t1.uploadCommonUniforms(n, l, P, null, d), l.draw(t1, y, f, x, p, e1.$.backCCW, D, "terrain_raster", i.gridBuffer, v, b);
                            }
                        }
                    }
                }(i, this, this.proxySourceCache, t1, this._updateTimestamp), this.renderingToTexture = !0, i.gpuTimingDeferredRenderEnd(), t1.splice(0, t1.length));
            }
            renderBatch(t1) {
                if (0 === this._drapedRenderBatches.length) return t1 + 1;
                this.renderingToTexture = !0;
                const i = this.painter, s = this.painter.context, r = this.proxySourceCache, o = this.proxiedCoords[r.id], n = this._drapedRenderBatches.shift(), a = i.style.order, l = [];
                this._updateFBOs("mrt-fallback" === i.emissiveMode);
                let c = 0;
                for (const h of o){
                    const o = r.getTileByID(h.proxyTileKey), d = r.proxyCachedFBO[h.key] ? r.proxyCachedFBO[h.key][t1] : void 0, u = void 0 !== d ? r.renderCache[d] : this.pool[c++], p = void 0 !== d;
                    if (o.texture = u.tex, o.emissiveTexture = u.emissiveTex, p && !u.dirty) {
                        l.push(o.tileID);
                        continue;
                    }
                    s.bindFramebuffer.set(u.fb.framebuffer);
                    const f = s.gl;
                    let m;
                    f.drawBuffers("mrt-fallback" === i.emissiveMode ? [
                        f.COLOR_ATTACHMENT0,
                        f.COLOR_ATTACHMENT1
                    ] : [
                        f.COLOR_ATTACHMENT0
                    ]), this.renderedToTile = !1, u.dirty && (s.clear({
                        color: e1.C.transparent,
                        stencil: 0
                    }), u.dirty = !1);
                    for(let e1 = n.start; e1 <= n.end; ++e1){
                        const t1 = i.style._mergedLayers[a[e1]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const r = i.style.getLayerSourceCache(t1), o = r ? this.proxyToSource[h.key][r.id] : [
                            h
                        ];
                        if (!o) continue;
                        const n = o;
                        s.viewport.set([
                            0,
                            0,
                            u.fb.width,
                            u.fb.height
                        ]), m !== (r ? r.id : null) && (this._setupStencil(u, o, t1, r), m = r ? r.id : null), i.renderLayer(i, r, t1, n);
                    }
                    if (f.drawBuffers([
                        f.COLOR_ATTACHMENT0
                    ]), 0 === this._drapedRenderBatches.length) for (const e1 of this._pendingGroundEffectLayers){
                        const t1 = i.style._mergedLayers[a[e1]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const r = i.style.getLayerSourceCache(t1), o = r ? this.proxyToSource[h.key][r.id] : [
                            h
                        ];
                        if (!o) continue;
                        const n = o;
                        s.viewport.set([
                            0,
                            0,
                            u.fb.width,
                            u.fb.height
                        ]), m !== (r ? r.id : null) && (this._setupStencil(u, o, t1, r), m = r ? r.id : null), i.renderLayer(i, r, t1, n);
                    }
                    this.renderedToTile ? (u.dirty = !0, l.push(o.tileID)) : p || --c, 5 === c && (c = 0, this.renderToBackBuffer(l));
                }
                return this.renderToBackBuffer(l), this.renderingToTexture = !1, s.bindFramebuffer.set(null), s.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), n.end + 1;
            }
            postRender() {}
            isLayerOrderingCorrect(e1) {
                const t1 = e1.order.length;
                let i = -1, s = t1;
                for(let r = 0; r < t1; ++r)this._style.isLayerDraped(e1._mergedLayers[e1.order[r]]) ? i = Math.max(i, r) : s = Math.min(s, r);
                return s > i;
            }
            getMinElevationBelowMSL() {
                let e1 = 0;
                return this._visibleDemTiles.filter((e1)=>e1.dem).forEach((t1)=>{
                    e1 = Math.min(e1, t1.dem.tree.minimums[0]);
                }), 0 === e1 ? e1 : (e1 - 30) * this._exaggeration;
            }
            raycast(e1, t1, i) {
                if (!this._visibleDemTiles) return null;
                const s = this._visibleDemTiles.filter((e1)=>e1.dem).map((s)=>{
                    const r = s.tileID, o = 1 << r.overscaledZ, { x: n, y: a } = r.canonical, l = n / o, c = (n + 1) / o, h = a / o, d = (a + 1) / o;
                    return {
                        minx: l,
                        miny: h,
                        maxx: c,
                        maxy: d,
                        t: s.dem.tree.raycastRoot(l, h, c, d, e1, t1, i),
                        tile: s
                    };
                });
                s.sort((e1, t1)=>(null !== e1.t ? e1.t : Number.MAX_VALUE) - (null !== t1.t ? t1.t : Number.MAX_VALUE));
                for (const r of s){
                    if (null == r.t) return null;
                    const s = r.tile.dem.tree.raycast(r.minx, r.miny, r.maxx, r.maxy, e1, t1, i);
                    if (null != s) return s;
                }
                return null;
            }
            _createFBO() {
                const t1 = this.painter.context, i = t1.gl, s = this.drapeBufferSize;
                t1.activeTexture.set(i.TEXTURE0);
                const r = new e1.T(t1, {
                    width: s[0],
                    height: s[1],
                    data: null
                }, i.RGBA8);
                r.bind(i.LINEAR, i.CLAMP_TO_EDGE);
                const o = t1.createFramebuffer(s[0], s[1], 1, null);
                let n;
                return o.colorAttachment0.set(r.texture), this._emissiveTexture && (n = new e1.T(t1, {
                    width: s[0],
                    height: s[1],
                    data: null
                }, i.R8), n.bind(i.LINEAR, i.CLAMP_TO_EDGE), o.createColorAttachment(t1, 1), o.colorAttachment1.set(n.texture)), o.depthAttachment = new un(t1, o.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t1.createRenderbuffer(t1.gl.DEPTH_STENCIL, s[0], s[1]), this._stencilRef = 0, o.depthAttachment.set(this._sharedDepthStencil), t1.clear({
                    stencil: 0
                })) : o.depthAttachment.set(this._sharedDepthStencil), t1.extTextureFilterAnisotropic && i.texParameterf(i.TEXTURE_2D, t1.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t1.extTextureFilterAnisotropicMax), {
                    fb: o,
                    tex: r,
                    emissiveTex: n,
                    dirty: !1
                };
            }
            _updateFBOs(e1) {
                if (this._emissiveTexture !== e1) {
                    for (const t1 of this.pool)this._updateFBO(t1, e1);
                    for (const t1 of this.proxySourceCache.renderCache)this._updateFBO(t1, e1);
                    this._emissiveTexture = e1;
                }
            }
            _updateFBO(t1, i) {
                const s = t1.fb, r = this.painter.context, o = r.gl, n = this.drapeBufferSize;
                if (i) {
                    const i = new e1.T(r, {
                        width: n[0],
                        height: n[1],
                        data: null
                    }, o.R8);
                    i.bind(o.LINEAR, o.CLAMP_TO_EDGE), t1.emissiveTex = i, s.createColorAttachment(r, 1), s.colorAttachment1.set(i.texture);
                } else t1.emissiveTex = void 0, s.removeColorAttachment(r, 1);
                t1.dirty = !0;
            }
            _initFBOPool() {
                for(; this.pool.length < Math.min(5, this.proxyCoords.length);)this.pool.push(this._createFBO());
            }
            _shouldDisableRenderCache() {
                if (this._style.hasLightTransitions()) return !0;
                for(const e1 in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[e1].hasTransition()) return !0;
                return this._style.order.some((e1)=>{
                    const t1 = this._style._mergedLayers[e1], i = t1.isHidden(this.painter.transform.zoom);
                    return "hillshade" === t1.type || "custom" === t1.type ? !i && t1.shouldRedrape() : !i && t1.hasTransition();
                });
            }
            _clearLineLayersFromRenderCache() {
                let t1 = !1;
                for (const e1 of this._style.getSources())if (e1 instanceof tr) {
                    t1 = !0;
                    break;
                }
                if (!t1) return;
                const i = {};
                for(let t1 = 0; t1 < this._style.order.length; ++t1){
                    const s = this._style._mergedLayers[this._style.order[t1]], r = this._style.getLayerSourceCache(s);
                    if (!r || i[r.id]) continue;
                    if (s.isHidden(this.painter.transform.zoom) || "line" !== s.type) continue;
                    const o = s.widthExpression(), n = s.emissiveStrengthExpression();
                    if (o instanceof e1.aj || n instanceof e1.aj) {
                        i[r.id] = !0;
                        for (const e1 of this.proxyCoords){
                            const t1 = this.proxyToSource[e1.key][r.id];
                            if (t1) for (const e1 of t1)this._clearRenderCacheForTile(r.id, e1);
                        }
                    }
                }
            }
            _clearRasterLayersFromRenderCache() {
                let e1 = !1;
                for(const t1 in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[t1]._source instanceof ir) {
                    e1 = !0;
                    break;
                }
                if (!e1) return;
                const t1 = {};
                for(let e1 = 0; e1 < this._style.order.length; ++e1){
                    const i = this._style._mergedLayers[this._style.order[e1]], s = this._style.getLayerSourceCache(i);
                    if (!s || t1[s.id]) continue;
                    if (i.isHidden(this.painter.transform.zoom) || "raster" !== i.type) continue;
                    const r = i.paint.get("raster-fade-duration");
                    for (const e1 of this.proxyCoords){
                        const t1 = this.proxyToSource[e1.key][s.id];
                        if (t1) for (const e1 of t1){
                            const t1 = Ai(s.getTile(e1), s.findLoadedParent(e1, 0), s, this.painter.transform, r);
                            (1 !== t1.opacity || 0 !== t1.mix) && this._clearRenderCacheForTile(s.id, e1);
                        }
                    }
                }
            }
            _setupDrapedRenderBatches() {
                this._style.updateDrapeFirstLayers();
                const t1 = this._style.order, i = t1.length;
                if (0 === i) return;
                const s = [];
                this._pendingGroundEffectLayers = [];
                let r, o = 0, n = this._style._mergedLayers[t1[o]];
                for(; !this._style.isLayerDraped(n) && n.isHidden(this.painter.transform.zoom) && ++o < i;)n = this._style._mergedLayers[t1[o]];
                for(; o < i; ++o){
                    const e1 = this._style._mergedLayers[t1[o]];
                    e1.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(e1) ? void 0 === r && (r = o) : ("fill-extrusion" === e1.type && this._pendingGroundEffectLayers.push(o), void 0 !== r && (s.push({
                        start: r,
                        end: o - 1
                    }), r = void 0)));
                }
                if (void 0 !== r && s.push({
                    start: r,
                    end: o - 1
                }), 0 !== s.length) {
                    const t1 = s.at(-1);
                    this._pendingGroundEffectLayers.every((e1)=>e1 > t1.end) || e1.w("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
                }
                this._drapedRenderBatches = s;
            }
            _setupRenderCache(e1) {
                const t1 = this.proxySourceCache;
                if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
                    if (this.invalidateRenderCache = !1, t1.renderCache.length > t1.renderCachePool.length) {
                        const e1 = Object.values(t1.proxyCachedFBO);
                        t1.proxyCachedFBO = {};
                        for(let i = 0; i < e1.length; ++i){
                            const s = Object.values(e1[i]);
                            t1.renderCachePool.push(...s);
                        }
                    }
                    return;
                }
                this._clearRasterLayersFromRenderCache();
                const i = this.proxyCoords, s = this._tilesDirty;
                for(let r = i.length - 1; r >= 0; r--){
                    const o = i[r];
                    if (t1.getTileByID(o.key), void 0 !== t1.proxyCachedFBO[o.key]) {
                        const i = e1[o.key], r = this.proxyToSource[o.key];
                        let n = 0;
                        for(const e1 in r){
                            const t1 = r[e1], o = i[e1];
                            if (!o || o.length !== t1.length || t1.some((t1, i)=>t1 !== o[i] || s[e1] && Object.hasOwn(s[e1], t1.key))) {
                                n = -1;
                                break;
                            }
                            ++n;
                        }
                        for(const e1 in t1.proxyCachedFBO[o.key])t1.renderCache[t1.proxyCachedFBO[o.key][e1]].dirty = n < 0 || n !== Object.values(i).length;
                    }
                }
                const r = [
                    ...this._drapedRenderBatches
                ];
                r.sort((e1, t1)=>t1.end - t1.start - (e1.end - e1.start));
                for (const e1 of r)for (const s of i){
                    if (t1.proxyCachedFBO[s.key]) continue;
                    let i = t1.renderCachePool.pop();
                    void 0 === i && t1.renderCache.length < 50 && (i = t1.renderCache.length, t1.renderCache.push(this._createFBO())), void 0 !== i && (t1.proxyCachedFBO[s.key] = {}, t1.proxyCachedFBO[s.key][e1.start] = i, t1.renderCache[i].dirty = !0);
                }
                this._tilesDirty = {};
            }
            _setupStencil(e1, t1, i, s) {
                if (!s || !this._sourceTilesOverlap[s.id]) return void (this._overlapStencilType && (this._overlapStencilType = !1));
                const r = this.painter.context, o = r.gl;
                if (t1.length <= 1) return void (this._overlapStencilType = !1);
                let n;
                if (i.isTileClipped()) n = t1.length, this._overlapStencilMode.test = {
                    func: o.EQUAL,
                    mask: 255
                }, this._overlapStencilType = "Clip";
                else {
                    if (!(t1[0].overscaledZ > t1.at(-1).overscaledZ)) return void (this._overlapStencilType = !1);
                    n = 1, this._overlapStencilMode.test = {
                        func: o.GREATER,
                        mask: 255
                    }, this._overlapStencilType = "Mask";
                }
                this._stencilRef + n > 255 && (r.clear({
                    stencil: 0
                }), this._stencilRef = 0), this._stencilRef += n, this._overlapStencilMode.ref = this._stencilRef, i.isTileClipped() && this._renderTileClippingMasks(t1, this._overlapStencilMode.ref);
            }
            clipOrMaskOverlapStencilType() {
                return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
            }
            stencilModeForRTTOverlap(t1) {
                return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[t1.key]), this._overlapStencilMode) : e1._.disabled;
            }
            _renderTileClippingMasks(t1, i) {
                const s = this.painter, r = this.painter.context, o = r.gl;
                s._tileClippingMaskIDs = {}, r.setColorMode(e1.a1.disabled), r.setDepthMode(e1.Z.disabled);
                const n = s.getOrCreateProgram("clippingMask");
                for (const r of t1){
                    const t1 = s._tileClippingMaskIDs[r.key] = --i;
                    n.draw(s, o.TRIANGLES, e1.Z.disabled, new e1._({
                        func: o.ALWAYS,
                        mask: 0
                    }, t1, 255, o.KEEP, o.KEEP, o.REPLACE), e1.a1.disabled, e1.$.disabled, Us(r.projMatrix), "$clipping", s.tileExtentBuffer, s.quadTriangleIndexBuffer, s.tileExtentSegments);
                }
            }
            pointCoordinate(t1) {
                const i = this.painter.transform;
                if (t1.x < 0 || t1.x > i.width || t1.y < 0 || t1.y > i.height) return null;
                const s = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e1.c7(s, s, i.pixelMatrixInverse), e1.dx(s, s, 1 / s[3]), s[0] /= i.worldSize, s[1] /= i.worldSize;
                const r = i._camera.position, o = e1.dv(1, i.center.lat), n = [
                    r[0],
                    r[1],
                    r[2] / o,
                    0
                ], a = e1.dy([], s.slice(0, 3), n);
                e1.c3(a, a);
                const l = this.raycast(n, a, this._exaggeration);
                return null !== l && l ? (e1.dz(n, n, a, l), n[3] = n[2], n[2] *= o, n) : null;
            }
            _setupProxiedCoordsForOrtho(e1, t1, i) {
                if (e1.getSource() instanceof nr) return this._setupProxiedCoordsForImageSource(e1, t1, i);
                this._findCoveringTileCache[e1.id] = this._findCoveringTileCache[e1.id] || {};
                const s = this.proxiedCoords[e1.id] = [], r = this.proxyCoords;
                for(let t1 = 0; t1 < r.length; t1++){
                    const o = r[t1], n = this._findTileCoveringTileID(o, e1);
                    if (n) {
                        const t1 = this._createProxiedId(o, n, i[o.key] && i[o.key][e1.id]);
                        s.push(t1), this.proxyToSource[o.key][e1.id] = [
                            t1
                        ];
                    }
                }
                let o = !1;
                const n = new Set;
                for(let r = 0; r < t1.length; r++){
                    const a = e1.getTile(t1[r]);
                    if (!a || !a.hasData()) continue;
                    const l = this._findTileCoveringTileID(a.tileID, this.proxySourceCache);
                    if (l && l.tileID.canonical.z !== a.tileID.canonical.z) {
                        const t1 = this.proxyToSource[l.tileID.key][e1.id], r = this._createProxiedId(l.tileID, a, i[l.tileID.key] && i[l.tileID.key][e1.id]);
                        t1 ? t1.splice(t1.length - 1, 0, r) : this.proxyToSource[l.tileID.key][e1.id] = [
                            r
                        ];
                        const c = this.proxyToSource[l.tileID.key][e1.id];
                        n.has(c) || n.add(c), s.push(r), o = !0;
                    }
                }
                if (this._sourceTilesOverlap[e1.id] = o, o) for (const e1 of n)e1.sort((e1, t1)=>t1.overscaledZ - e1.overscaledZ);
            }
            _setupProxiedCoordsForImageSource(t1, i, s) {
                if (!t1.getSource().loaded()) return;
                const r = this.proxiedCoords[t1.id] = [], o = this.proxyCoords, n = t1.getSource(), a = n.tileID;
                if (!a) return;
                const l = new e1.P(a.x, a.y)._div(1 << a.z), c = n.coordinates.map(e1.bS.fromLngLat).reduce((e1, t1)=>(e1.min.x = Math.min(e1.min.x, t1.x - l.x), e1.min.y = Math.min(e1.min.y, t1.y - l.y), e1.max.x = Math.max(e1.max.x, t1.x - l.x), e1.max.y = Math.max(e1.max.y, t1.y - l.y), e1), {
                    min: new e1.P(Number.MAX_VALUE, Number.MAX_VALUE),
                    max: new e1.P(-Number.MAX_VALUE, -Number.MAX_VALUE)
                }), h = (t1, i)=>{
                    const s = t1.wrap + t1.canonical.x / (1 << t1.canonical.z), r = t1.canonical.y / (1 << t1.canonical.z), o = e1.a2 / (1 << t1.canonical.z), n = i.wrap + i.canonical.x / (1 << i.canonical.z), a = i.canonical.y / (1 << i.canonical.z);
                    return s + o < n + c.min.x || s > n + c.max.x || r + o < a + c.min.y || r > a + c.max.y;
                };
                for(let e1 = 0; e1 < o.length; e1++){
                    const n = o[e1];
                    for(let e1 = 0; e1 < i.length; e1++){
                        const o = t1.getTile(i[e1]);
                        if (!o || !o.hasData()) continue;
                        if (h(n, o.tileID)) continue;
                        const a = this._createProxiedId(n, o, s[n.key] && s[n.key][t1.id]), l = this.proxyToSource[n.key][t1.id];
                        l ? l.push(a) : this.proxyToSource[n.key][t1.id] = [
                            a
                        ], r.push(a);
                    }
                }
            }
            _createProxiedId(t1, i, s) {
                let r = this.orthoMatrix;
                if (s) {
                    const e1 = s.find((e1)=>e1.key === i.tileID.key);
                    if (e1) return e1;
                }
                if (i.tileID.key !== t1.key) {
                    const s = t1.canonical.z - i.tileID.canonical.z;
                    let o, n, a;
                    r = e1.Y();
                    const l = i.tileID.wrap - t1.wrap << t1.overscaledZ;
                    s > 0 ? (o = e1.a2 >> s, n = o * ((i.tileID.canonical.x << s) - t1.canonical.x + l), a = o * ((i.tileID.canonical.y << s) - t1.canonical.y)) : (o = e1.a2 << -s, n = e1.a2 * (i.tileID.canonical.x - (t1.canonical.x + l << -s)), a = e1.a2 * (i.tileID.canonical.y - (t1.canonical.y << -s))), e1.dq(r, 0, o, 0, o, 0, 1), e1.bM(r, r, [
                        n,
                        a,
                        0
                    ]);
                }
                return new wn(i.tileID, t1.key, r);
            }
            _findTileCoveringTileID(t1, i) {
                let s = i.getTile(t1);
                if (s && s.hasData()) return s;
                const r = this._findCoveringTileCache[i.id], o = r[t1.key];
                if (s = o ? i.getTileByID(o) : null, s && s.hasData() || null === o) return s;
                let n = s ? s.tileID : t1, a = n.overscaledZ;
                const l = i.getSource().minzoom, c = [];
                if (!o) {
                    const r = i.getSource().maxzoom;
                    if (t1.canonical.z >= r) {
                        const s = t1.canonical.z - r;
                        i.getSource().reparseOverscaled ? (a = Math.max(t1.canonical.z + 2, i.transform.tileZoom), n = new e1.bP(a, t1.wrap, r, t1.canonical.x >> s, t1.canonical.y >> s)) : 0 !== s && (a = r, n = new e1.bP(a, t1.wrap, r, t1.canonical.x >> s, t1.canonical.y >> s));
                    }
                    n.key !== t1.key && (c.push(n.key), s = i.getTile(n));
                }
                const h = (e1)=>{
                    c.forEach((t1)=>{
                        r[t1] = e1;
                    }), c.length = 0;
                };
                for(a -= 1; a >= l && (!s || !s.hasData()); a--){
                    s && h(s.tileID.key);
                    const e1 = n.calculateScaledKey(a);
                    if (s = i.getTileByID(e1), s && s.hasData()) break;
                    const t1 = r[e1];
                    if (null === t1) break;
                    void 0 === t1 ? c.push(e1) : s = i.getTileByID(t1);
                }
                return h(s ? s.tileID.key : null), s && s.hasData() ? s : null;
            }
            findDEMTileFor(e1) {
                return this.enabled ? this._findTileCoveringTileID(e1, this.sourceCache) : null;
            }
            prepareDrawTile() {
                this.renderedToTile = !0;
            }
            _clearRenderCacheForTile(e1, t1) {
                let i = this._tilesDirty[e1];
                i || (i = this._tilesDirty[e1] = {}), i[t1.key] = !0;
            }
        }
        function Sn(t1, i, s) {
            const r = function(t1, i, s) {
                const r = e1.dE(i, t1), o = e1.dE(s, [
                    .2126,
                    .7152,
                    .0722
                ]), n = 1 - .3 * Math.min(o, 1), a = e1.al(n, 1, Math.min(r + 1, 1));
                return e1.al(.92, 1, Math.asin(e1.b0(i[2], -1, 1)) / Math.PI + .5) * a;
            }(t1, [
                0,
                0,
                1
            ], i), o = [
                0,
                0,
                0
            ];
            e1.dB(o, s.slice(0, 3), r);
            const n = [
                0,
                0,
                0
            ];
            e1.dB(n, i.slice(0, 3), t1[2]);
            const a = [
                0,
                0,
                0
            ];
            return e1.dC(a, o, n), e1.dD(a);
        }
        const Cn = [
            "fill",
            "fillOutline",
            "fillPattern",
            "line",
            "linePattern",
            "background",
            "backgroundPattern",
            "hillshade",
            "raster"
        ], En = [
            "stars",
            "rainParticle",
            "snowParticle",
            "fillExtrusion",
            "fillExtrusionGroundEffect",
            "building",
            "buildingBloom",
            "elevatedStructures",
            "model",
            "symbol"
        ];
        class In {
            static cacheKey(e1, t1, i, s) {
                const r = [
                    t1
                ];
                s && r.push(s.cacheKey);
                for (const t1 of i)("string" == typeof t1 && t1.includes(" ") || e1.usedDefines.has(t1)) && r.push(t1);
                return r.join("/");
            }
            constructor(t1, i, s, r, o, n, a = !1){
                const l = t1.gl;
                this.program = l.createProgram(), this._context = t1, this._fixedUniformsFn = o, this._pending = !0, this._precompiled = a, this.attributes = {}, this.configuration = r, this.name = i, this.fixedDefines = [
                    ...n
                ], a ? t1._compileStats.precompiled++ : t1._compileStats.onDemand++;
                const c = `#version 300 es\n${(r ? r.defines() : []).concat(n.map((e1)=>`#define ${e1}`)).join("\n")}`, h = [
                    c,
                    e1.dF
                ];
                for (const t1 of s.fragmentIncludes)h.push(e1.ba[t1]);
                h.push(s.fragmentSource);
                const d = h.join("\n"), u = [
                    c,
                    e1.dG
                ];
                for (const t1 of s.vertexIncludes)u.push(e1.ba[t1]);
                this.forceManualRenderingForInstanceIDShaders = t1.forceManualRenderingForInstanceIDShaders && s.vertexSource.includes("gl_InstanceID"), this.forceManualRenderingForInstanceIDShaders && u.push("uniform int u_instanceID;"), u.push(s.vertexSource);
                let p = u.join("\n");
                this.forceManualRenderingForInstanceIDShaders && (p = p.replaceAll("gl_InstanceID", "u_instanceID"));
                const f = l.createShader(l.FRAGMENT_SHADER);
                if (l.isContextLost()) return this.failedToCreate = !0, void (this._pending = !1);
                l.shaderSource(f, d), l.compileShader(f), l.attachShader(this.program, f);
                const m = l.createShader(l.VERTEX_SHADER);
                if (l.isContextLost()) return this.failedToCreate = !0, void (this._pending = !1);
                l.shaderSource(m, p), l.compileShader(m), l.attachShader(this.program, m), l.linkProgram(this.program), this._fragmentShader = f, this._vertexShader = m, t1.extParallelShaderCompile ? t1._pendingPrograms.add(this) : this._finalize();
            }
            _finalize() {
                if (!this._pending) return;
                this._pending = !1;
                const t1 = this._context, i = t1.gl;
                t1._pendingPrograms.delete(this);
                const s = e1.e.now(), r = i.getProgramParameter(this.program, i.LINK_STATUS), o = e1.e.now() - s, n = t1._compileStats;
                if (n.totalStallMs += o, o > n.maxStallMs && (n.maxStallMs = o), o > 1) {
                    n.framesMissed += Math.floor(60 * o / 1e3);
                    const e1 = this.fixedDefines.join(",");
                    n.stalls.push({
                        name: `${this.name}${e1 ? "/" : ""}${e1}`,
                        ms: o,
                        timestamp: s
                    });
                }
                if (this._fragmentShader && (r || e1.w(`Fragment shader '${this.name}': ${i.getShaderInfoLog(this._fragmentShader)}`), i.deleteShader(this._fragmentShader), this._fragmentShader = null), this._vertexShader && (r || e1.w(`Vertex shader '${this.name}': ${i.getShaderInfoLog(this._vertexShader)}`), i.deleteShader(this._vertexShader), this._vertexShader = null), !r) return e1.w(`Failed to link program '${this.name}': ${i.getProgramInfoLog(this.program)}`), void (this.failedToCreate = !0);
                this.fixedUniforms = this._fixedUniformsFn(t1), this.fixedUniformsEntries = Object.entries(this.fixedUniforms), this.binderUniforms = this.configuration ? this.configuration.getUniforms(t1) : [], this.forceManualRenderingForInstanceIDShaders && (this.instancingUniforms = ((t1)=>({
                        u_instanceID: new e1.aX(t1)
                    }))(t1));
                const a = this.fixedDefines, l = this.name;
                (a.includes("TERRAIN") || a.includes("ELEVATED") || l.includes("symbol") || l.includes("circle")) && (this.terrainUniforms = ((t1)=>({
                        u_dem: new e1.aX(t1),
                        u_dem_prev: new e1.aX(t1),
                        u_dem_tl: new e1.a3(t1),
                        u_dem_scale: new e1.a4(t1),
                        u_dem_tl_prev: new e1.a3(t1),
                        u_dem_scale_prev: new e1.a4(t1),
                        u_dem_size: new e1.a4(t1),
                        u_dem_lerp: new e1.a4(t1),
                        u_exaggeration: new e1.a4(t1),
                        u_depth: new e1.aX(t1),
                        u_depth_size_inv: new e1.a3(t1),
                        u_depth_range_unpack: new e1.a3(t1),
                        u_occluder_half_size: new e1.a4(t1),
                        u_occlusion_depth_offset: new e1.a4(t1),
                        u_meter_to_dem: new e1.a4(t1),
                        u_label_plane_matrix_inv: new e1.a5(t1)
                    }))(t1)), a.includes("GLOBE") && (this.globeUniforms = ((t1)=>({
                        u_tile_tl_up: new e1.a6(t1),
                        u_tile_tr_up: new e1.a6(t1),
                        u_tile_br_up: new e1.a6(t1),
                        u_tile_bl_up: new e1.a6(t1),
                        u_tile_up_scale: new e1.a4(t1)
                    }))(t1)), a.includes("FOG") && (this.fogUniforms = ((t1)=>({
                        u_fog_matrix: new e1.a5(t1),
                        u_fog_range: new e1.a3(t1),
                        u_fog_color: new e1.aY(t1),
                        u_fog_horizon_blend: new e1.a4(t1),
                        u_fog_vertical_limit: new e1.a3(t1),
                        u_fog_temporal_offset: new e1.a4(t1),
                        u_frustum_tl: new e1.a6(t1),
                        u_frustum_tr: new e1.a6(t1),
                        u_frustum_br: new e1.a6(t1),
                        u_frustum_bl: new e1.a6(t1),
                        u_globe_pos: new e1.a6(t1),
                        u_globe_radius: new e1.a4(t1),
                        u_globe_transition: new e1.a4(t1),
                        u_is_globe: new e1.aX(t1),
                        u_viewport: new e1.a3(t1)
                    }))(t1)), a.includes("RENDER_CUTOFF") && (this.cutoffUniforms = e1.dH(t1)), a.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((t1)=>({
                        u_lighting_ambient_color: new e1.a6(t1),
                        u_lighting_directional_dir: new e1.a6(t1),
                        u_lighting_directional_color: new e1.a6(t1),
                        u_ground_radiance: new e1.a6(t1)
                    }))(t1)), a.includes("RENDER_SHADOWS") && (this.shadowUniforms = e1.dI(t1));
            }
            maybeFinalize() {
                if (!this._pending) return;
                const e1 = this._context.extParallelShaderCompile;
                e1 && !this._context.gl.getProgramParameter(this.program, e1.COMPLETION_STATUS_KHR) || this._finalize();
            }
            _ensureReady() {
                this._pending && (this._finalize(), this._context.sweepPendingPrograms());
            }
            getAttributeLocation(e1, t1) {
                this._ensureReady();
                let i = this.attributes[t1];
                return void 0 === i && (i = this.attributes[t1] = e1.getAttribLocation(this.program, t1)), i;
            }
            _setUniformGroup(e1, t1, i) {
                this._ensureReady();
                const s = this[t1];
                if (!this.failedToCreate && s) {
                    e1.program.set(this.program);
                    for(const e1 in i){
                        const t1 = s[e1];
                        t1 && t1.set(this.program, e1, i[e1]);
                    }
                }
            }
            setTerrainUniformValues(e1, t1) {
                this._setUniformGroup(e1, "terrainUniforms", t1);
            }
            setGlobeUniformValues(e1, t1) {
                this._setUniformGroup(e1, "globeUniforms", t1);
            }
            setFogUniformValues(e1, t1) {
                this._setUniformGroup(e1, "fogUniforms", t1);
            }
            setCutoffUniformValues(e1, t1) {
                this._setUniformGroup(e1, "cutoffUniforms", t1);
            }
            setLightsUniformValues(e1, t1) {
                this._setUniformGroup(e1, "lightsUniforms", t1);
            }
            setShadowUniformValues(e1, t1) {
                this._setUniformGroup(e1, "shadowUniforms", t1);
            }
            _drawDebugWireframe(t1, i, s, r, o, n, a, l, c, h) {
                const d = t1.options.wireframe;
                if (!1 === d.terrain && !1 === d.layers2D && !1 === d.layers3D) return;
                const u = t1.context;
                if (!(()=>!(!d.terrain || "terrainRaster" !== this.name && "globeRaster" !== this.name) || !(!d.layers2D || t1._terrain && t1._terrain.renderingToTexture || !Cn.includes(this.name)) || !(!d.layers3D || !En.includes(this.name)))()) return;
                const p = u.gl, f = t1.wireframeDebugCache.getLinesFromTrianglesBuffer(t1.frameCounter, o, u);
                if (!f) return;
                const m = [
                    ...this.fixedDefines,
                    "DEBUG_WIREFRAME"
                ], _ = t1.getOrCreateProgram(this.name, {
                    config: this.configuration,
                    defines: m
                });
                _._ensureReady(), u.program.set(_.program);
                const g = (e1, t1, i)=>{
                    if (t1[e1] && i[e1]) for(const s in t1[e1])i[e1][s] && i[e1][s].set(i.program, s, t1[e1][s].current);
                };
                c && c.setUniforms(_.program, u, _.binderUniforms, a, {
                    zoom: l
                }), g("fixedUniforms", this, _), g("terrainUniforms", this, _), g("globeUniforms", this, _), g("fogUniforms", this, _), g("lightsUniforms", this, _), g("shadowUniforms", this, _), f.bind(), u.setColorMode(new e1.a1([
                    p.ONE,
                    p.ONE_MINUS_SRC_ALPHA,
                    p.ZERO,
                    p.ONE
                ], e1.C.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ])), u.setDepthMode(new e1.Z(i.func === p.LESS ? p.LEQUAL : i.func, e1.Z.ReadOnly, i.range)), u.setStencilMode(e1._.disabled);
                const y = 3 * n.primitiveLength * 2, v = 3 * n.primitiveOffset * 4;
                if (this.forceManualRenderingForInstanceIDShaders) {
                    const e1 = h || 1;
                    for(let t1 = 0; t1 < e1; ++t1)_.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", t1), p.drawElements(p.LINES, y, p.UNSIGNED_SHORT, v);
                } else h && h > 1 ? p.drawElementsInstanced(p.LINES, y, p.UNSIGNED_SHORT, v, h) : p.drawElements(p.LINES, y, p.UNSIGNED_SHORT, v);
                o.bind(), u.program.set(this.program), u.setDepthMode(i), u.setStencilMode(s), u.setColorMode(r);
            }
            checkUniforms(e1, t1, i) {
                if (this.fixedDefines.includes(t1)) {
                    for (const s of Object.keys(i))if (!i[s].initialized) throw new Error(`Program '${this.name}', from draw '${e1}': uniform ${s} not set but required by ${t1} being defined`);
                }
            }
            draw(e1, t1, i, s, r, o, n, a, l, c, h, d, u, p, f, m) {
                const _ = e1.context, g = _.gl;
                if (this._ensureReady(), this.failedToCreate) return;
                _.program.set(this.program), _.setDepthMode(i), _.setStencilMode(s), _.setColorMode(r), _.setCullFace(o);
                for (const [e1, t1] of this.fixedUniformsEntries)t1.set(this.program, e1, n[e1]);
                p && p.setUniforms(this.program, _, this.binderUniforms, d, {
                    zoom: u
                });
                const y = {
                    [g.POINTS]: 1,
                    [g.LINES]: 2,
                    [g.TRIANGLES]: 3,
                    [g.LINE_STRIP]: 1
                }[t1];
                this.checkUniforms(a, "RENDER_SHADOWS", this.shadowUniforms);
                const v = f || [], b = p ? p.getPaintVertexBuffers() : [], x = t1 === g.TRIANGLES && c, w = m && m > 0 ? 1 : void 0;
                for (const o of h.get()){
                    const n = o.vaos || (o.vaos = {});
                    if ((n[a] || (n[a] = new So)).bind(_, this, l, b, c, o.vertexOffset, v, w), this.forceManualRenderingForInstanceIDShaders) {
                        const e1 = m || 1;
                        for(let i = 0; i < e1; ++i)this.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", i), c ? g.drawElements(t1, o.primitiveLength * y, g.UNSIGNED_SHORT, o.primitiveOffset * y * 2) : g.drawArrays(t1, o.vertexOffset, o.vertexLength);
                    } else m && m > 1 ? g.drawElementsInstanced(t1, o.primitiveLength * y, g.UNSIGNED_SHORT, o.primitiveOffset * y * 2, m) : c ? g.drawElements(t1, o.primitiveLength * y, g.UNSIGNED_SHORT, o.primitiveOffset * y * 2) : g.drawArrays(t1, o.vertexOffset, o.vertexLength);
                    x && this._drawDebugWireframe(e1, i, s, r, c, o, d, u, p, m);
                }
            }
        }
        const Dn = (e1, t1, i)=>({
                u_matrix: e1,
                u_emissive_strength: t1,
                u_ground_shadow_factor: i,
                u_opacity_multiplier: 1
            }), Pn = (t1, i, s, r, o, n = 0)=>Object.assign(Dn(t1, i, o), e1.dJ(s, r, n)), Ln = (e1, t1, i, s)=>({
                u_matrix: e1,
                u_world: i,
                u_emissive_strength: t1,
                u_ground_shadow_factor: s,
                u_opacity_multiplier: 1
            }), Rn = (e1, t1, i, s, r, o, n = 0)=>Object.assign(Pn(e1, t1, i, s, o, n), {
                u_world: r
            }), An = (e1, t1, i)=>({
                u_image: e1,
                u_texel_size: t1,
                u_first_pass: i ? 1 : 0
            }), Mn = e1.Y(), Fn = (t1, i, s, r, o, n, a)=>{
            const l = t1.transform, c = "globe" === l.projection.name, h = c ? e1.dK(l.zoom, i.canonical) * l._pixelsPerMercatorPixel : e1.c5(s, 1, n), d = {
                u_matrix: i.projMatrix,
                u_extrude_scale: h,
                u_intensity: a,
                u_inv_rot_matrix: Mn,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (c) {
                d.u_inv_rot_matrix = r, d.u_merc_center = o, d.u_tile_id = [
                    i.canonical.x,
                    i.canonical.y,
                    1 << i.canonical.z
                ], d.u_zoom_transition = e1.S(l.zoom);
                const t1 = o[0] * e1.a2, s = o[1] * e1.a2;
                d.u_up_dir = l.projection.upVector(new e1.bX(0, 0, 0), t1, s);
            }
            return d;
        };
        function On(t1) {
            const i = t1.terrain ? t1.terrain.exaggeration() : 1;
            return (t1.transform.pitch < 15 ? e1.al(.07, .7, e1.b0((14 - t1.transform.zoom) / 5, 0, 1)) : .07) * i;
        }
        const Bn = (t1, i, s, r, o, n, a, l, c, h, d, u, p, f, m, _, g, y, v, b, x, w)=>({
                u_matrix: i,
                u_normalize_matrix: s,
                u_globe_matrix: r,
                u_merc_matrix: o,
                u_grid_matrix: n,
                u_tl_parent: a,
                u_scale_parent: d,
                u_fade_t: u.mix,
                u_opacity: u.opacity * p.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: p.paint.get("raster-brightness-min"),
                u_brightness_high: p.paint.get("raster-brightness-max"),
                u_saturation_factor: e1.dN(p.paint.get("raster-saturation")),
                u_contrast_factor: e1.dM(p.paint.get("raster-contrast")),
                u_spin_weights: kn(p.paint.get("raster-hue-rotate")),
                u_perspective_transform: f,
                u_raster_elevation: m,
                u_zoom_transition: l,
                u_merc_center: c,
                u_cutoff_params: h,
                u_colorization_mix: Di(e1.dL, g, v),
                u_colorization_offset: Pi(e1.dL, y, v),
                u_color_ramp: _,
                u_texture_offset: [
                    x / (b + 2 * x),
                    b / (b + 2 * x)
                ],
                u_texture_res: [
                    b + 2 * x,
                    b + 2 * x
                ],
                u_emissive_strength: w,
                u_zbias_factor: On(t1)
            });
        function kn(e1) {
            e1 *= Math.PI / 180;
            const t1 = Math.sin(e1), i = Math.cos(e1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t1 - i + 1) / 3,
                (Math.sqrt(3) * t1 - i + 1) / 3
            ];
        }
        const zn = e1.Y(), Un = (t1, i, s, r, o, n, a, l, c, h, d, u, p, f, m, _, g, y, v, b, x, w, T, S, C)=>{
            const E = o.transform, I = {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: i ? i.uSizeT : 0,
                u_size: i ? i.uSize : 0,
                u_camera_to_center_distance: E.getCameraToCenterDistance(b),
                u_rotate_symbol: +s,
                u_aspect_ratio: E.width / E.height,
                u_fade_change: o.options.fadeDuration ? o.symbolFadeChange : 1,
                u_matrix: n,
                u_label_plane_matrix: a,
                u_coord_matrix: l,
                u_is_text: +h,
                u_is_sdf: +d,
                u_elevation_from_sea: c ? 1 : 0,
                u_pitch_with_map: +r,
                u_texsize: u,
                u_texsize_icon: p,
                u_texture: 0,
                u_texture_icon: 1,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: zn,
                u_merc_center: [
                    0,
                    0
                ],
                u_camera_forward: [
                    0,
                    0,
                    0
                ],
                u_ecef_origin: [
                    0,
                    0,
                    0
                ],
                u_tile_matrix: zn,
                u_up_vector: [
                    0,
                    -1,
                    0
                ],
                u_color_adj_mat: T,
                u_icon_transition: S || 0,
                u_gamma_scale: d ? r ? o.transform.getCameraToCenterDistance(b) * Math.cos(o.terrain ? 0 : o.transform._pitch) : 1 : 0,
                u_device_pixel_ratio: e1.e.devicePixelRatio,
                u_is_halo: 1,
                u_scale_factor: C || 1,
                u_ground_shadow_factor: x,
                u_inv_matrix: e1.aO(e1.Y(), a),
                u_normal_scale: w,
                u_lutTexture: e1.dP.LUT,
                u_spp_fill_np_color: [
                    0,
                    0,
                    0,
                    1
                ],
                u_spp_halo_np_color: [
                    0,
                    0,
                    0,
                    0
                ],
                u_spp_opacity: 1,
                u_spp_halo_width: 0,
                u_spp_halo_blur: 0,
                u_spp_emissive_strength: 0,
                u_spp_occlusion_opacity: 1,
                u_spp_z_offset: 0,
                u_spp_translate_rotation: [
                    1,
                    0
                ],
                u_spp_zoom_fraction: 0,
                u_opacity_multiplier: 1
            };
            return "globe" === b.name && (I.u_tile_id = [
                m.canonical.x,
                m.canonical.y,
                1 << m.canonical.z
            ], I.u_zoom_transition = _, I.u_inv_rot_matrix = y, I.u_merc_center = g, I.u_camera_forward = E._camera.forward(), I.u_ecef_origin = e1.dO(E.globeMatrix, m.toUnwrapped()), I.u_tile_matrix = E.globeMatrix, I.u_up_vector = v), I;
        }, Nn = (e1, t1, i, s)=>({
                u_matrix: e1,
                u_emissive_strength: t1,
                u_opacity: i,
                u_color: s
            }), jn = (t1, i, s, r, o, n, a, l, c)=>Object.assign(e1.dQ(o, n, a, r, l, c), {
                u_matrix: t1,
                u_emissive_strength: i,
                u_opacity: s
            }), Vn = {
            fillExtrusion: e1.dW,
            fillExtrusionPattern: e1.dV,
            fill: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_emissive_strength: new e1.a4(t1),
                    u_ground_shadow_factor: new e1.a6(t1),
                    u_opacity_multiplier: new e1.a4(t1)
                }),
            fillPattern: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_emissive_strength: new e1.a4(t1),
                    u_image: new e1.aX(t1),
                    u_texsize: new e1.a3(t1),
                    u_pixel_coord_upper: new e1.a3(t1),
                    u_pixel_coord_lower: new e1.a3(t1),
                    u_tile_units_to_pixels: new e1.a4(t1),
                    u_ground_shadow_factor: new e1.a6(t1),
                    u_pattern_transition: new e1.a4(t1),
                    u_opacity_multiplier: new e1.a4(t1)
                }),
            fillOutline: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_emissive_strength: new e1.a4(t1),
                    u_world: new e1.a3(t1),
                    u_ground_shadow_factor: new e1.a6(t1),
                    u_opacity_multiplier: new e1.a4(t1)
                }),
            fillOutlinePattern: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_emissive_strength: new e1.a4(t1),
                    u_world: new e1.a3(t1),
                    u_image: new e1.aX(t1),
                    u_texsize: new e1.a3(t1),
                    u_pixel_coord_upper: new e1.a3(t1),
                    u_pixel_coord_lower: new e1.a3(t1),
                    u_tile_units_to_pixels: new e1.a4(t1),
                    u_ground_shadow_factor: new e1.a6(t1),
                    u_pattern_transition: new e1.a4(t1),
                    u_opacity_multiplier: new e1.a4(t1)
                }),
            lineBlendComposite: (t1)=>({
                    u_image: new e1.aX(t1),
                    u_opacity: new e1.a4(t1),
                    u_blend_mode: new e1.aX(t1),
                    u_max_density: new e1.a4(t1)
                }),
            lineBlendReduce: (t1)=>({
                    u_image: new e1.aX(t1),
                    u_texel_size: new e1.a3(t1),
                    u_first_pass: new e1.aX(t1)
                }),
            circle: e1.dU,
            collisionBox: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_inv_rot_matrix: new e1.a5(t1),
                    u_camera_to_center_distance: new e1.a4(t1),
                    u_extrude_scale: new e1.a3(t1),
                    u_zoom_transition: new e1.a4(t1),
                    u_merc_center: new e1.a3(t1),
                    u_tile_id: new e1.a6(t1)
                }),
            collisionCircle: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_inv_matrix: new e1.a5(t1),
                    u_camera_to_center_distance: new e1.a4(t1),
                    u_viewport_size: new e1.a3(t1)
                }),
            debug: e1.dT,
            clippingMask: (t1)=>({
                    u_matrix: new e1.a5(t1)
                }),
            heatmap: (t1)=>({
                    u_extrude_scale: new e1.a4(t1),
                    u_intensity: new e1.a4(t1),
                    u_matrix: new e1.a5(t1),
                    u_inv_rot_matrix: new e1.a5(t1),
                    u_merc_center: new e1.a3(t1),
                    u_tile_id: new e1.a6(t1),
                    u_zoom_transition: new e1.a4(t1),
                    u_up_dir: new e1.a6(t1)
                }),
            heatmapTexture: (t1)=>({
                    u_image: new e1.aX(t1),
                    u_color_ramp: new e1.aX(t1),
                    u_opacity: new e1.a4(t1)
                }),
            hillshade: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_image: new e1.aX(t1),
                    u_latrange: new e1.a3(t1),
                    u_light: new e1.a3(t1),
                    u_shadow: new e1.dp(t1),
                    u_highlight: new e1.dp(t1),
                    u_emissive_strength: new e1.a4(t1),
                    u_accent: new e1.dp(t1)
                }),
            hillshadePrepare: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_image: new e1.aX(t1),
                    u_dimension: new e1.a3(t1),
                    u_zoom: new e1.a4(t1)
                }),
            line: e1.dS,
            linePattern: e1.dR,
            raster: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_normalize_matrix: new e1.a5(t1),
                    u_globe_matrix: new e1.a5(t1),
                    u_merc_matrix: new e1.a5(t1),
                    u_grid_matrix: new e1.aZ(t1),
                    u_tl_parent: new e1.a3(t1),
                    u_scale_parent: new e1.a4(t1),
                    u_fade_t: new e1.a4(t1),
                    u_opacity: new e1.a4(t1),
                    u_image0: new e1.aX(t1),
                    u_image1: new e1.aX(t1),
                    u_brightness_low: new e1.a4(t1),
                    u_brightness_high: new e1.a4(t1),
                    u_saturation_factor: new e1.a4(t1),
                    u_contrast_factor: new e1.a4(t1),
                    u_spin_weights: new e1.a6(t1),
                    u_perspective_transform: new e1.a3(t1),
                    u_raster_elevation: new e1.a4(t1),
                    u_zoom_transition: new e1.a4(t1),
                    u_merc_center: new e1.a3(t1),
                    u_cutoff_params: new e1.aY(t1),
                    u_colorization_mix: new e1.aY(t1),
                    u_colorization_offset: new e1.a4(t1),
                    u_color_ramp: new e1.aX(t1),
                    u_texture_offset: new e1.a3(t1),
                    u_texture_res: new e1.a3(t1),
                    u_emissive_strength: new e1.a4(t1),
                    u_zbias_factor: new e1.a4(t1)
                }),
            symbol: (t1)=>({
                    u_is_size_zoom_constant: new e1.aX(t1),
                    u_is_size_feature_constant: new e1.aX(t1),
                    u_size_t: new e1.a4(t1),
                    u_size: new e1.a4(t1),
                    u_camera_to_center_distance: new e1.a4(t1),
                    u_rotate_symbol: new e1.aX(t1),
                    u_aspect_ratio: new e1.a4(t1),
                    u_fade_change: new e1.a4(t1),
                    u_matrix: new e1.a5(t1),
                    u_label_plane_matrix: new e1.a5(t1),
                    u_coord_matrix: new e1.a5(t1),
                    u_is_text: new e1.aX(t1),
                    u_is_sdf: new e1.aX(t1),
                    u_elevation_from_sea: new e1.aX(t1),
                    u_pitch_with_map: new e1.aX(t1),
                    u_texsize: new e1.a3(t1),
                    u_texsize_icon: new e1.a3(t1),
                    u_texture: new e1.aX(t1),
                    u_texture_icon: new e1.aX(t1),
                    u_gamma_scale: new e1.a4(t1),
                    u_device_pixel_ratio: new e1.a4(t1),
                    u_tile_id: new e1.a6(t1),
                    u_zoom_transition: new e1.a4(t1),
                    u_inv_rot_matrix: new e1.a5(t1),
                    u_merc_center: new e1.a3(t1),
                    u_camera_forward: new e1.a6(t1),
                    u_tile_matrix: new e1.a5(t1),
                    u_up_vector: new e1.a6(t1),
                    u_ecef_origin: new e1.a6(t1),
                    u_is_halo: new e1.aX(t1),
                    u_icon_transition: new e1.a4(t1),
                    u_color_adj_mat: new e1.a5(t1),
                    u_scale_factor: new e1.a4(t1),
                    u_ground_shadow_factor: new e1.a6(t1),
                    u_inv_matrix: new e1.a5(t1),
                    u_normal_scale: new e1.a4(t1),
                    u_lutTexture: new e1.aX(t1),
                    u_spp_fill_np_color: new e1.aY(t1),
                    u_spp_halo_np_color: new e1.aY(t1),
                    u_spp_opacity: new e1.a4(t1),
                    u_spp_halo_width: new e1.a4(t1),
                    u_spp_halo_blur: new e1.a4(t1),
                    u_spp_emissive_strength: new e1.a4(t1),
                    u_spp_occlusion_opacity: new e1.a4(t1),
                    u_spp_z_offset: new e1.a4(t1),
                    u_spp_translate_rotation: new e1.a3(t1),
                    u_spp_zoom_fraction: new e1.a4(t1),
                    u_opacity_multiplier: new e1.a4(t1)
                }),
            background: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_emissive_strength: new e1.a4(t1),
                    u_opacity: new e1.a4(t1),
                    u_color: new e1.dp(t1)
                }),
            backgroundPattern: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_emissive_strength: new e1.a4(t1),
                    u_opacity: new e1.a4(t1),
                    u_image: new e1.aX(t1),
                    u_pattern_tl: new e1.a3(t1),
                    u_pattern_br: new e1.a3(t1),
                    u_texsize: new e1.a3(t1),
                    u_pattern_size: new e1.a3(t1),
                    u_pixel_coord_upper: new e1.a3(t1),
                    u_pixel_coord_lower: new e1.a3(t1),
                    u_pattern_units_to_pixels: new e1.a3(t1)
                }),
            terrainRaster: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_image0: new e1.aX(t1),
                    u_image1: new e1.aX(t1),
                    u_skirt_height: new e1.a4(t1),
                    u_ground_shadow_factor: new e1.a6(t1),
                    u_emissive_texture_available: new e1.a4(t1)
                }),
            skybox: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_sun_direction: new e1.a6(t1),
                    u_cubemap: new e1.aX(t1),
                    u_opacity: new e1.a4(t1),
                    u_temporal_offset: new e1.a4(t1)
                }),
            skyboxGradient: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_color_ramp: new e1.aX(t1),
                    u_center_direction: new e1.a6(t1),
                    u_radius: new e1.a4(t1),
                    u_opacity: new e1.a4(t1),
                    u_temporal_offset: new e1.a4(t1)
                }),
            skyboxCapture: (t1)=>({
                    u_matrix_3f: new e1.aZ(t1),
                    u_sun_direction: new e1.a6(t1),
                    u_sun_intensity: new e1.a4(t1),
                    u_color_tint_r: new e1.aY(t1),
                    u_color_tint_m: new e1.aY(t1),
                    u_luminance: new e1.a4(t1)
                }),
            globeRaster: (t1)=>({
                    u_proj_matrix: new e1.a5(t1),
                    u_globe_matrix: new e1.a5(t1),
                    u_normalize_matrix: new e1.a5(t1),
                    u_merc_matrix: new e1.a5(t1),
                    u_zoom_transition: new e1.a4(t1),
                    u_merc_center: new e1.a3(t1),
                    u_image0: new e1.aX(t1),
                    u_image1: new e1.aX(t1),
                    u_grid_matrix: new e1.aZ(t1),
                    u_skirt_height: new e1.a4(t1),
                    u_far_z_cutoff: new e1.a4(t1),
                    u_frustum_tl: new e1.a6(t1),
                    u_frustum_tr: new e1.a6(t1),
                    u_frustum_br: new e1.a6(t1),
                    u_frustum_bl: new e1.a6(t1),
                    u_globe_pos: new e1.a6(t1),
                    u_globe_radius: new e1.a4(t1),
                    u_viewport: new e1.a3(t1),
                    u_emissive_texture_available: new e1.a4(t1)
                }),
            globeAtmosphere: (t1)=>({
                    u_frustum_tl: new e1.a6(t1),
                    u_frustum_tr: new e1.a6(t1),
                    u_frustum_br: new e1.a6(t1),
                    u_frustum_bl: new e1.a6(t1),
                    u_horizon: new e1.a4(t1),
                    u_transition: new e1.a4(t1),
                    u_fadeout_range: new e1.a4(t1),
                    u_atmosphere_fog_color: new e1.aY(t1),
                    u_high_color: new e1.aY(t1),
                    u_space_color: new e1.aY(t1),
                    u_temporal_offset: new e1.a4(t1),
                    u_horizon_angle: new e1.a4(t1)
                }),
            stars: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_up: new e1.a6(t1),
                    u_right: new e1.a6(t1),
                    u_intensity_multiplier: new e1.a4(t1)
                }),
            occlusion: (t1)=>({
                    u_matrix: new e1.a5(t1),
                    u_anchorPos: new e1.a6(t1),
                    u_screenSizePx: new e1.a3(t1),
                    u_occluderSizePx: new e1.a3(t1),
                    u_color: new e1.aY(t1)
                })
        };
        class Gn {
            constructor(e1, t1, i, s){
                this.id = Gn.uniqueIdxCounter, Gn.uniqueIdxCounter++, this.context = e1;
                const r = e1.gl;
                this.buffer = r.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), r.bufferData(r.ELEMENT_ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || s || t1.destroy();
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e1) {
                this.id = Gn.uniqueIdxCounter, Gn.uniqueIdxCounter++;
                const t1 = this.context.gl;
                this.context.unbindVAO(), this.bind(), t1.bufferSubData(t1.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        Gn.uniqueIdxCounter = 0;
        const qn = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class Zn {
            constructor(e1, t1, i, s, r, o){
                this.length = t1.length, this.attributes = i, this.itemSize = t1.bytesPerElement, this.dynamicDraw = s, this.instanceCount = o, this.context = e1;
                const n = e1.gl;
                this.buffer = n.createBuffer(), e1.bindVertexBuffer.set(this.buffer), n.bufferData(n.ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW), this.dynamicDraw || r || t1.destroy();
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e1) {
                const t1 = this.context.gl;
                this.bind(), t1.bufferSubData(t1.ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            enableAttributes(e1, t1) {
                for (const i of this.attributes){
                    const s = t1.getAttributeLocation(e1, i.name);
                    -1 !== s && e1.enableVertexAttribArray(s);
                }
            }
            setVertexAttribPointers(e1, t1, i) {
                for (const s of this.attributes){
                    const r = t1.getAttributeLocation(e1, s.name);
                    if (-1 !== r) {
                        const t1 = s.offset + this.itemSize * (i || 0);
                        "Float32" === s.type ? e1.vertexAttribPointer(r, s.components, e1.FLOAT, !1, this.itemSize, t1) : e1.vertexAttribIPointer(r, s.components, e1[qn[s.type]], this.itemSize, t1);
                    }
                }
            }
            setVertexAttribDivisor(e1, t1, i) {
                for(let s = 0; s < this.attributes.length; s++){
                    const r = t1.getAttributeLocation(e1, this.attributes[s].name);
                    -1 !== r && this.instanceCount && this.instanceCount > 0 && e1.vertexAttribDivisor(r, i);
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        class $n {
            constructor(e1, t1, i, s, r){
                this.context = e1, this.width = t1, this.height = i;
                const o = this.framebuffer = e1.gl.createFramebuffer();
                s > 0 && (this.colorAttachment0 = new cn(e1, o, 0)), s > 1 && (this.colorAttachment1 = new cn(e1, o, 1)), r && (this.depthAttachmentType = r, this.depthAttachment = "renderbuffer" === r ? new hn(e1, o) : new dn(e1, o));
            }
            static createWithTexture(t1, i, s, r, o) {
                const n = t1.gl;
                if (t1.activeTexture.set(n.TEXTURE1), t1.viewport.set([
                    0,
                    0,
                    s,
                    r
                ]), i && i.width === s && i.height === r) return n.bindTexture(n.TEXTURE_2D, i.colorAttachment0.get()), t1.bindFramebuffer.set(i.framebuffer), i;
                i && i.destroy();
                const a = t1.extRenderToTextureHalfFloat || t1.extColorBufferFloat ? t1.gl.RGBA16F : t1.gl.RGBA8, l = new e1.T(t1, {
                    width: s,
                    height: r,
                    data: null
                }, a);
                l.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                const c = t1.createFramebuffer(s, r, 1, null);
                if (c.format = a, c.colorAttachment0.set(l.texture), o) {
                    const e1 = t1.createRenderbuffer(n.DEPTH24_STENCIL8, s, r);
                    t1.bindFramebuffer.set(c.framebuffer), n.framebufferRenderbuffer(n.FRAMEBUFFER, n.DEPTH_STENCIL_ATTACHMENT, n.RENDERBUFFER, e1), c._stencilRbo = e1;
                }
                return c;
            }
            createColorAttachment(e1, t1) {
                0 === t1 ? this.colorAttachment0 = new cn(e1, this.framebuffer, 0) : 1 === t1 && (this.colorAttachment1 = new cn(e1, this.framebuffer, 1));
            }
            removeColorAttachment(e1, t1) {
                const i = this.context.gl;
                let s;
                0 === t1 ? (s = this.colorAttachment0.get(), this.colorAttachment0 = void 0) : 1 === t1 && (s = this.colorAttachment1.get(), this.colorAttachment1 = void 0), s && i.deleteTexture(s);
            }
            destroy() {
                const e1 = this.context.gl;
                if (this.colorAttachment0) {
                    const t1 = this.colorAttachment0.get();
                    t1 && e1.deleteTexture(t1);
                }
                if (this.colorAttachment1) {
                    const t1 = this.colorAttachment1.get();
                    t1 && e1.deleteTexture(t1);
                }
                if (this.depthAttachment && this.depthAttachmentType) {
                    if ("renderbuffer" === this.depthAttachmentType) {
                        const t1 = this.depthAttachment.get();
                        t1 && e1.deleteRenderbuffer(t1);
                    } else {
                        const t1 = this.depthAttachment.get();
                        t1 && e1.deleteTexture(t1);
                    }
                }
                this._stencilRbo && (e1.deleteRenderbuffer(this._stencilRbo), this._stencilRbo = null), e1.deleteFramebuffer(this.framebuffer);
            }
        }
        class Hn {
            constructor(e1, t1){
                this.gl = e1, this._pendingPrograms = new Set, this._compileStats = {
                    precompiled: 0,
                    onDemand: 0,
                    totalStallMs: 0,
                    maxStallMs: 0,
                    framesMissed: 0,
                    stalls: []
                }, this.clearColor = new Lo(this), this.clearDepth = new Ro(this), this.clearStencil = new Ao(this), this.colorMask = new Mo(this), this.depthMask = new Fo(this), this.stencilMask = new Oo(this), this.stencilFunc = new Bo(this), this.stencilOp = new ko(this), this.stencilTest = new zo(this), this.depthRange = new Uo(this), this.depthTest = new No(this), this.depthFunc = new jo(this), this.blend = new Vo(this), this.blendFunc = new Go(this), this.blendColor = new qo(this), this.blendEquation = new Zo(this), this.cullFace = new $o(this), this.cullFaceSide = new Ho(this), this.frontFace = new Wo(this), this.program = new Xo(this), this.activeTexture = new Ko(this), this.viewport = new Yo(this), this.bindFramebuffer = new Qo(this), this.bindRenderbuffer = new Jo(this), this.bindTexture = new en(this), this.bindVertexBuffer = new tn(this), this.bindElementBuffer = new sn(this), this.bindVertexArrayOES = new rn(this), this.pixelStoreUnpack = new on(this), this.pixelStoreUnpackPremultiplyAlpha = new nn(this), this.pixelStoreUnpackFlipY = new an(this), this.options = t1 ? {
                    ...t1
                } : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e1.getExtension("EXT_texture_filter_anisotropic") || e1.getExtension("MOZ_EXT_texture_filter_anisotropic") || e1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e1.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e1.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e1.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.forceManualRenderingForInstanceIDShaders = t1 && !!t1.forceManualRenderingForInstanceIDShaders || this.renderer && this.renderer.includes("PowerVR"), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e1.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e1.getExtension("EXT_color_buffer_half_float"), this.extColorBufferFloat = e1.getExtension("EXT_color_buffer_float"), this.extTimerQuery = e1.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE), this.maxUniformBlockSize = Math.min(e1.getParameter(e1.MAX_UNIFORM_BLOCK_SIZE), 32768), this.maxUniformBufferBindings = e1.getParameter(e1.MAX_UNIFORM_BUFFER_BINDINGS), this.extBlendFuncExtended = e1.getExtension("WEBGL_blend_func_extended"), this.extParallelShaderCompile = e1.getExtension("KHR_parallel_shader_compile");
            }
            sweepPendingPrograms() {
                if (0 !== this._pendingPrograms.size) for (const e1 of this._pendingPrograms)e1.maybeFinalize();
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArrayOES.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e1, t1, i) {
                return new Gn(this, e1, t1, i);
            }
            createVertexBuffer(e1, t1, i, s, r) {
                return new Zn(this, e1, t1, i, s, r);
            }
            createRenderbuffer(e1, t1, i) {
                const s = this.gl, r = s.createRenderbuffer();
                return this.bindRenderbuffer.set(r), s.renderbufferStorage(s.RENDERBUFFER, e1, t1, i), this.bindRenderbuffer.set(null), r;
            }
            createFramebuffer(e1, t1, i, s) {
                return new $n(this, e1, t1, i, s);
            }
            clear({ color: e1, depth: t1, stencil: i, colorMask: s }) {
                const r = this.gl;
                let o = 0;
                e1 && (o |= r.COLOR_BUFFER_BIT, this.clearColor.set(e1.toNonPremultipliedRenderColor(null)), this.colorMask.set(s || [
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t1 && (o |= r.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t1), this.depthMask.set(!0)), void 0 !== i && (o |= r.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), r.clear(o);
            }
            setCullFace(e1) {
                !1 === e1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
            }
            setDepthMode(e1) {
                e1.func !== this.gl.ALWAYS || e1.mask ? (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e1) {
                e1.test.func !== this.gl.ALWAYS || e1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
                    e1.fail,
                    e1.depthFail,
                    e1.pass
                ]), this.stencilFunc.set({
                    func: e1.test.func,
                    ref: e1.ref,
                    mask: e1.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(t1) {
                e1.O(t1.blendFunction, e1.a1.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(t1.blendFunction), this.blendColor.set(t1.blendColor), t1.blendEquation ? this.blendEquation.set(t1.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(t1.mask);
            }
            unbindVAO() {
                this.bindVertexArrayOES.set(null);
            }
        }
        const Wn = e1.Y();
        function Xn(t1) {
            const i = t1._camera.getWorldToCamera(t1.worldSize, 1), s = e1.X([], i, t1.globeMatrix);
            e1.aO(s, s);
            const r = [
                0,
                0,
                0
            ], o = [
                0,
                1,
                0,
                0
            ];
            return e1.c7(o, o, s), r[0] = o[0], r[1] = o[1], r[2] = o[2], e1.c3(r, r), r;
        }
        function Kn({ width: t1, height: i, anchor: s, textOffset: r, textScale: o }, n) {
            const { horizontalAlign: a, verticalAlign: l } = e1.cM(s), c = -(a - .5) * t1, h = -(l - .5) * i, d = e1.cN(s, r);
            return new e1.P((c / o + d[0]) * n, (h / o + d[1]) * n);
        }
        function Yn(t1, i, s, r, o, n, a, l, c, h) {
            const d = t1.text.placedSymbolArray, u = t1.text.dynamicLayoutVertexArray, p = t1.icon.dynamicLayoutVertexArray, f = {}, m = t1.getProjection(), _ = vt(a, m, o), g = o.elevation, y = m.upVectorScale(a.canonical, o.center.lat, o.worldSize).metersToTile;
            u.clear();
            for(let p = 0; p < d.length; p++){
                const v = d.get(p), { tileAnchorX: b, tileAnchorY: x, numGlyphs: w } = v, T = v.hidden || !v.crossTileID || t1.allowVerticalPlacement && !v.placedOrientation ? null : r[v.crossTileID];
                if (T) {
                    let r = 0, d = 0, S = 0;
                    const C = "road" === t1.elevationType;
                    if (g || C) {
                        const i = new e1.P(b, x);
                        let s = 0;
                        if (C && t1.hdExt) {
                            const r = t1.symbolInstances.get(t1.text.symbolInstanceIndices[p]);
                            if (t1.hdExt.isCrossTileRoadElevation(r.elevationFeatureIndex, a.canonical)) {
                                const e1 = t1.hdExt.getRoadFeatureHeightForPlacedSymbol(t1, t1.text, p, i, a.canonical);
                                s = null !== e1 ? e1 : 0;
                            } else {
                                const r = t1.hdExt.getElevationFeatureForPlacedSymbol(t1, t1.text, p);
                                s = e1.cW.getAtTileOffset(a, i, g, void 0 !== r ? r : null);
                            }
                        } else s = e1.cW.getAtTileOffset(a, i, g, null);
                        const [o, n, l] = m.upVector(a.canonical, b, x);
                        r = s * o * y, d = s * n * y, S = s * l * y;
                    }
                    let [E, I, D, P] = e1.cX(v.projectedAnchorX + r, v.projectedAnchorY + d, v.projectedAnchorZ + S, s ? _ : n);
                    const L = e1.dZ(o.getCameraToCenterDistance(m), P);
                    let R = e1.d4(t1.textSizeData, c, v) * L / e1.d1;
                    s && (R *= t1.tilePixelRatio / l);
                    const A = Kn(T, R);
                    s ? ({ x: E, y: I, z: D } = m.projectTilePoint(b + A.x, x + A.y, a.canonical), [E, I, D] = e1.cX(E + r, I + d, D + S, n)) : (i && A._rotate(-o.angle), E += A.x, I += A.y, D = 0);
                    const M = t1.allowVerticalPlacement && v.placedOrientation === e1.cL.vertical ? Math.PI / 2 : 0;
                    for(let t1 = 0; t1 < w; t1++)e1.d_(u, E, I, D, M);
                    h && v.associatedIconIndex >= 0 && (f[v.associatedIconIndex] = {
                        x: E,
                        y: I,
                        z: D,
                        angle: M
                    });
                } else e1.dY(w, u);
            }
            if (h) {
                p.clear();
                const i = t1.icon.placedSymbolArray;
                for(let t1 = 0; t1 < i.length; t1++){
                    const s = i.get(t1), { numGlyphs: r } = s, o = f[t1];
                    if (s.hidden || !o) e1.dY(r, p);
                    else {
                        const { x: t1, y: i, z: s, angle: n } = o;
                        for(let o = 0; o < r; o++)e1.d_(p, t1, i, s, n);
                    }
                }
                t1.icon.dynamicLayoutVertexBuffer.updateData(p);
            }
            t1.text.dynamicLayoutVertexBuffer.updateData(u);
        }
        function Qn(t1, i, s, r, o, n, a = {}) {
            const l = s.paint.get("icon-translate"), c = s.paint.get("text-translate"), h = s.paint.get("icon-translate-anchor"), d = s.paint.get("text-translate-anchor"), u = s.layout.get("icon-rotation-alignment"), p = s.layout.get("text-rotation-alignment"), f = s.layout.get("icon-pitch-alignment"), m = s.layout.get("text-pitch-alignment"), _ = s.layout.get("icon-keep-upright"), g = s.layout.get("text-keep-upright"), y = s.paint.get("icon-color-saturation"), v = s.paint.get("icon-color-contrast"), b = s.paint.get("icon-color-brightness-min"), x = s.paint.get("icon-color-brightness-max"), w = "sea" === s.layout.get("symbol-elevation-reference"), T = "none" === s.layout.get("icon-image-use-theme"), S = t1.context, C = S.gl, E = t1.transform, I = "map" === u, D = "map" === p, P = "map" === f, L = "map" === m, R = void 0 !== s.layout.get("symbol-sort-key").constantOr(1);
            let A = !1;
            const M = t1.depthModeForSublayer(0, e1.Z.ReadOnly), F = new e1.Z(t1.context.gl.LEQUAL, e1.Z.ReadOnly, t1.depthRangeFor3D), O = [
                e1.a7(E.center.lng),
                e1.a8(E.center.lat)
            ], B = s.layout.get("text-variable-anchor"), k = "globe" === E.projection.name, z = [], U = [
                0,
                -1,
                0
            ];
            for (const o of r){
                const r = i.getTile(o), n = r.getBucket(s);
                if (!n) continue;
                if ("mercator" === n.projection.name && k) continue;
                if (n.fullyClipped) continue;
                const u = "globe" === n.projection.name, p = u ? e1.S(E.zoom) : 0, f = vt(o, n.getProjection(), E), m = E.calculatePixelsToTileUnitsMatrix(r), N = B && n.hasTextData(), j = n.hasIconTextFit() && N && n.hasIconData(), V = n.getProjection().createInversionMatrix(E, o.canonical), G = (1 << r.tileID.canonical.z) * e1.a2 / t1.transform.worldSize, q = (i)=>{
                    let s = [
                        0,
                        0,
                        0
                    ];
                    if (i) {
                        const i = t1.style.directionalLight, r = t1.style.ambientLight;
                        i && r && (s = e1.aF(t1.style, i, r));
                    }
                    return s;
                }, Z = (e1)=>{
                    const i = Math.floor(t1.context.maxUniformBlockSize / 4), s = Math.floor(i / 4);
                    e1.push(`MAX_UBO_SIZE_VEC4 ${s}u`);
                }, $ = (e1)=>{
                    E.depthOcclusionForSymbolsAndCircles && (s.hasOcclusionOpacityProperties || t1.terrain) && (e1.push("DEPTH_D24"), e1.push("DEPTH_OCCLUSION"));
                }, H = (i)=>{
                    s.lut && !T && (s.lut.texture || (s.lut.texture = new e1.e0(t1.context, s.lut.image, [
                        s.lut.image.height,
                        s.lut.image.height,
                        s.lut.image.height
                    ], S.gl.RGBA8)), S.activeTexture.set(S.gl.TEXTURE0 + e1.dP.LUT), s.lut.texture && s.lut.texture.bind(S.gl.LINEAR, S.gl.CLAMP_TO_EDGE), i.push("APPLY_LUT_ON_GPU"));
                }, W = ()=>{
                    const i = I && "point" !== s.layout.get("symbol-placement"), a = [];
                    $(a), H(a);
                    const c = i || j, d = "road" === n.elevationType, g = t1.shadowRenderer, T = d && P && !!g && g.enabled, S = q(T), D = d && P && !t1.terrain ? F : M, L = s.paint.get("icon-image-cross-fade");
                    t1.terrainRenderModeElevated() && P && a.push("PITCH_WITH_MAP_TERRAIN"), u && (a.push("PROJECTION_GLOBE_VIEW"), c && a.push("PROJECTED_POS_ON_VIEWPORT")), L > 0 && n.hasAnySecondaryIcon && a.push("ICON_TRANSITION"), !n.icon.zOffsetVertexBuffer || d && t1.terrain || a.push("Z_OFFSET"), 0 === y && 0 === v && 0 === b && 1 === x || a.push("COLOR_ADJUSTMENT"), T && a.push("RENDER_SHADOWS", "NORMAL_OFFSET"), d && P && !t1.terrain && n.icon.orientationVertexBuffer && a.push("ELEVATED_ROADS"), Z(a);
                    const R = t1.getOrCreateProgram("symbol", {
                        defines: a
                    }), A = r.imageAtlasTexture ? r.imageAtlasTexture.size : [
                        0,
                        0
                    ], B = n.iconSizeData, z = e1.cG(B, E.zoom), N = P || !E.isOrthographic, W = e1.dX(f, r.tileID.canonical, P, I, E, n.getProjection(), m), X = e1.cF(f, r.tileID.canonical, P, I, E, n.getProjection(), m), K = n.icon.uboBinder && n.icon.uboBinder.hasPerFeatureTranslate() ? [
                        0,
                        0
                    ] : l, Y = t1.translatePosMatrix(X, r, K, h, !0), Q = t1.translatePosMatrix(f, r, K, h), J = c ? Wn : W, ee = I && !P && !i;
                    let te = U;
                    !k && !E.mercatorFromTransition || I || (te = Xn(E));
                    const ie = u ? te : U, se = s.getColorAdjustmentMatrix(y, v, b, x), re = Un(B.kind, z, ee, P, t1, Q, J, Y, w, !1, n.sdfIcons, A, [
                        0,
                        0
                    ], 0, o, p, O, V, ie, n.getProjection(), S, G, se, L, null), oe = r.imageAtlasTexture ? r.imageAtlasTexture : null, ne = 1 !== s.layout.get("icon-size").constantOr(0) || n.iconsNeedLinear, ae = n.sdfIcons || t1.options.rotating || t1.options.zooming || ne || N ? C.LINEAR : C.NEAREST, le = n.sdfIcons && 0 !== s.paint.get("icon-halo-width").constantOr(1), ce = t1.terrain && P && i ? e1.aO(e1.Y(), W) : Wn;
                    if (i && n.icon) {
                        const i = e1.cW.getAtTileOffsetFunc(o, E.center.lat, E.worldSize, n.getProjection()), a = e1.cE(f, r.tileID.canonical, P, I, E, n.getProjection(), m), l = s.layout.get("icon-size-scale-range"), c = e1.b0(t1.scaleFactor, l[0], l[1]);
                        e1.d$(n, f, t1, !1, a, X, P, _, i, o, c);
                    }
                    return {
                        program: R,
                        buffers: n.icon,
                        uniformValues: re,
                        atlasTexture: oe,
                        atlasTextureIcon: null,
                        atlasInterpolation: ae,
                        atlasInterpolationIcon: null,
                        isSDF: n.sdfIcons,
                        hasHalo: le,
                        depthMode: D,
                        tile: r,
                        renderWithShadows: T,
                        labelPlaneMatrixInv: ce
                    };
                }, X = ()=>{
                    const i = D && "point" !== s.layout.get("symbol-placement"), a = [], l = i || B || j, h = "road" === n.elevationType, _ = t1.shadowRenderer, y = h && L && !!_ && _.enabled, v = q(y), b = h && L && !t1.terrain ? F : M;
                    t1.terrainRenderModeElevated() && L && a.push("PITCH_WITH_MAP_TERRAIN"), u && (a.push("PROJECTION_GLOBE_VIEW"), l && a.push("PROJECTED_POS_ON_VIEWPORT")), !n.text.zOffsetVertexBuffer || h && t1.terrain || a.push("Z_OFFSET"), n.iconsInText && a.push("RENDER_TEXT_AND_SYMBOL"), y && a.push("RENDER_SHADOWS", "NORMAL_OFFSET"), h && L && !t1.terrain && n.text.orientationVertexBuffer && a.push("ELEVATED_ROADS"), $(a), Z(a);
                    const x = t1.getOrCreateProgram("symbol", {
                        defines: a
                    });
                    let T, S = [
                        0,
                        0
                    ], I = null;
                    const P = n.textSizeData;
                    n.iconsInText && (S = r.imageAtlasTexture ? r.imageAtlasTexture.size : [
                        0,
                        0
                    ], I = r.imageAtlasTexture ? r.imageAtlasTexture : null, T = L || !E.isOrthographic || t1.options.rotating || t1.options.zooming || "composite" === P.kind || "camera" === P.kind ? C.LINEAR : C.NEAREST);
                    const R = r.glyphAtlasTexture ? r.glyphAtlasTexture.size : [
                        0,
                        0
                    ], A = s.layout.get("text-size-scale-range"), z = e1.b0(t1.scaleFactor, A[0], A[1]), N = e1.cG(P, E.zoom, z), H = e1.dX(f, r.tileID.canonical, L, D, E, n.getProjection(), m), W = e1.cF(f, r.tileID.canonical, L, D, E, n.getProjection(), m), X = n.text.uboBinder && n.text.uboBinder.hasPerFeatureTranslate() ? [
                        0,
                        0
                    ] : c, K = t1.translatePosMatrix(W, r, X, d, !0), Y = t1.translatePosMatrix(f, r, X, d), Q = l ? Wn : H, J = D && !L && !i;
                    let ee = U;
                    !k && !E.mercatorFromTransition || D || (ee = Xn(E));
                    const te = Un(P.kind, N, J, L, t1, Y, Q, K, w, !0, !0, R, S, 0, o, p, O, V, u ? ee : U, n.getProjection(), v, G, null, null, z), ie = r.glyphAtlasTexture ? r.glyphAtlasTexture : null, se = C.LINEAR, re = 0 !== s.paint.get("text-halo-width").constantOr(1), oe = t1.terrain && L && i ? e1.aO(e1.Y(), H) : Wn;
                    if (i && n.text) {
                        const i = e1.cW.getAtTileOffsetFunc(o, E.center.lat, E.worldSize, n.getProjection()), s = e1.cE(f, r.tileID.canonical, L, D, E, n.getProjection(), m);
                        e1.d$(n, f, t1, !0, s, W, L, g, i, o, z);
                    }
                    return {
                        program: x,
                        buffers: n.text,
                        uniformValues: te,
                        atlasTexture: ie,
                        atlasTextureIcon: I,
                        atlasInterpolation: se,
                        atlasInterpolationIcon: T,
                        isSDF: !0,
                        hasHalo: re,
                        depthMode: b,
                        tile: r,
                        renderWithShadows: y,
                        labelPlaneMatrixInv: oe
                    };
                }, K = n.icon.segments.get().length, Y = n.text.segments.get().length, Q = K && !a.onlyText ? W() : null, J = Y && !a.onlyIcons ? X() : null, ee = s.paint.get("icon-opacity").constantOr(1), te = s.paint.get("text-opacity").constantOr(1);
                if (R && n.canOverlap) {
                    A = !0;
                    const t1 = ee && !a.onlyText ? n.icon.segments.get() : [], i = te && !a.onlyIcons ? n.text.segments.get() : [];
                    for (const i of t1)z.push({
                        segments: new e1.ac([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: Q
                    });
                    for (const t1 of i)z.push({
                        segments: new e1.ac([
                            t1
                        ]),
                        sortKey: t1.sortKey,
                        state: J
                    });
                } else a.onlyText || z.push({
                    segments: ee ? n.icon.segments : new e1.ac([]),
                    sortKey: 0,
                    state: Q
                }), a.onlyIcons || z.push({
                    segments: te ? n.text.segments : new e1.ac([]),
                    sortKey: 0,
                    state: J
                });
            }
            A && z.sort((e1, t1)=>e1.sortKey - t1.sortKey);
            for (const e1 of z){
                const i = e1.state;
                if (i) {
                    if (t1.terrain ? t1.terrain.setupElevationDraw(i.tile, i.program, {
                        useDepthForOcclusion: E.depthOcclusionForSymbolsAndCircles,
                        labelPlaneMatrixInv: i.labelPlaneMatrixInv
                    }) : t1.setupDepthForOcclusion(E.depthOcclusionForSymbolsAndCircles, i.program), S.activeTexture.set(C.TEXTURE0), i.atlasTexture && i.atlasTexture.bind(i.atlasInterpolation, C.CLAMP_TO_EDGE, !0), i.atlasTextureIcon && (S.activeTexture.set(C.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, C.CLAMP_TO_EDGE, !0)), i.renderWithShadows && t1.shadowRenderer.setupShadows(i.tile.tileID.toUnwrapped(), i.program, "vector-tile"), t1.uploadCommonLightUniforms(t1.context, i.program), i.hasHalo) {
                        const r = i.uniformValues;
                        r.u_is_halo = 1, Jn(i.buffers, e1.segments, s, t1, i.program, i.depthMode, o, n, r, 2), r.u_is_halo = 0;
                    } else {
                        if (i.isSDF) {
                            const r = i.uniformValues;
                            i.hasHalo && (r.u_is_halo = 1, Jn(i.buffers, e1.segments, s, t1, i.program, i.depthMode, o, n, r, 1)), r.u_is_halo = 0;
                        }
                        Jn(i.buffers, e1.segments, s, t1, i.program, i.depthMode, o, n, i.uniformValues, 1);
                    }
                }
            }
        }
        function Jn(t1, i, s, r, o, n, a, l, c, h) {
            const d = r.context, u = d.gl, p = [
                t1.dynamicLayoutVertexBuffer,
                t1.opacityVertexBuffer,
                t1.iconTransitioningVertexBuffer,
                t1.globeExtVertexBuffer,
                t1.zOffsetVertexBuffer,
                t1.orientationVertexBuffer
            ];
            t1.featureIdBuffer && p.push(t1.featureIdBuffer);
            const f = t1.uboBinder ? null : t1.programConfigurations.get(s.id);
            if (t1.uboBinder) {
                t1.uboBinder.layer = s;
                const e1 = r.transform.zoom, i = r.style.getBrightness ? r.style.getBrightness() : null, o = t1.uboBinder.getConstantUniformValues(e1, i);
                c.u_spp_fill_np_color = o.fill_np_color, c.u_spp_halo_np_color = o.halo_np_color, c.u_spp_opacity = o.opacity, c.u_spp_halo_width = o.halo_width, c.u_spp_halo_blur = o.halo_blur, c.u_spp_emissive_strength = o.emissive_strength, c.u_spp_occlusion_opacity = o.occlusion_opacity, c.u_spp_z_offset = o.z_offset, c.u_spp_zoom_fraction = e1 - t1.uboBinder._floorZoom;
                const n = s.paint.get(t1.uboBinder.isText ? "text-translate-anchor" : "icon-translate-anchor"), a = t1.uboBinder.hasPerFeatureTranslate() && "map" === n ? r.transform.angle : 0;
                c.u_spp_translate_rotation = [
                    Math.cos(a),
                    Math.sin(a)
                ];
            }
            const { batchIndices: m, batchSegments: _ } = t1.getBatchGrouping(i);
            for (const i of m){
                const m = _.get(i);
                t1.uboBinder && t1.uboBinder.bind(d, o.program, i), o.draw(r, u.TRIANGLES, n, a, l, e1.$.disabled, c, s.id, t1.layoutVertexBuffer, t1.indexBuffer, m, s.paint, r.transform.zoom, f, p, h);
            }
        }
        function ea(t1, i, s, r, o, n) {
            const a = s.paint.get("line-width"), l = s.paint.get("line-emissive-strength").isConstant(), c = s.paint.get("line-emissive-strength").constantOr(0), h = s.paint.get("line-occlusion-opacity"), d = s.layout.get("line-elevation-reference"), u = "meters" === s.layout.get("line-width-unit"), p = "sea" === d, f = !(!t1.terrain || !t1.terrain.enabled), m = t1.context, _ = m.gl;
            if (s.hasElevatedBuckets && "globe" === t1.transform.projection.name) return;
            const g = s.layout.get("line-cross-slope"), y = void 0 !== g, v = g < 1, b = o || t1.colorModeForDrapableLayerRenderPass(l ? c : null), x = t1.terrain && t1.terrain.renderingToTexture || n, w = x ? 1 : e1.e.devicePixelRatio, T = s.paint.get("line-dasharray"), S = T.constantOr(1), C = s.layout.get("line-cap"), E = T.constantOr(null), I = C.constantOr(null), D = s.paint.get("line-pattern"), P = D.constantOr(1), L = s.paint.get("line-pattern-cross-fade"), R = D.constantOr(null), A = s.paint.get("line-opacity").constantOr(1);
            let M = !P && 1 !== A || t1.depthOcclusion && h > 0 && h < 1;
            const F = s.paint.get("line-gradient"), O = 0 !== s.paint.get("line-border-width").constantOr(1) ? s.paint.get("line-border-gradient") : null, B = P ? "linePattern" : "line", k = e1.e3(s);
            let z;
            if (x && t1.terrain && t1.terrain.clipOrMaskOverlapStencilType() && (M = !1), 0 !== h && t1.depthOcclusion) {
                const t1 = s.paint._values["line-opacity"];
                t1 && t1.value && "constant" === t1.value.kind ? z = t1.value : e1.w(`Occlusion opacity for layer ${s.id} is supported only when line-opacity isn't data-driven.`);
            }
            "constant" !== a.value.kind && !1 === a.value.isLineProgressConstant && k.push("VARIABLE_LINE_WIDTH");
            const U = s.paint.get("line-emissive-strength");
            P || "constant" === U.value.kind || !1 !== U.value.isLineProgressConstant || k.push("VARIABLE_LINE_EMISSIVE_STRENGTH"), t1._debugParams.showElevationIdDebug && k.push("DEBUG_ELEVATION_ID"), x && ("dual-source-blending" !== t1.emissiveMode || l ? "mrt-fallback" === t1.emissiveMode && k.push("USE_MRT1") : k.push("DUAL_SOURCE_BLENDING"));
            const N = {}, j = [], V = (r, o, n, a, l, c)=>{
                for (const d of r){
                    const r = i.getTile(d);
                    if (P && !r.patternsLoaded()) continue;
                    const p = r.getBucket(s);
                    if (!p) continue;
                    if ("none" !== p.elevationType && !l || "none" === p.elevationType && l) continue;
                    t1.prepareDrawTile();
                    const f = [
                        ...o
                    ], g = "road" === p.elevationType, y = t1.shadowRenderer, v = g && !!y && y.enabled;
                    let T = [
                        0,
                        0,
                        0
                    ];
                    if (v) {
                        const i = t1.style.directionalLight, s = t1.style.ambientLight;
                        i && s && (T = e1.aF(t1.style, i, s)), f.push("RENDER_SHADOWS", "NORMAL_OFFSET");
                    }
                    const C = p.programConfigurations.get(s.id);
                    let D = !1;
                    if (R && r.imageAtlas) {
                        const t1 = e1.aG.from(R), i = t1.getPrimary().scaleSelf(w).toString(), s = r.imageAtlas.patternPositions.get(i), o = t1.getSecondary(), n = o ? r.imageAtlas.patternPositions.get(o.scaleSelf(w).toString()) : null;
                        D = !!s && !!n, s && C.setConstantPatternPositions(s, n);
                    }
                    L > 0 && (D || C.getPatternTransitionVertexBuffer("line-pattern")) && f.push("LINE_PATTERN_TRANSITION"), p.elevationGroundScaleVertexBuffer && f.push("ELEVATION_GROUND_SCALE");
                    const k = t1.isTileAffectedByFog(d), U = t1.getOrCreateProgram(B, {
                        config: C,
                        defines: f,
                        overrideFog: k
                    });
                    if (!P && E && I && r.lineAtlas) {
                        const e1 = r.lineAtlas.getDash(E, I);
                        e1 && C.setConstantPatternPositions(e1);
                    }
                    v && y.setupShadows(r.tileID.toUnwrapped(), U, "vector-tile");
                    let [V, G] = s.paint.get("line-trim-offset");
                    if ("round" === I || "square" === I) {
                        const e1 = 1;
                        V !== G && (0 === V && (V -= e1), 1 === G && (G += e1));
                    }
                    const q = x ? d.projMatrix : null, Z = u ? 1 / p.tileToMeter / e1.c5(r, 1, t1.transform.zoom) : 1, $ = u ? 1 / p.tileToMeter / e1.c5(r, 1, Math.floor(t1.transform.zoom)) : 1, H = S ? s.paint._values["line-floorwidth"] : null;
                    let W;
                    if (H && "constant" === H.value.kind) {
                        const e1 = p.zoom;
                        e1 in N || (N[e1] = Math.max(.01, s.widthExpression().evaluate({
                            zoom: e1
                        }))), W = H.value.value;
                        const i = Math.floor(t1.transform.zoom);
                        H.value.value = N[e1] * Math.pow(2, i - r.tileID.overscaledZ);
                    }
                    const X = P ? e1.e4(t1, r, s, q, w, Z, $, [
                        V,
                        G
                    ], T, L) : e1.e5(t1, r, s, q, p.lineClipsArray.length, w, Z, $, [
                        V,
                        G
                    ], T), K = (r, o, n, a, l, c)=>{
                        let h = r.texture;
                        if (o !== r.version) {
                            let c = 256;
                            if (n) {
                                const s = i.getSource().maxzoom, r = d.canonical.z === s ? Math.ceil(1 << t1.transform.maxZoom - d.canonical.z) : 1;
                                c = e1.b0(e1.e6(p.maxLineLength / e1.a2 * 1024 * r), 256, m.maxTextureSize);
                            }
                            r.gradient = e1.e7({
                                expression: a,
                                evaluationKey: "lineProgress",
                                resolution: c,
                                image: r.gradient || void 0,
                                clips: p.lineClipsArray,
                                lut: l ? null : s.lut
                            }), r.texture ? r.texture.update(r.gradient) : r.texture = new e1.T(m, r.gradient, _.RGBA8), r.version = o, h = r.texture;
                        }
                        m.activeTexture.set(c), h.bind(n ? _.NEAREST : _.LINEAR, _.CLAMP_TO_EDGE);
                    };
                    F && K(p.gradients[s.id], s.gradientVersion, s.stepInterpolant, s.gradientExpression(), "none" === s.paint.get("line-gradient-use-theme").constantOr("default"), _.TEXTURE1), O && K(p.borderGradients[s.id], s.borderGradientVersion, s.borderStepInterpolant, s.borderGradientExpression(), "none" === s.paint.get("line-border-gradient-use-theme").constantOr("default"), _.TEXTURE2), S && (m.activeTexture.set(_.TEXTURE0), r.lineAtlasTexture && r.lineAtlasTexture.bind(_.LINEAR, _.REPEAT), C.updatePaintBuffers()), P && (m.activeTexture.set(_.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(_.LINEAR, _.CLAMP_TO_EDGE), C.updatePaintBuffers()), l && !g && t1.terrain.setupElevationDraw(r, U), t1.uploadCommonUniforms(m, U, d.toUnwrapped());
                    const Y = Xs.drawLineFrcCoverageDetect ? Xs.drawLineFrcCoverageDetect(t1, p, d, l, X, C, U, n, b, j) : null, Q = (i, r, o)=>{
                        r && 0 !== r.get().length && (null != z && (z.value = A * h), void 0 !== o && (X.u_opacity_multiplier = o), U.draw(t1, _.TRIANGLES, n, i, b, e1.$.disabled, X, s.id, p.layoutVertexBuffer, p.indexBuffer, r, s.paint, t1.transform.zoom, C, [
                            p.layoutVertexBuffer2,
                            p.patternVertexBuffer,
                            p.zOffsetVertexBuffer,
                            p.elevationIdColVertexBuffer,
                            p.elevationGroundScaleVertexBuffer
                        ]), void 0 !== o && (X.u_opacity_multiplier = 1), null != z && (z.value = A));
                    }, J = (e1)=>{
                        Y && Y.active && Xs.drawLineFrcRenderLine ? Xs.drawLineFrcRenderLine(p, Y, e1, Q) : Q(e1, p.segments);
                    };
                    if (M && !l) {
                        const i = t1.stencilModeForClipping(d).ref;
                        0 === i && x && m.clear({
                            stencil: 0
                        });
                        const s = {
                            func: _.EQUAL,
                            mask: 255
                        };
                        X.u_alpha_discard_threshold = .8, J(new e1._(s, i, 255, _.KEEP, _.KEEP, _.INVERT)), X.u_alpha_discard_threshold = 0, J(new e1._(s, i, 255, _.KEEP, _.KEEP, _.KEEP));
                    } else X.u_alpha_discard_threshold = M && l && c ? .8 : 0, J(l ? a : t1.stencilModeForClipping(d));
                    Y && Xs.drawLineFrcFadePass && Xs.drawLineFrcFadePass(t1, p, d, Y, l, a, Q), void 0 !== W && (H.value.value = W);
                }
            };
            let G = t1.depthModeForSublayer(0, e1.Z.ReadOnly);
            const q = new e1.Z(t1.depthOcclusion ? _.GREATER : _.LEQUAL, e1.Z.ReadOnly, t1.depthRangeFor3D);
            if (s.hasNonElevatedBuckets) {
                const i = !x && t1.terrain;
                0 !== h && i ? e1.w(`Occlusion opacity for layer ${s.id} is supported on terrain only if the layer has line-z-offset enabled.`) : i ? e1.w(`Cannot render non-elevated lines in immediate mode when terrain is enabled. Layer: ${s.id}.`) : V(r, k, G, e1._.disabled, !1, !0);
            }
            if (s.hasElevatedBuckets) {
                "hd-road-markup" === d ? f || (G = q, k.push("ELEVATED_ROADS")) : (k.push("ELEVATED"), G = q, y && k.push(v ? "CROSS_SLOPE_HORIZONTAL" : "CROSS_SLOPE_VERTICAL"), p && k.push("ELEVATION_REFERENCE_SEA"));
                const i = M ? t1.stencilModeFor3D() : e1._.disabled;
                "hd-road-markup" !== d && (t1.forceTerrainMode = !0), V(r, k, G, i, !0, !0), M && V(r, k, G, i, !0, !1), "hd-road-markup" !== d && (t1.forceTerrainMode = !1);
            }
            Xs.drawLineFrcCoverageSecondPass && Xs.drawLineFrcCoverageSecondPass(t1, s, j), M && (t1.resetStencilClippingMasks(), x && m.clear({
                stencil: 0
            })), 0 === h || t1.depthOcclusion || x || t1.layersWithOcclusionOpacity.push(t1.currentLayer);
        }
        class ta {
            destroy() {
                this.fbo && (this.fbo.destroy(), this.fbo = null), this.drapeFbo && (this.drapeFbo.destroy(), this.drapeFbo = null);
            }
        }
        class ia {
            constructor(e1){
                this.pbo = e1.createBuffer(), this.sync = null, this.fboA = null, this.fboB = null, this.maxDensity = 0;
            }
            destroy(e1) {
                this.sync && (e1.deleteSync(this.sync), this.sync = null), e1.deleteBuffer(this.pbo), this.fboA && (this.fboA.destroy(), this.fboA = null), this.fboB && (this.fboB.destroy(), this.fboB = null);
            }
        }
        const sa = {
            additive: {
                clearColor: new e1.C(0, 0, 0, 0),
                colorMode: e1.a1.additiveAlphaWeighted,
                compositeUniformValue: 1
            },
            multiply: {
                clearColor: new e1.C(1, 1, 1, 1),
                colorMode: e1.a1.multiply,
                compositeUniformValue: 0
            }
        };
        function ra(e1) {
            return !(!e1.extRenderToTextureHalfFloat && !e1.extColorBufferFloat);
        }
        function oa(t1, i) {
            return "additive" === t1 && ra(i) ? e1.a1.additiveAlphaWeightedUnboundedAlpha : sa[t1].colorMode;
        }
        function na(t1, i, s) {
            const r = t1.context, o = r.gl;
            let n = s.width, a = s.height, l = s.colorAttachment0.get();
            i.lineBlendDensityReadback || (i.lineBlendDensityReadback = new ia(o));
            const c = i.lineBlendDensityReadback;
            let h = 0, d = !0;
            for(; n > 1 || a > 1;){
                const s = Math.max(1, Math.floor(n / 2)), u = Math.max(1, Math.floor(a / 2)), p = 0 === h ? "fboA" : "fboB";
                c[p] = $n.createWithTexture(r, c[p], s, u, !1);
                const f = c[p];
                r.bindFramebuffer.set(f.framebuffer), r.viewport.set([
                    0,
                    0,
                    s,
                    u
                ]), r.activeTexture.set(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, l), t1.getOrCreateProgram("lineBlendReduce").draw(t1, o.TRIANGLES, e1.Z.disabled, e1._.disabled, e1.a1.unblended, e1.$.disabled, An(0, [
                    1 / n,
                    1 / a
                ], d), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom), n = s, a = u, l = f.colorAttachment0.get(), h = 1 - h, d = !1;
            }
            const u = ra(r), p = u ? 16 : 4;
            c.sync && (o.deleteSync(c.sync), c.sync = null), o.bindBuffer(o.PIXEL_PACK_BUFFER, c.pbo), o.bufferData(o.PIXEL_PACK_BUFFER, p, o.STREAM_READ), o.readPixels(0, 0, 1, 1, o.RGBA, u ? o.FLOAT : o.UNSIGNED_BYTE, 0), o.bindBuffer(o.PIXEL_PACK_BUFFER, null), c.sync = o.fenceSync(o.SYNC_GPU_COMMANDS_COMPLETE, 0), r.viewport.set([
                0,
                0,
                t1.width,
                t1.height
            ]);
        }
        function aa(e1, t1, i) {
            if (!ra(e1.context)) return;
            const s = t1.lineBlendDensityReadback;
            s && s.sync ? (function(e1, t1, i) {
                if (e1.sync && t1.getSyncParameter(e1.sync, t1.SYNC_STATUS) === t1.SIGNALED) {
                    if (t1.deleteSync(e1.sync), e1.sync = null, t1.bindBuffer(t1.PIXEL_PACK_BUFFER, e1.pbo), ra(i)) {
                        const i = new Float32Array(4);
                        t1.getBufferSubData(t1.PIXEL_PACK_BUFFER, 0, i);
                        const s = i[1];
                        e1.maxDensity = Math.max(2 * (s > 0 ? i[0] / s : 0), 1);
                    } else e1.maxDensity = 1;
                    t1.bindBuffer(t1.PIXEL_PACK_BUFFER, null);
                }
            }(s, e1.context.gl, e1.context), s.sync || (na(e1, t1, i), e1.style.map.triggerRepaint())) : (na(e1, t1, i), e1.style.map.triggerRepaint());
        }
        function la(t1, i, s, r, o, n) {
            const a = t1.context, l = a.gl, c = "additive" === s ? 1 : i.paint.get("line-opacity").constantOr(1), h = "additive" === s ? function(e1, t1) {
                const i = t1.paint.get("line-blend-additive-clamp");
                if (i > 0) return i;
                const s = t1.lineBlendDensityReadback;
                return s && 0 !== s.maxDensity ? s.maxDensity : null;
            }(0, i) : 1;
            if (null === h) return;
            a.bindFramebuffer.set(o), n && a.viewport.set([
                0,
                0,
                n[0],
                n[1]
            ]), a.activeTexture.set(l.TEXTURE0), l.bindTexture(l.TEXTURE_2D, r.colorAttachment0.get());
            const d = oa(s, t1.context);
            t1.getOrCreateProgram("lineBlendComposite").draw(t1, l.TRIANGLES, e1.Z.disabled, e1._.disabled, d, e1.$.disabled, ((e1, t1, i, s)=>({
                    u_image: 0,
                    u_opacity: t1,
                    u_blend_mode: i,
                    u_max_density: s
                }))(0, c, sa[s].compositeUniformValue, h), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom);
        }
        function ca(t1, i, s, r) {
            const { painter: o, sourceCache: n, layer: a, coords: l, colorMode: c, elevationType: h, terrainEnabled: d, pass: u } = t1, p = o.context.gl, f = a.paint.get("fill-pattern"), m = a.paint.get("fill-pattern-cross-fade"), _ = f.constantOr(null);
            let g = h;
            "road" !== h || i && !d || (g = "none");
            const y = "road" === g, v = t1.painter.shadowRenderer, b = y && !!v && v.enabled, x = new e1.Z(o.context.gl.LEQUAL, e1.Z.ReadOnly, o.depthRangeFor3D);
            let w = [
                0,
                0,
                0
            ];
            if (b) {
                const t1 = o.style.directionalLight, i = o.style.ambientLight;
                t1 && i && (w = e1.aF(o.style, t1, i));
            }
            const T = f && f.constantOr(1), S = o.terrain && o.terrain.renderingToTexture, C = (t1, u)=>{
                let f, g, C, E, I;
                u ? (f = T && !a.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", C = p.LINES) : (f = T ? "fillPattern" : "fill", C = p.TRIANGLES);
                const D = [];
                for (const P of l){
                    const l = n.getTile(P);
                    if (T && !l.patternsLoaded()) continue;
                    const L = l.getBucket(a);
                    if (!L) continue;
                    const R = i ? L.hdExt && L.hdExt.elevationBufferData : L.bufferData;
                    if (!R || R.isEmpty()) continue;
                    o.prepareDrawTile();
                    const A = R.programConfigurations.get(a.id), M = o.isTileAffectedByFog(P), F = [], O = [];
                    y && (F.push("ELEVATED_ROADS"), O.push(R.elevatedLayoutVertexBuffer)), b && F.push("RENDER_SHADOWS", "NORMAL_OFFSET"), S && s && F.push("USE_MRT1"), T && (o.context.activeTexture.set(p.TEXTURE0), l.imageAtlasTexture && l.imageAtlasTexture.bind(p.LINEAR, p.CLAMP_TO_EDGE), A.updatePaintBuffers());
                    let B = !1;
                    if (_ && l.imageAtlas) {
                        const t1 = l.imageAtlas, i = e1.aG.from(_), s = i.getPrimary().scaleSelf(e1.e.devicePixelRatio).toString(), r = i.getSecondary(), o = t1.patternPositions.get(s), n = r ? t1.patternPositions.get(r.scaleSelf(e1.e.devicePixelRatio).toString()) : null;
                        B = !!o && !!n, o && A.setConstantPatternPositions(o, n);
                    }
                    m > 0 && (B || A.getPatternTransitionVertexBuffer("fill-pattern")) && F.push("FILL_PATTERN_TRANSITION");
                    const k = o.getOrCreateProgram(f, {
                        config: A,
                        overrideFog: M,
                        defines: F
                    }), z = o.translatePosMatrix(P.projMatrix, l, a.paint.get("fill-translate"), a.paint.get("fill-translate-anchor"));
                    b && v.setupShadows(l.tileID.toUnwrapped(), k, "vector-tile");
                    const U = a.paint.get("fill-emissive-strength");
                    if (u) {
                        E = R.lineIndexBuffer, I = R.lineSegments;
                        const e1 = o.terrain && o.terrain.renderingToTexture ? o.terrain.drapeBufferSize : [
                            p.drawingBufferWidth,
                            p.drawingBufferHeight
                        ];
                        g = "fillOutlinePattern" === f && T ? Rn(z, U, o, l, e1, w, m) : Ln(z, U, e1, w);
                    } else E = R.indexBuffer, I = R.triangleSegments, g = T ? Pn(z, U, o, l, w, m) : Dn(z, U, w);
                    o.uploadCommonUniforms(o.context, k, P.toUnwrapped());
                    let N = t1;
                    if (("road" === h && !d || "offset" === h) && (N = x), !I || I.get && 0 === I.get().length) continue;
                    const j = r || o.stencilModeForClipping(P);
                    let V = "fallthrough";
                    !u && Xs.drawFillFrcCoverageFirstPass && (V = Xs.drawFillFrcCoverageFirstPass({
                        painter: o,
                        layer: a,
                        bucket: L,
                        coord: P,
                        elevatedGeometry: i,
                        program: k,
                        programConfiguration: A,
                        uniformValues: g,
                        drawMode: C,
                        depthMode: N,
                        stencilMode: j,
                        colorMode: c,
                        bufferData: R,
                        indexBuffer: E,
                        segments: I,
                        dynamicBuffers: O,
                        polygonCoverageTiles: D
                    })), "fallthrough" === V && k.draw(o, C, N, j, c, e1.$.disabled, g, a.id, R.layoutVertexBuffer, E, I, a.paint, o.transform.zoom, A, O);
                }
                !u && Xs.drawFillFrcCoverageSecondPass && Xs.drawFillFrcCoverageSecondPass(o, a, D, C, c);
            };
            o.renderPass === u && C(o.depthModeForSublayer(1, "opaque" === o.renderPass ? e1.Z.ReadWrite : e1.Z.ReadOnly), !1), "none" === g && "translucent" === o.renderPass && a.paint.get("fill-antialias") && C(o.depthModeForSublayer(a.getPaintProperty("fill-outline-color") ? 2 : 0, e1.Z.ReadOnly), !0);
        }
        function ha(t1) {
            return [
                t1[0] * e1.e9,
                t1[1] * e1.e9,
                t1[2] * e1.e9,
                0
            ];
        }
        function da(t1, i, s, r, o, n, a, l, c) {
            const h = r.getSource(), d = s.globeSharedBuffers;
            if (!d) return;
            let u, p, f;
            if (i && (u = r.getTile(i)), h instanceof nr ? (p = h.texture, f = e1.dt(0, 0, s.transform)) : u && i && (p = u.texture, f = e1.dt(i.canonical.z, i.canonical.x, s.transform)), !p || !f) return;
            t1 || (f = e1.aN(e1.Y(), f, [
                1,
                -1,
                1
            ]));
            const m = s.context, _ = m.gl, g = "nearest" === o.paint.get("raster-resampling") ? _.NEAREST : _.LINEAR, y = s.colorModeForDrapableLayerRenderPass(n), v = a.defines;
            v.push("GLOBE_POLES");
            const b = new e1.Z(_.LEQUAL, e1.Z.ReadWrite, s.depthRangeFor3D), x = s.transform.expandedFarZProjMatrix, w = Float32Array.from(e1.b4(e1.b5(new e1.bX(0, 0, 0))));
            s.terrain && s.terrain.prepareDrawTile(), m.activeTexture.set(_.TEXTURE0), p.bind(g, _.CLAMP_TO_EDGE), m.activeTexture.set(_.TEXTURE1), p.bind(g, _.CLAMP_TO_EDGE), "useMipmap" in p && m.extTextureFilterAnisotropic && s.transform.pitch > 20 && _.texParameterf(_.TEXTURE_2D, m.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, m.extTextureFilterAnisotropicMax);
            const [T, S, C, E] = i ? d.getPoleBuffers(i.canonical.z, !1) : d.getPoleBuffers(0, !0), I = o.paint.get("raster-elevation");
            let D;
            t1 ? (D = T, s.renderDefaultNorthPole = 0 !== I) : (D = S, s.renderDefaultSouthPole = 0 !== I);
            const P = ha(a.mix), L = ((e1, t1, i, s, r, o, n, a, l, c, h, d, u, p)=>Bn(e1, t1, i, s, new Float32Array(16), new Float32Array(9), [
                    0,
                    0
                ], r, [
                    0,
                    0
                ], [
                    0,
                    0,
                    0,
                    0
                ], 1, {
                    opacity: 1,
                    mix: 0
                }, n, [
                    0,
                    0
                ], l, 2, h, d, u, 1, 0, p))(s, x, w, f, e1.S(s.transform.zoom), 0, o, 0, I, 0, P, a.offset, a.range, n), R = s.getOrCreateProgram("raster", {
                defines: v
            });
            s.uploadCommonUniforms(m, R, null), R.draw(s, _.TRIANGLES, b, c, y, l, L, o.id, D, C, E);
        }
        function ua(e1) {
            if (e1.isOrthographic) return [
                0,
                0,
                0,
                0
            ];
            const t1 = e1._nearZ, i = e1.projection.farthestPixelDistance(e1), s = i - t1, r = .2 * e1.height, o = t1 + r;
            return [
                t1,
                i,
                (o - r - t1) / s,
                (o - t1) / s
            ];
        }
        function pa(e1, t1, i, s) {
            if (e1) return "raster-array" === t1.type ? t1.getTextureDescriptor(e1, i, !0) : {
                texture: e1.texture,
                mix: ha(s.mix),
                offset: s.offset,
                buffer: 0,
                tileSize: 1
            };
        }
        const fa = e1.d0(new Float32Array(16)), ma = e1.a_([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), { members: _a } = ma;
        function ga(e1, t1, i, s) {
            e1.emplaceBack(t1, i, s);
        }
        class ya {
            constructor(t1){
                this.vertexArray = new e1.ea, this.indices = new e1.ad, ga(this.vertexArray, -1, -1, 1), ga(this.vertexArray, 1, -1, 1), ga(this.vertexArray, -1, 1, 1), ga(this.vertexArray, 1, 1, 1), ga(this.vertexArray, -1, -1, -1), ga(this.vertexArray, 1, -1, -1), ga(this.vertexArray, -1, 1, -1), ga(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t1.createVertexBuffer(this.vertexArray, _a), this.indexBuffer = t1.createIndexBuffer(this.indices), this.segment = e1.ac.simpleSegment(0, 0, 36, 12);
            }
        }
        function va(t1, i, s, r, o, n) {
            const a = t1.context.gl, l = i.paint.get("sky-atmosphere-color"), c = i.paint.get("sky-atmosphere-halo-color"), h = i.paint.get("sky-atmosphere-sun-intensity"), d = ((e1, t1, i, s, r)=>({
                    u_matrix_3f: e1,
                    u_sun_direction: t1,
                    u_sun_intensity: i,
                    u_color_tint_r: [
                        s.r,
                        s.g,
                        s.b,
                        s.a
                    ],
                    u_color_tint_m: [
                        r.r,
                        r.g,
                        r.b,
                        r.a
                    ],
                    u_luminance: 5e-5
                }))(e1.ed(e1.ee(), r), o, h, l.toPremultipliedRenderColor(null), c.toPremultipliedRenderColor(null));
            a.framebufferTexture2D(a.FRAMEBUFFER, a.COLOR_ATTACHMENT0, a.TEXTURE_CUBE_MAP_POSITIVE_X + n, i.skyboxTexture, 0), s.draw(t1, a.TRIANGLES, e1.Z.disabled, e1._.disabled, e1.a1.unblended, e1.$.frontCW, d, "skyboxCapture", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
        }
        const ba = e1.a_([
            {
                type: "Float32",
                name: "a_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]);
        class xa {
            constructor(t1){
                const i = new e1.ef;
                i.emplaceBack(-1, 1, 1, 0, 0), i.emplaceBack(1, 1, 1, 1, 0), i.emplaceBack(1, -1, 1, 1, 1), i.emplaceBack(-1, -1, 1, 0, 1);
                const s = new e1.ad;
                s.emplaceBack(0, 1, 2), s.emplaceBack(2, 3, 0), this.vertexBuffer = t1.createVertexBuffer(i, ba.members), this.indexBuffer = t1.createIndexBuffer(s), this.segments = e1.ac.simpleSegment(0, 0, 4, 2);
            }
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
            }
        }
        const wa = e1.a_([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_size_scale",
                components: 1
            },
            {
                type: "Float32",
                name: "a_opacity",
                components: 1
            }
        ]);
        class Ta {
            constructor(){
                this.colorModeAlphaBlendedWriteRGB = new e1.a1([
                    e1.eg,
                    e1.eh,
                    e1.eg,
                    e1.eh
                ], e1.C.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ]), this.colorModeWriteAlpha = new e1.a1([
                    e1.eg,
                    e1.ei,
                    e1.eg,
                    e1.ei
                ], e1.C.transparent, [
                    !1,
                    !1,
                    !1,
                    !0
                ]), this.params = {
                    starsCount: 16e3,
                    sizeMultiplier: .15,
                    sizeRange: 100,
                    intensityRange: 200
                }, this.updateNeeded = !0, this._painter = null, this._devtoolsFolder = null;
            }
            update(t1) {
                this._painter = t1;
                const i = t1.context;
                if (!this.atmosphereBuffer || this.updateNeeded) {
                    this.updateNeeded = !1, this.atmosphereBuffer = new xa(i);
                    let t1 = this.params;
                    const s = t1.sizeRange, r = t1.intensityRange, o = function(t1) {
                        const i = e1.bi(30), s = [];
                        for(let r = 0; r < t1; ++r){
                            const t1 = 2 * Math.PI * i(), r = Math.acos(1 - 2 * i()) - .5 * Math.PI;
                            s.push(e1.bh(Math.cos(r) * Math.cos(t1), Math.cos(r) * Math.sin(t1), Math.sin(r)));
                        }
                        return s;
                    }(t1.starsCount), n = e1.bi(300), a = new e1.ej, l = new e1.ad;
                    let c = 0;
                    for(let t1 = 0; t1 < o.length; ++t1){
                        const i = e1.dB([], o[t1], 200), h = Math.max(0, 1 + .01 * s * (1 * n() - .5)), d = Math.max(0, 1 + .01 * r * (1 * n() - .5));
                        a.emplaceBack(i[0], i[1], i[2], -1, -1, h, d), a.emplaceBack(i[0], i[1], i[2], 1, -1, h, d), a.emplaceBack(i[0], i[1], i[2], 1, 1, h, d), a.emplaceBack(i[0], i[1], i[2], -1, 1, h, d), l.emplaceBack(c + 0, c + 1, c + 2), l.emplaceBack(c + 0, c + 2, c + 3), c += 4;
                    }
                    this.starsVx = i.createVertexBuffer(a, wa.members), this.starsIdx = i.createIndexBuffer(l), this.starsSegments = e1.ac.simpleSegment(0, 0, a.length, l.length);
                }
            }
            destroy() {
                this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy(), this._painter = null;
            }
            drawAtmosphereGlow(t1, i) {
                const s = t1.context, r = s.gl, o = t1.transform, n = new e1.Z(r.LEQUAL, e1.Z.ReadOnly, [
                    0,
                    1
                ]), a = e1.S(o.zoom), l = t1.style.getLut(i.scope), c = "none" === i.properties.get("color-use-theme"), h = i.properties.get("color").toNonPremultipliedRenderColor(c ? null : l), d = "none" === i.properties.get("high-color-use-theme"), u = i.properties.get("high-color").toNonPremultipliedRenderColor(d ? null : l), p = "none" === i.properties.get("space-color-use-theme"), f = i.properties.get("space-color").toNonPremultipliedRenderColor(p ? null : l), m = 5e-4, _ = e1.ek(i.properties.get("horizon-blend"), 0, 1, m, .25), g = e1.ds(t1, s, o) && _ === m ? o.worldSize / (2 * Math.PI * 1.025) - 1 : o.globeRadius, y = t1.frameCounter / 1e3 % 1, v = e1.el(o.globeCenterInViewSpace), b = Math.sqrt(Math.pow(v, 2) - Math.pow(g, 2)), x = Math.acos(b / v), w = (i)=>{
                    const l = "globe" === o.projection.name ? [
                        "PROJECTION_GLOBE_VIEW",
                        "FOG"
                    ] : [
                        "FOG"
                    ];
                    i && l.push("ALPHA_PASS");
                    const c = t1.getOrCreateProgram("globeAtmosphere", {
                        defines: l
                    }), d = ((e1, t1, i, s, r, o, n, a, l, c, h, d)=>({
                            u_frustum_tl: e1,
                            u_frustum_tr: t1,
                            u_frustum_br: i,
                            u_frustum_bl: s,
                            u_horizon: r,
                            u_transition: o,
                            u_fadeout_range: n,
                            u_atmosphere_fog_color: a.toArray01(),
                            u_high_color: l.toArray01(),
                            u_space_color: c.toArray01(),
                            u_temporal_offset: h,
                            u_horizon_angle: d
                        }))(o.frustumCorners.TL, o.frustumCorners.TR, o.frustumCorners.BR, o.frustumCorners.BL, o.frustumCorners.horizon, a, _, h, u, f, y, x);
                    t1.uploadCommonUniforms(s, c);
                    const p = this.atmosphereBuffer;
                    p && c.draw(t1, r.TRIANGLES, n, e1._.disabled, i ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, e1.$.backCW, d, i ? "atmosphere_glow_alpha" : "atmosphere_glow", p.vertexBuffer, p.indexBuffer, p.segments);
                };
                w(!1), w(!0);
            }
            drawStars(t1, i) {
                const s = e1.b0(i.properties.get("star-intensity"), 0, 1);
                if (0 === s) return;
                const r = t1.context, o = r.gl, n = t1.transform, a = t1.getOrCreateProgram("stars"), l = e1.bd([]);
                e1.be(l, l, -n._pitch), e1.bf(l, l, -n.angle), e1.be(l, l, e1.au(n._center.lat)), e1.em(l, l, -e1.au(n._center.lng));
                const c = e1.bg(new Float32Array(16), l), h = e1.X([], n.starsProjMatrix, c), d = e1.ed([], c), u = e1.en([], d);
                let p = this.params.sizeMultiplier;
                const f = [
                    0,
                    1,
                    0
                ];
                e1.ct(f, f, u), e1.dB(f, f, p);
                const m = [
                    1,
                    0,
                    0
                ];
                e1.ct(m, m, u), e1.dB(m, m, p);
                const _ = (g = f, y = m, v = s, {
                    u_matrix: Float32Array.from(h),
                    u_up: g,
                    u_right: y,
                    u_intensity_multiplier: v
                });
                var g, y, v;
                t1.uploadCommonUniforms(r, a), this.starsVx && this.starsIdx && a.draw(t1, o.TRIANGLES, e1.Z.disabled, e1._.disabled, this.colorModeAlphaBlendedWriteRGB, e1.$.disabled, _, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
            }
        }
        class Sa {
        }
        class Ca {
            constructor(){
                this._storage = new Map;
            }
            getLinesFromTrianglesBuffer(t1, i, s) {
                {
                    const e1 = this._storage.get(i.id);
                    if (e1) return e1.lastUsedFrameIdx = t1, e1.buf;
                }
                const r = s.gl, o = r.getBufferParameter(r.ELEMENT_ARRAY_BUFFER, r.BUFFER_SIZE), n = new ArrayBuffer(o), a = new Int16Array(n);
                r.getBufferSubData(r.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(n));
                const l = new e1.eo;
                for(let e1 = 0; e1 < o / 2; e1 += 3){
                    const t1 = a[e1], i = a[e1 + 1], s = a[e1 + 2];
                    l.emplaceBack(t1, i), l.emplaceBack(i, s), l.emplaceBack(s, t1);
                }
                const c = s.bindVertexArrayOES.current, h = new Sa;
                return h.buf = new Gn(s, l), h.lastUsedFrameIdx = t1, this._storage.set(i.id, h), s.bindVertexArrayOES.set(c), h.buf;
            }
            update(e1) {
                for (const [t1, i] of this._storage)e1 - i.lastUsedFrameIdx > 30 && (i.buf.destroy(), this._storage.delete(t1));
            }
            destroy() {
                for (const [e1, t1] of this._storage)t1.buf.destroy(), this._storage.delete(e1);
            }
        }
        class Ea {
            constructor(){
                this.occluderSize = 30, this.depthOffset = -0.0001;
            }
        }
        const Ia = {
            symbol: function(t1, i, s, r, o) {
                if ("translucent" !== t1.renderPass) return;
                const n = e1._.disabled, a = t1.colorModeForRenderPass(), l = s.layout.get("text-variable-anchor"), c = s.layout.get("text-size-scale-range"), h = e1.b0(t1.scaleFactor, c[0], c[1]);
                l && function(t1, i, s, r, o, n, a, l) {
                    const c = i.transform, h = "map" === o, d = "map" === n;
                    for (const i of t1){
                        const t1 = r.getTile(i), o = t1.getBucket(s);
                        if (!o || !o.text || !o.text.segments.get().length) continue;
                        const n = e1.cG(o.textSizeData, c.zoom, l), u = vt(i, o.getProjection(), c), p = c.calculatePixelsToTileUnitsMatrix(t1), f = e1.dX(u, t1.tileID.canonical, d, h, c, o.getProjection(), p), m = o.hasIconTextFit() && o.hasIconData();
                        n && Yn(o, h, d, a, c, f, i, Math.pow(2, c.zoom - t1.tileID.overscaledZ), n, m);
                    }
                }(r, t1, s, i, s.layout.get("text-rotation-alignment"), s.layout.get("text-pitch-alignment"), o, h);
                const d = 0 !== s.paint.get("icon-opacity").constantOr(1), u = 0 !== s.paint.get("text-opacity").constantOr(1);
                void 0 !== s.layout.get("symbol-sort-key").constantOr(1) && (d || u) ? Qn(t1, i, s, r, n, a) : (d && Qn(t1, i, s, r, n, a, {
                    onlyIcons: !0
                }), u && Qn(t1, i, s, r, n, a, {
                    onlyText: !0
                })), i.map.showCollisionBoxes && xt.drawCollisionDebug && (xt.drawCollisionDebug(t1, i, s, r, s.paint.get("text-translate"), s.paint.get("text-translate-anchor"), !0), xt.drawCollisionDebug(t1, i, s, r, s.paint.get("icon-translate"), s.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(t1, i, s, r) {
                if ("translucent" !== t1.renderPass) return;
                const o = s.paint.get("circle-opacity"), n = s.paint.get("circle-stroke-width"), a = s.paint.get("circle-stroke-opacity"), l = void 0 !== s.layout.get("circle-sort-key").constantOr(1), c = s.paint.get("circle-emissive-strength");
                if (0 === o.constantOr(1) && (0 === n.constantOr(1) || 0 === a.constantOr(1))) return;
                const h = t1.context, d = h.gl, u = t1.transform, p = !(!t1.terrain || !t1.terrain.enabled), f = s.layout.get("circle-elevation-reference"), m = t1.depthModeForSublayer(0, e1.Z.ReadOnly), _ = new e1.Z(t1.context.gl.LEQUAL, e1.Z.ReadOnly, t1.depthRangeFor3D), g = "none" === f || p ? m : _, y = e1._.disabled, v = t1.colorModeForDrapableLayerRenderPass(c), b = "globe" === u.projection.name, x = [
                    e1.a7(u.center.lng),
                    e1.a8(u.center.lat)
                ], w = [];
                for(let o = 0; o < r.length; o++){
                    const n = r[o], a = i.getTile(n), c = a.getBucket(s);
                    if (!c || c.projection.name !== u.projection.name) continue;
                    const h = c.programConfigurations.get(s.id), d = c.layoutVertexBuffer, p = c.globeExtVertexBuffer, f = c.indexBuffer, m = e1.e1(s), _ = [
                        p
                    ], g = t1.isTileAffectedByFog(n);
                    b && m.push("PROJECTION_GLOBE_VIEW"), m.push("DEPTH_D24"), t1.terrain && u.depthOcclusionForSymbolsAndCircles && m.push("DEPTH_OCCLUSION"), c.hdExt && c.hdExt.hasElevation && !t1.terrain && (m.push("ELEVATED_ROADS"), _.push(c.hdExt.elevatedLayoutVertexBuffer));
                    const y = t1.getOrCreateProgram("circle", {
                        config: h,
                        defines: m,
                        overrideFog: g
                    }), v = u.projection.createInversionMatrix(u, n.canonical), T = {
                        programConfiguration: h,
                        program: y,
                        layoutVertexBuffer: d,
                        dynamicBuffers: _,
                        indexBuffer: f,
                        uniformValues: e1.e2(t1, n, a, v, x, s),
                        tile: a
                    };
                    if (l) {
                        const t1 = c.segments.get();
                        for (const i of t1)w.push({
                            segments: new e1.ac([
                                i
                            ]),
                            sortKey: i.sortKey,
                            state: T
                        });
                    } else w.push({
                        segments: c.segments,
                        sortKey: 0,
                        state: T
                    });
                }
                l && w.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                const T = {
                    useDepthForOcclusion: u.depthOcclusionForSymbolsAndCircles
                };
                for (const i of w){
                    const { programConfiguration: r, program: o, layoutVertexBuffer: n, dynamicBuffers: a, indexBuffer: l, uniformValues: c, tile: p } = i.state, f = i.segments;
                    t1.terrain && t1.terrain.setupElevationDraw(p, o, T), t1.uploadCommonUniforms(h, o, p.tileID.toUnwrapped()), o.draw(t1, d.TRIANGLES, g, y, v, e1.$.disabled, c, s.id, n, l, f, s.paint, u.zoom, r, a);
                }
            },
            heatmap: function(t1, i, s, r) {
                if (0 !== s.paint.get("heatmap-opacity")) {
                    if ("offscreen" === t1.renderPass) {
                        const o = t1.context, n = o.gl, a = e1._.disabled, l = new e1.a1([
                            n.ONE,
                            n.ONE,
                            n.ONE,
                            n.ONE
                        ], e1.C.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]), c = "globe" === t1.transform.projection.name ? .5 : .25;
                        s.heatmapFbo = $n.createWithTexture(o, s.heatmapFbo, t1.width * c, t1.height * c), o.clear({
                            color: e1.C.transparent
                        });
                        const h = t1.transform, d = "globe" === h.projection.name, u = d ? [
                            "PROJECTION_GLOBE_VIEW"
                        ] : [], p = d ? e1.$.frontCCW : e1.$.disabled, f = [
                            e1.a7(h.center.lng),
                            e1.a8(h.center.lat)
                        ];
                        for(let c = 0; c < r.length; c++){
                            const m = r[c];
                            if (i.hasRenderableParent(m)) continue;
                            const _ = i.getTile(m), g = _.getBucket(s);
                            if (!g || g.projection.name !== h.projection.name) continue;
                            const y = t1.isTileAffectedByFog(m), v = g.programConfigurations.get(s.id), b = t1.getOrCreateProgram("heatmap", {
                                config: v,
                                defines: u,
                                overrideFog: y
                            }), { zoom: x } = t1.transform;
                            t1.terrain && t1.terrain.setupElevationDraw(_, b), t1.uploadCommonUniforms(o, b, m.toUnwrapped());
                            const w = h.projection.createInversionMatrix(h, m.canonical);
                            b.draw(t1, n.TRIANGLES, e1.Z.disabled, a, l, p, Fn(t1, m, _, w, f, x, s.paint.get("heatmap-intensity")), s.id, g.layoutVertexBuffer, g.indexBuffer, g.segments, s.paint, t1.transform.zoom, v, d ? [
                                g.globeExtVertexBuffer
                            ] : null);
                        }
                        o.viewport.set([
                            0,
                            0,
                            t1.width,
                            t1.height
                        ]);
                    } else "translucent" === t1.renderPass && (t1.context.setColorMode(t1.colorModeForRenderPass()), function(t1, i) {
                        const s = t1.context, r = s.gl, o = i.heatmapFbo;
                        if (!o) return;
                        s.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, o.colorAttachment0.get()), s.activeTexture.set(r.TEXTURE1);
                        let n = i.colorRampTexture;
                        n || (n = i.colorRampTexture = new e1.T(s, i.colorRamp, r.RGBA8)), n.bind(r.LINEAR, r.CLAMP_TO_EDGE), t1.getOrCreateProgram("heatmapTexture").draw(t1, r.TRIANGLES, e1.Z.disabled, e1._.disabled, t1.colorModeForRenderPass(), e1.$.disabled, ((e1, t1)=>({
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: t1.paint.get("heatmap-opacity")
                            }))(0, i), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom);
                    }(t1, s));
                }
            },
            line: function(e1, t1, i, s) {
                const r = i.paint.get("line-opacity"), o = i.paint.get("line-width");
                if (0 === r.constantOr(1) || 0 === o.constantOr(1)) return;
                const n = i.paint.get("line-blend-mode"), a = e1.terrain && e1.terrain.renderingToTexture;
                if ("default" === n || "globe" === e1.transform.projection.name) "translucent" === e1.renderPass && ea(e1, t1, i, s);
                else {
                    if (a) return void function(e1, t1, i, s, r) {
                        if ("translucent" !== e1.renderPass) return;
                        const o = e1.context, n = o.gl, a = e1.terrain;
                        if (!a) return;
                        const l = o.bindFramebuffer.current, c = "mrt-fallback" === e1.emissiveMode, h = a.drapeBufferSize[0], d = a.drapeBufferSize[1];
                        i.lineBlendFbos || (i.lineBlendFbos = new ta), i.lineBlendFbos.drapeFbo = $n.createWithTexture(o, i.lineBlendFbos.drapeFbo, h, d, !0), c && n.drawBuffers([
                            n.COLOR_ATTACHMENT0
                        ]), o.clear({
                            color: sa[r].clearColor,
                            depth: 1,
                            stencil: 0
                        });
                        const u = e1.currentStencilSource, p = e1._tileClippingMaskIDs, f = e1.nextStencilID;
                        e1.currentStencilSource = void 0, e1._tileClippingMaskIDs = {}, e1.nextStencilID = 1;
                        const m = e1._terrain;
                        e1._terrain = null, e1._renderTileClippingMasks(i, t1, s), ea(e1, t1, i, s, oa(r, e1.context), !0), e1._terrain = m, e1.currentStencilSource = u, e1._tileClippingMaskIDs = p, e1.nextStencilID = f, c && n.drawBuffers([
                            n.COLOR_ATTACHMENT0,
                            n.COLOR_ATTACHMENT1
                        ]);
                        const _ = a.drapeBufferSize, g = i.lineBlendFbos && i.lineBlendFbos.drapeFbo;
                        g && ("additive" === r && aa(e1, i, g), la(e1, i, r, g, l, _));
                    }(e1, t1, i, s, n);
                    if ("offscreen" === e1.renderPass) return void function(e1, t1, i, s, r) {
                        const o = e1.context, n = Math.ceil(e1.width), a = Math.ceil(e1.height);
                        i.lineBlendFbos || (i.lineBlendFbos = new ta), i.lineBlendFbos.fbo = $n.createWithTexture(o, i.lineBlendFbos.fbo, n, a, !0), o.clear({
                            color: sa[r].clearColor,
                            depth: 1,
                            stencil: 0
                        });
                        const l = e1.currentStencilSource, c = e1._tileClippingMaskIDs, h = e1.nextStencilID;
                        e1.currentStencilSource = void 0, e1._tileClippingMaskIDs = {}, e1.nextStencilID = 1, e1._renderTileClippingMasks(i, t1, s);
                        const d = e1.renderPass;
                        e1.renderPass = "translucent", ea(e1, t1, i, s, oa(r, e1.context)), e1.renderPass = d, e1.currentStencilSource = l, e1._tileClippingMaskIDs = c, e1.nextStencilID = h, o.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]), "additive" === r && aa(e1, i, i.lineBlendFbos.fbo);
                    }(e1, t1, i, s, n);
                    if ("translucent" === e1.renderPass) {
                        const t1 = i.lineBlendFbos && i.lineBlendFbos.fbo;
                        return void (t1 && la(e1, i, n, t1, null));
                    }
                }
            },
            fill: function(t1, i, s, r) {
                const o = s.paint.get("fill-color"), n = s.paint.get("fill-opacity");
                if (0 === n.constantOr(1)) return;
                const a = s.paint.get("fill-emissive-strength"), l = t1.colorModeForDrapableLayerRenderPass(a), c = s.paint.get("fill-pattern"), h = t1.opaquePassEnabledForLayer() && !c.constantOr(1) && 1 === o.constantOr(e1.C.transparent).a && 1 === n.constantOr(0) ? "opaque" : "translucent";
                let d = "none";
                "none" !== s.layout.get("fill-elevation-reference") ? d = "road" : 0 !== s.paint.get("fill-z-offset").constantOr(1) && (d = "offset");
                const u = !(!t1.terrain || !t1.terrain.enabled), p = {
                    painter: t1,
                    sourceCache: i,
                    layer: s,
                    coords: r,
                    colorMode: l,
                    elevationType: d,
                    terrainEnabled: u,
                    pass: h
                };
                if ("shadow" === t1.renderPass) return void (t1.shadowRenderer && "road" === d && !u && Xs.drawElevatedFillShadows && Xs.drawElevatedFillShadows(p));
                const f = "mrt-fallback" === t1.emissiveMode;
                if ("offset" !== d) {
                    if (ca(p, !1, f), "road" === d) {
                        const o = !u && "translucent" === t1.renderPass;
                        o && Xs.drawDepthPrepass && Xs.drawDepthPrepass(t1, i, s, r, "geometry"), ca(p, !0, f, e1._.disabled), o && Xs.drawElevatedStructures && Xs.drawElevatedStructures(p);
                    }
                } else ca(p, !1, f, t1.stencilModeFor3D());
            },
            "fill-extrusion": function(t1, i, s, r) {
                const o = s.paint.get("fill-extrusion-opacity"), n = t1.context, a = n.gl, l = t1.terrain, c = l && l.renderingToTexture;
                if (0 === o) return;
                const h = "mrt-fallback" === t1.emissiveMode, d = t1.conflationActive && t1.style.isLayerClipped(s, i.getSource()), u = t1.style.order.indexOf(s.fqid);
                if (d && function(e1, t1, i, s, r) {
                    for (const o of s){
                        const s = t1.getTile(o).getBucket(i);
                        s && (s.updateReplacement(o, e1.replacementSource, r), s.uploadCentroid(e1.context));
                    }
                }(t1, i, s, r, u), l || d) for (const e1 of r){
                    const r = i.getTile(e1).getBucket(s);
                    r && fi(t1.context, i, e1, r, s, l, d);
                }
                if ("shadow" === t1.renderPass && t1.shadowRenderer) {
                    if (l && o < .65 && s._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof e1.aj) return;
                    const n = t1.shadowRenderer.getShadowPassDepthMode();
                    di(t1, i, s, r, n, e1._.disabled, e1.a1.disabled, d);
                } else if ("translucent" === t1.renderPass) {
                    const u = !s.paint.get("fill-extrusion-pattern").constantOr(1), p = s.paint.get("fill-extrusion-color").constantOr(e1.C.white);
                    if (!c && 0 !== p.a) {
                        const n = new e1.Z(t1.context.gl.LEQUAL, e1.Z.ReadWrite, t1.depthRangeFor3D);
                        1 === o && u ? di(t1, i, s, r, n, e1._.disabled, e1.a1.unblended, d) : (di(t1, i, s, r, n, e1._.disabled, e1.a1.disabled, d), di(t1, i, s, r, n, t1.stencilModeFor3D(), t1.colorModeForRenderPass(), d), t1.resetStencilClippingMasks());
                    }
                    const f = t1.style.enable3dLights() && u && (!l && "globe" !== t1.transform.projection.name || c);
                    if (f && !ci.drawGroundEffect && hi(), f && ci.drawGroundEffect) {
                        const o = s.paint.get("fill-extrusion-opacity"), u = s.paint.get("fill-extrusion-ambient-occlusion-intensity"), p = s.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), f = s.paint.get("fill-extrusion-flood-light-intensity"), m = "none" === s.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), _ = s.paint.get("fill-extrusion-flood-light-color").toNonPremultipliedRenderColor(m ? null : s.lut).toArray01().slice(0, 3), g = u > 0 && p > 0, y = f > 0, v = new ui;
                        v.translate = s.paint.get("fill-extrusion-translate"), v.translateAnchor = s.paint.get("fill-extrusion-translate-anchor"), v.edgeRadius = s.layout.get("fill-extrusion-edge-radius"), v.cutoffFadeRange = s.paint.get("fill-extrusion-cutoff-fade-range");
                        const b = (n)=>{
                            const l = t1.depthModeForSublayer(1, e1.Z.ReadOnly, a.LEQUAL, !0), c = s.paint.get(n ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), h = e1.al(.1, 3, c), m = t1._showOverdrawInspector;
                            if (!m) {
                                const c = new e1._({
                                    func: a.ALWAYS,
                                    mask: 255
                                }, 255, 255, a.KEEP, a.KEEP, a.REPLACE), m = new e1.a1([
                                    a.ONE,
                                    a.ONE,
                                    a.ONE,
                                    a.ONE
                                ], e1.C.transparent, [
                                    !1,
                                    !1,
                                    !1,
                                    !0
                                ], a.MIN);
                                ci.drawGroundEffect(v, t1, i, s, r, l, c, m, e1.$.disabled, n, "sdf", o, u, p, f, _, h, d, !1);
                            }
                            {
                                const c = m ? e1._.disabled : new e1._({
                                    func: a.EQUAL,
                                    mask: 255
                                }, 255, 255, a.KEEP, a.DECR, a.DECR), g = m ? t1.colorModeForRenderPass() : new e1.a1([
                                    a.ONE_MINUS_DST_ALPHA,
                                    a.DST_ALPHA,
                                    a.ONE,
                                    a.ONE
                                ], e1.C.transparent, [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]);
                                ci.drawGroundEffect(v, t1, i, s, r, l, c, g, e1.$.disabled, n, "color", o, u, p, f, _, h, d, !1);
                            }
                        };
                        if (c) {
                            const c = ()=>{
                                const t1 = l.drapeBufferSize[0], i = l.drapeBufferSize[1];
                                let s = l.framebufferCopyTexture;
                                return s && (!s || s.size[0] === t1 && s.size[1] === i) || (s && s.destroy(), s = l.framebufferCopyTexture = new e1.T(n, new e1.b({
                                    width: t1,
                                    height: i
                                }), a.RGBA8)), s.bind(a.LINEAR, a.CLAMP_TO_EDGE), a.copyTexSubImage2D(a.TEXTURE_2D, 0, 0, 0, 0, 0, t1, i), s;
                            }, m = (n, l, m)=>{
                                const g = t1.depthModeForSublayer(1, e1.Z.ReadOnly, a.LEQUAL, !1), y = s.paint.get(n ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), b = e1.al(.1, 3, y);
                                {
                                    const c = new e1.a1([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e1.C.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ]);
                                    ci.drawGroundEffect(v, t1, i, s, r, g, e1._.disabled, c, e1.$.disabled, n, "clear", o, u, p, f, _, b, d, l);
                                }
                                {
                                    const c = new e1._({
                                        func: a.ALWAYS,
                                        mask: 255
                                    }, 255, 255, a.KEEP, a.KEEP, a.REPLACE), h = new e1.a1([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e1.C.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], a.MIN);
                                    ci.drawGroundEffect(v, t1, i, s, r, g, c, h, e1.$.disabled, n, "sdf", o, u, p, f, _, b, d, l);
                                }
                                h && !n && (m = c());
                                {
                                    const c = n ? a.ZERO : a.ONE_MINUS_DST_ALPHA, h = new e1._({
                                        func: a.EQUAL,
                                        mask: 255
                                    }, 255, 255, a.KEEP, a.DECR, a.DECR), m = new e1.a1([
                                        c,
                                        a.DST_ALPHA,
                                        a.ONE_MINUS_DST_ALPHA,
                                        a.ZERO
                                    ], e1.C.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    ci.drawGroundEffect(v, t1, i, s, r, g, h, m, e1.$.disabled, n, "color", o, u, p, f, _, b, d, l);
                                }
                                if (!h || n) {
                                    const c = new e1.a1([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        n ? a.ZERO : a.ONE
                                    ], e1.C.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], n ? a.FUNC_ADD : a.MAX);
                                    ci.drawGroundEffect(v, t1, i, s, r, g, e1._.disabled, c, e1.$.disabled, n, "clear", o, u, p, f, _, b, d, l, m);
                                } else {
                                    a.drawBuffers([
                                        a.NONE,
                                        a.COLOR_ATTACHMENT1
                                    ]);
                                    const c = new e1._({
                                        func: a.EQUAL,
                                        mask: 255
                                    }, 254, 255, a.KEEP, a.DECR, a.DECR), h = new e1.a1([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e1.C.transparent, [
                                        !0,
                                        !1,
                                        !1,
                                        !1
                                    ], a.MAX);
                                    ci.drawGroundEffect(v, t1, i, s, r, g, c, h, e1.$.disabled, n, "emissive", o, u, p, f, _, b, d, l, m), a.drawBuffers([
                                        a.COLOR_ATTACHMENT0
                                    ]);
                                }
                            };
                            if (g || y) {
                                let e1;
                                t1.prepareDrawTile(), h && !g || (e1 = c()), g && m(!0, !1, e1), y && m(!1, !0, e1);
                            }
                        } else g && b(!0), y && b(!1), (g || y) && t1.resetStencilClippingMasks();
                    }
                }
            },
            hillshade: function(t1, i, s, r) {
                if ("offscreen" !== t1.renderPass && "translucent" !== t1.renderPass) return;
                if (t1.style.disableElevatedTerrain) return;
                const o = t1.context, n = t1.terrain && t1.terrain.renderingToTexture, [a, l] = "translucent" !== t1.renderPass || n ? [
                    {},
                    r
                ] : t1.stencilConfigForOverlap(r);
                for (const r of l){
                    const o = i.getTile(r);
                    if (o.needsHillshadePrepare && "offscreen" === t1.renderPass) Do(t1, o, s);
                    else if ("translucent" === t1.renderPass) {
                        const i = t1.depthModeForSublayer(0, e1.Z.ReadOnly), l = s.paint.get("hillshade-emissive-strength"), c = t1.colorModeForDrapableLayerRenderPass(l), h = n && t1.terrain ? t1.terrain.stencilModeForRTTOverlap(r) : a[r.overscaledZ];
                        Eo(t1, r, o, s, i, h, c);
                    }
                }
                o.viewport.set([
                    0,
                    0,
                    t1.width,
                    t1.height
                ]), t1.resetStencilClippingMasks();
            },
            raster: function(t1, i, s, r, o, n) {
                if ("translucent" !== t1.renderPass) return;
                const a = s.paint.get("raster-opacity");
                if (0 === a) return;
                const l = "globe" === t1.transform.projection.name, c = 0 !== s.paint.get("raster-elevation"), h = c && l, d = t1.terrain && t1.terrain.exaggeration() > 0 && c && "ground" === s.paint.get("raster-elevation-reference"), u = !l && d;
                if (t1.renderElevatedRasterBackface && !h) return;
                const p = t1.context, f = p.gl, m = i.getSource(), _ = function(t1, i, s, r, o) {
                    const n = i.paint.get("raster-color"), a = "raster-array" === t1.type, l = [], c = i.paint.get("raster-resampling"), h = i.paint.get("raster-color-mix");
                    let d = i.paint.get("raster-color-range");
                    const u = [
                        h[0],
                        h[1],
                        h[2],
                        0
                    ], p = h[3];
                    let f = "nearest" === c ? r.NEAREST : r.LINEAR;
                    if (a && (l.push("RASTER_ARRAY"), n || l.push("RASTER_COLOR"), "linear" === c && l.push("RASTER_ARRAY_LINEAR"), f = r.NEAREST, !d && t1.rasterLayers)) {
                        const e1 = t1.rasterLayers.find(({ id: e1 })=>e1 === i.sourceLayer);
                        e1 && e1.fields && e1.fields.range && (d = e1.fields.range);
                    }
                    if (d = d || [
                        0,
                        1
                    ], n) {
                        l.push("RASTER_COLOR"), s.activeTexture.set(r.TEXTURE2), i.updateColorRamp(d);
                        let t1 = i.colorRampTexture;
                        t1 || (t1 = i.colorRampTexture = new e1.T(s, i.colorRamp, r.RGBA8)), t1.bind(f, r.CLAMP_TO_EDGE);
                    }
                    return o && l.push("USE_MRT1"), {
                        mix: u,
                        range: d,
                        offset: p,
                        defines: l,
                        resampling: f
                    };
                }(m, s, p, f, t1.terrain && t1.terrain.renderingToTexture && "mrt-fallback" === t1.emissiveMode);
                if (m instanceof nr && !r.length && !l) return;
                const g = s.paint.get("raster-emissive-strength"), y = t1.colorModeForDrapableLayerRenderPass(g), v = t1.terrain && t1.terrain.renderingToTexture, b = !t1.options.moving, x = "nearest" === s.paint.get("raster-resampling") ? f.NEAREST : f.LINEAR;
                if (m instanceof nr && !r.length && (m.onNorthPole || m.onSouthPole)) {
                    const r = c ? t1.stencilModeFor3D() : e1._.disabled;
                    return void da(!!m.onNorthPole, null, t1, i, s, g, _, e1.$.disabled, r);
                }
                if (!r.length) return;
                const [w, T] = m instanceof nr || v ? [
                    {},
                    r
                ] : t1.stencilConfigForOverlap(r), S = T.at(-1).overscaledZ;
                h && _.defines.push("PROJECTION_GLOBE_VIEW"), c && _.defines.push("RENDER_CUTOFF", "ELEVATED"), d && _.defines.push("ELEVATION_REFERENCE_GROUND");
                const C = (r, o, T)=>{
                    for (const C of r){
                        const r = C.toUnwrapped(), E = i.getTile(C);
                        if (v && (!E || !E.hasData())) continue;
                        p.activeTexture.set(f.TEXTURE0);
                        const I = pa(E, m, s, _);
                        if (!I || !I.texture) continue;
                        const { texture: D, mix: P, offset: L, tileSize: R, buffer: A } = I;
                        let M, F;
                        v ? (M = e1.Z.disabled, F = C.projMatrix) : c ? (M = new e1.Z(f.LEQUAL, e1.Z.ReadWrite, t1.depthRangeFor3D), F = l ? t1.transform.expandedFarZProjMatrix : t1.transform.calculateProjMatrix(r, b)) : (M = t1.depthModeForSublayer(C.overscaledZ - S, 1 === a ? e1.Z.ReadWrite : e1.Z.ReadOnly, f.LESS), F = t1.transform.calculateProjMatrix(r, b));
                        const O = t1.terrain && v ? t1.terrain.stencilModeForRTTOverlap(C) : w[C.overscaledZ], B = n ? 0 : s.paint.get("raster-fade-duration");
                        E.registerFadeDuration(B);
                        const k = i.findLoadedParent(C, 0), z = Ai(E, k, i, t1.transform, B);
                        let U, N;
                        !z.isFading && E.refreshedUponExpiration && (E.refreshedUponExpiration = !1), t1.terrain && t1.terrain.prepareDrawTile(), p.activeTexture.set(f.TEXTURE0), D.bind(x, f.CLAMP_TO_EDGE), p.activeTexture.set(f.TEXTURE1), k ? (k.texture && k.texture.bind(x, f.CLAMP_TO_EDGE), U = Math.pow(2, k.tileID.overscaledZ - E.tileID.overscaledZ), N = [
                            E.tileID.canonical.x * U % 1,
                            E.tileID.canonical.y * U % 1
                        ]) : D.bind(x, f.CLAMP_TO_EDGE), "useMipmap" in D && p.extTextureFilterAnisotropic && t1.transform.pitch > 20 && f.texParameterf(f.TEXTURE_2D, p.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, p.extTextureFilterAnisotropicMax);
                        const j = t1.transform;
                        let V;
                        const G = c ? ua(j) : [
                            0,
                            0,
                            0,
                            0
                        ];
                        let q, Z, $, H, W, X = 0;
                        if (h && m instanceof nr && m.coordinates.length > 3) q = Float32Array.from(e1.b4(e1.b5(new e1.bX(0, 0, 0)))), Z = Float32Array.from(j.globeMatrix), $ = Float32Array.from(e1.b6(j)), H = [
                            e1.a7(j.center.lng),
                            e1.a8(j.center.lat)
                        ], V = m.elevatedGlobePerspectiveTransform, W = m.elevatedGlobeGridMatrix || new Float32Array(9);
                        else if (h) {
                            const t1 = e1.b2(C.canonical);
                            X = e1.b3(t1.getCenter().lat), q = Float32Array.from(e1.b4(e1.b5(C.canonical))), Z = Float32Array.from(j.globeMatrix), $ = Float32Array.from(e1.b6(j)), H = [
                                e1.a7(j.center.lng),
                                e1.a8(j.center.lat)
                            ], V = [
                                0,
                                0
                            ], W = Float32Array.from(e1.b7(C.canonical, t1, X, j.worldSize / j._pixelsPerMercatorPixel));
                        } else V = m instanceof nr ? m.perspectiveTransform : [
                            0,
                            0
                        ], q = new Float32Array(16), Z = new Float32Array(9), $ = new Float32Array(16), H = [
                            0,
                            0
                        ], W = new Float32Array(9);
                        const K = Bn(t1, F, q, Z, $, W, N || [
                            0,
                            0
                        ], e1.S(t1.transform.zoom), H, G, U || 1, z, s, V, c ? s.paint.get("raster-elevation") : 0, 2, P, L, _.range, R, A, g), Y = t1.isTileAffectedByFog(C), Q = t1.getOrCreateProgram("raster", {
                            defines: _.defines,
                            overrideFog: Y
                        });
                        if (t1.uploadCommonUniforms(p, Q, r), m instanceof nr) {
                            const i = m.elevatedGlobeVertexBuffer, r = m.elevatedGlobeIndexBuffer;
                            if (v || !l) m.boundsBuffer && m.boundsSegments && Q.draw(t1, f.TRIANGLES, M, e1._.disabled, y, e1.$.disabled, K, s.id, m.boundsBuffer, t1.quadTriangleIndexBuffer, m.boundsSegments);
                            else if (i && r) {
                                const n = j.zoom <= e1.e8 ? m.elevatedGlobeSegments : m.getSegmentsForLongitude(j.center.lng);
                                n && Q.draw(t1, f.TRIANGLES, M, e1._.disabled, y, o, K, s.id, i, r, n);
                            }
                        } else if (h) {
                            M = new e1.Z(f.LEQUAL, e1.Z.ReadOnly, t1.depthRangeFor3D);
                            const i = t1.globeSharedBuffers;
                            if (i) {
                                d && (t1.terrain.setupElevationDraw(E, Q), t1.uploadCommonUniforms(p, Q, E.tileID.toUnwrapped()));
                                const [e1, r, n] = i.getGridBuffers(X, !1), a = Q.getAttributeLocation(f, "a_texture_pos");
                                -1 !== a && f.vertexAttribI4ui(a, 0, 0, 0, 0), Q.draw(t1, f.TRIANGLES, M, T || O, t1.colorModeForRenderPass(), o, K, s.id, e1, r, n);
                            }
                        } else if (u) M = new e1.Z(f.LEQUAL, e1.Z.ReadWrite, t1.depthRangeFor3D), t1.terrain.setupElevationDraw(E, Q), t1.uploadCommonUniforms(p, Q, E.tileID.toUnwrapped()), j.pitch > 20 && Q.draw(t1, f.TRIANGLES, M, e1._.disabled, e1.a1.disabled, e1.$.frontCCW, K, s.id, t1.terrain.gridBuffer, t1.terrain.gridIndexBuffer, t1.terrain.gridSegments), Q.draw(t1, f.TRIANGLES, M, O, y, e1.$.backCCW, K, s.id, t1.terrain.gridBuffer, t1.terrain.gridIndexBuffer, t1.terrain.gridSegments);
                        else {
                            const { tileBoundsBuffer: i, tileBoundsIndexBuffer: r, tileBoundsSegments: o } = t1.getTileBoundsBuffers(E);
                            Q.draw(t1, f.TRIANGLES, M, O, y, e1.$.disabled, K, s.id, i, r, o);
                        }
                    }
                    if (!(m instanceof nr) && h) for (const n of r){
                        const r = n.canonical.y === (1 << n.canonical.z) - 1;
                        0 === n.canonical.y && da(!0, n, t1, i, s, g, _, o, T || e1._.disabled), r && da(!1, n, t1, i, s, g, _, o === e1.$.frontCW ? e1.$.backCW : e1.$.frontCW, T || e1._.disabled);
                    }
                };
                h ? C(T, t1.renderElevatedRasterBackface ? e1.$.backCW : e1.$.frontCW, t1.stencilModeFor3D()) : C(T, e1.$.disabled, void 0), t1.resetStencilClippingMasks();
            },
            background: function(t1, i, s, r) {
                const o = s.paint.get("background-color"), n = "none" === s.paint.get("background-color-use-theme").constantOr("default"), a = s.paint.get("background-opacity"), l = s.paint.get("background-emissive-strength"), c = "viewport" === s.paint.get("background-pitch-alignment");
                if (0 === a) return;
                const h = t1.context, d = h.gl, u = t1.transform, p = u.tileSize, f = s.paint.get("background-pattern");
                let m;
                if (void 0 !== f) {
                    if (null === f) return;
                    if (m = t1.imageManager.getPattern(e1.I.from(f.toString()), s.scope, t1.style.getLut(s.scope)), !m) return;
                }
                const _ = !f && 1 === o.a && 1 === a && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (t1.renderPass !== _) return;
                const g = e1._.disabled, y = t1.depthModeForSublayer(0, "opaque" === _ ? e1.Z.ReadWrite : e1.Z.ReadOnly), v = t1.colorModeForDrapableLayerRenderPass(l), b = f ? "backgroundPattern" : "background";
                let x, w = r;
                w || (x = t1.getBackgroundTiles(), w = Object.values(x).map((e1)=>e1.tileID)), f && (h.activeTexture.set(d.TEXTURE0), t1.imageManager.bind(t1.context, s.scope));
                const T = [];
                if (t1.terrain && t1.terrain.renderingToTexture && "mrt-fallback" === t1.emissiveMode && T.push("USE_MRT1"), c) {
                    const i = t1.getOrCreateProgram(b, {
                        overrideFog: !1,
                        overrideRtt: !0,
                        defines: T
                    }), r = fa, h = new e1.bP(0, 0, 0, 0, 0), u = f ? jn(r, l, a, t1, f, s.scope, m, c, {
                        tileID: h,
                        tileSize: p
                    }) : Nn(r, l, a, o.toPremultipliedRenderColor(n ? null : s.lut));
                    return void i.draw(t1, d.TRIANGLES, y, g, v, e1.$.disabled, u, s.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                }
                for (const _ of w){
                    const w = t1.isTileAffectedByFog(_), S = t1.getOrCreateProgram(b, {
                        overrideFog: w,
                        defines: T
                    }), C = _.toUnwrapped(), E = r ? _.projMatrix : t1.transform.calculateProjMatrix(C);
                    t1.prepareDrawTile();
                    const I = i ? i.getTile(_) : x ? x[_.key] : new fs(_, p, u.zoom, t1), D = f ? jn(E, l, a, t1, f, s.scope, m, c, {
                        tileID: _,
                        tileSize: p
                    }) : Nn(E, l, a, o.toPremultipliedRenderColor(n ? null : s.lut));
                    t1.uploadCommonUniforms(h, S, C);
                    const { tileBoundsBuffer: P, tileBoundsIndexBuffer: L, tileBoundsSegments: R } = t1.getTileBoundsBuffers(I);
                    S.draw(t1, d.TRIANGLES, y, g, v, e1.$.disabled, D, s.id, P, L, R);
                }
            },
            sky: function(t1, i, s) {
                const r = t1._atmosphere ? e1.S(t1.transform.zoom) : 1, o = s.paint.get("sky-opacity") * r;
                if (0 === o) return;
                const n = t1.context, a = s.paint.get("sky-type"), l = new e1.Z(n.gl.LEQUAL, e1.Z.ReadOnly, [
                    0,
                    1
                ]), c = t1.frameCounter / 1e3 % 1;
                "atmosphere" === a ? "offscreen" === t1.renderPass ? s.needsSkyboxCapture(t1) && (function(t1, i) {
                    const s = t1.context, r = s.gl;
                    let o = i.skyboxFbo;
                    if (!o) {
                        o = i.skyboxFbo = s.createFramebuffer(32, 32, 1, null), i.skyboxGeometry = new ya(s), i.skyboxTexture = s.gl.createTexture(), r.bindTexture(r.TEXTURE_CUBE_MAP, i.skyboxTexture), r.texParameteri(r.TEXTURE_CUBE_MAP, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_CUBE_MAP, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_CUBE_MAP, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_CUBE_MAP, r.TEXTURE_MAG_FILTER, r.LINEAR);
                        for(let e1 = 0; e1 < 6; ++e1)r.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + e1, 0, r.RGBA, 32, 32, 0, r.RGBA, r.UNSIGNED_BYTE, null);
                    }
                    s.bindFramebuffer.set(o.framebuffer), s.viewport.set([
                        0,
                        0,
                        32,
                        32
                    ]);
                    const n = i.getCenter(t1, !0), a = t1.getOrCreateProgram("skyboxCapture"), l = new Float64Array(16);
                    e1.eb(l, .5 * -Math.PI), va(t1, i, a, l, n, 0), e1.eb(l, .5 * Math.PI), va(t1, i, a, l, n, 1), e1.ec(l, .5 * -Math.PI), va(t1, i, a, l, n, 2), e1.ec(l, .5 * Math.PI), va(t1, i, a, l, n, 3), e1.d0(l), va(t1, i, a, l, n, 4), e1.eb(l, Math.PI), va(t1, i, a, l, n, 5), s.viewport.set([
                        0,
                        0,
                        t1.width,
                        t1.height
                    ]);
                }(t1, s), s.markSkyboxValid(t1)) : "sky" === t1.renderPass && function(t1, i, s, r, o) {
                    const n = t1.context, a = n.gl, l = t1.transform, c = t1.getOrCreateProgram("skybox");
                    n.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_CUBE_MAP, i.skyboxTexture);
                    const h = ((e1, t1, i, s, r)=>({
                            u_matrix: e1,
                            u_sun_direction: t1,
                            u_cubemap: 0,
                            u_opacity: s,
                            u_temporal_offset: r
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), 0, r, o);
                    t1.uploadCommonUniforms(n, c), c.draw(t1, a.TRIANGLES, s, e1._.disabled, t1.colorModeForRenderPass(), e1.$.backCW, h, "skybox", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, s, l, o, c) : "gradient" === a && "sky" === t1.renderPass && function(t1, i, s, r, o) {
                    const n = t1.context, a = n.gl, l = t1.transform, c = t1.getOrCreateProgram("skyboxGradient");
                    i.skyboxGeometry || (i.skyboxGeometry = new ya(n)), n.activeTexture.set(a.TEXTURE0);
                    let h = i.colorRampTexture;
                    h || (h = i.colorRampTexture = new e1.T(n, i.colorRamp, a.RGBA8)), h.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                    const d = ((t1, i, s, r, o)=>({
                            u_matrix: t1,
                            u_color_ramp: 0,
                            u_center_direction: i,
                            u_radius: e1.au(s),
                            u_opacity: r,
                            u_temporal_offset: o
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), i.paint.get("sky-gradient-radius"), r, o);
                    t1.uploadCommonUniforms(n, c), c.draw(t1, a.TRIANGLES, s, e1._.disabled, t1.colorModeForRenderPass(), e1.$.backCW, d, "skyboxGradient", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, s, l, o, c);
            },
            custom: function(t1, i, s, r) {
                const o = t1.context, n = s.implementation;
                if (!t1.transform.projection.unsupportedLayers || !t1.transform.projection.unsupportedLayers.includes("custom") || t1.terrain && (t1.terrain.renderingToTexture || "offscreen" === t1.renderPass) && s.isDraped(i)) {
                    if ("offscreen" === t1.renderPass) {
                        const i = n.prerender;
                        if (i) {
                            if (t1.setCustomLayerDefaults(), o.setColorMode(t1.colorModeForRenderPass()), "globe" === t1.transform.projection.name) {
                                const s = t1.transform.pointMerc;
                                i.call(n, o.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e1.S(t1.transform.zoom), [
                                    s.x,
                                    s.y
                                ], t1.transform.pixelsPerMeterRatio);
                            } else i.call(n, o.gl, t1.transform.customLayerMatrix());
                            o.setDirty(), t1.setBaseState();
                        }
                    } else if ("translucent" === t1.renderPass) {
                        if (t1.terrain && t1.terrain.renderingToTexture) {
                            const i = n.renderToTile;
                            if (i) {
                                const s = r[0].canonical, a = {
                                    x: s.x + r[0].wrap * (n.wrapTileId ? 0 : 1 << s.z),
                                    y: s.y,
                                    z: s.z
                                };
                                o.setDepthMode(e1.Z.disabled), o.setStencilMode(e1._.disabled), o.setColorMode(t1.colorModeForRenderPass()), t1.setCustomLayerDefaults();
                                const l = o.gl;
                                "mrt-fallback" === t1.emissiveMode && l.drawBuffers([
                                    l.COLOR_ATTACHMENT0
                                ]), i.call(n, o.gl, a), "mrt-fallback" === t1.emissiveMode && l.drawBuffers([
                                    l.COLOR_ATTACHMENT0,
                                    l.COLOR_ATTACHMENT1
                                ]), o.setDirty(), t1.setBaseState();
                            }
                            return;
                        }
                        t1.setCustomLayerDefaults(), o.setColorMode(t1.colorModeForRenderPass()), o.setStencilMode(e1._.disabled);
                        const i = "3d" === n.renderingMode ? new e1.Z(t1.context.gl.LEQUAL, e1.Z.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, e1.Z.ReadOnly);
                        if (o.setDepthMode(i), "globe" === t1.transform.projection.name) {
                            const i = t1.transform.pointMerc;
                            n.render(o.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e1.S(t1.transform.zoom), [
                                i.x,
                                i.y
                            ], t1.transform.pixelsPerMeterRatio);
                        } else n.render(o.gl, t1.transform.customLayerMatrix());
                        o.setDirty(), t1.setBaseState(), o.bindFramebuffer.set(null);
                    }
                } else e1.w("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
            }
        }, Da = {
            line: function(e1, t1, i) {
                if (e1.hasElevatedBuckets = !1, e1.hasNonElevatedBuckets = !1, void 0 !== e1._unevaluatedLayout.getValue("line-elevation-reference") || void 0 !== e1._unevaluatedLayout.getValue("line-z-offset")) {
                    if (t1) {
                        const i = t1.getVisibleCoordinates();
                        for (const s of i){
                            const i = t1.getTile(s).getBucket(e1);
                            if (i && ("none" !== i.elevationType ? e1.hasElevatedBuckets = !0 : e1.hasNonElevatedBuckets = !0, e1.hasElevatedBuckets && e1.hasNonElevatedBuckets)) break;
                        }
                    }
                } else e1.hasNonElevatedBuckets = !0;
            },
            raster: function(e1, t1, i) {
                const s = t1.getSource();
                if ("raster-array" !== s.type || !s.loaded()) return;
                const r = e1.sourceLayer || s.rasterLayerIds && s.rasterLayerIds[0];
                if (!r) return;
                const o = e1.paint.get("raster-array-band") || s.getInitialBand(r);
                if (null == o) return;
                const n = t1.getIds().map((e1)=>t1.getTileByID(e1));
                for (const t1 of n)t1.updateNeeded(e1.id, o) && s.prepareTile(t1, r, e1.id, o);
            }
        };
        async function Pa(e1) {
            if (await hi(), Object.assign(Ia, {
                model: ci.drawModels
            }), Object.assign(Da, {
                model: ci.prepare
            }), e1 && !e1._destroyed && !e1._shadowRenderer) {
                const t1 = ci.ShadowRenderer;
                t1 && (e1._shadowRenderer = new t1(e1));
            }
        }
        class La {
            constructor(t1, i, s, r, o){
                this.context = new Hn(t1, i), this.transform = s, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.frcCoverageSnapshot = null, this.elevationCoverageSnapshot = null, this.elevationProvidersReady = void 0, this.frcCoverageFadeRange = null, this.frcCoverageSourceLayers = [], this.frcCoverageRenderer = Xs.FrcCoverageRenderer ? new Xs.FrcCoverageRenderer : null, this._debugParams = {
                    averageFPS: 0,
                    fpsHistory: [],
                    fpsWindow: 30,
                    continousRedraw: !1,
                    enabledLayers: {},
                    buildingsShowNormals: !1,
                    buildingsDrawGroundAO: !0,
                    buildingsDrawShadowPass: !0,
                    buildingsDrawTranslucentPass: !0,
                    showTerrainProxyTiles: !1,
                    terrainSortTilesHiZFirst: !0,
                    terrainDisableRenderCache: !1,
                    forceEnablePrecipitation: !1,
                    overrideSnowParams: !1,
                    snowParamsOverride: null,
                    snowRevealParamsOverride: null,
                    snowVignetteParamsOverride: null,
                    overrideRainParams: !1,
                    rainParamsOverride: null,
                    rainRevealParamsOverride: null,
                    rainVignetteParamsOverride: null,
                    overrideStarsParams: !1,
                    starsParamsOverride: null,
                    show3DModelFootprints: !1,
                    showElevationIdDebug: !1,
                    lodSwitchDistance: -1,
                    lodSwitchFadeDuration: .5
                }, this.occlusionParams = new Ea, this.setup(), this.numSublayers = gs.maxUnderzooming + gs.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this.frameTimeDelta = 0, this.lastPaintStartTimeStamp = 0, this._shadowCullCache = null, this._backgroundTiles = {}, this.conflationActive = !1, this.replacementSource = new e1.ep, this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = !1, this._cachedTileFogOpacities = {}, this._wireframeDebugCache = new Ca, this.renderDefaultNorthPole = !0, this.renderDefaultSouthPole = !0, this.layersWithOcclusionOpacity = [];
                const n = new e1.b({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0));
                this.emptyDepthTexture = new e1.T(this.context, n, t1.RGBA8), this._clippingActiveLastFrame = !1, this.scaleFactor = r, this.maxFrontCutoffRawStart = 0, this.worldview = o, this._forceEmissiveMode = !1, this.emissiveMode = "constant";
            }
            updateTerrain(e1, t1) {
                const i = !!e1 && !!e1.terrain && this.transform.projection.supportsTerrain;
                if (!(i || this._terrain && this._terrain.enabled)) return;
                this._terrain || (this._terrain = new Tn(this, e1));
                const s = this._terrain;
                this.transform.elevation = i ? s : null, s.update(e1, this.transform, t1), this.transform.elevation && !s.enabled && (this.transform.elevation = null);
            }
            _updateFog(e1) {
                const t1 = e1.fog;
                if (!t1 || "globe" === this.transform.projection.name || t1.getOpacity(this.transform.pitch) < 1 || t1.properties.get("horizon-blend") < .03) return void (this.transform.fogCullDistSq = null);
                const [i, s] = t1.getRangeForProjection();
                if (i > s) return void (this.transform.fogCullDistSq = null);
                const r = i + .78 * (s - i);
                this.transform.fogCullDistSq = r * r;
            }
            get terrain() {
                return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled || this._forceTerrainMode ? this._terrain : null;
            }
            get forceTerrainMode() {
                return this._forceTerrainMode;
            }
            set forceTerrainMode(e1) {
                e1 && !this._terrain && (this._terrain = new Tn(this, this.style)), this._forceTerrainMode = e1;
            }
            get shadowRenderer() {
                return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
            }
            get wireframeDebugCache() {
                return this._wireframeDebugCache;
            }
            resize(t1, i) {
                if (this.width = t1 * e1.e.devicePixelRatio, this.height = i * e1.e.devicePixelRatio, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e1 of this.style.order)this.style._mergedLayers[e1].resize();
            }
            setup() {
                const t1 = this.context, i = new e1.bC;
                i.emplaceBack(0, 0), i.emplaceBack(e1.a2, 0), i.emplaceBack(0, e1.a2), i.emplaceBack(e1.a2, e1.a2), this.tileExtentBuffer = t1.createVertexBuffer(i, e1.bE.members), this.tileExtentSegments = e1.ac.simpleSegment(0, 0, 4, 2);
                const s = new e1.bC;
                s.emplaceBack(0, 0), s.emplaceBack(e1.a2, 0), s.emplaceBack(0, e1.a2), s.emplaceBack(e1.a2, e1.a2), this.debugBuffer = t1.createVertexBuffer(s, e1.bE.members), this.debugSegments = e1.ac.simpleSegment(0, 0, 4, 5);
                const r = new e1.bC;
                r.emplaceBack(-1, -1), r.emplaceBack(1, -1), r.emplaceBack(-1, 1), r.emplaceBack(1, 1), this.viewportBuffer = t1.createVertexBuffer(r, e1.bE.members), this.viewportSegments = e1.ac.simpleSegment(0, 0, 4, 2);
                const o = new e1.bs;
                o.emplaceBack(0, 0, 0, 0), o.emplaceBack(e1.a2, 0, e1.a2, 0), o.emplaceBack(0, e1.a2, 0, e1.a2), o.emplaceBack(e1.a2, e1.a2, e1.a2, e1.a2), this.mercatorBoundsBuffer = t1.createVertexBuffer(o, hs.members), this.mercatorBoundsSegments = e1.ac.simpleSegment(0, 0, 4, 2);
                const n = new e1.ad;
                n.emplaceBack(0, 1, 2), n.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t1.createIndexBuffer(n);
                const a = new e1.bD;
                for (const e1 of [
                    0,
                    1,
                    3,
                    2,
                    0
                ])a.emplaceBack(e1);
                this.debugIndexBuffer = t1.createIndexBuffer(a), this.emptyTexture = new e1.T(t1, new e1.b({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0)), t1.gl.RGBA8), this.identityMat = e1.Y();
                const l = this.context.gl;
                this.stencilClearMode = new e1._({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.loadTimeStamps.push(performance.now());
            }
            getMercatorTileBoundsBuffers() {
                return {
                    tileBoundsBuffer: this.mercatorBoundsBuffer,
                    tileBoundsIndexBuffer: this.quadTriangleIndexBuffer,
                    tileBoundsSegments: this.mercatorBoundsSegments
                };
            }
            getTileBoundsBuffers(e1) {
                return e1._makeTileBoundsBuffers(this.context, this.transform.projection), e1._tileBoundsBuffer ? {
                    tileBoundsBuffer: e1._tileBoundsBuffer,
                    tileBoundsIndexBuffer: e1._tileBoundsIndexBuffer,
                    tileBoundsSegments: e1._tileBoundsSegments
                } : this.getMercatorTileBoundsBuffers();
            }
            clearStencil() {
                const t1 = this.context.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, t1.TRIANGLES, e1.Z.disabled, this.stencilClearMode, e1.a1.disabled, e1.$.disabled, Us(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            resetStencilClippingMasks() {
                this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
            }
            _renderTileClippingMasks(t1, i, s) {
                if (!i || this.currentStencilSource === i.id || !t1.isTileClipped() || !s || 0 === s.length) return;
                if (this._tileClippingMaskIDs && !this.terrain) {
                    let e1 = !1;
                    for (const t1 of s)if (void 0 === this._tileClippingMaskIDs[t1.key]) {
                        e1 = !0;
                        break;
                    }
                    if (!e1) return;
                }
                this.currentStencilSource = i.id;
                const r = this.context, o = r.gl;
                this.nextStencilID + s.length > 256 && this.clearStencil(), r.setColorMode(e1.a1.disabled), r.setDepthMode(e1.Z.disabled);
                const n = this.getOrCreateProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const t1 of s){
                    const s = i.getTile(t1), r = this._tileClippingMaskIDs[t1.key] = this.nextStencilID++, { tileBoundsBuffer: a, tileBoundsIndexBuffer: l, tileBoundsSegments: c } = this.getTileBoundsBuffers(s);
                    n.draw(this, o.TRIANGLES, e1.Z.disabled, new e1._({
                        func: o.ALWAYS,
                        mask: 0
                    }, r, 255, o.KEEP, o.KEEP, o.REPLACE), e1.a1.disabled, e1.$.disabled, Us(t1.projMatrix), "$clipping", a, l, c);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const t1 = this.nextStencilID++, i = this.context.gl;
                return new e1._({
                    func: i.NOTEQUAL,
                    mask: 255
                }, t1, 255, i.KEEP, i.KEEP, i.REPLACE);
            }
            stencilModeForClipping(t1) {
                if (this.terrain) return this.terrain.stencilModeForRTTOverlap(t1);
                const i = this.context.gl;
                return new e1._({
                    func: i.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[t1.key], 0, i.KEEP, i.KEEP, i.REPLACE);
            }
            stencilConfigForOverlap(t1) {
                const i = this.context.gl, s = t1.sort((e1, t1)=>t1.overscaledZ - e1.overscaledZ), r = s.at(-1).overscaledZ, o = s[0].overscaledZ - r + 1;
                if (o > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + o > 256 && this.clearStencil();
                    const t1 = {};
                    for(let s = 0; s < o; s++)t1[s + r] = new e1._({
                        func: i.GEQUAL,
                        mask: 255
                    }, s + this.nextStencilID, 255, i.KEEP, i.KEEP, i.REPLACE);
                    return this.nextStencilID += o, [
                        t1,
                        s
                    ];
                }
                return [
                    {
                        [r]: e1._.disabled
                    },
                    s
                ];
            }
            colorModeForRenderPass() {
                const t1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new e1.a1([
                        t1.CONSTANT_COLOR,
                        t1.ONE,
                        t1.CONSTANT_COLOR,
                        t1.ONE
                    ], new e1.C(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? e1.a1.unblended : e1.a1.alphaBlended;
            }
            colorModeForDrapableLayerRenderPass(t1) {
                const i = this.context.gl;
                return (()=>this.style && this.style.enable3dLights() && this.terrain && this.terrain.renderingToTexture)() && "translucent" === this.renderPass ? null != t1 && "mrt-fallback" !== this.emissiveMode || "constant" === this.emissiveMode ? new e1.a1([
                    i.ONE,
                    i.ONE_MINUS_SRC_ALPHA,
                    i.CONSTANT_ALPHA,
                    i.ONE_MINUS_SRC_ALPHA
                ], new e1.C(0, 0, 0, t1 ?? 0), [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : "dual-source-blending" === this.emissiveMode ? new e1.a1([
                    i.ONE,
                    i.ONE_MINUS_SRC_ALPHA,
                    this.context.extBlendFuncExtended.SRC1_ALPHA_WEBGL,
                    i.ONE_MINUS_SRC_ALPHA
                ], e1.C.transparent, [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : this.colorModeForRenderPass() : this.colorModeForRenderPass();
            }
            depthModeForSublayer(t1, i, s, r = !1) {
                if (this.depthOcclusion) return new e1.Z(this.context.gl.GREATER, e1.Z.ReadOnly, this.depthRangeFor3D);
                if (!this.opaquePassEnabledForLayer() && !r) return e1.Z.disabled;
                const o = 1 - ((1 + this.currentLayer) * this.numSublayers + t1) * this.depthEpsilon;
                return new e1.Z(s || this.context.gl.LEQUAL, i, [
                    o,
                    o
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            blitDepth() {
                const t1 = this.context.gl, i = Math.ceil(this.width), s = Math.ceil(this.height), r = this.context.bindFramebuffer.get(), o = t1.getParameter(t1.TEXTURE_BINDING_2D);
                this.depthFBO && this.depthFBO.width === i && this.depthFBO.height === s || (this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), 0 !== i && 0 !== s && (this.depthFBO = new $n(this.context, i, s, 0, "texture"), this.depthTexture = new e1.T(this.context, {
                    width: i,
                    height: s,
                    data: null
                }, t1.DEPTH24_STENCIL8), this.depthFBO.depthAttachment.set(this.depthTexture.texture))), this.context.bindFramebuffer.set(r), t1.bindTexture(t1.TEXTURE_2D, o), this.depthFBO && (t1.bindFramebuffer(t1.READ_FRAMEBUFFER, null), t1.bindFramebuffer(t1.DRAW_FRAMEBUFFER, this.depthFBO.framebuffer), t1.blitFramebuffer(0, 0, i, s, 0, 0, i, s, t1.DEPTH_BUFFER_BIT, t1.NEAREST), t1.bindFramebuffer(t1.FRAMEBUFFER, this.context.bindFramebuffer.current));
            }
            render(t1, i) {
                this.context.sweepPendingPrograms(), this.frameTimeDelta = 0 === this.lastPaintStartTimeStamp ? 0 : i.paintStartTimeStamp - this.lastPaintStartTimeStamp, this.lastPaintStartTimeStamp = i.paintStartTimeStamp, this._wireframeDebugCache.update(this.frameCounter), this.style = t1, this.options = i, this.frcCoverageSnapshot && !this.frcCoverageSnapshot.empty() && (!this.frcCoverageRenderer && Xs.FrcCoverageRenderer && (this.frcCoverageRenderer = new Xs.FrcCoverageRenderer), this.frcCoverageRenderer && this.frcCoverageRenderer.update(this.context, this.frcCoverageSnapshot.tiles));
                const s = this.style._mergedLayers, r = !(!this.terrain || !this.terrain.enabled), o = ()=>this.style._getOrder(r);
                let n = o(), a = !1, l = !1, c = null, h = 0, d = !1;
                for (const e1 of n){
                    const t1 = s[e1];
                    "none" !== t1.visibility && ("circle" === t1.type ? a = !0 : "building" === t1.type ? (c = t1, ++h) : "symbol" === t1.type && (t1.hasOcclusionOpacityProperties ? l = !0 : a = !0));
                }
                this.updateEmissiveMode();
                let u = n.map((e1)=>s[e1]);
                const p = this.style._mergedSourceCaches;
                this.imageManager = t1.imageManager, this.modelManager = t1.modelManager, this.symbolFadeChange = t1.placement.symbolFadeChange(e1.e.now()), this.imageManager.beginFrame();
                for(const e1 in p){
                    const t1 = p[e1];
                    t1.used && (t1.prepare(this.context), t1.getSource().usedInConflation && ++h);
                }
                let f = !1;
                for (const e1 of u)e1.isHidden(this.transform.zoom) || ("clip" === e1.type && (f = !0), this.prepareLayer(e1));
                const m = {}, _ = {}, g = {}, y = {}, v = {};
                for(const e1 in p){
                    const t1 = p[e1];
                    m[e1] = t1.getVisibleCoordinates(), _[e1] = m[e1].slice().reverse(), g[e1] = t1.getVisibleCoordinates(!0).reverse(), y[e1] = t1.getShadowCasterCoordinates(), v[e1] = t1.sortCoordinatesByDistance(m[e1]);
                }
                const b = (e1)=>{
                    const t1 = this.style.getLayerSourceCache(e1);
                    return t1 && t1.used ? t1.getSource() : null;
                };
                if (h || f || this._clippingActiveLastFrame) {
                    const t1 = [], i = [];
                    let s = 0;
                    for (const e1 of u)this.isSourceForClippingOrConflation(e1, b(e1)) && (t1.push(e1), i.push(s)), s++;
                    if (t1 && (f || t1.length > 1) || this._clippingActiveLastFrame) {
                        f = !1;
                        const s = [];
                        for(let r = 0; r < t1.length; r++){
                            const o = t1[r], n = i[r], a = this.style.getLayerSourceCache(o);
                            if (!a || !a.used || !a.getSource().usedInConflation && "clip" !== o.type && "building" !== o.type) continue;
                            let l = e1.eq, c = e1.cI.None;
                            const h = [];
                            let d = !0;
                            if ("building" === o.type) l = e1.eu;
                            else if ("clip" === o.type) {
                                if (l = n, o.isHidden(this.transform.zoom)) d = !1;
                                else {
                                    if (!o.layout) {
                                        d = !1;
                                        continue;
                                    }
                                    for (const t1 of o.layout.get("clip-layer-types"))c |= "model" === t1 ? e1.cI.Model : "symbol" === t1 ? e1.cI.Symbol : e1.cI.FillExtrusion;
                                    for (const t1 of o.layout.get("clip-layer-scope"))h.push(e1.m(t1, o.scope));
                                    f = !0;
                                }
                            }
                            d && s.push({
                                layer: o.fqid,
                                cache: a,
                                order: l,
                                clipMask: c,
                                clipScope: h
                            });
                        }
                        this.replacementSource.setSources(s), d = !0;
                    }
                }
                this._clippingActiveLastFrame = f, d || this.replacementSource.clear(), this.conflationActive = d, this.minCutoffZoom = 0, this.longestCutoffRange = 0, this.maxFrontCutoffRawStart = 0, this.opaquePassCutoff = 1 / 0, this._lastOcclusionLayer = -1, this.layersWithOcclusionOpacity = [];
                for(let e1 = 0; e1 < u.length; e1++){
                    const t1 = u[e1];
                    if ("none" === t1.visibility) continue;
                    const i = t1.cutoffRange();
                    if (this.longestCutoffRange = Math.max(i, this.longestCutoffRange), i > 0) {
                        const e1 = b(t1);
                        e1 && (this.minCutoffZoom = Math.max(e1.minzoom, this.minCutoffZoom)), t1.minzoom && (this.minCutoffZoom = Math.max(t1.minzoom, this.minCutoffZoom));
                    }
                    t1.is3D(r) && (this.opaquePassCutoff === 1 / 0 && (this.opaquePassCutoff = e1), this._lastOcclusionLayer = e1);
                }
                const x = this.style && this.style.fog;
                x ? (this._fogVisible = 0 !== x.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = x.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = !1, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(g), this.opaquePassCutoff = 0, n = o(), u = n.map((e1)=>s[e1])), this.style.enable3dLights() && !this._shadowRenderer && Pa(this);
                const w = this._shadowRenderer;
                if (w) {
                    w.updateShadowParameters(this.transform, this.style.directionalLight);
                    for(const e1 in p)for (const t1 of m[e1]){
                        let e1 = {
                            min: 0,
                            max: 0
                        };
                        this.terrain && (e1 = this.terrain.getMinMaxForTile(t1) || e1), w.addShadowReceiver(t1.toUnwrapped(), e1.min, e1.max);
                    }
                }
                "globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e1.er(this.context)), this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new Ta), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0);
                let T = !(!this.style || !this.style.snow), S = !(!this.style || !this.style.rain);
                if (T && !this._snow && Xs.Snow && (this._snow = new Xs.Snow), !T && this._snow && (this._snow.destroy(), delete this._snow), S && !this._rain && Xs.Rain && (this._rain = new Xs.Rain), !S && this._rain && (this._rain.destroy(), delete this._rain), this._snow && this._snow.update(this), this._rain && this._rain.update(this), c && (!this.buildingTileBorderManager && Xs.BuildingTileBorderManager && (this.buildingTileBorderManager = new Xs.BuildingTileBorderManager), this.buildingTileBorderManager)) {
                    const e1 = this.style.getLayerSourceCache(c);
                    this.buildingTileBorderManager.updateBorders(e1, c);
                }
                if (!e1.es(this.context.gl)) return;
                this.renderPass = "offscreen";
                for (const e1 of u){
                    const i = t1.getLayerSourceCache(e1);
                    if (!e1.hasOffscreenPass() || e1.isHidden(this.transform.zoom)) continue;
                    const s = i ? _[i.id] : void 0;
                    ("custom" === e1.type || "raster" === e1.type || "raster-particle" === e1.type || e1.isSky() || s && s.length) && this.renderLayer(this, i, e1, s);
                }
                this.depthRangeFor3D = [
                    0,
                    1 - (u.length + 2) * this.numSublayers * this.depthEpsilon
                ], this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, y)), this.context.bindFramebuffer.set(null), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]);
                const C = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(), E = (()=>{
                    if (i.showOverdrawInspector) return e1.C.black;
                    const t1 = this.style.fog;
                    if (t1 && this.transform.projection.supportsFog) {
                        const i = this.style.getLut(t1.scope);
                        if (!C) {
                            const s = "none" === t1.properties.get("color-use-theme"), r = t1.properties.get("color").toNonPremultipliedRenderColor(s ? null : i).toArray01();
                            return new e1.C(...r);
                        }
                        if (C) {
                            const s = "none" === t1.properties.get("space-color-use-theme"), r = t1.properties.get("space-color").toNonPremultipliedRenderColor(s ? null : i).toArray01();
                            return new e1.C(...r);
                        }
                    }
                    return e1.C.transparent;
                })();
                if (this.context.clear({
                    color: E,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && C && this._atmosphere.drawStars(this, this.style.fog), !this.terrain) for(this.currentLayer = n.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const e1 = u[this.currentLayer], i = t1.getLayerSourceCache(e1);
                    if (e1.isSky()) continue;
                    const s = i ? (e1.is3D(r) ? v : _)[i.id] : void 0;
                    this._renderTileClippingMasks(e1, i, s), this.renderLayer(this, i, e1, s);
                }
                if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && C && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || e1.S(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible())) for(this.currentLayer = 0; this.currentLayer < n.length; this.currentLayer++){
                    const e1 = u[this.currentLayer], i = t1.getLayerSourceCache(e1);
                    e1.isSky() && this.renderLayer(this, i, e1, i ? _[i.id] : void 0);
                }
                function I(e1, t1) {
                    let i;
                    return t1 && (i = ("symbol" === e1.type ? g : e1.is3D(r) ? v : _)[t1.id]), i;
                }
                if (this.renderPass = "translucent", "globe" === this.transform.projection.name) {
                    for(this.renderElevatedRasterBackface = !0, this.currentLayer = 0; this.currentLayer < n.length;){
                        const e1 = u[this.currentLayer];
                        if ("raster" === e1.type || "raster-particle" === e1.type) {
                            const i = t1.getLayerSourceCache(e1);
                            this.renderLayer(this, i, e1, I(e1, i));
                        }
                        ++this.currentLayer;
                    }
                    this.renderElevatedRasterBackface = !1;
                }
                this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
                const D = w ? w.getGroundShadowLayerIndex() : -1;
                let P = !1, L = -1;
                for(let e1 = 0; e1 < n.length; ++e1){
                    const t1 = u[e1];
                    t1.isHidden(this.transform.zoom) || t1.is3D(r) && (L = e1);
                }
                l && -1 === L && (a = !0);
                let R = !1;
                for(; this.currentLayer < n.length;){
                    const e1 = u[this.currentLayer], i = t1.getLayerSourceCache(e1);
                    if (e1.isSky()) ++this.currentLayer;
                    else if (this.terrain && this.style.isLayerDraped(e1)) {
                        if (e1.isHidden(this.transform.zoom)) {
                            ++this.currentLayer;
                            continue;
                        }
                        this.currentLayer = this.terrain.renderBatch(this.currentLayer), this._lastOcclusionLayer = Math.max(this.currentLayer, this._lastOcclusionLayer);
                    } else {
                        if (!R && e1.is3D(r) && !r) {
                            const e1 = this.currentLayer, t1 = (e1)=>{
                                for(this.currentLayer = 0; this.currentLayer < u.length; this.currentLayer++){
                                    const t1 = u[this.currentLayer];
                                    if ("fill" === t1.type && Xs.drawDepthPrepass) {
                                        const i = this.style.getLayerSourceCache(t1);
                                        Xs.drawDepthPrepass(this, i, t1, I(t1, i), e1);
                                    }
                                }
                            };
                            t1("initialize"), t1("reset"), this.currentLayer = e1, R = !0;
                        }
                        if (a && !P && this.terrain && !this.transform.isOrthographic && (P = !0, this.blitDepth()), l && -1 !== L && this.currentLayer === L + 1 && !this.transform.isOrthographic && this.blitDepth(), this.terrain || this._renderTileClippingMasks(e1, i, i ? m[i.id] : void 0), this.renderLayer(this, i, e1, I(e1, i)), !this.terrain && w && this.currentLayer === D) {
                            {
                                this.clearStencil(), this.resetStencilClippingMasks();
                                const e1 = this.currentLayer;
                                for(this.currentLayer = 0; this.currentLayer < u.length; this.currentLayer++){
                                    const e1 = u[this.currentLayer];
                                    if ("fill" === e1.type && Xs.drawGroundShadowMask) {
                                        const t1 = this.style.getLayerSourceCache(e1);
                                        Xs.drawGroundShadowMask(this, t1, e1, I(e1, t1));
                                    }
                                }
                                this.currentLayer = e1;
                            }
                            if (w.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer) {
                                const e1 = this.currentLayer;
                                for(this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= e1; this.currentLayer++){
                                    const e1 = u[this.currentLayer];
                                    if (!e1.hasLightBeamPass()) continue;
                                    const i = t1.getLayerSourceCache(e1);
                                    this.renderLayer(this, i, e1, i ? _[i.id] : void 0);
                                }
                                this.currentLayer = e1, this.renderPass = "translucent";
                            }
                        }
                        if (this.currentLayer >= this._lastOcclusionLayer && this.layersWithOcclusionOpacity.length > 0) {
                            const e1 = this.currentLayer;
                            this.depthOcclusion = !0;
                            for (const e1 of this.layersWithOcclusionOpacity){
                                this.currentLayer = e1;
                                const i = u[this.currentLayer], s = t1.getLayerSourceCache(i), r = s ? _[s.id] : void 0;
                                this.terrain || this._renderTileClippingMasks(i, s, s ? m[s.id] : void 0), this.renderLayer(this, s, i, r);
                            }
                            this.depthOcclusion = !1, this.currentLayer = e1, this.renderPass = "translucent", this.layersWithOcclusionOpacity = [];
                        }
                        ++this.currentLayer;
                    }
                }
                if (this.terrain && this.terrain.postRender(), this._snow && this._snow.draw(this), this._rain && this._rain.draw(this), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
                    let i = null;
                    u.forEach((e1)=>{
                        const s = t1.getLayerSourceCache(e1);
                        s && !e1.isHidden(this.transform.zoom) && s.getVisibleCoordinates().length && (!i || i.getSource().maxzoom < s.getSource().maxzoom) && (i = s);
                    }), i && this.options.showTileBoundaries && xt.drawDebug && xt.drawDebug(this, i, i.getVisibleCoordinates(), e1.C.red, !1, this.options.showParseStatus);
                }
                this.options.showPadding && xt.drawDebugPadding && xt.drawDebugPadding(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(performance.now()), this.saveCanvasCopy()), d || (this.conflationActive = !1);
            }
            prepareLayer(e1) {
                this.gpuTimingStart(e1);
                const { unsupportedLayers: t1 } = this.transform.projection, i = !t1 || !t1.includes(e1.type);
                if (Da[e1.type] && (i || this.terrain && "custom" === e1.type)) {
                    const t1 = this.style.getLayerSourceCache(e1);
                    Da[e1.type](e1, t1, this);
                }
                this.gpuTimingEnd();
            }
            renderLayer(e1, t1, i, s) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "sky" === i.type || "custom" === i.type || "model" === i.type || "raster" === i.type || "raster-particle" === i.type || s && s.length) && (this.id = i.id, this.gpuTimingStart(i), (!e1.transform.projection.unsupportedLayers || !e1.transform.projection.unsupportedLayers.includes(i.type) || e1.terrain && "custom" === i.type) && "clip" !== i.type && "slot" !== i.type && Ia[i.type] && Ia[i.type](e1, t1, i, s, this.style.placement.variableOffsets, this.options.isInitialLoad), Ia[i.type] || (i.mayUse("HD") && async function() {
                    await Ks(), Object.assign(Ia, {
                        building: Xs.drawBuilding,
                        "raster-particle": Xs.drawRasterParticle
                    }), Object.assign(Da, {
                        "raster-particle": Xs.prepareRasterParticle
                    });
                }(), i.mayUse("Standard") && Pa(e1)), this.gpuTimingEnd());
            }
            gpuTimingStart(e1) {
                if (!this.options.gpuTiming) return;
                const t1 = this.context.extTimerQuery, i = this.context.gl;
                let s = this.gpuTimers[e1.id];
                s || (s = this.gpuTimers[e1.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: i.createQuery()
                }), s.calls++, i.beginQuery(t1.TIME_ELAPSED_EXT, s.query);
            }
            gpuTimingDeferredRenderStart() {
                if (this.options.gpuTimingDeferredRender) {
                    const e1 = this.context.extTimerQuery, t1 = this.context.gl, i = t1.createQuery();
                    this.deferredRenderGpuTimeQueries.push(i), t1.beginQuery(e1.TIME_ELAPSED_EXT, i);
                }
            }
            gpuTimingDeferredRenderEnd() {
                this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            gpuTimingEnd() {
                this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
                const e1 = this.gpuTimers;
                return this.gpuTimers = {}, e1;
            }
            collectDeferredRenderGpuQueries() {
                const e1 = this.deferredRenderGpuTimeQueries;
                return this.deferredRenderGpuTimeQueries = [], e1;
            }
            queryGpuTimers(e1) {
                const t1 = {};
                for(const i in e1){
                    const s = e1[i], r = this.context.extTimerQuery, o = r.getQueryParameter(s.query, this.context.gl.QUERY_RESULT) / 1e6;
                    r.deleteQueryEXT(s.query), t1[i] = o;
                }
                return t1;
            }
            queryGpuTimeDeferredRender(e1) {
                if (!this.options.gpuTimingDeferredRender) return 0;
                const t1 = this.context.gl;
                let i = 0;
                for (const s of e1)i += t1.getQueryParameter(s, t1.QUERY_RESULT) / 1e6, t1.deleteQuery(s);
                return i;
            }
            translatePosMatrix(t1, i, s, r, o) {
                if (!s[0] && !s[1]) return t1;
                const n = o ? "map" === r ? this.transform.angle : 0 : "viewport" === r ? -this.transform.angle : 0;
                if (n) {
                    const e1 = Math.sin(n), t1 = Math.cos(n);
                    s = [
                        s[0] * t1 - s[1] * e1,
                        s[0] * e1 + s[1] * t1
                    ];
                }
                const a = [
                    o ? s[0] : e1.c5(i, s[0], this.transform.zoom),
                    o ? s[1] : e1.c5(i, s[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return e1.bM(l, t1, a), l;
            }
            saveTileTexture(e1) {
                if (e1.context !== this.context) return;
                const t1 = e1.size[0], i = this._tileTextures[t1];
                i ? i.push(e1) : this._tileTextures[t1] = [
                    e1
                ];
            }
            getTileTexture(e1) {
                const t1 = this._tileTextures[e1];
                return t1 && t1.length > 0 ? t1.pop() : null;
            }
            terrainRenderModeElevated() {
                return this.style && this.style.hasTerrain() && !!this.terrain && !this.terrain.renderingToTexture || this.forceTerrainMode;
            }
            linearFloatFilteringSupported() {
                return null != this.context.extTextureFloatLinear;
            }
            currentGlobalDefines(e1, t1, i, s, r) {
                const o = void 0 === i ? this.terrain && this.terrain.renderingToTexture : i, n = void 0 === s ? this.terrainRenderModeElevated() : s, a = void 0 === r ? "globe" === this.transform.projection.name : r, l = [];
                return this.style && this.style.enable3dLights() && ("globeRaster" === e1 || "terrainRaster" === e1 ? (l.push("LIGHTING_3D_MODE"), l.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : o || l.push("LIGHTING_3D_MODE")), n && (l.push("TERRAIN"), this.linearFloatFilteringSupported() && l.push("TERRAIN_DEM_FLOAT_FORMAT")), a && l.push("GLOBE"), !this._fogVisible || o || void 0 !== t1 && !t1 || l.push("FOG"), o && l.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && l.push("OVERDRAW_INSPECTOR"), l;
            }
            getOrCreateProgram(e1, t1) {
                this.cache = this.cache || {};
                const { defines: i, config: s, overrideFog: r, overrideRtt: o, overrideTerrain: n, overrideGlobe: a, precompiled: l } = t1 || {}, c = this.currentGlobalDefines(e1, r, o, n, a).concat(i || []), h = this.getShaderSource(e1), d = Xs.programUniforms, u = ci.programUniforms, p = Vn[e1] || d && d[e1] || u && u[e1], f = In.cacheKey(h, e1, c, s);
                return this.cache[f] || (this.cache[f] = new In(this.context, e1, h, s, p, c, l)), this.cache[f];
            }
            getShaderSource(t1) {
                const i = Xs.shaders, s = ci.shaders;
                return e1.et[t1] || i && i[t1] || s && s[t1];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e1 = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e1.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e1.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA8));
            }
            destroy() {
                this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy(), this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), this.emptyDepthTexture && this.emptyDepthTexture.destroy(), this._destroyed = !0;
            }
            prepareDrawTile() {
                this.terrain && this.terrain.prepareDrawTile();
            }
            uploadCommonLightUniforms(t1, i, s) {
                if (this.style.enable3dLights()) {
                    const r = this.style.directionalLight, o = this.style.ambientLight;
                    if (r && o) {
                        const n = ((t1, i, s, r)=>{
                            const o = t1.properties.get("direction"), n = "none" === t1.properties.get("color-use-theme"), a = t1.properties.get("color").toNonPremultipliedRenderColor(n ? null : s.getLut(t1.scope)).toArray01();
                            let l = t1.properties.get("intensity");
                            const c = "none" === i.properties.get("color-use-theme"), h = i.properties.get("color").toNonPremultipliedRenderColor(c ? null : s.getLut(i.scope)).toArray01();
                            let d = i.properties.get("intensity");
                            const u = [
                                o.x,
                                o.y,
                                o.z
                            ];
                            r && (void 0 !== r.ambientIntensity && (d = r.ambientIntensity), void 0 !== r.directionalIntensity && (l = r.directionalIntensity), void 0 !== r.ambientColor && (h[0] = r.ambientColor[0], h[1] = r.ambientColor[1], h[2] = r.ambientColor[2]), void 0 !== r.directionalColor && (a[0] = r.directionalColor[0], a[1] = r.directionalColor[1], a[2] = r.directionalColor[2]));
                            const p = e1.dA(h, d), f = e1.dA(a, l);
                            return {
                                u_lighting_ambient_color: p,
                                u_lighting_directional_dir: u,
                                u_lighting_directional_color: f,
                                u_ground_radiance: Sn(u, f, p)
                            };
                        })(r, o, this.style, s);
                        i.setLightsUniformValues(t1, n);
                    }
                }
            }
            uploadCommonUniforms(t1, i, s, r, o, n) {
                if (this.uploadCommonLightUniforms(t1, i, n), this.terrain && this.terrain.renderingToTexture) return;
                const a = this.style.fog;
                if (a) {
                    const o = a.getOpacity(this.transform.pitch), n = ((t1, i, s, r, o, n, a, l, c, h, d, u)=>{
                        const p = t1.transform, f = "none" === i.properties.get("color-use-theme"), m = i.properties.get("color").toNonPremultipliedRenderColor(f ? null : t1.style.getLut(i.scope)).toArray01();
                        m[3] = r;
                        const _ = t1.frameCounter / 1e3 % 1, [g, y] = i.properties.get("vertical-range");
                        return {
                            u_fog_matrix: s ? p.calculateFogTileMatrix(s) : u || t1.identityMat,
                            u_fog_range: i.getRangeForProjection(),
                            u_fog_color: m,
                            u_fog_horizon_blend: i.properties.get("horizon-blend"),
                            u_fog_vertical_limit: [
                                Math.min(g, y),
                                y
                            ],
                            u_fog_temporal_offset: _,
                            u_frustum_tl: o,
                            u_frustum_tr: n,
                            u_frustum_br: a,
                            u_frustum_bl: l,
                            u_globe_pos: c,
                            u_globe_radius: h,
                            u_viewport: d,
                            u_globe_transition: e1.S(p.zoom),
                            u_is_globe: +("globe" === p.projection.name)
                        };
                    })(this, a, s, o, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [
                        this.transform.width * e1.e.devicePixelRatio,
                        this.transform.height * e1.e.devicePixelRatio
                    ], r);
                    i.setFogUniformValues(t1, n);
                }
                o && i.setCutoffUniformValues(t1, o.uniformValues);
            }
            setTileLoadedFlag(e1) {
                this.tileLoaded = e1;
            }
            saveCanvasCopy() {
                const e1 = this.canvasCopy();
                e1 && (this.frameCopies.push(e1), this.tileLoaded = !1);
            }
            canvasCopy() {
                const e1 = this.context.gl, t1 = e1.createTexture();
                return e1.bindTexture(e1.TEXTURE_2D, t1), e1.copyTexImage2D(e1.TEXTURE_2D, 0, e1.RGBA, 0, 0, e1.drawingBufferWidth, e1.drawingBufferHeight, 0), t1;
            }
            getCanvasCopiesAndTimestamps() {
                return {
                    canvasCopies: this.frameCopies,
                    timeStamps: this.loadTimeStamps
                };
            }
            averageElevationNeedsEasing() {
                if (!this.transform._elevation) return !1;
                const e1 = this.style && this.style.fog;
                return !!e1 && 0 !== e1.getOpacity(this.transform.pitch);
            }
            getBackgroundTiles() {
                const e1 = this._backgroundTiles, t1 = this._backgroundTiles = {}, i = this.transform.coveringTiles({
                    tileSize: 512
                });
                for (const s of i)t1[s.key] = e1[s.key] || new fs(s, 512, this.transform.tileZoom, this, void 0, this.worldview);
                return t1;
            }
            clearBackgroundTiles() {
                this._backgroundTiles = {};
            }
            isSourceForClippingOrConflation(e1, t1) {
                return !(!e1.is3D(!(!this.terrain || !this.terrain.enabled)) || "clip" !== e1.type && "building" !== e1.type && (e1.minzoom && e1.minzoom > this.transform.zoom || (this.style._clipLayerPresent || "building" !== e1.sourceLayer && "procedural_buildings" !== e1.sourceLayer) && (!t1 || "batched-model" !== t1.type)));
            }
            isTileAffectedByFog(t1) {
                if (!this.style || !this.style.fog) return !1;
                if ("globe" === this.transform.projection.name) return !0;
                let i = this._cachedTileFogOpacities[t1.key];
                return i || (this._cachedTileFogOpacities[t1.key] = i = this.style.fog.getOpacityForTile(t1)), i[0] >= e1.at || i[1] >= e1.at;
            }
            setupDepthForOcclusion(e1, t1, i) {
                const s = this.context, r = s.gl, o = !!i;
                var n;
                i || (i = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                }), s.activeTexture.set(r.TEXTURE3), e1 && this.depthFBO && this.depthTexture ? (this.depthTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), i.u_depth_size_inv = [
                    1 / this.depthFBO.width,
                    1 / this.depthFBO.height
                ], i.u_depth_range_unpack = [
                    2 / ((n = this.depthRangeFor3D)[1] - n[0]),
                    -1 - 2 * n[0] / (n[1] - n[0])
                ], i.u_occluder_half_size = .5 * this.occlusionParams.occluderSize, i.u_occlusion_depth_offset = this.occlusionParams.depthOffset) : this.emptyDepthTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), s.activeTexture.set(r.TEXTURE0), o || t1.setTerrainUniformValues(s, i);
            }
            updateEmissiveMode() {
                if (this._forceEmissiveMode) return;
                const e1 = this.style.hasDataDrivenEmissiveStrength();
                this.emissiveMode = e1 ? this.context.extBlendFuncExtended ? "dual-source-blending" : "mrt-fallback" : "constant";
            }
        }
        function Ra(e1, t1) {
            let i = !1, s = null;
            const r = ()=>{
                s = null, i && (e1(), s = setTimeout(r, t1), i = !1);
            };
            return ()=>(i = !0, s || r(), s);
        }
        const Aa = /(#.+)?$/;
        class Ma {
            constructor(t1){
                this._hashName = t1 && encodeURIComponent(t1), e1.aV([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = Ra(this._updateHashUnthrottled.bind(this), 300);
            }
            addTo(e1) {
                return this._map = e1, window.addEventListener("hashchange", this._onHashChange, !1), e1.on("moveend", this._updateHash), this;
            }
            remove() {
                return this._map ? (this._map.off("moveend", this._updateHash), window.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
            }
            getHashString() {
                const e1 = this._map;
                if (!e1) return "";
                const t1 = Fa(e1);
                if (this._hashName) {
                    const e1 = this._hashName;
                    let i = !1;
                    const s = location.hash.slice(1).split("&").map((s)=>{
                        const r = s.split("=")[0];
                        return r === e1 ? (i = !0, `${r}=${t1}`) : s;
                    }).filter((e1)=>e1);
                    return i || s.push(`${e1}=${t1}`), `#${s.join("&")}`;
                }
                return `#${t1}`;
            }
            _getCurrentHash() {
                const e1 = location.hash.replace("#", "");
                if (this._hashName) {
                    let t1;
                    return e1.split("&").map((e1)=>e1.split("=")).forEach((e1)=>{
                        e1[0] === this._hashName && (t1 = e1);
                    }), (t1 && t1[1] || "").split("/");
                }
                return e1.split("/");
            }
            _onHashChange() {
                const e1 = this._map;
                if (!e1) return !1;
                const t1 = this._getCurrentHash();
                if (t1.length >= 3 && !t1.some((e1)=>isNaN(Number(e1)))) {
                    const i = e1.dragRotate.isEnabled() && e1.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : e1.getBearing();
                    return e1.jumpTo({
                        center: [
                            +t1[2],
                            +t1[1]
                        ],
                        zoom: +t1[0],
                        bearing: i,
                        pitch: +(t1[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                history.replaceState(history.state, "", location.href.replace(Aa, this.getHashString()));
            }
        }
        function Fa(e1, t1) {
            const i = e1.getCenter(), s = Math.round(100 * e1.getZoom()) / 100, r = Math.ceil((s * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), o = Math.pow(10, r), n = Math.round(i.lng * o) / o, a = Math.round(i.lat * o) / o, l = e1.getBearing(), c = e1.getPitch();
            let h = t1 ? `/${n}/${a}/${s}` : `${s}/${a}/${n}`;
            return (l || c) && (h += "/" + Math.round(10 * l) / 10), c && (h += `/${Math.round(c)}`), h;
        }
        const Oa = {
            linearity: .3,
            easing: e1.ev(0, 0, .3, 1)
        }, Ba = {
            deceleration: 2500,
            maxSpeed: 1400,
            ...Oa
        }, ka = {
            deceleration: 20,
            maxSpeed: 1400,
            ...Oa
        }, za = {
            deceleration: 1e3,
            maxSpeed: 360,
            ...Oa
        }, Ua = {
            deceleration: 1e3,
            maxSpeed: 90,
            ...Oa
        };
        class Na {
            constructor(e1){
                this._map = e1, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(t1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: e1.e.now(),
                    settings: t1
                });
            }
            _drainInertiaBuffer() {
                const t1 = this._inertiaBuffer, i = e1.e.now();
                for(; t1.length > 0 && i - t1[0].time > 160;)t1.shift();
            }
            _onMoveEnd(t1) {
                if (this._map._prefersReducedMotion()) return;
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new e1.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e1 } of this._inertiaBuffer)i.zoom += e1.zoomDelta || 0, i.bearing += e1.bearingDelta || 0, i.pitch += e1.pitchDelta || 0, e1.panDelta && i.pan._add(e1.panDelta), e1.around && (i.around = e1.around), e1.pinchAround && (i.pinchAround = e1.pinchAround);
                const s = this._inertiaBuffer.at(-1).time - this._inertiaBuffer[0].time, r = {};
                if (i.pan.mag()) {
                    const e1 = Va(i.pan.mag(), s, {
                        ...Ba,
                        ...t1 || {}
                    });
                    r.offset = i.pan.mult(e1.amount / i.pan.mag()), r.center = this._map.transform.center, ja(r, e1);
                }
                if (i.zoom) {
                    const e1 = Va(i.zoom, s, ka);
                    r.zoom = this._map.transform.zoom + e1.amount, ja(r, e1);
                }
                if (i.bearing) {
                    const t1 = Va(i.bearing, s, za);
                    r.bearing = this._map.transform.bearing + e1.b0(t1.amount, -179, 179), ja(r, t1);
                }
                if (i.pitch) {
                    const e1 = Va(i.pitch, s, Ua);
                    r.pitch = this._map.transform.pitch + e1.amount, ja(r, e1);
                }
                if (r.zoom || r.bearing) {
                    const e1 = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    r.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
                }
                return this.clear(), r.noMoveStart = !0, r;
            }
        }
        function ja(e1, t1) {
            (!e1.duration || e1.duration < t1.duration) && (e1.duration = t1.duration, e1.easing = t1.easing);
        }
        function Va(t1, i, s) {
            const { maxSpeed: r, linearity: o, deceleration: n } = s, a = e1.b0(t1 * o / (i / 1e3), -r, r), l = Math.abs(a) / (n * o);
            return {
                easing: s.easing,
                duration: 1e3 * l,
                amount: a * (l / 2)
            };
        }
        class Ga extends e1.h {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t1, i, s = {}){
                const r = _(t1.getCanvasContainer(), i);
                super(e1, {
                    point: r,
                    lngLat: t1.unproject(r),
                    originalEvent: i,
                    ...s
                }), this._defaultPrevented = !1, this.target = t1;
            }
        }
        class qa extends e1.h {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, s){
                const r = "touchend" === t1 ? s.changedTouches : s.touches, o = g(i.getCanvasContainer(), r), n = o.map((e1)=>i.unproject(e1)), a = o.reduce((e1, t1, i, s)=>e1.add(t1.div(s.length)), new e1.P(0, 0));
                super(t1, {
                    points: o,
                    point: a,
                    lngLats: n,
                    lngLat: i.unproject(a),
                    originalEvent: s
                }), this._defaultPrevented = !1;
            }
        }
        class Za extends e1.h {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t1){
                super("wheel", {
                    originalEvent: t1
                }), this._defaultPrevented = !1;
            }
        }
        class $a {
            constructor(e1, t1){
                this._map = e1, this._clickTolerance = t1.clickTolerance;
            }
            reset() {
                this._mousedownPos = void 0;
            }
            wheel(e1) {
                return this._firePreventable(new Za(this._map, e1));
            }
            mousedown(e1, t1) {
                return this._mousedownPos = t1, this._firePreventable(new Ga(e1.type, this._map, e1));
            }
            mouseup(e1) {
                this._map.fire(new Ga(e1.type, this._map, e1));
            }
            preclick(e1) {
                const t1 = new MouseEvent("preclick", e1);
                this._map.fire(new Ga(t1.type, this._map, t1));
            }
            click(e1, t1) {
                this._mousedownPos && this._mousedownPos.dist(t1) >= this._clickTolerance || (this.preclick(e1), this._map.fire(new Ga(e1.type, this._map, e1)));
            }
            dblclick(e1) {
                return this._firePreventable(new Ga(e1.type, this._map, e1));
            }
            mouseover(e1) {
                this._map.fire(new Ga(e1.type, this._map, e1));
            }
            mouseout(e1) {
                this._map.fire(new Ga(e1.type, this._map, e1));
            }
            touchstart(e1) {
                return this._firePreventable(new qa(e1.type, this._map, e1));
            }
            touchmove(e1) {
                this._map.fire(new qa(e1.type, this._map, e1));
            }
            touchend(e1) {
                this._map.fire(new qa(e1.type, this._map, e1));
            }
            touchcancel(e1) {
                this._map.fire(new qa(e1.type, this._map, e1));
            }
            _firePreventable(e1) {
                if (this._map.fire(e1), e1.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class Ha {
            constructor(e1){
                this._map = e1;
            }
            reset() {
                this._delayContextMenu = !1, this._contextMenuEvent = void 0;
            }
            mousemove(e1) {
                this._map.fire(new Ga(e1.type, this._map, e1));
            }
            mousedown() {
                this._delayContextMenu = !0;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new Ga("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e1) {
                this._delayContextMenu ? this._contextMenuEvent = e1 : this._map.fire(new Ga(e1.type, this._map, e1)), this._map.listens("contextmenu") && e1.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class Wa {
            constructor(e1, t1){
                this._map = e1, this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t1.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e1, t1) {
                this.isEnabled() && e1.shiftKey && 0 === e1.button && (u(), this._startPos = this._lastPos = t1, this._active = !0);
            }
            mousemoveWindow(e1, t1) {
                if (!this._active) return;
                const i = t1, s = this._startPos, r = this._lastPos;
                if (!s || !r || r.equals(i) || !this._box && i.dist(s) < this._clickTolerance) return;
                this._lastPos = i, this._box || (this._box = a("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e1));
                const o = Math.min(s.x, i.x), n = Math.max(s.x, i.x), l = Math.min(s.y, i.y), c = Math.max(s.y, i.y);
                this._map._requestDomTask(()=>{
                    this._box && (this._box.style.transform = `translate(${o}px,${l}px)`, this._box.style.width = n - o + "px", this._box.style.height = c - l + "px");
                });
            }
            mouseupWindow(t1, i) {
                if (!this._active) return;
                const s = this._startPos, r = i;
                if (s && 0 === t1.button) {
                    if (this.reset(), m(), s.x !== r.x || s.y !== r.y) return this._map.fire(new e1.h("boxzoomend", {
                        originalEvent: t1
                    })), {
                        cameraAnimation: (e1)=>e1.fitScreenCoordinates(s, r, this._map.getBearing(), {
                                linear: !1
                            })
                    };
                    this._fireEvent("boxzoomcancel", t1);
                }
            }
            keydown(e1) {
                this._active && 27 === e1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e1));
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), p(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(t1, i) {
                return this._map.fire(new e1.h(t1, {
                    originalEvent: i
                }));
            }
        }
        function Xa(e1, t1) {
            const i = {};
            for(let s = 0; s < e1.length; s++)i[e1[s].identifier] = t1[s];
            return i;
        }
        class Ka {
            constructor(e1){
                this.reset(), this.numTouches = e1.numTouches;
            }
            reset() {
                this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
            }
            touchstart(t1, i, s) {
                (this.centroid || s.length > this.numTouches) && (this.aborted = !0), this.aborted || (0 === this.startTime && (this.startTime = t1.timeStamp), s.length === this.numTouches && (this.centroid = function(t1) {
                    const i = new e1.P(0, 0);
                    for (const e1 of t1)i._add(e1);
                    return i.div(t1.length);
                }(i), this.touches = Xa(s, i)));
            }
            touchmove(e1, t1, i) {
                if (this.aborted || !this.centroid) return;
                const s = Xa(i, t1);
                for(const e1 in this.touches){
                    const t1 = s[e1];
                    (!t1 || t1.dist(this.touches[e1]) > 30) && (this.aborted = !0);
                }
            }
            touchend(e1, t1, i) {
                if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e1 = !this.aborted && this.centroid;
                    if (this.reset(), e1) return e1;
                }
            }
        }
        class Ya {
            constructor(e1){
                this.singleTap = new Ka(e1), this.numTaps = e1.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
            }
            touchstart(e1, t1, i) {
                this.singleTap.touchstart(e1, t1, i);
            }
            touchmove(e1, t1, i) {
                this.singleTap.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                const s = this.singleTap.touchend(e1, t1, i);
                if (s) {
                    const t1 = e1.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(s) < 30;
                    if (t1 && i || this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = s, this.count === this.numTaps) return this.reset(), s;
                }
            }
        }
        class Qa {
            constructor(){
                this._zoomIn = new Ya({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new Ya({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e1, t1, i) {
                this._zoomIn.touchstart(e1, t1, i), this._zoomOut.touchstart(e1, t1, i);
            }
            touchmove(e1, t1, i) {
                this._zoomIn.touchmove(e1, t1, i), this._zoomOut.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                const s = this._zoomIn.touchend(e1, t1, i), r = this._zoomOut.touchend(e1, t1, i);
                return s ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() + 1,
                            around: t1.unproject(s)
                        }, {
                            originalEvent: e1
                        })
                }) : r ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() - 1,
                            around: t1.unproject(r)
                        }, {
                            originalEvent: e1
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        const Ja = 0, el = 2, tl = {
            [Ja]: 1,
            [el]: 2
        }, il = {
            Control: "ctrlKey",
            Alt: "altKey",
            Shift: "shiftKey",
            Meta: "metaKey"
        };
        class sl {
            constructor(e1){
                this.reset(), this._clickTolerance = e1.clickTolerance || 1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
            }
            _correctButton(e1, t1) {
                return !1;
            }
            _move(e1, t1) {
                return {};
            }
            mousedown(e1, t1) {
                if (this._lastPoint) return;
                const i = y(e1);
                this._correctButton(e1, i) && (this._lastPoint = t1, this._eventButton = i);
            }
            mousemoveWindow(e1, t1) {
                const i = this._lastPoint;
                if (i) {
                    if (e1.preventDefault(), null != this._eventButton && function(e1, t1) {
                        const i = tl[t1];
                        return void 0 === e1.buttons || (e1.buttons & i) !== i;
                    }(e1, this._eventButton)) this.reset();
                    else if (this._moved || !(t1.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = t1, this._move(i, t1);
                }
            }
            mouseupWindow(e1) {
                this._lastPoint && y(e1) === this._eventButton && (this._moved && m(), this.reset());
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class rl extends sl {
            mousedown(e1, t1) {
                super.mousedown(e1, t1), this._lastPoint && (this._active = !0);
            }
            _correctButton(e1, t1) {
                return 0 === t1 && !e1.ctrlKey;
            }
            _move(e1, t1) {
                return {
                    around: t1,
                    panDelta: t1.sub(e1)
                };
            }
        }
        class ol extends sl {
            constructor(e1){
                super(e1), this._pitchRotateKey = e1.pitchRotateKey ? il[e1.pitchRotateKey] : void 0;
            }
            _correctButton(e1, t1) {
                return this._pitchRotateKey ? 0 === t1 && e1[this._pitchRotateKey] : 0 === t1 && e1.ctrlKey || 2 === t1;
            }
            _move(e1, t1) {
                const i = .8 * (t1.x - e1.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }
            contextmenu(e1) {
                this._pitchRotateKey || e1.preventDefault();
            }
        }
        class nl extends sl {
            constructor(e1){
                super(e1), this._pitchRotateKey = e1.pitchRotateKey ? il[e1.pitchRotateKey] : void 0;
            }
            _correctButton(e1, t1) {
                return this._pitchRotateKey ? 0 === t1 && e1[this._pitchRotateKey] : 0 === t1 && e1.ctrlKey || 2 === t1;
            }
            _move(e1, t1) {
                const i = -0.5 * (t1.y - e1.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }
            contextmenu(e1) {
                this._pitchRotateKey || e1.preventDefault();
            }
        }
        class al {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i.clickTolerance || 1, this.reset(), e1.aV([
                    "_addTouchPanBlocker",
                    "_showTouchPanBlockerAlert"
                ], this);
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new e1.P(0, 0);
            }
            touchstart(e1, t1, i) {
                return this._calculateTransform(e1, t1, i);
            }
            touchmove(t1, i, s) {
                if (this._active && !(s.length < this._minTouches)) {
                    if (this._map._cooperativeGestures && !this._map.isMoving()) {
                        if (1 === s.length && !e1.ew()) return void this._showTouchPanBlockerAlert();
                        "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                    }
                    return t1.cancelable && t1.preventDefault(), this._calculateTransform(t1, i, s);
                }
            }
            touchend(e1, t1, i) {
                this._calculateTransform(e1, t1, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(t1, i, s) {
                s.length > 0 && (this._active = !0);
                const r = Xa(s, i), o = new e1.P(0, 0), n = new e1.P(0, 0);
                let a = 0;
                for(const e1 in r){
                    const t1 = r[e1], i = this._touches[e1];
                    i && (o._add(t1), n._add(t1.sub(i)), a++, r[e1] = t1);
                }
                if (this._touches = r, a < this._minTouches || !n.mag()) return;
                const l = n.div(a);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: o.div(a),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
            }
            disable() {
                this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            _addTouchPanBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = a("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showTouchPanBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 500);
            }
        }
        class ll {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, this._firstTwoTouches = void 0;
            }
            _start(e1) {}
            _move(e1, t1, i) {
                return {};
            }
            touchstart(e1, t1, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t1[0],
                    t1[1]
                ]));
            }
            touchmove(e1, t1, i) {
                const s = this._firstTwoTouches;
                if (!s) return;
                e1.preventDefault();
                const [r, o] = s, n = cl(i, t1, r), a = cl(i, t1, o);
                if (!n || !a) return;
                const l = this._aroundCenter ? null : n.add(a).div(2);
                return this._move([
                    n,
                    a
                ], l, e1);
            }
            touchend(e1, t1, i) {
                if (!this._firstTwoTouches) return;
                const [s, r] = this._firstTwoTouches, o = cl(i, t1, s), n = cl(i, t1, r);
                o && n || (this._active && m(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e1) {
                this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        function cl(e1, t1, i) {
            for(let s = 0; s < e1.length; s++)if (e1[s].identifier === i) return t1[s];
        }
        function hl(e1, t1) {
            return Math.log2(e1 / t1);
        }
        class dl extends ll {
            reset() {
                super.reset(), this._distance = 0, this._startDistance = 0;
            }
            _start(e1) {
                this._startDistance = this._distance = e1[0].dist(e1[1]);
            }
            _move(e1, t1) {
                const i = this._distance;
                if (this._distance = e1[0].dist(e1[1]), this._active || !(Math.abs(hl(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: hl(this._distance, i),
                    pinchAround: t1
                };
            }
        }
        function ul(e1, t1) {
            return 180 * e1.angleWith(t1) / Math.PI;
        }
        class pl extends ll {
            reset() {
                super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
            }
            _start(e1) {
                this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
            }
            _move(e1, t1) {
                const i = this._vector;
                if (this._vector = e1[0].sub(e1[1]), i && (this._active || !this._isBelowThreshold(this._vector))) return this._active = !0, {
                    bearingDelta: ul(this._vector, i),
                    pinchAround: t1
                };
            }
            _isBelowThreshold(e1) {
                this._minDiameter = Math.min(this._minDiameter, e1.mag());
                const t1 = 25 / (Math.PI * this._minDiameter) * 360, i = this._startVector;
                if (!i) return !1;
                const s = ul(e1, i);
                return Math.abs(s) < t1;
            }
        }
        function fl(e1) {
            return Math.abs(e1.y) > Math.abs(e1.x);
        }
        class ml extends ll {
            constructor(e1){
                super(), this._map = e1;
            }
            reset() {
                super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
            }
            _start(e1) {
                this._lastPoints = e1, fl(e1[0].sub(e1[1])) && (this._valid = !1);
            }
            _move(t1, i, s) {
                const r = this._lastPoints;
                if (!r) return;
                const o = t1[0].sub(r[0]), n = t1[1].sub(r[1]);
                return this._map._cooperativeGestures && !e1.ew() && s.touches.length < 3 || (this._valid = this.gestureBeginsVertically(o, n, s.timeStamp), !this._valid) ? void 0 : (this._lastPoints = t1, this._active = !0, {
                    pitchDelta: (o.y + n.y) / 2 * -0.5
                });
            }
            gestureBeginsVertically(e1, t1, i) {
                if (void 0 !== this._valid) return this._valid;
                const s = e1.mag() >= 2, r = t1.mag() >= 2;
                if (!s && !r) return;
                if (!s || !r) return this._firstMove ??= i, i - this._firstMove < 100 && void 0;
                const o = e1.y > 0 == t1.y > 0;
                return fl(e1) && fl(t1) && o;
            }
        }
        const _l = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class gl {
            constructor(){
                const e1 = _l;
                this._panStep = e1.panStep, this._bearingStep = e1.bearingStep, this._pitchStep = e1.pitchStep, this._rotationDisabled = !1, this._panDisabled = !1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            keydown(e1) {
                if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
                let t1 = 0, i = 0, s = 0, r = 0, o = 0;
                switch(e1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t1 = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t1 = -1;
                        break;
                    case 37:
                        e1.shiftKey ? i = -1 : (e1.preventDefault(), r = -1);
                        break;
                    case 39:
                        e1.shiftKey ? i = 1 : (e1.preventDefault(), r = 1);
                        break;
                    case 38:
                        e1.shiftKey ? s = 1 : (e1.preventDefault(), o = -1);
                        break;
                    case 40:
                        e1.shiftKey ? s = -1 : (e1.preventDefault(), o = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, s = 0), this._panDisabled && (r = 0, o = 0), {
                    cameraAnimation: (n)=>{
                        const a = n.getZoom();
                        n.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: yl,
                            zoom: t1 ? Math.round(a) + t1 * (e1.shiftKey ? 2 : 1) : a,
                            bearing: n.getBearing() + i * this._bearingStep,
                            pitch: n.getPitch() + s * this._pitchStep,
                            offset: [
                                -r * this._panStep,
                                -o * this._panStep
                            ],
                            center: n.getCenter()
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
            disablePan() {
                this._panDisabled = !0;
            }
            enablePan() {
                this._panDisabled = !1;
            }
        }
        function yl(e1) {
            return e1 * (2 - e1);
        }
        const vl = 4.000244140625, bl = 1 / 450, xl = /(Mac|iPad)/i;
        class wl {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._handler = i, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = bl, e1.aV([
                    "_onTimeout",
                    "_addScrollZoomBlocker",
                    "_showBlockerAlert"
                ], this);
            }
            setZoomRate(e1) {
                this._defaultZoomRate = e1;
            }
            setWheelZoomRate(e1) {
                this._wheelZoomRate = e1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e1) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
            }
            disable() {
                this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
            }
            wheel(t1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!(t1.ctrlKey || t1.metaKey || this.isZooming() || e1.ew())) return void this._showBlockerAlert();
                    "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                }
                let i = t1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t1.deltaY : t1.deltaY;
                const s = e1.e.now(), r = s - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = s, 0 !== i && i % vl === 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : r > 400 ? (this._type = null, this._lastValue = i, this._timeout = window.setTimeout(this._onTimeout, 40, t1)) : this._type || (this._type = Math.abs(r * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), t1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = t1, this._delta -= i, this._active || this._start(t1)), t1.preventDefault();
            }
            _onTimeout(e1) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e1);
            }
            _start(e1) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const t1 = _(this._el, e1);
                this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t1, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const t1 = this._map.transform;
                "wheel" === this._type && t1.projection.wrap && (t1._center.lng >= 180 || t1._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
                const i = ()=>t1._terrainEnabled() && this._aroundCoord ? t1.computeZoomRelativeTo(this._aroundCoord) : t1.zoom;
                if (0 !== this._delta) {
                    const e1 = "wheel" === this._type && Math.abs(this._delta) > vl ? this._wheelZoomRate : this._defaultZoomRate;
                    let s = 2 / (1 + Math.exp(-Math.abs(this._delta * e1)));
                    this._delta < 0 && 0 !== s && (s = 1 / s);
                    const r = i(), o = Math.pow(2, r), n = "number" == typeof this._targetZoom ? t1.zoomScale(this._targetZoom) : o;
                    this._targetZoom = Math.min(t1.maxZoom, Math.max(t1.minZoom, t1.scaleZoom(n * s))), "wheel" === this._type && (this._startZoom = r, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
                }
                const s = "number" == typeof this._targetZoom ? this._targetZoom : i(), r = this._startZoom, o = this._easing;
                let n, a = !1;
                if ("wheel" === this._type && r && o) {
                    const t1 = Math.min((e1.e.now() - this._lastWheelEventTime) / 200, 1), i = o(t1);
                    n = e1.al(r, s, i), t1 < 1 ? this._frameId || (this._frameId = !0) : a = !0;
                } else n = s, a = !0;
                this._active = !0, a && (this._active = !1, this._finishTimeout = window.setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200));
                let l = n - i();
                return l * this._lastDelta < 0 && (l = 0), {
                    noInertia: !0,
                    needsRenderFrame: !a,
                    zoomDelta: l,
                    around: this._aroundPoint,
                    aroundCoord: this._aroundCoord,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(t1) {
                let i = e1.ex;
                if (this._prevEase) {
                    const t1 = this._prevEase, s = (e1.e.now() - t1.start) / t1.duration, r = t1.easing(s + .01) - t1.easing(s), o = .27 / Math.sqrt(r * r + 1e-4) * .01, n = Math.sqrt(.0729 - o * o);
                    i = e1.ev(o, n, .25, 1);
                }
                return this._prevEase = {
                    start: e1.e.now(),
                    duration: t1,
                    easing: i
                }, i;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            _addScrollZoomBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = a("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = xl.test(navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 200);
            }
        }
        class Tl {
            constructor(e1, t1){
                this._clickZoom = e1, this._tapZoom = t1;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class Sl {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            blur() {
                this.reset();
            }
            dblclick(e1, t1) {
                return e1.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: i.getZoom() + (e1.shiftKey ? -1 : 1),
                            around: i.unproject(t1)
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Cl {
            constructor(){
                this._tap = new Ya({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
            }
            touchstart(e1, t1, i) {
                this._swipePoint || (this._tapTime && e1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = t1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(e1, t1, i));
            }
            touchmove(e1, t1, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const s = t1[0], r = s.y - this._swipePoint.y;
                        return this._swipePoint = s, e1.preventDefault(), this._active = !0, {
                            zoomDelta: r / 128
                        };
                    }
                } else this._tap.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(e1, t1, i) && (this._tapTime = e1.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class El {
            constructor(e1, t1, i){
                this._el = e1, this._mousePan = t1, this._touchPan = i;
            }
            enable(e1) {
                this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class Il {
            constructor(e1, t1, i){
                this._pitchWithRotate = e1.pitchWithRotate, this._mouseRotate = t1, this._mousePitch = i, this._pitchDisabled = !1;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && !this._pitchDisabled && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._pitchDisabled || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
            disablePitch() {
                this._pitchDisabled = !0, this._mousePitch.disable();
            }
            enablePitch() {
                this._pitchDisabled = !1, this._pitchWithRotate && this._mouseRotate.isEnabled() && this._mousePitch.enable();
            }
        }
        class Dl {
            constructor(e1, t1, i, s){
                this._el = e1, this._touchZoom = t1, this._touchRotate = i, this._tapDragZoom = s, this._rotationDisabled = !1, this._tapDragZoomDisabled = !1, this._enabled = !0;
            }
            enable(e1) {
                this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoomDisabled || this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && (this._tapDragZoomDisabled || this._tapDragZoom.isEnabled());
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
            disableTapDragZoom() {
                this._tapDragZoomDisabled = !0, this._tapDragZoom.disable();
            }
            enableTapDragZoom() {
                this._tapDragZoomDisabled = !1, this._touchZoom.isEnabled() && this._tapDragZoom.enable();
            }
        }
        const Pl = (e1)=>e1.zoom || e1.drag || e1.pitch || e1.rotate;
        class Ll extends e1.h {
        }
        class Rl {
            constructor(){
                this.constants = [
                    1,
                    1,
                    .01
                ], this.radius = 0;
            }
            setup(t1, i) {
                const s = e1.c2([], i, t1);
                this.radius = e1.el(s[2] < 0 ? e1.ez([], s, this.constants) : [
                    s[0],
                    s[1],
                    0
                ]);
            }
            projectRay(t1) {
                e1.ez(t1, t1, this.constants), e1.c3(t1, t1), e1.eA(t1, t1, this.constants);
                const i = e1.dB([], t1, this.radius);
                if (i[2] > 0) {
                    const t1 = e1.dB([], [
                        0,
                        0,
                        1
                    ], e1.dE(i, [
                        0,
                        0,
                        1
                    ])), s = e1.dB([], e1.c3([], [
                        i[0],
                        i[1],
                        0
                    ]), this.radius), r = e1.dC([], i, e1.dB([], e1.c2([], e1.dC([], s, t1), i), 2));
                    i[0] = r[0], i[1] = r[1];
                }
                return i;
            }
        }
        function Al(e1) {
            return e1.panDelta && e1.panDelta.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta;
        }
        class Ml {
            constructor(t1, i){
                this._map = t1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Na(t1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new Rl, this._dragOrigin = null, this._mouseBeingPressed = !1, this._activeTouchCount = 0, this._eventsInProgress = {}, this._addDefaultHandlers(i), e1.aV([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const s = this._el;
                this._listeners = [
                    [
                        s,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        s,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        s,
                        "touchend",
                        void 0
                    ],
                    [
                        s,
                        "touchcancel",
                        void 0
                    ],
                    [
                        s,
                        "mousedown",
                        void 0
                    ],
                    [
                        s,
                        "mousemove",
                        void 0
                    ],
                    [
                        s,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        s,
                        "mouseover",
                        void 0
                    ],
                    [
                        s,
                        "mouseout",
                        void 0
                    ],
                    [
                        s,
                        "dblclick",
                        void 0
                    ],
                    [
                        s,
                        "click",
                        void 0
                    ],
                    [
                        s,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        s,
                        "keyup",
                        void 0
                    ],
                    [
                        s,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        s,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [e1, t1, i] of this._listeners){
                    const s = e1 === document ? this.handleWindowEvent : this.handleEvent;
                    e1.addEventListener(t1, s, i);
                }
            }
            destroy() {
                for (const [e1, t1, i] of this._listeners){
                    const s = e1 === document ? this.handleWindowEvent : this.handleEvent;
                    e1.removeEventListener(t1, s, i);
                }
            }
            _addDefaultHandlers(e1) {
                const t1 = this._map, i = t1.getCanvasContainer();
                this._add("mapEvent", new $a(t1, e1));
                const s = t1.boxZoom = new Wa(t1, e1);
                this._add("boxZoom", s);
                const r = new Qa, o = new Sl;
                t1.doubleClickZoom = new Tl(o, r), this._add("tapZoom", r), this._add("clickZoom", o);
                const n = new Cl;
                this._add("tapDragZoom", n);
                const a = t1.touchPitch = new ml(t1);
                this._add("touchPitch", a);
                const l = new ol(e1), c = new nl(e1);
                t1.dragRotate = new Il(e1, l, c), this._add("mouseRotate", l, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]);
                const h = new rl(e1), d = new al(t1, e1);
                t1.dragPan = new El(i, h, d), this._add("mousePan", h), this._add("touchPan", d, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const u = new pl, p = new dl;
                t1.touchZoomRotate = new Dl(i, p, u, n), this._add("touchRotate", u, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", p, [
                    "touchPan",
                    "touchRotate"
                ]), this._add("blockableMapEvent", new Ha(t1));
                const f = t1.scrollZoom = new wl(t1, this);
                this._add("scrollZoom", f, [
                    "mousePan"
                ]);
                const m = t1.keyboard = new gl;
                this._add("keyboard", m);
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])e1.interactive && e1[i] && t1[i].enable(e1[i]);
            }
            _add(e1, t1, i) {
                this._handlers.push({
                    handlerName: e1,
                    handler: t1,
                    allowed: i
                }), this._handlersById[e1] = t1;
            }
            stop(e1 = "never") {
                if (!this._updatingCamera && !("always" === e1 || "ifPointerDown" === e1 && this._isPointerDown())) {
                    for (const { handler: e1 } of this._handlers)e1.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, !1), this._changes = [], this._originalZoom = void 0;
                }
            }
            isActive() {
                for (const { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return !!Pl(this._eventsInProgress) || this.isZooming();
            }
            _isDragging() {
                return !!this._eventsInProgress.drag;
            }
            _blockedByActive(e1, t1, i) {
                for(const s in e1)if (!(s === i || t1 && t1.includes(s))) return !0;
                return !1;
            }
            handleWindowEvent(e1) {
                this.handleEvent(e1, `${e1.type}Window`);
            }
            _getMapTouches(e1) {
                const t1 = [];
                for (const i of e1)this._el.contains(i.target) && t1.push(i);
                return t1;
            }
            _updatePointerLiveness(e1) {
                switch(e1.type){
                    case "mousedown":
                        this._mouseBeingPressed = !0;
                        break;
                    case "mousemove":
                        0 === e1.buttons && (this._mouseBeingPressed = !1);
                        break;
                    case "mouseup":
                        this._mouseBeingPressed = !1;
                        break;
                    case "touchstart":
                    case "touchmove":
                    case "touchend":
                    case "touchcancel":
                        this._activeTouchCount = e1.touches ? e1.touches.length : 0;
                        break;
                    case "blur":
                        this._mouseBeingPressed = !1, this._activeTouchCount = 0;
                }
            }
            _isPointerDown() {
                return this._mouseBeingPressed || this._activeTouchCount > 0;
            }
            handleEvent(e1, t1) {
                this._updatePointerLiveness(e1), this._updatingCamera = !0;
                const i = "renderFrame" === e1.type, s = i ? void 0 : e1, r = {
                    needsRenderFrame: !1
                }, o = {}, n = {}, a = e1.touches ? this._getMapTouches(e1.touches) : void 0, l = a ? g(this._el, a) : i ? void 0 : _(this._el, e1);
                for (const { handlerName: i, handler: c, allowed: h } of this._handlers){
                    if (!c.isEnabled()) continue;
                    let d;
                    this._blockedByActive(n, h, i) ? c.reset() : c[t1 || e1.type] && (d = c[t1 || e1.type](e1, l, a), this.mergeHandlerResult(r, o, d, i, s), d && d.needsRenderFrame && this._triggerRenderFrame()), (d || c.isActive()) && (n[i] = c);
                }
                const c = {};
                for(const e1 in this._previousActiveHandlers)n[e1] || (c[e1] = s);
                this._previousActiveHandlers = n, (Object.keys(c).length || Al(r)) && (this._changes.push([
                    r,
                    o,
                    c
                ]), this._triggerRenderFrame()), (Object.keys(n).length || Al(r)) && this._map._stop({
                    keepGesture: "always"
                }), this._updatingCamera = !1;
                const { cameraAnimation: h } = r;
                h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
            }
            mergeHandlerResult(e1, t1, i, s, r) {
                if (!i) return;
                Object.assign(e1, i);
                const o = {
                    handlerName: s,
                    originalEvent: i.originalEvent || r
                };
                void 0 !== i.zoomDelta && (t1.zoom = o), void 0 !== i.panDelta && (t1.drag = o), void 0 !== i.pitchDelta && (t1.pitch = o), void 0 !== i.bearingDelta && (t1.rotate = o);
            }
            _applyChanges() {
                const t1 = {}, i = {}, s = {};
                for (const [r, o, n] of this._changes)r.panDelta && (t1.panDelta = (t1.panDelta || new e1.P(0, 0))._add(r.panDelta)), r.zoomDelta && (t1.zoomDelta = (t1.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (t1.bearingDelta = (t1.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (t1.pitchDelta = (t1.pitchDelta || 0) + r.pitchDelta), void 0 !== r.around && (t1.around = r.around), void 0 !== r.aroundCoord && (t1.aroundCoord = r.aroundCoord), void 0 !== r.pinchAround && (t1.pinchAround = r.pinchAround), r.noInertia && (t1.noInertia = r.noInertia), Object.assign(i, o), Object.assign(s, n);
                this._updateMapTransform(t1, i, s), this._changes = [];
            }
            _updateMapTransform(t1, i, s) {
                const r = this._map, o = r.transform, n = (e1)=>[
                        e1.x,
                        e1.y,
                        e1.z
                    ];
                if ((()=>{
                    const e1 = this._eventsInProgress.drag;
                    return e1 && !this._handlersById[e1.handlerName].isActive();
                })() && !Al(t1)) {
                    const e1 = o.zoom;
                    o.cameraElevationReference = "sea", null != this._originalZoom && o._orthographicProjectionAtLowPitch && "globe" !== o.projection.name && 0 === o.pitch ? (o.cameraElevationReference = "ground", o.zoom = this._originalZoom) : (o.recenterOnTerrain(), o.cameraElevationReference = "ground"), e1 !== o.zoom && this._map._update(!0);
                }
                if (o._isCameraConstrained && r._stop({
                    keepGesture: "always"
                }), !Al(t1)) return void this._fireEvents(i, s, !0);
                let { panDelta: a, zoomDelta: l, bearingDelta: c, pitchDelta: h, around: d, aroundCoord: u, pinchAround: p } = t1;
                o._isCameraConstrained && (l > 0 && (l = 0), o._isCameraConstrained = !1), void 0 !== p && (d = p), (l || ((e1)=>i[e1] && !this._eventsInProgress[e1])("drag")) && d && (this._dragOrigin = n(o.pointCoordinate3D(d)), this._originalZoom = o.zoom, this._trackingEllipsoid.setup(o._camera.position, this._dragOrigin)), o.cameraElevationReference = "sea", r._stop({
                    keepGesture: "always"
                }), d = d || r.transform.centerPoint, c && (o.bearing += c), h && (o.pitch += h), o._updateCameraState();
                const f = [
                    0,
                    0,
                    0
                ];
                if (a) {
                    if ("mercator" === o.projection.name) {
                        const e1 = this._trackingEllipsoid.projectRay(o.screenPointToMercatorRay(d).dir), t1 = this._trackingEllipsoid.projectRay(o.screenPointToMercatorRay(d.sub(a)).dir);
                        f[0] = t1[0] - e1[0], f[1] = t1[1] - e1[1];
                    } else {
                        const t1 = o.pointCoordinate(d);
                        if ("globe" === o.projection.name) {
                            a = a.rotate(-o.angle);
                            const i = o._pixelsPerMercatorPixel / o.worldSize;
                            f[0] = -a.x * e1.ey(e1.br(t1.y)) * i, f[1] = -a.y * e1.ey(o.center.lat) * i;
                        } else {
                            const e1 = o.pointCoordinate(d.sub(a));
                            t1 && e1 && (f[0] = e1.x - t1.x, f[1] = e1.y - t1.y);
                        }
                    }
                }
                const m = o.zoom, _ = [
                    0,
                    0,
                    0
                ];
                if (l) {
                    const t1 = n(u || o.pointCoordinate3D(d)), i = {
                        dir: e1.c3([], e1.c2([], t1, o._camera.position))
                    };
                    if (i.dir[2] < 0) {
                        const s = o.zoomDeltaToMovement(t1, l);
                        e1.dB(_, i.dir, s);
                    }
                }
                const g = e1.dC(f, f, _);
                o._translateCameraConstrained(g), l && Math.abs(o.zoom - m) > 1e-4 && o.recenterOnTerrain(), o.cameraElevationReference = "ground", this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(i, s, !0);
            }
            _fireEvents(t1, i, s) {
                const r = Pl(this._eventsInProgress), o = Pl(t1), n = {};
                for(const e1 in t1){
                    const { originalEvent: i } = t1[e1];
                    this._eventsInProgress[e1] || (n[`${e1}start`] = i), this._eventsInProgress[e1] = t1[e1];
                }
                !r && o && this._fireEvent("movestart", o.originalEvent);
                for(const e1 in n)this._fireEvent(e1, n[e1]);
                o && this._fireEvent("move", o.originalEvent);
                for(const e1 in t1){
                    const { originalEvent: i } = t1[e1];
                    this._fireEvent(e1, i);
                }
                const a = {};
                let l;
                for(const e1 in this._eventsInProgress){
                    const { handlerName: t1, originalEvent: s } = this._eventsInProgress[e1];
                    this._handlersById[t1].isActive() || (delete this._eventsInProgress[e1], l = i[t1] || s, a[`${e1}end`] = l);
                }
                for(const e1 in a)this._fireEvent(e1, a[e1]);
                const c = Pl(this._eventsInProgress);
                if (s && (r || o) && !c) {
                    this._updatingCamera = !0;
                    const t1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (e1)=>0 !== e1 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
                    t1 ? (i(t1.bearing || this._map.getBearing()) && (t1.bearing = 0), this._map.easeTo(t1, {
                        originalEvent: l
                    })) : (this._map.fire(new e1.h("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(t1, i) {
                this._map.fire(new e1.h(t1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
                    this._frameId = void 0, this.handleEvent(new Ll("renderFrame", {
                        timeStamp: e1
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        const Fl = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
        class Ol extends e1.E {
            constructor(t1, i){
                super(), this._moving = !1, this._zooming = !1, this.transform = t1, this._bearingSnap = i.bearingSnap, this._respectPrefersReducedMotion = !1 !== i.respectPrefersReducedMotion, e1.aV([
                    "_renderFrameCallback"
                ], this);
            }
            getCenter() {
                return new e1.cz(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e1, t1) {
                return this.jumpTo({
                    center: e1
                }, t1);
            }
            panBy(t1, i, s) {
                return t1 = e1.P.convert(t1).mult(-1), this.panTo(this.transform.center, {
                    offset: t1,
                    ...i
                }, s);
            }
            panTo(e1, t1, i) {
                return this.easeTo({
                    center: e1,
                    ...t1
                }, i);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e1, t1) {
                return this.jumpTo({
                    zoom: e1
                }, t1), this;
            }
            zoomTo(e1, t1, i) {
                return this.easeTo({
                    zoom: e1,
                    ...t1
                }, i);
            }
            zoomIn(e1, t1) {
                return this.zoomTo(this.getZoom() + 1, e1, t1), this;
            }
            zoomOut(e1, t1) {
                return this.zoomTo(this.getZoom() - 1, e1, t1), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e1, t1) {
                return this.jumpTo({
                    bearing: e1
                }, t1), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e1, t1) {
                return this.jumpTo({
                    padding: e1
                }, t1), this;
            }
            rotateTo(e1, t1, i) {
                return this.easeTo({
                    bearing: e1,
                    ...t1
                }, i);
            }
            resetNorth(e1, t1) {
                return this.rotateTo(0, {
                    duration: 1e3,
                    ...e1
                }, t1), this;
            }
            resetNorthPitch(e1, t1) {
                return this.easeTo({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3,
                    ...e1
                }, t1), this;
            }
            snapToNorth(e1, t1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t1) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e1, t1) {
                return this.jumpTo({
                    pitch: e1
                }, t1), this;
            }
            getVerticalFieldOfView() {
                return this.transform.fov;
            }
            setVerticalFieldOfView(e1, t1) {
                return this.jumpTo({
                    fov: e1
                }, t1);
            }
            getHorizontalFieldOfView() {
                return this.transform.horizontalFov;
            }
            cameraForBounds(t1, i) {
                t1 = e1.eB.convert(t1);
                const s = i && i.bearing || 0, r = i && i.pitch || 0, o = t1.getNorthWest(), n = t1.getSouthEast();
                return this._cameraForBounds(this.transform, o, n, s, r, i);
            }
            _extendPadding(e1) {
                const t1 = {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                };
                return null == e1 ? {
                    ...t1,
                    ...this.transform.padding
                } : "number" == typeof e1 ? {
                    top: e1,
                    bottom: e1,
                    right: e1,
                    left: e1
                } : {
                    ...t1,
                    ...e1
                };
            }
            _extendCameraOptions(e1) {
                return (e1 = {
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom,
                    ...e1
                }).padding = this._extendPadding(e1.padding), e1;
            }
            _minimumAABBFrustumDistance(e1, t1) {
                const i = t1.max[0] - t1.min[0], s = t1.max[1] - t1.min[1];
                return i / s > e1.aspect ? i / (2 * Math.tan(.5 * e1.fovX) * e1.aspect) : s / (2 * Math.tan(.5 * e1.fovY) * e1.aspect);
            }
            _cameraForBoundsOnGlobe(t1, i, s, r, o, n) {
                const a = t1.clone(), l = this._extendCameraOptions(n);
                a.bearing = r, a.pitch = o;
                const c = e1.cz.convert(i), h = e1.cz.convert(s), d = .5 * (c.lat + h.lat), u = .5 * (c.lng + h.lng), p = e1.eC(d, u), f = e1.c3([], p), m = e1.c3([], e1.eD([], f, [
                    0,
                    1,
                    0
                ])), _ = e1.eD([], m, f), g = [
                    m[0],
                    m[1],
                    m[2],
                    0,
                    _[0],
                    _[1],
                    _[2],
                    0,
                    f[0],
                    f[1],
                    f[2],
                    0,
                    0,
                    0,
                    0,
                    1
                ], y = [
                    p,
                    e1.eC(c.lat, c.lng),
                    e1.eC(h.lat, c.lng),
                    e1.eC(h.lat, h.lng),
                    e1.eC(c.lat, h.lng),
                    e1.eC(d, c.lng),
                    e1.eC(d, h.lng),
                    e1.eC(c.lat, u),
                    e1.eC(h.lat, u)
                ];
                let v = e1.eE.fromPoints(y.map((t1)=>[
                        e1.dE(m, t1),
                        e1.dE(_, t1),
                        e1.dE(f, t1)
                    ]));
                const b = e1.bH([], v.center, g);
                0 === e1.eF(b) && e1.eG(b, 0, 0, 1), e1.c3(b, b), e1.dB(b, b, e1.c8), a.center = e1.eH(b);
                const x = a.getWorldToCameraMatrix(), w = e1.aO(new Float64Array(16), x);
                v = e1.eE.applyTransform(v, e1.X([], x, g));
                const T = this._extendAABB(v, a, l, r);
                if (!T) return void e1.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                v = T, e1.bH(b, b, x);
                const S = .5 * (v.max[2] - v.min[2]), C = this._minimumAABBFrustumDistance(a, v), E = e1.dB([], [
                    0,
                    0,
                    1
                ], S), I = e1.dC(E, b, E), D = C + (0 === a.pitch ? 0 : e1.eI(b, I)), P = a.globeCenterInViewSpace, L = e1.c2([], b, [
                    P[0],
                    P[1],
                    P[2]
                ]);
                e1.c3(L, L), e1.dB(L, L, D);
                const R = e1.dC([], b, L);
                e1.bH(R, R, w);
                const A = e1.bj / e1.c8, M = e1.el(R), F = e1.dv(Math.max(M * A - e1.bj, Number.EPSILON), 0), O = Math.min(a.zoomFromMercatorZAdjusted(F), l.maxZoom);
                return O > .5 * (e1.e8 + e1.b1) ? (a.setProjection({
                    name: "mercator"
                }), a.zoom = O, this._cameraForBounds(a, i, s, r, o, n)) : {
                    center: a.center,
                    zoom: O,
                    bearing: r,
                    pitch: o
                };
            }
            _extendAABB(t1, i, s, r) {
                const o = .5 * ((s.padding.left || 0) + (s.padding.right || 0)), n = .5 * ((s.padding.top || 0) + (s.padding.bottom || 0)), a = n, l = o, c = o, h = n, d = i.width - (l + c), u = i.height - (a + h), p = e1.c2([], t1.max, t1.min), f = Math.min(d / p[0], u / p[1]), m = Math.min(i.scaleZoom(i.scale * f), s.maxZoom);
                if (isNaN(m)) return null;
                const _ = i.scale / i.zoomScale(m), g = new e1.eE([
                    t1.min[0] - l * _,
                    t1.min[1] - h * _,
                    t1.min[2]
                ], [
                    t1.max[0] + c * _,
                    t1.max[1] + a * _,
                    t1.max[2]
                ]), y = ("number" == typeof s.offset.x && "number" == typeof s.offset.y ? new e1.P(s.offset.x, s.offset.y) : e1.P.convert(s.offset)).rotate(-e1.au(r));
                return g.center[0] -= y.x * _, g.center[1] += y.y * _, g;
            }
            queryTerrainElevation(t1, i) {
                const s = this.transform.elevation;
                return s ? (i = {
                    exaggerated: !0,
                    ...i
                }, s.getAtPoint(e1.bS.fromLngLat(t1), null, i.exaggerated)) : null;
            }
            _cameraForBounds(t1, i, s, r, o, n) {
                if ("globe" === t1.projection.name) return this._cameraForBoundsOnGlobe(t1, i, s, r, o, n);
                const a = t1.clone(), l = this._extendCameraOptions(n);
                a.bearing = r, a.pitch = o;
                const c = e1.cz.convert(i), h = e1.cz.convert(s), d = new e1.cz(c.lng, h.lat), u = new e1.cz(h.lng, c.lat), p = a.project(c), f = a.project(h), m = this.queryTerrainElevation(c), _ = this.queryTerrainElevation(h), g = this.queryTerrainElevation(d), y = this.queryTerrainElevation(u), v = [
                    [
                        p.x,
                        p.y,
                        Math.min(m || 0, _ || 0, g || 0, y || 0)
                    ],
                    [
                        f.x,
                        f.y,
                        Math.max(m || 0, _ || 0, g || 0, y || 0)
                    ]
                ];
                let b = e1.eE.fromPoints(v);
                const x = a.getWorldToCameraMatrix(), w = e1.aO(new Float64Array(16), x);
                b = e1.eE.applyTransform(b, x);
                const T = this._extendAABB(b, a, l, r);
                if (!T) return void e1.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                b = T;
                const S = .5 * e1.c2([], b.max, b.min)[2], C = this._minimumAABBFrustumDistance(a, b), E = [
                    0,
                    0,
                    1,
                    0
                ];
                e1.c7(E, E, x), e1.eJ(E, E);
                const I = e1.dB([], E, C + S), D = e1.dC([], b.center, I);
                e1.bH(b.center, b.center, w), e1.bH(D, D, w);
                const P = a.unproject(new e1.P(b.center[0], b.center[1])), L = e1.eK(a.projection, P), R = Math.pow(2, L), A = Math.min(a._zoomFromMercatorZ(D[2] * a.pixelsPerMeter * R / a.worldSize), l.maxZoom);
                return a.mercatorFromTransition && A < .5 * (e1.e8 + e1.b1) ? (a.setProjection({
                    name: "globe"
                }), a.zoom = A, this._cameraForBounds(a, i, s, r, o, n)) : {
                    center: P,
                    zoom: A,
                    bearing: r,
                    pitch: o
                };
            }
            fitBounds(e1, t1, i) {
                const s = this.cameraForBounds(e1, t1);
                return this._fitInternal(s, t1, i);
            }
            fitScreenCoordinates(t1, i, s, r, o) {
                const n = e1.P.convert(t1), a = e1.P.convert(i), l = new e1.P(Math.min(n.x, a.x), Math.min(n.y, a.y)), c = new e1.P(Math.max(n.x, a.x), Math.max(n.y, a.y));
                if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(n, a)) return this;
                const h = this.transform.pointLocation3D(l), d = this.transform.pointLocation3D(c), u = this.transform.pointLocation3D(new e1.P(l.x, c.y)), p = this.transform.pointLocation3D(new e1.P(c.x, l.y)), f = [
                    Math.min(h.lng, d.lng, u.lng, p.lng),
                    Math.min(h.lat, d.lat, u.lat, p.lat)
                ], m = [
                    Math.max(h.lng, d.lng, u.lng, p.lng),
                    Math.max(h.lat, d.lat, u.lat, p.lat)
                ], _ = r && r.pitch ? r.pitch : this.getPitch(), g = this._cameraForBounds(this.transform, f, m, s, _, r);
                return this._fitInternal(g, r, o);
            }
            _fitInternal(e1, t1, i) {
                return e1 ? (t1 = Object.assign(e1, t1)).linear ? this.easeTo(t1, i) : this.flyTo(t1, i) : this;
            }
            jumpTo(t1, i) {
                this._stop({
                    keepGesture: "ifPointerDown"
                });
                const s = t1.preloadOnly ? this.transform.clone() : this.transform;
                let r = !1, o = !1, n = !1;
                "zoom" in t1 && s.zoom !== +t1.zoom && (r = !0, s.zoom = +t1.zoom), void 0 !== t1.center && (s.center = e1.cz.convert(t1.center)), "bearing" in t1 && s.bearing !== +t1.bearing && (o = !0, s.bearing = +t1.bearing), "pitch" in t1 && s.pitch !== +t1.pitch && (n = !0, s.pitch = +t1.pitch), "fov" in t1 && (s.fov = +t1.fov);
                const a = "number" == typeof t1.padding ? this._extendPadding(t1.padding) : t1.padding;
                if (null != t1.padding && !s.isPaddingEqual(a)) {
                    if (!1 === t1.retainPadding) {
                        const e1 = s.clone();
                        e1.padding = a, s.setLocationAtPoint(s.center, e1.centerPoint);
                    } else s.padding = a;
                }
                return t1.preloadOnly ? (this._preloadTiles(s), this) : (this.fire(new e1.h("movestart", i)).fire(new e1.h("move", i)), r && this.fire(new e1.h("zoomstart", i)).fire(new e1.h("zoom", i)).fire(new e1.h("zoomend", i)), o && this.fire(new e1.h("rotatestart", i)).fire(new e1.h("rotate", i)).fire(new e1.h("rotateend", i)), n && this.fire(new e1.h("pitchstart", i)).fire(new e1.h("pitch", i)).fire(new e1.h("pitchend", i)), this.fire(new e1.h("moveend", i)));
            }
            getFreeCameraOptions() {
                return this.transform.projection.supportsFreeCamera || e1.w(Fl), this.transform.getFreeCameraOptions();
            }
            setFreeCameraOptions(t1, i) {
                const s = this.transform;
                if (!s.projection.supportsFreeCamera) return e1.w(Fl), this;
                this.stop();
                const r = s.zoom, o = s.pitch, n = s.bearing;
                s.setFreeCameraOptions(t1);
                const a = r !== s.zoom, l = o !== s.pitch, c = n !== s.bearing;
                return this.fire(new e1.h("movestart", i)).fire(new e1.h("move", i)), a && this.fire(new e1.h("zoomstart", i)).fire(new e1.h("zoom", i)).fire(new e1.h("zoomend", i)), c && this.fire(new e1.h("rotatestart", i)).fire(new e1.h("rotate", i)).fire(new e1.h("rotateend", i)), l && this.fire(new e1.h("pitchstart", i)).fire(new e1.h("pitch", i)).fire(new e1.h("pitchend", i)), this.fire(new e1.h("moveend", i)), this;
            }
            easeTo(t1, i) {
                this._stop({
                    easeId: t1.easeId
                }), (!1 === (t1 = {
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: e1.ex,
                    ...t1
                }).animate || this._prefersReducedMotion(t1)) && (t1.duration = 0);
                const s = this.transform, r = this.getZoom(), o = this.getBearing(), n = this.getPitch(), a = this.getPadding(), l = this.getVerticalFieldOfView(), c = "zoom" in t1 ? +t1.zoom : r, h = "bearing" in t1 ? this._normalizeBearing(t1.bearing, o) : o, d = "pitch" in t1 ? +t1.pitch : n, u = "fov" in t1 ? +t1.fov : l, p = this._extendPadding(t1.padding), f = e1.P.convert(t1.offset);
                let m, _, g;
                if ("globe" === s.projection.name) {
                    const i = e1.bS.fromLngLat(s.center), r = f.rotate(-s.angle);
                    i.x += r.x / s.worldSize, i.y += r.y / s.worldSize;
                    const o = i.toLngLat(), n = e1.cz.convert(t1.center || o);
                    this._normalizeCenter(n), m = s.centerPoint.add(r), _ = new e1.P(i.x, i.y).mult(s.worldSize), g = new e1.P(e1.a7(n.lng), e1.a8(n.lat)).mult(s.worldSize).sub(_);
                } else {
                    m = s.centerPoint.add(f);
                    const i = s.pointLocation(m), r = e1.cz.convert(t1.center || i);
                    this._normalizeCenter(r), _ = s.project(i), g = s.project(r).sub(_);
                }
                const y = s.zoomScale(c - r);
                let v, b;
                t1.around && (v = e1.cz.convert(t1.around), b = s.locationPoint(v));
                const x = this._zooming || c !== r, w = this._rotating || o !== h, T = this._pitching || d !== n, S = u !== l, C = !s.isPaddingEqual(p), E = !1 === t1.retainPadding ? s.clone() : s, I = (s)=>(I)=>{
                        if (x && (s.zoom = e1.al(r, c, I)), w && (s.bearing = e1.al(o, h, I)), T && (s.pitch = e1.al(n, d, I)), S && (s.fov = e1.al(l, u, I)), C && (E.interpolatePadding(a, p, I), m = E.centerPoint.add(f)), v) s.setLocationAtPoint(v, b);
                        else {
                            const e1 = s.zoomScale(s.zoom - r), t1 = c > r ? Math.min(2, y) : Math.max(.5, y), i = Math.pow(t1, 1 - I), o = s.unproject(_.add(g.mult(I * i)).mult(e1));
                            s.setLocationAtPoint(s.renderWorldCopies ? o.wrap() : o, m);
                        }
                        return t1.preloadOnly || this._fireMoveEvents(i), s;
                    };
                if (t1.preloadOnly) {
                    const e1 = this._emulate(I, t1.duration, s);
                    return this._preloadTiles(e1), this;
                }
                const D = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = x, this._rotating = w, this._pitching = T, this._padding = C, this._easeId = t1.easeId, this._prepareEase(i, t1.noMoveStart, D), this._ease(I(s), (e1)=>{
                    "sea" === s.cameraElevationReference && s.recenterOnTerrain(), this._afterEase(i, e1);
                }, t1), this;
            }
            _prepareEase(t1, i, s = {}) {
                this._moving = !0, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), i || s.moving || this.fire(new e1.h("movestart", t1)), this._zooming && !s.zooming && this.fire(new e1.h("zoomstart", t1)), this._rotating && !s.rotating && this.fire(new e1.h("rotatestart", t1)), this._pitching && !s.pitching && this.fire(new e1.h("pitchstart", t1));
            }
            _fireMoveEvents(t1) {
                this.fire(new e1.h("move", t1)), this._zooming && this.fire(new e1.h("zoom", t1)), this._rotating && this.fire(new e1.h("rotate", t1)), this._pitching && this.fire(new e1.h("pitch", t1));
            }
            _afterEase(t1, i) {
                if (this._easeId && i && this._easeId === i) return;
                this._easeId = void 0, this.transform.cameraElevationReference = "ground";
                const s = this._zooming, r = this._rotating, o = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, s && this.fire(new e1.h("zoomend", t1)), r && this.fire(new e1.h("rotateend", t1)), o && this.fire(new e1.h("pitchend", t1)), this.fire(new e1.h("moveend", t1));
            }
            flyTo(t1, i) {
                if (this._prefersReducedMotion(t1)) {
                    const s = e1.cb(t1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "fov",
                        "around",
                        "padding",
                        "retainPadding"
                    ]);
                    return this.jumpTo(s, i);
                }
                this.stop(), t1 = {
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: e1.ex,
                    ...t1
                };
                const s = this.transform, r = this.getZoom(), o = this.getBearing(), n = this.getPitch(), a = this.getPadding(), l = this.getVerticalFieldOfView(), c = "zoom" in t1 ? e1.b0(+t1.zoom, s.minZoom, s.maxZoom) : r, h = "bearing" in t1 ? this._normalizeBearing(t1.bearing, o) : o, d = "pitch" in t1 ? +t1.pitch : n, u = "fov" in t1 ? +t1.fov : l, p = u !== l, f = this._extendPadding(t1.padding), m = s.zoomScale(c - r), _ = e1.P.convert(t1.offset);
                let g = s.centerPoint.add(_);
                const y = s.pointLocation(g), v = e1.cz.convert(t1.center || y);
                this._normalizeCenter(v);
                const b = s.project(y), x = s.project(v).sub(b);
                let w = t1.curve;
                const T = Math.max(s.width, s.height), S = T / m, C = x.mag();
                if ("minZoom" in t1) {
                    const i = e1.b0(Math.min(t1.minZoom, r, c), s.minZoom, s.maxZoom), o = T / s.zoomScale(i - r);
                    w = Math.sqrt(o / C * 2);
                }
                const E = w * w;
                function I(e1) {
                    const t1 = (S * S - T * T + (e1 ? -1 : 1) * E * E * C * C) / (2 * (e1 ? S : T) * E * C);
                    return Math.log(Math.sqrt(t1 * t1 + 1) - t1);
                }
                function D(e1) {
                    return (Math.exp(e1) - Math.exp(-e1)) / 2;
                }
                function P(e1) {
                    return (Math.exp(e1) + Math.exp(-e1)) / 2;
                }
                const L = I(0);
                let R = function(e1) {
                    return P(L) / P(L + w * e1);
                }, A = function(e1) {
                    var t1;
                    return T * ((P(L) * (D(t1 = L + w * e1) / P(t1)) - D(L)) / E) / C;
                }, M = (I(1) - L) / w;
                if (Math.abs(C) < 1e-6 || !isFinite(M)) {
                    if (Math.abs(T - S) < 1e-6) return this.easeTo(t1, i);
                    const e1 = S < T ? -1 : 1;
                    M = Math.abs(Math.log(S / T)) / w, A = function() {
                        return 0;
                    }, R = function(t1) {
                        return Math.exp(e1 * w * t1);
                    };
                }
                t1.duration = "duration" in t1 ? +t1.duration : 1e3 * M / ("screenSpeed" in t1 ? +t1.screenSpeed / w : +t1.speed), t1.maxDuration && t1.duration > t1.maxDuration && (t1.duration = 0);
                const F = o !== h, O = d !== n, B = !s.isPaddingEqual(f), k = !1 === t1.retainPadding ? s.clone() : s, z = (s)=>(m)=>{
                        const y = m * M, w = 1 / R(y);
                        s.zoom = 1 === m ? c : r + s.scaleZoom(w), F && (s.bearing = e1.al(o, h, m)), O && (s.pitch = e1.al(n, d, m)), p && (s.fov = e1.al(l, u, m)), B && (k.interpolatePadding(a, f, m), g = k.centerPoint.add(_));
                        const T = 1 === m ? v : s.unproject(b.add(x.mult(A(y))).mult(w));
                        return s.setLocationAtPoint(s.renderWorldCopies ? T.wrap() : T, g), s._updateCameraOnTerrain(), t1.preloadOnly || this._fireMoveEvents(i), s;
                    };
                if (t1.preloadOnly) {
                    const e1 = this._emulate(z, t1.duration, s);
                    return this._preloadTiles(e1), this;
                }
                return this._zooming = !0, this._rotating = F, this._pitching = O, this._padding = B, this._prepareEase(i, !1), this._ease(z(s), ()=>this._afterEase(i), t1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _requestRenderFrame(e1) {}
            _cancelRenderFrame(e1) {}
            _stop({ easeId: e1, keepGesture: t1 } = {}) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
                    const t1 = this._onEaseEnd;
                    this._onEaseEnd = void 0, t1.call(this, e1);
                }
                const i = this.handlers;
                return i && i.stop(t1), this;
            }
            _ease(t1, i, s) {
                !1 === s.animate || 0 === s.duration ? (t1(1), i()) : (this._easeStart = e1.e.now(), this._easeOptions = s, this._onEaseFrame = t1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const t1 = Math.min((e1.e.now() - this._easeStart) / this._easeOptions.duration, 1), i = this._onEaseFrame;
                i && i(this._easeOptions.easing(t1)), t1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(t1, i) {
                t1 = e1.cU(t1, -180, 180);
                const s = Math.abs(t1 - i);
                return Math.abs(t1 - 360 - i) < s && (t1 -= 360), Math.abs(t1 + 360 - i) < s && (t1 += 360), t1;
            }
            _normalizeCenter(e1) {
                const t1 = this.transform;
                if (t1.maxBounds) return;
                if ("globe" !== t1.projection.name && !t1.renderWorldCopies) return;
                const i = e1.lng - t1.center.lng;
                e1.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            _prefersReducedMotion(t1) {
                return this._respectPrefersReducedMotion && e1.e.prefersReducedMotion && !(t1 && t1.essential);
            }
            _emulate(e1, t1, i) {
                const s = Math.ceil(15 * t1 / 1e3), r = [], o = e1(i.clone());
                for(let e1 = 0; e1 <= s; e1++){
                    const t1 = o(e1 / s);
                    r.push(t1.clone());
                }
                return r;
            }
            _preloadTiles(e1, t1) {}
        }
        const Bl = /^(https?:|mailto:)/i;
        class kl {
            constructor(t1 = {}){
                this.options = t1, e1.aV([
                    "_toggleAttribution",
                    "_updateEditLink",
                    "_updateData",
                    "_updateCompact"
                ], this);
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e1) {
                const t1 = this.options && this.options.compact, i = e1._getUIString("AttributionControl.ToggleAttribution");
                this._map = e1, this._container = a("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = a("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._compactButton.setAttribute("aria-label", i);
                const s = a("span", "mapboxgl-ctrl-icon", this._compactButton);
                return s.setAttribute("aria-hidden", "true"), s.setAttribute("title", i), this._innerContainer = a("div", "mapboxgl-ctrl-attrib-inner", this._container), t1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
            }
            _toggleAttribution() {
                this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
            }
            _updateEditLink() {
                let t1 = this._editLink;
                t1 || (t1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                const i = [
                    {
                        key: "owner",
                        value: this.styleOwner
                    },
                    {
                        key: "id",
                        value: this.styleId
                    },
                    {
                        key: "access_token",
                        value: this._map._requestManager._customAccessToken || e1.eL.ACCESS_TOKEN
                    }
                ];
                if (t1) {
                    const s = i.reduce((e1, t1, s)=>(t1.value && (e1 += `${t1.key}=${t1.value}${s < i.length - 1 ? "&" : ""}`), e1), "?");
                    t1.href = `${e1.eL.FEEDBACK_URL}/${s}#${Fa(this._map, !0)}`, t1.rel = "noopener nofollow";
                }
            }
            _updateData(e1) {
                !e1 || ("source" !== e1.dataType || "metadata" !== e1.sourceDataType && "visibility" !== e1.sourceDataType) && "style" !== e1.dataType || (this._updateAttributions(), this._updateEditLink());
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e1 = [];
                if (this._map.style.stylesheet) {
                    const e1 = this._map.style.stylesheet;
                    this.styleOwner = e1.owner, this.styleId = e1.id;
                }
                const t1 = this._map.style._mergedSourceCaches;
                for(const i in t1){
                    const s = t1[i];
                    if (s.used) {
                        const t1 = s.getSource();
                        t1.attribution && !e1.includes(t1.attribution) && e1.push(t1.attribution);
                    }
                }
                e1.sort((e1, t1)=>e1.length - t1.length), e1 = e1.filter((t1, i)=>{
                    for(let s = i + 1; s < e1.length; s++)if (e1[s].includes(t1)) return !1;
                    return !0;
                }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = [
                    ...this.options.customAttribution,
                    ...e1
                ] : e1.unshift(this.options.customAttribution));
                const i = e1.map((e1)=>(function(e1) {
                        const t1 = (new DOMParser).parseFromString(e1, "text/html");
                        return Array.from(t1.body.querySelectorAll("*")).reverse().forEach((e1)=>{
                            const i = e1.textContent || "";
                            if ("A" !== e1.tagName) return void e1.replaceWith(...e1.childNodes);
                            const s = e1.getAttribute("href");
                            if (!s || !Bl.test(s)) return void e1.replaceWith(t1.createTextNode(i));
                            const r = t1.createElement("a");
                            r.href = s, r.textContent = i, r.rel = "noopener nofollow";
                            const o = e1.getAttribute("class");
                            o && (r.className = o), e1.replaceWith(r);
                        }), t1.body.innerHTML;
                    })(e1)).join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e1.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
            }
        }
        class zl {
            constructor(){
                e1.aV([
                    "_updateLogo",
                    "_updateCompact"
                ], this);
            }
            onAdd(e1) {
                this._map = e1, this._container = a("div", "mapboxgl-ctrl");
                const t1 = a("a", "mapboxgl-ctrl-logo");
                return t1.target = "_blank", t1.rel = "noopener nofollow", t1.href = "https://www.mapbox.com/", t1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            _updateLogo(e1) {
                e1 && "metadata" !== e1.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
            }
            _logoRequired() {
                if (!this._map.style) return !0;
                const e1 = this._map.style._sourceCaches;
                if (0 === Object.entries(e1).length) return !0;
                for(const t1 in e1){
                    const i = e1[t1].getSource();
                    if (Object.hasOwn(i, "mapbox_logo") && !i.mapbox_logo) return !1;
                }
                return !0;
            }
            _updateCompact() {
                const e1 = this._container.children;
                if (e1.length) {
                    const t1 = e1[0];
                    this._map.getCanvasContainer().offsetWidth < 250 ? t1.classList.add("mapboxgl-compact") : t1.classList.remove("mapboxgl-compact");
                }
            }
        }
        class Ul {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(e1) {
                const t1 = ++this._id;
                return this._queue.push({
                    callback: e1,
                    id: t1,
                    cancelled: !1
                }), t1;
            }
            remove(e1) {
                const t1 = this._currentlyRunning, i = t1 ? this._queue.concat(t1) : this._queue;
                for (const t1 of i)if (t1.id === e1) return void (t1.cancelled = !0);
            }
            run(e1 = 0) {
                const t1 = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t1)if (!i.cancelled && (i.callback(e1), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        class Nl {
            constructor(e1){
                this.jumpTo(e1);
            }
            getValue(t1) {
                if (t1 <= this._startTime) return this._start;
                if (t1 >= this._endTime) return this._end;
                const i = e1.dr((t1 - this._startTime) / (this._endTime - this._startTime));
                return this._start * (1 - i) + this._end * i;
            }
            isEasing(e1) {
                return e1 >= this._startTime && e1 <= this._endTime;
            }
            jumpTo(e1) {
                this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e1, this._end = e1;
            }
            easeTo(e1, t1, i) {
                this._start = this.getValue(t1), this._end = e1, this._startTime = t1, this._endTime = t1 + i;
            }
        }
        const jl = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox homepage",
            "Map.Title": "Map",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map",
            "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map",
            "TouchPanBlocker.Message": "Use two fingers to move the map"
        };
        class Vl extends e1.h {
            constructor(e1, t1, i, s){
                const { point: r, lngLat: o, originalEvent: n, target: a } = e1;
                super(e1.type, {
                    point: r,
                    lngLat: o,
                    originalEvent: n,
                    target: a
                }), this.preventDefault = ()=>{
                    e1.preventDefault();
                }, this.id = t1, this.interaction = i, this.feature = s;
            }
        }
        class Gl {
            constructor(e1){
                this.map = e1, this.interactionsByType = new Map, this.delegatedInteractions = new Map, this.typeById = new Map, this.filters = new Map, this.handleType = this.handleType.bind(this), this.handleMove = this.handleMove.bind(this), this.handleOut = this.handleOut.bind(this), this.hoveredFeatures = new Map, this.prevHoveredFeatures = new Map;
            }
            add(t1, i) {
                if (this.typeById.has(t1)) throw new Error(`Interaction id "${t1}" already exists.`);
                const s = i.filter;
                let r = i.type;
                s && this.filters.set(t1, e1.bv(s)), "mouseover" === r && (r = "mouseenter"), "mouseout" === r && (r = "mouseleave");
                const o = this.interactionsByType.get(r) || new Map;
                "mouseenter" === r || "mouseleave" === r ? (0 === this.delegatedInteractions.size && (this.map.on("mousemove", this.handleMove), this.map.on("mouseout", this.handleOut)), this.delegatedInteractions.set(t1, i)) : 0 === o.size && this.map.on(r, this.handleType), 0 === o.size && this.interactionsByType.set(r, o), o.set(t1, i), this.typeById.set(t1, r);
            }
            get(e1) {
                const t1 = this.typeById.get(e1);
                if (!t1) return;
                const i = this.interactionsByType.get(t1);
                return i ? i.get(e1) : void 0;
            }
            remove(e1) {
                const t1 = this.typeById.get(e1);
                if (!t1) return;
                this.typeById.delete(e1), this.filters.delete(e1);
                const i = this.interactionsByType.get(t1);
                i && (i.delete(e1), "mouseenter" === t1 || "mouseleave" === t1 ? (this.delegatedInteractions.delete(e1), 0 === this.delegatedInteractions.size && (this.map.off("mousemove", this.handleMove), this.map.off("mouseout", this.handleOut))) : 0 === i.size && this.map.off(t1, this.handleType));
            }
            queryTargets(e1, t1) {
                const i = [];
                for (const [e1, s] of t1)s.target && i.push({
                    targetId: e1,
                    target: s.target,
                    filter: this.filters.get(e1)
                });
                return this.map.style.queryRenderedTargets(e1, i, this.map.transform);
            }
            handleMove(e1) {
                this.prevHoveredFeatures = this.hoveredFeatures, this.hoveredFeatures = new Map;
                const t1 = this.queryTargets(e1.point, Array.from(this.delegatedInteractions).reverse());
                t1.length && (e1.type = "mouseenter", this.handleType(e1, t1));
                const i = new Map;
                for (const [e1, { feature: t1 }] of this.prevHoveredFeatures)this.hoveredFeatures.has(e1) || i.set(t1.id, t1);
                i.size && (e1.type = "mouseleave", this.handleType(e1, Array.from(i.values())));
            }
            handleOut(e1) {
                const t1 = Array.from(this.hoveredFeatures.values()).map(({ feature: e1 })=>e1);
                t1.length && (e1.type = "mouseleave", this.handleType(e1, t1)), this.hoveredFeatures.clear();
            }
            handleType(t1, i) {
                const s = "mouseenter" === t1.type;
                if (s && !this.interactionsByType.has(t1.type)) return void e1.w("mouseenter interaction required for mouseleave to work.");
                const r = Array.from(this.interactionsByType.get(t1.type)).reverse(), o = !!i;
                i = i || this.queryTargets(t1.point, r);
                let n = !1;
                const a = new Set;
                for (const l of i){
                    for (const [i, c] of r){
                        if (!c.target) continue;
                        const r = l.variants ? l.variants[i] : null;
                        if (r) {
                            for (const h of r){
                                if (gr(h, l, a, i)) continue;
                                const r = new e1.dk(l, h), d = _r(h, l, i);
                                o && void 0 !== r.id && (r.state = this.map.getFeatureState(r));
                                const u = s ? this.prevHoveredFeatures.get(d) : null, p = new Vl(t1, i, c, r), f = u ? u.stop : c.handler(p);
                                if (s && this.hoveredFeatures.set(d, {
                                    feature: l,
                                    stop: f
                                }), !1 !== f) {
                                    n = !0;
                                    break;
                                }
                            }
                            if (n) break;
                        }
                    }
                    if (n) break;
                }
                if (!n) for (const [e1, i] of r){
                    const { handler: s, target: r } = i;
                    if (!r && !1 !== s(new Vl(t1, e1, i, null))) break;
                }
            }
        }
        function ql(t1, i) {
            if (Array.isArray(t1) && Array.isArray(i)) {
                const e1 = new Set(t1), s = new Set(i);
                return e1.size === s.size && t1.every((e1)=>s.has(e1));
            }
            return e1.O(t1, i);
        }
        const Zl = /matrix.*\((.+)\)/, $l = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 85,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            performanceMetricsCollection: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            antialias: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            minTileCacheSize: null,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            localFontFamily: null,
            fontstackCompositing: "client",
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            respectPrefersReducedMotion: !0,
            crossSourceCollisions: !0,
            collectResourceTiming: !1,
            testMode: !1,
            precompilePrograms: !0,
            scaleFactor: 1
        }, Hl = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class Wl {
            constructor(t1, i, s = !1){
                this._clickTolerance = 10, this.element = i, this.mouseRotate = new ol({
                    clickTolerance: t1.dragRotate._mouseRotate._clickTolerance
                }), this.map = t1, s && (this.mousePitch = new nl({
                    clickTolerance: t1.dragRotate._mousePitch._clickTolerance
                })), e1.aV([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), i.addEventListener("mousedown", this.mousedown), i.addEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener("touchmove", this.touchmove), i.addEventListener("touchend", this.touchend), i.addEventListener("touchcancel", this.reset);
            }
            down(e1, t1) {
                this.mouseRotate.mousedown(e1, t1), this.mousePitch && this.mousePitch.mousedown(e1, t1), u();
            }
            move(e1, t1) {
                const i = this.map, s = this.mouseRotate.mousemoveWindow(e1, t1), r = s && s.bearingDelta;
                if (r && i.setBearing(i.getBearing() + r), this.mousePitch) {
                    const s = this.mousePitch.mousemoveWindow(e1, t1), r = s && s.pitchDelta;
                    r && i.setPitch(i.getPitch() + r);
                }
            }
            off() {
                const e1 = this.element;
                e1.removeEventListener("mousedown", this.mousedown), e1.removeEventListener("touchstart", this.touchstart), e1.removeEventListener("touchmove", this.touchmove), e1.removeEventListener("touchend", this.touchend), e1.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                p(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup);
            }
            mousedown(e1) {
                this.down({
                    ...e1,
                    button: e1.button,
                    type: e1.type,
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }, _(this.element, e1)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
            }
            mousemove(e1) {
                this.move(e1, _(this.element, e1));
            }
            mouseup(e1) {
                this.mouseRotate.mouseupWindow(e1), this.mousePitch && this.mousePitch.mouseupWindow(e1), this.offTemp();
            }
            touchstart(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = g(this.element, e1.targetTouches)[0], this.down({
                    type: "mousedown",
                    button: 0,
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }, this._startPos));
            }
            touchmove(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._lastPos = g(this.element, e1.targetTouches)[0], this.move({
                    buttons: 1,
                    preventDefault: ()=>e1.preventDefault()
                }, this._lastPos));
            }
            touchend(e1) {
                0 === e1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
        }
        function Xl(t1, i, s) {
            if (t1 = new e1.cz(t1.lng, t1.lat), i) {
                const r = new e1.cz(t1.lng - 360, t1.lat), o = new e1.cz(t1.lng + 360, t1.lat), n = 360 * Math.ceil(Math.abs(t1.lng - s.center.lng) / 360), a = s.locationPoint3D(t1).distSqr(i), l = i.x < 0 || i.y < 0 || i.x > s.width || i.y > s.height;
                s.locationPoint3D(r).distSqr(i) < a && (l || Math.abs(r.lng - s.center.lng) < n) ? t1 = r : s.locationPoint3D(o).distSqr(i) < a && (l || Math.abs(o.lng - s.center.lng) < n) && (t1 = o);
            }
            for(; Math.abs(t1.lng - s.center.lng) > 180;){
                const e1 = s.locationPoint3D(t1);
                if (e1.x >= 0 && e1.y >= 0 && e1.x <= s.width && e1.y <= s.height) break;
                t1.lng > s.center.lng ? t1.lng -= 360 : t1.lng += 360;
            }
            return t1;
        }
        const Kl = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        }, Yl = /\s+/, Ql = {
            rotation: 0,
            rotationAlignment: "auto",
            pitchAlignment: "auto",
            occludedOpacity: .2,
            altitude: 0
        };
        class Jl extends e1.E {
            constructor(t1, i){
                super(), (t1 instanceof HTMLElement || i) && (t1 = {
                    element: t1,
                    ...i
                }), e1.aV([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress",
                    "_clearFadeTimer"
                ], this);
                const { anchor: s = "center", color: r = "#3FB1CE", scale: o = 1, draggable: n = !1, clickTolerance: a = 0, rotation: l = Ql.rotation, rotationAlignment: c = Ql.rotationAlignment, pitchAlignment: h = Ql.pitchAlignment, occludedOpacity: d = Ql.occludedOpacity, altitude: u = Ql.altitude } = t1 || {};
                this._anchor = s, this._color = r, this._scale = o, this._draggable = n, this._clickTolerance = a, this._rotation = l, this._rotationAlignment = c, this._pitchAlignment = h, this._occludedOpacity = d, this._altitude = u, this._state = "inactive", this._isDragging = !1, this._pointerEvents = null, this._updateMoving = ()=>this._update(!0), t1 && t1.element ? (this._element = t1.element, this._offset = e1.P.convert(t1 && t1.offset || [
                    0,
                    0
                ])) : (this._defaultMarker = !0, this._element = this._createDefaultMarker(), this._offset = e1.P.convert(t1 && t1.offset || [
                    0,
                    -14
                ])), this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e1)=>{
                    e1.preventDefault();
                }), this._element.addEventListener("mousedown", (e1)=>{
                    e1.preventDefault();
                });
                const p = this._element.classList;
                for(const e1 in Kl)p.remove(`mapboxgl-marker-anchor-${e1}`);
                p.add(`mapboxgl-marker-anchor-${this._anchor}`), t1 && t1.className && p.add(...t1.className.trim().split(Yl)), this._popup = null;
            }
            _createDefaultMarker() {
                const e1 = a("div"), t1 = l("svg", {
                    display: "block",
                    height: 41 * this._scale + "px",
                    width: 27 * this._scale + "px",
                    viewBox: "0 0 27 41"
                }, e1);
                this._svgElement = t1;
                const i = l("radialGradient", {
                    id: "shadowGradient"
                }, l("defs", {}, t1));
                l("stop", {
                    offset: "10%",
                    "stop-opacity": .4
                }, i), l("stop", {
                    offset: "100%",
                    "stop-opacity": .05
                }, i);
                const s = l("ellipse", {
                    cx: 13.5,
                    cy: 34.8,
                    rx: 10.5,
                    ry: 5.25,
                    fill: "url(#shadowGradient)"
                });
                return this._shadowElement = s, 0 === this._altitude && t1.insertBefore(s, t1.firstChild), l("path", {
                    fill: this._color,
                    d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"
                }, t1), l("path", {
                    opacity: .25,
                    d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"
                }, t1), l("circle", {
                    fill: "white",
                    cx: 13.5,
                    cy: 13.5,
                    r: 5.5
                }, t1), e1;
            }
            addTo(e1) {
                return e1 === this._map || (this.remove(), this._map = e1, e1.getCanvasContainer().appendChild(this._element), e1.on("move", this._updateMoving), e1.on("moveend", this._update), e1.on("remove", this._clearFadeTimer), e1._addMarker(this), this.setDraggable(this._draggable), this._update(), e1.on("click", this._onMapClick)), this;
            }
            remove() {
                const e1 = this._map;
                return e1 && (e1.off("click", this._onMapClick), e1.off("move", this._updateMoving), e1.off("moveend", this._update), e1.off("mousedown", this._addDragHandler), e1.off("touchstart", this._addDragHandler), e1.off("mouseup", this._onUp), e1.off("touchend", this._onUp), e1.off("mousemove", this._onMove), e1.off("touchmove", this._onMove), e1.off("remove", this._clearFadeTimer), e1._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(t1) {
                return this._lngLat = e1.cz.convert(t1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
            }
            setAltitude(e1) {
                if (e1 === this._altitude) return this;
                const t1 = this._altitude;
                return this._altitude = e1 || Ql.altitude, this._defaultMarker && 0 === t1 != (0 === this._altitude) && (0 === this._altitude ? this._svgElement.insertBefore(this._shadowElement, this._svgElement.firstChild) : this._shadowElement.remove()), this._update(), this;
            }
            getAltitude() {
                return this._altitude;
            }
            getElement() {
                return this._element;
            }
            setPopup(e1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e1) {
                    if (!("offset" in e1.options)) {
                        const t1 = 38.1, i = 13.5, s = Math.sqrt(Math.pow(i, 2) / 2);
                        e1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -t1
                            ],
                            "bottom-left": [
                                s,
                                -1 * (t1 - i + s)
                            ],
                            "bottom-right": [
                                -s,
                                -1 * (t1 - i + s)
                            ],
                            left: [
                                i,
                                -1 * (t1 - i)
                            ],
                            right: [
                                -i,
                                -1 * (t1 - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e1, e1._marker = this, e1._altitude = this._altitude, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
                }
                return this;
            }
            _onKeyPress(e1) {
                const t1 = e1.code, i = e1.charCode || e1.keyCode;
                "Space" !== t1 && "Enter" !== t1 && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(e1) {
                const t1 = e1.originalEvent.target, i = this._element;
                this._popup && (t1 === i || i.contains(t1)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e1 = this._popup;
                return e1 ? (e1.isOpen() ? (e1.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e1.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
            }
            _behindTerrain() {
                const e1 = this._map, t1 = this._pos;
                if (!e1 || !t1) return !1;
                const i = e1.unproject(t1, this._altitude), s = e1.getFreeCameraOptions();
                if (!s.position) return !1;
                const r = s.position.toLngLat();
                return r.distanceTo(i) < .9 * r.distanceTo(this._lngLat);
            }
            _evaluateOpacity() {
                const t1 = this._map;
                if (!t1) return;
                const i = this._pos;
                if (!i || i.x < 0 || i.x > t1.transform.width || i.y < 0 || i.y > t1.transform.height) return void this._clearFadeTimer();
                const s = t1.unproject(i, this._altitude);
                let r;
                t1._showingGlobe() && e1.f2(t1.transform, this._lngLat) ? r = 0 : (r = 1 - t1._queryFogOpacity(s), t1.transform._terrainEnabled() && t1.style && t1.style.hasTerrain() && this._behindTerrain() && (r *= this._occludedOpacity)), this._element.style.opacity = `${r}`;
                const o = this._element.style.pointerEvents;
                (null === this._pointerEvents ? "" === o : o === this._pointerEvents) && (this._pointerEvents = r > 0 ? "auto" : "none", this._element.style.pointerEvents = this._pointerEvents), this._popup && this._popup._setOpacity(r), this._fadeTimer = null;
            }
            _clearFadeTimer() {
                this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
            }
            _updateDOM() {
                const e1 = this._pos;
                if (!e1 || !this._map) return;
                const t1 = this._offset.mult(this._scale);
                this._element.style.transform = `\n            translate(${e1.x}px,${e1.y}px)\n            ${Kl[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t1.x}px,${t1.y}px)\n        `;
            }
            _calculateXYTransform() {
                const t1 = this._pos, i = this._map, s = this.getPitchAlignment();
                if (!i || !t1 || "map" !== s) return "";
                if (!i._showingGlobe()) {
                    const e1 = i.getPitch();
                    return e1 ? `rotateX(${e1}deg)` : "";
                }
                const r = e1.f3(e1.f4(i.transform, this._lngLat)), o = t1.sub(e1.f5(i.transform)), n = Math.abs(o.x) + Math.abs(o.y);
                if (0 === n) return "";
                const a = r / n;
                return `rotateX(${-o.y * a}deg) rotateY(${o.x * a}deg)`;
            }
            _calculateZTransform() {
                const t1 = this._pos, i = this._map;
                if (!i || !t1) return "";
                let s = 0;
                const r = this.getRotationAlignment();
                if ("map" === r) {
                    if (i._showingGlobe()) {
                        const t1 = i.project(new e1.cz(this._lngLat.lng, this._lngLat.lat + .001), this._altitude), r = i.project(new e1.cz(this._lngLat.lng, this._lngLat.lat - .001), this._altitude).sub(t1);
                        s = e1.f3(Math.atan2(r.y, r.x)) - 90;
                    } else s = -i.getBearing();
                } else if ("horizon" === r) {
                    const r = e1.am(4, 6, i.getZoom()), o = e1.f5(i.transform);
                    o.y += r * i.transform.height;
                    const n = t1.sub(o), a = e1.f3(Math.atan2(n.y, n.x));
                    s = (a > 90 ? a - 270 : a + 90) * (1 - r);
                }
                return s += this._rotation, s ? `rotateZ(${s}deg)` : "";
            }
            _update(e1) {
                cancelAnimationFrame(this._updateFrameId);
                const t1 = this._map;
                t1 && (t1.transform.renderWorldCopies && (this._lngLat = Xl(this._lngLat, this._pos, t1.transform)), this._pos = t1.project(this._lngLat, this._altitude), !0 === e1 ? this._updateFrameId = requestAnimationFrame(()=>{
                    this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
                }) : this._pos = this._pos.round(), t1._requestDomTask(()=>{
                    this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (t1._showingGlobe() || t1.style && t1.style.hasTerrain() || t1.getFog()) && !this._fadeTimer && (this._fadeTimer = window.setTimeout(this._evaluateOpacity.bind(this), 60)));
                }));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(t1) {
                return this._offset = e1.P.convert(t1), this._update(), this;
            }
            addClassName(e1) {
                return this._element.classList.add(e1), this;
            }
            removeClassName(e1) {
                return this._element.classList.remove(e1), this;
            }
            toggleClassName(e1) {
                return this._element.classList.toggle(e1);
            }
            _onMove(t1) {
                const i = this._map;
                if (!i) return;
                const s = this._pointerdownPos, r = this._positionDelta;
                if (s && r) {
                    if (!this._isDragging) {
                        const e1 = this._clickTolerance || i._clickTolerance;
                        if (t1.point.dist(s) < e1) return;
                        this._isDragging = !0;
                    }
                    this._pos = t1.point.sub(r), this._lngLat = i.unproject(this._pos, this._altitude), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e1.h("dragstart"))), this.fire(new e1.h("drag"));
                }
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
                const t1 = this._map;
                t1 && (t1.off("mousemove", this._onMove), t1.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e1.h("dragend")), this._state = "inactive";
            }
            _addDragHandler(e1) {
                const t1 = this._map, i = this._pos;
                t1 && i && this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(i), this._pointerdownPos = e1.point, this._state = "pending", t1.on("mousemove", this._onMove), t1.on("touchmove", this._onMove), t1.once("mouseup", this._onUp), t1.once("touchend", this._onUp));
            }
            setDraggable(e1) {
                this._draggable = !!e1;
                const t1 = this._map;
                return t1 && (e1 ? (t1.on("mousedown", this._addDragHandler), t1.on("touchstart", this._addDragHandler)) : (t1.off("mousedown", this._addDragHandler), t1.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e1) {
                return this._rotation = e1 || Ql.rotation, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e1) {
                return this._rotationAlignment = e1 || Ql.rotationAlignment, this._update(), this;
            }
            getRotationAlignment() {
                return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
            }
            setPitchAlignment(e1) {
                return this._pitchAlignment = e1 || Ql.pitchAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
            }
            setOccludedOpacity(e1) {
                return this._occludedOpacity = e1 || Ql.occludedOpacity, this._update(), this;
            }
            getOccludedOpacity() {
                return this._occludedOpacity;
            }
        }
        const ec = {
            OFF: [],
            WAITING_ACTIVE: [
                "waiting",
                "active"
            ],
            ACTIVE_LOCK: [
                "active"
            ],
            ACTIVE_ERROR: [
                "waiting",
                "active-error"
            ],
            BACKGROUND: [
                "background"
            ],
            BACKGROUND_ERROR: [
                "waiting",
                "background-error"
            ]
        }, tc = (e1)=>`mapboxgl-ctrl-geolocate-${e1}`, ic = [
            "waiting",
            "active",
            "active-error",
            "background",
            "background-error"
        ].map(tc), sc = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0,
            showUserHeading: !1,
            showButton: !0,
            followUserLocation: !0
        }, rc = {
            maxWidth: 100,
            unit: "metric"
        }, oc = {
            kilometer: "km",
            meter: "m",
            mile: "mi",
            foot: "ft",
            "nautical-mile": "nm"
        }, nc = /\s+/, ac = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px",
            altitude: 0
        }, lc = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function cc(t1 = new e1.P(0, 0), i = "bottom") {
            if ("number" == typeof t1) {
                const s = Math.round(Math.sqrt(.5 * Math.pow(t1, 2)));
                switch(i){
                    case "top":
                        return new e1.P(0, t1);
                    case "top-left":
                        return new e1.P(s, s);
                    case "top-right":
                        return new e1.P(-s, s);
                    case "bottom":
                        return new e1.P(0, -t1);
                    case "bottom-left":
                        return new e1.P(s, -s);
                    case "bottom-right":
                        return new e1.P(-s, -s);
                    case "left":
                        return new e1.P(t1, 0);
                    case "right":
                        return new e1.P(-t1, 0);
                }
                return new e1.P(0, 0);
            }
            return t1 instanceof e1.P || Array.isArray(t1) ? e1.P.convert(t1) : e1.P.convert(t1[i] || [
                0,
                0
            ]);
        }
        const hc = "undefined" != typeof document ? document.currentScript : null;
        e1.f6(hc && hc.src && e1.f7(hc.src) ? "cdn" : "other");
        const dc = {
            version: e1.f1,
            supported: function(e1) {
                return !function(e1) {
                    return "undefined" != typeof window && "undefined" != typeof document ? Object.hasOwn ? function() {
                        const e1 = document.createElement("canvas");
                        e1.width = e1.height = 1;
                        const t1 = e1.getContext("2d");
                        return !!t1 && t1.getImageData(0, 0, 1, 1).width === e1.width;
                    }() ? function(e1) {
                        return e1 ? (void 0 === s && (s = r(!0)), s) : (void 0 === i && (i = r(!1)), i);
                    }(e1) ? "" : "insufficient WebGL2 support" : "insufficient Canvas/getImageData support" : "Object.hasOwn not supported" : "not a browser";
                }(e1);
            },
            setRTLTextPlugin: e1.fc,
            getRTLTextPluginStatus: e1.fb,
            setSdkInfo: e1.fa,
            addTileProvider: e1.f9,
            Map: class extends Ol {
                constructor(t1){
                    e1.eM.mark(e1.eN.create);
                    const i = t1;
                    if (null != (t1 = {
                        ...$l,
                        ...t1
                    }).minZoom && null != t1.maxZoom && t1.minZoom > t1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != t1.minPitch && null != t1.maxPitch && t1.minPitch > t1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != t1.minPitch && t1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != t1.maxPitch && t1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    super(new e1.eO(t1.minZoom, t1.maxZoom, t1.minPitch, t1.maxPitch, t1.renderWorldCopies, null, null), t1), this._repaint = !!t1.repaint, this._interactive = t1.interactive, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t1.preserveDrawingBuffer, this._antialias = t1.antialias, this._trackResize = t1.trackResize, this._bearingSnap = t1.bearingSnap, this._refreshExpiredTiles = t1.refreshExpiredTiles, this._fadeDuration = t1.fadeDuration, this._placementAlgorithm = t1.placementAlgorithm || "default", this._isInitialLoad = !0, this._crossSourceCollisions = t1.crossSourceCollisions, this._collectResourceTiming = t1.collectResourceTiming, this._language = this._parseLanguage(t1.language), this._worldview = t1.worldview, this._renderTaskQueue = new Ul, this._domRenderTaskQueue = new Ul, this._controls = [], this._markers = [], this._popups = [], this._mapId = e1.av(), this._locale = {
                        ...jl,
                        ...t1.locale
                    }, this._clickTolerance = t1.clickTolerance, this._cooperativeGestures = t1.cooperativeGestures, this._performanceMetricsCollection = t1.performanceMetricsCollection, this._tessellationStep = t1.tessellationStep, this._containerWidth = 0, this._containerHeight = 0, this._showParseStatus = !0, this._precompilePrograms = t1.precompilePrograms, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new Nl(0), this._interactionRange = [
                        1 / 0,
                        -1 / 0
                    ], this._visibilityHidden = 0, this._useExplicitProjection = !1, this._frameId = 0, this._scaleFactor = t1.scaleFactor, this._requestManager = new e1.eP(t1.transformRequest, t1.accessToken, t1.testMode);
                    const s = e1.eQ(t1.accessToken || e1.eL.ACCESS_TOKEN);
                    if (s && "atlas" in s && "number" == typeof s.atlas && (this._tokenExpiration = s.atlas), this._silenceAuthErrors = !!t1.testMode, this._contextCreateOptions = t1.contextCreateOptions ? {
                        ...t1.contextCreateOptions
                    } : {}, "string" == typeof t1.container) {
                        const e1 = document.getElementById(t1.container);
                        if (!e1) throw new Error(`Container '${t1.container.toString()}' not found.`);
                        this._container = e1;
                    } else {
                        if (!(t1.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = t1.container;
                    }
                    if (this._container.childNodes.length > 0 && e1.w("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t1.maxBounds && this.setMaxBounds(t1.maxBounds), this._spriteFormat = "auto", e1.aV([
                        "_onWindowOnline",
                        "_onWindowResize",
                        "_onVisibilityChange",
                        "_onMapScroll",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                    if (this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this._fullscreenchangeEvent = "onfullscreenchange" in document ? "fullscreenchange" : "webkitfullscreenchange", window.addEventListener("online", this._onWindowOnline, !1), window.addEventListener("resize", this._onWindowResize, !1), window.addEventListener("orientationchange", this._onWindowResize, !1), window.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.addEventListener("visibilitychange", this._onVisibilityChange, !1), this.handlers = new Ml(this, t1), this._localFontFamily = t1.localFontFamily, this._localIdeographFontFamily = t1.localIdeographFontFamily, this._fontstackCompositing = t1.fontstackCompositing, (t1.style || !t1.testMode) && this.setStyle(t1.style || e1.eL.DEFAULT_STYLE, {
                        config: t1.config,
                        localFontFamily: this._localFontFamily,
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        fontstackCompositing: this._fontstackCompositing
                    }), t1.projection && this.setProjection(t1.projection), t1.hash && (this._hash = new Ma("string" == typeof t1.hash && t1.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
                        null == i.center && null == i.zoom || (this.transform._unmodified = !1), this.jumpTo({
                            center: t1.center,
                            zoom: t1.zoom,
                            bearing: t1.bearing,
                            pitch: t1.pitch
                        });
                        const e1 = t1.bounds;
                        e1 && (this.resize(), this.fitBounds(e1, {
                            ...t1.fitBoundsOptions,
                            duration: 0
                        }));
                    }
                    this.resize(), t1.attributionControl && this.addControl(new kl({
                        customAttribution: t1.customAttribution
                    })), this._logoControl = new zl, this.addControl(this._logoControl, t1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet), this._postStyleLoadEvent(), this._postStyleWithAppearanceEvent();
                    }), this.on("data", (t1)=>{
                        this._update("style" === t1.dataType), this.fire(new e1.h(`${t1.dataType}data`, t1));
                    }), this.on("dataloading", (t1)=>{
                        this.fire(new e1.h(`${t1.dataType}dataloading`, t1));
                    }), this._interactions = new Gl(this);
                }
                _getMapId() {
                    return this._mapId;
                }
                addControl(t1, i) {
                    if (void 0 === i && (i = t1.getDefaultPosition ? t1.getDefaultPosition() : "top-right"), !t1 || !t1.onAdd) return this.fire(new e1.f(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const s = t1.onAdd(this);
                    this._controls.push(t1);
                    const r = this._controlPositions[i];
                    return i.includes("bottom") ? r.insertBefore(s, r.firstChild) : r.appendChild(s), this;
                }
                removeControl(t1) {
                    if (!t1 || !t1.onRemove) return this.fire(new e1.f(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = this._controls.indexOf(t1);
                    return i > -1 && this._controls.splice(i, 1), t1.onRemove(this), this;
                }
                hasControl(e1) {
                    return this._controls.includes(e1);
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                resize(t1) {
                    if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
                    this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
                    const i = !this._moving;
                    return i && this.fire(new e1.h("movestart", t1)).fire(new e1.h("move", t1)), this.fire(new e1.h("resize", t1)), i && this.fire(new e1.h("moveend", t1)), this;
                }
                getBounds() {
                    return this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds() || null;
                }
                setMaxBounds(t1) {
                    return this.transform.setMaxBounds(e1.eB.convert(t1)), this._update();
                }
                setMinZoom(t1) {
                    if ((t1 = t1 ?? -2) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 ? this.setZoom(t1) : this.fire(new e1.h("zoomstart")).fire(new e1.h("zoom")).fire(new e1.h("zoomend")), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(t1) {
                    if ((t1 = t1 ?? 22) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 ? this.setZoom(t1) : this.fire(new e1.h("zoomstart")).fire(new e1.h("zoom")).fire(new e1.h("zoomend")), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(t1) {
                    if ((t1 = t1 ?? 0) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 ? this.setPitch(t1) : this.fire(new e1.h("pitchstart")).fire(new e1.h("pitch")).fire(new e1.h("pitchend")), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(t1) {
                    if ((t1 = t1 ?? 85) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 ? this.setPitch(t1) : this.fire(new e1.h("pitchstart")).fire(new e1.h("pitch")).fire(new e1.h("pitchend")), this;
                    throw new Error("maxPitch must be greater than or equal to minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getScaleFactor() {
                    return this._scaleFactor;
                }
                setScaleFactor(e1) {
                    return this._scaleFactor = e1, this.painter.scaleFactor = e1, this.style && this.style._setLabelPlacementStale(), this.style._updateFilteredLayers((e1)=>"symbol" === e1.type), this._update(!0), this;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(e1) {
                    return this.transform.renderWorldCopies = e1, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(!0), this._update();
                }
                getLanguage() {
                    return this._language;
                }
                _parseLanguage(e1) {
                    return "auto" === e1 ? navigator.language : Array.isArray(e1) ? 0 === e1.length ? void 0 : e1.map((e1)=>"auto" === e1 ? navigator.language : e1) : e1;
                }
                setLanguage(e1) {
                    const t1 = this._parseLanguage(e1);
                    if (!this.style || t1 === this._language) return this;
                    this._language = t1, this.style.reloadSources();
                    for (const e1 of this._controls)e1._setLanguage && e1._setLanguage(this._language);
                    return this;
                }
                getWorldview() {
                    return this._worldview;
                }
                setWorldview(e1) {
                    return this.style && e1 !== this._worldview ? (this._worldview = e1, this._styleDirty = !0, this.style.setWorldview(e1), this) : this;
                }
                getProjection() {
                    return this.transform.mercatorFromTransition ? {
                        name: "globe",
                        center: [
                            0,
                            0
                        ]
                    } : this.transform.getProjection();
                }
                _showingGlobe() {
                    return "globe" === this.transform.projection.name;
                }
                setProjection(e1) {
                    return this._lazyInitEmptyStyle(), e1 ? "string" == typeof e1 && (e1 = {
                        name: e1
                    }) : e1 = null, this._useExplicitProjection = !!e1, this._prioritizeAndUpdateProjection(e1, this.style.projection);
                }
                _updateProjectionTransition() {
                    if ("globe" !== this.getProjection().name) return;
                    const t1 = this.transform, i = t1.projection.name;
                    let s;
                    "globe" === i && t1.zoom >= e1.b1 ? (t1.setMercatorFromTransition(), s = !0) : "mercator" === i && t1.zoom < e1.b1 && (t1.setProjection({
                        name: "globe"
                    }), s = !0), s && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate(), this._update(!0));
                }
                _prioritizeAndUpdateProjection(e1, t1) {
                    return this._updateProjection(e1 || t1 || {
                        name: "mercator"
                    });
                }
                _updateProjection(t1) {
                    let i;
                    const s = this.transform.mercatorFromTransition;
                    i = "globe" === t1.name && this.transform.zoom >= e1.b1 ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t1), this.style.applyProjectionUpdate();
                    const r = "mercator" === this.transform.getProjection().name && s !== this.transform.mercatorFromTransition;
                    return (i || r) && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(!0), this._forceMarkerAndPopupUpdate(!0)), this;
                }
                project(t1, i) {
                    return this.transform.locationPoint3D(e1.cz.convert(t1), i);
                }
                unproject(t1, i) {
                    return this.transform.pointLocation3D(e1.P.convert(t1), i);
                }
                isMoving() {
                    return this._moving || this.handlers && this.handlers.isMoving() || !1;
                }
                isZooming() {
                    return this._zooming || this.handlers && this.handlers.isZooming() || !1;
                }
                isRotating() {
                    return this._rotating || this.handlers && this.handlers.isRotating() || !1;
                }
                _isDragging() {
                    return this.handlers && this.handlers._isDragging() || !1;
                }
                _createDelegatedListener(e1, t1, i) {
                    const s = (e1)=>{
                        let i = [];
                        if (Array.isArray(t1)) {
                            const s = t1.filter((e1)=>this.getLayer(e1));
                            i = s.length ? this.queryRenderedFeatures(e1, {
                                layers: s
                            }) : [];
                        } else i = this.queryRenderedFeatures(e1, {
                            target: t1
                        });
                        return i;
                    };
                    if ("mouseenter" === e1 || "mouseover" === e1) {
                        let r = !1;
                        const o = (t1)=>{
                            const o = s(t1.point);
                            o.length ? r || (r = !0, i.call(this, new Ga(e1, this, t1.originalEvent, {
                                features: o
                            }))) : r = !1;
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                mousemove: o,
                                mouseout: ()=>{
                                    r = !1;
                                }
                            }
                        };
                    }
                    if ("mouseleave" === e1 || "mouseout" === e1) {
                        let r = !1;
                        const o = (t1)=>{
                            s(t1.point).length ? r = !0 : r && (r = !1, i.call(this, new Ga(e1, this, t1.originalEvent)));
                        }, n = (t1)=>{
                            r && (r = !1, i.call(this, new Ga(e1, this, t1.originalEvent)));
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                mousemove: o,
                                mouseout: n
                            }
                        };
                    }
                    {
                        const r = (e1)=>{
                            const t1 = s(e1.point);
                            t1.length && (e1.features = t1, i.call(this, e1), delete e1.features);
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                [e1]: r
                            }
                        };
                    }
                }
                on(e1, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.on(e1, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const s = this._createDelegatedListener(e1, t1, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e1] = this._delegatedListeners[e1] || [], this._delegatedListeners[e1].push(s);
                    for(const e1 in s.delegates)this.on(e1, s.delegates[e1]);
                    return this;
                }
                once(e1, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.once(e1, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const s = this._createDelegatedListener(e1, t1, i);
                    for(const e1 in s.delegates)this.once(e1, s.delegates[e1]);
                    return this;
                }
                off(e1, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.off(e1, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const s = this._delegatedListeners ? this._delegatedListeners[e1] : void 0;
                    return s && ((e1)=>{
                        for(let s = 0; s < e1.length; s++){
                            const r = e1[s];
                            if (r.listener === i && ql(r.targets, t1)) {
                                for(const e1 in r.delegates)this.off(e1, r.delegates[e1]);
                                return e1.splice(s, 1), this;
                            }
                        }
                    })(s), this;
                }
                queryRenderedFeatures(t1, i) {
                    if (!this.style) return [];
                    if (void 0 === t1 || t1 instanceof e1.P || Array.isArray(t1) || void 0 !== i || (i = t1, t1 = void 0), t1 = t1 || [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ], !i) {
                        const e1 = this.style.queryRenderedFeatures(t1, void 0, this.transform), i = this.style.queryRenderedFeatureset(t1, void 0, this.transform);
                        return e1.concat(i);
                    }
                    let s = !0;
                    if (i.target && (s = this._isTargetValid(i.target), s && !i.layers)) return this.style.queryRenderedFeatureset(t1, i, this.transform);
                    let r = !0;
                    if (i.layers && Array.isArray(i.layers)) {
                        for (const e1 of i.layers)if (!this._isValidId(e1)) {
                            r = !1;
                            break;
                        }
                        if (r && !i.target) return this.style.queryRenderedFeatures(t1, i, this.transform);
                    }
                    let o = [];
                    return r && (o = o.concat(this.style.queryRenderedFeatures(t1, i, this.transform))), s && (o = o.concat(this.style.queryRenderedFeatureset(t1, i, this.transform))), o;
                }
                querySourceFeatures(e1, t1) {
                    return !e1 || "string" == typeof e1 && !this._isValidId(e1) ? [] : this.style.querySourceFeatures(e1, t1);
                }
                queryRasterValue(e1, t1, i) {
                    return this._isValidId(e1) ? this.style.queryRasterValue(e1, t1, i) : Promise.resolve(null);
                }
                isPointOnSurface(t1) {
                    const { name: i } = this.transform.projection;
                    return "globe" !== i && "mercator" !== i && e1.w(`${i} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(e1.P.convert(t1));
                }
                addInteraction(e1, t1) {
                    return this._interactions.add(e1, t1), this;
                }
                removeInteraction(e1) {
                    return this._interactions.remove(e1), this;
                }
                getCooperativeGestures() {
                    return this._cooperativeGestures;
                }
                setCooperativeGestures(e1) {
                    return this._cooperativeGestures = e1, this;
                }
                setStyle(t1, i) {
                    return i = {
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        localFontFamily: this._localFontFamily,
                        fontstackCompositing: this._fontstackCompositing,
                        ...i
                    }, this.style && t1 && !1 !== i.diff && i.localFontFamily === this._localFontFamily && i.localIdeographFontFamily === this._localIdeographFontFamily && i.fontstackCompositing === this._fontstackCompositing && !i.config ? (this.style._diffStyle(t1, (s, r)=>{
                        if (s) {
                            const r = "string" == typeof s ? s : s instanceof Error ? s.message : s.error;
                            e1.w(`Unable to perform style diff: ${r}. Rebuilding the style from scratch.`), this._updateStyle(t1, i);
                        } else r && this._update(!0);
                    }, ()=>this._postStyleLoadEvent()), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._localFontFamily = i.localFontFamily, this._fontstackCompositing = i.fontstackCompositing, this._updateStyle(t1, i));
                }
                _getUIString(e1) {
                    const t1 = this._locale[e1];
                    if (null == t1) throw new Error(`Missing UI string '${e1}'`);
                    return t1;
                }
                _updateStyle(e1, t1) {
                    if (this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), e1) {
                        const i = {
                            ...t1
                        };
                        t1 && t1.config && (i.initialConfig = t1.config, delete i.config), this.style = new To(this, i).load(e1), this.style.setEventedParent(this, {
                            style: this.style
                        });
                    }
                    return this._updateTerrain(), this;
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new To(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : (e1.w("There is no style added to the map."), !1);
                }
                _isValidId(t1) {
                    return null == t1 ? (this.fire(new e1.f(new Error("IDs can't be empty."))), !1) : e1.df(t1) ? (this.fire(new e1.f(new Error(`IDs can't contain special symbols: "${t1}".`))), !1) : "__proto__" !== t1 && "constructor" !== t1 && "prototype" !== t1 || (this.fire(new e1.f(new Error(`IDs can't be "${t1}".`))), !1);
                }
                _isTargetValid(e1) {
                    return "featuresetId" in e1 ? this._isValidId("importId" in e1 ? e1.importId : e1.featuresetId) : "layerId" in e1 && this._isValidId(e1.layerId);
                }
                _areTargetsValid(e1) {
                    if (Array.isArray(e1)) {
                        for (const t1 of e1)if (!this._isValidId(t1)) return !1;
                        return !0;
                    }
                    return this._isTargetValid(e1);
                }
                addSource(e1, t1) {
                    return this._isValidId(e1) ? (this._lazyInitEmptyStyle(), this.style.addSource(e1, t1), this._update(!0)) : this;
                }
                isSourceLoaded(e1) {
                    return !!this._isValidId(e1) && !!this.style && this.style._isSourceCacheLoaded(e1);
                }
                areTilesLoaded() {
                    return this.style.areTilesLoaded();
                }
                removeSource(e1) {
                    return this._isValidId(e1) ? (this.style.removeSource(e1), this._updateTerrain(), this._update(!0)) : this;
                }
                getSource(e1) {
                    return this._isValidId(e1) ? this.style.getOwnSource(e1) : null;
                }
                addImage(t1, i, { pixelRatio: s = 1, sdf: r = !1, stretchX: o, stretchY: n, content: a } = {}) {
                    this._lazyInitEmptyStyle();
                    const l = e1.I.from(t1);
                    if (i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap) {
                        const { width: t1, height: c, data: h } = e1.e.getImageData(i);
                        this.style.addImage(l, {
                            data: new e1.b({
                                width: t1,
                                height: c
                            }, h),
                            pixelRatio: s,
                            stretchX: o,
                            stretchY: n,
                            content: a,
                            sdf: r,
                            version: 0,
                            usvg: !1
                        });
                    } else if (void 0 === i.width || void 0 === i.height) this.fire(new e1.f(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    else {
                        const { width: c, height: h } = i, d = i;
                        this.style.addImage(l, {
                            data: new e1.b({
                                width: c,
                                height: h
                            }, new Uint8Array(d.data)),
                            pixelRatio: s,
                            stretchX: o,
                            stretchY: n,
                            content: a,
                            sdf: r,
                            usvg: !1,
                            version: 0,
                            userImage: d
                        }), d.onAdd && d.onAdd(this, t1);
                    }
                }
                updateImage(t1, i) {
                    this._lazyInitEmptyStyle();
                    const s = e1.I.from(t1), r = this.style.getImage(s);
                    if (!r) return void this.fire(new e1.f(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const o = i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap ? e1.e.getImageData(i) : i, { width: n, height: a, data: l } = o;
                    if (void 0 === n || void 0 === a) return void this.fire(new e1.f(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    if (n !== (r.usvg ? r.icon.usvg_tree.width : r.data.width) || a !== (r.usvg ? r.icon.usvg_tree.height : r.data.height)) return void this.fire(new e1.f(new Error(`The width and height of the updated image (${n}, ${a})\n                must be that same as the previous version of the image\n                (${r.data.width}, ${r.data.height})`)));
                    const c = !(i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap);
                    let h = !1;
                    r.usvg ? (r.data = new e1.b({
                        width: n,
                        height: a
                    }, new Uint8Array(l)), r.usvg = !1, r.icon = void 0, h = !0) : r.data.replace(l, c), this.style.updateImage(s, r, h);
                }
                hasImage(t1) {
                    return t1 ? !!this.style && !!this.style.getImage(e1.I.from(t1)) : (this.fire(new e1.f(new Error("Missing required image id"))), !1);
                }
                removeImage(t1) {
                    this.style.removeImage(e1.I.from(t1));
                }
                loadImage(t1, i) {
                    (async ()=>{
                        const i = await this._requestManager.transformRequest(t1, e1.R.Image), { data: s } = await e1.a(i);
                        return s;
                    })().then((e1)=>i(null, e1)).catch(i);
                }
                listImages() {
                    return this.style.listImages().map((e1)=>e1.name);
                }
                addModel(e1, t1) {
                    this._lazyInitEmptyStyle(), this.style.addModel(e1, t1);
                }
                hasModel(t1) {
                    return t1 ? this.style.hasModel(t1) : (this.fire(new e1.f(new Error("Missing required model id"))), !1);
                }
                removeModel(e1) {
                    this.style.removeModel(e1);
                }
                listModels() {
                    return this.style.listModels();
                }
                addLayer(e1, t1) {
                    return this._isValidId(e1.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e1, t1), this._update(!0)) : this;
                }
                getSlot(e1) {
                    const t1 = this.getLayer(e1);
                    return t1 && t1.slot || null;
                }
                setSlot(e1, t1) {
                    return this.style.setSlot(e1, t1), this.style.mergeLayers(), this._update(!0);
                }
                addImport(t1, i) {
                    return this._isValidId(t1.id) ? (this.style.addImport(t1, i).catch((t1)=>this.fire(new e1.f(new Error("Failed to add import", t1)))), this) : this;
                }
                updateImport(e1, t1) {
                    return "string" != typeof t1 && t1.id !== e1 ? (this.removeImport(e1), this.addImport(t1)) : (this.style.updateImport(e1, t1), this._update(!0));
                }
                removeImport(e1) {
                    return this.style.removeImport(e1), this;
                }
                moveImport(e1, t1) {
                    return this.style.moveImport(e1, t1), this._update(!0);
                }
                moveLayer(e1, t1) {
                    return this._isValidId(e1) ? (this.style.moveLayer(e1, t1), this._update(!0)) : this;
                }
                removeLayer(e1) {
                    return this._isValidId(e1) ? (this.style.removeLayer(e1), this._update(!0)) : this;
                }
                getLayer(e1) {
                    if (!this._isValidId(e1)) return null;
                    const t1 = this.style.getOwnLayer(e1);
                    return t1 ? "custom" === t1.type ? t1.implementation : t1.serialize() : void 0;
                }
                getSlots() {
                    return this.style.getSlots();
                }
                setLayerZoomRange(e1, t1, i) {
                    return this._isValidId(e1) ? (this.style.setLayerZoomRange(e1, t1, i), this._update(!0)) : this;
                }
                setFilter(e1, t1, i = {}) {
                    return this._isValidId(e1) ? (this.style.setFilter(e1, t1, i), this._update(!0)) : this;
                }
                getFilter(e1) {
                    return this._isValidId(e1) ? this.style.getFilter(e1) : null;
                }
                setPaintProperty(e1, t1, i, s = {}) {
                    return this._isValidId(e1) ? (this.style.setPaintProperty(e1, t1, i, s), this._update(!0)) : this;
                }
                getPaintProperty(e1, t1) {
                    return this._isValidId(e1) ? this.style.getPaintProperty(e1, t1) : null;
                }
                setLayoutProperty(e1, t1, i, s = {}) {
                    return this._isValidId(e1) ? (this.style.setLayoutProperty(e1, t1, i, s), this._update(!0)) : this;
                }
                getLayoutProperty(e1, t1) {
                    return this._isValidId(e1) ? this.style.getLayoutProperty(e1, t1) : null;
                }
                getLayerProperty(e1, t1) {
                    return this._isValidId(e1) ? this.style.getLayerProperty(e1, t1) : null;
                }
                setLayerProperty(e1, t1, i, s = {}) {
                    return this._isValidId(e1) ? ("appearances" === t1 && this._postAddingAppearancesToStyleEvent(), this.style.setLayerProperty(e1, t1, i, s), this._update(!0)) : this;
                }
                getGlyphsUrl() {
                    return this.style.getGlyphsUrl();
                }
                setGlyphsUrl(e1) {
                    return this.style.setGlyphsUrl(e1), this._update(!0);
                }
                getSchema(e1) {
                    return this.style.getSchema(e1);
                }
                setSchema(e1, t1) {
                    return this.style.setSchema(e1, t1), this._update(!0);
                }
                getConfig(e1) {
                    return this.style.getConfig(e1);
                }
                setConfig(e1, t1) {
                    return this.style.setConfig(e1, t1), this._update(!0);
                }
                getConfigProperty(e1, t1) {
                    return this.style.getConfigProperty(e1, t1);
                }
                setConfigProperty(e1, t1, i) {
                    return this.style.setConfigProperty(e1, t1, i), this._update(!0);
                }
                getFeaturesetDescriptors(e1) {
                    return this.style.getFeaturesetDescriptors(e1);
                }
                setLights(e1) {
                    if (this._lazyInitEmptyStyle(), e1 && 1 === e1.length && "flat" === e1[0].type) {
                        const t1 = e1[0];
                        t1.properties ? this.style.setFlatLight(t1.properties, t1.id, {}) : this.style.setFlatLight({}, "flat");
                    } else this.style.setLights(e1), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = !0);
                    return this._update(!0);
                }
                getLights() {
                    const e1 = this.style.getLights() || [];
                    return 0 === e1.length && e1.push({
                        id: this.style.light.id,
                        type: "flat",
                        properties: this.style.getFlatLight()
                    }), e1;
                }
                setLight(e1, t1 = {}) {
                    return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([
                        {
                            id: "flat",
                            type: "flat",
                            properties: e1
                        }
                    ]);
                }
                getLight() {
                    return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
                }
                setTerrain(e1) {
                    return this._lazyInitEmptyStyle(), !e1 && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e1), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
                }
                getTerrain() {
                    return this.style ? this.style.getTerrain() : null;
                }
                setFog(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setFog(e1), this._update(!0);
                }
                getFog() {
                    return this.style ? this.style.getFog() : null;
                }
                setSnow(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setSnow(e1), this._update(!0);
                }
                getSnow() {
                    return this.style ? this.style.getSnow() : null;
                }
                setRain(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setRain(e1), this._update(!0);
                }
                getRain() {
                    return this.style ? this.style.getRain() : null;
                }
                setColorTheme(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setColorTheme(e1), this._update(!0);
                }
                setImportColorTheme(e1, t1) {
                    return this._lazyInitEmptyStyle(), this.style.setImportColorTheme(e1, t1), this._update(!0);
                }
                setCamera(e1) {
                    return this.style.setCamera(e1), this._triggerCameraUpdate(e1);
                }
                getNearClipOffset() {
                    return this.transform.nearClipOffset;
                }
                setNearClipOffset(e1) {
                    const t1 = this.transform.nearClipOffset !== e1;
                    return this.transform.nearClipOffset = e1, this._update(t1);
                }
                _triggerCameraUpdate(e1) {
                    return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e1["camera-projection"]));
                }
                getCamera() {
                    return this.style.camera;
                }
                _queryFogOpacity(t1) {
                    return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e1.cz.convert(t1), this.transform) : 0;
                }
                setFeatureState(e1, t1) {
                    return e1.source && !this._isValidId(e1.source) ? this : (this.style.setFeatureState(e1, t1), this._update());
                }
                removeFeatureState(e1, t1) {
                    return e1.source && !this._isValidId(e1.source) ? this : (this.style.removeFeatureState(e1, t1), this._update());
                }
                getFeatureState(e1) {
                    return e1.source && !this._isValidId(e1.source) ? null : this.style.getFeatureState(e1);
                }
                resetFeatureStates(e1) {
                    return this.style.resetFeatureStates(e1), this._update();
                }
                _selectIndoorFloor(e1) {
                    this.style.indoorManager && this.style.indoorManager.selectFloor(e1);
                }
                _setIndoorActiveFloorsVisibility(e1) {
                    this.style.indoorManager && this.style.indoorManager.setActiveFloorsVisibility(e1);
                }
                getIndoorTileOptions(e1, t1) {
                    return this.style && this.style.isIndoorEnabled() && this.style.indoorManager ? this.style.indoorManager.getIndoorTileOptions(e1, t1) : null;
                }
                _updateContainerDimensions() {
                    if (!this._container) return;
                    const e1 = this._container.getBoundingClientRect().width || 400, t1 = this._container.getBoundingClientRect().height || 300;
                    let i, s, r, o = this._container;
                    for(; o && (!s || !r);){
                        const e1 = window.getComputedStyle(o).transform;
                        e1 && "none" !== e1 && (i = e1.match(Zl)[1].split(", "), i[0] && "0" !== i[0] && "1" !== i[0] && (s = i[0]), i[3] && "0" !== i[3] && "1" !== i[3] && (r = i[3])), o = o.parentElement;
                    }
                    this._containerWidth = s ? Math.abs(e1 / s) : e1, this._containerHeight = r ? Math.abs(t1 / r) : t1;
                }
                _detectMissingCSS() {
                    "rgb(250, 128, 114)" !== window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e1.w("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                }
                _setupContainer() {
                    const e1 = this._container;
                    e1.classList.add("mapboxgl-map"), (this._missingCSSCanary = a("div", "mapboxgl-canary", e1)).style.visibility = "hidden", this._detectMissingCSS();
                    const t1 = this._canvasContainer = a("div", "mapboxgl-canvas-container", e1);
                    this._canvas = a("canvas", "mapboxgl-canvas", t1), this._interactive && (t1.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
                    const i = this._controlContainer = a("div", "mapboxgl-control-container", e1), s = this._controlPositions = {};
                    [
                        "top-left",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left"
                    ].forEach((e1)=>{
                        s[e1] = a("div", `mapboxgl-ctrl-${e1}`, i);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _resizeCanvas(t1, i) {
                    const s = e1.e.devicePixelRatio || 1;
                    this._canvas.width = s * Math.ceil(t1), this._canvas.height = s * Math.ceil(i), this._canvas.style.width = `${t1}px`, this._canvas.style.height = `${i}px`;
                }
                _addMarker(e1) {
                    this._markers.push(e1);
                }
                _removeMarker(e1) {
                    const t1 = this._markers.indexOf(e1);
                    -1 !== t1 && this._markers.splice(t1, 1);
                }
                _addPopup(e1) {
                    this._popups.push(e1);
                }
                _removePopup(e1) {
                    const t1 = this._popups.indexOf(e1);
                    -1 !== t1 && this._popups.splice(t1, 1);
                }
                _setupPainter() {
                    const i = {
                        ...t1,
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    }, s = this._canvas.getContext("webgl2", i);
                    s ? (e1.eR(s, !0), this.painter = new La(s, this._contextCreateOptions, this.transform, this._scaleFactor, this._worldview), this.on("data", (e1)=>{
                        if ("source" === e1.dataType) {
                            const t1 = this.transform.elevation ? this.transform.elevation._source() : null;
                            t1 && e1.sourceCacheId === t1.id && this.style && this.style._setLabelPlacementStale(), this.style && e1.sourceCacheId && this.style._buildingIndex.hasLayerForSourceCache(e1.sourceCacheId) && this.style._requestFullLabelPlacement(), this.painter.setTileLoadedFlag(!0);
                        }
                    })) : this.fire(new e1.f(new Error("Failed to initialize WebGL")));
                }
                _contextLost(t1) {
                    t1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.style && this.style.handleContextLost(), this.fire(new e1.h("webglcontextlost", {
                        originalEvent: t1
                    }));
                }
                _contextRestored(t1) {
                    this._setupPainter(), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight)), this._updateTerrain(), this.style && (this.style.clearLayers(), this.style.imageManager.destroyAtlasTextures(), this.style.imageManager.imageAtlasCache.destroyTextures(), this.style.reloadModels(), this.style.clearSources()), this._update(), this.fire(new e1.h("webglcontextrestored", {
                        originalEvent: t1
                    }));
                }
                _onMapScroll(e1) {
                    if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                idle() {
                    return !this.isMoving() && this.loaded();
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                frameReady() {
                    return this.loaded() && !this._placementDirty;
                }
                _update(e1) {
                    return this.style ? (this._styleDirty = this._styleDirty || e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(e1) {
                    return this._update(), this._renderTaskQueue.add(e1);
                }
                _cancelRenderFrame(e1) {
                    this._renderTaskQueue.remove(e1);
                }
                _requestDomTask(e1) {
                    !this.loaded() || this.loaded() && !this.isMoving() ? e1() : this._domRenderTaskQueue.add(e1);
                }
                _render(t1) {
                    let i;
                    this.fire(new e1.h("renderstart")), ++this._frameId;
                    const s = this.painter.context.extTimerQuery, r = e1.e.now(), o = this.painter.context.gl;
                    if (this.listens("gpu-timing-frame") && (i = o.createQuery(), o.beginQuery(s.TIME_ELAPSED_EXT, i)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], performance.now())), this._renderTaskQueue.run(t1), this._domRenderTaskQueue.run(t1), this._removed) return;
                    this._updateProjectionTransition();
                    const n = this._isInitialLoad ? 0 : this._fadeDuration;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const t1 = this.transform.zoom, i = this.transform.pitch, s = e1.e.now(), r = new e1.ai(t1, {
                            now: s,
                            fadeDuration: n,
                            pitch: i,
                            transition: this._loaded ? this.style.transition : {
                                duration: 0,
                                delay: 0
                            },
                            worldview: this._worldview
                        });
                        this.style.update(r);
                    }
                    this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
                    let a = !1;
                    if (this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), a = this._updateAverageElevation(r), this.style.updateSources(this.transform), this.style.updateImageProviders(), this.isMoving() || this._forceMarkerAndPopupUpdate()) : a = this._updateAverageElevation(r), this.style && (this._placementDirty = this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, n, this._crossSourceCollisions, this.painter.replacementSource, this._placementAlgorithm)), this.style && this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showParseStatus: this.showParseStatus,
                        wireframe: {
                            terrain: this.showTerrainWireframe,
                            layers2D: this.showLayers2DWireframe,
                            layers3D: this.showLayers3DWireframe
                        },
                        showOverdrawInspector: this._showOverdrawInspector,
                        showQueryGeometry: !!this._showQueryGeometry,
                        showTileAABBs: this.showTileAABBs,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: n,
                        isInitialLoad: this._isInitialLoad,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer"),
                        gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"),
                        speedIndexTiming: this.speedIndexTiming,
                        paintStartTimeStamp: t1
                    }), this.fire(new e1.h("render")), this.loaded() && !this._loaded && (this._loaded = !0, e1.eM.mark(e1.eN.load), this.fire(new e1.h("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = !0), this.style && (this.style.snow || this.style.rain) && (this._styleDirty = !0), this.style && this.style.imageManager.hasPatternsInFlight() && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), i) {
                        const t1 = e1.e.now() - r;
                        o.endQuery(s.TIME_ELAPSED_EXT), setTimeout(()=>{
                            const s = o.getQueryParameter(i, o.QUERY_RESULT) / 1e6;
                            o.deleteQuery(i), this.fire(new e1.h("gpu-timing-frame", {
                                cpuTime: t1,
                                gpuTime: s
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        const t1 = this.painter.collectGpuTimers();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimers(t1);
                            this.fire(new e1.h("gpu-timing-layer", {
                                layerTimes: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-deferred-render")) {
                        const t1 = this.painter.collectDeferredRenderGpuQueries();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimeDeferredRender(t1);
                            this.fire(new e1.h("gpu-timing-deferred-render", {
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    const l = this._sourcesDirty || this._styleDirty || this._placementDirty || a;
                    if (l || this._repaint) this.triggerRepaint();
                    else {
                        const t1 = this.idle();
                        if (t1 && (a = this._updateAverageElevation(r, !0)), a) this.triggerRepaint();
                        else {
                            if (this._triggerFrame(!1), t1 && (this.fire(new e1.h("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
                                const t1 = this._calculateSpeedIndex();
                                this.fire(new e1.h("speedindexcompleted", {
                                    speedIndex: t1
                                })), this.speedIndexTiming = !1;
                            }
                            t1 && this.style && this.style.handleIdle();
                        }
                    }
                    !this._loaded || this._fullyLoaded || l || (this._fullyLoaded = !0, e1.eM.mark(e1.eN.fullLoad), this._performanceMetricsCollection && e1.eS(this._requestManager._customAccessToken, {
                        width: this.painter.width,
                        height: this.painter.height,
                        interactionRange: this._interactionRange,
                        visibilityHidden: this._visibilityHidden,
                        terrainEnabled: this.painter.style.hasTerrain(),
                        fogEnabled: !!this.painter.style.getFog(),
                        projection: this.getProjection().name,
                        zoom: this.transform.zoom,
                        renderer: this.painter.context.renderer,
                        vendor: this.painter.context.vendor
                    }), this._authenticate());
                }
                _forceMarkerAndPopupUpdate(e1) {
                    for (const t1 of this._markers)e1 && !this.getRenderWorldCopies() && (t1._lngLat = t1._lngLat.wrap()), t1._update();
                    for (const t1 of this._popups)!e1 || this.getRenderWorldCopies() || t1._trackPointer || (t1._lngLat = t1._lngLat.wrap()), t1._update();
                }
                _updateAverageElevation(e1, t1 = !1) {
                    const i = (e1)=>(this.transform.averageElevation = e1, this._update(!1), !0);
                    if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i(0);
                    const s = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
                    if (s || (t1 || e1 - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e1)) {
                        const t1 = this.transform.averageElevation;
                        let r = this.transform.sampleAverageElevation();
                        null != this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(r) ? r = 0 : this._averageElevationLastSampledAt = e1;
                        const o = Math.abs(t1 - r);
                        if (o > 1) {
                            if (this._isInitialLoad || s) return this._averageElevation.jumpTo(r), i(r);
                            this._averageElevation.easeTo(r, e1, 300);
                        } else if (o > 1e-4) return this._averageElevation.jumpTo(r), i(r);
                    }
                    return !!this._averageElevation.isEasing(e1) && i(this._averageElevation.getValue(e1));
                }
                _isTokenExpired() {
                    return null != this._tokenExpiration && Date.now() > this._tokenExpiration;
                }
                _revokeAuth() {
                    const t1 = this.painter.context.gl;
                    e1.eR(t1, !1), this._logoControl instanceof zl && this._logoControl._updateLogo(), t1 && t1.clear(t1.DEPTH_BUFFER_BIT | t1.COLOR_BUFFER_BIT | t1.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e1.f(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                }
                _authenticate() {
                    e1.eT(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t1)=>{
                        t1 && (t1.message !== e1.eU && 401 !== t1.status || this._revokeAuth());
                    }), this._isTokenExpired() && this._revokeAuth(), e1.eV(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, ()=>{});
                }
                _postStyleLoadEvent() {
                    this.style.globalId && e1.eW(this._requestManager._customAccessToken, {
                        map: this,
                        style: this.style.globalId,
                        importedStyles: this.style.getImportGlobalIds()
                    });
                }
                _postStyleWithAppearanceEvent() {
                    this.style.globalId && this.style.hasAppearances() && e1.eX(this._requestManager._customAccessToken);
                }
                _postAddingAppearancesToStyleEvent() {
                    e1.eY(this._requestManager._customAccessToken);
                }
                _updateTerrain() {
                    const e1 = this._isDragging();
                    this.painter.updateTerrain(this.style, e1);
                }
                _calculateSpeedIndex() {
                    const e1 = this.painter.canvasCopy(), t1 = this.painter.getCanvasCopiesAndTimestamps();
                    t1.timeStamps.push(performance.now());
                    const i = this.painter.context.gl, s = i.createFramebuffer();
                    function r(e1) {
                        i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e1, 0);
                        const t1 = new Uint8Array(i.drawingBufferWidth * i.drawingBufferHeight * 4);
                        return i.readPixels(0, 0, i.drawingBufferWidth, i.drawingBufferHeight, i.RGBA, i.UNSIGNED_BYTE, t1), t1;
                    }
                    return i.bindFramebuffer(i.FRAMEBUFFER, s), this._canvasPixelComparison(r(e1), t1.canvasCopies.map(r), t1.timeStamps);
                }
                _canvasPixelComparison(e1, t1, i) {
                    let s = i[1] - i[0];
                    const r = e1.length / 4;
                    for(let o = 0; o < t1.length; o++){
                        const n = t1[o];
                        let a = 0;
                        for(let t1 = 0; t1 < n.length; t1 += 4)n[t1] === e1[t1] && n[t1 + 1] === e1[t1 + 1] && n[t1 + 2] === e1[t1 + 2] && n[t1 + 3] === e1[t1 + 3] && (a += 1);
                        s += (i[o + 2] - i[o + 1]) * (1 - a / r);
                    }
                    return s;
                }
                remove() {
                    if (this._removed) return;
                    this._hash && this._hash.remove();
                    for (const e1 of this._controls)e1.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), window.removeEventListener("resize", this._onWindowResize, !1), window.removeEventListener("orientationchange", this._onWindowResize, !1), window.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.removeEventListener("online", this._onWindowOnline, !1), window.removeEventListener("visibilitychange", this._onVisibilityChange, !1);
                    const t1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    t1 && t1.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, !1), e1.eZ(this.painter.context.gl), e1.e_.remove(), e1.e$.remove(), this._removed = !0, this.fire(new e1.h("remove"));
                }
                triggerRepaint() {
                    this._triggerFrame(!0);
                }
                _triggerFrame(t1) {
                    this._renderNextFrame = this._renderNextFrame || t1, this.style && !this._frame && (this._frame = e1.e.frame((e1)=>{
                        const t1 = !!this._renderNextFrame;
                        this._frame = null, this._renderNextFrame = null, t1 && this._render(e1);
                    }));
                }
                _preloadTiles(t1) {
                    const i = this.style ? this.style.getSourceCaches() : [];
                    return e1.bT(i, (e1, i)=>e1._preloadTiles(t1, i), ()=>{
                        this.triggerRepaint();
                    }), this;
                }
                _onWindowOnline() {
                    this._update();
                }
                _onWindowResize(e1) {
                    this._trackResize && this.resize({
                        originalEvent: e1
                    })._update();
                }
                _onVisibilityChange() {
                    "hidden" === document.visibilityState && this._visibilityHidden++;
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(e1) {
                    this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, e1 && wt(), this._update());
                }
                get showParseStatus() {
                    return !!this._showParseStatus;
                }
                set showParseStatus(e1) {
                    this._showParseStatus !== e1 && (this._showParseStatus = e1, this._update());
                }
                get showTerrainWireframe() {
                    return !!this._showTerrainWireframe;
                }
                set showTerrainWireframe(e1) {
                    this._showTerrainWireframe !== e1 && (this._showTerrainWireframe = e1, this._update());
                }
                get showLayers2DWireframe() {
                    return !!this._showLayers2DWireframe;
                }
                set showLayers2DWireframe(e1) {
                    this._showLayers2DWireframe !== e1 && (this._showLayers2DWireframe = e1, this._update());
                }
                get showLayers3DWireframe() {
                    return !!this._showLayers3DWireframe;
                }
                set showLayers3DWireframe(e1) {
                    this._showLayers3DWireframe !== e1 && (this._showLayers3DWireframe = e1, this._update());
                }
                get showElevationIdDebug() {
                    return !!this.painter && this.painter._debugParams.showElevationIdDebug;
                }
                set showElevationIdDebug(e1) {
                    this.painter && this.painter._debugParams.showElevationIdDebug !== e1 && (this.painter._debugParams.showElevationIdDebug = e1, this.style && e1 ? this.style._reloadSources() : this._update());
                }
                get speedIndexTiming() {
                    return !!this._speedIndexTiming;
                }
                set speedIndexTiming(e1) {
                    this._speedIndexTiming !== e1 && (this._speedIndexTiming = e1, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(e1) {
                    this._showPadding !== e1 && (this._showPadding = e1, e1 && wt(), this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(e1) {
                    this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 && wt(), this.style && e1 ? this.style._reloadSources() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(e1) {
                    this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(e1) {
                    this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(e1) {
                    this._vertices = e1, this._update();
                }
                get showTileAABBs() {
                    return !!this._showTileAABBs;
                }
                set showTileAABBs(e1) {
                    this._showTileAABBs !== e1 && (this._showTileAABBs = e1, e1 && this._update());
                }
                _setCacheLimits(t1, i) {
                    e1.f0(t1, i);
                }
                get version() {
                    return e1.f1;
                }
            },
            NavigationControl: class {
                constructor(t1 = {}){
                    this.options = {
                        ...Hl,
                        ...t1
                    }, this._container = a("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this.options.showZoom && (e1.aV([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e1)=>{
                        this._map && this._map.zoomIn({}, {
                            originalEvent: e1
                        });
                    }), a("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e1)=>{
                        this._map && this._map.zoomOut({}, {
                            originalEvent: e1
                        });
                    }), a("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e1.aV([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e1)=>{
                        const t1 = this._map;
                        t1 && (this.options.visualizePitch ? t1.resetNorthPitch({}, {
                            originalEvent: e1
                        }) : t1.resetNorth({}, {
                            originalEvent: e1
                        }));
                    }), this._compassIcon = a("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
                _updateZoomButtons() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t1 = e1.getZoom(), i = t1 === e1.getMaxZoom(), s = t1 === e1.getMinZoom();
                    this._zoomInButton.disabled = i, this._zoomOutButton.disabled = s, this._zoomInButton.setAttribute("aria-disabled", i.toString()), this._zoomOutButton.setAttribute("aria-disabled", s.toString());
                }
                _rotateCompassArrow() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t1 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e1.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${e1.transform.pitch}deg) rotateZ(${e1.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e1.transform.angle * (180 / Math.PI)}deg)`;
                    e1._requestDomTask(()=>{
                        this._compassIcon && (this._compassIcon.style.transform = t1);
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e1.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e1.on("pitch", this._rotateCompassArrow), e1.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Wl(e1, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    const e1 = this._map;
                    e1 && (this._container.remove(), this.options.showZoom && e1.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e1.off("pitch", this._rotateCompassArrow), e1.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
                }
                _createButton(e1, t1) {
                    const i = a("button", e1, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e1, t1) {
                    if (!this._map) return;
                    const i = this._map._getUIString(`NavigationControl.${t1}`);
                    e1.setAttribute("aria-label", i), e1.firstElementChild && e1.firstElementChild.setAttribute("title", i);
                }
            },
            GeolocateControl: class extends e1.E {
                constructor(t1 = {}){
                    super();
                    const i = navigator.geolocation;
                    this.options = {
                        geolocation: i,
                        ...sc,
                        ...t1
                    }, e1.aV([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker",
                        "_updateMarkerRotation",
                        "_onDeviceOrientation"
                    ], this), this._updateMarkerRotationThrottled = Ra(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
                }
                onAdd(e1) {
                    return this._map = e1, this._container = a("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
                }
                onRemove() {
                    this._clearRequestTimeout(), void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
                }
                _checkGeolocationSupport(e1) {
                    const t1 = (t1 = !!this.options.geolocation)=>{
                        this._supportsGeolocation = t1, e1(t1);
                    };
                    void 0 !== this._supportsGeolocation ? e1(this._supportsGeolocation) : void 0 !== navigator.permissions ? navigator.permissions.query({
                        name: "geolocation"
                    }).then((e1)=>t1("denied" !== e1.state)).catch(()=>t1()) : t1();
                }
                _isOutOfMapMaxBounds(e1) {
                    const t1 = this._map.getMaxBounds(), i = e1.coords;
                    return !!t1 && (i.longitude < t1.getWest() || i.longitude > t1.getEast() || i.latitude < t1.getSouth() || i.latitude > t1.getNorth());
                }
                _setWatchState(e1) {
                    this._watchState = e1;
                    const t1 = this._geolocateButton.classList;
                    t1.remove(...ic);
                    for (const i of ec[e1])t1.add(tc(i));
                }
                _setButtonTitle(e1) {
                    const t1 = this._map._getUIString(e1);
                    this._geolocateButton.setAttribute("aria-label", t1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t1);
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                        case "ACTIVE_LOCK":
                            this._setWatchState("ACTIVE_ERROR");
                            break;
                        case "BACKGROUND":
                            this._setWatchState("BACKGROUND_ERROR");
                    }
                }
                _onSuccess(t1) {
                    if (this._map) {
                        if (this._clearRequestTimeout(), this._isOutOfMapMaxBounds(t1)) return this._setErrorState(), this.fire(new e1.h("outofmaxbounds", t1)), this._updateMarker(), void this._finish();
                        if (this._lastKnownPosition = t1, this.options.trackUserLocation) switch(this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._setWatchState(this.options.followUserLocation ? "ACTIVE_LOCK" : "BACKGROUND");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._setWatchState("BACKGROUND");
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t1), this.options.followUserLocation && (!this.options.trackUserLocation || "ACTIVE_LOCK" === this._watchState) && this._updateCamera(t1), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new e1.h("geolocate", {
                            coords: t1.coords,
                            timestamp: t1.timestamp,
                            ...t1.toJSON ? {
                                toJSON: t1.toJSON.bind(t1)
                            } : {}
                        })), this._finish();
                    }
                }
                _updateCamera(t1) {
                    const i = new e1.cz(t1.coords.longitude, t1.coords.latitude), s = t1.coords.accuracy, r = {
                        bearing: this._map.getBearing(),
                        ...this.options.fitBoundsOptions
                    };
                    this._map.fitBounds(i.toBounds(s), r, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(t1) {
                    if (t1) {
                        const i = new e1.cz(t1.coords.longitude, t1.coords.latitude);
                        this.options.showAccuracyCircle ? this._accuracyCircleMarker.setLngLat(i).addTo(this._map) : this._accuracyCircleMarker.remove(), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = t1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const t1 = this._map.transform, i = e1.dv(1, t1._center.lat) * t1.worldSize, s = Math.ceil(2 * this._accuracy * i);
                    this._circleElement.style.width = `${s}px`, this._circleElement.style.height = `${s}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _updateMarkerRotation() {
                    this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
                }
                _onError(t1) {
                    if (this._map) {
                        if (this._clearRequestTimeout(), this.options.trackUserLocation) {
                            if (1 === t1.code) this._setWatchState("OFF"), this._geolocateButton.disabled = !0, this._setButtonTitle("GeolocateControl.LocationNotAvailable"), void 0 !== this._geolocationWatchID && this._clearWatch();
                            else {
                                if (3 === t1.code && this._noTimeout) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new e1.h("error", {
                            code: t1.code,
                            message: t1.message,
                            PERMISSION_DENIED: t1.PERMISSION_DENIED,
                            POSITION_UNAVAILABLE: t1.POSITION_UNAVAILABLE,
                            TIMEOUT: t1.TIMEOUT
                        })), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _startRequestTimeout() {
                    this._clearRequestTimeout();
                    const e1 = this.options.positionOptions.timeout;
                    e1 && (this._requestTimeoutId = window.setTimeout(()=>{
                        this._onError({
                            code: 3,
                            message: "Geolocation request timed out"
                        });
                    }, e1));
                }
                _clearRequestTimeout() {
                    void 0 !== this._requestTimeoutId && (clearTimeout(this._requestTimeoutId), this._requestTimeoutId = void 0);
                }
                _setupUI(t1) {
                    void 0 !== this._map && (this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this._geolocateButton = a("button", "mapboxgl-ctrl-geolocate", this._container), a("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === t1 ? (e1.w("Geolocation support is not available so the GeolocateControl will be disabled."), this._geolocateButton.disabled = !0, this._setButtonTitle("GeolocateControl.LocationNotAvailable")) : this._setButtonTitle("GeolocateControl.FindMyLocation"), this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._createUserLocationMarkers(), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.showButton || (this._container.style.display = "none"), this.options.trackUserLocation && this._map.on("movestart", (t1)=>{
                        t1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t1.originalEvent && "resize" === t1.originalEvent.type || (this._setWatchState("BACKGROUND"), this.fire(new e1.h("trackuserlocationend")));
                    }), this.fire(new e1.h("ready")));
                }
                _onDeviceOrientation(e1) {
                    this._userLocationDotMarker && (e1.webkitCompassHeading ? this._heading = e1.webkitCompassHeading : !0 === e1.absolute && (this._heading = -1 * e1.alpha), this._updateMarkerRotationThrottled());
                }
                trigger() {
                    if (!this._setup) return e1.w("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._setWatchState("WAITING_ACTIVE"), this.fire(new e1.h("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                this._numberOfWatches--, this._noTimeout = !1, this._setWatchState("OFF"), this.fire(new e1.h("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._setWatchState("ACTIVE_LOCK"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e1.h("trackuserlocationstart"));
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let e1;
                            this._geolocateButton.classList.add(tc("waiting")), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e1 = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, this._noTimeout = !0) : (e1 = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e1), this._startRequestTimeout(), this.options.showUserHeading && this._addDeviceOrientationListener();
                        }
                    } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._startRequestTimeout(), this._timeoutId = window.setTimeout(this._finish, 1e4);
                    return !0;
                }
                setFollowUserLocation(t1) {
                    return this.options.followUserLocation = t1 ?? sc.followUserLocation, this.options.trackUserLocation && "OFF" !== this._watchState && (this.options.followUserLocation ? "BACKGROUND" !== this._watchState && "BACKGROUND_ERROR" !== this._watchState || (this._setWatchState("ACTIVE_LOCK"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e1.h("trackuserlocationstart"))) : "ACTIVE_LOCK" !== this._watchState && "ACTIVE_ERROR" !== this._watchState || (this._setWatchState("BACKGROUND"), this.fire(new e1.h("trackuserlocationend")))), this;
                }
                setShowAccuracyCircle(t1) {
                    if (this.options.showAccuracyCircle = t1 ?? sc.showAccuracyCircle, !this._accuracyCircleMarker) return this;
                    if (this.options.showAccuracyCircle) {
                        if (this.options.showUserLocation && this._lastKnownPosition) {
                            const { longitude: t1, latitude: i, accuracy: s } = this._lastKnownPosition.coords;
                            this._accuracy = s, this._accuracyCircleMarker.setLngLat(new e1.cz(t1, i)).addTo(this._map), this._updateCircleRadius();
                        }
                    } else this._accuracyCircleMarker.remove();
                    return this;
                }
                setShowUserHeading(e1) {
                    return this.options.showUserHeading = e1 ?? sc.showUserHeading, this._setup ? (this.options.showUserHeading ? void 0 !== this._geolocationWatchID && this._addDeviceOrientationListener() : (this._removeDeviceOrientationListener(), this._heading = void 0, this._userLocationDotMarker && this._updateMarkerRotation()), this) : this;
                }
                setFitBoundsOptions(e1) {
                    return this.options.fitBoundsOptions = e1 ?? sc.fitBoundsOptions, this;
                }
                setShowUserLocation(e1) {
                    return this.options.showUserLocation = e1 ?? sc.showUserLocation, this._setup ? (this.options.showUserLocation ? (this._userLocationDotMarker || (this._createUserLocationMarkers(), this._map.on("zoom", this._onZoom)), !this._lastKnownPosition || void 0 !== this._watchState && "OFF" === this._watchState || this._updateMarker(this._lastKnownPosition)) : (this._userLocationDotMarker && this._userLocationDotMarker.remove(), this._accuracyCircleMarker && this._accuracyCircleMarker.remove()), this) : this;
                }
                _addDeviceOrientationListener() {
                    const e1 = ()=>{
                        const e1 = "ondeviceorientationabsolute" in window ? "deviceorientationabsolute" : "deviceorientation";
                        window.addEventListener(e1, this._onDeviceOrientation);
                    };
                    "function" == typeof DeviceOrientationEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((t1)=>{
                        "granted" === t1 && e1();
                    }).catch(console.error) : e1();
                }
                _removeDeviceOrientationListener() {
                    window.removeEventListener("deviceorientation", this._onDeviceOrientation), window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation);
                }
                _createUserLocationMarkers() {
                    this._dotElement = a("div", "mapboxgl-user-location"), this._dotElement.appendChild(a("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(a("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new Jl({
                        element: this._dotElement,
                        rotationAlignment: "map",
                        pitchAlignment: "map"
                    }), this._circleElement = a("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Jl({
                        element: this._circleElement,
                        pitchAlignment: "map"
                    });
                }
                _clearWatch() {
                    this._clearRequestTimeout(), this.options.geolocation.clearWatch(this._geolocationWatchID), this._removeDeviceOrientationListener(), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove(tc("waiting")), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
            },
            AttributionControl: kl,
            ScaleControl: class {
                constructor(t1 = {}){
                    this.options = {
                        ...rc,
                        ...t1
                    }, e1.aV([
                        "_update",
                        "_setScale",
                        "setUnit"
                    ], this);
                }
                getDefaultPosition() {
                    return "bottom-left";
                }
                _update() {
                    const e1 = this.options.maxWidth || 100, t1 = this._map, i = t1._containerHeight / 2, s = t1._containerWidth / 2 - e1 / 2, r = t1.unproject([
                        s,
                        i
                    ]), o = t1.unproject([
                        s + e1,
                        i
                    ]), n = r.distanceTo(o);
                    if ("imperial" === this.options.unit) {
                        const t1 = 3.2808 * n;
                        t1 > 5280 ? this._setScale(e1, t1 / 5280, "mile") : this._setScale(e1, t1, "foot");
                    } else "nautical" === this.options.unit ? this._setScale(e1, n / 1852, "nautical-mile") : n >= 1e3 ? this._setScale(e1, n / 1e3, "kilometer") : this._setScale(e1, n, "meter");
                }
                _setScale(e1, t1, i) {
                    this._map._requestDomTask(()=>{
                        const s = function(e1) {
                            const t1 = Math.pow(10, `${Math.floor(e1)}`.length - 1);
                            let i = e1 / t1;
                            return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e1) {
                                const t1 = Math.pow(10, Math.ceil(-Math.log(e1) / Math.LN10));
                                return Math.round(e1 * t1) / t1;
                            }(i), t1 * i;
                        }(t1), r = s / t1;
                        this._container.innerHTML = "nautical-mile" !== i ? new Intl.NumberFormat(this._language, {
                            style: "unit",
                            unitDisplay: "short",
                            unit: i
                        }).format(s) : `${s}&nbsp;${oc[i]}`, this._container.style.width = e1 * r + "px";
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this._language = e1.getLanguage(), this._container = a("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e1.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
                }
                onRemove() {
                    this._container.remove(), this._map.off("move", this._update), this._map = void 0;
                }
                _setLanguage(e1) {
                    this._language = e1, this._update();
                }
                setUnit(e1) {
                    this.options.unit = e1, this._update();
                }
            },
            FullscreenControl: class {
                constructor(t1 = {}){
                    this._fullscreen = !1, t1 && t1.container && (t1.container instanceof HTMLElement ? this._container = t1.container : e1.w("Full screen control 'container' must be a DOM element.")), e1.aV([
                        "_onClickFullscreen",
                        "_changeIcon"
                    ], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in document && (this._fullscreenchange = "webkitfullscreenchange");
                }
                onAdd(t1) {
                    return this._map = t1, this._container || (this._container = this._map.getContainer()), this._controlContainer = a("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e1.w("This device does not support fullscreen mode.")), this._controlContainer;
                }
                onRemove() {
                    this._controlContainer.remove(), this._map = null, document.removeEventListener(this._fullscreenchange, this._changeIcon);
                }
                _checkFullscreenSupport() {
                    return !(!document.fullscreenEnabled && !document.webkitFullscreenEnabled);
                }
                _setupUI() {
                    const e1 = this._fullscreenButton = a("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                    a("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), e1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), document.addEventListener(this._fullscreenchange, this._changeIcon);
                }
                _updateTitle() {
                    const e1 = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", e1), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e1);
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _changeIcon() {
                    (document.fullscreenElement || document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                }
                _onClickFullscreen() {
                    this._isFullscreen() ? document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                }
            },
            IndoorControl: class {
                constructor(){
                    e1.aV([
                        "_onIndoorUpdate",
                        "_onStyleData",
                        "_scrollUp",
                        "_scrollDown",
                        "_toggleIndoor"
                    ], this), this._visibleFloorStart = 0, this._lastSelectedFloorId = null;
                }
                onAdd(e1) {
                    return this._map = e1, this._container = a("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.style.display = "none", this._map.on("styledata", this._onStyleData), this._map.on("idle", this._onStyleData), this._updateConnection(), this._container;
                }
                _onStyleData() {
                    this._updateConnection();
                }
                _updateConnection() {
                    if (this._map && this._map.style && this._map.style.indoorManager) {
                        const e1 = this._map.style.indoorManager;
                        e1.off("selector-update", this._onIndoorUpdate), e1.on("selector-update", this._onIndoorUpdate), this._onIndoorUpdate(e1.getControlState()), this._map.off("idle", this._onStyleData);
                    }
                }
                _createButton(e1, t1) {
                    const i = a("button", e1, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e1, t1) {
                    e1.setAttribute("aria-label", t1), e1.textContent = t1;
                }
                onRemove() {
                    this._container && this._container.remove(), this._map && (this._map.off("styledata", this._onStyleData), this._map.off("idle", this._onStyleData), this._map.style && this._map.style.indoorManager && this._map.style.indoorManager.off("selector-update", this._onIndoorUpdate), this._map = null);
                }
                getDefaultPosition() {
                    return "top-right";
                }
                _onIndoorUpdate(e1) {
                    if (!e1 || !e1.floors || 0 === e1.floors.length) return this._model = e1, void (this._container.style.display = "none");
                    const t1 = this._model;
                    this._model = e1, this._container.style.display = "inline-block";
                    const i = !t1 || t1.floors.length !== e1.floors.length || t1.floors.some((t1, i)=>t1.id !== e1.floors[i].id);
                    if (i && (this._visibleFloorStart = 0, this._lastSelectedFloorId = null), e1.selectedFloorId) {
                        if (e1.selectedFloorId !== this._lastSelectedFloorId || i) {
                            const t1 = e1.floors.findIndex((t1)=>t1.id === e1.selectedFloorId);
                            if (-1 !== t1) {
                                const i = e1.floors.length;
                                let s, r;
                                i <= 5 ? (s = 0, r = i - 1) : 0 === this._visibleFloorStart ? (s = 0, r = 3) : this._visibleFloorStart >= i - 3 ? (s = i - 3 - 1, r = i - 1) : (s = this._visibleFloorStart, r = this._visibleFloorStart + 3 - 1), t1 < s ? this._visibleFloorStart = t1 : t1 > r && (this._visibleFloorStart = t1 - 2);
                            }
                        }
                        this._lastSelectedFloorId = e1.selectedFloorId;
                    }
                    this._render();
                }
                _render() {
                    if (!this._container || !this._model || !this._model.floors) return;
                    this._container.innerHTML = "";
                    const e1 = this._createButton("mapboxgl-ctrl-indoor-toggle", this._toggleIndoor);
                    a("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), this._model.activeFloorsVisible || e1.classList.add("mapboxgl-ctrl-level-button-selected"), this._container.appendChild(e1);
                    const t1 = this._model.floors, i = t1.length;
                    if (i <= 5) return void t1.forEach((e1)=>this._createFloorButton(e1));
                    const s = 0 === this._visibleFloorStart, r = this._visibleFloorStart >= i - 3;
                    if (s) this._createFloorButton(t1[0]);
                    else {
                        const e1 = this._createButton("mapboxgl-ctrl-arrow-up", this._scrollUp);
                        a("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), this._container.appendChild(e1);
                    }
                    let o = [];
                    if (o = s ? t1.slice(1, 4) : r ? t1.slice(this._visibleFloorStart - 1, this._visibleFloorStart + 3 - 1) : t1.slice(this._visibleFloorStart, this._visibleFloorStart + 3), o.forEach((e1)=>this._createFloorButton(e1)), r) this._createFloorButton(t1[i - 1]);
                    else {
                        const e1 = this._createButton("mapboxgl-ctrl-arrow-down", this._scrollDown);
                        a("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), this._container.appendChild(e1);
                    }
                }
                _createFloorButton(e1) {
                    const t1 = this._createButton("mapboxgl-ctrl-level-button", ()=>{
                        const t1 = e1.id;
                        this._model && this._model.selectedFloorId === t1 && this._model.activeFloorsVisible || this._map && (this._model && !this._model.activeFloorsVisible && this._map.style && this._map.style.indoorManager && this._map.style.indoorManager.setActiveFloorsVisibility(!0), this._map._selectIndoorFloor(t1));
                    }), i = (e1.name || "").trim(), s = e1.zIndex.toString(), r = i ? Array.from(i).slice(0, 3).join("") : s;
                    this._setButtonTitle(t1, r), this._model && this._model.activeFloorsVisible && e1.id === this._model.selectedFloorId && t1.classList.add("mapboxgl-ctrl-level-button-selected"), this._container && this._container.appendChild(t1);
                }
                _toggleIndoor() {
                    this._map && this._map.style && this._map.style.indoorManager && this._model && this._model.activeFloorsVisible && this._map.style.indoorManager.setActiveFloorsVisibility(!1);
                }
                _scrollUp() {
                    if (this._visibleFloorStart > 0) {
                        this._visibleFloorStart--, 1 === this._visibleFloorStart && (this._visibleFloorStart = 0);
                        const e1 = this._model && this._model.floors || [];
                        if (e1.length > 3) {
                            const t1 = e1.length - 3;
                            this._visibleFloorStart === t1 - 1 && (this._visibleFloorStart = t1 - 2);
                        }
                        this._render();
                    }
                }
                _scrollDown() {
                    if (this._model && this._model.floors) {
                        const e1 = this._model.floors.length - 3;
                        this._visibleFloorStart < e1 && (this._visibleFloorStart++, 1 === this._visibleFloorStart && (this._visibleFloorStart = 2), this._visibleFloorStart === e1 - 1 && (this._visibleFloorStart = e1), this._visibleFloorStart > e1 && (this._visibleFloorStart = e1), this._render());
                    }
                }
            },
            Popup: class extends e1.E {
                constructor(t1){
                    super(), this.options = Object.assign(Object.create(ac), t1), this._altitude = this.options.altitude, e1.aV([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseEvent"
                    ], this), this._classList = new Set(t1 && t1.className ? t1.className.trim().split(nc) : []);
                }
                addTo(t1) {
                    return this._map && this.remove(), this._map = t1, this.options.closeOnClick && t1.on("preclick", this._onClose), this.options.closeOnMove && t1.on("move", this._onClose), t1.on("remove", this.remove), this._update(), t1._addPopup(this), this._focusFirstElement(), this._trackPointer ? (t1.on("mousemove", this._onMouseEvent), t1.on("mouseup", this._onMouseEvent), t1._canvasContainer.classList.add("mapboxgl-track-pointer")) : t1.on("move", this._update), this.fire(new e1.h("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
                    const t1 = this._map;
                    return t1 && (t1.off("move", this._update), t1.off("move", this._onClose), t1.off("preclick", this._onClose), t1.off("click", this._onClose), t1.off("remove", this.remove), t1.off("mousemove", this._onMouseEvent), t1.off("mouseup", this._onMouseEvent), t1.off("drag", this._onMouseEvent), t1._canvasContainer && t1._canvasContainer.classList.remove("mapboxgl-track-pointer"), t1._removePopup(this), this._map = void 0), this.fire(new e1.h("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(t1) {
                    this._lngLat = e1.cz.convert(t1), this._pos = null, this._trackPointer = !1, this._update();
                    const i = this._map;
                    return i && (i.on("move", this._update), i.off("mousemove", this._onMouseEvent), i._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                }
                getAltitude() {
                    return this._altitude;
                }
                setAltitude(e1) {
                    return this._altitude = e1, this._update(), this;
                }
                trackPointer() {
                    this._trackPointer = !0, this._pos = null, this._update();
                    const e1 = this._map;
                    return e1 && (e1.off("move", this._update), e1.on("mousemove", this._onMouseEvent), e1.on("drag", this._onMouseEvent), e1._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(e1) {
                    return this.setDOMContent(document.createTextNode(e1));
                }
                setHTML(e1) {
                    const t1 = document.createDocumentFragment(), i = document.createElement("body");
                    let s;
                    for(i.innerHTML = e1; s = i.firstChild, s;)t1.appendChild(s);
                    return this.setDOMContent(t1);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(e1) {
                    return this.options.maxWidth = e1, this._update(), this;
                }
                setDOMContent(e1) {
                    let t1 = this._content;
                    if (t1) for(; t1.hasChildNodes();)t1.firstChild && t1.removeChild(t1.firstChild);
                    else t1 = this._content = a("div", "mapboxgl-popup-content", this._container || void 0);
                    if (t1.appendChild(e1), this.options.closeButton) {
                        const e1 = this._closeButton = a("button", "mapboxgl-popup-close-button", t1);
                        e1.type = "button", e1.setAttribute("aria-label", "Close popup"), e1.innerHTML = '<span aria-hidden="true">&#215;</span>', e1.addEventListener("click", this._onClose);
                    }
                    return this._update(), this._focusFirstElement(), this;
                }
                addClassName(e1) {
                    return this._classList.add(e1), this._updateClassList(), this;
                }
                removeClassName(e1) {
                    return this._classList.delete(e1), this._updateClassList(), this;
                }
                setOffset(e1) {
                    return this.options.offset = e1, this._update(), this;
                }
                toggleClassName(e1) {
                    let t1;
                    return this._classList.delete(e1) ? t1 = !1 : (this._classList.add(e1), t1 = !0), this._updateClassList(), t1;
                }
                _onMouseEvent(e1) {
                    this._update(e1.point);
                }
                _getAnchor(e1) {
                    if (this.options.anchor) return this.options.anchor;
                    const t1 = this._map, i = this._container, s = this._pos;
                    if (!t1 || !i || !s) return "bottom";
                    const r = i.offsetWidth, o = i.offsetHeight, n = s.x < r / 2, a = s.x > t1.transform.width - r / 2;
                    if (s.y + e1 < o) return n ? "top-left" : a ? "top-right" : "top";
                    if (s.y > t1.transform.height - o) {
                        if (n) return "bottom-left";
                        if (a) return "bottom-right";
                    }
                    return n ? "left" : a ? "right" : "bottom";
                }
                _updateClassList() {
                    const e1 = this._container;
                    if (!e1) return;
                    const t1 = [
                        ...this._classList
                    ];
                    t1.push("mapboxgl-popup"), this._anchor && t1.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t1.push("mapboxgl-popup-track-pointer"), e1.className = t1.join(" ");
                }
                _update(t1) {
                    const i = this._map, s = this._content;
                    if (!i || !this._lngLat && !this._trackPointer || !s) return;
                    let r = this._container;
                    if (r || (r = this._container = a("div", "mapboxgl-popup", i.getContainer()), this._tip = a("div", "mapboxgl-popup-tip", r), r.appendChild(s)), this.options.maxWidth && r.style.maxWidth !== this.options.maxWidth && (r.style.maxWidth = this.options.maxWidth), i.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = Xl(this._lngLat, this._pos, i.transform)), !this._trackPointer || t1) {
                        const s = this._pos = this._trackPointer && t1 instanceof e1.P ? t1 : i.project(this._lngLat, this._altitude), r = cc(this.options.offset), o = this._anchor = this._getAnchor(r.y), n = cc(this.options.offset, o), a = s.add(n).round();
                        i._requestDomTask(()=>{
                            this._container && o && (this._container.style.transform = `${Kl[o]} translate(${a.x}px,${a.y}px)`);
                        });
                    }
                    if (!this._marker && i._showingGlobe()) {
                        const t1 = e1.f2(i.transform, this._lngLat) ? 0 : 1;
                        this._setOpacity(t1);
                    }
                    this._updateClassList();
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const e1 = this._container.querySelector(lc);
                    e1 && e1.focus();
                }
                _onClose() {
                    this.remove();
                }
                _setOpacity(e1) {
                    this._container && (this._container.style.opacity = `${e1}`), this._content && (this._content.style.pointerEvents = e1 ? "auto" : "none");
                }
            },
            Marker: Jl,
            Style: To,
            LngLat: e1.cz,
            LngLatBounds: e1.eB,
            Point: e1.P,
            MercatorCoordinate: e1.bS,
            FreeCameraOptions: e1.f8,
            Evented: e1.E,
            config: e1.eL,
            prewarm: function() {
                Sr().acquire(Qt);
            },
            clearPrewarmedResources: function() {
                const e1 = Tr;
                e1 && (e1.isPreloaded() && 1 === e1.numActive() ? (e1.release(Qt), Tr = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
            },
            get accessToken () {
                return e1.eL.ACCESS_TOKEN;
            },
            set accessToken (t){
                e1.fm(t);
            },
            get baseApiUrl () {
                return e1.eL.API_URL;
            },
            set baseApiUrl (t){
                e1.fl(t);
            },
            get workerCount () {
                return Jt.workerCount;
            },
            set workerCount (e){
                !function(e1) {
                    Jt.workerCount = e1;
                }(e);
            },
            get maxParallelImageRequests () {
                return e1.eL.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (t){
                e1.fk(t);
            },
            clearStorage (t1) {
                e1.fj(t1);
            },
            get workerUrl () {
                return Kt.workerUrl;
            },
            set workerUrl (e){
                Kt.workerUrl = e;
            },
            get workerClass () {
                return Kt.workerClass;
            },
            set workerClass (e){
                Kt.workerClass = e;
            },
            get dracoUrl () {
                return e1.fi();
            },
            set dracoUrl (t){
                e1.fh(t);
            },
            get meshoptUrl () {
                return e1.fg();
            },
            set meshoptUrl (t){
                e1.ff(t);
            },
            get buildingGenUrl () {
                return e1.fe();
            },
            set buildingGenUrl (t){
                e1.fd(t);
            },
            setNow: e1.e.setNow,
            restoreNow: e1.e.restoreNow
        };
        return dc;
    });
    var mapboxgl$1 = mapboxgl;
    return mapboxgl$1;
});

});


//# sourceMappingURL=poster-builder.f3c75a3b.js.map
